(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2bvox", function(module, exports) {

$parcel$export(module.exports, "gsap", () => $1974f63041948ee8$export$99ee26438460406a);

var $bvJM2 = parcelRequire("bvJM2");

var $aMBlh = parcelRequire("aMBlh");
var $1974f63041948ee8$export$99ee26438460406a = (0, $bvJM2.gsap).registerPlugin((0, $aMBlh.CSSPlugin)) || (0, $bvJM2.gsap), // to protect from tree shaking
$1974f63041948ee8$export$7b23975ad686bf91 = $1974f63041948ee8$export$99ee26438460406a.core.Tween;

});
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.14.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("aMBlh", function(module, exports) {

$parcel$export(module.exports, "CSSPlugin", () => $7d9b5a7dd4dbaff5$export$855822f522f18eef);
/*!
 * CSSPlugin 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $bvJM2 = parcelRequire("bvJM2");
var $7d9b5a7dd4dbaff5$var$_win, $7d9b5a7dd4dbaff5$var$_doc, $7d9b5a7dd4dbaff5$var$_docElement, $7d9b5a7dd4dbaff5$var$_pluginInitted, $7d9b5a7dd4dbaff5$var$_tempDiv, $7d9b5a7dd4dbaff5$var$_tempDivStyler, $7d9b5a7dd4dbaff5$var$_recentSetterPlugin, $7d9b5a7dd4dbaff5$var$_reverting, $7d9b5a7dd4dbaff5$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $7d9b5a7dd4dbaff5$var$_transformProps = {}, $7d9b5a7dd4dbaff5$var$_RAD2DEG = 180 / Math.PI, $7d9b5a7dd4dbaff5$var$_DEG2RAD = Math.PI / 180, $7d9b5a7dd4dbaff5$var$_atan2 = Math.atan2, $7d9b5a7dd4dbaff5$var$_bigNum = 1e8, $7d9b5a7dd4dbaff5$var$_capsExp = /([A-Z])/g, $7d9b5a7dd4dbaff5$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $7d9b5a7dd4dbaff5$var$_complexExp = /[\s,\(]\S/, $7d9b5a7dd4dbaff5$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $7d9b5a7dd4dbaff5$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $7d9b5a7dd4dbaff5$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $7d9b5a7dd4dbaff5$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $7d9b5a7dd4dbaff5$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $7d9b5a7dd4dbaff5$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_transformProp = "transform", $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin", $7d9b5a7dd4dbaff5$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $7d9b5a7dd4dbaff5$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $7d9b5a7dd4dbaff5$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $7d9b5a7dd4dbaff5$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $7d9b5a7dd4dbaff5$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $7d9b5a7dd4dbaff5$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($7d9b5a7dd4dbaff5$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, isNotCSS, "");
        }
        property = $7d9b5a7dd4dbaff5$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $7d9b5a7dd4dbaff5$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $7d9b5a7dd4dbaff5$var$_reverting();
        if ((!i || !i.isStart) && !style[$7d9b5a7dd4dbaff5$var$_transformProp]) {
            $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]) {
                style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $7d9b5a7dd4dbaff5$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $7d9b5a7dd4dbaff5$var$_revertStyle,
        save: $7d9b5a7dd4dbaff5$var$_saveStyle
    };
    target._gsap || (0, $bvJM2.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $7d9b5a7dd4dbaff5$var$_supports3D, $7d9b5a7dd4dbaff5$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $7d9b5a7dd4dbaff5$var$_doc.createElementNS ? $7d9b5a7dd4dbaff5$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $7d9b5a7dd4dbaff5$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $7d9b5a7dd4dbaff5$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $7d9b5a7dd4dbaff5$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $7d9b5a7dd4dbaff5$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($7d9b5a7dd4dbaff5$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $7d9b5a7dd4dbaff5$var$_prefixes[i] : "") + property;
}, $7d9b5a7dd4dbaff5$var$_initCore = function _initCore() {
    if ($7d9b5a7dd4dbaff5$var$_windowExists() && window.document) {
        $7d9b5a7dd4dbaff5$var$_win = window;
        $7d9b5a7dd4dbaff5$var$_doc = $7d9b5a7dd4dbaff5$var$_win.document;
        $7d9b5a7dd4dbaff5$var$_docElement = $7d9b5a7dd4dbaff5$var$_doc.documentElement;
        $7d9b5a7dd4dbaff5$var$_tempDiv = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $7d9b5a7dd4dbaff5$var$_tempDivStyler = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("div");
        $7d9b5a7dd4dbaff5$var$_transformProp = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b($7d9b5a7dd4dbaff5$var$_transformProp);
        $7d9b5a7dd4dbaff5$var$_transformOriginProp = $7d9b5a7dd4dbaff5$var$_transformProp + "Origin";
        $7d9b5a7dd4dbaff5$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $7d9b5a7dd4dbaff5$var$_supports3D = !!$7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b("perspective");
        $7d9b5a7dd4dbaff5$var$_reverting = (0, $bvJM2.gsap).core.reverting;
        $7d9b5a7dd4dbaff5$var$_pluginInitted = 1;
    }
}, $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $7d9b5a7dd4dbaff5$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $7d9b5a7dd4dbaff5$var$_docElement.removeChild(svg);
    return bbox;
}, $7d9b5a7dd4dbaff5$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $7d9b5a7dd4dbaff5$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$7d9b5a7dd4dbaff5$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $7d9b5a7dd4dbaff5$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$7d9b5a7dd4dbaff5$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp) property = $7d9b5a7dd4dbaff5$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($7d9b5a7dd4dbaff5$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $7d9b5a7dd4dbaff5$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $7d9b5a7dd4dbaff5$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$7d9b5a7dd4dbaff5$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $7d9b5a7dd4dbaff5$var$_tempDiv.style, horizontal = $7d9b5a7dd4dbaff5$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[unit] || $7d9b5a7dd4dbaff5$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($7d9b5a7dd4dbaff5$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $bvJM2._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $7d9b5a7dd4dbaff5$var$_doc || !parent.appendChild) parent = $7d9b5a7dd4dbaff5$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $bvJM2._ticker).time && !cache.uncache) return (0, $bvJM2._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $7d9b5a7dd4dbaff5$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$7d9b5a7dd4dbaff5$var$_nonStandardLayouts[$7d9b5a7dd4dbaff5$var$_getComputedProperty(parent, "display")] && (style.position = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            px = $7d9b5a7dd4dbaff5$var$_tempDiv[measureProperty];
            parent.removeChild($7d9b5a7dd4dbaff5$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $bvJM2._getCache)(parent);
            cache.time = (0, $bvJM2._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $bvJM2._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $7d9b5a7dd4dbaff5$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore();
    if (property in $7d9b5a7dd4dbaff5$var$_propertyAliases && property !== "transform") {
        property = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($7d9b5a7dd4dbaff5$var$_transformProps[property] && property !== "transform") {
        value = $7d9b5a7dd4dbaff5$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $7d9b5a7dd4dbaff5$var$_firstTwoOnly($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $7d9b5a7dd4dbaff5$var$_specialProps[property] && $7d9b5a7dd4dbaff5$var$_specialProps[property](target, property, unit) || $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, property) || (0, $bvJM2._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $bvJM2.PropTween)(this._pt, target.style, prop, 0, 1, (0, $bvJM2._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $bvJM2._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $bvJM2._numWithUnitExp)) || [];
    endValues = end.match((0, $bvJM2._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $bvJM2._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $bvJM2._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $bvJM2._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $bvJM2._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $7d9b5a7dd4dbaff5$var$_renderNonTweeningValueOnlyAtEnd : $7d9b5a7dd4dbaff5$var$_renderNonTweeningValue;
    (0, $bvJM2._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $7d9b5a7dd4dbaff5$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[x] || x;
    split[1] = $7d9b5a7dd4dbaff5$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $7d9b5a7dd4dbaff5$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($7d9b5a7dd4dbaff5$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $7d9b5a7dd4dbaff5$var$_transformOriginProp : $7d9b5a7dd4dbaff5$var$_transformProp;
                }
                $7d9b5a7dd4dbaff5$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $7d9b5a7dd4dbaff5$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$7d9b5a7dd4dbaff5$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, 0, 0, $7d9b5a7dd4dbaff5$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $7d9b5a7dd4dbaff5$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $7d9b5a7dd4dbaff5$var$_rotationalProperties = {}, $7d9b5a7dd4dbaff5$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
    return $7d9b5a7dd4dbaff5$var$_isNullTransform(matrixString) ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrixString.substr(7).match((0, $bvJM2._numExp)).map((0, $bvJM2._round));
}, $7d9b5a7dd4dbaff5$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $bvJM2._getCache)(target), style = target.style, matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $7d9b5a7dd4dbaff5$var$_identity2DMatrix : matrix;
    } else if (matrix === $7d9b5a7dd4dbaff5$var$_identity2DMatrix && !target.offsetParent && target !== $7d9b5a7dd4dbaff5$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $7d9b5a7dd4dbaff5$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $7d9b5a7dd4dbaff5$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $7d9b5a7dd4dbaff5$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $7d9b5a7dd4dbaff5$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $7d9b5a7dd4dbaff5$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $7d9b5a7dd4dbaff5$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $7d9b5a7dd4dbaff5$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $bvJM2.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $7d9b5a7dd4dbaff5$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$7d9b5a7dd4dbaff5$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$7d9b5a7dd4dbaff5$var$_transformProp] !== "none" ? cs[$7d9b5a7dd4dbaff5$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $7d9b5a7dd4dbaff5$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $7d9b5a7dd4dbaff5$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $7d9b5a7dd4dbaff5$var$_atan2(b, a) * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $7d9b5a7dd4dbaff5$var$_atan2(c, d) * $7d9b5a7dd4dbaff5$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $7d9b5a7dd4dbaff5$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a32, a33);
            rotationX = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $7d9b5a7dd4dbaff5$var$_atan2(-c, a33);
            rotationY = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $7d9b5a7dd4dbaff5$var$_atan2(b, a);
            rotation = angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $bvJM2._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $bvJM2._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $7d9b5a7dd4dbaff5$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $7d9b5a7dd4dbaff5$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$7d9b5a7dd4dbaff5$var$_isNullTransform($7d9b5a7dd4dbaff5$var$_getComputedProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $bvJM2._round)(scaleX);
    cache.scaleY = (0, $bvJM2._round)(scaleY);
    cache.rotation = (0, $bvJM2._round)(rotation) + deg;
    cache.rotationX = (0, $bvJM2._round)(rotationX) + deg;
    cache.rotationY = (0, $bvJM2._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$7d9b5a7dd4dbaff5$var$_transformOriginProp] = $7d9b5a7dd4dbaff5$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $bvJM2._config).force3D;
    cache.renderTransform = cache.svg ? $7d9b5a7dd4dbaff5$var$_renderSVGTransforms : $7d9b5a7dd4dbaff5$var$_supports3D ? $7d9b5a7dd4dbaff5$var$_renderCSSTransforms : $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $7d9b5a7dd4dbaff5$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$7d9b5a7dd4dbaff5$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $bvJM2.getUnit)(start);
    return (0, $bvJM2._round)(parseFloat(start) + parseFloat($7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $7d9b5a7dd4dbaff5$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $7d9b5a7dd4dbaff5$var$_renderCSSTransforms(ratio, cache);
}, $7d9b5a7dd4dbaff5$var$_zeroDeg = "0deg", $7d9b5a7dd4dbaff5$var$_zeroPx = "0px", $7d9b5a7dd4dbaff5$var$_endParenthesis = ") ", $7d9b5a7dd4dbaff5$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $7d9b5a7dd4dbaff5$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $7d9b5a7dd4dbaff5$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += "perspective(" + transformPerspective + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $7d9b5a7dd4dbaff5$var$_zeroPx || y !== $7d9b5a7dd4dbaff5$var$_zeroPx || z !== $7d9b5a7dd4dbaff5$var$_zeroPx) transforms += z !== $7d9b5a7dd4dbaff5$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotation !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotate(" + rotation + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateY(" + rotationY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (rotationX !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "rotateX(" + rotationX + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (skewX !== $7d9b5a7dd4dbaff5$var$_zeroDeg || skewY !== $7d9b5a7dd4dbaff5$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $7d9b5a7dd4dbaff5$var$_endParenthesis;
    target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms || "translate(0, 0)";
}, $7d9b5a7dd4dbaff5$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        skewX *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $7d9b5a7dd4dbaff5$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $bvJM2._round)(a11);
        a21 = (0, $bvJM2._round)(a21);
        a12 = (0, $bvJM2._round)(a12);
        a22 = (0, $bvJM2._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "x", x, "px");
        ty = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $bvJM2._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $bvJM2._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $bvJM2._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $bvJM2._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$7d9b5a7dd4dbaff5$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $7d9b5a7dd4dbaff5$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $bvJM2._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $7d9b5a7dd4dbaff5$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $7d9b5a7dd4dbaff5$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $bvJM2.PropTween)(plugin._pt, target, property, startNum, change, $7d9b5a7dd4dbaff5$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $7d9b5a7dd4dbaff5$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $7d9b5a7dd4dbaff5$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $7d9b5a7dd4dbaff5$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        $7d9b5a7dd4dbaff5$var$_removeProperty(target, $7d9b5a7dd4dbaff5$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$7d9b5a7dd4dbaff5$var$_transformProp];
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = transforms;
        endCache = $7d9b5a7dd4dbaff5$var$_parseTransform(target, 1);
        style[$7d9b5a7dd4dbaff5$var$_transformProp] = startValue;
    }
    for(p in $7d9b5a7dd4dbaff5$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $bvJM2.getUnit)(startValue);
            endUnit = (0, $bvJM2.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $bvJM2.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $7d9b5a7dd4dbaff5$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $bvJM2._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $7d9b5a7dd4dbaff5$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $7d9b5a7dd4dbaff5$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $7d9b5a7dd4dbaff5$export$855822f522f18eef = {
    name: "css",
    register: $7d9b5a7dd4dbaff5$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $7d9b5a7dd4dbaff5$var$_pluginInitted || $7d9b5a7dd4dbaff5$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $7d9b5a7dd4dbaff5$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $bvJM2._plugins)[p] && (0, $bvJM2._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $7d9b5a7dd4dbaff5$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $bvJM2._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $bvJM2._colorExp).lastIndex = 0;
                if (!(0, $bvJM2._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $bvJM2.getUnit)(startValue);
                    endUnit = (0, $bvJM2.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $bvJM2._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $bvJM2._replaceRandom)(startValue));
                    (0, $bvJM2.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $bvJM2._config).units[p] || (0, $bvJM2.getUnit)($7d9b5a7dd4dbaff5$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $7d9b5a7dd4dbaff5$var$_get(target, p)); // can't work with relative values
                } else startValue = $7d9b5a7dd4dbaff5$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $7d9b5a7dd4dbaff5$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $7d9b5a7dd4dbaff5$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $7d9b5a7dd4dbaff5$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $7d9b5a7dd4dbaff5$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $7d9b5a7dd4dbaff5$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $7d9b5a7dd4dbaff5$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $7d9b5a7dd4dbaff5$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $bvJM2.PropTween)(this._pt, style, $7d9b5a7dd4dbaff5$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $bvJM2.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $bvJM2._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($7d9b5a7dd4dbaff5$var$_transformOriginProp, 0, style[$7d9b5a7dd4dbaff5$var$_transformOriginProp]);
                        endValue = $7d9b5a7dd4dbaff5$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, style, p, $7d9b5a7dd4dbaff5$var$_firstTwoOnly(startValue), $7d9b5a7dd4dbaff5$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $7d9b5a7dd4dbaff5$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $7d9b5a7dd4dbaff5$var$_rotationalProperties) {
                        $7d9b5a7dd4dbaff5$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $bvJM2._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $7d9b5a7dd4dbaff5$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $7d9b5a7dd4dbaff5$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$7d9b5a7dd4dbaff5$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $bvJM2.getUnit)(endValue) || (p in (0, $bvJM2._config).units ? (0, $bvJM2._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $7d9b5a7dd4dbaff5$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $bvJM2.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $bvJM2._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $7d9b5a7dd4dbaff5$var$_renderRoundedCSSProp : $7d9b5a7dd4dbaff5$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $7d9b5a7dd4dbaff5$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $bvJM2._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $7d9b5a7dd4dbaff5$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $bvJM2._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$7d9b5a7dd4dbaff5$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $7d9b5a7dd4dbaff5$var$_get,
    aliases: $7d9b5a7dd4dbaff5$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $7d9b5a7dd4dbaff5$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $7d9b5a7dd4dbaff5$var$_transformProps && property !== $7d9b5a7dd4dbaff5$var$_transformOriginProp && (target._gsap.x || $7d9b5a7dd4dbaff5$var$_get(target, "x")) ? plugin && $7d9b5a7dd4dbaff5$var$_recentSetterPlugin === plugin ? property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScale : $7d9b5a7dd4dbaff5$var$_setterTransform : ($7d9b5a7dd4dbaff5$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $7d9b5a7dd4dbaff5$var$_setterScaleWithRender : $7d9b5a7dd4dbaff5$var$_setterTransformWithRender) : target.style && !(0, $bvJM2._isUndefined)(target.style[property]) ? $7d9b5a7dd4dbaff5$var$_setterCSSStyle : ~property.indexOf("-") ? $7d9b5a7dd4dbaff5$var$_setterCSSProp : (0, $bvJM2._getSetter)(target, property);
    },
    core: {
        _removeProperty: $7d9b5a7dd4dbaff5$var$_removeProperty,
        _getMatrix: $7d9b5a7dd4dbaff5$var$_getMatrix
    }
};
(0, $bvJM2.gsap).utils.checkPrefix = $7d9b5a7dd4dbaff5$export$8cbef5dd49a09c8b;
(0, $bvJM2.gsap).core.getStyleSaver = $7d9b5a7dd4dbaff5$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $bvJM2._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $7d9b5a7dd4dbaff5$var$_transformProps[name] = 1;
    });
    (0, $bvJM2._forEachName)(rotation, function(name) {
        (0, $bvJM2._config).units[name] = "deg";
        $7d9b5a7dd4dbaff5$var$_rotationalProperties[name] = 1;
    });
    $7d9b5a7dd4dbaff5$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $bvJM2._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $7d9b5a7dd4dbaff5$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $bvJM2._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $bvJM2._config).units[name] = "px";
});
(0, $bvJM2.gsap).registerPlugin($7d9b5a7dd4dbaff5$export$855822f522f18eef);

});


parcelRegister("f5sus", function(module, exports) {

$parcel$export(module.exports, "toggleAriaExpanded", () => $afbd6c33c795e19c$export$40ba32d7e7abefe9);
$parcel$export(module.exports, "FocusTrap", () => $afbd6c33c795e19c$export$34eba2437817a67b);
// Utility for toggling aria-expanded attribute
function $afbd6c33c795e19c$export$40ba32d7e7abefe9(element, expand) {
    if (expand === undefined) expand = element.getAttribute('aria-expanded') === 'false';
    element.setAttribute('aria-expanded', expand);
}
function $afbd6c33c795e19c$export$d0a8044dce8ff2fc() {
    return window.matchMedia('(max-width: 60em)').matches;
}
class $afbd6c33c795e19c$export$34eba2437817a67b {
    constructor(element, focusableEls){
        this.element = element;
        this.focusableEls = focusableEls ?? this.constructor.getFocusableEls(element);
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        this._handler = this._handleKeydown.bind(this);
    }
    static getFocusableEls(element) {
        return element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    }
    enable() {
        document.addEventListener('keydown', this._handler);
    }
    disable() {
        document.removeEventListener('keydown', this._handler);
    }
    _handleKeydown(e) {
        if (!(e.key === 'Tab' || e.keyCode === 9)) return;
        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
        }
    }
}

});

parcelRegister("gKp6f", function(module, exports) {

$parcel$export(module.exports, "createMap", () => $c3146981bf65af08$export$d49c9aa30b771d59);

var $kMGLj = parcelRequire("kMGLj");
function $c3146981bf65af08$export$d49c9aa30b771d59(options) {
    (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).accessToken = 'pk.eyJ1IjoiZXZlbnRjb25uZWN0b3JzIiwiYSI6ImNtbnExM3F2YTAyMzIycXFyNmY3ZXR2ZXAifQ.XpQu00LBJr9e0TreeRiXKQ';
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Map({
        style: 'mapbox://styles/eventconnectors/clwuexstn015i01qx6afg97vt',
        ...options
    });
}

});
parcelRegister("kMGLj", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(e) {
        var t1 = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
        function n(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = r * s - i * n;
            return o ? (e[0] = s * (o = 1 / o), e[1] = -n * o, e[2] = -i * o, e[3] = r * o, e) : null;
        }
        function i() {
            var e = new r(9);
            return r != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
        }
        function s(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = t1[4], a = t1[5], l = t1[6], u = t1[7], c = t1[8];
            return e[0] = o * c - a * u, e[1] = i * u - n * c, e[2] = n * a - i * o, e[3] = a * l - s * c, e[4] = r * c - i * l, e[5] = i * s - r * a, e[6] = s * u - o * l, e[7] = n * l - r * u, e[8] = r * o - n * s, e;
        }
        function o(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = r[0], d = r[1], f = r[2], m = r[3], y = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
            return e[0] = p * n + d * o + f * u, e[1] = p * i + d * a + f * c, e[2] = p * s + d * l + f * h, e[3] = m * n + y * o + g * u, e[4] = m * i + y * a + g * c, e[5] = m * s + y * l + g * h, e[6] = x * n + v * o + b * u, e[7] = x * i + v * a + b * c, e[8] = x * s + v * l + b * h, e;
        }
        function a() {
            var e = new r(16);
            return r != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0), e[0] = 1, e[5] = 1, e[10] = 1, e[15] = 1, e;
        }
        function l(e) {
            var t1 = new r(16);
            return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
        }
        function u(e) {
            return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
        function c(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = t1[4], a = t1[5], l = t1[6], u = t1[7], c = t1[8], h = t1[9], p = t1[10], d = t1[11], f = t1[12], m = t1[13], y = t1[14], g = t1[15], x = r * a - n * o, v = r * l - i * o, b = r * u - s * o, w = n * l - i * a, _ = n * u - s * a, A = i * u - s * l, M = c * m - h * f, I = c * y - p * f, S = c * g - d * f, z = h * y - p * m, P = h * g - d * m, B = p * g - d * y, T = x * B - v * P + b * z + w * S - _ * I + A * M;
            return T ? (e[0] = (a * B - l * P + u * z) * (T = 1 / T), e[1] = (i * P - n * B - s * z) * T, e[2] = (m * A - y * _ + g * w) * T, e[3] = (p * _ - h * A - d * w) * T, e[4] = (l * S - o * B - u * I) * T, e[5] = (r * B - i * S + s * I) * T, e[6] = (y * b - f * A - g * v) * T, e[7] = (c * A - p * b + d * v) * T, e[8] = (o * P - a * S + u * M) * T, e[9] = (n * S - r * P - s * M) * T, e[10] = (f * _ - m * b + g * x) * T, e[11] = (h * b - c * _ - d * x) * T, e[12] = (a * I - o * z - l * M) * T, e[13] = (r * z - n * I + i * M) * T, e[14] = (m * v - f * w - y * x) * T, e[15] = (c * w - h * v + p * x) * T, e) : null;
        }
        function h(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = t1[9], d = t1[10], f = t1[11], m = t1[12], y = t1[13], g = t1[14], x = t1[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return e[0] = v * n + b * a + w * h + _ * m, e[1] = v * i + b * l + w * p + _ * y, e[2] = v * s + b * u + w * d + _ * g, e[3] = v * o + b * c + w * f + _ * x, e[4] = (v = r[4]) * n + (b = r[5]) * a + (w = r[6]) * h + (_ = r[7]) * m, e[5] = v * i + b * l + w * p + _ * y, e[6] = v * s + b * u + w * d + _ * g, e[7] = v * o + b * c + w * f + _ * x, e[8] = (v = r[8]) * n + (b = r[9]) * a + (w = r[10]) * h + (_ = r[11]) * m, e[9] = v * i + b * l + w * p + _ * y, e[10] = v * s + b * u + w * d + _ * g, e[11] = v * o + b * c + w * f + _ * x, e[12] = (v = r[12]) * n + (b = r[13]) * a + (w = r[14]) * h + (_ = r[15]) * m, e[13] = v * i + b * l + w * p + _ * y, e[14] = v * s + b * u + w * d + _ * g, e[15] = v * o + b * c + w * f + _ * x, e;
        }
        function p(e, t1, r) {
            var n, i, s, o, a, l, u, c, h, p, d, f, m = r[0], y = r[1], g = r[2];
            return t1 === e ? (e[12] = t1[0] * m + t1[4] * y + t1[8] * g + t1[12], e[13] = t1[1] * m + t1[5] * y + t1[9] * g + t1[13], e[14] = t1[2] * m + t1[6] * y + t1[10] * g + t1[14], e[15] = t1[3] * m + t1[7] * y + t1[11] * g + t1[15]) : (i = t1[1], s = t1[2], o = t1[3], a = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = t1[9], d = t1[10], f = t1[11], e[0] = n = t1[0], e[1] = i, e[2] = s, e[3] = o, e[4] = a, e[5] = l, e[6] = u, e[7] = c, e[8] = h, e[9] = p, e[10] = d, e[11] = f, e[12] = n * m + a * y + h * g + t1[12], e[13] = i * m + l * y + p * g + t1[13], e[14] = s * m + u * y + d * g + t1[14], e[15] = o * m + c * y + f * g + t1[15]), e;
        }
        function d(e, t1, r) {
            var n = r[0], i = r[1], s = r[2];
            return e[0] = t1[0] * n, e[1] = t1[1] * n, e[2] = t1[2] * n, e[3] = t1[3] * n, e[4] = t1[4] * i, e[5] = t1[5] * i, e[6] = t1[6] * i, e[7] = t1[7] * i, e[8] = t1[8] * s, e[9] = t1[9] * s, e[10] = t1[10] * s, e[11] = t1[11] * s, e[12] = t1[12], e[13] = t1[13], e[14] = t1[14], e[15] = t1[15], e;
        }
        function f(e, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[4], o = t1[5], a = t1[6], l = t1[7], u = t1[8], c = t1[9], h = t1[10], p = t1[11];
            return t1 !== e && (e[0] = t1[0], e[1] = t1[1], e[2] = t1[2], e[3] = t1[3], e[12] = t1[12], e[13] = t1[13], e[14] = t1[14], e[15] = t1[15]), e[4] = s * i + u * n, e[5] = o * i + c * n, e[6] = a * i + h * n, e[7] = l * i + p * n, e[8] = u * i - s * n, e[9] = c * i - o * n, e[10] = h * i - a * n, e[11] = p * i - l * n, e;
        }
        function m(e, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[0], o = t1[1], a = t1[2], l = t1[3], u = t1[8], c = t1[9], h = t1[10], p = t1[11];
            return t1 !== e && (e[4] = t1[4], e[5] = t1[5], e[6] = t1[6], e[7] = t1[7], e[12] = t1[12], e[13] = t1[13], e[14] = t1[14], e[15] = t1[15]), e[0] = s * i - u * n, e[1] = o * i - c * n, e[2] = a * i - h * n, e[3] = l * i - p * n, e[8] = s * n + u * i, e[9] = o * n + c * i, e[10] = a * n + h * i, e[11] = l * n + p * i, e;
        }
        function y(e, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[0], o = t1[1], a = t1[2], l = t1[3], u = t1[4], c = t1[5], h = t1[6], p = t1[7];
            return t1 !== e && (e[8] = t1[8], e[9] = t1[9], e[10] = t1[10], e[11] = t1[11], e[12] = t1[12], e[13] = t1[13], e[14] = t1[14], e[15] = t1[15]), e[0] = s * i + u * n, e[1] = o * i + c * n, e[2] = a * i + h * n, e[3] = l * i + p * n, e[4] = u * i - s * n, e[5] = c * i - o * n, e[6] = h * i - a * n, e[7] = p * i - l * n, e;
        }
        function g(e, t1) {
            return e[0] = t1[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t1[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t1[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
        function x(e, r, n) {
            var i, s, o, a = n[0], l = n[1], u = n[2], c = Math.sqrt(a * a + l * l + u * u);
            return c < t1 ? null : (a *= c = 1 / c, l *= c, u *= c, i = Math.sin(r), s = Math.cos(r), e[0] = a * a * (o = 1 - s) + s, e[1] = l * a * o + u * i, e[2] = u * a * o - l * i, e[3] = 0, e[4] = a * l * o - u * i, e[5] = l * l * o + s, e[6] = u * l * o + a * i, e[7] = 0, e[8] = a * u * o + l * i, e[9] = l * u * o - a * i, e[10] = u * u * o + s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
        }
        function v(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[4], o = t1[5], a = t1[6], l = t1[8], u = t1[9], c = t1[10];
            return e[0] = Math.sqrt(r * r + n * n + i * i), e[1] = Math.sqrt(s * s + o * o + a * a), e[2] = Math.sqrt(l * l + u * u + c * c), e;
        }
        function b(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = r + r, a = n + n, l = i + i, u = r * o, c = n * o, h = n * a, p = i * o, d = i * a, f = i * l, m = s * o, y = s * a, g = s * l;
            return e[0] = 1 - h - f, e[1] = c + g, e[2] = p - y, e[3] = 0, e[4] = c - g, e[5] = 1 - u - f, e[6] = d + m, e[7] = 0, e[8] = p + y, e[9] = d - m, e[10] = 1 - u - h, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
        var w = h;
        function _() {
            var e = new r(3);
            return r != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e;
        }
        function A(e) {
            var t1 = new r(3);
            return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1;
        }
        function M(e) {
            var t1 = e[0], r = e[1], n = e[2];
            return Math.sqrt(t1 * t1 + r * r + n * n);
        }
        function I(e, t1, n) {
            var i = new r(3);
            return i[0] = e, i[1] = t1, i[2] = n, i;
        }
        function S(e, t1, r, n) {
            return e[0] = t1, e[1] = r, e[2] = n, e;
        }
        function z(e, t1, r) {
            return e[0] = t1[0] + r[0], e[1] = t1[1] + r[1], e[2] = t1[2] + r[2], e;
        }
        function P(e, t1, r) {
            return e[0] = t1[0] - r[0], e[1] = t1[1] - r[1], e[2] = t1[2] - r[2], e;
        }
        function B(e, t1, r) {
            return e[0] = t1[0] * r[0], e[1] = t1[1] * r[1], e[2] = t1[2] * r[2], e;
        }
        function T(e, t1, r) {
            return e[0] = Math.min(t1[0], r[0]), e[1] = Math.min(t1[1], r[1]), e[2] = Math.min(t1[2], r[2]), e;
        }
        function k(e, t1, r) {
            return e[0] = Math.max(t1[0], r[0]), e[1] = Math.max(t1[1], r[1]), e[2] = Math.max(t1[2], r[2]), e;
        }
        function V(e, t1, r) {
            return e[0] = t1[0] * r, e[1] = t1[1] * r, e[2] = t1[2] * r, e;
        }
        function E(e, t1, r, n) {
            return e[0] = t1[0] + r[0] * n, e[1] = t1[1] + r[1] * n, e[2] = t1[2] + r[2] * n, e;
        }
        function F(e, t1) {
            var r = t1[0] - e[0], n = t1[1] - e[1], i = t1[2] - e[2];
            return Math.sqrt(r * r + n * n + i * i);
        }
        function D(e, t1) {
            var r = t1[0] - e[0], n = t1[1] - e[1], i = t1[2] - e[2];
            return r * r + n * n + i * i;
        }
        function C(e) {
            var t1 = e[0], r = e[1], n = e[2];
            return t1 * t1 + r * r + n * n;
        }
        function R(e, t1) {
            return e[0] = -t1[0], e[1] = -t1[1], e[2] = -t1[2], e;
        }
        function L(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), e[0] = t1[0] * s, e[1] = t1[1] * s, e[2] = t1[2] * s, e;
        }
        function O(e, t1) {
            return e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2];
        }
        function U(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = r[0], a = r[1], l = r[2];
            return e[0] = i * l - s * a, e[1] = s * o - n * l, e[2] = n * a - i * o, e;
        }
        function N(e, t1, r, n) {
            var i = t1[0], s = t1[1], o = t1[2];
            return e[0] = i + n * (r[0] - i), e[1] = s + n * (r[1] - s), e[2] = o + n * (r[2] - o), e;
        }
        function j(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = r[3] * n + r[7] * i + r[11] * s + r[15];
            return e[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (o = o || 1), e[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / o, e[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / o, e;
        }
        function G(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2];
            return e[0] = n * r[0] + i * r[3] + s * r[6], e[1] = n * r[1] + i * r[4] + s * r[7], e[2] = n * r[2] + i * r[5] + s * r[8], e;
        }
        function $(e, t1, r) {
            var n = r[0], i = r[1], s = r[2], o = r[3], a = t1[0], l = t1[1], u = t1[2], c = i * u - s * l, h = s * a - n * u, p = n * l - i * a;
            return e[0] = a + o * (c += c) + i * (p += p) - s * (h += h), e[1] = l + o * h + s * c - n * p, e[2] = u + o * p + n * h - i * c, e;
        }
        function q(e) {
            return e[0] = 0, e[1] = 0, e[2] = 0, e;
        }
        function X(e, t1) {
            return e[0] === t1[0] && e[1] === t1[1] && e[2] === t1[2];
        }
        var H = P, Z = B, W = M;
        function Y() {
            var e = new r(4);
            return r != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0), e;
        }
        function J(e, t1, r) {
            return e[0] = t1[0] * r, e[1] = t1[1] * r, e[2] = t1[2] * r, e[3] = t1[3] * r, e;
        }
        function K(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = r * r + n * n + i * i + s * s;
            return o > 0 && (o = 1 / Math.sqrt(o)), e[0] = r * o, e[1] = n * o, e[2] = i * o, e[3] = s * o, e;
        }
        function Q(e, t1) {
            return e[0] * t1[0] + e[1] * t1[1] + e[2] * t1[2] + e[3] * t1[3];
        }
        function ee(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3];
            return e[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * o, e[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * o, e[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * o, e[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * o, e;
        }
        function te() {
            var e = new r(4);
            return r != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e[3] = 1, e;
        }
        function re(e) {
            return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e;
        }
        function ne(e, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = Math.sin(r), l = Math.cos(r);
            return e[0] = n * l + o * a, e[1] = i * l + s * a, e[2] = s * l - i * a, e[3] = o * l - n * a, e;
        }
        function ie(e, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = Math.sin(r), l = Math.cos(r);
            return e[0] = n * l - s * a, e[1] = i * l + o * a, e[2] = s * l + n * a, e[3] = o * l - i * a, e;
        }
        _(), Y();
        var se, oe, ae, le = K, ue = (se = _(), oe = I(1, 0, 0), ae = I(0, 1, 0), function(e, t1, r) {
            var n = O(t1, r);
            return n < -0.999999 ? (U(se, oe, t1), W(se) < 1e-6 && U(se, ae, t1), L(se, se), function(e, t1, r) {
                r *= .5;
                var n = Math.sin(r);
                e[0] = n * t1[0], e[1] = n * t1[1], e[2] = n * t1[2], e[3] = Math.cos(r);
            }(e, se, Math.PI), e) : n > .999999 ? (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e) : (U(se, t1, r), e[0] = se[0], e[1] = se[1], e[2] = se[2], e[3] = 1 + n, le(e, e));
        });
        function ce() {
            var e = new r(2);
            return r != Float32Array && (e[0] = 0, e[1] = 0), e;
        }
        function he(e, t1) {
            var n = new r(2);
            return n[0] = e, n[1] = t1, n;
        }
        function pe(e, t1, r) {
            return e[0] = t1, e[1] = r, e;
        }
        function de(e, t1, r) {
            return e[0] = t1[0] + r[0], e[1] = t1[1] + r[1], e;
        }
        function fe(e, t1, r) {
            return e[0] = t1[0] - r[0], e[1] = t1[1] - r[1], e;
        }
        function me(e, t1, r) {
            return e[0] = t1[0] * r, e[1] = t1[1] * r, e;
        }
        function ye(e) {
            var t1 = e[0], r = e[1];
            return Math.sqrt(t1 * t1 + r * r);
        }
        function ge(e, t1) {
            var r = t1[0], n = t1[1], i = r * r + n * n;
            return i > 0 && (i = 1 / Math.sqrt(i)), e[0] = t1[0] * i, e[1] = t1[1] * i, e;
        }
        function xe(e, t1) {
            return e[0] * t1[0] + e[1] * t1[1];
        }
        te(), te(), i();
        var ve, be, we = fe;
        function _e(e) {
            return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
        }
        ce();
        var Ae = function() {
            if (be) return ve;
            function e(e, t1, r, n) {
                this.cx = 3 * e, this.bx = 3 * (r - e) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t1, this.by = 3 * (n - t1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e, this.p1y = t1, this.p2x = r, this.p2y = n;
            }
            return be = 1, ve = e, e.prototype = {
                sampleCurveX: function(e) {
                    return ((this.ax * e + this.bx) * e + this.cx) * e;
                },
                sampleCurveY: function(e) {
                    return ((this.ay * e + this.by) * e + this.cy) * e;
                },
                sampleCurveDerivativeX: function(e) {
                    return (3 * this.ax * e + 2 * this.bx) * e + this.cx;
                },
                solveCurveX: function(e, t1) {
                    if (void 0 === t1 && (t1 = 1e-6), e < 0) return 0;
                    if (e > 1) return 1;
                    for(var r = e, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - e;
                        if (Math.abs(i) < t1) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var o = 0, a = 1;
                    for(r = e, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - e) < t1)); n++)e > i ? o = r : a = r, r = .5 * (a - o) + o;
                    return r;
                },
                solve: function(e, t1) {
                    return this.sampleCurveY(this.solveCurveX(e, t1));
                }
            }, ve;
        }(), Me = _e(Ae);
        function Ie(e, t1) {
            this.x = e, this.y = t1;
        }
        function Se(e, t1) {
            if (Array.isArray(e)) {
                if (!Array.isArray(t1) || e.length !== t1.length) return !1;
                for(let r = 0; r < e.length; r++)if (!Se(e[r], t1[r])) return !1;
                return !0;
            }
            if ("object" == typeof e && null !== e && null !== t1) {
                if ("object" != typeof t1) return !1;
                if (Object.keys(e).length !== Object.keys(t1).length) return !1;
                for(const r in e)if (!Se(e[r], t1[r])) return !1;
                return !0;
            }
            return e === t1;
        }
        Ie.prototype = {
            clone () {
                return new Ie(this.x, this.y);
            },
            add (e) {
                return this.clone()._add(e);
            },
            sub (e) {
                return this.clone()._sub(e);
            },
            multByPoint (e) {
                return this.clone()._multByPoint(e);
            },
            divByPoint (e) {
                return this.clone()._divByPoint(e);
            },
            mult (e) {
                return this.clone()._mult(e);
            },
            div (e) {
                return this.clone()._div(e);
            },
            rotate (e) {
                return this.clone()._rotate(e);
            },
            rotateAround (e, t1) {
                return this.clone()._rotateAround(e, t1);
            },
            matMult (e) {
                return this.clone()._matMult(e);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (e) {
                return this.x === e.x && this.y === e.y;
            },
            dist (e) {
                return Math.sqrt(this.distSqr(e));
            },
            distSqr (e) {
                const t1 = e.x - this.x, r = e.y - this.y;
                return t1 * t1 + r * r;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (e) {
                return Math.atan2(this.y - e.y, this.x - e.x);
            },
            angleWith (e) {
                return this.angleWithSep(e.x, e.y);
            },
            angleWithSep (e, t1) {
                return Math.atan2(this.x * t1 - this.y * e, this.x * e + this.y * t1);
            },
            _matMult (e) {
                const t1 = e[2] * this.x + e[3] * this.y;
                return this.x = e[0] * this.x + e[1] * this.y, this.y = t1, this;
            },
            _add (e) {
                return this.x += e.x, this.y += e.y, this;
            },
            _sub (e) {
                return this.x -= e.x, this.y -= e.y, this;
            },
            _mult (e) {
                return this.x *= e, this.y *= e, this;
            },
            _div (e) {
                return this.x /= e, this.y /= e, this;
            },
            _multByPoint (e) {
                return this.x *= e.x, this.y *= e.y, this;
            },
            _divByPoint (e) {
                return this.x /= e.x, this.y /= e.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const e = this.y;
                return this.y = this.x, this.x = -e, this;
            },
            _rotate (e) {
                const t1 = Math.cos(e), r = Math.sin(e), n = r * this.x + t1 * this.y;
                return this.x = t1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround (e, t1) {
                const r = Math.cos(e), n = Math.sin(e), i = t1.y + n * (this.x - t1.x) + r * (this.y - t1.y);
                return this.x = t1.x + r * (this.x - t1.x) - n * (this.y - t1.y), this.y = i, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: Ie
        }, Ie.convert = function(e) {
            if (e instanceof Ie) return e;
            if (Array.isArray(e)) return new Ie(+e[0], +e[1]);
            if (void 0 !== e.x && void 0 !== e.y) return new Ie(+e.x, +e.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        const ze = Math.PI / 180, Pe = 180 / Math.PI;
        function Be(e) {
            return e * ze;
        }
        function Te(e) {
            return e * Pe;
        }
        const ke = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function Ve(e) {
            if (e <= 0) return 0;
            if (e >= 1) return 1;
            const t1 = e * e, r = t1 * e;
            return 4 * (e < .5 ? r : 3 * (e - t1) + r - .75);
        }
        function Ee(e, t1, r, n) {
            const i = new Me(e, t1, r, n);
            return function(e) {
                return i.solve(e);
            };
        }
        const Fe = Ee(.25, .1, .25, 1);
        function De(e, t1, r) {
            return Math.min(r, Math.max(t1, e));
        }
        function Ce(e, t1, r) {
            return (r = De((r - e) / (t1 - e), 0, 1)) * r * (3 - 2 * r);
        }
        function Re(e, t1, r) {
            const n = r - t1, i = ((e - t1) % n + n) % n + t1;
            return i === t1 ? r : i;
        }
        function Le(e, t1, r) {
            if (!e.length) return r(null, []);
            let n = e.length;
            const i = new Array(e.length);
            let s = null;
            e.forEach((e, o)=>{
                t1(e, (e, t1)=>{
                    e && (s = e), i[o] = t1, 0 === --n && r(s, i);
                });
            });
        }
        let Oe = 1;
        function Ue() {
            return Oe++;
        }
        function Ne(e) {
            return e <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log2(e)));
        }
        function je(e, t1) {
            e.forEach((e)=>{
                t1[e] && (t1[e] = t1[e].bind(t1));
            });
        }
        function Ge(e, t1, r) {
            const n = {};
            for(const r in e)n[r] = t1.call(this, e[r], r, e);
            return n;
        }
        function $e(e, t1, r) {
            const n = {};
            for(const r in e)t1.call(this, e[r], r, e) && (n[r] = e[r]);
            return n;
        }
        function qe(e) {
            return Array.isArray(e) ? e.map(qe) : "object" == typeof e && e ? Ge(e, qe) : e;
        }
        function Xe(e, t1) {
            for(let r = 0; r < e.length; r++)if (t1.indexOf(e[r]) >= 0) return !0;
            return !1;
        }
        const He = {};
        function Ze(e) {
            He[e] || ("undefined" != typeof console && console.warn(e), He[e] = !0);
        }
        function We(e, t1, r) {
            return (r.y - e.y) * (t1.x - e.x) > (t1.y - e.y) * (r.x - e.x);
        }
        function Ye(e) {
            let t1 = 0;
            for(let r, n, i = 0, s = e.length, o = s - 1; i < s; o = i++)r = e[i], n = e[o], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        function Je([e, t1, r]) {
            const n = Be(t1 + 90), i = Be(r);
            return {
                x: e * Math.cos(n) * Math.sin(i),
                y: e * Math.sin(n) * Math.sin(i),
                z: e * Math.cos(i),
                azimuthal: t1,
                polar: r
            };
        }
        function Ke(e) {
            return ("undefined" != typeof self || void 0 !== e) && "undefined" != typeof WorkerGlobalScope && (void 0 !== e ? e : self) instanceof WorkerGlobalScope;
        }
        function Qe(e) {
            const t1 = {};
            if (e.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e, r, n, i)=>{
                const s = n || i;
                return t1[r] = !s || s.toLowerCase(), "";
            }), t1["max-age"]) {
                const e = parseInt(t1["max-age"], 10);
                isNaN(e) ? delete t1["max-age"] : t1["max-age"] = e;
            }
            return t1;
        }
        let et = null;
        function tt(e, t1) {
            return [
                e[4 * t1],
                e[4 * t1 + 1],
                e[4 * t1 + 2],
                e[4 * t1 + 3]
            ];
        }
        function rt(e, t1, r, n) {
            for(; t1 < r;){
                const i = t1 + r >> 1;
                e[i] < n ? t1 = i + 1 : r = i;
            }
            return t1;
        }
        function nt(e, t1, r, n) {
            for(; t1 < r;){
                const i = t1 + r >> 1;
                e[i] <= n ? t1 = i + 1 : r = i;
            }
            return t1;
        }
        function it(e) {
            return e > 0 ? 1 / (1.001 - e) : 1 + e;
        }
        function st(e) {
            return e > 0 ? 1 - 1 / (1.001 - e) : -e;
        }
        function ot(e, t1, r) {
            return (e - t1.min) * (r.max - r.min) / (t1.max - t1.min) + r.min;
        }
        const at = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!at.API_URL) return null;
                try {
                    const e = new URL(at.API_URL);
                    return "api.mapbox.cn" === e.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm",
            MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm",
            BUILDING_GEN_URL: "https://api.mapbox.com/mapbox-gl-js/building-gen/building_gen_v1.2.4.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1"
        };
        function lt(e) {
            return at.API_URL_REGEX.test(e);
        }
        function ut(e) {
            return at.API_SPRITE_REGEX.test(e);
        }
        let ct, ht, pt, dt, ft, mt;
        function yt() {
            return null == ct && (ct = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), ct;
        }
        const gt = {
            now: ()=>void 0 !== dt ? dt : performance.now(),
            setNow (e) {
                dt = e;
            },
            restoreNow () {
                dt = void 0;
            },
            frame (e) {
                const t1 = requestAnimationFrame(e);
                return {
                    cancel: ()=>cancelAnimationFrame(t1)
                };
            },
            getImageData (e, t1 = 0) {
                const { width: r, height: n } = e;
                ft || (ft = document.createElement("canvas"));
                const i = ft.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return (r > ft.width || n > ft.height) && (ft.width = r, ft.height = n), i.clearRect(-t1, -t1, r + 2 * t1, n + 2 * t1), i.drawImage(e, 0, 0, r, n), i.getImageData(-t1, -t1, r + 2 * t1, n + 2 * t1);
            },
            resolveURL: (e)=>(ht || (ht = document.createElement("a")), ht.href = e, ht.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (null == pt && (pt = window.matchMedia("(prefers-reduced-motion: reduce)")), pt.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== mt) return mt;
                if (!yt()) return mt = !1, !1;
                const e = new OffscreenCanvas(85, 1), t1 = e.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let n = 0; n < e.width; ++n)t1.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, t1.fillRect(n, 0, 1, 1);
                const n = t1.getImageData(0, 0, e.width, e.height);
                r = 0;
                for(let e = 0; e < n.data.length; ++e)if (e % 4 != 3 && r++ !== n.data[e]) return mt = !0, !0;
                return mt = !1, !1;
            }
        };
        function xt(e, t1) {
            const r = e.indexOf("?");
            if (r < 0) return `${e}?${new URLSearchParams(t1).toString()}`;
            const n = new URLSearchParams(e.slice(r));
            for(const e in t1)n.set(e, t1[e]);
            return `${e.slice(0, r)}?${n.toString()}`;
        }
        function vt(e, t1 = {
            persistentParams: []
        }) {
            const r = e.indexOf("?");
            if (r < 0) return e;
            const n = new URLSearchParams, i = new URLSearchParams(e.slice(r));
            for (const e of t1.persistentParams){
                const t1 = i.get(e);
                t1 && n.set(e, t1);
            }
            const s = n.toString();
            return `${e.slice(0, r)}${s.length > 0 ? `?${s}` : ""}`;
        }
        const bt = "mapbox-tiles";
        let wt = 500, _t = 50;
        const At = [
            "language",
            "worldview",
            "jobid"
        ];
        let Mt;
        function It() {
            try {
                return caches;
            } catch (e) {}
        }
        function St() {
            const e = It();
            e && null == Mt && (Mt = e.open(bt));
        }
        let zt = 1 / 0;
        const Pt = {
            supported: !1,
            testSupport: function(e) {
                !kt && Tt && (Vt ? Ft(e) : Bt = e);
            }
        };
        let Bt, Tt, kt = !1, Vt = !1;
        const Et = "undefined" != typeof self ? self : {};
        function Ft(e) {
            const t1 = e.createTexture();
            e.bindTexture(e.TEXTURE_2D, t1);
            try {
                if (e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, Tt), e.isContextLost()) return;
                Pt.supported = !0;
            } catch (e) {}
            e.deleteTexture(t1), kt = !0;
        }
        Et.document && (Tt = Et.document.createElement("img"), Tt.onload = function() {
            Bt && Ft(Bt), Bt = null, Vt = !0;
        }, Tt.onerror = function() {
            kt = !0, Bt = null;
        }, Tt.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const Dt = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        Object.freeze(Dt);
        class Ct extends Error {
            constructor(e, t1, r){
                401 === t1 && lt(r) && (e += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(e), this.status = t1, this.url = r;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        const Rt = Ke() ? ()=>self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href;
        const Lt = function(e, t1) {
            var r;
            return /^file:/.test(r = e.url) || /^file:/.test(Rt()) && !/^\w+:/.test(r) ? function(e, t1) {
                const r = new XMLHttpRequest;
                r.open(e.method || "GET", e.url, !0), "arrayBuffer" === e.type && (r.responseType = "arraybuffer");
                for(const t1 in e.headers)r.setRequestHeader(t1, e.headers[t1]);
                return "json" === e.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e.credentials, r.onerror = ()=>{
                    t1(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === e.type) try {
                            n = JSON.parse(r.response);
                        } catch (e) {
                            return t1(e);
                        }
                        const i = new Headers;
                        r.getAllResponseHeaders().trim().split(/[\r\n]+/).forEach((e)=>{
                            const t1 = e.split(": "), r = t1.shift(), n = t1.join(": ");
                            i.append(r, n);
                        }), t1(null, n, i);
                    } else t1(new Ct(r.statusText, r.status, e.url));
                }, r.send(e.body), {
                    cancel: ()=>r.abort()
                };
            }(e, t1) : function(e, t1) {
                const r = new AbortController, n = new Request(e.url, {
                    method: e.method || "GET",
                    body: e.body,
                    credentials: e.credentials,
                    headers: e.headers,
                    referrer: Rt(),
                    referrerPolicy: e.referrerPolicy,
                    signal: r.signal
                });
                let i = !1, s = !1;
                const o = (a = n.url).indexOf("sku=") > 0 && lt(a);
                var a;
                "json" === e.type && n.headers.set("Accept", "application/json");
                const l = (r, i, a)=>{
                    if (s) return;
                    if (r && "SecurityError" !== r.message && Ze(r.toString()), i && a) return u(i);
                    const l = Date.now();
                    fetch(n).then((r)=>{
                        if (r.ok) {
                            const e = o ? r.clone() : null;
                            return u(r, e, l);
                        }
                        return t1(new Ct(r.statusText, r.status, e.url));
                    }).catch((r)=>{
                        "AbortError" !== r.name && t1(new Error(`${r.message} ${e.url}`));
                    });
                }, u = (r, o, a)=>{
                    ("arrayBuffer" === e.type ? r.arrayBuffer() : "json" === e.type ? r.json() : r.text()).then((e)=>{
                        s || (o && a && function(e, t1, r) {
                            if (St(), null == Mt) return;
                            const n = Qe(t1.headers.get("cache-control") || "");
                            if (n["no-store"]) return;
                            const i = {
                                status: t1.status,
                                statusText: t1.statusText,
                                headers: new Headers
                            };
                            t1.headers.forEach((e, t1)=>i.headers.set(t1, e)), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                            const s = i.headers.get("expires");
                            if (!s) return;
                            if (new Date(s).getTime() - r < 42e4) return;
                            let o = vt(e.url, {
                                persistentParams: At
                            });
                            if (206 === t1.status) {
                                const t1 = e.headers.get("Range");
                                if (!t1) return;
                                i.status = 200, o = xt(o, {
                                    range: t1
                                });
                            }
                            const a = new Response(200 !== (l = t1.status) && 404 !== l && [
                                101,
                                103,
                                204,
                                205,
                                304
                            ].includes(l) ? null : t1.body, i);
                            var l;
                            St(), null != Mt && Mt.then((e)=>e.put(o, a)).catch((e)=>Ze(e.message));
                        }(n, o, a), i = !0, t1(null, e, r.headers));
                    }).catch((e)=>{
                        s || t1(new Error(e.message));
                    });
                };
                return o ? function(e, t1) {
                    if (St(), null == Mt) return t1(null);
                    Mt.then((r)=>{
                        let n = vt(e.url, {
                            persistentParams: At
                        });
                        const i = e.headers.get("Range");
                        i && (n = xt(n, {
                            range: i
                        })), r.match(n).then((e)=>{
                            const i = function(e) {
                                if (!e) return !1;
                                const t1 = new Date(e.headers.get("expires") || 0), r = Qe(e.headers.get("cache-control") || "");
                                return Number(t1) > Date.now() && !r["no-cache"];
                            }(e);
                            r.delete(n).catch(t1), i && r.put(n, e.clone()).catch(t1), t1(null, e, i);
                        }).catch(t1);
                    }).catch(t1);
                }(n, l) : l(null, null), {
                    cancel: ()=>{
                        s = !0, i || r.abort();
                    }
                };
            }(e, t1);
        }, Ot = function(e, t1) {
            return Lt(Object.assign(e, {
                type: "arrayBuffer"
            }), t1);
        };
        function Ut(e) {
            const t1 = document.createElement("a");
            return t1.href = e, t1.protocol === location.protocol && t1.host === location.host;
        }
        let Nt, jt;
        Nt = [], jt = 0;
        const Gt = function(e, t1) {
            if (Pt.supported && (e.headers || (e.headers = {}), e.headers.accept = "image/webp,*/*"), jt >= at.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: e,
                    callback: t1,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Nt.push(r), r;
            }
            jt++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, jt--; Nt.length && jt < at.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const e = Nt.shift(), { requestParameters: t1, callback: r, cancelled: n } = e;
                    n || (e.cancel = Gt(t1, r).cancel);
                }
            }, i = Ot(e, (e, r, i)=>{
                n(), e ? t1(e) : r && function(e, t1) {
                    const r = new Blob([
                        new Uint8Array(e)
                    ], {
                        type: "image/png"
                    });
                    createImageBitmap(r).then((e)=>{
                        t1(null, e);
                    }).catch((e)=>{
                        t1(new Error(`Could not load image because of ${e.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (e, r)=>t1(e, r, i));
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        var $t, qt, Xt, Ht = {
            exports: {}
        }, Zt = {
            exports: {}
        }, Wt = {
            exports: {}
        }, Yt = function() {
            if (Xt) return Ht.exports;
            Xt = 1;
            var e = ($t || ($t = 1, Zt.exports = function(e, t1) {
                var r, n, i, s, o, a, l, u;
                for(n = e.length - (r = 3 & e.length), i = t1, o = 3432918353, a = 461845907, u = 0; u < n;)l = 255 & e.charCodeAt(u) | (255 & e.charCodeAt(++u)) << 8 | (255 & e.charCodeAt(++u)) << 16 | (255 & e.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + (((s >>> 16) + 58964 & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & e.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & e.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e.charCodeAt(u))) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return i ^= e.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), Zt.exports), t1 = (qt || (qt = 1, Wt.exports = function(e, t1) {
                for(var r, n = e.length, i = t1 ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & e.charCodeAt(s) | (255 & e.charCodeAt(++s)) << 8 | (255 & e.charCodeAt(++s)) << 16 | (255 & e.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & e.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & e.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & e.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), Wt.exports);
            return Ht.exports = e, Ht.exports.murmur3 = e, Ht.exports.murmur2 = t1, Ht.exports;
        }(), Jt = _e(Yt);
        class Kt {
            constructor(e, ...t1){
                Object.assign(this, t1[0] || {}), this.type = e;
            }
        }
        class Qt extends Kt {
            constructor(e, t1 = {}){
                super("error", Object.assign({
                    error: e
                }, t1));
            }
        }
        function er(e, t1, r) {
            r[e] && -1 !== r[e].indexOf(t1) || (r[e] = r[e] || [], r[e].push(t1));
        }
        function tr(e, t1, r) {
            if (r && r[e]) {
                const n = r[e].indexOf(t1);
                -1 !== n && r[e].splice(n, 1);
            }
        }
        class rr {
            on(e, t1) {
                return this._listeners = this._listeners || {}, er(e, t1, this._listeners), this;
            }
            off(e, t1) {
                return tr(e, t1, this._listeners), tr(e, t1, this._oneTimeListeners), this;
            }
            once(e, t1) {
                return t1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, er(e, t1, this._oneTimeListeners), this) : new Promise((t1)=>{
                    this.once(e, t1);
                });
            }
            fire(e, t1) {
                const r = "string" == typeof e ? new Kt(e, t1) : e, n = r.type;
                if (this.listens(n)) {
                    r.target = this;
                    const e = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const t1 of e)t1.call(this, r);
                    const t1 = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const e of t1)tr(n, e, this._oneTimeListeners), e.call(this, r);
                    const i = this._eventedParent;
                    if (i) {
                        const e = "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData;
                        Object.assign(r, e), i.fire(r);
                    }
                } else r instanceof Qt && console.error(r.error);
                return this;
            }
            listens(e) {
                return !!(this._listeners && this._listeners[e] && this._listeners[e].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e] && this._oneTimeListeners[e].length > 0 || this._eventedParent && this._eventedParent.listens(e));
            }
            setEventedParent(e, t1) {
                return this._eventedParent = e, this._eventedParentData = t1, this;
            }
        }
        class nr {
            constructor(e){
                "string" == typeof e ? this.name = e : (this.name = e.name, this.iconsetId = e.iconsetId);
            }
            static from(e) {
                return new nr(e);
            }
            static toString(e) {
                return e.iconsetId ? `${e.name}${e.iconsetId}` : e.name;
            }
            static parse(e) {
                const [t1, r] = e.split("");
                return new nr({
                    name: t1,
                    iconsetId: r
                });
            }
            static isEqual(e, t1) {
                return e.name === t1.name && e.iconsetId === t1.iconsetId;
            }
            toString() {
                return nr.toString(this);
            }
            serialize() {
                return {
                    name: this.name,
                    iconsetId: this.iconsetId
                };
            }
        }
        var ir, sr = {}, or = function() {
            if (ir) return sr;
            ir = 1;
            var e = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function t1(e) {
                return (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : e;
            }
            function r(e) {
                return t1("%" === e[e.length - 1] ? parseFloat(e) / 100 * 255 : parseInt(e));
            }
            function n(e) {
                var t1;
                return (t1 = "%" === e[e.length - 1] ? parseFloat(e) / 100 : parseFloat(e)) < 0 ? 0 : t1 > 1 ? 1 : t1;
            }
            function i(e, t1, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? e + (t1 - e) * r * 6 : 2 * r < 1 ? t1 : 3 * r < 2 ? e + (t1 - e) * (2 / 3 - r) * 6 : e;
            }
            try {
                sr.parseCSSColor = function(s) {
                    var o, a = s.replace(/ /g, "").toLowerCase();
                    if (a in e) return e[a].slice();
                    if ("#" === a[0]) return 4 === a.length ? (o = parseInt(a.substr(1), 16)) >= 0 && o <= 4095 ? [
                        (3840 & o) >> 4 | (3840 & o) >> 8,
                        240 & o | (240 & o) >> 4,
                        15 & o | (15 & o) << 4,
                        1
                    ] : null : 7 === a.length && (o = parseInt(a.substr(1), 16)) >= 0 && o <= 16777215 ? [
                        (16711680 & o) >> 16,
                        (65280 & o) >> 8,
                        255 & o,
                        1
                    ] : null;
                    var l = a.indexOf("("), u = a.indexOf(")");
                    if (-1 !== l && u + 1 === a.length) {
                        var c = a.substr(0, l), h = a.substr(l + 1, u - (l + 1)).split(","), p = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    r(h[0]),
                                    r(h[1]),
                                    r(h[2]),
                                    p
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var d = (parseFloat(h[0]) % 360 + 360) % 360 / 360, f = n(h[1]), m = n(h[2]), y = m <= .5 ? m * (f + 1) : m + f - m * f, g = 2 * m - y;
                                return [
                                    t1(255 * i(g, y, d + 1 / 3)),
                                    t1(255 * i(g, y, d)),
                                    t1(255 * i(g, y, d - 1 / 3)),
                                    p
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (e) {}
            return sr;
        }();
        class ar {
            constructor(e, t1, r, n = 1){
                this.r = e, this.g = t1, this.b = r, this.a = n;
            }
            static parse(e) {
                if (!e) return;
                if (e instanceof ar) return e;
                if ("string" != typeof e) return;
                const t1 = or.parseCSSColor(e);
                return t1 ? new ar(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]) : void 0;
            }
            toString() {
                const [e, t1, r, n] = [
                    this.r,
                    this.g,
                    this.b,
                    this.a
                ];
                return `rgba(${Math.round(255 * e)},${Math.round(255 * t1)},${Math.round(255 * r)},${n})`;
            }
            toNonPremultipliedRenderColor(e) {
                const { r: t1, g: r, b: n, a: i } = this;
                return new ur(e, t1, r, n, i);
            }
            toPremultipliedRenderColor(e) {
                const { r: t1, g: r, b: n, a: i } = this;
                return new cr(e, t1 * i, r * i, n * i, i);
            }
            clone() {
                return new ar(this.r, this.g, this.b, this.a);
            }
        }
        class lr {
            constructor(e, t1, r, n, i, s = !1){
                if (this.premultiplied = !1, this.premultiplied = s, e) {
                    const s = e.image.height, o = s * s;
                    this.premultiplied ? (t1 = 0 === i ? 0 : t1 / i * (s - 1), r = 0 === i ? 0 : r / i * (s - 1), n = 0 === i ? 0 : n / i * (s - 1)) : (t1 *= s - 1, r *= s - 1, n *= s - 1), t1 = Math.max(0, Math.min(s - 1, t1)), r = Math.max(0, Math.min(s - 1, r)), n = Math.max(0, Math.min(s - 1, n));
                    const a = Math.floor(t1), l = Math.floor(r), u = Math.floor(n), c = Math.ceil(t1), h = Math.ceil(r), p = Math.ceil(n), d = t1 - a, f = r - l, m = n - u, y = e.image.data, g = 4 * (a + l * o + u * s), x = 4 * (a + l * o + p * s), v = 4 * (a + h * o + u * s), b = 4 * (a + h * o + p * s), w = 4 * (c + l * o + u * s), _ = 4 * (c + l * o + p * s), A = 4 * (c + h * o + u * s), M = 4 * (c + h * o + p * s);
                    this.r = hr(hr(hr(y[g], y[x], m), hr(y[v], y[b], m), f), hr(hr(y[w], y[_], m), hr(y[A], y[M], m), f), d) / 255 * (this.premultiplied ? i : 1), this.g = hr(hr(hr(y[g + 1], y[x + 1], m), hr(y[v + 1], y[b + 1], m), f), hr(hr(y[w + 1], y[_ + 1], m), hr(y[A + 1], y[M + 1], m), f), d) / 255 * (this.premultiplied ? i : 1), this.b = hr(hr(hr(y[g + 2], y[x + 2], m), hr(y[v + 2], y[b + 2], m), f), hr(hr(y[w + 2], y[_ + 2], m), hr(y[A + 2], y[M + 2], m), f), d) / 255 * (this.premultiplied ? i : 1), this.a = i;
                } else this.r = t1, this.g = r, this.b = n, this.a = i;
            }
            toArray() {
                const { r: e, g: t1, b: r, a: n } = this;
                return [
                    255 * e,
                    255 * t1,
                    255 * r,
                    n
                ];
            }
            toHslaArray() {
                let { r: e, g: t1, b: r, a: n } = this;
                if (this.premultiplied) {
                    if (0 === n) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const i = 1 / n;
                    e *= i, t1 *= i, r *= i;
                }
                const i = Math.min(Math.max(e, 0), 1), s = Math.min(Math.max(t1, 0), 1), o = Math.min(Math.max(r, 0), 1), a = Math.min(i, s, o), l = Math.max(i, s, o), u = l - a, c = .5 * (a + l);
                if (0 === u) return [
                    0,
                    0,
                    100 * c,
                    n
                ];
                const h = c > .5 ? u / (2 - l - a) : u / (l + a);
                let p;
                switch(l){
                    case i:
                        p = 60 * ((s - o) / u + (s < o ? 6 : 0));
                        break;
                    case s:
                        p = 60 * ((o - i) / u + 2);
                        break;
                    default:
                        p = 60 * ((i - s) / u + 4);
                }
                return [
                    p,
                    100 * h,
                    100 * c,
                    n
                ];
            }
            toArray01() {
                const { r: e, g: t1, b: r, a: n } = this;
                return [
                    e,
                    t1,
                    r,
                    n
                ];
            }
            toArray01Scaled(e) {
                const { r: t1, g: r, b: n } = this;
                return [
                    t1 * e,
                    r * e,
                    n * e
                ];
            }
            toArray01Linear() {
                const { r: e, g: t1, b: r, a: n } = this;
                return [
                    Math.pow(e, 2.2),
                    Math.pow(t1, 2.2),
                    Math.pow(r, 2.2),
                    n
                ];
            }
        }
        class ur extends lr {
            constructor(e, t1, r, n, i){
                super(e, t1, r, n, i, !1);
            }
        }
        class cr extends lr {
            constructor(e, t1, r, n, i){
                super(e, t1, r, n, i, !0);
            }
        }
        function hr(e, t1, r) {
            return e * (1 - r) + t1 * r;
        }
        function pr(e, t1, r) {
            return e.map((e, n)=>hr(e, t1[n], r));
        }
        ar.black = new ar(0, 0, 0, 1), ar.white = new ar(1, 1, 1, 1), ar.transparent = new ar(0, 0, 0, 0), ar.red = new ar(1, 0, 0, 1), ar.blue = new ar(0, 0, 1, 1);
        var dr = Object.freeze({
            __proto__: null,
            array: pr,
            color: function(e, t1, r) {
                return new ar(hr(e.r, t1.r, r), hr(e.g, t1.g, r), hr(e.b, t1.b, r), hr(e.a, t1.a, r));
            },
            number: hr
        });
        class fr extends Error {
            constructor(e, t1){
                super(t1), this.message = t1, this.key = e;
            }
        }
        class mr {
            constructor(e, t1 = []){
                this.parent = e, this.bindings = {};
                for (const [e, r] of t1)this.bindings[e] = r;
            }
            concat(e) {
                return new mr(this, e);
            }
            get(e) {
                if (this.bindings[e]) return this.bindings[e];
                if (this.parent) return this.parent.get(e);
                throw new Error(`${e} not found in scope.`);
            }
            has(e) {
                return !!this.bindings[e] || !!this.parent && this.parent.has(e);
            }
        }
        const yr = {
            kind: "null"
        }, gr = {
            kind: "number"
        }, xr = {
            kind: "string"
        }, vr = {
            kind: "boolean"
        }, br = {
            kind: "color"
        }, wr = {
            kind: "object"
        }, _r = {
            kind: "value"
        }, Ar = {
            kind: "collator"
        }, Mr = {
            kind: "formatted"
        }, Ir = {
            kind: "resolvedImage"
        };
        function Sr(e, t1) {
            return {
                kind: "array",
                itemType: e,
                N: t1
            };
        }
        function zr(e) {
            if ("array" === e.kind) {
                const t1 = zr(e.itemType);
                return "number" == typeof e.N ? `array<${t1}, ${e.N}>` : "value" === e.itemType.kind ? "array" : `array<${t1}>`;
            }
            return e.kind;
        }
        const Pr = [
            yr,
            gr,
            xr,
            vr,
            br,
            Mr,
            wr,
            Sr(_r),
            Ir
        ];
        function Br(e, t1) {
            if ("error" === t1.kind) return null;
            if ("array" === e.kind) {
                if ("array" === t1.kind && (0 === t1.N && "value" === t1.itemType.kind || !Br(e.itemType, t1.itemType)) && ("number" != typeof e.N || e.N === t1.N)) return null;
            } else {
                if (e.kind === t1.kind) return null;
                if ("value" === e.kind) {
                    for (const e of Pr)if (!Br(e, t1)) return null;
                }
            }
            return `Expected ${zr(e)} but found ${zr(t1)} instead.`;
        }
        function Tr(e, t1) {
            return t1.some((t1)=>t1.kind === e.kind);
        }
        function kr(e, t1) {
            return t1.some((t1)=>"null" === t1 ? null === e : "array" === t1 ? Array.isArray(e) : "object" === t1 ? e && !Array.isArray(e) && "object" == typeof e : t1 === typeof e);
        }
        function Vr(e, t1) {
            return "array" === e.kind && "array" === t1.kind ? e.N === t1.N && Vr(e.itemType, t1.itemType) : e.kind === t1.kind;
        }
        class Er {
            constructor(e, t1, r){
                this.sensitivity = e ? t1 ? "variant" : "case" : t1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e, t1) {
                return this.collator.compare(e, t1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Fr {
            constructor(e, t1, r, n, i){
                this.text = e.normalize ? e.normalize() : e, this.image = t1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Dr {
            constructor(e){
                this.sections = e;
            }
            static fromString(e) {
                return new Dr([
                    new Fr(e, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e)=>0 !== e.text.length || !!e.image && e.image.hasPrimary());
            }
            static factory(e) {
                return e instanceof Dr ? e : Dr.fromString(e);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e)=>e.text).join("");
            }
            serialize() {
                const e = [
                    "format"
                ];
                for (const t1 of this.sections){
                    if (t1.image) {
                        const r = t1.image.getPrimary().id.toString();
                        e.push([
                            "image",
                            r
                        ]);
                        continue;
                    }
                    e.push(t1.text);
                    const r = {};
                    t1.fontStack && (r["text-font"] = [
                        "literal",
                        t1.fontStack.split(",")
                    ]), t1.scale && (r["font-scale"] = t1.scale), t1.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(t1.textColor.toNonPremultipliedRenderColor(null).toArray())), e.push(r);
                }
                return e;
            }
        }
        class Cr {
            constructor(e, t1 = {}){
                this.id = nr.from(e), this.params = t1.params, this.sx = t1.sx || 1, this.sy = t1.sy || 1;
            }
            toString() {
                return JSON.stringify(this);
            }
            static parse(e) {
                let t1, r, n, i;
                try {
                    ({ id: t1, params: r, sx: n, sy: i } = JSON.parse(e) || {});
                } catch (e) {
                    return null;
                }
                return t1 ? new Cr(t1, {
                    params: r,
                    sx: n,
                    sy: i
                }) : null;
            }
            scaleSelf(e, t1 = e) {
                return this.sx *= e, this.sy *= t1, this;
            }
        }
        class Rr {
            constructor(e, t1, r, n, i = !1){
                this.primaryId = nr.from(e), this.primaryOptions = t1, r && (this.secondaryId = nr.from(r)), this.secondaryOptions = n, this.available = i;
            }
            toString() {
                return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
                return !!this.primaryId;
            }
            getPrimary() {
                return new Cr(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
                return !!this.secondaryId;
            }
            getSecondary() {
                return this.secondaryId ? new Cr(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(e) {
                return "string" == typeof e ? Rr.build({
                    name: e
                }) : e;
            }
            static build(e, t1, r, n) {
                return !e || "object" == typeof e && !("name" in e) ? null : new Rr(e, r, t1, n);
            }
        }
        function Lr(e, t1, r, n) {
            return "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                e,
                t1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                e,
                t1,
                r,
                n
            ] : [
                e,
                t1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function Or(e) {
            if (null === e) return !0;
            if ("string" == typeof e) return !0;
            if ("boolean" == typeof e) return !0;
            if ("number" == typeof e) return !0;
            if (e instanceof ar) return !0;
            if (e instanceof Er) return !0;
            if (e instanceof Dr) return !0;
            if (e instanceof Rr) return !0;
            if (Array.isArray(e)) {
                for (const t1 of e)if (!Or(t1)) return !1;
                return !0;
            }
            if ("object" == typeof e) {
                for(const t1 in e)if (!Or(e[t1])) return !1;
                return !0;
            }
            return !1;
        }
        function Ur(e) {
            if (null === e) return yr;
            if ("string" == typeof e) return xr;
            if ("boolean" == typeof e) return vr;
            if ("number" == typeof e) return gr;
            if (e instanceof ar) return br;
            if (e instanceof Er) return Ar;
            if (e instanceof Dr) return Mr;
            if (e instanceof Rr) return Ir;
            if (Array.isArray(e)) {
                const t1 = e.length;
                let r;
                for (const t1 of e){
                    const e = Ur(t1);
                    if (r) {
                        if (r === e) continue;
                        r = _r;
                        break;
                    }
                    r = e;
                }
                return Sr(r || _r, t1);
            }
            return wr;
        }
        function Nr(e) {
            const t1 = typeof e;
            return null === e ? "" : "string" === t1 || "number" === t1 || "boolean" === t1 ? String(e) : e instanceof Dr || e instanceof Rr || e instanceof ar ? e.toString() : JSON.stringify(e);
        }
        class jr {
            constructor(e, t1){
                this.type = e, this.value = t1;
            }
            static parse(e, t1) {
                if (2 !== e.length) return t1.error(`'literal' expression requires exactly one argument, but found ${e.length - 1} instead.`);
                if (!Or(e[1])) return t1.error("invalid value");
                const r = e[1];
                let n = Ur(r);
                const i = t1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new jr(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof ar ? [
                    "rgba"
                ].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof Dr ? this.value.serialize() : this.value;
            }
        }
        class Gr {
            constructor(e){
                this.name = "ExpressionEvaluationError", this.message = e;
            }
            toJSON() {
                return this.message;
            }
        }
        const $r = {
            string: xr,
            number: gr,
            boolean: vr,
            object: wr
        };
        class qr {
            constructor(e, t1){
                this.type = e, this.args = t1;
            }
            static parse(e, t1) {
                if (e.length < 2) return t1.error("Expected at least one argument.");
                let r, n = 1;
                const i = e[0];
                if ("array" === i) {
                    let i, s;
                    if (e.length > 2) {
                        const r = e[1];
                        if ("string" != typeof r || !(r in $r) || "object" === r) return t1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = $r[r], n++;
                    } else i = _r;
                    if (e.length > 3) {
                        if (null !== e[2] && ("number" != typeof e[2] || e[2] < 0 || e[2] !== Math.floor(e[2]))) return t1.error('The length argument to "array" must be a positive integer literal', 2);
                        s = e[2], n++;
                    }
                    r = Sr(i, s);
                } else r = $r[i];
                const s = [];
                for(; n < e.length; n++){
                    const r = t1.parse(e[n], n, _r);
                    if (!r) return null;
                    s.push(r);
                }
                return new qr(r, s);
            }
            evaluate(e) {
                for(let t1 = 0; t1 < this.args.length; t1++){
                    const r = this.args[t1].evaluate(e);
                    if (!Br(this.type, Ur(r))) return r;
                    if (t1 === this.args.length - 1) throw new Gr(`The expression ${JSON.stringify(this.args[t1].serialize())} evaluated to ${zr(Ur(r))} but was expected to be of type ${zr(this.type)}.`);
                }
                return null;
            }
            eachChild(e) {
                this.args.forEach(e);
            }
            outputDefined() {
                return this.args.every((e)=>e.outputDefined());
            }
            serialize() {
                const e = this.type, t1 = [
                    e.kind
                ];
                if ("array" === e.kind) {
                    const r = e.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        t1.push(r.kind);
                        const n = e.N;
                        ("number" == typeof n || this.args.length > 1) && t1.push(n);
                    }
                }
                return t1.concat(this.args.map((e)=>e.serialize()));
            }
        }
        class Xr {
            constructor(e){
                this.type = Mr, this.sections = e;
            }
            static parse(e, t1) {
                if (e.length < 2) return t1.error("Expected at least one argument.");
                const r = e[1];
                if (!Array.isArray(r) && "object" == typeof r) return t1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= e.length - 1; ++r){
                    const s = e[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let e = null;
                        if (s["font-scale"] && (e = t1.parseObjectValue(s["font-scale"], r, "font-scale", gr), !e)) return null;
                        let o = null;
                        if (s["text-font"] && (o = t1.parseObjectValue(s["text-font"], r, "text-font", Sr(xr)), !o)) return null;
                        let a = null;
                        if (s["text-color"] && (a = t1.parseObjectValue(s["text-color"], r, "text-color", br), !a)) return null;
                        const l = n[n.length - 1];
                        l.scale = e, l.font = o, l.textColor = a;
                    } else {
                        const s = t1.parse(e[r], r, _r);
                        if (!s) return null;
                        const o = s.type.kind;
                        if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return t1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Xr(n);
            }
            evaluate(e) {
                return new Dr(this.sections.map((t1)=>{
                    const r = t1.content.evaluate(e);
                    return Vr(Ur(r), Ir) ? new Fr("", r, null, null, null) : new Fr(Nr(r), null, t1.scale ? t1.scale.evaluate(e) : null, t1.font ? t1.font.evaluate(e).join(",") : null, t1.textColor ? t1.textColor.evaluate(e) : null);
                }));
            }
            eachChild(e) {
                for (const t1 of this.sections)e(t1.content), t1.scale && e(t1.scale), t1.font && e(t1.font), t1.textColor && e(t1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e = [
                    "format"
                ];
                for (const t1 of this.sections){
                    e.push(t1.content.serialize());
                    const r = {};
                    t1.scale && (r["font-scale"] = t1.scale.serialize()), t1.font && (r["text-font"] = t1.font.serialize()), t1.textColor && (r["text-color"] = t1.textColor.serialize()), e.push(r);
                }
                return e;
            }
        }
        class Hr {
            constructor(e, t1, r, n){
                this._imageWarnHistory = {}, this.type = Ir, this.namePrimary = e, this.nameSecondary = t1, r && (this.paramsPrimary = r.params, this.iconsetIdPrimary = r.iconset ? r.iconset.id : void 0), n && (this.paramsSecondary = n.params, this.iconsetIdSecondary = n.iconset ? n.iconset.id : void 0);
            }
            static parse(e, t1) {
                if (e.length < 2) return t1.error("Expected two or more arguments.");
                let r = 1;
                const n = [];
                function i() {
                    if (r < e.length) {
                        const i = t1.parse(e[r], r++, xr);
                        return i ? (n.push({
                            image: i,
                            options: {}
                        }), !0) : (t1.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function s() {
                    if (r < e.length) {
                        const s = e[r];
                        if (null === (i = s) || "object" != typeof i || Array.isArray(i)) return !0;
                        const o = s.params, a = s.iconset, l = t1.concat(r);
                        if (!o && !a) return r++, !0;
                        if (o) {
                            if ("object" != typeof o || o.constructor !== Object) return l.error('Image options "params" should be an object'), !1;
                            const e = {}, t1 = l.concat(void 0, "params");
                            for(const r in o){
                                if (!r) return t1.error("Image parameter name should be non-empty"), !1;
                                const n = t1.concat(void 0, r).parse(o[r], void 0, br, void 0, {
                                    typeAnnotation: "coerce"
                                });
                                if (!n) return !1;
                                e[r] = n;
                            }
                            n[n.length - 1].options.params = e;
                        }
                        if (a) {
                            if ("object" != typeof a || a.constructor !== Object) return l.error('Image options "iconset" should be an object'), !1;
                            if (!a.id) return l.error('Image options "iconset" should have an "id" property'), !1;
                            n[n.length - 1].options.iconset = a;
                        }
                        return r++, !0;
                    }
                    var i;
                    return !0;
                }
                for(let e = 0; e < 2; e++)if (!i() || !s()) return;
                return new Hr(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(e, t1) {
                const r = {};
                if (t1) {
                    for(const n in t1)if (t1[n]) try {
                        r[n] = t1[n].evaluate(e);
                    } catch (e) {
                        continue;
                    }
                    if (0 !== Object.keys(r).length) return {
                        params: r
                    };
                }
            }
            evaluate(e) {
                const t1 = {
                    name: this.namePrimary.evaluate(e),
                    iconsetId: this.iconsetIdPrimary
                }, r = this.nameSecondary ? {
                    name: this.nameSecondary.evaluate(e),
                    iconsetId: this.iconsetIdSecondary
                } : void 0, n = Rr.build(t1, r, this.paramsPrimary ? this.evaluateParams(e, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(e, this.paramsSecondary) : void 0);
                if (n && e.availableImages) {
                    const t1 = n.getPrimary().id;
                    if (n.available = e.availableImages.some((e)=>nr.isEqual(e, t1)), n.available) {
                        const t1 = n.getSecondary() ? n.getSecondary().id : null;
                        t1 && (n.available = e.availableImages.some((e)=>nr.isEqual(e, t1)));
                    }
                }
                return n;
            }
            eachChild(e) {
                if (e(this.namePrimary), this.paramsPrimary) for(const t1 in this.paramsPrimary)this.paramsPrimary[t1] && e(this.paramsPrimary[t1]);
                if (this.nameSecondary && (e(this.nameSecondary), this.paramsSecondary)) for(const t1 in this.paramsSecondary)this.paramsSecondary[t1] && e(this.paramsSecondary[t1]);
            }
            outputDefined() {
                return !1;
            }
            serializeOptions(e, t1) {
                const r = {};
                if (t1 && (r.iconset = {
                    id: t1
                }), e) {
                    r.params = {};
                    for(const t1 in e)e[t1] && (r.params[t1] = e[t1].serialize());
                }
                return Object.keys(r).length > 0 ? r : void 0;
            }
            serialize() {
                const e = [
                    "image",
                    this.namePrimary.serialize()
                ];
                if (this.paramsPrimary || this.iconsetIdPrimary) {
                    const t1 = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                    t1 && e.push(t1);
                }
                if (this.nameSecondary && (e.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                    const t1 = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                    t1 && e.push(t1);
                }
                return e;
            }
        }
        function Zr(e) {
            return Yr(e) ? "string" : Jr(e) ? "number" : Kr(e) ? "boolean" : Array.isArray(e) ? "array" : null === e ? "null" : Wr(e) ? "object" : typeof e;
        }
        function Wr(e) {
            return null != e && !Array.isArray(e) && "function" != typeof e && !(e instanceof String || e instanceof Number || e instanceof Boolean) && "object" == typeof e;
        }
        function Yr(e) {
            return "string" == typeof e || e instanceof String;
        }
        function Jr(e) {
            return "number" == typeof e || e instanceof Number;
        }
        function Kr(e) {
            return "boolean" == typeof e || e instanceof Boolean;
        }
        const Qr = {
            "to-boolean": vr,
            "to-color": br,
            "to-number": gr,
            "to-string": xr
        };
        class en {
            constructor(e, t1){
                this.type = e, this.args = t1;
            }
            static parse(e, t1) {
                if (e.length < 2) return t1.error("Expected at least one argument.");
                const r = e[0], n = [];
                let i = yr;
                if ("to-array" === r) {
                    if (!Array.isArray(e[1])) return null;
                    const r = e[1].length;
                    if (t1.expectedType) {
                        if ("array" !== t1.expectedType.kind) return t1.error(`Expected ${t1.expectedType.kind} but found array.`);
                        i = Sr(t1.expectedType.itemType, r);
                    } else {
                        if (!(r > 0 && Or(e[1][0]))) return null;
                        i = Sr(Ur(e[1][0]), r);
                    }
                    for(let s = 0; s < r; s++){
                        const r = e[1][s];
                        let o;
                        if (Array.isArray(r)) o = t1.parse(r, void 0, i.itemType);
                        else {
                            const e = Zr(r);
                            if (e !== i.itemType.kind) return t1.error(`Expected ${i.itemType.kind} but found ${e}.`);
                            o = t1.registry.literal.parse([
                                "literal",
                                void 0 === r ? null : r
                            ], t1);
                        }
                        if (!o) return null;
                        n.push(o);
                    }
                } else {
                    if (("to-boolean" === r || "to-string" === r) && 2 !== e.length) return t1.error("Expected one argument.");
                    i = Qr[r];
                    for(let r = 1; r < e.length; r++){
                        const i = t1.parse(e[r], r, _r);
                        if (!i) return null;
                        n.push(i);
                    }
                }
                return new en(i, n);
            }
            evaluate(e) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e));
                if ("color" === this.type.kind) {
                    let t1, r;
                    for (const n of this.args){
                        if (t1 = n.evaluate(e), r = null, t1 instanceof ar) return t1;
                        if ("string" == typeof t1) {
                            const r = e.parseColor(t1);
                            if (r) return r;
                        } else if (Array.isArray(t1) && (r = t1.length < 3 || t1.length > 4 ? `Invalid rbga value ${JSON.stringify(t1)}: expected an array containing either three or four numeric values.` : Lr(t1[0], t1[1], t1[2], t1[3]), !r)) return new ar(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]);
                    }
                    throw new Gr(r || `Could not parse color from value '${"string" == typeof t1 ? t1 : String(JSON.stringify(t1))}'`);
                }
                if ("number" === this.type.kind) {
                    let t1 = null;
                    for (const r of this.args){
                        if (t1 = r.evaluate(e), null === t1) return 0;
                        const n = Number(t1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Gr(`Could not convert ${JSON.stringify(t1)} to number.`);
                }
                return "formatted" === this.type.kind ? Dr.fromString(Nr(this.args[0].evaluate(e))) : "resolvedImage" === this.type.kind ? Rr.build(Nr(this.args[0].evaluate(e))) : "array" === this.type.kind ? this.args.map((t1)=>t1.evaluate(e)) : Nr(this.args[0].evaluate(e));
            }
            eachChild(e) {
                this.args.forEach(e);
            }
            outputDefined() {
                return this.args.every((e)=>e.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Xr([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Hr(this.args[0]).serialize();
                const e = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t1)=>{
                    e.push(t1.serialize());
                }), e;
            }
        }
        const tn = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class rn {
            constructor(e, t1, r){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = e, this.options = t1, this.iconImageUseTheme = r;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? tn[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e = this.featureDistanceData.center, t1 = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * t1 - e[0]) + this.featureDistanceData.bearing[1] * (n * t1 - e[1]);
                }
                return 0;
            }
            parseColor(e) {
                let t1 = this._parseColorCache[e];
                return t1 || (t1 = this._parseColorCache[e] = ar.parse(e)), t1;
            }
            getConfig(e) {
                return this.options ? this.options.get(e) : null;
            }
        }
        class nn {
            constructor(e, t1, r, n, i){
                this.name = e, this.type = t1, this._evaluate = r, this.args = n, this._overloadIndex = i;
            }
            evaluate(e) {
                if (!this._evaluate) {
                    const e = nn.definitions[this.name];
                    this._evaluate = Array.isArray(e) ? e[2] : e.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e, this.args);
            }
            eachChild(e) {
                this.args.forEach(e);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e)=>e.serialize()));
            }
            static parse(e, t1) {
                const r = e[0], n = nn.definitions[r];
                if (!n) return t1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, o = [];
                let a = null, l = -1;
                for (const [n, u] of s){
                    if (Array.isArray(n) && n.length !== e.length - 1) continue;
                    o.push(n), l++, a = new Ai(t1.registry, t1.path, null, t1.scope, void 0, t1._scope, t1.options, t1.iconImageUseTheme);
                    const s = [];
                    let c = !1;
                    for(let t1 = 1; t1 < e.length; t1++){
                        const r = e[t1], i = Array.isArray(n) ? n[t1 - 1] : n.type, o = a.parse(r, 1 + s.length, i);
                        if (!o) {
                            c = !0;
                            break;
                        }
                        s.push(o);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== s.length) a.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let e = 0; e < s.length; e++){
                                const t1 = Array.isArray(n) ? n[e] : n.type, r = s[e];
                                a.concat(e + 1).checkSubtype(t1, r.type);
                            }
                            if (0 === a.errors.length) return new nn(r, i, u, s, l);
                        }
                    }
                }
                if (1 === o.length) t1.errors.push(...a.errors);
                else {
                    const r = (o.length ? o : s.map(([e])=>e)).map(sn).join(" | "), n = [];
                    for(let r = 1; r < e.length; r++){
                        const i = t1.parse(e[r], 1 + n.length);
                        if (!i) return null;
                        n.push(zr(i.type));
                    }
                    t1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e, t1) {
                nn.definitions = t1;
                for(const r in t1)e[r] = nn;
            }
        }
        function sn(e) {
            return Array.isArray(e) ? `(${e.map(zr).join(", ")})` : `(${zr(e.type)}...)`;
        }
        class on {
            constructor(e, t1, r){
                this.type = Ar, this.locale = r, this.caseSensitive = e, this.diacriticSensitive = t1;
            }
            static parse(e, t1) {
                if (2 !== e.length) return t1.error("Expected one argument.");
                const r = e[1];
                if ("object" != typeof r || Array.isArray(r)) return t1.error("Collator options argument must be an object.");
                const n = void 0 === r["case-sensitive"] ? t1.parse(!1, 1, vr) : t1.parseObjectValue(r["case-sensitive"], 1, "case-sensitive", vr);
                if (!n) return null;
                const i = void 0 === r["diacritic-sensitive"] ? t1.parse(!1, 1, vr) : t1.parseObjectValue(r["diacritic-sensitive"], 1, "diacritic-sensitive", vr);
                if (!i) return null;
                let s = null;
                return r.locale && (s = t1.parseObjectValue(r.locale, 1, "locale", xr), !s) ? null : new on(n, i, s);
            }
            evaluate(e) {
                return new Er(this.caseSensitive.evaluate(e), this.diacriticSensitive.evaluate(e), this.locale ? this.locale.evaluate(e) : null);
            }
            eachChild(e) {
                e(this.caseSensitive), e(this.diacriticSensitive), this.locale && e(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e = {};
                return e["case-sensitive"] = this.caseSensitive.serialize(), e["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e.locale = this.locale.serialize()), [
                    "collator",
                    e
                ];
            }
        }
        function an(e, t1, r = 0, n = e.length - 1, i = un) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, o = t1 - r + 1, a = Math.log(s), l = .5 * Math.exp(2 * a / 3), u = .5 * Math.sqrt(a * l * (s - l) / s) * (o - s / 2 < 0 ? -1 : 1);
                    an(e, t1, Math.max(r, Math.floor(t1 - o * l / s + u)), Math.min(n, Math.floor(t1 + (s - o) * l / s + u)), i);
                }
                const s = e[t1];
                let o = r, a = n;
                for(ln(e, r, t1), i(e[n], s) > 0 && ln(e, r, n); o < a;){
                    for(ln(e, o, a), o++, a--; i(e[o], s) < 0;)o++;
                    for(; i(e[a], s) > 0;)a--;
                }
                0 === i(e[r], s) ? ln(e, r, a) : (a++, ln(e, a, n)), a <= t1 && (r = a + 1), t1 <= a && (n = a - 1);
            }
        }
        function ln(e, t1, r) {
            const n = e[t1];
            e[t1] = e[r], e[r] = n;
        }
        function un(e, t1) {
            return e < t1 ? -1 : e > t1 ? 1 : 0;
        }
        function cn(e) {
            let t1 = 0;
            for(let r, n, i = 0, s = e.length, o = s - 1; i < s; o = i++)r = e[i], n = e[o], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        function hn(e, t1) {
            e[0] = Math.min(e[0], t1[0]), e[1] = Math.min(e[1], t1[1]), e[2] = Math.max(e[2], t1[0]), e[3] = Math.max(e[3], t1[1]);
        }
        function pn(e, t1) {
            return !(e[0] <= t1[0] || e[2] >= t1[2] || e[1] <= t1[1] || e[3] >= t1[3]);
        }
        function dn(e, t1, r) {
            const n = e[0] - t1[0], i = e[1] - t1[1], s = e[0] - r[0], o = e[1] - r[1];
            return n * o - s * i === 0 && n * s <= 0 && i * o <= 0;
        }
        function fn(e, t1, r) {
            return t1[1] > e[1] != r[1] > e[1] && e[0] < (r[0] - t1[0]) * (e[1] - t1[1]) / (r[1] - t1[1]) + t1[0];
        }
        function mn(e, t1, r = !1) {
            let n = !1;
            for(let i = 0, s = t1.length; i < s; i++){
                const s = t1[i];
                for(let t1 = 0, i = s.length, o = i - 1; t1 < i; o = t1++){
                    const i = s[o], a = s[t1];
                    if (dn(e, i, a)) return r;
                    fn(e, i, a) && (n = !n);
                }
            }
            return n;
        }
        function yn(e, t1, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], o = (e[0] - r[0]) * s - i * (e[1] - r[1]), a = (t1[0] - r[0]) * s - i * (t1[1] - r[1]);
            return o > 0 && a < 0 || o < 0 && a > 0;
        }
        function gn(e, t1, r, n) {
            var i, s;
            return 0 !== (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                t1[0] - e[0],
                t1[1] - e[1]
            ])[1] - i[1] * s[0] && !(!yn(e, t1, r, n) || !yn(r, n, e, t1));
        }
        function xn(e) {
            const t1 = new Ie(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r = new Ie(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n of e[0])t1.x > n.x && (t1.x = n.x), t1.y > n.y && (t1.y = n.y), r.x < n.x && (r.x = n.x), r.y < n.y && (r.y = n.y);
            return {
                min: t1,
                max: r
            };
        }
        const vn = 8192;
        function bn(e, t1) {
            const r = (180 + e[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e[1] * Math.PI / 360))) / 360, i = Math.pow(2, t1.z);
            return [
                Math.round(r * i * vn),
                Math.round(n * i * vn)
            ];
        }
        function wn(e, t1) {
            for(let r = 0; r < t1.length; r++)if (mn(e, t1[r])) return !0;
            return !1;
        }
        function _n(e, t1, r) {
            for (const n of r)for(let r = 0, i = n.length, s = i - 1; r < i; s = r++)if (gn(e, t1, n[s], n[r])) return !0;
            return !1;
        }
        function An(e, t1) {
            for(let r = 0; r < e.length; ++r)if (!mn(e[r], t1)) return !1;
            for(let r = 0; r < e.length - 1; ++r)if (_n(e[r], e[r + 1], t1)) return !1;
            return !0;
        }
        function Mn(e, t1) {
            for(let r = 0; r < t1.length; r++)if (An(e, t1[r])) return !0;
            return !1;
        }
        function In(e, t1, r) {
            const n = [];
            for(let i = 0; i < e.length; i++){
                const s = [];
                for(let n = 0; n < e[i].length; n++){
                    const o = bn(e[i][n], r);
                    hn(t1, o), s.push(o);
                }
                n.push(s);
            }
            return n;
        }
        function Sn(e, t1, r) {
            const n = [];
            for(let i = 0; i < e.length; i++){
                const s = In(e[i], t1, r);
                n.push(s);
            }
            return n;
        }
        function zn(e, t1, r, n) {
            if (e[0] < r[0] || e[0] > r[2]) {
                const t1 = .5 * n;
                let i = e[0] - r[0] > t1 ? -n : r[0] - e[0] > t1 ? n : 0;
                0 === i && (i = e[0] - r[2] > t1 ? -n : r[2] - e[0] > t1 ? n : 0), e[0] += i;
            }
            hn(t1, e);
        }
        function Pn(e, t1, r, n) {
            const i = Math.pow(2, n.z) * vn, s = [
                n.x * vn,
                n.y * vn
            ], o = [];
            if (!e) return o;
            for (const n of e)for (const e of n){
                const n = [
                    e.x + s[0],
                    e.y + s[1]
                ];
                zn(n, t1, r, i), o.push(n);
            }
            return o;
        }
        function Bn(e, t1, r, n) {
            const i = Math.pow(2, n.z) * vn, s = [
                n.x * vn,
                n.y * vn
            ], o = [];
            if (!e) return o;
            for (const r of e){
                const e = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    hn(t1, r), e.push(r);
                }
                o.push(e);
            }
            if (t1[2] - t1[0] <= i / 2) {
                (a = t1)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const e of o)for (const n of e)zn(n, t1, r, i);
            }
            var a;
            return o;
        }
        class Tn {
            constructor(e, t1){
                this.type = vr, this.geojson = e, this.geometries = t1;
            }
            static parse(e, t1) {
                if (2 !== e.length) return t1.error(`'within' expression requires exactly one argument, but found ${e.length - 1} instead.`);
                if (Or(e[1])) {
                    const t1 = e[1];
                    if ("FeatureCollection" === t1.type) for(let e = 0; e < t1.features.length; ++e){
                        const r = t1.features[e].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Tn(t1, t1.features[e].geometry);
                    }
                    else if ("Feature" === t1.type) {
                        const e = t1.geometry.type;
                        if ("Polygon" === e || "MultiPolygon" === e) return new Tn(t1, t1.geometry);
                    } else if ("Polygon" === t1.type || "MultiPolygon" === t1.type) return new Tn(t1, t1);
                }
                return t1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e) {
                if (null != e.geometry() && null != e.canonicalID()) {
                    if ("Point" === e.geometryType()) return function(e, t1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === t1.type) {
                            const s = In(t1.coordinates, n, i), o = Pn(e.geometry(), r, n, i);
                            if (!pn(r, n)) return !1;
                            for (const e of o)if (!mn(e, s)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const s = Sn(t1.coordinates, n, i), o = Pn(e.geometry(), r, n, i);
                            if (!pn(r, n)) return !1;
                            for (const e of o)if (!wn(e, s)) return !1;
                        }
                        return !0;
                    }(e, this.geometries);
                    if ("LineString" === e.geometryType()) return function(e, t1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === t1.type) {
                            const s = In(t1.coordinates, n, i), o = Bn(e.geometry(), r, n, i);
                            if (!pn(r, n)) return !1;
                            for (const e of o)if (!An(e, s)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const s = Sn(t1.coordinates, n, i), o = Bn(e.geometry(), r, n, i);
                            if (!pn(r, n)) return !1;
                            for (const e of o)if (!Mn(e, s)) return !1;
                        }
                        return !0;
                    }(e, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        const kn = {
            kilometers: 1,
            miles: 1e3 / 1609.344,
            nauticalmiles: 1e3 / 1852,
            meters: 1e3,
            metres: 1e3,
            yards: 1e3 / .9144,
            feet: 1e3 / .3048,
            inches: 1e3 / .0254
        }, Vn = 1 / 298.257223563, En = Vn * (2 - Vn), Fn = Math.PI / 180;
        class Dn {
            static fromTile(e, t1, r) {
                const n = Math.PI * (1 - 2 * (e + .5) / Math.pow(2, t1)), i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / Fn;
                return new Dn(i, r);
            }
            static get units() {
                return kn;
            }
            constructor(e, t1){
                if (void 0 === e) throw new Error("No latitude given.");
                if (t1 && !kn[t1]) throw new Error(`Unknown unit ${t1}. Use one of: ${Object.keys(kn).join(", ")}`);
                const r = 6378.137 * Fn * (t1 ? kn[t1] : 1), n = Math.cos(e * Fn), i = 1 / (1 - En * (1 - n * n)), s = Math.sqrt(i);
                this.kx = r * s * n, this.ky = r * s * i * (1 - En);
            }
            distance(e, t1) {
                const r = Ln(e[0] - t1[0]) * this.kx, n = (e[1] - t1[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            bearing(e, t1) {
                const r = Ln(t1[0] - e[0]) * this.kx;
                return Math.atan2(r, (t1[1] - e[1]) * this.ky) / Fn;
            }
            destination(e, t1, r) {
                const n = r * Fn;
                return this.offset(e, Math.sin(n) * t1, Math.cos(n) * t1);
            }
            offset(e, t1, r) {
                return [
                    e[0] + t1 / this.kx,
                    e[1] + r / this.ky
                ];
            }
            lineDistance(e) {
                let t1 = 0;
                for(let r = 0; r < e.length - 1; r++)t1 += this.distance(e[r], e[r + 1]);
                return t1;
            }
            area(e) {
                let t1 = 0;
                for(let r = 0; r < e.length; r++){
                    const n = e[r];
                    for(let e = 0, i = n.length, s = i - 1; e < i; s = e++)t1 += Ln(n[e][0] - n[s][0]) * (n[e][1] + n[s][1]) * (r ? -1 : 1);
                }
                return Math.abs(t1) / 2 * this.kx * this.ky;
            }
            along(e, t1) {
                let r = 0;
                if (t1 <= 0) return e[0];
                for(let n = 0; n < e.length - 1; n++){
                    const i = e[n], s = e[n + 1], o = this.distance(i, s);
                    if (r += o, r > t1) return Rn(i, s, (t1 - (r - o)) / o);
                }
                return e[e.length - 1];
            }
            pointToSegmentDistance(e, t1, r) {
                let [n, i] = t1, s = Ln(r[0] - n) * this.kx, o = (r[1] - i) * this.ky;
                if (0 !== s || 0 !== o) {
                    const t1 = (Ln(e[0] - n) * this.kx * s + (e[1] - i) * this.ky * o) / (s * s + o * o);
                    t1 > 1 ? (n = r[0], i = r[1]) : t1 > 0 && (n += s / this.kx * t1, i += o / this.ky * t1);
                }
                return s = Ln(e[0] - n) * this.kx, o = (e[1] - i) * this.ky, Math.sqrt(s * s + o * o);
            }
            pointOnLine(e, t1) {
                let r = 1 / 0, n = e[0][0], i = e[0][1], s = 0, o = 0;
                for(let a = 0; a < e.length - 1; a++){
                    let l = e[a][0], u = e[a][1], c = Ln(e[a + 1][0] - l) * this.kx, h = (e[a + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (Ln(t1[0] - l) * this.kx * c + (t1[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = e[a + 1][0], u = e[a + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = Ln(t1[0] - l) * this.kx, h = (t1[1] - u) * this.ky;
                    const d = c * c + h * h;
                    d < r && (r = d, n = l, i = u, s = a, o = p);
                }
                return {
                    point: [
                        n,
                        i
                    ],
                    index: s,
                    t: Math.max(0, Math.min(1, o))
                };
            }
            lineSlice(e, t1, r) {
                let n = this.pointOnLine(r, e), i = this.pointOnLine(r, t1);
                if (n.index > i.index || n.index === i.index && n.t > i.t) {
                    const e = n;
                    n = i, i = e;
                }
                const s = [
                    n.point
                ], o = n.index + 1, a = i.index;
                !Cn(r[o], s[0]) && o <= a && s.push(r[o]);
                for(let e = o + 1; e <= a; e++)s.push(r[e]);
                return Cn(r[a], i.point) || s.push(i.point), s;
            }
            lineSliceAlong(e, t1, r) {
                let n = 0;
                const i = [];
                for(let s = 0; s < r.length - 1; s++){
                    const o = r[s], a = r[s + 1], l = this.distance(o, a);
                    if (n += l, n > e && 0 === i.length && i.push(Rn(o, a, (e - (n - l)) / l)), n >= t1) return i.push(Rn(o, a, (t1 - (n - l)) / l)), i;
                    n > e && i.push(a);
                }
                return i;
            }
            bufferPoint(e, t1) {
                const r = t1 / this.ky, n = t1 / this.kx;
                return [
                    e[0] - n,
                    e[1] - r,
                    e[0] + n,
                    e[1] + r
                ];
            }
            bufferBBox(e, t1) {
                const r = t1 / this.ky, n = t1 / this.kx;
                return [
                    e[0] - n,
                    e[1] - r,
                    e[2] + n,
                    e[3] + r
                ];
            }
            insideBBox(e, t1) {
                return Ln(e[0] - t1[0]) >= 0 && Ln(e[0] - t1[2]) <= 0 && e[1] >= t1[1] && e[1] <= t1[3];
            }
        }
        function Cn(e, t1) {
            return e[0] === t1[0] && e[1] === t1[1];
        }
        function Rn(e, t1, r) {
            const n = Ln(t1[0] - e[0]);
            return [
                e[0] + n * r,
                e[1] + (t1[1] - e[1]) * r
            ];
        }
        function Ln(e) {
            for(; e < -180;)e += 360;
            for(; e > 180;)e -= 360;
            return e;
        }
        class On {
            constructor(e = [], t1 = (e, t1)=>e < t1 ? -1 : e > t1 ? 1 : 0){
                if (this.data = e, this.length = this.data.length, this.compare = t1, this.length > 0) for(let e = (this.length >> 1) - 1; e >= 0; e--)this._down(e);
            }
            push(e) {
                this.data.push(e), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e = this.data[0], t1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = t1, this._down(0)), e;
            }
            peek() {
                return this.data[0];
            }
            _up(e) {
                const { data: t1, compare: r } = this, n = t1[e];
                for(; e > 0;){
                    const i = e - 1 >> 1, s = t1[i];
                    if (r(n, s) >= 0) break;
                    t1[e] = s, e = i;
                }
                t1[e] = n;
            }
            _down(e) {
                const { data: t1, compare: r } = this, n = this.length >> 1, i = t1[e];
                for(; e < n;){
                    let n = 1 + (e << 1);
                    const s = n + 1;
                    if (s < this.length && r(t1[s], t1[n]) < 0 && (n = s), r(t1[n], i) >= 0) break;
                    t1[e] = t1[n], e = n;
                }
                t1[e] = i;
            }
        }
        var Un = 8192;
        function Nn(e, t1) {
            return t1.dist - e.dist;
        }
        function jn(e) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t1.length !== e.length) return !1;
            for(let r = 0; r < t1.length; r++)if (t1[r] !== e[r]) return !1;
            return !0;
        }
        function Gn(e) {
            return e[1] - e[0] + 1;
        }
        function $n(e, t1) {
            const r = e[1] >= e[0] && e[1] < t1;
            return r || console.warn("Distance Expression: Index is out of range"), r;
        }
        function qn(e, t1) {
            if (e[0] > e[1]) return [
                null,
                null
            ];
            const r = Gn(e);
            if (t1) {
                if (2 === r) return [
                    e,
                    null
                ];
                const t1 = Math.floor(r / 2);
                return [
                    [
                        e[0],
                        e[0] + t1
                    ],
                    [
                        e[0] + t1,
                        e[1]
                    ]
                ];
            }
            {
                if (1 === r) return [
                    e,
                    null
                ];
                const t1 = Math.floor(r / 2) - 1;
                return [
                    [
                        e[0],
                        e[0] + t1
                    ],
                    [
                        e[0] + t1 + 1,
                        e[1]
                    ]
                ];
            }
        }
        function Xn(e, t1) {
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!$n(t1, e.length)) return r;
            for(let n = t1[0]; n <= t1[1]; ++n)hn(r, e[n]);
            return r;
        }
        function Hn(e) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = 0; r < e.length; ++r)for(let n = 0; n < e[r].length; ++n)hn(t1, e[r][n]);
            return t1;
        }
        function Zn(e, t1, r) {
            if (jn(e) || jn(t1)) return NaN;
            let n = 0, i = 0;
            return e[2] < t1[0] && (n = t1[0] - e[2]), e[0] > t1[2] && (n = e[0] - t1[2]), e[1] > t1[3] && (i = e[1] - t1[3]), e[3] < t1[1] && (i = t1[1] - e[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function Wn(e) {
            return 360 * e - 180;
        }
        function Yn(e) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e) * Math.PI / 180)) - 90;
        }
        function Jn(e, t1, r = 8192) {
            const n = Math.pow(2, t1.z), i = (e.y / r + t1.y) / n;
            return [
                Wn((e.x / r + t1.x) / n),
                Yn(i)
            ];
        }
        function Kn(e, t1) {
            const r = [];
            for(let n = 0; n < e.length; ++n)r.push(Jn(e[n], t1));
            return r;
        }
        function Qn(e, t1, r) {
            const n = r.pointOnLine(t1, e).point;
            return r.distance(e, n);
        }
        function ei(e, t1, r, n, i) {
            const s = r.slice(n[0], n[1] + 1);
            let o = 1 / 0;
            for(let r = t1[0]; r <= t1[1]; ++r)if (0 === (o = Math.min(o, Qn(e[r], s, i)))) return 0;
            return o;
        }
        function ti(e, t1, r, n, i) {
            const s = Math.min(i.pointToSegmentDistance(e, r, n), i.pointToSegmentDistance(t1, r, n)), o = Math.min(i.pointToSegmentDistance(r, e, t1), i.pointToSegmentDistance(n, e, t1));
            return Math.min(s, o);
        }
        function ri(e, t1, r, n, i) {
            if (!$n(t1, e.length) || !$n(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let o = t1[0]; o < t1[1]; ++o)for(let t1 = n[0]; t1 < n[1]; ++t1){
                if (gn(e[o], e[o + 1], r[t1], r[t1 + 1])) return 0;
                s = Math.min(s, ti(e[o], e[o + 1], r[t1], r[t1 + 1], i));
            }
            return s;
        }
        function ni(e, t1, r, n, i) {
            if (!$n(t1, e.length) || !$n(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let o = t1[0]; o <= t1[1]; ++o)for(let t1 = n[0]; t1 <= n[1]; ++t1)if (0 === (s = Math.min(s, i.distance(e[o], r[t1])))) return s;
            return s;
        }
        function ii(e, t1, r) {
            if (mn(e, t1, !0)) return 0;
            let n = 1 / 0;
            for (const i of t1){
                const t1 = i.length;
                if (t1 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (i[0] !== i[t1 - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(e, i[t1 - 1], i[0])))) return n;
                if (0 === (n = Math.min(n, Qn(e, i, r)))) return n;
            }
            return n;
        }
        function si(e, t1, r, n) {
            if (!$n(t1, e.length)) return NaN;
            for(let n = t1[0]; n <= t1[1]; ++n)if (mn(e[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = t1[0]; s < t1[1]; ++s)for (const t1 of r)for(let r = 0, o = t1.length, a = o - 1; r < o; a = r++){
                if (gn(e[s], e[s + 1], t1[a], t1[r])) return 0;
                i = Math.min(i, ti(e[s], e[s + 1], t1[a], t1[r], n));
            }
            return i;
        }
        function oi(e, t1) {
            for (const r of e)for(let e = 0; e <= r.length - 1; ++e)if (mn(r[e], t1, !0)) return !0;
            return !1;
        }
        function ai(e, t1, r, n = 1 / 0) {
            const i = Hn(e), s = Hn(t1);
            if (n !== 1 / 0 && Zn(i, s, r) >= n) return n;
            if (pn(i, s)) {
                if (oi(e, t1)) return 0;
            } else if (oi(t1, e)) return 0;
            let o = n;
            for (const n of e)for(let e = 0, i = n.length, s = i - 1; e < i; s = e++)for (const i of t1)for(let t1 = 0, a = i.length, l = a - 1; t1 < a; l = t1++){
                if (gn(n[s], n[e], i[l], i[t1])) return 0;
                o = Math.min(o, ti(n[s], n[e], i[l], i[t1], r));
            }
            return o;
        }
        function li(e, t1, r, n, i, s, o) {
            if (null === s || null === o) return;
            const a = Zn(Xn(n, s), Xn(i, o), r);
            a < t1 && e.push({
                dist: a,
                range1: s,
                range2: o
            });
        }
        function ui(e, t1, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(e[0], r[0][0]), i);
            if (0 === s) return s;
            const o = new On([
                {
                    dist: 0,
                    range1: [
                        0,
                        e.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Nn), a = t1 ? 50 : 100, l = Hn(r);
            for(; o.length;){
                const i = o.pop();
                if (i.dist >= s) continue;
                const u = i.range1;
                if (Gn(u) <= a) {
                    if (!$n(u, e.length)) return NaN;
                    if (t1) {
                        const t1 = si(e, u, r, n);
                        if (0 === (s = Math.min(s, t1))) return s;
                    } else for(let t1 = u[0]; t1 <= u[1]; ++t1){
                        const i = ii(e[t1], r, n);
                        if (0 === (s = Math.min(s, i))) return s;
                    }
                } else {
                    const r = qn(u, t1);
                    if (null !== r[0]) {
                        const t1 = Zn(Xn(e, r[0]), l, n);
                        t1 < s && o.push({
                            dist: t1,
                            range1: r[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== r[1]) {
                        const t1 = Zn(Xn(e, r[1]), l, n);
                        t1 < s && o.push({
                            dist: t1,
                            range1: r[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return s;
        }
        function ci(e, t1, r, n, i, s = 1 / 0) {
            let o = Math.min(s, i.distance(e[0], r[0]));
            if (0 === o) return o;
            const a = new On([
                {
                    dist: 0,
                    range1: [
                        0,
                        e.length - 1
                    ],
                    range2: [
                        0,
                        r.length - 1
                    ]
                }
            ], Nn), l = t1 ? 50 : 100, u = n ? 50 : 100;
            for(; a.length;){
                const s = a.pop();
                if (s.dist >= o) continue;
                const c = s.range1, h = s.range2;
                if (Gn(c) <= l && Gn(h) <= u) {
                    if (!$n(c, e.length) || !$n(h, r.length)) return NaN;
                    if (t1 && n ? o = Math.min(o, ri(e, c, r, h, i)) : t1 || n ? t1 && !n ? o = Math.min(o, ei(r, h, e, c, i)) : !t1 && n && (o = Math.min(o, ei(e, c, r, h, i))) : o = Math.min(o, ni(e, c, r, h, i)), 0 === o) return o;
                } else {
                    const s = qn(c, t1), l = qn(h, n);
                    li(a, o, i, e, r, s[0], l[0]), li(a, o, i, e, r, s[0], l[1]), li(a, o, i, e, r, s[1], l[0]), li(a, o, i, e, r, s[1], l[1]);
                }
            }
            return o;
        }
        function hi(e, t1, r, n, i = 1 / 0) {
            let s = i;
            const o = Xn(e, [
                0,
                e.length - 1
            ]);
            for (const i of r)if (!(s !== 1 / 0 && Zn(o, Xn(i, [
                0,
                i.length - 1
            ]), n) >= s) && (s = Math.min(s, ci(e, t1, i, !0, n, s)), 0 === s)) return s;
            return s;
        }
        function pi(e, t1, r, n, i = 1 / 0) {
            let s = i;
            const o = Xn(e, [
                0,
                e.length - 1
            ]);
            for (const i of r){
                if (s !== 1 / 0 && Zn(o, Hn(i), n) >= s) continue;
                const r = ui(e, t1, i, n, s);
                if (isNaN(r)) return r;
                if (0 === (s = Math.min(s, r))) return s;
            }
            return s;
        }
        function di(e) {
            return "Point" === e || "MultiPoint" === e || "LineString" === e || "MultiLineString" === e || "Polygon" === e || "MultiPolygon" === e;
        }
        class fi {
            constructor(e, t1){
                this.type = gr, this.geojson = e, this.geometries = t1;
            }
            static parse(e, t1) {
                if (2 !== e.length) return t1.error(`'distance' expression requires either one argument, but found ' ${e.length - 1} instead.`);
                if (Or(e[1])) {
                    const t1 = e[1];
                    if ("FeatureCollection" === t1.type) {
                        for(let e = 0; e < t1.features.length; ++e)if (di(t1.features[e].geometry.type)) return new fi(t1, t1.features[e].geometry);
                    } else if ("Feature" === t1.type) {
                        if (di(t1.geometry.type)) return new fi(t1, t1.geometry);
                    } else if (di(t1.type)) return new fi(t1, t1);
                }
                return t1.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(e) {
                const t1 = e.geometry(), r = e.canonicalID();
                if (null != t1 && null != r) {
                    if ("Point" === e.geometryType()) return function(e, t1, r) {
                        const n = [];
                        for (const r of e)for (const e of r)n.push(Jn(e, t1));
                        const i = new Dn(n[0][1], "meters");
                        return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? ci(n, !1, "Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? hi(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? pi(n, !1, "Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, i) : null;
                    }(t1, r, this.geometries);
                    if ("LineString" === e.geometryType()) return function(e, t1, r) {
                        const n = [];
                        for (const r of e){
                            const e = [];
                            for (const n of r)e.push(Jn(n, t1));
                            n.push(e);
                        }
                        const i = new Dn(n[0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return hi("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let e = 1 / 0;
                            for(let t1 = 0; t1 < r.coordinates.length; t1++){
                                const s = hi(r.coordinates[t1], !0, n, i, e);
                                if (isNaN(s)) return s;
                                if (0 === (e = Math.min(e, s))) return e;
                            }
                            return e;
                        }
                        if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                            let e = 1 / 0;
                            for(let t1 = 0; t1 < n.length; t1++){
                                const s = pi(n[t1], !0, "Polygon" === r.type ? [
                                    r.coordinates
                                ] : r.coordinates, i, e);
                                if (isNaN(s)) return s;
                                if (0 === (e = Math.min(e, s))) return e;
                            }
                            return e;
                        }
                        return null;
                    }(t1, r, this.geometries);
                    if ("Polygon" === e.geometryType()) return function(e, t1, r) {
                        const n = [];
                        for (const r of function(e) {
                            const t1 = e.length;
                            if (t1 <= 1) return [
                                e
                            ];
                            const r = [];
                            let n, i;
                            for(let s = 0; s < t1; s++){
                                const t1 = cn(e[s]);
                                0 !== t1 && (e[s].area = Math.abs(t1), void 0 === i && (i = t1 < 0), i === t1 < 0 ? (n && r.push(n), n = [
                                    e[s]
                                ]) : n.push(e[s]));
                            }
                            return n && r.push(n), r;
                        }(e)){
                            const e = [];
                            for(let n = 0; n < r.length; ++n)e.push(Kn(r[n], t1));
                            n.push(e);
                        }
                        const i = new Dn(n[0][0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return pi("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let e = 1 / 0;
                            for(let t1 = 0; t1 < r.coordinates.length; t1++){
                                const s = pi(r.coordinates[t1], !0, n, i, e);
                                if (isNaN(s)) return s;
                                if (0 === (e = Math.min(e, s))) return e;
                            }
                            return e;
                        }
                        return "Polygon" === r.type || "MultiPolygon" === r.type ? function(e, t1, r) {
                            let n = 1 / 0;
                            for (const i of e)for (const e of t1){
                                const t1 = ai(i, e, r, n);
                                if (isNaN(t1)) return t1;
                                if (0 === (n = Math.min(n, t1))) return n;
                            }
                            return n;
                        }("Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, n, i) : null;
                    }(t1, r, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requires valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        function mi(e) {
            if (e instanceof nn) {
                if ("get" === e.name && 1 === e.args.length) return !1;
                if ("feature-state" === e.name) return !1;
                if ("has" === e.name && 1 === e.args.length) return !1;
                if ("properties" === e.name || "geometry-type" === e.name || "id" === e.name) return !1;
                if (/^filter-/.test(e.name)) return !1;
            }
            if (e instanceof Tn) return !1;
            if (e instanceof fi) return !1;
            if (e instanceof wi) return e.featureConstant;
            let t1 = !0;
            return e.eachChild((e)=>{
                t1 && !mi(e) && (t1 = !1);
            }), t1;
        }
        function yi(e) {
            if (e instanceof nn && "feature-state" === e.name) return !1;
            let t1 = !0;
            return e.eachChild((e)=>{
                t1 && !yi(e) && (t1 = !1);
            }), t1;
        }
        function gi(e, t1) {
            if (e instanceof nn && t1.indexOf(e.name) >= 0) return !1;
            let r = !0;
            return e.eachChild((e)=>{
                r && !gi(e, t1) && (r = !1);
            }), r;
        }
        function xi(e, t1, r) {
            return [
                e,
                t1,
                r
            ].filter(Boolean).join("");
        }
        function vi(e, t1) {
            switch(e){
                case "string":
                    return Nr(t1);
                case "number":
                    return +t1;
                case "boolean":
                    return !!t1;
                case "color":
                    return ar.parse(t1);
                case "formatted":
                    return Dr.fromString(Nr(t1));
                case "resolvedImage":
                    return Rr.build(Nr(t1));
            }
            return t1;
        }
        function bi(e, t1, r, n) {
            return void 0 !== n && (e = n * Math.round(e / n)), void 0 !== t1 && e < t1 && (e = t1), void 0 !== r && e > r && (e = r), e;
        }
        class wi {
            constructor(e, t1, r, n = !1){
                this.type = e, this.key = t1, this.scope = r, this.featureConstant = n;
            }
            static parse(e, t1) {
                let r = t1.expectedType;
                if (null == r && (r = _r), e.length < 2 || e.length > 3) return t1.error("Invalid number of arguments for 'config' expression.");
                const n = t1.parse(e[1], 1);
                if (!(n instanceof jr)) return t1.error("Key name of 'config' expression must be a string literal.");
                let i, s = !0;
                const o = Nr(n.value);
                if (e.length >= 3) {
                    const r = t1.parse(e[2], 2);
                    if (!(r instanceof jr)) return t1.error("Scope of 'config' expression must be a string literal.");
                    i = Nr(r.value);
                }
                if (t1.options) {
                    const e = xi(o, i, t1._scope), r = t1.options.get(e);
                    r && (s = mi(r.value || r.default));
                }
                return new wi(r, o, i, s);
            }
            evaluate(e) {
                const t1 = xi(this.key, this.scope, e.scope), r = e.getConfig(t1);
                if (!r) return null;
                const { type: n, value: i, values: s, minValue: o, maxValue: a, stepValue: l } = r, u = r.default.evaluate(e);
                let c = u;
                if (i) {
                    const t1 = e.scope;
                    e.scope = (t1 || "").split("").slice(1).join(""), c = i.evaluate(e), e.scope = t1;
                }
                return n && (c = vi(n, c)), void 0 === c || void 0 === o && void 0 === a && void 0 === l || ("number" == typeof c ? c = bi(c, o, a, l) : Array.isArray(c) && (c = c.map((e)=>"number" == typeof e ? bi(e, o, a, l) : e))), void 0 !== i && void 0 !== c && s && !s.includes(c) && (c = u, n && (c = vi(n, c))), (n && n !== this.type || void 0 !== c && !Vr(Ur(c), this.type)) && (c = vi(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const e = [
                    "config",
                    this.key
                ];
                return this.scope && e.concat(this.scope), e;
            }
        }
        class _i {
            constructor(e, t1){
                this.type = t1.type, this.name = e, this.boundExpression = t1;
            }
            static parse(e, t1) {
                if (2 !== e.length || "string" != typeof e[1]) return t1.error("'var' expression requires exactly one string literal argument.");
                const r = e[1];
                return t1.scope.has(r) ? new _i(r, t1.scope.get(r)) : t1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e) {
                return this.boundExpression.evaluate(e);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class Ai {
            constructor(e, t1 = [], r, n = new mr, i = [], s, o, a){
                this.registry = e, this.path = t1, this.key = t1.map((e)=>"string" == typeof e ? `['${e}']` : `[${e}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = s, this.options = o, this.iconImageUseTheme = a;
            }
            parse(e, t1, r, n, i = {}) {
                return t1 || r ? this.concat(t1, null, r, n)._parse(e, i) : this._parse(e, i);
            }
            parseObjectValue(e, t1, r, n, i, s = {}) {
                return this.concat(t1, r, n, i)._parse(e, s);
            }
            _parse(e, t1) {
                function r(e, t1, r) {
                    return "assert" === r ? new qr(t1, [
                        e
                    ]) : "coerce" === r ? new en(t1, [
                        e
                    ]) : e;
                }
                if (null !== e && "string" != typeof e && "boolean" != typeof e && "number" != typeof e || (e = [
                    "literal",
                    e
                ]), Array.isArray(e)) {
                    if (0 === e.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = "string" == typeof e[0] ? this.registry[e[0]] : void 0;
                    if (n) {
                        let i = n.parse(e, this);
                        if (!i) return null;
                        if (this.expectedType) {
                            const e = this.expectedType, n = i.type;
                            if ("string" !== e.kind && "number" !== e.kind && "boolean" !== e.kind && "object" !== e.kind && "array" !== e.kind || "value" !== n.kind) {
                                if ("color" !== e.kind && "formatted" !== e.kind && "resolvedImage" !== e.kind || "value" !== n.kind && "string" !== n.kind) {
                                    if (this.checkSubtype(e, n)) return null;
                                } else i = r(i, e, t1.typeAnnotation || "coerce");
                            } else i = r(i, e, t1.typeAnnotation || "assert");
                        }
                        if (!(i instanceof jr) && "resolvedImage" !== i.type.kind && Mi(i)) {
                            const e = new rn(this._scope, this.options, this.iconImageUseTheme);
                            try {
                                i = new jr(i.type, i.evaluate(e));
                            } catch (e) {
                                return this.error(e.message), null;
                            }
                        }
                        return i;
                    }
                    return en.parse([
                        "to-array",
                        e
                    ], this);
                }
                return this.error(void 0 === e ? "'undefined' value invalid. Use null instead." : "object" == typeof e ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e} instead.`);
            }
            concat(e, t1, r, n) {
                let i = "number" == typeof e ? this.path.concat(e) : this.path;
                i = "string" == typeof t1 ? i.concat(t1) : i;
                const s = n ? this.scope.concat(n) : this.scope;
                return new Ai(this.registry, i, r || null, s, this.errors, this._scope, this.options, this.iconImageUseTheme);
            }
            error(e, ...t1) {
                const r = `${this.key}${t1.map((e)=>`[${e}]`).join("")}`;
                this.errors.push(new fr(r, e));
            }
            checkSubtype(e, t1) {
                const r = Br(e, t1);
                return r && this.error(r), r;
            }
        }
        function Mi(e) {
            if (e instanceof _i) return Mi(e.boundExpression);
            if (e instanceof nn && "error" === e.name) return !1;
            if (e instanceof on) return !1;
            if (e instanceof Tn) return !1;
            if (e instanceof fi) return !1;
            if (e instanceof wi) return !1;
            const t1 = e instanceof en || e instanceof qr;
            let r = !0;
            return e.eachChild((e)=>{
                r = t1 ? r && Mi(e) : r && e instanceof jr;
            }), !!r && mi(e) && gi(e, [
                "zoom",
                "heatmap-density",
                "worldview",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light",
                "raster-particle-speed",
                "is-active-floor"
            ]);
        }
        function Ii(e, t1) {
            const r = e.length - 1;
            let n, i, s = 0, o = r, a = 0;
            for(; s <= o;)if (a = Math.floor((s + o) / 2), n = e[a], i = e[a + 1], n <= t1) {
                if (a === r || t1 < i) return a;
                s = a + 1;
            } else {
                if (!(n > t1)) throw new Gr("Input is not a number.");
                o = a - 1;
            }
            return 0;
        }
        class Si {
            constructor(e, t1, r){
                this.type = e, this.input = t1, this.labels = [], this.outputs = [];
                for (const [e, t1] of r)this.labels.push(e), this.outputs.push(t1);
            }
            static parse(e, t1) {
                if (e.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
                if ((e.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                const r = t1.parse(e[1], 1, gr);
                if (!r) return null;
                const n = [];
                let i = null;
                t1.expectedType && "value" !== t1.expectedType.kind && (i = t1.expectedType);
                for(let r = 1; r < e.length; r += 2){
                    const s = 1 === r ? -1 / 0 : e[r], o = e[r + 1], a = r, l = r + 1;
                    if ("number" != typeof s) return t1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (n.length && n[n.length - 1][0] >= s) return t1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const u = t1.parse(o, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new Si(i, r, n);
            }
            evaluate(e) {
                const t1 = this.labels, r = this.outputs;
                if (1 === t1.length) return r[0].evaluate(e);
                const n = this.input.evaluate(e);
                if (n <= t1[0]) return r[0].evaluate(e);
                const i = t1.length;
                return n >= t1[i - 1] ? r[i - 1].evaluate(e) : r[Ii(t1, n)].evaluate(e);
            }
            eachChild(e) {
                e(this.input);
                for (const t1 of this.outputs)e(t1);
            }
            outputDefined() {
                return this.outputs.every((e)=>e.outputDefined());
            }
            serialize() {
                const e = [
                    "step",
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)t1 > 0 && e.push(this.labels[t1]), e.push(this.outputs[t1].serialize());
                return e;
            }
        }
        const zi = .95047, Pi = 1.08883, Bi = 4 / 29, Ti = 6 / 29, ki = 3 * Ti * Ti, Vi = Ti * Ti * Ti, Ei = Math.PI / 180, Fi = 180 / Math.PI;
        function Di(e) {
            return e > Vi ? Math.pow(e, 1 / 3) : e / ki + Bi;
        }
        function Ci(e) {
            return e > Ti ? e * e * e : ki * (e - Bi);
        }
        function Ri(e) {
            return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
        }
        function Li(e) {
            return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
        }
        function Oi(e) {
            const t1 = Li(e.r), r = Li(e.g), n = Li(e.b), i = Di((.4124564 * t1 + .3575761 * r + .1804375 * n) / zi), s = Di((.2126729 * t1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - Di((.0193339 * t1 + .119192 * r + .9503041 * n) / Pi)),
                alpha: e.a
            };
        }
        function Ui(e) {
            let t1 = (e.l + 16) / 116, r = isNaN(e.a) ? t1 : t1 + e.a / 500, n = isNaN(e.b) ? t1 : t1 - e.b / 200;
            return t1 = 1 * Ci(t1), r = zi * Ci(r), n = Pi * Ci(n), new ar(Ri(3.2404542 * r - 1.5371385 * t1 - .4985314 * n), Ri(-0.969266 * r + 1.8760108 * t1 + .041556 * n), Ri(.0556434 * r - .2040259 * t1 + 1.0572252 * n), e.alpha);
        }
        function Ni(e, t1, r) {
            const n = t1 - e;
            return e + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const ji = {
            forward: Oi,
            reverse: Ui,
            interpolate: function(e, t1, r) {
                return {
                    l: hr(e.l, t1.l, r),
                    a: hr(e.a, t1.a, r),
                    b: hr(e.b, t1.b, r),
                    alpha: hr(e.alpha, t1.alpha, r)
                };
            }
        }, Gi = {
            forward: function(e) {
                const { l: t1, a: r, b: n } = Oi(e), i = Math.atan2(n, r) * Fi;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: t1,
                    alpha: e.a
                };
            },
            reverse: function(e) {
                const t1 = e.h * Ei, r = e.c;
                return Ui({
                    l: e.l,
                    a: Math.cos(t1) * r,
                    b: Math.sin(t1) * r,
                    alpha: e.alpha
                });
            },
            interpolate: function(e, t1, r) {
                return {
                    h: Ni(e.h, t1.h, r),
                    c: hr(e.c, t1.c, r),
                    l: hr(e.l, t1.l, r),
                    alpha: hr(e.alpha, t1.alpha, r)
                };
            }
        };
        var $i = Object.freeze({
            __proto__: null,
            hcl: Gi,
            lab: ji
        });
        class qi {
            constructor(e, t1, r, n, i){
                this.type = e, this.operator = t1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [e, t1] of i)this.labels.push(e), this.outputs.push(t1);
            }
            static interpolationFactor(e, t1, r, n) {
                let i = 0;
                if ("exponential" === e.name) i = Xi(t1, e.base, r, n);
                else if ("linear" === e.name) i = Xi(t1, 1, r, n);
                else if ("cubic-bezier" === e.name) {
                    const s = e.controlPoints;
                    i = new Me(s[0], s[1], s[2], s[3]).solve(Xi(t1, 1, r, n));
                }
                return i;
            }
            static parse(e, t1) {
                let [r, n, i, ...s] = e;
                if (!Array.isArray(n) || 0 === n.length) return t1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const e = n[1];
                    if ("number" != typeof e) return t1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: e
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return t1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const e = n.slice(1);
                        if (4 !== e.length || e.some((e)=>"number" != typeof e || e < 0 || e > 1)) return t1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: e
                        };
                    }
                }
                if (e.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
                if (e.length - 1 > 3 && (e.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                if (i = t1.parse(i, 2, gr), !i) return null;
                const o = [];
                let a = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? a = br : t1.expectedType && "value" !== t1.expectedType.kind && (a = t1.expectedType);
                for(let e = 0; e < s.length; e += 2){
                    const r = s[e], n = s[e + 1], i = e + 3, l = e + 4;
                    if ("number" != typeof r) return t1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (o.length && o[o.length - 1][0] >= r) return t1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = t1.parse(n, l, a);
                    if (!u) return null;
                    a = a || u.type, o.push([
                        r,
                        u
                    ]);
                }
                return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new qi(a, r, n, i, o) : t1.error(`Type ${zr(a)} is not interpolatable.`);
            }
            evaluate(e) {
                const t1 = this.labels, r = this.outputs;
                if (1 === t1.length) return r[0].evaluate(e);
                const n = this.input.evaluate(e);
                if (n <= t1[0]) return r[0].evaluate(e);
                const i = t1.length;
                if (n >= t1[i - 1]) return r[i - 1].evaluate(e);
                const s = Ii(t1, n), o = qi.interpolationFactor(this.interpolation, n, t1[s], t1[s + 1]), a = r[s].evaluate(e), l = r[s + 1].evaluate(e);
                return "interpolate" === this.operator ? dr[this.type.kind.toLowerCase()](a, l, o) : "interpolate-hcl" === this.operator ? Gi.reverse(Gi.interpolate(Gi.forward(a), Gi.forward(l), o)) : ji.reverse(ji.interpolate(ji.forward(a), ji.forward(l), o));
            }
            eachChild(e) {
                e(this.input);
                for (const t1 of this.outputs)e(t1);
            }
            outputDefined() {
                return this.outputs.every((e)=>e.outputDefined());
            }
            serialize() {
                let e;
                e = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier",
                    ...this.interpolation.controlPoints
                ];
                const t1 = [
                    this.operator,
                    e,
                    this.input.serialize()
                ];
                for(let e = 0; e < this.labels.length; e++)t1.push(this.labels[e], this.outputs[e].serialize());
                return t1;
            }
        }
        function Xi(e, t1, r, n) {
            const i = n - r, s = e - r;
            return 0 === i ? 0 : 1 === t1 ? s / i : (Math.pow(t1, s) - 1) / (Math.pow(t1, i) - 1);
        }
        class Hi {
            constructor(e, t1){
                this.type = e, this.args = t1;
            }
            static parse(e, t1) {
                if (e.length < 2) return t1.error("Expectected at least one argument.");
                let r = null;
                const n = t1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of e.slice(1)){
                    const e = t1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e) return null;
                    r = r || e.type, i.push(e);
                }
                const s = n && i.some((e)=>Br(n, e.type));
                return new Hi(s ? _r : r, i);
            }
            evaluate(e) {
                let t1, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(e), r && r instanceof Rr && !r.available && (t1 || (t1 = r), r = null, n === this.args.length)) return t1;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(e) {
                this.args.forEach(e);
            }
            outputDefined() {
                return this.args.every((e)=>e.outputDefined());
            }
            serialize() {
                const e = [
                    "coalesce"
                ];
                return this.eachChild((t1)=>{
                    e.push(t1.serialize());
                }), e;
            }
        }
        class Zi {
            constructor(e, t1){
                this.type = t1.type, this.bindings = [].concat(e), this.result = t1;
            }
            evaluate(e) {
                return this.result.evaluate(e);
            }
            eachChild(e) {
                for (const t1 of this.bindings)e(t1[1]);
                e(this.result);
            }
            static parse(e, t1) {
                if (e.length < 4) return t1.error(`Expected at least 3 arguments, but found ${e.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < e.length - 1; n += 2){
                    const i = e[n];
                    if ("string" != typeof i) return t1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return t1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = t1.parse(e[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = t1.parse(e[e.length - 1], e.length - 1, t1.expectedType, r);
                return n ? new Zi(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e = [
                    "let"
                ];
                for (const [t1, r] of this.bindings)e.push(t1, r.serialize());
                return e.push(this.result.serialize()), e;
            }
        }
        class Wi {
            constructor(e, t1, r){
                this.type = e, this.index = t1, this.input = r;
            }
            static parse(e, t1) {
                if (3 !== e.length) return t1.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, gr), n = t1.parse(e[2], 2, Sr(t1.expectedType || _r));
                return r && n ? new Wi(n.type.itemType, r, n) : null;
            }
            evaluate(e) {
                const t1 = this.index.evaluate(e), r = this.input.evaluate(e);
                if (t1 < 0) throw new Gr("Array index out of bounds: negative index");
                if (t1 >= r.length) throw new Gr("Array index out of bounds: index exceeds array size");
                if (t1 !== Math.floor(t1)) throw new Gr("Array index must be an integer. Use at-interpolated for fractional indices");
                return r[t1];
            }
            eachChild(e) {
                e(this.index), e(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Yi {
            constructor(e, t1, r){
                this.type = e, this.index = t1, this.input = r;
            }
            static parse(e, t1) {
                if (3 !== e.length) return t1.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, gr), n = t1.parse(e[2], 2, Sr(t1.expectedType || _r));
                return r && n ? new Yi(n.type.itemType, r, n) : null;
            }
            evaluate(e) {
                const t1 = this.index.evaluate(e), r = this.input.evaluate(e);
                if (t1 < 0) throw new Gr(`Array index out of bounds: ${t1} < 0.`);
                if (t1 > r.length - 1) throw new Gr(`Array index out of bounds: ${t1} > ${r.length - 1}.`);
                if (t1 === Math.floor(t1)) return r[t1];
                const n = Math.floor(t1), i = Math.ceil(t1), s = r[n], o = r[i];
                if ("number" != typeof s || "number" != typeof o) throw new Gr(`Cannot interpolate between non-number values at index ${t1}.`);
                const a = t1 - n;
                return s * (1 - a) + o * a;
            }
            eachChild(e) {
                e(this.index), e(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at-interpolated",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class Ji {
            constructor(e, t1){
                this.type = vr, this.needle = e, this.haystack = t1;
            }
            static parse(e, t1) {
                if (3 !== e.length) return t1.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, _r), n = t1.parse(e[2], 2, _r);
                return r && n ? Tr(r.type, [
                    vr,
                    xr,
                    gr,
                    yr,
                    _r
                ]) ? new Ji(r, n) : t1.error(`Expected first argument to be of type boolean, string, number or null, but found ${zr(r.type)} instead`) : null;
            }
            evaluate(e) {
                const t1 = this.needle.evaluate(e), r = this.haystack.evaluate(e);
                if (null == r) return !1;
                if (!kr(t1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Gr(`Expected first argument to be of type boolean, string, number or null, but found ${zr(Ur(t1))} instead.`);
                if (!kr(r, [
                    "string",
                    "array"
                ])) throw new Gr(`Expected second argument to be of type array or string, but found ${zr(Ur(r))} instead.`);
                return r.indexOf(t1) >= 0;
            }
            eachChild(e) {
                e(this.needle), e(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class Ki {
            constructor(e, t1, r){
                this.type = gr, this.needle = e, this.haystack = t1, this.fromIndex = r;
            }
            static parse(e, t1) {
                if (e.length <= 2 || e.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, _r), n = t1.parse(e[2], 2, _r);
                if (!r || !n) return null;
                if (!Tr(r.type, [
                    vr,
                    xr,
                    gr,
                    yr,
                    _r
                ])) return t1.error(`Expected first argument to be of type boolean, string, number or null, but found ${zr(r.type)} instead`);
                if (4 === e.length) {
                    const i = t1.parse(e[3], 3, gr);
                    return i ? new Ki(r, n, i) : null;
                }
                return new Ki(r, n);
            }
            evaluate(e) {
                const t1 = this.needle.evaluate(e), r = this.haystack.evaluate(e);
                if (!kr(t1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Gr(`Expected first argument to be of type boolean, string, number or null, but found ${zr(Ur(t1))} instead.`);
                if (!kr(r, [
                    "string",
                    "array"
                ])) throw new Gr(`Expected second argument to be of type array or string, but found ${zr(Ur(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(e);
                    return r.indexOf(t1, n);
                }
                return r.indexOf(t1);
            }
            eachChild(e) {
                e(this.needle), e(this.haystack), this.fromIndex && e(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const e = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        e
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class Qi {
            constructor(e, t1, r, n, i, s){
                this.inputType = e, this.type = t1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(e, t1) {
                if (e.length < 5) return t1.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
                if (e.length % 2 != 1) return t1.error("Expected an even number of arguments.");
                let r, n;
                t1.expectedType && "value" !== t1.expectedType.kind && (n = t1.expectedType);
                const i = {}, s = [];
                for(let o = 2; o < e.length - 1; o += 2){
                    let a = e[o];
                    const l = e[o + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const u = t1.concat(o);
                    if (0 === a.length) return u.error("Expected at least one branch label.");
                    for (const e of a){
                        if ("number" != typeof e && "string" != typeof e) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof e && Math.abs(e) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof e && Math.floor(e) !== e) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, Ur(e))) return null;
                        } else r = Ur(e);
                        if (void 0 !== i[String(e)]) return u.error("Branch labels must be unique.");
                        i[String(e)] = s.length;
                    }
                    const c = t1.parse(l, o, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const o = t1.parse(e[1], 1, _r);
                if (!o) return null;
                const a = t1.parse(e[e.length - 1], e.length - 1, n);
                return a ? "value" !== o.type.kind && t1.concat(1).checkSubtype(r, o.type) ? null : new Qi(r, n, o, i, s, a) : null;
            }
            evaluate(e) {
                const t1 = this.input.evaluate(e);
                return (Vr(Ur(t1), this.inputType) && this.outputs[this.cases[t1]] || this.otherwise).evaluate(e);
            }
            eachChild(e) {
                e(this.input), this.outputs.forEach(e), e(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e)=>e.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e = [
                    "match",
                    this.input.serialize()
                ], t1 = Object.keys(this.cases).sort(), r = [], n = {};
                for (const e of t1){
                    const t1 = n[this.cases[e]];
                    void 0 === t1 ? (n[this.cases[e]] = r.length, r.push([
                        this.cases[e],
                        [
                            e
                        ]
                    ])) : r[t1][1].push(e);
                }
                const i = (e)=>"number" === this.inputType.kind ? Number(e) : e;
                for (const [t1, n] of r)e.push(1 === n.length ? i(n[0]) : n.map(i)), e.push(this.outputs[t1].serialize());
                return e.push(this.otherwise.serialize()), e;
            }
        }
        class es {
            constructor(e, t1, r){
                this.type = e, this.branches = t1, this.otherwise = r;
            }
            static parse(e, t1) {
                if (e.length < 4) return t1.error(`Expected at least 3 arguments, but found only ${e.length - 1}.`);
                if (e.length % 2 != 0) return t1.error("Expected an odd number of arguments.");
                let r;
                t1.expectedType && "value" !== t1.expectedType.kind && (r = t1.expectedType);
                const n = [];
                for(let i = 1; i < e.length - 1; i += 2){
                    const s = t1.parse(e[i], i, vr);
                    if (!s) return null;
                    const o = t1.parse(e[i + 1], i + 1, r);
                    if (!o) return null;
                    n.push([
                        s,
                        o
                    ]), r = r || o.type;
                }
                const i = t1.parse(e[e.length - 1], e.length - 1, r);
                return i ? new es(r, n, i) : null;
            }
            evaluate(e) {
                for (const [t1, r] of this.branches)if (t1.evaluate(e)) return r.evaluate(e);
                return this.otherwise.evaluate(e);
            }
            eachChild(e) {
                for (const [t1, r] of this.branches)e(t1), e(r);
                e(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e, t1])=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e = [
                    "case"
                ];
                return this.eachChild((t1)=>{
                    e.push(t1.serialize());
                }), e;
            }
        }
        class ts {
            constructor(e, t1, r, n){
                this.type = e, this.input = t1, this.beginIndex = r, this.endIndex = n;
            }
            static parse(e, t1) {
                if (e.length <= 2 || e.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, _r), n = t1.parse(e[2], 2, gr);
                if (!r || !n) return null;
                if (!Tr(r.type, [
                    Sr(_r),
                    xr,
                    _r
                ])) return t1.error(`Expected first argument to be of type array or string, but found ${zr(r.type)} instead`);
                if (4 === e.length) {
                    const i = t1.parse(e[3], 3, gr);
                    return i ? new ts(r.type, r, n, i) : null;
                }
                return new ts(r.type, r, n);
            }
            evaluate(e) {
                const t1 = this.input.evaluate(e), r = this.beginIndex.evaluate(e);
                if (!kr(t1, [
                    "string",
                    "array"
                ])) throw new Gr(`Expected first argument to be of type array or string, but found ${zr(Ur(t1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(e);
                    return t1.slice(r, n);
                }
                return t1.slice(r);
            }
            eachChild(e) {
                e(this.input), e(this.beginIndex), this.endIndex && e(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        class rs {
            constructor(e, t1){
                this.type = Sr(xr), this.str = e, this.delimiter = t1;
            }
            static parse(e, t1) {
                if (3 !== e.length) return t1.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1, xr), n = t1.parse(e[2], 2, xr);
                return r && n ? new rs(r, n) : void 0;
            }
            evaluate(e) {
                const t1 = this.str.evaluate(e), r = this.delimiter.evaluate(e);
                return t1.split(r);
            }
            eachChild(e) {
                e(this.str), e(this.delimiter);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "split",
                    this.str.serialize(),
                    this.delimiter.serialize()
                ];
            }
        }
        function ns(e, t1) {
            return "==" === e || "!=" === e ? "boolean" === t1.kind || "string" === t1.kind || "number" === t1.kind || "null" === t1.kind || "value" === t1.kind : "string" === t1.kind || "number" === t1.kind || "value" === t1.kind;
        }
        function is(e, t1, r, n) {
            return 0 === n.compare(t1, r);
        }
        function ss(e, t1, r) {
            const n = "==" !== e && "!=" !== e;
            return class i {
                constructor(e, t1, r){
                    this.type = vr, this.lhs = e, this.rhs = t1, this.collator = r, this.hasUntypedArgument = "value" === e.type.kind || "value" === t1.type.kind;
                }
                static parse(e, t1) {
                    if (3 !== e.length && 4 !== e.length) return t1.error("Expected two or three arguments.");
                    const r = e[0];
                    let s = t1.parse(e[1], 1, _r);
                    if (!s) return null;
                    if (!ns(r, s.type)) return t1.concat(1).error(`"${r}" comparisons are not supported for type '${zr(s.type)}'.`);
                    let o = t1.parse(e[2], 2, _r);
                    if (!o) return null;
                    if (!ns(r, o.type)) return t1.concat(2).error(`"${r}" comparisons are not supported for type '${zr(o.type)}'.`);
                    if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t1.error(`Cannot compare types '${zr(s.type)}' and '${zr(o.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== o.type.kind ? s = new qr(o.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new qr(s.type, [
                        o
                    ])));
                    let a = null;
                    if (4 === e.length) {
                        if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t1.error("Cannot use collator to compare non-string types.");
                        if (a = t1.parse(e[3], 3, Ar), !a) return null;
                    }
                    return new i(s, o, a);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), o = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const t1 = Ur(s), r = Ur(o);
                        if (t1.kind !== r.kind || "string" !== t1.kind && "number" !== t1.kind) throw new Gr(`Expected arguments for "${e}" to be (string, string) or (number, number), but found (${t1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const e = Ur(s), r = Ur(o);
                        if ("string" !== e.kind || "string" !== r.kind) return t1(i, s, o);
                    }
                    return this.collator ? r(i, s, o, this.collator.evaluate(i)) : t1(i, s, o);
                }
                eachChild(e) {
                    e(this.lhs), e(this.rhs), this.collator && e(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t1 = [
                        e
                    ];
                    return this.eachChild((e)=>{
                        t1.push(e.serialize());
                    }), t1;
                }
            };
        }
        const os = ss("==", function(e, t1, r) {
            return t1 === r;
        }, is), as = ss("!=", function(e, t1, r) {
            return t1 !== r;
        }, function(e, t1, r, n) {
            return !is(0, t1, r, n);
        }), ls = ss("<", function(e, t1, r) {
            return t1 < r;
        }, function(e, t1, r, n) {
            return n.compare(t1, r) < 0;
        }), us = ss(">", function(e, t1, r) {
            return t1 > r;
        }, function(e, t1, r, n) {
            return n.compare(t1, r) > 0;
        }), cs = ss("<=", function(e, t1, r) {
            return t1 <= r;
        }, function(e, t1, r, n) {
            return n.compare(t1, r) <= 0;
        }), hs = ss(">=", function(e, t1, r) {
            return t1 >= r;
        }, function(e, t1, r, n) {
            return n.compare(t1, r) >= 0;
        });
        class ps {
            constructor(e, t1, r, n, i, s){
                this.type = xr, this.number = e, this.locale = t1, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(e, t1) {
                if (3 !== e.length) return t1.error("Expected two arguments.");
                const r = t1.parse(e[1], 1, gr);
                if (!r) return null;
                const n = e[2];
                if ("object" != typeof n || Array.isArray(n)) return t1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = t1.parseObjectValue(n.locale, 2, "locale", xr), !i)) return null;
                let s = null;
                if (n.currency && (s = t1.parseObjectValue(n.currency, 2, "currency", xr), !s)) return null;
                let o = null;
                if (n.unit && (o = t1.parseObjectValue(n.unit, 2, "unit", xr), !o)) return null;
                let a = null;
                if (n["min-fraction-digits"] && (a = t1.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", gr), !a)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = t1.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", gr), !l) ? null : new ps(r, i, s, o, a, l);
            }
            evaluate(e) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e) : void 0,
                    unit: this.unit ? this.unit.evaluate(e) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e) : void 0
                }).format(this.number.evaluate(e));
            }
            eachChild(e) {
                e(this.number), this.locale && e(this.locale), this.currency && e(this.currency), this.unit && e(this.unit), this.minFractionDigits && e(this.minFractionDigits), this.maxFractionDigits && e(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e = {};
                return this.locale && (e.locale = this.locale.serialize()), this.currency && (e.currency = this.currency.serialize()), this.unit && (e.unit = this.unit.serialize()), this.minFractionDigits && (e["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e
                ];
            }
        }
        class ds {
            constructor(e){
                this.type = gr, this.input = e;
            }
            static parse(e, t1) {
                if (2 !== e.length) return t1.error(`Expected 1 argument, but found ${e.length - 1} instead.`);
                const r = t1.parse(e[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? t1.error(`Expected argument of type string or array, but found ${zr(r.type)} instead.`) : new ds(r) : null;
            }
            evaluate(e) {
                const t1 = this.input.evaluate(e);
                if ("string" == typeof t1) return t1.length;
                if (Array.isArray(t1)) return t1.length;
                throw new Gr(`Expected value to be of type string or array, but found ${zr(Ur(t1))} instead.`);
            }
            eachChild(e) {
                e(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e = [
                    "length"
                ];
                return this.eachChild((t1)=>{
                    e.push(t1.serialize());
                }), e;
            }
        }
        function fs(e) {
            return function() {
                e = 1831565813 + (e |= 0) | 0;
                let t1 = Math.imul(e ^ e >>> 15, 1 | e);
                return t1 = t1 + Math.imul(t1 ^ t1 >>> 7, 61 | t1) ^ t1, ((t1 ^ t1 >>> 14) >>> 0) / 4294967296;
            };
        }
        const ms = {
            "==": os,
            "!=": as,
            ">": us,
            "<": ls,
            ">=": hs,
            "<=": cs,
            array: qr,
            at: Wi,
            "at-interpolated": Yi,
            boolean: qr,
            case: es,
            coalesce: Hi,
            collator: on,
            format: Xr,
            image: Hr,
            in: Ji,
            "index-of": Ki,
            interpolate: qi,
            "interpolate-hcl": qi,
            "interpolate-lab": qi,
            length: ds,
            let: Zi,
            literal: jr,
            match: Qi,
            number: qr,
            "number-format": ps,
            object: qr,
            slice: ts,
            step: Si,
            string: qr,
            "to-boolean": en,
            "to-color": en,
            "to-number": en,
            "to-string": en,
            var: _i,
            within: Tn,
            distance: fi,
            config: wi,
            split: rs
        };
        function ys(e, [t1, r, n, i]) {
            t1 = t1.evaluate(e), r = r.evaluate(e), n = n.evaluate(e);
            const s = i ? i.evaluate(e) : 1, o = Lr(t1, r, n, s);
            if (o) throw new Gr(o);
            return new ar(t1 / 255, r / 255, n / 255, s);
        }
        function gs(e, [t1, r, n, i]) {
            t1 = t1.evaluate(e), r = r.evaluate(e), n = n.evaluate(e);
            const s = i ? i.evaluate(e) : 1, o = function(e, t1, r, n) {
                return "number" == typeof e && e >= 0 && e <= 360 ? "number" == typeof t1 && t1 >= 0 && t1 <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    e,
                    t1,
                    r,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    e,
                    t1,
                    r,
                    n
                ] : [
                    e,
                    t1,
                    r
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    e,
                    t1,
                    r,
                    n
                ] : [
                    e,
                    t1,
                    r
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t1, r, n, s);
            if (o) throw new Gr(o);
            const a = `hsla(${t1}, ${r}%, ${n}%, ${s})`, l = ar.parse(a);
            if (!l) throw new Gr(`Failed to parse HSLA color: ${a}`);
            return l;
        }
        function xs(e, t1) {
            return e in t1;
        }
        function vs(e, t1) {
            const r = t1[e];
            return void 0 === r ? null : r;
        }
        function bs(e) {
            return {
                type: e
            };
        }
        function ws(e) {
            if (e instanceof wi) return new Set([
                e.key
            ]);
            let t1 = new Set;
            return e.eachChild((e)=>{
                t1 = new Set([
                    ...t1,
                    ...ws(e)
                ]);
            }), t1;
        }
        function _s(e) {
            if (e instanceof nn && "is-active-floor" === e.name) return !0;
            let t1 = !1;
            return e.eachChild((e)=>{
                !t1 && _s(e) && (t1 = !0);
            }), t1;
        }
        function As(e) {
            return {
                result: "success",
                value: e
            };
        }
        function Ms(e) {
            return {
                result: "error",
                value: e
            };
        }
        function Is(e, t1) {
            return !!e && !!e.parameters && e.parameters.indexOf(t1) > -1;
        }
        function Ss(e) {
            return "data-driven" === e["property-type"];
        }
        function zs(e) {
            return Is(e.expression, "measure-light");
        }
        function Ps(e) {
            return Is(e.expression, "zoom");
        }
        function Bs(e) {
            return !!e.expression && e.expression.interpolated;
        }
        function Ts(e) {
            return "object" == typeof e && null !== e && !Array.isArray(e);
        }
        function ks(e) {
            return e;
        }
        function Vs(e, t1) {
            const r = "color" === t1.type, n = e.stops && "object" == typeof e.stops[0][0], i = n || !(n || void 0 !== e.property), s = e.type || (Bs(t1) ? "exponential" : "interval");
            if (r && ((e = Object.assign({}, e)).stops && (e.stops = e.stops.map((e)=>[
                    e[0],
                    ar.parse(e[1])
                ])), e.default = ar.parse(e.default ? e.default : t1.default)), e.colorSpace && "rgb" !== e.colorSpace && !$i[e.colorSpace]) throw new Error(`Unknown color space: ${e.colorSpace}`);
            let o, a, l;
            if ("exponential" === s) o = Cs;
            else if ("interval" === s) o = Ds;
            else if ("categorical" === s) {
                o = Fs, a = Object.create(null);
                for (const t1 of e.stops)a[t1[0]] = t1[1];
                l = typeof e.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                o = Rs;
            }
            if (n) {
                const r = {}, n = [];
                for(let t1 = 0; t1 < e.stops.length; t1++){
                    const i = e.stops[t1], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: e.type,
                        property: e.property,
                        default: e.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const e of n)i.push([
                    r[e].zoom,
                    Vs(r[e], t1)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: qi.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((e)=>e[0]),
                    evaluate: ({ zoom: r }, n)=>Cs({
                            stops: i,
                            base: e.base
                        }, t1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== e.base ? e.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: qi.interpolationFactor.bind(void 0, r),
                    zoomStops: e.stops.map((e)=>e[0]),
                    evaluate: ({ zoom: r })=>o(e, t1, r, a, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[e.property] : void 0;
                    return void 0 === i ? Es(e.default, t1.default) : o(e, t1, i, a, l);
                }
            };
        }
        function Es(e, t1, r) {
            return void 0 !== e ? e : void 0 !== t1 ? t1 : void 0 !== r ? r : void 0;
        }
        function Fs(e, t1, r, n, i) {
            return Es(typeof r === i ? n[r] : void 0, e.default, t1.default);
        }
        function Ds(e, t1, r) {
            if (!Jr(r)) return Es(e.default, t1.default);
            const n = e.stops.length;
            if (1 === n) return e.stops[0][1];
            if (r <= e.stops[0][0]) return e.stops[0][1];
            if (r >= e.stops[n - 1][0]) return e.stops[n - 1][1];
            const i = Ii(e.stops.map((e)=>e[0]), r);
            return e.stops[i][1];
        }
        function Cs(e, t1, r) {
            const n = void 0 !== e.base ? e.base : 1;
            if (!Jr(r)) return Es(e.default, t1.default);
            const i = e.stops.length;
            if (1 === i) return e.stops[0][1];
            if (r <= e.stops[0][0]) return e.stops[0][1];
            if (r >= e.stops[i - 1][0]) return e.stops[i - 1][1];
            const s = Ii(e.stops.map((e)=>e[0]), r), o = function(e, t1, r, n) {
                const i = n - r, s = e - r;
                return 0 === i ? 0 : 1 === t1 ? s / i : (Math.pow(t1, s) - 1) / (Math.pow(t1, i) - 1);
            }(r, n, e.stops[s][0], e.stops[s + 1][0]), a = e.stops[s][1], l = e.stops[s + 1][1];
            let u = dr[t1.type] || ks;
            if (e.colorSpace && "rgb" !== e.colorSpace) {
                const t1 = $i[e.colorSpace];
                u = (e, r)=>t1.reverse(t1.interpolate(t1.forward(e), t1.forward(r), o));
            }
            return "function" == typeof a.evaluate ? {
                evaluate (...e) {
                    const t1 = a.evaluate.apply(void 0, e), r = l.evaluate.apply(void 0, e);
                    if (void 0 !== t1 && void 0 !== r) return u(t1, r, o);
                }
            } : u(a, l, o);
        }
        function Rs(e, t1, r) {
            return "color" === t1.type ? r = ar.parse(r) : "formatted" === t1.type ? r = Dr.fromString(r.toString()) : "resolvedImage" === t1.type ? r = Rr.build(r.toString()) : Zr(r) === t1.type || "enum" === t1.type && t1.values[r] || (r = void 0), Es(r, e.default, t1.default);
        }
        nn.register(ms, {
            error: [
                {
                    kind: "error"
                },
                [
                    xr
                ],
                (e, [t1])=>{
                    throw new Gr(t1.evaluate(e));
                }
            ],
            typeof: [
                xr,
                [
                    _r
                ],
                (e, [t1])=>zr(Ur(t1.evaluate(e)))
            ],
            "to-rgba": [
                Sr(gr, 4),
                [
                    br
                ],
                (e, [t1])=>t1.evaluate(e).toNonPremultipliedRenderColor(null).toArray()
            ],
            "to-hsla": [
                Sr(gr, 4),
                [
                    br
                ],
                (e, [t1])=>t1.evaluate(e).toNonPremultipliedRenderColor(null).toHslaArray()
            ],
            rgb: [
                br,
                [
                    gr,
                    gr,
                    gr
                ],
                ys
            ],
            rgba: [
                br,
                [
                    gr,
                    gr,
                    gr,
                    gr
                ],
                ys
            ],
            hsl: [
                br,
                [
                    gr,
                    gr,
                    gr
                ],
                gs
            ],
            hsla: [
                br,
                [
                    gr,
                    gr,
                    gr,
                    gr
                ],
                gs
            ],
            has: {
                type: vr,
                overloads: [
                    [
                        [
                            xr
                        ],
                        (e, [t1])=>xs(t1.evaluate(e), e.properties())
                    ],
                    [
                        [
                            xr,
                            wr
                        ],
                        (e, [t1, r])=>xs(t1.evaluate(e), r.evaluate(e))
                    ]
                ]
            },
            get: {
                type: _r,
                overloads: [
                    [
                        [
                            xr
                        ],
                        (e, [t1])=>vs(t1.evaluate(e), e.properties())
                    ],
                    [
                        [
                            xr,
                            wr
                        ],
                        (e, [t1, r])=>vs(t1.evaluate(e), r.evaluate(e))
                    ]
                ]
            },
            "feature-state": [
                _r,
                [
                    xr
                ],
                (e, [t1])=>vs(t1.evaluate(e), e.featureState || {})
            ],
            properties: [
                wr,
                [],
                (e)=>e.properties()
            ],
            "geometry-type": [
                xr,
                [],
                (e)=>e.geometryType()
            ],
            worldview: [
                xr,
                [],
                (e)=>e.globals.worldview || ""
            ],
            "is-active-floor": [
                vr,
                bs(xr),
                (e, t1)=>{
                    if (!(e.globals && e.globals.activeFloors && e.globals.activeFloors.size > 0)) return !1;
                    if (0 === t1.length) return !0;
                    const r = e.globals.activeFloors;
                    return t1.some((t1)=>{
                        const n = t1.evaluate(e);
                        return r.has(n);
                    });
                }
            ],
            id: [
                _r,
                [],
                (e)=>e.id()
            ],
            zoom: [
                gr,
                [],
                (e)=>e.globals.zoom
            ],
            pitch: [
                gr,
                [],
                (e)=>e.globals.pitch || 0
            ],
            "distance-from-center": [
                gr,
                [],
                (e)=>e.distanceFromCenter()
            ],
            "measure-light": [
                gr,
                [
                    xr
                ],
                (e, [t1])=>e.measureLight(t1.evaluate(e))
            ],
            "heatmap-density": [
                gr,
                [],
                (e)=>e.globals.heatmapDensity || 0
            ],
            "line-progress": [
                gr,
                [],
                (e)=>e.globals.lineProgress || 0
            ],
            "raster-value": [
                gr,
                [],
                (e)=>e.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                gr,
                [],
                (e)=>e.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                gr,
                [],
                (e)=>e.globals.skyRadialProgress || 0
            ],
            accumulated: [
                _r,
                [],
                (e)=>void 0 === e.globals.accumulated ? null : e.globals.accumulated
            ],
            "+": [
                gr,
                bs(gr),
                (e, t1)=>{
                    let r = 0;
                    for (const n of t1)r += n.evaluate(e);
                    return r;
                }
            ],
            "*": [
                gr,
                bs(gr),
                (e, t1)=>{
                    let r = 1;
                    for (const n of t1)r *= n.evaluate(e);
                    return r;
                }
            ],
            "-": {
                type: gr,
                overloads: [
                    [
                        [
                            gr,
                            gr
                        ],
                        (e, [t1, r])=>t1.evaluate(e) - r.evaluate(e)
                    ],
                    [
                        [
                            gr
                        ],
                        (e, [t1])=>-t1.evaluate(e)
                    ]
                ]
            },
            "/": [
                gr,
                [
                    gr,
                    gr
                ],
                (e, [t1, r])=>t1.evaluate(e) / r.evaluate(e)
            ],
            "%": [
                gr,
                [
                    gr,
                    gr
                ],
                (e, [t1, r])=>t1.evaluate(e) % r.evaluate(e)
            ],
            ln2: [
                gr,
                [],
                ()=>Math.LN2
            ],
            pi: [
                gr,
                [],
                ()=>Math.PI
            ],
            e: [
                gr,
                [],
                ()=>Math.E
            ],
            "^": [
                gr,
                [
                    gr,
                    gr
                ],
                (e, [t1, r])=>Math.pow(t1.evaluate(e), r.evaluate(e))
            ],
            sqrt: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.sqrt(t1.evaluate(e))
            ],
            log10: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.log(t1.evaluate(e)) / Math.LN10
            ],
            ln: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.log(t1.evaluate(e))
            ],
            log2: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.log2(t1.evaluate(e))
            ],
            sin: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.sin(t1.evaluate(e))
            ],
            cos: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.cos(t1.evaluate(e))
            ],
            tan: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.tan(t1.evaluate(e))
            ],
            asin: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.asin(t1.evaluate(e))
            ],
            acos: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.acos(t1.evaluate(e))
            ],
            atan: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.atan(t1.evaluate(e))
            ],
            min: [
                gr,
                bs(gr),
                (e, t1)=>Math.min(...t1.map((t1)=>t1.evaluate(e)))
            ],
            max: [
                gr,
                bs(gr),
                (e, t1)=>Math.max(...t1.map((t1)=>t1.evaluate(e)))
            ],
            abs: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.abs(t1.evaluate(e))
            ],
            round: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>{
                    const r = t1.evaluate(e);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.floor(t1.evaluate(e))
            ],
            ceil: [
                gr,
                [
                    gr
                ],
                (e, [t1])=>Math.ceil(t1.evaluate(e))
            ],
            "filter-==": [
                vr,
                [
                    xr,
                    _r
                ],
                (e, [t1, r])=>e.properties()[t1.value] === r.value
            ],
            "filter-id-==": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>e.id() === t1.value
            ],
            "filter-type-==": [
                vr,
                [
                    xr
                ],
                (e, [t1])=>e.geometryType() === t1.value
            ],
            "filter-<": [
                vr,
                [
                    xr,
                    _r
                ],
                (e, [t1, r])=>{
                    const n = e.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>{
                    const r = e.id(), n = t1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                vr,
                [
                    xr,
                    _r
                ],
                (e, [t1, r])=>{
                    const n = e.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>{
                    const r = e.id(), n = t1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                vr,
                [
                    xr,
                    _r
                ],
                (e, [t1, r])=>{
                    const n = e.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>{
                    const r = e.id(), n = t1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                vr,
                [
                    xr,
                    _r
                ],
                (e, [t1, r])=>{
                    const n = e.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>{
                    const r = e.id(), n = t1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                vr,
                [
                    _r
                ],
                (e, [t1])=>t1.value in e.properties()
            ],
            "filter-has-id": [
                vr,
                [],
                (e)=>null !== e.id() && void 0 !== e.id()
            ],
            "filter-type-in": [
                vr,
                [
                    Sr(xr)
                ],
                (e, [t1])=>t1.value.indexOf(e.geometryType()) >= 0
            ],
            "filter-id-in": [
                vr,
                [
                    Sr(_r)
                ],
                (e, [t1])=>t1.value.indexOf(e.id()) >= 0
            ],
            "filter-in-small": [
                vr,
                [
                    xr,
                    Sr(_r)
                ],
                (e, [t1, r])=>r.value.indexOf(e.properties()[t1.value]) >= 0
            ],
            "filter-in-large": [
                vr,
                [
                    xr,
                    Sr(_r)
                ],
                (e, [t1, r])=>(function(e, t1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (t1[i] === e) return !0;
                            t1[i] > e ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(e.properties()[t1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: vr,
                overloads: [
                    [
                        [
                            vr,
                            vr
                        ],
                        (e, [t1, r])=>t1.evaluate(e) && r.evaluate(e)
                    ],
                    [
                        bs(vr),
                        (e, t1)=>{
                            for (const r of t1)if (!r.evaluate(e)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: vr,
                overloads: [
                    [
                        [
                            vr,
                            vr
                        ],
                        (e, [t1, r])=>t1.evaluate(e) || r.evaluate(e)
                    ],
                    [
                        bs(vr),
                        (e, t1)=>{
                            for (const r of t1)if (r.evaluate(e)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                vr,
                [
                    vr
                ],
                (e, [t1])=>!t1.evaluate(e)
            ],
            "is-supported-script": [
                vr,
                [
                    xr
                ],
                (e, [t1])=>{
                    const r = e.globals && e.globals.isSupportedScript;
                    return !r || r(t1.evaluate(e));
                }
            ],
            upcase: [
                xr,
                [
                    xr
                ],
                (e, [t1])=>t1.evaluate(e).toUpperCase()
            ],
            downcase: [
                xr,
                [
                    xr
                ],
                (e, [t1])=>t1.evaluate(e).toLowerCase()
            ],
            concat: [
                xr,
                bs(_r),
                (e, t1)=>t1.map((t1)=>Nr(t1.evaluate(e))).join("")
            ],
            "resolved-locale": [
                xr,
                [
                    Ar
                ],
                (e, [t1])=>t1.evaluate(e).resolvedLocale()
            ],
            random: [
                gr,
                [
                    gr,
                    gr,
                    _r
                ],
                (e, t1)=>{
                    const [r, n, i] = t1.map((t1)=>t1.evaluate(e));
                    if (r > n) return r;
                    if (r === n) return r;
                    let s;
                    if ("string" == typeof i) s = function(e) {
                        let t1 = 0;
                        if (0 === e.length) return t1;
                        for(let r = 0; r < e.length; r++)t1 = (t1 << 5) - t1 + e.charCodeAt(r), t1 &= t1;
                        return t1;
                    }(i);
                    else {
                        if ("number" != typeof i) throw new Gr(`Invalid seed input: ${i}`);
                        s = i;
                    }
                    return r + fs(s)() * (n - r);
                }
            ]
        });
        class Ls {
            constructor(e, t1, r, n, i){
                this.expression = e, this._warningHistory = {}, this._scope = r, this._options = n, this._iconImageUseTheme = i, this._evaluator = new rn(r, n, i), this._defaultValue = t1 ? function(e) {
                    return "color" === e.type && (Ts(e.default) || Array.isArray(e.default)) ? new ar(0, 0, 0, 0) : "color" === e.type ? ar.parse(e.default) || null : void 0 === e.default ? null : e.default;
                }(t1) : null, this._enumValues = t1 && "enum" === t1.type ? t1.values : null, this.configDependencies = ws(e), this.isIndoorDependent = _s(e);
            }
            evaluateWithoutErrorHandling(e, t1, r, n, i, s, o, a) {
                return this._evaluator.globals = e, this._evaluator.feature = t1, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(e, t1, r, n, i, s, o, a, l) {
                this._evaluator || (this._evaluator = new rn(this._scope, this._options, this._iconImageUseTheme)), this._evaluator.globals = e, this._evaluator.feature = t1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = o || null, this._evaluator.featureDistanceData = a || null, this._evaluator.iconImageUseTheme = l || null;
                try {
                    const e = this.expression.evaluate(this._evaluator);
                    if (null == e || "number" == typeof e && e != e) return this._defaultValue;
                    if (this._enumValues && !(e in this._enumValues)) throw new Gr(`Expected value to be one of ${Object.keys(this._enumValues).map((e)=>JSON.stringify(e)).join(", ")}, but found ${JSON.stringify(e)} instead.`);
                    return e;
                } catch (e) {
                    const t1 = e;
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function Os(e) {
            return Array.isArray(e) && e.length > 0 && "string" == typeof e[0] && e[0] in ms;
        }
        function Us(e, t1, r, n, i) {
            const s = new Ai(ms, [], t1 ? function(e) {
                const t1 = {
                    color: br,
                    string: xr,
                    number: gr,
                    enum: xr,
                    boolean: vr,
                    formatted: Mr,
                    resolvedImage: Ir
                };
                return "array" === e.type ? Sr(t1[e.value] || _r, e.length) : t1[e.type];
            }(t1) : void 0, void 0, void 0, r, n, i), o = s.parse(e, void 0, void 0, void 0, t1 && "string" === t1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return o ? As(new Ls(o, t1, r, n, i)) : Ms(s.errors);
        }
        class Ns {
            constructor(e, t1, r, n){
                this.kind = e, this._styleExpression = t1, this.isLightConstant = r, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== e && !yi(t1.expression), this.configDependencies = ws(t1.expression), this.isIndoorDependent = _s(t1.expression);
            }
            evaluateWithoutErrorHandling(e, t1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(e, t1, r, n, i, s);
            }
            evaluate(e, t1, r, n, i, s, o) {
                return this._styleExpression.evaluate(e, t1, r, n, i, s, void 0, void 0, o);
            }
        }
        class js {
            constructor(e, t1, r, n, i, s){
                this.kind = e, this.zoomStops = r, this._styleExpression = t1, this.isStateDependent = "camera" !== e && !yi(t1.expression), this.isIndoorDependent = _s(t1.expression), this.isLightConstant = i, this.isLineProgressConstant = s, this.configDependencies = ws(t1.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(e, t1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(e, t1, r, n, i, s);
            }
            evaluate(e, t1, r, n, i, s) {
                return this._styleExpression.evaluate(e, t1, r, n, i, s);
            }
            interpolationFactor(e, t1, r) {
                return this.interpolationType ? qi.interpolationFactor(this.interpolationType, e, t1, r) : 0;
            }
        }
        function Gs(e, t1, r, n, i) {
            if ("error" === (e = Us(e, t1, r, n, i)).result) return e;
            const s = e.value.expression, o = mi(s);
            if (!o && !Ss(t1)) return Ms([
                new fr("", "data expressions not supported")
            ]);
            const a = gi(s, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!a && !Ps(t1)) return Ms([
                new fr("", "zoom expressions not supported")
            ]);
            const l = gi(s, [
                "measure-light"
            ]);
            if (!l && !zs(t1)) return Ms([
                new fr("", "measure-light expression not supported")
            ]);
            const u = gi(s, [
                "line-progress"
            ]);
            if (!u && !function(e) {
                return Is(e.expression, "line-progress");
            }(t1)) return Ms([
                new fr("", "line-progress expression not supported")
            ]);
            const c = t1.expression && t1.expression.relaxZoomRestriction, h = qs(s);
            return h || a || c ? h instanceof fr ? Ms([
                h
            ]) : h instanceof qi && !Bs(t1) ? Ms([
                new fr("", '"interpolate" expressions cannot be used with this property')
            ]) : As(h ? new js(o && u ? "camera" : "composite", e.value, h.labels, h instanceof qi ? h.interpolation : void 0, l, u) : new Ns(o && u ? "constant" : "source", e.value, l, u)) : Ms([
                new fr("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class $s {
            constructor(e, t1){
                this._parameters = e, this._specification = t1, Object.assign(this, Vs(this._parameters, this._specification));
            }
            static deserialize(e) {
                return new $s(e._parameters, e._specification);
            }
            static serialize(e) {
                return {
                    _parameters: e._parameters,
                    _specification: e._specification
                };
            }
        }
        function qs(e) {
            let t1 = null;
            if (e instanceof Zi) t1 = qs(e.result);
            else if (e instanceof Hi) {
                for (const r of e.args)if (t1 = qs(r), t1) break;
            } else (e instanceof Si || e instanceof qi) && e.input instanceof nn && "zoom" === e.input.name && (t1 = e);
            return t1 instanceof fr || e.eachChild((e)=>{
                const r = qs(e);
                r instanceof fr ? t1 = r : t1 && r && t1 !== r && (t1 = new fr("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t1;
        }
        var Xs, Hs, Zs = function() {
            if (Hs) return Xs;
            Hs = 1, Xs = t1;
            var e = 3;
            function t1(t1, r, n) {
                var i = this.cells = [];
                if (t1 instanceof ArrayBuffer) {
                    this.arrayBuffer = t1;
                    var s = new Int32Array(this.arrayBuffer);
                    t1 = s[0], this.d = (r = s[1]) + 2 * (n = s[2]);
                    for(var o = 0; o < this.d * this.d; o++){
                        var a = s[e + o], l = s[e + o + 1];
                        i.push(a === l ? null : s.subarray(a, l));
                    }
                    var u = s[e + i.length + 1];
                    this.keys = s.subarray(s[e + i.length], u), this.bboxes = s.subarray(u), this.insert = this._insertReadonly;
                } else {
                    this.d = r + 2 * n;
                    for(var c = 0; c < this.d * this.d; c++)i.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = r, this.extent = t1, this.padding = n, this.scale = r / t1, this.uid = 0;
                var h = n / r * t1;
                this.min = -h, this.max = t1 + h;
            }
            return t1.prototype.insert = function(e, t1, r, n, i) {
                this._forEachCell(t1, r, n, i, this._insertCell, this.uid++), this.keys.push(e), this.bboxes.push(t1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }, t1.prototype._insertReadonly = function() {
                throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, t1.prototype._insertCell = function(e, t1, r, n, i, s) {
                this.cells[i].push(s);
            }, t1.prototype.query = function(e, t1, r, n, i) {
                var s = this.min, o = this.max;
                if (e <= s && t1 <= s && o <= r && o <= n && !i) return Array.prototype.slice.call(this.keys);
                var a = [];
                return this._forEachCell(e, t1, r, n, this._queryCell, a, {}, i), a;
            }, t1.prototype._queryCell = function(e, t1, r, n, i, s, o, a) {
                var l = this.cells[i];
                if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                    var p = l[h];
                    if (void 0 === o[p]) {
                        var d = 4 * p;
                        (a ? a(c[d + 0], c[d + 1], c[d + 2], c[d + 3]) : e <= c[d + 2] && t1 <= c[d + 3] && r >= c[d + 0] && n >= c[d + 1]) ? (o[p] = !0, s.push(u[p])) : o[p] = !1;
                    }
                }
            }, t1.prototype._forEachCell = function(e, t1, r, n, i, s, o, a) {
                for(var l = this._convertToCellCoord(e), u = this._convertToCellCoord(t1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var d = u; d <= h; d++){
                    var f = this.d * d + p;
                    if ((!a || a(this._convertFromCellCoord(p), this._convertFromCellCoord(d), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(d + 1))) && i.call(this, e, t1, r, n, f, s, o, a)) return;
                }
            }, t1.prototype._convertFromCellCoord = function(e) {
                return (e - this.padding) / this.scale;
            }, t1.prototype._convertToCellCoord = function(e) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(e * this.scale) + this.padding));
            }, t1.prototype.toArrayBuffer = function() {
                if (this.arrayBuffer) return this.arrayBuffer;
                for(var t1 = this.cells, r = e + this.cells.length + 1 + 1, n = 0, i = 0; i < this.cells.length; i++)n += this.cells[i].length;
                var s = new Int32Array(r + n + this.keys.length + this.bboxes.length);
                s[0] = this.extent, s[1] = this.n, s[2] = this.padding;
                for(var o = r, a = 0; a < t1.length; a++){
                    var l = t1[a];
                    s[e + a] = o, s.set(l, o), o += l.length;
                }
                return s[e + t1.length] = o, s.set(this.keys, o), s[e + t1.length + 1] = o += this.keys.length, s.set(this.bboxes, o), o += this.bboxes.length, s.buffer;
            }, Xs;
        }(), Ws = _e(Zs);
        const Ys = {};
        function Js(e, t1, r = {}) {
            Object.defineProperty(e, "_classRegistryKey", {
                value: t1,
                writable: !1
            }), Ys[t1] = {
                klass: e,
                omit: r.omit || []
            };
        }
        Js(Object, "Object"), Ws.serialize = function(e, t1) {
            const r = e.toArrayBuffer();
            return t1 && t1.add(r), {
                buffer: r
            };
        }, Ws.deserialize = function(e) {
            return new Ws(e.buffer);
        }, Object.defineProperty(Ws, "name", {
            value: "Grid"
        }), Js(Ws, "Grid"), delete Ie.prototype.constructor, Js(ar, "Color"), Js(Error, "Error"), Js(Dr, "Formatted"), Js(Fr, "FormattedSection"), Js(Ct, "AJAXError"), Js(Rr, "ResolvedImage"), Js($s, "StylePropertyFunction"), Js(Ls, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Js(nr, "ImageId"), Js(Cr, "ImageVariant"), Js(js, "ZoomDependentExpression"), Js(Ns, "ZoomConstantExpression"), Js(nn, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e in ms)Ys[ms[e]._classRegistryKey] || Js(ms[e], `Expression${e}`);
        function Ks(e) {
            return e && (e instanceof ArrayBuffer || e.constructor && "ArrayBuffer" === e.constructor.name);
        }
        function Qs(e, t1) {
            if (null == e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || e instanceof Boolean || e instanceof Number || e instanceof String || e instanceof Date || e instanceof RegExp) return e;
            if (Ks(e) || e instanceof ImageBitmap) return t1 && t1.add(e), e;
            if (ArrayBuffer.isView(e)) return t1 && t1.add(e.buffer), e;
            if (e instanceof ImageData) return t1 && t1.add(e.data.buffer), e;
            if (Array.isArray(e)) {
                const r = [];
                for (const n of e)r.push(Qs(n, t1));
                return r;
            }
            if (e instanceof Map) {
                const r = {
                    $name: "Map",
                    entries: []
                };
                for (const [n, i] of e.entries())r.entries.push(Qs(n), Qs(i, t1));
                return r;
            }
            if (e instanceof Set) {
                const t1 = {
                    $name: "Set"
                };
                let r = 0;
                for (const n of e.values())t1[++r] = Qs(n);
                return t1;
            }
            if ("bigint" == typeof e) return {
                $name: "BigInt",
                value: e.toString()
            };
            if ("object" == typeof e) {
                const r = e.constructor, n = r._classRegistryKey;
                if (!n) throw new Error(`Can't serialize object of unregistered class "${r.name}".`);
                const i = r.serialize ? r.serialize(e, t1) : {};
                if (!r.serialize) {
                    for(const r in e)e.hasOwnProperty(r) && (Ys[n].omit.indexOf(r) >= 0 || (i[r] = Qs(e[r], t1)));
                    e instanceof Error && (i.message = e.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof e);
        }
        function eo(e) {
            if (null == e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || e instanceof Boolean || e instanceof Number || e instanceof String || e instanceof Date || e instanceof RegExp || Ks(e) || e instanceof ImageBitmap || ArrayBuffer.isView(e) || e instanceof ImageData) return e;
            if (Array.isArray(e)) return e.map(eo);
            if ("object" == typeof e) {
                const t1 = e.$name || "Object";
                if ("Map" === t1) {
                    const t1 = e.entries || [], r = new Map;
                    for(let e = 0; e < t1.length; e += 2)r.set(eo(t1[e]), eo(t1[e + 1]));
                    return r;
                }
                if ("Set" === t1) {
                    const t1 = new Set;
                    for (const r of Object.keys(e))"$name" !== r && t1.add(eo(e[r]));
                    return t1;
                }
                if ("BigInt" === t1) return BigInt(e.value);
                const { klass: r } = Ys[t1];
                if (!r) throw new Error(`Can't deserialize unregistered class "${t1}".`);
                if (r.deserialize) return r.deserialize(e);
                const n = Object.create(r.prototype);
                for (const t1 of Object.keys(e))"$name" !== t1 && (n[t1] = eo(e[t1]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof e);
        }
        const to = (e)=>e >= 1536 && e <= 1791, ro = (e)=>e >= 1872 && e <= 1919, no = (e)=>e >= 2208 && e <= 2303, io = (e)=>e >= 11904 && e <= 12031, so = (e)=>e >= 12032 && e <= 12255, oo = (e)=>e >= 12272 && e <= 12287, ao = (e)=>e >= 12288 && e <= 12351, lo = (e)=>e >= 12352 && e <= 12447, uo = (e)=>e >= 12448 && e <= 12543, co = (e)=>e >= 12544 && e <= 12591, ho = (e)=>e >= 12704 && e <= 12735, po = (e)=>e >= 12736 && e <= 12783, fo = (e)=>e >= 12784 && e <= 12799, mo = (e)=>e >= 12800 && e <= 13055, yo = (e)=>e >= 13056 && e <= 13311, go = (e)=>e >= 13312 && e <= 19903, xo = (e)=>e >= 19968 && e <= 40959, vo = (e)=>e >= 40960 && e <= 42127, bo = (e)=>e >= 42128 && e <= 42191, wo = (e)=>e >= 44032 && e <= 55215, _o = (e)=>e >= 63744 && e <= 64255, Ao = (e)=>e >= 64336 && e <= 65023, Mo = (e)=>e >= 65040 && e <= 65055, Io = (e)=>e >= 65072 && e <= 65103, So = (e)=>e >= 65104 && e <= 65135, zo = (e)=>e >= 65136 && e <= 65279, Po = (e)=>e >= 65280 && e <= 65519;
        function Bo(e) {
            for (const t1 of e)if (Eo(t1.charCodeAt(0))) return !0;
            return !1;
        }
        function To(e) {
            for (const t1 of e)if (!ko(t1.charCodeAt(0))) return !1;
            return !0;
        }
        function ko(e) {
            return !(to(e) || ro(e) || no(e) || Ao(e) || zo(e));
        }
        function Vo(e) {
            return !(e < 11904 || !(ho(e) || co(e) || Io(e) || _o(e) || yo(e) || io(e) || po(e) || ao(e) || go(e) || xo(e) || mo(e) || Po(e) || lo(e) || oo(e) || so(e) || fo(e) || uo(e) || Mo(e) || bo(e) || vo(e)));
        }
        function Eo(e) {
            return !(746 !== e && 747 !== e && (e < 4352 || !(ho(e) || co(e) || Io(e) && !(e >= 65097 && e <= 65103) || _o(e) || yo(e) || io(e) || po(e) || !(!ao(e) || e >= 12296 && e <= 12305 || e >= 12308 && e <= 12319 || 12336 === e) || go(e) || xo(e) || mo(e) || ((e)=>e >= 12592 && e <= 12687)(e) || ((e)=>e >= 43360 && e <= 43391)(e) || ((e)=>e >= 55216 && e <= 55295)(e) || ((e)=>e >= 4352 && e <= 4607)(e) || wo(e) || lo(e) || oo(e) || ((e)=>e >= 12688 && e <= 12703)(e) || so(e) || fo(e) || uo(e) && 12540 !== e || !(!Po(e) || 65288 === e || 65289 === e || 65293 === e || e >= 65306 && e <= 65310 || 65339 === e || 65341 === e || 65343 === e || e >= 65371 && e <= 65503 || 65507 === e || e >= 65512 && e <= 65519) || !(!So(e) || e >= 65112 && e <= 65118 || e >= 65123 && e <= 65126) || ((e)=>e >= 5120 && e <= 5759)(e) || ((e)=>e >= 6320 && e <= 6399)(e) || Mo(e) || ((e)=>e >= 19904 && e <= 19967)(e) || vo(e) || bo(e))));
        }
        function Fo(e) {
            return 12312 === e || 12313 === e || 12316 === e || 12540 === e || 12448 === e;
        }
        function Do(e) {
            return !(Eo(e) || function(e) {
                return !!(((e)=>e >= 128 && e <= 255)(e) && (167 === e || 169 === e || 174 === e || 177 === e || 188 === e || 189 === e || 190 === e || 215 === e || 247 === e) || ((e)=>e >= 8192 && e <= 8303)(e) && (8214 === e || 8224 === e || 8225 === e || 8240 === e || 8241 === e || 8251 === e || 8252 === e || 8258 === e || 8263 === e || 8264 === e || 8265 === e || 8273 === e) || ((e)=>e >= 8448 && e <= 8527)(e) || ((e)=>e >= 8528 && e <= 8591)(e) || ((e)=>e >= 8960 && e <= 9215)(e) && (e >= 8960 && e <= 8967 || e >= 8972 && e <= 8991 || e >= 8996 && e <= 9e3 || 9003 === e || e >= 9085 && e <= 9114 || e >= 9150 && e <= 9165 || 9167 === e || e >= 9169 && e <= 9179 || e >= 9186 && e <= 9215) || ((e)=>e >= 9216 && e <= 9279)(e) && 9251 !== e || ((e)=>e >= 9280 && e <= 9311)(e) || ((e)=>e >= 9312 && e <= 9471)(e) || ((e)=>e >= 9632 && e <= 9727)(e) || ((e)=>e >= 9728 && e <= 9983)(e) && !(e >= 9754 && e <= 9759) || ((e)=>e >= 11008 && e <= 11263)(e) && (e >= 11026 && e <= 11055 || e >= 11088 && e <= 11097 || e >= 11192 && e <= 11243) || ao(e) || uo(e) || ((e)=>e >= 57344 && e <= 63743)(e) || Io(e) || So(e) || Po(e) || 8734 === e || 8756 === e || 8757 === e || e >= 9984 && e <= 10087 || e >= 10102 && e <= 10131 || 65532 === e || 65533 === e);
            }(e));
        }
        function Co(e) {
            return to(e) || ro(e) || no(e) || Ao(e) || zo(e);
        }
        function Ro(e) {
            return e >= 1424 && e <= 2303 || Ao(e) || zo(e);
        }
        function Lo(e, t1) {
            return !(!t1 && Ro(e) || e >= 2304 && e <= 3583 || e >= 3840 && e <= 4255 || ((e)=>e >= 6016 && e <= 6143)(e));
        }
        function Oo(e) {
            for (const t1 of e)if (Ro(t1.charCodeAt(0))) return !0;
            return !1;
        }
        const Uo = {
            unavailable: "unavailable",
            deferred: "deferred",
            loading: "loading",
            parsing: "parsing",
            parsed: "parsed",
            loaded: "loaded",
            error: "error"
        };
        let No = null, jo = Uo.unavailable, Go = null;
        const $o = function(e) {
            e && "string" == typeof e && e.indexOf("NetworkError") > -1 && (jo = Uo.error), No && No(e);
        };
        function qo() {
            Xo.fire(new Kt("pluginStateChange", {
                pluginStatus: jo,
                pluginURL: Go
            }));
        }
        const Xo = new rr, Ho = function() {
            return jo;
        }, Zo = function() {
            if (jo !== Uo.deferred || !Go) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            jo = Uo.loading, qo(), Go && Ot({
                url: Go
            }, (e)=>{
                e ? $o(e) : (jo = Uo.loaded, qo());
            });
        }, Wo = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>jo === Uo.loaded || null != Wo.applyArabicShaping,
            isLoading: ()=>jo === Uo.loading,
            setState (e) {
                jo = e.pluginStatus, Go = e.pluginURL;
            },
            isParsing: ()=>jo === Uo.parsing,
            isParsed: ()=>jo === Uo.parsed,
            getPluginURL: ()=>Go
        };
        class Yo {
            constructor(e, t1){
                this.zoom = e, t1 ? (this.now = t1.now, this.fadeDuration = t1.fadeDuration, this.transition = t1.transition, this.pitch = t1.pitch, this.brightness = t1.brightness, this.worldview = t1.worldview, this.activeFloors = t1.activeFloors) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(e) {
                return function(e, t1) {
                    for (const r of e)if (!Lo(r.charCodeAt(0), t1)) return !1;
                    return !0;
                }(e, Wo.isLoaded());
            }
        }
        class Jo {
            constructor(e, t1, r, n, i){
                this.property = e, this.value = t1, this.expression = function(e, t1, r, n, i) {
                    if (Ts(e)) return new $s(e, t1);
                    if (Os(e) || Array.isArray(e) && e.length > 0) {
                        const s = Gs(e, t1, r, n, i);
                        if ("error" === s.result) throw new Error(s.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                        return s.value;
                    }
                    {
                        let r = e;
                        return "string" == typeof e && "color" === t1.type && (r = ar.parse(e)), {
                            kind: "constant",
                            configDependencies: new Set,
                            isIndoorDependent: !1,
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === t1 ? e.specification.default : t1, e.specification, r, n, i);
            }
            isIndoorDependent() {
                return this.expression.isIndoorDependent;
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e, t1, r, n) {
                return this.property.possiblyEvaluate(this, e, t1, r, n);
            }
        }
        class Ko {
            constructor(e, t1, r, n){
                this.property = e, this.value = new Jo(e, void 0, t1, r, n);
            }
            transitioned(e, t1) {
                return new ea(this.property, this.value, t1, Object.assign({}, e.transition, this.transition), e.now);
            }
            untransitioned() {
                return new ea(this.property, this.value, null, {}, 0);
            }
        }
        class Qo {
            constructor(e, t1, r, n){
                this._properties = e, this._values = Object.create(e.defaultTransitionablePropertyValues), this._scope = t1, this._options = r, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e) {
                return qe(this._values[e].value.value);
            }
            setValue(e, t1) {
                this._values.hasOwnProperty(e) || (this._values[e] = new Ko(this._values[e].property, this._scope, this._options, this._iconImageUseTheme)), this._values[e].value = new Jo(this._values[e].property, null === t1 ? void 0 : qe(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e].value.expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e].value.isIndoorDependent());
            }
            setTransitionOrValue(e, t1) {
                t1 && (this._options = t1);
                const r = this._properties.properties;
                if (e) for(const t1 in e){
                    const n = e[t1];
                    if (t1.endsWith("-transition")) {
                        const e = t1.slice(0, -11);
                        r[e] && this.setTransition(e, n);
                    } else r.hasOwnProperty(t1) && this.setValue(t1, n);
                }
            }
            getTransition(e) {
                return qe(this._values[e].transition);
            }
            setTransition(e, t1) {
                this._values.hasOwnProperty(e) || (this._values[e] = new Ko(this._values[e].property)), this._values[e].transition = qe(t1) || void 0;
            }
            serialize() {
                const e = {};
                for (const t1 of Object.keys(this._values)){
                    const r = this.getValue(t1);
                    void 0 !== r && (e[t1] = r);
                    const n = this.getTransition(t1);
                    void 0 !== n && (e[`${t1}-transition`] = n);
                }
                return e;
            }
            transitioned(e, t1) {
                const r = new ta(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(e, t1._values[n]);
                return r;
            }
            untransitioned() {
                const e = new ta(this._properties);
                for (const t1 of Object.keys(this._values))e._values[t1] = this._values[t1].untransitioned();
                return e;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class ea {
            constructor(e, t1, r, n, i){
                const s = n.delay || 0, o = n.duration || 0;
                i = i || 0, this.property = e, this.value = t1, this.begin = i + s, this.end = this.begin + o, e.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(e, t1, r) {
                const n = e.now || 0, i = this.value.possiblyEvaluate(e, t1, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(e, t1, r);
                    {
                        const o = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(e, t1, r), i, Ve(o));
                    }
                }
                return i;
            }
        }
        class ta {
            constructor(e){
                this._properties = e, this._values = Object.create(e.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(e, t1, r) {
                const n = new ia(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(e, t1, r);
                return n;
            }
            hasTransition() {
                for (const e of Object.keys(this._values))if (this._values[e].prior) return !0;
                return !1;
            }
        }
        class ra {
            constructor(e, t1, r, n){
                this._properties = e, this._values = Object.create(e.defaultPropertyValues), this._scope = t1, this._options = r, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e) {
                return qe(this._values[e].value);
            }
            setValue(e, t1) {
                this._values[e] = new Jo(this._values[e].property, null === t1 ? void 0 : qe(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e].expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e].isIndoorDependent());
            }
            serialize() {
                const e = {};
                for (const t1 of Object.keys(this._values)){
                    const r = this.getValue(t1);
                    void 0 !== r && (e[t1] = r);
                }
                return e;
            }
            possiblyEvaluate(e, t1, r, n) {
                const i = new ia(this._properties);
                for (const s of Object.keys(this._values))i._values[s] = this._values[s].possiblyEvaluate(e, t1, r, n);
                return i;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class na {
            constructor(e, t1, r, n){
                this.property = e, this.value = t1, this.parameters = r, this.iconImageUseTheme = n;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e) {
                return "constant" === this.value.kind ? this.value.value : e;
            }
            evaluate(e, t1, r, n) {
                return this.property.evaluate(this.value, this.parameters, e, t1, r, n, this.iconImageUseTheme);
            }
        }
        class ia {
            constructor(e){
                this._properties = e, this._values = Object.create(e.defaultPossiblyEvaluatedValues);
            }
            get(e) {
                return this._values[e];
            }
        }
        class sa {
            constructor(e){
                this.specification = e;
            }
            possiblyEvaluate(e, t1) {
                return e.expression.evaluate(t1);
            }
            interpolate(e, t1, r) {
                const n = dr[this.specification.type];
                return n ? n(e, t1, r) : e;
            }
        }
        class oa {
            constructor(e, t1){
                this.specification = e, this.overrides = t1;
            }
            possiblyEvaluate(e, t1, r, n, i) {
                return "constant" === e.expression.kind || "camera" === e.expression.kind ? new na(this, {
                    kind: "constant",
                    value: e.expression.evaluate(t1, null, {}, r, n, void 0, i)
                }, t1) : new na(this, e.expression, t1, i);
            }
            interpolate(e, t1, r) {
                if ("constant" !== e.value.kind || "constant" !== t1.value.kind) return e;
                if (void 0 === e.value.value || void 0 === t1.value.value) return new na(this, {
                    kind: "constant",
                    value: void 0
                }, e.parameters);
                const n = dr[this.specification.type];
                return n ? new na(this, {
                    kind: "constant",
                    value: n(e.value.value, t1.value.value, r)
                }, e.parameters) : e;
            }
            evaluate(e, t1, r, n, i, s, o) {
                return "constant" === e.kind ? e.value : e.evaluate(t1, r, n, i, s, void 0, o);
            }
        }
        class aa {
            constructor(e){
                this.specification = e;
            }
            possiblyEvaluate(e, t1, r, n) {
                return !!e.expression.evaluate(t1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class la {
            constructor(e){
                this.properties = e, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t1 = new Yo(0, {});
                for(const r in e){
                    const n = e[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new Jo(n, void 0), s = this.defaultTransitionablePropertyValues[r] = new Ko(n);
                    this.defaultTransitioningPropertyValues[r] = s.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(t1);
                }
            }
        }
        Js(oa, "DataDrivenProperty"), Js(sa, "DataConstantProperty"), Js(aa, "ColorRampProperty");
        var ua = JSON.parse('{"$version":8,"$root":{"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","expression":{}},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string"},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"shadow-draw-before-layer":{"type":"string"}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"modelNodeOverride":{"orientation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360}},"modelNodeOverrides":{"*":{"type":"modelNodeOverride"}},"modelMaterialOverride":{"model-color":{"type":"color"},"model-color-mix-intensity":{"type":"number"},"model-opacity":{"type":"number"},"model-emissive-strength":{"type":"number"}},"modelMaterialOverrides":{"*":{"type":"modelMaterialOverride"}},"modelSourceModel":{"uri":{"type":"string"},"position":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[-180,-90],"maximum":[180,90]},"orientation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360},"nodeOverrides":{"type":"modelNodeOverrides"},"materialOverrides":{"type":"modelMaterialOverrides"},"nodeOverrideNames":{"type":"array","value":"string"},"materialOverrideNames":{"type":"array","value":"string"},"featureProperties":{"type":"*"}},"modelSourceModels":{"*":{"type":"modelSourceModel"}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"url":{"type":"string"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"},"models":{"type":"modelSourceModels"}},"layer":{"id":{"type":"string"},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"clip":{}}},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"},"appearances":{"type":"array","value":"appearance","supported-layer-types":["symbol"]}},"appearance":{"condition":{"type":"boolean","expression":{"interpolated":true,"parameters":["zoom","pitch","feature","feature-state","measure-light","distance-from-center"]},"property-type":"data-driven"},"name":{"type":"string"},"properties":{"type":"*"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"model-allow-density-reduction":{"type":"boolean","default":true}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{}},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","expression":{}},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-markup":1},"default":"none","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}}},"layout_building":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"building-facade":{"type":"boolean","default":false,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-floors":{"type":"number","minimum":1,"maximum":200,"default":3,"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-facade-unit-width":{"type":"number","minimum":1,"maximum":20,"default":3.1,"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-facade-window":{"type":"array","length":2,"value":"number","minimum":0.1,"maximum":1,"default":[0.9,0.9],"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-roof-shape":{"type":"enum","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"default":"flat","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"building-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"building-flip-roof-orientation":{"property-type":"data-driven","type":"boolean","default":false,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","expression":{}},"line-cross-slope":{"type":"number","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","expression":{"parameters":["zoom"]}},"line-elevation-ground-scale":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","line-progress"]},"transition":true,"property-type":"data-driven"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"expression":{}},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"appearance":true,"use-theme":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"expression":{}},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"period":360,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_building":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*"}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective"}},"colorTheme":{"data":{"type":"string","expression":{}}},"indoor_source":{"sourceId":{"type":"string"},"sourceLayers":{"type":"array","value":"string"}},"indoor":{"*":{"type":"indoor_source"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator"},"center":{"type":"array","length":2,"value":"number","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"flat"},"fill-extrusion-base-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"terrain"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"parameters":[]},"transition":true},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","use-theme":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-facade-emissive-chance":{"type":"number","default":0.35,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["measure-light","zoom"]}},"building-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"building-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"building-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"building-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-gradient":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["line-progress"]}},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1]},"line-trim-fade-range":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-trim-color":{"type":"color","default":"transparent","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"line-border-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"use-theme":true,"expression":{"interpolated":true,"parameters":["heatmap-density"]}},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{}},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-value"]}},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1},"default":"sea","expression":{}}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-particle-speed"]}},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-shadow-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-accent-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"use-theme":true,"expression":{"interpolated":true,"parameters":["sky-radial-progress"]}},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":true},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":true},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"use-theme":true,"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d"},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"model-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]},"model-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{}}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"promoteId":{"*":{"type":"*"}}}');
        function ca(e) {
            return e instanceof Number || e instanceof String || e instanceof Boolean ? e.valueOf() : e;
        }
        function ha(e) {
            if (Array.isArray(e)) return e.map(ha);
            if (e instanceof Object && !(e instanceof Number || e instanceof String || e instanceof Boolean)) {
                const t1 = {};
                for(const r in e)t1[r] = ha(e[r]);
                return t1;
            }
            return ca(e);
        }
        function pa(e) {
            if (!0 === e || !1 === e) return !0;
            if (!Array.isArray(e) || 0 === e.length) return !1;
            switch(e[0]){
                case "has":
                    return e.length >= 2 && "$id" !== e[1] && "$type" !== e[1];
                case "in":
                    return e.length >= 3 && ("string" != typeof e[1] || Array.isArray(e[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e.length || Array.isArray(e[1]) || Array.isArray(e[2]);
                case "any":
                case "all":
                    for (const t1 of e.slice(1))if (!pa(t1) && "boolean" != typeof t1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function da(e, t1 = "", r = null, n = "fill") {
            if (null == e) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            pa(e) || (e = ba(e));
            const i = e;
            let s = !0;
            try {
                s = function(e) {
                    if (!ya(e)) return e;
                    let t1 = ha(e);
                    return ma(t1), t1 = fa(t1), t1;
                }(i);
            } catch (e) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            let o = null, a = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                a = ua[`filter_${n}`];
                const e = Us(s, a, t1, r);
                if ("error" === e.result) throw new Error(e.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                o = (t1, r, n)=>e.value.evaluate(t1, r, {}, n);
            }
            let l = null, u = null;
            if (s !== i) {
                const e = Us(i, a, t1, r);
                if ("error" === e.result) throw new Error(e.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                l = (t1, r, n, i, s)=>e.value.evaluate(t1, r, {}, n, void 0, void 0, i, s), u = !mi(e.value.expression);
            }
            return {
                filter: o,
                dynamicFilter: l || void 0,
                needGeometry: va(s),
                needFeature: !!u
            };
        }
        function fa(e) {
            if (!Array.isArray(e)) return e;
            const t1 = function(e) {
                if (ga.has(e[0])) {
                    for(let t1 = 1; t1 < e.length; t1++)if (ya(e[t1])) return !0;
                }
                return e;
            }(e);
            return !0 === t1 ? t1 : t1.map((e)=>fa(e));
        }
        function ma(e) {
            let t1 = !1;
            const r = [];
            if ("case" === e[0]) {
                for(let n = 1; n < e.length - 1; n += 2)t1 = t1 || ya(e[n]), r.push(e[n + 1]);
                r.push(e[e.length - 1]);
            } else if ("match" === e[0]) {
                t1 = t1 || ya(e[1]);
                for(let t1 = 2; t1 < e.length - 1; t1 += 2)r.push(e[t1 + 1]);
                r.push(e[e.length - 1]);
            } else if ("step" === e[0]) {
                t1 = t1 || ya(e[1]);
                for(let t1 = 1; t1 < e.length - 1; t1 += 2)r.push(e[t1 + 1]);
            }
            t1 && (e.length = 0, e.push("any", ...r));
            for(let t1 = 1; t1 < e.length; t1++)ma(e[t1]);
        }
        function ya(e) {
            if (!Array.isArray(e)) return !1;
            if ("pitch" === (t1 = e[0]) || "distance-from-center" === t1) return !0;
            var t1;
            for(let t1 = 1; t1 < e.length; t1++)if (ya(e[t1])) return !0;
            return !1;
        }
        const ga = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function xa(e, t1) {
            return e < t1 ? -1 : e > t1 ? 1 : 0;
        }
        function va(e) {
            if (!Array.isArray(e)) return !1;
            if ("within" === e[0] || "distance" === e[0]) return !0;
            for(let t1 = 1; t1 < e.length; t1++)if (va(e[t1])) return !0;
            return !1;
        }
        function ba(e) {
            if (!e) return !0;
            const t1 = e[0];
            var r;
            return e.length <= 1 ? "any" !== t1 : "==" === t1 ? wa(e[1], e[2], "==") : "!=" === t1 ? Ma(wa(e[1], e[2], "==")) : "<" === t1 || ">" === t1 || "<=" === t1 || ">=" === t1 ? wa(e[1], e[2], t1) : "any" === t1 ? (r = e.slice(1), [
                "any"
            ].concat(r.map(ba))) : "all" === t1 ? [
                "all"
            ].concat(e.slice(1).map(ba)) : "none" === t1 ? [
                "all"
            ].concat(e.slice(1).map(ba).map(Ma)) : "in" === t1 ? _a(e[1], e.slice(2)) : "!in" === t1 ? Ma(_a(e[1], e.slice(2))) : "has" === t1 ? Aa(e[1]) : "!has" !== t1 || Ma(Aa(e[1]));
        }
        function wa(e, t1, r) {
            switch(e){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        t1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        t1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        e,
                        t1
                    ];
            }
        }
        function _a(e, t1) {
            if (0 === t1.length) return !1;
            switch(e){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                default:
                    return t1.length > 200 && !t1.some((e)=>typeof e != typeof t1[0]) ? [
                        "filter-in-large",
                        e,
                        [
                            "literal",
                            t1.sort(xa)
                        ]
                    ] : [
                        "filter-in-small",
                        e,
                        [
                            "literal",
                            t1
                        ]
                    ];
            }
        }
        function Aa(e) {
            switch(e){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e
                    ];
            }
        }
        function Ma(e) {
            return [
                "!",
                e
            ];
        }
        const Ia = "";
        function Sa(e, t1) {
            return t1 ? `${e}${Ia}${t1}` : e;
        }
        let za;
        const Pa = ()=>za || (za = new la({
                "icon-size": new oa(ua.layout_symbol["icon-size"]),
                "icon-image": new oa(ua.layout_symbol["icon-image"]),
                "icon-rotate": new oa(ua.layout_symbol["icon-rotate"]),
                "icon-offset": new oa(ua.layout_symbol["icon-offset"]),
                "text-size": new oa(ua.layout_symbol["text-size"]),
                "text-rotate": new oa(ua.layout_symbol["text-rotate"]),
                "text-offset": new oa(ua.layout_symbol["text-offset"])
            }));
        class Ba {
            constructor(e, t1, r, n, i, s){
                const o = Us(e, ua.appearance.condition);
                if ("success" === o.result && (this.condition = o.value), this.name = t1, r) {
                    this.properties = new ia(Pa()), this.unevaluatedLayout = new ra(Pa(), n, i, s);
                    for(const e in r)this.unevaluatedLayout.setValue(e, r[e]);
                }
            }
            isActive(e) {
                return !(this.condition || !e.isHidden || "hidden" !== this.name) || this.condition.evaluate(e.globals, e.feature, e.featureState, e.canonical);
            }
            getCondition() {
                return this.condition;
            }
            getName() {
                return this.name;
            }
            getProperty(e) {
                return this.properties.get(e);
            }
            getUnevaluatedProperties() {
                return this.unevaluatedLayout;
            }
            getUnevaluatedProperty(e) {
                return this.unevaluatedLayout._values[e];
            }
            recalculate(e, t1, r) {
                this.unevaluatedLayout && (this.properties = this.unevaluatedLayout.possiblyEvaluate(e, void 0, t1, r));
            }
            serialize() {
                const e = {};
                return e.condition = this.condition.expression.serialize(), this.name && (e.name = this.name), this.unevaluatedLayout && (e.properties = this.unevaluatedLayout.serialize()), e;
            }
            hasIconProperties() {
                const e = this.hasProperty("icon-image"), t1 = this.hasProperty("icon-size"), r = this.hasProperty("icon-offset"), n = this.hasProperty("icon-rotate");
                return e || t1 || r || n;
            }
            hasTextProperties() {
                const e = this.hasProperty("text-size"), t1 = this.hasProperty("text-offset"), r = this.hasProperty("text-rotate");
                return e || t1 || r;
            }
            hasProperty(e) {
                return void 0 !== this.getUnevaluatedProperty(e).value;
            }
        }
        const Ta = "-transition", ka = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class Va extends rr {
            constructor(e, t1, r, n, i, s){
                if (super(), this.id = e.id, this.fqid = Sa(this.id, r), this.type = e.type, this.scope = r, this.lut = n, this.options = i, this.iconImageUseTheme = s, this.appearances = new Array, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.expressionDependencies = {
                    isIndoorDependent: !1,
                    configDependencies: new Set
                }, "custom" !== e.type) {
                    if (this.metadata = e.metadata, this.minzoom = e.minzoom, this.maxzoom = e.maxzoom, e.type && "background" !== e.type && "sky" !== e.type && "slot" !== e.type) {
                        this.source = e.source, this.sourceLayer = e["source-layer"], this.filter = e.filter;
                        const t1 = Us(this.filter, ua[`filter_${e.type}`]);
                        "error" !== t1.result && (this.expressionDependencies.configDependencies = new Set([
                            ...this.expressionDependencies.configDependencies,
                            ...t1.value.configDependencies
                        ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || t1.value.isIndoorDependent);
                    }
                    if (e.slot && (this.slot = e.slot), e.appearances && this.setAppearances(e.appearances), t1.layout && (this._unevaluatedLayout = new ra(t1.layout, this.scope, i, this.iconImageUseTheme), this.expressionDependencies.configDependencies = new Set([
                        ...this.expressionDependencies.configDependencies,
                        ...this._unevaluatedLayout.configDependencies
                    ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || this._unevaluatedLayout.isIndoorDependent()), t1.paint) {
                        this._transitionablePaint = new Qo(t1.paint, this.scope, i);
                        for(const t1 in e.paint)this.setPaintProperty(t1, e.paint[t1]);
                        for(const t1 in e.layout)this.setLayoutProperty(t1, e.layout[t1]);
                        this.expressionDependencies.configDependencies = new Set([
                            ...this.expressionDependencies.configDependencies,
                            ...this._transitionablePaint.configDependencies
                        ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || this._transitionablePaint.isIndoorDependent(), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new ia(t1.paint);
                    }
                }
            }
            onAdd(e) {}
            onRemove(e) {}
            isDraped(e) {
                return !this.is3D(!0) && ka.has(this.type);
            }
            getLayoutProperty(e) {
                return "visibility" === e ? this.visibility : this._unevaluatedLayout.getValue(e);
            }
            setLayoutProperty(e, t1) {
                if ("custom" === this.type && "visibility" === e) return void (this.visibility = t1);
                const r = this._unevaluatedLayout;
                r._properties.properties[e] && (r.setValue(e, t1), this.expressionDependencies.configDependencies = new Set([
                    ...this.expressionDependencies.configDependencies,
                    ...r.configDependencies
                ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || r.isIndoorDependent(), "visibility" === e && this.possiblyEvaluateVisibility());
            }
            setAppearances(e) {
                this.appearances = [], e.forEach((e)=>{
                    this.appearances.push(new Ba(e.condition, e.name, e.properties, this.scope, this.options, this.iconImageUseTheme));
                });
            }
            possiblyEvaluateVisibility() {
                this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getPaintProperty(e) {
                return e.endsWith(Ta) ? this._transitionablePaint.getTransition(e.slice(0, -11)) : this._transitionablePaint.getValue(e);
            }
            isPaintProperty(e) {
                return !!this._transitionablePaint._properties.properties[e];
            }
            setPaintProperty(e, t1) {
                const r = this._transitionablePaint, n = r._properties.properties;
                if (e.endsWith(Ta)) {
                    const i = e.slice(0, -11);
                    return n[i] && r.setTransition(i, t1 || void 0), !1;
                }
                if (!n[e]) return !1;
                const i = r._values[e], s = i.value.isDataDriven(), o = i.value;
                r.setValue(e, t1), this.expressionDependencies.configDependencies = new Set([
                    ...this.expressionDependencies.configDependencies,
                    ...r.configDependencies
                ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || r.isIndoorDependent(), this._handleSpecialPaintPropertyUpdate(e);
                const a = r._values[e].value, l = a.isDataDriven(), u = e.endsWith("pattern") || "line-dasharray" === e;
                return l || s || u || this._handleOverridablePaintPropertyUpdate(e, o, a);
            }
            _handleSpecialPaintPropertyUpdate(e) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e, t1, r) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e, t1, r) {
                return !1;
            }
            isHidden(e) {
                return !!(this.minzoom && e < this.minzoom) || !!(this.maxzoom && e >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e, t1) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e, void 0, t1, this.iconImageUseTheme)), this.paint = this._transitioningPaint.possiblyEvaluate(e, void 0, t1);
            }
            serialize() {
                const e = {
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return 0 !== this.appearances.length && (e.appearances = this.appearances.map((e)=>e.serialize())), $e(e, (e, t1)=>!(void 0 === e || "layout" === t1 && !Object.keys(e).length || "paint" === t1 && !Object.keys(e).length));
            }
            is3D(e) {
                return !1;
            }
            hasElevation() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            _clear() {}
            isStateDependent() {
                for(const e in this.paint._values){
                    const t1 = this.paint.get(e);
                    if (t1 instanceof na && Ss(t1.property.specification) && ("source" === t1.value.kind || "composite" === t1.value.kind) && t1.value.isStateDependent) return !0;
                }
                for (const e of this.appearances)if (!yi(e.condition.expression)) return !0;
                return !1;
            }
            compileFilter(e) {
                this._filterCompiled || (this._featureFilter = da(this.filter, this.scope, e), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            dynamicFilterNeedsGeometry() {
                return this._featureFilter.needGeometry;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(e) {
                this._stats && ("shadow" === e.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            getAppearances() {
                return this.appearances;
            }
            queryRenderedFeatures(e, t1, r) {
                return {};
            }
            queryRadius(e) {}
            queryIntersectsFeature(e, t1, r, n, i, s, o, a, l, u) {}
        }
        const Ea = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Fa {
            constructor(e, t1){
                this._structArray = e, this._pos1 = t1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        const Da = new ArrayBuffer(0);
        class Ca {
            constructor(){
                this._reallocCount = 0, this.capacity = 0, this.length = 0;
            }
            static serialize(e, t1) {
                return e._trim(), t1 && e.arrayBuffer && t1.add(e.arrayBuffer), {
                    length: e.length,
                    arrayBuffer: e.arrayBuffer
                };
            }
            static deserialize(e) {
                const t1 = Object.create(this.prototype);
                return t1.arrayBuffer = e.arrayBuffer, t1.length = e.length, e.arrayBuffer ? t1.capacity = e.arrayBuffer.byteLength / t1.bytesPerElement : (t1.capacity = 0, t1.arrayBuffer = Da), t1._refreshViews(), t1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e) {
                this.reserve(e), this.length = e;
            }
            reserve(e) {
                if (e > this.capacity) {
                    this._reallocCount++, this.capacity = Math.max(e, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const t1 = this.uint8;
                    this._refreshViews(), t1 && this.uint8.set(t1);
                }
            }
            reserveForAdditional(e) {
                this.reserve(this.length + e);
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...e) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...e) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function Ra(e, t1 = 1) {
            let r = 0, n = 0;
            return {
                members: e.map((e)=>{
                    const i = Ea[e.type].BYTES_PER_ELEMENT, s = r = La(r, Math.max(t1, i)), o = e.components || 1;
                    return n = Math.max(n, i), r += i * o, {
                        name: e.name,
                        type: e.type,
                        components: o,
                        offset: s
                    };
                }),
                size: La(r, Math.max(n, t1)),
                alignment: t1
            };
        }
        function La(e, t1) {
            return Math.ceil(e / t1) * t1;
        }
        class Oa extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e, t1);
            }
            emplace(e, t1, r) {
                const n = 2 * e;
                return this.int16[n + 0] = t1, this.int16[n + 1] = r, e;
            }
        }
        Oa.prototype.bytesPerElement = 4, Js(Oa, "StructArrayLayout2i4");
        class Ua extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e, t1, r);
            }
            emplace(e, t1, r, n) {
                const i = 3 * e;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.int16[i + 2] = n, e;
            }
        }
        Ua.prototype.bytesPerElement = 6, Js(Ua, "StructArrayLayout3i6");
        class Na extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e, t1, r, n);
            }
            emplace(e, t1, r, n, i) {
                const s = 4 * e;
                return this.int16[s + 0] = t1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, e;
            }
        }
        Na.prototype.bytesPerElement = 8, Js(Na, "StructArrayLayout4i8");
        class ja extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e);
            }
            emplace(e, t1) {
                return this.float32[1 * e + 0] = t1, e;
            }
        }
        ja.prototype.bytesPerElement = 4, Js(ja, "StructArrayLayout1f4");
        class Ga extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e, t1, r);
            }
            emplace(e, t1, r, n) {
                const i = 4 * e, s = 2 * e;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.float32[s + 1] = n, e;
            }
        }
        Ga.prototype.bytesPerElement = 8, Js(Ga, "StructArrayLayout2i1f8");
        class $a extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e, t1, r);
            }
            emplace(e, t1, r, n) {
                const i = 4 * e;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.int16[i + 2] = n, e;
            }
        }
        $a.prototype.bytesPerElement = 8, Js($a, "StructArrayLayout3i8");
        class qa extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e, t1, r, n, i);
            }
            emplace(e, t1, r, n, i, s) {
                const o = 5 * e;
                return this.int16[o + 0] = t1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, e;
            }
        }
        qa.prototype.bytesPerElement = 10, Js(qa, "StructArrayLayout5i10");
        class Xa extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e, t1, r, n, i, s, o);
            }
            emplace(e, t1, r, n, i, s, o, a) {
                const l = 6 * e, u = 12 * e, c = 3 * e;
                return this.int16[l + 0] = t1, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = o, this.float32[c + 2] = a, e;
            }
        }
        Xa.prototype.bytesPerElement = 12, Js(Xa, "StructArrayLayout2i4ub1f12");
        class Ha extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e, t1, r);
            }
            emplace(e, t1, r, n) {
                const i = 3 * e;
                return this.float32[i + 0] = t1, this.float32[i + 1] = r, this.float32[i + 2] = n, e;
            }
        }
        Ha.prototype.bytesPerElement = 12, Js(Ha, "StructArrayLayout3f12");
        class Za extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e, t1, r, n, i);
            }
            emplace(e, t1, r, n, i, s) {
                const o = 6 * e, a = 3 * e;
                return this.uint16[o + 0] = t1, this.uint16[o + 1] = r, this.uint16[o + 2] = n, this.uint16[o + 3] = i, this.float32[a + 2] = s, e;
            }
        }
        Za.prototype.bytesPerElement = 12, Js(Za, "StructArrayLayout4ui1f12");
        class Wa extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e, t1, r, n);
            }
            emplace(e, t1, r, n, i) {
                const s = 4 * e;
                return this.uint16[s + 0] = t1, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, e;
            }
        }
        Wa.prototype.bytesPerElement = 8, Js(Wa, "StructArrayLayout4ui8");
        class Ya extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e, t1, r, n, i, s);
            }
            emplace(e, t1, r, n, i, s, o) {
                const a = 6 * e;
                return this.int16[a + 0] = t1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, this.int16[a + 5] = o, e;
            }
        }
        Ya.prototype.bytesPerElement = 12, Js(Ya, "StructArrayLayout6i12");
        class Ja extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, e, t1, r, n, i, s, o, a, l, u, c, h);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h, p) {
                const d = 12 * e;
                return this.int16[d + 0] = t1, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.uint16[d + 4] = s, this.uint16[d + 5] = o, this.uint16[d + 6] = a, this.uint16[d + 7] = l, this.int16[d + 8] = u, this.int16[d + 9] = c, this.int16[d + 10] = h, this.int16[d + 11] = p, e;
            }
        }
        Ja.prototype.bytesPerElement = 24, Js(Ja, "StructArrayLayout4i4ui4i24");
        class Ka extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e, t1, r, n, i, s);
            }
            emplace(e, t1, r, n, i, s, o) {
                const a = 10 * e, l = 5 * e;
                return this.int16[a + 0] = t1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = o, e;
            }
        }
        Ka.prototype.bytesPerElement = 20, Js(Ka, "StructArrayLayout3i3f20");
        class Qa extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e, t1, r, n);
            }
            emplace(e, t1, r, n, i) {
                const s = 4 * e;
                return this.float32[s + 0] = t1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, e;
            }
        }
        Qa.prototype.bytesPerElement = 16, Js(Qa, "StructArrayLayout4f16");
        class el extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e);
            }
            emplace(e, t1) {
                return this.uint32[1 * e + 0] = t1, e;
            }
        }
        el.prototype.bytesPerElement = 4, Js(el, "StructArrayLayout1ul4");
        class tl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e, t1);
            }
            emplace(e, t1, r) {
                const n = 2 * e;
                return this.uint16[n + 0] = t1, this.uint16[n + 1] = r, e;
            }
        }
        tl.prototype.bytesPerElement = 4, Js(tl, "StructArrayLayout2ui4");
        class rl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c, h, p) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e, t1, r, n, i, s, o, a, l, u, c, h, p);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h, p, d) {
                const f = 20 * e, m = 10 * e;
                return this.int16[f + 0] = t1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.int16[f + 4] = s, this.float32[m + 3] = o, this.float32[m + 4] = a, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[f + 14] = c, this.uint32[m + 8] = h, this.uint16[f + 18] = p, this.uint16[f + 19] = d, e;
            }
        }
        rl.prototype.bytesPerElement = 40, Js(rl, "StructArrayLayout5i4f1i1ul2ui40");
        class nl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e, t1, r, n, i, s, o);
            }
            emplace(e, t1, r, n, i, s, o, a) {
                const l = 8 * e;
                return this.int16[l + 0] = t1, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = o, this.int16[l + 7] = a, e;
            }
        }
        nl.prototype.bytesPerElement = 16, Js(nl, "StructArrayLayout3i2i2i16");
        class il extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e, t1, r, n, i);
            }
            emplace(e, t1, r, n, i, s) {
                const o = 4 * e, a = 8 * e;
                return this.float32[o + 0] = t1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.int16[a + 6] = i, this.int16[a + 7] = s, e;
            }
        }
        il.prototype.bytesPerElement = 16, Js(il, "StructArrayLayout2f1f2i16");
        class sl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e, t1, r, n, i, s);
            }
            emplace(e, t1, r, n, i, s, o) {
                const a = 20 * e, l = 5 * e;
                return this.uint8[a + 0] = t1, this.uint8[a + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = o, e;
            }
        }
        sl.prototype.bytesPerElement = 20, Js(sl, "StructArrayLayout2ub4f20");
        class ol extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e, t1, r);
            }
            emplace(e, t1, r, n) {
                const i = 3 * e;
                return this.uint16[i + 0] = t1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, e;
            }
        }
        ol.prototype.bytesPerElement = 6, Js(ol, "StructArrayLayout3ui6");
        class al extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b) {
                const w = this.length;
                return this.resize(w + 1), this.emplace(w, e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w) {
                const _ = 30 * e, A = 15 * e, M = 60 * e;
                return this.int16[_ + 0] = t1, this.int16[_ + 1] = r, this.int16[_ + 2] = n, this.float32[A + 2] = i, this.float32[A + 3] = s, this.uint16[_ + 8] = o, this.uint16[_ + 9] = a, this.uint32[A + 5] = l, this.uint32[A + 6] = u, this.uint32[A + 7] = c, this.uint16[_ + 16] = h, this.uint16[_ + 17] = p, this.uint16[_ + 18] = d, this.float32[A + 10] = f, this.float32[A + 11] = m, this.uint8[M + 48] = y, this.uint8[M + 49] = g, this.uint8[M + 50] = x, this.uint32[A + 13] = v, this.int16[_ + 28] = b, this.uint8[M + 58] = w, e;
            }
        }
        al.prototype.bytesPerElement = 60, Js(al, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class ll extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A, M, I, S, z, P, B, T, k, V) {
                const E = this.length;
                return this.resize(E + 1), this.emplace(E, e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A, M, I, S, z, P, B, T, k, V);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A, M, I, S, z, P, B, T, k, V, E) {
                const F = 20 * e, D = 40 * e, C = 80 * e;
                return this.float32[F + 0] = t1, this.float32[F + 1] = r, this.int16[D + 4] = n, this.int16[D + 5] = i, this.int16[D + 6] = s, this.int16[D + 7] = o, this.int16[D + 8] = a, this.int16[D + 9] = l, this.int16[D + 10] = u, this.int16[D + 11] = c, this.int16[D + 12] = h, this.uint16[D + 13] = p, this.uint16[D + 14] = d, this.uint16[D + 15] = f, this.uint16[D + 16] = m, this.uint16[D + 17] = y, this.uint16[D + 18] = g, this.uint16[D + 19] = x, this.uint16[D + 20] = v, this.uint16[D + 21] = b, this.uint16[D + 22] = w, this.uint16[D + 23] = _, this.uint16[D + 24] = A, this.uint16[D + 25] = M, this.uint16[D + 26] = I, this.uint16[D + 27] = S, this.uint32[F + 14] = z, this.float32[F + 15] = P, this.float32[F + 16] = B, this.float32[F + 17] = T, this.float32[F + 18] = k, this.uint8[C + 76] = V, this.uint16[D + 39] = E, e;
            }
        }
        ll.prototype.bytesPerElement = 80, Js(ll, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
        class ul extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e, t1, r, n, i, s);
            }
            emplace(e, t1, r, n, i, s, o) {
                const a = 6 * e;
                return this.float32[a + 0] = t1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, this.float32[a + 5] = o, e;
            }
        }
        ul.prototype.bytesPerElement = 24, Js(ul, "StructArrayLayout6f24");
        class cl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e, t1, r, n, i);
            }
            emplace(e, t1, r, n, i, s) {
                const o = 5 * e;
                return this.float32[o + 0] = t1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.float32[o + 3] = i, this.float32[o + 4] = s, e;
            }
        }
        cl.prototype.bytesPerElement = 20, Js(cl, "StructArrayLayout5f20");
        class hl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e, t1, r, n, i, s, o);
            }
            emplace(e, t1, r, n, i, s, o, a) {
                const l = 7 * e;
                return this.float32[l + 0] = t1, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = s, this.float32[l + 5] = o, this.float32[l + 6] = a, e;
            }
        }
        hl.prototype.bytesPerElement = 28, Js(hl, "StructArrayLayout7f28");
        class pl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, e, t1, r, n, i, s, o, a, l, u, c);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h) {
                const p = 11 * e;
                return this.float32[p + 0] = t1, this.float32[p + 1] = r, this.float32[p + 2] = n, this.float32[p + 3] = i, this.float32[p + 4] = s, this.float32[p + 5] = o, this.float32[p + 6] = a, this.float32[p + 7] = l, this.float32[p + 8] = u, this.float32[p + 9] = c, this.float32[p + 10] = h, e;
            }
        }
        pl.prototype.bytesPerElement = 44, Js(pl, "StructArrayLayout11f44");
        class dl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, e, t1, r, n, i, s, o, a, l);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u) {
                const c = 9 * e;
                return this.float32[c + 0] = t1, this.float32[c + 1] = r, this.float32[c + 2] = n, this.float32[c + 3] = i, this.float32[c + 4] = s, this.float32[c + 5] = o, this.float32[c + 6] = a, this.float32[c + 7] = l, this.float32[c + 8] = u, e;
            }
        }
        dl.prototype.bytesPerElement = 36, Js(dl, "StructArrayLayout9f36");
        class fl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e, t1);
            }
            emplace(e, t1, r) {
                const n = 2 * e;
                return this.float32[n + 0] = t1, this.float32[n + 1] = r, e;
            }
        }
        fl.prototype.bytesPerElement = 8, Js(fl, "StructArrayLayout2f8");
        class ml extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e, t1, r, n);
            }
            emplace(e, t1, r, n, i) {
                const s = 6 * e;
                return this.uint32[3 * e + 0] = t1, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, e;
            }
        }
        ml.prototype.bytesPerElement = 12, Js(ml, "StructArrayLayout1ul3ui12");
        class yl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e);
            }
            emplace(e, t1) {
                return this.uint16[1 * e + 0] = t1, e;
            }
        }
        yl.prototype.bytesPerElement = 2, Js(yl, "StructArrayLayout1ui2");
        class gl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m) {
                const y = this.length;
                return this.resize(y + 1), this.emplace(y, e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m);
            }
            emplace(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y) {
                const g = 16 * e;
                return this.float32[g + 0] = t1, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = s, this.float32[g + 5] = o, this.float32[g + 6] = a, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = p, this.float32[g + 12] = d, this.float32[g + 13] = f, this.float32[g + 14] = m, this.float32[g + 15] = y, e;
            }
        }
        gl.prototype.bytesPerElement = 64, Js(gl, "StructArrayLayout16f64");
        class xl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e, t1, r, n, i, s, o) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e, t1, r, n, i, s, o);
            }
            emplace(e, t1, r, n, i, s, o, a) {
                const l = 10 * e, u = 5 * e;
                return this.uint16[l + 0] = t1, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = s, this.float32[u + 3] = o, this.float32[u + 4] = a, e;
            }
        }
        xl.prototype.bytesPerElement = 20, Js(xl, "StructArrayLayout4ui3f20");
        class vl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e);
            }
            emplace(e, t1) {
                return this.int16[1 * e + 0] = t1, e;
            }
        }
        vl.prototype.bytesPerElement = 2, Js(vl, "StructArrayLayout1i2");
        class bl extends Ca {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e);
            }
            emplace(e, t1) {
                return this.uint8[1 * e + 0] = t1, e;
            }
        }
        bl.prototype.bytesPerElement = 1, Js(bl, "StructArrayLayout1ub1");
        class wl extends Fa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        wl.prototype.size = 40;
        class _l extends rl {
            get(e) {
                return new wl(this, e);
            }
        }
        Js(_l, "CollisionBoxArray");
        class Al extends Fa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e) {
                this._structArray.uint8[this._pos1 + 49] = e;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e) {
                this._structArray.uint8[this._pos1 + 50] = e;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e) {
                this._structArray.uint32[this._pos4 + 13] = e;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e) {
                this._structArray.uint8[this._pos1 + 58] = e;
            }
        }
        Al.prototype.size = 60;
        class Ml extends al {
            get(e) {
                return new Al(this, e);
            }
        }
        Js(Ml, "PlacedSymbolArray");
        class Il extends Fa {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e) {
                this._structArray.uint32[this._pos4 + 14] = e;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e) {
                this._structArray.float32[this._pos4 + 18] = e;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
                return this._structArray.uint16[this._pos2 + 39];
            }
        }
        Il.prototype.size = 80;
        class Sl extends ll {
            get(e) {
                return new Il(this, e);
            }
        }
        Js(Sl, "SymbolInstanceArray");
        class zl extends ja {
            getoffsetX(e) {
                return this.float32[1 * e + 0];
            }
        }
        Js(zl, "GlyphOffsetArray");
        class Pl extends Oa {
            getx(e) {
                return this.int16[2 * e + 0];
            }
            gety(e) {
                return this.int16[2 * e + 1];
            }
        }
        Js(Pl, "SymbolLineVertexArray");
        class Bl extends Fa {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Bl.prototype.size = 12;
        class Tl extends ml {
            get(e) {
                return new Bl(this, e);
            }
        }
        Js(Tl, "FeatureIndexArray");
        class kl extends tl {
            geta_centroid_pos0(e) {
                return this.uint16[2 * e + 0];
            }
            geta_centroid_pos1(e) {
                return this.uint16[2 * e + 1];
            }
        }
        Js(kl, "FillExtrusionCentroidArray");
        class Vl extends Fa {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        Vl.prototype.size = 6;
        class El extends Ua {
            get(e) {
                return new Vl(this, e);
            }
        }
        Js(El, "FillExtrusionWallArray");
        const Fl = Ra([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Dl = Ra([
            {
                name: "a_circle_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Cl = Ra([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class Rl {
            constructor(e = []){
                this.segments = e;
            }
            _prepareSegment(e, t1, r, n) {
                let i = this.segments[this.segments.length - 1];
                return e > Rl.MAX_VERTEX_ARRAY_LENGTH && Ze(`Max vertices per segment is ${Rl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e}`), (!i || i.vertexLength + e > Rl.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: t1,
                    primitiveOffset: r,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            prepareSegment(e, t1, r, n) {
                return this._prepareSegment(e, t1.length, r.length, n);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e of this.segments)for(const t1 in e.vaos)e.vaos[t1].destroy();
            }
            static simpleSegment(e, t1, r, n) {
                return new Rl([
                    {
                        vertexOffset: e,
                        primitiveOffset: t1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Ll(e, t1) {
            return 256 * (e = De(Math.floor(e), 0, 255)) + De(Math.floor(t1), 0, 255);
        }
        Rl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Js(Rl, "SegmentVector");
        const Ol = Ra([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), Ul = Ra([
            {
                name: "a_pattern_b",
                components: 4,
                type: "Uint16"
            }
        ]), Nl = Ra([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class jl {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(e, t1, r, n) {
                this.ids.push(Gl(e)), this.positions.push(t1, r, n);
            }
            eachPosition(e, t1) {
                const r = Gl(e);
                let n = 0, i = this.ids.length - 1;
                for(; n < i;){
                    const e = n + i >> 1;
                    this.ids[e] >= r ? i = e : n = e + 1;
                }
                for(; this.ids[n] === r;)t1(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(e, t1) {
                const r = new Float64Array(e.ids), n = new Uint32Array(e.positions);
                return $l(r, n, 0, r.length - 1), t1 && (t1.add(r.buffer), t1.add(n.buffer)), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(e) {
                const t1 = new jl;
                let r;
                t1.ids = e.ids, t1.positions = e.positions;
                for (const e of t1.ids)e !== r && t1.uniqueIds.push(e), r = e;
                return t1.indexed = !0, t1;
            }
        }
        function Gl(e) {
            const t1 = +e;
            return Number.isSafeInteger(t1) ? t1 : Jt(String(e));
        }
        function $l(e, t1, r, n) {
            for(; r < n;){
                const i = e[r + n >> 1];
                let s = r - 1, o = n + 1;
                for(;;){
                    do s++;
                    while (e[s] < i);
                    do o--;
                    while (e[o] > i);
                    if (s >= o) break;
                    ql(e, s, o), ql(t1, 3 * s, 3 * o), ql(t1, 3 * s + 1, 3 * o + 1), ql(t1, 3 * s + 2, 3 * o + 2);
                }
                o - r < n - o ? ($l(e, t1, r, o), r = o + 1) : ($l(e, t1, o + 1, n), n = o);
            }
        }
        function ql(e, t1, r) {
            const n = e[t1];
            e[t1] = e[r], e[r] = n;
        }
        Js(jl, "FeaturePositionMap");
        class Xl {
            constructor(e){
                this.gl = e.gl, this.initialized = !1;
            }
            fetchUniformLocation(e, t1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e, t1), this.initialized = !0), !!this.location;
            }
            set(e, t1, r) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class Hl extends Xl {
            constructor(e){
                super(e), this.current = 0;
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
        }
        class Zl extends Xl {
            constructor(e){
                super(e), this.current = 0;
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
        }
        class Wl extends Xl {
            constructor(e){
                super(e), this.current = [
                    0,
                    0
                ];
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
        }
        class Yl extends Xl {
            constructor(e){
                super(e), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
        }
        class Jl extends Xl {
            constructor(e){
                super(e), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class Kl extends Xl {
            constructor(e){
                super(e), this.current = ar.transparent.toPremultipliedRenderColor(null);
            }
            set(e, t1, r) {
                this.fetchUniformLocation(e, t1) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
        }
        const Ql = new Float32Array(16);
        class eu extends Xl {
            constructor(e){
                super(e), this.current = Ql;
            }
            set(e, t1, r) {
                if (this.fetchUniformLocation(e, t1)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let e = 1; e < 16; e++)if (r[e] !== this.current[e]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        const tu = new Float32Array(9), ru = new Float32Array(4);
        class nu extends Xl {
            constructor(e){
                super(e), this.current = ru;
            }
            set(e, t1, r) {
                if (this.fetchUniformLocation(e, t1)) {
                    for(let e = 0; e < 4; e++)if (r[e] !== this.current[e]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        function iu(e) {
            return [
                Ll(255 * e.r, 255 * e.g),
                Ll(255 * e.b, 255 * e.a)
            ];
        }
        function su(e, t1, r, n, i, s, o, a) {
            return !!e && ("composite" === e.kind || "source" === e.kind ? "none" === e.evaluate(new Yo(0, {
                brightness: s,
                worldview: a
            }), t1, r, i, n, o) : "none" === e.value);
        }
        class ou {
            constructor(e, t1, r, n){
                this.value = e, this.uniformNames = t1.map((e)=>`u_${e}`), this.type = r, this.context = n;
            }
            setUniform(e, t1, r, n, i) {
                const s = n.constantOr(this.value);
                t1.set(e, i, s instanceof ar ? s.toPremultipliedRenderColor(this.lutExpression && "constant" === this.lutExpression.kind && "none" === this.lutExpression.value ? null : this.context.lut) : s);
            }
            getBinding(e, t1) {
                return "color" === this.type ? new Kl(e) : new Zl(e);
            }
        }
        class au {
            constructor(e, t1){
                this.uniformNames = t1.map((e)=>`u_${e}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(e, t1) {
                this.pixelRatio = e.pixelRatio || 1, this.pattern = e.tl.concat(e.br), this.patternTransition = t1 ? t1.tl.concat(t1.br) : this.pattern;
            }
            setUniform(e, t1, r, n, i) {
                let s = null;
                "u_pattern" !== i && "u_dash" !== i || (s = this.pattern), "u_pattern_b" === i && (s = this.patternTransition), "u_pixel_ratio" === i && (s = this.pixelRatio), s && t1.set(e, i, s);
            }
            getBinding(e, t1) {
                return "u_pattern" === t1 || "u_pattern_b" === t1 || "u_dash" === t1 ? new Jl(e) : new Zl(e);
            }
        }
        class lu {
            constructor(e, t1, r, n){
                this.expression = e, this.type = r, this.maxValue = 0, this.paintVertexAttributes = t1.map((e)=>({
                        name: `a_${e}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(e, t1, r, n, i, s, o, a) {
                const l = this.paintVertexArray.length, u = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new Yo(0, {
                    brightness: s,
                    worldview: a
                }), t1, {}, i, n, o) : "constant" === this.expression.kind && this.expression.value, c = su(this.lutExpression, t1, {}, n, i, s, o, a);
                this.paintVertexArray.resize(e), this._setPaintValue(l, e, u, c ? null : this.context.lut);
            }
            updatePaintArray(e, t1, r, n, i, s, o, a) {
                const l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i) : "constant" === this.expression.kind && this.expression.value, u = su(this.lutExpression, r, n, i, void 0, o, void 0, a);
                this._setPaintValue(e, t1, l, u ? null : this.context.lut);
            }
            _setPaintValue(e, t1, r, n) {
                if ("color" === this.type) {
                    const i = iu(r.toPremultipliedRenderColor(n));
                    for(let r = e; r < t1; r++)this.paintVertexArray.emplace(r, i[0], i[1]);
                } else {
                    for(let n = e; n < t1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(e) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class uu {
            constructor(e, t1, r, n, i, s){
                this.expression = e, this.uniformNames = t1.map((e)=>`u_${e}_t`), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = t1.map((e)=>({
                        name: `a_${e}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(e, t1, r, n, i, s, o, a) {
                const l = this.expression.evaluate(new Yo(this.context.zoom, {
                    brightness: s,
                    worldview: a
                }), t1, {}, i, n, o), u = this.expression.evaluate(new Yo(this.context.zoom + 1, {
                    brightness: s,
                    worldview: a
                }), t1, {}, i, n, o), c = su(this.lutExpression, t1, {}, n, i, s, o, a), h = this.paintVertexArray.length;
                this.paintVertexArray.resize(e), this._setPaintValue(h, e, l, u, c ? null : this.context.lut);
            }
            updatePaintArray(e, t1, r, n, i, s, o, a) {
                const l = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i), u = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: o,
                    worldview: a
                }, r, n, void 0, i), c = su(this.lutExpression, r, n, i, void 0, o, void 0, a);
                this._setPaintValue(e, t1, l, u, c ? null : this.context.lut);
            }
            _setPaintValue(e, t1, r, n, i) {
                if ("color" === this.type) {
                    const s = iu(r.toPremultipliedRenderColor(i)), o = iu(n.toPremultipliedRenderColor(i));
                    for(let r = e; r < t1; r++)this.paintVertexArray.emplace(r, s[0], s[1], o[0], o[1]);
                } else {
                    for(let i = e; i < t1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(e) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e, t1, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, o = De(this.expression.interpolationFactor(s, this.context.zoom, this.context.zoom + 1), 0, 1);
                t1.set(e, i, o);
            }
            getBinding(e, t1) {
                return new Zl(e);
            }
        }
        class cu {
            constructor(e, t1, r, n, i){
                this.expression = e, this.layerId = i, this.paintVertexAttributes = ("array" === r ? Nl : Ol).members;
                for(let e = 0; e < t1.length; ++e);
                this.paintVertexArray = new n, this.paintTransitionVertexArray = new Wa;
            }
            populatePaintArray(e, t1, r, n) {
                const i = this.paintVertexArray.length;
                this.paintVertexArray.resize(e), this._setPaintValues(i, e, t1.patterns && t1.patterns[this.layerId], r);
            }
            updatePaintArray(e, t1, r, n, i, s, o) {
                this._setPaintValues(e, t1, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(e, t1, r, n) {
                if (!n || !r) return;
                const i = n[r[0]], s = n[r[1]];
                if (i) {
                    if (i) {
                        const { tl: r, br: n, pixelRatio: s } = i;
                        for(let i = e; i < t1; i++)this.paintVertexArray.emplace(i, r[0], r[1], n[0], n[1], s);
                    }
                    if (s) {
                        this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                        const { tl: r, br: n } = s;
                        for(let i = e; i < t1; i++)this.paintTransitionVertexArray.emplace(i, r[0], r[1], n[0], n[1]);
                    }
                }
            }
            upload(e) {
                const t1 = this.expression.isStateDependent || !this.expression.isLightConstant;
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, t1)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = e.createVertexBuffer(this.paintTransitionVertexArray, Ul.members, t1));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
        }
        class hu {
            constructor(e, t1, r = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = t1;
                const n = [];
                for(const i in e.paint._values){
                    const s = e.paint.get(i);
                    if (i.endsWith("-use-theme")) continue;
                    if (!r(i)) continue;
                    if (!(s instanceof na && Ss(s.property.specification))) continue;
                    const o = fu(i, e.type), a = s.value, l = s.property.specification.type, u = !!s.property.useIntegerZoom, c = "line-dasharray" === i || i.endsWith("pattern"), h = e.paint.get(`${i}-use-theme`), p = "line-dasharray" === i && "constant" !== e.layout.get("line-cap").value.kind || h && "constant" !== h.value.kind;
                    if ("constant" !== a.kind || p) {
                        if ("source" === a.kind || p || c) {
                            const t1 = gu(i, l, "source");
                            this.binders[i] = c ? new cu(a, o, l, t1, e.id) : new lu(a, o, l, t1), n.push(`/a_${i}`);
                        } else {
                            const e = gu(i, l, "composite");
                            this.binders[i] = new uu(a, o, l, u, t1, e), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = c ? new au(a.value, o) : new ou(a.value, o, l, t1), n.push(`/u_${i}`);
                    h && (this.binders[i].lutExpression = h.value);
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(e) {
                const t1 = this.binders[e];
                return t1 instanceof lu || t1 instanceof uu ? t1.maxValue : 0;
            }
            populatePaintArrays(e, t1, r, n, i, s, o, a) {
                for(const l in this.binders){
                    const u = this.binders[l];
                    u.context = this.context, (u instanceof lu || u instanceof uu || u instanceof cu) && u.populatePaintArray(e, t1, r, n, i, s, o, a);
                }
            }
            setConstantPatternPositions(e, t1) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof au && n.setConstantPatternPositions(e, t1);
                }
            }
            getPatternTransitionVertexBuffer(e) {
                const t1 = this.binders[e];
                return t1 instanceof cu ? t1.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(e, t1, r, n, i, s, o, a, l, u) {
                let c = !1;
                const h = Object.keys(e), p = 0 !== h.length && !a, d = p ? h : t1.uniqueIds;
                this.context.lut = i.lut;
                for(const a in this.binders){
                    const h = this.binders[a];
                    if (h.context = this.context, (h instanceof lu || h instanceof uu || h instanceof cu) && h.expression && h.expression.kind && "constant" !== h.expression.kind && (!0 === h.expression.isStateDependent || !1 === h.expression.isLightConstant)) {
                        const f = i.paint.get(a);
                        h.expression = f.value;
                        for (const r of d){
                            const i = e[r.toString()];
                            t1.eachPosition(r, (e, t1, r)=>{
                                const a = n.feature(e);
                                h.updatePaintArray(t1, r, a, i, s, o, l, u);
                            });
                        }
                        if (!p) for (const t1 of r.uniqueIds){
                            const i = e[t1.toString()];
                            r.eachPosition(t1, (e, t1, r)=>{
                                const a = n.feature(e);
                                h.updatePaintArray(t1, r, a, i, s, o, l, u);
                            });
                        }
                        c = !0;
                    }
                }
                return c;
            }
            defines() {
                const e = [];
                for(const t1 in this.binders){
                    const r = this.binders[t1];
                    (r instanceof ou || r instanceof au) && e.push(...r.uniformNames.map((e)=>`#define HAS_UNIFORM_${e}`));
                }
                return e;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e) {
                const t1 = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof ou || n instanceof au || n instanceof uu) for (const i of n.uniformNames)t1.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(e, i)
                    });
                }
                return t1;
            }
            setUniforms(e, t1, r, n, i) {
                for (const { name: t1, property: s, binding: o } of r)this.binders[s].setUniform(e, o, i, n.get(s), t1);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e in this.binders){
                    const t1 = this.binders[e];
                    (t1 instanceof lu || t1 instanceof uu || t1 instanceof cu) && t1.paintVertexBuffer && this._buffers.push(t1.paintVertexBuffer), t1 instanceof cu && t1.paintTransitionVertexBuffer && this._buffers.push(t1.paintTransitionVertexBuffer);
                }
            }
            upload(e) {
                for(const t1 in this.binders){
                    const r = this.binders[t1];
                    (r instanceof lu || r instanceof uu || r instanceof cu) && r.upload(e);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e in this.binders){
                    const t1 = this.binders[e];
                    (t1 instanceof lu || t1 instanceof uu || t1 instanceof cu) && t1.destroy();
                }
            }
        }
        class pu {
            constructor(e, t1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of e)this.programConfigurations[n.id] = new hu(n, t1, r);
                this.needsUpload = !1, this._featureMap = new jl, this._featureMapWithoutIds = new jl, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(e, t1, r, n, i, s, o, a, l) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(e, t1, n, i, s, o, a, l);
                void 0 !== t1.id ? this._featureMap.add(t1.id, r, this._bufferOffset, e) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, e), this._idlessCounter += 1), this._bufferOffset = e, this.needsUpload = !0;
            }
            updatePaintArrays(e, t1, r, n, i, s, o, a) {
                for (const l of r)this.needsUpload = this.programConfigurations[l.id].updatePaintArrays(e, this._featureMap, this._featureMapWithoutIds, t1, l, n, i, s, o || 0, a) || this.needsUpload;
            }
            get(e) {
                return this.programConfigurations[e];
            }
            upload(e) {
                if (this.needsUpload) {
                    for(const t1 in this.programConfigurations)this.programConfigurations[t1].upload(e);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e in this.programConfigurations)this.programConfigurations[e].destroy();
            }
        }
        const du = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "line-dasharray": [
                "dash"
            ],
            "fill-bridge-guard-rail-color": [
                "structure_color"
            ],
            "fill-tunnel-structure-color": [
                "structure_color"
            ]
        };
        function fu(e, t1) {
            return du[e] || [
                e.replace(`${t1}-`, "").replace(/-/g, "_")
            ];
        }
        const mu = {
            "line-pattern": {
                source: Za,
                composite: Za
            },
            "fill-pattern": {
                source: Za,
                composite: Za
            },
            "fill-extrusion-pattern": {
                source: Za,
                composite: Za
            },
            "line-dasharray": {
                source: Wa,
                composite: Wa
            }
        }, yu = {
            color: {
                source: fl,
                composite: Qa
            },
            number: {
                source: ja,
                composite: fl
            }
        };
        function gu(e, t1, r) {
            const n = mu[e];
            return n && n[r] || yu[t1][r];
        }
        Js(ou, "ConstantBinder"), Js(au, "PatternConstantBinder"), Js(lu, "SourceExpressionBinder"), Js(cu, "PatternCompositeBinder"), Js(uu, "CompositeExpressionBinder"), Js(hu, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Js(pu, "ProgramConfigurationSet");
        const xu = Un / Math.PI / 2, vu = 64, bu = [
            vu,
            32,
            16
        ], wu = -xu, _u = xu;
        function Au(e, t1, r, n = xu) {
            return r = Be(r), [
                e * Math.sin(r) * n,
                -t1 * n,
                e * Math.cos(r) * n
            ];
        }
        function Mu(e, t1, r) {
            return Au(Math.cos(Be(e)), Math.sin(Be(e)), t1, r);
        }
        const Iu = 6371008.8, Su = 2 * Math.PI * Iu;
        class zu {
            constructor(e, t1){
                if (isNaN(e) || isNaN(t1)) throw new Error(`Invalid LngLat object: (${e}, ${t1})`);
                if (this.lng = +e, this.lat = +t1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new zu(Re(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e) {
                const t1 = Math.PI / 180, r = this.lat * t1, n = e.lat * t1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((e.lng - this.lng) * t1);
                return Iu * Math.acos(Math.min(i, 1));
            }
            toBounds(e = 0) {
                const t1 = 360 * e / 40075017, r = t1 / Math.cos(Math.PI / 180 * this.lat);
                return new Pu({
                    lng: this.lng - r,
                    lat: this.lat - t1
                }, {
                    lng: this.lng + r,
                    lat: this.lat + t1
                });
            }
            toEcef(e) {
                return Mu(this.lat, this.lng, xu + e * xu / Iu);
            }
            static convert(e) {
                if (e instanceof zu) return e;
                if (Array.isArray(e) && (2 === e.length || 3 === e.length)) return new zu(Number(e[0]), Number(e[1]));
                if (!Array.isArray(e) && "object" == typeof e && null !== e) return new zu(Number("lng" in e ? e.lng : e.lon), Number(e.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class Pu {
            constructor(e, t1){
                e && (t1 ? this.setSouthWest(e).setNorthEast(t1) : Array.isArray(e) && 4 === e.length ? this.setSouthWest([
                    e[0],
                    e[1]
                ]).setNorthEast([
                    e[2],
                    e[3]
                ]) : this.setSouthWest(e[0]).setNorthEast(e[1]));
            }
            setNorthEast(e) {
                return this._ne = e instanceof zu ? new zu(e.lng, e.lat) : zu.convert(e), this;
            }
            setSouthWest(e) {
                return this._sw = e instanceof zu ? new zu(e.lng, e.lat) : zu.convert(e), this;
            }
            extend(e) {
                const t1 = this._sw, r = this._ne;
                let n, i;
                if (e instanceof zu) n = e, i = e;
                else {
                    if (!(e instanceof Pu)) return Array.isArray(e) ? 4 === e.length || e.every(Array.isArray) ? this.extend(Pu.convert(e)) : this.extend(zu.convert(e)) : "object" == typeof e && null !== e && e.hasOwnProperty("lat") && (e.hasOwnProperty("lon") || e.hasOwnProperty("lng")) ? this.extend(zu.convert(e)) : this;
                    if (n = e._sw, i = e._ne, !n || !i) return this;
                }
                return t1 || r ? (t1.lng = Math.min(n.lng, t1.lng), t1.lat = Math.min(n.lat, t1.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new zu(n.lng, n.lat), this._ne = new zu(i.lng, i.lat)), this;
            }
            getCenter() {
                return new zu((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new zu(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new zu(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e) {
                const { lng: t1, lat: r } = zu.convert(e);
                let n = this._sw.lng <= t1 && t1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= t1 && t1 >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(e) {
                if (e) return e instanceof Pu ? e : new Pu(e);
            }
        }
        function Bu(e) {
            return Su * Math.cos(e * Math.PI / 180);
        }
        function Tu(e) {
            return (180 + e) / 360;
        }
        function ku(e) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e * Math.PI / 360))) / 360;
        }
        function Vu(e, t1) {
            return e / Bu(t1);
        }
        function Eu(e) {
            return 360 * e - 180;
        }
        function Fu(e) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e) * Math.PI / 180)) - 90;
        }
        function Du(e, t1) {
            return e * Bu(Fu(t1));
        }
        const Cu = 85.051129;
        function Ru(e) {
            return Math.cos(Be(De(e, -85.051129, Cu)));
        }
        function Lu(e, t1) {
            const r = De(t1, 0, 25.5), n = Math.pow(2, r);
            return Ru(e) * Su / (512 * n);
        }
        function Ou(e) {
            return 1 / Math.cos(e * Math.PI / 180);
        }
        function Uu(e, t1 = 0) {
            const r = Math.exp(Math.PI * (1 - (e.y + t1 / Un) / (1 << e.z) * 2));
            return 80150034 * r / (r * r + 1) / Un / (1 << e.z);
        }
        class Nu {
            constructor(e, t1, r = 0){
                this.x = +e, this.y = +t1, this.z = +r;
            }
            static fromLngLat(e, t1 = 0) {
                const r = zu.convert(e);
                return new Nu(Tu(r.lng), ku(r.lat), Vu(t1, r.lat));
            }
            toLngLat() {
                return new zu(Eu(this.x), Fu(this.y));
            }
            toAltitude() {
                return Du(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / Su * Ou(Fu(this.y));
            }
        }
        function ju(e, t1, r, n, i, s, o, a, l) {
            const u = (t1 + n) / 2, c = (r + i) / 2, h = new Ie(u, c);
            a(h), function(e, t1, r, n, i, s) {
                const o = r - i, a = n - s;
                return Math.abs((n - t1) * o - (r - e) * a) / Math.hypot(o, a);
            }(h.x, h.y, s.x, s.y, o.x, o.y) >= l ? (ju(e, t1, r, u, c, s, h, a, l), ju(e, u, c, n, i, h, o, a, l)) : e.push(o);
        }
        function Gu(e, t1, r) {
            let n = e[0], i = n.x, s = n.y;
            t1(n);
            const o = [
                n
            ];
            for(let a = 1; a < e.length; a++){
                const l = e[a], { x: u, y: c } = l;
                t1(l), ju(o, i, s, u, c, n, l, t1, r), i = u, s = c, n = l;
            }
            return o;
        }
        function $u(e, t1, r, n) {
            if (n(t1, r)) {
                const i = t1.add(r)._mult(.5);
                $u(e, t1, i, n), $u(e, i, r, n);
            } else e.push(r);
        }
        function qu(e, t1) {
            let r = e[0];
            const n = [
                r
            ];
            for(let i = 1; i < e.length; i++){
                const s = e[i];
                $u(n, r, s, t1), r = s;
            }
            return n;
        }
        const Xu = Math.pow(2, 14) - 1, Hu = -Xu - 1;
        function Zu(e, t1) {
            const r = Math.round(e.x * t1), n = Math.round(e.y * t1);
            return e.x = De(r, Hu, Xu), e.y = De(n, Hu, Xu), (r < e.x || r > e.x + 1 || n < e.y || n > e.y + 1) && Ze("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e;
        }
        function Wu(e, t1, r) {
            const n = e.loadGeometry(), i = e.extent, s = Un / i;
            if (t1 && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << t1.z, { scale: o, x: a, y: l, projection: u } = r, c = (e)=>{
                    const r = Eu((t1.x + e.x / i) / s), n = Fu((t1.y + e.y / i) / s), c = u.project(r, n);
                    e.x = (c.x * o - a) * i, e.y = (c.y * o - l) * i;
                };
                for(let t1 = 0; t1 < n.length; t1++)if (1 !== e.type) n[t1] = Gu(n[t1], c, 1);
                else {
                    const e = [];
                    for (const r of n[t1])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), e.push(r));
                    n[t1] = e;
                }
            }
            for (const e of n)for (const t1 of e)Zu(t1, s);
            return n;
        }
        function Yu(e, t1) {
            return {
                type: e.type,
                id: e.id,
                properties: e.properties,
                geometry: t1 ? Wu(e) : []
            };
        }
        class Ju {
            constructor(e, t1, r, n, i){
                this.properties = {}, this.extent = r, this.type = 0, this.id = void 0, this._pbf = e, this._geometry = -1, this._keys = n, this._values = i, e.readFields(Ku, this, t1);
            }
            loadGeometry() {
                const e = this._pbf;
                e.pos = this._geometry;
                const t1 = e.readVarint() + e.pos, r = [];
                let n, i = 1, s = 0, o = 0, a = 0;
                for(; e.pos < t1;){
                    if (s <= 0) {
                        const t1 = e.readVarint();
                        i = 7 & t1, s = t1 >> 3;
                    }
                    if (s--, 1 === i || 2 === i) o += e.readSVarint(), a += e.readSVarint(), 1 === i && (n && r.push(n), n = []), n && n.push(new Ie(o, a));
                    else {
                        if (7 !== i) throw new Error(`unknown command ${i}`);
                        n && n.push(n[0].clone());
                    }
                }
                return n && r.push(n), r;
            }
            bbox() {
                const e = this._pbf;
                e.pos = this._geometry;
                const t1 = e.readVarint() + e.pos;
                let r = 1, n = 0, i = 0, s = 0, o = 1 / 0, a = -1 / 0, l = 1 / 0, u = -1 / 0;
                for(; e.pos < t1;){
                    if (n <= 0) {
                        const t1 = e.readVarint();
                        r = 7 & t1, n = t1 >> 3;
                    }
                    if (n--, 1 === r || 2 === r) i += e.readSVarint(), s += e.readSVarint(), i < o && (o = i), i > a && (a = i), s < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error(`unknown command ${r}`);
                }
                return [
                    o,
                    l,
                    a,
                    u
                ];
            }
            toGeoJSON(e, t1, r) {
                const n = this.extent * Math.pow(2, r), i = this.extent * e, s = this.extent * t1, o = this.loadGeometry();
                function a(e) {
                    return [
                        360 * (e.x + i) / n - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e.y + s) / n) * Math.PI)) - 90
                    ];
                }
                function l(e) {
                    return e.map(a);
                }
                let u;
                if (1 === this.type) {
                    const e = [];
                    for (const t1 of o)e.push(t1[0]);
                    const t1 = l(e);
                    u = 1 === e.length ? {
                        type: "Point",
                        coordinates: t1[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: t1
                    };
                } else if (2 === this.type) {
                    const e = o.map(l);
                    u = 1 === e.length ? {
                        type: "LineString",
                        coordinates: e[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const e = function(e) {
                            const t1 = e.length;
                            if (t1 <= 1) return [
                                e
                            ];
                            const r = [];
                            let n, i;
                            for(let s = 0; s < t1; s++){
                                const t1 = Qu(e[s]);
                                0 !== t1 && (void 0 === i && (i = t1 < 0), i === t1 < 0 ? (n && r.push(n), n = [
                                    e[s]
                                ]) : n && n.push(e[s]));
                            }
                            return n && r.push(n), r;
                        }(o), t1 = [];
                        for (const r of e)t1.push(r.map(l));
                        u = 1 === t1.length ? {
                            type: "Polygon",
                            coordinates: t1[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: t1
                        };
                    }
                }
                const c = {
                    type: "Feature",
                    geometry: u,
                    properties: this.properties
                };
                return null != this.id && (c.id = this.id), c;
            }
        }
        function Ku(e, t1, r) {
            1 === e ? t1.id = r.readVarint() : 2 === e ? function(e, t1) {
                const r = e.readVarint() + e.pos;
                for(; e.pos < r;){
                    const r = t1._keys[e.readVarint()], n = t1._values[e.readVarint()];
                    t1.properties[r] = n;
                }
            }(r, t1) : 3 === e ? t1.type = r.readVarint() : 4 === e && (t1._geometry = r.pos);
        }
        function Qu(e) {
            let t1 = 0;
            for(let r, n, i = 0, s = e.length, o = s - 1; i < s; o = i++)r = e[i], n = e[o], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        Ju.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class ec {
            constructor(e, t1){
                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e, this._keys = [], this._values = [], this._features = [], e.readFields(tc, this, t1), this.length = this._features.length;
            }
            feature(e) {
                if (e < 0 || e >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e];
                const t1 = this._pbf.readVarint() + this._pbf.pos;
                return new Ju(this._pbf, t1, this.extent, this._keys, this._values);
            }
        }
        function tc(e, t1, r) {
            15 === e ? t1.version = r.readVarint() : 1 === e ? t1.name = r.readString() : 5 === e ? t1.extent = r.readVarint() : 2 === e ? t1._features.push(r.pos) : 3 === e ? t1._keys.push(r.readString()) : 4 === e && t1._values.push(function(e) {
                let t1 = null;
                const r = e.readVarint() + e.pos;
                for(; e.pos < r;){
                    const r = e.readVarint() >> 3;
                    t1 = 1 === r ? e.readString() : 2 === r ? e.readFloat() : 3 === r ? e.readDouble() : 4 === r ? e.readVarint64() : 5 === r ? e.readVarint() : 6 === r ? e.readSVarint() : 7 === r ? e.readBoolean() : null;
                }
                if (null == t1) throw new Error("unknown feature value");
                return t1;
            }(r));
        }
        class rc {
            constructor(e, t1){
                this.layers = e.readFields(nc, {}, t1);
            }
        }
        function nc(e, t1, r) {
            if (3 === e) {
                const e = new ec(r, r.readVarint() + r.pos);
                e.length && (t1[e.name] = e);
            }
        }
        const ic = "3d_elevation_id", sc = "level";
        class oc {
            constructor(){
                this._valid = !1;
            }
            reset(e) {
                return this.feature = e, this._valid = !0, this._geometry = e.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(e, t1) {
                return this._valid && e(t1(this._geometry)), this;
            }
            require(e, t1, r) {
                return this.get(e, !0, t1, r);
            }
            optional(e, t1, r) {
                return this.get(e, !1, t1, r);
            }
            success() {
                return this._valid;
            }
            get(e, t1, r, n) {
                const i = this.feature.properties.hasOwnProperty(e) ? +this.feature.properties[e] : void 0;
                return this._valid && void 0 !== i && !Number.isNaN(i) ? r(n ? n(i) : i) : t1 && (this._valid = !1), this;
            }
        }
        class ac {
            constructor(e, t1){
                this.featureFunc = e, this.vertexFunc = t1;
            }
            parseFeature(e, t1, r) {
                return this.featureFunc(e, t1, r);
            }
            parseVertex(e, t1, r) {
                return this.vertexFunc(e, t1, r);
            }
        }
        const lc = new ac((e, t1, r)=>e.reset(t1).require(ic, (e)=>{
                r.id = e;
            }).optional("fixed_height_relative", (e)=>{
                r.constantHeight = e;
            }, cc.decodeRelativeHeight).geometry((e)=>{
                r.bounds = e;
            }, xn).success(), (e, t1, r)=>e.reset(t1).require(ic, (e)=>{
                r.id = e;
            }).require("elevation_idx", (e)=>{
                r.idx = e;
            }).require("extent", (e)=>{
                r.extent = e;
            }).require("height_relative", (e)=>{
                r.height = e;
            }, cc.decodeRelativeHeight).geometry((e)=>{
                r.position = e;
            }, cc.getPoint).success()), uc = new ac((e, t1, r)=>e.reset(t1).require(ic, (e)=>{
                r.id = e;
            }).optional("fixed_height", (e)=>{
                r.constantHeight = e;
            }, cc.decodeMetricHeight).geometry((e)=>{
                r.bounds = e;
            }, xn).success(), (e, t1, r)=>e.reset(t1).require(ic, (e)=>{
                r.id = e;
            }).require("elevation_idx", (e)=>{
                r.idx = e;
            }).require("extent", (e)=>{
                r.extent = e;
            }).require("height", (e)=>{
                r.height = e;
            }, cc.decodeMetricHeight).geometry((e)=>{
                r.position = e;
            }, cc.getPoint).success());
        class cc {
            static getPoint(e) {
                return he(e[0][0].x, e[0][0].y);
            }
            static decodeRelativeHeight(e) {
                return 1e-4 * e * 5;
            }
            static decodeMetricHeight(e) {
                return 1e-4 * e;
            }
            static getVersionSchema(e) {
                return e ? "1.0.1" === e ? uc : void 0 : lc;
            }
            static parse(e) {
                const t1 = [], r = [], n = e.length, i = new oc;
                for(let s = 0; s < n; s++){
                    const n = e.feature(s), o = n.properties.version, a = cc.getVersionSchema(o);
                    if (void 0 === a) {
                        Ze(`Unknown elevation feature version number ${o || "(unknown)"}`);
                        continue;
                    }
                    const l = n.properties.type;
                    if (!l) continue;
                    const u = Ju.types[n.type];
                    if ("Point" === u && "curve_point" === l) {
                        const e = {};
                        a.parseVertex(i, n, e) && t1.push(e);
                    } else if ("Polygon" === u && "curve_meta" === l) {
                        const e = {};
                        a.parseFeature(i, n, e) && r.push(e);
                    }
                }
                return {
                    vertices: t1,
                    features: r
                };
            }
        }
        class hc {
            constructor(e, t1){
                this.pos = e, this.dir = t1;
            }
            intersectsPlane(e, t1, r) {
                const n = xe(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((e[0] - this.pos[0]) * t1[0] + (e[1] - this.pos[1]) * t1[1]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, !0;
            }
        }
        class pc {
            constructor(e, t1){
                this.pos = e, this.dir = t1;
            }
            intersectsPlane(e, t1, r) {
                const n = O(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((e[0] - this.pos[0]) * t1[0] + (e[1] - this.pos[1]) * t1[1] + (e[2] - this.pos[2]) * t1[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(e, r, n) {
                if (function(e, r) {
                    var n = e[0], i = e[1], s = e[2], o = r[0], a = r[1], l = r[2];
                    return Math.abs(n - o) <= t1 * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - a) <= t1 * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(s - l) <= t1 * Math.max(1, Math.abs(s), Math.abs(l));
                }(this.pos, e) || 0 === r) return n[0] = n[1] = n[2] = 0, !1;
                const [i, s, o] = this.dir, a = this.pos[0] - e[0], l = this.pos[1] - e[1], u = this.pos[2] - e[2], c = i * i + s * s + o * o, h = 2 * (a * i + l * s + u * o), p = h * h - 4 * c * (a * a + l * l + u * u - r * r);
                if (p < 0) {
                    const e = Math.max(-h / 2, 0), t1 = a + i * e, c = l + s * e, p = u + o * e, d = Math.hypot(t1, c, p);
                    return n[0] = t1 * r / d, n[1] = c * r / d, n[2] = p * r / d, !1;
                }
                {
                    const e = (-h - Math.sqrt(p)) / (2 * c);
                    if (e < 0) {
                        const e = Math.hypot(a, l, u);
                        return n[0] = a * r / e, n[1] = l * r / e, n[2] = u * r / e, !1;
                    }
                    return n[0] = a + i * e, n[1] = l + s * e, n[2] = u + o * e, !0;
                }
            }
        }
        class dc {
            constructor(e, t1, r, n, i){
                this.TL = e, this.TR = t1, this.BR = r, this.BL = n, this.horizon = i;
            }
            static fromInvProjectionMatrix(e, t1, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], o = [
                    -1,
                    -1,
                    1
                ], a = j(n, n, e), l = j(i, i, e), u = j(s, s, e), c = j(o, o, e);
                return new dc(a, l, u, c, t1 / r);
            }
        }
        function fc(e, t1, r) {
            let n = 1 / 0, i = -1 / 0;
            const s = [];
            for (const o of e){
                H(s, o, t1);
                const e = O(s, r);
                n = Math.min(n, e), i = Math.max(i, e);
            }
            return [
                n,
                i
            ];
        }
        function mc(e, t1) {
            let r = !0;
            for(let n = 0; n < e.planes.length; n++){
                const i = e.planes[n];
                let s = 0;
                for(let e = 0; e < t1.length; e++)s += +(O(i, t1[e]) + i[3] >= 0);
                if (0 === s) return 0;
                s !== t1.length && (r = !1);
            }
            return r ? 2 : 1;
        }
        function yc(e, t1) {
            for (const r of e.projections){
                const n = fc(t1, e.points[0], r.axis);
                if (r.projection[1] < n[0] || r.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function gc(e, t1) {
            let r = 0;
            const n = [
                0,
                0,
                0,
                0
            ];
            for(let i = 0; i < e.length; i++)n[0] = e[i][0], n[1] = e[i][1], n[2] = e[i][2], n[3] = 1, Q(n, t1) >= 0 && r++;
            return r;
        }
        class xc {
            constructor(e, t1){
                this.points = e || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t1 || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = vc.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    H([], this.points[2], this.points[3]),
                    H([], this.points[0], this.points[3]),
                    H([], this.points[4], this.points[0]),
                    H([], this.points[5], this.points[1]),
                    H([], this.points[6], this.points[2]),
                    H([], this.points[7], this.points[3])
                ];
                for (const e of this.frustumEdges){
                    const t1 = [
                        0,
                        -e[2],
                        e[1]
                    ], r = [
                        e[2],
                        0,
                        -e[0]
                    ];
                    this.projections.push({
                        axis: t1,
                        projection: fc(this.points, this.points[0], t1)
                    }), this.projections.push({
                        axis: r,
                        projection: fc(this.points, this.points[0], r)
                    });
                }
            }
            static fromInvProjectionMatrix(e, t1, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = ee([], r, e), o = 1 / s[3] / t1 * i;
                    var a, l, u;
                    return (a = s)[0] = (l = s)[0] * (u = [
                        o,
                        o,
                        n ? 1 / s[3] : o,
                        o
                    ])[0], a[1] = l[1] * u[1], a[2] = l[2] * u[2], a[3] = l[3] * u[3], a;
                }), o = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e)=>{
                    const t1 = L([], U([], H([], s[e[0]], s[e[1]]), H([], s[e[2]], s[e[1]]))), r = -O(t1, s[e[1]]);
                    return t1.concat(r);
                }), a = [];
                for(let e = 0; e < s.length; e++)a.push([
                    s[e][0],
                    s[e][1],
                    s[e][2]
                ]);
                return new xc(a, o);
            }
            intersectsPrecise(e, t1, r) {
                for(let r = 0; r < t1.length; r++)if (!gc(e, t1[r])) return 0;
                for(let t1 = 0; t1 < this.planes.length; t1++)if (!gc(e, this.planes[t1])) return 0;
                for (const t1 of r)for (const r of this.frustumEdges){
                    const n = U([], t1, r), i = M(n);
                    if (0 === i) continue;
                    V(n, n, 1 / i);
                    const s = fc(this.points, this.points[0], n), o = fc(e, this.points[0], n);
                    if (s[0] > o[1] || o[0] > s[1]) return 0;
                }
                return 1;
            }
            containsPoint(e) {
                for (const t1 of this.planes){
                    const r = t1[3];
                    if (O([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], e) + r < 0) return !1;
                }
                return !0;
            }
        }
        class vc {
            static fromPoints(e) {
                const t1 = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of e)T(t1, t1, n), k(r, r, n);
                return new vc(t1, r);
            }
            static fromTileIdAndHeight(e, t1, r) {
                const n = 1 << e.canonical.z, i = e.canonical.x, s = e.canonical.y;
                return new vc([
                    i / n,
                    s / n,
                    t1
                ], [
                    (i + 1) / n,
                    (s + 1) / n,
                    r
                ]);
            }
            static applyTransform(e, t1) {
                const r = e.getCorners();
                for(let e = 0; e < r.length; ++e)j(r[e], r[e], t1);
                return vc.fromPoints(r);
            }
            static applyTransformFast(e, t1) {
                const r = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], n = [
                    ...r
                ];
                for(let i = 0; i < 3; i++)for(let s = 0; s < 3; s++){
                    const o = t1[4 * s + i], a = o * e.min[s], l = o * e.max[s];
                    r[i] += Math.min(a, l), n[i] += Math.max(a, l);
                }
                return new vc(r, n);
            }
            static projectAabbCorners(e, t1) {
                const r = e.getCorners();
                for(let e = 0; e < r.length; ++e)j(r[e], r[e], t1);
                return r;
            }
            constructor(e, t1){
                this.min = e, this.max = t1, this.center = V([], z([], this.min, this.max), .5);
            }
            quadrant(e) {
                const t1 = [
                    e % 2 == 0,
                    e < 2
                ], r = A(this.min), n = A(this.max);
                for(let e = 0; e < t1.length; e++)r[e] = t1[e] ? this.min[e] : this.center[e], n[e] = t1[e] ? this.center[e] : this.max[e];
                return n[2] = this.max[2], new vc(r, n);
            }
            distanceX(e) {
                return Math.max(Math.min(this.max[0], e[0]), this.min[0]) - e[0];
            }
            distanceY(e) {
                return Math.max(Math.min(this.max[1], e[1]), this.min[1]) - e[1];
            }
            distanceZ(e) {
                return Math.max(Math.min(this.max[2], e[2]), this.min[2]) - e[2];
            }
            getCorners() {
                const e = this.min, t1 = this.max;
                return [
                    [
                        e[0],
                        e[1],
                        e[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        e[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        t1[2]
                    ]
                ];
            }
            intersects(e) {
                return this.intersectsAabb(e.bounds) ? mc(e, this.getCorners()) : 0;
            }
            intersectsFlat(e) {
                return this.intersectsAabb(e.bounds) ? mc(e, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(e, t1) {
                return t1 || this.intersects(e) ? yc(e, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e, t1) {
                return t1 || this.intersectsFlat(e) ? yc(e, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e) {
                for(let t1 = 0; t1 < 3; ++t1)if (this.min[t1] > e.max[t1] || e.min[t1] > this.max[t1]) return !1;
                return !0;
            }
            intersectsAabbXY(e) {
                return !(this.min[0] > e.max[0] || e.min[0] > this.max[0] || this.min[1] > e.max[1] || e.min[1] > this.max[1]);
            }
            encapsulate(e) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e.min[t1]), this.max[t1] = Math.max(this.max[t1], e.max[t1]);
            }
            encapsulatePoint(e) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e[t1]), this.max[t1] = Math.max(this.max[t1], e[t1]);
            }
            closestPoint(e) {
                return [
                    Math.max(Math.min(this.max[0], e[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e[2]), this.min[2])
                ];
            }
        }
        Js(vc, "Aabb");
        class bc {
            constructor(e, t1){
                this.feature = e, this.metersToTile = t1, this.index = 0;
            }
            get() {
                const e = this.feature.vertices[this.index], t1 = this.feature.vertexProps[this.index].dir, r = t1[1], n = -t1[0], i = (e.extent + 1) * this.metersToTile;
                return [
                    new Ie(Math.trunc(e.position[0] + r * i), Math.trunc(e.position[1] + n * i)),
                    new Ie(Math.trunc(e.position[0] - r * i), Math.trunc(e.position[1] - n * i))
                ];
            }
            next() {
                this.index++;
            }
            valid() {
                return this.index < this.feature.vertices.length;
            }
        }
        class wc {
            constructor(e, t1, r, n, i, s){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this._tmpVec2 = [
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce()
                ], this.id = e, this.heightRange = {
                    min: r,
                    max: r
                }, this.safeArea = t1, this.constantHeight = r, null == this.constantHeight && (null != this.constantHeight || 0 !== n.length)) {
                    this.vertices = n, this.edges = i, this.edges = this.edges.filter((e)=>{
                        var t1, r;
                        return e.a < this.vertices.length && e.b < this.vertices.length && !((t1 = this.vertices[e.a].position)[0] === (r = this.vertices[e.b].position)[0] && t1[1] === r[1]);
                    }), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const e of this.vertices)this.vertexProps.push({
                        dir: he(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, e.height), this.heightRange.max = Math.max(this.heightRange.max, e.height);
                    for (const e of this.edges){
                        const t1 = this.vertices[e.a].position, r = this.vertices[e.b].position, n = fe(ce(), r, t1), i = ye(n), s = me(ce(), n, 1 / i);
                        this.edgeProps.push({
                            vec: n,
                            dir: s,
                            len: i
                        });
                        const o = this.vertexProps[e.a].dir, a = this.vertexProps[e.b].dir;
                        de(o, o, s), de(a, a, s);
                    }
                    for (const e of this.vertexProps)0 === e.dir[0] && 0 === e.dir[1] || ge(e.dir, e.dir);
                    this.tessellate(s);
                }
            }
            pointElevation(e) {
                if (null != this.constantHeight) return this.constantHeight;
                const t1 = this.getClosestEdge(e);
                if (null == t1) return 0;
                const [r, n] = t1;
                return hr(this.vertices[this.edges[r].a].height, this.vertices[this.edges[r].b].height, n);
            }
            computeSlopeNormal(e, t1) {
                const r = this.getClosestEdge(e);
                if (!r) return I(0, 0, 1);
                const n = r[0], i = this.edges[n], s = this.edgeProps[n].vec, o = I(s[0], s[1], (this.vertices[i.b].height - this.vertices[i.a].height) * t1), a = I(o[1], -o[0], 0);
                U(a, a, o);
                const l = M(a);
                return l > 0 ? V(a, a, 1 / l) : S(a, 0, 0, 1);
            }
            getSafeArea() {
                return this.safeArea;
            }
            isTunnel() {
                return this.heightRange.max <= -5;
            }
            getClosestEdge(e) {
                if (0 === this.edges.length) return;
                let t1 = 0, r = Number.POSITIVE_INFINITY, n = 0;
                const [i, s, o, a, l, u, c] = this._tmpVec2;
                pe(c, e.x, e.y);
                const h = new hc(c, null);
                for(let e = 0; e < this.edges.length; e++){
                    const p = this.edges[e], d = this.edgeProps[e].dir;
                    h.dir = d;
                    const f = this.vertices[p.a].position, m = this.vertices[p.b].position, y = h.intersectsPlane(f, this.vertexProps[p.a].dir, i), g = h.intersectsPlane(m, this.vertexProps[p.b].dir, s);
                    if (!y || !g) continue;
                    fe(o, s, i), fe(a, c, i);
                    const x = xe(o, o), v = x > 0 ? xe(a, o) / x : 0, b = De(v, 0, 1), w = Math.abs((v - b) * this.edgeProps[e].len);
                    fe(l, c, f), pe(u, d[1], -d[0]);
                    const _ = w + Math.abs(xe(l, u));
                    _ < r && (t1 = e, r = _, n = b);
                }
                return [
                    t1,
                    n
                ];
            }
            tessellate(e) {
                const t1 = _(), r = _(), n = _(), i = _();
                for(let s = this.edges.length - 1; s >= 0; --s){
                    const o = this.edges[s].a, a = this.edges[s].b, { position: l, height: u, extent: c } = this.vertices[o], { position: h, height: p, extent: d } = this.vertices[a], f = this.vertexProps[o].dir, m = this.vertexProps[a].dir;
                    if (S(t1, l[0] / e, l[1] / e, u), S(r, h[0] / e, h[1] / e, p), S(n, f[1], -f[0], 0), V(n, n, c), S(i, m[1], -m[0], 0), V(i, i, d), this.distSqLines(I(t1[0] + .5 * n[0], t1[1] + .5 * n[1], t1[2] + .5 * n[2]), I(r[0] - .5 * i[0], r[1] - .5 * i[1], r[2] - .5 * i[2]), I(t1[0] - .5 * n[0], t1[1] - .5 * n[1], t1[2] - .5 * n[2]), I(r[0] + .5 * i[0], r[1] + .5 * i[1], r[2] + .5 * i[2])) <= .0025000000000000005) continue;
                    const y = this.vertices.length, g = de(ce(), l, h);
                    this.vertices.push({
                        position: me(g, g, .5),
                        height: .5 * (u + p),
                        extent: .5 * (c + d)
                    });
                    const x = de(ce(), f, m);
                    this.vertexProps.push({
                        dir: ge(x, x)
                    }), this.edges.splice(s, 1), this.edgeProps.splice(s, 1), this.edges.push({
                        a: o,
                        b: y
                    }), this.edges.push({
                        a: y,
                        b: a
                    });
                    const v = fe(ce(), this.vertices[y].position, l), b = ye(v), w = {
                        vec: v,
                        dir: me(ce(), v, 1 / b),
                        len: b
                    };
                    this.edgeProps.push(w), this.edgeProps.push(w);
                }
            }
            distSqLines(e, t1, r, n) {
                const i = P(_(), t1, e), s = P(_(), n, r), o = P(_(), e, r), a = O(i, i), l = O(i, s), u = O(i, o), c = O(s, s), h = O(s, o), p = a * c - l * l;
                if (0 === p) return D(N(i, r, n, O(o, s) / O(s, s)), e);
                const d = (a * h - l * u) / p;
                return D(N(i, e, t1, (l * h - u * c) / p), N(s, r, n, d));
            }
        }
        class _c {
            static parseFrom(e, t1) {
                const r = cc.parse(e);
                if (!r) return [];
                let { vertices: n, features: i } = r;
                const s = 1 / Uu(t1);
                i.sort((e, t1)=>e.id - t1.id), n.sort((e, t1)=>e.id - t1.id || e.idx - t1.idx), n = n.filter((e, t1, r)=>t1 === r.findIndex((t1)=>t1.id === e.id && t1.idx === e.idx));
                const o = new Array;
                let a = 0;
                const l = n.length;
                for (const e of i){
                    if (e.constantHeight) {
                        o.push(new wc(e.id, e.bounds, e.constantHeight));
                        continue;
                    }
                    for(; a !== l && n[a].id < e.id;)a++;
                    if (a === l || n[a].id !== e.id) continue;
                    const t1 = new Array, r = new Array, i = a;
                    for(; a !== l && n[a].id === e.id;){
                        const e = n[a];
                        if (t1.push({
                            position: e.position,
                            height: e.height,
                            extent: e.extent
                        }), a !== i && n[a - 1].idx === e.idx - 1) {
                            const e = a - i;
                            r.push({
                                a: e - 1,
                                b: e
                            });
                        }
                        a++;
                    }
                    o.push(new wc(e.id, e.bounds, void 0, t1, r, s));
                }
                return o;
            }
            static getElevationFeature(e, t1) {
                if (!t1) return;
                const r = +e.properties[ic];
                return Number.isNaN(r) ? void 0 : t1.find((e)=>e.id === r);
            }
        }
        class Ac {
            constructor(e, t1){
                this.zScale = 1, this.xOffset = 0, this.yOffset = 0, e.equals(t1) || (this.zScale = Math.pow(2, t1.z - e.z), this.xOffset = (e.x * this.zScale - t1.x) * Un, this.yOffset = (e.y * this.zScale - t1.y) * Un);
            }
            constantElevation(e, t1) {
                if (null != e.constantHeight) return this.computeBiasedHeight(e.constantHeight, t1);
            }
            pointElevation(e, t1, r) {
                const n = this.constantElevation(t1, r);
                return null != n ? n : (e.x = e.x * this.zScale + this.xOffset, e.y = e.y * this.zScale + this.yOffset, this.computeBiasedHeight(t1.pointElevation(e), r));
            }
            computeBiasedHeight(e, t1) {
                return t1 <= 0 ? e : e + t1 * Ce(0, t1, e >= 0 ? e : Math.abs(.5 * e));
            }
        }
        Js(wc, "ElevationFeature");
        class Mc {
            constructor(e){
                this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.hasPattern = !1, this.projection = e.projection, this.layoutVertexArray = new Oa, this.indexArray = new ol, this.segments = new Rl, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.elevationMode = this.layers[0].layout.get("circle-elevation-reference"), this.hasElevation = !1, "none" !== this.elevationMode && (this.elevatedLayoutVertexArray = new ja), this.worldview = e.worldview, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {}
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                const i = this.layers[0], s = [];
                let o = null;
                "circle" === i.type && (o = i.layout.get("circle-sort-key"));
                for (const { feature: i, id: a, index: l, sourceLayerIndex: u } of e){
                    const e = this.layers[0]._featureFilter.needGeometry, c = Yu(i, e);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = o ? o.evaluate(c, {}, r) : void 0, p = {
                        id: a,
                        properties: i.properties,
                        type: i.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e ? c.geometry : Wu(i, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                o && s.sort((e, t1)=>e.sortKey - t1.sortKey);
                let a = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new Ya, a = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n, l = e[s].feature;
                    this.addFeature(n, i, s, t1.availableImages, r, a, t1.brightness, t1.elevationFeatures), t1.featureIndex.insert(l, i, s, o, this.index);
                }
                this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            update(e, t1, r, n, i, s, o) {
                this.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e) {
                this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Fl.members), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e.createVertexBuffer(this.globeExtVertexArray, Cl.members)), this.elevatedLayoutVertexArray && (this.elevatedLayoutVertexBuffer = e.createVertexBuffer(this.elevatedLayoutVertexArray, Dl.members))), this.programConfigurations.upload(e), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy());
            }
            addFeature(e, t1, r, n, i, s, o, a) {
                let l;
                "none" !== this.elevationMode && (l = _c.getElevationFeature(e, a));
                for (const r of t1)for (const t1 of r){
                    const r = t1.x, n = t1.y;
                    if (r < 0 || r >= Un || n < 0 || n >= Un) continue;
                    if (s) {
                        const e = s.projectTilePoint(r, n, i), t1 = s.upVector(i, r, n);
                        this.addGlobeExtVertex(e, t1), this.addGlobeExtVertex(e, t1), this.addGlobeExtVertex(e, t1), this.addGlobeExtVertex(e, t1);
                    }
                    const o = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e.sortKey), a = o.vertexLength;
                    if (this.addCircleVertex(r, n, -1, -1), this.addCircleVertex(r, n, 1, -1), this.addCircleVertex(r, n, 1, 1), this.addCircleVertex(r, n, -1, 1), "none" !== this.elevationMode) {
                        const e = l ? l.pointElevation(new Ie(r, n)) : 0;
                        this.hasElevation = this.hasElevation || 0 !== e;
                        for(let t1 = 0; t1 < 4; t1++)this.elevatedLayoutVertexArray.emplaceBack(e);
                    }
                    this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 2, a + 3), o.vertexLength += 4, o.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, r, {}, n, i, o, void 0, this.worldview);
            }
            addCircleVertex(e, t1, r, n) {
                this.layoutVertexArray.emplaceBack(2 * e + (r + 1) / 2, 2 * t1 + (n + 1) / 2);
            }
            addGlobeExtVertex(e, t1) {
                const r = 16384;
                this.globeExtVertexArray.emplaceBack(e.x, e.y, e.z, t1[0] * r, t1[1] * r, t1[2] * r);
            }
        }
        function Ic(e, t1) {
            for(let r = 0; r < e.length; r++)if (Cc(t1, e[r])) return !0;
            for(let r = 0; r < t1.length; r++)if (Cc(e, t1[r])) return !0;
            return !!Bc(e, t1);
        }
        function Sc(e, t1, r) {
            return !!Cc(e, t1) || !!Ec(t1, e, r);
        }
        function zc(e, t1) {
            if (1 === e.length) return Dc(t1, e[0]);
            for(let r = 0; r < t1.length; r++){
                const n = t1[r];
                for(let t1 = 0; t1 < n.length; t1++)if (Cc(e, n[t1])) return !0;
            }
            for(let r = 0; r < e.length; r++)if (Dc(t1, e[r])) return !0;
            for(let r = 0; r < t1.length; r++)if (Bc(e, t1[r])) return !0;
            return !1;
        }
        function Pc(e, t1, r) {
            if (e.length > 1) {
                if (Bc(e, t1)) return !0;
                for(let n = 0; n < t1.length; n++)if (Ec(t1[n], e, r)) return !0;
            }
            for(let n = 0; n < e.length; n++)if (Ec(e[n], t1, r)) return !0;
            return !1;
        }
        function Bc(e, t1) {
            if (0 === e.length || 0 === t1.length) return !1;
            for(let r = 0; r < e.length - 1; r++){
                const n = e[r], i = e[r + 1];
                for(let e = 0; e < t1.length - 1; e++)if (Tc(n, i, t1[e], t1[e + 1])) return !0;
            }
            return !1;
        }
        function Tc(e, t1, r, n) {
            return We(e, r, n) !== We(t1, r, n) && We(e, t1, r) !== We(e, t1, n);
        }
        function kc(e, t1, r) {
            return (e.x - r.x) * (t1.y - r.y) - (e.y - r.y) * (t1.x - r.x);
        }
        function Vc(e, t1, r, n) {
            const i = kc(e, t1, n), s = kc(e, t1, r);
            if (Math.sign(i) === Math.sign(s)) return;
            const o = kc(r, n, e), a = o + s - i;
            return Math.sign(o) !== Math.sign(a) ? [
                o / (o - a),
                s / (s - i)
            ] : void 0;
        }
        function Ec(e, t1, r) {
            const n = r * r;
            if (1 === t1.length) return e.distSqr(t1[0]) < n;
            for(let r = 1; r < t1.length; r++)if (Fc(e, t1[r - 1], t1[r]) < n) return !0;
            return !1;
        }
        function Fc(e, t1, r) {
            const n = t1.distSqr(r);
            if (0 === n) return e.distSqr(t1);
            const i = ((e.x - t1.x) * (r.x - t1.x) + (e.y - t1.y) * (r.y - t1.y)) / n;
            return e.distSqr(i < 0 ? t1 : i > 1 ? r : r.sub(t1)._mult(i)._add(t1));
        }
        function Dc(e, t1) {
            let r, n, i, s = !1;
            for(let o = 0; o < e.length; o++){
                r = e[o];
                for(let e = 0, o = r.length - 1; e < r.length; o = e++)n = r[e], i = r[o], n.y > t1.y != i.y > t1.y && t1.x < (i.x - n.x) * (t1.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Cc(e, t1) {
            let r = !1;
            for(let n = 0, i = e.length - 1; n < e.length; i = n++){
                const s = e[n], o = e[i];
                s.y > t1.y != o.y > t1.y && t1.x < (o.x - s.x) * (t1.y - s.y) / (o.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Rc(e, t1, r, n, i) {
            for (const s of e)if (t1 <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
            const s = [
                new Ie(t1, r),
                new Ie(t1, i),
                new Ie(n, i),
                new Ie(n, r)
            ];
            if (e.length > 2) {
                for (const t1 of s)if (Cc(e, t1)) return !0;
            }
            for(let t1 = 0; t1 < e.length - 1; t1++)if (Lc(e[t1], e[t1 + 1], s)) return !0;
            return !1;
        }
        function Lc(e, t1, r) {
            const n = r[0], i = r[2];
            if (e.x < n.x && t1.x < n.x || e.x > i.x && t1.x > i.x || e.y < n.y && t1.y < n.y || e.y > i.y && t1.y > i.y) return !1;
            const s = We(e, t1, r[0]);
            return s !== We(e, t1, r[1]) || s !== We(e, t1, r[2]) || s !== We(e, t1, r[3]);
        }
        function Oc(e, t1, r, n, i, s) {
            let o = t1.y - e.y, a = e.x - t1.x;
            if (s = s || 0) {
                const e = o * o + a * a;
                if (0 === e) return !0;
                const t1 = Math.sqrt(e);
                o /= t1, a /= t1;
            }
            return !((r.x - e.x) * o + (r.y - e.y) * a - s < 0 || (n.x - e.x) * o + (n.y - e.y) * a - s < 0 || (i.x - e.x) * o + (i.y - e.y) * a - s < 0);
        }
        function Uc(e, t1, r, n, i, s, o) {
            return !(Oc(e, t1, n, i, s, o) || Oc(t1, r, n, i, s, o) || Oc(r, e, n, i, s, o) || Oc(n, i, e, t1, r, o) || Oc(i, s, e, t1, r, o) || Oc(s, n, e, t1, r, o));
        }
        function Nc(e, t1, r) {
            const n = t1.paint.get(e).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(t1.id).getMaxValue(e);
        }
        function jc(e) {
            return Math.sqrt(e[0] * e[0] + e[1] * e[1]);
        }
        function Gc(e, t1, r, n, i) {
            if (!t1[0] && !t1[1]) return e;
            const s = Ie.convert(t1)._mult(i);
            "viewport" === r && s._rotate(-n);
            const o = [];
            for(let t1 = 0; t1 < e.length; t1++)o.push(e[t1].sub(s));
            return o;
        }
        function $c(e, t1, r, n) {
            const i = Ie.convert(e)._mult(n);
            return "viewport" === t1 && i._rotate(-r), i;
        }
        let qc, Xc;
        Js(Mc, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        class Hc {
            constructor(e, t1, r){
                this.z = e, this.x = t1, this.y = r, this.key = Yc(0, e, e, t1, r);
            }
            equals(e) {
                return this.z === e.z && this.x === e.x && this.y === e.y;
            }
            isChildOf(e) {
                const t1 = this.z - e.z;
                return 0 === e.z || e.z < this.z && e.x === this.x >> t1 && e.y === this.y >> t1;
            }
            url(e, t1) {
                const r = function(e, t1, r) {
                    const n = 2 ** r, i = 2 * Math.PI * 6378137, s = i * (e / n - .5), o = i * (.5 - (t1 + 1) / n);
                    return `${s},${o},${s + i / n},${o + i / n}`;
                }(this.x, this.y, this.z), n = function(e, t1, r) {
                    let n, i = "";
                    for(let s = e; s > 0; s--)n = 1 << s - 1, i += (t1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return e[(this.x + this.y) % e.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Zc {
            constructor(e, t1){
                this.wrap = e, this.canonical = t1, this.key = Yc(e, t1.z, t1.z, t1.x, t1.y);
            }
        }
        class Wc {
            constructor(e, t1, r, n, i){
                this.overscaledZ = e, this.wrap = t1, this.canonical = new Hc(r, +n, +i), this.key = 0 === t1 && e === r ? this.canonical.key : Yc(t1, e, r, n, i);
            }
            equals(e) {
                return this.overscaledZ === e.overscaledZ && this.wrap === e.wrap && this.canonical.equals(e.canonical);
            }
            scaledTo(e) {
                const t1 = this.canonical.z - e;
                return e > this.canonical.z ? new Wc(e, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Wc(e, this.wrap, e, this.canonical.x >> t1, this.canonical.y >> t1);
            }
            calculateScaledKey(e, t1 = !0) {
                if (this.overscaledZ === e && t1) return this.key;
                if (e > this.canonical.z) return Yc(this.wrap * +t1, e, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - e;
                    return Yc(this.wrap * +t1, e, e, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(e) {
                if (e.wrap !== this.wrap) return !1;
                const t1 = this.canonical.z - e.canonical.z;
                return 0 === e.overscaledZ || e.overscaledZ < this.overscaledZ && e.canonical.z < this.canonical.z && e.canonical.x === this.canonical.x >> t1 && e.canonical.y === this.canonical.y >> t1;
            }
            children(e) {
                if (this.overscaledZ >= e) return [
                    new Wc(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new Wc(t1, this.wrap, t1, r, n),
                    new Wc(t1, this.wrap, t1, r + 1, n),
                    new Wc(t1, this.wrap, t1, r, n + 1),
                    new Wc(t1, this.wrap, t1, r + 1, n + 1)
                ];
            }
            isLessThan(e) {
                return this.wrap < e.wrap || !(this.wrap > e.wrap) && (this.overscaledZ < e.overscaledZ || !(this.overscaledZ > e.overscaledZ) && (this.canonical.x < e.canonical.x || !(this.canonical.x > e.canonical.x) && this.canonical.y < e.canonical.y));
            }
            wrapped() {
                return new Wc(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e) {
                return new Wc(this.overscaledZ, e, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Zc(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function Yc(e, t1, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let o = s * (i % s) + n % s;
            return e && r < 22 && (o += s * s * ((e < 0 ? -2 * e - 1 : 2 * e) % (1 << 2 * (22 - r)))), 16 * (32 * o + r) + (t1 - r);
        }
        const Jc = [
            (e)=>{
                let t1 = e.canonical.x - 1, r = e.wrap;
                return t1 < 0 && (t1 = (1 << e.canonical.z) - 1, r--), new Wc(e.overscaledZ, r, e.canonical.z, t1, e.canonical.y);
            },
            (e)=>{
                let t1 = e.canonical.x + 1, r = e.wrap;
                return t1 === 1 << e.canonical.z && (t1 = 0, r++), new Wc(e.overscaledZ, r, e.canonical.z, t1, e.canonical.y);
            },
            (e)=>new Wc(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, (0 === e.canonical.y ? 1 << e.canonical.z : e.canonical.y) - 1),
            (e)=>new Wc(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y === (1 << e.canonical.z) - 1 ? 0 : e.canonical.y + 1)
        ];
        Js(Hc, "CanonicalTileID"), Js(Wc, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const Kc = Ra([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Qc } = Kc, eh = Ra([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var th = Ra([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function rh(e) {
            return e * xu / Iu;
        }
        const nh = [
            new vc([
                wu,
                wu,
                wu
            ], [
                _u,
                _u,
                _u
            ]),
            new vc([
                wu,
                wu,
                wu
            ], [
                0,
                0,
                _u
            ]),
            new vc([
                0,
                wu,
                wu
            ], [
                _u,
                0,
                _u
            ]),
            new vc([
                wu,
                0,
                wu
            ], [
                0,
                _u,
                _u
            ]),
            new vc([
                0,
                0,
                wu
            ], [
                _u,
                _u,
                _u
            ])
        ];
        function ih(e, t1, r, n = !0) {
            const i = V([], e._camera.position, e.worldSize), s = [
                t1,
                r,
                1,
                1
            ];
            ee(s, s, e.pixelMatrixInverse), J(s, s, 1 / s[3]);
            const o = L([], H([], s, i)), a = e.globeMatrix, l = [
                a[12],
                a[13],
                a[14]
            ], u = H([], l, i), c = M(u), h = L([], u), p = e.worldSize / (2 * Math.PI), d = O(h, o), f = Math.asin(p / c);
            if (f < Math.acos(d)) {
                if (!n) return null;
                const e = [], t1 = [];
                V(e, o, c / d), L(t1, H(t1, e, u)), L(o, z(o, u, V(o, t1, Math.tan(f) * c)));
            }
            const m = [];
            new pc(i, o).closestPointOnSphere(l, p, m);
            const y = L([], tt(a, 0)), g = L([], tt(a, 1)), x = L([], tt(a, 2)), v = O(y, m), b = O(g, m), w = O(x, m), _ = Te(Math.asin(-b / p));
            let A = Te(Math.atan2(v, w));
            A = e.center.lng + function(e, t1) {
                const r = (t1 - e + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(e.center.lng, A);
            const I = Tu(A), S = De(ku(_), 0, 1);
            return new Nu(I, S);
        }
        class sh {
            constructor(e, t1, r){
                this.a = H([], e, r), this.b = H([], t1, r), this.center = r;
                const n = L([], this.a), i = L([], this.b);
                this.angle = Math.acos(O(n, i));
            }
        }
        function oh(e, t1) {
            if (0 === e.angle) return null;
            let r;
            return r = 0 === e.a[t1] ? 1 / e.angle * .5 * Math.PI : 1 / e.angle * Math.atan(e.b[t1] / e.a[t1] / Math.sin(e.angle) - 1 / Math.tan(e.angle)), r < 0 || r > 1 ? null : function(e, t1, r, n) {
                const i = Math.sin(r);
                return e * (Math.sin((1 - n) * r) / i) + t1 * (Math.sin(n * r) / i);
            }(e.a[t1], e.b[t1], e.angle, De(r, 0, 1)) + e.center[t1];
        }
        function ah(e) {
            if (e.z <= 1) return nh[e.z + 2 * e.y + e.x];
            const t1 = ph(hh(e));
            return vc.fromPoints(t1);
        }
        function lh(e, t1, r) {
            return V(e, e, 1 - r), E(e, e, t1, r);
        }
        function uh(e, t1, r) {
            for (const n of e)j(n, n, t1), V(n, n, r);
        }
        function ch(e, t1, r, n) {
            const i = t1 / e.worldSize, s = e.globeMatrix;
            if (r.z <= 1) {
                const e = ah(r).getCorners();
                return uh(e, s, i), vc.fromPoints(e);
            }
            const o = hh(r, n), a = ph(o, xu + rh(e._tileCoverLift));
            uh(a, s, i);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (o.contains(e.center)) {
                for (const e of a)T(c, c, e), k(u, u, e);
                u[2] = 0;
                const t1 = e.point, r = [
                    t1.x * i,
                    t1.y * i,
                    0
                ];
                return T(c, c, r), k(u, u, r), new vc(c, u);
            }
            if (e._tileCoverLift > 0) {
                for (const e of a)T(c, c, e), k(u, u, e);
                return new vc(c, u);
            }
            const h = [
                s[12] * i,
                s[13] * i,
                s[14] * i
            ], p = o.getCenter(), d = De(e.center.lat, -85.051129, Cu), f = De(p.lat, -85.051129, Cu), m = Tu(e.center.lng), y = ku(d);
            let g = m - Tu(p.lng);
            const x = y - ku(f);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let v = 0;
            Math.abs(g) > Math.abs(x) ? v = g >= 0 ? 1 : 3 : (v = x >= 0 ? 0 : 2, E(h, h, [
                s[4] * i,
                s[5] * i,
                s[6] * i
            ], -Math.sin(Be(x >= 0 ? o.getSouth() : o.getNorth())) * xu));
            const b = a[v], w = a[(v + 1) % 4], _ = new sh(b, w, h), A = [
                oh(_, 0) || b[0],
                oh(_, 1) || b[1],
                oh(_, 2) || b[2]
            ], M = wh(e.zoom);
            if (M > 0) {
                const n = function({ x: e, y: t1, z: r }, n, i, s, o) {
                    const a = 1 / (1 << r);
                    let l = e * a, u = l + a, c = t1 * a, h = c + a, p = 0;
                    const d = (l + u) / 2 - s;
                    return d > .5 ? p = -1 : d < -0.5 && (p = 1), l = ((l + p) * n - (s *= n)) * i + s, u = ((u + p) * n - s) * i + s, c = (c * n - (o *= n)) * i + o, h = (h * n - o) * i + o, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, t1, e._pixelsPerMercatorPixel, m, y);
                for(let e = 0; e < a.length; e++)lh(a[e], n[e], M);
                const i = z([], n[v], n[(v + 1) % 4]);
                V(i, i, .5), lh(A, i, M);
            }
            for (const e of a)T(c, c, e), k(u, u, e);
            return c[2] = Math.min(b[2], w[2]), T(c, c, A), k(u, u, A), new vc(c, u);
        }
        function hh({ x: e, y: t1, z: r }, n = !1) {
            const i = 1 / (1 << r), s = new zu(Eu(e * i), t1 === (1 << r) - 1 && n ? -90 : Fu((t1 + 1) * i)), o = new zu(Eu((e + 1) * i), 0 === t1 && n ? 90 : Fu(t1 * i));
            return new Pu(s, o);
        }
        function ph(e, t1 = xu) {
            const r = Be(e.getNorth()), n = Be(e.getSouth()), i = Math.cos(r), s = Math.cos(n), o = Math.sin(r), a = Math.sin(n), l = e.getWest(), u = e.getEast();
            return [
                Au(s, a, l, t1),
                Au(s, a, u, t1),
                Au(i, o, u, t1),
                Au(i, o, l, t1)
            ];
        }
        function dh(e, t1, r, n) {
            const i = 1 << r.z, s = (e / Un + r.x) / i;
            return Mu(Fu((t1 / Un + r.y) / i), Eu(s), n);
        }
        function fh({ min: e, max: t1 }) {
            return 16383 / Math.max(t1[0] - e[0], t1[1] - e[1], t1[2] - e[2]);
        }
        const mh = new Float64Array(16);
        function yh(e) {
            const t1 = fh(e), r = g(mh, [
                t1,
                t1,
                t1
            ]);
            return p(r, r, R([], e.min));
        }
        function gh(e) {
            const t1 = function(e, t1) {
                return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t1[0], e[13] = t1[1], e[14] = t1[2], e[15] = 1, e;
            }(mh, e.min), r = 1 / fh(e);
            return d(t1, t1, [
                r,
                r,
                r
            ]);
        }
        function xh(e) {
            const t1 = Un / (2 * Math.PI);
            return e / (2 * Math.PI) / t1;
        }
        function vh(e, t1) {
            return Un / (512 * Math.pow(2, e)) * fh(ah(t1));
        }
        function bh(e, t1, r, n, i) {
            const s = xh(r), o = [
                e,
                t1,
                -r / (2 * Math.PI)
            ], a = u(new Float64Array(16));
            return p(a, a, o), d(a, a, [
                s,
                s,
                s
            ]), f(a, a, Be(-i)), m(a, a, Be(-n)), a;
        }
        function wh(e) {
            return Ce(5, 6, e);
        }
        function _h(e, t1) {
            const r = Mu(t1.lat, t1.lng), n = function(e) {
                const t1 = Mu(e._center.lat, e._center.lng);
                let r = U([], I(0, 1, 0), t1);
                const n = x([], -e.angle, t1);
                r = j(r, r, n), x(n, -e._pitch, r);
                const i = L([], t1);
                return V(i, i, rh(e.cameraToCenterDistance / e.pixelsPerMeter)), j(i, i, n), z([], t1, i);
            }(e);
            var i, s, o, a, l, u, c, h, p, d;
            return o = (i = P([], n, r))[0], a = i[1], l = i[2], u = (s = r)[0], c = s[1], h = s[2], d = (p = Math.sqrt((o * o + a * a + l * l) * (u * u + c * c + h * h))) && O(i, s) / p, Math.acos(Math.min(Math.max(d, -1), 1));
        }
        function Ah(e, t1) {
            return _h(e, t1) > Math.PI / 2 * 1.01;
        }
        const Mh = Be(85), Ih = Math.cos(Mh), Sh = Math.sin(Mh), zh = a(), Ph = (e)=>{
            const t1 = [];
            return "map" === e.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        };
        function Bh(e, t1, r, n, i, s, o, a, l) {
            if (s && e.queryGeometry.isAboveHorizon) return !1;
            s && (l *= e.pixelToTileUnitsFactor);
            const u = e.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of t1)for (const t1 of h){
                const h = t1.add(a), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, d = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const e = r.projection.upVector(u, h.x, h.y);
                    d.x += e[0] * c * p, d.y += e[1] * c * p, d.z += e[2] * c * p;
                }
                const f = s ? h : Th(d.x, d.y, d.z, n), m = s ? e.tilespaceRays.map((e)=>Eh(e, p)) : e.queryGeometry.screenGeometry, y = ee([], [
                    d.x,
                    d.y,
                    d.z,
                    1
                ], n);
                if (!o && s ? l *= y[3] / r.cameraToCenterDistance : o && !s && (l *= r.cameraToCenterDistance / y[3]), s) {
                    const e = Fu((t1.y / Un + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(e, 1) / Vu(1, e);
                }
                if (Sc(m, f, l)) return !0;
            }
            return !1;
        }
        function Th(e, t1, r, n) {
            const i = ee([], [
                e,
                t1,
                r,
                1
            ], n);
            return new Ie(i[0] / i[3], i[1] / i[3]);
        }
        const kh = I(0, 0, 0), Vh = I(0, 0, 1);
        function Eh(e, t1) {
            const r = _();
            return kh[2] = t1, e.intersectsPlane(kh, Vh, r), new Ie(r[0], r[1]);
        }
        class Fh extends Mc {
        }
        let Dh, Ch, Rh, Lh;
        function Oh(e, { width: t1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== t1 * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(t1 * r * n);
            return e.width = t1, e.height = r, e.data = i, e;
        }
        function Uh(e, t1, r) {
            const { width: n, height: i } = t1;
            n === e.width && i === e.height || (Nh(e, t1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e.width, n),
                height: Math.min(e.height, i)
            }, r, null), e.width = n, e.height = i, e.data = t1.data);
        }
        function Nh(e, t1, r, n, i, s, o, a) {
            if (0 === i.width || 0 === i.height) return t1;
            if (i.width > e.width || i.height > e.height || r.x > e.width - i.width || r.y > e.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > t1.width || i.height > t1.height || n.x > t1.width - i.width || n.y > t1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = e.data, u = t1.data, c = 4 === s && a;
            for(let a = 0; a < i.height; a++){
                const h = ((r.y + a) * e.width + r.x) * s, p = ((n.y + a) * t1.width + n.x) * s;
                if (c) for(let e = 0; e < i.width; e++){
                    const t1 = h + e * s + 3, r = p + e * s;
                    u[r + 0] = 255, u[r + 1] = 255, u[r + 2] = 255, u[r + 3] = l[t1];
                }
                else if (o) for(let e = 0; e < i.width; e++){
                    const t1 = h + e * s, r = p + e * s, n = new ar(l[t1 + 0] / 255, l[t1 + 1] / 255, l[t1 + 2] / 255, l[t1 + 3]).toNonPremultipliedRenderColor(o).toArray();
                    u[r + 0] = n[0], u[r + 1] = n[1], u[r + 2] = n[2], u[r + 3] = n[3];
                }
                else for(let e = 0; e < i.width * s; e++)u[p + e] = l[h + e];
            }
            return t1;
        }
        Js(Fh, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class jh {
            constructor(e, t1){
                Oh(this, e, 1, t1);
            }
            resize(e) {
                Uh(this, new jh(e), 1);
            }
            clone() {
                return new jh({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e, t1, r, n, i) {
                Nh(e, t1, r, n, i, 1, null);
            }
        }
        class Gh {
            constructor(e, t1){
                Oh(this, e, 4, t1);
            }
            resize(e) {
                Uh(this, new Gh(e), 4);
            }
            replace(e, t1) {
                t1 ? this.data.set(e) : this.data = e instanceof Uint8ClampedArray ? new Uint8Array(e.buffer) : e;
            }
            clone() {
                return new Gh({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e, t1, r, n, i, s, o) {
                Nh(e, t1, r, n, i, 4, s, o);
            }
        }
        class $h {
            constructor(e, t1){
                this.width = e.width, this.height = e.height, this.data = t1 instanceof Uint8Array ? new Float32Array(t1.buffer) : t1;
            }
        }
        function qh(e) {
            const t1 = {}, r = e.resolution || 256, n = e.clips ? e.clips.length : 1, i = e.image || new Gh({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                t1[e.evaluationKey] = s;
                const o = e.expression.evaluate(t1), a = o ? o.toNonPremultipliedRenderColor(null) : null;
                a && (i.data[r + n + 0] = Math.floor(255 * a.r), i.data[r + n + 1] = Math.floor(255 * a.g), i.data[r + n + 2] = Math.floor(255 * a.b), i.data[r + n + 3] = Math.floor(255 * a.a));
            };
            if (e.clips) for(let t1 = 0, i = 0; t1 < n; ++t1, i += 4 * r)for(let n = 0, o = 0; n < r; n++, o += 4){
                const a = n / (r - 1), { start: l, end: u } = e.clips[t1];
                s(i, o, l * (1 - a) + u * a);
            }
            else for(let e = 0, t1 = 0; e < r; e++, t1 += 4)s(0, t1, e / (r - 1));
            return i;
        }
        Js(jh, "AlphaImage"), Js(Gh, "RGBAImage");
        const Xh = Ra([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Hh = Ra([
            {
                name: "a_road_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), Zh = Ra([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_height",
                components: 1,
                type: "Float32"
            }
        ], 4), Wh = Ra([
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ], 4);
        function Yh(e, t1, r = 2) {
            const n = t1 && t1.length, i = n ? t1[0] * r : e.length;
            let s = Jh(e, 0, i, r, !0);
            const o = [];
            if (!s || s.next === s.prev) return o;
            let a, l, u;
            if (n && (s = function(e, t1, r, n) {
                const i = [];
                for(let r = 0, s = t1.length; r < s; r++){
                    const o = Jh(e, t1[r] * n, r < s - 1 ? t1[r + 1] * n : e.length, n, !1);
                    o === o.next && (o.steiner = !0), i.push(lp(o));
                }
                i.sort(ip);
                for(let e = 0; e < i.length; e++)r = sp(i[e], r);
                return r;
            }(e, t1, s, r)), e.length > 80 * r) {
                a = e[0], l = e[1];
                let t1 = a, n = l;
                for(let s = r; s < i; s += r){
                    const r = e[s], i = e[s + 1];
                    r < a && (a = r), i < l && (l = i), r > t1 && (t1 = r), i > n && (n = i);
                }
                u = Math.max(t1 - a, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return Qh(s, o, r, a, l, u, 0), o;
        }
        function Jh(e, t1, r, n, i) {
            let s;
            if (i === function(e, t1, r, n) {
                let i = 0;
                for(let s = t1, o = r - n; s < r; s += n)i += (e[o] - e[s]) * (e[s + 1] + e[o + 1]), o = s;
                return i;
            }(e, t1, r, n) > 0) for(let i = t1; i < r; i += n)s = vp(i / n | 0, e[i], e[i + 1], s);
            else for(let i = r - n; i >= t1; i -= n)s = vp(i / n | 0, e[i], e[i + 1], s);
            return s && dp(s, s.next) && (bp(s), s = s.next), s;
        }
        function Kh(e, t1) {
            if (!e) return e;
            t1 || (t1 = e);
            let r, n = e;
            do if (r = !1, n.steiner || !dp(n, n.next) && 0 !== pp(n.prev, n, n.next)) n = n.next;
            else {
                if (bp(n), n = t1 = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== t1);
            return t1;
        }
        function Qh(e, t1, r, n, i, s, o) {
            if (!e) return;
            !o && s && function(e, t1, r, n) {
                let i = e;
                do 0 === i.z && (i.z = ap(i.x, i.y, t1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== e);
                i.prevZ.nextZ = null, i.prevZ = null, function(e) {
                    let t1, r = 1;
                    do {
                        let n, i = e;
                        e = null;
                        let s = null;
                        for(t1 = 0; i;){
                            t1++;
                            let o = i, a = 0;
                            for(let e = 0; e < r && (a++, o = o.nextZ, o); e++);
                            let l = r;
                            for(; a > 0 || l > 0 && o;)0 !== a && (0 === l || !o || i.z <= o.z) ? (n = i, i = i.nextZ, a--) : (n = o, o = o.nextZ, l--), s ? s.nextZ = n : e = n, n.prevZ = s, s = n;
                            i = o;
                        }
                        s.nextZ = null, r *= 2;
                    }while (t1 > 1);
                }(i);
            }(e, n, i, s);
            let a = e;
            for(; e.prev !== e.next;){
                const l = e.prev, u = e.next;
                if (s ? tp(e, n, i, s) : ep(e)) t1.push(l.i, e.i, u.i), bp(e), e = u.next, a = u.next;
                else if ((e = u) === a) {
                    o ? 1 === o ? Qh(e = rp(Kh(e), t1), t1, r, n, i, s, 2) : 2 === o && np(e, t1, r, n, i, s) : Qh(Kh(e), t1, r, n, i, s, 1);
                    break;
                }
            }
        }
        function ep(e) {
            const t1 = e.prev, r = e, n = e.next;
            if (pp(t1, r, n) >= 0) return !1;
            const i = t1.x, s = r.x, o = n.x, a = t1.y, l = r.y, u = n.y, c = Math.min(i, s, o), h = Math.min(a, l, u), p = Math.max(i, s, o), d = Math.max(a, l, u);
            let f = n.next;
            for(; f !== t1;){
                if (f.x >= c && f.x <= p && f.y >= h && f.y <= d && cp(i, a, s, l, o, u, f.x, f.y) && pp(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function tp(e, t1, r, n) {
            const i = e.prev, s = e, o = e.next;
            if (pp(i, s, o) >= 0) return !1;
            const a = i.x, l = s.x, u = o.x, c = i.y, h = s.y, p = o.y, d = Math.min(a, l, u), f = Math.min(c, h, p), m = Math.max(a, l, u), y = Math.max(c, h, p), g = ap(d, f, t1, r, n), x = ap(m, y, t1, r, n);
            let v = e.prevZ, b = e.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= d && v.x <= m && v.y >= f && v.y <= y && v !== i && v !== o && cp(a, c, l, h, u, p, v.x, v.y) && pp(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= d && b.x <= m && b.y >= f && b.y <= y && b !== i && b !== o && cp(a, c, l, h, u, p, b.x, b.y) && pp(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= d && v.x <= m && v.y >= f && v.y <= y && v !== i && v !== o && cp(a, c, l, h, u, p, v.x, v.y) && pp(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= d && b.x <= m && b.y >= f && b.y <= y && b !== i && b !== o && cp(a, c, l, h, u, p, b.x, b.y) && pp(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function rp(e, t1) {
            let r = e;
            do {
                const n = r.prev, i = r.next.next;
                !dp(n, i) && fp(n, r, r.next, i) && gp(n, i) && gp(i, n) && (t1.push(n.i, r.i, i.i), bp(r), bp(r.next), r = e = i), r = r.next;
            }while (r !== e);
            return Kh(r);
        }
        function np(e, t1, r, n, i, s) {
            let o = e;
            do {
                let e = o.next.next;
                for(; e !== o.prev;){
                    if (o.i !== e.i && hp(o, e)) {
                        let a = xp(o, e);
                        return o = Kh(o, o.next), a = Kh(a, a.next), Qh(o, t1, r, n, i, s, 0), void Qh(a, t1, r, n, i, s, 0);
                    }
                    e = e.next;
                }
                o = o.next;
            }while (o !== e);
        }
        function ip(e, t1) {
            let r = e.x - t1.x;
            return 0 === r && (r = e.y - t1.y, 0 === r) && (r = (e.next.y - e.y) / (e.next.x - e.x) - (t1.next.y - t1.y) / (t1.next.x - t1.x)), r;
        }
        function sp(e, t1) {
            const r = function(e, t1) {
                let r = t1;
                const n = e.x, i = e.y;
                let s, o = -1 / 0;
                if (dp(e, r)) return r;
                do {
                    if (dp(e, r.next)) return r.next;
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const e = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (e <= n && e > o && (o = e, s = r.x < r.next.x ? r : r.next, e === n)) return s;
                    }
                    r = r.next;
                }while (r !== t1);
                if (!s) return null;
                const a = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && up(i < u ? n : o, i, l, u, i < u ? o : n, i, r.x, r.y)) {
                        const t1 = Math.abs(i - r.y) / (n - r.x);
                        gp(r, e) && (t1 < c || t1 === c && (r.x > s.x || r.x === s.x && op(s, r))) && (s = r, c = t1);
                    }
                    r = r.next;
                }while (r !== a);
                return s;
            }(e, t1);
            if (!r) return t1;
            const n = xp(r, e);
            return Kh(n, n.next), Kh(r, r.next);
        }
        function op(e, t1) {
            return pp(e.prev, e, t1.prev) < 0 && pp(t1.next, e, e.next) < 0;
        }
        function ap(e, t1, r, n, i) {
            return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - r) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - n) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) << 1;
        }
        function lp(e) {
            let t1 = e, r = e;
            do (t1.x < r.x || t1.x === r.x && t1.y < r.y) && (r = t1), t1 = t1.next;
            while (t1 !== e);
            return r;
        }
        function up(e, t1, r, n, i, s, o, a) {
            return (i - o) * (t1 - a) >= (e - o) * (s - a) && (e - o) * (n - a) >= (r - o) * (t1 - a) && (r - o) * (s - a) >= (i - o) * (n - a);
        }
        function cp(e, t1, r, n, i, s, o, a) {
            return !(e === o && t1 === a) && up(e, t1, r, n, i, s, o, a);
        }
        function hp(e, t1) {
            return e.next.i !== t1.i && e.prev.i !== t1.i && !function(e, t1) {
                let r = e;
                do {
                    if (r.i !== e.i && r.next.i !== e.i && r.i !== t1.i && r.next.i !== t1.i && fp(r, r.next, e, t1)) return !0;
                    r = r.next;
                }while (r !== e);
                return !1;
            }(e, t1) && (gp(e, t1) && gp(t1, e) && function(e, t1) {
                let r = e, n = !1;
                const i = (e.x + t1.x) / 2, s = (e.y + t1.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== e);
                return n;
            }(e, t1) && (pp(e.prev, e, t1.prev) || pp(e, t1.prev, t1)) || dp(e, t1) && pp(e.prev, e, e.next) > 0 && pp(t1.prev, t1, t1.next) > 0);
        }
        function pp(e, t1, r) {
            return (t1.y - e.y) * (r.x - t1.x) - (t1.x - e.x) * (r.y - t1.y);
        }
        function dp(e, t1) {
            return e.x === t1.x && e.y === t1.y;
        }
        function fp(e, t1, r, n) {
            const i = yp(pp(e, t1, r)), s = yp(pp(e, t1, n)), o = yp(pp(r, n, e)), a = yp(pp(r, n, t1));
            return i !== s && o !== a || !(0 !== i || !mp(e, r, t1)) || !(0 !== s || !mp(e, n, t1)) || !(0 !== o || !mp(r, e, n)) || !(0 !== a || !mp(r, t1, n));
        }
        function mp(e, t1, r) {
            return t1.x <= Math.max(e.x, r.x) && t1.x >= Math.min(e.x, r.x) && t1.y <= Math.max(e.y, r.y) && t1.y >= Math.min(e.y, r.y);
        }
        function yp(e) {
            return e > 0 ? 1 : e < 0 ? -1 : 0;
        }
        function gp(e, t1) {
            return pp(e.prev, e, e.next) < 0 ? pp(e, t1, e.next) >= 0 && pp(e, e.prev, t1) >= 0 : pp(e, t1, e.prev) < 0 || pp(e, e.next, t1) < 0;
        }
        function xp(e, t1) {
            const r = wp(e.i, e.x, e.y), n = wp(t1.i, t1.x, t1.y), i = e.next, s = t1.prev;
            return e.next = t1, t1.prev = e, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function vp(e, t1, r, n) {
            const i = wp(e, t1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function bp(e) {
            e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
        }
        function wp(e, t1, r) {
            return {
                i: e,
                x: t1,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function _p(e, t1) {
            const r = e.length;
            if (r <= 1) return [
                e
            ];
            const n = [];
            let i, s;
            for(let t1 = 0; t1 < r; t1++){
                const r = Ye(e[t1]);
                0 !== r && (e[t1].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    e[t1]
                ]) : i.push(e[t1]));
            }
            if (i && n.push(i), t1 > 1) for(let e = 0; e < n.length; e++)n[e].length <= t1 || (an(n[e], t1, 1, n[e].length - 1, Ap), n[e] = n[e].slice(0, t1));
            return n;
        }
        function Ap(e, t1) {
            return t1.area - e.area;
        }
        function Mp(e, t1, r = 1) {
            if (!e) return null;
            const n = "string" == typeof e ? Rr.from(e).getPrimary() : e.getPrimary(), i = "string" == typeof e ? null : e.getSecondary();
            for (const e of [
                n,
                i
            ]){
                if (!e) continue;
                const n = e.id.toString();
                t1.has(n) || t1.set(n, []), e.scaleSelf(r), t1.get(n).push(e);
            }
            return {
                primary: n.toString(),
                secondary: i ? i.toString() : null
            };
        }
        function Ip(e, t1, r, n) {
            const i = n.patternDependencies;
            let s = !1;
            for (const n of t1){
                const t1 = n.paint.get(`${e}-pattern`);
                t1.isConstant() || (s = !0), Mp(t1.constantOr(null), i, r) && (s = !0);
            }
            return s;
        }
        function Sp(e, t1, r, n, i, s) {
            const o = s.patternDependencies;
            for (const a of t1){
                const t1 = a.paint.get(`${e}-pattern`).value;
                if ("constant" !== t1.kind) {
                    let e = t1.evaluate({
                        zoom: n
                    }, r, {}, s.availableImages);
                    e = e && e.name ? e.name : e;
                    const l = Mp(e, o, i);
                    if (!l) continue;
                    const { primary: u, secondary: c } = l;
                    u && (r.patterns[a.id] = [
                        u,
                        c
                    ].filter(Boolean));
                }
            }
            return r;
        }
        class zp {
            constructor(){
                this.portals = [];
            }
            static isOnBorder(e, t1) {
                return e <= 0 && t1 <= 0 || e >= Un && t1 >= Un;
            }
            static evaluate(e) {
                if (0 === e.length) return new zp;
                let t1 = [];
                for (const r of e)t1.push(...r.portals);
                if (0 === t1.length) return new zp;
                for (const e of t1){
                    const t1 = e.va, r = e.vb;
                    (zp.isOnBorder(t1.x, r.x) || zp.isOnBorder(t1.y, r.y)) && (e.type = "border");
                }
                const r = t1.filter((e)=>"unevaluated" !== e.type), n = t1.filter((e)=>"unevaluated" === e.type);
                if (0 === n.length) return new zp;
                n.sort((e, t1)=>e.hash === t1.hash ? e.isTunnel === t1.isTunnel ? 0 : e.isTunnel ? -1 : 1 : e.hash < t1.hash ? 1 : -1), t1 = r.concat(n);
                let i = r.length, s = i, o = i;
                do if (s++, s === t1.length || t1[i].hash !== t1[s].hash) {
                    if (s - i === 2) {
                        o < i && (t1[o] = t1[i], t1[i] = null);
                        const e = t1[o], r = t1[s - 1];
                        e.type = e.isTunnel !== r.isTunnel ? "tunnel" : "polygon", e.connection = {
                            a: e.connection.a,
                            b: r.connection.a
                        }, o++;
                    }
                    i = s;
                }
                while (i !== t1.length);
                return t1.splice(o), t1.sort((e, t1)=>e.hash < t1.hash ? 1 : -1), {
                    portals: t1
                };
            }
        }
        Js(zp, "ElevationPortalGraph");
        class Pp {
            constructor(e, t1, r){
                this.outPositions = e, this.outNormals = t1, this.outIndices = r, this.vertexLookup = new Map;
            }
            addVertex(e, t1, r) {
                let n = e[2];
                null != r && (n *= r);
                const i = `${e[0]},${e[1]},${e[2]},${t1[0]},${t1[1]},${t1[2]}`, s = this.vertexLookup.get(i);
                if (null != s) return s;
                const o = this.outPositions.length;
                this.vertexLookup.set(i, o);
                const a = Math.trunc(16384 * t1[0]), l = Math.trunc(16384 * t1[1]), u = Math.trunc(16384 * t1[2]);
                return this.outPositions.emplaceBack(e[0], e[1], n), this.outNormals.emplaceBack(a, l, u), o;
            }
            addTriangle(e, t1, r) {
                this.outIndices.emplaceBack(e, t1, r);
            }
            addTriangles(e, t1, r) {
                if (0 === e.length) return;
                const n = 1 === r.length, i = _(), s = _();
                for(let o = 0; o < e.length; o += 3){
                    const a = t1[e[o + 0]], l = t1[e[o + 1]], u = t1[e[o + 2]], c = n ? r[0] : r[e[o + 1]], h = n ? r[0] : r[e[o + 2]];
                    S(i, a.x, a.y, n ? r[0] : r[e[o + 0]]);
                    const p = this.addVertex(i, s);
                    S(i, l.x, l.y, c);
                    const d = this.addVertex(i, s);
                    S(i, u.x, u.y, h);
                    const f = this.addVertex(i, s);
                    this.outIndices.emplaceBack(p, d, f);
                }
            }
            addQuad(e, t1, r, n, i, s) {
                const o = this.addVertex(e, i, s), a = this.addVertex(t1, i, s), l = this.addVertex(r, i, s), u = this.addVertex(n, i, s);
                this.addTriangle(o, a, l), this.addTriangle(l, u, o);
            }
            getVertexCount() {
                return this.outPositions.length;
            }
            clearVertexLookup() {
                this.vertexLookup.clear();
            }
        }
        class Bp {
            constructor(e, t1, r, n){
                this.unevaluatedPortals = new zp, this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = new Map, this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new Ga, this.vertexNormals = new $a, this.indexArray = new ol, this.tileToMeters = Uu(e), this.bridgeProgramConfigurations = new pu(t1, {
                    zoom: r,
                    lut: n
                }, (e)=>"fill-tunnel-structure-color" !== e), this.tunnelProgramConfigurations = new pu(t1, {
                    zoom: r,
                    lut: n
                }, (e)=>"fill-bridge-guard-rail-color" !== e);
            }
            addVertices(e, t1) {
                const r = this.unevalVertices.length;
                for(let r = 0; r < e.length; r++)this.unevalVertices.push(e[r]), this.unevalHeights.push(t1[r]);
                return r;
            }
            addTriangles(e, t1, r) {
                const n = r ? this.unevalTunnelTriangles : this.unevalTriangles;
                for (const r of e)n.push(r + t1);
            }
            addRenderableRing(e, t1, r, n, i, s) {
                const o = [
                    new Ie(i.min.x, i.min.y),
                    new Ie(i.max.x, i.min.y),
                    new Ie(i.max.x, i.max.y),
                    new Ie(i.min.x, i.max.y)
                ];
                for(let a = 0; a < r - 1; a++){
                    const r = t1 + a, l = r + 1, u = this.unevalVertices[r], c = this.unevalVertices[l];
                    if (!(u.x >= i.min.x && u.x <= i.max.x && u.y >= i.min.y && u.y <= i.max.y || c.x >= i.min.x && c.x <= i.max.x && c.y >= i.min.y && c.y <= i.max.y || Lc(u, c, o))) continue;
                    if (this.isOnBorder(u.x, c.x) || this.isOnBorder(u.y, c.y)) continue;
                    const h = Bp.computeEdgeHash(this.unevalVertices[r], this.unevalVertices[l]);
                    let p, d = this.vertexHashLookup.get(Bp.computePosHash(u));
                    null != d ? p = d.next : (d = this.vertexHashLookup.get(Bp.computePosHash(c)), p = null != d ? d.prev : h), this.unevalEdges.push({
                        polygonIdx: e,
                        a: r,
                        b: l,
                        hash: h,
                        portalHash: p,
                        isTunnel: n,
                        type: "unevaluated",
                        featureInfo: s
                    });
                }
            }
            addPortalCandidates(e, t1, r, n, i) {
                if (0 !== t1.length) {
                    this.vertexHashLookup.clear();
                    for (const i of t1){
                        if (0 === i.length) continue;
                        const t1 = i[0];
                        let s = Bp.computeEdgeHash(t1[t1.length - 2], t1[t1.length - 1]);
                        for(let i = 0; i < t1.length - 1; i++){
                            const o = t1[i + 0], a = t1[i + 1], l = he(a.x - o.x, a.y - o.y), u = ye(l);
                            if (0 === u) continue;
                            let c = "unevaluated";
                            const h = n.pointElevation(o), p = n.pointElevation(a);
                            Math.abs(h) < .01 && Math.abs(p) < .01 ? c = "entrance" : (this.isOnBorder(o.x, a.x) || this.isOnBorder(o.y, a.y)) && (c = "border");
                            const d = Bp.computeEdgeHash(o, a);
                            this.unevaluatedPortals.portals.push({
                                connection: {
                                    a: e,
                                    b: void 0
                                },
                                va: o,
                                vb: a,
                                vab: l,
                                length: u,
                                hash: d,
                                isTunnel: r,
                                type: c
                            });
                            const f = Bp.computePosHash(o);
                            this.vertexHashLookup.set(f, {
                                prev: s,
                                next: d
                            }), s = d;
                        }
                    }
                }
            }
            construct(e) {
                if (0 === this.unevalVertices.length) return;
                const t1 = ()=>({
                        vertexOffset: 0,
                        primitiveOffset: this.indexArray.length
                    }), r = (e)=>{
                    e.primitiveLength = this.indexArray.length - e.primitiveOffset;
                }, n = new Pp(this.vertexPositions, this.vertexNormals, this.indexArray);
                this.prepareEdges(e.portals, this.unevalEdges);
                const i = t1(), s = t1(), o = t1(), a = (e, t1)=>{
                    e.sort((e, r)=>e.type === t1 && r.type !== t1 ? -1 : e.type !== t1 && r.type === t1 ? 1 : 0);
                    const r = e.findIndex((e)=>e.type !== t1);
                    return r >= 0 ? r : e.length;
                };
                let l = 0;
                this.unevalEdges.length > 0 && (l = a(this.unevalEdges, "none"), this.constructBridgeStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                    min: 0,
                    max: l
                }, this.tileToMeters)), r(o);
                const u = t1(), c = t1();
                if (this.unevalEdges.length > 0) {
                    const e = this.unevalEdges.splice(l), t1 = a(e, "tunnel") + l;
                    this.unevalEdges.push(...e), this.constructTunnelStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                        min: 0,
                        max: l
                    }, {
                        min: l,
                        max: t1
                    });
                }
                r(u), n.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), r(c), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), r(s), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, [
                    -0.1
                ]), r(i), this.maskSegments = Rl.simpleSegment(0, c.primitiveOffset, 0, c.primitiveLength), this.depthSegments = Rl.simpleSegment(0, s.primitiveOffset, 0, s.primitiveLength), this.renderableBridgeSegments = Rl.simpleSegment(0, o.primitiveOffset, 0, o.primitiveLength), this.renderableTunnelSegments = Rl.simpleSegment(0, u.primitiveOffset, 0, u.primitiveLength), this.shadowCasterSegments = Rl.simpleSegment(0, i.primitiveOffset, 0, i.primitiveLength);
            }
            update(e, t1, r, n, i, s, o, a) {
                this.bridgeProgramConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, a), this.tunnelProgramConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, a);
            }
            upload(e) {
                this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = e.createVertexBuffer(this.vertexPositions, Zh.members), this.vertexBufferNormal = e.createVertexBuffer(this.vertexNormals, Wh.members), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(e), this.tunnelProgramConfigurations.upload(e));
            }
            destroy() {
                this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(e, t1, r, n, i) {
                const s = (s, o)=>{
                    for(let a = 0; a < o.length - 1; a++){
                        const l = o[a].featureIndex, u = o[a + 1].vertexStart, c = e.feature(l);
                        s.populatePaintArrays(u, c, l, {}, r, t1, n, void 0, i);
                    }
                };
                s(this.bridgeProgramConfigurations, this.bridgeFeatureSections), s(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(e, t1, r, n, i) {
                const s = new Map;
                for(let o = n; o < i; o++){
                    const n = r[o], i = n.a, a = n.b, l = Bp.computePosHash(e[i]), u = Bp.computePosHash(e[a]);
                    let c = s.get(l);
                    c || (c = {}, s.set(l, c));
                    let h = s.get(u);
                    h || (h = {}, s.set(u, h)), t1[i] <= 0 && t1[a] <= 0 || (c.to = a, h.from = i);
                }
                return s;
            }
            isTerminalVertex(e, t1) {
                const r = Bp.computePosHash(this.unevalVertices[e]), n = t1.get(r);
                return !n || !n.from || !n.to;
            }
            constructBridgeStructures(e, t1, r, n, i, s) {
                e.clearVertexLookup();
                const o = this.computeVertexConnections(t1, r, n, i.min, i.max), a = 1 / s, l = .5 * a, u = (e, n)=>S(e, t1[n].x, t1[n].y, r[n] * a), c = _(), h = _(), p = _(), d = _(), f = _(), m = (e, r)=>{
                    const n = o.get(Bp.computePosHash(t1[r])), i = n.from, s = n.to;
                    if (!i || !s) return;
                    u(c, i), u(h, r), u(p, s), q(d), X(c, h) || (H(f, h, c), L(d, f)), X(p, h) || (H(f, p, h), z(d, d, L(f, f)));
                    const a = W(d);
                    return a > 0 ? V(e, d, 1 / a) : void 0;
                };
                let y = Number.POSITIVE_INFINITY;
                this.sortSubarray(n, i.min, i.max, (e, t1)=>e.featureInfo.featureIndex - t1.featureInfo.featureIndex);
                const g = _(), x = _(), v = _(), b = _(), w = _(), A = _(), M = _(), I = _(), P = _(), B = [
                    _(),
                    _(),
                    _(),
                    _()
                ], T = [
                    _(),
                    _(),
                    _(),
                    _()
                ], k = [
                    {
                        coord: new Ie(0, 0),
                        height: 0
                    },
                    {
                        coord: new Ie(0, 0),
                        height: 0
                    }
                ], E = (e, t1)=>e > t1;
                for(let u = i.min; u < i.max; u++){
                    const i = n[u];
                    if (!i.featureInfo.guardRailEnabled) continue;
                    if (!this.prepareEdgePoints(k, t1, r, i, E)) continue;
                    const [c, h] = k;
                    if (S(g, c.coord.x, c.coord.y, a * c.height), S(x, h.coord.x, h.coord.y, a * h.height), X(g, x)) continue;
                    H(v, x, g), L(v, v);
                    const p = m(I, i.a) || v, d = m(P, i.b) || v;
                    S(b, p[1], -p[0], 0), L(b, b), S(w, d[1], -d[0], 0), L(w, w), U(I, b, p), L(A, I), U(I, w, d), L(M, I), z(B[0], g, V(I, H(I, b, A), l)), z(B[1], g, V(I, z(I, b, A), l)), z(B[2], g, V(I, A, l)), B[3] = g, z(T[0], x, V(I, H(I, w, M), l)), z(T[1], x, V(I, z(I, w, M), l)), z(T[2], x, V(I, M, l)), T[3] = x, y = this.addFeatureSection(i.featureInfo.featureIndex, y, this.bridgeFeatureSections, e);
                    const f = e.addVertex(B[0], b, s), _ = e.addVertex(B[1], b, s), F = e.addVertex(T[0], w, s), D = e.addVertex(T[1], w, s);
                    e.addTriangle(f, _, F), e.addTriangle(_, D, F);
                    const C = e.addVertex(B[1], A, s), O = e.addVertex(B[2], A, s), N = e.addVertex(T[1], M, s), j = e.addVertex(T[2], M, s);
                    e.addTriangle(C, O, N), e.addTriangle(O, j, N), R(b, b), R(w, w);
                    const G = e.addVertex(B[2], b, s), $ = e.addVertex(B[3], b, s), q = e.addVertex(T[2], w, s), Z = e.addVertex(T[3], w, s);
                    e.addTriangle(G, $, q), e.addTriangle($, Z, q);
                    const W = this.isTerminalVertex(i.a, o), Y = this.isTerminalVertex(i.b, o);
                    c.height < .01 && W && e.addQuad(B[3], B[2], B[1], B[0], R(p, p), s), h.height < .01 && Y && e.addQuad(T[0], T[1], T[2], T[3], d, s);
                }
                this.bridgeFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e.getVertexCount()
                });
            }
            constructTunnelStructures(e, t1, r, n, i, s) {
                e.clearVertexLookup();
                let o = Number.POSITIVE_INFINITY;
                const a = (e, t1)=>e.featureInfo.featureIndex - t1.featureInfo.featureIndex;
                this.sortSubarray(n, i.min, i.max, a), this.sortSubarray(n, s.min, s.max, a);
                const l = (e)=>L(e, e), u = [
                    {
                        coord: new Ie(0, 0),
                        height: 0
                    },
                    {
                        coord: new Ie(0, 0),
                        height: 0
                    }
                ], c = (e, t1)=>e < t1, h = _(), p = _(), d = _(), f = _(), m = _();
                for(let s = i.min; s < i.max; s++){
                    if (!this.prepareEdgePoints(u, t1, r, n[s], c)) continue;
                    const [i, a] = u, y = l(S(m, -(a.coord.y - i.coord.y), a.coord.x - i.coord.x, 0));
                    o = this.addFeatureSection(n[s].featureInfo.featureIndex, o, this.tunnelFeatureSections, e), e.addQuad(S(h, i.coord.x, i.coord.y, i.height), S(p, a.coord.x, a.coord.y, a.height), S(d, a.coord.x, a.coord.y, n[s].isTunnel ? -0.1 : 0), S(f, i.coord.x, i.coord.y, n[s].isTunnel ? -0.1 : 0), y);
                }
                for(let i = s.min; i < s.max; i++){
                    const s = n[i];
                    s.isTunnel && ([s.a, s.b] = [
                        s.b,
                        s.a
                    ]);
                    const a = t1[s.a], u = t1[s.b], c = l(S(m, -(u.y - a.y), u.x - a.x, 0));
                    o = this.addFeatureSection(s.featureInfo.featureIndex, o, this.tunnelFeatureSections, e), e.addQuad(S(h, u.x, u.y, 0), S(p, a.x, a.y, 0), S(d, a.x, a.y, r[s.a] + 4), S(f, u.x, u.y, r[s.b] + 4), c), e.addQuad(S(h, a.x, a.y, 0), S(p, u.x, u.y, 0), S(d, u.x, u.y, r[s.b] + 4), S(f, a.x, a.y, r[s.a] + 4), c);
                }
                this.tunnelFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e.getVertexCount()
                });
            }
            setElevatedPoint(e, t1, r, n) {
                e.coord.x = t1, e.coord.y = r, e.height = n;
            }
            prepareEdgePoints(e, t1, r, n, i) {
                let s = t1[n.a].x, o = t1[n.a].y, a = t1[n.b].x, l = t1[n.b].y, u = r[n.a], c = r[n.b];
                const h = i(u, 0), p = i(c, 0);
                if (h && p) return this.setElevatedPoint(e[0], s, o, u), this.setElevatedPoint(e[1], a, l, c), !0;
                if (!h && !p) return !1;
                if (h) {
                    if (!p) {
                        const e = c / (c - u);
                        a = hr(a, s, e), l = hr(l, o, e), c = hr(c, u, e);
                    }
                } else {
                    const e = u / (u - c);
                    s = hr(s, a, e), o = hr(o, l, e), u = hr(u, c, e);
                }
                return this.setElevatedPoint(e[0], s, o, u), this.setElevatedPoint(e[1], a, l, c), !0;
            }
            prepareEdges(e, t1) {
                if (0 === t1.length) return;
                t1.sort((e, t1)=>e.hash === t1.hash ? t1.polygonIdx - e.polygonIdx : t1.hash > e.hash ? 1 : -1);
                let r = 0, n = 0, i = 0, s = t1[r].polygonIdx;
                do n++, (n === t1.length || t1[r].hash !== t1[n].hash) && ((1 === n - r || t1[n - 1].polygonIdx !== s) && (i < r && (t1[i] = t1[r], t1[r] = null), t1[i].type = "none", i++), r = n, r !== t1.length && (s = t1[r].polygonIdx));
                while (r !== t1.length);
                if (t1.splice(i), 0 !== t1.length && 0 !== e.length) {
                    t1.sort((e, t1)=>e.portalHash < t1.portalHash ? 1 : -1);
                    let r = 0, n = 0;
                    for(; r !== t1.length && n !== e.length;){
                        const i = t1[r], s = e[n];
                        i.portalHash > s.hash ? r++ : s.hash > i.portalHash ? n++ : (i.type = s.type, r++);
                    }
                }
            }
            isOnBorder(e, t1) {
                return e <= 0 && t1 <= 0 || e >= Un && t1 >= Un;
            }
            addFeatureSection(e, t1, r, n) {
                return e !== t1 && (t1 = e, r.push({
                    featureIndex: e,
                    vertexStart: n.getVertexCount()
                }), n.clearVertexLookup()), t1;
            }
            sortSubarray(e, t1, r, n) {
                const i = e.slice(t1, r);
                i.sort(n), e.splice(t1, i.length, ...i);
            }
            static computeEdgeHash(e, t1) {
                return (e.y === t1.y && e.x > t1.x || e.y > t1.y) && ([e, t1] = [
                    t1,
                    e
                ]), BigInt(Bp.computePosHash(e)) << 32n | BigInt(Bp.computePosHash(t1));
            }
            static computePosHash(e) {
                return ((65535 & e.x) << 16 | 65535 & e.y) >>> 0;
            }
        }
        function Tp(e, t1) {
            return e > t1 ? 1 : e < t1 ? -1 : 0;
        }
        class kp {
            constructor(e = Tp, t1 = !1){
                this._compare = e, this._root = null, this._size = 0, this._noDuplicates = !!t1;
            }
            rotateLeft(e) {
                var t1 = e.right;
                t1 && (e.right = t1.left, t1.left && (t1.left.parent = e), t1.parent = e.parent), e.parent ? e === e.parent.left ? e.parent.left = t1 : e.parent.right = t1 : this._root = t1, t1 && (t1.left = e), e.parent = t1;
            }
            rotateRight(e) {
                var t1 = e.left;
                t1 && (e.left = t1.right, t1.right && (t1.right.parent = e), t1.parent = e.parent), e.parent ? e === e.parent.left ? e.parent.left = t1 : e.parent.right = t1 : this._root = t1, t1 && (t1.right = e), e.parent = t1;
            }
            _splay(e) {
                for(; e.parent;){
                    var t1 = e.parent;
                    t1.parent ? t1.left === e && t1.parent.left === t1 ? (this.rotateRight(t1.parent), this.rotateRight(t1)) : t1.right === e && t1.parent.right === t1 ? (this.rotateLeft(t1.parent), this.rotateLeft(t1)) : t1.left === e && t1.parent.right === t1 ? (this.rotateRight(t1), this.rotateLeft(t1)) : (this.rotateLeft(t1), this.rotateRight(t1)) : t1.left === e ? this.rotateRight(t1) : this.rotateLeft(t1);
                }
            }
            splay(e) {
                for(var t1, r, n, i, s; e.parent;)(r = (t1 = e.parent).parent) && r.parent ? ((n = r.parent).left === r ? n.left = e : n.right = e, e.parent = n) : (e.parent = null, this._root = e), i = e.left, s = e.right, e === t1.left ? (r && (r.left === t1 ? (t1.right ? (r.left = t1.right, r.left.parent = r) : r.left = null, t1.right = r, r.parent = t1) : (i ? (r.right = i, i.parent = r) : r.right = null, e.left = r, r.parent = e)), s ? (t1.left = s, s.parent = t1) : t1.left = null, e.right = t1, t1.parent = e) : (r && (r.right === t1 ? (t1.left ? (r.right = t1.left, r.right.parent = r) : r.right = null, t1.left = r, r.parent = t1) : (s ? (r.left = s, s.parent = r) : r.left = null, e.right = r, r.parent = e)), i ? (t1.right = i, i.parent = t1) : t1.right = null, e.left = t1, t1.parent = e);
            }
            replace(e, t1) {
                e.parent ? e === e.parent.left ? e.parent.left = t1 : e.parent.right = t1 : this._root = t1, t1 && (t1.parent = e.parent);
            }
            minNode(e = this._root) {
                if (e) for(; e.left;)e = e.left;
                return e;
            }
            maxNode(e = this._root) {
                if (e) for(; e.right;)e = e.right;
                return e;
            }
            insert(e, t1) {
                var r = this._root, n = null, i = this._compare;
                if (this._noDuplicates) for(; r;){
                    if (n = r, 0 === i(r.key, e)) return;
                    r = i(r.key, e) < 0 ? r.right : r.left;
                }
                else for(; r;)n = r, r = i(r.key, e) < 0 ? r.right : r.left;
                return r = {
                    key: e,
                    data: t1,
                    left: null,
                    right: null,
                    parent: n
                }, n ? i(n.key, r.key) < 0 ? n.right = r : n.left = r : this._root = r, this.splay(r), this._size++, r;
            }
            find(e) {
                for(var t1 = this._root, r = this._compare; t1;){
                    var n = r(t1.key, e);
                    if (n < 0) t1 = t1.right;
                    else {
                        if (!(n > 0)) return t1;
                        t1 = t1.left;
                    }
                }
                return null;
            }
            contains(e) {
                for(var t1 = this._root, r = this._compare; t1;){
                    var n = r(e, t1.key);
                    if (0 === n) return !0;
                    t1 = n < 0 ? t1.left : t1.right;
                }
                return !1;
            }
            remove(e) {
                var t1 = this.find(e);
                if (!t1) return !1;
                if (this.splay(t1), t1.left) {
                    if (t1.right) {
                        var r = this.minNode(t1.right);
                        r.parent !== t1 && (this.replace(r, r.right), r.right = t1.right, r.right.parent = r), this.replace(t1, r), r.left = t1.left, r.left.parent = r;
                    } else this.replace(t1, t1.left);
                } else this.replace(t1, t1.right);
                return this._size--, !0;
            }
            removeNode(e) {
                if (!e) return !1;
                if (this.splay(e), e.left) {
                    if (e.right) {
                        var t1 = this.minNode(e.right);
                        t1.parent !== e && (this.replace(t1, t1.right), t1.right = e.right, t1.right.parent = t1), this.replace(e, t1), t1.left = e.left, t1.left.parent = t1;
                    } else this.replace(e, e.left);
                } else this.replace(e, e.right);
                return this._size--, !0;
            }
            erase(e) {
                var t1 = this.find(e);
                if (t1) {
                    this.splay(t1);
                    var r = t1.left, n = t1.right, i = null;
                    r && (r.parent = null, i = this.maxNode(r), this.splay(i), this._root = i), n && (r ? i.right = n : this._root = n, n.parent = i), this._size--;
                }
            }
            pop() {
                var e = this._root, t1 = null;
                if (e) {
                    for(; e.left;)e = e.left;
                    t1 = {
                        key: e.key,
                        data: e.data
                    }, this.remove(e.key);
                }
                return t1;
            }
            next(e) {
                var t1 = e;
                if (t1) {
                    if (t1.right) for(t1 = t1.right; t1 && t1.left;)t1 = t1.left;
                    else for(t1 = e.parent; t1 && t1.right === e;)e = t1, t1 = t1.parent;
                }
                return t1;
            }
            prev(e) {
                var t1 = e;
                if (t1) {
                    if (t1.left) for(t1 = t1.left; t1 && t1.right;)t1 = t1.right;
                    else for(t1 = e.parent; t1 && t1.left === e;)e = t1, t1 = t1.parent;
                }
                return t1;
            }
            forEach(e) {
                for(var t1 = this._root, r = [], n = !1, i = 0; !n;)t1 ? (r.push(t1), t1 = t1.left) : r.length > 0 ? (e(t1 = r.pop(), i++), t1 = t1.right) : n = !0;
                return this;
            }
            range(e, t1, r, n) {
                const i = [], s = this._compare;
                let o, a = this._root;
                for(; 0 !== i.length || a;)if (a) i.push(a), a = a.left;
                else {
                    if (a = i.pop(), o = s(a.key, t1), o > 0) break;
                    if (s(a.key, e) >= 0 && r.call(n, a)) return this;
                    a = a.right;
                }
                return this;
            }
            keys() {
                for(var e = this._root, t1 = [], r = [], n = !1; !n;)e ? (t1.push(e), e = e.left) : t1.length > 0 ? (e = t1.pop(), r.push(e.key), e = e.right) : n = !0;
                return r;
            }
            values() {
                for(var e = this._root, t1 = [], r = [], n = !1; !n;)e ? (t1.push(e), e = e.left) : t1.length > 0 ? (e = t1.pop(), r.push(e.data), e = e.right) : n = !0;
                return r;
            }
            at(e) {
                for(var t1 = this._root, r = [], n = !1, i = 0; !n;)if (t1) r.push(t1), t1 = t1.left;
                else if (r.length > 0) {
                    if (t1 = r.pop(), i === e) return t1;
                    i++, t1 = t1.right;
                } else n = !0;
                return null;
            }
            load(e = [], t1 = [], r = !1) {
                if (0 !== this._size) throw new Error("bulk-load: tree is not empty");
                const n = e.length;
                return r && Ep(e, t1, 0, n - 1, this._compare), this._root = Vp(null, e, t1, 0, n), this._size = n, this;
            }
            min() {
                var e = this.minNode(this._root);
                return e ? e.key : null;
            }
            max() {
                var e = this.maxNode(this._root);
                return e ? e.key : null;
            }
            isEmpty() {
                return null === this._root;
            }
            get size() {
                return this._size;
            }
            static createTree(e, t1, r, n, i) {
                return new kp(r, i).load(e, t1, n);
            }
        }
        function Vp(e, t1, r, n, i) {
            const s = i - n;
            if (s > 0) {
                const o = n + Math.floor(s / 2), a = {
                    key: t1[o],
                    data: r[o],
                    parent: e
                };
                return a.left = Vp(a, t1, r, n, o), a.right = Vp(a, t1, r, o + 1, i), a;
            }
            return null;
        }
        function Ep(e, t1, r, n, i) {
            if (r >= n) return;
            const s = e[r + n >> 1];
            let o = r - 1, a = n + 1;
            for(;;){
                do o++;
                while (i(e[o], s) < 0);
                do a--;
                while (i(e[a], s) > 0);
                if (o >= a) break;
                let r = e[o];
                e[o] = e[a], e[a] = r, r = t1[o], t1[o] = t1[a], t1[a] = r;
            }
            Ep(e, t1, r, a, i), Ep(e, t1, a + 1, n, i);
        }
        const Fp = 11102230246251565e-32, Dp = 134217729, Cp = (3 + 8 * Fp) * Fp;
        function Rp(e, t1, r, n, i) {
            let s, o, a, l, u = t1[0], c = n[0], h = 0, p = 0;
            c > u == c > -u ? (s = u, u = t1[++h]) : (s = c, c = n[++p]);
            let d = 0;
            if (h < e && p < r) for(c > u == c > -u ? (o = u + s, a = s - (o - u), u = t1[++h]) : (o = c + s, a = s - (o - c), c = n[++p]), s = o, 0 !== a && (i[d++] = a); h < e && p < r;)c > u == c > -u ? (o = s + u, l = o - s, a = s - (o - l) + (u - l), u = t1[++h]) : (o = s + c, l = o - s, a = s - (o - l) + (c - l), c = n[++p]), s = o, 0 !== a && (i[d++] = a);
            for(; h < e;)o = s + u, l = o - s, a = s - (o - l) + (u - l), u = t1[++h], s = o, 0 !== a && (i[d++] = a);
            for(; p < r;)o = s + c, l = o - s, a = s - (o - l) + (c - l), c = n[++p], s = o, 0 !== a && (i[d++] = a);
            return 0 === s && 0 !== d || (i[d++] = s), d;
        }
        function Lp(e) {
            return new Float64Array(e);
        }
        const Op = Lp(4), Up = Lp(8), Np = Lp(12), jp = Lp(16), Gp = Lp(4);
        function $p(e, t1, r) {
            null === t1 ? (e.inOut = !1, e.otherInOut = !0) : (e.isSubject === t1.isSubject ? (e.inOut = !t1.inOut, e.otherInOut = t1.otherInOut) : (e.inOut = !t1.otherInOut, e.otherInOut = t1.isVertical() ? !t1.inOut : t1.inOut), t1 && (e.prevInResult = !qp(t1, r) || t1.isVertical() ? t1.prevInResult : t1)), e.resultTransition = qp(e, r) ? function(e, t1) {
                let r, n = !e.inOut, i = !e.otherInOut;
                switch(t1){
                    case 0:
                        r = n && i;
                        break;
                    case 1:
                        r = n || i;
                        break;
                    case 3:
                        r = n !== i;
                        break;
                    case 2:
                        r = e.isSubject ? n && !i : i && !n;
                }
                return r ? 1 : -1;
            }(e, r) : 0;
        }
        function qp(e, t1) {
            switch(e.type){
                case 0:
                    switch(t1){
                        case 0:
                            return !e.otherInOut;
                        case 1:
                            return e.otherInOut;
                        case 2:
                            return e.isSubject && e.otherInOut || !e.isSubject && !e.otherInOut;
                        case 3:
                            return !0;
                    }
                    break;
                case 2:
                    return 0 === t1 || 1 === t1;
                case 3:
                    return 2 === t1;
                case 1:
                    return !1;
            }
            return !1;
        }
        class Xp {
            constructor(e, t1, r, n, i){
                this.left = t1, this.point = e, this.otherEvent = r, this.isSubject = n ?? !1, this.type = i || 0, this.inOut = !1, this.otherInOut = !1, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = !0;
            }
            isBelow(e) {
                const t1 = this.point, r = this.otherEvent.point;
                return this.left ? (t1[0] - e[0]) * (r[1] - e[1]) - (r[0] - e[0]) * (t1[1] - e[1]) > 0 : (r[0] - e[0]) * (t1[1] - e[1]) - (t1[0] - e[0]) * (r[1] - e[1]) > 0;
            }
            isAbove(e) {
                return !this.isBelow(e);
            }
            isVertical() {
                return this.point[0] === this.otherEvent.point[0];
            }
            get inResult() {
                return 0 !== this.resultTransition;
            }
            clone() {
                const e = new Xp(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                return e.contourId = this.contourId, e.resultTransition = this.resultTransition, e.prevInResult = this.prevInResult, e.isExteriorRing = this.isExteriorRing, e.inOut = this.inOut, e.otherInOut = this.otherInOut, e;
            }
        }
        function Hp(e, t1) {
            return e[0] === t1[0] && e[1] === t1[1];
        }
        function Zp(e, t1, r) {
            const n = function(e, t1, r, n, i, s) {
                const o = (t1 - s) * (r - i), a = (e - i) * (n - s), l = o - a;
                if (0 === o || 0 === a || o > 0 != a > 0) return l;
                const u = Math.abs(o + a);
                return Math.abs(l) >= 33306690738754716e-32 * u ? l : -function(e, t1, r, n, i, s, o) {
                    let a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A, M;
                    const I = e - i, S = r - i, z = t1 - s, P = n - s;
                    b = I * P, p = Dp * I, d = p - (p - I), f = I - d, p = Dp * P, m = p - (p - P), y = P - m, w = f * y - (b - d * m - f * m - d * y), _ = z * S, p = Dp * z, d = p - (p - z), f = z - d, p = Dp * S, m = p - (p - S), y = S - m, A = f * y - (_ - d * m - f * m - d * y), g = w - A, h = w - g, Op[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, Op[1] = v - (g + h) + (h - _), M = x + g, h = M - x, Op[2] = x - (M - h) + (g - h), Op[3] = M;
                    let B = function(e, t1) {
                        let r = t1[0];
                        for(let e = 1; e < 4; e++)r += t1[e];
                        return r;
                    }(0, Op), T = 22204460492503146e-32 * o;
                    if (B >= T || -B >= T) return B;
                    if (h = e - I, a = e - (I + h) + (h - i), h = r - S, u = r - (S + h) + (h - i), h = t1 - z, l = t1 - (z + h) + (h - s), h = n - P, c = n - (P + h) + (h - s), 0 === a && 0 === l && 0 === u && 0 === c) return B;
                    if (T = 11093356479670487e-47 * o + Cp * Math.abs(B), B += I * c + P * a - (z * u + S * l), B >= T || -B >= T) return B;
                    b = a * P, p = Dp * a, d = p - (p - a), f = a - d, p = Dp * P, m = p - (p - P), y = P - m, w = f * y - (b - d * m - f * m - d * y), _ = l * S, p = Dp * l, d = p - (p - l), f = l - d, p = Dp * S, m = p - (p - S), y = S - m, A = f * y - (_ - d * m - f * m - d * y), g = w - A, h = w - g, Gp[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, Gp[1] = v - (g + h) + (h - _), M = x + g, h = M - x, Gp[2] = x - (M - h) + (g - h), Gp[3] = M;
                    const k = Rp(4, Op, 4, Gp, Up);
                    b = I * c, p = Dp * I, d = p - (p - I), f = I - d, p = Dp * c, m = p - (p - c), y = c - m, w = f * y - (b - d * m - f * m - d * y), _ = z * u, p = Dp * z, d = p - (p - z), f = z - d, p = Dp * u, m = p - (p - u), y = u - m, A = f * y - (_ - d * m - f * m - d * y), g = w - A, h = w - g, Gp[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, Gp[1] = v - (g + h) + (h - _), M = x + g, h = M - x, Gp[2] = x - (M - h) + (g - h), Gp[3] = M;
                    const V = Rp(k, Up, 4, Gp, Np);
                    b = a * c, p = Dp * a, d = p - (p - a), f = a - d, p = Dp * c, m = p - (p - c), y = c - m, w = f * y - (b - d * m - f * m - d * y), _ = l * u, p = Dp * l, d = p - (p - l), f = l - d, p = Dp * u, m = p - (p - u), y = u - m, A = f * y - (_ - d * m - f * m - d * y), g = w - A, h = w - g, Gp[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, Gp[1] = v - (g + h) + (h - _), M = x + g, h = M - x, Gp[2] = x - (M - h) + (g - h), Gp[3] = M;
                    const E = Rp(V, Np, 4, Gp, jp);
                    return jp[E - 1];
                }(e, t1, r, n, i, s, u);
            }(e[0], e[1], t1[0], t1[1], r[0], r[1]);
            return n > 0 ? -1 : n < 0 ? 1 : 0;
        }
        function Wp(e, t1) {
            const r = e.point, n = t1.point;
            return r[0] > n[0] ? 1 : r[0] < n[0] ? -1 : r[1] !== n[1] ? r[1] > n[1] ? 1 : -1 : function(e, t1, r) {
                return e.left !== t1.left ? e.left ? 1 : -1 : 0 !== Zp(r, e.otherEvent.point, t1.otherEvent.point) ? e.isBelow(t1.otherEvent.point) ? -1 : 1 : !e.isSubject && t1.isSubject ? 1 : -1;
            }(e, t1, r);
        }
        function Yp(e, t1, r) {
            const n = new Xp(t1, !1, e, e.isSubject), i = new Xp(t1, !0, e.otherEvent, e.isSubject);
            return Hp(e.point, e.otherEvent.point) && console.warn("what is that, a collapsed segment?", e), n.contourId = i.contourId = e.contourId, Wp(i, e.otherEvent) > 0 && (e.otherEvent.left = !0, i.left = !1), e.otherEvent.otherEvent = i, e.otherEvent = n, r.push(i), r.push(n), r;
        }
        function Jp(e, t1) {
            return e[0] * t1[1] - e[1] * t1[0];
        }
        function Kp(e, t1) {
            return e[0] * t1[0] + e[1] * t1[1];
        }
        function Qp(e, t1, r) {
            const n = function(e, t1, r, n) {
                const i = [
                    t1[0] - e[0],
                    t1[1] - e[1]
                ], s = [
                    n[0] - r[0],
                    n[1] - r[1]
                ];
                function o(e, t1, r) {
                    return [
                        e[0] + t1 * r[0],
                        e[1] + t1 * r[1]
                    ];
                }
                const a = [
                    r[0] - e[0],
                    r[1] - e[1]
                ];
                let l = Jp(i, s), u = l * l;
                const c = Kp(i, i);
                if (u > 0) {
                    const t1 = Jp(a, s) / l;
                    if (t1 < 0 || t1 > 1) return null;
                    const n = Jp(a, i) / l;
                    return n < 0 || n > 1 ? null : 0 === t1 || 1 === t1 ? [
                        o(e, t1, i)
                    ] : 0 === n || 1 === n ? [
                        o(r, n, s)
                    ] : [
                        o(e, t1, i)
                    ];
                }
                if (l = Jp(a, i), u = l * l, u > 0) return null;
                const h = Kp(i, a) / c, p = h + Kp(i, s) / c, d = Math.min(h, p), f = Math.max(h, p);
                return d <= 1 && f >= 0 ? 1 === d ? [
                    o(e, d > 0 ? d : 0, i)
                ] : 0 === f ? [
                    o(e, f < 1 ? f : 1, i)
                ] : [
                    o(e, d > 0 ? d : 0, i),
                    o(e, f < 1 ? f : 1, i)
                ] : null;
            }(e.point, e.otherEvent.point, t1.point, t1.otherEvent.point), i = n ? n.length : 0;
            if (0 === i || 1 === i && (Hp(e.point, t1.point) || Hp(e.otherEvent.point, t1.otherEvent.point)) || 2 === i && e.isSubject === t1.isSubject) return 0;
            if (1 === i) return !Hp(e.point, n[0]) && !Hp(e.otherEvent.point, n[0]) && Yp(e, n[0], r), !Hp(t1.point, n[0]) && !Hp(t1.otherEvent.point, n[0]) && Yp(t1, n[0], r), 1;
            const s = [];
            let o = !1, a = !1;
            return Hp(e.point, t1.point) ? o = !0 : 1 === Wp(e, t1) ? s.push(t1, e) : s.push(e, t1), Hp(e.otherEvent.point, t1.otherEvent.point) ? a = !0 : 1 === Wp(e.otherEvent, t1.otherEvent) ? s.push(t1.otherEvent, e.otherEvent) : s.push(e.otherEvent, t1.otherEvent), o && a || o ? (t1.type = 1, e.type = t1.inOut === e.inOut ? 2 : 3, o && !a && Yp(s[1].otherEvent, s[0].point, r), 2) : a ? (Yp(s[0], s[1].point, r), 3) : s[0] !== s[3].otherEvent ? (Yp(s[0], s[1].point, r), Yp(s[1], s[2].point, r), 3) : (Yp(s[0], s[1].point, r), Yp(s[3].otherEvent, s[2].point, r), 3);
        }
        function ed(e, t1) {
            if (e === t1) return 0;
            if (0 !== Zp(e.point, e.otherEvent.point, t1.point) || 0 !== Zp(e.point, e.otherEvent.point, t1.otherEvent.point)) return Hp(e.point, t1.point) ? e.isBelow(t1.otherEvent.point) ? -1 : 1 : e.point[0] === t1.point[0] ? e.point[1] < t1.point[1] ? -1 : 1 : 1 === Wp(e, t1) ? t1.isAbove(e.point) ? -1 : 1 : e.isBelow(t1.point) ? -1 : 1;
            if (e.isSubject !== t1.isSubject) return e.isSubject ? -1 : 1;
            {
                let r = e.point, n = t1.point;
                if (r[0] === n[0] && r[1] === n[1]) return r = e.otherEvent.point, n = t1.otherEvent.point, r[0] === n[0] && r[1] === n[1] ? 0 : (e.contourId ?? 0) > (t1.contourId ?? 0) ? 1 : -1;
            }
            return 1 === Wp(e, t1) ? 1 : -1;
        }
        class td {
            constructor(){
                this.points = [], this.holeIds = [], this.holeOf = null, this.depth = null;
            }
            isExterior() {
                return null == this.holeOf;
            }
        }
        function rd(e, t1, r, n) {
            let i, s = e + 1, o = t1[e].point;
            const a = t1.length;
            for(s < a && (i = t1[s].point); s < a && i[0] === o[0] && i[1] === o[1];){
                if (!r[s]) return s;
                s++, s < a && (i = t1[s].point);
            }
            for(s = e - 1; r[s] && s > n;)s--;
            return s;
        }
        function nd(e, t1, r) {
            const n = new td;
            if (null != e.prevInResult) {
                const i = e.prevInResult, s = i.outputContourId;
                if (i.resultTransition > 0) {
                    const e = t1[s];
                    if (null != e.holeOf) {
                        const i = e.holeOf;
                        t1[i].holeIds.push(r), n.holeOf = i, n.depth = t1[s].depth;
                    } else t1[s].holeIds.push(r), n.holeOf = s, n.depth = t1[s].depth + 1;
                } else n.holeOf = null, n.depth = t1[s].depth;
            } else n.holeOf = null, n.depth = 0;
            return n;
        }
        const id = Math.max, sd = Math.min;
        let od = 0;
        function ad(e, t1, r, n, i, s) {
            let o, a, l, u, c, h;
            for(o = 0, a = e.length - 1; o < a; o++){
                if (l = e[o], u = e[o + 1], c = new Xp(l, !1, void 0, t1), h = new Xp(u, !1, c, t1), c.otherEvent = h, l[0] === u[0] && l[1] === u[1]) continue;
                c.contourId = h.contourId = r, s || (c.isExteriorRing = !1, h.isExteriorRing = !1), Wp(c, h) > 0 ? h.left = !0 : c.left = !0;
                const a = l[0], p = l[1];
                i[0] = sd(i[0], a), i[1] = sd(i[1], p), i[2] = id(i[2], a), i[3] = id(i[3], p), n.push(c), n.push(h);
            }
        }
        const ld = [];
        function ud(e, t1, r) {
            let n = e, i = t1;
            "number" == typeof e[0][0][0] && (n = [
                e
            ]), "number" == typeof t1[0][0][0] && (i = [
                t1
            ]);
            let s = function(e, t1, r) {
                let n = null;
                return e.length * t1.length === 0 && (0 === r ? n = ld : 2 === r ? n = e : (1 === r || 3 === r) && (n = 0 === e.length ? t1 : e)), n;
            }(n, i, r);
            if (s) return s === ld ? null : s;
            const o = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], a = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], l = function(e, t1, r, n, i) {
                const s = new On(void 0, Wp);
                let o, a, l, u, c, h;
                for(l = 0, u = e.length; l < u; l++)for(o = e[l], c = 0, h = o.length; c < h; c++)a = 0 === c, a && od++, ad(o[c], !0, od, s, r, a);
                for(l = 0, u = t1.length; l < u; l++)for(o = t1[l], c = 0, h = o.length; c < h; c++)a = 0 === c, 2 === i && (a = !1), a && od++, ad(o[c], !1, od, s, n, a);
                return s;
            }(n, i, o, a, r);
            if (s = function(e, t1, r, n, i) {
                let s = null;
                return (r[0] > n[2] || n[0] > r[2] || r[1] > n[3] || n[1] > r[3]) && (0 === i ? s = ld : 2 === i ? s = e : (1 === i || 3 === i) && (s = e.concat(t1))), s;
            }(n, i, o, a, r), s) return s === ld ? null : s;
            const u = function(e, t1, r, n, i, s) {
                const o = new kp(ed), a = [], l = Math.min(n[2], i[2]);
                let u, c, h;
                for(; 0 !== e.length;){
                    let t1 = e.pop();
                    if (a.push(t1), 0 === s && t1.point[0] > l || 2 === s && t1.point[0] > n[2]) break;
                    if (t1.left) {
                        c = u = o.insert(t1), h = o.minNode(), u = u !== h ? o.prev(u) : null, c = o.next(c);
                        const r = u ? u.key : null;
                        let n;
                        if ($p(t1, r, s), c && 2 === Qp(t1, c.key, e) && ($p(t1, r, s), $p(c.key, t1, s)), u && 2 === Qp(u.key, t1, e)) {
                            let e = u;
                            e = e !== h ? o.prev(e) : null, n = e ? e.key : null, $p(r, n, s), $p(t1, r, s);
                        }
                    } else t1 = t1.otherEvent, c = u = o.find(t1), u && c && (u = u !== h ? o.prev(u) : null, c = o.next(c), o.remove(t1), c && u && Qp(u.key, c.key, e));
                }
                return a;
            }(l, 0, 0, o, a, r), c = function(e) {
                let t1, r;
                const n = function(e) {
                    let t1, r, n, i, s;
                    const o = [];
                    for(r = 0, n = e.length; r < n; r++)t1 = e[r], (t1.left && t1.inResult || !t1.left && t1.otherEvent.inResult) && o.push(t1);
                    let a = !1;
                    for(; !a;)for(a = !0, r = 0, n = o.length; r < n; r++)r + 1 < n && 1 === Wp(o[r], o[r + 1]) && (i = o[r], o[r] = o[r + 1], o[r + 1] = i, a = !1);
                    for(r = 0, n = o.length; r < n; r++)t1 = o[r], t1.otherPos = r;
                    for(r = 0, n = o.length; r < n; r++)t1 = o[r], t1.left || (s = t1.otherPos, t1.otherPos = t1.otherEvent.otherPos, t1.otherEvent.otherPos = s);
                    return o;
                }(e), i = {}, s = [];
                for(t1 = 0, r = n.length; t1 < r; t1++){
                    if (i[t1]) continue;
                    const e = s.length, r = nd(n[t1], s, e), o = (t1)=>{
                        i[t1] = !0, t1 < n.length && n[t1] && (n[t1].outputContourId = e);
                    };
                    let a = t1, l = t1;
                    for(r.points.push(n[t1].point); o(a), a = n[a].otherPos, o(a), r.points.push(n[a].point), a = rd(a, n, i, l), !(a == l || a >= n.length) && n[a];);
                    s.push(r);
                }
                return s;
            }(u), h = [];
            for(let e = 0; e < c.length; e++){
                let t1 = c[e];
                if (t1.isExterior()) {
                    let e = [
                        t1.points
                    ];
                    for(let r = 0; r < t1.holeIds.length; r++)e.push(c[t1.holeIds[r]].points);
                    h.push(e);
                }
            }
            return h;
        }
        function cd(e, t1, r, n) {
            const i = [], s = 0 === n ? (e, t1, r, n, i, s)=>{
                e.push(new Ie(s, r + (s - t1) / (n - t1) * (i - r)));
            } : (e, t1, r, n, i, s)=>{
                e.push(new Ie(t1 + (s - r) / (i - r) * (n - t1), s));
            };
            for (const o of e){
                const e = [];
                for (const i of o){
                    if (i.length <= 2) continue;
                    const o = [];
                    for(let e = 0; e < i.length - 1; e++){
                        const a = i[e].x, l = i[e].y, u = i[e + 1].x, c = i[e + 1].y, h = 0 === n ? a : l, p = 0 === n ? u : c;
                        h < t1 ? p > t1 && s(o, a, l, u, c, t1) : h > r ? p < r && s(o, a, l, u, c, r) : o.push(i[e]), p < t1 && h >= t1 && s(o, a, l, u, c, t1), p > r && h <= r && s(o, a, l, u, c, r);
                    }
                    let a = i[i.length - 1];
                    const l = 0 === n ? a.x : a.y;
                    l >= t1 && l <= r && o.push(a), o.length && (a = o[o.length - 1], o[0].x === a.x && o[0].y === a.y || o.push(o[0]), e.push(o));
                }
                e.length && i.push(e);
            }
            return i;
        }
        function hd(e, t1) {
            const r = ud(dd(e), dd([
                t1
            ]), 0);
            return null == r ? [] : fd(r);
        }
        function pd(e, t1) {
            const r = 65536;
            let n = dd(e, r);
            const i = [];
            for(; t1.valid(); t1.next()){
                const [e, n] = t1.get(), s = e.x * r, o = e.y * r, a = n.x * r, l = n.y * r, u = a - s, c = l - o, h = Math.hypot(u, c);
                if (0 === h) continue;
                const p = Math.trunc(c / h * 3), d = -Math.trunc(u / h * 3);
                i.push([
                    [
                        [
                            s,
                            o
                        ],
                        [
                            a,
                            l
                        ],
                        [
                            a + p,
                            l + d
                        ],
                        [
                            s + p,
                            o + d
                        ],
                        [
                            s,
                            o
                        ]
                    ]
                ]);
            }
            return i.length > 0 && (n = ud(n, i, 2)), fd(n, 1 / r, 128);
        }
        function dd(e, t1 = 1) {
            return [
                e.map((e)=>e.map((e)=>[
                            e.x * t1,
                            e.y * t1
                        ]))
            ];
        }
        function fd(e, t1 = 1, r) {
            return e.map((e)=>e.map((e, n)=>{
                    const i = e.map((e)=>{
                        let n = e[0], i = e[1];
                        return r && (n = Math.round(n / r) * r, i = Math.round(i / r) * r), new Ie(n * t1, i * t1)._round();
                    });
                    return n > 0 && i.reverse(), i;
                }));
        }
        class md {
            constructor(e, t1){
                this.layoutVertexArray = new Oa, this.indexArray = new ol, this.lineIndexArray = new tl, this.triangleSegments = new Rl, this.lineSegments = new Rl, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }), this.uploaded = !1, t1 && (this.elevatedLayoutVertexArray = new ja);
            }
            update(e, t1, r, n, i, s, o, a) {
                this.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, a);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
                return this.programConfigurations.needsUpload;
            }
            upload(e) {
                this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, Xh.members), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.lineIndexBuffer = e.createIndexBuffer(this.lineIndexArray), this.elevatedLayoutVertexArray && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = e.createVertexBuffer(this.elevatedLayoutVertexArray, Hh.members))), this.programConfigurations.upload(e), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(e, t1, r, n, i, s, o) {
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, t1, r, n, i, s, void 0, o);
            }
        }
        class yd {
            constructor(e){
                this.zoom = e.zoom, this.pixelRatio = e.pixelRatio, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.hasPattern = !1, this.patternFeatures = [], this.lut = e.lut, this.bufferData = new md(e, !1), this.elevationBufferData = new md(e, !0), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.projection = e.projection, this.elevationMode = this.layers[0].layout.get("fill-elevation-reference"), this.sourceLayerIndex = e.sourceLayerIndex, this.worldview = e.worldview, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {}
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                this.hasPattern = Ip("fill", this.layers, this.pixelRatio, t1);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of e){
                    const e = this.layers[0]._featureFilter.needGeometry, c = Yu(o, e);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, t1.availableImages) : void 0, p = {
                        id: a,
                        properties: o.properties,
                        type: o.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e ? c.geometry : Wu(o, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(p);
                }
                i && s.sort((e, t1)=>e.sortKey - t1.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    if (this.hasPattern) {
                        const e = Sp("fill", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e);
                    } else this.addFeature(n, i, s, r, {}, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    t1.featureIndex.insert(e[s].feature, i, s, o, this.index);
                }
            }
            update(e, t1, r, n, i, s, o) {
                this.bufferData.update(e, t1, r, n, i, s, o, this.worldview), this.elevationBufferData.update(e, t1, r, n, i, s, o, this.worldview), this.elevatedStructures && this.elevatedStructures.update(e, t1, r, n, i, s, o, this.worldview);
            }
            addFeatures(e, t1, r, n, i, s) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t1, r, n, s, e.elevationFeatures);
            }
            isEmpty() {
                return this.bufferData.isEmpty() && this.elevationBufferData.isEmpty();
            }
            uploadPending() {
                return !this.uploaded || this.bufferData.needsUpload() || this.elevationBufferData.needsUpload();
            }
            upload(e) {
                this.bufferData.upload(e), this.elevationBufferData.upload(e), this.elevatedStructures && this.elevatedStructures.upload(e);
            }
            destroy() {
                this.bufferData.destroy(), this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            addFeature(e, t1, r, n, i, s = [], o, a) {
                const l = _p(t1, 500);
                "none" !== this.elevationMode ? this.addElevatedRoadFeature(e, l, n, r, a) : this.addGeometry(l, this.bufferData), this.bufferData.populatePaintArrays(e, r, i, s, n, o, this.worldview), this.elevationBufferData.populatePaintArrays(e, r, i, s, n, o, this.worldview);
            }
            getUnevaluatedPortalGraph() {
                return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            setEvaluatedPortalGraph(e, t1, r, n, i) {
                this.elevatedStructures && (this.elevatedStructures.construct(e), this.elevatedStructures.populatePaintArrays(t1, r, n, i, this.worldview));
            }
            addElevatedRoadFeature(e, t1, r, n, i) {
                const s = new Array, o = _c.getElevationFeature(e, i);
                if (!o) return void this.addGeometry(t1, this.bufferData);
                {
                    const e = this.clipPolygonsToTile(t1, 1);
                    e.length > 0 && s.push({
                        polygons: e,
                        elevationFeature: o,
                        elevationTileID: r
                    });
                }
                const a = {
                    guardRailEnabled: this.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(e, {}, r),
                    featureIndex: n
                };
                for (const t1 of s)if (t1.elevationFeature) {
                    if ("hd-road-base" === this.elevationMode) {
                        this.elevatedStructures || (this.elevatedStructures = new Bp(t1.elevationTileID, this.layers, this.zoom, this.lut));
                        const r = t1.elevationFeature.isTunnel();
                        let n = 0;
                        e.properties.hasOwnProperty(sc) && (n = +e.properties[sc]), this.elevatedStructures.addPortalCandidates(t1.elevationFeature.id, t1.polygons, r, t1.elevationFeature, n);
                    }
                    null == t1.elevationFeature.constantHeight && (t1.polygons = this.prepareElevatedPolygons(t1.polygons, t1.elevationFeature, t1.elevationTileID));
                    const i = new Ac(r, t1.elevationTileID);
                    this.addElevatedGeometry(t1.polygons, i, t1.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : .05, n, a);
                }
            }
            addElevatedGeometry(e, t1, r, n, i, s) {
                const o = {
                    elevation: r,
                    elevationSampler: t1,
                    bias: n,
                    index: i,
                    featureInfo: s
                }, [a, l] = this.addGeometry(e, this.elevationBufferData, o);
                null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = {
                    min: a,
                    max: l
                } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, a), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, l));
            }
            addGeometry(e, t1, r) {
                let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY, s = null;
                r && (s = r.elevationSampler.constantElevation(r.elevation, r.bias), null != s && (n = s, i = s));
                const o = (e, o, a)=>{
                    if (null != r) {
                        if (o.push(e), null != s) t1.elevatedLayoutVertexArray.emplaceBack(s), a.push(s);
                        else {
                            const s = r.elevationSampler.pointElevation(e, r.elevation, r.bias);
                            t1.elevatedLayoutVertexArray.emplaceBack(s), a.push(s), n = Math.min(n, s), i = Math.max(i, s);
                        }
                    }
                };
                for (const n of e){
                    let e = 0;
                    for (const t1 of n)e += t1.length;
                    const i = t1.triangleSegments.prepareSegment(e, t1.layoutVertexArray, t1.indexArray), s = i.vertexLength, a = [], l = [], u = [], c = [], h = [], p = t1.layoutVertexArray.length;
                    for (const e of n){
                        if (0 === e.length) continue;
                        e !== n[0] && l.push(a.length / 2);
                        const i = t1.lineSegments.prepareSegment(e.length, t1.layoutVertexArray, t1.lineIndexArray), s = i.vertexLength;
                        r && h.push(t1.layoutVertexArray.length - p), o(e[0], u, c), t1.layoutVertexArray.emplaceBack(e[0].x, e[0].y), t1.lineIndexArray.emplaceBack(s + e.length - 1, s), a.push(e[0].x), a.push(e[0].y);
                        for(let r = 1; r < e.length; r++)o(e[r], u, c), t1.layoutVertexArray.emplaceBack(e[r].x, e[r].y), t1.lineIndexArray.emplaceBack(s + r - 1, s + r), a.push(e[r].x), a.push(e[r].y);
                        i.vertexLength += e.length, i.primitiveLength += e.length;
                    }
                    const d = Yh(a, l);
                    for(let e = 0; e < d.length; e += 3)t1.indexArray.emplaceBack(s + d[e], s + d[e + 1], s + d[e + 2]);
                    if (d.length > 0 && r && "hd-road-base" === this.elevationMode) {
                        const e = r.elevation.isTunnel(), t1 = r.elevation.safeArea, n = this.elevatedStructures.addVertices(u, c);
                        this.elevatedStructures.addTriangles(d, n, e);
                        const i = h.length;
                        if (i > 0) {
                            for(let s = 0; s < i - 1; s++)this.elevatedStructures.addRenderableRing(r.index, h[s] + n, h[s + 1] - h[s], e, t1, r.featureInfo);
                            this.elevatedStructures.addRenderableRing(r.index, h[i - 1] + n, u.length - h[i - 1], e, t1, r.featureInfo);
                        }
                    }
                    i.vertexLength += e, i.primitiveLength += d.length / 3;
                }
                return [
                    n,
                    i
                ];
            }
            prepareElevatedPolygons(e, t1, r) {
                const n = 1 / Uu(r), i = [];
                for (const r of e){
                    const e = pd(r, new bc(t1, n));
                    i.push(...e);
                }
                return i;
            }
            clipPolygonsToTile(e, t1) {
                const r = -t1, n = -t1, i = Un + t1, s = Un + t1;
                let o = 0;
                const a = [], l = [];
                for(; o < e.length; o++){
                    const t1 = e[o], u = xn(t1);
                    (u.min.x >= r && u.max.x <= i && u.min.y >= n && u.max.y <= s ? a : l).push(t1);
                }
                if (a.length === e.length) return e;
                const u = [
                    new Ie(r, n),
                    new Ie(i, n),
                    new Ie(i, s),
                    new Ie(r, s),
                    new Ie(r, n)
                ], c = a;
                for (const e of l)c.push(...hd(e, u));
                return c;
            }
        }
        let gd, xd, vd, bd;
        Js(yd, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        }), Js(md, "FillBufferData"), Js(Bp, "ElevatedStructures");
        class wd {
            constructor(e, t1, r, n){
                if (this.triangleCount = t1.length / 3, this.min = new Ie(0, 0), this.max = new Ie(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === e.length) return;
                const [i, s] = [
                    e[0].clone(),
                    e[0].clone()
                ];
                for(let t1 = 1; t1 < e.length; ++t1){
                    const r = e[t1];
                    i.x = Math.min(i.x, r.x), i.y = Math.min(i.y, r.y), s.x = Math.max(s.x, r.x), s.y = Math.max(s.y, r.y);
                }
                if (n) {
                    const e = Math.ceil(Math.max(s.x - i.x, s.y - i.y) / n);
                    r = Math.max(r, e);
                }
                if (0 === r) return;
                this.min = i, this.max = s;
                const o = this.max.sub(this.min);
                o.x = Math.max(o.x, 1), o.y = Math.max(o.y, 1);
                const a = Math.max(o.x, o.y) / r;
                this.cellsX = Math.max(1, Math.ceil(o.x / a)), this.cellsY = Math.max(1, Math.ceil(o.y / a)), this.xScale = 1 / a, this.yScale = 1 / a;
                const l = [];
                for(let r = 0; r < this.triangleCount; r++){
                    const n = e[t1[3 * r + 0]].sub(this.min), i = e[t1[3 * r + 1]].sub(this.min), s = e[t1[3 * r + 2]].sub(this.min), o = _d(Math.floor(Math.min(n.x, i.x, s.x)), this.xScale, this.cellsX), u = _d(Math.floor(Math.max(n.x, i.x, s.x)), this.xScale, this.cellsX), c = _d(Math.floor(Math.min(n.y, i.y, s.y)), this.yScale, this.cellsY), h = _d(Math.floor(Math.max(n.y, i.y, s.y)), this.yScale, this.cellsY), p = new Ie(0, 0), d = new Ie(0, 0), f = new Ie(0, 0), m = new Ie(0, 0);
                    for(let e = c; e <= h; ++e){
                        p.y = d.y = e * a, f.y = m.y = (e + 1) * a;
                        for(let t1 = o; t1 <= u; ++t1)p.x = f.x = t1 * a, d.x = m.x = (t1 + 1) * a, (Uc(n, i, s, p, d, m) || Uc(n, i, s, p, m, f)) && l.push({
                            cellIdx: e * this.cellsX + t1,
                            triIdx: r
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((e, t1)=>e.cellIdx - t1.cellIdx || e.triIdx - t1.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const e = l[u].cellIdx, t1 = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === e;)++t1.len, this.payload.push(l[u++].triIdx);
                    this.cells[e] = t1;
                }
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(e, t1) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e.x > this.max.x || this.min.x > e.x || e.y > this.max.y || this.min.y > e.y) return;
                const r = _d(e.x - this.min.x, this.xScale, this.cellsX), n = _d(e.y - this.min.y, this.yScale, this.cellsY), i = this.cells[n * this.cellsX + r];
                if (i) {
                    this._lazyInitLookup();
                    for(let e = 0; e < i.len; e++){
                        const r = this.payload[i.start + e], n = Math.floor(r / 8), s = 1 << r % 8;
                        if (!(this.lookup[n] & s) && (this.lookup[n] |= s, t1.push(r), t1.length === this.triangleCount)) return;
                    }
                }
            }
            query(e, t1, r) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e.x > this.max.x || this.min.x > t1.x) return;
                if (e.y > this.max.y || this.min.y > t1.y) return;
                this._lazyInitLookup();
                const n = _d(e.x - this.min.x, this.xScale, this.cellsX), i = _d(t1.x - this.min.x, this.xScale, this.cellsX), s = _d(e.y - this.min.y, this.yScale, this.cellsY), o = _d(t1.y - this.min.y, this.yScale, this.cellsY);
                for(let e = s; e <= o; e++)for(let t1 = n; t1 <= i; t1++){
                    const n = this.cells[e * this.cellsX + t1];
                    if (n) for(let e = 0; e < n.len; e++){
                        const t1 = this.payload[n.start + e], i = Math.floor(t1 / 8), s = 1 << t1 % 8;
                        if (!(this.lookup[i] & s) && (this.lookup[i] |= s, r.push(t1), r.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function _d(e, t1, r) {
            return Math.max(0, Math.min(r - 1, Math.floor(e * t1)));
        }
        Js(wd, "TriangleGridIndex");
        class Ad {
            constructor(e){
                this.zoom = e.zoom, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.footprints = [], this.worldview = e.worldview, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {
                for (const r of this.footprints)t1.push({
                    footprint: r,
                    id: e
                });
            }
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                const i = [];
                for (const { feature: s, id: o, index: a, sourceLayerIndex: l } of e){
                    const e = this.layers[0]._featureFilter.needGeometry, u = Yu(s, e);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), u, r)) continue;
                    const c = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e ? u.geometry : Wu(s, r, n),
                        patterns: {}
                    };
                    i.push(c);
                }
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    this.addFeature(n, i, s, r, {}, t1.availableImages, t1.brightness), t1.featureIndex.insert(e[s].feature, i, s, o, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(e) {}
            update(e, t1, r, n, i, s, o) {}
            destroy() {}
            addFeature(e, t1, r, n, i, s = [], o) {
                for (const e of _p(t1, 2)){
                    const t1 = [], r = [], n = [], i = new Ie(1 / 0, 1 / 0), s = new Ie(-1 / 0, -1 / 0);
                    for (const o of e)if (0 !== o.length) {
                        o !== e[0] && n.push(r.length / 2);
                        for(let e = 0; e < o.length; e++)r.push(o[e].x), r.push(o[e].y), t1.push(o[e]), i.x = Math.min(i.x, o[e].x), i.y = Math.min(i.y, o[e].y), s.x = Math.max(s.x, o[e].x), s.y = Math.max(s.y, o[e].y);
                    }
                    const o = Yh(r, n), a = new wd(t1, o, 8, 256);
                    this.footprints.push({
                        vertices: t1,
                        indices: o,
                        grid: a,
                        min: i,
                        max: s
                    });
                }
            }
        }
        Js(Ad, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Md = Ra([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Id = Ra([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Sd = Ra([
            {
                name: "a_flood_light_ground_radius",
                components: 1,
                type: "Float32"
            }
        ]), zd = Ra([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Pd = Ra([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Bd = Ra([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Td = Ra([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: kd } = Md, Vd = Number.MAX_SAFE_INTEGER, Ed = Vd - 1;
        function Fd(e, t1, r, n) {
            return e.order < t1 || e.order === Vd || !(e.clipMask & r) || function(e, t1) {
                return 0 !== t1.length && void 0 === t1.find((t1)=>t1 === e);
            }(n, e.clipScope);
        }
        function Dd(e, t1) {
            return e.x - t1.x || e.y - t1.y;
        }
        function Cd(e, t1) {
            return 0 === Dd(e.min, t1.min) && 0 === Dd(e.max, t1.max);
        }
        function Rd(e, t1) {
            return !(e.min.x > t1.max.x || e.max.x < t1.min.x || e.min.y > t1.max.y || e.max.y < t1.min.y);
        }
        function Ld(e, t1) {
            if (e.length !== t1.length) return !1;
            for(let r = 0; r < e.length; r++)if (e[r].sourceId !== t1[r].sourceId || !Cd(e[r], t1[r]) || e[r].order !== t1[r].order || e[r].clipMask !== t1[r].clipMask || !Se(e[r].clipScope, t1[r].clipScope)) return !1;
            return !0;
        }
        function Od(e, t1, r) {
            const n = 1 / Un, i = 1 / (1 << r.canonical.z), s = (t1.x * n + r.canonical.x) * i + r.wrap, o = (t1.y * n + r.canonical.y) * i;
            return {
                min: new Ie((e.x * n + r.canonical.x) * i + r.wrap, (e.y * n + r.canonical.y) * i),
                max: new Ie(s, o)
            };
        }
        function Ud(e, t1, r) {
            const n = 1 << r.canonical.z, i = ((t1.x - r.wrap) * n - r.canonical.x) * Un, s = (t1.y * n - r.canonical.y) * Un;
            return {
                min: new Ie(((e.x - r.wrap) * n - r.canonical.x) * Un, (e.y * n - r.canonical.y) * Un),
                max: new Ie(i, s)
            };
        }
        function Nd(e, t1, r, n, i, s, o) {
            const a = e.indices, l = e.vertices, u = [];
            for(let c = n; c < n + i; c += 3){
                const n = t1[r[c + 0] + s], i = t1[r[c + 1] + s], h = t1[r[c + 2] + s], p = Math.min(n.x, i.x, h.x), d = Math.max(n.x, i.x, h.x), f = Math.min(n.y, i.y, h.y), m = Math.max(n.y, i.y, h.y);
                u.length = 0, e.grid.query(new Ie(p, f), new Ie(d, m), u);
                for(let e = 0; e < u.length; e++){
                    const t1 = u[e];
                    if (Uc(l[a[3 * t1 + 0]], l[a[3 * t1 + 1]], l[a[3 * t1 + 2]], n, i, h, o)) return !0;
                }
            }
            return !1;
        }
        function jd(e, t1, r, n) {
            if (!e || !r) return !1;
            let i = e.vertices;
            if (!t1.canonical.equals(n.canonical) || t1.wrap !== n.wrap) {
                if (r.vertices.length < e.vertices.length) return jd(r, n, e, t1);
                const s = t1.canonical, o = n.canonical, a = Math.pow(2, o.z - s.z);
                i = e.vertices.map((e)=>new Ie((e.x + s.x * Un) * a - o.x * Un, (e.y + s.y * Un) * a - o.y * Un));
            }
            return Nd(r, i, e.indices, 0, e.indices.length, 0, 0);
        }
        function Gd(e, t1, r, n) {
            const i = Math.pow(2, n.z - r.z);
            return new Ie((e + r.x * Un) * i - n.x * Un, (t1 + r.y * Un) * i - n.y * Un);
        }
        function $d(e, t1) {
            const r = [];
            t1.grid.queryPoint(e, r);
            const n = t1.indices, i = t1.vertices;
            for(let t1 = 0; t1 < r.length; t1++){
                const s = r[t1];
                if (Cc([
                    i[n[3 * s + 0]],
                    i[n[3 * s + 1]],
                    i[n[3 * s + 2]]
                ], e)) return !0;
            }
            return !1;
        }
        const qd = [
            new Ie(0, 0),
            new Ie(Un, 0),
            new Ie(Un, Un),
            new Ie(0, Un)
        ];
        function Xd(e, t1) {
            const r = [];
            let n = [];
            if (!t1 || e.length < 2) return [
                e
            ];
            if (2 === e.length) return Lc(e[0], e[1], qd) ? [
                e
            ] : [];
            for(let t1 = 0; t1 < e.length + 2; t1++){
                const i = e[t1 % e.length], s = e[(t1 + 1) % e.length], o = Lc(0 === t1 ? e[e.length - 1] : e[(t1 - 1) % e.length], i, qd), a = Lc(i, s, qd), l = o || a;
                l && n.push(i), l && a || n.length > 0 && (n.length > 1 && r.push(n), n = []);
            }
            return n.length > 1 && r.push(n), r;
        }
        const Hd = Ju.types, Zd = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], Wd = [
            "fill-extrusion-flood-light-ground-radius"
        ], Yd = Math.pow(2, 13), Jd = Math.pow(2, 15) - 1, Kd = new Ie(0, 1), Qd = 2147483648;
        function ef(e, t1, r, n, i, s, o, a) {
            e.emplaceBack((t1 << 1) + o, (r << 1) + s, (Math.floor(n * Yd) << 1) + i, Math.round(a));
        }
        function tf(e, t1, r) {
            e.emplaceBack(t1.x * Un, t1.y * Un, r ? 1 : 0);
        }
        function rf(e, t1, r, n, i, s) {
            e.emplaceBack(t1.x, t1.y, (r.x << 1) + n, (r.y << 1) + i, s);
        }
        function nf(e, t1, r) {
            const n = 16384;
            e.emplaceBack(t1.x, t1.y, t1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class sf {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class of {
            constructor(){
                this.centroidXY = new Ie(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new Ie(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new Ie(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0, this.buildingId = 0;
            }
            span() {
                return new Ie(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class af {
            constructor(){
                this.acc = new Ie(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(e, t1) {
                e.min.x === Number.MAX_VALUE && (e.min.x = e.max.x = t1.x, e.min.y = e.max.y = t1.y);
            }
            appendEdge(e, t1, r) {
                this.accCount++, this.acc._add(t1);
                let n = !!this.borders;
                t1.x < e.min.x ? (e.min.x = t1.x, n = !0) : t1.x > e.max.x && (e.max.x = t1.x, n = !0), t1.y < e.min.y ? (e.min.y = t1.y, n = !0) : t1.y > e.max.y && (e.max.y = t1.y, n = !0), ((0 === t1.x || t1.x === Un) && t1.x === r.x) != ((0 === t1.y || t1.y === Un) && t1.y === r.y) && this.processBorderOverlap(t1, r), n && this.checkBorderIntersection(t1, r);
            }
            checkBorderIntersection(e, t1) {
                t1.x < 0 != e.x < 0 && this.addBorderIntersection(0, hr(t1.y, e.y, (0 - t1.x) / (e.x - t1.x))), t1.x > Un != e.x > Un && this.addBorderIntersection(1, hr(t1.y, e.y, (Un - t1.x) / (e.x - t1.x))), t1.y < 0 != e.y < 0 && this.addBorderIntersection(2, hr(t1.x, e.x, (0 - t1.y) / (e.y - t1.y))), t1.y > Un != e.y > Un && this.addBorderIntersection(3, hr(t1.x, e.x, (Un - t1.y) / (e.y - t1.y)));
            }
            addBorderIntersection(e, t1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[e];
                t1 < r[0] && (r[0] = t1), t1 > r[1] && (r[1] = t1);
            }
            processBorderOverlap(e, t1) {
                if (e.x === t1.x) {
                    if (e.y === t1.y) return;
                    const r = 0 === e.x ? 0 : 1;
                    this.addBorderIntersection(r, t1.y), this.addBorderIntersection(r, e.y);
                } else {
                    const r = 0 === e.y ? 2 : 3;
                    this.addBorderIntersection(r, t1.x), this.addBorderIntersection(r, e.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new Ie(0, 0) : new Ie(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e, t1)=>e + +(t1[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function lf(e, t1) {
            const r = e.add(t1)._unit(), n = De(e.x * r.x + e.y * r.y, -1, 1);
            var i, s, o;
            return o = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(o))) / 4 * Jd * ((i = e).x * (s = t1).y - i.y * s.x < 0 ? -1 : 1);
        }
        const uf = [
            (e)=>e.x < 0,
            (e)=>e.x > Un,
            (e)=>e.y < 0,
            (e)=>e.y > Un
        ];
        function cf(e, t1, r, n) {
            const i = [
                4
            ];
            if (0 === n) return i;
            r._mult(n);
            const s = e.sub(r), o = t1.sub(r), a = [
                e,
                t1,
                s,
                o
            ];
            for(let e = 0; e < 4; e++)for (const t1 of a)if (uf[e](t1)) {
                i.push(e);
                break;
            }
            return i;
        }
        class hf {
            constructor(e){
                this.groundRadiusArray = null, this.groundRadiusBuffer = null, this.vertexArray = new qa, this.indexArray = new ol, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }, (e)=>Wd.includes(e)), this._segments = new Rl, this.hiddenByLandmarkVertexArray = new bl, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new Rl;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e, t1, r, n = !1) {
                const i = e.length;
                if (i > 2) {
                    let s = Math.max(0, this._segments.get().length - 1);
                    const o = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[s].length);
                    let a;
                    s !== this._segments.get().length - 1 && (s++, this._segmentToGroundQuads[s] = [], this._segmentToRegionTriCounts[s] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t1 = e[0], r = e[1];
                        a = lf(t1.sub(e[i - 1])._perp()._unit(), r.sub(t1)._perp()._unit());
                    }
                    for(let l = 0; l < i; l++){
                        const u = l === i - 1 ? 0 : l + 1, c = e[l], h = e[u], p = e[u === i - 1 ? 0 : u + 1], d = h.sub(c)._perp()._unit(), f = lf(d, p.sub(h)._perp()._unit()), m = a, y = f;
                        if (yf(c, h, t1) || n && gf(c, t1) && gf(h, t1)) {
                            a = f;
                            continue;
                        }
                        const g = o.vertexLength;
                        rf(this.vertexArray, c, h, 1, 1, m), rf(this.vertexArray, c, h, 1, 0, m), rf(this.vertexArray, c, h, 0, 1, y), rf(this.vertexArray, c, h, 0, 0, y), o.vertexLength += 4;
                        const x = cf(c, h, d, r);
                        for (const e of x)this._segmentToGroundQuads[s].push({
                            id: g,
                            region: e
                        }), this._segmentToRegionTriCounts[s][e] += 2, o.primitiveLength += 2;
                        a = f;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e = this._segments.get(), t1 = e.length;
                for(let e = 0; e < t1; e++)this._segmentToGroundQuads[e].sort((e, t1)=>e.region - t1.region);
                for(let r = 0; r < t1; r++){
                    const t1 = this._segmentToGroundQuads[r], n = e[r], i = this._segmentToRegionTriCounts[r];
                    i.reduce((e, t1)=>e + t1, 0);
                    let s = 0;
                    for(let e = 0; e <= 4; e++){
                        const t1 = i[e];
                        if (0 !== t1) {
                            let r = this.regionSegments[e];
                            r || (r = this.regionSegments[e] = new Rl);
                            const i = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + s,
                                vertexLength: n.vertexLength,
                                primitiveLength: t1
                            };
                            r.get().push(i);
                        }
                        s += t1;
                    }
                    for(let e = 0; e < t1.length; e++){
                        const r = t1[e].id;
                        this.indexArray.emplaceBack(r, r + 1, r + 3), this.indexArray.emplaceBack(r, r + 3, r + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e, t1, r, n, i, s, o) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e, t1, r, n, i, s, void 0, o);
            }
            upload(e) {
                this.hasData() && (this.vertexBuffer = e.createVertexBuffer(this.vertexArray, Id.members), this.indexBuffer = e.createIndexBuffer(this.indexArray), null != this.groundRadiusArray && (this.groundRadiusBuffer = e.createVertexBuffer(this.groundRadiusArray, Sd.members)));
            }
            uploadPaintProperties(e) {
                this.hasData() && this.programConfigurations.upload(e);
            }
            update(e, t1, r, n, i, s, o, a) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e, t1, r, n, i, s, o, a);
            }
            updateHiddenByLandmark(e) {
                this.updateHiddenByLandmarkRange(e.groundVertexArrayOffset, e.groundVertexCount, !!(e.flags & Qd));
            }
            updateHiddenByLandmarkRange(e, t1, r) {
                if (!this.hasData()) return;
                const n = t1 + e;
                if (0 !== t1) {
                    for(let t1 = e; t1 < n; ++t1)this.hiddenByLandmarkVertexArray.emplace(t1, r ? 1 : 0);
                    this._needsHiddenByLandmarkUpdate = !0;
                }
            }
            uploadHiddenByLandmark(e) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e.createVertexBuffer(this.hiddenByLandmarkVertexArray, Bd.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this.groundRadiusBuffer && this.groundRadiusBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e = 0; e <= 4; e++){
                        const t1 = this.regionSegments[e];
                        t1 && t1.destroy();
                    }
                }
            }
        }
        class pf {
            constructor(e){
                this.zoom = e.zoom, this.canonical = e.canonical, this.overscaling = e.overscaling, this.layers = e.layers, this.pixelRatio = e.pixelRatio, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new ol, this.footprintVertices = new Oa, this.footprintSegments = [], this.layoutVertexArray = new Na, this.centroidVertexArray = new kl, this.wallVertexArray = new El, this.indexArray = new ol, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }, (e)=>Zd.includes(e)), this.segments = new Rl, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.groundEffect = new hf(e), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [], this.worldview = e.worldview, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {}
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                this.features = [], this.hasPattern = Ip("fill-extrusion", this.layers, this.pixelRatio, t1), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = Uu(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: i, id: s, index: o, sourceLayerIndex: a } of e){
                    const e = this.layers[0]._featureFilter.needGeometry, l = Yu(i, e);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: a,
                        index: o,
                        geometry: e ? l.geometry : Wu(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === Hd[u.type];
                    if (this.hasPattern) this.features.push({
                        featureId: i.id,
                        feature: Sp("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, t1)
                    });
                    else if (this.wallMode) for (const e of u.geometry)for (const s of Xd(e, h))this.addFeature(i.id, u, [
                        s
                    ], o, r, {}, t1.availableImages, n, t1.brightness);
                    else this.addFeature(i.id, u, u.geometry, o, r, {}, t1.availableImages, n, t1.brightness);
                    t1.featureIndex.insert(i, u.geometry, o, a, this.index, c);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e, t1, r, n, i, s) {
                for (const { featureId: e, feature: o } of this.features){
                    const a = "Polygon" === Hd[o.type], { geometry: l } = o;
                    if (this.wallMode) for (const u of l)for (const l of Xd(u, a))this.addFeature(e, o, [
                        l
                    ], o.index, t1, r, n, i, s);
                    else this.addFeature(e, o, l, o.index, t1, r, n, i, s);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e, t1, r, n, i, s, o) {
                this.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, this.worldview), this.groundEffect.update(e, t1, i, r, n, s, o, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e) {
                this.uploaded || (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, kd), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.wallVertexBuffer = e.createVertexBuffer(this.wallVertexArray, Pd.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e.createVertexBuffer(this.layoutVertexExtArray, Td.members, !0)), this.groundEffect.upload(e)), this.groundEffect.uploadPaintProperties(e), this.programConfigurations.upload(e), this.uploaded = !0;
            }
            uploadCentroid(e) {
                this.groundEffect.uploadHiddenByLandmark(e), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e.createVertexBuffer(this.centroidVertexArray, zd.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e, t1, r, n, i, s, o, a, l) {
                const u = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, c = [
                    new Ie(0, 0),
                    new Ie(Un, Un)
                ], h = a.projection, p = "globe" === h.name, d = this.wallMode || "Polygon" === Hd[t1.type], f = new af;
                f.centroidDataIndex = this.centroidData.length;
                const m = new of;
                m.buildingId = e, t1.properties && t1.properties.hasOwnProperty("building_id") && (m.buildingId = Number(t1.properties.building_id));
                const y = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, i) <= 0, g = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, i);
                let x;
                if (m.height = g, m.vertexArrayOffset = this.layoutVertexArray.length, m.groundVertexArrayOffset = this.groundEffect.vertexArray.length, p && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Ya), this.wallMode) {
                    if (p) return void Ze("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== r.length) return;
                    x = function(e) {
                        const t1 = e[0].x === e[e.length - 1].x && e[0].y === e[e.length - 1].y, r = function(e) {
                            let t1 = 0;
                            const r = e.length;
                            for(let n = 0; n < r; n++)t1 += (e[(n + 1) % r].x - e[n].x) * (e[(n + 1) % r].y + e[n].y);
                            return t1 >= 0;
                        }(e);
                        r || (e = e.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, i = [], s = [], o = [];
                        let a = e.length;
                        for(; a >= 2 && e[a - 1].equals(e[a - 2]);)a--;
                        if (a < (t1 ? 3 : 2)) return n;
                        let l, u, c, h, p, d = 0;
                        for(; d < a - 1 && e[d].equals(e[d + 1]);)d++;
                        t1 && (l = e[a - 2], p = e[d].sub(l)._unit()._perp());
                        for(let r = d; r < a; r++){
                            if (c = r === a - 1 ? t1 ? e[d + 1] : void 0 : e[r + 1], c && e[r].equals(c)) continue;
                            p && (h = p), l && (u = l), l = e[r], p = c ? c.sub(l)._unit()._perp() : h, h = h || p;
                            let n = h.add(p);
                            0 === n.x && 0 === n.y || n._unit();
                            const f = n.x * p.x + n.y * p.y, m = 0 !== f ? 1 / f : 1 / 0, y = h.x * p.y - h.y * p.x > 0;
                            let g = "miter";
                            const x = 2;
                            "miter" === g && m > x && (g = "bevel"), "bevel" === g && (m > 100 && (g = "flipbevel"), m < x && (g = "miter"));
                            const v = (e, t1, r, n)=>{
                                const a = new Ie(e.x, e.y), l = new Ie(e.x, e.y);
                                a.x += t1.x * n, a.y += t1.y * n, l.x -= t1.x * Math.max(r, 1), l.y -= t1.y * Math.max(r, 1), o.push(t1), i.push(a), s.push(l);
                            };
                            if ("miter" === g) n._mult(m), v(l, n, 0, 0);
                            else if ("flipbevel" === g) n = p.mult(-1), v(l, n, 0, 0), v(l, n.mult(-1), 0, 0);
                            else {
                                const e = -Math.sqrt(m * m - 1), t1 = y ? e : 0, r = y ? 0 : e;
                                u && v(l, h, t1, r), c && v(l, p, t1, r);
                            }
                        }
                        n.geometry = [
                            ...i,
                            ...s.reverse(),
                            i[0]
                        ], n.joinNormals = [
                            ...o,
                            ...o.reverse(),
                            o[o.length - 1]
                        ];
                        const f = n.geometry.length - 1;
                        for(let e = 0; e < f / 2; e++)if (e + 1 < f / 2) {
                            let t1 = e, r = e + 1, i = f - 1 - e, s = f - 2 - e;
                            t1 = 0 === t1 ? f - 1 : t1 - 1, r = 0 === r ? f - 1 : r - 1, i = 0 === i ? f - 1 : i - 1, s = 0 === s ? f - 1 : s - 1, n.indices.push(i), n.indices.push(r), n.indices.push(t1), n.indices.push(i), n.indices.push(s), n.indices.push(r);
                        }
                        return n;
                    }(r[0]), r = [
                        x.geometry
                    ];
                }
                const v = (e, t1)=>e < (t1.length - 1) / 2 || e === t1.length - 1, b = this.wallMode ? [
                    r
                ] : _p(r, 500);
                for(let e = b.length - 1; e >= 0; e--){
                    const t1 = b[e];
                    (0 === t1.length || xf(t1[0])) && b.splice(e, 1);
                }
                let w;
                if (p) w = _f(b, c, i);
                else {
                    w = [];
                    for (const e of b)w.push({
                        polygon: e,
                        bounds: c
                    });
                }
                const _ = d ? this.edgeRadius : 0, A = _ > 0 && this.zoom < 17, M = (e, t1)=>{
                    if (0 === e.length) return !1;
                    const r = e[e.length - 1];
                    return t1.x === r.x && t1.y === r.y;
                };
                for (const { polygon: e, bounds: t1 } of w){
                    let r = 0, n = 0;
                    for (const t1 of e)d && !t1[0].equals(t1[t1.length - 1]) && t1.push(t1[0]), n += d ? t1.length - 1 : t1.length;
                    const s = this.segments.prepareSegment((d ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    m.footprintSegIdx < 0 && (m.footprintSegIdx = this.footprintSegments.length), m.polygonSegIdx < 0 && (m.polygonSegIdx = this.polygonSegments.length);
                    const o = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, a = new sf;
                    if (a.vertexOffset = this.footprintVertices.length, a.indexOffset = 3 * this.footprintIndices.length, a.ringIndices = [], d) {
                        const n = [], o = [];
                        r = s.vertexLength;
                        for(let r = 0; r < e.length; r++){
                            const l = e[r];
                            l.length && 0 !== r && o.push(n.length / 2);
                            const c = [];
                            let d, f;
                            d = l[1].sub(l[0])._perp()._unit(), a.ringIndices.push(l.length - 1);
                            for(let e = 1; e < l.length; e++){
                                const t1 = l[e], r = l[e === l.length - 1 ? 1 : e + 1], o = t1.clone();
                                if (_) {
                                    f = r.sub(t1)._perp()._unit();
                                    const e = d.add(f)._unit(), n = _ * Math.min(4, 1 / (d.x * e.x + d.y * e.y));
                                    o.x += n * e.x, o.y += n * e.y, o.x = Math.round(o.x), o.y = Math.round(o.y), d = f;
                                }
                                if (!y || 0 !== _ && !A || M(c, o) || c.push(o), ef(this.layoutVertexArray, o.x, o.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const t1 = v(e, l);
                                    tf(this.wallVertexArray, x.joinNormals[e], !t1);
                                }
                                s.vertexLength++, this.footprintVertices.emplaceBack(t1.x, t1.y), n.push(t1.x, t1.y), p && nf(this.layoutVertexExtArray, h.projectTilePoint(o.x, o.y, i), h.upVector(i, o.x, o.y));
                            }
                            y && (0 === _ || A) && (0 !== c.length && M(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u));
                        }
                        const l = this.wallMode ? x.indices : Yh(n, o);
                        for(let e = 0; e < l.length; e += 3)this.footprintIndices.emplaceBack(a.vertexOffset + l[e + 0], a.vertexOffset + l[e + 1], a.vertexOffset + l[e + 2]), this.indexArray.emplaceBack(r + l[e], r + l[e + 2], r + l[e + 1]), s.primitiveLength++;
                        a.indexCount += l.length, a.vertexCount += this.footprintVertices.length - a.vertexOffset;
                    }
                    for(let n = 0; n < e.length; n++){
                        const o = e[n];
                        f.startRing(m, o[0]);
                        let a = o.length > 4 && vf(o[o.length - 2], o[0], o[1]), l = _ ? ff(o[o.length - 2], o[0], o[1], _) : 0;
                        const c = [];
                        let g, b, w;
                        b = o[1].sub(o[0])._perp()._unit();
                        let A = !0;
                        for(let e = 1, n = 0; e < o.length; e++){
                            let u = o[e - 1], d = o[e];
                            const I = o[e === o.length - 1 ? 1 : e + 1];
                            if (f.appendEdge(m, d, u), yf(d, u, t1)) {
                                _ && (b = I.sub(d)._perp()._unit(), A = !A);
                                continue;
                            }
                            const S = d.sub(u)._perp(), z = S.x / (Math.abs(S.x) + Math.abs(S.y)), P = S.y > 0 ? 1 : 0, B = u.dist(d);
                            if (n + B > 32768 && (n = 0), _) {
                                w = I.sub(d)._perp()._unit();
                                let e = mf(u, d, I, df(b, w), _);
                                isNaN(e) && (e = 0);
                                const t1 = d.sub(u)._unit();
                                u = u.add(t1.mult(l))._round(), d = d.add(t1.mult(-e))._round(), l = e, b = w, y && this.zoom >= 17 && (M(c, u) || c.push(u), M(c, d) || c.push(d));
                            }
                            const T = s.vertexLength, k = o.length > 4 && vf(u, d, I);
                            let V = bf(n, a, A);
                            if (ef(this.layoutVertexArray, u.x, u.y, z, P, 0, 0, V), ef(this.layoutVertexArray, u.x, u.y, z, P, 0, 1, V), this.wallMode) {
                                const t1 = v(e - 1, o), r = x.joinNormals[e - 1];
                                tf(this.wallVertexArray, r, t1), tf(this.wallVertexArray, r, t1);
                            }
                            if (n += B, V = bf(n, k, !A), a = k, ef(this.layoutVertexArray, d.x, d.y, z, P, 0, 0, V), ef(this.layoutVertexArray, d.x, d.y, z, P, 0, 1, V), this.wallMode) {
                                const t1 = v(e, o), r = x.joinNormals[e];
                                tf(this.wallVertexArray, r, t1), tf(this.wallVertexArray, r, t1);
                            }
                            if (s.vertexLength += 4, this.indexArray.emplaceBack(T + 0, T + 1, T + 2), this.indexArray.emplaceBack(T + 1, T + 3, T + 2), s.primitiveLength += 2, _) {
                                const n = r + (1 === e ? o.length - 2 : e - 2), i = 1 === e ? r : n + 1;
                                if (this.indexArray.emplaceBack(T + 1, n, T + 3), this.indexArray.emplaceBack(n, i, T + 3), s.primitiveLength += 2, void 0 === g && (g = T), !yf(I, o[e], t1)) {
                                    const t1 = e === o.length - 1 ? g : s.vertexLength;
                                    this.indexArray.emplaceBack(T + 2, T + 3, t1), this.indexArray.emplaceBack(T + 3, t1 + 1, t1), this.indexArray.emplaceBack(T + 3, i, t1 + 1), s.primitiveLength += 3;
                                }
                                A = !A;
                            }
                            if (p) {
                                const e = this.layoutVertexExtArray, t1 = h.projectTilePoint(u.x, u.y, i), r = h.projectTilePoint(d.x, d.y, i), n = h.upVector(i, u.x, u.y), s = h.upVector(i, d.x, d.y);
                                nf(e, t1, n), nf(e, t1, n), nf(e, r, s), nf(e, r, s);
                            }
                        }
                        d && (r += o.length - 1), y && _ && this.zoom >= 17 && (0 !== c.length && M(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u, _ > 0));
                    }
                    this.footprintSegments.push(a), o.triangleCount = this.indexArray.length - o.triangleArrayOffset, this.polygonSegments.push(o), ++m.footprintSegLen, ++m.polygonSegLen;
                }
                if (m.vertexCount = this.layoutVertexArray.length - m.vertexArrayOffset, m.groundVertexCount = this.groundEffect.vertexArray.length - m.groundVertexArrayOffset, 0 !== m.vertexCount) {
                    if (m.centroidXY = f.borders ? Kd : this.encodeCentroid(f, m), this.centroidData.push(m), f.borders) {
                        this.featuresOnBorder.push(f);
                        const e = this.featuresOnBorder.length - 1;
                        for(let t1 = 0; t1 < f.borders.length; t1++)f.borders[t1][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t1].push(e);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, n, s, o, i, l, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t1, n, s, o, i, l, this.worldview), this.maxHeight = Math.max(this.maxHeight, g);
                }
            }
            sortBorders() {
                for(let e = 0; e < this.borderFeatureIndices.length; e++)this.borderFeatureIndices[e].sort((t1, r)=>this.featuresOnBorder[t1].borders[e][0] - this.featuresOnBorder[r].borders[e][0]);
            }
            splitToSubtiles() {
                const e = [];
                for(let t1 = 0; t1 < this.centroidData.length; t1++){
                    const r = this.centroidData[t1], n = +(r.min.y + r.max.y > Un), i = 2 * n + (+(r.min.x + r.max.x > Un) ^ n);
                    for(let n = 0; n < r.polygonSegLen; n++){
                        const s = r.polygonSegIdx + n;
                        e.push({
                            centroidIdx: t1,
                            subtile: i,
                            polygonSegmentIdx: s,
                            triangleSegmentIdx: this.polygonSegments[s].triangleSegIdx
                        });
                    }
                }
                const t1 = new ol;
                e.sort((e, t1)=>e.triangleSegmentIdx === t1.triangleSegmentIdx ? e.subtile - t1.subtile : e.triangleSegmentIdx - t1.triangleSegmentIdx);
                let r = 0, n = 0, i = 0;
                for (const t1 of e){
                    if (t1.triangleSegmentIdx !== r) break;
                    i++;
                }
                const s = e.length;
                for(; n !== e.length;){
                    r = e[n].triangleSegmentIdx;
                    let o = 0, a = n, l = n;
                    for(let t1 = a; t1 < i && e[t1].subtile === o; t1++)l++;
                    for(; a !== i;){
                        const n = e[a];
                        o = n.subtile;
                        const s = this.centroidData[n.centroidIdx].min.clone(), u = this.centroidData[n.centroidIdx].max.clone(), c = {
                            vertexOffset: this.segments.segments[r].vertexOffset,
                            primitiveOffset: t1.length,
                            vertexLength: this.segments.segments[r].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let r = a; r < l; r++){
                            const n = e[r], i = this.polygonSegments[n.polygonSegmentIdx], o = this.centroidData[n.centroidIdx].min, a = this.centroidData[n.centroidIdx].max, l = this.indexArray.uint16;
                            for(let e = i.triangleArrayOffset; e < i.triangleArrayOffset + i.triangleCount; e++)t1.emplaceBack(l[3 * e], l[3 * e + 1], l[3 * e + 2]);
                            c.primitiveLength += i.triangleCount, s.x = Math.min(s.x, o.x), s.y = Math.min(s.y, o.y), u.x = Math.max(u.x, a.x), u.y = Math.max(u.y, a.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: s,
                            max: u
                        }), a = l;
                        for(let t1 = a; t1 < i && e[t1].subtile === e[a].subtile; t1++)l++;
                    }
                    n = i;
                    for(let t1 = n; t1 < s && e[t1].triangleSegmentIdx === e[n].triangleSegmentIdx; t1++)i++;
                }
                t1._trim(), this.indexArray = t1;
            }
            getVisibleSegments(e, t1, r) {
                const n = new Rl;
                if (this.wallMode) {
                    for (const e of this.triangleSubSegments)n.segments.push(e.segment);
                    return n;
                }
                let i = 0, s = 0;
                const o = 1 << e.canonical.z;
                if (t1) {
                    const r = t1.getMinMaxForTile(e);
                    r && (i = r.min, s = r.max);
                }
                s += this.maxHeight;
                const a = e.toUnwrapped();
                let l;
                const u = [
                    a.canonical.x / o + a.wrap,
                    a.canonical.y / o
                ], c = [
                    (a.canonical.x + 1) / o + a.wrap,
                    (a.canonical.y + 1) / o
                ], h = (e, t1, r)=>[
                        e[0] * (1 - r[0]) + t1[0] * r[0],
                        e[1] * (1 - r[1]) + t1[1] * r[1]
                    ], p = [], d = [];
                for (const e of this.triangleSubSegments){
                    p[0] = e.min.x / Un, p[1] = e.min.y / Un, d[0] = e.max.x / Un, d[1] = e.max.y / Un;
                    const t1 = h(u, c, p), o = h(u, c, d);
                    if (0 === new vc([
                        t1[0],
                        t1[1],
                        i
                    ], [
                        o[0],
                        o[1],
                        s
                    ]).intersectsPrecise(r)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const a = e.segment;
                    l && l.vertexOffset !== a.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += a.vertexLength, l.primitiveLength += a.primitiveLength) : l = {
                        vertexOffset: a.vertexOffset,
                        primitiveLength: a.primitiveLength,
                        vertexLength: a.vertexLength,
                        primitiveOffset: a.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(e, t1) {
                const r = e.centroid(), n = t1.span(), i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), s = Math.min(7, Math.round(n.y * this.tileToMeter / 10));
                return new Ie(De(r.x, 1, 8191) << 3 | i, De(r.y, 1, 8191) << 3 | s);
            }
            encodeBorderCentroid(e) {
                if (!e.borders) return new Ie(0, 0);
                const t1 = e.borders, r = Number.MAX_VALUE;
                if (t1[0][0] !== r || t1[1][0] !== r) {
                    const e = t1[0][0] !== r ? 0 : 1;
                    return new Ie(6 | (t1[0][0] !== r ? 0 : 65528), (t1[e][0] + t1[e][1]) / 2 << 3 | 6);
                }
                {
                    const e = t1[2][0] !== r ? 2 : 3;
                    return new Ie((t1[e][0] + t1[e][1]) / 2 << 3 | 6, 6 | (t1[2][0] !== r ? 0 : 65528));
                }
            }
            showCentroid(e) {
                const t1 = this.centroidData[e.centroidDataIndex];
                t1.flags &= Qd, t1.centroidXY.x = 0, t1.centroidXY.y = 0, this.writeCentroidToBuffer(t1);
            }
            writeCentroidToBuffer(e) {
                this.groundEffect.updateHiddenByLandmark(e);
                const t1 = e.vertexArrayOffset, r = e.vertexCount + e.vertexArrayOffset, n = e.flags & Qd ? Kd : e.centroidXY, i = this.centroidVertexArray.geta_centroid_pos0(t1);
                if (this.centroidVertexArray.geta_centroid_pos1(t1) !== n.y || i !== n.x) {
                    for(let e = t1; e < r; ++e)this.centroidVertexArray.emplace(e, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e of this.centroidData)this.writeCentroidToBuffer(e);
            }
            updateReplacement(e, t1, r) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e.toUnwrapped());
                if (Ld(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e of this.centroidData)e.flags &= 2147483647;
                const i = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < r) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e.canonical.z));
                    if (t1.footprint.buildingIds) for (const e of this.centroidData)e.flags & Qd || t1.min.x > e.max.x || e.min.x > t1.max.x || t1.min.y > e.max.y || e.min.y > t1.max.y || t1.footprint.buildingIds.has(e.buildingId) && (e.flags |= Qd);
                    else for (const r of this.centroidData)if (!(r.flags & Qd || t1.min.x > r.max.x || r.min.x > t1.max.x || t1.min.y > r.max.y || r.min.y > t1.max.y)) for(let s = 0; s < r.footprintSegLen; s++){
                        const o = this.footprintSegments[r.footprintSegIdx + s];
                        if (i.length = 0, Af(this.footprintVertices, o.vertexOffset, o.vertexCount, t1.footprintTileId.canonical, e.canonical, i), Nd(t1.footprint, i, this.footprintIndices.uint16, o.indexOffset, o.indexCount, -o.vertexOffset, -n)) {
                            r.flags |= Qd;
                            break;
                        }
                    }
                }
                for (const e of this.centroidData)this.writeCentroidToBuffer(e);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e, t1, r) {
                let n = !1;
                for(let i = 0; i < r.footprintSegLen; i++){
                    const s = this.footprintSegments[r.footprintSegIdx + i];
                    let o = 0;
                    for (const r of s.ringIndices){
                        for(let i = o, a = r + o - 1; i < r + o; a = i++){
                            const r = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 0], o = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (a + s.vertexOffset) + 1];
                            o > t1 != l > t1 && e < (this.footprintVertices.int16[2 * (a + s.vertexOffset) + 0] - r) * (t1 - o) / (l - o) + r && (n = !n);
                        }
                        o = r;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(e, t1) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (e + Un) * Un + (t1 + Un);
                if (this.partLookup.hasOwnProperty(i)) {
                    const e = this.partLookup[i];
                    return e ? {
                        height: e.height,
                        hidden: !!(e.flags & Qd)
                    } : void 0;
                }
                for (const s of this.centroidData)e > s.max.x || s.min.x > e || t1 > s.max.y || s.min.y > t1 || s.height <= r || this.footprintContainsPoint(e, t1, s) && (r = s.height, this.partLookup[i] = s, n = !!(s.flags & Qd));
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.partLookup[i] = void 0;
            }
        }
        function df(e, t1) {
            const r = e.add(t1)._unit();
            return e.x * r.x + e.y * r.y;
        }
        function ff(e, t1, r, n) {
            const i = t1.sub(e)._perp()._unit(), s = r.sub(t1)._perp()._unit();
            return mf(e, t1, r, df(i, s), n);
        }
        function mf(e, t1, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(e.dist(t1) / 3, t1.dist(r) / 3, i * s / n);
        }
        function yf(e, t1, r) {
            return e.x < r[0].x && t1.x < r[0].x || e.x > r[1].x && t1.x > r[1].x || e.y < r[0].y && t1.y < r[0].y || e.y > r[1].y && t1.y > r[1].y;
        }
        function gf(e, t1) {
            return e.x < t1[0].x || e.x > t1[1].x || e.y < t1[0].y || e.y > t1[1].y;
        }
        function xf(e) {
            return e.every((e)=>e.x <= 0) || e.every((e)=>e.x >= Un) || e.every((e)=>e.y <= 0) || e.every((e)=>e.y >= Un);
        }
        function vf(e, t1, r) {
            if (e.x < 0 || e.x >= Un || t1.x < 0 || t1.x >= Un || r.x < 0 || r.x >= Un) return !1;
            const n = r.sub(t1), i = n.perp(), s = e.sub(t1);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function bf(e, t1, r) {
            const n = t1 ? 2 | e : -3 & e;
            return r ? 1 | n : -2 & n;
        }
        function wf() {
            const e = Math.PI / 32, t1 = Math.tan(e), r = Iu;
            return r * Math.sqrt(1 + 2 * t1 * t1) - r;
        }
        function _f(e, t1, r) {
            const n = 1 << r.z, i = Eu(r.x / n), s = Eu((r.x + 1) / n), o = Fu(r.y / n), a = Fu((r.y + 1) / n);
            return function(e, t1, r, n, i = 0, s) {
                const o = [];
                if (!e.length || !r || !n) return o;
                const a = (e, t1)=>{
                    for (const r of e)o.push({
                        polygon: r,
                        bounds: t1
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let e = 0; e < Math.abs(c); e++)h.push(c > 0 ? 0 : 1);
                for(let e = 0; e < Math.min(l, u); e++)h.push(0), h.push(1);
                let p = e;
                if (p = cd(p, t1[0].y - i, t1[1].y + i, 1), p = cd(p, t1[0].x - i, t1[1].x + i, 0), !p.length) return o;
                const d = [];
                for(h.length ? d.push({
                    polygons: p,
                    bounds: t1,
                    depth: 0
                }) : a(p, t1); d.length;){
                    const e = d.pop(), t1 = e.depth, r = h[t1], n = e.bounds[0], o = e.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? o.x : o.y, c = s ? s(r, l, u) : .5 * (l + u), p = cd(e.polygons, l - i, c + i, r), f = cd(e.polygons, c - i, u + i, r);
                    if (p.length) {
                        const e = [
                            n,
                            new Ie(0 === r ? c : o.x, 1 === r ? c : o.y)
                        ];
                        h.length > t1 + 1 ? d.push({
                            polygons: p,
                            bounds: e,
                            depth: t1 + 1
                        }) : a(p, e);
                    }
                    if (f.length) {
                        const e = [
                            new Ie(0 === r ? c : n.x, 1 === r ? c : n.y),
                            o
                        ];
                        h.length > t1 + 1 ? d.push({
                            polygons: f,
                            bounds: e,
                            depth: t1 + 1
                        }) : a(f, e);
                    }
                }
                return o;
            }(e, t1, Math.ceil((s - i) / 11.25), Math.ceil((o - a) / 11.25), 1, (e, t1, i)=>{
                if (0 === e) return .5 * (t1 + i);
                {
                    const e = Fu((r.y + t1 / Un) / n);
                    return (ku(.5 * (Fu((r.y + i / Un) / n) + e)) * n - r.y) * Un;
                }
            });
        }
        function Af(e, t1, r, n, i, s) {
            const o = Math.pow(2, n.z - i.z);
            for(let a = 0; a < r; a++){
                let r = e.int16[2 * (a + t1) + 0], l = e.int16[2 * (a + t1) + 1];
                r = (r + i.x * Un) * o - n.x * Un, l = (l + i.y * Un) * o - n.y * Un, s.push(new Ie(r, l));
            }
        }
        let Mf, If;
        Js(pf, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Js(of, "PartData"), Js(sf, "FootprintSegment"), Js(af, "BorderCentroidData"), Js(hf, "GroundEffect");
        class Sf extends Ie {
            constructor(e, t1, r){
                super(e, t1), this.z = r;
            }
        }
        class zf extends Sf {
            constructor(e, t1, r, n){
                super(e, t1, r), this.w = n;
            }
        }
        function Pf(e, t1, r, n) {
            const i = "x" === r ? "y" : "x", s = (n - e[r]) / (t1[r] - e[r]);
            e[i] = Math.round(e[i] + (t1[i] - e[i]) * s), e[r] = n, e.hasOwnProperty("z") && (e.z = hr(e.z, t1.z, s)), e.hasOwnProperty("w") && (e.w = hr(e.w, t1.w, s));
        }
        function Bf(e, t1, r, n) {
            const i = r, s = n;
            for (const r of [
                "x",
                "y"
            ]){
                let n = e, o = t1;
                n[r] >= o[r] && (n = t1, o = e), n[r] < i && o[r] > i && Pf(n, o, r, i), n[r] < s && o[r] > s && Pf(o, n, r, s);
            }
        }
        function Tf(e, t1, r, n, i, s) {
            const o = [];
            for(let a = 0; a < e.length; a++){
                const l = e[a];
                let u;
                const c = o.length;
                let h = 0;
                for(let e = 0; e < l.length - 1; e++){
                    let c = l[e], p = l[e + 1], d = 0;
                    const f = h;
                    let m, y;
                    s && (d = Math.hypot(p.x - c.x, p.y - c.y), h += d, m = c, y = p), c.x < t1 && p.x < t1 || (c.x < t1 ? c = new Ie(t1, c.y + (t1 - c.x) / (p.x - c.x) * (p.y - c.y))._round() : p.x < t1 && (p = new Ie(t1, c.y + (t1 - c.x) / (p.x - c.x) * (p.y - c.y))._round()), c.y < r && p.y < r || (c.y < r ? c = new Ie(c.x + (r - c.y) / (p.y - c.y) * (p.x - c.x), r)._round() : p.y < r && (p = new Ie(c.x + (r - c.y) / (p.y - c.y) * (p.x - c.x), r)._round()), c.x >= n && p.x >= n || (c.x >= n ? c = new Ie(n, c.y + (n - c.x) / (p.x - c.x) * (p.y - c.y))._round() : p.x >= n && (p = new Ie(n, c.y + (n - c.x) / (p.x - c.x) * (p.y - c.y))._round()), c.y >= i && p.y >= i || (c.y >= i ? c = new Ie(c.x + (i - c.y) / (p.y - c.y) * (p.x - c.x), i)._round() : p.y >= i && (p = new Ie(c.x + (i - c.y) / (p.y - c.y) * (p.x - c.x), i)._round()), u && c.equals(u[u.length - 1]) || (u = [
                        c
                    ], o.push(u), s && s.push({
                        progress: {
                            min: f + Vf(m, y, c) * d,
                            max: 1
                        },
                        parentIndex: a,
                        prevPoint: m,
                        nextPoint: y
                    })), u.push(p), s && (s[s.length - 1].progress.max = f + Vf(m, y, p) * d, s[s.length - 1].nextPoint = y)))));
                }
                if (s && h > 0) for(let e = c; e < o.length; e++)s[e].progress.min /= h, s[e].progress.max /= h;
            }
            return o;
        }
        function kf(e, t1, r, n, i) {
            if (e.length < 2) return void n.push(e);
            const s = [];
            for(; t1.valid();){
                const [r, n] = t1.get();
                for(let t1 = 0; t1 < e.length - 1; t1++){
                    const i = e[t1], o = e[t1 + 1], a = Vc(i, o, r, n);
                    if (a) {
                        const [e] = a, r = new Ie(hr(i.x, o.x, e), hr(i.y, o.y, e));
                        s.push({
                            t: t1 + e,
                            distance: 0,
                            point: r
                        });
                    }
                }
                t1.next();
            }
            if (0 === s.length) return void n.push(e);
            s.sort((e, t1)=>e.t - t1.t);
            let o = 0, a = 0, l = [];
            for(n.push(l); o !== e.length;){
                if (a === s.length) {
                    for(; o !== e.length;)0 !== l.length && l[l.length - 1].equals(e[o]) || l.push(e[o]), o++;
                    break;
                }
                s[a].t <= o ? (0 !== l.length && l[l.length - 1].equals(s[a].point) || l.push(s[a].point), s[a].t, a++) : (0 !== l.length && l[l.length - 1].equals(e[o]) || l.push(e[o]), o++);
            }
        }
        function Vf(e, t1, r) {
            return e.x !== t1.x ? (r.x - e.x) / (t1.x - e.x) : e.y !== t1.y ? (r.y - e.y) / (t1.y - e.y) : 0;
        }
        function Ef(e, t1) {
            return e.x * t1.x + e.y * t1.y;
        }
        function Ff(e, t1) {
            if (1 === e.length) {
                let r = 0;
                const n = t1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = t1[r++], !i) return 1 / 0;
                for(; r < t1.length; r++){
                    const s = t1[r], o = e[0], a = i.sub(n), l = s.sub(n), u = o.sub(n), c = Ef(a, a), h = Ef(a, l), p = Ef(l, l), d = Ef(u, a), f = Ef(u, l), m = c * p - h * h, y = (p * d - h * f) / m, g = (c * f - h * d) / m, x = n.z * (1 - y - g) + i.z * y + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let e = 1 / 0;
                for (const r of t1)e = Math.min(e, r.z);
                return e;
            }
        }
        function Df(e, t1, r) {
            let n = 1 / 0;
            zc(r, t1) && (n = Ff(r, t1[0]));
            for(let i = 0; i < t1.length; i++){
                const s = t1[i], o = e[i];
                for(let e = 0; e < s.length - 1; e++){
                    const t1 = s[e], i = [
                        t1,
                        s[e + 1],
                        o[e + 1],
                        o[e],
                        t1
                    ];
                    Ic(r, i) && (n = Math.min(n, Ff(r, i)));
                }
            }
            return n !== 1 / 0 && n;
        }
        function Cf(e, t1, r, n, i, s, o, a, l, u, c) {
            return "globe" === e.projection.name ? function(e, t1, r, n, i, s, o, a, l, u, c) {
                const h = [], p = [], d = e.projection.upVectorScale(c, e.center.lat, e.worldSize).metersToTile, f = [
                    0,
                    0,
                    0,
                    1
                ], m = [
                    0,
                    0,
                    0,
                    1
                ], y = (e, t1, r, n)=>{
                    e[0] = t1, e[1] = r, e[2] = n, e[3] = 1;
                }, g = wf();
                r > 0 && (r += g), n += g;
                for (const g of t1){
                    const t1 = [], x = [];
                    for (const h of g){
                        const p = h.x + i.x, g = h.y + i.y, v = e.projection.projectTilePoint(p, g, c), b = e.projection.upVector(c, h.x, h.y);
                        let w = r, _ = n;
                        if (o) {
                            const e = Rf(p, g, r, n, o, a, l, u);
                            w += e.base, _ += e.top;
                        }
                        0 !== r ? y(f, v.x + b[0] * d * w, v.y + b[1] * d * w, v.z + b[2] * d * w) : y(f, v.x, v.y, v.z), y(m, v.x + b[0] * d * _, v.y + b[1] * d * _, v.z + b[2] * d * _), j(f, f, s), j(m, m, s), t1.push(new Sf(f[0], f[1], f[2])), x.push(new Sf(m[0], m[1], m[2]));
                    }
                    h.push(t1), p.push(x);
                }
                return [
                    h,
                    p
                ];
            }(e, t1, r, n, i, s, o, a, l, u, c) : o ? function(e, t1, r, n, i, s, o, a, l) {
                const u = [], c = [], h = [
                    0,
                    0,
                    0,
                    1
                ];
                for (const p of e){
                    const e = [], d = [];
                    for (const u of p){
                        const c = u.x + n.x, p = u.y + n.y, f = Rf(c, p, t1, r, s, o, a, l);
                        h[0] = c, h[1] = p, h[2] = f.base, h[3] = 1, ee(h, h, i), h[3] = Math.max(h[3], 1e-5);
                        const m = new Sf(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        h[0] = c, h[1] = p, h[2] = f.top, h[3] = 1, ee(h, h, i), h[3] = Math.max(h[3], 1e-5);
                        const y = new Sf(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        e.push(m), d.push(y);
                    }
                    u.push(e), c.push(d);
                }
                return [
                    u,
                    c
                ];
            }(t1, r, n, i, s, o, a, l, u) : function(e, t1, r, n, i) {
                const s = [], o = [], a = i[8] * t1, l = i[9] * t1, u = i[10] * t1, c = i[11] * t1, h = i[8] * r, p = i[9] * r, d = i[10] * r, f = i[11] * r;
                for (const t1 of e){
                    const e = [], r = [];
                    for (const s of t1){
                        const t1 = s.x + n.x, o = s.y + n.y, m = i[0] * t1 + i[4] * o + i[12], y = i[1] * t1 + i[5] * o + i[13], g = i[2] * t1 + i[6] * o + i[14], x = i[3] * t1 + i[7] * o + i[15], v = m + a, b = y + l, w = g + u, _ = Math.max(x + c, 1e-5), A = m + h, M = y + p, I = g + d, S = Math.max(x + f, 1e-5);
                        e.push(new Sf(v / _, b / _, w / _)), r.push(new Sf(A / S, M / S, I / S));
                    }
                    s.push(e), o.push(r);
                }
                return [
                    s,
                    o
                ];
            }(t1, r, n, i, s);
        }
        function Rf(e, t1, r, n, i, s, o, a) {
            const l = o * i.getElevationAt(e, t1, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? o * (s[0] / 7 - 450) : o * function(e, t1, r) {
                const n = Math.floor(t1[0] / 8), i = Math.floor(t1[1] / 8), s = 10 * (t1[0] - 8 * n), o = 10 * (t1[1] - 8 * i), a = e.getElevationAt(n, i, !0, !0), l = e.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (o * l - 1)), h = e.tileCoordToPixel(n, i), p = 2 * u + 1, d = 2 * c + 1, f = function(e, t1, r, n, i) {
                    return [
                        e.getElevationAtPixel(t1, r, !0),
                        e.getElevationAtPixel(t1 + i, r, !0),
                        e.getElevationAtPixel(t1, r + i, !0),
                        e.getElevationAtPixel(t1 + n, r + i, !0)
                    ];
                }(e, h.x - u, h.y - c, p, d), m = Math.abs(f[0] - f[1]), y = Math.abs(f[2] - f[3]), g = Math.abs(f[0] - f[2]) + Math.abs(f[1] - f[3]), x = Math.min(.25, .5 * l * (m + y) / p), v = Math.min(.25, .5 * l * g / d);
                return a + Math.max(x * s, v * o);
            }(i, s, a) : l;
            return {
                base: l + (0 === r ? -1 : r),
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        class Lf {
            constructor(e){
                this._callback = e, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class Of {
            constructor(){
                this.tasks = {}, this.taskQueue = [], je([
                    "process"
                ], this), this.invoker = new Lf(this.process), this.nextId = 0;
            }
            add(e, t1) {
                const r = this.nextId++, n = function({ type: e, isSymbolTile: t1, zoom: r }) {
                    return r = r || 0, "message" === e ? 0 : "maybePrepare" !== e || t1 ? "parseTile" !== e || t1 ? "parseTile" === e && t1 ? 300 - r : "maybePrepare" === e && t1 ? 400 - r : 500 : 200 - r : 100 - r;
                }(t1);
                if (0 === n) {
                    e();
                    return null;
                }
                return this.tasks[r] = {
                    fn: e,
                    metadata: t1,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                {
                    if (this.taskQueue = this.taskQueue.filter((e)=>!!this.tasks[e]), !this.taskQueue.length) return;
                    const e = this.pick();
                    if (null === e) return;
                    const t1 = this.tasks[e];
                    if (delete this.tasks[e], this.taskQueue.length && this.invoker.trigger(), !t1) return;
                    t1.fn();
                }
            }
            pick() {
                let e = null, t1 = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < t1 && (t1 = n.priority, e = r);
                }
                if (null === e) return null;
                const r = this.taskQueue[e];
                return this.taskQueue.splice(e, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
        }
        class Uf {
            constructor(e, t1, r){
                this.target = e, this.parent = t1, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, je([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new Of;
            }
            send(e, t1, r, n, i = !1, s) {
                const o = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[o] = r);
                const a = new Set;
                return this.target.postMessage({
                    id: o,
                    type: e,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: Qs(t1, a)
                }, a), {
                    cancel: ()=>{
                        r && delete this.callbacks[o], this.target.postMessage({
                            id: o,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(e) {
                const t1 = e.data;
                if (!t1) return;
                const r = t1.id;
                if (r && (!t1.targetMapId || this.mapId === t1.targetMapId)) {
                    if ("<cancel>" === t1.type) {
                        const e = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], e && e.cancel();
                    } else if (t1.mustQueue || Ke(self)) {
                        const e = this.callbacks[r], n = this.scheduler.add(()=>this.processTask(r, t1), e && e.metadata || {
                            type: "message"
                        });
                        n && (this.cancelCallbacks[r] = n);
                    } else this.processTask(r, t1);
                }
            }
            processTask(e, t1) {
                if (delete this.cancelCallbacks[e], "<response>" === t1.type) {
                    const r = this.callbacks[e];
                    delete this.callbacks[e], r && (t1.error ? r(eo(t1.error)) : r(null, eo(t1.data)));
                } else {
                    const r = new Set, n = t1.hasCallback ? (t1, n)=>{
                        this.target.postMessage({
                            id: e,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: t1 ? Qs(t1) : null,
                            data: Qs(n, r)
                        }, r);
                    } : ()=>{}, i = eo(t1.data);
                    if (this.parent[t1.type]) this.parent[t1.type](t1.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const e = t1.type.split("."), { source: r, scope: s } = i;
                        this.parent.getWorkerSource(t1.sourceMapId, e[0], r, s)[e[1]](i, n);
                    } else n(new Error(`Could not find function ${t1.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }
        var Nf = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        function jf(e) {
            return null != Nf.workerClass ? new Nf.workerClass : new self.Worker(Nf.workerUrl, Object.assign({
                name: e
            }, Nf.workerParams));
        }
        const Gf = "mapboxgl_preloaded_worker_pool";
        class $f {
            constructor(e){
                this.active = {}, this.name = e;
            }
            acquire(e, t1 = $f.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < t1;){
                    const t1 = jf(`${this.name || ""}WorkerPool: ${e}-${this.workers.length}`);
                    this.workers.push(t1);
                }
                return this.active[e] = !0, this.workers.slice();
            }
            release(e) {
                delete this.active[e], this.workers && 0 === this.numActive() && (this.workers.forEach((e)=>{
                    e.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Gf];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        $f.workerCount = 2;
        class qf {
            constructor(e, t1, r = "Worker", n = $f.workerCount){
                this.workerPool = e, this.actors = [], this.currentActor = 0, this.id = Ue();
                const i = this.workerPool.acquire(this.id, n);
                for(let e = 0; e < i.length; e++){
                    const n = new qf.Actor(i[e], t1, this.id);
                    n.name = `${r} ${e}`, this.actors.push(n);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(e, t1, r) {
                Le(this.actors, (r, n)=>{
                    r.send(e, t1, n);
                }, r = r || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e)=>{
                    e.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        let Xf, Hf;
        function Zf() {
            return Xf || (Xf = new $f), Xf;
        }
        qf.Actor = Uf;
        const Wf = 4096;
        class Yf {
            constructor(e){
                this.module = e, this.memoryStack = this.module.malloc(Wf), this.memoryStackNextFree = this.memoryStack;
            }
            createIntArray(e) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e.length * Int32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Wf ? -1 : (new Int32Array(this.module.heap32.buffer, t1, e.length).set(e), t1);
            }
            createFloatArray(e) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e.length * Float32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Wf ? -1 : (new Float32Array(this.module.heapF32.buffer, t1, e.length).set(e), t1);
            }
            readStringBuffer(e) {
                let t1 = "";
                for(; 0 !== this.module.heapU8[e];)t1 += String.fromCharCode(this.module.heapU8[e]), ++e;
                return t1;
            }
            setStyle(e) {
                const t1 = e.normalScale;
                this.module.setStyle(t1[0], t1[1], t1[2], e.tileToMeters);
            }
            setAOOptions(e, t1) {
                this.module.setAOOptions(e ? 1 : 0, t1);
            }
            setMetricOptions(e, t1) {
                this.module.setMetricOptions(e ? 1 : 0, t1);
            }
            setStructuralOptions(e) {
                this.module.setStructuralOptions(e ? 1 : 0);
            }
            setFacadeOptions(e, t1) {
                this.module.setFacadeOptions(e, t1 ? 1 : 0);
            }
            setFauxFacadeOptions(e, t1, r) {
                this.module.setFauxFacadeOptions(e ? 1 : 0, t1 ? 1 : 0, r);
            }
            setFacadeClassifierOptions(e) {
                this.module.setFacadeClassifierOptions(e);
            }
            generateMesh(e, t1) {
                this.memoryStackNextFree = this.memoryStack;
                for (const t1 of e){
                    const e = this.createIntArray(t1.ringIndices), r = this.createFloatArray(t1.coordinates);
                    if (-1 === e || -1 === r) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFeature(t1.id, t1.sourceId, t1.minHeight, t1.height, t1.roofType, r, e, t1.ringIndices.length - 1);
                }
                for (const e of t1){
                    let t1;
                    t1 = e.entrances ? JSON.parse(e.entrances) : [];
                    const r = this.createFloatArray(t1), n = this.createFloatArray(e.coordinates);
                    if (-1 === r || -1 === n) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFacade(e.sourceId, e.crossPerc, e.distanceToRoad, r, t1.length, n, e.coordinates.length);
                }
                if (!this.module.generateMesh()) {
                    const e = this.module.getLastError();
                    return this.readStringBuffer(e);
                }
                const r = this.module.getMeshCount(), n = new Array(r);
                for(let e = 0; e < r; e++){
                    const t1 = this.module.getPositionsPtr(e), r = this.module.getPositionsLength(e), i = new Float32Array(this.module.heapF32.buffer, t1, r), s = this.module.getNormalsPtr(e), o = this.module.getNormalsLength(e), a = new Float32Array(this.module.heapF32.buffer, s, o), l = this.module.getAOPtr(e), u = this.module.getAOLength(e), c = new Float32Array(this.module.heapF32.buffer, l, u), h = this.module.getUVPtr(e), p = this.module.getUVLength(e), d = new Float32Array(this.module.heapF32.buffer, h, p), f = this.module.getFauxFacadePtr(e), m = this.module.getFauxFacadeLength(e), y = new Uint8Array(this.module.heapU8.buffer, f, m), g = this.module.getIndicesPtr(e), x = this.module.getIndicesLength(e), v = new Int16Array(this.module.heap16.buffer, g, x), b = this.module.getBuildingPart(e);
                    n[e] = {
                        positions: i,
                        normals: a,
                        ao: c,
                        uv: d,
                        isFauxFacade: y,
                        indices: v,
                        buildingPart: b
                    };
                }
                const i = this.module.getRingCount(), s = [];
                for(let e = 0; e < i; e++){
                    const t1 = this.module.getRingPtr(e), r = this.module.getRingLength(e), n = new Float32Array(this.module.heapF32.buffer, t1, r);
                    s.push(n);
                }
                return {
                    meshes: n,
                    outerRingLength: this.module.getOuterRingLength(),
                    modifiedPolygonRings: s
                };
            }
        }
        let Jf, Kf, Qf, em, tm, rm = null, nm = null, im = null, sm = null;
        function om() {
            return Ke(self) && self.worker.dracoUrl ? self.worker.dracoUrl : Kf || at.DRACO_URL;
        }
        function am() {
            if (Ke(self) && self.worker.meshoptUrl) return self.worker.meshoptUrl;
            if (em) return em;
            const e = new Uint8Array([
                0,
                97,
                115,
                109,
                1,
                0,
                0,
                0,
                1,
                4,
                1,
                96,
                0,
                0,
                3,
                3,
                2,
                0,
                0,
                5,
                3,
                1,
                0,
                1,
                12,
                1,
                0,
                10,
                22,
                2,
                12,
                0,
                65,
                0,
                65,
                0,
                65,
                0,
                252,
                10,
                0,
                0,
                11,
                7,
                0,
                65,
                0,
                253,
                15,
                26,
                11
            ]);
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return em = WebAssembly.validate(e) ? at.MESHOPT_SIMD_URL : at.MESHOPT_URL, em;
        }
        function lm() {
            return sm;
        }
        const um = 5120, cm = 5121, hm = 5122, pm = 5123, dm = 5125, fm = 5126, mm = {
            [um]: Int8Array,
            [cm]: Uint8Array,
            [hm]: Int16Array,
            [pm]: Uint16Array,
            [dm]: Uint32Array,
            [fm]: Float32Array
        }, ym = {
            [um]: "DT_INT8",
            [cm]: "DT_UINT8",
            [hm]: "DT_INT16",
            [pm]: "DT_UINT16",
            [dm]: "DT_UINT32",
            [fm]: "DT_FLOAT32"
        }, gm = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function xm(e, t1, r) {
            const n = r.json.bufferViews.length, i = r.buffers.length;
            t1.bufferView = n, r.json.bufferViews[n] = {
                buffer: i,
                byteLength: e.byteLength
            }, r.buffers[i] = e;
        }
        const vm = "KHR_draco_mesh_compression";
        function bm(e, t1) {
            const r = e.extensions && e.extensions[vm];
            if (!r) return;
            const n = new Qf.Decoder, i = zm(t1, r.bufferView), s = new Qf.Mesh;
            if (!n.DecodeArrayToMesh(i, i.byteLength, s)) throw new Error("Failed to decode Draco mesh");
            const o = t1.json.accessors[e.indices], a = mm[o.componentType], l = o.count * a.BYTES_PER_ELEMENT, u = Qf._malloc(l);
            a === Uint16Array ? n.GetTrianglesUInt16Array(s, l, u) : n.GetTrianglesUInt32Array(s, l, u), xm(Qf.memory.buffer.slice(u, u + l), o, t1), Qf._free(u);
            for (const i of Object.keys(r.attributes)){
                const o = n.GetAttributeByUniqueId(s, r.attributes[i]), a = t1.json.accessors[e.attributes[i]], l = ym[a.componentType], u = a.count * gm[a.type] * mm[a.componentType].BYTES_PER_ELEMENT, c = Qf._malloc(u);
                n.GetAttributeDataArrayForAllPoints(s, o, Qf[l], u, c), xm(Qf.memory.buffer.slice(c, c + u), a, t1), Qf._free(c);
            }
            n.destroy(), s.destroy(), delete e.extensions[vm];
        }
        const wm = "EXT_meshopt_compression";
        function _m(e, t1) {
            if (!e.extensions || !e.extensions[wm]) return;
            const r = e.extensions[wm], n = new Uint8Array(t1.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0), i = new Uint8Array(r.count * r.byteStride);
            tm.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), e.buffer = t1.buffers.length, e.byteOffset = 0, t1.buffers[e.buffer] = i.buffer, delete e.extensions[wm];
        }
        const Am = 1179937895, Mm = new TextDecoder("utf8");
        function Im(e, t1) {
            return new URL(e, t1).href;
        }
        async function Sm(e, t1, r, n, i) {
            const s = await fetch(Im(e.uri, n), {
                signal: i
            }), o = await s.arrayBuffer();
            t1.buffers[r] = o;
        }
        function zm(e, t1) {
            const r = e.json.bufferViews[t1];
            return new Uint8Array(e.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
        }
        async function Pm(e, t1, r, n, i) {
            if (e.uri) {
                const s = Im(e.uri, n), o = await fetch(s, {
                    signal: i
                }), a = await o.blob(), l = await createImageBitmap(a);
                t1.images[r] = l;
            } else if (void 0 !== e.bufferView) {
                const n = zm(t1, e.bufferView), i = new Blob([
                    n
                ], {
                    type: e.mimeType
                }), s = await createImageBitmap(i);
                t1.images[r] = s;
            }
        }
        async function Bm(e, t1 = 0, r, n) {
            const i = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e, t1, 1)[0] === Am) {
                const r = new Uint32Array(e, t1);
                let n = 2;
                const s = (r[n++] >> 2) - 3, o = r[n++] >> 2;
                if (n++, i.json = JSON.parse(Mm.decode(r.subarray(n, n + o))), n += o, n < s) {
                    const s = r[n++];
                    n++;
                    const o = t1 + (n << 2);
                    i.buffers[0] = e.slice(o, o + s);
                }
            } else i.json = JSON.parse(Mm.decode(new Uint8Array(e, t1)));
            const { buffers: s, images: o, meshes: a, extensionsUsed: l, bufferViews: u } = i.json;
            if (s) {
                const e = [];
                for(let t1 = 0; t1 < s.length; t1++){
                    const o = s[t1];
                    o.uri ? e.push(Sm(o, i, t1, r, n)) : i.buffers[t1] || (i.buffers[t1] = null);
                }
                await Promise.all(e);
            }
            if (n && n.aborted) throw new DOMException("Aborted", "AbortError");
            const c = [], h = l && l.includes(vm), p = l && l.includes(wm);
            if (h && c.push(function() {
                if (!Qf) return null != Jf ? Jf : (Jf = function(e) {
                    let t1, r = null;
                    function n() {
                        t1 = new Uint8Array(r.buffer);
                    }
                    function i() {
                        throw new Error("Unexpected Draco error.");
                    }
                    const s = {
                        a: {
                            a: i,
                            d: function(e, r, n) {
                                return t1.copyWithin(e, r, r + n);
                            },
                            c: function(e) {
                                const i = t1.length, s = Math.max(e >>> 0, Math.ceil(1.2 * i)), o = Math.ceil((s - i) / 65536);
                                try {
                                    return r.grow(o), n(), !0;
                                } catch (e) {
                                    return !1;
                                }
                            },
                            b: i
                        }
                    };
                    return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e, s) : e.then((e)=>e.arrayBuffer()).then((e)=>WebAssembly.instantiate(e, s))).then((e)=>{
                        const { Rb: i, Qb: s, P: o, T: a, X: l, Ja: u, La: c, Qa: h, Va: p, Wa: d, eb: f, jb: m, f: y, e: g, yb: x, zb: v, Ab: b, Bb: w, Db: _, Gb: A } = e.instance.exports;
                        r = g;
                        const M = (()=>{
                            let e = 0, r = 0, n = 0, o = 0;
                            return (a)=>{
                                n && (i(o), i(e), r += n, n = e = 0), e || (r += 128, e = s(r));
                                const l = a.length + 7 & -8;
                                let u = e;
                                l >= r && (n = l, u = o = s(l));
                                for(let e = 0; e < a.length; e++)t1[u + e] = a[e];
                                return u;
                            };
                        })();
                        return n(), y(), {
                            memory: g,
                            _free: i,
                            _malloc: s,
                            Mesh: class {
                                constructor(){
                                    this.ptr = o();
                                }
                                destroy() {
                                    a(this.ptr);
                                }
                            },
                            Decoder: class {
                                constructor(){
                                    this.ptr = u();
                                }
                                destroy() {
                                    m(this.ptr);
                                }
                                DecodeArrayToMesh(e, t1, r) {
                                    const n = M(e), i = c(this.ptr, n, t1, r.ptr);
                                    return !!l(i);
                                }
                                GetAttributeByUniqueId(e, t1) {
                                    return {
                                        ptr: h(this.ptr, e.ptr, t1)
                                    };
                                }
                                GetTrianglesUInt16Array(e, t1, r) {
                                    p(this.ptr, e.ptr, t1, r);
                                }
                                GetTrianglesUInt32Array(e, t1, r) {
                                    d(this.ptr, e.ptr, t1, r);
                                }
                                GetAttributeDataArrayForAllPoints(e, t1, r, n, i) {
                                    f(this.ptr, e.ptr, t1.ptr, r, n, i);
                                }
                            },
                            DT_INT8: x(),
                            DT_UINT8: v(),
                            DT_INT16: b(),
                            DT_UINT16: w(),
                            DT_UINT32: _(),
                            DT_FLOAT32: A()
                        };
                    });
                }(fetch(om())), Jf.then((e)=>{
                    Qf = e, Jf = void 0;
                }));
            }()), p && c.push(function() {
                if (tm) return;
                const e = function(e) {
                    let t1;
                    const r = WebAssembly.instantiateStreaming(e, {}).then((e)=>{
                        t1 = e.instance, t1.exports.__wasm_call_ctors();
                    }), n = {
                        NONE: "",
                        OCTAHEDRAL: "meshopt_decodeFilterOct",
                        QUATERNION: "meshopt_decodeFilterQuat",
                        EXPONENTIAL: "meshopt_decodeFilterExp"
                    }, i = {
                        ATTRIBUTES: "meshopt_decodeVertexBuffer",
                        TRIANGLES: "meshopt_decodeIndexBuffer",
                        INDICES: "meshopt_decodeIndexSequence"
                    };
                    return {
                        ready: r,
                        supported: !0,
                        decodeGltfBuffer (e, r, s, o, a, l) {
                            !function(e, t1, r, n, i, s, o) {
                                const a = e.exports.sbrk, l = n + 3 & -4, u = a(l * i), c = a(s.length), h = new Uint8Array(e.exports.memory.buffer);
                                h.set(s, c);
                                const p = t1(u, n, i, c, s.length);
                                if (0 === p && o && o(u, l, i), r.set(h.subarray(u, u + n * i)), a(u - a(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                            }(t1, t1.exports[i[a]], e, r, s, o, t1.exports[n[l]]);
                        }
                    };
                }(fetch(am()));
                return e.ready.then(()=>{
                    tm = e;
                });
            }()), o) for(let e = 0; e < o.length; e++)c.push(Pm(o[e], i, e, r, n));
            if (c.length && await Promise.all(c), n && n.aborted) throw new DOMException("Aborted", "AbortError");
            if (h && a) for (const { primitives: e } of a)for (const t1 of e)bm(t1, i);
            if (p && a && u) for (const e of u)_m(e, i);
            return i;
        }
        async function Tm(e, t1) {
            const r = await async function(e, t1) {
                if (t1 && t1.aborted) throw new DOMException("Aborted", "AbortError");
                return new Promise((r, n)=>{
                    const i = Lt(e, (e, t1)=>{
                        e ? n(e) : r(t1);
                    });
                    t1 && t1.addEventListener("abort", ()=>{
                        i.cancel(), n(new DOMException("Aborted", "AbortError"));
                    }, {
                        once: !0
                    });
                });
            }({
                url: e,
                type: "arrayBuffer"
            }, t1);
            return Bm(r, 0, e, t1);
        }
        function km(e) {
            switch(e){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function Vm(e) {
            switch(e){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        class Em {
            constructor(e, t1, r, n){
                this.context = e, this.format = r, this.useMipmap = n && n.useMipmap, this.texture = e.gl.createTexture(), this.update(t1, {
                    premultiply: n && n.premultiply
                });
            }
            update(e, t1) {
                const r = e && e instanceof HTMLVideoElement && 0 === e.width ? e.videoWidth : e.width, n = e && e instanceof HTMLVideoElement && 0 === e.height ? e.videoHeight : e.height, { context: i } = this, { gl: s } = i, { x: o, y: a } = t1 && t1.position ? t1.position : {
                    x: 0,
                    y: 0
                }, l = o + r, u = a + n;
                !this.size || this.size[0] === l && this.size[1] === u || (s.bindTexture(s.TEXTURE_2D, null), s.deleteTexture(this.texture), this.texture = s.createTexture(), this.size = null), s.bindTexture(s.TEXTURE_2D, this.texture), i.pixelStoreUnpackFlipY.set(!1), i.pixelStoreUnpack.set(1), i.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA8 && (!t1 || !1 !== t1.premultiply));
                const c = e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof HTMLVideoElement || e instanceof ImageData || ImageBitmap && e instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const e = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    s.texStorage2D(s.TEXTURE_2D, e, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                this.size && (c ? s.texSubImage2D(s.TEXTURE_2D, 0, o, a, km(this.format), Vm(this.format), e) : "data" in e && e.data && s.texSubImage2D(s.TEXTURE_2D, 0, o, a, r, n, km(this.format), Vm(this.format), e.data)), this.useMipmap && s.generateMipmap(s.TEXTURE_2D);
            }
            bind(e, t1, r = !1) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), e !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? e === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : e), this.minFilter = e), t1 !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            bindExtraParam(e, t1, r, n, i) {
                const { context: s } = this, { gl: o } = s;
                o.bindTexture(o.TEXTURE_2D, this.texture), t1 !== this.magFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, t1), this.magFilter = t1), e !== this.minFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this.useMipmap ? e === o.NEAREST ? o.NEAREST_MIPMAP_NEAREST : o.LINEAR_MIPMAP_LINEAR : e), this.minFilter = e), r !== this.wrapS && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, n), this.wrapT = n), i !== this.compareMode && (i ? (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_MODE, o.COMPARE_REF_TO_TEXTURE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_FUNC, i)) : o.texParameteri(o.TEXTURE_2D, o.TEXTURE_COMPARE_MODE, o.NONE), this.compareMode = i);
            }
            destroy() {
                const { gl: e } = this.context;
                e.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Fm {
            constructor(e, t1){
                this.context = e, this.texture = t1;
            }
            bind(e, t1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), e !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, e), this.minFilter = e), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
        }
        const Dm = Ra([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Cm = Ra([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Rm = Ra([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Lm = Ra([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), Om = Ra([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Um = Ra([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), Nm = Ra([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]);
        function jm(e, t1) {
            const r = $m(e.projection, e.zoom, e.width, e.height), n = function(e, t1, r, n, i) {
                const s = new zu(r.lng - 180 * qm, r.lat), o = new zu(r.lng + 180 * qm, r.lat), a = e.project(s.lng, s.lat), l = e.project(o.lng, o.lat), c = -Math.atan2(l.y - a.y, l.x - a.x), p = Nu.fromLngLat(r);
                p.y = De(p.y, -1 + qm, 1 - qm);
                const f = p.toLngLat(), m = e.project(f.lng, f.lat), g = Nu.fromLngLat(f);
                g.x += qm;
                const x = g.toLngLat(), v = e.project(x.lng, x.lat), b = Hm(v.x - m.x, v.y - m.y, c), w = Nu.fromLngLat(f);
                w.y += qm;
                const _ = w.toLngLat(), A = e.project(_.lng, _.lat), M = Hm(A.x - m.x, A.y - m.y, c), I = Math.abs(b.x) / Math.abs(M.y), S = u([]);
                y(S, S, -c * (1 - (i ? 0 : n)));
                const z = u([]);
                return d(z, z, [
                    1,
                    1 - (1 - I) * n,
                    1
                ]), z[4] = -M.x / M.y * n, y(z, z, c), h(z, S, z), z;
            }(e.projection, 0, e.center, r, t1), i = Gm(e);
            return d(n, n, [
                i,
                i,
                1
            ]), n;
        }
        function Gm(e) {
            const t1 = e.projection, r = $m(e.projection, e.zoom, e.width, e.height), n = Xm(t1, e.center), i = Xm(t1, zu.convert(t1.center));
            return Math.pow(2, n * r + (1 - r) * i);
        }
        function $m(e, t1, r, n, i = 1 / 0) {
            const s = e.range;
            if (!s) return 0;
            const o = Math.min(i, Math.max(r, n)), a = Math.log2(o / 1024);
            return Ce(s[0] + a, s[1] + a, t1);
        }
        const qm = 1 / 4e4;
        function Xm(e, t1) {
            const r = De(t1.lat, -85.051129, Cu), n = new zu(t1.lng - 180 * qm, r), i = new zu(t1.lng + 180 * qm, r), s = e.project(n.lng, r), o = e.project(i.lng, r), a = Nu.fromLngLat(n), l = Nu.fromLngLat(i), u = o.x - s.x, c = o.y - s.y, h = l.x - a.x, p = l.y - a.y, d = Math.sqrt((h * h + p * p) / (u * u + c * c));
            return Math.log2(d);
        }
        function Hm(e, t1, r) {
            const n = Math.cos(r), i = Math.sin(r);
            return {
                x: e * n - t1 * i,
                y: e * i + t1 * n
            };
        }
        function Zm(e, t1, r) {
            u(e), y(e, e, Be(t1[2])), f(e, e, Be(t1[0])), m(e, e, Be(t1[1])), d(e, e, r), h(e, e, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Wm(e, t1, r, n, i, s, o, a) {
            const l = [
                r[0] - t1[0],
                r[1] - t1[1],
                0
            ], u = [
                n[0] - t1[0],
                n[1] - t1[1],
                0
            ];
            if (M(l) < 1e-12 || M(u) < 1e-12) return re(e);
            const c = U([], l, u);
            L(c, c), P(u, n, t1), l[2] = (s - i) * a, u[2] = (o - i) * a;
            const h = l;
            return U(h, l, u), L(h, h), ue(e, c, h);
        }
        function Ym(e, t1, r = !1) {
            const n = wh(t1.zoom), i = function(e, t1, r) {
                const n = t1.worldSize, i = [
                    e[12],
                    e[13],
                    e[14]
                ], s = Fu(i[1] / n), o = Eu(i[0] / n), a = u([]), l = Vu(1, s) * n, c = Vu(1, 0) * n * Lu(s, t1.zoom), f = 1 / xh(n);
                let m = c * f;
                if (r) {
                    const e = $m(t1.projection, t1.zoom, t1.width, t1.height, 1024);
                    m = f * t1.projection.pixelSpaceConversion(t1.center.lat, n, e);
                }
                const y = Mu(s, o);
                z(y, y, V([], L([], y), l * m * i[2]));
                const g = function(e) {
                    const t1 = [
                        e[0],
                        e[1],
                        e[2]
                    ];
                    let r = [
                        0,
                        1,
                        0
                    ];
                    const n = U([], r, t1);
                    return U(r, t1, n), 0 === C(r) && (r = [
                        0,
                        1,
                        0
                    ], U(n, t1, r)), L(n, n), L(r, r), L(t1, t1), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        r[0],
                        r[1],
                        r[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        0,
                        e[0],
                        e[1],
                        e[2],
                        1
                    ];
                }(y);
                d(a, a, [
                    m,
                    m,
                    m * l
                ]), p(a, a, [
                    -i[0],
                    -i[1],
                    -i[2]
                ]);
                const x = h([], t1.globeMatrix, g);
                return h(x, x, a), h(x, x, e), x;
            }(e, t1, r);
            if (n > 0) {
                const r = function(e, t1) {
                    const r = t1.worldSize, n = Vu(1, 0) * r * Lu(t1.center.lat, t1.zoom) / xh(r), i = Vu(1, t1.center.lat) * r, s = u([]);
                    m(s, s, Be(t1.center.lng)), f(s, s, Be(t1.center.lat)), p(s, s, [
                        0,
                        0,
                        xu
                    ]), d(s, s, [
                        n,
                        n,
                        n * i
                    ]);
                    const o = t1.point;
                    return p(s, s, [
                        -o.x,
                        -o.y,
                        0
                    ]), h(s, s, e), h(s, t1.globeMatrix, s);
                }(e, t1);
                return function(e, t1, r) {
                    const n = (e, t1, r)=>{
                        const n = M(e), i = M(t1), s = lh(e, t1, r);
                        return V(s, s, 1 / M(s) * hr(n, i, r));
                    }, i = n([
                        e[0],
                        e[1],
                        e[2]
                    ], [
                        t1[0],
                        t1[1],
                        t1[2]
                    ], r), s = n([
                        e[4],
                        e[5],
                        e[6]
                    ], [
                        t1[4],
                        t1[5],
                        t1[6]
                    ], r), o = n([
                        e[8],
                        e[9],
                        e[10]
                    ], [
                        t1[8],
                        t1[9],
                        t1[10]
                    ], r), a = lh([
                        e[12],
                        e[13],
                        e[14]
                    ], [
                        t1[12],
                        t1[13],
                        t1[14]
                    ], r);
                    return [
                        i[0],
                        i[1],
                        i[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        1
                    ];
                }(i, r, n);
            }
            return i;
        }
        function Jm(e, t1, r, n) {
            const i = vc.projectAabbCorners(n, r);
            let s = Number.MAX_VALUE;
            for(let e = 0; e < i.length; ++e){
                const r = i[e];
                r[0] = (.5 * r[0] + .5) * t1.width, r[1] = (.5 - .5 * r[1]) * t1.height, r[2] < s && (s = r[2]);
            }
            const o = function(e) {
                const t1 = [];
                let r = 0;
                for(let t1 = 1; t1 < e.length; t1++)(e[t1][0] < e[r][0] || e[t1][0] === e[r][0] && e[t1][1] < e[r][1]) && (r = t1);
                let n, i = r;
                const s = new Uint8Array(e.length);
                do {
                    if (s[i]) break;
                    t1.push(new Ie(e[i][0], e[i][1])), s[i] = 1, n = (i + 1) % e.length;
                    for(let t1 = 0; t1 < e.length; t1++){
                        if (e[t1][0] === e[n][0] && e[t1][1] === e[n][1] || e[t1][0] === e[i][0] && e[t1][1] === e[i][1]) continue;
                        const r = [
                            e[t1][0] - e[i][0],
                            e[t1][1] - e[i][1]
                        ], s = [
                            e[n][0] - e[i][0],
                            e[n][1] - e[i][1]
                        ], o = r[0] * s[1] - r[1] * s[0];
                        (o > 0 || 0 === o && r[0] * s[0] + r[1] * s[1] >= 0 && r[0] * r[0] + r[1] * r[1] > s[0] * s[0] + s[1] * s[1]) && (n = t1);
                    }
                    i = n;
                }while (i !== r);
                return t1.length > 0 && t1.push(t1[0]), t1;
            }(i);
            if (Ic(e, o)) return s;
        }
        const Km = 64, Qm = {
            CoordinateSpaceTile: 1,
            HasMapboxMeshFeatures: 4,
            HasMeshoptCompression: 8
        };
        function ey(e, t1, r, n, i, s, o, a, l, c = !1) {
            const f = r.zoom, m = r.project(n), y = Lu(n.lat, f), g = 1 / y;
            u(e), p(e, e, [
                m.x + o[0] * g,
                m.y + o[1] * g,
                o[2]
            ]);
            let x = 1, v = 1;
            const w = r.worldSize;
            if (c) {
                if ("mercator" === r.projection.name) {
                    let e = 0;
                    r.elevation && (e = r.elevation.getAtPointOrZero(new Nu(m.x / w, m.y / w), 0));
                    const t1 = ee([], [
                        m.x,
                        m.y,
                        e,
                        1
                    ], r.projMatrix)[3] / r.cameraToCenterDistance;
                    x = t1, v = t1 * Lu(r.center.lat, f);
                } else if ("globe" === r.projection.name) {
                    const t1 = Ym(e, r), i = [
                        0,
                        0,
                        0,
                        1
                    ];
                    ee(i, i, h([], r.projMatrix, t1));
                    const s = i[3] / r.cameraToCenterDistance, o = wh(f), a = r.projection.pixelsPerMeter(n.lat, w) * Lu(n.lat, f), l = r.projection.pixelsPerMeter(r.center.lat, w) * Lu(r.center.lat, f);
                    x = s / hr(a, Ru(r.center.lat), o), v = s * y / a, x *= l, v *= l;
                }
            } else x = g;
            d(e, e, [
                x,
                x,
                v
            ]);
            const _ = [
                ...e
            ], A = t1.orientation, M = [];
            if (Zm(M, [
                A[0] + (i ? i[0] : 0),
                A[1] + (i ? i[1] : 0),
                A[2] + (i ? i[2] : 0)
            ], s), h(e, _, M), a && r.elevation) {
                let i = 0;
                const s = [];
                if (l && r.elevation) {
                    i = function(e, t1, r, n, i) {
                        const s = t1.elevation;
                        if (!s) return 0;
                        const o = vc.projectAabbCorners(r, n), a = Vu(1, i.lat) * t1.worldSize, l = function(e, t1) {
                            const r = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const i of n){
                                const n = e[i.corners[0]], s = e[i.corners[1]], o = e[i.corners[2]], a = [
                                    s[0] - n[0],
                                    s[1] - n[1],
                                    t1 * (s[2] - n[2])
                                ], l = U(a, a, [
                                    o[0] - n[0],
                                    o[1] - n[1],
                                    t1 * (o[2] - n[2])
                                ]);
                                L(l, l), i.dotProductWithUp = O(l, r);
                            }
                            return n.sort((e, t1)=>e.dotProductWithUp - t1.dotProductWithUp), n[0].corners;
                        }(o, a), u = o[l[0]], c = o[l[1]], h = o[l[2]], p = o[l[3]], d = s.getAtPointOrZero(new Nu(u[0] / t1.worldSize, u[1] / t1.worldSize), 0), f = s.getAtPointOrZero(new Nu(c[0] / t1.worldSize, c[1] / t1.worldSize), 0), m = s.getAtPointOrZero(new Nu(h[0] / t1.worldSize, h[1] / t1.worldSize), 0), y = s.getAtPointOrZero(new Nu(p[0] / t1.worldSize, p[1] / t1.worldSize), 0), g = (d + y) / 2, x = (f + m) / 2;
                        return g > x ? f < m ? Wm(e, c, p, u, f, y, d, a) : Wm(e, h, u, p, m, d, y, a) : d < y ? Wm(e, u, c, h, d, f, m, a) : Wm(e, p, h, c, y, m, f, a), Math.max(g, x);
                    }(s, r, t1.aabb, e, n);
                    const o = h([], b([], s), M);
                    h(e, _, o);
                } else i = r.elevation.getAtPointOrZero(new Nu(m.x / w, m.y / w), 0);
                0 !== i && (e[14] += i);
            }
        }
        class ty {
            constructor(e, t1, r, n, i){
                this.materialOverrides = new Map, this.nodeOverrides = new Map, this.materialOverrideNames = [], this.nodeOverrideNames = [], this.featureProperties = {}, this.id = e, this.uri = t1, this.position = null != r ? new zu(r[0], r[1]) : new zu(0, 0), this.orientation = null != n ? n : [
                    0,
                    0,
                    0
                ], this.nodes = i, this.uploaded = !1, this.aabb = new vc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(e, t1) {
                h(e.globalMatrix, t1, e.localMatrix);
                const r = this.nodeOverrides.get(e.name);
                if (void 0 !== r) {
                    const t1 = [];
                    i = r.orientation, u(n = t1), m(n, n, Be(i[1])), y(n, n, Be(i[2])), f(n, n, Be(i[0])), h(e.globalMatrix, e.globalMatrix, t1);
                }
                var n, i;
                if (e.meshes) for (const t1 of e.meshes){
                    const r = vc.applyTransformFast(t1.aabb, e.globalMatrix);
                    this.aabb.encapsulate(r);
                }
                if (e.children) for (const t1 of e.children)this._applyTransformations(t1, e.globalMatrix);
            }
            computeBoundsAndApplyParent() {
                const e = u([]);
                this.aabb = new vc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                for (const t1 of this.nodes)this._applyTransformations(t1, e);
            }
            computeModelMatrix(e, t1, r, n, i, s, o = !1) {
                ey(this.matrix, this, e.transform, this.position, t1, r, n, i, s, o);
            }
            upload(e) {
                if (!this.uploaded) {
                    for (const t1 of this.nodes)iy(t1, e);
                    for (const e of this.nodes)sy(e);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e of this.nodes)ay(e);
            }
        }
        function ry(e, t1, r = !1) {
            e.uploaded || (e.gfxTexture = new Em(t1, e.image, r ? t1.gl.R8 : t1.gl.RGBA8, {
                useMipmap: e.sampler.minFilter >= t1.gl.NEAREST_MIPMAP_NEAREST
            }), e.uploaded = !0, e.image = null);
        }
        function ny(e, t1, r) {
            e.indexBuffer = t1.createIndexBuffer(e.indexArray, !1, !0), e.vertexBuffer = t1.createVertexBuffer(e.vertexArray, Dm.members, !1, !0), e.normalArray && (e.normalBuffer = t1.createVertexBuffer(e.normalArray, Om.members, !1, !0)), e.texcoordArray && (e.texcoordBuffer = t1.createVertexBuffer(e.texcoordArray, Lm.members, !1, !0)), e.colorArray && (e.colorBuffer = t1.createVertexBuffer(e.colorArray, (12 === e.colorArray.bytesPerElement ? Cm : Rm).members, !1, !0)), e.featureArray && (e.pbrBuffer = t1.createVertexBuffer(e.featureArray, Nm.members, !0)), e.segments = Rl.simpleSegment(0, 0, e.vertexArray.length, e.indexArray.length);
            const n = e.material;
            n.pbrMetallicRoughness.baseColorTexture && ry(n.pbrMetallicRoughness.baseColorTexture, t1), n.pbrMetallicRoughness.metallicRoughnessTexture && ry(n.pbrMetallicRoughness.metallicRoughnessTexture, t1), n.normalTexture && ry(n.normalTexture, t1), n.occlusionTexture && ry(n.occlusionTexture, t1, r), n.emissionTexture && ry(n.emissionTexture, t1);
        }
        function iy(e, t1, r) {
            if (e.meshes) for (const n of e.meshes)ny(n, t1, r);
            if (e.children) for (const n of e.children)iy(n, t1, r);
        }
        function sy(e) {
            if (e.meshes) for (const t1 of e.meshes)t1.indexArray.destroy(), t1.vertexArray.destroy(), t1.colorArray && t1.colorArray.destroy(), t1.normalArray && t1.normalArray.destroy(), t1.texcoordArray && t1.texcoordArray.destroy(), t1.featureArray && t1.featureArray.destroy();
            if (e.children) for (const t1 of e.children)sy(t1);
        }
        function oy(e) {
            e.pbrMetallicRoughness.baseColorTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e.pbrMetallicRoughness.metallicRoughnessTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e.normalTexture && e.normalTexture.gfxTexture && e.normalTexture.gfxTexture.destroy(), e.emissionTexture && e.emissionTexture.gfxTexture && e.emissionTexture.gfxTexture.destroy(), e.occlusionTexture && e.occlusionTexture.gfxTexture && e.occlusionTexture.gfxTexture.destroy();
        }
        function ay(e) {
            if (e.meshes) for (const t1 of e.meshes)t1.vertexBuffer && (t1.vertexBuffer.destroy(), t1.indexBuffer.destroy(), t1.normalBuffer && t1.normalBuffer.destroy(), t1.texcoordBuffer && t1.texcoordBuffer.destroy(), t1.colorBuffer && t1.colorBuffer.destroy(), t1.pbrBuffer && t1.pbrBuffer.destroy(), t1.segments.destroy(), t1.material && oy(t1.material));
            if (e.footprintDebugMesh && (e.footprintDebugMesh.vertexBuffer.destroy(), e.footprintDebugMesh.indexBuffer.destroy(), e.footprintDebugMesh.segments.destroy()), e.children) for (const t1 of e.children)ay(t1);
        }
        function ly(e, t1) {
            const r = e.json.bufferViews[t1.bufferView], n = mm[t1.componentType];
            return new n(e.buffers[r.buffer], (t1.byteOffset || 0) + (r.byteOffset || 0), t1.count * (r.byteStride && r.byteStride !== gm[t1.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : gm[t1.type]));
        }
        function uy(e, t1, r, n) {
            const i = mm[t1.componentType], s = function(e) {
                switch(e){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(i), o = e.json.bufferViews[t1.bufferView], a = o.byteStride ? o.byteStride / i.BYTES_PER_ELEMENT : gm[t1.type], l = r.float32, u = l.length / r.capacity;
            for(let e = 0, r = 0; e < t1.count * a; e += a, r += u)for(let t1 = 0; t1 < u; t1++)l[r + t1] = n[e + t1] * s;
            r._trim();
        }
        function cy(e, t1, r) {
            const n = e.indices, i = e.attributes, s = {};
            s.indexArray = new ol;
            const o = t1.json.accessors[n], a = o.count / 3;
            s.indexArray.reserve(a);
            const l = ly(t1, o);
            for(let e = 0; e < a; e++)s.indexArray.emplaceBack(l[3 * e], l[3 * e + 1], l[3 * e + 2]);
            s.indexArray._trim(), s.vertexArray = new Ha;
            const u = t1.json.accessors[i.POSITION];
            s.vertexArray.reserve(u.count);
            const c = ly(t1, u);
            for(let e = 0; e < u.count; e++)s.vertexArray.emplaceBack(c[3 * e], c[3 * e + 1], c[3 * e + 2]);
            if (s.vertexArray._trim(), s.aabb = new vc(u.min, u.max), s.centroid = function(e, t1) {
                const r = [
                    0,
                    0,
                    0
                ], n = e.length;
                if (n > 0) {
                    for(let i = 0; i < n; i++){
                        const n = 3 * e[i];
                        r[0] += t1[n], r[1] += t1[n + 1], r[2] += t1[n + 2];
                    }
                    r[0] /= n, r[1] /= n, r[2] /= n;
                }
                return r;
            }(l, c), void 0 !== i.COLOR_0) {
                const e = t1.json.accessors[i.COLOR_0], r = gm[e.type], n = ly(t1, e);
                s.colorArray = 3 === r ? new Ha : new Qa, s.colorArray.resize(e.count), uy(t1, e, s.colorArray, n);
            }
            if (void 0 !== i.NORMAL) {
                s.normalArray = new Ha;
                const e = t1.json.accessors[i.NORMAL];
                s.normalArray.resize(e.count);
                const r = ly(t1, e);
                uy(t1, e, s.normalArray, r);
            }
            if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
                s.texcoordArray = new fl;
                const e = t1.json.accessors[i.TEXCOORD_0];
                s.texcoordArray.resize(e.count);
                const r = ly(t1, e);
                uy(t1, e, s.texcoordArray, r);
            }
            if (void 0 !== i._FEATURE_ID_RGBA4444) {
                const e = t1.json.accessors[i._FEATURE_ID_RGBA4444];
                t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression") && (s.featureData = ly(t1, e));
            }
            void 0 !== i._FEATURE_RGBA4444 && (s.featureData = new Uint32Array(ly(t1, t1.json.accessors[i._FEATURE_RGBA4444]).buffer));
            const h = e.material;
            return s.material = function(e, t1) {
                const { emissiveFactor: r = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: i = .5, normalTexture: s, occlusionTexture: o, emissiveTexture: a, doubleSided: l, name: u } = e, { baseColorFactor: c = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: p = 1, baseColorTexture: d, metallicRoughnessTexture: f } = e.pbrMetallicRoughness || {}, m = o ? t1[o.index] : void 0;
                if (o && o.extensions && o.extensions.KHR_texture_transform && m) {
                    const e = o.extensions.KHR_texture_transform;
                    m.offsetScale = [
                        e.offset[0],
                        e.offset[1],
                        e.scale[0],
                        e.scale[1]
                    ];
                }
                return {
                    name: u,
                    pbrMetallicRoughness: {
                        baseColorFactor: new ar(...c),
                        metallicFactor: h,
                        roughnessFactor: p,
                        baseColorTexture: d ? t1[d.index] : void 0,
                        metallicRoughnessTexture: f ? t1[f.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: new ar(...r),
                    alphaMode: n,
                    alphaCutoff: i,
                    normalTexture: s ? t1[s.index] : void 0,
                    occlusionTexture: m,
                    emissionTexture: a ? t1[a.index] : void 0,
                    defined: void 0 === e.defined
                };
            }(void 0 !== h ? t1.json.materials[h] : {
                defined: !1
            }, r), s;
        }
        function hy(e, t1, r) {
            const { matrix: n, rotation: i, translation: s, scale: o, mesh: a, extras: u, children: c, name: h } = e, p = {};
            if (p.name = h, p.localMatrix = n || function(e, t1, r, n) {
                var i = t1[0], s = t1[1], o = t1[2], a = t1[3], l = i + i, u = s + s, c = o + o, h = i * l, p = i * u, d = i * c, f = s * u, m = s * c, y = o * c, g = a * l, x = a * u, v = a * c, b = n[0], w = n[1], _ = n[2];
                return e[0] = (1 - (f + y)) * b, e[1] = (p + v) * b, e[2] = (d - x) * b, e[3] = 0, e[4] = (p - v) * w, e[5] = (1 - (h + y)) * w, e[6] = (m + g) * w, e[7] = 0, e[8] = (d + x) * _, e[9] = (m - g) * _, e[10] = (1 - (h + f)) * _, e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
            }([], i || [
                0,
                0,
                0,
                1
            ], s || [
                0,
                0,
                0
            ], o || [
                1,
                1,
                1
            ]), p.globalMatrix = l(p.localMatrix), void 0 !== a) {
                p.meshes = r[a];
                const e = p.anchor = [
                    0,
                    0
                ];
                for (const t1 of p.meshes){
                    const { min: r, max: n } = t1.aabb;
                    e[0] += r[0] + n[0], e[1] += r[1] + n[1];
                }
                e[0] = Math.floor(e[0] / p.meshes.length / 2), e[1] = Math.floor(e[1] / p.meshes.length / 2);
            }
            if (u && (u.id && (p.id = u.id), u.lights && (p.lights = function(e) {
                if (!e.length) return [];
                const t1 = function(e) {
                    const t1 = atob(e), r = new Uint8Array(t1.length);
                    for(let e = 0; e < t1.length; e++)r[e] = t1.codePointAt(e);
                    return r;
                }(e), r = [], n = t1.length / 24, i = new Uint16Array(t1.buffer), s = new Float32Array(t1.buffer);
                for(let e = 0; e < n; e++){
                    const t1 = i[2 * e * 6] / 30, n = i[2 * e * 6 + 1] / 30, o = i[2 * e * 6 + 10] / 100, a = s[6 * e + 1], l = s[6 * e + 2], u = s[6 * e + 3], c = s[6 * e + 4], h = u - a, p = c - l, d = Math.hypot(h, p);
                    r.push({
                        pos: [
                            a + .5 * h,
                            l + .5 * p,
                            n
                        ],
                        normal: [
                            p / d,
                            -h / d,
                            0
                        ],
                        width: d,
                        height: t1,
                        depth: o,
                        points: [
                            a,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return r;
            }(u.lights)), u.MAPBOX_geometry_bloom && (p.isGeometryBloom = u.MAPBOX_geometry_bloom)), c) {
                const e = [];
                for (const n of c)e.push(hy(t1.json.nodes[n], t1, r));
                p.children = e;
            }
            return p;
        }
        function py(e) {
            if (0 === e.vertices.length || 0 === e.indices.length) return null;
            const t1 = new wd(e.vertices, e.indices, 8, 256), [r, n] = [
                t1.min.clone(),
                t1.max.clone()
            ];
            return {
                vertices: e.vertices,
                indices: e.indices,
                grid: t1,
                min: r,
                max: n
            };
        }
        function dy(e) {
            if (!e.extras || !e.extras.ground) return null;
            const t1 = e.extras.ground;
            if (!t1 || !Array.isArray(t1) || 0 === t1.length) return null;
            const r = t1[0];
            if (!r || !Array.isArray(r) || 0 === r.length) return null;
            const n = [];
            for (const e of r){
                if (!Array.isArray(e) || 2 !== e.length) continue;
                const t1 = e[0], r = e[1];
                "number" == typeof t1 && "number" == typeof r && n.push(new Ie(t1, r));
            }
            if (n.length < 3) return null;
            n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
            let i = 0;
            for(let e = 0; e < n.length; e++){
                const t1 = n[e], r = n[(e + 1) % n.length], s = n[(e + 2) % n.length];
                i += (t1.x - r.x) * (s.y - r.y) - (s.x - r.x) * (t1.y - r.y);
            }
            i > 0 && n.reverse();
            const s = Yh(n.flatMap((e)=>[
                    e.x,
                    e.y
                ]), []);
            return 0 === s.length ? null : {
                vertices: n,
                indices: s
            };
        }
        function fy(e, t1) {
            const r = [], n = [];
            let i = 0;
            const s = [];
            for (const o of e){
                i = r.length;
                const e = o.vertexArray.float32, a = o.indexArray.uint16;
                for(let n = 0; n < o.vertexArray.length; n++)s[0] = e[3 * n + 0], s[1] = e[3 * n + 1], s[2] = e[3 * n + 2], j(s, s, t1), r.push(new Ie(s[0], s[1]));
                for(let e = 0; e < 3 * o.indexArray.length; e++)n.push(a[e] + i);
            }
            if (n.length % 3 != 0) return null;
            for(let e = 0; e < n.length; e += 3){
                const t1 = r[n[e + 0]], i = r[n[e + 1]], s = r[n[e + 2]];
                (t1.x - i.x) * (s.y - i.y) - (s.x - i.x) * (t1.y - i.y) > 0 && ([n[e + 1], n[e + 2]] = [
                    n[e + 2],
                    n[e + 1]
                ]);
            }
            return {
                vertices: r,
                indices: n
            };
        }
        function my(e) {
            const t1 = function(e, t1) {
                const r = [], n = WebGL2RenderingContext;
                if (e.json.textures) for (const i of e.json.textures){
                    const s = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== i.sampler && Object.assign(s, e.json.samplers[i.sampler]), r.push({
                        image: t1[i.source],
                        sampler: s,
                        uploaded: !1
                    });
                }
                return r;
            }(e, e.images), r = function(e, t1) {
                const r = [];
                for (const n of e.json.meshes){
                    const i = [];
                    for (const r of n.primitives)i.push(cy(r, e, t1));
                    r.push(i);
                }
                return r;
            }(e, t1), { scenes: n, scene: i, nodes: s } = e.json, o = n ? n[i || 0].nodes : [
                ...s.keys()
            ], a = [];
            for (const t1 of o)a.push(hy(s[t1], e, r));
            return function(e, t1, r) {
                const n = {}, i = new Set;
                for(let s = 0; s < e.length; s++){
                    const e = r[t1[s]];
                    if (!e.extras) continue;
                    const o = e.extras["mapbox:footprint:version"], a = e.extras["mapbox:footprint:id"];
                    (o || a) && i.add(s), "1.0.0" === o && a && (n[a] = s);
                }
                for(let s = 0; s < e.length; s++){
                    if (i.has(s)) continue;
                    const o = e[s], a = r[t1[s]];
                    if (!a.extras) continue;
                    let l = null;
                    o.id in n && (l = fy(e[n[o.id]].meshes, o.localMatrix)), l || (l = dy(a)), l && (o.footprint = py(l));
                }
                if (i.size > 0) {
                    const t1 = Array.from(i.values()).sort((e, t1)=>e - t1);
                    for(let r = t1.length - 1; r >= 0; r--)e.splice(t1[r], 1);
                }
            }(a, o, e.json.nodes), a;
        }
        function yy(e) {
            e.heightmap = new Float32Array(4096), e.heightmap.fill(-1);
            const t1 = e.vertexArray.float32, r = e.aabb.min[0] - 1, n = e.aabb.min[1] - 1, i = Km / (e.aabb.max[0] - r + 2), s = Km / (e.aabb.max[1] - n + 2);
            for(let o = 0; o < t1.length; o += 3){
                const a = t1[o + 2], l = (t1[o + 0] - r) * i | 0, u = (t1[o + 1] - n) * s | 0;
                a > e.heightmap[u * Km + l] && (e.heightmap[u * Km + l] = a);
            }
        }
        function gy(e, t1, r, n, i) {
            r.reserve(r.length + 4 * e.length), n.reserve(n.length + 10 * e.length), i.reserve(i.length + 10 * e.length);
            let s = n.length;
            for (const o of e){
                const e = Math.min(10, Math.max(4, 1.3 * o.height)) * t1, a = [
                    -o.normal[1],
                    o.normal[0],
                    0
                ], l = Math.min(.29, .1 * o.width / o.depth), u = o.width - 2 * o.depth * t1 * (l + .01), c = E([], o.pos, a, u / 2), h = E([], o.pos, a, -u / 2), p = [
                    c[0],
                    c[1],
                    c[2] + o.height
                ], d = [
                    h[0],
                    h[1],
                    h[2] + o.height
                ], f = E([], o.normal, a, l);
                V(f, f, e);
                const m = E([], o.normal, a, -l);
                V(m, m, e), z(f, c, f), z(m, h, m), c[2] += .1, h[2] += .1, n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(m[0], m[1], m[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(d[0], d[1], d[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(m[0], m[1], m[2]);
                const y = u / e / 2;
                i.emplaceBack(-y - l, -1, y, .8), i.emplaceBack(y + l, -1, y, .8), i.emplaceBack(-y, 0, y, 1.3), i.emplaceBack(y, 0, y, 1.3), i.emplaceBack(y + l, -0.8, y, .7), i.emplaceBack(y + l, -0.8, y, .7), i.emplaceBack(0, 0, y, 1.3), i.emplaceBack(0, 0, y, 1.3), i.emplaceBack(y + l, -1.2, y, .8), i.emplaceBack(y + l, -1.2, y, .8), r.emplaceBack(6 + s, 4 + s, 8 + s), r.emplaceBack(7 + s, 9 + s, 5 + s), r.emplaceBack(0 + s, 1 + s, 2 + s), r.emplaceBack(1 + s, 3 + s, 2 + s), s += 10;
            }
        }
        function xy(e, t1) {
            const r = {};
            r.indexArray = new ol, r.vertexArray = new Ha, r.colorArray = new Qa, gy(e, t1, r.indexArray, r.vertexArray, r.colorArray);
            const n = {
                defined: !0
            };
            n.emissiveFactor = ar.black;
            const i = {};
            return i.baseColorFactor = ar.white, n.pbrMetallicRoughness = i, r.material = n, r.aabb = new vc([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), r;
        }
        const vy = Ra([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), by = Ra([
            {
                name: "a_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), wy = Ra([
            {
                name: "a_centroid_3",
                components: 3,
                type: "Int16"
            }
        ]), _y = Ra([
            {
                name: "a_part_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), Ay = Ra([
            {
                name: "a_faux_facade_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), My = Ra([
            {
                name: "a_faux_facade_data",
                components: 4,
                type: "Uint16"
            }
        ]), Iy = Ra([
            {
                name: "a_faux_facade_vertical_range",
                components: 2,
                type: "Uint16"
            }
        ]), Sy = Ra([
            {
                name: "a_bloom_attenuation",
                components: 4,
                type: "Float32"
            }
        ]), zy = Ra([
            {
                name: "a_flood_light_wall_radius_1i16",
                components: 1,
                type: "Uint16"
            }
        ]), Py = Ju.types, By = 32767;
        function Ty(e, t1) {
            const r = Un + t1;
            for (const n of e)for (const e of n)if (e.x < -t1 || e.x > r || e.y < -t1 || e.y > r) return !1;
            return !0;
        }
        function ky(e) {
            switch(e){
                case "flat":
                    return 3;
                case "hipped":
                    return 1;
                case "gabled":
                    return 2;
                case "parapet":
                    return 0;
                case "mansard":
                    return 4;
                case "skillion":
                    return 5;
                case "pyramidal":
                    return 6;
                default:
                    throw new Error(`Unknown roof shape: ${e}`);
            }
        }
        class Vy {
            constructor(){
                this.layoutVertexArray = new Ha, this.layoutAttenuationArray = new Qa, this.layoutColorArray = new tl, this.indexArray = new ol, this.indexArrayForConflation = new ol, this.segmentsBucket = new Rl;
            }
        }
        class Ey {
            constructor(e){
                this.layoutFacadePaintArray = null, this.layoutFacadeDataArray = null, this.layoutFacadeVerticalRangeArray = null, this.segmentsBucket = new Rl, this.entranceBloom = new Vy;
                const t1 = 66560;
                this.layoutVertexArray = new Ha, this.layoutVertexArray.reserve(t1), this.layoutNormalArray = new Ua, this.layoutNormalArray.reserve(t1), this.layoutCentroidArray = new Ua, this.layoutCentroidArray.reserve(t1), this.layoutColorArray = new tl, this.layoutColorArray.reserve(t1), this.layoutFloodLightDataArray = new yl, this.layoutFloodLightDataArray.reserve(t1), this.layoutAOArray = new bl, this.layoutAOArray.reserve(t1), this.indexArray = new ol, this.indexArray.reserve(66560), this.indexArrayForConflation = new ol, this.segmentsBucket = new Rl, this.entranceBloom = new Vy, e && (this.layoutFacadePaintArray = new tl, this.layoutFacadeDataArray = new Wa, this.layoutFacadeVerticalRangeArray = new tl);
            }
            reserve(e, t1, r) {
                this.layoutVertexArray.reserveForAdditional(e), this.layoutCentroidArray.reserveForAdditional(e), this.layoutFloodLightDataArray.reserveForAdditional(e), this.layoutNormalArray.reserveForAdditional(e), this.layoutAOArray.reserveForAdditional(e), this.layoutColorArray.reserveForAdditional(e), this.indexArray.reserveForAdditional(t1), r && (this.layoutFacadePaintArray.reserveForAdditional(e), this.layoutFacadeDataArray.reserveForAdditional(e), this.layoutFacadeVerticalRangeArray.reserveForAdditional(e));
            }
        }
        class Fy {
            constructor(e){
                this.colorBufferUploaded = !1, this.maxHeight = 0, this.replacementUpdateTime = 0, this.activeReplacements = [], this.footprints = [], this.footprintsVertices = new fl, this.footprintsIndices = new yl, this.footprintsMin = new Ie(1 / 0, 1 / 0), this.footprintsMax = new Ie(-1 / 0, -1 / 0), this.featuresOnBorder = [], this.buildingWithoutFacade = new Ey(!1), this.buildingWithFacade = new Ey(!0), this.indexArrayForConflationUploaded = !1, this.featureFootprintLookup = new Map, this.buildingIds = new Set, this.footprintLookup = {}, this.zoom = e.zoom, this.canonical = e.canonical, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.hasPattern = !1, this.worldview = e.worldview, this.lut = e.lut, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.projection = e.projection, this.groundEffect = new hf(e), this.groundEffect.groundRadiusArray = new ja, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {
                const r = new wd([], [], 1), n = {
                    vertices: [],
                    indices: new Uint32Array(0),
                    grid: r,
                    min: this.footprintsMin,
                    max: this.footprintsMax,
                    buildingIds: this.buildingIds
                };
                t1.push({
                    footprint: n,
                    id: e
                });
            }
            updateAppearances(e, t1, r, n) {}
            prepare() {
                return function() {
                    if (null != sm || null != im) return null;
                    if (null != nm) return nm;
                    const e = fetch(at.BUILDING_GEN_URL);
                    return nm = (function(e) {
                        let t1, r, n, i, s;
                        function o() {
                            t1 = new Uint8Array(s.buffer), r = new Int16Array(s.buffer), n = new Int32Array(s.buffer), i = new Float32Array(s.buffer);
                        }
                        function a() {
                            throw new Error("Unexpected BuildingGen error.");
                        }
                        const l = ()=>{}, u = {
                            a: {
                                a: a,
                                f: function(e) {
                                    const r = t1.length, n = Math.max(e >>> 0, Math.ceil(1.2 * r)), i = Math.ceil((n - r) / 65536);
                                    try {
                                        return s.grow(i), o(), !0;
                                    } catch (e) {
                                        return !1;
                                    }
                                },
                                g: a,
                                b: l,
                                c: l,
                                d: l,
                                e: l
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e, u) : e.then((e)=>e.arrayBuffer()).then((e)=>WebAssembly.instantiate(e, u))).then((e)=>{
                            const a = e.instance.exports;
                            return (0, a.g)(), s = a.f, o(), new Yf({
                                setStyle: a.h,
                                setAOOptions: a.i,
                                setMetricOptions: a.j,
                                setStructuralOptions: a.k,
                                setFacadeOptions: a.l,
                                setFauxFacadeOptions: a.m,
                                setFacadeClassifierOptions: a.n,
                                addFeature: a.o,
                                addFacade: a.p,
                                generateMesh: a.q,
                                getLastError: a.r,
                                getOuterRingLength: a.s,
                                getMeshCount: a.t,
                                getPositionsPtr: a.u,
                                getPositionsLength: a.v,
                                getNormalsPtr: a.w,
                                getNormalsLength: a.x,
                                getAOPtr: a.y,
                                getAOLength: a.z,
                                getUVPtr: a.A,
                                getUVLength: a.B,
                                getFauxFacadePtr: a.C,
                                getFauxFacadeLength: a.D,
                                getIndicesPtr: a.E,
                                getIndicesLength: a.F,
                                getBuildingPart: a.G,
                                getRingCount: a.H,
                                getRingPtr: a.I,
                                getRingLength: a.J,
                                malloc: a.K,
                                free: a.L,
                                heapU8: t1,
                                heap16: r,
                                heap32: n,
                                heapF32: i
                            });
                        });
                    })(e).then((e)=>(nm = null, sm = e, sm)).catch((e)=>{
                        Ze("Could not load building-gen"), nm = null, im = e;
                    }), nm;
                }();
            }
            populate(e, t1, r, n) {
                const i = lm();
                if (!i) return;
                const s = Uu(r);
                this.tileToMeter = s, this.brightness = t1.brightness, i.setStyle({
                    normalScale: [
                        1,
                        -1,
                        s
                    ],
                    tileToMeters: s
                }), i.setAOOptions(!1, .3), i.setMetricOptions(!1, 16), i.setStructuralOptions(!0), i.setFacadeClassifierOptions(3);
                const o = new Map, a = new Map;
                let l = 0;
                for (const { feature: t1 } of e){
                    if ("LineString" !== Py[t1.type]) {
                        o.set(t1.id, t1.properties.source_id);
                        continue;
                    }
                    const e = this.layers[0]._featureFilter.needGeometry;
                    if (e && !this.layers[0]._featureFilter.filter(new Yo(this.zoom), t1, r)) continue;
                    const i = Yu(t1, e);
                    if (!e && !this.layers[0]._featureFilter.filter(new Yo(this.zoom), i, r)) continue;
                    const s = e ? i.geometry : Wu(t1, r, n), u = [];
                    for (const e of s)for (const t1 of e)u.push(t1.x), u.push(t1.y);
                    const c = {
                        coordinates: u,
                        crossPerc: t1.properties.cross_perc,
                        distanceToRoad: t1.properties.distance_to_road,
                        entrances: t1.properties.entrances,
                        sourceId: 0
                    }, h = t1.properties.source_id;
                    let p = a.get(h);
                    p || (p = [], a.set(h, p)), p.push(c), ++l;
                }
                this.maxHeight = 0;
                const u = new Array, c = new Set, h = (e)=>{
                    null != e && c.add(e);
                }, p = (e, t1)=>{
                    null != e && u.push({
                        buildingId: e,
                        footprintIndex: t1
                    });
                }, d = 64 * (e.length - l), f = d / 2;
                this.buildingWithFacade.reserve(d, f, !0), this.buildingWithoutFacade.reserve(2 * d, 2 * f, !1), this.footprintsIndices.reserve(16 * (e.length - l)), this.footprintsVertices.reserve(8 * (e.length - l));
                for (const { feature: l, id: u, index: d, sourceLayerIndex: f } of e){
                    if ("LineString" === Py[l.type]) continue;
                    const e = this.layers[0]._featureFilter.needGeometry;
                    if (e && !this.layers[0]._featureFilter.filter(new Yo(this.zoom), l, r)) continue;
                    let m = null;
                    if (l.properties && l.properties.hasOwnProperty("building_id") && (m = Number(l.properties.building_id), c.has(m))) continue;
                    const y = Yu(l, e);
                    if (!e && !this.layers[0]._featureFilter.filter(new Yo(this.zoom), y, r)) continue;
                    const g = e ? y.geometry : Wu(l, r, n), x = _p(g, 500);
                    let v = !1;
                    for (const e of x)if (1 !== e.length) {
                        v = !0;
                        break;
                    }
                    if (v) {
                        h(m);
                        continue;
                    }
                    if (!Ty(g, 163)) {
                        h(m);
                        continue;
                    }
                    const b = this.layers[0], w = ky(b.layout.get("building-roof-shape").evaluate(l, {}, r)), _ = b.layout.get("building-base").evaluate(l, {}, r), A = b.layout.get("building-height").evaluate(l, {}, r), M = b.layout.get("building-flood-light-ground-radius").evaluate(l, {}, r), I = b.paint.get("building-ambient-occlusion-intensity"), S = M / this.tileToMeter;
                    l.properties["building-part"] = "roof";
                    const z = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), P = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "wall";
                    const B = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), T = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "window";
                    const k = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), V = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "door";
                    const E = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), F = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    let D = b.layout.get("building-flood-light-wall-radius").evaluate(l, {}, r);
                    D = De(D, 0, 2048);
                    const C = D / 2048 * By, R = o.get(u), L = a.get(R) || [], O = 0 !== L.length && b.layout.get("building-facade").evaluate(l, {}, r);
                    i.setFacadeOptions(4, !0), i.setFauxFacadeOptions(O, !1, 1);
                    let U = 0, N = 0, j = 0, G = 0, $ = 0, q = 0, X = 0, H = 0, Z = 0, W = 0, Y = 0;
                    if (O) {
                        let e = Math.round(b.layout.get("building-facade-floors").evaluate(l, {}, r));
                        if (0 === _) {
                            e = Math.max(1, e - (L.length > 0 ? 1 : 0));
                            let t1 = 4;
                            if (A > 100) {
                                const e = [
                                    10,
                                    13,
                                    15
                                ];
                                t1 = e[l.id ? l.id % e.length : 0];
                            } else A <= 10 && (t1 = 3);
                            i.setFacadeOptions(t1, !0), $ = (A < 15 ? 1.3 : 1.61803) * t1 / s;
                        } else $ = _ / s;
                        q = A / s, $ = Math.min($, q), j = b.layout.get("building-facade-unit-width").evaluate(l, {}, r) / s, G = (q - $) / e, i.setFauxFacadeOptions(!0, !0, j);
                        const t1 = b.layout.get("building-facade-window").evaluate(l, {}, r);
                        U = t1[0], N = t1[1], X = Math.floor(65535 * Math.min(1, $ / Un)), H = Math.floor(65535 * Math.min(1, q / Un)), Z = Math.floor(255 * U) << 8 | Math.floor(255 * N), W = Math.floor(65535 * Math.min(1, j / Un)), Y = Math.floor(65535 * Math.min(1, G / Un));
                    }
                    const J = Array(x.length), K = {
                        x: 1 / 0,
                        y: 1 / 0
                    }, Q = {
                        x: -1 / 0,
                        y: -1 / 0
                    }, ee = {
                        x: 0,
                        y: 0
                    };
                    let te = 0;
                    for(let e = 0; e < x.length; e++){
                        const t1 = x[e];
                        if (t1.length > 0) {
                            const r = [], n = Array(t1.length + 1);
                            n[0] = 0;
                            for(let e = 0; e < t1.length; e++){
                                const i = t1[e];
                                for(let e = 0; e < i.length; e++){
                                    const t1 = i[i.length - e - 1];
                                    K.x = Math.min(K.x, t1.x), K.y = Math.min(K.y, t1.y), Q.x = Math.max(Q.x, t1.x), Q.y = Math.max(Q.y, t1.y), ee.x += t1.x, ee.y += t1.y, te++, r.push(t1.x), r.push(t1.y);
                                }
                                n[e + 1] = r.length;
                            }
                            J[e] = {
                                id: l.id ? l.id : 0,
                                height: A,
                                minHeight: _,
                                sourceId: 0,
                                roofType: w,
                                coordinates: r,
                                ringIndices: n
                            };
                        }
                    }
                    ee.x /= te || 1, ee.y /= te || 1;
                    const re = i.generateMesh(J, L);
                    if ("string" == typeof re) {
                        Ze(`Unable to generate building ${l.id}: ${re}`), h(m);
                        continue;
                    }
                    if (0 === re.meshes.length || 0 === re.modifiedPolygonRings.length) {
                        h(m);
                        continue;
                    }
                    const ne = O ? this.buildingWithFacade : this.buildingWithoutFacade;
                    let ie = 0;
                    for (const e of re.meshes)ie += e.positions.length / 3;
                    const se = ne.segmentsBucket.prepareSegment(ie, ne.layoutVertexArray, ne.indexArray), oe = [];
                    let ae = null, le = 0, ue = -1;
                    const ce = ne.layoutVertexArray.length, he = ce + ie;
                    ne.layoutVertexArray.resize(he), ne.layoutCentroidArray.resize(he), ne.layoutNormalArray.resize(he), ne.layoutAOArray.resize(he), ne.layoutColorArray.resize(he), ne.layoutFloodLightDataArray.resize(he), O && (ne.layoutFacadePaintArray.resize(he), ne.layoutFacadeDataArray.resize(he), ne.layoutFacadeVerticalRangeArray.resize(he));
                    const pe = ne.indexArray.length;
                    let de = 0, fe = ce;
                    for (const e of re.meshes){
                        let t1, r;
                        if (1 === e.buildingPart) t1 = z, r = P;
                        else if (0 === e.buildingPart) t1 = B, r = T;
                        else if (2 === e.buildingPart) t1 = k, r = V;
                        else {
                            if (3 !== e.buildingPart) continue;
                            t1 = E, r = F;
                        }
                        if (r = De(r, 0, 1), 3 === e.buildingPart) {
                            const t1 = new Array;
                            for(let r = 0; r < e.positions.length; r += 12){
                                const n = e.positions[r + 0], i = e.positions[r + 1], s = e.positions[r + 3], o = e.positions[r + 4], a = e.positions[r + 2], l = e.positions[r + 8] - a, u = 1, c = s - n, h = o - i, p = Math.hypot(c, h);
                                t1.push({
                                    pos: [
                                        n + .5 * c,
                                        i + .5 * h,
                                        a
                                    ],
                                    normal: [
                                        h / p,
                                        -c / p,
                                        0
                                    ],
                                    width: p,
                                    height: l,
                                    depth: u,
                                    points: [
                                        n,
                                        i,
                                        s,
                                        o
                                    ]
                                });
                            }
                            const r = ne.entranceBloom.segmentsBucket.prepareSegment(10 * t1.length, ne.entranceBloom.layoutVertexArray, ne.entranceBloom.indexArray), n = ne.entranceBloom.layoutVertexArray.length;
                            le = ne.entranceBloom.indexArray.length, gy(t1, .5 / this.tileToMeter, ne.entranceBloom.indexArray, ne.entranceBloom.layoutVertexArray, ne.entranceBloom.layoutAttenuationArray);
                            const i = ne.entranceBloom.layoutVertexArray.length - n;
                            ue = ne.entranceBloom.indexArray.length - le;
                            for(let e = 0; e < i; e++)ne.entranceBloom.layoutColorArray.emplaceBack(255 * E.r << 8 | 255 * E.g, 255 * E.b << 8 | 51 * F);
                            r.vertexLength += i, r.primitiveLength += ue, ae = {
                                part: e.buildingPart,
                                vertexOffset: n,
                                vertexLength: i
                            };
                        }
                        ne.layoutVertexArray.float32.set(e.positions, 3 * fe);
                        const n = e.positions.length / 3;
                        for(let i = 0; i < n; ++i){
                            const n = 3 * i;
                            de = Math.max(de, e.positions[n + 2]);
                            const s = e.normals[n + 1] * By, o = e.normals[n + 2] * By, a = 3 * (fe + i);
                            ne.layoutNormalArray.int16[a] = e.normals[n] * By, ne.layoutNormalArray.int16[a + 1] = s, ne.layoutNormalArray.int16[a + 2] = o;
                            const l = e.ao[i];
                            ne.layoutAOArray.uint8[fe + i] = 255 * l;
                            const u = 1 + (l - 1) * I, c = 255 * t1.b * u << 8 | 255 * r;
                            ne.layoutColorArray.uint16[2 * (fe + i)] = 255 * t1.r * u << 8 | 255 * t1.g * u, ne.layoutColorArray.uint16[2 * (fe + i) + 1] = c;
                        }
                        const i = Math.floor(ee.x), s = Math.floor(ee.y), o = Math.floor(A);
                        for(let e = 0; e < n; ++e){
                            const t1 = 3 * (fe + e);
                            ne.layoutCentroidArray.int16[t1] = i, ne.layoutCentroidArray.int16[t1 + 1] = s, ne.layoutCentroidArray.int16[t1 + 2] = o;
                        }
                        if (ne.layoutFloodLightDataArray.uint16.fill(0 === e.buildingPart ? C : 0, fe, fe + n), O) {
                            const t1 = 255 * k.r << 8 | 255 * k.g, r = 255 * k.b << 8 | 255 * V;
                            for(let e = 0; e < n; ++e){
                                const n = 2 * (fe + e);
                                ne.layoutFacadePaintArray.uint16[n] = t1, ne.layoutFacadePaintArray.uint16[n + 1] = r;
                            }
                            for(let t1 = 0; t1 < n; ++t1)if (e.isFauxFacade[t1]) {
                                const r = Math.min(65535, Math.floor(e.uv[2 * t1] * re.outerRingLength));
                                ne.layoutFacadeDataArray.emplace(fe + t1, 1 | r, Z, W, Y), ne.layoutFacadeVerticalRangeArray.emplace(fe + t1, X, H);
                            } else ne.layoutFacadeDataArray.emplace(fe + t1, 0, 0, 0, 0), ne.layoutFacadeVerticalRangeArray.emplace(fe + t1, 0, 0);
                        }
                        const a = se.vertexLength, l = e.indices.length / 3, u = ne.indexArray.length;
                        ne.indexArray.resize(u + l);
                        for(let t1 = 0; t1 < l; ++t1){
                            const r = 3 * t1, n = 3 * u + r;
                            ne.indexArray.uint16[n] = a + e.indices[r], ne.indexArray.uint16[n + 1] = a + e.indices[r + 1], ne.indexArray.uint16[n + 2] = a + e.indices[r + 2];
                        }
                        1 !== e.buildingPart && 0 !== e.buildingPart && 2 !== e.buildingPart && 3 !== e.buildingPart || oe.push({
                            part: e.buildingPart,
                            vertexOffset: fe,
                            vertexLength: e.positions.length / 3
                        }), fe += n, se.vertexLength += n, se.primitiveLength += e.indices.length / 3;
                    }
                    this.maxHeight = Math.max(this.maxHeight, de);
                    const me = ne.indexArray.length - pe, ye = this.footprintsIndices.length, ge = this.footprintsVertices.length, xe = [], ve = new Ie(1 / 0, 1 / 0), be = new Ie(-1 / 0, -1 / 0), we = this.groundEffect.vertexArray.length;
                    for (const e of re.modifiedPolygonRings){
                        const t1 = [], r = new Ie(1 / 0, 1 / 0), n = new Ie(-1 / 0, -1 / 0);
                        for(let i = 0; i < e.length; i += 2){
                            const s = e.length - i - 2;
                            r.x = Math.min(r.x, e[s]), r.y = Math.min(r.y, e[s + 1]), n.x = Math.max(n.x, e[s]), n.y = Math.max(n.y, e[s + 1]);
                            const o = new Ie(e[s], e[s + 1]);
                            t1.push(o), xe.push(o.x, o.y), this.footprintsVertices.emplaceBack(o.x, o.y);
                        }
                        ve.x = Math.min(ve.x, r.x), ve.y = Math.min(ve.y, r.y), be.x = Math.max(be.x, n.x), be.y = Math.max(be.y, n.y), this.groundEffect.addData(t1, [
                            r,
                            n
                        ], S);
                    }
                    const _e = this.groundEffect.vertexArray.length - we;
                    this.groundEffect.groundRadiusArray.reserveForAdditional(_e);
                    for(let e = 0; e < _e; e++)this.groundEffect.groundRadiusArray.emplaceBack(M);
                    (K.x < 0 || Q.x > Un || K.y < 0 || Q.y > Un) && this.featuresOnBorder.push({
                        featureId: l.id,
                        footprintIndex: this.footprints.length
                    });
                    {
                        const e = Yh(xe, null, 2);
                        this.footprintsIndices.resize(this.footprintsIndices.length + e.length), this.footprintsIndices.uint16.set(e, ye), this.buildingIds.add(null != m ? m : l.id), this.footprintsMin.x = Math.min(this.footprintsMin.x, ve.x), this.footprintsMin.y = Math.min(this.footprintsMin.y, ve.y), this.footprintsMax.x = Math.max(this.footprintsMax.x, be.x), this.footprintsMax.y = Math.max(this.footprintsMax.y, be.y);
                        const t1 = {
                            footprintVertexOffset: ge,
                            footprintVertexLength: this.footprintsVertices.length - ge,
                            footprintIndexOffset: ye,
                            footprintIndexLength: this.footprintsIndices.length - ye,
                            min: ve,
                            max: be,
                            hiddenFlags: 0,
                            indicesOffset: pe,
                            indicesLength: me,
                            bloomIndicesOffset: le,
                            bloomIndicesLength: ue,
                            groundEffectVertexOffset: we,
                            groundEffectVertexLength: _e,
                            hasFauxFacade: O,
                            height: de,
                            promoteId: u,
                            feature: y,
                            parts: oe,
                            buildingBloom: ae
                        }, r = this.footprints.length;
                        void 0 !== l.id && this.featureFootprintLookup.set(l.id, r), p(m, r), this.footprints.push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(ne.layoutVertexArray.length, l, d, {}, t1.availableImages, r, t1.brightness), this.groundEffect.addPaintPropertiesData(l, d, {}, t1.availableImages, r, t1.brightness), t1.featureIndex.insert(l, g, d, f, this.index, ce);
                }
                u.forEach(({ buildingId: e, footprintIndex: t1 })=>{
                    c.has(e) && (this.footprints[t1].hiddenFlags |= 4);
                });
                const m = new Set;
                this.buildingIds.forEach((e, t1, r)=>{
                    c.has(e) || m.add(e);
                }), this.buildingIds = m, this.groundEffect.prepareBorderSegments();
            }
            update(e, t1, r, n, i, s, o) {
                this.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o), this.groundEffect.update(e, t1, i, r, n, s, o), this.evaluate(this.layers[0], e), this.colorBufferUploaded = !1;
            }
            isEmpty() {
                return 0 === this.buildingWithoutFacade.layoutVertexArray.length && 0 === this.buildingWithFacade.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e) {
                const t1 = (t1)=>{
                    t1.layoutVertexBuffer = e.createVertexBuffer(t1.layoutVertexArray, vy.members), t1.layoutNormalBuffer = e.createVertexBuffer(t1.layoutNormalArray, by.members), t1.layoutCentroidBuffer = e.createVertexBuffer(t1.layoutCentroidArray, wy.members), t1.layoutFloodLightDataBuffer = e.createVertexBuffer(t1.layoutFloodLightDataArray, zy.members), t1.layoutFacadeDataArray && t1.layoutFacadeDataArray.length && (t1.layoutFacadeDataBuffer = e.createVertexBuffer(t1.layoutFacadeDataArray, My.members)), t1.layoutFacadeVerticalRangeArray && t1.layoutFacadeVerticalRangeArray.length && (t1.layoutFacadeVerticalRangeBuffer = e.createVertexBuffer(t1.layoutFacadeVerticalRangeArray, Iy.members)), t1.entranceBloom.layoutVertexArray.length && (t1.entranceBloom.layoutVertexBuffer = e.createVertexBuffer(t1.entranceBloom.layoutVertexArray, vy.members), t1.entranceBloom.layoutAttenuationBuffer = e.createVertexBuffer(t1.entranceBloom.layoutAttenuationArray, Sy.members)), this.uploadUpdatedColorBuffer(e), this.uploadUpdatedIndexBuffer(e);
                };
                this.uploaded || (t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.groundEffect.upload(e)), this.groundEffect.uploadPaintProperties(e), this.programConfigurations.upload(e), this.uploaded = !0;
            }
            destroy() {
                const e = (e)=>{
                    e.layoutVertexBuffer && (e.layoutVertexBuffer.destroy(), e.layoutNormalBuffer.destroy(), e.layoutColorBuffer.destroy(), e.segmentsBucket.destroy(), e.indexBuffer && e.indexBuffer.destroy(), e.entranceBloom.layoutVertexBuffer && (e.entranceBloom.layoutVertexBuffer.destroy(), e.entranceBloom.layoutColorBuffer.destroy(), e.entranceBloom.layoutAttenuationBuffer.destroy(), e.entranceBloom.indexBuffer.destroy(), e.entranceBloom.segmentsBucket.destroy()));
                };
                e(this.buildingWithoutFacade), e(this.buildingWithFacade), this.groundEffect.destroy(), this.programConfigurations.destroy();
            }
            updateFootprintHiddenFlags(e, t1, r = !0) {
                let n = !1;
                const i = r ? t1 : 0, s = 0 | (r ? -1 : ~t1);
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of e){
                    const e = this.footprints[t1], r = e.hiddenFlags & s | i;
                    e.hiddenFlags !== r && (e.hiddenFlags = r, n = !0, this.groundEffect.updateHiddenByLandmarkRange(e.groundEffectVertexOffset, e.groundEffectVertexLength, 0 !== e.hiddenFlags));
                }
                return n && (this.indexArrayForConflationUploaded = !1), n;
            }
            uploadUpdatedIndexBuffer(e) {
                if (this.groundEffect.uploadHiddenByLandmark(e), this.indexArrayForConflationUploaded) return;
                const t1 = (e)=>{
                    0 !== e.indexArray.length && (e.indexArrayForConflation.resize(e.indexArray.length), e.indexArrayForConflation.uint16.set(e.indexArray.uint16), e.entranceBloom.indexArrayForConflation.resize(e.entranceBloom.indexArray.length), e.entranceBloom.indexArrayForConflation.uint16.set(e.entranceBloom.indexArray.uint16));
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade);
                for (const e of this.footprints){
                    const t1 = e.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade, r = e.indicesOffset + e.indicesLength;
                    if (0 !== e.hiddenFlags) {
                        for(let n = e.indicesOffset; n < r; n++)t1.indexArrayForConflation.uint16[3 * n + 0] = 0, t1.indexArrayForConflation.uint16[3 * n + 1] = 0, t1.indexArrayForConflation.uint16[3 * n + 2] = 0;
                        const n = e.bloomIndicesOffset + e.bloomIndicesLength;
                        for(let r = e.bloomIndicesOffset; r < n; r++)t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 0] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 1] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 2] = 0;
                    }
                }
                const r = (t1)=>{
                    0 !== t1.indexArray.length && (t1.indexBuffer ? t1.indexBuffer.updateData(t1.indexArrayForConflation) : t1.indexBuffer = e.createIndexBuffer(t1.indexArrayForConflation, !0), t1.entranceBloom.indexBuffer ? t1.entranceBloom.indexBuffer.updateData(t1.entranceBloom.indexArrayForConflation) : t1.entranceBloom.indexBuffer = e.createIndexBuffer(t1.entranceBloom.indexArrayForConflation, !0));
                };
                r(this.buildingWithoutFacade), r(this.buildingWithFacade), this.indexArrayForConflationUploaded = !0;
            }
            uploadUpdatedColorBuffer(e) {
                const t1 = (t1)=>{
                    t1.layoutColorBuffer ? t1.layoutColorBuffer.updateData(t1.layoutColorArray) : t1.layoutColorBuffer = e.createVertexBuffer(t1.layoutColorArray, _y.members, !0), t1.layoutFacadePaintArray && (t1.layoutFacadePaintBuffer ? t1.layoutFacadePaintBuffer.updateData(t1.layoutFacadePaintArray) : t1.layoutFacadePaintBuffer = e.createVertexBuffer(t1.layoutFacadePaintArray, Ay.members, !0)), t1.entranceBloom.layoutColorBuffer ? t1.entranceBloom.layoutColorBuffer.updateData(t1.entranceBloom.layoutColorArray) : t1.entranceBloom.layoutColorBuffer = e.createVertexBuffer(t1.entranceBloom.layoutColorArray, _y.members, !0);
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.colorBufferUploaded = !0;
            }
            evaluate(e, t1) {
                const r = e.paint.get("building-ambient-occlusion-intensity");
                for (const n of this.footprints){
                    if (4 & n.hiddenFlags) continue;
                    const i = t1[n.promoteId], s = n.feature;
                    s.properties["building-part"] = "roof";
                    const o = e.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), a = e.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "wall";
                    const l = e.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), u = e.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "window";
                    const c = e.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), h = e.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "door";
                    const p = e.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), d = e.paint.get("building-emissive-strength").evaluate(s, i, this.canonical), f = n.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade;
                    for (const e of n.parts){
                        let t1, i = o;
                        1 === e.part ? (i = o, t1 = a) : 0 === e.part ? (i = l, t1 = u) : 2 === e.part ? (i = c, t1 = h) : 3 === e.part && (i = p, t1 = d), t1 = De(t1, 0, 1);
                        for(let s = 0; s < e.vertexLength; s++){
                            const o = e.vertexOffset + s, a = 1 + (f.layoutAOArray.uint8[o] / 255 - 1) * r;
                            f.layoutColorArray.emplace(o, i.r * a * 255 << 8 | i.g * a * 255, i.b * a * 255 << 8 | 255 * t1), n.hasFauxFacade && f.layoutFacadePaintArray.emplace(o, 255 * c.r << 8 | 255 * c.g, 255 * c.b << 8 | 255 * h);
                        }
                    }
                    const m = n.buildingBloom;
                    if (m) for(let e = 0; e < m.vertexLength; e++)f.entranceBloom.layoutColorArray.emplace(m.vertexOffset + e, 255 * p.r << 8 | 255 * p.g, 255 * p.b << 8 | 51 * d);
                }
            }
            needsEvaluation() {
                return !this.colorBufferUploaded;
            }
            updateReplacement(e, t1, r) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e.toUnwrapped());
                if (Ld(this.activeReplacements, n)) return;
                this.activeReplacements = n;
                for (const e of this.footprints)e.hiddenFlags &= -2;
                const i = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < r) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e.canonical.z));
                    for (const r of this.footprints)r.min.x > t1.max.x || r.max.x < t1.min.x || r.min.y > t1.max.y || r.max.y < t1.min.y || (i.length = 0, Cy(this.footprintsVertices, r.footprintVertexOffset, r.footprintVertexLength, t1.footprintTileId.canonical, e.canonical, i), Nd(t1.footprint, i, this.footprintsIndices.uint16, r.footprintIndexOffset, r.footprintIndexLength, 0, -n) && (r.hiddenFlags |= 1));
                }
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e of this.footprints)this.groundEffect.updateHiddenByLandmarkRange(e.groundEffectVertexOffset, e.groundEffectVertexLength, 0 !== e.hiddenFlags);
                this.indexArrayForConflationUploaded = !1;
            }
            getFootprint(e) {
                if (void 0 !== e.id) {
                    const t1 = this.featureFootprintLookup.get(e.id);
                    return this.footprints[t1];
                }
                return null;
            }
            getHeightAtTileCoord(e, t1) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (e + Un) * Un + (t1 + Un);
                if (this.footprintLookup.hasOwnProperty(i)) {
                    const e = this.footprintLookup[i];
                    return e ? {
                        height: e.height,
                        hidden: 0 !== e.hiddenFlags
                    } : void 0;
                }
                const s = new Ie(e, t1);
                for (const o of this.footprints)e > o.max.x || o.min.x > e || t1 > o.max.y || o.min.y > t1 || o.height <= r || Dy(s, this.footprintsVertices.float32.subarray(2 * o.footprintVertexOffset, 2 * (o.footprintVertexOffset + o.footprintVertexLength)), this.footprintsIndices.uint16.subarray(o.footprintIndexOffset, o.footprintIndexOffset + o.footprintIndexLength)) && (r = o.height, this.footprintLookup[i] = o, n = 0 !== o.hiddenFlags);
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.footprintLookup[i] = void 0;
            }
        }
        function Dy(e, t1, r) {
            for(let n = 0; n < r.length; n += 3){
                const i = r[n], s = r[n + 1], o = r[n + 2], a = t1[2 * i + 0], l = t1[2 * i + 1], u = t1[2 * s + 0], c = t1[2 * s + 1], h = t1[2 * o + 0], p = t1[2 * o + 1], d = (a - h) * (e.y - p) - (l - p) * (e.x - h), f = (u - a) * (e.y - l) - (c - l) * (e.x - a);
                if (d < 0 != f < 0 && 0 !== d && 0 !== f) continue;
                const m = (h - u) * (e.y - c) - (p - c) * (e.x - u);
                if (0 === m || m < 0 == d + f <= 0) return !0;
            }
            return !1;
        }
        function Cy(e, t1, r, n, i, s) {
            const o = Math.pow(2, n.z - i.z);
            for(let a = 0; a < r; a++){
                let r = e.float32[2 * (a + t1) + 0], l = e.float32[2 * (a + t1) + 1];
                r = (r + i.x * Un) * o - n.x * Un, l = (l + i.y * Un) * o - n.y * Un, s.push(new Ie(r, l));
            }
        }
        let Ry, Ly;
        Js(Fy, "BuildingBucket", {
            omit: [
                "layers"
            ]
        }), Js(Ey, "BuildingGeometry"), Js(Vy, "BuildingBloomGeometry");
        const Oy = Ra([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), Uy = Ra([
            {
                name: "a_z_offset_width",
                components: 3,
                type: "Float32"
            }
        ], 4), Ny = Ra([
            {
                name: "a_elevation_ground_scale",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: jy } = Oy, Gy = Ra([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: $y } = Gy, qy = Ra([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: Xy } = qy;
        class Hy {
            constructor(e, t1){
                this.width = e, this.height = t1, this.nextRow = 0, this.image = new jh({
                    width: e,
                    height: t1
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(e, t1) {
                const r = this.getKey(e, t1);
                return this.positions[r];
            }
            trim() {
                const e = this.width, t1 = this.height = Ne(this.nextRow);
                this.image.resize({
                    width: e,
                    height: t1
                });
            }
            getKey(e, t1) {
                return e.join(",") + t1;
            }
            getDashRanges(e, t1, r) {
                const n = [];
                let i = e.length % 2 == 1 ? -e[e.length - 1] * r : 0, s = e[0] * r, o = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: o,
                    zeroLength: 0 === e[0]
                });
                let a = e[0];
                for(let t1 = 1; t1 < e.length; t1++){
                    o = !o;
                    const l = e[t1];
                    i = a * r, a += l, s = a * r, n.push({
                        left: i,
                        right: s,
                        isDash: o,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(e, t1, r) {
                const n = t1 / 2;
                for(let t1 = -r; t1 <= r; t1++){
                    const i = this.width * (this.nextRow + r + t1);
                    let s = 0, o = e[s];
                    for(let a = 0; a < this.width; a++){
                        a / o.right > 1 && (o = e[++s]);
                        const l = Math.abs(a - o.left), u = Math.abs(a - o.right), c = Math.min(l, u);
                        let h;
                        const p = t1 / r * (n + 1);
                        if (o.isDash) {
                            const e = n - Math.abs(p);
                            h = Math.sqrt(c * c + e * e);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + a] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(e, t1) {
                for(let t1 = e.length - 1; t1 >= 0; --t1){
                    const r = e[t1], n = e[t1 + 1];
                    r.zeroLength ? e.splice(t1, 1) : n && n.isDash === r.isDash && (n.left = r.left, e.splice(t1, 1));
                }
                const r = e[0], n = e[e.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, o = e[s];
                for(let r = 0; r < this.width; r++){
                    r / o.right > 1 && (o = e[++s]);
                    const n = Math.abs(r - o.left), a = Math.abs(r - o.right), l = Math.min(n, a);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (o.isDash ? l : -l) + t1 + 128));
                }
            }
            addDash(e, t1) {
                const r = this.getKey(e, t1);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === t1, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return Ze("LineAtlas out of space"), null;
                0 === e.length && e.push(1);
                let o = 0;
                for(let t1 = 0; t1 < e.length; t1++)e[t1] < 0 && (Ze("Negative value is found in line dasharray, replacing values with 0"), e[t1] = 0), o += e[t1];
                if (0 !== o) {
                    const r = this.width / o, s = this.getDashRanges(e, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === t1 ? .5 * r : 0);
                }
                const a = this.nextRow + i;
                this.nextRow += s;
                const l = {
                    tl: [
                        a,
                        i
                    ],
                    br: [
                        o,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
        }
        Js(Hy, "LineAtlas");
        const Zy = Ju.types, Wy = Math.cos(Math.PI / 180 * 37.5), Yy = Math.cos(Math.PI / 180 * 5);
        class Jy {
            constructor(e){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.elevationType = "none", this.isSeaLevelReference = !1, this.zoom = e.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = e.overscaling, this.pixelRatio = e.pixelRatio, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.projection = e.projection, this.hasPattern = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((e)=>{
                    this.gradients[e.id] = {};
                }), this.layoutVertexArray = new Xa, this.layoutVertexArray2 = new Ha, this.patternVertexArray = new Ha, this.indexArray = new ol, this.programConfigurations = new pu(e.layers, {
                    zoom: e.zoom,
                    lut: e.lut
                }), this.segments = new Rl, this.maxLineLength = 0, this.zOffsetVertexArray = new Ha, this.elevationGroundScaleVertexArray = new ja, this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.tessellationStep = e.tessellationStep ? e.tessellationStep : 128, this.worldview = e.worldview, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {}
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                this.hasPattern = Ip("line", this.layers, this.pixelRatio, t1);
                const i = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = Uu(r);
                const s = this.layers[0].layout.get("line-elevation-reference");
                if ("hd-road-markup" === s) this.elevationType = "road";
                else {
                    const e = this.layers[0].layout.get("line-z-offset"), t1 = e.isConstant() && !e.constantOr(0);
                    this.elevationType = "sea" !== s && "ground" !== s && t1 ? "none" : "offset", "offset" === this.elevationType && "none" === s && Ze(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`), this.isSeaLevelReference = "sea" === s;
                }
                const o = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = "offset" === this.elevationType && void 0 !== o;
                const a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of e){
                    const e = this.layers[0]._featureFilter.needGeometry, c = Yu(s, e);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e ? c.geometry : Wu(s, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((e, t1)=>e.sortKey - t1.sortKey);
                const { lineAtlas: l, featureIndex: u } = t1, c = this.addConstantDashes(l);
                for (const n of a){
                    const { geometry: i, index: s, sourceLayerIndex: o } = n;
                    if (c && this.addFeatureDashes(n, l), this.hasPattern) {
                        const e = Sp("line", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e);
                    } else this.addFeature(n, i, s, r, l.positions, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    u.insert(e[s].feature, i, s, o, this.index);
                }
            }
            addConstantDashes(e) {
                let t1 = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) t1 = !0;
                    else {
                        const t1 = i.value, r = n.value;
                        if (!r) continue;
                        e.addDash(r, t1);
                    }
                }
                return t1;
            }
            addFeatureDashes(e, t1) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let o, a;
                    if ("constant" === i.kind) {
                        if (o = i.value, !o) continue;
                    } else o = i.evaluate({
                        zoom: r
                    }, e);
                    a = "constant" === s.kind ? s.value : s.evaluate({
                        zoom: r
                    }, e), t1.addDash(o, a), e.patterns[n.id] = [
                        t1.getKey(o, a)
                    ];
                }
            }
            update(e, t1, r, n, i, s, o, a) {
                this.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, a);
            }
            addFeatures(e, t1, r, n, i, s) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t1, r, n, s, e.elevationFeatures);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e.createVertexBuffer(this.layoutVertexArray2, $y)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = e.createVertexBuffer(this.patternVertexArray, Xy)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = e.createVertexBuffer(this.zOffsetVertexArray, Uy.members, !0)), !this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexArray.length > 0 && (this.elevationGroundScaleVertexBuffer = e.createVertexBuffer(this.elevationGroundScaleVertexArray, Ny.members, !0)), this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, jy), this.indexBuffer = e.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e, t1) {
                let r, n;
                if (t1 && t1 > 0 ? (r = `mapbox_clip_start_${t1}`, n = `mapbox_clip_end_${t1}`) : (r = "mapbox_clip_start", n = "mapbox_clip_end"), e.properties && e.properties.hasOwnProperty(r) && e.properties.hasOwnProperty(n)) return {
                    start: +e.properties[r],
                    end: +e.properties[n]
                };
            }
            addFeature(e, t1, r, n, i, s, o, a) {
                const l = this.layers[0].layout, u = l.get("line-join").evaluate(e, {}), c = l.get("line-cap").evaluate(e, {}), h = l.get("line-miter-limit"), p = l.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e), this.lineFeature = e;
                const d = !(!e.properties || !e.properties.hasOwnProperty("mapbox_line_metrics")) && e.properties.mapbox_line_metrics;
                this.zOffsetValue = l.get("line-z-offset").value;
                const f = this.layers[0].paint.get("line-width").value;
                if ("constant" !== f.kind && !1 === f.isLineProgressConstant && (this.variableWidthValue = f), this.isSeaLevelReference) {
                    const e = l.get("line-elevation-ground-scale").value;
                    "constant" === e.kind && 0 === e.value || (this.elevationGroundScaleValue = e);
                }
                if ("road" === this.elevationType) {
                    const r = this.layoutVertexArray.length;
                    if (!this.addElevatedRoadFeature(e, t1, n, a, u, c, h, p)) {
                        const [i, s] = this.clipRuntimeLinesToTile(t1, 1);
                        for(let t1 = 0; t1 < i.length; t1++){
                            const r = i[t1], o = s[t1], a = {
                                progress: {
                                    min: o.progress.min,
                                    max: o.progress.max
                                },
                                nextDir: this.computeSegNextDir(o, r),
                                prevDir: this.computeSegPrevDir(o, r)
                            };
                            this.addLine(r, e, n, u, c, h, p, a, d && o.parentIndex > 0 ? o.parentIndex : null);
                        }
                        this.fillNonElevatedRoadSegment(r);
                    }
                } else for(let r = 0; r < t1.length; r++)this.addLine(t1[r], e, n, u, c, h, p, void 0, d && r > 0 ? r : null);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e, r, i, s, n, o, void 0, this.worldview);
            }
            computeSegNextDir(e, t1) {
                return e.nextPoint.sub(t1.at(-2)).unit();
            }
            computeSegPrevDir(e, t1) {
                return t1[1].sub(e.prevPoint).unit();
            }
            clipLinesToTile(e, t1) {
                return Tf(e, -t1, -t1, Un + t1, Un + t1);
            }
            clipRuntimeLinesToTile(e, t1) {
                const r = [];
                return [
                    Tf(e, -t1, -t1, Un + t1, Un + t1, r),
                    r
                ];
            }
            addElevatedRoadFeature(e, t1, r, n, i, s, o, a) {
                const l = [], u = _c.getElevationFeature(e, n);
                if (u) {
                    const e = this.clipLinesToTile(t1, 1), n = this.prepareElevatedLines(e, u, r);
                    for (const e of n)l.push({
                        geometry: e,
                        elevation: u,
                        elevationTileID: r,
                        segment: {
                            progress: {
                                min: 0,
                                max: 1
                            },
                            nextDir: void 0,
                            prevDir: void 0
                        }
                    });
                }
                if (0 === l.length) return !1;
                for (const t1 of l){
                    const n = this.layoutVertexArray.length;
                    this.addLine(t1.geometry, e, r, i, s, o, a);
                    const l = new Ac(r, t1.elevationTileID);
                    if (t1.elevation) for(let e = n; e < this.layoutVertexArray.length; e++){
                        const r = new Ie(this.layoutVertexArray.int16[6 * e] >> 1, this.layoutVertexArray.int16[6 * e + 1] >> 1), n = l.pointElevation(r, t1.elevation, .05);
                        this.updateHeightRange(n), this.zOffsetVertexArray.emplaceBack(n, 0, 0);
                    }
                    else this.fillNonElevatedRoadSegment(n);
                }
                return !0;
            }
            prepareElevatedLines(e, t1, r) {
                if (null != t1.constantHeight) return e;
                const n = [], i = 1 / Uu(r);
                for (const r of e)kf(r, new bc(t1, i), 0, n);
                return n;
            }
            fillNonElevatedRoadSegment(e) {
                for(let t1 = e; t1 < this.layoutVertexArray.length; t1++)this.zOffsetVertexArray.emplaceBack(0, 0, 0);
            }
            updateHeightRange(e) {
                this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, e), this.heightRange.max = Math.max(this.heightRange.max, e)) : this.heightRange = {
                    min: e,
                    max: e
                };
            }
            addLine(e, t1, r, n, i, s, o, a, l) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0, this.lineClips = l ? this.lineFeatureClips(t1, l) : this.lineClips;
                const u = "none" === n;
                this.patternJoinNone = this.hasPattern && u, this.currentLineJoinType = n, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
                const c = a && a.progress.min > 0, h = a && a.progress.max < 1;
                if (this.lineClips) {
                    let r = {
                        min: this.lineClips.start,
                        max: this.lineClips.end
                    }, n = 1;
                    if (a) {
                        const e = this.lineClips.end - this.lineClips.start;
                        r = function(e, t1, r) {
                            return {
                                min: ot(e.min, t1, r),
                                max: ot(e.max, t1, r)
                            };
                        }(a.progress, {
                            min: 0,
                            max: 1
                        }, r), e > 0 && (n = (r.max - r.min) / e);
                    }
                    const i = +t1.properties.mapbox_clip_feature_len, s = +t1.properties.mapbox_clip_seg_len;
                    if (Number.isNaN(i) || Number.isNaN(s)) {
                        for(let t1 = 0; t1 < e.length - 1; t1++)this.totalDistance += e[t1].dist(e[t1 + 1]);
                        const t1 = this.totalDistance / (r.max - r.min);
                        this.totalFeatureLength = Number.isFinite(t1) ? t1 : 0, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    } else this.totalFeatureLength = i, this.distance = s * n, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.distance);
                    this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
                }
                const p = "Polygon" === Zy[t1.type];
                let d = e.length;
                for(; d >= 2 && e[d - 1].equals(e[d - 2]);)d--;
                let f = 0;
                for(; f < d - 1 && e[f].equals(e[f + 1]);)f++;
                if (d < (p ? 3 : 2)) return;
                "bevel" === n && (s = 1.05);
                const m = this.segments.prepareSegment(10 * d, this.layoutVertexArray, this.indexArray);
                let y, g, x, v, b, w, _, A;
                a && a.prevDir && (w = a.prevDir.perp()), a && a.nextDir && (_ = a.nextDir.perp()), this.e1 = this.e2 = -1, p && (y = e[d - 2], b = e[f].sub(y)._unit()._perp());
                for(let t1 = f; t1 < d; t1++){
                    if (x = t1 === d - 1 ? p ? e[f + 1] : void 0 : e[t1 + 1], x && e[t1].equals(x)) continue;
                    b && (v = b), y && (g = y), y = e[t1], A = this.evaluateLineProgressFeatures(g ? g.dist(y) : 0), b = x ? x.sub(y)._unit()._perp() : v, v = v || b;
                    const r = g && x;
                    let a = r ? n : p || u ? "butt" : i;
                    const l = v.x * b.x + v.y * b.y;
                    if (u) {
                        const e = function(e) {
                            if (e.patternJoinNone) {
                                const t1 = e.segmentPoints.length / 2, r = e.lineSoFar - e.segmentStart;
                                for(let n = 0; n < t1; ++n){
                                    const t1 = e.segmentPoints[2 * n + 1], i = Math.round(e.segmentPoints[2 * n]) + .5 + .25 * t1;
                                    e.patternVertexArray.emplaceBack(i, r, e.segmentStart), e.patternVertexArray.emplaceBack(i, r, e.segmentStart);
                                }
                                e.segmentPoints.length = 0;
                            }
                            e.e1 = e.e2 = -1;
                        };
                        if (r && l < Yy) {
                            this.updateDistance(g, y), this.addCurrentVertex(y, v, 1, 1, m, A), e(this), this.addCurrentVertex(y, b, -1, -1, m, A);
                            continue;
                        }
                        if (g) {
                            if (!x) {
                                this.updateDistance(g, y), this.addCurrentVertex(y, v, 1, 1, m, A), e(this);
                                continue;
                            }
                            a = "miter";
                        }
                    }
                    let M = v.add(b);
                    0 === M.x && 0 === M.y || M._unit();
                    const I = M.x * b.x + M.y * b.y, S = 0 !== I ? 1 / I : 1 / 0, z = 2 * Math.sqrt(2 - 2 * I), P = I < Wy && g && x, B = v.x * b.y - v.y * b.x > 0, T = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0;
                    if (r && "round" === a) {
                        if (S < o) a = "miter";
                        else if (S <= 2) {
                            const e = Ky(y, -10, 8202);
                            a = "offset" === this.elevationType && (e || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === a && S > s && (a = "bevel"), "bevel" === a && (S > 2 && (a = "flipbevel"), S < s && (a = "miter")), g && !("miter" === a && P) && this.updateDistance(g, y), "miter" === a) {
                        if (P) {
                            const e = y.dist(g);
                            if (e > 2 * T) {
                                const t1 = y.sub(y.sub(g)._mult(T / e)._round());
                                this.updateDistance(g, t1), this.addCurrentVertex(t1, v, 0, 0, m, A), g = t1;
                            }
                            this.updateDistance(g, y), M._mult(S), this.addCurrentVertex(y, M, 0, 0, m, A);
                            const t1 = y.dist(x);
                            if (t1 > 2 * T) {
                                const e = y.add(x.sub(y)._mult(T / t1)._round());
                                this.updateDistance(y, e), this.addCurrentVertex(e, b, 0, 0, m, A), y = e;
                            }
                        } else M._mult(S), this.addCurrentVertex(y, M, 0, 0, m, A);
                    } else if ("flipbevel" === a) {
                        if (S > 100) M = b.mult(-1);
                        else {
                            const e = S * v.add(b).mag() / v.sub(b).mag();
                            M._perp()._mult(e * (B ? -1 : 1));
                        }
                        this.addCurrentVertex(y, M, 0, 0, m, A), this.addCurrentVertex(y, M.mult(-1), 0, 0, m, A);
                    } else if ("bevel" === a || "fakeround" === a) {
                        const e = y.dist(g);
                        let t1 = 1;
                        if ("offset" === this.elevationType && "bevel" === a && "round" !== this.currentLineJoinType && !this.patternJoinNone && null != A && g && x) {
                            const r = 4 * T;
                            e < r && (t1 = Math.max(0, e / r));
                        }
                        null != A && g && this.addCurrentVertex(y, _ || v, -t1, -t1, m, A);
                        const r = e <= 2 * T && "bevel" !== a, n = M.mult(B ? 1 : -1);
                        n._mult(S);
                        const i = b.mult(B ? -1 : 1), s = v.mult(B ? -1 : 1), o = this.evaluateLineProgressFeatures(this.distance);
                        if (null == A && (this.addHalfVertex(y, n.x, n.y, !1, !B, 0, m, o), r || this.addHalfVertex(y, n.x + 2 * s.x, n.y + 2 * s.y, !1, B, 0, m, o)), "fakeround" === a) {
                            const e = Math.round(180 * z / Math.PI / 20);
                            this.addHalfVertex(y, s.x, s.y, !1, B, 0, m, o);
                            for(let t1 = 0; t1 < e; t1++){
                                let r = t1 / e;
                                if (.5 !== r) {
                                    const e = r - .5;
                                    r += r * e * (r - 1) * ((1.0904 + l * (l * (3.55645 - 1.43519 * l) - 3.2452)) * e * e + (.848013 + l * (.215638 * l - 1.06021)));
                                }
                                const n = i.sub(s)._mult(r)._add(s)._unit();
                                this.addHalfVertex(y, n.x, n.y, !1, B, 0, m, o);
                            }
                            this.addHalfVertex(y, i.x, i.y, !1, B, 0, m, o);
                        }
                        r || null != A || this.addHalfVertex(y, n.x + 2 * i.x, n.y + 2 * i.y, !1, B, 0, m, o), null != A && x && this.addCurrentVertex(y, w || b, t1, t1, m, A);
                    } else if ("butt" === a) this.addCurrentVertex(y, M, 0, 0, m, A);
                    else if ("square" === a) {
                        if (!g) {
                            const e = c ? 0 : -1;
                            this.addCurrentVertex(y, M, e, e, m, A);
                        }
                        if (this.addCurrentVertex(y, M, 0, 0, m, A), g) {
                            const e = h ? 0 : 1;
                            this.addCurrentVertex(y, M, e, e, m, A);
                        }
                    } else if ("round" === a) {
                        if (g) {
                            const e = !r && _ ? _ : v;
                            this.addCurrentVertex(y, e, 0, 0, m, A), !r && h || this.addCurrentVertex(y, e, 1, 1, m, A, !0);
                        }
                        if (x) {
                            const e = !r && w ? w : b;
                            !r && c || this.addCurrentVertex(y, e, -1, -1, m, A, !0), this.addCurrentVertex(y, e, 0, 0, m, A);
                        }
                    }
                }
            }
            addVerticesTo(e, t1, r, n, i, s, o, a, l, u) {
                const c = (t1.w - e.w) / this.tessellationStep | 0;
                let h = 0;
                const p = this.scaledDistance;
                if (c > 1) {
                    this.lineSoFar = e.w;
                    const r = (t1.x - e.x) / c, n = (t1.y - e.y) / c, i = (t1.z - e.z) / c, s = (t1.w - e.w) / c, o = t1.x - e.x, a = t1.y - e.y, p = Math.sqrt(o * o + a * a);
                    if (0 === p) return;
                    const d = -a / p, f = o / p, m = d, y = f, g = -d, x = -f;
                    for(let t1 = 1; t1 < c; ++t1){
                        e.x += r, e.y += n, e.z += i, this.lineSoFar += s, h += s;
                        const t1 = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(e, m, y, u, !1, 0, l, t1), this.addHalfVertex(e, g, x, u, !0, 0, l, t1);
                    }
                }
                this.lineSoFar = t1.w, this.scaledDistance = p;
                const d = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(t1, r, n, u, !1, o, l, d), this.addHalfVertex(t1, i, s, u, !0, -a, l, d);
            }
            evaluateLineProgressFeatures(e) {
                if (!this.variableWidthValue && "offset" !== this.elevationType) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + e) / this.totalFeatureLength) : Ze(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let t1 = 0;
                this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (t1 = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0);
                const r = this.evaluateElevationGroundScale();
                return "offset" !== this.elevationType ? {
                    zOffset: 0,
                    variableWidth: t1,
                    elevationGroundScale: r
                } : "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: t1,
                    elevationGroundScale: r
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: t1,
                    elevationGroundScale: r
                };
            }
            evaluateElevationGroundScale() {
                return this.elevationGroundScaleValue ? "constant" === this.elevationGroundScaleValue.kind ? this.elevationGroundScaleValue.value : this.elevationGroundScaleValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0 : 0;
            }
            addCurrentVertex(e, t1, r, n, i, s, o = !1) {
                const a = t1.x + t1.y * r, l = t1.y - t1.x * r, u = t1.y * n - t1.x, c = -t1.y - t1.x * n;
                if (null != s) {
                    const t1 = "offset" === this.elevationType, h = "offset" === this.elevationType ? 2 : 10, p = -h, d = Un + h, f = s.zOffset, m = new zf(e.x, e.y, f, this.lineSoFar), y = !!t1 && Ky(e, p, d), g = this.lineSoFar, x = this.distance;
                    if (this.currentVertex) {
                        if (y) {
                            const t1 = this.currentVertexIsOutside, s = this.currentVertex, h = new zf(e.x, e.y, f, this.lineSoFar);
                            if (Bf(s, h, p, d), !Ky(h, p, d)) {
                                if (t1) {
                                    this.e1 = this.e2 = -1, this.distance -= s.dist(m), this.lineSoFar = s.w;
                                    const e = this.evaluateLineProgressFeatures(s.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(s, a, l, o, !1, r, i, e), this.addHalfVertex(s, u, c, o, !0, -n, i, e), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + s.dist(h), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(s, h, a, l, u, c, r, n, i, o), this.distance = x, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const e = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                Bf(e, m, p, d), this.e1 = this.e2 = -1, this.distance -= e.dist(m), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e.w;
                                const t1 = this.evaluateLineProgressFeatures(e.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(e, a, l, o, !1, r, i, t1), this.addHalfVertex(e, u, c, o, !0, -n, i, t1), this.prevDistance = this.distance, this.distance = x, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(e, m, a, l, u, c, r, n, i, o);
                        }
                    } else y || (this.addHalfVertex(e, a, l, o, !1, r, i, s), this.addHalfVertex(e, u, c, o, !0, -n, i, s));
                    this.currentVertex = m, this.currentVertexIsOutside = y, this.lineSoFar = g;
                } else this.addHalfVertex(e, a, l, o, !1, r, i, s), this.addHalfVertex(e, u, c, o, !0, -n, i, s);
            }
            addHalfVertex({ x: e, y: t1 }, r, n, i, s, o, a, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s || this.segmentPoints.push(this.lineSoFar - this.segmentStart, o)), this.layoutVertexArray.emplaceBack((e << 1) + (i ? 1 : 0), (t1 << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === o ? 0 : o < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                    const e = hr(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, e);
                }
                const u = a.vertexLength++;
                if (this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), a.primitiveLength++), s ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth), this.elevationGroundScaleValue) {
                    const e = l ? l.elevationGroundScale : this.evaluateElevationGroundScale();
                    this.elevationGroundScaleVertexArray.emplaceBack(e);
                }
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(e, t1) {
                this.prevDistance = this.distance, this.distance += e.dist(t1), this.updateScaledDistance();
            }
        }
        function Ky(e, t1, r) {
            return e.x < t1 || e.x > r || e.y < t1 || e.y > r;
        }
        let Qy, eg;
        function tg(e, t1, r) {
            return t1 * (Un / (e.tileSize * Math.pow(2, r - e.tileID.overscaledZ)));
        }
        Js(Jy, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const rg = (e, t1, r)=>(1 - r) * e + r * t1;
        function ng(e, t1) {
            return 1 / tg(e, 1, t1.tileZoom);
        }
        function ig(e, t1, r, n) {
            return e.translatePosMatrix(n || t1.tileID.projMatrix, t1, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        const sg = (e)=>{
            const t1 = [];
            og(e) && t1.push("RENDER_LINE_DASH"), e.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT");
            const r = e.paint.get("line-trim-offset");
            0 === r[0] && 0 === r[1] || t1.push("RENDER_LINE_TRIM_OFFSET"), 0 !== e.paint.get("line-border-width").constantOr(1) && t1.push("RENDER_LINE_BORDER");
            const n = "none" === e.layout.get("line-join").constantOr("miter"), i = !!e.paint.get("line-pattern").constantOr(1);
            return n && i && t1.push("LINE_JOIN_NONE"), t1;
        };
        function og(e) {
            const t1 = e.paint.get("line-dasharray").value;
            return "constant" !== t1.kind || t1.value;
        }
        let ag;
        const lg = ()=>ag || (ag = {
                layout: Qy || (Qy = new la({
                    "line-cap": new oa(ua.layout_line["line-cap"]),
                    "line-join": new oa(ua.layout_line["line-join"]),
                    "line-miter-limit": new sa(ua.layout_line["line-miter-limit"]),
                    "line-round-limit": new sa(ua.layout_line["line-round-limit"]),
                    "line-sort-key": new oa(ua.layout_line["line-sort-key"]),
                    "line-z-offset": new oa(ua.layout_line["line-z-offset"]),
                    "line-elevation-reference": new sa(ua.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new sa(ua.layout_line["line-cross-slope"]),
                    visibility: new sa(ua.layout_line.visibility),
                    "line-width-unit": new sa(ua.layout_line["line-width-unit"]),
                    "line-elevation-ground-scale": new oa(ua.layout_line["line-elevation-ground-scale"])
                })),
                paint: eg || (eg = new la({
                    "line-opacity": new oa(ua.paint_line["line-opacity"]),
                    "line-color": new oa(ua.paint_line["line-color"]),
                    "line-translate": new sa(ua.paint_line["line-translate"]),
                    "line-translate-anchor": new sa(ua.paint_line["line-translate-anchor"]),
                    "line-width": new oa(ua.paint_line["line-width"]),
                    "line-gap-width": new oa(ua.paint_line["line-gap-width"]),
                    "line-offset": new oa(ua.paint_line["line-offset"]),
                    "line-blur": new oa(ua.paint_line["line-blur"]),
                    "line-dasharray": new oa(ua.paint_line["line-dasharray"]),
                    "line-pattern": new oa(ua.paint_line["line-pattern"]),
                    "line-pattern-cross-fade": new sa(ua.paint_line["line-pattern-cross-fade"]),
                    "line-gradient": new aa(ua.paint_line["line-gradient"]),
                    "line-trim-offset": new sa(ua.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new sa(ua.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new sa(ua.paint_line["line-trim-color"]),
                    "line-emissive-strength": new oa(ua.paint_line["line-emissive-strength"]),
                    "line-border-width": new oa(ua.paint_line["line-border-width"]),
                    "line-border-color": new oa(ua.paint_line["line-border-color"]),
                    "line-occlusion-opacity": new sa(ua.paint_line["line-occlusion-opacity"]),
                    "line-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, ag);
        class ug extends oa {
            possiblyEvaluate(e, t1) {
                return t1 = new Yo(Math.floor(t1.zoom), {
                    now: t1.now,
                    fadeDuration: t1.fadeDuration,
                    transition: t1.transition,
                    worldview: t1.worldview
                }), super.possiblyEvaluate(e, t1);
            }
            evaluate(e, t1, r, n) {
                return t1 = Object.assign({}, t1, {
                    zoom: Math.floor(t1.zoom)
                }), super.evaluate(e, t1, r, n);
            }
        }
        let cg;
        function hg(e, t1) {
            return t1 > 0 ? t1 + 2 * e : e;
        }
        const pg = Ra([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), dg = Ra([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), fg = Ra([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Ra([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const mg = Ra([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), yg = Ra([
            {
                name: "a_x_axis",
                components: 3,
                type: "Float32"
            },
            {
                name: "a_y_axis",
                components: 3,
                type: "Float32"
            }
        ]), gg = Ra([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), xg = Ra([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), vg = Ra([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        Ra([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const bg = Ra([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), wg = Ra([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Ra([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ra([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Ra([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            },
            {
                type: "Uint16",
                name: "elevationFeatureIndex"
            }
        ]), Ra([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ra([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var _g = 24;
        function Ag(e, t1, r) {
            return e.sections.forEach((e)=>{
                e.text = function(e, t1, r) {
                    const n = t1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? e = e.toLocaleUpperCase() : "lowercase" === n && (e = e.toLocaleLowerCase()), Wo.applyArabicShaping && (e = Wo.applyArabicShaping(e)), e;
                }(e.text, t1, r);
            }), e;
        }
        const Mg = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function Ig(e) {
            return "\uFE36" === e || "\uFE48" === e || "\uFE38" === e || "\uFE44" === e || "\uFE42" === e || "\uFE3E" === e || "\uFE3C" === e || "\uFE3A" === e || "\uFE18" === e || "\uFE40" === e || "\uFE10" === e || "\uFE13" === e || "\uFE14" === e || "\uFF40" === e || "\uFFE3" === e || "\uFE11" === e || "\uFE12" === e;
        }
        function Sg(e) {
            return "\uFE35" === e || "\uFE47" === e || "\uFE37" === e || "\uFE43" === e || "\uFE41" === e || "\uFE3D" === e || "\uFE3B" === e || "\uFE39" === e || "\uFE17" === e || "\uFE3F" === e;
        }
        const zg = 4294967296, Pg = 1 / zg, Bg = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        let Tg = class {
            constructor(e = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(e) ? e : new Uint8Array(e), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            readFields(e, t1, r = this.length) {
                for(; this.pos < r;){
                    const r = this.readVarint(), n = r >> 3, i = this.pos;
                    this.type = 7 & r, e(n, t1, this), this.pos === i && this.skip(r);
                }
                return t1;
            }
            readMessage(e, t1) {
                return this.readFields(e, t1, this.readVarint() + this.pos);
            }
            readFixed32() {
                const e = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, e;
            }
            readSFixed32() {
                const e = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, e;
            }
            readFixed64() {
                const e = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * zg;
                return this.pos += 8, e;
            }
            readSFixed64() {
                const e = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * zg;
                return this.pos += 8, e;
            }
            readFloat() {
                const e = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, e;
            }
            readDouble() {
                const e = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, e;
            }
            readVarint(e) {
                const t1 = this.buf;
                let r, n;
                return n = t1[this.pos++], r = 127 & n, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 7, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 14, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 21, n < 128 ? r : (n = t1[this.pos], r |= (15 & n) << 28, function(e, t1, r) {
                    const n = r.buf;
                    let i, s;
                    if (s = n[r.pos++], i = (112 & s) >> 4, s < 128) return kg(e, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 3, s < 128) return kg(e, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 10, s < 128) return kg(e, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 17, s < 128) return kg(e, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 24, s < 128) return kg(e, i, t1);
                    if (s = n[r.pos++], i |= (1 & s) << 31, s < 128) return kg(e, i, t1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(r, e, this)))));
            }
            readVarint64() {
                return this.readVarint(!0);
            }
            readSVarint() {
                const e = this.readVarint();
                return e % 2 == 1 ? (e + 1) / -2 : e / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const e = this.readVarint() + this.pos, t1 = this.pos;
                return this.pos = e, e - t1 >= 12 && Bg ? Bg.decode(this.buf.subarray(t1, e)) : function(e, t1, r) {
                    let n = "", i = t1;
                    for(; i < r;){
                        const t1 = e[i];
                        let s, o, a, l = null, u = t1 > 239 ? 4 : t1 > 223 ? 3 : t1 > 191 ? 2 : 1;
                        if (i + u > r) break;
                        1 === u ? t1 < 128 && (l = t1) : 2 === u ? (s = e[i + 1], 128 == (192 & s) && (l = (31 & t1) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & t1) << 12 | (63 & s) << 6 | 63 & o, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & t1) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += u;
                    }
                    return n;
                }(this.buf, t1, e);
            }
            readBytes() {
                const e = this.readVarint() + this.pos, t1 = this.buf.subarray(this.pos, e);
                return this.pos = e, t1;
            }
            readPackedVarint(e = [], t1) {
                const r = this.readPackedEnd();
                for(; this.pos < r;)e.push(this.readVarint(t1));
                return e;
            }
            readPackedSVarint(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readSVarint());
                return e;
            }
            readPackedBoolean(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readBoolean());
                return e;
            }
            readPackedFloat(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readFloat());
                return e;
            }
            readPackedDouble(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readDouble());
                return e;
            }
            readPackedFixed32(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readFixed32());
                return e;
            }
            readPackedSFixed32(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readSFixed32());
                return e;
            }
            readPackedFixed64(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readFixed64());
                return e;
            }
            readPackedSFixed64(e = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e.push(this.readSFixed64());
                return e;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            skip(e) {
                const t1 = 7 & e;
                if (0 === t1) for(; this.buf[this.pos++] > 127;);
                else if (2 === t1) this.pos = this.readVarint() + this.pos;
                else if (5 === t1) this.pos += 4;
                else {
                    if (1 !== t1) throw new Error(`Unimplemented type: ${t1}`);
                    this.pos += 8;
                }
            }
            writeTag(e, t1) {
                this.writeVarint(e << 3 | t1);
            }
            realloc(e) {
                let t1 = this.length || 16;
                for(; t1 < this.pos + e;)t1 *= 2;
                if (t1 !== this.length) {
                    const e = new Uint8Array(t1);
                    e.set(this.buf), this.buf = e, this.dataView = new DataView(e.buffer), this.length = t1;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(e) {
                this.realloc(4), this.dataView.setInt32(this.pos, e, !0), this.pos += 4;
            }
            writeSFixed32(e) {
                this.realloc(4), this.dataView.setInt32(this.pos, e, !0), this.pos += 4;
            }
            writeFixed64(e) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e * Pg), !0), this.pos += 8;
            }
            writeSFixed64(e) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e * Pg), !0), this.pos += 8;
            }
            writeVarint(e) {
                (e = +e || 0) > 268435455 || e < 0 ? function(e, t1) {
                    let r, n;
                    if (e >= 0 ? (r = e % 4294967296 | 0, n = e / 4294967296 | 0) : (r = ~(-e % 4294967296), n = ~(-e / 4294967296), 4294967295 ^ r ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), e >= 0x10000000000000000 || e < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t1.realloc(10), function(e, t1, r) {
                        r.buf[r.pos++] = 127 & e | 128, e >>>= 7, r.buf[r.pos++] = 127 & e | 128, e >>>= 7, r.buf[r.pos++] = 127 & e | 128, e >>>= 7, r.buf[r.pos++] = 127 & e | 128, r.buf[r.pos] = 127 & (e >>>= 7);
                    }(r, 0, t1), function(e, t1) {
                        const r = (7 & e) << 4;
                        t1.buf[t1.pos++] |= r | ((e >>>= 3) ? 128 : 0), e && (t1.buf[t1.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t1.buf[t1.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t1.buf[t1.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t1.buf[t1.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t1.buf[t1.pos++] = 127 & e)))));
                    }(n, t1);
                }(e, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = e >>> 7 & 127))));
            }
            writeSVarint(e) {
                this.writeVarint(e < 0 ? 2 * -e - 1 : 2 * e);
            }
            writeBoolean(e) {
                this.writeVarint(+e);
            }
            writeString(e) {
                e = String(e), this.realloc(4 * e.length), this.pos++;
                const t1 = this.pos;
                this.pos = function(e, t1, r) {
                    for(let n, i, s = 0; s < t1.length; s++){
                        if (n = t1.charCodeAt(s), n > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === t1.length ? (e[r++] = 239, e[r++] = 191, e[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                e[r++] = 239, e[r++] = 191, e[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (e[r++] = 239, e[r++] = 191, e[r++] = 189, i = null);
                        n < 128 ? e[r++] = n : (n < 2048 ? e[r++] = n >> 6 | 192 : (n < 65536 ? e[r++] = n >> 12 | 224 : (e[r++] = n >> 18 | 240, e[r++] = n >> 12 & 63 | 128), e[r++] = n >> 6 & 63 | 128), e[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, e, this.pos);
                const r = this.pos - t1;
                r >= 128 && Vg(t1, r, this), this.pos = t1 - 1, this.writeVarint(r), this.pos += r;
            }
            writeFloat(e) {
                this.realloc(4), this.dataView.setFloat32(this.pos, e, !0), this.pos += 4;
            }
            writeDouble(e) {
                this.realloc(8), this.dataView.setFloat64(this.pos, e, !0), this.pos += 8;
            }
            writeBytes(e) {
                const t1 = e.length;
                this.writeVarint(t1), this.realloc(t1);
                for(let r = 0; r < t1; r++)this.buf[this.pos++] = e[r];
            }
            writeRawMessage(e, t1) {
                this.pos++;
                const r = this.pos;
                e(t1, this);
                const n = this.pos - r;
                n >= 128 && Vg(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            }
            writeMessage(e, t1, r) {
                this.writeTag(e, 2), this.writeRawMessage(t1, r);
            }
            writePackedVarint(e, t1) {
                t1.length && this.writeMessage(e, Eg, t1);
            }
            writePackedSVarint(e, t1) {
                t1.length && this.writeMessage(e, Fg, t1);
            }
            writePackedBoolean(e, t1) {
                t1.length && this.writeMessage(e, Rg, t1);
            }
            writePackedFloat(e, t1) {
                t1.length && this.writeMessage(e, Dg, t1);
            }
            writePackedDouble(e, t1) {
                t1.length && this.writeMessage(e, Cg, t1);
            }
            writePackedFixed32(e, t1) {
                t1.length && this.writeMessage(e, Lg, t1);
            }
            writePackedSFixed32(e, t1) {
                t1.length && this.writeMessage(e, Og, t1);
            }
            writePackedFixed64(e, t1) {
                t1.length && this.writeMessage(e, Ug, t1);
            }
            writePackedSFixed64(e, t1) {
                t1.length && this.writeMessage(e, Ng, t1);
            }
            writeBytesField(e, t1) {
                this.writeTag(e, 2), this.writeBytes(t1);
            }
            writeFixed32Field(e, t1) {
                this.writeTag(e, 5), this.writeFixed32(t1);
            }
            writeSFixed32Field(e, t1) {
                this.writeTag(e, 5), this.writeSFixed32(t1);
            }
            writeFixed64Field(e, t1) {
                this.writeTag(e, 1), this.writeFixed64(t1);
            }
            writeSFixed64Field(e, t1) {
                this.writeTag(e, 1), this.writeSFixed64(t1);
            }
            writeVarintField(e, t1) {
                this.writeTag(e, 0), this.writeVarint(t1);
            }
            writeSVarintField(e, t1) {
                this.writeTag(e, 0), this.writeSVarint(t1);
            }
            writeStringField(e, t1) {
                this.writeTag(e, 2), this.writeString(t1);
            }
            writeFloatField(e, t1) {
                this.writeTag(e, 5), this.writeFloat(t1);
            }
            writeDoubleField(e, t1) {
                this.writeTag(e, 1), this.writeDouble(t1);
            }
            writeBooleanField(e, t1) {
                this.writeVarintField(e, +t1);
            }
        };
        function kg(e, t1, r) {
            return r ? 4294967296 * t1 + (e >>> 0) : 4294967296 * (t1 >>> 0) + (e >>> 0);
        }
        function Vg(e, t1, r) {
            const n = t1 <= 16383 ? 1 : t1 <= 2097151 ? 2 : t1 <= 268435455 ? 3 : Math.floor(Math.log(t1) / (7 * Math.LN2));
            r.realloc(n);
            for(let t1 = r.pos - 1; t1 >= e; t1--)r.buf[t1 + n] = r.buf[t1];
        }
        function Eg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeVarint(e[r]);
        }
        function Fg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeSVarint(e[r]);
        }
        function Dg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeFloat(e[r]);
        }
        function Cg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeDouble(e[r]);
        }
        function Rg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeBoolean(e[r]);
        }
        function Lg(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeFixed32(e[r]);
        }
        function Og(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeSFixed32(e[r]);
        }
        function Ug(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeFixed64(e[r]);
        }
        function Ng(e, t1) {
            for(let r = 0; r < e.length; r++)t1.writeSFixed64(e[r]);
        }
        function jg(e, t1, r) {
            t1.glyphs = [], 1 === e && r.readMessage(Gg, t1);
        }
        function Gg(e, t1, r) {
            if (3 === e) {
                const { id: e, bitmap: n, width: i, height: s, left: o, top: a, advance: l } = r.readMessage($g, {});
                t1.glyphs.push({
                    id: e,
                    bitmap: new jh({
                        width: i + 6,
                        height: s + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: o,
                        top: a,
                        advance: l
                    }
                });
            } else 4 === e ? t1.ascender = r.readSVarint() : 5 === e && (t1.descender = r.readSVarint());
        }
        function $g(e, t1, r) {
            1 === e ? t1.id = r.readVarint() : 2 === e ? t1.bitmap = r.readBytes() : 3 === e ? t1.width = r.readVarint() : 4 === e ? t1.height = r.readVarint() : 5 === e ? t1.left = r.readSVarint() : 6 === e ? t1.top = r.readSVarint() : 7 === e && (t1.advance = r.readVarint());
        }
        const qg = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class Xg {
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(e, t1) {
                const r = new Xg;
                return r.scale = e || 1, r.fontStack = t1, r;
            }
            static forImage(e) {
                const t1 = new Xg;
                return t1.image = e, t1;
            }
        }
        class Hg {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(e, t1, r, n = 1) {
                const i = new Hg;
                for(let s = 0; s < e.sections.length; s++){
                    const o = e.sections[s];
                    o.image ? i.addImageSection(o, r, n) : i.addTextSection(o, t1);
                }
                return i;
            }
            length() {
                return this.text.length;
            }
            getSection(e) {
                return this.sections[this.sectionIndex[e]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e) {
                return this.sectionIndex[e];
            }
            getCodePoint(e) {
                return this.text.codePointAt(e);
            }
            verticalizePunctuation(e) {
                this.text = function(e, t1) {
                    let r = "";
                    for(let n = 0; n < e.length; n++){
                        const i = e.charCodeAt(n + 1) || null, s = e.charCodeAt(n - 1) || null;
                        r += !t1 && (i && Do(i) && !Mg[e[n + 1]] || s && Do(s) && !Mg[e[n - 1]]) || !Mg[e[n]] ? e[n] : Mg[e[n]];
                    }
                    return r;
                }(this.text, e);
            }
            trim() {
                let e = 0;
                for(let t1 = 0; t1 < this.text.length && Wg[this.text.charCodeAt(t1)]; t1++)e++;
                let t1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= e && Wg[this.text.charCodeAt(r)]; r--)t1--;
                this.text = this.text.substring(e, t1), this.sectionIndex = this.sectionIndex.slice(e, t1);
            }
            substring(e, t1) {
                const r = new Hg;
                return r.text = this.text.substring(e, t1), r.sectionIndex = this.sectionIndex.slice(e, t1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e, t1)=>Math.max(e, this.sections[t1].scale), 0);
            }
            addTextSection(e, t1) {
                this.text += e.text, this.sections.push(Xg.forText(e.scale, e.fontStack || t1));
                const r = this.sections.length - 1;
                for(let t1 = 0; t1 < e.text.length; ++t1)this.sectionIndex.push(r);
            }
            addImageSection(e, t1, r = 1) {
                const n = e.image ? e.image.getPrimary() : null;
                if (!n) return void Ze("Can't add FormattedSection with an empty image.");
                n.scaleSelf(t1 * r);
                const i = this.getNextImageSectionCharCode();
                i ? (this.text += String.fromCodePoint(i), this.sections.push(Xg.forImage(n)), this.sectionIndex.push(this.sections.length - 1)) : Ze("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function Zg(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m = 1, y = 1) {
            const g = Hg.fromFeature(e, i, m, y);
            h === qg.vertical && g.verticalizePunctuation(p);
            let x = [];
            const v = function(e, t1, r, n, i, s, o = 1) {
                if (!e) return [];
                const a = [], l = function(e, t1, r, n, i, s, o = 1) {
                    let a = 0;
                    for(let r = 0; r < e.length(); r++){
                        const l = e.getSection(r);
                        a += Jg(e.getCodePoint(r), l, n, i, t1, s, o);
                    }
                    return a / Math.max(1, Math.ceil(a / r));
                }(e, t1, r, n, i, s, o), u = e.text.indexOf("\u200B") >= 0;
                let c = 0;
                for(let r = 0; r < e.length(); r++){
                    const h = e.getSection(r), p = e.getCodePoint(r);
                    if (Wg[p] || (c += Jg(p, h, n, i, t1, s, o)), r < e.length() - 1) {
                        const t1 = Vo(p);
                        (Yg[p] || t1 || h.image) && a.push(ex(r + 1, c, l, a, Qg(p, e.getCodePoint(r + 1), t1 && u), !1));
                    }
                }
                return tx(ex(e.length(), c, l, a, 0, !0));
            }(g, u, s, t1, n, d, y), { processBidirectionalText: b, processStyledBidirectionalText: w } = Wo;
            if (b && 1 === g.sections.length) {
                const e = b(g.toString(), v);
                for (const t1 of e){
                    const e = new Hg;
                    e.text = t1, e.sections = g.sections;
                    for(let r = 0; r < t1.length; r++)e.sectionIndex.push(0);
                    x.push(e);
                }
            } else if (w) {
                const e = w(g.text, g.sectionIndex, v);
                for (const t1 of e){
                    const e = new Hg;
                    e.text = t1[0], e.sectionIndex = t1[1], e.sections = g.sections, x.push(e);
                }
            } else x = function(e, t1) {
                const r = [], n = e.text;
                let i = 0;
                for (const n of t1)r.push(e.substring(i, n)), i = n;
                return i < n.length && r.push(e.substring(i, n.length)), r;
            }(g, v);
            const _ = [], A = {
                positionedLines: _,
                text: g.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            if (function(e, t1, r, n, i, s, o, a, l, u, c, h, p = 1) {
                let d = 0, f = 0, m = 0;
                const y = "right" === a ? 1 : "left" === a ? 0 : .5;
                let g = !1;
                for (const e of i){
                    const r = e.getSections();
                    for (const e of r){
                        if (e.image) continue;
                        const r = t1[e.fontStack];
                        if (r && (g = void 0 !== r.ascender && void 0 !== r.descender, !g)) break;
                    }
                    if (!g) break;
                }
                let x = 0;
                for (const o of i){
                    o.trim();
                    const i = o.getMaxScale(), a = (i - 1) * _g, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e.positionedLines[x] = v;
                    const b = v.positionedGlyphs;
                    let w = 0;
                    if (!o.length()) {
                        f += s, ++x;
                        continue;
                    }
                    let _ = 0, A = 0;
                    for(let s = 0; s < o.length(); s++){
                        const a = o.getSection(s), m = o.getSectionIndex(s), y = o.getCodePoint(s);
                        let x = a.scale, v = null, M = null, I = null, S = _g, z = 0, P = l;
                        P === qg.vertical && Fo(y) && (P = qg.horizontal);
                        const B = !(P === qg.horizontal || !c && !Eo(y) || c && (Wg[y] || Co(y)));
                        if (a.image) {
                            const t1 = n.get(a.image.toString());
                            if (!t1) continue;
                            I = a.image, e.iconsInText = e.iconsInText || !0, M = t1.paddedRect;
                            const r = t1.displaySize, s = r[0] * p, o = r[1] * p;
                            x = x * _g / h, v = {
                                width: s,
                                height: o,
                                left: 0,
                                top: -3,
                                advance: B ? o : s,
                                localGlyph: !1
                            }, z = g ? -v.height * x : i * _g - 17 - o * x, S = v.advance;
                            const l = (B ? s : o) * x - _g * i;
                            l > 0 && l > w && (w = l);
                        } else {
                            const e = r[a.fontStack];
                            if (!e) continue;
                            e[y] && (M = e[y]);
                            const n = t1[a.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[y];
                            if (!s) continue;
                            if (v = s.metrics, S = 8203 !== y ? _g : 0, g) {
                                const e = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, t1 = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (e + t1) * x;
                                _ < r && (_ = r, A = (e - t1) / 2 * x), z = -e * x;
                            } else z = (i - x) * _g - 17;
                        }
                        B ? (e.verticalizable = !0, b.push({
                            glyph: y,
                            image: I,
                            x: d,
                            y: f + z,
                            vertical: B,
                            scale: x,
                            localGlyph: v.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: m,
                            metrics: v,
                            rect: M
                        }), d += S * x + u) : (b.push({
                            glyph: y,
                            image: I,
                            x: d,
                            y: f + z,
                            vertical: B,
                            scale: x,
                            localGlyph: v.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: m,
                            metrics: v,
                            rect: M
                        }), d += v.advance * x + u);
                    }
                    0 !== b.length && (m = Math.max(d - u, m), g ? nx(b, y, w, A, s * i / 2) : nx(b, y, w, 0, s / 2)), d = 0;
                    const M = s * i + w;
                    v.lineOffset = Math.max(w, a), f += M, ++x;
                }
                const v = f, { horizontalAlign: b, verticalAlign: w } = rx(o);
                (function(e, t1, r, n, i, s) {
                    const o = (t1 - r) * i, a = -s * n;
                    for (const t1 of e)for (const e of t1.positionedGlyphs)e.x += o, e.y += a;
                })(e.positionedLines, y, b, w, m, v), e.top += -w * v, e.bottom = e.top + v, e.left += -b * m, e.right = e.left + m, e.hasBaseline = g;
            }(A, t1, r, n, x, o, a, l, h, u, p, f, y), !function(e) {
                for (const t1 of e)if (0 !== t1.positionedGlyphs.length) return !1;
                return !0;
            }(_)) return A;
        }
        const Wg = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Yg = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function Jg(e, t1, r, n, i, s, o = 1) {
            if (t1.image) {
                const e = n.get(t1.image.toString());
                return e ? e.displaySize[0] * o * t1.scale * _g / s + i : 0;
            }
            {
                const n = r[t1.fontStack], s = n && n.glyphs[e];
                return s ? s.metrics.advance * t1.scale + i : 0;
            }
        }
        function Kg(e, t1, r, n) {
            const i = Math.pow(e - t1, 2);
            return n ? e < t1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function Qg(e, t1, r) {
            let n = 0;
            return 10 === e && (n -= 1e4), r && (n += 150), 40 !== e && 65288 !== e || (n += 50), 41 !== t1 && 65289 !== t1 || (n += 50), n;
        }
        function ex(e, t1, r, n, i, s) {
            let o = null, a = Kg(t1, r, i, s);
            for (const e of n){
                const n = Kg(t1 - e.x, r, i, s) + e.badness;
                n <= a && (o = e, a = n);
            }
            return {
                index: e,
                x: t1,
                priorBreak: o,
                badness: a
            };
        }
        function tx(e) {
            return e ? tx(e.priorBreak).concat(e.index) : [];
        }
        function rx(e) {
            let t1 = .5, r = .5;
            switch(e){
                case "right":
                case "top-right":
                case "bottom-right":
                    t1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t1 = 0;
            }
            switch(e){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: t1,
                verticalAlign: r
            };
        }
        function nx(e, t1, r, n, i) {
            if (!(t1 || r || n || i)) return;
            const s = e.length - 1, o = e[s], a = (o.x + o.metrics.advance * o.scale) * t1;
            for(let t1 = 0; t1 <= s; t1++)e[t1].x -= a, e[t1].y += r + n + i;
        }
        function ix(e) {
            return void 0 !== e.imagePrimary && void 0 !== e.top && void 0 !== e.bottom && void 0 !== e.left && void 0 !== e.right;
        }
        function sx(e, t1, r, n) {
            const { horizontalAlign: i, verticalAlign: s } = rx(n), o = r[0] - e.displaySize[0] * i, a = r[1] - e.displaySize[1] * s;
            return {
                imagePrimary: e,
                imageSecondary: t1,
                top: a,
                bottom: a + e.displaySize[1],
                left: o,
                right: o + e.displaySize[0]
            };
        }
        function ox(e, t1, r, n, i, s) {
            const o = e.imagePrimary;
            let a;
            if (o.content) {
                const e = o.content, t1 = o.pixelRatio || 1;
                a = [
                    e[0] / t1,
                    e[1] / t1,
                    o.displaySize[0] - e[2] / t1,
                    o.displaySize[1] - e[3] / t1
                ];
            }
            const l = t1.left * s, u = t1.right * s;
            let c, h, p, d;
            "width" === r || "both" === r ? (d = i[0] + l - n[3], h = i[0] + u + n[1]) : (d = i[0] + (l + u - o.displaySize[0]) / 2, h = d + o.displaySize[0]);
            const f = t1.top * s, m = t1.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + f - n[0], p = i[1] + m + n[2]) : (c = i[1] + (f + m - o.displaySize[1]) / 2, p = c + o.displaySize[1]), {
                imagePrimary: o,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: p,
                left: d,
                collisionPadding: a
            };
        }
        function ax(e) {
            return !e.imagePrimary.stretchX;
        }
        function lx(e) {
            return !e.imagePrimary.stretchY;
        }
        function ux(e) {
            return {
                width: e.right - e.left,
                height: e.bottom - e.top
            };
        }
        const cx = 128;
        function hx(e, t1, r, n) {
            const { expression: i } = t1;
            if ("constant" === i.kind) return {
                kind: "constant",
                layoutSize: i.evaluate(new Yo(e + 1, {
                    worldview: r
                }), void 0, void 0, void 0, n)
            };
            if ("source" === i.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t1, interpolationType: s } = i;
                let o = 0;
                for(; o < t1.length && t1[o] <= e;)o++;
                o = Math.max(0, o - 1);
                let a = o;
                for(; a < t1.length && t1[a] < e + 1;)a++;
                a = Math.min(t1.length - 1, a);
                const l = t1[o], u = t1[a];
                return "composite" === i.kind ? {
                    kind: "composite",
                    minZoom: l,
                    maxZoom: u,
                    interpolationType: s
                } : {
                    kind: "camera",
                    minZoom: l,
                    maxZoom: u,
                    minSize: i.evaluate(new Yo(l, {
                        worldview: r
                    }), void 0, void 0, void 0, n),
                    maxSize: i.evaluate(new Yo(u, {
                        worldview: r
                    }), void 0, void 0, void 0, n),
                    interpolationType: s
                };
            }
        }
        function px(e, { uSize: t1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === e.kind ? n / cx : "composite" === e.kind ? hr(n / cx, i / cx, r) : t1;
        }
        function dx(e, t1, r = 1) {
            let n = 0, i = 0;
            if ("constant" === e.kind) i = e.layoutSize * r;
            else if ("source" !== e.kind) {
                const { interpolationType: s, minZoom: o, maxZoom: a } = e, l = s ? De(qi.interpolationFactor(s, t1, o, a), 0, 1) : 0;
                "camera" === e.kind ? i = hr(e.minSize, e.maxSize, l) * r : n = l * r;
            }
            return {
                uSizeT: n,
                uSize: i
            };
        }
        class fx extends Ie {
            constructor(e, t1, r, n, i){
                super(e, t1), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new fx(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function mx(e, t1, r, n, i) {
            if (void 0 === t1.segment) return !0;
            let s = t1, o = t1.segment + 1, a = 0;
            for(; a > -r / 2;){
                if (o--, o < 0) return !1;
                a -= e[o].dist(s), s = e[o];
            }
            a += e[o].dist(e[o + 1]), o++;
            const l = [];
            let u = 0;
            for(; a < r / 2;){
                const t1 = e[o], r = e[o + 1];
                if (!r) return !1;
                let s = e[o - 1].angleTo(t1) - t1.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: s
                }), u += s; a - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                o++, a += t1.dist(r);
            }
            return !0;
        }
        function yx(e) {
            let t1 = 0;
            for(let r = 0; r < e.length - 1; r++)t1 += e[r].dist(e[r + 1]);
            return t1;
        }
        function gx(e, t1, r) {
            return e ? .6 * t1 * r : 0;
        }
        function xx(e, t1) {
            return Math.max(e ? e.right - e.left : 0, t1 ? t1.right - t1.left : 0);
        }
        function vx(e, t1, r, n, i, s) {
            const o = gx(r, i, s), a = xx(r, n) * s;
            let l = 0;
            const u = yx(e) / 2;
            for(let r = 0; r < e.length - 1; r++){
                const n = e[r], i = e[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = hr(n.x, i.x, c), p = hr(n.y, i.y, c), d = new fx(h, p, 0, i.angleTo(n), r);
                    return !o || mx(e, d, a, o, t1) ? d : void 0;
                }
                l += s;
            }
        }
        function bx(e, t1, r, n, i, s, o, a, l) {
            const u = gx(n, s, o), c = xx(n, i), h = c * o, p = 0 === e[0].x || e[0].x === l || 0 === e[0].y || e[0].y === l;
            return t1 - h < t1 / 4 && (t1 = h + t1 / 4), wx(e, p ? t1 / 2 * a % t1 : (c / 2 + 2 * s) * o * a % t1, t1, u, r, h, p, !1, l);
        }
        function wx(e, t1, r, n, i, s, o, a, l) {
            const u = s / 2, c = yx(e);
            let h = 0, p = t1 - r, d = [];
            for(let t1 = 0; t1 < e.length - 1; t1++){
                const o = e[t1], a = e[t1 + 1], f = o.dist(a), m = a.angleTo(o);
                for(; p + r < h + f;){
                    p += r;
                    const y = (p - h) / f, g = hr(o.x, a.x, y), x = hr(o.y, a.y, y);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new fx(g, x, 0, m, t1);
                        n && !mx(e, r, s, n, i) || d.push(r);
                    }
                }
                h += f;
            }
            return a || d.length || o || (d = wx(e, h / 2, r, n, i, s, o, !0, l)), d;
        }
        function _x(e) {
            let t1 = 0, r = 0;
            for (const n of e)t1 += n.w * n.h, r = Math.max(r, n.w);
            e.sort((e, t1)=>t1.h - e.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const t1 of e)for(let e = n.length - 1; e >= 0; e--){
                const r = n[e];
                if (!(t1.w > r.w || t1.h > r.h)) {
                    if (t1.x = r.x, t1.y = r.y, s = Math.max(s, t1.y + t1.h), i = Math.max(i, t1.x + t1.w), t1.w === r.w && t1.h === r.h) {
                        const t1 = n.pop();
                        t1 && e < n.length && (n[e] = t1);
                    } else t1.h === r.h ? (r.x += t1.w, r.w -= t1.w) : t1.w === r.w ? (r.y += t1.h, r.h -= t1.h) : (n.push({
                        x: r.x + t1.w,
                        y: r.y,
                        w: r.w - t1.w,
                        h: t1.h
                    }), r.y += t1.h, r.h -= t1.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: t1 / (i * s) || 0
            };
        }
        function Ax(e, t1) {
            return e.id < t1.id ? -1 : e.id > t1.id ? 1 : e.version < t1.version ? -1 : e.version > t1.version ? 1 : e.sx < t1.sx ? -1 : e.sx > t1.sx ? 1 : e.sy < t1.sy ? -1 : e.sy > t1.sy ? 1 : 0;
        }
        function Mx(e) {
            let t1 = 0;
            for(let r = 0; r < e.length; r++)t1 = (t1 << 5) - t1 + e.charCodeAt(r), t1 &= t1;
            return t1;
        }
        function Ix(e, t1) {
            return (e << 5) - e + t1;
        }
        function Sx(e, t1, r, n) {
            for (const [i] of e.entries()){
                const e = n && n.get(i) || Cr.parse(i), s = e.id.toString(), o = t1.get(s) || 0;
                r.push({
                    id: i,
                    version: o,
                    sx: e.sx,
                    sy: e.sy
                });
            }
        }
        Js(fx, "Anchor");
        class zx {
            constructor(e, t1, r, n, i){
                this.iconDescriptors = [], this.patternDescriptors = [], this.requiresMipMaps = t1.size > 0, Sx(e, r, this.iconDescriptors, i), Sx(t1, r, this.patternDescriptors, i), this.iconDescriptors.sort(Ax), this.patternDescriptors.sort(Ax);
                let s = 0;
                const o = n ? n.data : "";
                o && (s = Ix(s, Mx(o))), s = Ix(s, 1);
                for (const e of this.iconDescriptors)s = Ix(s, Mx(e.id)), s = Ix(s, e.version), s = Ix(s, e.sx), s = Ix(s, e.sy);
                s = Ix(s, 1);
                for (const e of this.patternDescriptors)s = Ix(s, Mx(e.id)), s = Ix(s, e.version), s = Ix(s, e.sx), s = Ix(s, e.sy);
                this.hash = s;
            }
            subsetOf(e) {
                return this.isSubsetArray(this.iconDescriptors, e.iconDescriptors, Ax) && this.isSubsetArray(this.patternDescriptors, e.patternDescriptors, Ax);
            }
            isSubsetArray(e, t1, r) {
                let n = 0, i = 0;
                if (e.length > t1.length) return !1;
                for(; n < e.length && i < t1.length;){
                    const s = r(e[n], t1[i]);
                    if (0 === s) n++, i++;
                    else {
                        if (s < 0) return !1;
                        i++;
                    }
                }
                return n === e.length;
            }
        }
        Js(zx, "AtlasContentDescriptor");
        class Px {
            static getImagePositionScale(e, t1, r) {
                if (t1 && e) {
                    const { sx: t1, sy: r } = e;
                    return {
                        x: t1,
                        y: r
                    };
                }
                return {
                    x: r,
                    y: r
                };
            }
            constructor(e, t1, r, n){
                this.paddedRect = e;
                const { pixelRatio: i, version: s, stretchX: o, stretchY: a, content: l, sdf: u, usvg: c } = t1;
                this.pixelRatio = i, this.stretchX = o, this.stretchY = a, this.content = l, this.version = s, this.padding = r, this.sdf = u, this.usvg = c, this.scale = Px.getImagePositionScale(n, c, i);
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
        }
        function Bx(e, t1, r) {
            const n = Cr.parse(e), i = function(e, t1, r = [
                1,
                1
            ]) {
                return {
                    x: 0,
                    y: 0,
                    w: (e.data ? e.data.width : e.width * r[0]) + 2 * t1,
                    h: (e.data ? e.data.height : e.height * r[1]) + 2 * t1
                };
            }(t1, r, [
                n.sx,
                n.sy
            ]);
            return {
                bin: i,
                imagePosition: new Px(i, t1, r, n),
                imageVariant: n
            };
        }
        function Tx(e, t1) {
            const r = [];
            for (const [n, i] of e.entries()){
                const e = Cr.parse(n);
                e && (r.push({
                    key: n,
                    value: i,
                    variant: e
                }), t1 && t1.set(n, e));
            }
            r.sort((e, t1)=>{
                const r = e.variant.id.toString().localeCompare(t1.variant.id.toString());
                return 0 !== r ? r : e.variant.sx !== t1.variant.sx ? e.variant.sx - t1.variant.sx : e.variant.sy !== t1.variant.sy ? e.variant.sy - t1.variant.sy : 0;
            });
            const n = new Map;
            for (const e of r)n.set(e.key, e.value);
            return n;
        }
        class kx {
            constructor(e){
                this.sourceAtlasHash = e;
            }
        }
        class Vx {
            constructor(e, t1, r, n){
                const i = new Map, s = new Map;
                this.haveRenderCallbacks = [];
                const o = [], a = void 0 !== n, l = a ? new Map : void 0, u = a ? Tx(e, l) : e, c = a ? Tx(t1, l) : t1;
                this.addImages(u, i, 1, o), this.addImages(c, s, 2, o);
                const { w: h, h: p } = _x(o), d = new Gh({
                    width: h || 1,
                    height: p || 1
                });
                for (const [e, t1] of u.entries()){
                    const r = i.get(e).paddedRect;
                    Gh.copy(t1.data, d, {
                        x: 0,
                        y: 0
                    }, {
                        x: r.x + 1,
                        y: r.y + 1
                    }, t1.data, null, t1.sdf);
                }
                for (const [e, t1] of c.entries()){
                    const n = s.get(e), i = n.paddedRect;
                    let o = n.padding;
                    const a = i.x + o, l = i.y + o, u = t1.data.width, c = t1.data.height;
                    o = o > 1 ? o - 1 : o, Gh.copy(t1.data, d, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: l
                    }, t1.data, r), Gh.copy(t1.data, d, {
                        x: 0,
                        y: c - o
                    }, {
                        x: a,
                        y: l - o
                    }, {
                        width: u,
                        height: o
                    }, r), Gh.copy(t1.data, d, {
                        x: 0,
                        y: 0
                    }, {
                        x: a,
                        y: l + c
                    }, {
                        width: u,
                        height: o
                    }, r), Gh.copy(t1.data, d, {
                        x: u - o,
                        y: 0
                    }, {
                        x: a - o,
                        y: l
                    }, {
                        width: o,
                        height: c
                    }, r), Gh.copy(t1.data, d, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + u,
                        y: l
                    }, {
                        width: o,
                        height: c
                    }, r), Gh.copy(t1.data, d, {
                        x: u - o,
                        y: c - o
                    }, {
                        x: a - o,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, r), Gh.copy(t1.data, d, {
                        x: 0,
                        y: c - o
                    }, {
                        x: a + u,
                        y: l - o
                    }, {
                        width: o,
                        height: o
                    }, r), Gh.copy(t1.data, d, {
                        x: 0,
                        y: 0
                    }, {
                        x: a + u,
                        y: l + c
                    }, {
                        width: o,
                        height: o
                    }, r), Gh.copy(t1.data, d, {
                        x: u - o,
                        y: 0
                    }, {
                        x: a - o,
                        y: l + c
                    }, {
                        width: o,
                        height: o
                    }, r);
                }
                this.lut = r, this.image = d, this.iconPositions = i, this.patternPositions = s, a && (this.contentDescriptor = new zx(u, c, n, r, l));
            }
            addImages(e, t1, r, n) {
                for (const [i, s] of e.entries()){
                    const { bin: e, imagePosition: o, imageVariant: a } = Bx(i, s, r);
                    t1.set(i, o), n.push(e), s.hasRenderCallback && this.haveRenderCallbacks.push(a.id);
                }
            }
            patchUpdatedImages(e, t1, r, n) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t1)=>e.hasImage(t1, r)), e.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
                for (const i of e.getUpdatedImages(r)){
                    for (const n of this.iconPositions.keys()){
                        const s = Cr.parse(n);
                        if (nr.isEqual(s.id, i)) {
                            const s = e.getImage(i, r);
                            this.patchUpdatedImage(this.iconPositions.get(n), s, t1, null);
                        }
                    }
                    for (const s of this.patternPositions.keys()){
                        const o = Cr.parse(s);
                        if (nr.isEqual(o.id, i)) {
                            const o = e.getImage(i, r);
                            this.patchUpdatedImage(this.patternPositions.get(s), o, t1, n || this.lut);
                        }
                    }
                }
            }
            patchUpdatedImage(e, t1, r, n = null) {
                if (!e || !t1) return;
                if (e.version === t1.version) return;
                e.version = t1.version;
                const [i, s] = e.tl, o = e.sdf;
                if (this.lut || o) {
                    const e = {
                        width: t1.data.width,
                        height: t1.data.height
                    }, a = new Gh(e);
                    Gh.copy(t1.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, e, n, o), r.update(a, {
                        position: {
                            x: i,
                            y: s
                        }
                    });
                } else r.update(t1.data, {
                    position: {
                        x: i,
                        y: s
                    }
                });
            }
        }
        Js(Px, "ImagePosition"), Js(Vx, "ImageAtlas", {
            omit: [
                "lut"
            ]
        }), Js(kx, "ImageAtlasReference");
        const Ex = 1e20;
        function Fx(e, t1, r, n, i, s, o, a, l) {
            for(let u = t1; u < t1 + n; u++)Dx(e, r * s + u, s, i, o, a, l);
            for(let u = r; u < r + i; u++)Dx(e, u * s + t1, 1, n, o, a, l);
        }
        function Dx(e, t1, r, n, i, s, o) {
            s[0] = 0, o[0] = -Ex, o[1] = Ex, i[0] = e[t1];
            for(let a = 1, l = 0, u = 0; a < n; a++){
                i[a] = e[t1 + a * r];
                const n = a * a;
                do {
                    const e = s[l];
                    u = (i[a] - i[e] + n - e * e) / (a - e) / 2;
                }while (u <= o[l] && --l > -1);
                l++, s[l] = a, o[l] = u, o[l + 1] = Ex;
            }
            for(let a = 0, l = 0; a < n; a++){
                for(; o[l + 1] < a;)l++;
                const n = s[l], u = a - n;
                e[t1 + a * r] = i[n] + u * u;
            }
        }
        const Cx = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class Rx {
            constructor(e, t1, r){
                this.requestManager = e, this.localGlyphMode = t1, this.localFontFamily = r, this.url = "", this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(e) {
                this.url = e;
            }
            getGlyphs(e, t1) {
                const r = [], n = this.url || at.GLYPHS_URL;
                for(const t1 in e)for (const n of e[t1])r.push({
                    stack: t1,
                    id: n
                });
                Le(r, ({ stack: e, id: t1 }, r)=>{
                    let i = this.entries[e];
                    i || (i = this.entries[e] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let s = i.glyphs[t1];
                    if (void 0 !== s) return void r(null, {
                        stack: e,
                        id: t1,
                        glyph: s
                    });
                    if (s = this._tinySDF(i, e, t1), s) return i.glyphs[t1] = s, void r(null, {
                        stack: e,
                        id: t1,
                        glyph: s
                    });
                    const o = Math.floor(t1 / 256);
                    if (256 * o > 65535) return Ze("glyphs > 65535 not supported"), void r(null, {
                        stack: e,
                        id: t1,
                        glyph: s
                    });
                    if (i.ranges[o]) return void r(null, {
                        stack: e,
                        id: t1,
                        glyph: s
                    });
                    let a = i.requests[o];
                    a || (a = i.requests[o] = [], Rx.loadGlyphRange(e, o, n, this.requestManager, (e, t1)=>{
                        if (t1) {
                            i.ascender = t1.ascender, i.descender = t1.descender;
                            for(const e in t1.glyphs)this._doesCharSupportLocalGlyph(+e) || (i.glyphs[+e] = t1.glyphs[+e]);
                            i.ranges[o] = !0;
                        }
                        for (const r of a)r(e, t1);
                        delete i.requests[o];
                    })), a.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: e,
                            id: t1,
                            glyph: i.glyphs[t1] || null
                        });
                    });
                }, (e, r)=>{
                    if (e) t1(e);
                    else if (r) {
                        const e = {};
                        for (const { stack: t1, id: n, glyph: i } of r)void 0 === e[t1] && (e[t1] = {}), void 0 === e[t1].glyphs && (e[t1].glyphs = {}), e[t1].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, e[t1].ascender = this.entries[t1].ascender, e[t1].descender = this.entries[t1].descender;
                        t1(null, e);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e) {
                var t1;
                return this.localGlyphMode !== Cx.none && (this.localGlyphMode === Cx.all ? !!this.localFontFamily : !!this.localFontFamily && (xo(e) || wo(e) || lo(e) || uo(e) || ao(e) || go(e) || (t1 = e) >= 131072 && t1 <= 173791 || ((e)=>e >= 66736 && e <= 66815)(e)));
            }
            _tinySDF(e, t1, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = e.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(t1) ? r = "900" : /medium/i.test(t1) ? r = "500" : /light/i.test(t1) && (r = "200"), i = e.tinySDF = new Rx.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 48,
                        buffer: 6,
                        radius: 16
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const s = String.fromCodePoint(r), { data: o, width: a, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: d } = i.draw(s);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new jh({
                        width: a,
                        height: l
                    }, o),
                    metrics: {
                        width: u / 2,
                        height: c / 2,
                        left: h / 2,
                        top: p / 2 - 27,
                        advance: d / 2,
                        localGlyph: !0
                    }
                };
            }
        }
        function Lx(e, t1) {
            return e + t1[1] - t1[0];
        }
        function Ox(e, t1, r, n, i = 1) {
            const s = [], o = e.imagePrimary, a = o.pixelRatio, l = o.paddedRect.w - 2, u = o.paddedRect.h - 2, c = (e.right - e.left) * i, h = (e.bottom - e.top) * i, p = o.stretchX || [
                [
                    0,
                    l
                ]
            ], d = o.stretchY || [
                [
                    0,
                    u
                ]
            ], f = p.reduce(Lx, 0), m = d.reduce(Lx, 0), y = l - f, g = u - m;
            let x = 0, v = f, b = 0, w = m, _ = 0, A = y, M = 0, I = g;
            if (o.content && n) {
                const e = o.content;
                x = Nx(p, 0, e[0]), b = Nx(d, 0, e[1]), v = Nx(p, e[0], e[2]), w = Nx(d, e[1], e[3]), _ = e[0] - x, M = e[1] - b, A = e[2] - e[0] - v, I = e[3] - e[1] - w;
            }
            const S = (n, s, l, u)=>{
                const p = $x(n.stretch - x, v, c, e.left * i), d = qx(n.fixed - _, A, n.stretch, f), y = $x(s.stretch - b, w, h, e.top * i), g = qx(s.fixed - M, I, s.stretch, m), S = $x(l.stretch - x, v, c, e.left * i), z = qx(l.fixed - _, A, l.stretch, f), P = $x(u.stretch - b, w, h, e.top * i), B = qx(u.fixed - M, I, u.stretch, m), T = new Ie(p, y), k = new Ie(S, y), V = new Ie(S, P), E = new Ie(p, P), F = new Ie(d / a, g / a), D = new Ie(z / a, B / a), C = t1 * Math.PI / 180;
                if (C) {
                    const e = Math.sin(C), t1 = Math.cos(C), r = [
                        t1,
                        -e,
                        e,
                        t1
                    ];
                    T._matMult(r), k._matMult(r), E._matMult(r), V._matMult(r);
                }
                const R = n.stretch + n.fixed, L = l.stretch + l.fixed, O = s.stretch + s.fixed, U = u.stretch + u.fixed, N = e.imageSecondary;
                return {
                    tl: T,
                    tr: k,
                    bl: E,
                    br: V,
                    texPrimary: {
                        x: o.paddedRect.x + 1 + R,
                        y: o.paddedRect.y + 1 + O,
                        w: L - R,
                        h: U - O
                    },
                    texSecondary: N ? {
                        x: N.paddedRect.x + 1 + R,
                        y: N.paddedRect.y + 1 + O,
                        w: L - R,
                        h: U - O
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: F,
                    pixelOffsetBR: D,
                    minFontScaleX: A / a / c,
                    minFontScaleY: I / a / h,
                    isSDF: r
                };
            };
            if (o.stretchX || o.stretchY) {
                const e = jx(p, y, f), t1 = jx(d, g, m);
                for(let r = 0; r < e.length - 1; r++){
                    const n = e[r], i = e[r + 1];
                    for(let e = 0; e < t1.length - 1; e++)s.push(S(n, t1[e], i, t1[e + 1]));
                }
            } else s.push(S({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function Ux(e, t1) {
            const r = e.stretchY || [
                [
                    0,
                    e.paddedRect.h - 2
                ]
            ];
            return e.stretchX || e.stretchY ? Gx(e.stretchX || [
                [
                    0,
                    e.paddedRect.w - 2
                ]
            ]) * Gx(r) : 1;
        }
        function Nx(e, t1, r) {
            let n = 0;
            for (const i of e)n += Math.max(t1, Math.min(r, i[1])) - Math.max(t1, Math.min(r, i[0]));
            return n;
        }
        function jx(e, t1, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [t1, r] of e){
                const e = n[n.length - 1];
                n.push({
                    fixed: t1 - e.stretch,
                    stretch: e.stretch
                }), n.push({
                    fixed: t1 - e.stretch,
                    stretch: e.stretch + (r - t1)
                });
            }
            return n.push({
                fixed: t1 + 1,
                stretch: r
            }), n;
        }
        function Gx(e) {
            return 2 * e.length + 1;
        }
        function $x(e, t1, r, n) {
            return e / t1 * r + n;
        }
        function qx(e, t1, r, n) {
            return e - t1 * r / n;
        }
        function Xx(e, t1, r, n) {
            const i = t1 + e.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (t1 + e.positionedLines[n - 1].lineOffset)) / 2;
        }
        function Hx(e, t1, r, n, i, s, o, a, l, u = 1) {
            const c = [];
            if (0 === t1.positionedLines.length) return c;
            const h = (void 0 !== l ? l : n.layout.get("text-rotate").evaluate(s, {})) * Math.PI / 180, p = function(e) {
                const t1 = e[0], r = e[1], n = t1 * r;
                return n > 0 ? [
                    t1,
                    -r
                ] : n < 0 ? [
                    -t1,
                    r
                ] : 0 === t1 ? [
                    r,
                    t1
                ] : [
                    r,
                    -t1
                ];
            }(r);
            let d = Math.abs(t1.top - t1.bottom);
            for (const e of t1.positionedLines)d -= e.lineOffset;
            const f = t1.positionedLines.length, m = d / f;
            let y = t1.top - r[1];
            for(let e = 0; e < f; ++e){
                const n = t1.positionedLines[e];
                y = Xx(t1, m, y, e);
                for (const e of n.positionedGlyphs){
                    if (!e.rect) continue;
                    const n = e.rect || {};
                    let s = 4, l = !0, d = 1, f = 0;
                    if (e.image) {
                        const t1 = o.get(e.image.toString());
                        if (!t1) continue;
                        if (t1.sdf) {
                            Ze("SDF images are not supported in formatted text and will be ignored.");
                            continue;
                        }
                        l = !1, d = t1.pixelRatio, s = 1 / d, t1.usvg || (d /= u);
                    }
                    const m = (i || a) && e.vertical, g = e.metrics.advance * e.scale / 2, x = e.metrics, v = e.rect;
                    if (null === v) continue;
                    a && t1.verticalizable && (f = e.image ? g - e.metrics.width * e.scale / 2 : 0);
                    const b = i ? [
                        e.x + g,
                        e.y
                    ] : [
                        0,
                        0
                    ];
                    let w = [
                        0,
                        0
                    ], _ = [
                        0,
                        0
                    ], A = !1;
                    i || (m ? (_ = [
                        e.x + g + p[0],
                        e.y + p[1] - f
                    ], A = !0) : w = [
                        e.x + g + r[0],
                        e.y + r[1] - f
                    ]);
                    const M = v.w * e.scale / (d * (e.localGlyph ? 2 : 1)), I = v.h * e.scale / (d * (e.localGlyph ? 2 : 1));
                    let S, z, P, B;
                    if (m) {
                        const t1 = e.y - y, r = new Ie(-g, g - t1), n = -Math.PI / 2, i = new Ie(..._);
                        S = new Ie(-g + w[0], w[1]), S._rotateAround(n, r)._add(i), S.x += -t1 + g, S.y -= (x.left - s) * e.scale;
                        const o = e.image ? x.advance * e.scale : _g * e.scale, a = String.fromCodePoint(e.glyph);
                        Ig(a) ? S.x += (1 - s) * e.scale : Sg(a) ? S.x += o - x.height * e.scale + (-s - 1) * e.scale : S.x += e.image || x.width + 2 * s === v.w && x.height + 2 * s === v.h ? (o - I) / 2 : (o - (x.height + 2 * s) * e.scale) / 2, z = new Ie(S.x, S.y - M), P = new Ie(S.x + I, S.y), B = new Ie(S.x + I, S.y - M);
                    } else {
                        const t1 = (x.left - s) * e.scale - g + w[0], r = (-x.top - s) * e.scale + w[1], n = t1 + M, i = r + I;
                        S = new Ie(t1, r), z = new Ie(n, r), P = new Ie(t1, i), B = new Ie(n, i);
                    }
                    if (h) {
                        let e;
                        e = i ? new Ie(0, 0) : A ? new Ie(p[0], p[1]) : new Ie(r[0], r[1]), S._rotateAround(h, e), z._rotateAround(h, e), P._rotateAround(h, e), B._rotateAround(h, e);
                    }
                    const T = new Ie(0, 0), k = new Ie(0, 0);
                    c.push({
                        tl: S,
                        tr: z,
                        bl: P,
                        br: B,
                        texPrimary: n,
                        texSecondary: void 0,
                        writingMode: t1.writingMode,
                        glyphOffset: b,
                        sectionIndex: e.sectionIndex,
                        isSDF: l,
                        pixelOffsetTL: T,
                        pixelOffsetBR: k,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
            }
            return c;
        }
        function Zx(e, t1 = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0;
            const a = e[0];
            for(let e = 0; e < a.length; e++){
                const t1 = a[e];
                (!e || t1.x < n) && (n = t1.x), (!e || t1.y < i) && (i = t1.y), (!e || t1.x > s) && (s = t1.x), (!e || t1.y > o) && (o = t1.y);
            }
            const l = Math.min(s - n, o - i);
            let u = l / 2;
            const c = new On([], Wx);
            if (0 === l) return new Ie(n, i);
            for(let t1 = n; t1 < s; t1 += l)for(let r = i; r < o; r += l)c.push(new Yx(t1 + u, r + u, u, e));
            let h = function(e) {
                let t1 = 0, r = 0, n = 0;
                const i = e[0];
                for(let e = 0, s = i.length, o = s - 1; e < s; o = e++){
                    const s = i[e], a = i[o], l = s.x * a.y - a.x * s.y;
                    r += (s.x + a.x) * l, n += (s.y + a.y) * l, t1 += 3 * l;
                }
                return new Yx(r / t1, n / t1, 0, e);
            }(e), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= t1 || (u = n.h / 2, c.push(new Yx(n.p.x - u, n.p.y - u, u, e)), c.push(new Yx(n.p.x + u, n.p.y - u, u, e)), c.push(new Yx(n.p.x - u, n.p.y + u, u, e)), c.push(new Yx(n.p.x + u, n.p.y + u, u, e)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function Wx(e, t1) {
            return t1.max - e.max;
        }
        Rx.loadGlyphRange = function(e, t1, r, n, i) {
            const s = 256 * t1, o = s + 255, a = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", e).replace("{range}", `${s}-${o}`), Dt.Glyphs);
            Ot(a, (e, t1)=>{
                if (e) i(e);
                else if (t1) {
                    const e = {}, r = function(e) {
                        return new Tg(e).readFields(jg, {});
                    }(t1);
                    for (const t1 of r.glyphs)e[t1.id] = t1;
                    i(null, {
                        glyphs: e,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, Rx.TinySDF = class {
            constructor({ fontSize: e = 24, buffer: t1 = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: o = "normal", lang: a = null } = {}){
                this.buffer = t1, this.cutoff = n, this.radius = r, this.lang = a;
                const l = this.size = e + 4 * t1, u = this._createCanvas(l), c = this.ctx = u.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${o} ${s} ${e}px ${i}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            _createCanvas(e) {
                const t1 = document.createElement("canvas");
                return t1.width = t1.height = e, t1;
            }
            draw(e) {
                const { width: t1, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(e), o = Math.ceil(r), a = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))), l = Math.min(this.size - this.buffer, o + Math.ceil(n)), u = a + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), d = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: a,
                    glyphHeight: l,
                    glyphTop: o,
                    glyphLeft: 0,
                    glyphAdvance: t1
                };
                if (0 === a || 0 === l) return d;
                const { ctx: f, buffer: m, gridInner: y, gridOuter: g } = this;
                this.lang && (f.lang = this.lang), f.clearRect(m, m, a, l), f.fillText(e, m, m + o);
                const x = f.getImageData(m, m, a, l);
                g.fill(Ex, 0, h), y.fill(0, 0, h);
                for(let e = 0; e < l; e++)for(let t1 = 0; t1 < a; t1++){
                    const r = x.data[4 * (e * a + t1) + 3] / 255;
                    if (0 === r) continue;
                    const n = (e + m) * u + t1 + m;
                    if (1 === r) g[n] = 0, y[n] = Ex;
                    else {
                        const e = .5 - r;
                        g[n] = e > 0 ? e * e : 0, y[n] = e < 0 ? e * e : 0;
                    }
                }
                Fx(g, 0, 0, u, c, u, this.f, this.v, this.z), Fx(y, m, m, a, l, u, this.f, this.v, this.z);
                for(let e = 0; e < h; e++){
                    const t1 = Math.sqrt(g[e]) - Math.sqrt(y[e]);
                    p[e] = Math.round(255 - 255 * (t1 / this.radius + this.cutoff));
                }
                return d;
            }
        };
        class Yx {
            constructor(e, t1, r, n){
                this.p = new Ie(e, t1), this.h = r, this.d = function(e, t1) {
                    let r = !1, n = 1 / 0;
                    for(let i = 0; i < t1.length; i++){
                        const s = t1[i];
                        for(let t1 = 0, i = s.length, o = i - 1; t1 < i; o = t1++){
                            const i = s[t1], a = s[o];
                            i.y > e.y != a.y > e.y && e.x < (a.x - i.x) * (e.y - i.y) / (a.y - i.y) + i.x && (r = !r), n = Math.min(n, Fc(e, i, a));
                        }
                    }
                    return (r ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const Jx = Object.keys, Kx = Number.POSITIVE_INFINITY, Qx = Math.sqrt(2);
        function ev(e, t1, r, n, i) {
            const s = ix(e) && e.collisionPadding ? e.collisionPadding : [
                0,
                0,
                0,
                0
            ], o = {
                top: e.top - s[1],
                bottom: e.bottom + s[3],
                left: e.left - s[0],
                right: e.right + s[2],
                scaled: !1
            };
            return void 0 !== n && function(e, t1) {
                e.top *= t1, e.bottom *= t1, e.left *= t1, e.right *= t1, e.scaled = !0;
            }(o, n), r && function(e, t1) {
                if (!t1) return;
                const r = Be(t1), n = new Ie(e.left, e.top), i = new Ie(e.right, e.top), s = new Ie(e.left, e.bottom), o = new Ie(e.right, e.bottom), a = new Ie(0, 0);
                n._rotateAround(r, a), i._rotateAround(r, a), s._rotateAround(r, a), o._rotateAround(r, a), e.left = Math.min(n.x, i.x, s.x, o.x), e.right = Math.max(n.x, i.x, s.x, o.x), e.top = Math.min(n.y, i.y, s.y, o.y), e.bottom = Math.max(n.y, i.y, s.y, o.y);
            }(o, r), i && (o.left += i[0], o.right += i[0], o.top += i[1], o.bottom += i[1]), t1 ? {
                top: Math.min(t1.top, o.top),
                bottom: Math.max(t1.bottom, o.bottom),
                left: Math.min(t1.left, o.left),
                right: Math.max(t1.right, o.right),
                scaled: t1.scaled || o.scaled
            } : o;
        }
        function tv(e, [t1, r]) {
            let n = 0, i = 0;
            if (r === Kx) {
                t1 < 0 && (t1 = 0);
                const r = t1 / Qx;
                switch(e){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - t1;
                        break;
                    case "top":
                        i = t1 - 7;
                }
                switch(e){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = t1;
                        break;
                    case "right":
                        n = -t1;
                }
            } else {
                switch(t1 = Math.abs(t1), r = Math.abs(r), e){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(e){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -t1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = t1;
                }
            }
            return [
                n,
                i
            ];
        }
        function rv(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f) {
            const m = e.layers[0], y = m.appearances;
            if (0 === y.length) return {
                iconBBox: null,
                iconVerticalBBox: null,
                textBBox: null,
                textVerticalBBox: null
            };
            const g = {
                iconBBox: null,
                iconVerticalBBox: null
            }, x = {
                textBBox: null,
                textVerticalBBox: null
            }, { baseIconRotate: v, baseTextRotate: b, iconScaleFactor: w } = function(e, t1, r) {
                const n = e.get("icon-rotate").evaluate(t1, {}, r), i = e.get("text-rotate").evaluate(t1, {}, r), [s, o] = e.get("icon-size-scale-range");
                return {
                    baseIconRotate: n,
                    baseTextRotate: i,
                    iconScaleFactor: De(1, s, o)
                };
            }(n, i, s);
            t1 && (g.iconBBox = ev(t1, g.iconBBox, v, o), r) && (g.iconVerticalBBox = ev(r, g.iconVerticalBBox, v + 90, o));
            const _ = _v(h.horizontal);
            _ && (x.textBBox = ev(_, x.textBBox, b, 1, d)), h.vertical && (x.textVerticalBBox = ev(h.vertical, x.textVerticalBBox, b + 90, 1, d));
            for (const r of y)r.hasIconProperties() && nv(g, e, m, r, i, s, a, v, o, l, t1, u, w, c, f), r.hasTextProperties() && sv(x, m, r, i, s, d, b, p, _, h.vertical);
            return {
                iconBBox: g.iconBBox,
                iconVerticalBBox: g.iconVerticalBBox,
                textBBox: x.textBBox,
                textVerticalBBox: x.textVerticalBBox
            };
        }
        function nv(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f) {
            const { appearanceIconOffset: m, appearanceIconRotate: y, appearanceIconSize: g } = iv(n, r, i, s, o, a, l, u.iconScaleFactor);
            let x = null, v = null, b = null;
            n.hasProperty("icon-image") ? b = function(e, t1, r, n, i, s, o, a) {
                let l = null;
                const u = t1.getAppearanceValueAndResolveTokens(r, "icon-image", n, i, a);
                if (u) {
                    const t1 = e.getResolvedImageFromTokens(u), c = r.getUnevaluatedProperty("icon-size"), h = uv(t1, hx(e.zoom, c, e.worldview, a), c, i, e.zoom, n, e.pixelRatio, o, e.worldview, a);
                    l = s.get(h.iconPrimary.toString());
                }
                return l;
            }(t1, r, n, i, s, h, p, f) : c && (b = c.imagePrimary), b && (x = sx(b, null, m, d), t1.allowVerticalPlacement && (v = sx(b, null, m, d))), x && (e.iconBBox = ev(x, e.iconBBox, y, g)), v && (e.iconVerticalBBox = ev(v, e.iconVerticalBBox, y + 90, g));
        }
        function iv(e, t1, r, n, i, s, o, a) {
            const l = e.hasProperty("icon-offset") ? t1.getAppearanceValueAndResolveTokens(e, "icon-offset", r, n, []) : null, u = l && Array.isArray(l) ? l : i, c = e.hasProperty("icon-rotate") ? t1.getAppearanceValueAndResolveTokens(e, "icon-rotate", r, n, []) : null, h = "number" == typeof c ? c : s, p = e.hasProperty("icon-size") ? t1.getAppearanceValueAndResolveTokens(e, "icon-size", r, n, []) : null;
            return {
                appearanceIconOffset: u,
                appearanceIconRotate: h,
                appearanceIconSize: "number" == typeof p ? p * a : o
            };
        }
        function sv(e, t1, r, n, i, s, o, a, l, u) {
            const { appearanceTextOffset: c, appearanceTextRotate: h, appearanceTextSize: p } = ov(r, t1, n, i, s, o, a), d = p / a;
            l && (e.textBBox = ev(l, e.textBBox, h, d, c)), u && (e.textVerticalBBox = ev(u, e.textVerticalBBox, h + 90, d, c));
        }
        function ov(e, t1, r, n, i, s, o) {
            const a = e.hasProperty("text-offset") ? t1.getAppearanceValueAndResolveTokens(e, "text-offset", r, n, []) : null, l = a && Array.isArray(a) ? [
                a[0] * _g,
                a[1] * _g
            ] : i, u = e.hasProperty("text-rotate") ? t1.getAppearanceValueAndResolveTokens(e, "text-rotate", r, n, []) : null, c = "number" == typeof u ? u : s, h = e.hasProperty("text-size") ? t1.getAppearanceValueAndResolveTokens(e, "text-size", r, n, []) : null;
            return {
                appearanceTextOffset: l,
                appearanceTextRotate: c,
                appearanceTextSize: "number" == typeof h ? h : o
            };
        }
        function av(e, t1, r, n, i, s, o, a, l) {
            if (!t1 || !t1.usvg) return;
            const u = ux(n), c = ux(i), h = "both" !== s && "width" !== s || !ax(n) ? 1 : c.width / u.width, p = "both" !== s && "height" !== s || !lx(n) ? 1 : c.height / u.height;
            r.scaleSelf(h, p);
            const d = r.toString();
            o.set(d, r), a.set(d, t1);
            const { imagePosition: f } = Bx(d, t1, 1);
            l.set(d, f);
        }
        function lv(e, t1, r, n, i, s, o, a, l, u) {
            if (!e) return;
            const c = function(e, t1, r, n, i, s, o) {
                if ("camera" === e.kind) return e.maxSize;
                if ("composite" === e.kind) {
                    const n = t1.possiblyEvaluate(new Yo(e.maxZoom, {
                        worldview: s
                    }), r, o).evaluate(i, {}, r, o), a = t1.possiblyEvaluate(new Yo(e.minZoom, {
                        worldview: s
                    }), r, o).evaluate(i, {}, r, o);
                    return Math.max(n, a);
                }
                return t1.possiblyEvaluate(new Yo(n, {
                    worldview: s
                }), r, o).evaluate(i, {}, r, o);
            }(t1, r, n, i, s, l, u);
            return e.scaleSelf(c * a * o);
        }
        function uv(e, t1, r, n, i, s, o, a, l, u) {
            return {
                iconPrimary: lv(e.getPrimary(), t1, r, n, i, s, o, a, l, u),
                iconSecondary: lv(e.getSecondary(), t1, r, n, i, s, o, a, l, u)
            };
        }
        function cv(e, t1, r) {
            if (!t1) return;
            const n = r.get(e.toString()), i = r.get(t1.toString());
            n && i && (n.paddedRect.w === i.paddedRect.w && n.paddedRect.h === i.paddedRect.h || Ze(`Mismatch in icon variant sizes: ${e.toString()} and ${t1.toString()}`), n.usvg !== i.usvg && Ze(`Mismatch in icon variant image types: ${e.id} and ${t1.id}`));
        }
        function hv(e, t1, r, n) {
            if (!e) return;
            const i = t1.get(r.toString());
            if (i && (e.imagePrimary = i), n) {
                const r = t1.get(n.toString());
                e.imageSecondary = r;
            }
        }
        function pv(e, t1) {
            for(const r in e.horizontal)dv(e.horizontal[r], t1);
            dv(e.vertical, t1);
        }
        function dv(e, t1) {
            if (e) {
                for (const r of e.positionedLines)for (const e of r.positionedGlyphs)if (null !== e.image) {
                    const r = e.image.toString();
                    e.rect = t1.get(r).paddedRect;
                }
            }
        }
        function fv(e) {
            switch(e){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function mv(e, t1, r, n, i, s, o, a, l) {
            const u = _v(s.horizontal) || s.vertical, c = r.get("icon-text-fit-padding").evaluate(n, {}, i);
            let h, p = t1;
            return t1 && "none" !== l && (e.allowVerticalPlacement && s.vertical && (h = ox(t1, s.vertical, l, c, a, o)), u && (p = ox(t1, u, l, c, a, o))), {
                defaultShapedIcon: p,
                verticallyShapedIcon: h
            };
        }
        function yv(e, t1) {
            return e * t1 / 24;
        }
        function gv(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A) {
            let M = o.textMaxSize.evaluate(t1, {}, p);
            void 0 === M ? M = a * o.textScaleFactor : M *= o.textScaleFactor;
            const I = e.layers[0].layout, S = yv(a, o.textScaleFactor), z = _v(r.horizontal) || r.vertical, P = e.hasAnyAppearanceProperty([
                "text-size",
                "text-offset",
                "text-rotate"
            ]);
            if (("none" !== y || P) && e.appearanceFeatureData && e.featureToAppearanceIndex[t1.index] < e.appearanceFeatureData.length) {
                const r = e.appearanceFeatureData[e.featureToAppearanceIndex[t1.index]];
                r && (r.textShaping = z, r.iconTextFitPadding = I.get("icon-text-fit-padding").evaluate(t1, {}, p), r.fontScale = S, r.textScaleFactor = o.textScaleFactor);
            }
            const B = "globe" === d.name, T = e.tilePixelRatio * M / 24, k = (R = e.overscaling, e.zoom > 18 && R > 2 && (R >>= 1), Math.max(Un / (512 * R), 1) * I.get("symbol-spacing")), V = I.get("text-padding") * e.tilePixelRatio, E = I.get("icon-padding") * e.tilePixelRatio, F = Be(I.get("text-max-angle")), D = "map" === I.get("icon-rotation-alignment") && "point" !== v, C = k / 2;
            var R;
            !1 === e.hasAnyIconTextFit && "none" !== y && (e.hasAnyIconTextFit = !0);
            const L = t1.properties ? +t1.properties[ic] : null, O = L && e.elevationFeatureIdToIndex ? e.elevationFeatureIdToIndex.get(L) : 65535, U = (a, l, v)=>{
                if (l.x < 0 || l.x >= Un || l.y < 0 || l.y >= Un) return;
                let A = null;
                if (B) {
                    const { x: e, y: t1, z: r } = d.projectTilePoint(l.x, l.y, v);
                    A = {
                        anchor: new fx(e, t1, r, 0, void 0),
                        up: d.upVector(v, l.x, l.y)
                    };
                }
                !function(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x, v, b, w, _, A, M, I, S, z, P, B, T, k) {
                    const V = e.addToLineVertexArray(t1, n);
                    let E, F, D, C, R, L, O, U = 0, N = 0, j = 0, G = 0, $ = -1, q = -1;
                    const X = {};
                    let H = Jt("");
                    const Z = r ? r.anchor : t1, W = "none" !== z;
                    let Y = 0, J = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset")) {
                        const e = l.layout.get("text-offset").evaluate(b, {}, M);
                        Y = e[0] * _g, J = e[1] * _g;
                    } else Y = l.layout.get("text-radial-offset").evaluate(b, {}, M) * _g, J = Kx;
                    if (e.allowVerticalPlacement && i.vertical) {
                        const e = i.vertical;
                        if (f) L = Mv(e), a && (O = Mv(a));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, M) + 90;
                            D = Av(u, Z, t1, c, h, p, e, d, r, m, k), a && (C = Av(u, Z, t1, c, h, p, a, g, r, null, T));
                        }
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(b, {}, M), i = Ox(s, n, _, W, w.iconScaleFactor), o = a ? Ox(a, n, _, W, w.iconScaleFactor) : void 0;
                        F = Av(u, Z, t1, c, h, p, s, g, n, null, B);
                        const d = function(e, t1, r, n, i, s, o, a, l, u) {
                            const c = e.layers[0], h = c.appearances;
                            let p = t1.length;
                            if (r && (p = Math.max(p, r.length)), 0 === h.length) return p;
                            const [d, f] = n.get("icon-size-scale-range"), m = De(1, d, f);
                            for (const t1 of h){
                                const r = t1.getUnevaluatedProperties();
                                if (void 0 !== r._values["icon-image"].value) {
                                    const n = c.getAppearanceValueAndResolveTokens(t1, "icon-image", s, o, u);
                                    if (n) {
                                        const l = e.getResolvedImageFromTokens(n);
                                        if (l) {
                                            const n = t1.hasProperty("icon-size") ? r._values["icon-size"] : i._values["icon-size"], c = uv(l, hx(e.zoom, n, e.worldview, u), n, o, e.zoom, s, e.pixelRatio, m, e.worldview, u), h = a.get(c.iconPrimary.toString());
                                            h && (p = Math.max(p, Ux(h)));
                                        }
                                    }
                                }
                            }
                            return p;
                        }(e, i, o, l.layout, l._unevaluatedLayout, b, M, e.iconAtlasPositions, 0, A);
                        U = 4 * d;
                        const f = l.layout.get("icon-size").evaluate(b, {}, M, A), m = w.compositeIconSizes ? w.compositeIconSizes[0].evaluate(b, {}, M, A) : 0, y = w.compositeIconSizes ? w.compositeIconSizes[1].evaluate(b, {}, M, A) : 0, z = wv(e.layerIds[0], e.iconSizeData, f, w.iconScaleFactor, m, y);
                        e.addSymbols(e.icon, i, z, v, x, b, void 0, r, t1, V.lineStartIndex, V.lineLength, -1, A, M, I, S, e.symbolInstances.length, d), $ = e.icon.placedSymbolArray.length - 1, o && (N = 4 * d, e.addSymbols(e.icon, o, z, v, x, b, qg.vertical, r, t1, V.lineStartIndex, V.lineLength, -1, A, M, I, S, e.symbolInstances.length, d), q = e.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = n, a = i.horizontal[s];
                        E || (H = Jt(a.text), f ? R = Mv(a) : E = Av(u, Z, t1, c, h, p, a, d, l.layout.get("text-rotate").evaluate(b, {}, M), m, k));
                        const y = 1 === a.positionedLines.length;
                        if (j += bv(e, r, t1, a, o, l, f, b, m, V, i.vertical ? qg.horizontal : qg.horizontalOnly, y ? Jx(i.horizontal) : [
                            s
                        ], X, $, w, A, M, e.symbolInstances.length, I), y) break;
                    }
                    i.vertical && (G += bv(e, r, t1, i.vertical, o, l, f, b, m, V, qg.vertical, [
                        "vertical"
                    ], X, q, w, A, M, e.symbolInstances.length, I));
                    let K = -1;
                    const Q = (e, t1)=>e ? Math.max(e, t1) : t1;
                    K = Q(R, K), K = Q(L, K), K = Q(O, K);
                    const ee = K > -1 ? 1 : 0;
                    e.glyphOffsetArray.length >= 65535 && Ze("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && e.addToSortKeyRanges(e.symbolInstances.length, b.sortKey), e.symbolInstances.emplaceBack(t1.x, t1.y, Z.x, Z.y, Z.z, X.right >= 0 ? X.right : -1, X.center >= 0 ? X.center : -1, X.left >= 0 ? X.left : -1, X.vertical >= 0 ? X.vertical : -1, $, q, H, void 0 !== E ? E : e.collisionBoxArray.length, void 0 !== E ? E + 1 : e.collisionBoxArray.length, void 0 !== D ? D : e.collisionBoxArray.length, void 0 !== D ? D + 1 : e.collisionBoxArray.length, void 0 !== F ? F : e.collisionBoxArray.length, void 0 !== F ? F + 1 : e.collisionBoxArray.length, C || e.collisionBoxArray.length, C ? C + 1 : e.collisionBoxArray.length, c, j, G, U, N, ee, 0, Y, J, K, 0, W ? 1 : 0, P);
                }(e, l, A, a, r, n, s, i, e.layers[0], e.collisionBoxArray, t1.index, t1.sourceLayerIndex, e.index, V, x, u, 0, E, D, g, t1, o, c, h, p, f, m, y, O, b, w, _);
            };
            if ("line" === v) for (const i of Tf(t1.geometry, 0, 0, Un, Un)){
                const t1 = bx(i, k, F, r.vertical || z, n, 24, T, e.overscaling, Un);
                for (const r of t1)z && Iv(e, z.text, C, r) || U(i, r, p);
            }
            else if ("line-center" === v) {
                for (const e of t1.geometry)if (e.length > 1) {
                    const t1 = vx(e, F, r.vertical || z, n, 24, T);
                    t1 && U(e, t1, p);
                }
            } else if ("Polygon" === t1.type) for (const e of _p(t1.geometry, 0)){
                const t1 = Zx(e, 16);
                U(e[0], new fx(t1.x, t1.y, 0, 0, void 0), p);
            }
            else if ("LineString" === t1.type) for (const e of t1.geometry)U(e, new fx(e[0].x, e[0].y, 0, 0, void 0), p);
            else if ("Point" === t1.type) for (const e of t1.geometry)for (const t1 of e)U([
                t1
            ], new fx(t1.x, t1.y, 0, 0, void 0), p);
        }
        const xv = 255, vv = xv * cx;
        function bv(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g, x) {
            const v = Hx(0, n, l, s, o, a, i, e.allowVerticalPlacement, void 0, f.textScaleFactor), b = s.layout.get("text-size").evaluate(a, {}, y), w = f.compositeTextSizes ? f.compositeTextSizes[0].evaluate(a, {}, y) : 0, _ = f.compositeTextSizes ? f.compositeTextSizes[1].evaluate(a, {}, y) : 0, A = wv(e.layerIds[0], e.textSizeData, b, f.textScaleFactor, w, _);
            e.addSymbols(e.text, v, A, l, o, a, c, t1, r, u.lineStartIndex, u.lineLength, d, m, y, x, !1, g, v.length);
            for (const t1 of h)p[t1] = e.text.placedSymbolArray.length - 1;
            return 4 * v.length;
        }
        function wv(e, t1, r, n, i, s) {
            const o = t1;
            let a = null;
            return "source" === o.kind ? (a = [
                cx * r * n
            ], a[0] > vv && Ze(`${e}: Value for "text-size" is >= ${xv}. Reduce your "text-size".`)) : "composite" === o.kind && (a = [
                cx * i * n,
                cx * s * n
            ], (a[0] > vv || a[1] > vv) && Ze(`${e}: Value for "text-size" is >= ${xv}. Reduce your "text-size".`)), a;
        }
        function _v(e) {
            for(const t1 in e)return e[t1];
            return null;
        }
        function Av(e, t1, r, n, i, s, o, a, l, u, c) {
            let h, p, d, f;
            if (h = c ? c.top : o.top, p = c ? c.bottom : o.bottom, d = c ? c.left : o.left, f = c ? c.right : o.right, ix(o) && o.collisionPadding) {
                const e = o.collisionPadding;
                d -= e[0], h -= e[1], f += e[2], p += e[3];
            }
            if (l) {
                const e = new Ie(d, h), t1 = new Ie(f, h), r = new Ie(d, p), n = new Ie(f, p), i = Be(l);
                let s = new Ie(0, 0);
                u && (s = new Ie(u[0], u[1])), e._rotateAround(i, s), t1._rotateAround(i, s), r._rotateAround(i, s), n._rotateAround(i, s), d = Math.min(e.x, t1.x, r.x, n.x), f = Math.max(e.x, t1.x, r.x, n.x), h = Math.min(e.y, t1.y, r.y, n.y), p = Math.max(e.y, t1.y, r.y, n.y);
            }
            return e.emplaceBack(t1.x, t1.y, t1.z, r.x, r.y, d, h, f, p, a, n, i, s), e.length - 1;
        }
        function Mv(e) {
            ix(e) && e.collisionPadding && (e.top -= e.collisionPadding[1], e.bottom += e.collisionPadding[3]);
            const t1 = e.bottom - e.top;
            return t1 > 0 ? Math.max(10, t1) : null;
        }
        function Iv(e, t1, r, n) {
            const i = e.compareText;
            if (t1 in i) {
                const e = i[t1];
                for(let t1 = e.length - 1; t1 >= 0; t1--)if (n.dist(e[t1]) < r) return !0;
            } else i[t1] = [];
            return i[t1].push(n), !1;
        }
        function Sv(e, t1) {
            const r = e.fovAboveCenter, n = e.elevation ? e.elevation.getMinElevationBelowMSL() * t1 : 0, i = (e._camera.position[2] * e.worldSize - n) / Math.cos(e._pitch), s = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - e._pitch - r, .01));
            let o = Math.sin(e._pitch) * s + i;
            const a = i * (1 / e._horizonShift);
            if (!e.elevation || 0 === e.elevation.exaggeration()) {
                let t1 = Math.max(e.zoom - 17, 0);
                e.isOrthographic && (t1 /= 10), o *= 1 + t1;
            }
            return Math.min(1.01 * o, a);
        }
        function zv(e, t1) {
            if (!t1.isReprojectedInTileSpace) return {
                scale: 1 << e.z,
                x: e.x,
                y: e.y,
                x2: e.x + 1,
                y2: e.y + 1,
                projection: t1
            };
            const r = Math.pow(2, -e.z), n = e.x * r, i = (e.x + 1) * r, s = e.y * r, o = (e.y + 1) * r, a = Eu(n), l = Eu(i), u = Fu(s), c = Fu(o), h = t1.project(a, u), p = t1.project(l, u), d = t1.project(l, c), f = t1.project(a, c);
            let m = Math.min(h.x, p.x, d.x, f.x), y = Math.min(h.y, p.y, d.y, f.y), g = Math.max(h.x, p.x, d.x, f.x), x = Math.max(h.y, p.y, d.y, f.y);
            const v = r / 16;
            function b(e, r, n, i, s, o) {
                const a = (n + s) / 2, l = (i + o) / 2, u = t1.project(Eu(a), Fu(l)), c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
                m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > v && (b(e, u, n, i, a, l), b(u, r, a, l, s, o));
            }
            b(h, p, n, s, i, s), b(p, d, i, s, i, o), b(d, f, i, o, n, o), b(f, h, n, o, n, s), m -= v, y -= v, g += v, x += v;
            const w = 1 / Math.max(g - m, x - y);
            return {
                scale: w,
                x: m * w,
                y: y * w,
                x2: g * w,
                y2: x * w,
                projection: t1
            };
        }
        function Pv(e, { x: t1, y: r }, n = 0) {
            return new Ie(((t1 - n) * e.scale - e.x) * Un, (r * e.scale - e.y) * Un);
        }
        const Bv = u(new Float32Array(16));
        class Tv {
            constructor(e){
                this.spec = e, this.name = e.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(e, t1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e, t1) {
                return new zu(0, 0);
            }
            projectTilePoint(e, t1, r) {
                return {
                    x: e,
                    y: t1,
                    z: 0
                };
            }
            locationPoint(e, t1, r, n = !0) {
                return e._coordinatePoint(e.locationCoordinate(t1, r), n);
            }
            pixelsPerMeter(e, t1) {
                return Vu(1, e) * t1;
            }
            pixelSpaceConversion(e, t1, r) {
                return 1;
            }
            farthestPixelDistance(e) {
                return Sv(e, e.pixelsPerMeter);
            }
            pointCoordinate(e, t1, r, n) {
                const i = e.horizonLineFromTop(!1), s = new Ie(t1, Math.max(i, r));
                return e.rayIntersectionCoordinate(e.pointRayIntersection(s, n));
            }
            pointCoordinate3D(e, t1, r) {
                const n = new Ie(t1, r);
                if (e.elevation) return e.elevation.pointCoordinate(n);
                {
                    const t1 = this.pointCoordinate(e, n.x, n.y, 0);
                    return [
                        t1.x,
                        t1.y,
                        t1.z
                    ];
                }
            }
            isPointAboveHorizon(e, t1) {
                if (e.elevation && e.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(e, t1.x, t1.y);
                const r = e.horizonLineFromTop();
                return t1.y < r;
            }
            createInversionMatrix(e, t1) {
                return Bv;
            }
            createTileMatrix(e, t1, r) {
                let n, i, s;
                const o = r.canonical, a = u(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = zv(o, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, d(a, a, [
                        n / l.scale,
                        n / l.scale,
                        e.pixelsPerMeter / t1
                    ]);
                } else n = t1 / e.zoomScale(o.z), i = (o.x + Math.pow(2, o.z) * r.wrap) * n, s = o.y * n;
                return p(a, a, [
                    i,
                    s,
                    0
                ]), d(a, a, [
                    n / Un,
                    n / Un,
                    1
                ]), a;
            }
            upVector(e, t1, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e, t1, r) {
                return {
                    metersToTile: 1
                };
            }
        }
        class kv extends Tv {
            constructor(e){
                super(e), this.range = [
                    4,
                    7
                ], this.center = e.center || [
                    -96,
                    37.5
                ];
                const [t1, r] = this.parallels = e.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Be(t1));
                this.n = (n + Math.sin(Be(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(e, t1) {
                const { n: r, c: n, r0: i } = this, s = Be(e - this.center[0]), o = Be(t1), a = Math.sqrt(n - 2 * r * Math.sin(o)) / r;
                return {
                    x: a * Math.sin(s * r),
                    y: a * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(e, t1) {
                const { n: r, c: n, r0: i } = this, s = i + t1;
                let o = Math.atan2(e, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (o -= Math.PI * Math.sign(e) * Math.sign(s));
                const a = Be(this.center[0]) * r;
                o = Re(o, -Math.PI - a, Math.PI - a);
                const l = De(Te(o / r) + this.center[0], -180, 180), u = Math.asin(De((n - (e * e + s * s) * r * r) / (2 * r), -1, 1)), c = De(Te(u), -85.051129, Cu);
                return new zu(l, c);
            }
        }
        const Vv = 1.340264, Ev = -0.081106, Fv = 893e-6, Dv = .003796, Cv = Math.sqrt(3) / 2;
        class Rv extends Tv {
            project(e, t1) {
                t1 = t1 / 180 * Math.PI, e = e / 180 * Math.PI;
                const r = Math.asin(Cv * Math.sin(t1)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (e * Math.cos(r) / (Cv * (Vv + 3 * Ev * n + i * (7 * Fv + 9 * Dv * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (Vv + Ev * n + i * (Fv + Dv * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e, t1) {
                e = (2 * e - .5) * Math.PI;
                let r = t1 = (2 * (1 - t1) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let e, s, o, a = 0; a < 12 && (s = r * (Vv + Ev * n + i * (Fv + Dv * n)) - t1, o = Vv + 3 * Ev * n + i * (7 * Fv + 9 * Dv * n), e = s / o, r = De(r - e, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(e) < 1e-12)); ++a);
                const s = Cv * e * (Vv + 3 * Ev * n + i * (7 * Fv + 9 * Dv * n)) / Math.cos(r), o = Math.asin(Math.sin(r) / Cv), a = De(180 * s / Math.PI, -180, 180), l = De(180 * o / Math.PI, -85.051129, Cu);
                return new zu(a, l);
            }
        }
        class Lv extends Tv {
            constructor(e){
                super(e), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e, t1) {
                return {
                    x: .5 + e / 360,
                    y: .5 - t1 / 360,
                    z: 0
                };
            }
            unproject(e, t1) {
                const r = 360 * (e - .5), n = De(360 * (.5 - t1), -85.051129, Cu);
                return new zu(r, n);
            }
        }
        const Ov = Math.PI / 2;
        function Uv(e) {
            return Math.tan((Ov + e) / 2);
        }
        class Nv extends Tv {
            constructor(e){
                super(e), this.center = e.center || [
                    0,
                    30
                ];
                const [t1, r] = this.parallels = e.parallels || [
                    30,
                    30
                ];
                let n = Be(t1), i = Be(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const s = Math.cos(n), o = Uv(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Uv(i) / o), this.f = s * Math.pow(Uv(n), this.n) / this.n;
            }
            project(e, t1) {
                t1 = Be(t1), this.southernCenter && (t1 = -t1), e = Be(e - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? t1 < -Ov + r && (t1 = -Ov + r) : t1 > Ov - r && (t1 = Ov - r);
                const s = i / Math.pow(Uv(t1), n);
                let o = s * Math.sin(n * e), a = i - s * Math.cos(n * e);
                return o = .5 * (o / Math.PI + .5), a = .5 * (a / Math.PI + .5), {
                    x: o,
                    y: this.southernCenter ? a : 1 - a,
                    z: 0
                };
            }
            unproject(e, t1) {
                e = (2 * e - .5) * Math.PI, this.southernCenter && (t1 = 1 - t1), t1 = (2 * (1 - t1) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - t1, s = Math.sign(i), o = Math.sign(r) * Math.sqrt(e * e + i * i);
                let a = Math.atan2(e, Math.abs(i)) * s;
                i * r < 0 && (a -= Math.PI * Math.sign(e) * s);
                const l = De(Te(a / r) + this.center[0], -180, 180), u = De(Te(2 * Math.atan(Math.pow(n / o, 1 / r)) - Ov), -85.051129, Cu);
                return new zu(l, this.southernCenter ? -u : u);
            }
        }
        class jv extends Tv {
            constructor(e){
                super(e), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(e, t1) {
                return {
                    x: Tu(e),
                    y: ku(t1),
                    z: 0
                };
            }
            unproject(e, t1) {
                const r = Eu(e), n = Fu(t1);
                return new zu(r, n);
            }
        }
        const Gv = Be(Cu);
        class $v extends Tv {
            project(e, t1) {
                const r = (t1 = Be(t1)) * t1, n = r * r;
                return {
                    x: .5 * ((e = Be(e)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e, t1) {
                e = (2 * e - .5) * Math.PI;
                let r = t1 = (2 * (1 - t1) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const e = s * s;
                    i = (r * (1.007226 + s * (.015085 + e * (.028874 * s - .044475 - .005916 * e))) - t1) / (1.007226 + s * (.045255 + e * (.259866 * s - .311325 - .005916 * 11 * e))), r = De(r - i, -Gv, Gv);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const o = De(Te(e / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), a = Te(r);
                return new zu(o, a);
            }
        }
        const qv = Be(Cu);
        class Xv extends Tv {
            project(e, t1) {
                t1 = Be(t1), e = Be(e);
                const r = Math.cos(t1), n = 2 / Math.PI, i = Math.acos(r * Math.cos(e / 2)), s = Math.sin(i) / i, o = .5 * (e * n + 2 * r * Math.sin(e / 2) / s) || 0, a = .5 * (t1 + Math.sin(t1) / s) || 0;
                return {
                    x: .5 * (o / Math.PI + .5),
                    y: 1 - .5 * (a / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e, t1) {
                let r = e = (2 * e - .5) * Math.PI, n = t1 = (2 * (1 - t1) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let o = 0, a = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), d = 2 * h * p, f = p * p, m = 1 - c * h * h, y = m ? 1 / m : 0, g = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, x = .5 * (2 * g * i * p + 2 * r / Math.PI) - e, v = .5 * (g * s + n) - t1, b = .5 * y * (c * f + g * i * h * u) + 1 / Math.PI, w = y * (d * l / 4 - g * s * p), _ = .125 * y * (l * p - g * s * c * d), A = .5 * y * (u * h + g * f * i) + .5, M = w * _ - A * b;
                    o = (v * w - x * A) / M, a = (x * _ - v * b) / M, r = De(r - o, -Math.PI, Math.PI), n = De(n - a, -qv, qv);
                }while ((Math.abs(o) > s || Math.abs(a) > s) && --i > 0);
                return new zu(Te(r), Te(n));
            }
        }
        class Hv extends Tv {
            constructor(e){
                super(e), this.center = e.center || [
                    0,
                    0
                ], this.parallels = e.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Be(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e, t1) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: Be(e) * n * r + .5,
                    y: -Math.sin(Be(t1)) / n * r + .5,
                    z: 0
                };
            }
            unproject(e, t1) {
                const { scale: r, cosPhi: n } = this, i = -(t1 - .5) / r, s = De(Te((e - .5) / r) / n, -180, 180), o = Math.asin(De(i * n, -1, 1)), a = De(Te(o), -85.051129, Cu);
                return new zu(s, a);
            }
        }
        class Zv extends jv {
            constructor(e){
                super(e), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(e, t1, r) {
                const n = dh(e, t1, r);
                return j(n, n, yh(ah(r))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(e, t1, r) {
                const n = Mu(t1.lat, t1.lng), i = L([], n), s = r ? e._centerAltitude + r : e.elevation ? e.elevation.getAtPointOrZero(e.locationCoordinate(t1), e._centerAltitude) : e._centerAltitude;
                E(n, n, i, Vu(1, 0) * Un * s);
                const o = u(new Float64Array(16));
                return h(o, e.pixelMatrix, e.globeMatrix), j(n, n, o), new Ie(n[0], n[1]);
            }
            pixelsPerMeter(e, t1) {
                return Vu(1, 0) * t1;
            }
            pixelSpaceConversion(e, t1, r) {
                const n = Vu(1, e) * t1, i = hr(Vu(1, 45) * t1, n, r);
                return this.pixelsPerMeter(e, t1) / i;
            }
            createTileMatrix(e, t1, r) {
                const n = gh(ah(r.canonical));
                return h(new Float64Array(16), e.globeMatrix, n);
            }
            createInversionMatrix(e, t1) {
                const { center: r } = e, n = yh(ah(t1));
                return m(n, n, Be(r.lng)), f(n, n, Be(r.lat)), d(n, n, [
                    e._pixelsPerMercatorPixel,
                    e._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(e, t1, r, n) {
                return ih(e, t1, r, !0) || new Nu(0, 0);
            }
            pointCoordinate3D(e, t1, r) {
                const n = this.pointCoordinate(e, t1, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(e, t1) {
                return !ih(e, t1.x, t1.y, !1);
            }
            farthestPixelDistance(e) {
                const t1 = function(e, t1) {
                    const r = e.cameraToCenterDistance, n = e._centerAltitude * t1, i = e._camera, s = e._camera.forward(), o = z([], V([], s, -r), [
                        0,
                        0,
                        n
                    ]), a = e.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -a
                    ], u = e.width / e.height, c = Math.tan(e.fovAboveCenter), h = V([], i.up(), c), p = V([], i.right(), c * u), d = L([], z([], z([], s, h), p)), f = [];
                    let m;
                    if (new pc(o, d).closestPointOnSphere(l, a, f)) {
                        const t1 = z([], f, l), r = H([], t1, o);
                        m = Math.cos(e.fovAboveCenter) * M(r);
                    } else {
                        const e = H([], o, l), t1 = H([], l, o);
                        L(t1, t1);
                        const r = M(e) - a;
                        m = Math.sqrt(r * (r + 2 * a));
                        const n = Math.acos(m / (a + r)) - Math.acos(O(s, t1));
                        m *= Math.cos(n);
                    }
                    return 1.01 * m;
                }(e, this.pixelsPerMeter(e.center.lat, e.worldSize)), r = wh(e.zoom);
                if (r > 0) {
                    const n = Sv(e, Vu(1, e.center.lat) * e.worldSize), i = e.worldSize / (2 * Math.PI), s = Math.max(e.width, e.height) / e.worldSize * Math.PI;
                    return hr(t1, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return t1;
            }
            upVector(e, t1, r) {
                return dh(t1, r, e, 1);
            }
            upVectorScale(e) {
                return {
                    metersToTile: rh(fh(ah(e)))
                };
            }
        }
        function Wv(e) {
            const t1 = e.parallels, r = !!t1 && Math.abs(t1[0] + t1[1]) < .01;
            switch(e.name){
                case "mercator":
                    return new jv(e);
                case "equirectangular":
                    return new Lv(e);
                case "naturalEarth":
                    return new $v(e);
                case "equalEarth":
                    return new Rv(e);
                case "winkelTripel":
                    return new Xv(e);
                case "albers":
                    return r ? new Hv(e) : new kv(e);
                case "lambertConformalConic":
                    return r ? new Hv(e) : new Nv(e);
                case "globe":
                    return new Zv(e);
            }
            throw new Error(`Invalid projection name: ${e.name}`);
        }
        const Yv = Ju.types, Jv = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Kv(e, t1, r, n, i, s, o, a, l, u, c, h, p) {
            const d = a ? Math.min(vv, Math.round(a[0])) : 0, f = a ? Math.min(vv, Math.round(a[1])) : 0;
            e.emplaceBack(t1, r, Math.round(32 * n), Math.round(32 * i), s, o, (d << 1) + (l ? 1 : 0), 0 + (f << 1), 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Qv(e, t1, r) {
            e.emplaceBack(t1, r);
        }
        function eb(e, t1, r, n, i, s, o) {
            e.emplaceBack(t1, r, n, i, s, o);
        }
        const tb = (e, t1, r, n)=>{
            for(let i = 0; i < t1; i++)e.emplaceBack(r[0], r[1], r[2], n[0], n[1], n[2]);
        };
        function rb(e, t1, r, n, i) {
            e.emplaceBack(t1, r, n, i), e.emplaceBack(t1, r, n, i), e.emplaceBack(t1, r, n, i), e.emplaceBack(t1, r, n, i);
        }
        function nb(e) {
            for (const t1 of e.sections)if (Oo(t1.text)) return !0;
            return !1;
        }
        class ib {
            constructor(e){
                this.layoutVertexArray = new Ja, this.indexArray = new ol, this.programConfigurations = e, this.segments = new Rl, this.dynamicLayoutVertexArray = new Qa, this.opacityVertexArray = new el, this.placedSymbolArray = new Ml, this.iconTransitioningVertexArray = new tl, this.globeExtVertexArray = new Ka, this.zOffsetVertexArray = new ja, this.orientationVertexArray = new ul, this.symbolInstanceIndices = [];
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            getSymbolVertexData(e, t1) {
                const r = [], n = this.layoutVertexArray.uint16;
                for(let i = 0; i < t1; ++i){
                    const t1 = 12 * (e + i);
                    r.push(...n.slice(t1, t1 + 12));
                }
                return r;
            }
            updateSymbolVertexData(e, t1, r, n, i, s, o, a, l, u, c, h, p) {
                const d = this.layoutVertexArray.uint16, f = 12 * e;
                d[f] = t1, d[f + 1] = r, d[f + 2] = n, d[f + 3] = i, d[f + 4] = s, d[f + 5] = o, d[f + 6] = a, d[f + 7] = l, d[f + 8] = u, d[f + 9] = c, d[f + 10] = h, d[f + 11] = p;
            }
            upload(e, t1, r, n, i, s) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, pg.members, !!s), this.indexBuffer = e.createIndexBuffer(this.indexArray, t1), this.dynamicLayoutVertexBuffer = e.createVertexBuffer(this.dynamicLayoutVertexArray, fg.members, !0), this.opacityVertexBuffer = e.createVertexBuffer(this.opacityVertexArray, Jv, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e.createVertexBuffer(this.iconTransitioningVertexArray, gg.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e.createVertexBuffer(this.globeExtVertexArray, dg.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = e.createVertexBuffer(this.zOffsetVertexArray, mg.members, !0)), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = e.createVertexBuffer(this.orientationVertexArray, yg.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(e));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy());
            }
        }
        Js(ib, "SymbolBuffers");
        class sb {
            constructor(e, t1, r){
                this.layoutVertexArray = new e, this.layoutAttributes = t1, this.indexArray = new r, this.segments = new Rl, this.collisionVertexArray = new sl, this.collisionVertexArrayExt = new Qa;
            }
            upload(e) {
                this.layoutVertexBuffer = e.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e.createVertexBuffer(this.collisionVertexArray, xg.members, !0), this.collisionVertexBufferExt = e.createVertexBuffer(this.collisionVertexArrayExt, vg.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        Js(sb, "CollisionBuffers");
        class ob {
            constructor(e){
                this.collisionBoxArray = e.collisionBoxArray, this.zoom = e.zoom, this.overscaling = e.overscaling, this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.index = e.index, this.pixelRatio = e.pixelRatio, this.sourceLayerIndex = e.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = u([]), this.placementViewportMatrix = u([]);
                const t1 = this.layers[0]._unevaluatedLayout._values;
                this.worldview = e.worldview, this.localizable = e.localizable, this.textSizeData = hx(this.zoom, t1["text-size"], this.worldview, e.availableImages), this.iconSizeData = hx(this.zoom, t1["icon-size"], this.worldview, e.availableImages);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.lut = e.lut, this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((e)=>qg[e]), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.sourceID = e.sourceID, this.projection = e.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = !1, this.elevationType = "none", this.elevationStateComplete = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.hasAnySecondaryIcon = !1, this.hasAppearances = null, this.lastActiveApperance = null, this.featureToAppearanceIndex = {};
            }
            hasAnyAppearanceProperty(e) {
                const t1 = this.layers[0].getAppearances();
                if (!t1 || 0 === t1.length) return !1;
                const r = Array.isArray(e) ? e : [
                    e
                ];
                return t1.some((e)=>r.some((t1)=>null != e.getProperty(t1)));
            }
            createArrays() {
                this.text = new ib(new pu(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e)=>e.startsWith("text") || e.startsWith("symbol"))), this.icon = new ib(new pu(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e)=>e.startsWith("icon") || e.startsWith("symbol"))), this.glyphOffsetArray = new zl, this.lineVertexArray = new Pl, this.symbolInstances = new Sl;
            }
            calculateGlyphDependencies(e, t1, r, n, i) {
                for (const r of e){
                    const e = r.codePointAt(0);
                    if (void 0 === e) break;
                    if (t1[e] = !0, n && i && e <= 65535) {
                        const e = Mg[r];
                        e && (t1[e.charCodeAt(0)] = !0);
                    }
                }
            }
            calculateEffectiveAppearanceIconSize(e, t1, r, n, i, s, o) {
                if (!e.hasProperty("icon-size")) return o * s;
                let a = 1;
                const l = e.getUnevaluatedProperties()._values["icon-size"], u = hx(this.zoom, l, this.worldview, i), c = dx(u, t1);
                if ("constant" !== u.kind && "camera" !== u.kind || (a = c.uSize), "composite" === u.kind) {
                    const { minZoom: e, maxZoom: t1 } = u, s = l.possiblyEvaluate(new Yo(e, {
                        worldview: this.worldview
                    }), n), o = l.possiblyEvaluate(new Yo(t1, {
                        worldview: this.worldview
                    }), n), h = s.evaluate(r, {}, n, i);
                    a = h + (o.evaluate(r, {}, n, i) - h) * c.uSizeT;
                }
                return "source" === u.kind && (a = l.possiblyEvaluate(new Yo(this.zoom, {
                    worldview: this.worldview
                }), n).evaluate(r, {}, n, i)), a * s;
            }
            updateFootprints(e, t1) {}
            updateReplacement(e, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e.toUnwrapped(), !0);
                return !Ld(this.activeReplacements, r) && (this.activeReplacements = r, !0);
            }
            getResolvedImageFromTokens(e) {
                return "string" == typeof e ? Rr.build(e) : e;
            }
            populate(e, t1, r, n) {
                const i = this.layers[0], s = i.layout, o = "globe" === this.projection.name, a = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), [c, h] = s.get("icon-size-scale-range"), p = De(t1.scaleFactor || 1, c, h), [d, f] = s.get("text-size-scale-range"), m = De(t1.scaleFactor || 1, d, f), y = ("constant" !== l.value.kind || l.value.value instanceof Dr && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), g = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, x = this.hasAnyAppearanceProperty("icon-image"), v = s.get("symbol-sort-key");
                if (this.features = [], this.appearanceFeatureData = [], !y && !g && !x) return;
                const b = t1.iconDependencies, w = t1.glyphDependencies, _ = t1.availableImages, A = new Yo(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                }), M = (e)=>{
                    const t1 = e.id.toString();
                    b.has(t1) ? b.get(t1).push(e) : b.set(t1, [
                        e
                    ]);
                };
                for (const t1 of e){
                    const { feature: e, id: l, index: u, sourceLayerIndex: c } = t1, h = i._featureFilter.needGeometry, d = Yu(e, h);
                    if (!i._featureFilter.filter(A, d, r)) continue;
                    if (h || (d.geometry = Wu(e, r, n)), o && 1 !== e.type && r.z <= 5) {
                        const e = d.geometry, t1 = .98078528056, n = (e, n)=>O(dh(e.x, e.y, r, 1), dh(n.x, n.y, r, 1)) < t1;
                        for(let t1 = 0; t1 < e.length; t1++)e[t1] = qu(e[t1], n);
                    }
                    let f, I;
                    if (y) {
                        const e = i.getValueAndResolveTokens("text-field", d, r, _), t1 = Dr.factory(e);
                        nb(t1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Ho() || this.hasRTLText && Wo.isParsed()) && (f = Ag(t1, i, d));
                    }
                    if (g) {
                        const e = i.getValueAndResolveTokens("icon-image", d, r, _);
                        I = this.getResolvedImageFromTokens(e);
                    }
                    const S = this.layers[0];
                    let z = !1;
                    if (!I && x) {
                        const e = S.getAppearances();
                        for (const t1 of e)if (t1.getProperty("icon-image")) {
                            const e = S.getAppearanceValueAndResolveTokens(t1, "icon-image", d, r, _);
                            if (e) {
                                I = this.getResolvedImageFromTokens(e), z = !0;
                                break;
                            }
                        }
                    }
                    if (!f && !I) continue;
                    const P = this.sortFeaturesByKey ? v.evaluate(d, {}, r) : void 0, B = {
                        id: l,
                        text: f,
                        icon: I,
                        index: u,
                        sourceLayerIndex: c,
                        geometry: d.geometry,
                        properties: e.properties,
                        type: Yv[e.type],
                        sortKey: P
                    };
                    if (this.features.push(B), this.featureToAppearanceIndex[u] = this.appearanceFeatureData.length, this.appearanceFeatureData.push({
                        id: l,
                        properties: e.properties,
                        usesAppearanceIconAsPlaceholder: z,
                        isUsingAppearanceIconVertexData: !1,
                        isUsingAppearanceTextVertexData: !1,
                        layoutBasedIconVertexData: [],
                        layoutBasedTextVertexData: [],
                        activeAppearance: null
                    }), I) {
                        const e = S._unevaluatedLayout._values, { iconPrimary: t1, iconSecondary: n } = uv(I, this.iconSizeData, e["icon-size"], r, this.zoom, B, this.pixelRatio, p, this.worldview, _);
                        M(t1), n && (this.hasAnySecondaryIcon = !0, M(n));
                    }
                    const T = S.getAppearances();
                    if (0 !== T.length && T.forEach((e)=>{
                        if (!e.getProperty("icon-image")) return;
                        const t1 = this.getCombinedIconPrimary(e, S, d, r, _, B, p);
                        t1 && M(t1);
                    }), f) {
                        const e = a.evaluate(d, {}, r).join(","), t1 = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(qg.vertical) >= 0;
                        for (const r of f.sections)if (r.image) {
                            const e = r.image.getPrimary().scaleSelf(this.pixelRatio * m), t1 = e.id.toString(), n = b.get(t1) || [];
                            n.push(e), b.set(t1, n);
                        } else {
                            const n = Bo(f.toString()), i = r.fontStack || e, s = w[i] = w[i] || {};
                            this.calculateGlyphDependencies(r.text, s, t1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                if ("line" === s.get("symbol-placement") && (this.features = function(e) {
                    const t1 = {}, r = {}, n = [];
                    let i = 0;
                    function s(t1) {
                        n.push(e[t1]), i++;
                    }
                    function o(e, t1, i) {
                        const s = r[e];
                        return delete r[e], r[t1] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function a(e, r, i) {
                        const s = t1[r];
                        return delete t1[r], t1[e] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(e, t1, r) {
                        const n = r ? t1[0][t1[0].length - 1] : t1[0][0];
                        return `${e}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < e.length; u++){
                        const c = e[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            s(u);
                            continue;
                        }
                        const d = l(p, h), f = l(p, h, !0);
                        if (d in r && f in t1 && r[d] !== t1[f]) {
                            const e = a(d, f, h), i = o(d, f, n[e].geometry);
                            delete t1[d], delete r[f], r[l(p, n[i].geometry, !0)] = i, n[e].geometry = null;
                        } else d in r ? o(d, f, h) : f in t1 ? a(d, f, h) : (s(u), t1[d] = i - 1, r[f] = i - 1);
                    }
                    return n.filter((e)=>e.geometry);
                }(this.features)), "hd-road-markup" === s.get("symbol-elevation-reference")) {
                    if (this.elevationType = "road", t1.elevationFeatures) {
                        !this.elevationFeatures && t1.elevationFeatures.length > 0 && (this.elevationFeatures = [], this.elevationFeatureIdToIndex = new Map);
                        for (const e of t1.elevationFeatures)this.elevationFeatureIdToIndex.set(e.id, this.elevationFeatures.length), this.elevationFeatures.push(e);
                    }
                } else s.get("symbol-z-elevate") && (this.elevationType = "offset");
                "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = !0), this.sortFeaturesByKey && this.features.sort((e, t1)=>e.sortKey - t1.sortKey);
            }
            getCombinedIconPrimary(e, t1, r, n, i, s, o) {
                let a, l;
                const u = e.getUnevaluatedProperties();
                if (void 0 !== u._values["icon-image"].value) {
                    const s = t1.getAppearanceValueAndResolveTokens(e, "icon-image", r, n, i);
                    a = this.getResolvedImageFromTokens(s);
                } else {
                    const e = t1.getValueAndResolveTokens("icon-image", r, n, i);
                    a = this.getResolvedImageFromTokens(e);
                }
                if (a) {
                    const r = e.hasProperty("icon-size") ? u._values["icon-size"] : t1._unevaluatedLayout._values["icon-size"];
                    l = uv(a, hx(this.zoom, r, this.worldview, i), r, n, this.zoom, s, this.pixelRatio, o, this.worldview, i).iconPrimary;
                }
                return l;
            }
            updateSymbolInstanceIconVertices(e, t1, r, n, i, s, o, a, l, u, c, h, p, d) {
                if (e.placedIconSymbolIndex < 0) return {
                    vertexOffsetDelta: 0,
                    hasChanges: !1
                };
                if (t1.activeAppearance === r) return {
                    vertexOffsetDelta: e.numIconVertices,
                    hasChanges: !1
                };
                if (r) {
                    const f = this.getCombinedIconPrimary(r, l, n, s, o, {
                        sortKey: void 0,
                        text: void 0,
                        icon: null,
                        index: e.featureIndex,
                        sourceLayerIndex: e.featureIndex,
                        geometry: [],
                        properties: t1.properties,
                        type: "Point",
                        id: t1.id
                    }, u);
                    if (!f) return {
                        vertexOffsetDelta: 0,
                        hasChanges: !1
                    };
                    const m = f.toString(), y = this.iconAtlasPositions && this.iconAtlasPositions.get(m);
                    if (y) {
                        const { appearanceIconOffset: f, appearanceIconRotate: m } = iv(r, l, n, s, h, d, p, u);
                        let g = sx(y, void 0, f, l.layout.get("icon-anchor").evaluate(n, c, s));
                        const x = y.sdf, v = l.layout.get("icon-text-fit").constantOr("none");
                        "none" !== v && t1.textShaping && t1.iconTextFitPadding && t1.fontScale && (g = ox(g, t1.textShaping, v, t1.iconTextFitPadding, f, t1.fontScale));
                        const b = this.calculateEffectiveAppearanceIconSize(r, a.zoom, n, s, o, u, p), w = 0, _ = 1 + (Math.min(vv, Math.round(b * cx)) << 1), A = Ox(g, m, x, "none" !== v, u);
                        t1.isUsingAppearanceIconVertexData || (t1.isUsingAppearanceIconVertexData = !0, t1.layoutBasedIconVertexData = this.icon.getSymbolVertexData(i, e.numIconVertices));
                        let M = i;
                        for(let r = 0; r < A.length; ++r){
                            const n = A[r], i = t1.layoutBasedIconVertexData[0] || e.tileAnchorX, s = t1.layoutBasedIconVertexData[1] || e.tileAnchorY, o = 16 * n.pixelOffsetTL.x, a = 16 * n.pixelOffsetTL.y, l = 16 * n.pixelOffsetBR.x, u = 16 * n.pixelOffsetBR.y, c = 16 * n.minFontScaleX, h = 16 * n.minFontScaleY;
                            this.icon.updateSymbolVertexData(M, i, s, Math.round(32 * n.tl.x), Math.round(32 * n.tl.y), n.texPrimary.x, n.texPrimary.y, w, _, o, a, c, h), this.icon.updateSymbolVertexData(M + 1, i, s, Math.round(32 * n.tr.x), Math.round(32 * n.tr.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y, w, _, l, a, c, h), this.icon.updateSymbolVertexData(M + 2, i, s, Math.round(32 * n.bl.x), Math.round(32 * n.bl.y), n.texPrimary.x, n.texPrimary.y + n.texPrimary.h, w, _, o, u, c, h), this.icon.updateSymbolVertexData(M + 3, i, s, Math.round(32 * n.br.x), Math.round(32 * n.br.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y + n.texPrimary.h, w, _, l, u, c, h), M += 4;
                        }
                        const I = e.numIconVertices - 4 * A.length;
                        for(let e = 0; e < I; ++e)this.icon.updateSymbolVertexData(M + e, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        return {
                            vertexOffsetDelta: e.numIconVertices,
                            hasChanges: !0
                        };
                    }
                } else if (t1.usesAppearanceIconAsPlaceholder) {
                    if (this.layers[0].appearances && this.layers[0].appearances.length > 0) return this.icon.updateSymbolVertexData(i, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), {
                        vertexOffsetDelta: e.numIconVertices,
                        hasChanges: !0
                    };
                } else if (t1.isUsingAppearanceIconVertexData) {
                    const e = 12, r = t1.layoutBasedIconVertexData.length / e;
                    for(let n = 0; n < r; ++n){
                        const r = n * e;
                        this.icon.updateSymbolVertexData(i + n, t1.layoutBasedIconVertexData[r + 0], t1.layoutBasedIconVertexData[r + 1], t1.layoutBasedIconVertexData[r + 2], t1.layoutBasedIconVertexData[r + 3], t1.layoutBasedIconVertexData[r + 4], t1.layoutBasedIconVertexData[r + 5], t1.layoutBasedIconVertexData[r + 6], t1.layoutBasedIconVertexData[r + 7], t1.layoutBasedIconVertexData[r + 8], t1.layoutBasedIconVertexData[r + 9], t1.layoutBasedIconVertexData[r + 10], t1.layoutBasedIconVertexData[r + 11]);
                    }
                    return t1.isUsingAppearanceIconVertexData = !1, {
                        vertexOffsetDelta: r,
                        hasChanges: !0
                    };
                }
                return {
                    vertexOffsetDelta: e.numIconVertices,
                    hasChanges: !1
                };
            }
            updateSymbolInstanceTextVertices(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g) {
                const x = e.numHorizontalGlyphVertices > 0 || e.numVerticalGlyphVertices > 0;
                if (!x) return {
                    vertexOffsetDelta: x ? e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices : 0,
                    hasChanges: !1
                };
                if (t1.activeAppearance === r) return {
                    vertexOffsetDelta: e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices,
                    hasChanges: !1
                };
                if (r && t1.textShaping) {
                    const { appearanceTextOffset: x, appearanceTextRotate: v, appearanceTextSize: b } = ov(r, o, n, s, c, p, h);
                    t1.fontScale = yv(b, t1.textScaleFactor);
                    const w = r.getUnevaluatedProperty("text-size");
                    let _ = this.textSizeData, A = m, M = y;
                    r.hasProperty("text-size") && (_ = hx(this.zoom, w, this.worldview, g), A = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, M = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0);
                    const I = t1.textShaping.bottom - c[1], S = t1.textShaping.left - c[0], z = t1.textShaping.right - c[0];
                    t1.textShaping.top = x[1] + (t1.textShaping.top - c[1]), t1.textShaping.bottom = x[1] + I, t1.textShaping.left = x[0] + S, t1.textShaping.right = x[0] + z;
                    const P = Hx(0, t1.textShaping, x, o, !1, n, l, this.allowVerticalPlacement, v), B = b && "composite" === _.kind ? w.possiblyEvaluate(new Yo(A, {}), s).evaluate(n, u, s) : d, T = b && "composite" === _.kind ? w.possiblyEvaluate(new Yo(M, {}), s).evaluate(n, u, s) : f, k = wv(r.name, _, b, a, B, T), V = Array.isArray(k) ? k[1] : b, E = 0, F = 1 + (Math.min(vv, Math.round(V * cx)) << 1);
                    t1.isUsingAppearanceTextVertexData || (t1.isUsingAppearanceTextVertexData = !0, t1.layoutBasedTextVertexData = this.text.getSymbolVertexData(i, e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices));
                    for(let t1 = 0; t1 < P.length && t1 < (e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices) / 4; ++t1){
                        const r = P[t1], n = r.glyphOffset[1], s = e.tileAnchorX, o = e.tileAnchorY, a = i + 4 * t1;
                        this.text.updateSymbolVertexData(a, s, o, Math.round(32 * r.tl.x), Math.round(32 * (n + r.tl.y)), r.texPrimary.x, r.texPrimary.y, E, F, r.pixelOffsetTL.x, r.pixelOffsetTL.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(a + 1, s, o, Math.round(32 * r.tr.x), Math.round(32 * (n + r.tr.y)), r.texPrimary.x + r.texPrimary.w, r.texPrimary.y, E, F, r.pixelOffsetBR.x, r.pixelOffsetTL.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(a + 2, s, o, Math.round(32 * r.bl.x), Math.round(32 * (n + r.bl.y)), r.texPrimary.x, r.texPrimary.y + r.texPrimary.h, E, F, r.pixelOffsetTL.x, r.pixelOffsetBR.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(a + 3, s, o, Math.round(32 * r.br.x), Math.round(32 * (n + r.br.y)), r.texPrimary.x + r.texPrimary.w, r.texPrimary.y + r.texPrimary.h, E, F, r.pixelOffsetBR.x, r.pixelOffsetBR.y, r.minFontScaleX, r.minFontScaleY);
                    }
                    return {
                        vertexOffsetDelta: e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices,
                        hasChanges: !0
                    };
                }
                if (t1.isUsingAppearanceTextVertexData) {
                    const e = 12, r = t1.layoutBasedTextVertexData.length / e;
                    for(let n = 0; n < r; ++n){
                        const r = n * e;
                        this.text.updateSymbolVertexData(i + n, t1.layoutBasedTextVertexData[r + 0], t1.layoutBasedTextVertexData[r + 1], t1.layoutBasedTextVertexData[r + 2], t1.layoutBasedTextVertexData[r + 3], t1.layoutBasedTextVertexData[r + 4], t1.layoutBasedTextVertexData[r + 5], t1.layoutBasedTextVertexData[r + 6], t1.layoutBasedTextVertexData[r + 7], t1.layoutBasedTextVertexData[r + 8], t1.layoutBasedTextVertexData[r + 9], t1.layoutBasedTextVertexData[r + 10], t1.layoutBasedTextVertexData[r + 11]);
                    }
                    return t1.isUsingAppearanceTextVertexData = !1, {
                        vertexOffsetDelta: r,
                        hasChanges: !0
                    };
                }
                return {
                    vertexOffsetDelta: e.numHorizontalGlyphVertices + e.numVerticalGlyphVertices,
                    hasChanges: !1
                };
            }
            update(e, t1, r, n, i, s, o) {
                this.text.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, this.worldview), this.icon.programConfigurations.updatePaintArrays(e, t1, i, r, n, s, o, this.worldview);
            }
            updateRoadElevation(e) {
                if ("road" !== this.elevationType || !this.elevationFeatures) return;
                if (this.elevationStateComplete) return;
                this.elevationStateComplete = !0, this.hasAnyZOffset = !1;
                let t1 = !1;
                const r = Uu(e), n = 1 / r;
                let i = !1, s = !1;
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const o = this.symbolInstances.get(e), a = I(1, 0, 0), l = I(0, 1, 0), { numHorizontalGlyphVertices: u, numVerticalGlyphVertices: c, numIconVertices: h, numVerticalIconVertices: p } = o, d = u > 0 || c > 0, f = h > 0, m = this.elevationFeatures[o.elevationFeatureIndex];
                    if (m) {
                        const e = new Ie(o.tileAnchorX, o.tileAnchorY), u = .075 + m.pointElevation(e);
                        o.zOffset !== u && (t1 = !0, o.zOffset = u), 0 !== u && (this.hasAnyZOffset = !0);
                        const c = m.computeSlopeNormal(e, n), h = ue(te(), I(0, 0, 1), c);
                        $(a, a, h), $(l, l, h), a[2] *= r, l[2] *= r, 1 === a[0] && 0 === a[1] && 0 === a[2] && 0 === l[0] && 1 === l[1] && 0 === l[2] || (i = i || d, s = s || f);
                    }
                    if (d && (tb(this.text.orientationVertexArray, u, a, l), tb(this.text.orientationVertexArray, c, a, l)), f) {
                        const { placedIconSymbolIndex: e, verticalPlacedIconSymbolIndex: t1 } = o;
                        e >= 0 && tb(this.icon.orientationVertexArray, h, a, l), t1 >= 0 && tb(this.icon.orientationVertexArray, p, a, l);
                    }
                }
                i || (this.text.orientationVertexArray = void 0), s || (this.icon.orientationVertexArray = void 0), t1 && (this.zOffsetBuffersNeedUpload = !0, this.zOffsetSortDirty = !0);
            }
            updateZOffset() {
                const e = (e, t1, n)=>{
                    r += t1, r > e.length && e.resize(r);
                    for(let i = -t1; i < 0; i++)e.emplace(i + r, n);
                }, t1 = (e, t1, r)=>{
                    n += t1, n > e.length && e.resize(n);
                    for(let i = -t1; i < 0; i++)e.emplace(i + n, r);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let r = 0, n = 0;
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const n = this.symbolInstances.get(r), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: s, numIconVertices: o } = n, a = n.zOffset, l = o > 0;
                    if ((i > 0 || s > 0) && (e(this.text.zOffsetVertexArray, i, a), e(this.text.zOffsetVertexArray, s, a)), l) {
                        const { placedIconSymbolIndex: e, verticalPlacedIconSymbolIndex: r } = n;
                        e >= 0 && t1(this.icon.zOffsetVertexArray, o, a), r >= 0 && t1(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, a);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e, t1, r, n, i) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e), this.iconCollisionBox.upload(e)), this.text.upload(e, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), null === this.hasAppearances && (this.hasAppearances = this.layers.some((e)=>e.appearances && e.appearances.length > 0)), this.icon.upload(e, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), this.uploaded = !0;
            }
            updateAppearances(e, t1, r, n, i) {
                if (!(e && t1 && r && this.appearanceFeatureData)) return !1;
                const s = this.icon.layoutVertexArray && this.icon.layoutVertexArray.length > 0 && this.icon.layoutVertexArray.arrayBuffer, o = this.text.layoutVertexArray && this.text.layoutVertexArray.length > 0 && this.text.layoutVertexArray.arrayBuffer;
                if (!s && !o) return !1;
                const a = this.layers[0], l = a.layout;
                let u = 1, c = 0, h = !1;
                if (s) {
                    const [e, t1] = l.get("icon-size-scale-range");
                    u = De(1, e, t1);
                }
                let p = 1, d = 0, f = !1;
                if (o) {
                    const [e, t1] = l.get("text-size-scale-range");
                    p = De(1, e, t1);
                }
                const m = new Map;
                if (i && r) for (const e of r){
                    const t1 = i.getImage(e, a.scope);
                    if (t1) {
                        const r = new Cr(e.toString());
                        m.set(r.toString(), t1);
                    }
                }
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const y = this.symbolInstances.get(i), g = this.featureToAppearanceIndex[y.featureIndex], x = void 0 !== g ? this.appearanceFeatureData[g] : void 0;
                    if (!x) continue;
                    const v = x.id, b = t1 && void 0 !== v ? t1[String(v)] : void 0, w = {
                        type: "Point",
                        id: x.id,
                        properties: x.properties,
                        geometry: []
                    }, _ = a.appearances && a.appearances.find((t1)=>t1.isActive({
                            globals: n,
                            feature: w,
                            canonical: e,
                            featureState: b
                        }));
                    if (o) {
                        const t1 = l.get("text-size"), n = l.get("text-offset").evaluate(w, b, e), i = t1.evaluate(w, b, e), s = l.get("text-rotate").evaluate(w, b, e), o = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, u = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0, c = t1.evaluate(w, {
                            zoom: o
                        }, e), h = t1.evaluate(w, {
                            zoom: u
                        }, e), g = this.updateSymbolInstanceTextVertices(y, x, _, w, d, e, a, p, m, b, n, i, s, c, h, o, u, r);
                        d += g.vertexOffsetDelta, f = f || g.hasChanges;
                    }
                    if (s) {
                        const t1 = l.get("icon-offset").evaluate(w, b, e), i = l.get("icon-size").evaluate(w, b, e, r), s = l.get("icon-rotate").evaluate(w, b, e), o = this.updateSymbolInstanceIconVertices(y, x, _, w, c, e, r, n, a, u, b, t1, i, s);
                        c += o.vertexOffsetDelta, h = h || o.hasChanges;
                    }
                    x.activeAppearance = _;
                }
                return h && this.icon.layoutVertexBuffer && null !== this.icon.layoutVertexArray.arrayBuffer && this.icon.layoutVertexArray.length === this.icon.layoutVertexBuffer.length && this.icon.layoutVertexBuffer.updateData(this.icon.layoutVertexArray), f && this.text.layoutVertexBuffer && null !== this.text.layoutVertexArray.arrayBuffer && this.text.layoutVertexArray.length === this.text.layoutVertexBuffer.length && this.text.layoutVertexBuffer.updateData(this.text.layoutVertexArray), h || f;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Wv(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e, t1) {
                const r = this.lineVertexArray.length;
                if (void 0 !== e.segment) for (const { x: e, y: r } of t1)this.lineVertexArray.emplaceBack(e, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e, t1, r, n, i, s, o, a, l, u, c, h, p, d, f, m, y, g) {
                const x = e.indexArray, v = e.layoutVertexArray, b = e.globeExtVertexArray, w = e.segments.prepareSegment(4 * g, v, x, this.canOverlap ? s.sortKey : void 0), _ = this.glyphOffsetArray.length, A = w.vertexLength, M = this.allowVerticalPlacement && o === qg.vertical ? Math.PI / 2 : 0, I = s.text && s.text.sections;
                for(let n = 0; n < t1.length; n++){
                    const { tl: i, tr: o, bl: u, br: c, texPrimary: h, texSecondary: y, pixelOffsetTL: g, pixelOffsetBR: _, minFontScaleX: A, minFontScaleY: S, glyphOffset: z, isSDF: P, sectionIndex: B } = t1[n], T = w.vertexLength, k = z[1];
                    if (Kv(v, l.x, l.y, i.x, k + i.y, h.x, h.y, r, P, g.x, g.y, A, S), Kv(v, l.x, l.y, o.x, k + o.y, h.x + h.w, h.y, r, P, _.x, g.y, A, S), Kv(v, l.x, l.y, u.x, k + u.y, h.x, h.y + h.h, r, P, g.x, _.y, A, S), Kv(v, l.x, l.y, c.x, k + c.y, h.x + h.w, h.y + h.h, r, P, _.x, _.y, A, S), a) {
                        const { x: t1, y: r, z: n } = a.anchor, [i, s, o] = a.up;
                        eb(b, t1, r, n, i, s, o), eb(b, t1, r, n, i, s, o), eb(b, t1, r, n, i, s, o), eb(b, t1, r, n, i, s, o), rb(e.dynamicLayoutVertexArray, t1, r, n, M);
                    } else rb(e.dynamicLayoutVertexArray, l.x, l.y, l.z, M);
                    if (m) {
                        const t1 = y || h;
                        Qv(e.iconTransitioningVertexArray, t1.x, t1.y), Qv(e.iconTransitioningVertexArray, t1.x + t1.w, t1.y), Qv(e.iconTransitioningVertexArray, t1.x, t1.y + t1.h), Qv(e.iconTransitioningVertexArray, t1.x + t1.w, t1.y + t1.h);
                    }
                    x.emplaceBack(T, T + 1, T + 2), x.emplaceBack(T + 1, T + 2, T + 3), w.vertexLength += 4, w.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(z[0]), n !== t1.length - 1 && B === t1[n + 1].sectionIndex || e.programConfigurations.populatePaintArrays(v.length, s, s.index, {}, p, d, f, I && I[B], this.worldview);
                }
                const S = g - t1.length;
                0 !== S && this._addNullVertices(S, v, r, a, b, e, m, w, x);
                const z = a ? a.anchor : l;
                e.placedSymbolArray.emplaceBack(z.x, z.y, z.z, l.x, l.y, _, this.glyphOffsetArray.length - _, A, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], o, 0, 0, 0, h, 0), e.symbolInstanceIndices.push(y);
            }
            _addNullVertices(e, t1, r, n, i, s, o, a, l) {
                for(let u = 0; u < e; u++){
                    for(let e = 0; e < 4; e++)Kv(t1, 0, 0, 0, 0, 0, 0, r, !1, 0, 0, 0, 0), n ? (eb(i, 0, 0, 0, 0, 0, 0), rb(s.dynamicLayoutVertexArray, 0, 0, 0, 0)) : rb(s.dynamicLayoutVertexArray, 0, 0, 0, 0), o && Qv(s.iconTransitioningVertexArray, 0, 0);
                    const e = a.vertexLength;
                    l.emplaceBack(e, e + 1, e + 2), l.emplaceBack(e + 1, e + 2, e + 3), a.vertexLength += 4, a.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(0);
                }
            }
            _commitLayoutVertex(e, t1, r, n, i, s, o) {
                e.emplaceBack(t1, r, n, i, s, Math.round(o.x), Math.round(o.y));
            }
            _addCollisionDebugVertices(e, t1, r, n, i, s, o) {
                const a = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = a.vertexLength, u = o.tileAnchorX, c = o.tileAnchorY;
                for(let e = 0; e < 4; e++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, t1, e.padding, o.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Ie(e.x1, e.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Ie(e.x2, e.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Ie(e.x2, e.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Ie(e.x1, e.y2)), a.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), a.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e, t1, r, n, i, s) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceTextSize(e, s, t1, o);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(e, t1, r, n, i, s) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceIconSize(e, t1, s.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(e, t1, r) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new sb(nl, bg.members, tl), this.iconCollisionBox = new sb(nl, bg.members, tl);
                const n = dx(this.iconSizeData, e), i = dx(this.textSizeData, e, r);
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const s = this.symbolInstances.get(r);
                    this._addTextDebugCollisionBoxes(i, e, t1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(i, e, t1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, e, t1, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, e, t1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(e, t1, r, n) {
                const i = this.text.placedSymbolArray.get(t1.rightJustifiedTextSymbolIndex >= 0 ? t1.rightJustifiedTextSymbolIndex : t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.leftJustifiedTextSymbolIndex >= 0 ? t1.leftJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex >= 0 ? t1.verticalPlacedTextSymbolIndex : n), s = px(this.textSizeData, e, i) / _g;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(e, t1, r) {
                const n = this.icon.placedSymbolArray.get(r), i = px(this.iconSizeData, e, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(e, t1, r, n) {
                e.emplaceBack(t1, -r, -r, n), e.emplaceBack(t1, r, -r, n), e.emplaceBack(t1, r, r, n), e.emplaceBack(t1, -r, r, n);
            }
            _updateTextDebugCollisionBoxes(e, t1, r, n, i, s, o) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceTextSize(e, s, t1, o);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e, t1, r, n, i, s, o) {
                for(let o = n; o < i; o++){
                    const n = r.get(o), i = this.getSymbolInstanceIconSize(e, t1, s.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            updateCollisionDebugBuffers(e, t1, r, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = dx(this.iconSizeData, e, n), s = dx(this.textSizeData, e, r);
                for(let o = 0; o < this.symbolInstances.length; o++){
                    const a = this.symbolInstances.get(o);
                    this._updateTextDebugCollisionBoxes(s, e, t1, a.textBoxStartIndex, a.textBoxEndIndex, a, r), this._updateTextDebugCollisionBoxes(s, e, t1, a.verticalTextBoxStartIndex, a.verticalTextBoxEndIndex, a, r), this._updateIconDebugCollisionBoxes(i, e, t1, a.iconBoxStartIndex, a.iconBoxEndIndex, a, n), this._updateIconDebugCollisionBoxes(i, e, t1, a.verticalIconBoxStartIndex, a.verticalIconBoxEndIndex, a, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(e, t1, r, n, i, s, o, a, l) {
                const u = {};
                if (t1 < r) {
                    const { x1: r, y1: n, x2: i, y2: s, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: d } = e.get(t1);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: s,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.textFeatureIndex = d;
                }
                if (n < i) {
                    const { x1: t1, y1: r, x2: i, y2: s, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: d } = e.get(n);
                    u.verticalTextBox = {
                        x1: t1,
                        y1: r,
                        x2: i,
                        y2: s,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalTextFeatureIndex = d;
                }
                if (s < o) {
                    const { x1: t1, y1: r, x2: n, y2: i, padding: o, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: d } = e.get(s);
                    u.iconBox = {
                        x1: t1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: o,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.iconFeatureIndex = d;
                }
                if (a < l) {
                    const { x1: t1, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: d } = e.get(a);
                    u.verticalIconBox = {
                        x1: t1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalIconFeatureIndex = d;
                }
                return u;
            }
            deserializeCollisionBoxes(e) {
                this.collisionArrays = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const r = this.symbolInstances.get(t1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e, t1) {
                const r = e.placedSymbolArray.get(t1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let t1 = r.vertexStartIndex; t1 < n; t1 += 4)e.indexArray.emplaceBack(t1, t1 + 1, t1 + 2), e.indexArray.emplaceBack(t1 + 1, t1 + 2, t1 + 3);
            }
            getSortedSymbolIndexes(e) {
                if (this.sortedAngle === e && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t1 = Math.sin(e), r = Math.cos(e), n = [], i = [], s = [];
                for(let e = 0; e < this.symbolInstances.length; ++e){
                    s.push(e);
                    const o = this.symbolInstances.get(e);
                    n.push(0 | Math.round(t1 * o.tileAnchorX + r * o.tileAnchorY)), i.push(o.featureIndex);
                }
                return s.sort((e, t1)=>n[e] - n[t1] || i[t1] - i[e]), s;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e = 0; e < this.symbolInstances.length; ++e)this.symbolInstanceIndexesSortedZOffset.push(e);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e, t1)=>this.symbolInstances.get(t1).zOffset - this.symbolInstances.get(e).zOffset);
            }
            addToSortKeyRanges(e, t1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === t1 ? r.symbolInstanceEnd = e + 1 : this.sortKeyRanges.push({
                    sortKey: t1,
                    symbolInstanceStart: e,
                    symbolInstanceEnd: e + 1
                });
            }
            sortFeatures(e) {
                if (this.sortFeaturesByY && this.sortedAngle !== e) {
                    if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) this.sortFeaturesByY = !1;
                    else {
                        this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e), this.sortedAngle = e, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                        for (const e of this.symbolInstanceIndexes){
                            const t1 = this.symbolInstances.get(e);
                            this.featureSortOrder.push(t1.featureIndex);
                            const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s, placedIconSymbolIndex: o, verticalPlacedIconSymbolIndex: a } = t1;
                            r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a);
                        }
                        this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                    }
                }
            }
            getElevationFeatureForText(e) {
                const t1 = this.symbolInstances.get(this.text.symbolInstanceIndices[e]).elevationFeatureIndex;
                let r;
                return this.elevationFeatures && t1 < this.elevationFeatures.length && (r = this.elevationFeatures[t1]), r;
            }
        }
        function ab(e, t1) {
            return t1.replace(/{([^{}]+)}/g, (t1, r)=>r in e ? String(e[r]) : "");
        }
        let lb, ub, cb;
        Js(ob, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "compareText",
                "features"
            ]
        }), ob.addDynamicAttributes = rb;
        class hb {
            constructor(e){
                this.type = e.property.overrides ? e.property.overrides.runtimeType : yr, this.defaultValue = e;
            }
            evaluate(e) {
                if (e.formattedSection) {
                    const t1 = this.defaultValue.property.overrides;
                    if (t1 && t1.hasOverride(e.formattedSection)) return t1.getOverride(e.formattedSection);
                }
                return e.feature && e.featureState ? this.defaultValue.evaluate(e.feature, e.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e) {
                this.defaultValue.isConstant() || e(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Js(hb, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const pb = ()=>cb || (cb = {
                layout: lb || (lb = new la({
                    "symbol-placement": new sa(ua.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new sa(ua.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new sa(ua.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new oa(ua.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new sa(ua.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new sa(ua.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new sa(ua.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new sa(ua.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new sa(ua.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new sa(ua.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new sa(ua.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new oa(ua.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new sa(ua.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new oa(ua.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new oa(ua.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new oa(ua.layout_symbol["icon-image"]),
                    "icon-image-use-theme": new sa({
                        type: "string",
                        default: "default",
                        "property-type": "data-constant"
                    }),
                    "icon-rotate": new oa(ua.layout_symbol["icon-rotate"]),
                    "icon-padding": new sa(ua.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new sa(ua.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new oa(ua.layout_symbol["icon-offset"]),
                    "icon-anchor": new oa(ua.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new sa(ua.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new sa(ua.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new sa(ua.layout_symbol["text-rotation-alignment"]),
                    "text-field": new oa(ua.layout_symbol["text-field"]),
                    "text-font": new oa(ua.layout_symbol["text-font"]),
                    "text-size": new oa(ua.layout_symbol["text-size"]),
                    "text-size-scale-range": new sa(ua.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new oa(ua.layout_symbol["text-max-width"]),
                    "text-line-height": new oa(ua.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new oa(ua.layout_symbol["text-letter-spacing"]),
                    "text-justify": new oa(ua.layout_symbol["text-justify"]),
                    "text-radial-offset": new oa(ua.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new sa(ua.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new oa(ua.layout_symbol["text-anchor"]),
                    "text-max-angle": new sa(ua.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new sa(ua.layout_symbol["text-writing-mode"]),
                    "text-rotate": new oa(ua.layout_symbol["text-rotate"]),
                    "text-padding": new sa(ua.layout_symbol["text-padding"]),
                    "text-keep-upright": new sa(ua.layout_symbol["text-keep-upright"]),
                    "text-transform": new oa(ua.layout_symbol["text-transform"]),
                    "text-offset": new oa(ua.layout_symbol["text-offset"]),
                    "text-allow-overlap": new sa(ua.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new sa(ua.layout_symbol["text-ignore-placement"]),
                    "text-optional": new sa(ua.layout_symbol["text-optional"]),
                    visibility: new sa(ua.layout_symbol.visibility)
                })),
                paint: ub || (ub = new la({
                    "icon-opacity": new oa(ua.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new oa(ua.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new oa(ua.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new oa(ua.paint_symbol["text-emissive-strength"]),
                    "icon-color": new oa(ua.paint_symbol["icon-color"]),
                    "icon-halo-color": new oa(ua.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new oa(ua.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new oa(ua.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new sa(ua.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new sa(ua.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new sa(ua.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new oa(ua.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new oa(ua.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new oa(ua.paint_symbol["text-color"], {
                        runtimeType: br,
                        getOverride: (e)=>e.textColor,
                        hasOverride: (e)=>!!e.textColor
                    }),
                    "text-halo-color": new oa(ua.paint_symbol["text-halo-color"]),
                    "text-halo-width": new oa(ua.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new oa(ua.paint_symbol["text-halo-blur"]),
                    "text-translate": new sa(ua.paint_symbol["text-translate"]),
                    "text-translate-anchor": new sa(ua.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new sa(ua.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new sa(ua.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new sa(ua.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new sa(ua.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new oa(ua.paint_symbol["symbol-z-offset"]),
                    "icon-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new oa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, cb);
        class db extends Va {
            constructor(e, t1, r, n){
                super(e, pb(), t1, r, n, e.layout ? e.layout["icon-image-use-theme"] : null), this._colorAdjustmentMatrix = u([]), this.hasOcclusionOpacityProperties = void 0 !== e.paint && ("icon-occlusion-opacity" in e.paint || "text-occlusion-opacity" in e.paint);
            }
            _handleSpecialPaintPropertyUpdate(e) {
                "icon-occlusion-opacity" !== e && "text-occlusion-opacity" !== e || (this.hasOcclusionOpacityProperties = !0);
            }
            recalculate(e, t1) {
                super.recalculate(e, t1), this.appearances && this.appearances.forEach((r)=>{
                    r.recalculate(e, t1, this.iconImageUseTheme);
                }), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const e = [];
                    for (const t1 of r)e.indexOf(t1) < 0 && e.push(t1);
                    this.layout._values["text-writing-mode"] = e;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(e, t1, r, n) {
                return this._saturation === e && this._contrast === t1 && this._brightnessMin === r && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(e, t1, r, n) {
                    e = st(e), t1 = it(t1);
                    const i = a(), s = e / 3, o = 1 - 2 * s, l = [
                        o,
                        s,
                        s,
                        0,
                        s,
                        o,
                        s,
                        0,
                        s,
                        s,
                        o,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], u = .5 - .5 * t1, c = n - r;
                    return h(i, [
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        r,
                        r,
                        r,
                        1
                    ], [
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        u,
                        u,
                        u,
                        1
                    ]), h(i, i, l), i;
                }(e, t1, r, n), this._saturation = e, this._contrast = t1, this._brightnessMin = r, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(e, t1, r, n) {
                const i = this.layout.get(e).evaluate(t1, {}, r, n), s = this._unevaluatedLayout._values[e];
                return s.isDataDriven() || Os(s.value) || !i ? i : ab(t1.properties, i);
            }
            getAppearanceValueAndResolveTokens(e, t1, r, n, i) {
                const s = e.getProperty(t1);
                if (!s) return;
                const o = s.evaluate(r, {}, n, i), a = e.getUnevaluatedProperties()._values[t1];
                return a.isDataDriven() || Os(a.value) || !o || "string" != typeof o ? o : ab(r.properties, o);
            }
            createBucket(e) {
                return new ob(e);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const e of pb().paint.overridableProperties){
                    if (!db.hasPaintOverride(this.layout, e)) continue;
                    const t1 = this.paint.get(e), r = new hb(t1), n = new Ls(r, t1.property.specification, this.scope, this.options, this.layout.get("icon-image-use-theme"));
                    let i = null;
                    i = "constant" === t1.value.kind || "source" === t1.value.kind ? new Ns("source", n) : new js("composite", n, t1.value.zoomStops, t1.value.interpolationType), this.paint._values[e] = new na(t1.property, i, t1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e, t1, r) {
                return !(!this.layout || t1.isDataDriven() || r.isDataDriven()) && db.hasPaintOverride(this.layout, e);
            }
            static hasPaintOverride(e, t1) {
                const r = e.get("text-field"), n = pb().paint.properties[t1];
                let i = !1;
                const s = (e)=>{
                    for (const t1 of e)if (n.overrides && n.overrides.hasOverride(t1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Dr) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const e = (t1)=>{
                        i || (t1 instanceof jr && Ur(t1.value) === Mr ? s(t1.value.sections) : t1 instanceof Xr ? s(t1.sections) : t1.eachChild(e));
                    }, t1 = r.value;
                    t1._styleExpression && e(t1._styleExpression.expression);
                }
                return i;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(e, t1, r) {
                return {
                    config: new hu(this, {
                        zoom: t1,
                        lut: r
                    }),
                    overrideFog: !1
                };
            }
            hasElevation() {
                return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
        }
        let fb, mb, yb, gb;
        var xb = Ra([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function vb(e, t1, r, n, i, a, l, u) {
            const c = [
                e,
                t1,
                1,
                r,
                n,
                1,
                i,
                a,
                1
            ], h = [
                l,
                u,
                1
            ], p = s([], c), [d, f, m] = G(h, h, p);
            return o(c, c, [
                d,
                0,
                0,
                0,
                f,
                0,
                0,
                0,
                m
            ]);
        }
        function bb(e, t1, r, n, i, a, l, u) {
            const c = function(e, t1, r, n, i, a, l, u) {
                const c = vb(0, 0, 1, 0, 1, 1, 0, 1), h = vb(e, t1, r, n, i, a, l, u);
                return o(h, h, s([], c));
            }(e, t1, r, n, i, a, l, u);
            return [
                c[2] / c[8] / Un,
                c[5] / c[8] / Un
            ];
        }
        function wb(e) {
            return [
                e[0],
                Math.min(Math.max(e[1], -85.051129), Cu)
            ];
        }
        class _b extends rr {
            constructor(e, t1, r, n){
                super(), this.id = e, this.dispatcher = r, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(n), this.options = t1, this._dirty = !1;
            }
            load(e, t1) {
                if (this._loaded = t1 || !1, this.fire(new Kt("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return e && (this.coordinates = e), this._loaded = !0, void this._finishLoading();
                this._imageRequest = Gt(this.map._requestManager.transformRequest(this.url, Dt.Image), (t1, r)=>{
                    this._imageRequest = null, this._loaded = !0, t1 ? this.fire(new Qt(t1)) : r && (this.image = r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, e && (this.coordinates = e), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e) {
                return e.url ? (this._imageRequest && e.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = e.url, this.load(e.coordinates, this._loaded), this) : this;
            }
            setTexture(e) {
                if (!(e.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new Fm(this.map.painter.context, e.handle), this.width = e.dimensions[0], this.height = e.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new Kt("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            onRemove(e) {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof Fm || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(e) {
                if (this.coordinates = e, this._boundsArray = void 0, this._unsupportedCoords = !1, !e.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let t1 = e[0][1], r = e[0][1];
                for (const n of e)n[1] > r && (r = n[1]), n[1] < t1 && (t1 = n[1]);
                const n = (r + t1) / 2;
                if (n > Cu ? this.onNorthPole = !0 : n < -85.051129 && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const t1 = e.map(Nu.fromLngLat);
                    this.tileID = function(e) {
                        let t1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                        for (const s of e)t1 = Math.min(t1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                        const s = Math.max(n - t1, i - r), o = Math.max(0, Math.floor(-Math.log2(s))), a = Math.pow(2, o);
                        let l = Math.floor((t1 + n) / 2 * a);
                        return l > 1 && (l -= 1), new Hc(o, l, Math.floor((r + i) / 2 * a));
                    }(t1), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new Kt("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                !this.texture || this.texture instanceof Fm || (this.texture.destroy(), this._dirty = !0), this.texture = null, this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(e) {
                for(const e in this.tiles){
                    const t1 = this.tiles[e];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const t1 = zv(new Hc(0, 0, 0), this.map.transform.projection), r = [
                    t1.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    t1.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    t1.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    t1.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(e) {
                    const t1 = e[1].x - e[0].x, r = e[1].y - e[0].y, n = e[2].x - e[1].x, i = e[2].y - e[1].y, s = e[3].x - e[2].x, o = e[3].y - e[2].y, a = e[0].x - e[3].x, l = e[0].y - e[3].y, u = t1 * i - n * r, c = n * o - s * i, h = s * l - a * o, p = a * r - t1 * l;
                    return u > 0 && c > 0 && h > 0 && p > 0 || u < 0 && c < 0 && h < 0 && p < 0;
                }(r)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const n = zv(this.tileID, this.map.transform.projection), [i, a, l, u] = this.coordinates.map((e)=>{
                    const t1 = n.projection.project(e[0], e[1]);
                    return Pv(n, t1)._round();
                });
                this.perspectiveTransform = bb(i.x, i.y, a.x, a.y, l.x, l.y, u.x, u.y);
                const c = this._boundsArray = new Na;
                c.emplaceBack(i.x, i.y, 0, 0), c.emplaceBack(a.x, a.y, Un, 0), c.emplaceBack(u.x, u.y, 0, Un), c.emplaceBack(l.x, l.y, Un, Un), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = e.createVertexBuffer(c, xb.members), this.boundsSegments = Rl.simpleSegment(0, 0, 4, 2);
                const h = [], p = [
                    wb((d = this.coordinates)[0]),
                    wb(d[1]),
                    wb(d[2]),
                    wb(d[3])
                ];
                var d;
                const [f, m, y, g] = function(e) {
                    let t1 = e[0][0], r = t1, n = e[0][1], i = n;
                    for(let s = 1; s < e.length; s++)e[s][0] < t1 ? t1 = e[s][0] : e[s][0] > r && (r = e[s][0]), e[s][1] < n ? n = e[s][1] : e[s][1] > i && (i = e[s][1]);
                    return [
                        t1,
                        n,
                        r - t1,
                        i - n
                    ];
                }(p);
                {
                    const n = new Na, [i, a, l, u] = function(e) {
                        let t1 = e[0].x, r = t1, n = e[0].y, i = n;
                        for(let s = 1; s < e.length; s++)e[s].x < t1 ? t1 = e[s].x : e[s].x > r && (r = e[s].x), e[s].y < n ? n = e[s].y : e[s].y > i && (i = e[s].y);
                        return [
                            t1,
                            n,
                            r - t1,
                            i - n
                        ];
                    }(r), c = (e)=>[
                            (e.x - i) / l,
                            (e.y - a) / u
                        ], [p, d, x, v] = r.map(c), b = function(e, t1, r, n, i, a, l, u) {
                        const c = vb(0, 0, 1, 0, 1, 1, 0, 1);
                        return o(c, c, s([], vb(e, t1, r, n, i, a, l, u)));
                    }(p[0], p[1], d[0], d[1], x[0], x[1], v[0], v[1]);
                    this.elevatedGlobePerspectiveTransform = bb(p[0], p[1], d[0], d[1], x[0], x[1], v[0], v[1]);
                    const w = (e, t1)=>{
                        h.push(e.lng);
                        const r = Math.round((e.lng - f) / y * Un), i = Math.round((e.lat - m) / g * Un), s = c(t1), o = G([], [
                            s[0],
                            s[1],
                            1
                        ], b), a = Math.round(o[0] / o[2] * Un), l = Math.round(o[1] / o[2] * Un);
                        n.emplaceBack(r, i, a, l);
                    }, _ = r[3].x - r[0].x, A = r[3].y - r[0].y, M = r[2].x - r[1].x, I = r[2].y - r[1].y;
                    for(let e = 0; e < 65; e++){
                        const n = e / 64, i = [
                            r[0].x + n * _,
                            r[0].y + n * A
                        ], s = [
                            r[1].x + n * M,
                            r[1].y + n * I
                        ], o = s[0] - i[0], a = s[1] - i[1];
                        for(let e = 0; e < 65; e++){
                            const r = e / 64, n = {
                                x: i[0] + o * r,
                                y: i[1] + a * r
                            };
                            w(t1.projection.unproject(n.x, n.y), n);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = e.createVertexBuffer(n, xb.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let t1 = [], r = new ol;
                    const n = (e, n, i)=>{
                        r.emplaceBack(e, n, i);
                        const s = h[e], o = h[n], a = h[i], l = Math.min(Math.min(s, o), a), u = Math.max(Math.max(s, o), a) - l;
                        u > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = u), t1.push(l + u / 2);
                    };
                    for(let e = 0; e < 64; e++)for(let t1 = 0; t1 < 64; t1++){
                        const r = 65 * e + t1, i = r + 1, s = r + 65, o = s + 1;
                        n(r, s, i), n(i, s, o);
                    }
                    [t1, r] = function(e, t1) {
                        const r = Array.from({
                            length: e.length
                        }, (e, t1)=>t1);
                        r.sort((t1, r)=>e[t1] - e[r]);
                        const n = [], i = new ol;
                        for(let s = 0; s < r.length; s++){
                            const o = r[s];
                            n.push(e[o]);
                            const a = 3 * o, l = a + 1;
                            i.emplaceBack(t1.uint16[a], t1.uint16[l], t1.uint16[l + 1]);
                        }
                        return [
                            n,
                            i
                        ];
                    }(t1, r), this.elevatedGlobeTrianglesCenterLongitudes = t1, this.elevatedGlobeIndexBuffer = e.createIndexBuffer(r);
                }
                this.elevatedGlobeSegments = Rl.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    y / Un,
                    0,
                    g / Un,
                    0,
                    0,
                    m,
                    f,
                    0
                ]);
            }
            prepare() {
                const e = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !e) return;
                const t1 = this.map.painter.context, r = t1.gl;
                !this._dirty || this.texture instanceof Fm || (this.texture ? this.texture.update(this.image) : (this.texture = new Em(t1, this.image, r.RGBA8), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), e && this._prepareData(t1);
            }
            loadTile(e, t1) {
                this.tileID && this.tileID.equals(e.tileID.canonical) ? (this.tiles[String(e.tileID.wrap)] = e, e.buckets = {}, t1(null)) : (e.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(e) {
                const t1 = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !t1) return null;
                const r = this.elevatedGlobeTrianglesCenterLongitudes;
                let n = (i = e + 180) + 360 * Math.round((r[0] - i) / 360);
                var i;
                const s = new Rl, o = (e, r)=>{
                    s.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: e,
                        vertexLength: t1.segments[0].vertexLength,
                        primitiveLength: r,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, a = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(r[0] - n) <= a) {
                    const e = nt(r, 0, r.length, n + a);
                    return e === r.length || o(e, rt(r, e + 1, r.length, n + 360 - a) - e), s;
                }
                n < r[0] && (n += 360);
                const l = rt(r, 0, r.length, n - a);
                if (l === r.length) return o(0, r.length), s;
                o(0, l - 0);
                const u = nt(r, l + 1, r.length, n + a);
                return u !== r.length && o(u, r.length - u), s;
            }
        }
        const Ab = 1024, Mb = (Math.pow(Ab, 2) - 1) / 268170240;
        class Ib extends Va {
            constructor(e, t1, r, n){
                super(e, {
                    layout: yb || (yb = new la({
                        visibility: new sa(ua.layout_raster.visibility)
                    })),
                    paint: gb || (gb = new la({
                        "raster-opacity": new sa(ua.paint_raster["raster-opacity"]),
                        "raster-color": new aa(ua.paint_raster["raster-color"]),
                        "raster-color-mix": new sa(ua.paint_raster["raster-color-mix"]),
                        "raster-color-range": new sa(ua.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new sa(ua.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new sa(ua.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new sa(ua.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new sa(ua.paint_raster["raster-saturation"]),
                        "raster-contrast": new sa(ua.paint_raster["raster-contrast"]),
                        "raster-resampling": new sa(ua.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new sa(ua.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new sa(ua.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new sa(ua.paint_raster["raster-array-band"]),
                        "raster-elevation": new sa(ua.paint_raster["raster-elevation"]),
                        "raster-elevation-reference": new sa(ua.paint_raster["raster-elevation-reference"]),
                        "raster-color-use-theme": new oa({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, r, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(e) {
                return !(e && e._source instanceof _b && (e._source.onNorthPole || e._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(e) {
                "raster-color" !== e && "raster-color-range" !== e || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
            }
            updateColorRamp(e) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const t1 = this._transitionablePaint._values["raster-color"].value.expression, [r, n] = e || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = qh({
                    expression: t1,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: r,
                            end: n
                        }
                    ],
                    resolution: Ab
                }), this.colorRampTexture = null, this._curRampRange = [
                    r,
                    n
                ]);
            }
            is3D(e) {
                return this.paint.get("raster-elevation") > 0;
            }
        }
        let Sb, zb, Pb, Bb, Tb;
        class kb extends Va {
            constructor(e, t1, r, n){
                super(e, {
                    layout: Sb || (Sb = new la({
                        visibility: new sa(ua["layout_raster-particle"].visibility)
                    })),
                    paint: zb || (zb = new la({
                        "raster-particle-array-band": new sa(ua["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new sa(ua["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new aa(ua["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new sa(ua["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new sa(ua["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new sa(ua["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new sa(ua["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new sa(ua["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new oa({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, r, n), this._updateColorRamp(), this.lastInvalidatedAt = gt.now();
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this.tileFramebuffer && (this.tileFramebuffer.destroy(), this.tileFramebuffer = null), this.particleFramebuffer && (this.particleFramebuffer.destroy(), this.particleFramebuffer = null);
            }
            onRemove(e) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(e) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(e) {
                "raster-particle-color" !== e && "raster-particle-max-speed" !== e || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === e && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const e = this._transitionablePaint._values["raster-particle-color"].value.expression, t1 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = qh({
                    expression: e,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: t1
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = gt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class Vb extends Va {
            constructor(e, t1){
                super(e, {}, t1, null), this.implementation = e, e.slot && (this.slot = e.slot);
            }
            is3D(e) {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(e) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e) {
                this.implementation.onAdd && this.implementation.onAdd(e, e.painter.context.gl);
            }
            onRemove(e) {
                this.implementation.onRemove && this.implementation.onRemove(e, e.painter.context.gl);
            }
        }
        function Eb(e, t1, r) {
            const n = [
                0,
                0,
                1
            ], i = re([]);
            return ie(i, i, r ? -Be(e) + Math.PI : Be(e)), ne(i, i, -Be(t1)), $(n, n, i), L(n, n);
        }
        const Fb = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4
        };
        class Db {
            constructor(e, t1, r, n){
                this.message = (e ? `${e}: ` : "") + r, n && (this.identifier = n), null != t1 && t1.__line__ && (this.line = t1.__line__);
            }
        }
        function Cb(e, t1) {
            const r = -1 === e.indexOf("://");
            try {
                return new URL(e, r && t1 ? "http://example.com" : void 0), !0;
            } catch (e) {
                return !1;
            }
        }
        class Rb {
            constructor(e, t1){
                this.feature = e, this.instancedDataOffset = t1, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Lb {
            constructor(){
                this.maxScale = 1, this.maxXYTranslationDistance = 0, this.instancedDataArray = new gl, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
            colorForInstance(e) {
                const t1 = 16 * e, r = this.instancedDataArray.float32;
                let n = Math.floor(r[t1 + 2]);
                const i = 1.05 * (r[t1 + 2] - n);
                return n /= 100, [
                    r[t1] % 1 * 1.05,
                    r[t1 + 1] % 1 * 1.05,
                    i,
                    n
                ];
            }
            tileCoordinatesForInstance(e) {
                const t1 = 16 * e, r = this.instancedDataArray.float32;
                let n = r[t1 + 0];
                return n = n > Un ? n - Un : n, new Ie(Math.trunc(n), Math.trunc(r[t1 + 1]));
            }
            translationForInstance(e) {
                const t1 = 16 * e, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 4],
                    r[t1 + 5],
                    r[t1 + 6]
                ];
            }
            rotationScaleForInstance(e) {
                const t1 = 16 * e, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 7],
                    r[t1 + 8],
                    r[t1 + 9],
                    r[t1 + 10],
                    r[t1 + 11],
                    r[t1 + 12],
                    r[t1 + 13],
                    r[t1 + 14],
                    r[t1 + 15]
                ];
            }
            transformForInstance(e) {
                const t1 = 16 * e, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 7],
                    r[t1 + 8],
                    r[t1 + 9],
                    r[t1 + 4],
                    r[t1 + 10],
                    r[t1 + 11],
                    r[t1 + 12],
                    r[t1 + 5],
                    r[t1 + 13],
                    r[t1 + 14],
                    r[t1 + 15],
                    r[t1 + 6],
                    0,
                    0,
                    0,
                    1
                ];
            }
        }
        class Ob {
            constructor(e){
                this.zoom = e.zoom, this.canonical = e.canonical, this.overscaledZ = this.canonical.z + Math.log2(e.overscaling), this.layers = e.layers, this.layerIds = this.layers.map((e)=>e.fqid), this.projection = e.projection, this.index = e.index, this.worldview = e.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z + 1 ? 0 : this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = e.styleDefinedModelURLs, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {}
            updateAppearances(e, t1, r, n) {}
            populate(e, t1, r, n) {
                this.tileToMeter = Uu(r);
                const i = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                const s = "hd-road-markup" === this.layers[0].paint.get("model-elevation-reference") ? t1.elevationFeatures : void 0;
                for (const { feature: o, id: a, index: l, sourceLayerIndex: u } of e){
                    const e = null != a ? a : o.properties && o.properties.hasOwnProperty("id") ? o.properties.id : void 0, c = Yu(o, i);
                    if (!this.layers[0]._featureFilter.filter(new Yo(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = {
                        id: e,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: i ? c.geometry : Wu(o, r, n),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    }, p = this.addFeature(h, h.geometry, c, s, r);
                    p && t1.featureIndex.insert(o, h.geometry, l, u, this.index, this.instancesPerModel[p].instancedDataArray.length, 256);
                }
                this.lookup = null;
            }
            evaluateQueryRenderedFeaturePadding() {
                const e = this.layers[0].modelManager, t1 = this.layers[0].scope;
                let r = 0;
                for (const n of this.modelUris){
                    const i = e.getModel(n, t1);
                    if (!i) continue;
                    const s = this.instancesPerModel[n];
                    if (s) {
                        const e = .5 * F(i.aabb.max, i.aabb.min) * s.maxScale + s.maxXYTranslationDistance, t1 = Math.min(Un, Math.max(e / this.tileToMeter, 256));
                        r = Math.max(t1, r);
                    }
                }
                return r;
            }
            update(e, t1, r, n) {
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    for(const t1 in e)r.idToFeaturesIndex.hasOwnProperty(t1) && (this.evaluate(r.features[r.idToFeaturesIndex[t1]], e[t1], r, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let e = !1;
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    for (const t1 of r.features){
                        const n = this.layers[0], i = t1.feature, s = this.canonical, o = n.paint.get("model-rotation").evaluate(i, {}, s), a = n.paint.get("model-scale").evaluate(i, {}, s), l = n.paint.get("model-translation").evaluate(i, {}, s);
                        X(t1.rotation, o) && X(t1.scale, a) && X(t1.translation, l) || (this.evaluate(t1, t1.featureStates, r, !0), e = !0);
                    }
                }
                return e;
            }
            updateReplacement(e, t1, r, n) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e.toUnwrapped(), !0);
                if (Ld(this.activeReplacements, i)) return !1;
                this.activeReplacements = i;
                let s = !1;
                for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1], o = i.instancedDataArray;
                    for (const t1 of i.features){
                        const i = t1.instancedDataOffset, a = t1.instancedDataCount;
                        for(let t1 = 0; t1 < a; t1++){
                            const a = 16 * (t1 + i);
                            let l = o.float32[a + 0];
                            const u = l > Un;
                            l = u ? l - Un : l;
                            const c = Math.floor(l), h = Math.floor(o.float32[a + 1]);
                            let p = !1;
                            for (const t1 of this.activeReplacements)if (!Fd(t1, r, Fb.Model, n) && !(t1.min.x > c || c > t1.max.x || t1.min.y > h || h > t1.max.y) && (p = $d(Gd(c, h, e.canonical, t1.footprintTileId.canonical), t1.footprint), p)) break;
                            o.float32[a] = p ? l + Un : l, s = s || p !== u;
                        }
                    }
                }
                return s;
            }
            isEmpty() {
                for(const e in this.instancesPerModel)if (0 !== this.instancesPerModel[e].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e) {
                if (!this.uploaded) for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    r.instancedDataArray.length < 0 || 0 === r.instancedDataArray.length || (r.instancedDataBuffer ? r.instancedDataBuffer.updateData(r.instancedDataArray) : r.instancedDataBuffer = e.createVertexBuffer(r.instancedDataArray, Um.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy(e) {
                for(const e in this.instancesPerModel){
                    const t1 = this.instancesPerModel[e];
                    0 !== t1.instancedDataArray.length && t1.instancedDataBuffer && t1.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (e && t1 && this.modelUris && this.modelsRequested) for (const e of this.modelUris)t1.removeModel(e, "", !0);
            }
            addFeature(e, t1, r, n, i) {
                const s = this.layers[0], o = s.layout.get("model-id"), a = s.layout.get("model-allow-density-reduction"), l = o.evaluate(r, {}, this.canonical);
                if (!l) return Ze(`modelId is not evaluated for layer ${s.id} and it is not going to get rendered.`), l;
                (Cb(l, !1) || void 0 !== this.styleDefinedModelURLs[l]) && (this.modelUris.includes(l) || this.modelUris.push(l)), this.instancesPerModel[l] || (this.instancesPerModel[l] = new Lb);
                const u = this.instancesPerModel[l], c = u.instancedDataArray, h = new Rb(r, c.length);
                let p;
                n && (p = _c.getElevationFeature(e, n));
                for (const e of t1)for (const t1 of e){
                    if (t1.x < 0 || t1.x >= Un || t1.y < 0 || t1.y >= Un) continue;
                    if (0 !== this.lookupDim && a) {
                        const e = (this.lookupDim - 1) / Un, r = this.lookupDim * (t1.y * e | 0) + t1.x * e | 0;
                        if (this.lookup) {
                            if (0 !== this.lookup[r]) continue;
                            this.lookup[r] = 1;
                        }
                    }
                    this.instanceCount++;
                    const e = c.length;
                    if (c.resize(e + 1), n) {
                        u.instancesRoadElevation || (u.instancesRoadElevation = []);
                        const e = p ? p.pointElevation(new Ie(t1.x, t1.y)) : 0;
                        u.instancesRoadElevation.push(e);
                    }
                    u.instancesEvaluatedElevation.push(0), c.float32[16 * e] = t1.x, c.float32[16 * e + 1] = t1.y;
                }
                return h.instancedDataCount = u.instancedDataArray.length - h.instancedDataOffset, h.instancedDataCount > 0 && (e.id && (u.idToFeaturesIndex[e.id] = u.features.length), u.features.push(h), this.evaluate(h, {}, u, !1)), l;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(e, t1, r, n) {
                const i = this.layers[0], s = e.feature, o = this.canonical, a = e.rotation = i.paint.get("model-rotation").evaluate(s, t1, o), l = e.scale = i.paint.get("model-scale").evaluate(s, t1, o), u = e.translation = i.paint.get("model-translation").evaluate(s, t1, o), c = Object.assign({}, i.paint.get("model-color").evaluate(s, t1, o));
                c.a = i.paint.get("model-color-mix-intensity").evaluate(s, t1, o);
                const h = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]);
                const p = u[0] * u[0] + u[1] * u[1], d = p > 0 ? Math.sqrt(p) : 0;
                r.maxScale = Math.max(Math.max(r.maxScale, l[0]), Math.max(l[1], l[2])), r.maxXYTranslationDistance = Math.max(r.maxXYTranslationDistance, d), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Zm(h, a, l);
                const f = Math.round(100 * c.a) + c.b / 1.05;
                for(let t1 = 0; t1 < e.instancedDataCount; ++t1){
                    const i = e.instancedDataOffset + t1, s = 16 * i, a = r.instancedDataArray.float32;
                    let l = 0;
                    n && (l = a[s + 6] - r.instancesEvaluatedElevation[i]);
                    const p = 0 | a[s + 1];
                    a[s] = (0 | a[s]) + c.r / 1.05, a[s + 1] = p + c.g / 1.05, a[s + 2] = f, a[s + 3] = 1 / (o.z > 10 ? this.tileToMeter : Uu(o, p)), a[s + 4] = u[0], a[s + 5] = u[1], a[s + 6] = u[2] + (r.instancesRoadElevation ? r.instancesRoadElevation[i] : 0) + l, a[s + 7] = h[0], a[s + 8] = h[1], a[s + 9] = h[2], a[s + 10] = h[4], a[s + 11] = h[5], a[s + 12] = h[6], a[s + 13] = h[8], a[s + 14] = h[9], a[s + 15] = h[10], r.instancesEvaluatedElevation[i] = u[2];
                }
            }
        }
        let Ub, Nb;
        Js(Ob, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), Js(Lb, "PerModelAttributes"), Js(Rb, "ModelFeature");
        class jb {
            constructor(e, t1, r){
                this._demTile = e, this._dem = this._demTile.dem, this._scale = t1, this._offset = r;
            }
            static create(e, t1, r) {
                const n = r || e.findDEMTileFor(t1);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, o = 1 << t1.canonical.z - s.canonical.z;
                return new jb(n, i.dim / Un / o, [
                    (t1.canonical.x / o - s.canonical.x) * i.dim,
                    (t1.canonical.y / o - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(e, t1) {
                const r = t1 * this._scale + this._offset[1];
                return new Ie(Math.floor(e * this._scale + this._offset[0]), Math.floor(r));
            }
            getElevationAt(e, t1, r, n) {
                const i = e * this._scale + this._offset[0], s = t1 * this._scale + this._offset[1], o = Math.floor(i), a = Math.floor(s), l = this._dem;
                return n = !!n, r ? hr(hr(l.get(o, a, n), l.get(o, a + 1, n), s - a), hr(l.get(o + 1, a, n), l.get(o + 1, a + 1, n), s - a), i - o) : l.get(o, a, n);
            }
            getElevationAtPixel(e, t1, r) {
                return this._dem.get(e, t1, !!r);
            }
            getMeterToDEM(e) {
                return (1 << this._demTile.tileID.canonical.z) * Vu(1, e) * this._dem.stride;
            }
        }
        const Gb = new Float32Array(262144), $b = new Uint8Array(262144);
        function qb(e) {
            let t1 = 0;
            if (e.meshes) for (const r of e.meshes)t1 = Math.max(t1, r.aabb.max[2]);
            if (e.children) for (const r of e.children)t1 = Math.max(t1, qb(r));
            return t1;
        }
        function Xb(e, t1, r) {
            if (e.meshes) for (const n of e.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const i = vc.applyTransform(n.aabb, e.globalMatrix);
                r.insert(t1, i.min[0], i.min[1], i.max[0], i.max[1]);
            }
            if (e.children) for (const n of e.children)Xb(n, t1, r);
        }
        const Hb = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class Zb {
            constructor(e){
                this.node = e, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedTranslation = [
                    0,
                    0,
                    0
                ], this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = {
                    type: "Point",
                    id: e.id,
                    geometry: [],
                    properties: {
                        height: qb(e)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new vc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let e = 0;
                    const t1 = new vc([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const r of this.node.meshes)this.node.lightMeshIndex !== e && (r.transformedAabb = vc.applyTransformFast(r.aabb, this.node.globalMatrix), t1.encapsulate(r.transformedAabb)), e++;
                    this.aabb = t1;
                }
                return this.aabb;
            }
        }
        class Wb {
            constructor(e, t1, r, n, i, s, o, a){
                this.id = r, this.layers = e, this.layerIds = this.layers.map((e)=>e.fqid), this.stateDependentLayerIds = this.layers.filter((e)=>e.isStateDependent()).map((e)=>e.id), this.modelTraits |= Qm.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= Qm.HasMapboxMeshFeatures), i && (this.modelTraits |= Qm.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = s, this.worldview = a, this.dirty = !0, this.needsUpload = !1, this.filter = null, this.nodesInfo = [];
                for (const e of t1)this.nodesInfo.push(new Zb(e)), Xb(e, o.featureIndexArray.length, o.grid), o.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, o.bucketLayerIDs.length - 1, 0);
                this.states = {}, this.hasAppearances = null;
            }
            updateFootprints(e, t1) {
                for (const r of this.getNodesInfo()){
                    const n = r.node;
                    n.footprint && t1.push({
                        footprint: n.footprint,
                        id: e
                    });
                }
            }
            updateAppearances(e, t1, r, n) {}
            update(e) {
                const t1 = 0 !== Object.keys(e).length;
                if (t1 && !this.stateDependentLayers.length) return;
                const r = t1 ? this.stateDependentLayers : this.layers;
                if (!Se(e, this.states)) for (const t1 of r)this.evaluate(t1, e);
                this.states = structuredClone(e);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(e) {
                if (!this.needsUpload) return;
                const t1 = this.getNodesInfo();
                for (const r of t1){
                    const t1 = r.node;
                    this.uploaded ? this.updatePbrBuffer(t1) : iy(t1, e, !0);
                }
                for (const e of t1)sy(e.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(e) {
                let t1 = !1;
                if (!e.meshes) return t1;
                for (const r of e.meshes)r.pbrBuffer && (r.pbrBuffer.updateData(r.featureArray), t1 = !0);
                return t1;
            }
            needsReEvaluation(e, t1, r) {
                const n = e.transform.projectionOptions, i = e.style.getBrightness(), s = this.brightness !== i;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || Yb(r.paint.get("model-color").value, s) || Yb(r.paint.get("model-color-mix-intensity").value, s) || Yb(r.paint.get("model-roughness").value, s) || Yb(r.paint.get("model-emissive-strength").value, s) || Yb(r.paint.get("model-height-based-emissive-strength-multiplier").value, s)) {
                    this.projection = n, this.brightness = i;
                    const e = this.getNodesInfo();
                    for (const t1 of e)t1.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateTransform(e, t1) {
                if (e.transform.zoom === this.zoom) return;
                this.zoom = e.transform.zoom;
                const r = this.getNodesInfo(), n = this.id.canonical;
                for (const e of r){
                    const r = e.feature;
                    e.evaluatedTranslation = t1.paint.get("model-translation").evaluate(r, {}, n), e.evaluatedScale = t1.paint.get("model-scale").evaluate(r, {}, n);
                }
            }
            evaluate(e, t1) {
                const r = this.getNodesInfo();
                for (const n of r){
                    if (!n.node.meshes) continue;
                    const r = n.feature, i = t1 && t1[r.id];
                    if (Se(i, n.state)) continue;
                    n.state = structuredClone(i);
                    const s = n.node.meshes && n.node.meshes[0].featureData, o = n.evaluatedColor[2], a = n.evaluatedRMEA[2], l = this.id.canonical;
                    if (n.hasTranslucentParts = !1, s) {
                        for(let t1 = 0; t1 < Hb.length; t1++){
                            const s = Hb[t1];
                            s.length && (r.properties.part = s);
                            const o = e.paint.get("model-color").evaluate(r, i, l).toPremultipliedRenderColor(null), a = e.paint.get("model-color-mix-intensity").evaluate(r, i, l);
                            n.evaluatedColor[t1] = [
                                o.r,
                                o.g,
                                o.b,
                                a
                            ], n.evaluatedRMEA[t1][0] = e.paint.get("model-roughness").evaluate(r, i, l), n.evaluatedRMEA[t1][2] = e.paint.get("model-emissive-strength").evaluate(r, i, l), n.evaluatedRMEA[t1][3] = o.a, n.emissionHeightBasedParams[t1] = e.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r, i, l), !n.hasTranslucentParts && o.a < 1 && (n.hasTranslucentParts = !0);
                        }
                        delete r.properties.part, Kb(n, o !== n.evaluatedColor[2] || a !== n.evaluatedRMEA[2], this.modelTraits);
                    } else n.evaluatedRMEA[0][2] = e.paint.get("model-emissive-strength").evaluate(r, i, l);
                    n.evaluatedTranslation = e.paint.get("model-translation").evaluate(r, i, l), n.evaluatedScale = e.paint.get("model-scale").evaluate(r, i, l), this.updatePbrBuffer(n.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(e, t1, r, n) {
                const i = e.findDEMTileFor(r);
                if (i && (i.tileID.canonical !== this.terrainTile || t1 !== this.terrainExaggeration)) {
                    if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = i.tileID.overscaledZ;
                        const t1 = jb.create(e, r, i);
                        if (!t1) return;
                        this.modelTraits & Qm.HasMapboxMeshFeatures && this.updateDEM(e, t1, r, n);
                        for (const e of this.getNodesInfo()){
                            const r = e.node;
                            if (!r.footprint || !r.footprint.vertices || !r.footprint.vertices.length) continue;
                            const n = r.footprint.vertices;
                            let i = t1.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let e = 1; e < n.length; e++)i = Math.min(i, t1.getElevationAt(n[e].x, n[e].y, !0, !0));
                            r.elevation = i;
                        }
                    }
                    this.terrainTile = i.tileID.canonical, this.terrainExaggeration = t1;
                }
            }
            updateDEM(e, t1, r, n) {
                let i = t1._dem._modifiedForSources[n];
                if (void 0 === i && (t1._dem._modifiedForSources[n] = [], i = t1._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
                const s = t1._dem.dim;
                i.push(r.canonical);
                let o = !1;
                for (const e of this.getNodesInfo()){
                    const r = e.node;
                    if (!r.footprint || !r.footprint.grid) continue;
                    const n = r.footprint.grid, i = t1.tileCoordToPixel(n.min.x, n.min.y), a = t1.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(s - a.y, i.x), Math.min(i.y, s - a.x));
                    if (l < 0) continue;
                    const u = De(l, 2, 5);
                    let c = Math.max(0, i.x - u), h = Math.max(0, i.y - u), p = Math.min(a.x + u, s - 1), d = Math.min(a.y + u, s - 1);
                    for(let e = h; e <= d; ++e)for(let t1 = c; t1 <= p; ++t1)$b[e * s + t1] = 255;
                    let f = 0, m = 0;
                    for(let e = 0; e < n.cellsY; ++e)for(let r = 0; r < n.cellsX; ++r){
                        if (!n.cells[e * n.cellsX + r]) continue;
                        const i = t1.tileCoordToPixel(n.min.x + r / n.xScale, n.min.y + e / n.yScale), o = t1.tileCoordToPixel(n.min.x + (r + 1) / n.xScale, n.min.y + (e + 1) / n.yScale);
                        for(let e = i.y; e <= Math.min(o.y + 1, s - 1); ++e)for(let r = i.x; r <= Math.min(o.x + 1, s - 1); ++r)255 === $b[e * s + r] && ($b[e * s + r] = 0, f += t1.getElevationAtPixel(r, e), m++);
                    }
                    const y = f / m;
                    c = Math.max(1, i.x - u), h = Math.max(1, i.y - u), p = Math.min(a.x + u, s - 2), d = Math.min(a.y + u, s - 2), o = !0;
                    for(let e = h; e <= d; ++e)for(let r = c; r <= p; ++r)0 === $b[e * s + r] && (Gb[e * s + r] = t1._dem.set(r, e, y));
                    for(let e = 1; e < u; ++e){
                        c = Math.max(1, i.x - e), h = Math.max(1, i.y - e), p = Math.min(a.x + e, s - 2), d = Math.min(a.y + e, s - 2);
                        for(let r = h; r <= d; ++r)for(let n = c; n <= p; ++n){
                            const i = r * s + n;
                            if (255 === $b[i]) {
                                let o = 0, a = 0, l = -1, c = -1;
                                for(let t1 = -1; t1 <= 1; ++t1)for(let i = -1; i <= 1; ++i){
                                    const u = (r + t1) * s + n + i;
                                    if ($b[u] >= e) continue;
                                    const h = Gb[u], p = Math.abs(h);
                                    p > a && (o = h, a = p, l = i, c = t1);
                                }
                                if (a > .1) {
                                    const s = 1 - (e + .5 * Math.abs(l * c)) / u;
                                    let a = t1._dem.get(n, r) + o * s;
                                    const h = t1._dem.get(n + l, r + c), p = t1._dem.get(n - l, r - c, !0);
                                    (a - h) * (a - p) > 0 && (a = (h + p) / 2), Gb[i] = t1._dem.set(n, r, a), $b[i] = e;
                                }
                            }
                        }
                    }
                }
                o && (t1._demTile.needsDEMTextureUpload = !0, t1._dem._timestamp = gt.now());
            }
            setFilter(e) {
                this.filter = e ? da(e) : null;
            }
            getNodesInfo() {
                return this.filter ? this.nodesInfo.filter((e)=>this.filter.filter(new Yo(this.id.overscaledZ, {
                        worldview: this.worldview
                    }), e.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
                const e = this.getNodesInfo();
                for (const t1 of e)sy(t1.node), ay(t1.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(e, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e.toUnwrapped());
                for (const e of this.getNodesInfo()){
                    const t1 = e.node.footprint;
                    e.hiddenByReplacement = !!t1 && !r.find((e)=>e.footprint === t1);
                }
            }
            getHeightAtTileCoord(e, t1) {
                const r = [], n = [
                    0,
                    0,
                    0
                ], i = u([]);
                for (const s of this.getNodesInfo()){
                    const o = s.node.meshes[0], a = o.transformedAabb;
                    if (e < a.min[0] || t1 < a.min[1] || e > a.max[0] || t1 > a.max[1]) continue;
                    if (!0 === s.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: s.feature.properties.height,
                        hidden: !1,
                        verticalScale: s.evaluatedScale[2]
                    };
                    c(i, s.node.globalMatrix), n[0] = e, n[1] = t1, j(n, n, i);
                    const l = (n[0] - o.aabb.min[0]) / (o.aabb.max[0] - o.aabb.min[0]) * Km | 0, u = Math.min(63, (n[1] - o.aabb.min[1]) / (o.aabb.max[1] - o.aabb.min[1]) * Km | 0) * Km + Math.min(63, l), h = o.heightmap[u];
                    if (!(h < 0 && s.node.footprint)) {
                        if (s.hiddenByReplacement) return;
                        return {
                            height: h,
                            maxHeight: s.feature.properties.height,
                            hidden: !1,
                            verticalScale: s.evaluatedScale[2]
                        };
                    }
                    if (s.node.footprint.grid.query(new Ie(e, t1), new Ie(e, t1), r), r.length > 0) return {
                        height: void 0,
                        maxHeight: s.feature.properties.height,
                        hidden: s.hiddenByReplacement,
                        verticalScale: s.evaluatedScale[2]
                    };
                }
            }
        }
        function Yb(e, t1) {
            return e instanceof Ns && !e.isLightConstant && t1;
        }
        function Jb(e, t1, r, n, i, s, o, a) {
            let l = (61440 & t1 | (61440 & t1) >> 4) >> 8, u = (3840 & t1 | (3840 & t1) >> 4) >> 4, c = 240 & t1 | (240 & t1) >> 4;
            r[3] > 0 && (l = hr(l, 255 * r[0], r[3]), u = hr(u, 255 * r[1], r[3]), c = hr(c, 255 * r[2], r[3]));
            const h = l << 8 | u, p = c << 8 | Math.floor(255 * n[3]), d = function(e) {
                const t1 = De(e, 0, 2);
                return Math.min(Math.round(.5 * t1 * 255), 255);
            }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1], f = De(i[0], 0, 1), m = De(i[1], 0, 1), y = De(i[2], 0, 1), g = De(i[3], 0, 1);
            let x, v, b, w;
            if (f !== m && o !== s && m !== f) {
                const e = o - s;
                v = 1 / (e * (m - f)), b = -(s + e * f) / (e * (m - f));
                const t1 = De(i[4], -1, 1);
                w = Math.pow(10, t1), x = 255 * y << 8 | 255 * g;
            } else x = 65535, v = 0, b = 1, w = 1;
            if (e.emplaceBack(h, p, d, x, v, b, w), a) {
                const e = a.length;
                a.clear();
                for(let t1 = 0; t1 < e; t1++)a.emplaceBack(h, p, d, x, v, b, w);
            }
        }
        function Kb(e, t1, r) {
            const n = e.node;
            let i = 0;
            const s = r & Qm.HasMeshoptCompression;
            for (const r of n.meshes){
                if (n.lights && n.lightMeshIndex === i) continue;
                if (!r.featureData) continue;
                r.featureArray = new xl, r.featureArray.reserve(r.featureData.length);
                let o = t1;
                for (const t1 of r.featureData){
                    const i = s ? 65535 & t1 : t1 >> 16 & 65535, a = s ? t1 >> 16 & 65535 : 65535 & t1, l = (15 & a) < 8 ? 15 & a : 0, u = e.evaluatedRMEA[l], c = e.evaluatedColor[l], h = e.emissionHeightBasedParams[l];
                    let p;
                    if (o && 2 === l && n.lights && (p = new xl, p.resize(10 * n.lights.length)), Jb(r.featureArray, i, c, u, h, r.aabb.min[2], r.aabb.max[2], p), p && o) {
                        o = !1;
                        const e = n.meshes[n.lightMeshIndex];
                        e.featureArray = p, e.featureArray._trim();
                    }
                }
                r.featureArray._trim(), i++;
            }
        }
        Js(Wb, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), Js(Zb, "Tiled3dModelFeature");
        const Qb = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class ew {
            constructor(e, t1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = e, this._z = t1, this._x = r, this._y = n, this.properties = e ? e.properties : {}, this.id = i;
            }
            clone() {
                const e = new ew(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (e.state = Object.assign({}, this.state)), this.layer && (e.layer = Object.assign({}, this.layer)), this.source && (e.source = this.source), this.sourceLayer && (e.sourceLayer = this.sourceLayer), e;
            }
            get geometry() {
                return void 0 === this._geometry && this._vectorTileFeature && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e) {
                this._geometry = e;
            }
            toJSON() {
                const e = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const t1 of Qb)void 0 !== this[t1] && (e[t1] = this[t1]);
                return e;
            }
        }
        class tw extends rr {
            constructor(e, t1, r, n){
                super(), this.id = e, this.type = "model", this.models = [], this._options = t1, this._modelsInfo = new Map, this._abortController = null;
            }
            cancelModelRequests() {
                this._abortController && (this._abortController.abort(), this._abortController = null);
            }
            loadGLTFFromURI(e, t1) {
                return Tm(this.map._requestManager.transformRequest(e, Dt.Model).url, t1);
            }
            async loadModel(e, t1, r) {
                try {
                    const n = await this.loadGLTFFromURI(t1.uri, r);
                    if (r.aborted) return;
                    const i = this._modelsInfo.get(e);
                    if (!i) return;
                    const s = my(n), o = i.modelSpec, a = new ty(e, o.uri, o.position, o.orientation, s);
                    tw.applyModelSpecification(a, o), a.computeBoundsAndApplyParent(), this.models.push(a), i.model = a;
                } catch (r) {
                    if (r instanceof Error && "AbortError" === r.name) return;
                    const n = r instanceof Error ? r.message : "Unknown error";
                    this.fire(new Qt(new Error(`Could not load model ${e} from ${t1.uri}: ${n}`)));
                }
            }
            async load() {
                this._abortController || (this._abortController = new AbortController);
                const e = this._abortController.signal, t1 = [];
                for(const r in this._options.models){
                    const n = this._options.models[r], i = this._modelsInfo.get(r);
                    if (i && i.model) {
                        i.modelSpec = n;
                        const e = i.model;
                        e.position = null != n.position ? new zu(n.position[0], n.position[1]) : new zu(0, 0), e.orientation = null != n.orientation ? n.orientation : [
                            0,
                            0,
                            0
                        ], tw.applyModelSpecification(e, n), e.computeBoundsAndApplyParent(), this.models.push(e);
                    } else i ? i.modelSpec = n : (this._modelsInfo.set(r, {
                        modelSpec: n,
                        model: null
                    }), t1.push(this.loadModel(r, n, e)));
                }
                0 !== t1.length ? (await Promise.allSettled(t1), e.aborted || this.fire(new Kt("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }))) : this.loaded() && this.fire(new Kt("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }));
            }
            static applyModelSpecification(e, t1) {
                t1.nodeOverrides && tw.convertNodeOverrides(e, t1.nodeOverrides), t1.materialOverrides && tw.convertMaterialOverrides(e, t1.materialOverrides), t1.nodeOverrideNames && (e.nodeOverrideNames = [
                    ...t1.nodeOverrideNames
                ]), t1.materialOverrideNames && (e.materialOverrideNames = [
                    ...t1.materialOverrideNames
                ]), t1.featureProperties && (e.featureProperties = t1.featureProperties);
            }
            static convertNodeOverrides(e, t1) {
                if (Array.isArray(t1) && t1.every((e)=>"string" == typeof e)) {
                    e.nodeOverrideNames = [];
                    for (const r of t1)e.nodeOverrideNames.push(r);
                } else Object.entries(t1).forEach(([t1, r])=>{
                    const n = {
                        orientation: [
                            0,
                            0,
                            0
                        ]
                    };
                    if (r.hasOwnProperty("orientation")) {
                        const e = r.orientation;
                        e && (n.orientation = e);
                    }
                    e.nodeOverrides.set(t1, n);
                });
            }
            static convertMaterialOverrides(e, t1) {
                if (Array.isArray(t1) && t1.every((e)=>"string" == typeof e)) {
                    e.materialOverrideNames = [];
                    for (const r of t1)e.materialOverrideNames.push(r);
                } else Object.entries(t1).forEach(([t1, r])=>{
                    const n = {
                        color: new ar(1, 1, 1),
                        colorMix: 0,
                        emissionStrength: 0,
                        opacity: 1
                    }, i = r["model-color"];
                    void 0 !== i && (n.color.r = i[0], n.color.g = i[1], n.color.b = i[2]);
                    const s = r["model-color-mix-intensity"];
                    void 0 !== s && (n.colorMix = s);
                    const o = r["model-emissive-strength"];
                    void 0 !== o && (n.emissionStrength = o);
                    const a = r["model-opacity"];
                    void 0 !== a && (n.opacity = a), e.materialOverrides.set(t1, n);
                });
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            hasTransition() {
                return !1;
            }
            loaded() {
                if (0 === this._modelsInfo.size) return !0;
                for (const e of this._modelsInfo.values())if (null == e.model) return !1;
                return !0;
            }
            getModels() {
                return this.models;
            }
            loadTile(e, t1) {}
            serialize() {
                return this._options;
            }
            setProperty(e, t1) {
                return !1;
            }
            reload() {
                this.cancelModelRequests();
                const e = Sa(this.id, this.scope);
                this.map.style.clearSource(e), this.models = [], this._modelsInfo.clear(), this.load();
            }
            onRemove(e) {
                this.cancelModelRequests();
            }
            setModels(e) {
                this.models = [];
                const t1 = new Map;
                for(const r in e){
                    const n = e[r], i = this._modelsInfo.get(r);
                    i && i.modelSpec.uri === n.uri && t1.set(r, i);
                }
                if (this._modelsInfo.size !== t1.size) {
                    this.cancelModelRequests();
                    for (const [e, r] of t1)r.model || t1.delete(e);
                }
                this._modelsInfo = t1, this._options.models = e, this.load();
            }
        }
        function rw(e, t1, r, n) {
            const i = 1 << e.z;
            t1.lat = Fu((n / Un + e.y) / i), t1.lng = Eu((r / Un + e.x) / i);
        }
        function nw(e, t1, r, n) {
            const i = e.getNodesInfo()[t1];
            if (!i || i.hiddenByReplacement || !i.node.meshes) return;
            let s = Number.MAX_VALUE;
            const o = i.node, a = r.tile, l = n.calculatePosMatrix(a.tileID.toUnwrapped(), n.worldSize), u = i.evaluatedScale;
            let c = 0;
            n.elevation && o.elevation && (c = o.elevation * n.elevation.exaggeration()), p(l, l, [
                (o.anchor ? o.anchor[0] : 0) * (u[0] - 1),
                (o.anchor ? o.anchor[1] : 0) * (u[1] - 1),
                c
            ]), d(l, l, u);
            const f = r.queryGeometry, m = f.isPointQuery() ? f.screenBounds : f.screenGeometry, y = function(e) {
                const t1 = h([], l, e.globalMatrix);
                h(t1, n.expandedFarZProjMatrix, t1);
                for(let r = 0; r < e.meshes.length; ++r){
                    const i = e.meshes[r];
                    if (r === e.lightMeshIndex) continue;
                    const o = Jm(m, n, t1, i.aabb);
                    null != o && (s = Math.min(o, s));
                }
                if (e.children) for (const t1 of e.children)y(t1);
            };
            if (y(o), s === Number.MAX_VALUE) return;
            const g = new zu(0, 0);
            return rw(a.tileID.canonical, g, i.node.anchor[0], i.node.anchor[1]), {
                intersectionZ: s,
                position: g,
                feature: i.feature
            };
        }
        const iw = {
            circle: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: qc || (qc = new la({
                            "circle-sort-key": new oa(ua.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new sa(ua.layout_circle["circle-elevation-reference"]),
                            visibility: new sa(ua.layout_circle.visibility)
                        })),
                        paint: Xc || (Xc = new la({
                            "circle-radius": new oa(ua.paint_circle["circle-radius"]),
                            "circle-color": new oa(ua.paint_circle["circle-color"]),
                            "circle-blur": new oa(ua.paint_circle["circle-blur"]),
                            "circle-opacity": new oa(ua.paint_circle["circle-opacity"]),
                            "circle-translate": new sa(ua.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new sa(ua.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new sa(ua.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new sa(ua.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new oa(ua.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new oa(ua.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new oa(ua.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new sa(ua.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                createBucket(e) {
                    return new Mc(e);
                }
                queryRadius(e) {
                    const t1 = e;
                    return Nc("circle-radius", this, t1) + Nc("circle-stroke-width", this, t1) + jc(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e, t1, r, n, i, s, o, a) {
                    const l = $c(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, e.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(t1, r) + this.paint.get("circle-stroke-width").evaluate(t1, r);
                    return Bh(e, n, s, o, a, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e, t1, r) {
                    const n = Ph(this);
                    return {
                        config: new hu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                is3D(e) {
                    return !e && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
            },
            heatmap: class extends Va {
                createBucket(e) {
                    return new Fh(e);
                }
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Dh || (Dh = new la({
                            visibility: new sa(ua.layout_heatmap.visibility)
                        })),
                        paint: Ch || (Ch = new la({
                            "heatmap-radius": new oa(ua.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new oa(ua.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new sa(ua.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new aa(ua.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new sa(ua.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e) {
                    "heatmap-color" === e && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = qh({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                _clear() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                queryRadius(e) {
                    return Nc("heatmap-radius", this, e);
                }
                queryIntersectsFeature(e, t1, r, n, i, s, o, a) {
                    const l = this.paint.get("heatmap-radius").evaluate(t1, r);
                    return Bh(e, n, s, o, a, !0, !0, new Ie(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e, t1, r) {
                    return "heatmap" === e ? {
                        config: new hu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Rh || (Rh = new la({
                            visibility: new sa(ua.layout_hillshade.visibility)
                        })),
                        paint: Lh || (Lh = new la({
                            "hillshade-illumination-direction": new sa(ua.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new sa(ua.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new sa(ua.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new sa(ua.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new sa(ua.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new sa(ua.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new sa(ua.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e, t1, r) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: gd || (gd = new la({
                            "fill-sort-key": new oa(ua.layout_fill["fill-sort-key"]),
                            visibility: new sa(ua.layout_fill.visibility),
                            "fill-elevation-reference": new sa(ua.layout_fill["fill-elevation-reference"]),
                            "fill-construct-bridge-guard-rail": new oa(ua.layout_fill["fill-construct-bridge-guard-rail"])
                        })),
                        paint: xd || (xd = new la({
                            "fill-antialias": new sa(ua.paint_fill["fill-antialias"]),
                            "fill-opacity": new oa(ua.paint_fill["fill-opacity"]),
                            "fill-color": new oa(ua.paint_fill["fill-color"]),
                            "fill-outline-color": new oa(ua.paint_fill["fill-outline-color"]),
                            "fill-translate": new sa(ua.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new sa(ua.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new oa(ua.paint_fill["fill-pattern"]),
                            "fill-pattern-cross-fade": new sa(ua.paint_fill["fill-pattern-cross-fade"]),
                            "fill-emissive-strength": new sa(ua.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new oa(ua.paint_fill["fill-z-offset"]),
                            "fill-bridge-guard-rail-color": new oa(ua.paint_fill["fill-bridge-guard-rail-color"]),
                            "fill-tunnel-structure-color": new oa(ua.paint_fill["fill-tunnel-structure-color"]),
                            "fill-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-bridge-guard-rail-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-tunnel-structure-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                getProgramIds() {
                    const e = this.paint.get("fill-pattern"), t1 = e && e.constantOr(1), r = [
                        t1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(t1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getDefaultProgramParams(e, t1, r) {
                    return {
                        config: new hu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(e, t1) {
                    super.recalculate(e, t1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e) {
                    return new yd(e);
                }
                queryRadius() {
                    return jc(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e, t1, r, n, i, s) {
                    return !e.queryGeometry.isAboveHorizon && zc(Gc(e.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, e.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return 0 === this.paint.get("fill-z-offset").constantOr(1);
                }
                is3D(e) {
                    if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return !0;
                    const t1 = this.layout && "none" !== this.layout.get("fill-elevation-reference");
                    return null != e ? t1 && !e : t1;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
                hasShadowPass() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
            },
            "fill-extrusion": class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Mf || (Mf = new la({
                            visibility: new sa(ua["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new sa(ua["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
                        })),
                        paint: If || (If = new la({
                            "fill-extrusion-opacity": new sa(ua["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new oa(ua["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new sa(ua["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new sa(ua["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new oa(ua["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-pattern-cross-fade": new sa(ua["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]),
                            "fill-extrusion-height": new oa(ua["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new oa(ua["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new sa(ua["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new sa(ua["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new sa(ua["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new sa(ua["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new sa(ua["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new sa(ua["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new sa(ua["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new sa(ua["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new sa(ua["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new sa(ua["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new oa(ua["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new oa(ua["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new sa(ua["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new sa(ua["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new sa(ua["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new sa(ua["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-emissive-strength": new oa(ua["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new oa(ua["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new sa(ua["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e) {
                    return new pf(e);
                }
                queryRadius() {
                    return jc(this.paint.get("fill-extrusion-translate"));
                }
                is3D(e) {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e, t1, r, n, i, s, o, a, l) {
                    const u = $c(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, e.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(t1, r), h = this.paint.get("fill-extrusion-base").evaluate(t1, r), p = [
                        0,
                        0
                    ], d = a && s.elevation, f = s.elevation ? s.elevation.exaggeration() : 1, m = e.tile.getBucket(this);
                    if (d && m instanceof pf) {
                        const e = m.centroidVertexArray, t1 = l + 1;
                        t1 < e.length && (p[0] = e.geta_centroid_pos0(t1), p[1] = e.geta_centroid_pos1(t1));
                    }
                    if (0 === p[0] && 1 === p[1]) return !1;
                    "globe" === s.projection.name && (n = _f([
                        n
                    ], [
                        new Ie(0, 0),
                        new Ie(Un, Un)
                    ], e.tileID.canonical).map((e)=>e.polygon).flat());
                    const y = d ? a : null, [g, x] = Cf(s, n, h, c, u, o, y, p, f, s.center.lat, e.tileID.canonical), v = e.queryGeometry;
                    return Df(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
            },
            building: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Ry || (Ry = new la({
                            visibility: new sa(ua.layout_building.visibility),
                            "building-facade": new oa(ua.layout_building["building-facade"]),
                            "building-facade-floors": new oa(ua.layout_building["building-facade-floors"]),
                            "building-facade-unit-width": new oa(ua.layout_building["building-facade-unit-width"]),
                            "building-facade-window": new oa(ua.layout_building["building-facade-window"]),
                            "building-roof-shape": new oa(ua.layout_building["building-roof-shape"]),
                            "building-height": new oa(ua.layout_building["building-height"]),
                            "building-base": new oa(ua.layout_building["building-base"]),
                            "building-flood-light-wall-radius": new oa(ua.layout_building["building-flood-light-wall-radius"]),
                            "building-flood-light-ground-radius": new oa(ua.layout_building["building-flood-light-ground-radius"]),
                            "building-flip-roof-orientation": new oa(ua.layout_building["building-flip-roof-orientation"])
                        })),
                        paint: Ly || (Ly = new la({
                            "building-opacity": new sa(ua.paint_building["building-opacity"]),
                            "building-ambient-occlusion-intensity": new sa(ua.paint_building["building-ambient-occlusion-intensity"]),
                            "building-ambient-occlusion-ground-intensity": new sa(ua.paint_building["building-ambient-occlusion-ground-intensity"]),
                            "building-ambient-occlusion-ground-radius": new sa(ua.paint_building["building-ambient-occlusion-ground-radius"]),
                            "building-ambient-occlusion-ground-attenuation": new sa(ua.paint_building["building-ambient-occlusion-ground-attenuation"]),
                            "building-vertical-scale": new sa(ua.paint_building["building-vertical-scale"]),
                            "building-cast-shadows": new sa(ua.paint_building["building-cast-shadows"]),
                            "building-color": new oa(ua.paint_building["building-color"]),
                            "building-emissive-strength": new oa(ua.paint_building["building-emissive-strength"]),
                            "building-facade-emissive-chance": new sa(ua.paint_building["building-facade-emissive-chance"]),
                            "building-cutoff-fade-range": new sa(ua.paint_building["building-cutoff-fade-range"]),
                            "building-flood-light-color": new sa(ua.paint_building["building-flood-light-color"]),
                            "building-flood-light-intensity": new sa(ua.paint_building["building-flood-light-intensity"]),
                            "building-flood-light-ground-attenuation": new sa(ua.paint_building["building-flood-light-ground-attenuation"]),
                            "building-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "building-flood-light-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e) {
                    return new Fy(e);
                }
                cutoffRange() {
                    return this.paint.get("building-cutoff-fade-range");
                }
                hasShadowPass() {
                    return this.paint.get("building-cast-shadows");
                }
                hasLightBeamPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                is3D(e) {
                    return !0;
                }
                queryRadius(e) {
                    return 0;
                }
                queryIntersectsFeature(e, t1, r, n, i, s, o, a, l, u) {
                    let c = this.layout.get("building-height").evaluate(t1, r);
                    const h = this.layout.get("building-base").evaluate(t1, r), p = e.tile.getBucket(this).getFootprint(t1);
                    if (p) {
                        if (0 !== p.hiddenFlags) return !1;
                        c = p.height;
                    }
                    const [d, f] = Cf(s, n, h, c, new Ie(0, 0), o, null, [
                        0,
                        0
                    ], 1, s.center.lat, e.tileID.canonical), m = e.queryGeometry;
                    return Df(d, f, m.isPointQuery() ? m.screenBounds : m.screenGeometry);
                }
            },
            line: class extends Va {
                constructor(e, t1, r, n){
                    const i = lg();
                    super(e, i, t1, r, n), i.layout && (this.layout = new ia(i.layout)), this.gradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1;
                }
                _handleSpecialPaintPropertyUpdate(e) {
                    if ("line-gradient" === e) {
                        const e = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = e._styleExpression && e._styleExpression.expression instanceof Si, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                emissiveStrengthExpression() {
                    return this._transitionablePaint._values["line-emissive-strength"].value.expression;
                }
                recalculate(e, t1) {
                    super.recalculate(e, t1), this.paint._values["line-floorwidth"] = (()=>{
                        if (cg) return cg;
                        const e = lg();
                        return cg = new ug(e.paint.properties["line-width"].specification), cg.useIntegerZoom = !0, cg;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e);
                }
                createBucket(e) {
                    return new Jy(e);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(e, t1, r) {
                    const n = sg(this);
                    return {
                        config: new hu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(e) {
                    const t1 = e, r = hg(Nc("line-width", this, t1), Nc("line-gap-width", this, t1)), n = Nc("line-offset", this, t1);
                    return r / 2 + Math.abs(n) + jc(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e, t1, r, n, i, s) {
                    if (e.queryGeometry.isAboveHorizon) return !1;
                    const o = Gc(e.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, e.pixelToTileUnitsFactor), a = e.pixelToTileUnitsFactor / 2 * hg(this.paint.get("line-width").evaluate(t1, r), this.paint.get("line-gap-width").evaluate(t1, r)), l = this.paint.get("line-offset").evaluate(t1, r);
                    return l && (n = function(e, t1) {
                        const r = [], n = new Ie(0, 0);
                        for(let i = 0; i < e.length; i++){
                            const s = e[i], o = [];
                            for(let e = 0; e < s.length; e++){
                                const r = s[e], i = s[e + 1], a = 0 === e ? n : r.sub(s[e - 1])._unit()._perp(), l = e === s.length - 1 ? n : i.sub(r)._unit()._perp(), u = a._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), o.push(u._mult(t1)._add(r));
                            }
                            r.push(o);
                        }
                        return r;
                    }(n, l * e.pixelToTileUnitsFactor)), function(e, t1, r) {
                        for(let n = 0; n < t1.length; n++){
                            const i = t1[n];
                            if (e.length >= 3) {
                                for(let t1 = 0; t1 < i.length; t1++)if (Cc(e, i[t1])) return !0;
                            }
                            if (Pc(e, i, r)) return !0;
                        }
                        return !1;
                    }(o, n, a);
                }
                isTileClipped() {
                    return this.hasNonElevatedBuckets;
                }
                isDraped(e) {
                    return !this.hasElevatedBuckets || this.layout && "hd-road-markup" === this.layout.get("line-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("line-elevation-reference");
                }
            },
            symbol: db,
            background: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: fb || (fb = new la({
                            visibility: new sa(ua.layout_background.visibility)
                        })),
                        paint: mb || (mb = new la({
                            "background-pitch-alignment": new sa(ua.paint_background["background-pitch-alignment"]),
                            "background-color": new sa(ua.paint_background["background-color"]),
                            "background-pattern": new sa(ua.paint_background["background-pattern"]),
                            "background-opacity": new sa(ua.paint_background["background-opacity"]),
                            "background-emissive-strength": new sa(ua.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e, t1, r) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D(e) {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: Ib,
            "raster-particle": kb,
            sky: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Pb || (Pb = new la({
                            visibility: new sa(ua.layout_sky.visibility)
                        })),
                        paint: Bb || (Bb = new la({
                            "sky-type": new sa(ua.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new sa(ua.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new sa(ua.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new sa(ua.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new sa(ua.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new aa(ua.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new sa(ua.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new sa(ua.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new sa(ua.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._updateColorRamp();
                }
                _clear() {
                    this.skyboxFbo && (this.skyboxFbo.destroy(), this.skyboxFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this._skyboxInvalidated = !0;
                }
                _handleSpecialPaintPropertyUpdate(e) {
                    "sky-gradient" === e ? this._updateColorRamp() : "sky-atmosphere-sun" !== e && "sky-atmosphere-halo-color" !== e && "sky-atmosphere-color" !== e && "sky-atmosphere-sun-intensity" !== e || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = qh({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t1 = e.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t1.azimuthal || this._lightPosition.polar !== t1.polar;
                    }
                    return !1;
                }
                getCenter(e, t1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = e.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && Ze("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Eb(s.azimuthal, 90 - s.polar, t1) : Eb(r[0], 90 - r[1], t1);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return Eb(r[0], 90 - r[1], t1);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e) {
                    this._skyboxInvalidated = !1, this._lightPosition = e.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e = this.paint.get("sky-type");
                    return "atmosphere" === e ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        paint: Tb || (Tb = new la({}))
                    }, t1, null);
                }
            },
            model: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: Ub || (Ub = new la({
                            visibility: new sa(ua.layout_model.visibility),
                            "model-id": new oa(ua.layout_model["model-id"]),
                            "model-allow-density-reduction": new sa(ua.layout_model["model-allow-density-reduction"])
                        })),
                        paint: Nb || (Nb = new la({
                            "model-opacity": new oa(ua.paint_model["model-opacity"]),
                            "model-rotation": new oa(ua.paint_model["model-rotation"]),
                            "model-scale": new oa(ua.paint_model["model-scale"]),
                            "model-translation": new oa(ua.paint_model["model-translation"]),
                            "model-color": new oa(ua.paint_model["model-color"]),
                            "model-color-mix-intensity": new oa(ua.paint_model["model-color-mix-intensity"]),
                            "model-type": new sa(ua.paint_model["model-type"]),
                            "model-cast-shadows": new sa(ua.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new sa(ua.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new sa(ua.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new oa(ua.paint_model["model-emissive-strength"]),
                            "model-roughness": new oa(ua.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new oa(ua.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new sa(ua.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new sa(ua.paint_model["model-front-cutoff"]),
                            "model-elevation-reference": new sa(ua.paint_model["model-elevation-reference"]),
                            "model-color-use-theme": new oa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this.layer = e, this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e) {
                    return new Ob(e);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D(e) {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(e) {
                    return e instanceof Wb ? 8191 : 0;
                }
                queryRenderedFeatures(e, t1, r) {
                    const n = t1.getSource();
                    if (!(n && n instanceof tw)) return {};
                    const i = n, s = {};
                    s[this.id] = [];
                    const o = s[this.id];
                    let a = 0;
                    for (const n of i.models){
                        const i = t1.getFeatureState(this.sourceLayer, n.id), s = {
                            type: "Unknown",
                            id: n.id,
                            properties: n.featureProperties
                        }, l = this.paint.get("model-rotation").evaluate(s, i), u = this.paint.get("model-scale").evaluate(s, i), c = this.paint.get("model-translation").evaluate(s, i), p = this.paint.get("model-elevation-reference");
                        let d = [];
                        ey(d, n, r, n.position, l, u, c, "ground" === p, "ground" === p, !1), "globe" === r.projection.name && (d = Ym(d, r));
                        const f = h([], r.projMatrix, d), m = Jm(e.isPointQuery() ? e.screenBounds : e.screenGeometry, r, f, n.aabb);
                        if (null != m) {
                            const e = new ew(void 0, 0, 0, 0, n.id);
                            e.layer = this.layer, e.properties = structuredClone(n.featureProperties), e.properties.layer = this.id, e.properties.uri = n.uri, e.properties.orientation = n.orientation, e.sourceLayer = this.sourceLayer, e.geometry = {
                                type: "Point",
                                coordinates: [
                                    n.position.lng,
                                    n.position.lat
                                ]
                            }, e.state = i, e.source = this.source, o.push({
                                featureIndex: a,
                                feature: e,
                                intersectionZ: m
                            });
                        }
                        ++a;
                    }
                    return s;
                }
                queryIntersectsFeature(e, t1, r, n, i, s, o, a, l, u) {
                    if (!this.modelManager) return !1;
                    const c = this.modelManager, p = e.tile.getBucket(this);
                    if (!(p && p instanceof Ob)) return !1;
                    for(const r in p.instancesPerModel){
                        const n = p.instancesPerModel[r], i = void 0 !== t1.id ? t1.id : t1.properties && t1.properties.hasOwnProperty("id") ? t1.properties.id : void 0;
                        if (n.idToFeaturesIndex.hasOwnProperty(i)) {
                            const t1 = n.features[n.idToFeaturesIndex[i]], o = c.getModel(r, u || this.scope);
                            if (!o) return !1;
                            let a = [];
                            const l = new zu(0, 0), d = p.canonical;
                            let f = Number.MAX_VALUE;
                            for(let r = 0; r < t1.instancedDataCount; ++r){
                                const i = 16 * (t1.instancedDataOffset + r), u = n.instancedDataArray.float32, c = [
                                    u[i + 4],
                                    u[i + 5],
                                    u[i + 6]
                                ];
                                rw(d, l, Math.floor(u[i]), Math.floor(u[i + 1])), ey(a, o, s, l, t1.rotation, t1.scale, c, !1, !1, !1), "globe" === s.projection.name && (a = Ym(a, s));
                                const p = h([], s.projMatrix, a), m = e.queryGeometry, y = Jm(m.isPointQuery() ? m.screenBounds : m.screenGeometry, s, p, o.aabb);
                                null != y && (f = Math.min(y, f));
                            }
                            return f !== Number.MAX_VALUE && f;
                        }
                    }
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(e, t1, r) {
                    return !(!this.layout || t1.isDataDriven() || r.isDataDriven() || "model-color" !== e && "model-color-mix-intensity" !== e && "model-rotation" !== e && "model-scale" !== e && "model-translation" !== e && "model-emissive-strength" !== e);
                }
                _isPropertyZoomDependent(e) {
                    const t1 = this._transitionablePaint._values[e];
                    return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof js;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            },
            clip: class extends Va {
                constructor(e, t1, r, n){
                    super(e, {
                        layout: vd || (vd = new la({
                            "clip-layer-types": new sa(ua.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new sa(ua.layout_clip["clip-layer-scope"]),
                            visibility: new sa(ua.layout_clip.visibility)
                        })),
                        paint: bd || (bd = new la({}))
                    }, t1, r, n);
                }
                recalculate(e, t1) {
                    super.recalculate(e, t1);
                }
                createBucket(e) {
                    return new Ad(e);
                }
                is3D(e) {
                    return !0;
                }
            }
        }, sw = new ar(0, 0, 0);
        function ow(e, t1, r) {
            1 === e && t1.icons.push(function(e, t1) {
                return function(e) {
                    if (e.usvg_tree.height || (e.usvg_tree.height = e.usvg_tree.width), !e.metadata) return e;
                    const { metadata: t1 } = e;
                    if (t1.content_area) {
                        const { content_area: r } = t1;
                        null == r.left && (r.left = 0), null == r.top && (r.top = r.left), null == r.width && (r.width = e.usvg_tree.width), null == r.height && (r.height = r.width);
                    }
                    if (t1.text_placeholder) {
                        const { text_placeholder: e } = t1;
                        null == e.top && (e.top = e.left), null == e.height && (e.height = e.width);
                    }
                    return t1.stretch_x && t1.stretch_x.length && aw(t1, "x"), t1.stretch_y && t1.stretch_y.length && aw(t1, "y"), e;
                }(e.readFields(lw, {
                    name: void 0
                }, t1));
            }(r, r.readVarint() + r.pos));
        }
        function aw(e, t1) {
            const r = [], n = e[`stretch_${t1}`];
            let i = null;
            for(let e = 0; e < n.length; e++)null === i ? i = 0 === r.length ? n[0] : r[r.length - 1][1] + n[e] : (r.push([
                i,
                i + n[e]
            ]), i = null);
            e[`stretch_${t1}_areas`] = r;
        }
        function lw(e, t1, r) {
            1 === e ? t1.name = r.readString() : 2 === e ? t1.metadata = function(e, t1) {
                return e.readFields(uw, {
                    stretch_x: null,
                    stretch_y: null,
                    stretch_x_areas: null,
                    stretch_y_areas: null,
                    variables: []
                }, t1);
            }(r, r.readVarint() + r.pos) : 3 === e && (t1.usvg_tree = function(e, t1) {
                return e.readFields(dw, {
                    width: 20,
                    children: [],
                    linear_gradients: [],
                    radial_gradients: [],
                    clip_paths: [],
                    masks: []
                }, t1);
            }(r, r.readVarint() + r.pos), t1.data = "usvg_tree");
        }
        function uw(e, t1, r) {
            1 === e ? t1.stretch_x = r.readPackedVarint() : 2 === e ? t1.stretch_y = r.readPackedVarint() : 3 === e ? t1.content_area = cw(r, r.readVarint() + r.pos) : 4 === e ? t1.variables.push(function(e, t1) {
                return e.readFields(pw, {
                    name: void 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 5 === e && (t1.text_placeholder = cw(r, r.readVarint() + r.pos));
        }
        function cw(e, t1) {
            return e.readFields(hw, {}, t1);
        }
        function hw(e, t1, r) {
            1 === e ? t1.left = r.readVarint() : 2 === e ? t1.width = r.readVarint() : 3 === e ? t1.top = r.readVarint() : 4 === e && (t1.height = r.readVarint());
        }
        function pw(e, t1, r) {
            1 === e ? t1.name = r.readString() : 2 === e && (t1.rgb_color = ww(r.readVarint()), t1.value = "rgb_color");
        }
        function dw(e, t1, r) {
            1 === e ? t1.width = t1.height = r.readVarint() : 2 === e ? t1.height = r.readVarint() : 3 === e ? t1.children.push(fw(r, r.readVarint() + r.pos)) : 4 === e ? t1.linear_gradients.push(function(e, t1) {
                return e.readFields(Aw, {
                    spread_method: 1,
                    stops: [],
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 5 === e ? t1.radial_gradients.push(function(e, t1) {
                return e.readFields(Sw, {
                    spread_method: 1,
                    stops: [],
                    cx: .5,
                    cy: .5,
                    r: .5,
                    fx: .5,
                    fy: .5,
                    fr: 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 7 === e ? t1.clip_paths.push(function(e, t1) {
                return e.readFields(zw, {
                    children: []
                }, t1);
            }(r, r.readVarint() + r.pos)) : 8 === e && t1.masks.push(function(e, t1) {
                const r = e.readFields(Pw, {
                    left: 0,
                    width: 20,
                    mask_type: 1,
                    children: []
                }, t1);
                return null == r.height && (r.height = r.width), null == r.top && (r.top = r.left), r;
            }(r, r.readVarint() + r.pos));
        }
        function fw(e, t1) {
            return e.readFields(mw, {}, t1);
        }
        function mw(e, t1, r) {
            1 === e ? (t1.group = function(e, t1) {
                return e.readFields(yw, {
                    opacity: 255,
                    children: []
                }, t1);
            }(r, r.readVarint() + r.pos), t1.node = "group") : 2 === e && (t1.path = function(e, t1) {
                return e.readFields(vw, {
                    paint_order: 1,
                    commands: [],
                    step: 1,
                    diffs: [],
                    rule: 1
                }, t1);
            }(r, r.readVarint() + r.pos), t1.node = "path");
        }
        function yw(e, t1, r) {
            1 === e ? t1.transform = gw(r, r.readVarint() + r.pos) : 2 === e ? t1.opacity = r.readVarint() : 5 === e ? t1.clip_path_idx = r.readVarint() : 6 === e ? t1.mask_idx = r.readVarint() : 7 === e && t1.children.push(fw(r, r.readVarint() + r.pos));
        }
        function gw(e, t1) {
            return e.readFields(xw, {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            }, t1);
        }
        function xw(e, t1, r) {
            1 === e ? t1.sx = r.readFloat() : 2 === e ? t1.ky = r.readFloat() : 3 === e ? t1.kx = r.readFloat() : 4 === e ? t1.sy = r.readFloat() : 5 === e ? t1.tx = r.readFloat() : 6 === e && (t1.ty = r.readFloat());
        }
        function vw(e, t1, r) {
            1 === e ? t1.fill = function(e, t1) {
                return e.readFields(bw, {
                    rgb_color: sw,
                    paint: "rgb_color",
                    opacity: 255
                }, t1);
            }(r, r.readVarint() + r.pos) : 2 === e ? t1.stroke = function(e, t1) {
                return e.readFields(_w, {
                    rgb_color: sw,
                    paint: "rgb_color",
                    dasharray: [],
                    dashoffset: 0,
                    miterlimit: 4,
                    opacity: 255,
                    width: 1,
                    linecap: 1,
                    linejoin: 1
                }, t1);
            }(r, r.readVarint() + r.pos) : 3 === e ? t1.paint_order = r.readVarint() : 5 === e ? r.readPackedVarint(t1.commands) : 6 === e ? t1.step = r.readFloat() : 7 === e ? r.readPackedSVarint(t1.diffs) : 8 === e && (t1.rule = r.readVarint());
        }
        function bw(e, t1, r) {
            1 === e ? (t1.rgb_color = ww(r.readVarint()), t1.paint = "rgb_color") : 2 === e ? (t1.linear_gradient_idx = r.readVarint(), t1.paint = "linear_gradient_idx") : 3 === e ? (t1.radial_gradient_idx = r.readVarint(), t1.paint = "radial_gradient_idx") : 5 === e && (t1.opacity = r.readVarint());
        }
        function ww(e) {
            return new ar((e >> 16 & 255) / 255, (e >> 8 & 255) / 255, (255 & e) / 255, 1);
        }
        function _w(e, t1, r) {
            1 === e ? (t1.rgb_color = ww(r.readVarint()), t1.paint = "rgb_color") : 2 === e ? (t1.linear_gradient_idx = r.readVarint(), t1.paint = "linear_gradient_idx") : 3 === e ? (t1.radial_gradient_idx = r.readVarint(), t1.paint = "radial_gradient_idx") : 5 === e ? r.readPackedFloat(t1.dasharray) : 6 === e ? t1.dashoffset = r.readFloat() : 7 === e ? t1.miterlimit = r.readFloat() : 8 === e ? t1.opacity = r.readVarint() : 9 === e ? t1.width = r.readFloat() : 10 === e ? t1.linecap = r.readVarint() : 11 === e && (t1.linejoin = r.readVarint());
        }
        function Aw(e, t1, r) {
            1 === e ? t1.transform = gw(r, r.readVarint() + r.pos) : 2 === e ? t1.spread_method = r.readVarint() : 3 === e ? t1.stops.push(Mw(r, r.readVarint() + r.pos)) : 4 === e ? t1.x1 = r.readFloat() : 5 === e ? t1.y1 = r.readFloat() : 6 === e ? t1.x2 = r.readFloat() : 7 === e && (t1.y2 = r.readFloat());
        }
        function Mw(e, t1) {
            return e.readFields(Iw, {
                offset: 0,
                opacity: 255,
                rgb_color: sw
            }, t1);
        }
        function Iw(e, t1, r) {
            1 === e ? t1.offset = r.readFloat() : 2 === e ? t1.opacity = r.readVarint() : 3 === e && (t1.rgb_color = ww(r.readVarint()));
        }
        function Sw(e, t1, r) {
            1 === e ? t1.transform = gw(r, r.readVarint() + r.pos) : 2 === e ? t1.spread_method = r.readVarint() : 3 === e ? t1.stops.push(Mw(r, r.readVarint() + r.pos)) : 4 === e ? t1.cx = r.readFloat() : 5 === e ? t1.cy = r.readFloat() : 6 === e ? t1.r = r.readFloat() : 7 === e ? t1.fx = r.readFloat() : 8 === e ? t1.fy = r.readFloat() : 9 === e && (t1.fr = r.readFloat());
        }
        function zw(e, t1, r) {
            1 === e ? t1.transform = gw(r, r.readVarint() + r.pos) : 2 === e ? t1.clip_path_idx = r.readVarint() : 3 === e && t1.children.push(fw(r, r.readVarint() + r.pos));
        }
        function Pw(e, t1, r) {
            1 === e ? t1.left = t1.top = r.readFloat() : 2 === e ? t1.width = t1.height = r.readFloat() : 3 === e ? t1.top = r.readFloat() : 4 === e ? t1.height = r.readFloat() : 5 === e ? t1.mask_type = r.readVarint() : 6 === e ? t1.mask_idx = r.readVarint() : 7 === e && t1.children.push(fw(r, r.readVarint() + r.pos));
        }
        class Bw {
            static calculate(e = {}, t1 = []) {
                const r = new Map, n = new Map;
                if (0 === Object.keys(e).length) return r;
                t1.forEach((e)=>{
                    n.set(e.name, e.rgb_color || new ar(0, 0, 0));
                });
                for (const [t1, i] of Object.entries(e))n.has(t1) ? r.set(n.get(t1).toString(), i) : console.warn(`Ignoring unknown image variable "${t1}"`);
                return r;
            }
        }
        function Tw(e, t1 = 255, r) {
            const n = t1 / 255, i = e.toString(), s = r.has(i) ? r.get(i).clone() : e.clone();
            return s.a *= n, s.toString();
        }
        function kw(e, t1) {
            if (!yt()) {
                const r = document.createElement("canvas");
                return r.width = e, r.height = t1, r;
            }
            return new OffscreenCanvas(e, t1);
        }
        let Vw, Ew = null;
        function Fw(e, t1, r, n, i) {
            for (const s of n.children)Dw(e, t1, r, s, i);
        }
        function Dw(e, t1, r, n, i) {
            n.group ? (e.save(), function(e, t1, r, n, i) {
                const s = null != n.mask_idx ? r.masks[n.mask_idx] : null, o = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
                if (n.transform && (t1 = $w(n.transform).preMultiplySelf(t1)), !function(e, t1, r) {
                    return 255 !== e.opacity || t1 || r;
                }(n, null != o, null != s)) return void Fw(e, t1, r, n, i);
                const a = kw(e.canvas.width, e.canvas.height), l = a.getContext("2d");
                Fw(l, t1, r, n, i), o && jw(l, t1, r, o), s && Gw(l, t1, r, s, i), e.globalAlpha = n.opacity / 255, e.drawImage(a, 0, 0);
            }(e, t1, r, n.group, i), e.restore()) : n.path && (e.save(), function(e, t1, r, n, i) {
                e.setTransform(t1), 1 === n.paint_order ? (Cw(e, r, n, i), Lw(e, r, n, i)) : (Lw(e, r, n, i), Cw(e, r, n, i));
            }(e, t1, r, n.path, i), e.restore());
        }
        function Cw(e, t1, r, n) {
            const i = r.fill;
            if (!i) return;
            const s = i.opacity / 255;
            switch(e.save(), e.beginPath(), qw(r, e), i.paint){
                case "rgb_color":
                    e.fillStyle = Tw(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    {
                        const r = t1.linear_gradients[i.linear_gradient_idx];
                        r.transform && e.setTransform($w(r.transform).preMultiplySelf(e.getTransform())), e.fillStyle = Ow(e, r, s, n);
                        break;
                    }
                case "radial_gradient_idx":
                    {
                        const r = t1.radial_gradients[i.radial_gradient_idx];
                        r.transform && e.setTransform($w(r.transform).preMultiplySelf(e.getTransform())), e.fillStyle = Uw(e, r, s, n);
                    }
            }
            e.fill(Rw(r)), e.restore();
        }
        function Rw(e) {
            return 1 === e.rule ? "nonzero" : 2 === e.rule ? "evenodd" : void 0;
        }
        function Lw(e, t1, r, n) {
            const i = r.stroke;
            if (!i) return;
            const s = Xw(r);
            e.lineWidth = i.width, e.miterLimit = i.miterlimit, e.setLineDash(i.dasharray), e.lineDashOffset = i.dashoffset;
            const o = i.opacity / 255;
            switch(i.paint){
                case "rgb_color":
                    e.strokeStyle = Tw(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    e.strokeStyle = Ow(e, t1.linear_gradients[i.linear_gradient_idx], o, n, !0);
                    break;
                case "radial_gradient_idx":
                    e.strokeStyle = Uw(e, t1.radial_gradients[i.radial_gradient_idx], o, n, !0);
            }
            switch(i.linejoin){
                case 2:
                case 1:
                    e.lineJoin = "miter";
                    break;
                case 3:
                    e.lineJoin = "round";
                    break;
                case 4:
                    e.lineJoin = "bevel";
            }
            switch(i.linecap){
                case 1:
                    e.lineCap = "butt";
                    break;
                case 2:
                    e.lineCap = "round";
                    break;
                case 3:
                    e.lineCap = "square";
            }
            e.stroke(s);
        }
        function Ow(e, t1, r, n, i = !1) {
            if (1 === t1.stops.length) {
                const e = t1.stops[0];
                return Tw(e.rgb_color, e.opacity * r, n);
            }
            const { x1: s, y1: o, x2: a, y2: l } = t1;
            let u = new DOMPoint(s, o), c = new DOMPoint(a, l);
            if (i) {
                const e = $w(t1.transform);
                u = e.transformPoint(u), c = e.transformPoint(c);
            }
            const h = e.createLinearGradient(u.x, u.y, c.x, c.y);
            for (const e of t1.stops)h.addColorStop(e.offset, Tw(e.rgb_color, e.opacity * r, n));
            return h;
        }
        function Uw(e, t1, r, n, i = !1) {
            if (1 === t1.stops.length) {
                const e = t1.stops[0];
                return Tw(e.rgb_color, e.opacity * r, n);
            }
            const s = $w(t1.transform), { fx: o, fy: a, fr: l, cx: u, cy: c, r: h } = t1;
            let p = new DOMPoint(o, a), d = new DOMPoint(u, c), f = l, m = h;
            if (i) {
                p = s.transformPoint(p), d = s.transformPoint(d);
                const e = (s.a + s.d) / 2;
                f = l * e, m = t1.r * e;
            }
            const y = e.createRadialGradient(p.x, p.y, f, d.x, d.y, m);
            for (const e of t1.stops)y.addColorStop(e.offset, Tw(e.rgb_color, e.opacity * r, n));
            return y;
        }
        function Nw(e, t1, r, n) {
            const i = n.transform ? $w(n.transform).preMultiplySelf(t1) : t1, s = kw(e.canvas.width, e.canvas.height), o = s.getContext("2d");
            for (const e of n.children)if (e.group) Nw(o, i, r, e.group);
            else if (e.path) {
                const t1 = e.path, r = new Path2D;
                r.addPath(Xw(t1), i), o.fill(r, Rw(t1));
            }
            const a = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
            a && jw(o, i, r, a), e.globalCompositeOperation = "source-over", e.drawImage(s, 0, 0);
        }
        function jw(e, t1, r, n) {
            const i = kw(e.canvas.width, e.canvas.height);
            Nw(i.getContext("2d"), t1, r, n), e.globalCompositeOperation = "destination-in", e.drawImage(i, 0, 0);
        }
        function Gw(e, t1, r, n, i) {
            if (0 === n.children.length) return;
            const s = null != n.mask_idx ? r.masks[n.mask_idx] : null;
            s && Gw(e, t1, r, s, i);
            const o = e.canvas.width, a = e.canvas.height, l = kw(o, a), u = l.getContext("2d"), c = n.width, h = n.height, p = n.left, d = n.top, f = new Path2D, m = new Path2D;
            m.rect(p, d, c, h), f.addPath(m, t1), u.clip(f);
            for (const e of n.children)Dw(u, t1, r, e, i);
            const y = u.getImageData(0, 0, o, a), g = y.data;
            if (1 === n.mask_type) for(let e = 0; e < g.length; e += 4)g[e + 3] = g[e + 3] / 255 * (.2126 * g[e] + .7152 * g[e + 1] + .0722 * g[e + 2]);
            u.putImageData(y, 0, 0), e.globalCompositeOperation = "destination-in", e.drawImage(l, 0, 0);
        }
        function $w(e) {
            return e ? new DOMMatrix([
                e.sx,
                e.ky,
                e.kx,
                e.sy,
                e.tx,
                e.ty
            ]) : new DOMMatrix;
        }
        function qw(e, t1) {
            const r = e.step;
            let n = e.diffs[0] * r, i = e.diffs[1] * r;
            t1.moveTo(n, i);
            for(let s = 0, o = 2; s < e.commands.length; s++)switch(e.commands[s]){
                case 1:
                    n += e.diffs[o++] * r, i += e.diffs[o++] * r, t1.moveTo(n, i);
                    break;
                case 2:
                    n += e.diffs[o++] * r, i += e.diffs[o++] * r, t1.lineTo(n, i);
                    break;
                case 3:
                    {
                        const s = n + e.diffs[o++] * r, a = i + e.diffs[o++] * r;
                        n = s + e.diffs[o++] * r, i = a + e.diffs[o++] * r, t1.quadraticCurveTo(s, a, n, i);
                        break;
                    }
                case 4:
                    {
                        const s = n + e.diffs[o++] * r, a = i + e.diffs[o++] * r, l = s + e.diffs[o++] * r, u = a + e.diffs[o++] * r;
                        n = l + e.diffs[o++] * r, i = u + e.diffs[o++] * r, t1.bezierCurveTo(s, a, l, u, n, i);
                        break;
                    }
                case 5:
                    t1.closePath();
                    break;
                default:
                    Hw();
            }
            return t1;
        }
        function Xw(e) {
            return qw(e, new Path2D);
        }
        function Hw(e, t1) {}
        class Zw {
            constructor(e){
                this.capacity = e, this.cache = new Map;
            }
            get(e) {
                if (!this.cache.has(e)) return;
                const t1 = this.cache.get(e);
                return this.cache.delete(e), this.cache.set(e, t1), t1;
            }
            put(e, t1) {
                this.cache.has(e) ? this.cache.delete(e) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(e, t1);
            }
            delete(e) {
                this.cache.delete(e);
            }
        }
        Js(Zw, "LRUCache");
        class Ww {
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
            static _getImage(e) {
                return new Gh(e, e.data);
            }
            getFromCache(e, t1, r) {
                return this.cacheMap.has(r) || this.cacheMap.set(r, new Zw(150)), this.cacheMap.get(r).get(Sa(e.toString(), t1));
            }
            setInCache(e, t1, r, n) {
                this.cacheDependenciesMap.has(n) || this.cacheDependenciesMap.set(n, new Map), this.cacheMap.has(n) || this.cacheMap.set(n, new Zw(150));
                const i = this.cacheDependenciesMap.get(n), s = Sa(e.id.toString(), r);
                i.get(s) || i.set(s, new Set);
                const o = this.cacheMap.get(n), a = e.toString();
                i.get(s).add(a), o.put(Sa(e.toString(), r), t1);
            }
            removeImagesFromCacheByIds(e, t1, r = 0) {
                if (!this.cacheMap.has(r) || !this.cacheDependenciesMap.has(r)) return;
                const n = this.cacheMap.get(r), i = this.cacheDependenciesMap.get(r);
                for (const r of e){
                    const e = Sa(r.toString(), t1);
                    if (i.has(e)) {
                        for (const t1 of i.get(e))n.delete(t1);
                        i.delete(e);
                    }
                }
            }
            rasterize(e, t1, r, n) {
                const i = this.getFromCache(e, r, n);
                if (i) return i.clone();
                const s = function(e, t1) {
                    const r = Bw.calculate(t1.params, e.metadata ? e.metadata.variables : []), n = e.usvg_tree, i = n.width, s = n.height, o = Math.max(1, Math.round(i * t1.sx)), a = Math.max(1, Math.round(s * t1.sy)), l = new DOMMatrix([
                        o / i,
                        0,
                        0,
                        a / s,
                        0,
                        0
                    ]);
                    return null === Ew && (Ew = kw(10, 10), Vw = Ew.getContext("2d", {
                        willReadFrequently: !0
                    })), Ew.width = o, Ew.height = a, Fw(Vw, l, n, n, r), Vw.getImageData(0, 0, o, a);
                }(t1.icon, e), o = Ww._getImage(s);
                return this.setInCache(e, o, r, n), o.clone();
            }
        }
        class Yw {
            constructor(e){
                this.size = e, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(e, t1) {
                const r = this.toIdx(e, t1);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(e, t1) {
                return this.leaves[this.toIdx(e, t1)];
            }
            toIdx(e, t1) {
                return t1 * this.size + e;
            }
        }
        function Jw(e, t1, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let o = 0; o < 3; o++)if (Math.abs(n[o]) < 1e-15) {
                if (r[o] < e[o] || r[o] > t1[o]) return null;
            } else {
                const a = 1 / n[o];
                let l = (e[o] - r[o]) * a, u = (t1[o] - r[o]) * a;
                if (l > u) {
                    const e = l;
                    l = u, u = e;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function Kw(e, t1, r, n, i, s, o, a, l, u, c) {
            const h = n - e, p = i - t1, d = s - r, f = o - e, m = a - t1, y = l - r, g = c[1] * y - c[2] * m, x = c[2] * f - c[0] * y, v = c[0] * m - c[1] * f, b = h * g + p * x + d * v;
            if (Math.abs(b) < 1e-15) return null;
            const w = 1 / b, _ = u[0] - e, A = u[1] - t1, M = u[2] - r, I = (_ * g + A * x + M * v) * w;
            if (I < 0 || I > 1) return null;
            const S = A * d - M * p, z = M * h - _ * d, P = _ * p - A * h, B = (c[0] * S + c[1] * z + c[2] * P) * w;
            return B < 0 || I + B > 1 ? null : (f * S + m * z + y * P) * w;
        }
        function Qw(e, t1, r) {
            return (e - t1) / (r - t1);
        }
        function e_(e, t1, r, n, i, s, o, a, l) {
            const u = 1 << r, c = s - n, h = o - i, p = (e + 1) / u * c + n, d = (t1 + 0) / u * h + i, f = (t1 + 1) / u * h + i;
            a[0] = (e + 0) / u * c + n, a[1] = d, l[0] = p, l[1] = f;
        }
        class t_ {
            constructor(e){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = e, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const t1 = function(e) {
                    const t1 = Math.ceil(Math.log2(e.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, t1));
                    const i = 1 / n, s = (e, t1, r, n, i)=>{
                        const s = n ? 1 : 0, o = (e + 1) * r - s, a = t1 * r, l = (t1 + 1) * r - s;
                        i[0] = e * r, i[1] = a, i[2] = o, i[3] = l;
                    };
                    let o = new Yw(n);
                    const a = [];
                    for(let t1 = 0; t1 < n * n; t1++){
                        s(t1 % n, Math.floor(t1 / n), i, !1, a);
                        const r = n_(a[0], a[1], e), l = n_(a[2], a[1], e), u = n_(a[2], a[3], e), c = n_(a[0], a[3], e);
                        o.minimums.push(Math.min(r, l, u, c)), o.maximums.push(Math.max(r, l, u, c)), o.leaves.push(1);
                    }
                    for(r.push(o), n /= 2; n >= 1; n /= 2){
                        const e = r[r.length - 1];
                        o = new Yw(n);
                        for(let t1 = 0; t1 < n * n; t1++){
                            s(t1 % n, Math.floor(t1 / n), 2, !0, a);
                            const r = e.getElevation(a[0], a[1]), i = e.getElevation(a[2], a[1]), l = e.getElevation(a[2], a[3]), u = e.getElevation(a[0], a[3]), c = e.isLeaf(a[0], a[1]), h = e.isLeaf(a[2], a[1]), p = e.isLeaf(a[2], a[3]), d = e.isLeaf(a[0], a[3]), f = Math.min(r.min, i.min, l.min, u.min), m = Math.max(r.max, i.max, l.max, u.max), y = c && h && p && d;
                            o.maximums.push(m), o.minimums.push(f), o.leaves.push(m - f <= 5 && y ? 1 : 0);
                        }
                        r.push(o);
                    }
                    return r;
                }(this.dem), r = t1.length - 1, n = t1[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(t1, 0, 0, r, 0);
            }
            raycastRoot(e, t1, r, n, i, s, o = 1) {
                return Jw([
                    e,
                    t1,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * o
                ], i, s);
            }
            raycast(e, t1, r, n, i, s, o = 1) {
                if (!this.nodeCount) return null;
                const a = this.raycastRoot(e, t1, r, n, i, s, o);
                if (null == a) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: a,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: a, t: d, nodex: f, nodey: m, depth: y } = p.pop();
                    if (this.leaves[a]) {
                        e_(f, m, y, e, t1, r, n, c, h);
                        const a = 1 << y, l = (f + 0) / a, u = (f + 1) / a, p = (m + 0) / a, g = (m + 1) / a, x = n_(l, p, this.dem) * o, v = n_(u, p, this.dem) * o, b = n_(u, g, this.dem) * o, w = n_(l, g, this.dem) * o, _ = Kw(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, s), A = Kw(h[0], h[1], b, c[0], h[1], w, c[0], c[1], x, i, s), M = Math.min(null !== _ ? _ : Number.MAX_VALUE, null !== A ? A : Number.MAX_VALUE);
                        if (M !== Number.MAX_VALUE) return M;
                        {
                            const e = E([], i, s, d);
                            if (r_(x, v, w, b, Qw(e[0], c[0], h[0]), Qw(e[1], c[1], h[1])) >= e[2]) return d;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        e_((f << 1) + this._siblingOffset[p][0], (m << 1) + this._siblingOffset[p][1], y + 1, e, t1, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[a] + p] * o;
                        const d = Jw(c, h, i, s);
                        if (null != d) {
                            const e = d;
                            l[p] = e;
                            let t1 = !1;
                            for(let r = 0; r < g && !t1; r++)e >= l[u[r]] && (u.splice(r, 0, p), t1 = !0);
                            t1 || (u[g] = p), g++;
                        }
                    }
                    for(let e = 0; e < g; e++){
                        const t1 = u[e];
                        p.push({
                            idx: this.childOffsets[a] + t1,
                            t: l[t1],
                            nodex: (f << 1) + this._siblingOffset[t1][0],
                            nodey: (m << 1) + this._siblingOffset[t1][1],
                            depth: y + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e, t1, r) {
                return this.minimums.push(e), this.maximums.push(t1), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(e, t1, r, n, i) {
                if (1 === e[n].isLeaf(t1, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, o = e[s];
                let a = 0, l = 0;
                for(let e = 0; e < this._siblingOffset.length; e++){
                    const n = 2 * t1 + this._siblingOffset[e][0], i = 2 * r + this._siblingOffset[e][1], s = o.getElevation(n, i), u = o.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (a |= 1 << e), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)a & 1 << n || this._construct(e, 2 * t1 + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
        }
        function r_(e, t1, r, n, i, s) {
            return hr(hr(e, r, s), hr(t1, n, s), i);
        }
        function n_(e, t1, r) {
            const n = r.dim, i = De(e * n - .5, 0, n - 1), s = De(t1 * n - .5, 0, n - 1), o = Math.floor(i), a = Math.floor(s), l = Math.min(o + 1, n - 1), u = Math.min(a + 1, n - 1);
            return r_(r.get(o, a), r.get(l, a), r.get(o, u), r.get(l, u), i - o, s - a);
        }
        const i_ = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function s_(e, t1, r) {
            return (256 * e * 256 + 256 * t1 + r) / 10 - 1e4;
        }
        function o_(e, t1, r) {
            return 256 * e + t1 + r / 256 - 32768;
        }
        class a_ {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(e, t1, r, n = !1){
                if (this.uid = e, t1.height !== t1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void Ze(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t1.height;
                const i = this.dim = t1.height - 2, s = new Uint32Array(t1.data.buffer);
                if (this.pixels = new Uint8Array(t1.data.buffer), this.floatView = new Float32Array(t1.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let e = 0; e < i; e++)s[this._idx(-1, e)] = s[this._idx(0, e)], s[this._idx(i, e)] = s[this._idx(i - 1, e)], s[this._idx(e, -1)] = s[this._idx(e, 0)], s[this._idx(e, i)] = s[this._idx(e, i - 1)];
                    s[this._idx(-1, -1)] = s[this._idx(0, 0)], s[this._idx(i, -1)] = s[this._idx(i - 1, 0)], s[this._idx(-1, i)] = s[this._idx(0, i - 1)], s[this._idx(i, i)] = s[this._idx(i - 1, i - 1)];
                }
                const o = "terrarium" === r ? o_ : s_;
                for(let e = 0; e < s.length; ++e){
                    const t1 = 4 * e;
                    this.floatView[e] = o(this.pixels[t1], this.pixels[t1 + 1], this.pixels[t1 + 2]);
                }
                this._timestamp = gt.now();
            }
            _buildQuadTree() {
                this._tree = new t_(this);
            }
            get(e, t1, r = !1) {
                r && (e = De(e, -1, this.dim), t1 = De(t1, -1, this.dim));
                const n = this._idx(e, t1);
                return this.floatView[n];
            }
            set(e, t1, r) {
                const n = this._idx(e, t1), i = this.floatView[n];
                return this.floatView[n] = r, r - i;
            }
            static getUnpackVector(e) {
                return i_[e];
            }
            _idx(e, t1) {
                if (e < -1 || e >= this.dim + 1 || t1 < -1 || t1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t1 + 1) * this.stride + (e + 1);
            }
            static pack(e, t1) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = a_.getUnpackVector(t1);
                let i = Math.floor((e + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new $h({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e, t1, r) {
                if (this.dim !== e.dim) throw new Error("dem dimension mismatch");
                let n = t1 * this.dim, i = t1 * this.dim + this.dim, s = r * this.dim, o = r * this.dim + this.dim;
                switch(t1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = o - 1;
                        break;
                    case 1:
                        o = s + 1;
                }
                const a = -t1 * this.dim, l = -r * this.dim;
                for(let t1 = s; t1 < o; t1++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, t1), i = 4 * this._idx(r + a, t1 + l);
                    this.pixels[n + 0] = e.pixels[i + 0], this.pixels[n + 1] = e.pixels[i + 1], this.pixels[n + 2] = e.pixels[i + 2], this.pixels[n + 3] = e.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        function l_(e, t1, r) {
            1 === e ? t1.headerLength = r.readFixed32() : 2 === e ? t1.x = r.readVarint() : 3 === e ? t1.y = r.readVarint() : 4 === e ? t1.z = r.readVarint() : 5 === e && t1.layers.push(function(e, t1) {
                return e.readFields(d_, {
                    version: 0,
                    name: "",
                    units: "",
                    tileSize: 0,
                    buffer: 0,
                    pixelFormat: 0,
                    dataIndex: []
                }, t1);
            }(r, r.readVarint() + r.pos));
        }
        function u_(e, t1, r) {
            1 === e ? (t1.delta_filter = function(e, t1) {
                return e.readFields(c_, {
                    blockSize: 0
                }, t1);
            }(r, r.readVarint() + r.pos), t1.filter = "delta_filter") : 2 === e ? (r.readVarint(), t1.filter = "zigzag_filter") : 3 === e ? (r.readVarint(), t1.filter = "bitshuffle_filter") : 4 === e && (r.readVarint(), t1.filter = "byteshuffle_filter");
        }
        function c_(e, t1, r) {
            1 === e && (t1.blockSize = r.readVarint());
        }
        function h_(e, t1, r) {
            1 === e ? (r.readVarint(), t1.codec = "gzip_data") : 2 === e ? (r.readVarint(), t1.codec = "jpeg_image") : 3 === e ? (r.readVarint(), t1.codec = "webp_image") : 4 === e && (r.readVarint(), t1.codec = "png_image");
        }
        function p_(e, t1, r) {
            let n = 0, i = 0;
            1 === e ? t1.firstByte = r.readFixed64() : 2 === e ? t1.lastByte = r.readFixed64() : 3 === e ? t1.filters.push(function(e, t1) {
                return e.readFields(u_, {}, t1);
            }(r, r.readVarint() + r.pos)) : 4 === e ? t1.codec = function(e, t1) {
                return e.readFields(h_, {}, t1);
            }(r, r.readVarint() + r.pos) : 5 === e ? i = r.readFloat() : 6 === e ? n = r.readFloat() : 7 === e ? t1.bands.push(r.readString()) : 8 === e ? t1.offset = r.readDouble() : 9 === e && (t1.scale = r.readDouble()), 0 === t1.offset && (t1.offset = i), 0 === t1.scale && (t1.scale = n);
        }
        function d_(e, t1, r) {
            1 === e ? t1.version = r.readVarint() : 2 === e ? t1.name = r.readString() : 3 === e ? t1.units = r.readString() : 4 === e ? t1.tileSize = r.readVarint() : 5 === e ? t1.buffer = r.readVarint() : 6 === e ? t1.pixelFormat = r.readVarint() : 7 === e && t1.dataIndex.push(function(e, t1) {
                return e.readFields(p_, {
                    firstByte: 0,
                    lastByte: 0,
                    filters: [],
                    codec: null,
                    offset: 0,
                    scale: 0,
                    bands: []
                }, t1);
            }(r, r.readVarint() + r.pos));
        }
        function f_(e, t1, r) {
            if (2 === e) !function(e, t1, r) {
                e.readFields(m_, r, t1);
            }(r, r.readVarint() + r.pos, t1);
            else if (3 === e) throw new Error("Not implemented");
        }
        function m_(e, t1, r) {
            if (1 === e) {
                let e = 0;
                const n = r.readVarint() + r.pos;
                for(; r.pos < n;)t1[e++] = r.readVarint();
            }
        }
        function y_(e, t1) {
            if (4 !== t1.length) throw new Error(`Expected data of dimension 4 but got ${t1.length}.`);
            let r = t1[3];
            for(let n = 2; n >= 1; n--){
                const i = 1 === n ? 1 : 0, s = 2 === n ? 1 : 0;
                for(let n = 0; n < t1[0]; n++){
                    const o = t1[1] * n;
                    for(let n = i; n < t1[1]; n++){
                        const i = t1[2] * (n + o);
                        for(let n = s; n < t1[2]; n++){
                            const s = t1[3] * (n + i);
                            for(let n = 0; n < t1[3]; n++){
                                const t1 = s + n;
                                e[t1] += e[t1 - r];
                            }
                        }
                    }
                }
                r *= t1[n];
            }
            return e;
        }
        function g_(e) {
            for(let t1 = 0, r = e.length; t1 < r; t1++)e[t1] = e[t1] >>> 1 ^ -(1 & e[t1]);
            return e;
        }
        function x_(e, t1) {
            switch(t1){
                case "uint32":
                    return e;
                case "uint16":
                    for(let t1 = 0; t1 < e.length; t1 += 2){
                        const r = e[t1], n = e[t1 + 1];
                        e[t1] = (240 & r) >> 4 | (61440 & r) >> 8 | (240 & n) << 4 | 61440 & n, e[t1 + 1] = 15 & r | (3840 & r) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return e;
                case "uint8":
                    for(let t1 = 0; t1 < e.length; t1 += 4){
                        const r = e[t1], n = e[t1 + 1], i = e[t1 + 2], s = e[t1 + 3];
                        e[t1 + 0] = (192 & r) >> 6 | (192 & n) >> 4 | (192 & i) >> 2 | 192 & s, e[t1 + 1] = (48 & r) >> 4 | (48 & n) >> 2 | 48 & i | (48 & s) << 2, e[t1 + 2] = (12 & r) >> 2 | 12 & n | (12 & i) << 2 | (12 & s) << 4, e[t1 + 3] = 3 & r | (3 & n) << 2 | (3 & i) << 4 | (3 & s) << 6;
                    }
                    return e;
                default:
                    throw new Error(`Invalid pixel format, "${t1}"`);
            }
        }
        Js(a_, "DEMData"), Js(t_, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        var v_ = Uint8Array, b_ = Uint16Array, w_ = Int32Array, __ = new v_([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), A_ = new v_([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), M_ = new v_([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), I_ = function(e, t1) {
            for(var r = new b_(31), n = 0; n < 31; ++n)r[n] = t1 += 1 << e[n - 1];
            var i = new w_(r[30]);
            for(n = 1; n < 30; ++n)for(var s = r[n]; s < r[n + 1]; ++s)i[s] = s - r[n] << 5 | n;
            return {
                b: r,
                r: i
            };
        }, S_ = I_(__, 2), z_ = S_.b, P_ = S_.r;
        z_[28] = 258, P_[258] = 28;
        for(var B_ = I_(A_, 0).b, T_ = new b_(32768), k_ = 0; k_ < 32768; ++k_){
            var V_ = (43690 & k_) >> 1 | (21845 & k_) << 1;
            T_[k_] = ((65280 & (V_ = (61680 & (V_ = (52428 & V_) >> 2 | (13107 & V_) << 2)) >> 4 | (3855 & V_) << 4)) >> 8 | (255 & V_) << 8) >> 1;
        }
        var E_ = function(e, t1, r) {
            for(var n = e.length, i = 0, s = new b_(t1); i < n; ++i)e[i] && ++s[e[i] - 1];
            var o, a = new b_(t1);
            for(i = 1; i < t1; ++i)a[i] = a[i - 1] + s[i - 1] << 1;
            o = new b_(1 << t1);
            var l = 15 - t1;
            for(i = 0; i < n; ++i)if (e[i]) for(var u = i << 4 | e[i], c = t1 - e[i], h = a[e[i] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h)o[T_[h] >> l] = u;
            return o;
        }, F_ = new v_(288);
        for(k_ = 0; k_ < 144; ++k_)F_[k_] = 8;
        for(k_ = 144; k_ < 256; ++k_)F_[k_] = 9;
        for(k_ = 256; k_ < 280; ++k_)F_[k_] = 7;
        for(k_ = 280; k_ < 288; ++k_)F_[k_] = 8;
        var D_ = new v_(32);
        for(k_ = 0; k_ < 32; ++k_)D_[k_] = 5;
        var C_ = E_(F_, 9), R_ = E_(D_, 5), L_ = function(e) {
            for(var t1 = e[0], r = 1; r < e.length; ++r)e[r] > t1 && (t1 = e[r]);
            return t1;
        }, O_ = function(e, t1, r) {
            var n = t1 / 8 | 0;
            return (e[n] | e[n + 1] << 8) >> (7 & t1) & r;
        }, U_ = function(e, t1) {
            var r = t1 / 8 | 0;
            return (e[r] | e[r + 1] << 8 | e[r + 2] << 16) >> (7 & t1);
        }, N_ = function(e) {
            return (e + 7) / 8 | 0;
        }, j_ = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], G_ = function(e, t1, r) {
            var n = new Error(t1 || j_[e]);
            if (n.code = e, Error.captureStackTrace && Error.captureStackTrace(n, G_), !r) throw n;
            return n;
        }, $_ = new v_(0);
        var q_ = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            q_.decode($_, {
                stream: !0
            });
        } catch (e) {}
        const X_ = {
            gzip_data: "gzip"
        };
        class H_ extends Error {
            constructor(e){
                super(e), this.name = "MRTError";
            }
        }
        const Z_ = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, W_ = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, Y_ = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let J_;
        class K_ {
            constructor(e = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = e;
            }
            getLayer(e) {
                const t1 = this.layers[e];
                if (!t1) throw new H_(`Layer '${e}' not found`);
                return t1;
            }
            getHeaderLength(e) {
                const t1 = new Uint8Array(e), r = new DataView(e);
                if (13 !== t1[0]) throw new H_("File is not a valid MRT.");
                return r.getUint32(1, !0);
            }
            parseHeader(e) {
                const t1 = new Uint8Array(e), r = this.getHeaderLength(e);
                if (t1.length < r) throw new H_(`Expected header with length >= ${r} but got buffer of length ${t1.length}`);
                const n = new J_(t1.subarray(0, r)).readFields(l_, {
                    headerLength: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    layers: []
                }, void 0);
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new H_(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const e of n.layers)this.layers[e.name] = new Q_(e, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(e) {
                const t1 = [], r = this.getLayer(e.layerName);
                for (let n of e.blockIndices){
                    const i = r.dataIndex[n], s = i.firstByte - e.firstByte, o = i.lastByte - e.firstByte;
                    if (r._blocksInProgress.has(n)) continue;
                    const a = {
                        layerName: r.name,
                        firstByte: s,
                        lastByte: o,
                        pixelFormat: r.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            i.bands.length
                        ].concat(r.bandShape),
                        buffer: r.buffer,
                        codec: i.codec.codec,
                        filters: i.filters.map((e)=>e.filter)
                    };
                    r._blocksInProgress.add(n), t1.push(a);
                }
                return new eA(t1, ()=>{
                    t1.forEach((e)=>r._blocksInProgress.delete(e.blockIndex));
                }, (e, n)=>{
                    if (t1.forEach((e)=>r._blocksInProgress.delete(e.blockIndex)), e) throw e;
                    n.forEach((e)=>{
                        this.getLayer(e.layerName).processDecodedData(e);
                    });
                });
            }
        }
        class Q_ {
            constructor({ version: e, name: t1, units: r, tileSize: n, pixelFormat: i, buffer: s, dataIndex: o }, a){
                if (this.version = e, 1 !== this.version) throw new H_(`Cannot parse raster layer encoded with MRT version ${e}`);
                this.name = t1, this.units = r, this.tileSize = n, this.buffer = s, this.pixelFormat = Z_[i], this.dataIndex = o, this.bandShape = [
                    n + 2 * s,
                    n + 2 * s,
                    W_[this.pixelFormat]
                ], this._decodedBlocks = new Zw(a ? a.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return W_[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: e })=>e).flat();
            }
            processDecodedData(e) {
                const t1 = e.blockIndex.toString();
                this._decodedBlocks.get(t1) || this._decodedBlocks.put(t1, e.data);
            }
            getBlockForBand(e) {
                let t1 = 0;
                switch(typeof e){
                    case "string":
                        for (const [r, n] of this.dataIndex.entries()){
                            for (const [i, s] of n.bands.entries())if (s === e) return {
                                bandIndex: t1 + i,
                                blockIndex: r,
                                blockBandIndex: i
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [r, n] of this.dataIndex.entries()){
                            if (e >= t1 && e < t1 + n.bands.length) return {
                                bandIndex: e,
                                blockIndex: r,
                                blockBandIndex: e - t1
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    default:
                        throw new H_(`Invalid band \`${JSON.stringify(e)}\`. Expected string or integer.`);
                }
                return {
                    blockIndex: -1,
                    blockBandIndex: -1
                };
            }
            getDataRange(e) {
                let t1 = 1 / 0, r = -1 / 0;
                const n = [], i = new Set;
                for (const s of e){
                    const { blockIndex: e } = this.getBlockForBand(s);
                    if (e < 0) throw new H_(`Invalid band: ${JSON.stringify(s)}`);
                    const o = this.dataIndex[e];
                    n.includes(e) || n.push(e), i.add(e), t1 = Math.min(t1, o.firstByte), r = Math.max(r, o.lastByte);
                }
                if (i.size > this.cacheSize) throw new H_(`Number of blocks to decode (${i.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: t1,
                    lastByte: r,
                    blockIndices: n
                };
            }
            hasBand(e) {
                const { blockIndex: t1 } = this.getBlockForBand(e);
                return t1 >= 0;
            }
            hasDataForBand(e) {
                const { blockIndex: t1 } = this.getBlockForBand(e);
                return t1 >= 0 && !!this._decodedBlocks.get(t1.toString());
            }
            getBandView(e) {
                const { blockIndex: t1, blockBandIndex: r } = this.getBlockForBand(e);
                if (t1 < 0) throw new H_(`Band not found: ${JSON.stringify(e)}`);
                const n = this._decodedBlocks.get(t1.toString());
                if (!n) throw new H_(`Data for band ${JSON.stringify(e)} of layer "${this.name}" not decoded.`);
                const i = this.dataIndex[t1], s = this.bandShape.reduce((e, t1)=>e * t1, 1), o = r * s, a = n.subarray(o, o + s);
                return {
                    data: a,
                    bytes: new Uint8Array(a.buffer).subarray(a.byteOffset, a.byteOffset + a.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: i.offset,
                    scale: i.scale
                };
            }
        }
        K_.setPbf = function(e) {
            J_ = e;
        };
        class eA {
            constructor(e, t1, r){
                this.tasks = e, this._onCancel = t1, this._onComplete = r, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(e, t1) {
                this._finalized || (this._onComplete(e, t1), this._finalized = !0);
            }
        }
        K_.performDecoding = function(e, t1) {
            const r = new Uint8Array(e);
            return Promise.all(t1.tasks.map((e)=>{
                const { layerName: t1, firstByte: n, lastByte: i, pixelFormat: s, blockShape: o, blockIndex: a, filters: l, codec: u } = e, c = r.subarray(n, i + 1), h = new Uint32Array(o[0] * o[1] * o[2]);
                let p;
                if ("gzip_data" !== u) throw new H_(`Unhandled codec: ${u}`);
                return p = (function(e, t1) {
                    if (!globalThis.DecompressionStream && "gzip_data" === t1) return Promise.resolve((o = function(e) {
                        31 == e[0] && 139 == e[1] && 8 == e[2] || G_(6, "invalid gzip data");
                        var t1 = e[3], r = 10;
                        4 & t1 && (r += 2 + (e[10] | e[11] << 8));
                        for(var n = (t1 >> 3 & 1) + (t1 >> 4 & 1); n > 0; n -= !e[r++]);
                        return r + (2 & t1);
                    }(r = e), o + 8 > r.length && G_(6, "invalid gzip data"), function(e, t1, r, n) {
                        var i = e.length;
                        if (!i || t1.f && !t1.l) return r || new v_(0);
                        var s = !r, o = s || 2 != t1.i, a = t1.i;
                        s && (r = new v_(3 * i));
                        var l = function(e) {
                            var t1 = r.length;
                            if (e > t1) {
                                var n = new v_(Math.max(2 * t1, e));
                                n.set(r), r = n;
                            }
                        }, u = t1.f || 0, c = t1.p || 0, h = t1.b || 0, p = t1.l, d = t1.d, f = t1.m, m = t1.n, y = 8 * i;
                        do {
                            if (!p) {
                                u = O_(e, c, 1);
                                var g = O_(e, c + 1, 3);
                                if (c += 3, !g) {
                                    var x = e[(B = N_(c) + 4) - 4] | e[B - 3] << 8, v = B + x;
                                    if (v > i) {
                                        a && G_(0);
                                        break;
                                    }
                                    o && l(h + x), r.set(e.subarray(B, v), h), t1.b = h += x, t1.p = c = 8 * v, t1.f = u;
                                    continue;
                                }
                                if (1 == g) p = C_, d = R_, f = 9, m = 5;
                                else if (2 == g) {
                                    var b = O_(e, c, 31) + 257, w = O_(e, c + 10, 15) + 4, _ = b + O_(e, c + 5, 31) + 1;
                                    c += 14;
                                    for(var A = new v_(_), M = new v_(19), I = 0; I < w; ++I)M[M_[I]] = O_(e, c + 3 * I, 7);
                                    c += 3 * w;
                                    var S = L_(M), z = (1 << S) - 1, P = E_(M, S);
                                    for(I = 0; I < _;){
                                        var B, T = P[O_(e, c, z)];
                                        if (c += 15 & T, (B = T >> 4) < 16) A[I++] = B;
                                        else {
                                            var k = 0, V = 0;
                                            for(16 == B ? (V = 3 + O_(e, c, 3), c += 2, k = A[I - 1]) : 17 == B ? (V = 3 + O_(e, c, 7), c += 3) : 18 == B && (V = 11 + O_(e, c, 127), c += 7); V--;)A[I++] = k;
                                        }
                                    }
                                    var E = A.subarray(0, b), F = A.subarray(b);
                                    f = L_(E), m = L_(F), p = E_(E, f), d = E_(F, m);
                                } else G_(1);
                                if (c > y) {
                                    a && G_(0);
                                    break;
                                }
                            }
                            o && l(h + 131072);
                            for(var D = (1 << f) - 1, C = (1 << m) - 1, R = c;; R = c){
                                var L = (k = p[U_(e, c) & D]) >> 4;
                                if ((c += 15 & k) > y) {
                                    a && G_(0);
                                    break;
                                }
                                if (k || G_(2), L < 256) r[h++] = L;
                                else {
                                    if (256 == L) {
                                        R = c, p = null;
                                        break;
                                    }
                                    var O = L - 254;
                                    L > 264 && (O = O_(e, c, (1 << (j = __[I = L - 257])) - 1) + z_[I], c += j);
                                    var U = d[U_(e, c) & C], N = U >> 4;
                                    if (U || G_(3), c += 15 & U, F = B_[N], N > 3) {
                                        var j = A_[N];
                                        F += U_(e, c) & (1 << j) - 1, c += j;
                                    }
                                    if (c > y) {
                                        a && G_(0);
                                        break;
                                    }
                                    o && l(h + 131072);
                                    var G = h + O;
                                    if (h < F) {
                                        var $ = 0 - F, q = Math.min(F, G);
                                        for($ + h < 0 && G_(3); h < q; ++h)r[h] = n[$ + h];
                                    }
                                    for(; h < G; ++h)r[h] = r[h - F];
                                }
                            }
                            t1.l = p, t1.p = R, t1.b = h, t1.f = u, p && (u = 1, t1.m = f, t1.d = d, t1.n = m);
                        }while (!u);
                        return h != r.length && s ? function(e, t1, r) {
                            return (null == r || r > e.length) && (r = e.length), new v_(e.subarray(0, r));
                        }(r, 0, h) : r.subarray(0, h);
                    }(r.subarray(o, -8), {
                        i: 2
                    }, new v_(((i = r)[(s = i.length) - 4] | i[s - 3] << 8 | i[s - 2] << 16 | i[s - 1] << 24) >>> 0), n)));
                    var r, n, i, s, o;
                    const a = X_[t1];
                    if (!a) throw new Error(`Unhandled codec: ${t1}`);
                    const l = new globalThis.DecompressionStream(a);
                    return new Response(new Blob([
                        e
                    ]).stream().pipeThrough(l)).arrayBuffer().then((e)=>new Uint8Array(e));
                })(c, u).then((e)=>((function(e, t1) {
                        e.readFields(f_, t1);
                    })(new J_(e), h), new Y_[s](h.buffer))), p.then((e)=>{
                    for(let t1 = l.length - 1; t1 >= 0; t1--)switch(l[t1]){
                        case "delta_filter":
                            y_(e, o);
                            break;
                        case "zigzag_filter":
                            g_(e);
                            break;
                        case "bitshuffle_filter":
                            x_(e, s);
                            break;
                        default:
                            throw new H_(`Unhandled filter "${l[t1]}"`);
                    }
                    return {
                        layerName: t1,
                        blockIndex: a,
                        data: e
                    };
                }).catch((e)=>{
                    throw e;
                });
            }));
        }, Js(eA, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        }), Js(K_, "MapboxRasterTile"), Js(Q_, "MapboxRasterLayer", {
            omit: [
                "_blocksInProgress"
            ]
        });
        class tA {
            constructor(e){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t1 = 0; t1 < e.length; t1++){
                    const r = e[t1];
                    this._stringToNumber[r] = t1, this._numberToString[t1] = r;
                }
            }
            encode(e) {
                return this._stringToNumber[e];
            }
            decode(e) {
                return this._numberToString[e];
            }
        }
        class rA {
            constructor(e, t1){
                this.tileID = e, this.x = e.canonical.x, this.y = e.canonical.y, this.z = e.canonical.z, this.grid = new Ws(Un, 16, 0), this.featureIndexArray = new Tl, this.promoteId = t1, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
            insert(e, t1, r, n, i, s = 0, o = 0) {
                const a = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const l = this.grid;
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e = 0; e < r.length; e++){
                        const t1 = r[e];
                        n[0] = Math.min(n[0], t1.x), n[1] = Math.min(n[1], t1.y), n[2] = Math.max(n[2], t1.x), n[3] = Math.max(n[3], t1.y);
                    }
                    0 !== o && (n[0] -= o, n[1] -= o, n[2] += o, n[3] += o), n[0] < Un && n[1] < Un && n[2] >= 0 && n[3] >= 0 && l.insert(a, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new rc(new Tg(this.rawTileData)).layers, this.sourceLayerCoder = new tA(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e in this.vtLayers)this.vtFeatures[e] = [];
                }
                return this.vtLayers;
            }
            query(e, t1) {
                const { tilespaceGeometry: r, transform: n, tileTransform: i, pixelPosMatrix: s, availableImages: o, worldview: a } = t1;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const l = t1.queryRadius ? t1.queryRadius : 0, u = r.bufferedTilespaceBounds, c = this.grid.query(u.min.x, u.min.y, u.max.x, u.max.y, (e, t1, n, i)=>Rc(r.bufferedTilespaceGeometry, e - l, t1 - l, n + l, i + l));
                c.sort(iA);
                let h = null;
                n.elevation && c.length > 0 && (h = jb.create(n.elevation, this.tileID));
                const p = {};
                let d;
                for(let l = 0; l < c.length; l++){
                    const u = c[l];
                    if (u === d) continue;
                    d = u;
                    const f = this.featureIndexArray.get(u);
                    let m = null;
                    this.is3DTile ? this.loadMatchingModelFeature(p, f, e, r, n, a) : this.loadMatchingFeature(p, f, e, o, a, (e, o, a, l = 0)=>(m || (m = Wu(e, this.tileID.canonical, i)), o.queryIntersectsFeature(r, e, a, m, this.z, n, s, h, l, t1.scope)));
                }
                return p;
            }
            loadMatchingFeature(e, t1, r, n, i, s) {
                const { featureIndex: o, bucketIndex: a, sourceLayerIndex: l, layoutVertexArrayOffset: u } = t1, c = this.bucketLayerIDs[a], h = r.layers, p = Object.keys(h);
                if (p.length && !Xe(p, c)) return;
                const d = r.sourceCache, f = this.sourceLayerCoder.decode(l), m = this.vtLayers[f].feature(o), y = this.getId(m, f);
                for(let t1 = 0; t1 < c.length; t1++){
                    const r = c[t1];
                    if (!h[r]) continue;
                    const { styleLayer: a, targets: l } = h[r];
                    let p = {};
                    void 0 !== y && (p = d.getFeatureState(a.sourceLayer, y));
                    const f = !s || s(m, a, p, u);
                    if (!f) continue;
                    const g = new ew(m, this.z, this.x, this.y, y);
                    g.tile = this.tileID.canonical, g.state = p;
                    let x = this.serializedLayersCache.get(r);
                    x || (x = a.serialize(), x.id = r, this.serializedLayersCache.set(r, x)), g.source = x.source, g.sourceLayer = x["source-layer"], g.layer = Object.assign({}, x), g.layer.paint = nA(x.paint, a.paint, m, p, n), g.layer.layout = nA(x.layout, a.layout, m, p, n);
                    let v = !1;
                    for (const e of l){
                        this.updateFeatureProperties(g, e);
                        const { filter: t1 } = e;
                        if (t1) {
                            if (m.properties = g.properties, t1.needGeometry) {
                                const e = Yu(m, !0);
                                if (!t1.filter(new Yo(this.tileID.overscaledZ, {
                                    worldview: i
                                }), e, this.tileID.canonical)) continue;
                            } else if (!t1.filter(new Yo(this.tileID.overscaledZ, {
                                worldview: i
                            }), m)) continue;
                        }
                        v = !0, e.targetId && this.addFeatureVariant(g, e);
                    }
                    v && this.appendToResult(e, r, o, g, f);
                }
            }
            loadMatchingModelFeature(e, t1, r, n, i, s) {
                const { featureIndex: o, bucketIndex: a } = t1, l = this.bucketLayerIDs[a], u = r.layers, c = Object.keys(u);
                if (!c.length || Xe(c, l)) for(let t1 = 0; t1 < l.length; t1++){
                    const a = l[t1], { styleLayer: c, targets: h } = u[a];
                    if ("model" !== c.type) continue;
                    const p = n.tile, d = p.getBucket(c);
                    if (!(d && d instanceof Wb)) continue;
                    const f = nw(d, o, n, i);
                    if (!f) continue;
                    const { z: m, x: y, y: g } = p.tileID.canonical, { feature: x, intersectionZ: v, position: b } = f;
                    let w = {};
                    void 0 !== x.id && (w = r.sourceCache.getFeatureState(c.sourceLayer, x.id));
                    const _ = new ew({}, m, y, g, x.id);
                    _.tile = this.tileID.canonical, _.state = w, _.properties = x.properties, _.geometry = {
                        type: "Point",
                        coordinates: [
                            b.lng,
                            b.lat
                        ]
                    };
                    let A = this.serializedLayersCache.get(a);
                    A || (A = c.serialize(), A.id = a, this.serializedLayersCache.set(a, A)), _.source = A.source, _.sourceLayer = A["source-layer"], _.layer = Object.assign({}, A);
                    let M = !1;
                    for (const e of h){
                        this.updateFeatureProperties(_, e);
                        const { filter: t1 } = e;
                        if (t1) {
                            if (x.properties = _.properties, t1.needGeometry) {
                                if (!t1.filter(new Yo(this.tileID.overscaledZ, {
                                    worldview: s
                                }), x, this.tileID.canonical)) continue;
                            } else if (!t1.filter(new Yo(this.tileID.overscaledZ, {
                                worldview: s
                            }), x)) continue;
                        }
                        M = !0, e.targetId && this.addFeatureVariant(_, e);
                    }
                    M && this.appendToResult(e, a, o, _, v);
                }
            }
            updateFeatureProperties(e, t1, r) {
                if (t1.properties) {
                    const n = {};
                    for(const i in t1.properties){
                        const s = t1.properties[i].evaluate({
                            zoom: this.z
                        }, e._vectorTileFeature, e.state, e.tile, r);
                        null != s && (n[i] = s);
                    }
                    e.properties = n;
                }
            }
            addFeatureVariant(e, t1, r) {
                const n = {
                    target: t1.target,
                    namespace: t1.namespace,
                    uniqueFeatureID: t1.uniqueFeatureID
                };
                t1.properties && (n.properties = e.properties), e.variants = e.variants || {}, e.variants[t1.targetId] = e.variants[t1.targetId] || [], e.variants[t1.targetId].push(n);
            }
            appendToResult(e, t1, r, n, i) {
                let s = e[t1];
                void 0 === s && (s = e[t1] = []), s.push({
                    featureIndex: r,
                    feature: n,
                    intersectionZ: i
                });
            }
            lookupSymbolFeatures(e, t1, r, n, i, s) {
                const o = {};
                this.loadVTLayers();
                for (const a of e)this.loadMatchingFeature(o, {
                    bucketIndex: t1,
                    sourceLayerIndex: r,
                    featureIndex: a,
                    layoutVertexArrayOffset: 0
                }, n, i, s);
                return o;
            }
            loadFeature(e) {
                const { featureIndex: t1, sourceLayerIndex: r } = e;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[t1]) return i[t1];
                const s = this.vtLayers[n].feature(t1);
                return i[t1] = s, s;
            }
            hasLayer(e) {
                for (const t1 of this.bucketLayerIDs)for (const r of t1)if (e === r) return !0;
                return !1;
            }
            getId(e, t1) {
                let r = e.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[t1];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const e = Us(n);
                                if ("success" !== e.result) {
                                    const t1 = e.value.map((e)=>`${e.key}: ${e.message}`).join(", ");
                                    return void Ze(`Failed to create expression for promoteId: ${t1}`);
                                }
                                this.promoteIdExpression = e.value;
                            }
                            r = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, e);
                        } else r = e.properties[n];
                    }
                    "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
        }
        function nA(e, t1, r, n, i) {
            return Ge(e, (e, s)=>{
                const o = t1 instanceof ia ? t1.get(s) : null;
                return o && o.evaluate ? o.evaluate(r, n, void 0, i) : o;
            });
        }
        function iA(e, t1) {
            return t1 - e;
        }
        Js(rA, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const sA = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class oA {
            static from(e) {
                if (!(e instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [t1, r] = new Uint8Array(e, 0, 2);
                if (219 !== t1) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = sA[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(e, 2, 1), [o] = new Uint32Array(e, 4, 1);
                return new oA(o, s, i, e);
            }
            constructor(e, t1 = 64, r = Float64Array, n){
                if (isNaN(e) || e < 0) throw new Error(`Unpexpected numItems value: ${e}.`);
                this.numItems = +e, this.nodeSize = Math.min(Math.max(+t1, 2), 65535), this.ArrayType = r, this.IndexArrayType = e < 65536 ? Uint16Array : Uint32Array;
                const i = sA.indexOf(this.ArrayType), s = 2 * e * this.ArrayType.BYTES_PER_ELEMENT, o = e * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - o % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, e), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * e), this._pos = 2 * e, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + o + a), this.ids = new this.IndexArrayType(this.data, 8, e), this.coords = new this.ArrayType(this.data, 8 + o + a, 2 * e), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = t1, new Uint32Array(this.data, 4, 1)[0] = e);
            }
            add(e, t1) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = e, this.coords[this._pos++] = t1, r;
            }
            finish() {
                const e = this._pos >> 1;
                if (e !== this.numItems) throw new Error(`Added ${e} items when expected ${this.numItems}.`);
                return aA(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e, t1, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: o } = this, a = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= o) {
                        for(let o = h; o <= c; o++){
                            const a = s[2 * o], u = s[2 * o + 1];
                            a >= e && a <= r && u >= t1 && u <= n && l.push(i[o]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, d = s[2 * p], f = s[2 * p + 1];
                    d >= e && d <= r && f >= t1 && f <= n && l.push(i[p]), (0 === u ? e <= d : t1 <= f) && (a.push(h), a.push(p - 1), a.push(1 - u)), (0 === u ? r >= d : n >= f) && (a.push(p + 1), a.push(c), a.push(1 - u));
                }
                return l;
            }
            within(e, t1, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, o = [
                    0,
                    n.length - 1,
                    0
                ], a = [], l = r * r;
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)hA(i[2 * r], i[2 * r + 1], e, t1) <= l && a.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, d = i[2 * p], f = i[2 * p + 1];
                    hA(d, f, e, t1) <= l && a.push(n[p]), (0 === u ? e - r <= d : t1 - r <= f) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? e + r >= d : t1 + r >= f) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return a;
            }
        }
        function aA(e, t1, r, n, i, s) {
            if (i - n <= r) return;
            const o = n + i >> 1;
            lA(e, t1, o, n, i, s), aA(e, t1, r, n, o - 1, 1 - s), aA(e, t1, r, o + 1, i, 1 - s);
        }
        function lA(e, t1, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const o = i - n + 1, a = r - n + 1, l = Math.log(o), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (o - u) / o) * (a - o / 2 < 0 ? -1 : 1);
                    lA(e, t1, r, Math.max(n, Math.floor(r - a * u / o + c)), Math.min(i, Math.floor(r + (o - a) * u / o + c)), s);
                }
                const o = t1[2 * r + s];
                let a = n, l = i;
                for(uA(e, t1, n, r), t1[2 * i + s] > o && uA(e, t1, n, i); a < l;){
                    for(uA(e, t1, a, l), a++, l--; t1[2 * a + s] < o;)a++;
                    for(; t1[2 * l + s] > o;)l--;
                }
                t1[2 * n + s] === o ? uA(e, t1, n, l) : (l++, uA(e, t1, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function uA(e, t1, r, n) {
            cA(e, r, n), cA(t1, 2 * r, 2 * n), cA(t1, 2 * r + 1, 2 * n + 1);
        }
        function cA(e, t1, r) {
            const n = e[t1];
            e[t1] = e[r], e[r] = n;
        }
        function hA(e, t1, r, n) {
            const i = e - r, s = t1 - n;
            return i * i + s * s;
        }
        e.$ = nn, e.A = Kt, e.B = Cr, e.C = Sa, e.D = qf, e.E = rr, e.F = 2, e.G = Px, e.H = _x, e.I = nr, e.J = Wr, e.K = ca, e.L = Zr, e.M = Jr, e.N = Bs, e.O = Ss, e.P = Ie, e.Q = Ps, e.R = Dt, e.S = Os, e.T = Em, e.U = ha, e.V = Db, e.W = Us, e.X = Gs, e.Y = gi, e.Z = mi, e._ = yi, e.a = function(e) {
            return at.API_CDN_URL_REGEX.test(e);
        }, e.a$ = Eu, e.a0 = Kr, e.a1 = Yr, e.a2 = or, e.a3 = pa, e.a4 = class extends Db {
        }, e.a5 = Ts, e.a6 = zs, e.a7 = ua, e.a8 = function(e) {
            const t1 = e.value;
            return t1 ? Yr(t1) ? Cb(t1, !0) ? [] : [
                new Db(e.key, t1, `invalid url "${t1}"`)
            ] : [
                new Db(e.key, t1, `string expected, "${Zr(t1)}" found`)
            ] : [];
        }, e.a9 = Qo, e.aA = function(e) {
            let t1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of e)t1 = Math.min(t1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                min: new Ie(t1, r),
                max: new Ie(n, i)
            };
        }, e.aB = De, e.aC = h, e.aD = ee, e.aE = xu, e.aF = Cc, e.aG = Tu, e.aH = Gu, e.aI = function(e, t1) {
            const r = {};
            for(let n = 0; n < t1.length; n++){
                const i = t1[n];
                i in e && (r[i] = e[i]);
            }
            return r;
        }, e.aJ = Pu, e.aK = ku, e.aL = class {
            constructor(e){
                this.entries = {}, this.scheduler = e;
            }
            request(e, t1, r, n) {
                const i = this.entries[e] = this.entries[e] || {
                    callbacks: []
                };
                if (i.result) {
                    const [e, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(e, r);
                    }, t1) : n(e, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const e of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e(r, n);
                    }, t1) : e(r, n);
                    setTimeout(()=>delete this.entries[e], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((e)=>e !== n), i.callbacks.length || (i.cancel(), delete this.entries[e]));
                };
            }
        }, e.aM = function(e, t1, r) {
            const n = JSON.stringify(e.request);
            return e.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    e.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: e.isSymbolTile,
                zoom: e.tileZoom
            }, (t1)=>{
                const n = Ot(e.request, (e, n, i)=>{
                    e ? t1(e) : n && t1(null, {
                        rawData: n,
                        vectorTile: r ? void 0 : new rc(new Tg(n)),
                        responseHeaders: new Map(i.entries())
                    });
                });
                return ()=>{
                    n.cancel(), t1();
                };
            }, t1);
        }, e.aN = function(e) {
            return e ? {
                cacheControl: e.get("cache-control"),
                expires: e.get("expires")
            } : {
                cacheControl: void 0,
                expires: void 0
            };
        }, e.aO = Ct, e.aP = function(e) {
            zt++, zt > _t && (e.getActor().send("enforceCacheSizeLimit", wt), zt = 0);
        }, e.aQ = function(e) {
            return e <= 1 ? 1 : Math.pow(2, Math.floor(Math.log2(e)));
        }, e.aR = Wc, e.aS = Ib, e.aT = kb, e.aU = zu, e.aV = _b, e.aW = function(e, t1) {
            const r = document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                t1(null, r);
            };
            for(let t1 = 0; t1 < e.length; t1++){
                const n = document.createElement("source");
                Ut(e[t1]) || (r.crossOrigin = "Anonymous"), n.src = e[t1], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, e.aX = Fm, e.aY = tw, e.aZ = je, e.a_ = zv, e.aa = la, e.ab = sa, e.ac = class {
            constructor(e){
                this.specification = e;
            }
            possiblyEvaluate(e, t1) {
                return Je(e.expression.evaluate(t1));
            }
            interpolate(e, t1, r) {
                return {
                    x: hr(e.x, t1.x, r),
                    y: hr(e.y, t1.y, r),
                    z: hr(e.z, t1.z, r),
                    azimuthal: hr(e.azimuthal, t1.azimuthal, r),
                    polar: hr(e.polar, t1.polar, r)
                };
            }
        }, e.ad = Yo, e.ae = js, e.af = Nu, e.ag = j, e.ah = M, e.ai = Ce, e.aj = ia, e.ak = wh, e.al = hr, e.am = Un, e.an = pr, e.ao = Be, e.ap = ar, e.aq = class {
            constructor(e){
                this.specification = e;
            }
            possiblyEvaluate(e, t1) {
                return function([e, t1]) {
                    const r = Je([
                        1,
                        e,
                        t1
                    ]);
                    return {
                        x: r.x,
                        y: r.y,
                        z: r.z
                    };
                }(e.expression.evaluate(t1));
            }
            interpolate(e, t1, r) {
                return {
                    x: hr(e.x, t1.x, r),
                    y: hr(e.y, t1.y, r),
                    z: hr(e.z, t1.z, r)
                };
            }
        }, e.ar = function(e, t1, r = 0, n = !0) {
            const i = new Ie(r, r), s = e.sub(i), o = t1.add(i), a = [
                s,
                new Ie(o.x, s.y),
                o,
                new Ie(s.x, o.y)
            ];
            return n && a.push(s.clone()), a;
        }, e.as = function(e, t1) {
            const r = [];
            for(let n = 0; n < e.length; n++){
                const i = Re(n - 1, -1, e.length - 1), s = Re(n + 1, -1, e.length - 1), o = e[n], a = e[s], l = e[i].sub(o).unit(), u = a.sub(o).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * t1 / Math.sin(c / 2));
                r.push(o.add(h));
            }
            return r;
        }, e.at = Pv, e.au = Rc, e.av = function(e, t1, r = 0) {
            return I(((t1.x - r) * e.scale - e.x) * Un, (t1.y * e.scale - e.y) * Un, Du(t1.z, t1.y));
        }, e.aw = H, e.ax = L, e.ay = pc, e.az = tg, e.b = function(e) {
            return at.API_FONTS_REGEX.test(e);
        }, e.b$ = Fb, e.b0 = Fu, e.b1 = ol, e.b2 = Na, e.b3 = Ue, e.b4 = _l, e.b5 = ob, e.b6 = function() {
            Wo.isLoading() || Wo.isLoaded() || "deferred" !== Ho() || Zo();
        }, e.b7 = da, e.b8 = Yu, e.b9 = ew, e.bA = l, e.bB = u, e.bC = y, e.bD = a, e.bE = function(e, t1) {
            const { x: r, y: n } = e.point, i = bh(r, n, e.worldSize / e._pixelsPerMercatorPixel, 0, 0);
            return h(i, i, gh(ah(t1)));
        }, e.bF = n, e.bG = q, e.bH = F, e.bI = E, e.bJ = U, e.bK = O, e.bL = dx, e.bM = qg, e.bN = px, e.bO = function(e, t1, r, n, i) {
            const s = 5 * t1 + 2;
            e.float32[s + 0] = r, e.float32[s + 1] = n, e.float32[s + 2] = i;
        }, e.bP = rb, e.bQ = he, e.bR = me, e.bS = de, e.bT = we, e.bU = Re, e.bV = function(e, t1, n, i) {
            var s = new r(4);
            return s[0] = e, s[1] = t1, s[2] = n, s[3] = i, s;
        }, e.bW = class {
            isDataAvailableAtPoint(e) {
                const t1 = this._source();
                if (this.isUsingMockSource() || !t1 || e.y < 0 || e.y > 1) return !1;
                const r = t1.getSource().maxzoom, n = 1 << r, i = Math.floor(e.x), s = Math.floor((e.x - i) * n), o = Math.floor(e.y * n), a = this.findDEMTileFor(new Wc(r, i, r, s, o));
                return !(!a || !a.dem);
            }
            getAtPointOrZero(e, t1 = 0) {
                return this.getAtPoint(e, t1) || 0;
            }
            getAtPoint(e, t1, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == t1 && (t1 = null);
                const n = this._source();
                if (!n) return t1;
                if (e.y < 0 || e.y > 1) return t1;
                const i = n.getSource().maxzoom, s = 1 << i, o = Math.floor(e.x), a = e.x - o, l = new Wc(i, o, i, Math.floor(a * s), Math.floor(e.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return t1;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (a * h - u.tileID.canonical.x) * c.dim, d = (e.y * h - u.tileID.canonical.y) * c.dim, f = Math.floor(p), m = Math.floor(d);
                return (r ? this.exaggeration() : 1) * hr(hr(c.get(f, m), c.get(f, m + 1), d - m), hr(c.get(f + 1, m), c.get(f + 1, m + 1), d - m), p - f);
            }
            static getAtTileOffset(e, t1, r, n) {
                const i = 1 << e.canonical.z;
                return n ? n.pointElevation(t1) : r ? r.getAtPointOrZero(new Nu(e.wrap + (e.canonical.x + t1.x / Un) / i, (e.canonical.y + t1.y / Un) / i)) : 0;
            }
            static getAtTileOffsetFunc(e, t1, r, n) {
                return (i, s, o)=>{
                    const a = this.getAtTileOffset(e, i, s, o), l = n.upVector(e.canonical, i.x, i.y);
                    return V(l, l, a * n.upVectorScale(e.canonical, t1, r).metersToTile), l;
                };
            }
            getForTilePoints(e, t1, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = jb.create(this, e, n);
                return !!i && (t1.forEach((e)=>{
                    e[2] = this.exaggeration() * i.getElevationAt(e[0], e[1], r);
                }), !0);
            }
            getMinMaxForTile(e) {
                if (this.isUsingMockSource()) return null;
                const t1 = this.findDEMTileFor(e);
                if (!t1 || !t1.dem) return null;
                const r = t1.dem.tree, n = t1.tileID, i = 1 << e.canonical.z - n.canonical.z;
                let s = e.canonical.x / i - n.canonical.x, o = e.canonical.y / i - n.canonical.y, a = 0;
                for(let t1 = 0; t1 < e.canonical.z - n.canonical.z && !r.leaves[a]; t1++){
                    s *= 2, o *= 2;
                    const e = 2 * Math.floor(o) + Math.floor(s);
                    a = r.childOffsets[a] + e, s %= 1, o %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[a],
                    max: this.exaggeration() * r.maximums[a]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e, t1, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e = this.visibleDemTiles;
                if (0 === e.length) return null;
                let t1 = !1, r = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const i of e){
                    const e = this.getMinMaxForTile(i.tileID);
                    e && (r = Math.min(r, e.min), n = Math.max(n, e.max), t1 = !0);
                }
                return t1 ? {
                    min: r,
                    max: n
                } : null;
            }
        }, e.bX = Tf, e.bY = Ic, e.bZ = _g, e.b_ = Fd, e.ba = Qe, e.bb = Jy, e.bc = yd, e.bd = Wu, e.be = Oa, e.bf = yl, e.bg = th, e.bh = Rl, e.bi = Yh, e.bj = xb, e.bk = function(e, t1) {
            const r = wh(t1.zoom);
            if (0 === r) return ah(e);
            const n = hh(e), i = ph(n), s = Tu(n.getWest()) * t1.worldSize, o = Tu(n.getEast()) * t1.worldSize, a = ku(n.getNorth()) * t1.worldSize, l = ku(n.getSouth()) * t1.worldSize, u = [
                s,
                a,
                0
            ], h = [
                o,
                a,
                0
            ], p = [
                s,
                l,
                0
            ], d = [
                o,
                l,
                0
            ], f = c([], t1.globeMatrix);
            return j(u, u, f), j(h, h, f), j(p, p, f), j(d, d, f), i[0] = lh(i[0], p, r), i[1] = lh(i[1], d, r), i[2] = lh(i[2], h, r), i[3] = lh(i[3], u, r), vc.fromPoints(i);
        }, e.bl = yh, e.bm = c, e.bn = dh, e.bo = lh, e.bp = Ua, e.bq = eh, e.br = g, e.bs = p, e.bt = K_, e.bu = Tg, e.bv = Ot, e.bw = function(e, t1) {
            const r = [];
            for(const n in e)n in t1 || r.push(n);
            return r;
        }, e.bx = Le, e.by = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], e.bz = Se, e.c = ut, e.c$ = 5, e.c0 = Gd, e.c1 = $d, e.c2 = rx, e.c3 = tv, e.c4 = fv, e.c5 = oA, e.c6 = V, e.c7 = W, e.c8 = re, e.c9 = function(e, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = Math.sin(r), l = Math.cos(r);
            return e[0] = n * l + i * a, e[1] = i * l - n * a, e[2] = s * l + o * a, e[3] = o * l - s * a, e;
        }, e.cA = N, e.cB = _, e.cC = xc, e.cD = Gm, e.cE = Hc, e.cF = ch, e.cG = function(e, t1, r, n, i, s, o, a, l) {
            if ("globe" === l.name) return ch(e, t1, new Hc(r, n, i), !1);
            const u = zv({
                z: r,
                x: n,
                y: i
            }, l);
            return new vc([
                (s + u.x / u.scale) * t1,
                t1 * (u.y / u.scale),
                o
            ], [
                (s + u.x2 / u.scale) * t1,
                t1 * (u.y2 / u.scale),
                a
            ]);
        }, e.cH = function(e, t1, r) {
            return e[0] = Math.min(t1[0], r[0]), e[1] = Math.min(t1[1], r[1]), e[2] = Math.min(t1[2], r[2]), e[3] = Math.min(t1[3], r[3]), e;
        }, e.cI = function(e, t1, r) {
            return e[0] = Math.max(t1[0], r[0]), e[1] = Math.max(t1[1], r[1]), e[2] = Math.max(t1[2], r[2]), e[3] = Math.max(t1[3], r[3]), e;
        }, e.cJ = function(e) {
            const t1 = Math.round((e + 45 + 360) % 360 / 90) % 4;
            return ke[t1];
        }, e.cK = Cu, e.cL = J, e.cM = 6, e.cN = function(e) {
            const t1 = u(new Float64Array(16));
            h(t1, e.pixelMatrix, e.globeMatrix);
            const r = [
                0,
                wu,
                0
            ], n = [
                0,
                _u,
                0
            ];
            return j(r, r, t1), j(n, n, t1), [
                r[0] > 0 && r[0] <= e.width && r[1] > 0 && r[1] <= e.height && !Ah(e, new zu(e.center.lat, 90)),
                n[0] > 0 && n[0] <= e.width && n[1] > 0 && n[1] <= e.height && !Ah(e, new zu(e.center.lat, -90))
            ];
        }, e.cO = function(e, t1) {
            const { scale: r } = e.tileTransform, n = r * Un / (e.tileSize * Math.pow(2, t1.zoom - e.tileID.overscaledZ + e.tileID.canonical.z));
            return function(e, t1, r) {
                var n = t1[1], i = t1[2], s = t1[3], o = r[0], a = r[1];
                return e[0] = t1[0] * o, e[1] = n * o, e[2] = i * a, e[3] = s * a, e;
            }(new Float32Array(4), t1.inverseAdjustmentMatrix, [
                n,
                n
            ]);
        }, e.cP = $m, e.cQ = w, e.cR = jm, e.cS = function(e) {
            const t1 = jm(e, !0);
            return n([], [
                t1[0],
                t1[1],
                t1[4],
                t1[5]
            ]);
        }, e.cT = d, e.cU = dc, e.cV = f, e.cW = function(e) {
            const { x: t1, y: r } = e.point, { lng: n, lat: i } = e._center;
            return bh(t1, r, e.worldSize, n, i);
        }, e.cX = B, e.cY = Te, e.cZ = Yc, e.c_ = Lc, e.ca = ne, e.cb = tt, e.cc = function(e, t1) {
            return e[0] = -t1[0], e[1] = -t1[1], e[2] = -t1[2], e[3] = t1[3], e;
        }, e.cd = b, e.ce = function(e, t1, r, n, i) {
            var s = 1 / Math.tan(t1 / 2);
            if (e[0] = s / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, null != i && i !== 1 / 0) {
                var o = 1 / (n - i);
                e[10] = (i + n) * o, e[14] = 2 * i * n * o;
            } else e[10] = -1, e[14] = -2 * n;
            return e;
        }, e.cf = function(e, t1, r, n, i, s, o) {
            var a = 1 / (t1 - r), l = 1 / (n - i), u = 1 / (s - o);
            return e[0] = -2 * a, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * l, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * u, e[11] = 0, e[12] = (t1 + r) * a, e[13] = (i + n) * l, e[14] = (o + s) * u, e[15] = 1, e;
        }, e.cg = Vu, e.ch = function(e, t1, r) {
            e[4 * t1 + 0] = r[0], e[4 * t1 + 1] = r[1], e[4 * t1 + 2] = r[2], e[4 * t1 + 3] = r[3];
        }, e.ci = Hl, e.cj = Yl, e.ck = Zl, e.cl = Wl, e.cm = eu, e.cn = Wv, e.co = function() {
            var e = new r(4);
            return r != Float32Array && (e[1] = 0, e[2] = 0), e[0] = 1, e[3] = 1, e;
        }, e.cp = function(e, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], o = t1[3], a = Math.sin(r), l = Math.cos(r);
            return e[0] = n * l + s * a, e[1] = i * l + o * a, e[2] = n * -a + s * l, e[3] = i * -a + o * l, e;
        }, e.cq = function(e, t1) {
            return e[0] === t1[0] && e[1] === t1[1] && e[2] === t1[2] && e[3] === t1[3];
        }, e.cr = X, e.cs = function(e) {
            var t1 = e[0], r = e[1], n = e[2], i = e[3];
            return Math.sqrt(t1 * t1 + r * r + n * n + i * i);
        }, e.ct = le, e.cu = $, e.cv = Zc, e.cw = 3, e.cx = 2, e.cy = 7, e.cz = 6, e.d = function(e) {
            return at.API_TILEJSON_REGEX.test(e);
        }, e.d$ = il, e.d0 = function(e, t1, r) {
            let n = 0;
            for(let r = 0; r < 2; ++r){
                const i = 0;
                e[r] > i && (n += (e[r] - i) * (e[r] - i)), t1[r] < i && (n += (i - t1[r]) * (i - t1[r]));
            }
            return n;
        }, e.d1 = function(e) {
            return e * e * e * e * e;
        }, e.d2 = Bu, e.d3 = 45, e.d4 = Jl, e.d5 = function(e, t1, r) {
            const n = Math.sqrt(e * e + t1 * t1 + r * r), i = n > 0 ? Math.acos(r / n) * Pe : 0;
            let s = 0 !== e || 0 !== t1 ? Math.atan2(-t1, -e) * Pe + 90 : 0;
            return s < 0 && (s += 360), [
                n,
                s,
                i
            ];
        }, e.d6 = I, e.d7 = Je, e.d8 = Uu, e.d9 = z, e.dA = class extends ew {
            constructor(e, t1){
                super(e._vectorTileFeature, e._z, e._x, e._y, e.id), e.state && (this.state = Object.assign({}, e.state)), this.target = t1.target, this.namespace = t1.namespace, t1.properties && (this.properties = t1.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = e.source, this.sourceLayer = e.sourceLayer, this.layer = e.layer);
            }
            toJSON() {
                const e = super.toJSON();
                return e.target = this.target, e.namespace = this.namespace, e;
            }
        }, e.dB = Xo, e.dC = function(e) {
            return e({
                pluginStatus: jo,
                pluginURL: Go
            }), Xo.on("pluginStateChange", e), e;
        }, e.dD = Kl, e.dE = class extends Xl {
            constructor(e){
                super(e), this.current = tu;
            }
            set(e, t1, r) {
                if (this.fetchUniformLocation(e, t1)) {
                    for(let e = 0; e < 9; e++)if (r[e] !== this.current[e]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, e.dF = Ve, e.dG = function(e, t1, r) {
            const n = wh(r.zoom), i = e.style.map._antialias, s = e.terrain && e.terrain.exaggeration() > 0;
            return 0 === n && !i && !s;
        }, e.dH = function(e) {
            const t1 = e.pixelsPerMeter, r = t1 / Vu(1, e.center.lat), n = u(new Float64Array(16));
            return p(n, n, [
                e.point.x,
                e.point.y,
                0
            ]), d(n, n, [
                r,
                r,
                t1
            ]), Float32Array.from(n);
        }, e.dI = hh, e.dJ = function(e) {
            const t1 = 80.051129;
            e = De(e, -80.051129, t1) / t1 * 90;
            const r = Math.pow(Math.abs(Math.sin(Be(e))), 3);
            return Math.round(r * (bu.length - 1));
        }, e.dK = function(e, t1, r, n) {
            const i = t1.getNorth(), s = t1.getSouth(), a = t1.getWest(), l = t1.getEast(), u = 1 << e.z, c = l - a, h = i - s, p = c / vu, d = -h / bu[r], f = [
                0,
                p,
                0,
                d,
                0,
                0,
                i,
                a,
                0
            ];
            if (e.z > 0) {
                const e = 180 / n;
                o(f, f, [
                    e / c + 1,
                    0,
                    0,
                    0,
                    e / h + 1,
                    0,
                    -0.5 * e / p,
                    .5 * e / d,
                    1
                ]);
            }
            return f[2] = u, f[5] = e.x, f[8] = e.y, f;
        }, e.dL = ah, e.dM = function(e, t1, r) {
            const n = u(new Float64Array(16)), i = (t1 / (1 << e) - .5) * Math.PI * 2;
            return m(n, r.globeMatrix, i), Float32Array.from(n);
        }, e.dN = $h, e.dO = rh, e.dP = function(e, t1) {
            return [
                Math.pow(e[0], 2.2) * t1,
                Math.pow(e[1], 2.2) * t1,
                Math.pow(e[2], 2.2) * t1
            ];
        }, e.dQ = i, e.dR = function(e, t1) {
            var r = Math.sin(t1), n = Math.cos(t1);
            return e[0] = n, e[1] = r, e[2] = 0, e[3] = -r, e[4] = n, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
        }, e.dS = G, e.dT = vh, e.dU = it, e.dV = st, e.dW = Ab, e.dX = function(e, t1) {
            const r = [
                0,
                0,
                0
            ];
            return j(r, r, yh(ah(t1.canonical))), j(r, r, e), r;
        }, e.dY = (e)=>({
                u_matrix: new eu(e),
                u_texsize: new Wl(e),
                u_pixels_to_tile_units: new nu(e),
                u_device_pixel_ratio: new Zl(e),
                u_width_scale: new Zl(e),
                u_floor_width_scale: new Zl(e),
                u_image: new Hl(e),
                u_units_to_pixels: new Wl(e),
                u_tile_units_to_pixels: new Zl(e),
                u_alpha_discard_threshold: new Zl(e),
                u_trim_offset: new Wl(e),
                u_trim_fade_range: new Wl(e),
                u_trim_gradient_mix_range: new Wl(e),
                u_trim_color: new Jl(e),
                u_zbias_factor: new Zl(e),
                u_tile_to_meter: new Zl(e),
                u_ground_shadow_factor: new Yl(e),
                u_pattern_transition: new Zl(e)
            }), e.dZ = (e)=>({
                u_matrix: new eu(e),
                u_pixels_to_tile_units: new nu(e),
                u_device_pixel_ratio: new Zl(e),
                u_width_scale: new Zl(e),
                u_floor_width_scale: new Zl(e),
                u_units_to_pixels: new Wl(e),
                u_dash_image: new Hl(e),
                u_gradient_image: new Hl(e),
                u_image_height: new Zl(e),
                u_texsize: new Wl(e),
                u_tile_units_to_pixels: new Zl(e),
                u_alpha_discard_threshold: new Zl(e),
                u_trim_offset: new Wl(e),
                u_trim_fade_range: new Wl(e),
                u_trim_gradient_mix_range: new Wl(e),
                u_trim_color: new Jl(e),
                u_zbias_factor: new Zl(e),
                u_tile_to_meter: new Zl(e),
                u_ground_shadow_factor: new Yl(e)
            }), e.d_ = (e)=>({
                u_camera_to_center_distance: new Zl(e),
                u_extrude_scale: new nu(e),
                u_device_pixel_ratio: new Zl(e),
                u_matrix: new eu(e),
                u_inv_rot_matrix: new eu(e),
                u_merc_center: new Wl(e),
                u_tile_id: new Yl(e),
                u_zoom_transition: new Zl(e),
                u_up_dir: new Yl(e),
                u_emissive_strength: new Zl(e)
            }), e.da = vc, e.db = P, e.dc = function(e) {
            return [
                Math.pow(e[0], 1 / 2.2),
                Math.pow(e[1], 1 / 2.2),
                Math.pow(e[2], 1 / 2.2)
            ];
        }, e.dd = Tm, e.de = my, e.df = ty, e.dg = Cb, e.dh = function(e, t1) {
            return e.readFields(ow, {
                icons: []
            }, t1);
        }, e.di = zc, e.dj = class {
            static calculate(e, t1, r) {
                const n = new Set, i = new Map, s = new Set, o = new Set;
                for (const r of Object.values(e))for (const [e, a] of Object.entries(r.floors)){
                    s.add(e), a.isDefault && o.add(e), a.conflicts && i.set(e, a.conflicts);
                    const r = e === t1, l = a.connections && t1 && a.connections.has(t1);
                    (r || l) && n.add(e);
                }
                const a = (e)=>{
                    const t1 = i.get(e) || new Set;
                    for (const r of n)if ((i.get(r) || new Set).has(e) || t1.has(r)) return !0;
                    return !1;
                };
                if (r) for (const e of r)s.has(e) && (a(e) || n.add(e));
                for (const e of o)n.has(e) || a(e) || n.add(e);
                return n;
            }
        }, e.dk = Zf, e.dl = Rx, e.dm = Cx, e.dn = Rt, e.dp = $o, e.dq = vt, e.dr = Jt, e.ds = qe, e.dt = function(e) {
            const t1 = e.indexOf(Ia);
            return t1 >= 0 ? e.slice(0, t1) : e;
        }, e.du = function(e) {
            return e.indexOf(Ia) >= 0;
        }, e.dv = function(e) {
            const t1 = e.lastIndexOf(Ia);
            return t1 >= 0 ? e.slice(t1 + 1) : "";
        }, e.dw = function(e) {
            const t1 = [], r = e.id;
            return void 0 === r && t1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === e.render && t1.push({
                message: `layers.${r}: missing required method "render"`
            }), e.renderingMode && "2d" !== e.renderingMode && "3d" !== e.renderingMode && t1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), t1;
        }, e.dx = function(e, t1, r, n) {
            return "custom" === e.type ? new Vb(e, t1) : new iw[e.type](e, t1, r, n);
        }, e.dy = $e, e.dz = function(e) {
            const t1 = e.indexOf(Ia);
            return t1 >= 0 ? e.slice(t1 + 1) : "";
        }, e.e = at, e.e$ = Z, e.e0 = wg, e.e1 = class {
            constructor(e, t1, r, n){
                this.context = e, this.format = n, this.size = r, this.texture = e.gl.createTexture();
                const [i, s, o] = this.size, { gl: a } = e;
                a.bindTexture(a.TEXTURE_3D, this.texture), e.pixelStoreUnpackFlipY.set(!1), e.pixelStoreUnpack.set(1), e.pixelStoreUnpackPremultiplyAlpha.set(!1), "data" in t1 && t1.data && a.texImage3D(a.TEXTURE_3D, 0, this.format, i, s, o, 0, km(this.format), Vm(this.format), t1.data);
            }
            bind(e, t1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_3D, this.texture), e !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, e), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, e), this.minFilter = e), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            destroy() {
                const { gl: e } = this.context;
                e.deleteTexture(this.texture), this.texture = null;
            }
        }, e.e2 = Ph, e.e3 = (e, t1, r, n, i, s)=>{
            const o = e.transform, a = "globe" === o.projection.name;
            let l;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                if (a) {
                    const e = vh(o.zoom, t1.canonical) * o._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e,
                        0,
                        0,
                        e
                    ]);
                } else l = o.calculatePixelsToTileUnitsMatrix(r);
            } else l = new Float32Array([
                o.pixelsToGLUnits[0],
                0,
                0,
                o.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: e.transform.getCameraToCenterDistance(o.projection),
                u_matrix: e.translatePosMatrix(t1.projMatrix, r, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: gt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: zh,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: s.paint.get("circle-emissive-strength")
            };
            if (a) {
                u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [
                    t1.canonical.x,
                    t1.canonical.y,
                    1 << t1.canonical.z
                ], u.u_zoom_transition = wh(o.zoom);
                const e = i[0] * Un, r = i[1] * Un;
                u.u_up_dir = o.projection.upVector(new Hc(0, 0, 0), e, r);
            }
            return u;
        }, e.e4 = sg, e.e5 = Rr, e.e6 = (e, t1, r, n, i, s, o, a, l, u)=>{
            const c = e.transform, h = c.pitch < 15 ? rg(.07, .7, De((14 - c.zoom) / 5, 0, 1)) : .07, p = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: ig(e, t1, r, n),
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: c.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: i,
                u_width_scale: s,
                u_floor_width_scale: o,
                u_image: 0,
                u_tile_units_to_pixels: ng(t1, c),
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: a,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(p ? null : r.lut).toArray01(),
                u_zbias_factor: h,
                u_tile_to_meter: Uu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: l,
                u_pattern_transition: u
            };
        }, e.e7 = (e, t1, r, n, i, s, o, a, l, u)=>{
            const c = e.transform, h = c.calculatePixelsToTileUnitsMatrix(t1), p = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default"), d = c.pitch < 15 ? rg(.07, .7, De((14 - c.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: ig(e, t1, r, n),
                u_pixels_to_tile_units: h,
                u_device_pixel_ratio: s,
                u_width_scale: o,
                u_floor_width_scale: a,
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: i,
                u_texsize: og(r) && t1.lineAtlasTexture ? t1.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: ng(t1, e.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(p ? null : r.lut).toArray01(),
                u_zbias_factor: d,
                u_tile_to_meter: Uu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: u
            };
        }, e.e8 = Ne, e.e9 = qh, e.eA = te, e.eB = v, e.eC = function(e, t1) {
            var n = new r(3);
            v(n, t1);
            var i = 1 / n[0], s = 1 / n[1], o = 1 / n[2], a = t1[0] * i, l = t1[1] * s, u = t1[2] * o, c = t1[4] * i, h = t1[5] * s, p = t1[6] * o, d = t1[8] * i, f = t1[9] * s, m = t1[10] * o, y = a + h + m, g = 0;
            return y > 0 ? (g = 2 * Math.sqrt(y + 1), e[3] = .25 * g, e[0] = (p - f) / g, e[1] = (d - u) / g, e[2] = (l - c) / g) : a > h && a > m ? (g = 2 * Math.sqrt(1 + a - h - m), e[3] = (p - f) / g, e[0] = .25 * g, e[1] = (l + c) / g, e[2] = (d + u) / g) : h > m ? (g = 2 * Math.sqrt(1 + h - a - m), e[3] = (d - u) / g, e[0] = (l + c) / g, e[1] = .25 * g, e[2] = (p + f) / g) : (g = 2 * Math.sqrt(1 + m - a - h), e[3] = (l - c) / g, e[0] = (d + u) / g, e[1] = (p + f) / g, e[2] = .25 * g), e;
        }, e.eD = function(e, r) {
            var n = 2 * Math.acos(r[3]), i = Math.sin(n / 2);
            return i > t1 ? (e[0] = r[0] / i, e[1] = r[1] / i, e[2] = r[2] / i) : (e[0] = 1, e[1] = 0, e[2] = 0), n;
        }, e.eE = rw, e.eF = ey, e.eG = Ym, e.eH = [
            1,
            1,
            1
        ], e.eI = jb, e.eJ = Y, e.eK = function(e, t1, r, n) {
            var i = t1[0], s = t1[1], o = t1[2], a = t1[3];
            return e[0] = i + n * (r[0] - i), e[1] = s + n * (r[1] - s), e[2] = o + n * (r[2] - o), e[3] = a + n * (r[3] - a), e;
        }, e.eL = Qm, e.eM = tl, e.eN = fl, e.eO = function(e, t1, n, i, s, o, a, l, u, c, h, p, d, f, m, y) {
            var g = new r(16);
            return g[0] = e, g[1] = t1, g[2] = n, g[3] = i, g[4] = s, g[5] = o, g[6] = a, g[7] = l, g[8] = u, g[9] = c, g[10] = h, g[11] = p, g[12] = d, g[13] = f, g[14] = m, g[15] = y, g;
        }, e.eP = Iu, e.eQ = dl, e.eR = pl, e.eS = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new Ie(1 / 0, 1 / 0),
                    max: new Ie(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e, t1 = !1) {
                const r = Od(new Ie(0, 0), new Ie(Un, Un), e), n = [];
                if (t1 && !Rd(r, this._globalClipBounds)) return n;
                for (const t1 of this._activeRegions){
                    if (t1.hiddenByOverlap) continue;
                    if (!Rd(r, t1)) continue;
                    const i = Ud(t1.min, t1.max, e);
                    n.push({
                        min: i.min,
                        max: i.max,
                        sourceId: this._sourceIds[t1.priority],
                        footprint: t1.footprint,
                        footprintTileId: t1.tileId,
                        order: t1.order,
                        clipMask: t1.clipMask,
                        clipScope: t1.clipScope
                    });
                }
                return n;
            }
            setSources(e) {
                this._setSources(e.map((e)=>({
                        getSourceId: ()=>e.cache.id,
                        getFootprints: ()=>{
                            const t1 = [];
                            for (const r of e.cache.getVisibleCoordinates()){
                                const n = e.cache.getTile(r).buckets[e.layer];
                                n && n.updateFootprints(r.toUnwrapped(), t1);
                            }
                            return t1;
                        },
                        getOrder: ()=>e.order,
                        getClipMask: ()=>e.clipMask,
                        getClipScope: ()=>e.clipScope
                    })));
            }
            _addSource(e) {
                const t1 = e.getFootprints();
                if (0 === t1.length) return;
                const r = e.getOrder(), n = e.getClipMask(), i = e.getClipScope();
                for (const e of t1){
                    if (!e.footprint) continue;
                    const t1 = Od(e.footprint.min, e.footprint.max, e.id);
                    this._activeRegions.push({
                        min: t1.min,
                        max: t1.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: e.id,
                        footprint: e.footprint,
                        order: r,
                        clipMask: n,
                        clipScope: i
                    });
                }
                this._sourceIds.push(e.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((e, t1)=>e.priority - t1.priority || Dd(e.min, t1.min) || Dd(e.max, t1.max) || e.order - t1.order || e.clipMask - t1.clipMask || function(e, t1) {
                        const r = (e, t1)=>e + t1;
                        return e.length - t1.length || e.reduce(r, "").localeCompare(t1.reduce(r, ""));
                    }(e.clipScope, t1.clipScope));
                let e = this._activeRegions.length !== this._prevRegions.length;
                if (!e) {
                    let t1 = 0;
                    for(; !e && t1 !== this._activeRegions.length;){
                        const r = this._activeRegions[t1], n = this._prevRegions[t1];
                        e = r.priority !== n.priority || !Cd(r, n) || r.order !== n.order || r.clipMask !== n.clipMask || !Se(r.clipScope, n.clipScope), this._activeRegions[t1].hiddenByOverlap = n.hiddenByOverlap, ++t1;
                    }
                }
                if (e) {
                    ++this._updateTime;
                    for (const e of this._activeRegions)e.order !== Vd && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, e.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, e.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, e.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, e.max.y));
                    const e = (e)=>{
                        const t1 = this._activeRegions;
                        if (e >= t1.length) return e;
                        const r = t1[e].priority;
                        for(; e < t1.length && t1[e].priority === r;)++e;
                        return e;
                    };
                    if (this._sourceIds.length > 1) {
                        let t1 = 0, r = e(t1);
                        for(; t1 !== r;){
                            let n = t1;
                            const i = t1;
                            for(; n !== r;){
                                const e = this._activeRegions[n];
                                e.hiddenByOverlap = !1;
                                for(let t1 = 0; t1 < i; t1++){
                                    const r = this._activeRegions[t1];
                                    if (!r.hiddenByOverlap && e.order === Vd && Rd(e, r) && (e.hiddenByOverlap = jd(e.footprint, e.tileId, r.footprint, r.tileId), e.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            t1 = r, r = e(t1);
                        }
                    }
                }
            }
            _setSources(e) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t1 = e.length - 1; t1 >= 0; t1--)this._addSource(e[t1]);
                this._computeReplacement();
            }
        }, e.eT = Vd, e.eU = class {
            constructor(e){
                this._createGrid(e), this._createPoles(e);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e of this._poleSegments)e.destroy();
                for (const e of this._gridSegments)e.withSkirts.destroy(), e.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e, t1) {
                const r = new Oa, n = new ol, i = [], s = e + 1 + 2, o = t1[0] + 1, a = t1[0] + 1 + (1 + t1.length), l = (e, t1, r)=>{
                    let n = e === s - 1 ? e - 2 : 0 === e ? e : e - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        t1
                    ];
                };
                for(let e = 0; e < s; ++e)r.emplaceBack(...l(e, 0, !0));
                for(let e = 0; e < o; ++e)for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, e, (0 === t1 || t1 === s - 1) && !0));
                for(let e = 0; e < t1.length; ++e){
                    const n = t1[e];
                    for(let e = 0; e < s; ++e)r.emplaceBack(...l(e, n, !0));
                }
                for(let e = 0; e < t1.length; ++e){
                    const o = n.length, l = t1[e] + 1 + 2, u = new ol;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, o = i ? s * (a - t1.length + e - r) : s;
                        for(let e = 0; e < s - 1; e++){
                            const t1 = r * s + e;
                            0 === r || i || 0 === e || e === s - 2 ? (u.emplaceBack(t1 + 1, t1, t1 + o), u.emplaceBack(t1 + o, t1 + o + 1, t1 + 1)) : (n.emplaceBack(t1 + 1, t1, t1 + o), n.emplaceBack(t1 + o, t1 + o + 1, t1 + 1));
                        }
                    }
                    const c = Rl.simpleSegment(0, o, r.length, n.length - o);
                    for(let e = 0; e < u.uint16.length; e += 3)n.emplaceBack(u.uint16[e], u.uint16[e + 1], u.uint16[e + 2]);
                    const h = Rl.simpleSegment(0, o, r.length, n.length - o);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(e) {
                const t1 = this._fillGridMeshWithLods(vu, bu);
                this._gridSegments = t1.segments, this._gridBuffer = e.createVertexBuffer(t1.vertices, th.members), this._gridIndexBuffer = e.createIndexBuffer(t1.indices, !0);
            }
            _createPoles(e) {
                const t1 = new ol;
                for(let e = 0; e <= vu; e++)t1.emplaceBack(0, e + 1, e + 2);
                this._poleIndexBuffer = e.createIndexBuffer(t1, !0);
                const r = new cl, n = new cl, i = new cl, s = new cl;
                this._poleSegments = [];
                for(let e = 0, t1 = 0; e < 6; e++){
                    const o = 360 / (1 << e);
                    r.emplaceBack(0, -xu, 0, .5, 0), n.emplaceBack(0, -xu, 0, .5, 1), i.emplaceBack(0, -xu, 0, .5, .5), s.emplaceBack(0, -xu, 0, .5, .5);
                    for(let e = 0; e <= vu; e++){
                        let t1 = e / vu, a = 0;
                        const l = hr(0, o, t1), [u, c, h] = Au(Ih, Sh, l, xu);
                        r.emplaceBack(u, c, h, t1, a), n.emplaceBack(u, c, h, t1, 1 - a);
                        const p = Be(l);
                        t1 = .5 + .5 * Math.sin(p), a = .5 + .5 * Math.cos(p), i.emplaceBack(u, c, h, t1, a), s.emplaceBack(u, c, h, t1, 1 - a);
                    }
                    this._poleSegments.push(Rl.simpleSegment(t1, 0, 66, 64)), t1 += 66;
                }
                this._poleNorthVertexBuffer = e.createVertexBuffer(r, Qc, !1), this._poleSouthVertexBuffer = e.createVertexBuffer(n, Qc, !1), this._texturedPoleNorthVertexBuffer = e.createVertexBuffer(i, Qc, !1), this._texturedPoleSouthVertexBuffer = e.createVertexBuffer(s, Qc, !1);
            }
            getGridBuffers(e, t1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t1 ? this._gridSegments[e].withSkirts : this._gridSegments[e].withoutSkirts
                ];
            }
            getPoleBuffers(e, t1) {
                return [
                    t1 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t1 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e]
                ];
            }
        }, e.eV = Ed, e.eW = Ee, e.eX = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, e.eY = Fe, e.eZ = Ou, e.e_ = function(e, t1, r) {
            return e[0] = t1[0] / r[0], e[1] = t1[1] / r[1], e[2] = t1[2] / r[2], e;
        }, e.ea = Du, e.eb = Jc, e.ec = pf, e.ed = wf, e.ee = Qd, e.ef = 450, e.eg = 7, e.eh = Lu, e.ei = function(e, t1) {
            if (e === t1) {
                var r = t1[1], n = t1[2], i = t1[3], s = t1[6], o = t1[7], a = t1[11];
                e[1] = t1[4], e[2] = t1[8], e[3] = t1[12], e[4] = r, e[6] = t1[9], e[7] = t1[13], e[8] = n, e[9] = s, e[11] = t1[14], e[12] = i, e[13] = o, e[14] = a;
            } else e[0] = t1[0], e[1] = t1[4], e[2] = t1[8], e[3] = t1[12], e[4] = t1[1], e[5] = t1[5], e[6] = t1[9], e[7] = t1[13], e[8] = t1[2], e[9] = t1[6], e[10] = t1[10], e[11] = t1[14], e[12] = t1[3], e[13] = t1[7], e[14] = t1[11], e[15] = t1[15];
            return e;
        }, e.ej = Mb, e.ek = Ra, e.el = vl, e.em = 256, e.en = function(e) {
            return e >>>= 0, e = Math.imul(2747636419 ^ e, 2654435769) >>> 0, e = Math.imul(e ^ e >>> 16, 2654435769) >>> 0, (e = Math.imul(e ^ e >>> 16, 2654435769) >>> 0) / 4294967296;
        }, e.eo = gh, e.ep = Ha, e.eq = m, e.er = function(e, t1) {
            return e[0] = t1[0], e[1] = t1[1], e[2] = t1[2], e[3] = t1[4], e[4] = t1[5], e[5] = t1[6], e[6] = t1[8], e[7] = t1[9], e[8] = t1[10], e;
        }, e.es = cl, e.et = hl, e.eu = function(e, t1, r, n, i) {
            return De((e - t1) / (r - t1) * (i - n) + n, n, i);
        }, e.ev = ie, e.ew = function(e, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], o = t1[4], a = t1[5], l = t1[6], u = t1[7], c = t1[8], h = c * o - a * u, p = -c * s + a * l, d = u * s - o * l, f = r * h + n * p + i * d;
            return f ? (e[0] = h * (f = 1 / f), e[1] = (-c * n + i * u) * f, e[2] = (a * n - i * o) * f, e[3] = p * f, e[4] = (c * r - i * l) * f, e[5] = (-a * r + i * s) * f, e[6] = d * f, e[7] = (-u * r + n * l) * f, e[8] = (o * r - n * s) * f, e) : null;
        }, e.ex = fs, e.ey = 2, e.ez = R, e.f = function(e) {
            return btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (e, t1)=>String.fromCharCode(Number("0x" + t1))));
        }, e.f0 = Mu, e.f1 = C, e.f2 = S, e.f3 = function([e, t1, r]) {
            const n = Math.hypot(e, t1, r), i = Math.atan2(e, r), s = .5 * Math.PI - Math.acos(-t1 / n);
            return new zu(Te(i), Te(s));
        }, e.f4 = K, e.f5 = Xm, e.f6 = function(e) {
            const t1 = e.navigator ? e.navigator.userAgent : null;
            return !!function(e) {
                if (null == et) {
                    const t1 = e.navigator ? e.navigator.userAgent : null;
                    et = !!e.safari || !(!t1 || !(/\b(iPad|iPhone|iPod)\b/.test(t1) || t1.match("Safari") && !t1.match("Chrome")));
                }
                return et;
            }(e) && !(!t1 || !(t1.match("Version/15.4") || t1.match("Version/15.5") || t1.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/)));
        }, e.f7 = function(e, t1) {
            wt = e, _t = t1;
        }, e.f8 = Ah, e.f9 = _h, e.fA = function(e, t1, r, n, i, s, o, a = 1, l, u, c, h) {
            e.createArrays(), e.tilePixelRatio = Un / (512 * e.overscaling), e.compareText = {}, e.iconsNeedLinear = !1;
            const p = e.layers[0].layout, d = e.layers[0]._unevaluatedLayout._values, f = {};
            f.scaleFactor = a, f.textSizeScaleRange = p.get("text-size-scale-range"), f.iconSizeScaleRange = p.get("icon-size-scale-range");
            const [m, y] = f.textSizeScaleRange, [g, x] = f.iconSizeScaleRange;
            f.textScaleFactor = De(f.scaleFactor, m, y), f.iconScaleFactor = De(f.scaleFactor, g, x);
            const v = d["text-size"], b = d["icon-size"];
            if ("composite" === e.textSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e.textSizeData;
                f.compositeTextSizes = [
                    v.possiblyEvaluate(new Yo(t1, {
                        worldview: c
                    }), s),
                    v.possiblyEvaluate(new Yo(r, {
                        worldview: c
                    }), s)
                ];
            }
            if ("composite" === e.iconSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e.iconSizeData;
                f.compositeIconSizes = [
                    b.possiblyEvaluate(new Yo(t1, {
                        worldview: c
                    }), s, h),
                    b.possiblyEvaluate(new Yo(r, {
                        worldview: c
                    }), s, h)
                ];
            }
            f.layoutTextSize = v.possiblyEvaluate(new Yo(o + 1, {
                worldview: c
            }), s), f.layoutIconSize = b.possiblyEvaluate(new Yo(o + 1, {
                worldview: c
            }), s, h), f.textMaxSize = v.possiblyEvaluate(new Yo(18, {
                worldview: c
            }), s);
            const w = p.get("symbol-placement"), _ = "map" === p.get("text-rotation-alignment") && "point" !== w, A = p.get("text-size");
            let M = !1;
            const I = [];
            for (const o of e.features){
                const a = p.get("text-font").evaluate(o, {}, s).join(","), m = A.evaluate(o, {}, s) * f.textScaleFactor, y = f.layoutTextSize.evaluate(o, {}, s) * f.textScaleFactor, g = f.layoutIconSize.evaluate(o, {}, s, h) * f.iconScaleFactor, x = {
                    horizontal: {},
                    vertical: void 0
                }, v = o.text;
                let b, S = [
                    0,
                    0
                ];
                if (v) {
                    const n = v.toString(), u = p.get("text-letter-spacing").evaluate(o, {}, s) * _g, c = p.get("text-line-height").evaluate(o, {}, s) * _g, h = To(n) ? u : 0, d = p.get("text-anchor").evaluate(o, {}, s), g = p.get("text-variable-anchor");
                    if (!g) {
                        const e = p.get("text-radial-offset").evaluate(o, {}, s);
                        if (e) S = tv(d, [
                            e * _g,
                            Kx
                        ]);
                        else {
                            const e = p.get("text-offset").evaluate(o, {}, s);
                            S = [
                                e[0] * _g,
                                e[1] * _g
                            ];
                        }
                    }
                    let b = _ ? "center" : p.get("text-justify").evaluate(o, {}, s);
                    const A = "point" === w, M = A ? p.get("text-max-width").evaluate(o, {}, s) * _g : 1 / 0, I = (s)=>{
                        e.allowVerticalPlacement && Bo(n) && (x.vertical = Zg(v, t1, r, i, a, M, c, d, s, h, S, qg.vertical, !0, y, m, l, f.textScaleFactor));
                    };
                    if (!_ && g) {
                        const e = "auto" === b ? g.map((e)=>fv(e)) : [
                            b
                        ];
                        let n = !1;
                        for(let s = 0; s < e.length; s++){
                            const o = e[s];
                            if (!x.horizontal[o]) {
                                if (n) x.horizontal[o] = x.horizontal[0];
                                else {
                                    const e = Zg(v, t1, r, i, a, M, c, "center", o, h, S, qg.horizontal, !1, y, m, l, f.textScaleFactor);
                                    e && (x.horizontal[o] = e, n = 1 === e.positionedLines.length);
                                }
                            }
                        }
                        I("left");
                    } else {
                        if ("auto" === b && (b = fv(d)), A || p.get("text-writing-mode").indexOf("horizontal") >= 0 || !Bo(n)) {
                            const e = Zg(v, t1, r, i, a, M, c, d, b, h, S, qg.horizontal, !1, y, m, l, f.textScaleFactor);
                            e && (x.horizontal[b] = e);
                        }
                        I(A ? "left" : b);
                    }
                }
                let z, P, B, T, k, V, E = !1;
                const F = p.get("icon-text-fit").evaluate(o, {}, s);
                if (o.icon && o.icon.hasPrimary()) {
                    const t1 = uv(o.icon, e.iconSizeData, d["icon-size"], s, e.zoom, o, l, f.iconScaleFactor, c, h);
                    z = t1.iconPrimary, B = t1.iconSecondary;
                    const r = z.toString();
                    if (P = n.get(r), P && (k = p.get("icon-offset").evaluate(o, {}, s), V = p.get("icon-anchor").evaluate(o, {}, s), b = sx(i.get(r), B ? i.get(B.toString()) : void 0, k, V), E = P.sdf, void 0 === e.sdfIcons ? e.sdfIcons = P.sdf : e.sdfIcons !== P.sdf && Ze("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (P.pixelRatio !== e.pixelRatio || 0 !== p.get("icon-rotate").constantOr(1)) && (e.iconsNeedLinear = !0)), B) {
                        const e = B.toString();
                        T = n.get(e);
                    }
                }
                M = M || !(!o.icon || !o.icon.hasSecondary());
                const D = _v(x.horizontal) || x.vertical;
                e.iconsInText || (e.iconsInText = !!D && D.iconsInText);
                const C = y * f.textScaleFactor / _g, { defaultShapedIcon: R, verticallyShapedIcon: L } = mv(e, b, p, o, s, x, C, k, F);
                "none" !== F && b && (ax(b) || lx(b)) && (av(0, P, z, b, R, F, u, n, i), av(0, T, B, b, R, F, u, n, i), L && (av(0, P, z, b, L, F, u, n, i), av(0, T, B, b, L, F, u, n, i))), b = R;
                const { iconBBox: O, iconVerticalBBox: U, textBBox: N, textVerticalBBox: j } = rv(e, b, L, p, o, s, g, k, f, i, V, x, y, S, h);
                I.push({
                    feature: o,
                    shapedTextOrientations: x,
                    shapedText: D,
                    shapedIcon: b,
                    iconPrimary: z,
                    iconSecondary: B,
                    iconOffset: k,
                    iconAnchor: V,
                    verticallyShapedIcon: L,
                    layoutTextSize: y,
                    layoutIconSize: g,
                    textOffset: S,
                    isSDFIcon: E,
                    iconTextFit: F,
                    iconCollisionBounds: O,
                    iconVerticalCollisionBounds: U,
                    textCollisionBounds: N,
                    textVerticalCollisionBounds: j
                });
            }
            return {
                featureData: I,
                sizes: f,
                hasAnySecondaryIcon: M,
                textAlongLine: _,
                symbolPlacement: w
            };
        }, e.fB = Tx, e.fC = zx, e.fD = kx, e.fE = Vx, e.fF = function(e, t1, r, n, i, s, o, a, l, u) {
            e.iconAtlasPositions = u.iconPositions;
            const { featureData: c, hasAnySecondaryIcon: h, sizes: p, textAlongLine: d, symbolPlacement: f } = t1;
            for (const t1 of c){
                const { shapedIcon: r, verticallyShapedIcon: s, feature: c, shapedTextOrientations: m, shapedText: y, layoutTextSize: g, textOffset: x, isSDFIcon: v, iconPrimary: b, iconSecondary: w, iconTextFit: _, iconOffset: A, iconCollisionBounds: M, iconVerticalCollisionBounds: I, textCollisionBounds: S } = t1;
                hv(r, u.iconPositions, b, w), hv(s, u.iconPositions, b, w), pv(m, u.iconPositions), cv(b, w, u.iconPositions), (y || r) && gv(e, c, m, r, s, l, p, g, 0, x, v, n, i, o, a, h, _, A, d, f, M, I, S);
            }
            r && e.generateCollisionDebugBuffers(s, e.collisionBoxArray, p.textScaleFactor);
        }, e.fG = rc, e.fH = a_, e.fI = Ju, e.fJ = function(e) {
            let t1 = 0;
            if (new Uint32Array(e, 0, 1)[0] !== Am) {
                const r = new Uint32Array(e, 0, 7), [, , n, i, s, o] = r;
                t1 = r.byteLength + i + s + o + s, (n !== e.byteLength || t1 >= e.byteLength) && Ze("Invalid b3dm header information.");
            }
            return Bm(e, t1);
        }, e.fK = function(e, t1) {
            const r = my(e);
            for (const e of r){
                for (const t1 of e.meshes)yy(t1);
                e.lights && (e.lightMeshIndex = e.meshes.length, e.meshes.push(xy(e.lights, t1)));
            }
            return r;
        }, e.fL = Wb, e.fM = Ke, e.fN = Uf, e.fO = Wo, e.fP = Uo, e.fQ = function(e) {
            St(), null != Mt && Mt.then((t1)=>{
                t1.keys().then((r)=>{
                    for(let n = 0; n < r.length - e; n++)t1.delete(r[n]).catch((e)=>Ze(e.message));
                }).catch((e)=>Ze(e.message));
            }).catch((e)=>Ze(e.message));
        }, e.fa = function(e) {
            const t1 = [
                0,
                0,
                0
            ], r = u(new Float64Array(16));
            return h(r, e.pixelMatrix, e.globeMatrix), j(t1, t1, r), new Ie(t1[0], t1[1]);
        }, e.fb = function() {
            const e = Xf;
            e && (e.isPreloaded() && 1 === e.numActive() ? (e.release(Gf), Xf = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e.fc = function() {
            Zf().acquire(Gf);
        }, e.fd = Ho, e.fe = function(e, t1, r = !1) {
            if (jo === Uo.deferred || jo === Uo.loading || jo === Uo.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Go = gt.resolveURL(e), jo = Uo.deferred, No = t1, qo(), r || Zo();
        }, e.ff = function(e) {
            em = gt.resolveURL(e), rm || (rm = new qf(Zf(), new rr)), rm.broadcast("setMeshoptUrl", em);
        }, e.fg = am, e.fh = function(e) {
            Kf = gt.resolveURL(e), rm || (rm = new qf(Zf(), new rr)), rm.broadcast("setDracoUrl", Kf);
        }, e.fi = om, e.fj = Nf, e.fk = function(e) {
            const t1 = It();
            if (!t1) return;
            const r = t1.delete(bt);
            e && r.then(()=>e()).catch(e);
        }, e.fl = $f, e.fm = Js, e.fn = jh, e.fo = 2, e.fp = Jn, e.fq = tA, e.fr = rA, e.fs = Hy, e.ft = ic, e.fu = "hd_road_elevation", e.fv = _c, e.fw = Ge, e.fx = zp, e.fy = Bx, e.fz = 1, e.g = function(e, t1) {
            return Lt(Object.assign(e, {
                method: "GET"
            }), t1);
        }, e.h = function(e) {
            return 0 === e.indexOf("mapbox:");
        }, e.i = function(e) {
            return at.API_STYLE_REGEX.test(e) && !ut(e);
        }, e.j = lt, e.k = Pt, e.l = function(e) {
            return decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }, e.m = function(e, t1) {
            return Lt(Object.assign(e, {
                type: "json"
            }), t1);
        }, e.n = Gt, e.o = gt, e.p = function(e, t1) {
            return Lt(Object.assign(e, {
                method: "POST"
            }), t1);
        }, e.q = Gh, e.r = class {
            constructor(e){
                this.cache = new Map, this.textures = new Map, this.textureAccessTimes = new Map, this.textureMemoryUsed = 0, this.maxTextureMemory = 1024 * (e && e.maxTextureMemoryMB ? e.maxTextureMemoryMB : 256) * 1024, this.finalizationRegistry = new FinalizationRegistry((e)=>{
                    this.cache.delete(e), this.clearExpiredTextures();
                });
            }
            calculateTextureMemory(e) {
                return e.image ? Math.ceil(e.image.width * e.image.height * 4 * (e.patternPositions.size > 0 ? 1.33 : 1)) : 0;
            }
            evictTexture(e) {
                const t1 = this.textures.get(e);
                if (t1) {
                    const r = this.calculateTextureMemory(e);
                    t1.destroy(), this.textures.delete(e), this.textureAccessTimes.delete(e), this.textureMemoryUsed -= r;
                }
            }
            evictTexturesIfNeeded(e) {
                for(; this.textureMemoryUsed + e > this.maxTextureMemory && this.textures.size > 0;){
                    let e = null, t1 = 1 / 0;
                    for (const [r] of this.textures.entries()){
                        const n = this.textureAccessTimes.get(r) || 0;
                        n < t1 && (t1 = n, e = r);
                    }
                    if (!e) break;
                    this.evictTexture(e);
                }
            }
            findCachedAtlas(e) {
                const t1 = this.cache.get(e.hash);
                if (t1) {
                    const r = t1.deref();
                    if (r && r.contentDescriptor && this.isMipmapCompatible(e, r.contentDescriptor)) return r;
                }
                for (const [, t1] of this.cache.entries()){
                    const r = t1.deref();
                    if (r && r.contentDescriptor) {
                        const t1 = e.subsetOf(r.contentDescriptor), n = this.isMipmapCompatible(e, r.contentDescriptor);
                        if (t1 && n) return r;
                    }
                }
            }
            getTextureForAtlas(e, t1, r) {
                this.textureAccessTimes.set(e, performance.now());
                let n = this.textures.get(e);
                if (n) return n;
                if (e.image) {
                    const i = this.calculateTextureMemory(e);
                    return this.evictTexturesIfNeeded(i), n = new Em(t1, e.image, r, {
                        useMipmap: !!e.patternPositions.size
                    }), this.textures.set(e, n), this.textureMemoryUsed += i, n;
                }
                return null;
            }
            clearExpiredTextures() {
                for (const [e] of this.textures.entries())if (!this.isAtlasCached(e)) {
                    const t1 = this.textures.get(e);
                    if (t1) {
                        const r = this.calculateTextureMemory(e);
                        t1.destroy(), this.textureMemoryUsed -= r;
                    }
                    this.textures.delete(e), this.textureAccessTimes.delete(e);
                }
            }
            isAtlasCached(e) {
                if (!e.contentDescriptor) return !1;
                const t1 = this.cache.get(e.contentDescriptor.hash);
                return !!t1 && t1.deref() === e;
            }
            getOrCache(e) {
                if (!("image" in e)) {
                    const t1 = this.cache.get(e.sourceAtlasHash);
                    if (t1) {
                        const e = t1.deref();
                        if (e) return e;
                    }
                    return Ze("ImageAtlasReference points to GC'd atlas - atlas may have been evicted"), null;
                }
                if (!e.contentDescriptor) return e;
                const t1 = e.contentDescriptor, r = t1.hash, n = this.cache.get(r);
                if (n) {
                    const e = n.deref();
                    if (e && e.contentDescriptor && this.isMipmapCompatible(t1, e.contentDescriptor)) return e;
                }
                return this.cache.set(r, new WeakRef(e)), this.finalizationRegistry.register(e, r, e), e;
            }
            isMipmapCompatible(e, t1) {
                return !e.requiresMipMaps || t1.requiresMipMaps;
            }
            destroyTextures() {
                for (const e of this.textures.values())e && e.destroy();
                this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
            clear() {
                for (const e of this.textures.values())e && e.destroy();
                this.cache.clear(), this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
        }, e.s = function(e) {
            try {
                const t1 = self[e];
                return t1.setItem("_mapbox_test_", 1), t1.removeItem("_mapbox_test_"), !0;
            } catch (e) {
                return !1;
            }
        }, e.t = yt, e.u = function() {
            return function e(t1) {
                return t1 ? (t1 ^ Math.random() * (16 >> t1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e);
            }();
        }, e.v = function(e) {
            return !!e && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e);
        }, e.w = Ze, e.x = function() {
            return Hf || (Hf = new $f("ImageRasterizer")), Hf;
        }, e.y = Ww, e.z = Qt;
    });
    define([
        "./shared"
    ], function(e) {
        function t1(e) {
            const t1 = e ? e.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function s(e) {
            if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return JSON.stringify(e);
            if (Array.isArray(e)) {
                let t1 = "[";
                for (const i of e)t1 += `${s(i)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const i of Object.keys(e).sort())t1 += `${i}:${s(e[i])},`;
            return `${t1}}`;
        }
        function i(t1) {
            let i = "";
            for (const o of e.by)i += `/${s(t1[o])}`;
            return i;
        }
        function o(e, t1) {
            return function e(s) {
                return "string" == typeof s && s === t1 || (Array.isArray(s) ? s.some(e) : !(!s || "object" != typeof s) && Object.values(s).some(e));
            }(e);
        }
        class n {
            constructor(e){
                this.keyCache = Object.create(null), this._layers = Object.create(null), this._layerConfigs = Object.create(null), e && this.replace(e);
            }
            replace(e, t1) {
                this._layerConfigs = Object.create(null), this._layers = Object.create(null), this.update(e, [], t1);
            }
            update(t1, n, r) {
                this._options = r;
                for (const s of t1)this._layerConfigs[s.id] = s, (this._layers[s.id] = e.dx(s, this.scope, null, this._options)).compileFilter(r), this.keyCache[s.id] && delete this.keyCache[s.id];
                for (const e of n)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = Object.create(null);
                const a = function(e, t1) {
                    const n = Object.create(null);
                    for(let r = 0; r < e.length; r++){
                        const a = e[r];
                        let l = t1 && t1[a.id];
                        l || ("symbol" === a.type ? l = a.id : (l = i(a), "line" === a.type && a.paint && o(a.paint["line-width"], "line-progress") && (l += `/${s(a.paint["line-width"])}`))), t1 && (t1[a.id] = l);
                        let c = n[l];
                        c || (c = n[l] = []), c.push(a);
                    }
                    const r = [];
                    for(const e in n)r.push(n[e]);
                    return r;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e of a){
                    const t1 = e.map((e)=>this._layers[e.id]), s = t1[0];
                    if ("none" === s.visibility) continue;
                    const i = s.source || "";
                    let o = this.familiesBySource[i];
                    o || (o = this.familiesBySource[i] = Object.create(null));
                    const n = s.sourceLayer || "_geojsonTileLayer";
                    let r = o[n];
                    r || (r = o[n] = []), r.push(t1);
                }
            }
        }
        const r = 1 * e.fo;
        class a {
            constructor(t1){
                const s = {}, i = [];
                for(const e in t1){
                    const o = t1[e], n = s[e] = {};
                    for(const e in o.glyphs){
                        const t1 = o.glyphs[+e];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const s = t1.metrics.localGlyph ? r : 1, a = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * s,
                            h: t1.bitmap.height + 2 * s
                        };
                        i.push(a), n[e] = a;
                    }
                }
                const { w: o, h: n } = e.H(i), a = new e.fn({
                    width: o || 1,
                    height: n || 1
                });
                for(const i in t1){
                    const o = t1[i];
                    for(const t1 in o.glyphs){
                        const n = o.glyphs[+t1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const l = s[i][t1], c = n.metrics.localGlyph ? r : 1;
                        e.fn.copy(n.bitmap, a, {
                            x: 0,
                            y: 0
                        }, {
                            x: l.x + c,
                            y: l.y + c
                        }, n.bitmap);
                    }
                }
                this.image = a, this.positions = s;
            }
        }
        function l(e, t1, s) {
            e[t1] ? s && (e[t1].center = s) : e[t1] = {
                floorIds: new Set,
                center: s || [
                    0,
                    0
                ],
                floors: {}
            };
        }
        function c(e, t1, s, i) {
            for (const o of t1)l(e, o), e[o].floors[s] = i, e[o].floorIds.add(s);
        }
        function h(e) {
            return {
                id: e.properties.id.toString(),
                center: [
                    e.properties.center_lon || 0,
                    e.properties.center_lat || 0
                ]
            };
        }
        function u(t1, s) {
            const i = t1.properties.id.toString(), o = !!t1.properties.is_default && t1.properties.is_default, n = t1.properties.connected_floor_ids ? new Set(t1.properties.connected_floor_ids.toString().split(";")) : new Set, r = t1.properties.conflicted_floor_ids ? new Set(t1.properties.conflicted_floor_ids.toString().split(";")) : new Set, a = t1.properties.structure_ids ? new Set(t1.properties.structure_ids.toString().split(";")) : new Set, l = t1.properties.name.toString(), c = t1.properties.z_index, h = function(t1, s) {
                const i = t1.loadGeometry();
                if (!i || 0 === i.length) return;
                const o = i.map((i)=>i.map((i)=>e.fp(i, s, t1.extent)));
                return 0 === o.length ? void 0 : {
                    type: "Polygon",
                    coordinates: [
                        o[0]
                    ]
                };
            }(t1, s);
            return {
                id: i,
                isDefault: o,
                connections: n,
                conflicts: r,
                buildings: a,
                name: l,
                zIndex: c,
                geometry: h
            };
        }
        function d(e, t1) {
            return t1.every((t1)=>e.properties && null != e.properties[t1]);
        }
        function f(e) {
            return d(e, [
                "type",
                "id",
                "name"
            ]) && "structure" === e.properties.type;
        }
        function p(e) {
            return d(e, [
                "type",
                "id",
                "name",
                "z_index"
            ]) && "floor" === e.properties.type;
        }
        e.fm(a, "GlyphAtlas");
        class g {
            constructor(t1){
                this.tileID = new e.aR(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.lut = t1.lut, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.scope = t1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.request && t1.request.collectResourceTiming, this.promoteId = t1.promoteId, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = e.a_(t1.tileID.canonical, t1.projection), this.projection = t1.projection, this.worldview = t1.worldview, this.localizableLayerIds = t1.localizableLayerIds, this.brightness = t1.brightness, this.extraShadowCaster = !!t1.extraShadowCaster, this.tessellationStep = t1.tessellationStep, this.scaleFactor = t1.scaleFactor, this.worldview = t1.worldview, this.indoor = t1.indoor;
            }
            parse(t1, s, i, o, n, r) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e.b4;
                const d = new e.fq(Object.keys(t1.layers).sort()), g = new e.fr(this.tileID, this.promoteId);
                g.bucketLayerIDs = [];
                const y = {}, w = new e.fs(256, 256), b = {
                    featureIndex: g,
                    iconDependencies: new Map,
                    patternDependencies: new Map,
                    glyphDependencies: {},
                    lineAtlas: w,
                    availableImages: i,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    elevationFeatures: void 0,
                    activeFloors: void 0
                };
                this.indoor && (b.activeFloors = function(t1, s, i, o) {
                    const n = s.indoorState.activeFloorsVisible;
                    if (!s.sourceLayers) return n ? s.indoorState.activeFloors : void 0;
                    const r = function(t1, s) {
                        if (!t1) return e.w("No source layers defined in indoor specification"), s;
                        if (0 === t1.size) return s;
                        const i = t1.difference(s);
                        for (const t1 of i)e.w(`Missing source layer required in indoor specification: ${t1}`);
                        return s.intersection(s);
                    }(s.sourceLayers, new Set(Object.keys(t1.layers))), a = s.indoorState, d = function(t1, s, i, o, n) {
                        const r = {};
                        for (const i of s){
                            const s = t1.layers[i];
                            if (s) for(let e = 0; e < s.length; e++){
                                const t1 = s.feature(e);
                                if (f(t1)) {
                                    const { id: e, center: s } = h(t1);
                                    l(r, e, s);
                                    continue;
                                }
                                if (p(t1)) {
                                    const e = u(t1, n);
                                    c(r, e.buildings, e.id, e);
                                }
                            }
                            else e.w(`indoor source layer not found: ${i}`);
                        }
                        return {
                            buildings: r,
                            activeFloors: e.dj.calculate(r, o, i)
                        };
                    }(t1, r, a.activeFloors, a.selectedFloorId, o);
                    return i.send("setIndoorData", d), n ? d.activeFloors : void 0;
                }(t1, this.indoor, n, this.canonical));
                const v = [], x = s.familiesBySource[this.source];
                for(const s in x){
                    const n = t1.layers[s];
                    if (!n) continue;
                    let r = !1, a = !1, l = !1;
                    for (const e of x[s])"symbol" === e[0].type ? r = !0 : a = !0, e[0].is3D() && "model" !== e[0].type && (l = !0);
                    if (this.extraShadowCaster && !l) continue;
                    if (!0 === this.isSymbolTile && !r) continue;
                    if (!1 === this.isSymbolTile && !a) continue;
                    1 === n.version && e.w(`Vector tile source "${this.source}" layer "${s}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const c = d.encode(s), h = [], u = this.localizableLayerIds && this.localizableLayerIds.has(s);
                    let f = !1;
                    for(let t1 = 0, i = 0; t1 < n.length; t1++){
                        const o = n.feature(t1), r = g.getId(o, s), a = o.properties ? o.properties.worldview : null;
                        if (u && this.worldview && "string" == typeof a) {
                            if ("all" === a) o.properties.$localized = !0;
                            else {
                                if (!a.split(",").includes(this.worldview)) continue;
                                o.properties.$localized = !0, o.properties.worldview = this.worldview;
                            }
                        }
                        !f && o.properties && o.properties.hasOwnProperty(e.ft) && (f = !0), h.push({
                            feature: o,
                            id: r,
                            index: i,
                            sourceLayerIndex: c
                        }), i++;
                    }
                    f && !b.elevationFeatures && t1.layers.hasOwnProperty(e.fu) && (b.elevationFeatures = e.fv.parseFrom(t1.layers[e.fu], this.canonical));
                    for (const t1 of x[s]){
                        const s = t1[0];
                        if (this.extraShadowCaster && (!s.is3D() || "model" === s.type)) continue;
                        if (void 0 !== this.isSymbolTile && "symbol" === s.type !== this.isSymbolTile) continue;
                        if (s.minzoom && this.zoom < Math.floor(s.minzoom)) continue;
                        if (s.maxzoom && this.zoom >= s.maxzoom) continue;
                        if ("none" === s.visibility) continue;
                        m(t1, this.zoom, b.brightness, i, this.worldview, b.activeFloors);
                        const n = y[s.id] = s.createBucket({
                            index: g.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            lut: this.lut,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: c,
                            sourceID: this.source,
                            projection: this.projection.spec,
                            tessellationStep: this.tessellationStep,
                            styleDefinedModelURLs: o,
                            worldview: this.worldview,
                            localizable: u,
                            availableImages: i
                        });
                        g.bucketLayerIDs.push(t1.map((t1)=>e.C(t1.id, t1.scope)));
                        let r = n.prepare ? n.prepare() : null;
                        null != r ? (r = r.then(()=>n.populate(h, b, this.tileID.canonical, this.tileTransform)), v.push(r)) : n.populate(h, b, this.tileID.canonical, this.tileTransform);
                    }
                }
                const I = ()=>{
                    let s, o, l, c, h, u, f;
                    w.trim();
                    const p = {
                        type: "maybePrepare",
                        isSymbolTile: this.isSymbolTile,
                        zoom: this.zoom
                    }, v = ()=>{
                        if (s) return this.status = "done", r(s);
                        if (this.extraShadowCaster) this.status = "done", r(null, {
                            buckets: Object.values(y).filter((e)=>!e.isEmpty()),
                            featureIndex: g,
                            collisionBoxArray: null,
                            glyphAtlasImage: null,
                            lineAtlas: null,
                            imageAtlas: null,
                            brightness: b.brightness,
                            glyphMap: null,
                            iconMap: null,
                            glyphPositions: null
                        });
                        else if (o && l && c && f) {
                            const t1 = void 0, s = new a(o), r = new Map;
                            for (const [t1, s] of l.entries()){
                                const { imagePosition: i } = e.fy(t1, s, e.fz);
                                r.set(t1, i);
                            }
                            const d = {};
                            for(const t1 in y){
                                const n = y[t1];
                                n instanceof e.b5 && (m(n.layers, this.zoom, b.brightness, i, this.worldview, b.activeFloors), d[t1] = e.fA(n, o, s.positions, l, r, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, h, this.worldview, i));
                            }
                            const p = {
                                iconsPending: !0,
                                patternsPending: !0
                            };
                            this.rasterizeIfNeeded(n, l, h, ()=>{
                                p.iconsPending = !1, x(d, s, p, t1, f);
                            }), this.rasterizeIfNeeded(n, c, u, ()=>{
                                p.patternsPending = !1, x(d, s, p, t1, f);
                            });
                        }
                    }, x = (t1, s, o, a, h)=>{
                        if (o.iconsPending || o.patternsPending) return;
                        const u = l.size > 0 || c.size > 0, d = Object.keys(t1).length > 0;
                        if (!u && !d) return this.status = "done", void r(null, {
                            buckets: Object.values(y).filter((e)=>!e.isEmpty()),
                            featureIndex: g,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: s.image,
                            lineAtlas: w,
                            imageAtlas: null,
                            brightness: b.brightness
                        });
                        const f = (o, n)=>{
                            for(const s in y){
                                const o = y[s];
                                if (s in t1) e.fF(o, t1[s], this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, l, n);
                                else if (o.hasPattern && (o instanceof e.bb || o instanceof e.bc || o instanceof e.ec)) {
                                    m(o.layers, this.zoom, b.brightness, i, this.worldview, b.activeFloors);
                                    const e = Object.fromEntries(n.patternPositions);
                                    o.addFeatures(b, this.tileID.canonical, e, i, this.tileTransform, this.brightness);
                                }
                            }
                            this.status = "done", r(null, {
                                buckets: Object.values(y).filter((e)=>!e.isEmpty()),
                                featureIndex: g,
                                collisionBoxArray: this.collisionBoxArray,
                                glyphAtlasImage: s.image,
                                lineAtlas: w,
                                imageAtlas: o,
                                brightness: b.brightness
                            });
                        };
                        if (u) {
                            const t1 = new Map, s = e.fB(l, t1), i = e.fB(c, t1), o = new e.fC(s, i, h, this.lut, t1);
                            n.send("checkAtlasCache", {
                                descriptor: o,
                                scope: this.scope
                            }, (t1, s)=>{
                                let i, o;
                                if (t1 && e.w(`[Worker] Error checking atlas cache: ${t1.message}`), s) i = new e.fD(s.sourceHash), o = s;
                                else {
                                    const t1 = new e.fE(l, c, this.lut, h);
                                    i = t1, o = t1;
                                }
                                f(i, o);
                            });
                        } else f(null, {
                            iconPositions: new Map,
                            patternPositions: new Map
                        });
                    };
                    if (!this.extraShadowCaster) {
                        const t1 = e.fw(b.glyphDependencies, (e)=>Object.keys(e).map(Number));
                        Object.keys(t1).length ? n.send("getGlyphs", {
                            uid: this.uid,
                            stacks: t1
                        }, (e, t1)=>{
                            s || (s = e, o = t1, v());
                        }, void 0, !1, p) : o = {}, f = new Map;
                        const i = Array.from(b.iconDependencies.keys()).map((t1)=>e.I.parse(t1));
                        i.length ? n.send("getImages", {
                            images: i,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "icons"
                        }, (e, t1)=>{
                            if (!s) {
                                s = e, l = new Map, h = this.updateImageMapAndGetImageTaskQueue(l, t1.images, b.iconDependencies);
                                for (const [e, s] of t1.versions.entries())f.set(e, s);
                                v();
                            }
                        }, void 0, !1, p) : (l = new Map, h = new Map);
                        const r = Array.from(b.patternDependencies.keys()).map((t1)=>e.I.parse(t1));
                        r.length ? n.send("getImages", {
                            images: r,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "patterns"
                        }, (e, t1)=>{
                            if (!s) {
                                s = e, c = new Map, u = this.updateImageMapAndGetImageTaskQueue(c, t1.images, b.patternDependencies);
                                for (const [e, s] of t1.versions.entries())f.set(e, s);
                                v();
                            }
                        }, void 0, !1, p) : (c = new Map, u = new Map);
                    }
                    if (b.elevationFeatures && b.elevationFeatures.length > 0) {
                        const s = [];
                        for (const t1 of Object.values(y))if (t1 instanceof e.bc) {
                            const e = t1.getUnevaluatedPortalGraph();
                            e && s.push(e);
                        }
                        const i = e.fx.evaluate(s);
                        for (const s of Object.values(y))if (s instanceof e.bc) {
                            const e = t1.layers[d.decode(s.sourceLayerIndex)];
                            s.setEvaluatedPortalGraph(i, e, this.tileID.canonical, b.availableImages, b.brightness);
                        }
                    }
                    v();
                };
                v.length > 0 ? Promise.allSettled(v).then(I).catch(r) : I();
            }
            updateParameters(t1) {
                this.scaleFactor = t1.scaleFactor, this.showCollisionBoxes = t1.showCollisionBoxes, this.projection = t1.projection, this.brightness = t1.brightness, this.tileTransform = e.a_(t1.tileID.canonical, t1.projection), this.extraShadowCaster = t1.extraShadowCaster, this.lut = t1.lut, this.worldview = t1.worldview, this.indoor = t1.indoor;
            }
            rasterizeIfNeeded(e, t1, s, i) {
                Array.from(t1.values()).some((e)=>e.usvg) ? this.rasterize(e, t1, s, i) : i();
            }
            updateImageMapAndGetImageTaskQueue(e, t1, s) {
                const i = new Map;
                for (const o of t1.keys()){
                    const n = s.get(o) || [];
                    for (const s of n){
                        const o = s.toString(), n = t1.get(s.id.toString());
                        n.usvg ? i.has(o) || (i.set(o, s), e.set(o, Object.assign({}, n))) : e.set(o, n);
                    }
                }
                return i;
            }
            rasterize(e, t1, s, i) {
                this.rasterizeTask = e.send("rasterizeImages", {
                    scope: this.scope,
                    tasks: s
                }, (e, s)=>{
                    if (!e) for (const [e, i] of s.entries()){
                        const s = Object.assign(t1.get(e), {
                            data: i
                        });
                        t1.set(e, s);
                    }
                    i();
                });
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.cancel();
            }
        }
        function m(t1, s, i, o, n, r) {
            const a = new e.ad(s, {
                brightness: i,
                worldview: n,
                activeFloors: r
            });
            for (const e of t1)e.recalculate(a, o);
        }
        class y extends e.E {
            constructor({ actor: t1, layerIndex: s, availableImages: i, availableModels: o, isSpriteLoaded: n, loadTileData: r, brightness: a }){
                super(), this.actor = t1, this.layerIndex = s, this.availableImages = i, this.availableModels = o, this.loadVectorData = r || e.aM, this.loading = {}, this.loaded = {}, this.deduped = new e.aL(t1.scheduler), this.isSpriteLoaded = n, this.scheduler = t1.scheduler, this.brightness = a;
            }
            loadTile(s, i) {
                const o = s.uid, n = s && s.request, r = n && n.collectResourceTiming, a = this.loading[o] = new g(s);
                a.abort = this.loadVectorData(s, (l, c)=>{
                    const h = !this.loading[o];
                    if (delete this.loading[o], a.cancelRasterize(), h || l || !c) return a.status = "done", h || (this.loaded[o] = a), i(l);
                    const u = c.rawData, d = {}, f = e.aN(c.responseHeaders);
                    f && f.expires && (d.expires = f.expires), f && f.cacheControl && (d.cacheControl = f.cacheControl), a.vectorTile = c.vectorTile || new e.fG(new e.bu(u));
                    const p = ()=>{
                        a.parse(a.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (e, s)=>{
                            if (e || !s) return i(e);
                            const o = {};
                            if (r) {
                                const e = t1(n);
                                e.length > 0 && (o.resourceTiming = JSON.parse(JSON.stringify(e)));
                            }
                            i(null, Object.assign({
                                rawTileData: u.slice(0),
                                responseHeaders: c.responseHeaders
                            }, s, d, o));
                        });
                    };
                    this.isSpriteLoaded ? p() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(p, {
                            type: "parseTile",
                            isSymbolTile: s.isSymbolTile,
                            zoom: s.tileZoom
                        }) : p();
                    }), this.loaded = this.loaded || {}, this.loaded[o] = a;
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded, i = e.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.updateParameters(e);
                    const n = (e, s)=>{
                        const i = o.reloadCallback;
                        i && (delete o.reloadCallback, o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, i)), t1(e, s);
                    };
                    "parsing" === o.status ? o.reloadCallback = n : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, n) : n());
                } else t1(null, void 0);
            }
            abortTile(e, t1) {
                const s = e.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        class w {
            loadTile(t1, s) {
                const { uid: i, encoding: o, rawImageData: n, padding: r } = t1, a = ImageBitmap && n instanceof ImageBitmap ? this.getImageData(n, r) : n;
                s(null, new e.fH(i, a, o, r < 1));
            }
            reloadTile(e, t1) {
                t1(null, null);
            }
            abortTile(e, t1) {
                t1();
            }
            removeTile(e, t1) {
                t1();
            }
            getImageData(e, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
                const s = this.offscreenCanvasContext.getImageData(-t1, -t1, e.width + 2 * t1, e.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s;
            }
        }
        e.bt.setPbf(e.bu);
        class b {
            constructor(t1){
                this._mrt = new e.bt(t1.partial ? 30 : 1 / 0), this._isHeaderLoaded = !1, this.uid = t1.uid, this.tileID = t1.tileID, this.source = t1.source;
            }
            parse(t1, s) {
                const i = this._mrt;
                this.status = "parsing", this._entireBuffer = t1;
                try {
                    i.parseHeader(t1), this._isHeaderLoaded = !0;
                    const o = [];
                    for(const s in i.layers){
                        const n = i.getLayer(s), r = n.getDataRange(n.getBandList()), a = i.createDecodingTask(r), l = t1.slice(r.firstByte, r.lastByte + 1), c = e.bt.performDecoding(l, a).then((e)=>a.complete(null, e)).catch((e)=>a.complete(e, null));
                        o.push(c);
                    }
                    Promise.allSettled(o).then(()=>s(null, i)).catch((e)=>s(e));
                } catch (e) {
                    s(e);
                }
            }
        }
        class v {
            constructor({ actor: e }){
                this.actor = e, this.loading = {}, this.loaded = {};
            }
            loadTile(t1, s) {
                const i = t1.uid, o = t1.request, n = this.loading[i] = new b(t1), { cancel: r } = e.bv(o, (e, t1, o)=>{
                    const r = !this.loading[i];
                    if (delete this.loading[i], r || e || !t1) return n.status = "done", r || (this.loaded[i] = n), s(e);
                    n.parse(t1, (e, t1)=>{
                        if (e || !t1) return s(e);
                        s(null, t1, o);
                    }), this.loaded[i] = n;
                });
                n.abort = r;
            }
            reloadTile(e, t1) {
                t1(null, void 0);
            }
            abortTile(e, t1) {
                const s = e.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e, t1) {
                const s = e.uid;
                this.loaded[s] && delete this.loaded[s], t1();
            }
            decodeRasterArray(t1, s) {
                e.bt.performDecoding(t1.buffer, t1.task).then((e)=>s(null, e)).catch((e)=>s(e));
            }
        }
        const x = e.fI.prototype.toGeoJSON;
        class I {
            constructor(t1){
                this._feature = t1, this.extent = e.am, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const s of this._feature.geometry)t1.push([
                        new e.P(s[0], s[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const s of this._feature.geometry){
                        const i = [];
                        for (const t1 of s)i.push(new e.P(t1[0], t1[1]));
                        t1.push(i);
                    }
                    return t1;
                }
            }
            toGeoJSON(e, t1, s) {
                return x.call(this, e, t1, s);
            }
        }
        class S {
            constructor(t1, s){
                this.name = t1, this.extent = e.am, this.length = s.length, this._jsonFeatures = s;
            }
            feature(e) {
                return new I(this._jsonFeatures[e]);
            }
        }
        class M {
            constructor(t1){
                this.layers = {}, this.extent = e.am;
                for (const e of Object.keys(t1))this.layers[e] = new S(e, t1[e]);
            }
        }
        const P = 64 / 4096;
        class T {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e = [], t1) {
                for (const s of e){
                    const e = s.id;
                    if (null == e) continue;
                    let i = this.features.get(e);
                    i && this.updateCache(i, t1), s.geometry ? (i = k(s), this.updateCache(i, t1), this.features.set(e, i)) : this.features.delete(e), this.updateCache(i, t1);
                }
            }
            updateCache(e, t1) {
                for (const { canonical: s, uid: i } of Object.values(t1)){
                    const { z: o, x: n, y: r } = s;
                    _(e, Math.pow(2, o), n, r) && delete t1[i];
                }
            }
            getTile(e, t1, s) {
                const i = Math.pow(2, e), o = [];
                for (const e of this.features.values())_(e, i, t1, s) && o.push(j(e, i, t1, s));
                return {
                    features: o
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function _({ minX: e, minY: t1, maxX: s, maxY: i }, o, n, r) {
            return e < (n + 1 + P) / o && t1 < (r + 1 + P) / o && s > (n - P) / o && i > (r - P) / o;
        }
        function k(e) {
            const { id: t1, geometry: s, properties: i } = e;
            if (!s) return;
            if ("GeometryCollection" === s.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: o, coordinates: n } = s, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === o) L(n, a, r);
            else if ("MultiPoint" === o) for (const e of n)L(e, a, r);
            else if ("LineString" === o) r.type = 2, O(n, a, r);
            else if ("MultiLineString" === o) r.type = 2, z(n, a, r);
            else if ("Polygon" === o) r.type = 3, z(n, a, r, !0);
            else {
                if ("MultiPolygon" !== o) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e of n)z(e, a, r, !0);
            }
            return r;
        }
        function L([t1, s], i, o) {
            const n = e.aG(t1);
            let r = e.aK(s);
            r = r < 0 ? 0 : r > 1 ? 1 : r, i.push(n, r), o.minX = Math.min(o.minX, n), o.minY = Math.min(o.minY, r), o.maxX = Math.max(o.maxX, n), o.maxY = Math.max(o.maxY, r);
        }
        function O(e, t1, s, i = !1, o = !1) {
            const n = [];
            for (const t1 of e)L(t1, n, s);
            t1.push(n), i && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(n, o);
        }
        function z(e, t1, s, i = !1) {
            for(let o = 0; o < e.length; o++)O(e[o], t1, s, i, 0 === o);
        }
        function j(t1, s, i, o) {
            const { id: n, type: r, geometry: a, tags: l } = t1, c = [];
            if (1 === r) !function(t1, s, i, o, n) {
                for(let r = 0; r < t1.length; r += 2){
                    const a = Math.round(e.am * (t1[r + 0] * s - i)), l = Math.round(e.am * (t1[r + 1] * s - o));
                    n.push([
                        a,
                        l
                    ]);
                }
            }(a, s, i, o, c);
            else if (2 === r) for (const e of a)C(e, s, i, o, c);
            else if (3 === r) for (const e of a)D(e, s, i, o, c);
            return {
                id: n,
                type: r,
                geometry: c,
                tags: l
            };
        }
        function C(t1, s, i, o, n) {
            const r = -128, a = e.am + 128;
            let l;
            for(let c = 0; c < t1.length - 2; c += 2){
                let h = Math.round(e.am * (t1[c + 0] * s - i)), u = Math.round(e.am * (t1[c + 1] * s - o)), d = Math.round(e.am * (t1[c + 2] * s - i)), f = Math.round(e.am * (t1[c + 3] * s - o));
                const p = d - h, g = f - u;
                h < r && d < r || (h < r ? (u += Math.round(g * ((r - h) / p)), h = r) : d < r && (f = u + Math.round(g * ((r - h) / p)), d = r), u < r && f < r || (u < r ? (h += Math.round(p * ((r - u) / g)), u = r) : f < r && (d = h + Math.round(p * ((r - u) / g)), f = r), h >= a && d >= a || (h >= a ? (u += Math.round(g * ((a - h) / p)), h = a) : d >= a && (f = u + Math.round(g * ((a - h) / p)), d = a), u >= a && f >= a || (u >= a ? (h += Math.round(p * ((a - u) / g)), u = a) : f >= a && (d = h + Math.round(p * ((a - u) / g)), f = a), l && h === l[l.length - 1][0] && u === l[l.length - 1][1] || (l = [
                    [
                        h,
                        u
                    ]
                ], n.push(l)), l.push([
                    d,
                    f
                ])))));
            }
        }
        function D(t1, s, i, o, n) {
            const r = (i - P) / s, a = (o - P) / s, l = (i + 1 + P) / s, c = (o + 1 + P) / s;
            function h(e, t1) {
                let s = 0;
                return e < r ? s |= 1 : e > l && (s |= 2), t1 < a ? s |= 4 : t1 > c && (s |= 8), s;
            }
            let u = [];
            for(let e = 1; e <= 8; e *= 2){
                let s = t1[t1.length - 2], i = t1[t1.length - 1], o = !(h(s, i) & e);
                for(let n = 0; n < t1.length; n += 2){
                    const d = t1[n], f = t1[n + 1], p = !(h(d, f) & e);
                    p !== o && (8 & e ? u.push(s + (d - s) * (c - i) / (f - i), c) : 4 & e ? u.push(s + (d - s) * (a - i) / (f - i), a) : 2 & e ? u.push(l, i + (f - i) * (l - s) / (d - s)) : 1 & e && u.push(r, i + (f - i) * (r - s) / (d - s))), p && u.push(d, f), s = d, i = f, o = p;
                }
                if (!(t1 = u).length || 8 === e) break;
                u = [];
            }
            const d = [];
            for(let t1 = 0; t1 < u.length; t1 += 2)d.push([
                Math.round(e.am * (u[t1] * s - i)),
                Math.round(e.am * (u[t1 + 1] * s - o))
            ]);
            d.length && n.push(d);
        }
        function F({ name: t1, features: s }, i) {
            i.writeStringField(1, t1), i.writeVarintField(5, e.am);
            const o = new Map, n = new Map, r = {
                keys: o,
                values: n,
                feature: null
            };
            for (const e of s)r.feature = e, i.writeMessage(2, A, r);
            for (const e of o.keys())i.writeStringField(3, e);
            for (const e of n.keys())i.writeMessage(4, N, e);
        }
        function A(e, t1) {
            const s = e.feature;
            void 0 !== s.id && Number.isSafeInteger(+s.id) && t1.writeVarintField(1, +s.id), s.tags && t1.writeMessage(2, B, e), t1.writeVarintField(3, s.type), t1.writeMessage(4, E, s);
        }
        function B({ keys: e, values: t1, feature: s }, i) {
            for (const o of Object.keys(s.tags)){
                let n = s.tags[o];
                if (null === n) continue;
                let r = e.get(o);
                void 0 === r && (r = e.size, e.set(o, r)), i.writeVarint(r);
                const a = typeof n;
                "string" !== a && "boolean" !== a && "number" !== a && (n = JSON.stringify(n));
                let l = t1.get(n);
                void 0 === l && (l = t1.size, t1.set(n, l)), i.writeVarint(l);
            }
        }
        function Z(e, t1) {
            return (t1 << 3) + (7 & e);
        }
        function R(e) {
            return e << 1 ^ e >> 31;
        }
        function E(e, t1) {
            const { geometry: s, type: i } = e;
            let o = 0, n = 0;
            if (1 === i) {
                t1.writeVarint(Z(1, s.length));
                for (const e of s){
                    const s = e[0] - o, i = e[1] - n;
                    t1.writeVarint(R(s)), t1.writeVarint(R(i)), o += s, n += i;
                }
            } else for (const e of s){
                if (0 === e.length) continue;
                t1.writeVarint(Z(1, 1));
                const s = e.length - (3 === i ? 1 : 0);
                for(let i = 0; i < s; i++){
                    1 === i && t1.writeVarint(Z(2, s - 1));
                    const r = e[i][0] - o, a = e[i][1] - n;
                    t1.writeVarint(R(r)), t1.writeVarint(R(a)), o += r, n += a;
                }
                3 === i && t1.writeVarint(Z(7, 1));
            }
        }
        function N(e, t1) {
            const s = typeof e;
            "string" === s ? t1.writeStringField(1, e) : "boolean" === s ? t1.writeBooleanField(7, e) : "number" === s && (e % 1 != 0 ? t1.writeDoubleField(3, e) : e < 0 ? t1.writeSVarintField(6, e) : t1.writeVarintField(5, e));
        }
        const Y = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, X = Math.fround || (G = new Float32Array(1), (e)=>(G[0] = +e, G[0]));
        var G;
        class J {
            constructor(e){
                this.options = Object.assign(Object.create(Y), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e) {
                const { log: t1, minZoom: s, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const o = `prepare ${e.length} points`;
                t1 && console.time(o), this.points = e;
                const n = [];
                for(let t1 = 0; t1 < e.length; t1++){
                    const s = e[t1];
                    if (!s.geometry) continue;
                    const [i, o] = s.geometry.coordinates, r = X(W(i)), a = X(U(o));
                    n.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && n.push(0);
                }
                let r = this.trees[i + 1] = this._createTree(n);
                t1 && console.timeEnd(o);
                for(let e = i; e >= s; e--){
                    const s = +Date.now();
                    r = this.trees[e] = this._createTree(this._cluster(r, e)), t1 && console.log("z%d: %d clusters in %dms", e, r.numItems, +Date.now() - s);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e, t1) {
                let s = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e[1]));
                let o = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) s = -180, o = 180;
                else if (s > o) {
                    const e = this.getClusters([
                        s,
                        i,
                        180,
                        n
                    ], t1), r = this.getClusters([
                        -180,
                        i,
                        o,
                        n
                    ], t1);
                    return e.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(W(s), U(n), W(o), U(i)), l = r.data, c = [];
                for (const e of a){
                    const t1 = this.stride * e;
                    c.push(l[t1 + 5] > 1 ? $(l, t1, this.clusterProps) : this.points[l[t1 + 3]]);
                }
                return c;
            }
            getChildren(e) {
                const t1 = this._getOriginId(e), s = this._getOriginZoom(e), i = "No cluster with the specified id.", o = this.trees[s];
                if (!o) throw new Error(i);
                const n = o.data;
                if (t1 * this.stride >= n.length) throw new Error(i);
                const r = this.options.radius / (this.options.extent * Math.pow(2, s - 1)), a = o.within(n[t1 * this.stride], n[t1 * this.stride + 1], r), l = [];
                for (const t1 of a){
                    const s = t1 * this.stride;
                    n[s + 4] === e && l.push(n[s + 5] > 1 ? $(n, s, this.clusterProps) : this.points[n[s + 3]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e, t1, s) {
                const i = [];
                return this._appendLeaves(i, e, t1 = t1 || 10, s = s || 0, 0), i;
            }
            getTile(e, t1, s) {
                const i = this.trees[this._limitZoom(e)], o = Math.pow(2, e), { extent: n, radius: r } = this.options, a = r / n, l = (s - a) / o, c = (s + 1 + a) / o, h = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / o, l, (t1 + 1 + a) / o, c), i.data, t1, s, o, h), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, l, 1, c), i.data, o, s, o, h), t1 === o - 1 && this._addTileFeatures(i.range(0, l, a / o, c), i.data, -1, s, o, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t1 = this._getOriginZoom(e) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const s = this.getChildren(e);
                    if (t1++, 1 !== s.length) break;
                    e = s[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e, t1, s, i, o) {
                const n = this.getChildren(t1);
                for (const t1 of n){
                    const n = t1.properties;
                    if (n && n.cluster ? o + n.point_count <= i ? o += n.point_count : o = this._appendLeaves(e, n.cluster_id, s, i, o) : o < i ? o++ : e.push(t1), e.length === s) break;
                }
                return o;
            }
            _createTree(t1) {
                const s = new e.c5(t1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t1.length; e += this.stride)s.add(t1[e], t1[e + 1]);
                return s.finish(), s.data = t1, s;
            }
            _addTileFeatures(e, t1, s, i, o, n) {
                for (const r of e){
                    const e = r * this.stride, a = t1[e + 5] > 1;
                    let l, c, h;
                    if (a) l = V(t1, e, this.clusterProps), c = t1[e], h = t1[e + 1];
                    else {
                        const s = this.points[t1[e + 3]];
                        l = s.properties;
                        const [i, o] = s.geometry.coordinates;
                        c = W(i), h = U(o);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * o - s)),
                                Math.round(this.options.extent * (h * o - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e + 3] : this.points[t1[e + 3]].id, void 0 !== d && (u.id = d), n.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t1) {
                const { radius: s, extent: i, reduce: o, minPoints: n } = this.options, r = s / (i * Math.pow(2, t1)), a = e.data, l = [], c = this.stride;
                for(let s = 0; s < a.length; s += c){
                    if (a[s + 2] <= t1) continue;
                    a[s + 2] = t1;
                    const i = a[s], h = a[s + 1], u = e.within(a[s], a[s + 1], r), d = a[s + 5];
                    let f = d;
                    for (const e of u){
                        const s = e * c;
                        a[s + 2] > t1 && (f += a[s + 5]);
                    }
                    if (f > d && f >= n) {
                        let e, n = i * d, r = h * d, p = -1;
                        const g = (s / c << 5) + (t1 + 1) + this.points.length;
                        for (const i of u){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const h = a[l + 5];
                            n += a[l] * h, r += a[l + 1] * h, a[l + 4] = g, o && (e || (e = this._map(a, s, !0), p = this.clusterProps.length, this.clusterProps.push(e)), o(e, this._map(a, l)));
                        }
                        a[s + 4] = g, l.push(n / f, r / f, 1 / 0, g, -1, f), o && l.push(p);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[s + e]);
                        if (f > 1) for (const e of u){
                            const s = e * c;
                            if (!(a[s + 2] <= t1)) {
                                a[s + 2] = t1;
                                for(let e = 0; e < c; e++)l.push(a[s + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t1, s) {
                if (e[t1 + 5] > 1) {
                    const i = this.clusterProps[e[t1 + 6]];
                    return s ? Object.assign({}, i) : i;
                }
                const i = this.points[e[t1 + 3]].properties, o = this.options.map(i);
                return s && o === i ? Object.assign({}, o) : o;
            }
        }
        function $(e, t1, s) {
            var i;
            return {
                type: "Feature",
                id: e[t1 + 3],
                properties: V(e, t1, s),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e[t1], 360 * (i - .5)),
                        q(e[t1 + 1])
                    ]
                }
            };
        }
        function V(e, t1, s) {
            const i = e[t1 + 5], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, n = e[t1 + 6], r = -1 === n ? {} : Object.assign({}, s[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e[t1 + 3],
                point_count: i,
                point_count_abbreviated: o
            });
        }
        function W(e) {
            return e / 360 + .5;
        }
        function U(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function q(e) {
            const t1 = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function H(e, t1, s, i) {
            let o = i;
            const n = t1 + (s - t1 >> 1);
            let r, a = s - t1;
            const l = e[t1], c = e[t1 + 1], h = e[s], u = e[s + 1];
            for(let i = t1 + 3; i < s; i += 3){
                const t1 = Q(e[i], e[i + 1], l, c, h, u);
                if (t1 > o) r = i, o = t1;
                else if (t1 === o) {
                    const e = Math.abs(i - n);
                    e < a && (r = i, a = e);
                }
            }
            o > i && (r - t1 > 3 && H(e, t1, r, i), e[r + 2] = o, s - r > 3 && H(e, r, s, i));
        }
        function Q(e, t1, s, i, o, n) {
            let r = o - s, a = n - i;
            if (0 !== r || 0 !== a) {
                const l = ((e - s) * r + (t1 - i) * a) / (r * r + a * a);
                l > 1 ? (s = o, i = n) : l > 0 && (s += r * l, i += a * l);
            }
            return r = e - s, a = t1 - i, r * r + a * a;
        }
        function K(e, t1, s, i) {
            const o = {
                id: e ?? null,
                type: t1,
                geometry: s,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) ee(o, s);
            else if ("Polygon" === t1) ee(o, s[0]);
            else if ("MultiLineString" === t1) for (const e of s)ee(o, e);
            else if ("MultiPolygon" === t1) for (const e of s)ee(o, e[0]);
            return o;
        }
        function ee(e, t1) {
            for(let s = 0; s < t1.length; s += 3)e.minX = Math.min(e.minX, t1[s]), e.minY = Math.min(e.minY, t1[s + 1]), e.maxX = Math.max(e.maxX, t1[s]), e.maxY = Math.max(e.maxY, t1[s + 1]);
        }
        function te(e, t1, s, i) {
            if (!t1.geometry) return;
            const o = t1.geometry.coordinates;
            if (o && 0 === o.length) return;
            const n = t1.geometry.type, r = Math.pow(s.tolerance / ((1 << s.maxZoom) * s.extent), 2);
            let a = [], l = t1.id;
            if (s.promoteId ? l = t1.properties[s.promoteId] : s.generateId && (l = i || 0), "Point" === n) se(o, a);
            else if ("MultiPoint" === n) for (const e of o)se(e, a);
            else if ("LineString" === n) ie(o, a, r, !1);
            else if ("MultiLineString" === n) {
                if (s.lineMetrics) {
                    for (const s of o)a = [], ie(s, a, r, !1), e.push(K(l, "LineString", a, t1.properties));
                    return;
                }
                oe(o, a, r, !1);
            } else if ("Polygon" === n) oe(o, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        for (const o of t1.geometry.geometries)te(e, {
                            id: l,
                            geometry: o,
                            properties: t1.properties
                        }, s, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of o){
                    const t1 = [];
                    oe(e, t1, r, !0), a.push(t1);
                }
            }
            e.push(K(l, n, a, t1.properties));
        }
        function se(e, t1) {
            t1.push(ne(e[0]), re(e[1]), 0);
        }
        function ie(e, t1, s, i) {
            let o, n, r = 0;
            for(let s = 0; s < e.length; s++){
                const a = ne(e[s][0]), l = re(e[s][1]);
                t1.push(a, l, 0), s > 0 && (r += i ? (o * l - a * n) / 2 : Math.sqrt(Math.pow(a - o, 2) + Math.pow(l - n, 2))), o = a, n = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, H(t1, 0, a, s), t1[a + 2] = 1, t1.size = Math.abs(r), t1.start = 0, t1.end = t1.size;
        }
        function oe(e, t1, s, i) {
            for(let o = 0; o < e.length; o++){
                const n = [];
                ie(e[o], n, s, i), t1.push(n);
            }
        }
        function ne(e) {
            return e / 360 + .5;
        }
        function re(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function ae(e, t1, s, i, o, n, r, a) {
            if (i /= t1, n >= (s /= t1) && r < i) return e;
            if (r < s || n >= i) return null;
            const l = [];
            for (const t1 of e){
                const e = t1.geometry;
                let n = t1.type;
                const r = 0 === o ? t1.minX : t1.minY, c = 0 === o ? t1.maxX : t1.maxY;
                if (r >= s && c < i) {
                    l.push(t1);
                    continue;
                }
                if (c < s || r >= i) continue;
                let h = [];
                if ("Point" === n || "MultiPoint" === n) le(e, h, s, i, o);
                else if ("LineString" === n) ce(e, h, s, i, o, !1, a.lineMetrics);
                else if ("MultiLineString" === n) ue(e, h, s, i, o, !1);
                else if ("Polygon" === n) ue(e, h, s, i, o, !0);
                else if ("MultiPolygon" === n) for (const t1 of e){
                    const e = [];
                    ue(t1, e, s, i, o, !0), e.length && h.push(e);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === n) {
                        for (const e of h)l.push(K(t1.id, n, e, t1.tags));
                        continue;
                    }
                    "LineString" !== n && "MultiLineString" !== n || (1 === h.length ? (n = "LineString", h = h[0]) : n = "MultiLineString"), "Point" !== n && "MultiPoint" !== n || (n = 3 === h.length ? "Point" : "MultiPoint"), l.push(K(t1.id, n, h, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function le(e, t1, s, i, o) {
            for(let n = 0; n < e.length; n += 3){
                const r = e[n + o];
                r >= s && r <= i && de(t1, e[n], e[n + 1], e[n + 2]);
            }
        }
        function ce(e, t1, s, i, o, n, r) {
            let a = he(e);
            const l = 0 === o ? fe : pe;
            let c, h, u = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const f = e[d], p = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], w = 0 === o ? f : p, b = 0 === o ? m : y;
                let v = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(p - y, 2))), w < s ? b > s && (h = l(a, f, p, m, y, s), r && (a.start = u + c * h)) : w > i ? b < i && (h = l(a, f, p, m, y, i), r && (a.start = u + c * h)) : de(a, f, p, g), b < s && w >= s && (h = l(a, f, p, m, y, s), v = !0), b > i && w <= i && (h = l(a, f, p, m, y, i), v = !0), !n && v && (r && (a.end = u + c * h), t1.push(a), a = he(e)), r && (u += c);
            }
            let d = e.length - 3;
            const f = e[d], p = e[d + 1], g = 0 === o ? f : p;
            g >= s && g <= i && de(a, f, p, e[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && de(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function he(e) {
            const t1 = [];
            return t1.size = e.size, t1.start = e.start, t1.end = e.end, t1;
        }
        function ue(e, t1, s, i, o, n) {
            for (const r of e)ce(r, t1, s, i, o, n, !1);
        }
        function de(e, t1, s, i) {
            e.push(t1, s, i);
        }
        function fe(e, t1, s, i, o, n) {
            const r = (n - t1) / (i - t1);
            return de(e, n, s + (o - s) * r, 1), r;
        }
        function pe(e, t1, s, i, o, n) {
            const r = (n - s) / (o - s);
            return de(e, t1 + (i - t1) * r, n, 1), r;
        }
        function ge(e, t1) {
            const s = [];
            for(let i = 0; i < e.length; i++){
                const o = e[i], n = o.type;
                let r;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = me(o.geometry, t1);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for (const e of o.geometry)r.push(me(e, t1));
                } else if ("MultiPolygon" === n) {
                    r = [];
                    for (const e of o.geometry){
                        const s = [];
                        for (const i of e)s.push(me(i, t1));
                        r.push(s);
                    }
                }
                s.push(K(o.id, n, r, o.tags));
            }
            return s;
        }
        function me(e, t1) {
            const s = [];
            s.size = e.size, void 0 !== e.start && (s.start = e.start, s.end = e.end);
            for(let i = 0; i < e.length; i += 3)s.push(e[i] + t1, e[i + 1], e[i + 2]);
            return s;
        }
        function ye(e, t1) {
            if (e.transformed) return e;
            const s = 1 << e.z, i = e.x, o = e.y;
            for (const n of e.features){
                const e = n.geometry, r = n.type;
                if (n.geometry = [], 1 === r) for(let r = 0; r < e.length; r += 2)n.geometry.push(we(e[r], e[r + 1], t1, s, i, o));
                else for(let r = 0; r < e.length; r++){
                    const a = [];
                    for(let n = 0; n < e[r].length; n += 2)a.push(we(e[r][n], e[r][n + 1], t1, s, i, o));
                    n.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function we(e, t1, s, i, o, n) {
            return [
                Math.round(s * (e * i - o)),
                Math.round(s * (t1 * i - n))
            ];
        }
        function be(e, t1, s, i, o) {
            const n = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: s,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e)ve(r, t1, n, o);
            return r;
        }
        function ve(e, t1, s, i) {
            const o = t1.geometry, n = t1.type, r = [];
            if (e.minX = Math.min(e.minX, t1.minX), e.minY = Math.min(e.minY, t1.minY), e.maxX = Math.max(e.maxX, t1.maxX), e.maxY = Math.max(e.maxY, t1.maxY), "Point" === n || "MultiPoint" === n) for(let t1 = 0; t1 < o.length; t1 += 3)r.push(o[t1], o[t1 + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === n) xe(r, o, e, s, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(let t1 = 0; t1 < o.length; t1++)xe(r, o[t1], e, s, "Polygon" === n, 0 === t1);
            else if ("MultiPolygon" === n) for(let t1 = 0; t1 < o.length; t1++){
                const i = o[t1];
                for(let t1 = 0; t1 < i.length; t1++)xe(r, i[t1], e, s, !0, 0 === t1);
            }
            if (r.length) {
                let s = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    s = {};
                    for(const e in t1.tags)s[e] = t1.tags[e];
                    s.mapbox_clip_start = o.start / o.size, s.mapbox_clip_end = o.end / o.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: s
                };
                null !== t1.id && (a.id = t1.id), e.features.push(a);
            }
        }
        function xe(e, t1, s, i, o, n) {
            const r = i * i;
            if (i > 0 && t1.size < (o ? r : i)) return void (s.numPoints += t1.length / 3);
            const a = [];
            for(let e = 0; e < t1.length; e += 3)(0 === i || t1[e + 2] > r) && (s.numSimplified++, a.push(t1[e], t1[e + 1])), s.numPoints++;
            o && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(a, n), e.push(a);
        }
        const Ie = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class Se {
            constructor(e, t1){
                const s = (t1 = this.options = function(e, t1) {
                    for(const s in t1)e[s] = t1[s];
                    return e;
                }(Object.create(Ie), t1)).debug;
                if (s && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e, t1) {
                    const s = [];
                    if ("FeatureCollection" === e.type) for(let i = 0; i < e.features.length; i++)te(s, e.features[i], t1, i);
                    else te(s, "Feature" === e.type ? e : {
                        geometry: e
                    }, t1);
                    return s;
                }(e, t1);
                this.tiles = {}, this.tileCoords = [], s && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e, t1) {
                    const s = t1.buffer / t1.extent;
                    let i = e;
                    const o = ae(e, 1, -1 - s, s, 0, -1, 2, t1), n = ae(e, 1, 1 - s, 2 + s, 0, -1, 2, t1);
                    return (o || n) && (i = ae(e, 1, -s, 1 + s, 0, -1, 2, t1) || [], o && (i = ge(o, 1).concat(i)), n && (i = i.concat(ge(n, -1)))), i;
                }(i, t1), i.length && this.splitTile(i, 0, 0, 0), s && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e, t1, s, i, o, n, r) {
                const a = [
                    e,
                    t1,
                    s,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), s = a.pop(), t1 = a.pop(), e = a.pop();
                    const h = 1 << t1, u = Me(t1, s, i);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = be(e, t1, s, i, l), this.tileCoords.push({
                        z: t1,
                        x: s,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, s, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t1}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == o) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === o) continue;
                        if (null != o) {
                            const e = o - t1;
                            if (s !== n >> e || i !== r >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, p = .5 - f, g = .5 + f, m = 1 + f;
                    let y = null, w = null, b = null, v = null, x = ae(e, h, s - f, s + g, 0, d.minX, d.maxX, l), I = ae(e, h, s + p, s + m, 0, d.minX, d.maxX, l);
                    e = null, x && (y = ae(x, h, i - f, i + g, 1, d.minY, d.maxY, l), w = ae(x, h, i + p, i + m, 1, d.minY, d.maxY, l), x = null), I && (b = ae(I, h, i - f, i + g, 1, d.minY, d.maxY, l), v = ae(I, h, i + p, i + m, 1, d.minY, d.maxY, l), I = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * s, 2 * i), a.push(w || [], t1 + 1, 2 * s, 2 * i + 1), a.push(b || [], t1 + 1, 2 * s + 1, 2 * i), a.push(v || [], t1 + 1, 2 * s + 1, 2 * i + 1);
                }
            }
            getTile(e, t1, s) {
                e = +e, t1 = +t1, s = +s;
                const i = this.options, { extent: o, debug: n } = i;
                if (e < 0 || e > 24) return null;
                const r = 1 << e, a = Me(e, t1 = t1 + r & r - 1, s);
                if (this.tiles[a]) return ye(this.tiles[a], o);
                n > 1 && console.log("drilling down to z%d-%d-%d", e, t1, s);
                let l, c = e, h = t1, u = s;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[Me(c, h, u)];
                return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e, t1, s), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ye(this.tiles[a], o) : null) : null;
            }
        }
        function Me(e, t1, s) {
            return 32 * ((1 << e) * s + t1) + e;
        }
        function Pe(t1, s) {
            const i = t1.tileID.canonical;
            if (!this._geoJSONIndex) return void s(null, null);
            const o = this._geoJSONIndex.getTile(i.z, i.x, i.y);
            if (!o) return void s(null, null);
            const n = (e)=>e.tags && "3d_elevation_id" in e.tags && "source" in e.tags && "elevation" === e.tags.source, r = o.features.filter((e)=>n(e));
            let a = {
                _geojsonTileLayer: o.features
            };
            r.length > 0 && (a = {
                _geojsonTileLayer: o.features.filter((e)=>!n(e)),
                hd_road_elevation: r
            });
            const l = new M(a), c = function(t1) {
                const s = new e.bu;
                for (const e of Object.keys(t1))s.writeMessage(3, F, {
                    name: e,
                    features: t1[e]
                });
                return s.finish();
            }(a).buffer;
            s(null, {
                vectorTile: l,
                rawData: c
            });
        }
        class Te extends y {
            constructor({ actor: e, layerIndex: t1, availableImages: s, availableModels: i, isSpriteLoaded: o, brightness: n }){
                super({
                    actor: e,
                    layerIndex: t1,
                    availableImages: s,
                    availableModels: i,
                    isSpriteLoaded: o,
                    loadTileData: Pe,
                    brightness: n
                }), this._dynamicIndex = new T;
            }
            loadData(s, i) {
                const o = s && s.request, n = o && o.collectResourceTiming;
                this._geoJSONIndex = null, this.loadGeoJSON(s, (r, a)=>{
                    if (r || !a) return i(r);
                    if ("object" != typeof a) return i(new Error(`Input data given to '${s.source}' is not a valid GeoJSON object.`));
                    {
                        try {
                            if (s.filter) {
                                const t1 = e.W(s.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === t1.result) throw new Error(t1.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                a.features = a.features.filter((e)=>t1.value.evaluate({
                                        zoom: 0
                                    }, e));
                            }
                            s.dynamic ? ("Feature" === a.type && (a = {
                                type: "FeatureCollection",
                                features: [
                                    a
                                ]
                            }), s.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a.features, this.loaded), s.cluster && (a.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s.cluster ? new J(function({ superclusterOptions: t1, clusterProperties: s }) {
                                if (!s || !t1) return t1;
                                const i = {}, o = {}, n = {
                                    accumulated: null,
                                    zoom: 0
                                }, r = {
                                    properties: null
                                }, a = Object.keys(s);
                                for (const t1 of a){
                                    const [n, r] = s[t1], a = e.W(r), l = e.W("string" == typeof n ? [
                                        n,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : n);
                                    i[t1] = a.value, o[t1] = l.value;
                                }
                                return t1.map = (e)=>{
                                    r.properties = e;
                                    const t1 = {};
                                    for (const e of a)t1[e] = i[e].evaluate(n, r);
                                    return t1;
                                }, t1.reduce = (e, t1)=>{
                                    r.properties = t1;
                                    for (const t1 of a)n.accumulated = e[t1], e[t1] = o[t1].evaluate(n, r);
                                }, t1;
                            }(s)).load(a.features) : s.dynamic ? this._dynamicIndex : function(e, t1) {
                                return new Se(e, t1);
                            }(a, s.geojsonVtOptions);
                        } catch (e) {
                            return i(e);
                        }
                        const r = {};
                        if (n) {
                            const e = t1(o);
                            e && (r.resourceTiming = {}, r.resourceTiming[s.source] = JSON.parse(JSON.stringify(e)));
                        }
                        i(null, r);
                    }
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded;
                return s && s[e.uid] ? e.partial ? t1(null, void 0) : super.reloadTile(e, t1) : this.loadTile(e, t1);
            }
            loadGeoJSON(t1, s) {
                if (t1.request) e.m(t1.request, s);
                else {
                    if ("string" != typeof t1.data) return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    setTimeout(()=>{
                        try {
                            return s(null, JSON.parse(t1.data));
                        } catch (e) {
                            return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                        }
                    }, 0);
                }
            }
            getClusterExpansionZoom(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterChildren(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterLeaves(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t1(e);
                }
            }
        }
        class _e {
            constructor(t1, s, i){
                this.tileID = new e.aR(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t1.projection, this.brightness = s, this.worldview = i;
            }
            parse(t1, s, i, o) {
                this.status = "parsing";
                const n = new e.aR(i.tileID.overscaledZ, i.tileID.wrap, i.tileID.canonical.z, i.tileID.canonical.x, i.tileID.canonical.y), r = [], a = s.familiesBySource[i.source], l = new e.fr(n, i.promoteId);
                l.bucketLayerIDs = [], l.is3DTile = !0, e.fJ(t1).then((t1)=>{
                    const s = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("MAPBOX_mesh_features") || t1.json.asset.extras && t1.json.asset.extras.MAPBOX_mesh_features, c = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression"), h = new e.ad(this.zoom, {
                        brightness: this.brightness,
                        worldview: this.worldview
                    });
                    for(const o in a)for (const u of a[o]){
                        const o = u[0];
                        l.bucketLayerIDs.push(u.map((t1)=>e.C(t1.id, t1.scope))), o.recalculate(h, []);
                        const a = e.fK(t1, 1 / e.d8(i.tileID.canonical)), d = new e.fL(u, a, n, s, c, this.brightness, l, this.worldview);
                        s || (d.needsUpload = !0), r.push(d), d.evaluate(o);
                    }
                    this.status = "done", o(null, {
                        buckets: r,
                        featureIndex: l,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: null
                    });
                }).catch((e)=>o(new Error(e.message)));
            }
        }
        class ke {
            constructor({ actor: e, layerIndex: t1, availableImages: s, availableModels: i, brightness: o, worldview: n }){
                this.actor = e, this.layerIndex = t1, this.availableImages = s, this.availableModels = i, this.brightness = o, this.loading = {}, this.loaded = {}, this.worldview = n;
            }
            loadTile(t1, s) {
                const i = t1.uid, o = this.loading[i] = new _e(t1, this.brightness, this.worldview);
                e.bv(t1.request, (e, n)=>{
                    const r = !this.loading[i];
                    return delete this.loading[i], r || e ? (o.status = "done", r || (this.loaded[i] = o), s(e)) : n && 0 !== n.byteLength ? void o.parse(n, this.layerIndex, t1, (e, t1)=>{
                        o.status = "done", this.loaded = this.loaded || {}, this.loaded[i] = o, e || !t1 ? s(e) : s(null, t1);
                    }) : (o.status = "done", this.loaded[i] = o, s());
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded, i = e.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.projection = e.projection, o.brightness = e.brightness;
                    const n = (s, i)=>{
                        o.reloadCallback && (delete o.reloadCallback, this.loadTile(e, t1)), t1(s, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = n : "done" === o.status && this.loadTile(e, t1);
                }
            }
            abortTile(e, t1) {
                const s = e.uid;
                this.loading[s] && delete this.loading[s], t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        class Le {
            constructor(t1){
                this.self = t1, this.actor = new e.fN(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new e.y, this.rtlPluginParsingListeners = [], this.projections = {}, this.defaultProjection = e.cn({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: y,
                    geojson: Te,
                    "raster-dem": w,
                    "raster-array": v,
                    "batched-model": ke
                }, this.workerSources = {}, this.self.registerWorkerSource = (e, t1)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e.fO.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.fO.setState({
                        pluginStatus: e.fP.parsed,
                        pluginURL: e.fO.getPluginURL()
                    }), e.fO.applyArabicShaping = t1.applyArabicShaping, e.fO.processBidirectionalText = t1.processBidirectionalText, e.fO.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                    for (const e of this.rtlPluginParsingListeners)e(null, !0);
                    this.rtlPluginParsingListeners = [];
                };
            }
            clearCaches(e, t1, s) {
                delete this.layerIndexes[e], delete this.availableImages[e], delete this.availableModels[e], delete this.workerSources[e], s();
            }
            checkIfReady(e, t1, s) {
                s();
            }
            setReferrer(e, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, s) {
                this.isSpriteLoaded[t1] || (this.isSpriteLoaded[t1] = {});
                const { scope: i, isLoaded: o } = s;
                if (this.isSpriteLoaded[t1][i] = o, this.workerSources[t1] && this.workerSources[t1][i]) for(const s in this.workerSources[t1][i]){
                    const n = this.workerSources[t1][i][s];
                    for(const t1 in n){
                        const s = n[t1];
                        s instanceof y && (s.isSpriteLoaded = o, s.fire(new e.A("isSpriteLoaded")));
                    }
                }
            }
            setImages(e, t1, s) {
                this.availableImages[e] || (this.availableImages[e] = {});
                const { scope: i, images: o } = t1;
                if (this.availableImages[e][i] = o, this.workerSources[e] && this.workerSources[e][i]) {
                    for(const t1 in this.workerSources[e][i]){
                        const s = this.workerSources[e][i][t1];
                        for(const e in s)s[e].availableImages = o;
                    }
                    s();
                } else s();
            }
            setModels(e, { scope: t1, models: s }, i) {
                if (this.availableModels[e] || (this.availableModels[e] = {}), this.availableModels[e][t1] = s, this.workerSources[e] && this.workerSources[e][t1]) {
                    for(const i in this.workerSources[e][t1]){
                        const o = this.workerSources[e][t1][i];
                        for(const e in o)o[e].availableModels = s;
                    }
                    i();
                } else i();
            }
            setProjection(t1, s) {
                this.projections[t1] = e.cn(s);
            }
            setBrightness(e, t1, s) {
                this.brightness = t1, s();
            }
            setWorldview(e, t1, s) {
                this.worldview = t1, s();
            }
            setLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).replace(t1.layers, t1.options), s();
            }
            updateLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).update(t1.layers, t1.removedIds, t1.options), s();
            }
            loadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).loadTile(t1, s);
            }
            decodeRasterArray(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).decodeRasterArray(t1, s);
            }
            reloadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).reloadTile(t1, s);
            }
            abortTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).abortTile(t1, s);
            }
            removeTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).removeTile(t1, s);
            }
            removeSource(e, t1, s) {
                if (!(this.workerSources[e] && this.workerSources[e][t1.scope] && this.workerSources[e][t1.scope][t1.type] && this.workerSources[e][t1.scope][t1.type][t1.source])) return;
                const i = this.workerSources[e][t1.scope][t1.type][t1.source];
                delete this.workerSources[e][t1.scope][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, s) : s();
            }
            loadWorkerSource(e, t1, s) {
                try {
                    this.self.importScripts(t1.url), s();
                } catch (e) {
                    s(e);
                }
            }
            syncRTLPluginState(t1, s, i) {
                if (e.fO.isParsed()) i(null, !0);
                else if (e.fO.isParsing()) this.rtlPluginParsingListeners.push(i);
                else try {
                    e.fO.setState(s);
                    const t1 = e.fO.getPluginURL();
                    !e.fO.isLoaded() || e.fO.isParsed() || e.fO.isParsing() || null == t1 || (e.fO.setState({
                        pluginStatus: e.fP.parsing,
                        pluginURL: e.fO.getPluginURL()
                    }), this.self.importScripts(t1), e.fO.isParsed() ? i(null, !0) : this.rtlPluginParsingListeners.push(i));
                } catch (e) {
                    i(e);
                }
            }
            setDracoUrl(e, t1) {
                this.dracoUrl = t1;
            }
            getAvailableImages(e, t1) {
                this.availableImages[e] || (this.availableImages[e] = {});
                let s = this.availableImages[e][t1];
                return s || (s = []), s;
            }
            getAvailableModels(e, t1) {
                this.availableModels[e] || (this.availableModels[e] = {});
                let s = this.availableModels[e][t1];
                return s || (s = {}), s;
            }
            getLayerIndex(e, t1) {
                this.layerIndexes[e] || (this.layerIndexes[e] = {});
                let s = this.layerIndexes[e][t1];
                return s || (s = this.layerIndexes[e][t1] = new n, s.scope = t1), s;
            }
            getWorkerSource(e, t1, s, i) {
                const o = this.workerSources;
                if (o[e] || (o[e] = {}), o[e][i] || (o[e][i] = {}), o[e][i][t1] || (o[e][i][t1] = {}), this.isSpriteLoaded[e] || (this.isSpriteLoaded[e] = {}), !o[e][i][t1][s]) {
                    const n = {
                        send: (t1, s, i, o, n, r)=>this.actor.send(t1, s, i, e, n, r),
                        scheduler: this.actor.scheduler
                    }, r = this.workerSourceTypes[t1];
                    if (!r) throw new Error(`Unknown worker source type "${t1}".`);
                    o[e][i][t1][s] = new r({
                        actor: n,
                        layerIndex: this.getLayerIndex(e, i),
                        availableImages: this.getAvailableImages(e, i),
                        availableModels: this.getAvailableModels(e, i),
                        isSpriteLoaded: this.isSpriteLoaded[e][i],
                        loadTileData: void 0,
                        brightness: this.brightness,
                        worldview: this.worldview
                    });
                }
                return o[e][i][t1][s];
            }
            rasterizeImagesWorker(e, t1, s) {
                const i = new Map;
                for (const [s, { image: o, imageVariant: n }] of t1.tasks.entries()){
                    const r = this.imageRasterizer.rasterize(n, o, t1.scope, e);
                    i.set(s, r);
                }
                s(void 0, i);
            }
            removeRasterizedImages(e, t1, s) {
                this.imageRasterizer.removeImagesFromCacheByIds(t1.imageIds, t1.scope, e), s();
            }
            enforceCacheSizeLimit(t1, s) {
                e.fQ(s);
            }
            getWorkerPerformanceMetrics(e, t1, s) {
                s(void 0, void 0);
            }
        }
        return e.fM(self) && (self.worker = new Le(self)), Le;
    });
    define([
        "./shared"
    ], function(e) {
        var t1 = "3.20.0";
        const i = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, o = {
            mark (e) {
                performance.mark(e);
            },
            measure (e, t1, i) {
                performance.measure(e, t1, i);
            }
        };
        function s(t1) {
            const i = t1.name.split("?")[0];
            return e.a(i) && i.includes("mapbox-gl.js") ? "javascript" : e.a(i) && i.includes("mapbox-gl.css") ? "css" : e.b(i) ? "fontRange" : e.c(i) ? "sprite" : e.i(i) ? "style" : e.d(i) ? "tilejson" : "other";
        }
        var r, n = {}, a = function() {
            if (r) return n;
            function e(e) {
                return !t1(e);
            }
            function t1(t1) {
                var o;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e = !0;
                    } catch (t1) {
                        e = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e;
                }() ? function() {
                    var e = document.createElement("canvas");
                    e.width = e.height = 1;
                    var t1 = e.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e.width;
                }() ? (void 0 === i[o = t1 && t1.failIfMajorPerformanceCaveat] && (i[o] = function(t1) {
                    var i, o = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.getContext("webgl2", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        i = o.createShader(o.VERTEX_SHADER);
                    } catch (e) {
                        return !1;
                    }
                    return !(!i || o.isContextLost()) && (o.shaderSource(i, "void main() {}"), o.compileShader(i), !0 === o.getShaderParameter(i, o.COMPILE_STATUS));
                }(o)), i[o] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            }
            r = 1, n.supported = e, n.notSupportedReason = t1;
            var i = {};
            return e.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            }, n;
        }();
        function l(e, t1, i) {
            const o = document.createElement(e);
            return null != t1 && (o.className = t1), i && i.appendChild(o), o;
        }
        function c(e, t1, i) {
            const o = document.createElementNS("http://www.w3.org/2000/svg", e);
            for (const e of Object.keys(t1))o.setAttributeNS(null, e, String(t1[e]));
            return i && i.appendChild(o), o;
        }
        const h = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, d = h && void 0 !== h.userSelect ? "userSelect" : "WebkitUserSelect";
        let u;
        function _() {
            h && d && (u = h[d], h[d] = "none");
        }
        function p() {
            h && d && (h[d] = u);
        }
        function f(e) {
            e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function g(e, t1) {
            const i = e.getBoundingClientRect();
            return x(e, i, t1);
        }
        function v(e, t1) {
            const i = e.getBoundingClientRect(), o = [];
            for(let s = 0; s < t1.length; s++)o.push(x(e, i, t1[s]));
            return o;
        }
        function y(e) {
            return /firefox/i.test(navigator.userAgent) && /macintosh/i.test(navigator.userAgent) && 2 === e.button && e.ctrlKey ? 0 : e.button;
        }
        function x(t1, i, o) {
            const s = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e.P((o.clientX - i.left) * s, (o.clientY - i.top) * s);
        }
        const b = "01", w = "NO_ACCESS_TOKEN";
        class T {
            constructor(e, t1, i){
                this._transformRequestFn = e, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e = function() {
                    let e = "";
                    for(let t1 = 0; t1 < 10; t1++)e += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            b,
                            e
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e.token, this._skuTokenExpiresAt = e.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e, t1) {
                return this._transformRequestFn && this._transformRequestFn(e, t1) || {
                    url: e
                };
            }
            normalizeStyleURL(i, o) {
                if (!e.h(i)) return i;
                const s = S(i);
                return s.params.push(`sdk=js-${t1}`), s.path = `/styles/v1${s.path}`, this._makeAPIURL(s, this._customAccessToken || o);
            }
            normalizeGlyphsURL(t1, i) {
                if (!e.h(t1)) return t1;
                const o = S(t1);
                return o.path = `/fonts/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeModelURL(t1, i) {
                if (!e.h(t1)) return t1;
                const o = S(t1);
                return o.path = `/models/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeSourceURL(t1, i, o, s) {
                if (!e.h(t1)) return t1;
                const r = S(t1);
                return r.path = `/v4/${r.authority}.json`, r.params.push("secure"), o && r.params.push(`language=${o}`), s && r.params.push(`worldview=${s}`), this._makeAPIURL(r, this._customAccessToken || i);
            }
            normalizeIconsetURL(t1, i) {
                const o = S(t1);
                return e.h(t1) ? (o.path = `/styles/v1${o.path}/iconset.pbf`, this._makeAPIURL(o, this._customAccessToken || i)) : I(o);
            }
            normalizeSpriteURL(t1, i, o, s) {
                const r = S(t1);
                return e.h(t1) ? (r.path = `/styles/v1${r.path}/sprite${i}${o}`, this._makeAPIURL(r, this._customAccessToken || s)) : (r.path += `${i}${o}`, I(r));
            }
            normalizeTileURL(t1, i, o) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !e.h(t1)) return t1;
                const s = S(t1);
                s.path = s.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i || o && "raster" !== s.authority && 512 === o ? "@2x" : ""}${e.k.supported ? ".webp" : "$1"}`), "raster" === s.authority ? s.path = `/${e.e.RASTER_URL_PREFIX}${s.path}` : "rasterarrays" === s.authority ? s.path = `/${e.e.RASTERARRAYS_URL_PREFIX}${s.path}` : "3dtiles" === s.authority ? s.path = `/${e.e.TILES3D_URL_PREFIX}${s.path}` : (s.path = s.path.replace(/^.+\/v4\//, "/"), s.path = `/${e.e.TILE_URL_VERSION}${s.path}`);
                const r = this._customAccessToken || function(e) {
                    for (const t1 of e){
                        const e = t1.match(/^access_token=(.*)$/);
                        if (e) return e[1];
                    }
                    return null;
                }(s.params) || e.e.ACCESS_TOKEN;
                return e.e.REQUIRE_ACCESS_TOKEN && r && this._skuToken && s.params.push(`sku=${this._skuToken}`), this._makeAPIURL(s, r);
            }
            canonicalizeTileURL(t1, i) {
                const o = S(t1);
                if (!o.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o.path.match(/\.[\w]+$/)) return t1;
                let s = "mapbox://";
                o.path.match(/^\/raster\/v1\//) ? s += `raster/${o.path.replace(`/${e.e.RASTER_URL_PREFIX}/`, "")}` : o.path.match(/^\/rasterarrays\/v1\//) ? s += `rasterarrays/${o.path.replace(`/${e.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : s += `tiles/${o.path.replace(`/${e.e.TILE_URL_VERSION}/`, "")}`;
                let r = o.params;
                return i && (r = r.filter((e)=>!e.match(/^access_token=/))), r.length && (s += `?${r.join("&")}`), s;
            }
            canonicalizeTileset(t1, i) {
                const o = !!i && e.h(i), s = [];
                for (const i of t1.tiles || [])e.j(i) ? s.push(this.canonicalizeTileURL(i, o)) : s.push(i);
                return s;
            }
            _makeAPIURL(t1, i) {
                const o = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", s = S(e.e.API_URL);
                if (t1.protocol = s.protocol, t1.authority = s.authority, "http" === t1.protocol) {
                    const e = t1.params.indexOf("secure");
                    e >= 0 && t1.params.splice(e, 1);
                }
                if ("/" !== s.path && (t1.path = `${s.path}${t1.path}`), !e.e.REQUIRE_ACCESS_TOKEN) return I(t1);
                if (i = i || e.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!i) throw new Error(`An API access token is required to use Mapbox GL. ${o}`);
                    if ("s" === i[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o}`);
                }
                return t1.params = t1.params.filter((e)=>-1 === e.indexOf("access_token")), t1.params.push(`access_token=${i || ""}`), I(t1);
            }
        }
        const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function S(e) {
            const t1 = e.match(E);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function I(e) {
            const t1 = e.params.length ? `?${e.params.join("&")}` : "";
            return `${e.protocol}://${e.authority}${e.path}${t1}`;
        }
        const C = "mapbox.eventData";
        function R(t1) {
            if (!t1) return null;
            const i = t1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(e.l(i[1]));
            } catch (e) {
                return null;
            }
        }
        class A {
            constructor(e){
                this.type = e, this.anonId = null, this.anonIdTimestamp = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t1) {
                const i = R(e.e.ACCESS_TOKEN);
                let o = "";
                return o = i && i.u ? e.f(i.u) : e.e.ACCESS_TOKEN || "", t1 ? `${C}.${t1}:${o}` : `${C}:${o}`;
            }
            fetchEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), s = this.getStorageKey("uuidTimestamp");
                if (t1) try {
                    const e = localStorage.getItem(i);
                    e && (this.eventData = JSON.parse(e));
                    const t1 = localStorage.getItem(o);
                    t1 && (this.anonId = t1);
                    const r = localStorage.getItem(s);
                    r && (this.anonIdTimestamp = Number(r));
                    const n = Date.now() - 864e5;
                    (!this.anonIdTimestamp || this.anonIdTimestamp < n) && this.refreshUUID();
                } catch (t1) {
                    e.w("Unable to read from LocalStorage");
                }
            }
            refreshUUID() {
                this.anonId = e.u(), this.anonIdTimestamp = Date.now();
            }
            saveEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), s = this.getStorageKey("uuidTimestamp"), r = this.anonId, n = this.anonIdTimestamp;
                if (t1 && r) try {
                    localStorage.setItem(o, r), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i, JSON.stringify(this.eventData)), n && localStorage.setItem(s, n.toString());
                } catch (t1) {
                    e.w("Unable to write to LocalStorage");
                }
            }
            processRequests(e) {}
            postEvent(t1, i, o, s) {
                if (!e.e.EVENTS_URL) return;
                const r = S(e.e.EVENTS_URL);
                r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const n = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, a = i ? Object.assign(n, i) : n, l = {
                    url: I(r),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = e.p(l, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            queueRequest(e, t1) {
                this.queue.push(e), this.processRequests(t1);
            }
        }
        class D extends A {
            constructor(e){
                super("metrics"), e && (this.data = e);
            }
            postMetricsEvent(t1) {
                if (!e.e.EVENTS_URL || !t1 && !e.e.ACCESS_TOKEN) return;
                this.anonId || this.fetchEventData(), e.v(this.anonId) || this.refreshUUID();
                const i = Object.assign({}, this.data, {
                    sessionId: this.anonId
                });
                this.queueRequest({
                    timestamp: Date.now(),
                    payload: i
                }, t1);
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e);
            }
        }
        const L = new class extends A {
            constructor(e){
                super("appUserTurnstile"), this._customAccessToken = e;
            }
            postTurnstileEvent(t1, i) {
                e.e.EVENTS_URL && e.e.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>e.h(t1) || e.j(t1)) && this.queueRequest(Date.now(), i);
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.anonIdTimestamp && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const o = R(e.e.ACCESS_TOKEN), s = o ? o.u : e.e.ACCESS_TOKEN;
                let r = s !== this.eventData.tokenU;
                e.v(this.anonId) || (this.refreshUUID(), r = !0);
                const n = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e = new Date(this.eventData.lastSuccess), t1 = new Date(n), i = (n - this.eventData.lastSuccess) / 864e5;
                    r = r || i >= 1 || i < -1 || e.getDate() !== t1.getDate();
                } else r = !0;
                r ? this.postEvent(n, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e)=>{
                    e || (this.eventData.lastSuccess = n, this.eventData.tokenU = s);
                }, i) : this.processRequests();
            }
        }, P = L.postTurnstileEvent.bind(L), O = new class extends A {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.EVENTS_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: o, timestamp: s } = this.queue.shift();
                o && this.success[o] || (this.anonId && this.anonIdTimestamp || this.fetchEventData(), e.v(this.anonId) || this.refreshUUID(), this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e)=>{
                    e ? this.errorCb(e) : o && (this.success[o] = !0);
                }, i));
            }
            remove() {
                this.errorCb = null;
            }
        }, z = O.postMapLoadEvent.bind(O), M = new class extends A {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(t1) {
                let i = this.mapInstanceIdMap.get(t1);
                return i || (i = e.u(), this.mapInstanceIdMap.set(t1, i)), i;
            }
            getEventId(e) {
                const t1 = this.eventIdPerMapInstanceMap.get(e) || 0;
                return this.eventIdPerMapInstanceMap.set(e, t1 + 1), t1;
            }
            postStyleLoadEvent(t1, i) {
                const { map: o, style: s, importedStyles: r } = i;
                if (!e.e.EVENTS_URL || !t1 && !e.e.ACCESS_TOKEN) return;
                const n = this.getMapInstanceId(o), a = {
                    mapInstanceId: n,
                    eventId: this.getEventId(n),
                    style: s
                };
                r.length && (a.importedStyles = r), this.queueRequest({
                    timestamp: Date.now(),
                    payload: a
                }, t1);
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e);
            }
        }, F = M.postStyleLoadEvent.bind(M), k = new D({
            attributes: [
                {
                    name: "maps/js/layer-animations/style-with-appearances"
                }
            ]
        }), B = k.postMetricsEvent.bind(k), N = new D({
            attributes: [
                {
                    name: "maps/js/layer-animations/runtime-appearances"
                }
            ]
        }), U = N.postMetricsEvent.bind(N), j = new class extends A {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(t1, i) {
                e.e.EVENTS_URL && (t1 || e.e.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: i
                }, t1);
            }
            processRequests(o) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: r, performanceData: n } = this.queue.shift(), a = function(o) {
                    const r = performance.getEntriesByType("resource"), n = performance.getEntriesByType("mark"), a = function(e) {
                        const t1 = {};
                        if (e) {
                            for(const i in e)if ("other" !== i) for (const o of e[i]){
                                const e = `${i}ResolveRangeMin`, s = `${i}ResolveRangeMax`, r = `${i}RequestCount`, n = `${i}RequestCachedCount`;
                                t1[e] = Math.min(t1[e] || 1 / 0, o.startTime), t1[s] = Math.max(t1[s] || -1 / 0, o.responseEnd);
                                const a = (e)=>{
                                    void 0 === t1[e] && (t1[e] = 0), ++t1[e];
                                };
                                void 0 !== o.transferSize && 0 === o.transferSize && a(n), a(r);
                            }
                        }
                        return t1;
                    }(function(e, t1) {
                        const i = {};
                        if (e) for (const o of e){
                            const e = t1(o);
                            void 0 === i[e] && (i[e] = []), i[e].push(o);
                        }
                        return i;
                    }(r, s)), l = window.devicePixelRatio, c = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h = c ? c.effectiveType : void 0, d = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, u = (e, t1, i)=>{
                        null != i && e.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e in a)u(d.counters, e, a[e]);
                    if (o.interactionRange[0] !== 1 / 0 && o.interactionRange[1] !== -1 / 0 && (u(d.counters, "interactionRangeMin", o.interactionRange[0]), u(d.counters, "interactionRangeMax", o.interactionRange[1])), n) for (const e of Object.values(i)){
                        const t1 = n.find((t1)=>t1.name === e);
                        t1 && u(d.counters, e, t1.startTime);
                    }
                    return u(d.counters, "visibilityHidden", o.visibilityHidden), u(d.attributes, "style", function(t1) {
                        if (t1) for (const i of t1){
                            const t1 = i.name.split("?")[0];
                            if (e.i(t1)) {
                                const e = t1.split("/").slice(-2);
                                if (2 === e.length) return `mapbox://styles/${e[0]}/${e[1]}`;
                            }
                        }
                    }(r)), u(d.attributes, "terrainEnabled", o.terrainEnabled ? "true" : "false"), u(d.attributes, "fogEnabled", o.fogEnabled ? "true" : "false"), u(d.attributes, "projection", o.projection), u(d.attributes, "zoom", o.zoom), u(d.metadata, "devicePixelRatio", l), u(d.metadata, "connectionEffectiveType", h), u(d.metadata, "navigatorUserAgent", navigator.userAgent), u(d.metadata, "screenWidth", window.screen.width), u(d.metadata, "screenHeight", window.screen.height), u(d.metadata, "windowWidth", window.innerWidth), u(d.metadata, "windowHeight", window.innerHeight), u(d.metadata, "mapWidth", o.width / l), u(d.metadata, "mapHeight", o.height / l), u(d.metadata, "webglRenderer", o.renderer), u(d.metadata, "webglVendor", o.vendor), u(d.metadata, "sdkVersion", t1), u(d.metadata, "sdkIdentifier", "mapbox-gl-js"), d;
                }(n);
                for (const e of a.metadata);
                for (const e of a.counters);
                for (const e of a.attributes);
                this.postEvent(r, a, ()=>{}, o);
            }
        }, V = j.postPerformanceEvent.bind(j), G = new class extends A {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t1, i, o, s) {
                if (!e.e.API_URL || !e.e.SESSION_PATH) return;
                const r = S(e.e.API_URL + e.e.SESSION_PATH);
                r.params.push(`sku=${i || ""}`), r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const n = {
                    url: I(r),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = e.g(n, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            getSessionAPI(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.SESSION_PATH && e.e.API_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t1, timestamp: i } = this.queue.shift();
                t1 && this.success[t1] || this.getSession(i, this.skuToken, (e)=>{
                    e ? this.errorCb(e) : t1 && (this.success[t1] = !0);
                }, e);
            }
            remove() {
                this.errorCb = null;
            }
        }, H = G.getSessionAPI.bind(G), q = new Set;
        function Z(e, t1) {
            t1 ? q.add(e) : q.delete(e);
        }
        class W {
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = {};
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e, t1) {
                this._updatedSourceCaches[e] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e) {
                delete this._updatedSourceCaches[e];
            }
            updateLayer(e) {
                const t1 = e.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e.id), this.setDirty();
            }
            removeLayer(e) {
                const t1 = e.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e.id] = e, this._updatedLayers[t1].delete(e.id), this._updatedPaintProps.delete(e.fqid), this.setDirty();
            }
            getRemovedLayer(e) {
                return this._removedLayers[e.scope] ? this._removedLayers[e.scope][e.id] : null;
            }
            discardLayerRemoval(e) {
                this._removedLayers[e.scope] && delete this._removedLayers[e.scope][e.id];
            }
            getLayerUpdatesByScope() {
                const e = {};
                for(const t1 in this._updatedLayers)e[t1] = e[t1] || {}, e[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e[t1] = e[t1] || {}, e[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e) {
                this._updatedPaintProps.add(e.fqid), this.setDirty();
            }
            getUpdatedImages(e) {
                return this._updatedImages[e] ? Array.from(this._updatedImages[e].values()) : [];
            }
            updateImage(t1, i) {
                this._updatedImages[i] = this._updatedImages[i] || new Set, this._updatedImages[i].add(e.I.toString(t1)), this.setDirty();
            }
            resetUpdatedImages(e) {
                this._updatedImages[e] && this._updatedImages[e].clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages = {};
            }
        }
        function $(e) {
            const { userImage: t1 } = e;
            return !!(t1 && t1.render && t1.render()) && (e.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class X extends e.E {
            constructor(t1){
                super(), this.imageProviders = new Map, this.images = new Map, this.updatedImages = new Map, this.callbackDispatchedThisFrame = new Map, this.imageVersions = new Map, this.loaded = new Map, this.requestors = [], this.patterns = new Map, this.patternsInFlight = new Set, this.atlasImage = new Map, this.atlasTexture = new Map, this.imageAtlasCache = new e.r, this.dirty = !0, this.spriteFormat = t1, "raster" !== t1 && e.t() && (this.imageRasterizerDispatcher = new e.D(e.x(), this, "Image Rasterizer Worker", 1));
            }
            addScope(t1) {
                this.loaded.set(t1, !1), this.imageProviders.set(t1, new Map), this.images.set(t1, new Map), this.updatedImages.set(t1, new Set), this.callbackDispatchedThisFrame.set(t1, new Set), this.imageVersions.set(t1, new Map), this.patterns.set(t1, new Map), this.atlasImage.set(t1, new e.q({
                    width: 1,
                    height: 1
                }));
            }
            removeScope(e) {
                this.loaded.delete(e), this.imageProviders.delete(e), this.images.delete(e), this.updatedImages.delete(e), this.callbackDispatchedThisFrame.delete(e), this.imageVersions.delete(e), this.patterns.delete(e), this.atlasImage.delete(e);
                const t1 = this.atlasTexture.get(e);
                t1 && (t1.destroy(), this.atlasTexture.delete(e));
            }
            addImageProvider(e, t1) {
                this.imageProviders.has(t1) || this.imageProviders.set(t1, new Map), this.imageProviders.get(t1).set(e.id, e);
            }
            removeImageProvider(e, t1) {
                this.imageProviders.has(t1) && this.imageProviders.get(t1).delete(e);
            }
            getPendingImageProviders() {
                const e = [];
                for (const t1 of this.imageProviders.values())for (const i of t1.values())i.hasPendingRequests() && e.push(i);
                return e;
            }
            get imageRasterizer() {
                return this._imageRasterizer || (this._imageRasterizer = new e.y), this._imageRasterizer;
            }
            isLoaded() {
                for (const e of this.loaded.keys())if (!this.loaded.get(e)) return !1;
                return !0;
            }
            setLoaded(e, t1) {
                if (this.loaded.get(t1) !== e && (this.loaded.set(t1, e), e)) {
                    for (const { ids: e, callback: i } of this.requestors)this._notify(e, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e, t1) {
                return !!this.getImage(e, t1);
            }
            getImage(e, t1) {
                return this.images.get(t1).get(e.toString());
            }
            addImage(e, t1, i) {
                if (this._validate(e, i)) {
                    this.images.get(t1).set(e.toString(), i);
                    const o = this.imageVersions.get(t1), s = o.get(e.toString()) || 0;
                    o.set(e.toString(), s + 1);
                }
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e.z(new Error(`Image "${t1.name}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e, t1) {
                if (!e) return !0;
                let i = 0;
                for (const o of e){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e, t1) {
                if (!e) return !0;
                if (4 !== e.length) return !1;
                if (!t1.usvg) {
                    if (e[0] < 0 || t1.data.width < e[0]) return !1;
                    if (e[1] < 0 || t1.data.height < e[1]) return !1;
                    if (e[2] < 0 || t1.data.width < e[2]) return !1;
                    if (e[3] < 0 || t1.data.height < e[3]) return !1;
                }
                return !(e[2] < e[0] || e[3] < e[1]);
            }
            updateImage(e, t1, i) {
                const o = this.images.get(t1).get(e.toString());
                i.version = o.version + 1, this.images.get(t1).set(e.toString(), i), this.updatedImages.get(t1).add(e);
                const s = this.imageVersions.get(t1), r = s.get(e.toString()) || 0;
                s.set(e.toString(), r + 1), this.removeFromImageRasterizerCache(e, t1);
            }
            clearUpdatedImages(e) {
                this.updatedImages.get(e).clear();
            }
            removeFromImageRasterizerCache(t1, i) {
                "raster" !== this.spriteFormat && (e.t() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", {
                    imageIds: [
                        t1
                    ],
                    scope: i
                }) : this.imageRasterizer.removeImagesFromCacheByIds([
                    t1
                ], i));
            }
            removeImage(e, t1) {
                const i = this.images.get(t1), o = i.get(e.toString());
                i.delete(e.toString());
                const s = this.imageVersions.get(t1), r = s.get(e.toString()) || 0;
                s.set(e.toString(), r + 1), this.patterns.get(t1).delete(e.toString()), this.removeFromImageRasterizerCache(e, t1), o.userImage && o.userImage.onRemove && o.userImage.onRemove();
            }
            listImages(t1) {
                return Array.from(this.images.get(t1).keys()).map((t1)=>e.I.from(t1));
            }
            getImageVersions(e) {
                const t1 = this.imageVersions.get(e);
                if (t1) return t1;
            }
            getImages(e, t1, i) {
                const o = [], s = [], r = this.imageProviders.get(t1);
                for (const i of e){
                    if (!i.iconsetId) {
                        o.push(i);
                        continue;
                    }
                    const e = r.get(i.iconsetId);
                    e && (this.getImage(i, t1) ? s.push(i) : e.addPendingRequest(i));
                }
                if (0 === o.length) return void this._notify(s, t1, i);
                let n = !0;
                const a = !!this.loaded.get(t1), l = this.images.get(t1);
                if (!a) for (const e of o)l.has(e.toString()) || (n = !1);
                a || n ? this._notify(o, t1, i) : this.requestors.push({
                    ids: o,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages(e, t1) {
                const i = new Map, { tasks: o, scope: s } = e;
                for (const [e, t1] of o.entries()){
                    const o = this.getImage(t1.id, s);
                    o && i.set(e, {
                        image: o,
                        imageVariant: t1
                    });
                }
                this._rasterizeImages(s, i, t1);
            }
            _rasterizeImages(t1, i, o) {
                if (e.t()) this.imageRasterizerDispatcher.getActor().send("rasterizeImagesWorker", {
                    tasks: i,
                    scope: t1
                }, o);
                else {
                    const e = new Map;
                    for (const [o, { image: s, imageVariant: r }] of i.entries())e.set(o, this.imageRasterizer.rasterize(r, s, t1, 0));
                    o(void 0, e);
                }
            }
            getUpdatedImages(e) {
                return this.updatedImages.get(e) || new Set;
            }
            _notify(t1, i, o) {
                const s = this.images.get(i), r = new Map;
                for (const i of t1){
                    if (!s.get(i.toString())) {
                        if (i.iconsetId) continue;
                        this.fire(new e.A("styleimagemissing", {
                            id: i.name
                        }));
                    }
                    const t1 = s.get(i.toString());
                    if (!t1) {
                        e.w(`Image "${i.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                        continue;
                    }
                    const o = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    };
                    t1.usvg && Object.assign(o, {
                        width: t1.icon.usvg_tree.width,
                        height: t1.icon.usvg_tree.height
                    }), r.set(e.I.toString(i), o);
                }
                o(null, {
                    images: r,
                    versions: this.getImageVersions(i)
                });
            }
            getPixelSize(e) {
                const { width: t1, height: i } = this.atlasImage.get(e);
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, o) {
                const s = t1.toString(), r = this.patterns.get(i), n = r.get(s), a = this.getImage(t1, i);
                if (!a) return null;
                if (n) {
                    if (n.position.version === a.version) return n.position;
                    n.position.version = a.version;
                } else {
                    if (a.usvg && !a.data) {
                        const r = this.getPatternInFlightId(s, i);
                        if (this.patternsInFlight.has(r)) return null;
                        this.patternsInFlight.add(r);
                        const n = new e.B(t1).scaleSelf(e.o.devicePixelRatio), l = new Map([
                            [
                                n.toString(),
                                {
                                    image: a,
                                    imageVariant: n
                                }
                            ]
                        ]);
                        return this._rasterizeImages(i, l, (e, t1)=>this.storePatternImage(n, i, a, o, t1)), null;
                    }
                    this.storePattern(t1, i, a);
                }
                return this._updatePatternAtlas(i, o), r.get(s).position;
            }
            getPatternInFlightId(t1, i) {
                return e.C(t1, i);
            }
            hasPatternsInFlight() {
                return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e, t1, i, o, s) {
                const r = e.toString(), n = s ? s.get(r) : void 0;
                n && (i.data = n, this.storePattern(e.id, t1, i), this._updatePatternAtlas(t1, o), this.patternsInFlight.delete(this.getPatternInFlightId(e.id.toString(), t1)));
            }
            storePattern(t1, i, o) {
                const s = {
                    w: o.data.width + 2 * e.F,
                    h: o.data.height + 2 * e.F,
                    x: 0,
                    y: 0
                }, r = new e.G(s, o, e.F);
                this.patterns.get(i).set(t1.toString(), {
                    bin: s,
                    position: r
                });
            }
            destroyAtlasTextures() {
                for (const e of this.atlasTexture.values())e && e.destroy();
                this.atlasTexture.clear();
            }
            bind(t1, i) {
                const o = t1.gl;
                let s = this.atlasTexture.get(i);
                s ? this.dirty && (s.update(this.atlasImage.get(i)), this.dirty = !1) : (s = new e.T(t1, this.atlasImage.get(i), o.RGBA8), this.atlasTexture.set(i, s)), s.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const o = this.patterns.get(t1), s = Array.from(o.values()).map(({ bin: e })=>e), { w: r, h: n } = e.H(s), a = this.atlasImage.get(t1);
                a.resize({
                    width: r || 1,
                    height: n || 1
                });
                const l = this.images.get(t1);
                for (const [t1, { bin: s, position: r }] of o.entries()){
                    let o = r.padding;
                    const n = s.x + o, c = s.y + o, h = l.get(t1).data, d = h.width, u = h.height;
                    o = o > 1 ? o - 1 : o, e.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c
                    }, {
                        width: d,
                        height: u
                    }, i), e.q.copy(h, a, {
                        x: 0,
                        y: u - o
                    }, {
                        x: n,
                        y: c - o
                    }, {
                        width: d,
                        height: o
                    }, i), e.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n,
                        y: c + u
                    }, {
                        width: d,
                        height: o
                    }, i), e.q.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: n - o,
                        y: c
                    }, {
                        width: o,
                        height: u
                    }, i), e.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c
                    }, {
                        width: o,
                        height: u
                    }, i), e.q.copy(h, a, {
                        x: d - o,
                        y: u - o
                    }, {
                        x: n - o,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e.q.copy(h, a, {
                        x: 0,
                        y: u - o
                    }, {
                        x: n + d,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n + d,
                        y: c + u
                    }, {
                        width: o,
                        height: o
                    }, i), e.q.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: n - o,
                        y: c + u
                    }, {
                        width: o,
                        height: o
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for (const e of this.images.keys())this.callbackDispatchedThisFrame.set(e, new Set);
            }
            dispatchRenderCallbacks(e, t1) {
                const i = this.images.get(t1);
                for (const o of e){
                    if (this.callbackDispatchedThisFrame.get(t1).has(o.toString())) continue;
                    this.callbackDispatchedThisFrame.get(t1).add(o.toString());
                    const e = i.get(o.toString());
                    $(e) && this.updateImage(o, t1, e);
                }
            }
            destroy() {
                this.imageRasterizerDispatcher && this.imageRasterizerDispatcher.remove();
            }
        }
        function K(t1) {
            const i = t1.value, o = t1.valueSpec, s = t1.style, r = t1.styleSpec, n = t1.key, a = t1.arrayElementValidator || ve;
            if (!Array.isArray(i)) return [
                new e.V(n, i, `array expected, ${e.L(i)} found`)
            ];
            if (o.length && i.length !== o.length) return [
                new e.V(n, i, `array length ${o.length} expected, length ${i.length} found`)
            ];
            if (o["min-length"] && i.length < o["min-length"]) return [
                new e.V(n, i, `array length at least ${o["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: o.value,
                values: o.values,
                minimum: o.minimum,
                maximum: o.maximum,
                function: void 0
            };
            r.$version < 7 && (l.function = o.function), e.J(o.value) && (l = o.value);
            let c = [];
            for(let e = 0; e < i.length; e++)c = c.concat(a({
                array: i,
                arrayIndex: e,
                value: i[e],
                valueSpec: l,
                style: s,
                styleSpec: r,
                key: `${n}[${e}]`
            }, !0));
            return c;
        }
        function Y(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec;
            if (!e.M(o)) return [
                new e.V(i, o, `number expected, ${e.L(o)} found`)
            ];
            if (o != o) return [
                new e.V(i, o, "number expected, NaN found")
            ];
            if ("minimum" in s) {
                let r = s.minimum;
                if (Array.isArray(s.minimum) && (r = s.minimum[t1.arrayIndex]), o < r) return [
                    new e.V(i, o, `${o} is less than the minimum value ${r}`)
                ];
            }
            if ("maximum" in s) {
                let r = s.maximum;
                if (Array.isArray(s.maximum) && (r = s.maximum[t1.arrayIndex]), o > r) return [
                    new e.V(i, o, `${o} is greater than the maximum value ${r}`)
                ];
            }
            return [];
        }
        function J(t1) {
            const i = t1.key, o = t1.value;
            if (!e.J(o)) return [
                new e.V(i, o, `object expected, ${e.L(o)} found`)
            ];
            const s = t1.valueSpec, r = e.K(o.type);
            let n, a, l, c = {};
            const h = "categorical" !== r && void 0 === o.property, d = !h, u = function(t1) {
                const i = t1.stops;
                return Array.isArray(i) && Array.isArray(i[0]) && e.J(i[0][0]);
            }(o), _ = ye({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === r) return [
                            new e.V(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let i = [];
                        const o = t1.value;
                        return i = i.concat(K({
                            key: t1.key,
                            value: o,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: p
                        })), Array.isArray(o) && 0 === o.length && i.push(new e.V(t1.key, o, "array must have at least one stop")), i;
                    },
                    default: function(e) {
                        return ve({
                            key: e.key,
                            value: e.value,
                            valueSpec: s,
                            style: e.style,
                            styleSpec: e.styleSpec
                        });
                    }
                }
            });
            return "identity" === r && h && _.push(new e.V(t1.key, t1.value, 'missing required property "property"')), "identity" === r || o.stops || _.push(new e.V(t1.key, t1.value, 'missing required property "stops"')), "exponential" === r && s.expression && !e.N(s) && _.push(new e.V(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (d && !e.O(s) ? _.push(new e.V(t1.key, t1.value, "property functions not supported")) : h && !e.Q(s) && _.push(new e.V(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== r && !u || void 0 !== o.property || _.push(new e.V(t1.key, t1.value, '"property" property is required')), _;
            function p(t1) {
                let i = [];
                const o = t1.value, r = t1.key;
                if (!Array.isArray(o)) return [
                    new e.V(r, o, `array expected, ${e.L(o)} found`)
                ];
                if (2 !== o.length) return [
                    new e.V(r, o, `array length 2 expected, length ${o.length} found`)
                ];
                if (u) {
                    if (!e.J(o[0])) return [
                        new e.V(r, o, `object expected, ${e.L(o[0])} found`)
                    ];
                    const s = o[0];
                    if (void 0 === s.zoom) return [
                        new e.V(r, o, "object stop key must have zoom")
                    ];
                    if (void 0 === s.value) return [
                        new e.V(r, o, "object stop key must have value")
                    ];
                    const n = e.K(s.zoom);
                    if ("number" != typeof n) return [
                        new e.V(r, s.zoom, "stop zoom values must be numbers")
                    ];
                    if (l && l > n) return [
                        new e.V(r, s.zoom, "stop zoom values must appear in ascending order")
                    ];
                    n !== l && (l = n, a = void 0, c = {}), i = i.concat(ye({
                        key: `${r}[0]`,
                        value: o[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: Y,
                            value: f
                        }
                    }));
                } else i = i.concat(f({
                    key: `${r}[0]`,
                    value: o[0],
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, o));
                return e.S(e.U(o[1])) ? i.concat([
                    new e.V(`${r}[1]`, o[1], "expressions are not allowed in function stops.")
                ]) : i.concat(ve({
                    key: `${r}[1]`,
                    value: o[1],
                    valueSpec: s,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function f(t1, i) {
                const o = e.L(t1.value), l = e.K(t1.value), h = null !== t1.value ? t1.value : i;
                if (n) {
                    if (o !== n) return [
                        new e.V(t1.key, h, `${o} stop domain type must match previous stop domain type ${n}`)
                    ];
                } else n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new e.V(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== r) {
                    let i = `number expected, ${o} found`;
                    return e.O(s) && void 0 === r && (i += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new e.V(t1.key, h, i)
                    ];
                }
                return "categorical" !== r || "number" !== o || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && "number" == typeof l && "number" == typeof a && void 0 !== a && l < a ? [
                    new e.V(t1.key, h, "stop domain values must appear in ascending order")
                ] : (a = l, "categorical" === r && l in c ? [
                    new e.V(t1.key, h, "stop domain values must be unique")
                ] : (c[l] = !0, [])) : [
                    new e.V(t1.key, h, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function Q(t1) {
            const i = ("property" === t1.expressionContext ? e.X : e.W)(e.U(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((i)=>new e.V(`${t1.key}${i.key}`, t1.value, i.message));
            const o = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !o.outputDefined()) return [
                new e.V(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e._(o)) return [
                new e.V(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return ee(o, t1);
            if ("appearance" === t1.expressionContext) return te(o, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e.Y(o, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new e.V(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e.Z(o)) return [
                    new e.V(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function ee(t1, i) {
            const o = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e of i.valueSpec.expression.parameters)o.delete(e);
            if (0 === o.size) return [];
            const s = [];
            return t1 instanceof e.$ && o.has(t1.name) ? [
                new e.V(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e)=>{
                s.push(...ee(e, i));
            }), s);
        }
        function te(t1, i) {
            const o = new Set;
            if (i.valueSpec && i.valueSpec.expression) for (const e of i.valueSpec.expression.parameters)o.add(e);
            if (0 === o.size) return [];
            const s = [];
            return t1 instanceof e.$ && !o.has(t1.name) ? [
                new e.V(i.key, i.value, `["${t1.name}"] is not an allowed parameter`)
            ] : (t1.eachChild((e)=>{
                s.push(...te(e, i));
            }), s);
        }
        function ie(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec, r = [];
            return Array.isArray(s.values) ? -1 === s.values.indexOf(e.K(o)) && r.push(new e.V(i, o, `expected one of [${s.values.join(", ")}], ${JSON.stringify(o)} found`)) : -1 === Object.keys(s.values).indexOf(e.K(o)) && r.push(new e.V(i, o, `expected one of [${Object.keys(s.values).join(", ")}], ${JSON.stringify(o)} found`)), r;
        }
        function oe(t1) {
            return e.a3(e.U(t1.value)) ? Q(Object.assign({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : se(t1);
        }
        function se(t1) {
            const i = t1.value, o = t1.key;
            if (!Array.isArray(i)) return [
                new e.V(o, i, `array expected, ${e.L(i)} found`)
            ];
            if (i.length < 1) return [
                new e.V(o, i, "filter array must have at least 1 element")
            ];
            const s = t1.styleSpec;
            let r = ie({
                key: `${o}[0]`,
                value: i[0],
                valueSpec: s.filter_operator
            });
            const n = ()=>{
                i.length >= 2 && (e.a1(i[1]) || r.push(new e.V(`${o}[1]`, i[1], `string expected, ${e.L(i[1])} found`)));
                for(let t1 = 2; t1 < i.length; t1++)"$type" === e.K(i[1]) ? r = r.concat(ie({
                    key: `${o}[${t1}]`,
                    value: i[t1],
                    valueSpec: s.geometry_type
                })) : e.a1(i[t1]) || e.M(i[t1]) || e.a0(i[t1]) || r.push(new e.V(`${o}[${t1}]`, i[t1], `string, number, or boolean expected, ${e.L(i[t1])} found.`));
            };
            switch(e.K(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e.K(i[1]) && r.push(new e.V(o, i, `"$type" cannot be use with operator "${i[0]}"`)), 3 !== i.length && r.push(new e.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "==":
                case "!=":
                    3 !== i.length && r.push(new e.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`)), n();
                    break;
                case "in":
                case "!in":
                    n();
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e = 1; e < i.length; e++)r = r.concat(se({
                        key: `${o}[${e}]`,
                        value: i[e],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    2 !== i.length ? r.push(new e.V(o, i, `filter array for "${i[0]}" operator must have 2 elements`)) : e.a1(i[1]) || r.push(new e.V(`${o}[1]`, i[1], `string expected, ${e.L(i[1])} found`));
            }
            return r;
        }
        function re(t1, i) {
            const o = t1.key, s = t1.style, r = t1.layer, n = t1.styleSpec, a = t1.value, l = t1.objectKey, c = n[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(/^(.*)-use-theme$/);
            if (h && c[h[1]]) return e.S(e.U(a)) ? [].concat(ve({
                key: o,
                value: a,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: s,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : ve({
                key: o,
                value: a,
                valueSpec: {
                    type: "string"
                },
                style: s,
                styleSpec: n
            });
            const d = l.match(/^(.*)-transition$/);
            if ("paint" === i && d && c[d[1]] && c[d[1]].transition) return ve({
                key: o,
                value: a,
                valueSpec: n.transition,
                style: s,
                styleSpec: n
            });
            const u = t1.valueSpec || c[l];
            if (!u) return [
                new e.a4(o, a, `unknown property "${l}"`)
            ];
            let _;
            if (e.a1(a) && e.O(u) && !u.tokens && (_ = /^{([^}]+)}$/.exec(a))) {
                const t1 = `\`{ "type": "identity", "property": ${_ ? JSON.stringify(_[1]) : '"_"'} }\``;
                return [
                    new e.V(o, a, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${t1}.`)
                ];
            }
            const p = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !s || s.glyphs || s.imports || p.push(new e.V(o, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e.a5(e.U(a)) && "identity" === e.K(a.type) && p.push(new e.V(o, a, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && r && r.layout && r.layout.hasOwnProperty("model-id") && e.O(u) && (e.a6(u) || e.Q(u))) {
                const t1 = e.X(e.U(a), u).value, i = "expression" in t1 && t1.expression || "_styleExpression" in t1 && t1._styleExpression && t1._styleExpression.expression;
                i && !e.Y(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e.Z(i) && e._(i) || p.push(new e.V(o, a, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return p.concat(ve({
                key: t1.key,
                value: a,
                valueSpec: u,
                style: s,
                styleSpec: n,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function ne(e) {
            return re(e, "paint");
        }
        function ae(e) {
            return re(e, "layout");
        }
        function le(t1) {
            let i = [];
            const o = t1.value, s = t1.key, r = t1.style, n = t1.styleSpec;
            if (!e.J(o)) return [
                new e.V(s, o, "object expected")
            ];
            o.type || o.ref || i.push(new e.V(s, o, 'either "type" or "ref" is required'));
            let a = e.K(o.type);
            const l = e.K(o.ref);
            if (o.id) {
                const n = e.K(o.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = r.layers[a];
                    e.K(t1.id) === n && i.push(new e.V(s, o.id, `duplicate layer id "${n}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in o) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in o && i.push(new e.V(s, o[t1], `"${t1}" is prohibited for ref layers`));
                }), r.layers.forEach((i)=>{
                    e.K(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new e.V(s, o.ref, "ref cannot reference another ref layer")) : a = e.K(t1.type) : "string" == typeof l && i.push(new e.V(s, o.ref, `ref layer "${l}" not found`));
            } else if ("background" !== a && "sky" !== a && "slot" !== a) {
                if (o.source) {
                    if (e.a1(o.source)) {
                        const t1 = r.sources && r.sources[o.source], n = t1 && e.K(t1.type);
                        t1 ? "vector" === n && "raster" === a ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a raster source`)) : "raster" === n && "raster" !== a ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a vector source`)) : "vector" !== n || o["source-layer"] ? "raster-dem" === n && "hillshade" !== a ? i.push(new e.V(s, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n || [
                            "raster",
                            "raster-particle"
                        ].includes(a) ? "line" === a && o.paint && (o.paint["line-gradient"] || o.paint["line-trim-offset"]) && "geojson" === n && !t1.lineMetrics ? i.push(new e.V(s, o, `layer "${o.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a && "raster-array" !== n && i.push(new e.V(s, o.source, `layer "${o.id}" requires a 'raster-array' source.`)) : i.push(new e.V(s, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e.V(s, o, `layer "${o.id}" must specify a "source-layer"`)) : i.push(new e.V(s, o.source, `source "${o.source}" not found`));
                    } else i.push(new e.V(`${s}.source`, o.source, '"source" must be a string'));
                } else i.push(new e.V(s, o, 'missing required property "source"'));
            }
            return i = i.concat(ye({
                key: s,
                value: o,
                valueSpec: n.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>ve({
                            key: `${s}.type`,
                            value: o.type,
                            valueSpec: n.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: o,
                            objectKey: "type"
                        }),
                    filter: (e)=>oe(Object.assign({
                            layerType: a
                        }, e)),
                    layout: (e)=>ye({
                            layer: o,
                            key: e.key,
                            value: e.value,
                            valueSpec: {},
                            style: e.style,
                            styleSpec: e.styleSpec,
                            objectElementValidators: {
                                "*": (e)=>ae(Object.assign({
                                        layerType: a
                                    }, e))
                            }
                        }),
                    paint: (e)=>ye({
                            layer: o,
                            key: e.key,
                            value: e.value,
                            valueSpec: {},
                            style: e.style,
                            styleSpec: e.styleSpec,
                            objectElementValidators: {
                                "*": (e)=>ne(Object.assign({
                                        layerType: a,
                                        layer: o
                                    }, e))
                            }
                        }),
                    appearances (t1) {
                        const i = K({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: (t1)=>(function(t1) {
                                    const { key: i, layer: o, layerType: s } = t1, r = e.K(t1.value), n = e.K(r.name), a = e.K(r.condition), l = ye({
                                        key: i,
                                        value: r,
                                        valueSpec: t1.styleSpec.appearance,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            condition: (t1)=>(function(t1) {
                                                    const i = [];
                                                    return i.push(...Q({
                                                        key: t1.key,
                                                        value: t1.object.condition,
                                                        valueSpec: e.a7.appearance.condition,
                                                        expressionContext: "appearance"
                                                    })), i;
                                                })(Object.assign({
                                                    layer: o,
                                                    layerType: s
                                                }, t1)),
                                            properties: (t1)=>(function(t1) {
                                                    const i = [], { styleSpec: o, layer: s, layerType: r } = t1, n = o[`paint_${r}`], a = o[`layout_${r}`], l = t1.object[t1.objectKey];
                                                    for(const o in l){
                                                        const c = o in n ? "paint" : o in a ? "layout" : void 0;
                                                        if (!c) {
                                                            i.push(new e.V(t1.key, o, `unknown property "${o}" for layer type "${r}"`));
                                                            continue;
                                                        }
                                                        const h = Object.assign({}, t1, {
                                                            key: `${t1.key}.${o}`,
                                                            object: l,
                                                            objectKey: o,
                                                            layer: s,
                                                            layerType: r,
                                                            value: l[o],
                                                            valueSpec: "paint" === c ? n[o] : a[o]
                                                        });
                                                        i.push(...re(h, c));
                                                    }
                                                    return i;
                                                })(Object.assign({
                                                    layer: o,
                                                    layerType: s
                                                }, t1))
                                        }
                                    });
                                    return "hidden" !== n && void 0 === a && l.push(new e.V(t1.key, "name", 'Appearance with name different than "hidden" must have a condition')), l;
                                })(Object.assign({
                                    layerType: a,
                                    layer: o
                                }, t1))
                        }), s = Array.isArray(t1.value) ? t1.value : [], r = new Set;
                        return s.forEach((s, n)=>{
                            const a = e.K(s.name);
                            if (a) {
                                if (r.has(a)) {
                                    const s = e.K(o.id);
                                    i.push(new e.V(t1.key, a, `Duplicated appearance name "${a}" for layer "${s}"`));
                                } else r.add(a);
                            }
                        }), i;
                    }
                }
            })), i;
        }
        function ce({ key: t1, value: i }) {
            return e.a1(i) ? [] : [
                new e.V(t1, i, `string expected, ${e.L(i)} found`)
            ];
        }
        const he = {
            promoteId: function t1({ key: i, value: o }) {
                if (e.a1(o)) return ce({
                    key: i,
                    value: o
                });
                if (Array.isArray(o)) {
                    const t1 = [], s = e.U(o), r = e.W(s);
                    return "error" === r.result && r.value.forEach((o)=>{
                        t1.push(new e.V(`${i}${o.key}`, null, `${o.message}`));
                    }), e.Y(r.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new e.V(`${i}`, null, "promoteId expression should be only feature dependent")), t1;
                }
                if (!e.J(o)) return [
                    new e.V(i, o, `string, expression or object expected, "${e.L(o)}" found`)
                ];
                const s = [];
                for(const e in o)s.push(...t1({
                    key: `${i}.${e}`,
                    value: o[e]
                }));
                return s;
            }
        };
        function de(t1) {
            const i = t1.value, o = t1.key, s = t1.styleSpec, r = t1.style;
            if (!e.J(i)) return [
                new e.V(o, i, `object expected, ${e.L(i)} found`)
            ];
            if (!("type" in i)) return [
                new e.V(o, i, '"type" is required')
            ];
            const n = e.K(i.type);
            let a = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(n) && ("url" in i || "tiles" in i || a.push(new e.a4(o, i, 'Either "url" or "tiles" is required.'))), n){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return a = a.concat(ye({
                        key: o,
                        value: i,
                        valueSpec: s[`source_${n.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: s,
                        objectElementValidators: he
                    })), a;
                case "geojson":
                    if (a = ye({
                        key: o,
                        value: i,
                        valueSpec: s.source_geojson,
                        style: r,
                        styleSpec: s,
                        objectElementValidators: he
                    }), "cluster" in i && "clusterProperties" in i) {
                        if (!e.J(i.clusterProperties)) return [
                            new e.V(`${o}.clusterProperties`, i, `object expected, ${e.L(i)} found`)
                        ];
                        for(const t1 in i.clusterProperties){
                            const s = i.clusterProperties[t1];
                            if (!Array.isArray(s)) return [
                                new e.V(`${o}.clusterProperties.${t1}`, s, "array expected")
                            ];
                            const [r, n] = s, l = "string" == typeof r ? [
                                r,
                                [
                                    "accumulated"
                                ],
                                [
                                    "get",
                                    t1
                                ]
                            ] : r;
                            a.push(...Q({
                                key: `${o}.${t1}.map`,
                                value: n,
                                expressionContext: "cluster-map"
                            })), a.push(...Q({
                                key: `${o}.${t1}.reduce`,
                                value: l,
                                expressionContext: "cluster-reduce"
                            }));
                        }
                    }
                    return a;
                case "video":
                    return ye({
                        key: o,
                        value: i,
                        valueSpec: s.source_video,
                        style: r,
                        styleSpec: s
                    });
                case "image":
                    return ye({
                        key: o,
                        value: i,
                        valueSpec: s.source_image,
                        style: r,
                        styleSpec: s
                    });
                case "canvas":
                    return [
                        new e.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return ie({
                        key: `${o}.type`,
                        value: i.type,
                        valueSpec: {
                            values: ue(s)
                        }
                    });
            }
        }
        function ue(e) {
            return e.source.reduce((t1, i)=>{
                const o = e[i];
                return "enum" === o.type.type && (t1 = t1.concat(Object.keys(o.type.values || {}))), t1;
            }, []);
        }
        function _e(t1) {
            const i = t1.value, o = t1.styleSpec, s = o.light, r = t1.style;
            if (void 0 === i) return [];
            if (!e.J(i)) return [
                new e.V("light", i, `object expected, ${e.L(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                n = n.concat(l && s[l[1]] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: o
                }) : a && s[a[1]] && s[a[1]].transition ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: r,
                    styleSpec: o
                }) : s[t1] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: s[t1],
                    style: r,
                    styleSpec: o
                }) : [
                    new e.V(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        function pe(t1) {
            const i = t1.value;
            if (!i) return [];
            const o = t1.key;
            if (!e.J(i)) return [
                new e.V(o, i, `object expected, ${e.L(i)} found`)
            ];
            let s = [];
            const r = t1.styleSpec, n = r["light-3d"], a = t1.style, l = t1.style.lights;
            for (const t1 of [
                "type",
                "id"
            ])if (!(t1 in i)) return s = s.concat([
                new e.V(o, i, `missing property "${t1}"`)
            ]), s;
            if (!e.a1(i.type)) return s = s.concat([
                new e.V(`${o}.type`, i.type, "string expected")
            ]), s;
            if (l) for(let r = 0; r < t1.arrayIndex; r++){
                const t1 = e.K(i.type), n = l[r];
                e.K(n.type) === t1 && s.push(new e.V(o, i.id, `duplicate light type "${i.type}", previously defined at line ${n.id.__line__}`));
            }
            const c = `properties_light_${i.type}`;
            if (!(c in r)) return s = s.concat([
                new e.V(`${o}.type`, i, `Invalid light type ${i.type}`)
            ]), s;
            const h = r[c];
            for(const o in i)if ("properties" === o) {
                const n = i[o];
                if (!e.J(n)) return s = s.concat([
                    new e.V("properties", n, `object expected, ${e.L(n)} found`)
                ]), s;
                for(const l in n){
                    const c = l.match(/^(.*)-transition$/), d = l.match(/^(.*)-use-theme$/);
                    s = s.concat(d && h[d[1]] ? ve({
                        key: o,
                        value: n[l],
                        valueSpec: {
                            type: "string"
                        },
                        style: a,
                        styleSpec: r
                    }) : c && h[c[1]] && h[c[1]].transition ? ve({
                        key: o,
                        value: i[o],
                        valueSpec: r.transition,
                        style: a,
                        styleSpec: r
                    }) : h[l] ? ve({
                        key: l,
                        value: n[l],
                        valueSpec: h[l],
                        style: a,
                        styleSpec: r
                    }) : [
                        new e.a4(t1.key, n[l], `unknown property "${l}"`)
                    ]);
                }
            } else s = s.concat(n[o] ? ve({
                key: o,
                value: i[o],
                valueSpec: n[o],
                style: a,
                styleSpec: r
            }) : [
                new e.a4(o, i[o], `unknown property "${o}"`)
            ]);
            return s;
        }
        function fe(t1) {
            const i = t1.value, o = t1.key, s = t1.style, r = t1.styleSpec, n = r.terrain;
            if (null == i) return [];
            if (!e.J(i)) return [
                new e.V("terrain", i, `object expected, ${e.L(i)} found`)
            ];
            let a = [];
            for(const t1 in i){
                const o = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                a = a.concat(l && n[l[1]] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: s,
                    styleSpec: r
                }) : o && n[o[1]] && n[o[1]].transition ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: s,
                    styleSpec: r
                }) : n[t1] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: n[t1],
                    style: s,
                    styleSpec: r
                }) : [
                    new e.a4(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                if (e.a1(i.source)) {
                    const t1 = s.sources && s.sources[i.source], r = t1 && e.K(t1.type);
                    t1 ? "raster-dem" !== r && a.push(new e.V(`${o}.source`, i.source, `terrain cannot be used with a source of type ${r}, it only be used with a "raster-dem" source type`)) : a.push(new e.V(`${o}.source`, i.source, `source "${i.source}" not found`));
                } else a.push(new e.V(`${o}.source`, i.source, "source must be a string"));
            } else a.push(new e.V(o, i, 'terrain is missing required property "source"'));
            return a;
        }
        function me(t1) {
            const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.fog;
            if (void 0 === i) return [];
            if (!e.J(i)) return [
                new e.V("fog", i, `object expected, ${e.L(i)} found`)
            ];
            let n = [];
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                n = n.concat(l && r[l[1]] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: s
                }) : a && r[a[1]] && r[a[1]].transition ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: o,
                    styleSpec: s
                }) : r[t1] ? ve({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: o,
                    styleSpec: s
                }) : [
                    new e.a4(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return n;
        }
        const ge = {
            "*": ()=>[],
            array: K,
            boolean: function(t1) {
                const i = t1.value, o = t1.key;
                return e.a0(i) ? [] : [
                    new e.V(o, i, `boolean expected, ${e.L(i)} found`)
                ];
            },
            number: Y,
            color: function({ key: t1, value: i }) {
                return e.a1(i) ? null === e.a2.parseCSSColor(i) ? [
                    new e.V(t1, i, `color expected, "${i}" found`)
                ] : [] : [
                    new e.V(t1, i, `color expected, ${e.L(i)} found`)
                ];
            },
            enum: ie,
            filter: oe,
            function: J,
            layer: le,
            object: ye,
            source: de,
            model: e.a8,
            light: _e,
            "light-3d": pe,
            terrain: fe,
            fog: me,
            string: ce,
            formatted: function(e) {
                return 0 === ce(e).length ? [] : Q(e);
            },
            resolvedImage: function(e) {
                return 0 === ce(e).length ? [] : Q(e);
            },
            projection: function(t1) {
                const i = t1.value, o = t1.styleSpec, s = o.projection, r = t1.style;
                if (e.J(i)) {
                    let e = [];
                    for(const t1 in i)e = e.concat(ve({
                        key: t1,
                        value: i[t1],
                        valueSpec: s[t1],
                        style: r,
                        styleSpec: o
                    }));
                    return e;
                }
                return e.a1(i) ? [] : [
                    new e.V("projection", i, `object or string expected, ${e.L(i)} found`)
                ];
            },
            import: function(t1) {
                const i = t1.key, { value: o, styleSpec: s } = t1;
                if (!e.J(o)) return [
                    new e.V(i, o, "import must be an object")
                ];
                const { data: r, ...n } = o;
                Object.defineProperty(n, "__line__", {
                    value: o.__line__,
                    enumerable: !1
                });
                let a = ye(Object.assign({}, t1, {
                    value: n,
                    valueSpec: s.import
                }));
                return "" === e.K(n.id) && a.push(new e.V(`${t1.key}.id`, n, "import id can't be an empty string")), r && (a = a.concat(be(r, s, {
                    key: `${t1.key}.data`
                }))), a;
            },
            iconset: function(t1) {
                const i = t1.value, o = t1.key, s = t1.styleSpec, r = t1.style;
                if (!e.J(i)) return [
                    new e.V(o, i, "object expected")
                ];
                if (!i.type) return [
                    new e.V(o, i, '"type" is required')
                ];
                const n = e.K(i.type);
                let a = [];
                if (a = a.concat(ye({
                    key: o,
                    value: i,
                    valueSpec: s[`iconset_${n}`],
                    style: r,
                    styleSpec: s
                })), function(e, t1) {
                    return !("source" !== e || !t1.source);
                }(n, i)) {
                    const t1 = r.sources && r.sources[i.source], s = t1 && e.K(t1.type);
                    t1 ? "raster-array" !== s && a.push(new e.V(o, i.source, `iconset cannot be used with a source of type ${String(s)}, it only be used with a "raster-array" source type`)) : a.push(new e.V(o, i.source, `source "${i.source}" not found`));
                }
                return a;
            }
        };
        function ve(t1, i = !1) {
            const o = t1.value, s = t1.valueSpec, r = t1.styleSpec;
            if (s.expression) {
                if (e.a5(e.K(o))) return J(t1);
                if (e.S(e.U(o))) return Q(t1);
            }
            if (s.type && ge[s.type]) {
                const e = ge[s.type](t1);
                return !0 === i && e.length > 0 && Array.isArray(t1.value) ? Q(t1) : e;
            }
            return ye(Object.assign({}, t1, {
                valueSpec: s.type ? r[s.type] : s
            }));
        }
        function ye(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec || {}, r = t1.objectElementValidators || {}, n = t1.style, a = t1.styleSpec;
            if (!e.J(o)) return [
                new e.V(i, o, `object expected, ${e.L(o)} found`)
            ];
            let l = [];
            for(const t1 in o){
                const c = t1.split(".")[0];
                let h;
                r[c] ? h = r[c] : s[c] ? h = ve : r["*"] ? h = r["*"] : s["*"] && (h = ve), h ? l = l.concat(h({
                    key: (i ? `${i}.` : i) + t1,
                    value: o[t1],
                    valueSpec: s[c] || s["*"],
                    style: n,
                    styleSpec: a,
                    object: o,
                    objectKey: t1
                }, o)) : l.push(new e.a4(i, o[t1], `unknown property "${t1}"`));
            }
            for(const t1 in s){
                if (r[t1]) continue;
                const n = s[t1];
                n.required && void 0 === n.default && void 0 === o[t1] && l.push(new e.V(i, o, `missing required property "${t1}"`));
            }
            return l;
        }
        function xe({ key: t1, value: i }) {
            const o = ce({
                key: t1,
                value: i
            });
            if (o.length) return o;
            const s = i;
            return -1 === s.indexOf("{fontstack}") && o.push(new e.V(t1, i, '"glyphs" url must include a "{fontstack}" token')), -1 === s.indexOf("{range}") && o.push(new e.V(t1, i, '"glyphs" url must include a "{range}" token')), o;
        }
        function be(t1, i = e.a7, o = {}) {
            return ye({
                key: o.key || "",
                value: t1,
                valueSpec: Object.assign(i.$root, {
                    "*": {
                        type: "*"
                    }
                }),
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: xe
                }
            });
        }
        function we(t1, i = e.a7) {
            return Me(be(t1, i));
        }
        const Te = (e)=>Me(de(e)), Ee = (e)=>Me(_e(e)), Se = (e)=>Me(pe(e)), Ie = (e)=>Me(fe(e)), Ce = (e)=>Me(me(e)), Re = (t1)=>Me(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.snow;
                if (void 0 === i) return [];
                if (!e.J(i)) return [
                    new e.V("snow", i, `object expected, ${e.L(i)} found`)
                ];
                let n = [];
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    n = n.concat(a && r[a[1]] && r[a[1]].transition ? ve({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? ve({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.a4(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return n;
            }(t1)), Ae = (t1)=>Me(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.rain;
                if (void 0 === i) return [];
                if (!e.J(i)) return [
                    new e.V("rain", i, `object expected, ${e.L(i)} found`)
                ];
                let n = [];
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    n = n.concat(a && r[a[1]] && r[a[1]].transition ? ve({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? ve({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.a4(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return n;
            }(t1)), De = (e)=>Me(le(e)), Le = (e)=>Me(oe(e)), Pe = (e)=>Me(ne(e)), Oe = (e)=>Me(ae(e)), ze = (t1)=>Me(e.a8(t1));
        function Me(e) {
            return e.slice().sort((e, t1)=>e.line && t1.line ? e.line - t1.line : 0);
        }
        function Fe(t1, i) {
            let o = !1;
            if (i && i.length) for (const s of i)s instanceof e.a4 ? e.w(s.message) : (t1.fire(new e.z(new Error(s.message))), o = !0);
            return o;
        }
        const ke = e.a7.light;
        let Be;
        class Ne extends e.E {
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e.a9(Be || (Be = new e.aa({
                    anchor: new e.ab(ke.anchor),
                    position: new e.ac(ke.position),
                    color: new e.ab(ke.color),
                    intensity: new e.ab(ke.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, t1, i = {}) {
                this._validate(Ee, e, i) || (this._transitionable.setTransitionOrValue(e), this.id = t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Fe(this, t1.call(we, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a7
                })));
            }
        }
        const Ue = e.a7.terrain;
        let je = class extends e.E {
            constructor(t1, i, o, s, r){
                super(), this.scope = o, this._transitionable = new e.a9(new e.aa({
                    source: new e.ab(Ue.source),
                    exaggeration: new e.ab(Ue.exaggeration)
                }), o, s), this._transitionable.setTransitionOrValue(t1, s), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i, this.worldview = r;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e, t1) {
                this._transitionable.setTransitionOrValue(e, t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e.ad(t1, {
                    worldview: this.worldview
                })).get("exaggeration");
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration;
                if (!t1) return null;
                const i = t1.value.expression;
                if (!i) return null;
                let o = -1, s = -1, r = 1;
                for (const t1 of i.zoomStops)r = i.evaluate(new e.ad(t1, {
                    worldview: this.worldview
                })), r > .01 ? (o = t1, s = -1) : s = t1;
                return r < .01 && o > 0 && s > o ? [
                    o,
                    s
                ] : null;
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e.ae;
            }
        };
        const Ve = .05;
        function Ge(t1, i, o, s) {
            const r = e.ai(45, 65, o), [n, a] = He(t1, s);
            let l = 1 - Math.min(1, Math.exp((i - n) / (a - n) * -6));
            return l *= l * l, l = Math.min(1, 1.00747 * l), l * r * t1.alpha;
        }
        function He(e, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e.range[0] + i,
                e.range[1] + i
            ];
        }
        function qe(t1, i, o, s, r) {
            const n = e.ag([], [
                i,
                o,
                s
            ], r.mercatorFogMatrix);
            return Ge(t1, e.ah(n), r.pitch, r._fov);
        }
        function Ze(t1, i, o, s, r, n, a) {
            const l = [
                [
                    o,
                    s,
                    0
                ],
                [
                    r,
                    s,
                    0
                ],
                [
                    r,
                    n,
                    0
                ],
                [
                    o,
                    n,
                    0
                ]
            ];
            let c = Number.MAX_VALUE, h = -Number.MAX_VALUE;
            for (const t1 of l){
                const o = e.ag([], t1, i), s = e.ah(o);
                c = Math.min(c, s), h = Math.max(h, s);
            }
            return [
                Ge(t1, c, a.pitch, a._fov),
                Ge(t1, h, a.pitch, a._fov)
            ];
        }
        const We = e.a7.fog;
        class $e extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = new e.aa({
                    range: new e.ab(We.range),
                    color: new e.ab(We.color),
                    "color-use-theme": new e.ab({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e.ab(We["high-color"]),
                    "high-color-use-theme": new e.ab({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e.ab(We["space-color"]),
                    "space-color-use-theme": new e.ab({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e.ab(We["horizon-blend"]),
                    "star-intensity": new e.ab(We["star-intensity"]),
                    "vertical-range": new e.ab(We["vertical-range"])
                });
                this._transitionable = new e.a9(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e.aj(r), this.scope = o;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e.ak(t1.zoom), s = this.properties.get("range"), r = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e.al(r[0], s[0], o),
                        e.al(r[1], s[1], o)
                    ] : s,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e, t1, i = {}) {
                if (this._validate(Ce, e, i)) return;
                const o = Object.assign({}, e);
                for (const e of Object.keys(We))void 0 === o[e] && (o[e] = We[e].default);
                this._options = o, this._transitionable.setTransitionOrValue(this._options, t1);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e.ai(45, 65, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const s = e.af.fromLngLat(i), r = o.elevation ? o.elevation.getAtPointOrZero(s) : 0;
                    return qe(t1, s.x, s.y, r, o);
                }(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return Ze(this.state, i, 0, 0, e.am, e.am, this._transform);
            }
            getOpacityForBounds(e, t1, i, o, s) {
                return this._transform.projection.supportsFog ? Ze(this.state, e, t1, i, o, s, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e) {
                return this._transform.projection.supportsFog ? He(this.state, e) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const o of i){
                    const i = t1.points[o];
                    let s;
                    if (i[2] >= 0) s = i;
                    else {
                        const r = t1.points[o - 4];
                        s = e.an(r, i, r[2] / (r[2] - i[2]));
                    }
                    if (qe(this.state, s[0], s[1], 0, this._transform) >= Ve) return !0;
                }
                return !1;
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Fe(this, t1.call(we, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a7
                })));
            }
        }
        let Xe, Ke, Ye, Je = class extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = Xe || (Xe = new e.aa({
                    density: new e.ab(e.a7.snow.density),
                    intensity: new e.ab(e.a7.snow.intensity),
                    color: new e.ab(e.a7.snow.color),
                    opacity: new e.ab(e.a7.snow.opacity),
                    vignette: new e.ab(e.a7.snow.vignette),
                    "vignette-color": new e.ab(e.a7.snow["vignette-color"]),
                    "center-thinning": new e.ab(e.a7.snow["center-thinning"]),
                    direction: new e.ab(e.a7.snow.direction),
                    "flake-size": new e.ab(e.a7.snow["flake-size"])
                }));
                this._transitionable = new e.a9(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.aj(r), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.ao(o[0]), r = -Math.max(e.ao(o[1]), .01), n = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], a = this.properties.get("vignette"), l = this.properties.get("vignette-color");
                return l.a = a, {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.ap(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Re, t1, o)) return;
                const s = Object.assign({}, t1), r = e.a7.snow;
                for (const e of Object.keys(r))void 0 === s[e] && (s[e] = r[e].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Fe(this, t1.call(we, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a7
                })));
            }
        }, Qe = class extends e.E {
            constructor(t1, i, o, s){
                super();
                const r = Ke || (Ke = new e.aa({
                    density: new e.ab(e.a7.rain.density),
                    intensity: new e.ab(e.a7.rain.intensity),
                    color: new e.ab(e.a7.rain.color),
                    opacity: new e.ab(e.a7.rain.opacity),
                    vignette: new e.ab(e.a7.rain.vignette),
                    "vignette-color": new e.ab(e.a7.rain["vignette-color"]),
                    "center-thinning": new e.ab(e.a7.rain["center-thinning"]),
                    direction: new e.ab(e.a7.rain.direction),
                    "droplet-size": new e.ab(e.a7.rain["droplet-size"]),
                    "distortion-strength": new e.ab(e.a7.rain["distortion-strength"])
                }));
                this._transitionable = new e.a9(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.aj(r), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.ao(o[0]), r = -Math.max(e.ao(o[1]), .01), n = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], a = this.properties.get("vignette-color");
                return a.a = this.properties.get("vignette"), {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.ap(i.r, i.g, i.b, i.a * t1),
                    direction: n,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Ae, t1, o)) return;
                const s = Object.assign({}, t1), r = e.a7.rain;
                for (const e of Object.keys(r))void 0 === s[e] && (s[e] = r[e].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Fe(this, t1.call(we, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a7
                })));
            }
        };
        class et extends e.E {
            constructor(t1, i, o, s){
                super(), this.scope = o, this._options = t1, this.properties = new e.aj(i), this._transitionable = new e.a9(i, o, new Map(s)), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e, t1) {
                this._options = e, this._transitionable.setTransitionOrValue(e.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        const tt = ()=>Ye || (Ye = new e.aa({
                color: new e.ab(e.a7.properties_light_ambient.color),
                "color-use-theme": new e.ab({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e.ab(e.a7.properties_light_ambient.intensity)
            }));
        let it;
        const ot = ()=>it || (it = new e.aa({
                direction: new e.aq(e.a7.properties_light_directional.direction),
                color: new e.ab(e.a7.properties_light_directional.color),
                "color-use-theme": new e.ab({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e.ab(e.a7.properties_light_directional.intensity),
                "cast-shadows": new e.ab(e.a7.properties_light_directional["cast-shadows"]),
                "shadow-quality": new e.ab(e.a7.properties_light_directional["shadow-quality"]),
                "shadow-intensity": new e.ab(e.a7.properties_light_directional["shadow-intensity"]),
                "shadow-draw-before-layer": new e.ab(e.a7.properties_light_directional["shadow-draw-before-layer"])
            }));
        class st {
            constructor(e, t1, i){
                this.screenBounds = e, this.cameraPoint = i.getCameraPoint(), this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = t1, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, i);
            }
            static createFromScreenPoints(t1, i) {
                let o, s;
                if (t1 instanceof e.P || "number" == typeof t1[0]) {
                    const r = e.P.convert(t1);
                    o = [
                        r
                    ], s = i.isPointAboveHorizon(r);
                } else {
                    const r = e.P.convert(t1[0]), n = e.P.convert(t1[1]), a = r.add(n)._div(2);
                    o = [
                        r,
                        n
                    ], s = e.ar(r, n).every((e)=>i.isPointAboveHorizon(e)) && i.isPointAboveHorizon(a);
                }
                return new st(o, s, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e.ar(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.ar(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? s.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? s[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (s[3] = this.cameraPoint)), e.as(s, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.ar(i, o, t1), r = this.cameraPoint.clone();
                switch(3 * ((r.y > i.y) + (r.y > o.y)) + ((r.x > i.x) + (r.x > o.x))){
                    case 0:
                        s[0] = r, s[4] = r.clone();
                        break;
                    case 1:
                        s.splice(1, 0, r);
                        break;
                    case 2:
                        s[1] = r;
                        break;
                    case 3:
                        s.splice(4, 0, r);
                        break;
                    case 5:
                        s.splice(2, 0, r);
                        break;
                    case 6:
                        s[3] = r;
                        break;
                    case 7:
                        s.splice(3, 0, r);
                        break;
                    case 8:
                        s[2] = r;
                }
                return s;
            }
            containsTile(t1, i, o, s = 0) {
                const r = Math.max(t1.queryPadding, t1.evaluateQueryRenderedFeaturePadding()) / i._pixelsPerMercatorPixel + 1, n = o ? this._bufferedCameraMercator(r, i) : this._bufferedScreenMercator(r, i);
                let a = t1.tileID.wrap + (n.unwrapped ? s : 0);
                const l = n.polygon.map((i)=>e.at(t1.tileTransform, i, a));
                if (!e.au(l, 0, 0, e.am, e.am)) return;
                a = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? s : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e.av(t1.tileTransform, i, a)), h = c.map((t1)=>new e.P(t1[0], t1[1])), d = i.getFreeCameraOptions().position || new e.af(0, 0, 0), u = e.av(t1.tileTransform, d, a), _ = c.map((t1)=>{
                    const i = e.aw(t1, t1, u);
                    return e.ax(i, i), new e.ay(u, i);
                }), p = e.az(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: _,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (f = e.aA(l), f.min.x = e.aB(f.min.x, 0, e.am), f.min.y = e.aB(f.min.y, 0, e.am), f.max.x = e.aB(f.max.x, 0, e.am), f.max.y = e.aB(f.max.y, 0, e.am), f),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e, t1) {
                const i = at(e);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e), t1) : {
                        polygon: this.bufferedScreenGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e, t1) {
                const i = at(e);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e), t1) : {
                        polygon: this.bufferedCameraGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e.aC([], i.pixelMatrix, i.globeMatrix), s = [
                        0,
                        -e.aE,
                        0,
                        1
                    ], r = [
                        0,
                        e.aE,
                        0,
                        1
                    ], n = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e.aD(s, s, o), e.aD(r, r, o), e.aD(n, n, o);
                    const a = new e.P(s[0] / s[3], s[1] / s[3]), l = new e.P(r[0] / r[3], r[1] / r[3]), c = e.aF(t1, a) && s[3] < n[3], h = e.aF(t1, l) && r[3] < n[3];
                    if (!c && !h) return null;
                    const d = function(e, t1, i) {
                        for(let o = 1; o < e.length; o++){
                            const s = nt(t1.pointCoordinate3D(e[o - 1]).x), r = nt(t1.pointCoordinate3D(e[o]).x);
                            if (i < 0) {
                                if (s < r) return {
                                    idx: o,
                                    t: -s / (r - 1 - s)
                                };
                            } else if (r < s) return {
                                idx: o,
                                t: (1 - s) / (r + 1 - s)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!d) return null;
                    const { idx: u, t: _ } = d;
                    let p = u > 1 ? rt(t1.slice(0, u), i) : [], f = u < t1.length ? rt(t1.slice(u), i) : [];
                    p = p.map((t1)=>new e.P(nt(t1.x), t1.y)), f = f.map((t1)=>new e.P(nt(t1.x), t1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const g = e.al(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, _);
                    let v;
                    return v = c ? [
                        new e.P(0, g),
                        new e.P(0, 0),
                        new e.P(1, 0),
                        new e.P(1, g)
                    ] : [
                        new e.P(1, g),
                        new e.P(1, 1),
                        new e.P(0, 1),
                        new e.P(0, g)
                    ], m.push(...v), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((t1)=>new e.af(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const s = function(t1, i) {
                    let o = !1, s = -1 / 0, r = 0;
                    for(let e = 0; e < t1.length - 1; e++)t1[e].x > s && (s = t1[e].x, r = e);
                    for(let e = 0; e < t1.length - 1; e++){
                        const i = (r + e) % (t1.length - 1), s = t1[i], n = t1[i + 1];
                        Math.abs(s.x - n.x) > .5 && (s.x < n.x ? (s.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (n.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const n = e.aG(i.center.lng);
                    return o && n < Math.abs(n - 1) && t1.forEach((e)=>{
                        e.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(rt(t1, i).map((t1)=>new e.P(nt(t1.x), t1.y)), i);
                return {
                    polygon: s.polygon.map((t1)=>new e.af(t1.x, t1.y)),
                    unwrapped: s.unwrapped
                };
            }
        }
        function rt(t1, i) {
            return e.aH(t1, (e)=>{
                const t1 = i.pointCoordinate3D(e);
                e.x = t1.x, e.y = t1.y;
            }, 1 / 256);
        }
        function nt(e) {
            return e < 0 ? 1 + e % 1 : e % 1;
        }
        function at(e) {
            return 100 * e | 0;
        }
        function lt(t1, i, o, s, r) {
            const n = function(o, s) {
                if (o) return r(o);
                if (s) {
                    if (t1.url && s.tiles && t1.tiles && delete t1.tiles, s.variants) {
                        if (!Array.isArray(s.variants)) return r(new Error("variants must be an array"));
                        for (const e of s.variants){
                            if (null == e || "object" != typeof e || e.constructor !== Object) return r(new Error("variant must be an object"));
                            if (!Array.isArray(e.capabilities)) return r(new Error("capabilities must be an array"));
                            if (1 === e.capabilities.length && "meshopt" === e.capabilities[0]) {
                                s = Object.assign(s, e);
                                break;
                            }
                        }
                    }
                    const o = e.aI(Object.assign({}, s, t1), [
                        "tilejson",
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "extra_bounds",
                        "scheme",
                        "tileSize",
                        "encoding",
                        "vector_layers",
                        "raster_layers",
                        "worldview_options",
                        "worldview_default",
                        "worldview"
                    ]);
                    o.tiles = i.canonicalizeTileset(o, t1.url), r(null, o);
                }
            }, a = function(e, t1, i) {
                if (!e) return null;
                if (!t1 && !i) return e;
                i = i || e.worldview_default;
                const o = Object.values(e.language || {});
                if (0 === o.length) return null;
                const s = Object.values(e.worldview || {});
                if (0 === s.length) return null;
                const r = o.every((e)=>e === t1), n = s.every((e)=>e === i);
                return r && n ? e : t1 in (e.language_options || {}) || i in (e.worldview_options || {}) ? null : e.language_options && e.worldview_options ? e : null;
            }(t1.data, o, s);
            return a ? e.o.frame(()=>n(null, a)) : t1.url ? e.m(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, s), e.R.Source), n) : e.o.frame(()=>{
                const { data: e, ...i } = t1;
                n(null, i);
            });
        }
        function ct(t1, i) {
            const o = Math.pow(2, i.z), s = Math.floor(e.aG(t1.getWest()) * o), r = Math.floor(e.aK(t1.getNorth()) * o), n = Math.ceil(e.aG(t1.getEast()) * o), a = Math.ceil(e.aK(t1.getSouth()) * o);
            return i.x >= s && i.x < n && i.y >= r && i.y < a;
        }
        class ht {
            constructor(t1, i, o){
                this.bounds = t1 ? e.aJ.convert(this.validateBounds(t1)) : null, this.minzoom = i || 0, this.maxzoom = o || 24;
            }
            validateBounds(e) {
                return Array.isArray(e) && 4 === e.length ? [
                    Math.max(-180, e[0]),
                    Math.max(-90, e[1]),
                    Math.min(180, e[2]),
                    Math.min(90, e[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            addExtraBounds(t1) {
                if (t1) {
                    this.extraBounds || (this.extraBounds = []);
                    for (const i of t1)this.extraBounds.push(e.aJ.convert(this.validateBounds(i)));
                }
            }
            contains(e) {
                if (e.z > this.maxzoom || e.z < this.minzoom) return !1;
                if (this.bounds && !ct(this.bounds, e)) return !1;
                if (!this.extraBounds) return !0;
                for (const t1 of this.extraBounds)if (ct(t1, e)) return !0;
                return !1;
            }
            static fromTileJSON(e) {
                if (!e.bounds && !e.extra_bounds) return null;
                const t1 = new ht(e.bounds, e.minzoom, e.maxzoom);
                return t1.addExtraBounds(e.extra_bounds), t1;
            }
        }
        class dt extends e.E {
            constructor(t1, i, o, s){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, Object.assign(this, e.aI(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = Object.assign({
                    type: "vector"
                }, i), this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(s), this._tileWorkers = {}, this._deduped = new e.aL;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.A("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                this._tileJSONRequest = lt(this._options, this.map._requestManager, i, o, (s, r)=>{
                    if (this._tileJSONRequest = null, this._loaded = !0, s) i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.z(s));
                    else if (r) {
                        if (Object.assign(this, r), this.hasWorldviews = !!r.worldview_options, r.worldview_default && (this.worldviewDefault = r.worldview_default), r.vector_layers) {
                            this.vectorLayers = r.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                            for (const e of r.vector_layers)this.vectorLayerIds.push(e.id), r.worldview && r.worldview[e.source] && this.localizableLayerIds.add(e.id);
                        }
                        this.tileBounds = ht.fromTileJSON(r), P(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }));
                    }
                    t1 && t1(s);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.C(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return Object.assign({}, this._options);
            }
            loadTile(t1, i) {
                const o = t1.tileID.canonical.url(this.tiles, this.scheme), s = this.map._requestManager.normalizeTileURL(o), r = this.map._requestManager.transformRequest(s, e.R.Tile), n = this.map.style ? this.map.style.getLut(this.scope) : null, a = n ? {
                    image: n.image.clone()
                } : null, l = {
                    request: r,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    lut: a,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e.o.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: t1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep,
                    scaleFactor: this.map.getScaleFactor(),
                    worldview: this.map.getWorldview() || this.worldviewDefault,
                    indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                };
                if (this.hasWorldviews && e.h(o) && (l.localizableLayerIds = this.localizableLayerIds), l.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", l, c.bind(this));
                else if (t1.actor = this._tileWorkers[s] = this._tileWorkers[s] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                else {
                    const i = e.aM.call({
                        deduped: this._deduped
                    }, l, (i, o)=>{
                        if (i || !o) c.call(this, i);
                        else {
                            const i = e.aN(o.responseHeaders);
                            l.data = {
                                rawData: o.rawData.slice(0),
                                expires: i.expires,
                                cacheControl: i.cacheControl
                            }, t1.actor && t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                        }
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function c(o, s) {
                    return delete t1.request, t1.aborted ? i(null) : o && o instanceof e.aO && 404 !== o.status ? i(o) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(s), t1.loadVectorData(s, this.map.painter), e.aP(this.dispatcher), i(null, s), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e, t1) {
                e.actor && e.actor.send("removeTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class ut extends e.E {
            constructor(t1, i, o, s){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(s), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = Object.assign({
                    type: "raster"
                }, i), Object.assign(this, e.aI(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e.A("dataloading", {
                    dataType: "source"
                }));
                const i = this.map.getWorldview();
                this._tileJSONRequest = lt(this._options, this.map._requestManager, null, i, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e.z(i)) : o && (Object.assign(this, o), o.raster_layers && (this.rasterLayers = o.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e)=>e.id)), this.tileBounds = ht.fromTileJSON(o), P(o.tiles), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.C(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return Object.assign({}, this._options);
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            loadTile(t1, i) {
                const o = e.o.devicePixelRatio >= 2, s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e.n(this.map._requestManager.transformRequest(s, e.R.Tile), (o, s, r)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (o) return t1.state = "errored", i(o);
                    if (!s) return i(null);
                    const n = e.aN(r);
                    this.map._refreshExpiredTiles && t1.setExpiryData(n), t1.setTexture(s, this.map.painter), t1.state = "loaded", e.aP(this.dispatcher), i(null);
                });
            }
            abortTile(e, t1) {
                e.request && (e.request.cancel(), delete e.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        function _t([t1, i], o, s, { scaled: r = !0 } = {}) {
            const { tileSize: n, buffer: a } = s, { x: l, y: c, z: h } = o;
            if (!isFinite(l) || !isFinite(c) || !isFinite(h)) throw new Error("Invalid MRT header");
            const d = 2 ** h, u = d * e.aG(t1), _ = d * e.aK(i);
            return function([e, t1], i, { scaled: o = !0 } = {}) {
                if (!i) throw new Error("bandView is undefined");
                const { data: s, tileSize: r, buffer: n, offset: a, scale: l, dimension: c } = i;
                if (e < -n || e > r + n || t1 < -n || t1 > r + n) throw new Error(`Point (${e}, ${t1}) out of bounds for tileSize=${r}, buffer=${n}`);
                const h = (t1 + n) * (r + 2 * n) + (e + n);
                if (4294967295 === new Uint32Array(s.buffer)[h]) return null;
                let d = [];
                d = o ? [] : new i.data.constructor(c);
                for(let e = 0; e < c; e++)d[e] = Math.round(1e12 * (s[c * h + e] * l + a)) / 1e12;
                return d;
            }([
                Math.min(Math.max(-a, Math.floor((u - l) * n)), n - 1 + a),
                Math.min(Math.max(-a, Math.floor((_ - c) * n)), n - 1 + a)
            ], s, {
                scaled: r
            });
        }
        class pt extends ut {
            constructor(e, t1, i, o){
                super(e, t1, i, o), this.type = "raster-array", this.maxzoom = 22, this.partial = !0, this._loadTilePending = {}, this._loadTileLoaded = {}, this._options = Object.assign({
                    type: "raster-array"
                }, t1);
            }
            triggerRepaint(e) {
                const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e.tileID), this.map.triggerRepaint();
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), s = this.map._requestManager.transformRequest(o, e.R.Tile), r = {
                    request: s,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    partial: this.partial
                };
                t1.source = this.id, t1.scope = this.scope, t1.requestParams = s, t1.actor || (t1.actor = this.dispatcher.getActor());
                const n = (o, s, r)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (o) {
                        if ("AbortError" === o.name) return;
                        return t1.state = "errored", i(o);
                    }
                    if (this.map._refreshExpiredTiles && s) {
                        const i = e.aN(r);
                        t1.setExpiryData(i);
                    }
                    if (this.partial && "expired" !== t1.state) t1.state = "empty";
                    else if (!this.partial) {
                        if (!s) return i(null);
                        t1.state = "loaded", t1._isHeaderLoaded = !0, t1._mrt = s;
                    }
                    i(null);
                };
                t1.request = this.partial ? t1.fetchHeader(void 0, n.bind(this)) : t1.actor.send("loadTile", r, n.bind(this), void 0, !0);
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e, t1) {
                const i = e.texturePerLayer;
                if (e.flushAllQueues(), i.size) {
                    e.destroy(!1);
                    for (const e of i.values())this.map.painter.saveTileTexture(e);
                } else e.destroy();
            }
            prepareTile(t1, i, o, s) {
                t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBandForRender(i, o, s, (i, s)=>{
                    i ? (t1.state = "errored", this.fire(new e.z(i))) : s && (t1._isHeaderLoaded = !0, t1.setTexturePerLayer(o, s, this.map.painter), t1.state = "loaded"), this.triggerRepaint(t1);
                }));
            }
            getInitialBand(e) {
                if (!this.rasterLayers) return 0;
                const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e), i = t1 && t1.fields, o = i && i.bands && i.bands;
                return o ? o[0] : 0;
            }
            getTextureDescriptor(t1, i, o) {
                if (!t1) return;
                const s = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                if (!s) return;
                let r = null;
                i instanceof e.aS ? r = i.paint.get("raster-array-band") : i instanceof e.aT && (r = i.paint.get("raster-particle-array-band"));
                const n = r || this.getInitialBand(s);
                if (null == n) return;
                if (!t1.textureDescriptorPerLayer.get(i.id)) return void this.prepareTile(t1, s, i.id, n);
                if (t1.updateNeeded(i.id, n) && !o) return;
                const a = t1.textureDescriptorPerLayer.get(i.id);
                return Object.assign({}, a, {
                    texture: t1.texturePerLayer.get(i.id)
                });
            }
            getImages(t1, i) {
                const o = new Map;
                for (const s of t1)for (const t1 of i){
                    const [i, r] = t1.split("/"), n = s.getLayer(i);
                    if (!n) continue;
                    if (!n.hasBand(r) || !n.hasDataForBand(r)) continue;
                    const { bytes: a, tileSize: l, buffer: c } = n.getBandView(r), h = l + 2 * c, d = {
                        data: new e.q({
                            width: h,
                            height: h
                        }, a),
                        pixelRatio: 2,
                        sdf: !1,
                        usvg: !1,
                        version: 0
                    };
                    o.set(t1, d);
                }
                return o;
            }
            queryRasterArrayValueByBandId(t1, i, o) {
                const s = i._mrt;
                return new Promise((r)=>{
                    const n = {}, a = new Set;
                    for (const [l, c] of Object.entries(s.layers)){
                        if (o.layerName && l !== o.layerName) continue;
                        const h = {};
                        n[l] = h;
                        for (const { bands: d } of c.dataIndex)for (const u of d)o.bands && !o.bands.includes(u) || (a.add(e.C(l, u)), i.fetchBand(l, null, u, (i)=>{
                            e.o.frame(()=>{
                                h[u] = i ? null : _t([
                                    t1.lng,
                                    t1.lat
                                ], s, c.getBandView(u)), a.delete(e.C(l, u)), 0 === a.size && r(n);
                            });
                        }, !1));
                    }
                    0 === a.size && r(n);
                });
            }
            _loadTileForQuery(t1, i) {
                if (this._loadTileLoaded[t1.uid]) return void i(null, t1._mrt);
                if (this._loadTilePending[t1.uid]) return void this._loadTilePending[t1.uid].push(i);
                this._loadTilePending[t1.uid] = [
                    i
                ];
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), s = this.map._requestManager.transformRequest(o, e.R.Tile);
                t1.actor.send("loadTile", {
                    request: s,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    partial: !1
                }, (i, o, s)=>{
                    if (i) return this._loadTilePending[t1.uid].forEach((e)=>e(i, null)), void delete this._loadTilePending[t1.uid];
                    if (!o) return this._loadTilePending[t1.uid].forEach((e)=>e(null, null)), void delete this._loadTilePending[t1.uid];
                    if (this.map._refreshExpiredTiles && o) {
                        const i = e.aN(s);
                        t1.setExpiryData(i);
                    }
                    t1._mrt = o, t1._isHeaderLoaded = !0, t1.state = "loaded", this._loadTilePending[t1.uid].forEach((e)=>e(null, o)), this._loadTileLoaded[t1.uid] = !0, delete this._loadTilePending[t1.uid];
                }, void 0, !0);
            }
            queryRasterArrayValueByAllBands(e, t1, i) {
                return new Promise((o, s)=>{
                    this._loadTileForQuery(t1, (r, n)=>{
                        r ? s(r) : o(n ? this.queryRasterArrayValueByBandId(e, t1, i) : null);
                    });
                });
            }
            queryRasterArrayValue(t1, i) {
                const o = e.aU.convert(t1), s = this.findLoadedParent(o);
                return s && s._mrt ? i.bands || !this.partial ? this.queryRasterArrayValueByBandId(o, s, i) : this.queryRasterArrayValueByAllBands(o, s, i) : Promise.resolve(null);
            }
            findLoadedParent(t1) {
                const i = e.af.fromLngLat(t1, this.map.transform.tileSize), o = this.maxzoom + 1, s = 1 << o, r = Math.floor(i.x), n = Math.floor((i.x - r) * s), a = Math.floor(i.y * s), l = this.map.style.getSourceCache(this.id), c = new e.aR(o, r, o, n, a);
                return l.findLoadedParent(c, this.minzoom);
            }
        }
        const ft = {
            vector: dt,
            raster: ut,
            "raster-dem": class extends ut {
                constructor(e, t1, i, o){
                    super(e, t1, i, o), this.type = "raster-dem", this.maxzoom = 22, this._options = Object.assign({
                        type: "raster-dem"
                    }, t1), this.encoding = t1.encoding || "mapbox";
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function s(e, o) {
                        e && (t1.state = "errored", i(e)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e.n(this.map._requestManager.transformRequest(o, e.R.Tile), (function(o, r, n) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (r) {
                            const i = e.aN(n);
                            this.map._refreshExpiredTiles && t1.setExpiryData(i);
                            const o = e.t(), a = 1 - (r.width - e.aQ(r.width)) / 2;
                            a < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = o ? r : e.o.getImageData(r, a), c = {
                                uid: t1.uid,
                                tileID: t1.tileID,
                                source: this.id,
                                type: this.type,
                                scope: this.scope,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: a
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadTile", c, s.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), s = (i.x - 1 + o) % o, r = 0 === i.x ? t1.wrap - 1 : t1.wrap, n = (i.x + 1 + o) % o, a = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e.aR(t1.overscaledZ, r, i.z, s, i.y).key] = {
                        backfilled: !1
                    }, l[new e.aR(t1.overscaledZ, a, i.z, n, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e.aR(t1.overscaledZ, r, i.z, s, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aR(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aR(t1.overscaledZ, a, i.z, n, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e.aR(t1.overscaledZ, r, i.z, s, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aR(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aR(t1.overscaledZ, a, i.z, n, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            "raster-array": pt,
            geojson: class extends e.E {
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(s), this._data = i.data, this._options = Object.assign({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const r = e.am / this.tileSize;
                    this.workerOptions = Object.assign({
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * r,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * r,
                            extent: e.am,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e.am,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * r,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic
                    }, i.workerOptions);
                }
                onAdd(e) {
                    this.map = e, this.setData(this._data);
                }
                setData(e) {
                    return this._data = e, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e.z(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e.z(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e = new Map;
                        for (const t1 of this._data.features)e.set(t1.id, t1);
                        for (const i of t1.features)e.set(i.id, i);
                        this._data.features = [
                            ...e.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterChildren(e, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterLeaves(e, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e.A("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = Object.assign({
                        append: t1
                    }, this.workerOptions);
                    i.scope = this.scope;
                    const o = this._data;
                    "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e.o.resolveURL(o), e.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                        if (this._loaded = !0, this._pendingLoad = null, i) this.fire(new e.z(i));
                        else {
                            const i = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (i.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e.A("data", i)), this._partialReload = !1, this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e.C(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const s = this.map.style ? this.map.style.getLut(this.scope) : null, r = s ? {
                        image: s.image.clone()
                    } : null, n = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: r,
                        scope: this.scope,
                        pixelRatio: e.o.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: n,
                        worldview: this.map.getWorldview(),
                        indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                    };
                    t1.request = this.actor.send(o, a, (e, s)=>n && !s ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(!1), t1.aborted ? i(null) : e ? i(e) : (t1.loadVectorData(s, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e) {
                    e.request && (e.request.cancel(), delete e.request), e.aborted = !0;
                }
                unloadTile(e, t1) {
                    this.actor.send("removeTile", {
                        uid: e.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e.destroy();
                }
                onRemove(e) {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return Object.assign({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends e.aV {
                constructor(e, t1, i, o){
                    super(e, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e.R.Source).url);
                    e.aW(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e.z(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e.z(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e) {
                    this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: e.aV,
            model: e.aY,
            "batched-model": class extends e.E {
                constructor(e, t1, i, o){
                    super(), this.type = "batched-model", this.id = e, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(o);
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const t1 = e.C(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(t1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e.A("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                    this._tileJSONRequest = lt(this._options, this.map._requestManager, i, o, (s, r)=>{
                        this._tileJSONRequest = null, this._loaded = !0, s ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.z(s))) : r && (Object.assign(this, r), r.bounds && (this.tileBounds = new ht(r.bounds, this.minzoom, this.maxzoom)), P(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(s);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e) {
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), s = {
                        request: this.map._requestManager.transformRequest(o, e.R.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: t1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        pixelRatio: e.o.devicePixelRatio,
                        promoteId: this.promoteId
                    };
                    if (t1.actor && "expired" !== t1.state) {
                        if ("loading" === t1.state) t1.reloadCallback = i;
                        else {
                            if (t1.buckets) {
                                const e = Object.values(t1.buckets);
                                for (const t1 of e)t1.dirty = !0;
                                return void (t1.state = "loaded");
                            }
                            t1.request = t1.actor.send("reloadTile", s, r.bind(this));
                        }
                    } else t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", s, r.bind(this), void 0, !0);
                    function r(e, o) {
                        return t1.aborted ? i(null) : e && 404 !== e.status ? i(e) : (this.map._refreshExpiredTiles && o && t1.setExpiryData(o), t1.loadModelData(o, this.map.painter), t1.state = "loaded", void i(null));
                    }
                }
                serialize() {
                    return Object.assign({}, this._options);
                }
            },
            canvas: class extends e.aV {
                constructor(t1, i, o, s){
                    super(t1, i, o, s), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e)=>!Array.isArray(e) || 2 !== e.length || e.some((e)=>"number" != typeof e)) || this.fire(new e.z(new e.V(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.z(new e.V(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e.z(new e.V(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e.z(new e.V(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.z(new e.V(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.z(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e) {
                    this.map = e, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e.aX || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e) || e <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e.E {
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(s), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e.z(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.z(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new ht(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.clearTiles = this._clearTiles.bind(this), i.coveringTiles = this._coveringTiles.bind(this), Object.assign(this, e.aI(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e.aI(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e.A("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e) {
                    this._implementation.onRemove && this._implementation.onRemove(e);
                }
                hasTile(e) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loadTile(e, t1) {
                    const { x: i, y: o, z: s } = e.tileID.canonical, r = new AbortController;
                    e.request = Promise.resolve(this._implementation.loadTile({
                        x: i,
                        y: o,
                        z: s
                    }, {
                        signal: r.signal
                    })).then((function(i) {
                        return delete e.request, e.aborted ? (e.state = "unloaded", t1(null)) : void 0 === i ? (e.state = "errored", t1(null)) : null === i ? (this.loadTileData(e, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e.state = "loaded", t1(null)) : function(e) {
                            return e instanceof ImageData || e instanceof HTMLCanvasElement || e instanceof ImageBitmap || e instanceof HTMLImageElement;
                        }(i) ? (this.loadTileData(e, i), e.state = "loaded", void t1(null)) : (e.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((i)=>{
                        "AbortError" !== i.name && (e.state = "errored", t1(i));
                    }), e.request.cancel = ()=>r.abort();
                }
                loadTileData(e, t1) {
                    e.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e, y: i, z: o } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e,
                            y: i,
                            z: o
                        });
                    }
                    i && i();
                }
                abortTile(e, t1) {
                    e.request && e.request.cancel && (e.request.cancel(), delete e.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e)=>({
                            x: e.canonical.x,
                            y: e.canonical.y,
                            z: e.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e.C(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e.A("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, mt = function(t1, i, o, s) {
            const r = new ft[i.type](t1, i, o, s);
            if (r.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${r.id}`);
            return e.aZ([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], r), r;
        };
        function gt(e, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e) {
                if ("layerId" in e) return `layer:${e.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e.target)}`;
        }
        function vt(e, t1, i, o = "") {
            if (e.uniqueFeatureID) {
                const s = gt(e, t1, o);
                if (i.has(s)) return !0;
                i.add(s);
            }
            return !1;
        }
        function yt(e, t1, i, o, s = !1, r) {
            const n = t1.sourceCache.transform, a = t1.sourceCache.tilesIn(e, t1.has3DLayers, s);
            a.sort(wt);
            const l = [];
            for (const e of a){
                const a = e.tile.queryRenderedFeatures(t1, e, i, o, n, s, r);
                Object.keys(a).length && l.push({
                    wrappedTileID: e.tile.tileID.wrapped().key,
                    queryResults: a
                });
            }
            for(const i in t1.layers){
                const s = t1.layers[i];
                if (s.styleLayer) {
                    const i = s.styleLayer.queryRenderedFeatures(e, t1.sourceCache, o);
                    Object.keys(i).length && l.push({
                        wrappedTileID: 0,
                        queryResults: i
                    });
                }
            }
            return 0 === l.length ? {} : function(e) {
                const t1 = {}, i = {};
                for (const o of e){
                    const e = o.queryResults, s = o.wrappedTileID, r = i[s] = i[s] || {};
                    for(const i in e){
                        const o = e[i], s = r[i] = r[i] || {}, n = t1[i] = t1[i] || [];
                        for (const e of o)s[e.featureIndex] || (s[e.featureIndex] = !0, n.push(e));
                    }
                }
                return t1;
            }(l);
        }
        function xt(e, t1, i, o, s, r) {
            const n = {}, a = o.queryRenderedSymbols(e), l = [];
            for (const e of Object.keys(a).map(Number))l.push(s[e]);
            l.sort(wt);
            for (const e of l){
                const o = e.featureIndex.lookupSymbolFeatures(a[e.bucketInstanceId], e.bucketIndex, e.sourceLayerIndex, t1, i, r);
                for(const t1 in o){
                    const i = n[t1] = n[t1] || [], s = o[t1];
                    s.sort((t1, i)=>{
                        const o = e.featureSortOrder;
                        if (o) {
                            const e = o.indexOf(t1.featureIndex);
                            return o.indexOf(i.featureIndex) - e;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e of s)i.push(e);
                }
            }
            return n;
        }
        function bt(e, t1) {
            const i = e.getRenderableIds().map((t1)=>e.getTileByID(t1)), o = [], s = {};
            for(let e = 0; e < i.length; e++){
                const r = i[e], n = r.tileID.canonical.key;
                s[n] || (s[n] = !0, r.querySourceFeatures(o, t1));
            }
            return o;
        }
        function wt(e, t1) {
            const i = e.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function Tt(e, t1) {
            const i = {};
            if (!t1) return i;
            for (const o of e){
                const e = o.layerIds.map((e)=>t1.getLayer(e)).filter(Boolean);
                if (0 !== e.length) {
                    o.layers = e, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((t1)=>e.filter((e)=>e.id === t1)[0]));
                    for (const t1 of e)i[t1.fqid] = o;
                }
            }
            return i;
        }
        const Et = 32, St = 33, It = new Uint16Array(8184);
        for(let e = 0; e < 2046; e++){
            let t1 = e + 2, i = 0, o = 0, s = 0, r = 0, n = 0, a = 0;
            for(1 & t1 ? s = r = n = Et : i = o = a = Et; (t1 >>= 1) > 1;){
                const e = i + s >> 1, l = o + r >> 1;
                1 & t1 ? (s = i, r = o, i = n, o = a) : (i = s, o = r, s = n, r = a), n = e, a = l;
            }
            const l = 4 * e;
            It[l + 0] = i, It[l + 1] = o, It[l + 2] = s, It[l + 3] = r;
        }
        const Ct = new Uint16Array(2178), Rt = new Uint8Array(1089), At = new Uint16Array(1089);
        function Dt(e) {
            return 0 === e ? -0.03125 : 32 === e ? .03125 : 0;
        }
        const Lt = (()=>({
                type: 2,
                extent: e.am,
                loadGeometry: ()=>[
                        [
                            new e.P(0, 0),
                            new e.P(e.am + 1, 0),
                            new e.P(e.am + 1, e.am + 1),
                            new e.P(0, e.am + 1),
                            new e.P(0, 0)
                        ]
                    ]
            }))();
        class Pt {
            constructor(t1, i, o, s, r, n){
                this.tileID = t1, this.uid = e.b3(), this.uses = 0, this.tileSize = i, this.tileZoom = o, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = r, s && s.style && (this._lastUpdatedBrightness = s.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", s && s.transform && (this.projection = s.transform.projection), this.worldview = n, this._hasAppearances = null;
            }
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e.o.now() || void 0 !== this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e.a_(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, o) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = Tt(t1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.b5) {
                            if (this.hasSymbolBuckets = !0, !o) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.b5 && i.hasRTLText) {
                            this.hasRTLText = !0, e.b6();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e in this.buckets){
                        const t1 = this.buckets[e], o = i.style.getOwnLayer(e);
                        if (!o) continue;
                        const s = o.queryRadius(t1);
                        this.queryPadding = Math.max(this.queryPadding, s);
                    }
                    t1.imageAtlas && (this.imageAtlas = i.style.imageManager.imageAtlasCache.getOrCache(t1.imageAtlas)), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e.b4;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e in this.buckets)this.buckets[e].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e, t1, i) {
                e && (e.resourceTiming && (this.resourceTiming = e.resourceTiming), this.buckets = Object.assign({}, this.buckets, Tt(e.buckets, t1.style)), e.featureIndex && (this.latestFeatureIndex = e.featureIndex));
            }
            getBucket(e) {
                return this.buckets[e.fqid];
            }
            upload(t1, i) {
                for(const e in this.buckets){
                    const o = this.buckets[e];
                    if (o.uploadPending()) {
                        let e = {}, s = [], r = {
                            zoom: 0,
                            pitch: 0,
                            brightness: 0,
                            worldview: ""
                        };
                        if (i) {
                            if (i.style) {
                                s = i.style.listImages();
                                const t1 = o.layers[0], r = t1.sourceLayer || "_geojsonTileLayer", n = i.style.getLayerSourceCache(t1);
                                n && (e = n._state.getState(r, void 0));
                            }
                            r = {
                                zoom: i.transform.zoom || 0,
                                pitch: i.transform.pitch || 0,
                                brightness: i.style.getBrightness() || 0,
                                worldview: i.worldview || ""
                            };
                        }
                        o.upload(t1, this.tileID.canonical, e, s, r);
                    }
                }
                const o = t1.gl, s = this.imageAtlas;
                !s || this.imageAtlasTexture && s.uploaded || (this.imageAtlasTexture = null, this.imageAtlasTexture = i.style.imageManager.imageAtlasCache.getTextureForAtlas(s, t1, o.RGBA8), s.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new e.T(t1, this.glyphAtlasImage, o.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e.T(t1, this.lineAtlas.image, o.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && t1) {
                    const o = t1.style.getLut(i);
                    this.imageAtlas.patchUpdatedImages(e, this.imageAtlasTexture, i, o);
                }
                if (!t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const o = t1.style.getBrightness();
                null === this._hasAppearances && (this._hasAppearances = this.hasAppearances(t1)), (this._lastUpdatedBrightness || o || this._hasAppearances) && (!this._hasAppearances && this._lastUpdatedBrightness && o && Math.abs(this._lastUpdatedBrightness - o) < .001 || (this.updateBuckets(t1, this._lastUpdatedBrightness !== o), this._lastUpdatedBrightness = o));
            }
            evaluateQueryRenderedFeaturePadding() {
                let e = 0;
                for(const t1 in this.buckets){
                    const i = this.buckets[t1];
                    i.evaluateQueryRenderedFeaturePadding && (e = Math.max(e, i.evaluateQueryRenderedFeaturePadding()));
                }
                return e;
            }
            queryRenderedFeatures(t1, i, o, s, r, n, a) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const l = this.evaluateQueryRenderedFeaturePadding(), c = function(t1, i) {
                    const o = e.br([], [
                        .5 * t1.width,
                        .5 * -t1.height,
                        1
                    ]);
                    return e.bs(o, o, [
                        1,
                        -1,
                        0
                    ]), e.aC(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
                }(r, this.tileID);
                return this.latestFeatureIndex.query(t1, {
                    tilespaceGeometry: i,
                    pixelPosMatrix: c,
                    transform: s,
                    availableImages: o,
                    tileTransform: this.tileTransform,
                    worldview: this.worldview,
                    queryRadius: l,
                    scope: a
                });
            }
            querySourceFeatures(t1, i) {
                const o = this.latestFeatureIndex;
                if (!o || !o.rawTileData) return;
                const s = o.loadVTLayers(), r = i ? i.sourceLayer : "", n = s._geojsonTileLayer || s[r];
                if (!n) return;
                const a = e.b7(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, d = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < n.length; i++){
                    const s = n.feature(i);
                    if (a.needGeometry) {
                        const t1 = e.b8(s, !0);
                        if (!a.filter(new e.ad(this.tileID.overscaledZ, {
                            worldview: this.worldview
                        }), t1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new e.ad(this.tileID.overscaledZ, {
                        worldview: this.worldview
                    }), s)) continue;
                    const u = o.getId(s, r), _ = new e.b9(s, l, c, h, u);
                    _.tile = d, t1.push(_);
                }
            }
            loaded() {
                return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e.ba(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = e + Math.max(o, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e, t1) {
                this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && e && this.updateBuckets(e, !1, t1);
            }
            hasAppearances(e) {
                for(const t1 in this.buckets)if (e.style.hasLayer(t1) && this.buckets[t1].layers.some((e)=>e.appearances && e.appearances.length > 0)) return !0;
                return !1;
            }
            updateBuckets(t1, i, o) {
                if (!this.latestFeatureIndex) return;
                if (!t1.style) return;
                const s = t1.style.listImages(), r = t1.style.getBrightness();
                for(const n in this.buckets){
                    if (!t1.style.hasLayer(n)) continue;
                    const a = this.buckets[n], l = a.layers[0], c = l.sourceLayer || "_geojsonTileLayer", h = t1.style.getLayerSourceCache(l);
                    let d = o && o[c] || {};
                    o || (d = h._state.getState(c, void 0));
                    const u = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, _ = Object.keys(d).length > 0 && !i;
                    a.hasAppearances = a.layers.some((e)=>e.appearances && e.appearances.length > 0);
                    const p = _ ? a.stateDependentLayers : a.layers;
                    if (_ && 0 !== a.stateDependentLayers.length || i) {
                        const e = this.latestFeatureIndex.loadVTLayers();
                        a.update(d, e[c], s, u, p, i, r);
                    }
                    if (_ && 0 !== a.stateDependentLayers.length || i || a.hasAppearances) {
                        const e = {
                            zoom: t1.transform.zoom,
                            pitch: t1.transform.pitch,
                            brightness: t1.style.getBrightness() || 0,
                            worldview: t1.worldview
                        };
                        a.updateAppearances(this.tileID.canonical, d, s, e, t1.imageManager);
                    }
                    (a instanceof e.bb || a instanceof e.bc) && t1._terrain && t1._terrain.enabled && h && a.uploadPending() && t1._terrain._clearRenderCacheForTile(h.id, this.tileID);
                    const f = t1 && t1.style && t1.style.getOwnLayer(n);
                    f && (this.queryPadding = Math.max(this.queryPadding, f.queryRadius(a)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e.o.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e.o.now() + t1;
            }
            setTexture(t1, i) {
                const o = i.context, s = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1) : (this.texture = new e.T(o, t1, s.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE));
            }
            setDependencies(e, t1) {
                const i = {};
                for (const e of t1)i[e] = !0;
                this.dependencies[e] = i;
            }
            hasDependency(e, t1) {
                for (const i of e){
                    const e = this.dependencies[i];
                    if (e) {
                        for (const i of t1)if (e[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const o = e.bd(Lt, this.tileID.canonical, this.tileTransform)[0], s = new e.be, r = new e.bf;
                for(let e = 0; e < o.length; e++){
                    const { x: t1, y: i } = o[e];
                    s.emplaceBack(t1, i), r.emplaceBack(e);
                }
                r.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(r), this._tileDebugBuffer = t1.createVertexBuffer(s, e.bg.members), this._tileDebugSegments = e.bh.simpleSegment(0, 0, s.length, r.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const o = e.bd(Lt, this.tileID.canonical, this.tileTransform)[0];
                let s, r;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const o = e.a_(t1, i), s = Math.pow(2, t1.z);
                        for(let r = 0; r < St; r++)for(let n = 0; n < St; n++){
                            const a = e.a$((t1.x + (n + Dt(n)) / Et) / s), l = e.b0((t1.y + (r + Dt(r)) / Et) / s), c = i.project(a, l), h = r * St + n;
                            Ct[2 * h + 0] = Math.round((c.x * o.scale - o.x) * e.am), Ct[2 * h + 1] = Math.round((c.y * o.scale - o.y) * e.am);
                        }
                        Rt.fill(0), At.fill(0);
                        for(let e = 2045; e >= 0; e--){
                            const t1 = 4 * e, i = It[t1 + 0], o = It[t1 + 1], s = It[t1 + 2], r = It[t1 + 3], n = i + s >> 1, a = o + r >> 1, l = n + a - o, c = a + i - n, h = o * St + i, d = r * St + s, u = a * St + n, _ = Math.hypot((Ct[2 * h + 0] + Ct[2 * d + 0]) / 2 - Ct[2 * u + 0], (Ct[2 * h + 1] + Ct[2 * d + 1]) / 2 - Ct[2 * u + 1]) >= 16;
                            Rt[u] = Rt[u] || (_ ? 1 : 0), e < 1022 && (Rt[u] = Rt[u] || Rt[(o + c >> 1) * St + (i + l >> 1)] || Rt[(r + c >> 1) * St + (s + l >> 1)]);
                        }
                        const r = new e.b2, n = new e.b1;
                        let a = 0;
                        function l(t1, i) {
                            const o = i * St + t1;
                            return 0 === At[o] && (r.emplaceBack(Ct[2 * o + 0], Ct[2 * o + 1], t1 * e.am / Et, i * e.am / Et), At[o] = ++a), At[o] - 1;
                        }
                        function c(e, t1, i, o, s, r) {
                            const a = e + i >> 1, h = t1 + o >> 1;
                            if (Math.abs(e - s) + Math.abs(t1 - r) > 1 && Rt[h * St + a]) c(s, r, e, t1, a, h), c(i, o, s, r, a, h);
                            else {
                                const a = l(e, t1), c = l(i, o), h = l(s, r);
                                n.emplaceBack(a, c, h);
                            }
                        }
                        return c(0, 0, Et, Et, Et, 0), c(Et, Et, 0, 0, 0, Et), {
                            vertices: r,
                            indices: n
                        };
                    }(this.tileID.canonical, i);
                    s = t1.vertices, r = t1.indices;
                } else {
                    s = new e.b2, r = new e.b1;
                    for (const { x: e, y: t1 } of o)s.emplaceBack(e, t1, 0, 0);
                    const t1 = e.bi(s.int16.subarray(0, 4 * s.length), void 0, 4);
                    for(let e = 0; e < t1.length; e += 3)r.emplaceBack(t1[e], t1[e + 1], t1[e + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(s, e.bj.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(r), this._tileBoundsSegments = e.bh.simpleSegment(0, 0, s.length, r.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const o = i.projection;
                if (!o || "globe" !== o.name || i.freezeTileCoverage) return;
                const s = this.tileID.canonical, r = e.bk(s, i), n = e.bl(r), a = e.ak(i.zoom);
                let l;
                a > 0 && (l = e.bm(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, s, i, n, l, a), this._makeGlobeTileDebugTextBuffer(t1, s, i, n, l, a);
            }
            _globePoint(t1, i, o, s, r, n, a) {
                let l = e.bn(t1, i, o);
                if (n) {
                    const r = 1 << o.z, c = e.aG(s.center.lng), h = e.aK(s.center.lat), d = (o.x + .5) / r - c;
                    let u = 0;
                    d > .5 ? u = -1 : d < -0.5 && (u = 1);
                    let _ = (t1 / e.am + o.x) / r + u, p = (i / e.am + o.y) / r;
                    _ = (_ - c) * s._pixelsPerMercatorPixel + c, p = (p - h) * s._pixelsPerMercatorPixel + h;
                    const f = [
                        _ * s.worldSize,
                        p * s.worldSize,
                        0
                    ];
                    e.ag(f, f, n), l = e.bo(l, f, a);
                }
                return e.ag(l, l, r);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, o, s, r, n) {
                const a = new e.be, l = new e.bf, c = new e.bp, h = (e, t1, h, d, u)=>{
                    const _ = (h - e) / (u - 1), p = (d - t1) / (u - 1), f = a.length;
                    for(let h = 0; h < u; h++){
                        const d = e + h * _, u = t1 + h * p;
                        a.emplaceBack(d, u);
                        const m = this._globePoint(d, u, i, o, s, r, n);
                        c.emplaceBack(m[0], m[1], m[2]), l.emplaceBack(f + h);
                    }
                }, d = e.am;
                h(0, 0, d, 0, 16), h(d, 0, d, d, 16), h(d, d, 0, d, 16), h(0, d, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(a, e.bg.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e.bq.members), this._tileDebugSegments = e.bh.simpleSegment(0, 0, a.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, o, s, r, n) {
                const a = e.am / 4, l = new e.be, c = new e.b1, h = new e.bp, d = 25;
                c.reserve(32), l.reserve(d), h.reserve(d);
                const u = (e, t1)=>d * e + t1;
                for(let e = 0; e < d; e++){
                    const t1 = e * a;
                    for(let e = 0; e < d; e++){
                        const c = e * a;
                        l.emplaceBack(c, t1);
                        const d = this._globePoint(c, t1, i, o, s, r, n);
                        h.emplaceBack(d[0], d[1], d[2]);
                    }
                }
                for(let e = 0; e < 4; e++)for(let t1 = 0; t1 < 4; t1++){
                    const i = u(e, t1), o = u(e, t1 + 1), s = u(e + 1, t1), r = u(e + 1, t1 + 1);
                    c.emplaceBack(i, o, s), c.emplaceBack(s, o, r);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e.bg.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e.bq.members), this._tileDebugTextSegments = e.bh.simpleSegment(0, 0, d, 32);
            }
            destroy(t1 = !0) {
                for(const e in this.buckets)this.buckets[e].destroy(t1);
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && delete this.imageAtlasTexture, this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), t1 && this.texture && this.texture instanceof e.T && (this.texture.destroy(), delete this.texture), this.emissiveTexture && this.emissiveTexture instanceof e.T && (this.emissiveTexture.destroy(), delete this.emissiveTexture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        e.bt.setPbf(e.bu);
        class Ot extends Pt {
            constructor(e, t1, i, o, s){
                super(e, t1, i, o, s), this._workQueuePerLayer = new Map, this._fetchQueuePerLayer = new Map, this._taskQueue = new Map, this._isHeaderLoaded = !1, this.textureDescriptorPerLayer = new Map, this.texturePerLayer = new Map;
            }
            getLayers() {
                return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e) {
                return this._mrt && this._mrt.getLayer(e);
            }
            setTexturePerLayer(t1, i, o) {
                const s = o.context, r = s.gl;
                let n = this.texturePerLayer.get(t1) || o.getTileTexture(i.width);
                n && n instanceof e.T ? n.update(i, {
                    premultiply: !1
                }) : n = new e.T(s, i, r.RGBA8, {
                    premultiply: !1
                }), this.texturePerLayer.has(t1) || this.texturePerLayer.set(t1, n);
            }
            flushQueues(e) {
                const t1 = this._workQueuePerLayer.get(e) || [], i = this._fetchQueuePerLayer.get(e) || [];
                for(; t1.length;)t1.pop()();
                for(; i.length;)i.pop()();
            }
            flushAllQueues() {
                for (const e of this._workQueuePerLayer.keys()){
                    const t1 = this._workQueuePerLayer.get(e) || [];
                    for(; t1.length;)t1.pop()();
                }
                for (const e of this._fetchQueuePerLayer.keys()){
                    const t1 = this._fetchQueuePerLayer.get(e) || [];
                    for(; t1.length;)t1.pop()();
                }
            }
            fetchHeader(t1 = 16384, i) {
                const o = this._mrt = new e.bt(30), s = Object.assign({}, this.requestParams, {
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                });
                return this.entireBuffer = null, this.request = e.bv(s, (e, s, r)=>{
                    if (e) i(e);
                    else try {
                        const e = o.getHeaderLength(s);
                        if (e > t1) return void (this.request = this.fetchHeader(e, i));
                        o.parseHeader(s), this._isHeaderLoaded = !0;
                        let n = 0;
                        for (const e of Object.values(o.layers))n = Math.max(n, e.dataIndex[e.dataIndex.length - 1].lastByte);
                        s.byteLength >= n && (this.entireBuffer = s), i(null, this.entireBuffer || s, r);
                    } catch (e) {
                        i(e);
                    }
                }), this.request;
            }
            fetchBandForRender(e, t1, i, o) {
                this.fetchBand(e, t1, i, (s)=>{
                    if (s) return void o(s);
                    this.updateTextureDescriptor(e, t1, i);
                    const r = this.textureDescriptorPerLayer.get(t1);
                    o(null, r ? r.img : null);
                });
            }
            fetchBand(t1, i, o, s, r = !0) {
                const n = this._mrt;
                if (!this._isHeaderLoaded || !n) return void s(new Error("Tile header is not ready"));
                const a = this.actor;
                if (!a) return void s(new Error("Can't fetch tile band without an actor"));
                let l;
                const c = e.C(String(o), e.C(this.tileID.key, t1));
                let h = this._taskQueue.get(c);
                h ? h.add(s) : (h = new Set, h.add(s), this._taskQueue.set(c, h));
                const d = (e, t1)=>{
                    l.complete(e, t1), e ? s(e) : (h.forEach((e)=>e(null, t1)), this._taskQueue.delete(c));
                }, u = (e, t1)=>{
                    if (e) return s(e);
                    const o = a.send("decodeRasterArray", {
                        type: "raster-array",
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        uid: this.uid,
                        buffer: t1,
                        task: l
                    }, d, void 0, !0);
                    if (null !== i) {
                        const e = this._workQueuePerLayer.get(i) || [];
                        e.push(()=>{
                            o && o.cancel(), l.cancel();
                        }), this._workQueuePerLayer.has(i) || this._workQueuePerLayer.set(i, e);
                    }
                };
                let _;
                try {
                    _ = n.getLayer(t1);
                } catch (e) {
                    if ("reloading" === this.state) return;
                    throw e;
                }
                if (!_) return void s(new Error(`Unknown sourceLayer "${t1}"`));
                if (_.hasDataForBand(o)) return h.forEach((e)=>e(null, null)), void this._taskQueue.delete(c);
                const p = _.getDataRange([
                    o
                ]);
                if (l = n.createDecodingTask(p), !l || l.tasks.length) {
                    if (null !== i && this.flushQueues(i), this.entireBuffer) u(null, this.entireBuffer.slice(p.firstByte, p.lastByte + 1));
                    else {
                        const t1 = Object.assign({}, this.requestParams, {
                            headers: {
                                Range: `bytes=${p.firstByte}-${p.lastByte}`
                            }
                        }), o = e.bv(t1, u);
                        if (null !== i) {
                            const e = this._fetchQueuePerLayer.get(i) || [];
                            e.push(()=>{
                                o.cancel(), l.cancel();
                            }), this._fetchQueuePerLayer.has(i) || this._fetchQueuePerLayer.set(i, e);
                        }
                    }
                }
            }
            updateNeeded(e, t1) {
                return (!this.textureDescriptorPerLayer.get(e) || this.textureDescriptorPerLayer.get(e).band !== t1 || this.refreshedUponExpiration) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i, o) {
                if (!this._mrt) return;
                const s = this._mrt.getLayer(t1);
                if (!s || !s.hasBand(o) || !s.hasDataForBand(o)) return;
                const { bytes: r, tileSize: n, buffer: a, offset: l, scale: c } = s.getBandView(o), h = n + 2 * a, d = new e.q({
                    width: h,
                    height: h
                }, r), u = this.texturePerLayer.get(i);
                u && u instanceof e.T && u.update(d, {
                    premultiply: !1
                }), this.textureDescriptorPerLayer.set(i, {
                    layer: t1,
                    band: o,
                    img: d,
                    buffer: a,
                    offset: l,
                    tileSize: n,
                    format: s.pixelFormat,
                    mix: [
                        c,
                        256 * c,
                        65536 * c,
                        16777216 * c
                    ]
                });
            }
            destroy(t1 = !1) {
                if (super.destroy(t1), delete this._mrt, !t1) for (const t1 of this.texturePerLayer.values())t1 && t1 instanceof e.T && t1.destroy();
                this.texturePerLayer.clear(), this.textureDescriptorPerLayer.clear(), this.fbo && (this.fbo.destroy(), delete this.fbo), delete this.request, delete this.requestParams, this._isHeaderLoaded = !1;
            }
        }
        class zt {
            constructor(e, t1){
                this.max = e, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e in this.data)for (const t1 of this.data[e])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e, t1, i) {
                const o = e.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const s = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (s.timeout = setTimeout(()=>{
                    this.remove(e, s);
                }, i)), this.data[o].push(s), this.order.push(o), this.order.length > this.max) {
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            has(e) {
                return e.wrapped().key in this.data;
            }
            getAndRemove(e) {
                return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
            }
            _getAndRemoveByKey(e) {
                const t1 = this.data[e].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e].length && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t1.value;
            }
            getByKey(e) {
                const t1 = this.data[e];
                return t1 ? t1[0].value : null;
            }
            get(e) {
                return this.has(e) ? this.data[e.wrapped().key][0].value : null;
            }
            remove(e, t1) {
                if (!this.has(e)) return this;
                const i = e.wrapped().key, o = void 0 === t1 ? 0 : this.data[i].indexOf(t1), s = this.data[i][o];
                return this.data[i].splice(o, 1), s.timeout && clearTimeout(s.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(s.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e) {
                for(this.max = e; this.order.length > this.max;){
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            filter(e) {
                const t1 = [];
                for(const i in this.data)for (const o of this.data[i])e(o.value) || t1.push(o);
                for (const e of t1)this.remove(e.value.tileID, e);
            }
        }
        class Mt {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e, t1, i) {
                const o = String(t1);
                if (this.stateChanges[e] = this.stateChanges[e] || {}, this.stateChanges[e][o] = this.stateChanges[e][o] || {}, Object.assign(this.stateChanges[e][o], i), null === this.deletedStates[e]) {
                    this.deletedStates[e] = {};
                    for(const t1 in this.state[e])t1 !== o && (this.deletedStates[e][t1] = null);
                } else if (this.deletedStates[e] && null === this.deletedStates[e][o]) {
                    this.deletedStates[e][o] = {};
                    for(const t1 in this.state[e][o])i[t1] || (this.deletedStates[e][o][t1] = null);
                } else for(const t1 in i)this.deletedStates[e] && this.deletedStates[e][o] && null === this.deletedStates[e][o][t1] && delete this.deletedStates[e][o][t1];
            }
            removeFeatureState(e, t1, i) {
                if (null === this.deletedStates[e]) return;
                const o = String(t1);
                if (this.deletedStates[e] = this.deletedStates[e] || {}, i && void 0 !== t1) null !== this.deletedStates[e][o] && (this.deletedStates[e][o] = this.deletedStates[e][o] || {}, this.deletedStates[e][o][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e] && this.stateChanges[e][o]) for(i in this.deletedStates[e][o] = {}, this.stateChanges[e][o])this.deletedStates[e][o][i] = null;
                    else this.deletedStates[e][o] = null;
                } else this.deletedStates[e] = null;
            }
            getState(e, t1) {
                const i = this.state[e] || {}, o = this.stateChanges[e] || {}, s = this.deletedStates[e];
                if (null === s) return {};
                if (void 0 !== t1) {
                    const e = String(t1), r = Object.assign({}, i[e], o[e]);
                    if (s) {
                        const e = s[t1];
                        if (null === e) return {};
                        for(const t1 in e)delete r[t1];
                    }
                    return r;
                }
                const r = Object.assign({}, i, o);
                if (s) for(const e in s)delete r[e];
                return r;
            }
            initializeTileState(e, t1) {
                e.refreshFeatureState(t1);
            }
            coalesceChanges(e, t1) {
                const i = {};
                for(const e in this.stateChanges){
                    this.state[e] = this.state[e] || {};
                    const t1 = {};
                    for(const i in this.stateChanges[e])this.state[e][i] || (this.state[e][i] = {}), Object.assign(this.state[e][i], this.stateChanges[e][i]), t1[i] = this.state[e][i];
                    i[e] = t1;
                }
                for(const e in this.deletedStates){
                    this.state[e] = this.state[e] || {};
                    const t1 = {};
                    if (null === this.deletedStates[e]) for(const i in this.state[e])t1[i] = {}, this.state[e][i] = {};
                    else for(const i in this.deletedStates[e]){
                        if (null === this.deletedStates[e][i]) this.state[e][i] = {};
                        else if (this.state[e][i]) for (const t1 of Object.keys(this.deletedStates[e][i]))delete this.state[e][i][t1];
                        t1[i] = this.state[e][i];
                    }
                    i[e] = i[e] || {}, Object.assign(i[e], t1);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(i).length) for(const o in e)e[o].refreshFeatureState(t1, i);
            }
        }
        class Ft extends e.E {
            constructor(e, t1, i){
                super(), this.id = e, this._onlySymbols = i, t1.on("data", (e)=>{
                    "source" === e.dataType && "metadata" === e.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e.dataType && "content" === e.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t1, this._tiles = {}, this._cache = new zt(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Mt, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "_dataType" in this._source && "raster" === this._source._dataType, this._supportsFading = "raster" === this._source.type || "raster-array" === this._source.type || "image" === this._source.type || "video" === this._source.type || "custom" === this._source.type, this._isRasterElevatedOverTerrain = !1;
            }
            onAdd(e) {
                this.map = e, this._minTileCacheSize = void 0 === this._minTileCacheSize && e ? e._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e ? e._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e in this._tiles)if (!this._tiles[e].loaded()) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e, t1) {
                return e.isSymbolTile = this._onlySymbols, e.isExtraShadowCaster = this._shadowCasterTiles[e.tileID.key], this._source.loadTile(e, t1);
            }
            _unloadTile(e) {
                if (this._source.unloadTile) return this._source.unloadTile(e);
            }
            _abortTile(e) {
                if (this._source.abortTile) return this._source.abortTile(e);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e, this.map ? this.map.painter : void 0), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e)=>e.tileID).sort(kt).map((e)=>e.key);
            }
            getRenderableIds(t1, i) {
                const o = [];
                for(const e in this._tiles)this._isIdRenderable(+e, t1, i) && o.push(this._tiles[e]);
                return t1 ? o.sort((t1, i)=>{
                    const o = t1.tileID, s = i.tileID, r = new e.P(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), n = new e.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - s.overscaledZ || n.y - r.y || n.x - r.x;
                }).map((e)=>e.tileID.key) : o.map((e)=>e.tileID).sort(kt).map((e)=>e.key);
            }
            hasRenderableParent(e) {
                const t1 = this.findLoadedParent(e, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e, t1, i) {
                return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t1 || !this._tiles[e].holdingForFade()) && (i || !this._shadowCasterTiles[e]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e in this._tiles)"errored" !== this._tiles[e].state && this._reloadTile(+e, "reloading");
                }
            }
            _reloadTile(e, t1) {
                const i = this._tiles[e];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e, t1)));
            }
            _tileLoaded(t1, i, o, s, r) {
                if (s) {
                    if (t1.state = "errored", 404 !== s.status) this._source.fire(new e.z(s, {
                        tile: t1
                    }));
                    else {
                        if (this._source.fire(new e.A("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e = this.map.painter.terrain;
                            this.update(this.transform, e.getScaledDemTileSize(), !0), e.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                    return;
                }
                t1.timeAdded = e.o.now(), "expired" === o && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null);
                let n = new Map;
                r && r.responseHeaders && (n = r.responseHeaders), this._source.fire(new e.A("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id,
                    responseHeaders: n
                }));
            }
            _backfillDEM(e) {
                const t1 = this.getRenderableIds();
                for(let o = 0; o < t1.length; o++){
                    const s = t1[o];
                    if (e.neighboringTiles && e.neighboringTiles[s]) {
                        const t1 = this.getTileByID(s);
                        i(e, t1), i(t1, e);
                    }
                }
                function i(e, t1) {
                    if (!e.dem || e.dem.borderReady) return;
                    e.needsHillshadePrepare = !0, e.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e.tileID.canonical.x;
                    const o = t1.tileID.canonical.y - e.tileID.canonical.y, s = Math.pow(2, e.tileID.canonical.z), r = t1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + s) ? i += s : 1 === Math.abs(i - s) && (i -= s)), t1.dem && e.dem && (e.dem.backfillBorder(t1.dem, i, o), e.neighboringTiles && e.neighboringTiles[r] && (e.neighboringTiles[r].backfilled = !0)));
                }
            }
            getTile(e) {
                return this.getTileByID(e.key);
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            _retainLoadedChildren(e, t1, i, o) {
                for(const s in this._tiles){
                    let r = this._tiles[s];
                    if (o[s] || !r.hasData() || r.tileID.overscaledZ <= t1 || r.tileID.overscaledZ > i) continue;
                    let n = r.tileID;
                    for(; r && r.tileID.overscaledZ > t1 + 1;){
                        const e = r.tileID.scaledTo(r.tileID.overscaledZ - 1);
                        r = this._tiles[e.key], r && r.hasData() && (n = e);
                    }
                    let a = n;
                    for(; a.overscaledZ > t1;)if (a = a.scaledTo(a.overscaledZ - 1), e[a.key]) {
                        o[n.key] = n;
                        break;
                    }
                }
            }
            findLoadedParent(e, t1) {
                if (e.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e.overscaledZ - 1; i >= t1; i--){
                    const t1 = e.scaledTo(i), o = this._getLoadedTile(t1);
                    if (o) return o;
                }
            }
            _getLoadedTile(e) {
                const t1 = this._tiles[e.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e.wrapped().key : e.canonical.key);
            }
            updateCacheSize(e, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e.width / t1) + 1, o = Math.ceil(e.height / t1) + 1, s = Math.floor(i * o * 5), r = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, s) : s, n = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                this._cache.setMaxSize(n);
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - (void 0 === this._prevLng ? e : this._prevLng)) / 360);
                if (this._prevLng = e, t1) {
                    const e = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t1), e[o.tileID.key] = o;
                    }
                    this._tiles = e;
                    for(const e in this._timers)clearTimeout(this._timers[e]), delete this._timers[e];
                    for(const e in this._tiles)this._setTileReloadTimer(+e, this._tiles[e]);
                }
            }
            update(t1, i, o, s, r) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !o) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const n = "batched-model" === this._source.type;
                let a, l = this._source.maxzoom;
                const c = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (c && c.sourceCache === this && c.attenuationRange()) {
                    const e = c.attenuationRange()[0], t1 = Math.floor(e) - Math.log2(c.getDemUpscale());
                    l > t1 && (l = t1);
                }
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e.aR(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const s = t1.clone();
                        s.tileCoverLift = this.tileCoverLift, a = s.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: l,
                            roundZoom: this._source.roundZoom && !o,
                            reparseOverscaled: this._source.reparseOverscaled,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: n
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e.aR(1, 0, 1, 0, 0)), a.push(new e.aR(1, 0, 1, 1, 0)), a.push(new e.aR(1, 0, 1, 0, 1)), a.push(new e.aR(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: l,
                        roundZoom: this._source.roundZoom && !o,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: n
                    }), this._source.hasTile) {
                        const e = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e(t1));
                    }
                } else a = [];
                if (a.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !this._supportsFading) {
                    const e = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !o
                    }), l = Math.min(e, this._source.maxzoom);
                    if (n) {
                        const e = t1.extendTileCover(a, l);
                        for (const t1 of e)a.push(t1);
                    } else if (r) {
                        const e = t1.extendTileCoverToNearPlane(a, this.transform.getFrustum(l), l);
                        for (const t1 of e)a.push(t1);
                    } else if (this.castsShadows && s) {
                        const e = t1.extendTileCover(a, l, s, 16);
                        for (const t1 of e)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const h = this._updateRetainedTiles(a);
                if (this._supportsFading && 0 !== a.length) {
                    const t1 = {}, i = {}, o = e.o.now(), s = Object.keys(h);
                    for (const e of s){
                        const s = h[e], r = this._tiles[e];
                        if (!r || void 0 !== r.fadeEndTime && r.fadeEndTime <= o) continue;
                        const n = this.findLoadedParent(s, Math.max(s.overscaledZ - Ft.maxOverzooming, this._source.minzoom));
                        n && (this._addTile(n.tileID), t1[n.tileID.key] = n.tileID), i[e] = s;
                    }
                    const r = a[a.length - 1].overscaledZ;
                    for(const e in this._tiles){
                        const t1 = this._tiles[e];
                        if (h[e] || !t1.hasData()) continue;
                        let o = t1.tileID;
                        for(; o.overscaledZ > r;){
                            o = o.scaledTo(o.overscaledZ - 1);
                            const s = this._tiles[o.key];
                            if (s && s.hasData() && i[o.key]) {
                                h[e] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e in t1)h[e] || (this._coveredTiles[e] = !0, h[e] = t1[e]);
                }
                for(const e in h)this._tiles[e].clearFadeHold();
                const d = e.bw(this._tiles, h);
                for (const e of d){
                    const t1 = this._tiles[e];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e in this._tiles)this._tiles[e].holdingForFade() && this._removeTile(+e);
            }
            _updateRetainedTiles(e) {
                const t1 = {};
                if (0 === e.length) return t1;
                const i = {}, o = e.reduce((e, t1)=>Math.min(e, t1.overscaledZ), 1 / 0), s = e[0].overscaledZ, r = Math.max(s - Ft.maxOverzooming, this._source.minzoom), n = Math.max(s + Ft.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e){
                    const e = this._addTile(i);
                    t1[i.key] = i, e.hasData() || o < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, o, n, t1);
                for (const o of e){
                    let e = this._tiles[o.key];
                    if (e.hasData()) continue;
                    if (o.canonical.z >= this._source.maxzoom) {
                        const e = o.children(this._source.maxzoom)[0], i = this.getTile(e);
                        if (i && i.hasData()) {
                            t1[e.key] = e;
                            continue;
                        }
                    } else {
                        const e = o.children(this._source.maxzoom);
                        if (t1[e[0].key] && t1[e[1].key] && t1[e[2].key] && t1[e[3].key]) continue;
                    }
                    let s = e.wasRequested();
                    for(let n = o.overscaledZ - 1; n >= r; --n){
                        const r = o.scaledTo(n);
                        if (i[r.key]) break;
                        if (i[r.key] = !0, e = this.getTile(r), !e && s && (e = this._addTile(r)), e && (t1[r.key] = r, s = e.wasRequested(), e.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e in this._tiles){
                    const t1 = [];
                    let i, o = this._tiles[e].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        t1.push(o.key);
                        const e = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(e), i) break;
                        o = e;
                    }
                    for (const e of t1)this._loadedParentTiles[e] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const o = Boolean(i);
                if (!o) {
                    const e = this.map ? this.map.painter : null, o = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? new Ot(t1, o, this.transform.tileZoom, e, this._isRaster) : new Pt(t1, o, this.transform.tileZoom, e, this._isRaster, this._source.worldview), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i.uses++, this._tiles[t1.key] = i, o || this._source.fire(new e.A("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e, t1) {
                e in this._timers && (clearTimeout(this._timers[e]), delete this._timers[e]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e] = setTimeout(()=>{
                    this._reloadTile(e, "expired"), delete this._timers[e];
                }, i));
            }
            _removeTile(e) {
                const t1 = this._tiles[e];
                t1 && (t1.uses--, delete this._tiles[e], this._timers[e] && (clearTimeout(this._timers[e]), delete this._timers[e]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e in this._tiles)this._removeTile(+e);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, o) {
                const s = [], r = this.transform;
                if (!r) return s;
                const n = "globe" === r.projection.name, a = e.aG(r.center.lng);
                for(const l in this._tiles){
                    const c = this._tiles[l];
                    if (o && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (n) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e.aB(a, ...Bt(t1, -1)) - a),
                                Math.abs(e.aB(a, ...Bt(t1, 1)) - a)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e.aB(a, ...Bt(t1, -1)) - a),
                                Math.abs(e.aB(a, ...Bt(t1, 0)) - a),
                                Math.abs(e.aB(a, ...Bt(t1, 1)) - a)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e of h){
                        const o = t1.containsTile(c, r, i, e);
                        o && s.push(o);
                    }
                }
                return s;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e) {
                return this._getRenderableCoordinates(e);
            }
            _getRenderableCoordinates(e, t1) {
                const i = this.getRenderableIds(e, t1).map((e)=>this._tiles[e].tileID), o = "globe" === this.transform.projection.name;
                for (const e of i)e.projMatrix = this.transform.calculateProjMatrix(e.toUnwrapped()), e.expandedProjMatrix = o ? this.transform.calculateProjMatrix(e.toUnwrapped(), !1, !0) : e.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e) {
                const t1 = e.slice(), i = this.transform._camera.position, o = this.transform._camera.forward(), s = {};
                for (const e of t1){
                    const t1 = 1 / (1 << e.canonical.z);
                    s[e.key] = ((e.canonical.x + .5) * t1 + e.wrap - i[0]) * o[0] + ((e.canonical.y + .5) * t1 - i[1]) * o[1] - i[2] * o[2];
                }
                return t1.sort((e, t1)=>s[e.key] - s[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (this._supportsFading) {
                    const t1 = e.o.now();
                    for(const e in this._tiles){
                        const i = this._tiles[e];
                        if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1) return !0;
                    }
                }
                return !1;
            }
            setFeatureState(e, t1, i) {
                this._state.updateState(e = e || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e, t1, i) {
                this._state.removeFeatureState(e = e || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e, t1) {
                return this._state.getState(e = e || "_geojsonTileLayer", t1);
            }
            setDependencies(e, t1, i) {
                const o = this._tiles[e];
                o && o.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e = ()=>{
                        this._sourceLoaded && (this._source.off("data", e), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e);
                }
                const o = new Map, s = Array.isArray(t1) ? t1 : [
                    t1
                ], r = this.map.painter.terrain, n = this.usedForTerrain && r ? r.getScaledDemTileSize() : this._source.tileSize;
                for (const e of s){
                    const t1 = e.coveringTiles({
                        tileSize: n,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e of t1)o.set(e.key, e);
                    this.usedForTerrain && e.updateElevation(!1);
                }
                const a = Array.from(o.values());
                e.bx(a, (e, t1)=>{
                    const i = new Pt(e, this._source.tileSize * e.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                    this._loadTile(i, (e)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e, i);
                    });
                }, i);
            }
        }
        function kt(e, t1) {
            const i = Math.abs(2 * e.wrap) - +(e.wrap < 0), o = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e.overscaledZ - t1.overscaledZ || o - i || t1.canonical.y - e.canonical.y || t1.canonical.x - e.canonical.x;
        }
        function Bt(e, t1) {
            const i = 1 << e.z;
            return [
                e.x / i + t1,
                (e.x + 1) / i + t1
            ];
        }
        Ft.maxOverzooming = 10, Ft.maxUnderzooming = 3;
        class Nt {
            constructor(e){
                this.style = e, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const o = this.style._mergedLayers[i];
                    if ("fill-extrusion" === o.type || "building" === o.type) this.layers.push({
                        layer: o,
                        visible: e,
                        visibilityChanged: t1
                    });
                    else if ("model" === o.type) {
                        const i = this.style.getLayerSource(o);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: o,
                            visible: e,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let o = !1;
                    "fill-extrusion" === i.type ? o = !i.isHidden(e) && i.paint.get("fill-extrusion-opacity") > 0 : "building" === i.type ? o = !i.isHidden(e) && i.paint.get("building-opacity") > 0 : "model" === i.type && (o = !i.isHidden(e) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !o && t1.visible, t1.visible = o;
                }
            }
            updateZOffset(e, t1) {
                this.currentBuildingBuckets = [];
                for (const e of this.layers){
                    const i = e.layer, o = this.style.getLayerSourceCache(i);
                    let s = 1;
                    "fill-extrusion" === i.type ? s = e.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i.type && (s = e.visible ? i.paint.get("building-vertical-scale") : 0);
                    let r = o ? o.getTile(t1) : null;
                    if (!r && o) for(const e in o._tiles){
                        const i = o._tiles[e];
                        if (t1.canonical.isChildOf(i.tileID.canonical)) {
                            r = i;
                            break;
                        }
                    }
                    this.currentBuildingBuckets.push({
                        bucket: r ? r.getBucket(i) : null,
                        tileID: r ? r.tileID : t1,
                        verticalScale: s
                    });
                }
                e.hasAnyZOffset = !1;
                let i = !1;
                for(let o = 0; o < e.symbolInstances.length; o++){
                    const s = e.symbolInstances.get(o), r = s.zOffset, n = this._getHeightAtTileOffset(t1, s.tileAnchorX, s.tileAnchorY);
                    s.zOffset = n !== Number.NEGATIVE_INFINITY ? n : r, i || r === s.zOffset || (i = !0), e.hasAnyZOffset || 0 === s.zOffset || (e.hasAnyZOffset = !0);
                }
                i && (e.zOffsetBuffersNeedUpload = !0, e.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(t1, i, o, s) {
                let r = i, n = o;
                if (t1.canonical.z !== s.canonical.z) {
                    const a = s.canonical, l = 1 / (1 << t1.canonical.z - a.z);
                    r = (i + t1.canonical.x * e.am) * l - a.x * e.am | 0, n = (o + t1.canonical.y * e.am) * l - a.y * e.am | 0;
                }
                return {
                    tileX: r,
                    tileY: n
                };
            }
            _getHeightAtTileOffset(e, t1, i) {
                let o, s;
                for(let r = 0; r < this.layers.length; ++r){
                    const n = this.layers[r].layer;
                    if ("fill-extrusion" !== n.type && "building" !== n.type) continue;
                    const { bucket: a, tileID: l, verticalScale: c } = this.currentBuildingBuckets[r];
                    if (!a) continue;
                    const { tileX: h, tileY: d } = this._mapCoordToOverlappingTile(e, t1, i, l), u = a.getHeightAtTileCoord(h, d);
                    u && void 0 !== u.height && (u.hidden ? o = u.height : s = Math.max(u.height * c, s || 0));
                }
                if (void 0 !== s) return s;
                for(let s = 0; s < this.layers.length; ++s){
                    const r = this.layers[s];
                    if ("model" !== r.layer.type || !r.visible) continue;
                    const { bucket: n, tileID: a } = this.currentBuildingBuckets[s];
                    if (!n) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e, t1, i, a), h = n.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== o ? Math.min(h.maxHeight, o) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        function Ut(t1, i) {
            const o = {};
            for(const e in t1)"ref" !== e && (o[e] = t1[e]);
            return e.by.forEach((e)=>{
                e in i && (o[e] = i[e]);
            }), o;
        }
        function jt(e) {
            e = e.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e.length; i++)t1[e[i].id] = e[i];
            for(let i = 0; i < e.length; i++)"ref" in e[i] && (e[i] = Ut(e[i], t1[e[i].ref]));
            return e;
        }
        const Vt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setSnow: "setSnow",
            setRain: "setRain",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            updateImport: "updateImport",
            addIconset: "addIconset",
            removeIconset: "removeIconset"
        };
        function Gt(e, t1, i) {
            i.push({
                command: Vt.addSource,
                args: [
                    e,
                    t1[e]
                ]
            });
        }
        function Ht(e, t1, i) {
            t1.push({
                command: Vt.removeSource,
                args: [
                    e
                ]
            }), i[e] = !0;
        }
        function qt(e, t1, i, o) {
            Ht(e, i, o), Gt(e, t1, i);
        }
        function Zt(t1, i, o) {
            let s;
            for(s in t1[o])if (t1[o].hasOwnProperty(s) && "data" !== s && !e.bz(t1[o][s], i[o][s])) return !1;
            for(s in i[o])if (i[o].hasOwnProperty(s) && "data" !== s && !e.bz(t1[o][s], i[o][s])) return !1;
            return !0;
        }
        function Wt(t1, i, o, s, r, n) {
            let a;
            for(a in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(a) && (e.bz(t1[a], i[a]) || o.push({
                command: n,
                args: [
                    s,
                    a,
                    i[a],
                    r
                ]
            }));
            for(a in i)i.hasOwnProperty(a) && !t1.hasOwnProperty(a) && (e.bz(t1[a], i[a]) || o.push({
                command: n,
                args: [
                    s,
                    a,
                    i[a],
                    r
                ]
            }));
        }
        function $t(e) {
            return e.id;
        }
        function Xt(e, t1) {
            return e[t1.id] = t1, e;
        }
        function Kt(t1, i, o) {
            const s = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e.aC(new Float32Array(16), t1.projMatrix, s);
        }
        function Yt(e, t1, i) {
            if (t1.projection.name === i.projection.name) return e.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), Kt(o, t1.getProjection(), e);
        }
        function Jt(e, t1, i) {
            return t1.name === i.projection.name ? e.projMatrix : Kt(i, t1, e);
        }
        class Qt {
            constructor(e, t1){
                this.reset(e, t1);
            }
            reset(e, t1) {
                this.points = e || [], this._distances = [
                    0
                ];
                for(let e = 1; e < this.points.length; e++)this._distances[e] = this._distances[e - 1] + this.points[e].dist(this.points[e - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e.aB(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const s = t1 * this.paddedLength + this.padding;
                for(; o < s && i < this._distances.length;)o = this._distances[++i];
                const r = i - 1, n = this._distances[r], a = o - n, l = a > 0 ? (s - n) / a : 0;
                return this.points[r].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        class ei {
            constructor(e, t1, i){
                const o = this.boxCells = [], s = this.circleCells = [];
                this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e = 0; e < this.xCellCount * this.yCellCount; e++)o.push([]), s.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t1, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e, t1, i, o, s) {
                this._forEachCell(t1, i, o, s, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(s);
            }
            insertCircle(e, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e, t1, i, o, s, r) {
                this.boxCells[s].push(r);
            }
            _insertCircleCell(e, t1, i, o, s, r) {
                this.circleCells[s].push(r);
            }
            _query(e, t1, i, o, s, r) {
                if (i < 0 || e > this.width || o < 0 || t1 > this.height) return !s && [];
                const n = [];
                if (e <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (s) return !0;
                    for(let e = 0; e < this.boxKeys.length; e++)n.push({
                        key: this.boxKeys[e],
                        x1: this.bboxes[4 * e],
                        y1: this.bboxes[4 * e + 1],
                        x2: this.bboxes[4 * e + 2],
                        y2: this.bboxes[4 * e + 3]
                    });
                    for(let e = 0; e < this.circleKeys.length; e++){
                        const t1 = this.circles[3 * e], i = this.circles[3 * e + 1], o = this.circles[3 * e + 2];
                        n.push({
                            key: this.circleKeys[e],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return r ? n.filter(r) : n;
                }
                return this._forEachCell(e, t1, i, o, this._queryCell, n, {
                    hitTest: s,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), s ? n.length > 0 : n;
            }
            _queryCircle(e, t1, i, o, s) {
                const r = e - i, n = e + i, a = t1 - i, l = t1 + i;
                if (n < 0 || r > this.width || l < 0 || a > this.height) return !o && [];
                const c = [];
                return this._forEachCell(r, a, n, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s), o ? c.length > 0 : c;
            }
            query(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !1, s);
            }
            hitTest(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !0, s);
            }
            hitTestCircle(e, t1, i, o) {
                return this._queryCircle(e, t1, i, !0, o);
            }
            _queryCell(e, t1, i, o, s, r, n, a) {
                const l = n.seenUids, c = this.boxCells[s];
                if (null !== c) {
                    const s = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e <= s[c + 2] && t1 <= s[c + 3] && i >= s[c + 0] && o >= s[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (n.hitTest) return r.push(!0), !0;
                            r.push({
                                key: this.boxKeys[h],
                                x1: s[c],
                                y1: s[c + 1],
                                x2: s[c + 2],
                                y2: s[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[s];
                if (null !== h) {
                    const s = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(s[h], s[h + 1], s[h + 2], e, t1, i, o) && (!a || a(this.circleKeys[c]))) {
                            if (n.hitTest) return r.push(!0), !0;
                            {
                                const e = s[h], t1 = s[h + 1], i = s[h + 2];
                                r.push({
                                    key: this.circleKeys[c],
                                    x1: e - i,
                                    y1: t1 - i,
                                    x2: e + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e, t1, i, o, s, r, n, a) {
                const l = n.circle, c = n.seenUids, h = this.boxCells[s];
                if (null !== h) {
                    const e = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e[i + 0], e[i + 1], e[i + 2], e[i + 3]) && (!a || a(this.boxKeys[t1]))) return r.push(!0), !0;
                    }
                }
                const d = this.circleCells[s];
                if (null !== d) {
                    const e = this.circles;
                    for (const t1 of d)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e[i], e[i + 1], e[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t1]))) return r.push(!0), !0;
                    }
                }
            }
            _forEachCell(e, t1, i, o, s, r, n, a) {
                const l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), d = this._convertToYCellCoord(o);
                for(let u = l; u <= h; u++)for(let l = c; l <= d; l++)if (s.call(this, e, t1, i, o, this.xCellCount * l + u, r, n, a)) return;
            }
            _convertToXCellCoord(e) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
            }
            _convertToYCellCoord(e) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
            }
            _circlesCollide(e, t1, i, o, s, r) {
                const n = o - e, a = s - t1, l = i + r;
                return l * l > n * n + a * a;
            }
            _circleAndRectCollide(e, t1, i, o, s, r, n) {
                const a = (r - o) / 2, l = Math.abs(e - (o + a));
                if (l > a + i) return !1;
                const c = (n - s) / 2, h = Math.abs(t1 - (s + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const d = l - a, u = h - c;
                return d * d + u * u <= i * i;
            }
        }
        const ti = Math.tan(85 * Math.PI / 180);
        function ii(t1, i, o, s, r, n, a) {
            const l = e.bD();
            if (o) {
                if ("globe" === n.name) {
                    const t1 = e.bE(r, i);
                    e.aC(l, l, t1);
                } else {
                    const t1 = e.bF([], a);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], s || e.bC(l, l, r.angle);
                }
            } else e.aC(l, r.labelPlaneMatrix, t1);
            return l;
        }
        function oi(e, t1, i, o, s, r, n) {
            const a = ii(e, t1, i, o, s, r, n);
            return "globe" === r.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function si(t1, i, o, s, r, n, a) {
            if (o) {
                if ("globe" === n.name) {
                    const l = ii(t1, i, o, s, r, n, a);
                    return e.bm(l, l), e.aC(l, t1, l), l;
                }
                {
                    const i = e.bA(t1), o = e.bB([]);
                    return o[0] = a[0], o[1] = a[1], o[4] = a[2], o[5] = a[3], e.aC(i, i, o), s || e.bC(i, i, -r.angle), i;
                }
            }
            return r.glCoordMatrix;
        }
        function ri(t1, i, o, s) {
            const r = [
                t1,
                i,
                o,
                1
            ];
            o ? e.aD(r, r, s) : mi(r, r, s);
            const n = r[3];
            return r[0] /= n, r[1] /= n, r[2] /= n, r;
        }
        function ni(e, t1) {
            return Math.min(.5 + e / t1 * .5, 1.5);
        }
        function ai(e, t1) {
            const i = e[0] / e[3], o = e[1] / e[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function li(t1, i, o, s, r, n, a, l, c, h, d = 1) {
            const u = o.transform, _ = s ? t1.textSizeData : t1.iconSizeData, p = e.bL(_, o.transform.zoom, d), f = "globe" === u.projection.name, m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], g = s ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            g.clear();
            let v = null;
            f && (v = s ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const y = t1.lineVertexArray, x = s ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, b = o.transform.width / o.transform.height;
            let w, T = !1;
            for(let s = 0; s < x.length; s++){
                const d = x.get(s), { numGlyphs: f, writingMode: E } = d;
                if (E !== e.bM.vertical || T || w === e.bM.horizontal || (T = !0), w = E, (d.hidden || E === e.bM.vertical) && !T) {
                    fi(f, g);
                    continue;
                }
                T = !1;
                const S = new e.P(d.tileAnchorX, d.tileAnchorY), I = "road" === t1.elevationType, C = !!u.elevation || I;
                let { x: R, y: A, z: D } = u.projection.projectTilePoint(S.x, S.y, h.canonical), L = null;
                if (C) {
                    const e = I ? t1.getElevationFeatureForText(s) : null;
                    L = {
                        getElevation: c,
                        elevation: u.elevation,
                        elevationFeature: e
                    };
                    const [i, o, r] = c(S, u.elevation, e);
                    R += i, A += o, D += r;
                }
                const P = [
                    R,
                    A,
                    D,
                    1
                ];
                if (e.aD(P, P, i), !ai(P, m)) {
                    fi(f, g);
                    continue;
                }
                const O = P[3], z = ni(o.transform.getCameraToCenterDistance(u.projection), O), M = e.bN(_, p, d), F = a ? M / z : M * z, k = ri(R, A, D, r);
                if (k[3] <= 0) {
                    fi(f, g);
                    continue;
                }
                let B = {};
                const N = e.ao(t1.layers[0].layout.get("text-max-angle")), U = Math.cos(N), j = a ? null : L, V = di(d, F, !1, l, i, r, n, t1.glyphOffsetArray, y, g, v, k, S, B, b, j, u.projection, h, a, U);
                T = V.useVertical, j && V.needsFlipping && (B = {}), (V.notEnoughRoom || T || V.needsFlipping && di(d, F, !0, l, i, r, n, t1.glyphOffsetArray, y, g, v, k, S, B, b, j, u.projection, h, a, U).notEnoughRoom) && fi(f, g);
            }
            s ? (t1.text.dynamicLayoutVertexBuffer.updateData(g), v && t1.text.globeExtVertexBuffer && t1.text.globeExtVertexBuffer.updateData(v)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(g), v && t1.icon.globeExtVertexBuffer && t1.icon.globeExtVertexBuffer.updateData(v));
        }
        function ci(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m) {
            const { lineStartIndex: g, glyphStartIndex: v, segment: y } = a, x = v + a.numGlyphs, b = g + a.lineLength, w = t1.getoffsetX(v), T = t1.getoffsetX(x - 1), E = pi(e * w, i, o, s, r, n, y, g, b, l, c, h, d, u, !0, _, p, f, m);
            if (!E) return null;
            const S = pi(e * T, i, o, s, r, n, y, g, b, l, c, h, d, u, !0, _, p, f, m);
            return S ? {
                first: E,
                last: S
            } : null;
        }
        function hi(t1, i, o, s) {
            return t1 === e.bM.horizontal && Math.abs(s) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e.bM.vertical ? s > 0 ? {
                needsFlipping: !0
            } : null : 0 !== i && function(e, t1) {
                return 0 === e || Math.abs(t1 / e) > ti;
            }(o, s) ? 1 === i ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function di(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x) {
            const b = i / 24, w = t1.lineOffsetX * b, T = t1.lineOffsetY * b, { lineStartIndex: E, glyphStartIndex: S, numGlyphs: I, segment: C, writingMode: R, flipState: A } = t1, D = E + t1.lineLength, L = (t1)=>{
                if (d) {
                    const [i, o, s] = t1.up, r = h.length;
                    e.bO(d, r + 0, i, o, s), e.bO(d, r + 1, i, o, s), e.bO(d, r + 2, i, o, s), e.bO(d, r + 3, i, o, s);
                }
                const [i, o, s] = t1.point;
                e.bP(h, i, o, s, t1.angle);
            };
            if (I > 1) {
                const e = ci(b, l, w, T, o, u, _, t1, c, n, p, m, !1, g, v, y, x);
                if (!e) return {
                    notEnoughRoom: !0
                };
                if (s && !o) {
                    let [i, o, s] = e.first.point, [r, n, l] = e.last.point;
                    [i, o] = ri(i, o, s, a), [r, n] = ri(r, n, l, a);
                    const c = hi(R, A, (r - i) * f, n - o);
                    if (t1.flipState = c && c.needsFlipping ? 1 : 2, c) return c;
                }
                L(e.first);
                for(let e = S + 1; e < S + I - 1; e++){
                    const t1 = pi(b * l.getoffsetX(e), w, T, o, u, _, C, E, D, c, n, p, m, !1, !1, g, v, y, x);
                    if (!t1) return h.length -= 4 * (e - S), {
                        notEnoughRoom: !0
                    };
                    L(t1);
                }
                L(e.last);
            } else {
                if (s && !o) {
                    const i = ri(_.x, _.y, 0, r), o = E + C + 1, s = new e.P(c.getx(o), c.gety(o)), n = ri(s.x, s.y, 0, r), a = n[3] > 0 ? n : _i(_, s, i, 1, r, void 0, g, v.canonical), l = hi(R, A, (a[0] - i[0]) * f, a[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? 1 : 2, l) return l;
                }
                const i = pi(b * l.getoffsetX(S), w, T, o, u, _, C, E, D, c, n, p, m, !1, !1, g, v, y, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                L(i);
            }
            return {};
        }
        function ui(e, t1, i, o, s) {
            const { x: r, y: n, z: a } = o.projectTilePoint(e.x, e.y, t1);
            if (!s) return ri(r, n, a, i);
            const [l, c, h] = s.getElevation(e, s.elevation, s.elevationFeature);
            return ri(r + l, n + c, a + h, i);
        }
        function _i(t1, i, o, s, r, n, a, l) {
            const c = ui(t1.sub(i)._unit()._add(t1), l, r, a, n);
            return e.aw(c, o, c), e.ax(c, c), e.bI(c, o, c, s);
        }
        function pi(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y) {
            const x = s ? t1 - i : t1 + i;
            let b = x > 0 ? 1 : -1, w = 0;
            s && (b *= -1, w = Math.PI), b < 0 && (w += Math.PI);
            let T = l + a + (b > 0 ? 0 : 1) | 0, E = r, S = r, I = 0, C = 0;
            const R = Math.abs(x), A = [], D = [];
            let L = n, P = L, O = e.bG([]);
            const z = ()=>_i(P, L, S, R - I + 1, d, _, m, g.canonical);
            for(; I + C <= R;){
                if (T += b, T < l || T >= c) return null;
                if (S = E, P = L, A.push(S), p && D.push(P), L = new e.P(h.getx(T), h.gety(T)), E = u[T], !E) {
                    const e = ui(L, g.canonical, d, m, _);
                    E = e[3] > 0 ? u[T] = e : z();
                }
                I += C;
                const t1 = e.aw([], E, S), i = e.bH(S, E);
                if (o && i > 0 && C > 0 && e.bK(O, t1) / (C * i) < y) return null;
                C = i, O = t1;
            }
            f && _ && (u[T] && (E = z(), C = e.bH(S, E), O = e.aw([], E, S)), u[T] = E);
            const M = (R - I) / C, F = L.sub(P)._mult(M)._add(P), k = e.bI([], S, O, M);
            let B = [
                0,
                0,
                1
            ], N = O[0], U = O[1];
            if (v && (B = m.upVector(g.canonical, F.x, F.y), 0 !== B[0] || 0 !== B[1] || 1 !== B[2])) {
                const t1 = [
                    B[2],
                    0,
                    -B[0]
                ], i = e.bJ([], B, t1);
                e.ax(t1, t1), e.ax(i, i), N = e.bK(O, t1), U = e.bK(O, i);
            }
            if (o) {
                const t1 = e.bJ([], B, O);
                e.ax(t1, t1), e.bI(k, k, t1, o * b);
            }
            const j = w + Math.atan2(U, N);
            return A.push(k), p && D.push(F), {
                point: k,
                angle: j,
                path: A,
                tilePath: D,
                up: B
            };
        }
        function fi(e, t1) {
            const i = t1.length, o = i + 4 * e;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function mi(e, t1, i) {
            const o = t1[0], s = t1[1];
            return e[0] = i[0] * o + i[4] * s + i[12], e[1] = i[1] * o + i[5] * s + i[13], e[3] = i[3] * o + i[7] * s + i[15], e;
        }
        const gi = 100;
        class vi {
            constructor(e, t1, i = new ei(e.width + 200, e.height + 200, 25), o = new ei(e.width + 200, e.height + 200, 25)){
                this.transform = e, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + gi, this.screenBottomBoundary = e.height + gi, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.fogState = t1;
            }
            placeCollisionBox(t1, i, o, s, r, n, a, l, c, h, d) {
                let u = o.projectedAnchorX, _ = o.projectedAnchorY, p = o.projectedAnchorZ;
                const f = o.tileAnchorX, m = o.tileAnchorY, g = o.elevation, v = o.tileID, y = t1.getProjection();
                if (g && v) {
                    const [e, t1, i] = y.upVector(v.canonical, o.tileAnchorX, o.tileAnchorY), s = y.upVectorScale(v.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    u += e * g * s, _ += t1 * g * s, p += i * g * s;
                }
                const x = "globe" === t1.projection.name, b = "globe" === t1.projection.name ? e.ak(this.transform.zoom) : 0;
                if (v && x && b < 1 && !n) {
                    const t1 = 1 << v.canonical.z, i = e.bQ(f, m);
                    e.bR(i, i, 1 / e.am), e.bS(i, i, e.bQ(v.canonical.x, v.canonical.y)), e.bR(i, i, 1 / t1), e.bT(i, i, e.bQ(s[0], s[1])), i[0] = e.bU(i[0], -0.5, .5), e.bR(i, i, e.am);
                    const o = e.bV(i[0], i[1], e.am / (2 * Math.PI), 1);
                    e.aD(o, o, r), u = e.al(u, o[0], b), _ = e.al(_, o[1], b), p = e.al(p, o[2], b);
                }
                const w = this.projectAndGetPerspectiveRatio(h, u, _, p, o.tileID, "globe" === y.name || !!g || this.transform.pitch > 0, y), T = c * w.perspectiveRatio, E = (o.x1 * i + a.x - o.padding) * T + w.point.x, S = (o.y1 * i + a.y - o.padding) * T + w.point.y, I = (o.x2 * i + a.x + o.padding) * T + w.point.x, C = (o.y2 * i + a.y + o.padding) * T + w.point.y, R = w.perspectiveRatio <= .55 || w.occluded;
                return !this.isInsideGrid(E, S, I, C) || !l && this.grid.hitTest(E, S, I, C, d) || R ? {
                    box: [],
                    offscreen: !1,
                    occluded: w.occluded
                } : {
                    box: [
                        E,
                        S,
                        I,
                        C
                    ],
                    offscreen: this.isOffscreen(E, S, I, C),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m) {
                const g = [], v = this.transform.elevation, y = t1.getProjection(), x = "road" === t1.elevationType, b = !!v || x, w = e.bW.getAtTileOffsetFunc(m, this.transform.center.lat, this.transform.worldSize, y), T = new e.P(o.tileAnchorX, o.tileAnchorY), E = new e.P(o.tileAnchorX, o.tileAnchorY);
                let { x: S, y: I, z: C } = y.projectTilePoint(E.x, E.y, m.canonical), R = null;
                if (b) {
                    const e = x ? t1.getElevationFeatureForText(s) : null;
                    R = {
                        getElevation: w,
                        elevation: v,
                        elevationFeature: e
                    };
                    const [i, o, r] = w(T, v, e);
                    S += i, I += o, C += r;
                }
                const A = "globe" === y.name, D = this.projectAndGetPerspectiveRatio(l, S, I, C, m, A || !!v || this.transform.pitch > 0, y), { perspectiveRatio: L } = D, P = (u ? a / L : a * L) / e.bZ, O = ri(S, I, C, c), z = o.lineOffsetX * P, M = o.lineOffsetY * P, F = e.ao(t1.layers[0].layout.get("text-max-angle")), k = Math.cos(F), B = D.signedDistanceFromCamera > 0 ? ci(P, n, z, M, x && 1 === o.flipState, O, E, o, r, c, {}, b && !u ? R : null, u && b, y, m, u, k) : null;
                let N = !1, U = !1, j = !0;
                if (B && !D.occluded) {
                    const t1 = .5 * p * L + f, o = new e.P(-100, -100), s = new e.P(this.screenRightBoundary, this.screenBottomBoundary), r = new Qt, { first: n, last: a } = B, l = n.path.length;
                    let c = [];
                    for(let e = l - 1; e >= 1; e--)c.push(n.path[e]);
                    for(let e = 1; e < a.path.length; e++)c.push(a.path[e]);
                    const u = 2.5 * t1;
                    h && (c = c.map(([e, t1, i], o)=>(b && !A && (i = w(o < l - 1 ? n.tilePath[l - 1 - o] : a.tilePath[o - l + 2], v, R.elevationFeature)[2]), ri(e, t1, i, h))), c.some((e)=>e[3] <= 0) && (c = []));
                    let m = [];
                    if (c.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, r = 1 / 0, n = -1 / 0;
                        for (const e of c)t1 = Math.min(t1, e[0]), r = Math.min(r, e[1]), i = Math.max(i, e[0]), n = Math.max(n, e[1]);
                        i >= o.x && t1 <= s.x && n >= o.y && r <= s.y && (m = [
                            c.map((t1)=>new e.P(t1[0], t1[1]))
                        ], (t1 < o.x || i > s.x || r < o.y || n > s.y) && (m = e.bX(m, o.x, o.y, s.x, s.y)));
                    }
                    for (const e of m){
                        r.reset(e, .25 * t1);
                        let o = 0;
                        o = r.length <= .5 * t1 ? 1 : Math.ceil(r.paddedLength / u) + 1;
                        for(let e = 0; e < o; e++){
                            const s = e / Math.max(o - 1, 1), n = r.lerp(s), a = n.x + gi, l = n.y + gi;
                            g.push(a, l, t1, 0);
                            const c = a - t1, h = l - t1, u = a + t1, p = l + t1;
                            if (j = j && this.isOffscreen(c, h, u, p), U = U || this.isInsideGrid(c, h, u, p), !i && this.grid.hitTestCircle(a, l, t1, _) && (N = !0, !d)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: N,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !d && N || !U ? [] : g,
                    offscreen: j,
                    collisionDetected: N,
                    occluded: D.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, s = 1 / 0, r = -1 / 0, n = -1 / 0;
                for (const a of t1){
                    const t1 = new e.P(a.x + gi, a.y + gi);
                    o = Math.min(o, t1.x), s = Math.min(s, t1.y), r = Math.max(r, t1.x), n = Math.max(n, t1.y), i.push(t1);
                }
                const a = this.grid.query(o, s, r, n).concat(this.ignoredGrid.query(o, s, r, n)), l = {}, c = {};
                for (const t1 of a){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const s = [
                        new e.P(t1.x1, t1.y1),
                        new e.P(t1.x2, t1.y1),
                        new e.P(t1.x2, t1.y2),
                        new e.P(t1.x1, t1.y2)
                    ];
                    e.bY(i, s) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e, t1, i, o, s) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                }, e[0], e[1], e[2], e[3]);
            }
            insertCollisionCircles(e, t1, i, o, s) {
                const r = t1 ? this.ignoredGrid : this.grid, n = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                };
                for(let t1 = 0; t1 < e.length; t1 += 4)r.insertCircle(n, e[t1], e[t1 + 1], e[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, s, r, n, a) {
                const l = [
                    i,
                    o,
                    s,
                    1
                ];
                let c = !1;
                if (s || this.transform.pitch > 0) {
                    if (e.aD(l, l, t1), this.fogState && r && "globe" !== a.name) {
                        const t1 = function(t1, i, o, s, r, n) {
                            const a = n.calculateFogTileMatrix(r), l = [
                                i,
                                o,
                                s
                            ];
                            return e.ag(l, l, a), Ge(t1, e.ah(l), n.pitch, n._fov);
                        }(this.fogState, i, o, s, r.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else mi(l, l, t1);
                const h = l[3];
                return {
                    point: new e.P((l[0] / h + 1) / 2 * this.transform.width + gi, (-l[1] / h + 1) / 2 * this.transform.height + gi),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: n && l[2] > h || c
                };
            }
            isOffscreen(e, t1, i, o) {
                return i < gi || e >= this.screenRightBoundary || o < gi || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e, t1, i, o) {
                return i >= 0 && e < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e.bB([]);
                return e.bs(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        class yi {
            constructor(e, t1, i, o){
                this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class xi {
            constructor(e, t1, i, o, s, r = !1){
                this.text = new yi(e ? e.text : null, t1, i, s), this.icon = new yi(e ? e.icon : null, t1, o, s), this.clipped = r;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class bi {
            constructor(e, t1, i, o = !1){
                this.text = e, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class wi {
            constructor(){
                this.invProjMatrix = e.bD(), this.viewportMatrix = e.bD(), this.circles = [];
            }
        }
        class Ti {
            constructor(e, t1, i, o, s){
                this.bucketInstanceId = e, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = s;
            }
        }
        class Ei {
            constructor(e){
                this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e] = {
                        ID: t1,
                        predicate: (e)=>e.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e];
            }
        }
        function Si(t1, i, o, s, r) {
            const { horizontalAlign: n, verticalAlign: a } = e.c2(t1), l = -(n - .5) * i, c = -(a - .5) * o, h = e.c3(t1, s);
            return new e.P(l + h[0] * r, c + h[1] * r);
        }
        function Ii(t1, i, o, s, r) {
            const n = new e.P(t1, i);
            return o && n._rotate(s ? r : -r), n;
        }
        class Ci {
            constructor(e, t1, i, o, s, r){
                this.transform = e.clone(), this.projection = e.projection.name, this.collisionIndex = new vi(this.transform, s), this.buildingIndex = r, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new Ei(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {}, this.lastReplacementSourceUpdateTime = 0;
            }
            getBucketParts(t1, i, o, s, r = 1) {
                const n = o.getBucket(i), a = o.latestFeatureIndex;
                if (!n || !a || i.fqid !== n.layerIds[0]) return;
                const l = n.layers[0].layout, c = n.layers[0].paint, h = o.collisionBoxArray, d = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), u = o.tileSize / e.am, _ = o.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const p = (f = o.tileID, m = n.getProjection(), g = this.transform, m.name === this.projection ? g.calculateProjMatrix(f.toUnwrapped()) : Kt(g, m, f));
                var f, m, g;
                const v = "map" === l.get("text-pitch-alignment"), y = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const x = i.dynamicFilter(), b = i.dynamicFilterNeedsFeature(), w = i.dynamicFilterNeedsGeometry(), T = this.transform.calculatePixelsToTileUnitsMatrix(o), E = oi(p, o.tileID.canonical, v, y, this.transform, n.getProjection(), T);
                let S = null;
                const I = n.getProjection().createInversionMatrix(this.transform, o.tileID.canonical);
                if (v) {
                    const t1 = si(p, o.tileID.canonical, v, y, this.transform, n.getProjection(), T);
                    S = e.aC([], this.transform.labelPlaneMatrix, t1);
                }
                let C = null;
                x && o.latestFeatureIndex && (C = {
                    unwrappedTileID: _,
                    dynamicFilter: x,
                    dynamicFilterNeedsFeature: b,
                    needGeometry: w
                }), this.retainedQueryData[n.bucketInstanceId] = new Ti(n.bucketInstanceId, a, n.sourceLayerIndex, n.index, o.tileID);
                const [R, A] = n.layers[0].layout.get("text-size-scale-range"), D = e.aB(r, R, A), [L, P] = l.get("icon-size-scale-range"), O = e.aB(r, L, P), z = {
                    bucket: n,
                    layout: l,
                    paint: c,
                    posMatrix: p,
                    invMatrix: I,
                    mercatorCenter: [
                        e.aG(this.transform.center.lng),
                        e.aK(this.transform.center.lat)
                    ],
                    textLabelPlaneMatrix: E,
                    labelToScreenMatrix: S,
                    clippingData: C,
                    scale: d,
                    textPixelRatio: u,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e.bL(n.textSizeData, this.transform.zoom, D),
                    partiallyEvaluatedIconSize: e.bL(n.iconSizeData, this.transform.zoom, O),
                    collisionGroup: this.collisionGroups.get(n.sourceID),
                    latestFeatureIndex: o.latestFeatureIndex
                };
                if (s) for (const e of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: s } = e;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: s,
                        parameters: z
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: z
                });
            }
            attemptAnchorPlacement(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x) {
                const { textOffset0: b, textOffset1: w, crossTileID: T } = p, E = [
                    b,
                    w
                ], S = Si(e, r, n, E, a), I = this.collisionIndex.placeCollisionBox(m, a, t1, i, o, s, Ii(S.x, S.y, l, c, this.transform.angle), _, h, d, u.predicate);
                if (v) {
                    const e = m.getSymbolInstanceIconSize(x, this.transform.zoom, p.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(m, e, v, i, o, s, Ii(S.x, S.y, l, c, this.transform.angle), _, h, d, u.predicate).box.length) return;
                }
                if (I.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[T] && this.prevPlacement.placements[T] && this.prevPlacement.placements[T].text && (t1 = this.prevPlacement.variableOffsets[T].anchor), this.variableOffsets[T] = {
                        textOffset: E,
                        width: r,
                        height: n,
                        anchor: e,
                        textScale: a,
                        prevAnchor: t1
                    }, this.markUsedJustification(m, e, p, g), m.allowVerticalPlacement && (this.markUsedOrientation(m, g, p), this.placedOrientations[T] = g), {
                        shift: S,
                        placedGlyphBoxes: I
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, s, r = 1) {
                const { bucket: n, layout: a, paint: l, posMatrix: c, textLabelPlaneMatrix: h, labelToScreenMatrix: d, clippingData: u, textPixelRatio: _, mercatorCenter: p, invMatrix: f, holdingForFade: m, collisionBoxArray: g, partiallyEvaluatedTextSize: v, partiallyEvaluatedIconSize: y, collisionGroup: x, latestFeatureIndex: b } = t1.parameters, w = a.get("text-optional"), T = a.get("icon-optional"), E = a.get("text-allow-overlap"), S = a.get("icon-allow-overlap"), I = "map" === a.get("text-rotation-alignment"), C = "map" === a.get("icon-rotation-alignment"), R = "map" === a.get("text-pitch-alignment"), A = l.get("symbol-z-offset"), D = "sea" === a.get("symbol-elevation-reference"), L = a.get("symbol-placement"), [P, O] = a.get("text-size-scale-range"), [z, M] = a.get("icon-size-scale-range"), F = e.aB(r, P, O), k = e.aB(r, z, M), B = a.get("text-variable-anchor"), N = I && "point" !== L, U = C && "point" !== L, j = B && n.hasTextData(), V = n.hasIconTextFit() && j && n.hasIconData();
                this.transform.setProjection(n.projection);
                const G = j || N, H = U || V;
                let q = E && (S || !n.hasIconData() || T), Z = S && (E || !n.hasTextData() || w);
                const W = !A.isConstant();
                !n.collisionArrays && g && n.deserializeCollisionBoxes(g), o && s && n.updateCollisionDebugBuffers(this.transform.zoom, g, F, k);
                const $ = (t1, s, r)=>{
                    const { crossTileID: l, numVerticalGlyphVertices: g } = t1;
                    let C = null;
                    if (u && u.dynamicFilterNeedsFeature || W) {
                        const i = this.retainedQueryData[n.bucketInstanceId], o = b.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: i.bucketIndex,
                            sourceLayerIndex: i.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        }), s = o.properties ? o.properties.worldview : null;
                        if (n.localizable && n.worldview && "string" == typeof s) {
                            if ("all" === s) o.properties.$localized = !0;
                            else {
                                if (!s.split(",").includes(n.worldview)) return;
                                o.properties.$localized = !0, o.properties.worldview = n.worldview;
                            }
                        }
                        C = u && u.needGeometry ? e.b8(o, !0) : o;
                    }
                    if (u && !(0, u.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch,
                        worldview: n.worldview
                    }, C, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new e.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(u.unwrappedTileID))) return this.placements[l] = new bi(!1, !1, !1, !0), void i.add(l);
                    const L = A.evaluate(C, {});
                    if (i.has(l)) return;
                    if (m) return void (this.placements[l] = new bi(!1, !1, !1));
                    let P = !1, O = !1, z = !0, M = !1, F = !1, k = null, N = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, U = {
                        box: null
                    }, j = null, V = null, $ = null, X = 0, K = 0, Y = 0;
                    r.textFeatureIndex ? X = r.textFeatureIndex : t1.useRuntimeCollisionCircles && (X = t1.featureIndex), r.verticalTextFeatureIndex && (K = r.verticalTextFeatureIndex);
                    const J = n.elevationFeatures ? n.elevationFeatures[t1.elevationFeatureIndex] : void 0, Q = (i)=>{
                        i.tileID = this.retainedQueryData[n.bucketInstanceId].tileID;
                        const o = this.transform.elevation;
                        i.elevation = D ? L : L + e.bW.getAtTileOffset(i.tileID, new e.P(i.tileAnchorX, i.tileAnchorY), o, J), i.elevation += t1.zOffset;
                    }, ee = r.textBox;
                    if (ee) {
                        Q(ee);
                        const i = (i)=>{
                            let o = e.bM.horizontal;
                            if (n.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e = this.prevPlacement.placedOrientations[l];
                                e && (this.placedOrientations[l] = e, o = e, this.markUsedOrientation(n, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (n.allowVerticalPlacement && g > 0 && r.verticalTextBox) {
                                for (const o of n.writingModes)if (o === e.bM.vertical ? (N = i(), U = N) : N = t1(), N && N.box && N.box.length) break;
                            } else N = t1();
                        };
                        if (B) {
                            let a = B;
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[l]) {
                                const e = this.prevPlacement.variableOffsets[l];
                                a.indexOf(e.anchor) > 0 && (a = a.filter((t1)=>t1 !== e.anchor), a.unshift(e.anchor));
                            }
                            const h = (e, i, o)=>{
                                const r = n.getSymbolInstanceTextSize(v, t1, this.transform.zoom, s), l = (e.x2 - e.x1) * r + 2 * e.padding, h = (e.y2 - e.y1) * r + 2 * e.padding, d = t1.hasIconTextFit && !S ? i : null;
                                d && Q(d);
                                let u = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const m = E ? 2 * a.length : a.length;
                                for(let i = 0; i < m; ++i){
                                    const m = this.attemptAnchorPlacement(a[i % a.length], e, p, f, G, l, h, r, I, R, _, c, x, i >= a.length, t1, s, n, o, d, v, y);
                                    if (m && (u = m.placedGlyphBoxes, u && u.box && u.box.length)) {
                                        P = !0, k = m.shift;
                                        break;
                                    }
                                }
                                return u;
                            };
                            o(()=>h(ee, r.iconBox, e.bM.horizontal), ()=>{
                                const t1 = r.verticalTextBox;
                                return t1 && Q(t1), n.allowVerticalPlacement && !(N && N.box && N.box.length) && g > 0 && t1 ? h(t1, r.verticalIconBox, e.bM.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), N && (P = N.box, z = N.offscreen, M = N.occluded);
                            const d = i(!(!N || !N.box));
                            if (!P && this.prevPlacement) {
                                const e = this.prevPlacement.variableOffsets[l];
                                e && (this.variableOffsets[l] = e, this.markUsedJustification(n, e.anchor, t1, d));
                            }
                        } else {
                            const a = (i, o)=>{
                                const r = n.getSymbolInstanceTextSize(v, t1, this.transform.zoom, s), a = this.collisionIndex.placeCollisionBox(n, r, i, p, f, G, new e.P(0, 0), E, _, c, x.predicate);
                                return a && a.box && a.box.length && (this.markUsedOrientation(n, o, t1), this.placedOrientations[l] = o), a;
                            };
                            o(()=>a(ee, e.bM.horizontal), ()=>{
                                const t1 = r.verticalTextBox;
                                return n.allowVerticalPlacement && g > 0 && t1 ? (Q(t1), a(t1, e.bM.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!(N && N.box && N.box.length));
                        }
                    }
                    if (j = N, P = j && j.box && j.box.length > 0, z = j && j.offscreen, M = j && j.occluded, t1.useRuntimeCollisionCircles) {
                        const i = t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex, s = n.text.placedSymbolArray.get(i), r = e.bN(n.textSizeData, v, s), l = a.get("text-padding");
                        V = this.collisionIndex.placeCollisionCircles(n, E, s, i, n.lineVertexArray, n.glyphOffsetArray, r, c, h, d, o, R, x.predicate, t1.collisionCircleDiameter * r / e.bZ, l, this.retainedQueryData[n.bucketInstanceId].tileID), P = E || V.circles.length > 0 && !V.collisionDetected, z = z && V.offscreen, M = V.occluded;
                    }
                    if (r.iconFeatureIndex && (Y = r.iconFeatureIndex), r.iconBox) {
                        const i = (i)=>{
                            Q(i);
                            const o = t1.hasIconTextFit && k ? Ii(k.x, k.y, I, R, this.transform.angle) : new e.P(0, 0), s = n.getSymbolInstanceIconSize(y, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(n, s, i, p, f, H, o, S, _, c, x.predicate);
                        };
                        U && U.box && U.box.length && r.verticalIconBox ? ($ = i(r.verticalIconBox), O = $.box.length > 0) : ($ = i(r.iconBox), O = $.box.length > 0), z = z && $.offscreen, F = $.occluded;
                    }
                    const te = w || 0 === t1.numHorizontalGlyphVertices && 0 === g, ie = T || 0 === t1.numIconVertices;
                    if (te || ie ? ie ? te || (O = O && P) : P = O && P : O = P = O && P, P && j && j.box && this.collisionIndex.insertCollisionBox(j.box, a.get("text-ignore-placement"), n.bucketInstanceId, U && U.box && K ? K : X, x.ID), O && $ && this.collisionIndex.insertCollisionBox($.box, a.get("icon-ignore-placement"), n.bucketInstanceId, Y, x.ID), V && (P && this.collisionIndex.insertCollisionCircles(V.circles, a.get("text-ignore-placement"), n.bucketInstanceId, X, x.ID), o)) {
                        const e = n.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e] = new wi);
                        for(let e = 0; e < V.circles.length; e += 4)t1.circles.push(V.circles[e + 0]), t1.circles.push(V.circles[e + 1]), t1.circles.push(V.circles[e + 2]), t1.circles.push(V.collisionDetected ? 1 : 0);
                    }
                    const oe = "globe" !== n.projection.name;
                    q = q && (oe || !M), Z = Z && (oe || !F), this.placements[l] = new bi(P || q, O || Z, z || n.justReloaded), i.add(l);
                }, X = this.retainedQueryData[n.bucketInstanceId].tileID;
                if ("offset" === n.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(n, X), "road" === n.elevationType && n.updateRoadElevation(X.canonical), n.updateZOffset(), n.sortFeaturesByY) {
                    const t1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t1.length - 1; e >= 0; --e){
                        const i = t1[e];
                        $(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                    n.hasAnyZOffset && e.w(`${n.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (n.hasAnyZOffset) {
                    const e = n.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e.length; ++t1){
                        const i = e[t1];
                        $(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let e = t1.symbolInstanceStart; e < t1.symbolInstanceEnd; e++)$(n.symbolInstances.get(e), e, n.collisionArrays[e]);
                if (o && n.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[n.bucketInstanceId];
                    e.bm(t1.invProjMatrix, c), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, s) {
                const { leftJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e.c4(i), d = s === e.bM.vertical ? l : "left" === h ? r : "center" === h ? n : "right" === h ? a : -1;
                r >= 0 && (t1.text.placedSymbolArray.get(r).crossTileID = d >= 0 && r !== d ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = d >= 0 && n !== d ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = d >= 0 && a !== d ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = d >= 0 && l !== d ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const s = i === e.bM.horizontal || i === e.bM.horizontalOnly ? i : 0, r = i === e.bM.vertical ? i : 0, { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                n >= 0 && (h.get(n).placedOrientation = s), a >= 0 && (h.get(a).placedOrientation = s), l >= 0 && (h.get(l).placedOrientation = s), c >= 0 && (h.get(c).placedOrientation = r);
            }
            commit(e) {
                this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e) : 1, s = t1 ? t1.opacities : {}, r = t1 ? t1.variableOffsets : {}, n = t1 ? t1.placedOrientations : {};
                for(const e in this.placements){
                    const t1 = this.placements[e], r = s[e];
                    r ? (this.opacities[e] = new xi(r, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== r.text.placed || t1.icon !== r.icon.placed) : (this.opacities[e] = new xi(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e in s){
                    const t1 = s[e];
                    if (!this.opacities[e]) {
                        const s = new xi(t1, o, !1, !1);
                        s.isHidden() || (this.opacities[e] = s, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e in r)this.variableOffsets[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.variableOffsets[e] = r[e]);
                for(const e in n)this.placedOrientations[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.placedOrientations[e] = n[e]);
                i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e);
            }
            updateLayerOpacities(e, t1, i, o) {
                o && (this.lastReplacementSourceUpdateTime = o.updateTime);
                const s = new Set;
                for (const r of t1){
                    const t1 = r.getBucket(e);
                    t1 && r.latestFeatureIndex && e.fqid === t1.layerIds[0] && (this.updateBucketOpacities(t1, s, r, r.collisionBoxArray, i, o, r.tileID, e.scope), "offset" === t1.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(t1, r.tileID), "road" === t1.elevationType && t1.updateRoadElevation(r.tileID.canonical), t1.updateZOffset());
                }
            }
            updateBucketOpacities(t1, i, o, s, r, n, a, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, d = !!t1.layers[0].dynamicFilter(), u = new xi(null, 0, !1, !1, !0), _ = c.get("text-allow-overlap"), p = c.get("icon-allow-overlap"), f = c.get("text-variable-anchor"), m = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), v = h.get("symbol-z-offset"), y = "sea" === c.get("symbol-elevation-reference"), x = !v.isConstant(), b = new xi(null, 0, _ && (p || !t1.hasIconData() || c.get("icon-optional")), p && (_ || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && s && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(s);
                const w = (e, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                n && t1.updateReplacement(a, n);
                for(let s = 0; s < t1.symbolInstances.length; s++){
                    const c = t1.symbolInstances.get(s), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: _, crossTileID: p, numIconVertices: E, tileAnchorX: S, tileAnchorY: I } = c;
                    let C = null;
                    const R = this.retainedQueryData[t1.bucketInstanceId];
                    x && c && R && (C = o.latestFeatureIndex.loadFeature({
                        featureIndex: c.featureIndex,
                        bucketIndex: R.bucketIndex,
                        sourceLayerIndex: R.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const A = v.evaluate(C, {}), D = i.has(p);
                    let L = this.opacities[p];
                    D ? L = u : L || (L = b, this.opacities[p] = L), i.add(p);
                    const P = h > 0 || _ > 0, O = E > 0, z = this.placedOrientations[p], M = z === e.bM.vertical, F = z === e.bM.horizontal || z === e.bM.horizontalOnly;
                    !P && !O || L.isHidden() || T++;
                    let k = !1;
                    if ((P || O) && n) for (const i of t1.activeReplacements){
                        if (e.b_(i, r, e.b$.Symbol, l)) continue;
                        if (i.min.x > S || S > i.max.x || i.min.y > I || I > i.max.y) continue;
                        const t1 = e.c0(S, I, a.canonical, i.footprintTileId.canonical);
                        if (k = e.c1(t1, i.footprint), k) break;
                    }
                    if (P) {
                        const e = k ? ki : Fi(L.text);
                        w(t1.text, h, M ? ki : e), w(t1.text, _, F ? ki : e);
                        const i = L.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: r, verticalPlacedTextSymbolIndex: n } = c, a = t1.text.placedSymbolArray, l = i || M ? 1 : 0;
                        o >= 0 && (a.get(o).hidden = l), s >= 0 && (a.get(s).hidden = l), r >= 0 && (a.get(r).hidden = l), n >= 0 && (a.get(n).hidden = i || F ? 1 : 0);
                        const d = this.variableOffsets[p];
                        d && this.markUsedJustification(t1, d.anchor, c, z);
                        const u = this.placedOrientations[p];
                        u && (this.markUsedJustification(t1, "left", c, u), this.markUsedOrientation(t1, u, c));
                    }
                    if (O) {
                        const e = k ? ki : Fi(L.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = c, s = t1.icon.placedSymbolArray, r = L.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, E, M ? ki : e), s.get(i).hidden = r), o >= 0 && (w(t1.icon, c.numVerticalIconVertices, F ? ki : e), s.get(o).hidden = r);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[s];
                        if (i) {
                            let o = new e.P(0, 0), s = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (f) {
                                    const e = this.variableOffsets[p];
                                    e ? (o = Si(e.anchor, e.width, e.height, e.textOffset, e.textScale), m && o._rotate(g ? this.transform.angle : -this.transform.angle)) : s = !1;
                                }
                                d && (s = !L.clipped), i.textBox && Ri(t1.textCollisionBox.collisionVertexArray, L.text.placed, !s || M, A, y, o.x, o.y), i.verticalTextBox && Ri(t1.textCollisionBox.collisionVertexArray, L.text.placed, !s || F, A, y, o.x, o.y);
                            }
                            const r = s && Boolean(!F && i.verticalIconBox);
                            i.iconBox && Ri(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, r, A, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0), i.verticalIconBox && Ri(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, !r, A, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e.invProjMatrix, t1.placementViewportMatrix = e.viewportMatrix, t1.collisionCircleArray = e.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e) {
                return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e) {
                return Math.max(0, (this.transform.zoom - e) / 1.5);
            }
            hasTransitions(e) {
                return e - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e;
            }
            isStale() {
                return this.stale;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Ri(e, t1, i, o, s, r, n) {
            e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, n || 0, o, s ? 1 : 0);
        }
        const Ai = Math.pow(2, 25), Di = Math.pow(2, 24), Li = Math.pow(2, 17), Pi = Math.pow(2, 16), Oi = Math.pow(2, 9), zi = Math.pow(2, 8), Mi = Math.pow(2, 1);
        function Fi(e) {
            if (0 === e.opacity && !e.placed) return 0;
            if (1 === e.opacity && e.placed) return 4294967295;
            const t1 = e.placed ? 1 : 0, i = Math.floor(127 * e.opacity);
            return i * Ai + t1 * Di + i * Li + t1 * Pi + i * Oi + t1 * zi + i * Mi + t1;
        }
        const ki = 0;
        class Bi {
            constructor(e){
                this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && void 0 !== e.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e, t1, i, o, s, r) {
                const n = this._bucketParts;
                for(; this._currentTileIndex < e.length;)if (t1.getBucketParts(n, o, e[this._currentTileIndex], this._sortAcrossTiles, r), this._currentTileIndex++, s()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, n.sort((e, t1)=>e.sortKey - t1.sortKey)); this._currentPartIndex < n.length;){
                    const e = n[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e, this._seenCrossTileIDs, i, 0 === e.symbolInstanceStart, r), this._currentPartIndex++, s()) return !0;
                }
                return !1;
            }
        }
        class Ni {
            startNewPlacement(e, t1, i, o, s, r, n, a) {
                return this.placement = new Ci(e, o, s, r, n, a), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = !1, this._showCollisionBoxes = i, this._fadeDuration = o, this._done = !1, this._inProgressLayer = null, this;
            }
            requestFullPlacement() {
                this._forceFullPlacement = !0;
            }
            isFullPlacementRequested() {
                return this._forceFullPlacement;
            }
            setStale() {
                this.placement && (this.placement.stale = !0);
            }
            isStale() {
                return !!this.placement && this.placement.stale;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o, s, r) {
                const n = e.o.now(), a = ()=>{
                    const t1 = e.o.now() - n;
                    return !this.isFullPlacementRequested() && 0 !== this._fadeDuration && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const n = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && "none" !== n.visibility && (!n.minzoom || n.minzoom <= l) && (!n.maxzoom || n.maxzoom > l)) {
                        const t1 = n, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), d = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), u = h && d, _ = this._inProgressLayer = this._inProgressLayer || new Bi(t1), p = e.C(n.source, n.scope);
                        if (_.continuePlacement(i || u ? s[p] : o[p], this.placement, this._showCollisionBoxes, n, a, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._forceFullPlacement = !1, this._done = !0;
            }
            commit(e) {
                return this.placement.commit(e), this.placement;
            }
        }
        const Ui = 512 / e.am / 2;
        class ji {
            constructor(t1, i, o){
                this.tileID = t1, this.bucketInstanceId = o, this.index = new e.c5(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const s = t1.canonical.x * e.am, r = t1.canonical.y * e.am;
                for(let e = 0; e < i.length; e++){
                    const { key: t1, crossTileID: o, tileAnchorX: n, tileAnchorY: a } = i.get(e), l = Math.floor((s + n) * Ui), c = Math.floor((r + a) * Ui);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
            findMatches(t1, i, o) {
                const s = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), r = Ui / Math.pow(2, i.canonical.z - this.tileID.canonical.z), n = i.canonical.x * e.am, a = i.canonical.y * e.am;
                for(let e = 0; e < t1.length; e++){
                    const i = t1.get(e);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, d = Math.floor((n + c) * r), u = Math.floor((a + h) * r), _ = this.index.range(d - s, u - s, d + s, u + s).sort((e, t1)=>e - t1);
                    for (const e of _){
                        const t1 = this.crossTileIDs[e];
                        if (this.keys[e] === l && !o.has(t1)) {
                            o.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class Vi {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class Gi {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - this.lng) / 360);
                if (0 !== t1) for(const e in this.indexes){
                    const i = this.indexes[e], o = {};
                    for(const e in i){
                        const s = i[e];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + t1), o[s.tileID.key] = s;
                    }
                    this.indexes[e] = o;
                }
                this.lng = e;
            }
            addBucket(e, t1, i) {
                if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                    if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
                }
                for(let e = 0; e < t1.symbolInstances.length; e++)t1.symbolInstances.get(e).crossTileID = 0;
                this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = new Set);
                const o = this.usedCrossTileIDs[e.overscaledZ];
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    if (Number(i) > e.overscaledZ) for(const i in s){
                        const r = s[i];
                        r.tileID.isChildOf(e) && r.findMatches(t1.symbolInstances, e, o);
                    }
                    else {
                        const r = s[e.scaledTo(Number(i)).key];
                        r && r.findMatches(t1.symbolInstances, e, o);
                    }
                }
                for(let e = 0; e < t1.symbolInstances.length; e++){
                    const s = t1.symbolInstances.get(e);
                    s.crossTileID || (s.crossTileID = i.generate(), o.add(s.crossTileID));
                }
                return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new ji(e, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e].delete(i);
            }
            removeStaleBuckets(e) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const s in o)e[o[s].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[s]), delete o[s], t1 = !0);
                }
                return t1;
            }
        }
        class Hi {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Vi, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e, t1, i, o) {
                let s = this.layerIndexes[e.fqid];
                void 0 === s && (s = this.layerIndexes[e.fqid] = new Gi);
                let r = !1;
                const n = {};
                "globe" !== o.name && s.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e);
                    t1 && e.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, t1, this.crossTileIDs) && (r = !0), n[t1.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(n) && (r = !0), r;
            }
            pruneUnusedLayers(e) {
                const t1 = {};
                e.forEach((e)=>{
                    t1[e] = !0;
                });
                for(const e in this.layerIndexes)t1[e] || delete this.layerIndexes[e];
            }
        }
        const qi = 771;
        class Zi {
            constructor(e, t1, i, o){
                this.blendFunction = e, this.blendColor = t1.toNonPremultipliedRenderColor(null), this.mask = i, this.blendEquation = o;
            }
        }
        Zi.Replace = [
            1,
            0,
            1,
            0
        ], Zi.disabled = new Zi(Zi.Replace, e.ap.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Zi.unblended = new Zi(Zi.Replace, e.ap.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.alphaBlended = new Zi([
            1,
            qi,
            1,
            qi
        ], e.ap.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.alphaBlendedNonPremultiplied = new Zi([
            770,
            qi,
            770,
            qi
        ], e.ap.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.multiply = new Zi([
            774,
            0,
            774,
            0
        ], e.ap.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.additive = new Zi([
            1,
            1,
            1,
            1
        ], e.ap.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Wi {
            constructor(e, t1, i){
                this.func = e, this.mask = t1, this.range = i;
            }
        }
        Wi.ReadOnly = !1, Wi.ReadWrite = !0, Wi.disabled = new Wi(519, Wi.ReadOnly, [
            0,
            1
        ]);
        const $i = 7680;
        class Xi {
            constructor(e, t1, i, o, s, r){
                this.test = e, this.ref = t1, this.mask = i, this.fail = o, this.depthFail = s, this.pass = r;
            }
        }
        Xi.disabled = new Xi({
            func: 519,
            mask: 0
        }, 0, 0, $i, $i, $i);
        const Ki = 1029, Yi = 2305;
        class Ji {
            constructor(e, t1, i){
                this.enable = e, this.mode = t1, this.frontFace = i;
            }
        }
        function Qi(t1, i) {
            const o = e.cb(t1, 3);
            e.cd(t1, i), e.ch(t1, 3, o);
        }
        function eo(t1, i) {
            const o = e.c8([]);
            return e.c9(o, o, -i), e.ca(o, o, -t1), o;
        }
        function to(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], s = [
                i[0],
                i[1],
                0
            ];
            if (e.ah(o) >= 1e-15) {
                const t1 = e.ax([], o);
                e.c6(s, t1, e.bK(s, t1)), i[0] = s[0], i[1] = s[1];
            }
            const r = e.bJ([], i, t1);
            if (e.c7(r) < 1e-15) return null;
            const n = Math.atan2(-r[1], r[0]);
            return eo(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), n);
        }
        Ji.disabled = new Ji(!1, Ki, Yi), Ji.backCCW = new Ji(!0, Ki, Yi), Ji.backCW = new Ji(!0, Ki, 2304), Ji.frontCW = new Ji(!0, 1028, 2304), Ji.frontCCW = new Ji(!0, 1028, Yi);
        class io {
            constructor(e, t1){
                this.position = e, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e.af ? t1 : new e.af(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e.bU(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i, o) {
                if (this.orientation = null, !this.position) return;
                const s = this.position, r = o || (this._elevation ? this._elevation.getAtPointOrZero(e.af.fromLngLat(t1)) : 0), n = e.af.fromLngLat(t1, r), a = [
                    n.x - s.x,
                    n.y - s.y,
                    n.z - s.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = to(a, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = eo(e.ao(t1), e.ao(-i));
            }
        }
        class oo {
            constructor(t1, i){
                this._transform = e.bB([]), this.orientation = i, this.position = t1;
            }
            get mercatorPosition() {
                const t1 = this.position;
                return new e.af(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e.cb(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e.ch(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e.c8([]), t1 && Qi(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e[0] * e[0] + e[1] * e[1]), -e[2])
                };
            }
            setPitchBearing(e, t1) {
                this._orientation = eo(e, t1), Qi(this._transform, this._orientation);
            }
            forward() {
                const t1 = e.cb(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e.cb(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e.cb(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e.bm(o, this.getWorldToCamera(t1, i)), o;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(t1, i, o) {
                const s = this.position;
                e.c6(s, s, -t1);
                const r = new Float64Array(16);
                return e.br(r, [
                    o,
                    o,
                    o
                ]), e.bs(r, r, s), r[10] *= i, r;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), s = new Float64Array(4), r = this.position;
                return e.cc(s, this._orientation), e.c6(r, r, -t1), e.cd(o, s), e.bs(o, o, r), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, s) {
                const r = new Float64Array(16);
                return e.ce(r, t1, i, o, s), r;
            }
            getCameraToClipOrthographic(t1, i, o, s, r, n) {
                const a = new Float64Array(16);
                return e.cf(a, t1, i, o, s, r, n), a;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e.cg(t1, i ? e.b0(this.position[1]) : this.position[1]), s = this.forward();
                return (o - this.position[2]) / s[2];
            }
            clone() {
                return new oo([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const so = (e, t1)=>({
                u_matrix: e,
                u_ground_shadow_factor: t1
            });
        class ro {
            constructor(e = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e) || e < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e, this.bottom = t1, this.left = i, this.right = o;
            }
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e.al(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e.al(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e.al(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e.al(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e.aB((this.left + t1 - this.right) / 2, 0, t1), s = e.aB((this.top + i - this.bottom) / 2, 0, i);
                return new e.P(o, s);
            }
            equals(e) {
                return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
            }
            clone() {
                return new ro(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        const no = 15;
        class ao {
            constructor(t1, i, o, s, r, n, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === r || r, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = o ?? 0, this._maxPitch = s ?? 60, this.setProjection(n), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new e.aU(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._nearClipOffset = 0, this._unmodified = !0, this._edgeInsets = new ro, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new oo, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1, this._allowWorldUnderZoom = !1;
            }
            clone() {
                const e = new ao(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
                return e._elevation = this._elevation, e._centerAltitude = this._centerAltitude, e._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e.tileSize = this.tileSize, e.mercatorFromTransition = this.mercatorFromTransition, e.width = this.width, e.height = this.height, e.cameraElevationReference = this.cameraElevationReference, e._center = this._center, e._setZoom(this.zoom), e._seaLevelZoom = this._seaLevelZoom, e.angle = this.angle, e._fov = this._fov, e._pitch = this._pitch, e._nearZ = this._nearZ, e._farZ = this._farZ, e._nearClipOffset = this._nearClipOffset, e._averageElevation = this._averageElevation, e._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e._unmodified = this._unmodified, e._edgeInsets = this._edgeInsets.clone(), e._camera = this._camera.clone(), e._calcMatrices(), e.freezeTileCoverage = this.freezeTileCoverage, e.frustumCorners = this.frustumCorners, e._allowWorldUnderZoom = this._allowWorldUnderZoom, e;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < no;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e) {
                this._elevation !== e && (this._elevation = e, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get nearClipOffset() {
                return this._nearClipOffset;
            }
            set nearClipOffset(e) {
                this._nearClipOffset = e, this._calcMatrices();
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e.aI(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(t1) {
                this.projectionOptions = t1 || {
                    name: "mercator"
                };
                const i = this.projection ? this.getProjection() : void 0;
                this.projection = e.cn(this.projectionOptions);
                const o = this.getProjection(), s = !e.bz(i, o);
                return s && this._calcMatrices(), this.mercatorFromTransition = !1, s;
            }
            setOrthographicProjectionAtLowPitch(e) {
                return this._orthographicProjectionAtLowPitch !== e && (this._orthographicProjectionAtLowPitch = e, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e.cn({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e) {
                this._minZoom !== e && (this._minZoom = e, this.zoom = Math.max(this.zoom, e));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e) {
                this._maxZoom !== e && (this._maxZoom = e, this.zoom = Math.min(this.zoom, e));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e) {
                this._minPitch !== e && (this._minPitch = e, this.pitch = Math.max(this.pitch, e));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e) {
                this._maxPitch !== e && (this._maxPitch = e, this.pitch = Math.min(this.pitch, e));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e) {
                void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get cameraWorldSize() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e.cg(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e.P(this.width, this.height);
            }
            get bearing() {
                return e.bU(this.rotation, -180, 180);
            }
            set bearing(e) {
                this.rotation = e;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e.co(), e.cp(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e.aB(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e.ao(t1), this._calcMatrices());
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e);
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e) {
                this._averageElevation = e, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e) {
                const t1 = Math.min(Math.max(e, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e) {
                this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e) {
                this._tileCoverLift !== e && (this._tileCoverLift = e);
            }
            _updateCameraOnTerrain() {
                const e = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                if (void 0 === this._centerAltitudeValidForExaggeration) return;
                const e = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
                this._seaLevelZoom = this._zoomFromMercatorZ(e);
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let s = 0, r = 0;
                for(let n = 0; n < i.length; n++){
                    const a = new e.P(i[n][0] * this.width, o + i[n][1] * (this.height - o)), l = t1.pointCoordinate(a);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    s += l[3] * c, r += c;
                }
                return 0 === r ? NaN : s / r;
            }
            get center() {
                return this._center;
            }
            set center(e) {
                e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e), s = this._mercatorZfromZoom(this._maxZoom), r = Math.max(o - i, s);
                this._setZoom(this._zoomFromMercatorZ(r));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e) {
                this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
            }
            equals(e) {
                const t1 = this.elevation, i = e.elevation, o = null != t1 != (null != i) || t1 && i && t1.exaggeration() !== i.exaggeration();
                return this.width === e.width && this.height === e.height && this.center.lng === e.center.lng && this.center.lat === e.center.lat && this.zoom === e.zoom && this.bearing === e.bearing && this.pitch === e.pitch && this.fov === e.fov && this.projection.name === e.projection.name && this._edgeInsets.equals(e.padding) && !o;
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const s = e.ah(e.aw([], this._camera.position, o));
                return e.aB(this._zoomFromMercatorZ(s), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e.cq(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e.cr(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new io;
                return i.position = new e.af(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e.cs(t1)) return !1;
                e.ct(t1, t1);
                const i = e.cu([], [
                    0,
                    0,
                    -1
                ], t1), o = e.cu([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const s = to(i, o);
                return !!s && (this._camera.orientation = s, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, s = this.cameraToCenterDistance;
                t1[2] = e.aB(t1[2], s / o, s / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e) {
                return this._edgeInsets.equals(e);
            }
            interpolatePadding(e, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e) {
                const t1 = (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e.cv(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e.P(0, 0)), s = this.pointCoordinate(new e.P(this.width, 0)), r = this.pointCoordinate(new e.P(this.width, this.height)), n = this.pointCoordinate(new e.P(0, this.height)), a = Math.floor(Math.min(o.x, s.x, r.x, n.x)), l = Math.floor(Math.max(o.x, s.x, r.x, n.x)), c = 1;
                    for(let o = a - c; o <= l + c; o++)0 !== o && i.push(new e.cv(o, t1));
                }
                return i;
            }
            isLODDisabled(e) {
                return (!e || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t1, i, o, s) {
                let r = [];
                const n = null != o, a = !n;
                if (a && this.zoom < i) return r;
                if (n && 0 === o[0] && 0 === o[1]) return r;
                const l = new Set, c = (t1, i, o, s, n)=>{
                    const a = e.cZ(i, t1, o, s, n);
                    l.has(a) || (r.push(new e.aR(t1, i, o, s, n)), l.add(a));
                };
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e];
                    if (a && r.canonical.z !== i) continue;
                    if (n && void 0 !== s && s > r.canonical.z) continue;
                    const l = r.canonical, h = r.overscaledZ, d = r.wrap, u = 1 << l.z, _ = l.x + 1 < u, p = l.x > 0, f = l.y + 1 < u, m = l.y > 0, g = r.wrap - (p ? 0 : 1), v = r.wrap + (_ ? 0 : 1), y = p ? l.x - 1 : u - 1, x = _ ? l.x + 1 : 0;
                    if (n) o[0] < 0 ? (c(h, v, l.z, x, l.y), o[1] < 0 && f && (c(h, d, l.z, l.x, l.y + 1), c(h, v, l.z, x, l.y + 1)), o[1] > 0 && m && (c(h, d, l.z, l.x, l.y - 1), c(h, v, l.z, x, l.y - 1))) : o[0] > 0 ? (c(h, g, l.z, y, l.y), o[1] < 0 && f && (c(h, d, l.z, l.x, l.y + 1), c(h, g, l.z, y, l.y + 1)), o[1] > 0 && m && (c(h, d, l.z, l.x, l.y - 1), c(h, g, l.z, y, l.y - 1))) : o[1] < 0 && f ? c(h, d, l.z, l.x, l.y + 1) : m && c(h, d, l.z, l.x, l.y - 1);
                    else {
                        const e = r.visibleQuadrants;
                        1 & e && (c(h, g, l.z, y, l.y), m && (c(h, d, l.z, l.x, l.y - 1), c(h, g, l.z, y, l.y - 1))), 2 & e && (c(h, v, l.z, x, l.y), m && (c(h, d, l.z, l.x, l.y - 1), c(h, v, l.z, x, l.y - 1))), 4 & e && (c(h, g, l.z, y, l.y), f && (c(h, d, l.z, l.x, l.y + 1), c(h, g, l.z, y, l.y + 1))), 8 & e && (c(h, v, l.z, x, l.y), f && (c(h, d, l.z, l.x, l.y + 1), c(h, v, l.z, x, l.y + 1)));
                    }
                }
                const h = [];
                for (const e of r)r.some((t1)=>e.isChildOf(t1)) || h.push(e);
                if (r = h.filter((e)=>!t1.some((t1)=>!!(e.overscaledZ < i && t1.isChildOf(e)) || e.equals(t1) || e.isChildOf(t1))), a) {
                    const e = 1 << i, t1 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o = [
                        e * t1.x,
                        e * t1.y
                    ], s = 4, n = s * s;
                    r = r.filter((e)=>{
                        const t1 = e.canonical.x + .5 - o[0], i = e.canonical.y + .5 - o[1];
                        return t1 * t1 + i * i < n;
                    });
                }
                return r;
            }
            extendTileCoverToNearPlane(t1, i, o) {
                const s = [], r = new Set;
                for (const e of t1)r.add(e.key);
                const n = (t1, i, o, n, a)=>{
                    const l = e.cZ(i, t1, o, n, a);
                    r.has(l) || (s.push(new e.aR(t1, i, o, n, a)), r.add(l));
                }, a = t1.reduce((e, t1)=>Math.max(e, t1.overscaledZ), o), l = 1 << o, c = [
                    new e.P(0, 0),
                    new e.P(e.am, 0),
                    new e.P(e.am, e.am),
                    new e.P(0, e.am)
                ], h = new e.P(0, 0), d = new e.P(0, 0), u = (t1, i)=>{
                    const s = Math.floor(t1[0]), r = Math.floor(t1[1]), u = (t1[0] - s) * e.am, _ = (t1[1] - r) * e.am, p = Math.floor(i[0]), f = Math.floor(i[1]), m = (i[0] - p) * e.am, g = (i[1] - f) * e.am;
                    for(let t1 = -1; t1 <= 1; t1++){
                        const i = s + t1;
                        if (!(i < 0 || i >= l)) {
                            h.x = u - t1 * e.am, d.x = m - (i - p) * e.am;
                            for(let t1 = -1; t1 <= 1; t1++){
                                const s = r + t1;
                                h.y = _ - t1 * e.am, d.y = g - (s - f) * e.am, e.c_(h, d, c) && n(a, 0, o, i, s);
                            }
                        }
                    }
                }, _ = i.points, p = _[e.cw], f = _[e.cx], m = this._projectToGround(p, _[e.cy]), g = this._projectToGround(f, _[e.cz]);
                return u(p, m), u(f, g), s;
            }
            _projectToGround(t1, i) {
                return e.cA(e.cB(), t1, i, t1[2] / (t1[2] - i[2]));
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, s = this.elevation && this.elevation.exaggeration(), r = s && !t1.isTerrainDEM, n = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const a = this.locationCoordinate(this.center), l = this.center.lat, c = 1 << i, h = [
                    c * a.x,
                    c * a.y,
                    0
                ], d = "globe" === this.projection.name, u = !d, _ = e.cC.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, u), p = d ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = c * e.cg(1, this.center.lat), m = this._camera.position[2] / e.cg(1, this.center.lat), g = [
                    c * p.x,
                    c * p.y,
                    m * (u ? 1 : f)
                ], v = d || s, y = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? i : 0;
                let b;
                if (this._elevation && t1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e = this._elevation.getMinMaxForVisibleTiles();
                    b = e ? e.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = t1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T = this.projection.isReprojectedInTileSpace ? e.cD(this) : 1, E = (t1)=>{
                    const i = 1 / 4e4, o = new e.af(t1.x + i, t1.y, t1.z), s = new e.af(t1.x, t1.y + i, t1.z), r = t1.toLngLat(), n = o.toLngLat(), a = s.toLngLat(), l = this.locationCoordinate(r), c = this.locationCoordinate(n), h = this.locationCoordinate(a), d = Math.hypot(c.x - l.x, c.y - l.y), u = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(d * u) * T / i;
                }, S = (t1)=>{
                    const i = b, o = w;
                    return {
                        aabb: e.cG(this, c, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, I = [];
                let C = [];
                const R = i, A = t1.reparseOverscaled ? o : i, D = (m - this._centerAltitude) * f, L = (e)=>{
                    if (!this._elevation || !e.tileID || !n) return;
                    const t1 = this._elevation.getMinMaxForTile(e.tileID), i = e.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e.shouldSplit = O(e), e.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (e, t1)=>{
                    if (.707 * t1 < e) return 1;
                    const i = t1 / e;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, O = (t1)=>{
                    if (t1.zoom < x) return !0;
                    if (t1.zoom === R) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(g), s = t1.aabb.distanceY(g);
                    let a = D, c = 1;
                    if (d) {
                        a = t1.aabb.distanceZ(g);
                        const i = Math.pow(2, t1.zoom), o = e.b0((t1.y + 1) / i), s = e.b0(t1.y / i), r = Math.min(Math.max(l, o), s), n = e.d2(r) / e.d2(l);
                        if (c = r === l ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, n / this._mercatorScaleRatio), this.zoom <= e.c$ && t1.zoom === R - 1 && n >= .9) return !0;
                    } else if (r && (a = t1.aabb.distanceZ(g) * f), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = E(new e.af((t1.x + .5) / i, (t1.y + .5) / i));
                        c = o > .85 ? 1 : o;
                    }
                    if (!n && !d) {
                        const e = Math.sqrt(i * i + s * s + a * a);
                        let o = (1 << R - t1.zoom) * y * c;
                        return o *= P(Math.max(a, D), e), e < o;
                    }
                    let u = Number.MAX_VALUE, _ = 0;
                    const p = t1.aabb.getCorners(), m = [];
                    for (const t1 of p){
                        e.aw(m, t1, g), d || (r ? m[2] *= f : m[2] = D);
                        const i = e.bK(m, this._camera.forward());
                        i < u && (u = i, _ = Math.abs(m[2]));
                    }
                    let v = (1 << R - t1.zoom) * y * c;
                    if (v *= P(Math.max(_, D), u), u < v) return !0;
                    const b = t1.aabb.closestPoint(h);
                    return b[0] === h[0] && b[1] === h[1];
                };
                if (this.renderWorldCopies) for(let e = 1; e <= 3; e++)I.push(S(-e)), I.push(S(e));
                for(I.push(S(0)); I.length > 0;){
                    const o = I.pop(), s = o.x, a = o.y;
                    let l = o.fullyVisible;
                    const u = ()=>"globe" === this.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
                    if (!l) {
                        let t1 = v ? o.aabb.intersects(_) : o.aabb.intersectsFlat(_);
                        if (0 === t1 && u()) {
                            const i = new e.cE(o.zoom, s, a);
                            t1 = e.cF(this, c, i, !0).intersects(_);
                        }
                        if (0 === t1) continue;
                        l = 2 === t1;
                    }
                    if (o.zoom === R || !O(o)) {
                        const r = o.zoom === R ? A : o.zoom;
                        if (t1.minzoom && t1.minzoom > r) continue;
                        let n = 0;
                        if (!l) {
                            let i = v ? o.aabb.intersectsPrecise(_) : o.aabb.intersectsPreciseFlat(_);
                            if (0 === i && u()) {
                                const t1 = new e.cE(o.zoom, s, a);
                                i = e.cF(this, c, t1, !0).intersectsPrecise(_);
                            }
                            if (0 === i) continue;
                            if (t1.calculateQuadrantVisibility) {
                                if (_.containsPoint(o.aabb.center)) n = 15;
                                else for(let e = 0; e < 4; e++)0 !== o.aabb.quadrant(e).intersects(_) && (n |= 1 << e);
                            }
                        }
                        const d = h[0] - (.5 + s + (o.wrap << o.zoom)) * (1 << i - o.zoom), p = h[1] - .5 - a, f = o.tileID ? o.tileID : new e.aR(r, o.wrap, o.zoom, s, a);
                        t1.calculateQuadrantVisibility && (f.visibleQuadrants = n), C.push({
                            tileID: f,
                            distanceSq: d * d + p * p
                        });
                        continue;
                    }
                    for(let t1 = 0; t1 < 4; t1++){
                        const i = (s << 1) + t1 % 2, h = (a << 1) + (t1 >> 1), u = {
                            aabb: n ? o.aabb.quadrant(t1) : e.cG(this, c, o.zoom + 1, i, h, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: h,
                            wrap: o.wrap,
                            fullyVisible: l,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        r && !d && (u.tileID = new e.aR(o.zoom + 1 === R ? A : o.zoom + 1, o.wrap, o.zoom + 1, i, h), L(u)), I.push(u);
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    C = C.filter((s)=>{
                        const r = [
                            0,
                            0,
                            0,
                            1
                        ], n = [
                            e.am,
                            e.am,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(s.tileID.toUnwrapped());
                        e.aD(r, r, a), e.aD(n, n, a);
                        const l = e.cH([], r, n), c = e.cI([], r, n), h = e.d0(l, c);
                        if (0 === h) return !0;
                        let d = !1;
                        const u = this._elevation;
                        if (u && h > i && 0 !== o) {
                            const i = this.calculateProjMatrix(s.tileID.toUnwrapped());
                            let r;
                            t1.isTerrainDEM || (r = u.getMinMaxForTile(s.tileID)), r || (r = {
                                min: w,
                                max: b
                            });
                            const n = e.cJ(this.rotation), a = [
                                n[0] * e.am,
                                n[1] * e.am,
                                r.max
                            ];
                            e.ag(a, a, i), d = (1 - a[1]) * this.height * .5 < o;
                        }
                        return h < i || d;
                    });
                }
                return C.sort((e, t1)=>e.distanceSq - t1.distanceSq).map((e)=>e.tileID);
            }
            resize(e, t1) {
                this.width = e, this.height = t1, this.pixelsToGLUnits = [
                    2 / e,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e) {
                return Math.pow(2, e);
            }
            scaleZoom(e) {
                return Math.log2(e);
            }
            project(t1) {
                const i = e.aB(t1.lat, -e.cK, e.cK), o = this.projection.project(t1.lng, i);
                return new e.P(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e) {
                return this.projection.unproject(e.x / this.worldSize, e.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e.cg(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, s;
                const r = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e = this.worldSize;
                    o = (i.x - r.x) / e, s = (i.y - r.y) / e;
                } else {
                    const e = this.pointCoordinate(i), t1 = this.pointCoordinate(r);
                    o = e.x - t1.x, s = e.y - t1.y;
                }
                const n = this.locationCoordinate(t1);
                this.setLocation(new e.af(n.x - o, n.y - s));
            }
            setLocation(e) {
                this.center = this.coordinateLocation(e), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e, t1) {
                return this.projection.locationPoint(this, e, t1);
            }
            locationPoint3D(e, t1) {
                return this.projection.locationPoint(this, e, t1, !0);
            }
            pointLocation(e) {
                return this.coordinateLocation(this.pointCoordinate(e));
            }
            pointLocation3D(e, t1) {
                return this.coordinateLocation(this.pointCoordinate3D(e, t1));
            }
            locationCoordinate(t1, i) {
                const o = i ? e.cg(i, t1.lat) : void 0, s = this.projection.project(t1.lng, t1.lat);
                return new e.af(s.x, s.y, o);
            }
            coordinateLocation(e) {
                return this.projection.unproject(e.x, e.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, s = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], r = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.aD(s, s, this.pixelMatrixInverse), e.aD(r, r, this.pixelMatrixInverse);
                const n = r[3];
                e.cL(s, s, 1 / s[3]), e.cL(r, r, 1 / n);
                const a = s[2], l = r[2];
                return {
                    p0: s,
                    p1: r,
                    t: a === l ? 0 : (o - a) / (l - a)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e.aD(i, i, this.pixelMatrixInverse), e.aD(o, o, this.pixelMatrixInverse), e.cL(i, i, 1 / i[3]), e.cL(o, o, 1 / o[3]), i[2] = e.cg(i[2], this._center.lat) * this.worldSize, o[2] = e.cg(o[2], this._center.lat) * this.worldSize, e.cL(i, i, 1 / this.worldSize), e.cL(o, o, 1 / this.worldSize), new e.ay([
                    i[0],
                    i[1],
                    i[2]
                ], e.ax([], e.aw([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: s } = t1, r = e.cg(i[2], this._center.lat), n = e.cg(o[2], this._center.lat);
                return new e.af(e.al(i[0], o[0], s) / this.worldSize, e.al(i[1], o[1], s) / this.worldSize, e.al(r, n, s));
            }
            pointCoordinate(e, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e.x, e.y, t1);
            }
            pointCoordinate3D(t1, i) {
                if (!this.elevation) return this.pointCoordinate(t1, i);
                let o = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (o) return new e.af(o[0], o[1], o[2]);
                let s = 0, r = this.horizonLineFromTop();
                if (t1.y > r) return this.pointCoordinate(t1, i);
                const n = .02 * r, a = t1.clone();
                for(let t1 = 0; t1 < 10 && r - s > n; t1++){
                    a.y = e.al(s, r, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (r = a.y, o = t1) : s = a.y;
                }
                return o ? new e.af(o[0], o[1], o[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e) {
                return this.projection.isPointAboveHorizon(this, e);
            }
            isPointOnSurface(t1) {
                if (t1.y < 0 || t1.y > this.height || t1.x < 0 || t1.x > this.width) return !1;
                if (this.elevation || this.zoom >= e.cM) return !this.isPointAboveHorizon(t1);
                const i = this.pointCoordinate(t1);
                return i.y >= 0 && i.y <= 1;
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, s = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e.aD(s, s, this.pixelMatrix), s[3] > 0 ? new e.P(s[0] / s[3], s[1] / s[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, s = this.width - this._edgeInsets.right, r = this.pointLocation3D(new e.P(i, t1)), n = this.pointLocation3D(new e.P(s, t1)), a = this.pointLocation3D(new e.P(s, o)), l = this.pointLocation3D(new e.P(i, o));
                let c = Math.min(r.lng, n.lng, a.lng, l.lng), h = Math.max(r.lng, n.lng, a.lng, l.lng), d = Math.min(r.lat, n.lat, a.lat, l.lat), u = Math.max(r.lat, n.lat, a.lat, l.lat);
                const _ = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (t1, i, o, s, r)=>{
                    const n = (t1 + o) / 2, a = (i + s) / 2, l = new e.P(n, a), { lng: m, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - m, d - g, m - h, g - u);
                    c = Math.min(c, m), h = Math.max(h, m), d = Math.min(d, g), u = Math.max(u, g), (r < p || v > _) && (f(t1, i, n, a, r + 1), f(n, a, o, s, r + 1));
                };
                if (f(i, t1, s, t1, 1), f(s, t1, s, o, 1), f(s, o, i, o, 1), f(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e.cN(this);
                    t1 ? (u = 90, h = 180, c = -180) : i && (d = -90, h = 180, c = -180);
                }
                return new e.aJ(new e.aU(c, d), new e.aU(h, u));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: s } = this._edgeInsets, r = this.height - this._edgeInsets.bottom, n = this.width - this._edgeInsets.right, a = new e.P(s, o), l = new e.P(n, o), c = new e.P(n, r), h = new e.P(s, r);
                let d = this.pointCoordinate(a, t1), u = this.pointCoordinate(l, t1);
                const _ = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), f = (e, t1)=>(t1.y - e.y) / (t1.x - e.x);
                return d.y > 1 && u.y >= 0 ? d = new e.af((1 - p.y) / f(p, d) + p.x, 1) : d.y < 0 && u.y <= 1 && (d = new e.af(-p.y / f(p, d) + p.x, 0)), u.y > 1 && d.y >= 0 ? u = new e.af((1 - _.y) / f(_, u) + _.x, 1) : u.y < 0 && d.y <= 1 && (u = new e.af(-_.y / f(_, u) + _.x, 0)), (new e.aJ).extend(this.coordinateLocation(d)).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(_));
            }
            _getBoundsRectangularTerrain() {
                const e = this.elevation;
                if (!e.visibleDemTiles.length || e.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e.visibleDemTiles.reduce((e, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e.min = Math.min(e.min, i.minimums[0]), e.max = Math.max(e.max, i.maximums[0]);
                    }
                    return e;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e.exaggeration(), t1.max * e.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e.cK, this.maxLat = e.cK, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.aG(this.minLng) * this.tileSize, this.worldMaxX = e.aG(this.maxLng) * this.tileSize, this.worldMinY = e.aK(this.maxLat) * this.tileSize, this.worldMaxY = e.aK(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e, t1) {
                return this.projection.createTileMatrix(this, t1, e);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const s = t1.canonical, r = 1 / this.height, n = this.cameraWorldSize, a = n / this.zoomScale(s.z), l = (s.x + Math.pow(2, s.z) * t1.wrap) * a, c = s.y * a, h = this.point;
                h.x *= n / this.worldSize, h.y *= n / this.worldSize;
                const d = this.angle, u = Math.sin(-d), _ = -Math.cos(-d);
                return o[i] = {
                    bearing: [
                        u,
                        _
                    ],
                    center: [
                        (h.x - l) * r,
                        (h.y - c) * r
                    ],
                    scale: a / e.am * r
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const s = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e.aC(s, this.worldToFogMatrix, s), o[i] = new Float32Array(s), o[i];
            }
            calculateProjMatrix(t1, i = !1, o = !1) {
                const s = t1.key;
                let r;
                if (r = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, r[s]) return r[s];
                const n = this.calculatePosMatrix(t1, this.worldSize);
                let a;
                return a = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e.aC(n, a, n), r[s] = new Float32Array(n), r[s];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const s = e.cO(t1, this);
                return o[i] = s, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e.br([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e.aC(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e.cg(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), s = this._camera.forward(), r = e.cg(1, this._center.lat);
                o[2] /= r, s[2] /= r, e.ax(s, s);
                const n = t1.raycast(o, s, t1.exaggeration());
                if (n) {
                    const t1 = e.bI([], o, s, n), i = new e.af(t1[0], t1[1], e.cg(t1[2], e.b0(t1[1]))), a = (i.z + e.ah([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * r
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e.cg(1, this._center.lat) * this.worldSize, s = this._computeCameraPosition(o), r = i.getAtPointOrZero(new e.af(...s)), n = this.pixelsPerMeter / this.worldSize * r, a = this._minimumHeightOverTerrain(), l = s[2] - n;
                if (l <= a) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            s[0],
                            s[1],
                            t1.z - s[2]
                        ], o = e.ah(i);
                        i[2] -= (a - l) / this._pixelsPerMercatorPixel;
                        const r = e.ah(i);
                        if (0 === r) return;
                        e.c6(i, i, o / r * this._pixelsPerMercatorPixel), this._camera.position = [
                            s[0],
                            s[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e.aB(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e.aB(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: s } = this.point;
                let r = 0, n = o, a = s;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, d = this.worldMaxY * this.scale;
                if (s - c < h && (a = h + c), s + c > d && (a = d - c), d - h < this.height && (r = Math.max(r, this.height / (d - h)), a = (d + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e + t1) / 2;
                    n = (o + i + this.worldSize) % this.worldSize - i, n - l < e && (n = e + l), n + l > t1 && (n = t1 - l), t1 - e < this.width && (r = Math.max(r, this.width / (t1 - e)), n = (t1 + e) / 2);
                }
                n === o && a === s || this._allowWorldUnderZoom || (this.center = this.unproject(new e.P(n, a))), r && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(r)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e = Math.max(e, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = "globe" === this.projection.name, o = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e.cg(1, this.center.lat) / e.cg(1, e.d3));
                const s = e.cP(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, s), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? o : 1, n = this._camera.getWorldToCamera(this.worldSize, r);
                let a;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -t1.x / this.width, l[9] = 2 * t1.y / this.height, this.isOrthographic) {
                    let i = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), o = i * this.aspect, s = -o, r = -i;
                    o -= t1.x, s -= t1.x, i += t1.y, r += t1.y, a = this._camera.getCameraToClipOrthographic(s, o, r, i, this._nearZ + this._nearClipOffset, this._farZ), ((t1, i, o, s)=>{
                        for(let r = 0; r < 16; r++)t1[r] = e.al(i[r], o[r], s);
                    })(a, a, l, e.d1(this.pitch >= no ? 1 : this.pitch / no));
                } else a = l;
                const c = e.cQ([], l, n);
                let h = e.cQ([], a, n);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e.bB([]);
                    e.bs(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e.aC(i, i, e.cR(this)), e.bs(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e.aC(h, h, i), e.aC(c, c, i), this.inverseAdjustmentMatrix = e.cS(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = e.cT([], h, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = h, this.invProjMatrix = e.bm(new Float64Array(16), this.projMatrix), i) {
                    const i = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    i[8] = 2 * -t1.x / this.width, i[9] = 2 * t1.y / this.height, this.expandedFarZProjMatrix = e.cQ([], i, n);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const d = e.bm([], a);
                this.frustumCorners = e.cU.fromInvProjectionMatrix(d, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.cC.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
                const u = new Float32Array(16);
                e.bB(u), e.cT(u, u, [
                    1,
                    -1,
                    1
                ]), e.cV(u, u, this._pitch), e.bC(u, u, this.angle);
                const _ = e.ce(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = e.bA(_);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                _[8] = 2 * -t1.x / this.width, _[9] = 2 * (t1.y + p) / this.height, this.skyboxMatrix = e.aC(u, _, u);
                const f = this.point, m = f.x, g = f.y, v = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), b = Math.sin(this.angle), w = m - Math.round(m) + x * v + b * y, T = g - Math.round(g) + x * y + b * v, E = new Float64Array(h);
                if (e.bs(E, E, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = E, h = e.bD(), e.cT(h, h, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e.bs(h, h, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = h, h = e.bD(), e.cT(h, h, [
                    1,
                    -1,
                    1
                ]), e.bs(h, h, [
                    -1,
                    -1,
                    0
                ]), e.cT(h, h, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = h, this.pixelMatrix = e.aC(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e.bm(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e.cW(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e.ag(t1, t1, n), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = h;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, s = 1 / this.height / this._pixelsPerMercatorPixel, r = [
                    t1,
                    t1,
                    i
                ];
                e.c6(r, r, s), e.c6(o, o, -1), e.cX(o, o, r);
                const n = e.bD();
                e.bs(n, n, o), e.cT(n, n, r), this.mercatorFogMatrix = n, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, s);
            }
            _computeCameraPosition(e) {
                const t1 = (e = e || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, s = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * s,
                    o.y / this.worldSize - i[1] * s,
                    e / this.worldSize * this._centerAltitude - i[2] * s
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], s = t1[2];
                let r = 1;
                this.projection.wrap && (this.center = this.center.wrap()), s > 0 && (r = Math.min((i - o) / s, 1)), this._camera.position = e.bI([], this._camera.position, t1, r), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: s } = this._camera.getPitchBearing(), r = e.cg(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, n = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.ao(this._maxPitch)), a = Math.max((t1[2] - r) / Math.cos(o), n), l = this._zoomFromMercatorZ(a);
                e.bI(t1, t1, i, a), this._pitch = e.aB(o, e.ao(this.minPitch), e.ao(this.maxPitch)), this.angle = e.bU(s, -Math.PI, Math.PI), this._setZoom(e.aB(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e.af(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e) {
                return Math.pow(2, e) * this.tileSize;
            }
            _mercatorZfromZoom(e) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e);
            }
            _minimumHeightOverTerrain() {
                const e = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e);
            }
            _zoomFromMercatorZ(e) {
                return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e.cM, s = 0, r = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e = i + .5 * (o - i), n = this.tileSize * Math.pow(2, e), a = this.getCameraToCenterDistance(this.projection, e, n), l = this.scaleZoom(a / (Math.max(0, t1) * this.tileSize)), c = Math.abs(e - l);
                    c < r && (r = c, s = e), e < l ? i = e : o = e;
                }
                return s;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), s = Math.max(t1.x, i.x), r = Math.min(t1.y, i.y), n = Math.max(t1.y, i.y);
                if (r < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new e.P(o, r),
                    new e.P(s, n),
                    new e.P(o, n),
                    new e.P(s, r)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e of a){
                    const t1 = this.pointRayIntersection(e);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e.cY(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e.ah(e.aw([], this._camera.position, t1)), s = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(s);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], s) {
                        const r = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e.aD(r, r, s);
                        const n = r[3] = Math.max(r[3], 1e-6);
                        return r[0] /= n, r[1] /= n, r[2] /= n, r;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e.P(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e.P(0, t1));
                }
            }
            getCameraToCenterDistance(t1, i = this.zoom, o = this.worldSize) {
                const s = e.cP(t1, i, this.width, this.height, 1024), r = t1.pixelSpaceConversion(this.center.lat, o, s);
                let n = .5 / Math.tan(.5 * this._fov) * this.height * r;
                return this.isOrthographic && (n = e.al(1, n, e.d1(this.pitch >= no ? 1 : this.pitch / no))), n;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e.aC(t1, t1, this.globeMatrix), t1;
            }
            getFrustum(t1) {
                return e.cC.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, "meters" === this.projection.zAxisUnit);
            }
        }
        const lo = (t1, i)=>{
            if (i > 0 && t1.terrain && e.w("Cutoff is currently disabled on terrain"), i <= 0 || t1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = t1.transform, s = Math.max(Math.abs(o._zoom - (t1.minCutoffZoom - 1)), 1), r = o.isLODDisabled(!1) ? e.ai(60, 45, o.pitch) : e.ai(30, 15, o.pitch), n = o._farZ - o._nearZ, a = i * o.height, l = ((1 - (c = r)) * o.cameraToCenterDistance + c * (o._farZ + a)) * s;
            var c;
            return {
                shouldRenderCutoff: r < 1,
                uniformValues: {
                    u_cutoff_params: [
                        o._nearZ,
                        o._farZ,
                        (l - o._nearZ) / n,
                        (l - a - o._nearZ) / n
                    ]
                }
            };
        }, co = 2048;
        class ho {
            constructor(e, t1){
                this.aabb = e, this.lastCascade = t1;
            }
        }
        class uo {
            add(e, t1) {
                const i = this.receivers[e.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e.key] = new ho(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e) {
                return this.receivers[e.key];
            }
            computeRequiredCascades(t1, i, o) {
                const s = e.da.fromPoints(t1.points);
                let r = 0;
                for(const t1 in this.receivers){
                    const n = this.receivers[t1];
                    if (!n) continue;
                    if (!s.intersectsAabb(n.aabb)) continue;
                    n.aabb.min = s.closestPoint(n.aabb.min), n.aabb.max = s.closestPoint(n.aabb.max);
                    const a = n.aabb.getCorners();
                    for(let t1 = 0; t1 < o.length; t1++){
                        let s = !0;
                        for (const r of a){
                            const n = [
                                r[0] * i,
                                r[1] * i,
                                r[2]
                            ];
                            if (e.ag(n, n, o[t1].matrix), n[0] < -1 || n[0] > 1 || n[1] < -1 || n[1] > 1) {
                                s = !1;
                                break;
                            }
                        }
                        if (n.lastCascade = t1, r = Math.max(r, t1), s) break;
                    }
                }
                return r + 1;
            }
        }
        class _o {
            constructor(e){
                this.painter = e, this._enabled = !1, this._drawShadowAfterLayer = -1, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new uo, this._depthMode = new Wi(e.context.gl.LEQUAL, Wi.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this._forceDisable = !1, this.useNormalOffset = !1;
            }
            destroy() {
                for (const e of this._cascades)e.texture.destroy(), e.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(t1, i) {
                const o = this.painter;
                if (this._enabled = !1, this._drawShadowAfterLayer = -1, this._receivers.clear(), !i || !i.properties) return;
                const s = i.properties.get("shadow-intensity"), r = i.properties.get("shadow-draw-before-layer");
                if (!i.shadowsEnabled() || s <= 0) return;
                let n = -1, a = 0;
                for (const e of o.style.order){
                    const i = o.style._mergedLayers[e];
                    i.hasShadowPass() && !i.isHidden(t1.zoom) && (n = a), !r || r !== e && r !== i.slot || (this._drawShadowAfterLayer = a > 0 ? a - 1 : 0), a += 1;
                }
                if (this._enabled = n >= 0, !this.enabled) return;
                this._drawShadowAfterLayer < 0 && (this._drawShadowAfterLayer = n);
                const l = o.context, c = co, h = co;
                if (0 === this._cascades.length || co !== this._cascades[0].texture.size[0]) {
                    this._cascades = [];
                    for(let t1 = 0; t1 < 2; ++t1){
                        const t1 = o._shadowMapDebug, i = l.gl, s = l.createFramebuffer(c, h, t1 ? 1 : 0, "texture"), r = new e.T(l, {
                            width: c,
                            height: h,
                            data: null
                        }, i.DEPTH_COMPONENT16);
                        if (s.depthAttachment.set(r.texture), t1) {
                            const t1 = new e.T(l, {
                                width: c,
                                height: h,
                                data: null
                            }, i.RGBA8);
                            s.colorAttachment0.set(t1.texture);
                        }
                        this._cascades.push({
                            framebuffer: s,
                            texture: r,
                            matrix: [],
                            far: 0,
                            boundingSphereRadius: 0,
                            frustum: new e.cC,
                            scale: 0
                        });
                    }
                }
                this.shadowDirection = fo(i);
                let d = 0;
                if (t1.elevation) {
                    const e = t1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    e.visibleDemTiles.filter((e)=>e.dem).forEach((e)=>{
                        const t1 = e.dem.tree;
                        i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                    }), 1e4 !== i[0] && (d = (i[1] - i[0]) * e.exaggeration());
                }
                const u = 1.5 * t1.cameraToCenterDistance, _ = 3 * u, p = new Float64Array(16);
                for(let i = 0; i < this._cascades.length; ++i){
                    const o = this._cascades[i];
                    let s = t1.height / 50, r = 1;
                    0 === i ? r = u : (s = u, r = _);
                    const [n, a] = go(t1, this.shadowDirection, s, r, co, d);
                    o.scale = t1.scale, o.matrix = n, o.boundingSphereRadius = a, e.bm(p, o.matrix), o.frustum = e.cC.fromInvProjectionMatrix(p, 1, 0, !0), o.far = r;
                }
                const f = this._cascades.length - 1;
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[f].far,
                    this._cascades[f].far
                ], this._uniformValues.u_shadow_intensity = s, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = .00048828125, this._uniformValues.u_shadow_map_resolution = co, this._uniformValues.u_shadowmap_0 = 11, this._uniformValues.u_shadowmap_1 = 12, this._groundShadowTiles = o.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const m = o.transform.elevation;
                for (const e of this._groundShadowTiles){
                    let t1 = {
                        min: 0,
                        max: 0
                    };
                    if (m) {
                        const i = m.getMinMaxForTile(e);
                        i && (t1 = i);
                    }
                    this.addShadowReceiver(e.toUnwrapped(), t1.min, t1.max);
                }
            }
            get enabled() {
                return this._enabled && !this._forceDisable;
            }
            set enabled(e) {
                this._enabled = e;
            }
            drawShadowPass(t1, i) {
                if (!this.enabled) return;
                const o = this.painter, s = o.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), s.viewport.set([
                    0,
                    0,
                    co,
                    co
                ]);
                for(let r = 0; r < this._numCascadesToRender; ++r){
                    o.currentShadowCascade = r, s.bindFramebuffer.set(this._cascades[r].framebuffer.framebuffer), s.clear({
                        color: e.ap.white,
                        depth: 1
                    });
                    for (const e of t1.order){
                        const s = t1._mergedLayers[e];
                        if (!s.hasShadowPass() || s.isHidden(o.transform.zoom)) continue;
                        const r = t1.getLayerSourceCache(s), n = r ? i[r.id] : void 0;
                        ("model" === s.type || n && n.length) && o.renderLayer(o, r, s, n);
                    }
                }
                o.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this.enabled) return;
                const e = this.painter, t1 = e.style, i = e.context, o = i.gl, s = t1.directionalLight, r = t1.ambientLight;
                if (!s || !r) return;
                const n = [], a = lo(e, e.longestCutoffRange);
                a.shouldRenderCutoff && n.push("RENDER_CUTOFF"), n.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && n.push("NORMAL_OFFSET");
                const l = mo(t1, s, r), c = new Wi(o.LEQUAL, Wi.ReadOnly, e.depthRangeFor3D), h = new Xi({
                    func: o.EQUAL,
                    mask: 255
                }, 0, 255, o.KEEP, o.KEEP, o.KEEP);
                for (const t1 of this._groundShadowTiles){
                    const s = t1.toUnwrapped(), r = e.isTileAffectedByFog(t1), d = e.getOrCreateProgram("groundShadow", {
                        defines: n,
                        overrideFog: r
                    });
                    this.setupShadows(s, d), e.uploadCommonUniforms(i, d, s, null, a);
                    const u = so(e.transform.calculateProjMatrix(s), l);
                    d.draw(e, o.TRIANGLES, c, h, Zi.multiply, Ji.disabled, u, "ground_shadow", e.tileExtentBuffer, e.quadTriangleIndexBuffer, e.tileExtentSegments, null, e.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? Zi.unblended : Zi.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getGroundShadowLayerIndex() {
                return this._drawShadowAfterLayer;
            }
            calculateShadowPassMatrixFromTile(t1) {
                const i = this.painter.transform, o = i.calculatePosMatrix(t1, i.worldSize);
                return e.aC(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
            }
            calculateShadowPassMatrixFromMatrix(t1) {
                const i = e.bA(t1);
                return e.aC(i, this._cascades[this.painter.currentShadowCascade].matrix, t1), i;
            }
            setupShadows(t1, i, o) {
                if (!this.enabled) return;
                const s = this.painter.transform, r = this.painter.context, n = r.gl, a = this._uniformValues, l = new Float64Array(16), c = s.calculatePosMatrix(t1, s.worldSize);
                for(let t1 = 0; t1 < this._cascades.length; t1++)e.aC(l, this._cascades[t1].matrix, c), a[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(l), r.activeTexture.set(n.TEXTURE0 + 11 + t1), this._cascades[t1].texture.bindExtraParam(n.LINEAR, n.LINEAR, n.CLAMP_TO_EDGE, n.CLAMP_TO_EDGE, n.GREATER);
                if (this.useNormalOffset = !!o, this.useNormalOffset) {
                    const i = e.d8(t1.canonical), r = 2 / s.tileSize * e.am / co, n = r * this._cascades[0].boundingSphereRadius, l = r * this._cascades[this._cascades.length - 1].boundingSphereRadius, c = ("vector-tile" === o ? 1 : 3) * function(t1) {
                        const i = e.aB((t1 - 22) / -22, 0, 1);
                        return .125 * (1 - i) + 4 * i;
                    }(s.zoom);
                    a.u_shadow_normal_offset = [
                        i,
                        n * c,
                        l * c
                    ], a.u_shadow_bias = [
                        1e-4,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(r, a);
            }
            setupShadowsFromMatrix(t1, i, o = !1) {
                if (!this.enabled) return;
                const s = this.painter.context, r = s.gl, n = this._uniformValues, a = new Float64Array(16);
                for(let i = 0; i < 2; i++)e.aC(a, this._cascades[i].matrix, t1), n[0 === i ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(a), s.activeTexture.set(r.TEXTURE0 + 11 + i), this._cascades[i].texture.bindExtraParam(r.LINEAR, r.LINEAR, r.CLAMP_TO_EDGE, r.CLAMP_TO_EDGE, r.GREATER);
                this.useNormalOffset = o, o ? (n.u_shadow_normal_offset = [
                    1,
                    3,
                    3
                ], n.u_shadow_bias = [
                    6e-5,
                    .0012,
                    .012
                ]) : n.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ], i.setShadowUniformValues(s, n);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t1, i, o, s) {
                if (s[2] >= 0) return {};
                const r = (function(t1, i, o) {
                    const s = o / (1 << t1.canonical.z);
                    return new e.da([
                        t1.canonical.x * s + t1.wrap * o,
                        t1.canonical.y * s + t1.wrap * o,
                        0
                    ], [
                        (t1.canonical.x + 1) * s + t1.wrap * o,
                        (t1.canonical.y + 1) * s + t1.wrap * o,
                        i
                    ]);
                })(t1, i, o).getCorners(), n = i / -s[2];
                s[0] < 0 ? (e.d9(r[0], r[0], [
                    s[0] * n,
                    0,
                    0
                ]), e.d9(r[3], r[3], [
                    s[0] * n,
                    0,
                    0
                ])) : s[0] > 0 && (e.d9(r[1], r[1], [
                    s[0] * n,
                    0,
                    0
                ]), e.d9(r[2], r[2], [
                    s[0] * n,
                    0,
                    0
                ])), s[1] < 0 ? (e.d9(r[0], r[0], [
                    0,
                    s[1] * n,
                    0
                ]), e.d9(r[1], r[1], [
                    0,
                    s[1] * n,
                    0
                ])) : s[1] > 0 && (e.d9(r[2], r[2], [
                    0,
                    s[1] * n,
                    0
                ]), e.d9(r[3], r[3], [
                    0,
                    s[1] * n,
                    0
                ]));
                const a = {};
                return a.vertices = r, a.planes = [
                    po(r[1], r[0], r[4]),
                    po(r[2], r[1], r[5]),
                    po(r[3], r[2], r[6]),
                    po(r[0], r[3], r[7])
                ], a;
            }
            addShadowReceiver(t1, i, o) {
                this._receivers.add(t1, e.da.fromTileIdAndHeight(t1, i, o));
            }
            getMaxCascadeForTile(e) {
                const t1 = this._receivers.get(e);
                return t1 && t1.lastCascade ? t1.lastCascade : 0;
            }
        }
        function po(t1, i, o) {
            const s = e.aw([], o, i), r = e.aw([], t1, i), n = e.bJ([], s, r), a = e.ah(n);
            return 0 === a ? [
                0,
                0,
                1,
                0
            ] : (e.c6(n, n, 1 / a), [
                n[0],
                n[1],
                n[2],
                -e.bK(n, i)
            ]);
        }
        function fo(t1) {
            const i = t1.properties.get("direction"), o = e.d5(i.x, i.y, i.z);
            o[2] = e.aB(o[2], 0, 75);
            const s = e.d7([
                o[0],
                o[1],
                o[2]
            ]);
            return e.d6(s.x, s.y, s.z);
        }
        function mo(t1, i, o) {
            const s = "none" === i.properties.get("color-use-theme"), r = i.properties.get("color"), n = i.properties.get("intensity"), a = i.properties.get("direction"), l = [
                a.x,
                a.y,
                a.z
            ], c = "none" === o.properties.get("color-use-theme"), h = o.properties.get("color"), d = o.properties.get("intensity"), u = Math.max(e.bK([
                0,
                0,
                1
            ], l), 0), _ = [
                0,
                0,
                0
            ];
            e.c6(_, h.toPremultipliedRenderColor(c ? null : t1.getLut(i.scope)).toArray01Linear().slice(0, 3), d);
            const p = [
                0,
                0,
                0
            ];
            return e.c6(p, r.toPremultipliedRenderColor(s ? null : t1.getLut(o.scope)).toArray01Linear().slice(0, 3), u * n), e.dc([
                _[0] > 0 ? _[0] / (_[0] + p[0]) : 0,
                _[1] > 0 ? _[1] / (_[1] + p[1]) : 0,
                _[2] > 0 ? _[2] / (_[2] + p[2]) : 0
            ]);
        }
        function go(t1, i, o, s, r, n) {
            const a = t1.zoom, l = t1.scale, c = t1.worldSize, h = 1 / c, d = t1.aspect, u = Math.sqrt(1 + d * d) * Math.tan(.5 * t1.fovX), _ = u * u, p = s - o, f = s + o;
            let m, g;
            _ > p / f ? (m = s, g = s * u) : (m = .5 * f * (1 + _), g = .5 * Math.sqrt(p * p + 2 * (s * s + o * o) * _ + f * f * _ * _));
            const v = t1.projection.pixelsPerMeter(t1.center.lat, c), y = t1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * h
            ];
            e.ag(x, x, y);
            let b = g * h;
            const w = function(i) {
                return i[0] /= l, i[1] /= l, i[2] = e.cg(i[2], t1._center.lat), i;
            }, T = t1._edgeInsets;
            if (!(0 === T.left && 0 === T.top && 0 === T.right && 0 === T.bottom || T.left === T.right && T.top === T.bottom)) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, "meters" === t1.projection.zAxisUnit ? v : 1), r = t1._camera.getCameraToClipPerspective(t1._fov, t1.width / t1.height, o, s);
                r[8] = 2 * -t1.centerOffset.x / t1.width, r[9] = 2 * t1.centerOffset.y / t1.height;
                const n = new Float64Array(16);
                e.cQ(n, r, i);
                const l = new Float64Array(16);
                e.bm(l, n);
                const h = e.cC.fromInvProjectionMatrix(l, c, a, !0);
                for (const t1 of h.points){
                    const i = w(t1);
                    b = Math.max(b, e.c7(e.db([], x, i)));
                }
            }
            b *= r / (r - 1);
            const E = Math.acos(i[2]), S = Math.atan2(-i[0], -i[1]), I = new oo;
            I.position = x, I.setPitchBearing(E, S);
            const C = I.getWorldToCamera(c, v), R = b * c, A = Math.min(t1._mercatorZfromZoom(17) * c * -2, -2 * R), D = I.getCameraToClipOrthographic(-R, R, -R, R, A, (R + n * v) / i[2]), L = new Float64Array(16);
            e.aC(L, D, C);
            const P = e.d6(Math.floor(1e6 * x[0]) / 1e6 * c, Math.floor(1e6 * x[1]) / 1e6 * c, 0), O = .5 * r, z = [
                0,
                0,
                0
            ];
            e.ag(z, P, L), e.c6(z, z, O);
            const M = [
                Math.floor(z[0]),
                Math.floor(z[1]),
                Math.floor(z[2])
            ], F = [
                0,
                0,
                0
            ];
            e.aw(F, z, M), e.c6(F, F, -1 / O);
            const k = new Float64Array(16);
            return e.bB(k), e.bs(k, k, F), e.aC(L, k, L), [
                L,
                R
            ];
        }
        class vo extends e.E {
            constructor(e){
                super(), this.requestManager = e, this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            loadModel(t1, i) {
                return e.dd(this.requestManager.transformRequest(i, e.R.Model).url).then((o)=>{
                    const s = e.de(o), r = new e.df(t1, i, void 0, void 0, s);
                    return r.computeBoundsAndApplyParent(), r;
                }).catch((o)=>{
                    if (o && 404 === o.status) return null;
                    this.fire(new e.z(new Error(`Could not load model ${t1} from ${i}: ${o.message}`)));
                });
            }
            load(t1, i, o = {
                forceReload: !1
            }) {
                this.models[i] || (this.models[i] = {});
                const s = Object.keys(t1), r = [], n = [];
                for (const e of s){
                    const s = t1[e];
                    this.hasURLBeenRequested(s) && !o.forceReload || (this.modelByURL[s] = {
                        modelId: e,
                        scope: i
                    }, r.push(this.loadModel(e, s)), n.push(e)), this.models[i][e] || (this.models[i][e] = {
                        model: null,
                        numReferences: 1
                    });
                }
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + n.length, Promise.allSettled(r).then((t1)=>{
                    for(let e = 0; e < t1.length; e++){
                        const { status: o } = t1[e];
                        if ("rejected" === o) continue;
                        const { value: s } = t1[e];
                        this.models[i][n[e]] || (this.models[i][n[e]] = {
                            model: null,
                            numReferences: 1
                        }), this.models[i][n[e]].model = s;
                    }
                    this.numModelsLoading[i] -= n.length, this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e.z(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e in this.numModelsLoading)if (this.numModelsLoading[e] > 0) return !1;
                return !0;
            }
            hasModel(e, t1, i = {
                exactIdMatch: !1
            }) {
                return !!(i.exactIdMatch ? this.getModel(e, t1) : this.getModelByURL(this.modelUris[t1][e]));
            }
            getModel(e, t1) {
                return this.models[t1] || (this.models[t1] = {}), this.models[t1][e] ? this.models[t1][e].model : void 0;
            }
            getModelByURL(e) {
                if (!e) return null;
                const t1 = this.modelByURL[e];
                return t1 ? this.models[t1.scope][t1.modelId].model : null;
            }
            hasModelBeenAdded(e, t1) {
                return this.models[t1] && void 0 !== this.models[t1][e];
            }
            getModelURIs(e) {
                return this.modelUris[e] || {};
            }
            addModel(e, t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = this.requestManager.normalizeModelURL(t1);
                if ((this.hasModel(e, i, {
                    exactIdMatch: !0
                }) || this.hasModelBeenAdded(e, i)) && this.modelUris[i][e] === o) this.models[i][e].numReferences++;
                else if (this.hasURLBeenRequested(o)) {
                    const { scope: e, modelId: t1 } = this.modelByURL[o];
                    this.models[e][t1].numReferences++;
                } else this.modelUris[i][e] = o, this.load({
                    [e]: this.modelUris[i][e]
                }, i);
            }
            addModelURLs(e, t1) {
                this.models[t1] || (this.models[t1] = {}), this.modelUris[t1] || (this.modelUris[t1] = {});
                const i = this.modelUris[t1];
                for(const t1 in e)i[t1] = this.requestManager.normalizeModelURL(e[t1]);
            }
            reloadModels(e) {
                this.load(this.modelUris[e], e, {
                    forceReload: !0
                });
            }
            addModelsFromBucket(t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = {};
                for (const s of t1)this.hasModel(s, i, {
                    exactIdMatch: !0
                }) || this.hasURLBeenRequested(s) ? this.models[i][s].numReferences++ : this.modelUris[i][s] && !this.hasURLBeenRequested(s) ? o[s] = this.modelUris[i][s] : !this.hasURLBeenRequested(s) && e.dg(s, !1) && (this.modelUris[i][s] = this.requestManager.normalizeModelURL(s), o[s] = this.modelUris[i][s]);
                this.load(o, i);
            }
            hasURLBeenRequested(e) {
                return void 0 !== this.modelByURL[e];
            }
            removeModel(e, t1, i = !1, o = !1) {
                if (this.models[t1] && this.models[t1][e] && (this.models[t1][e].numReferences--, 0 === this.models[t1][e].numReferences || o)) {
                    const o = this.modelUris[t1][e];
                    i || delete this.modelUris[t1][e], delete this.modelByURL[o];
                    const s = this.models[t1][e].model;
                    if (!s) return;
                    delete this.models[t1][e], s.destroy();
                }
            }
            destroy() {
                for (const e of Object.keys(this.models))for (const t1 of Object.keys(this.models[e])){
                    const i = this.models[e][t1].model;
                    delete this.models[e][t1], i && i.destroy();
                }
                this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            listModels(e) {
                return this.models[e] || (this.models[e] = {}), Object.keys(this.models[e]);
            }
            upload(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e.context);
            }
        }
        const yo = e.a7.colorTheme, xo = new e.aa({
            data: new e.ab(yo.data)
        });
        function bo(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e.o.devicePixelRatio, { left: o, top: s, width: r, height: n } = t1.metadata.content_area, a = o * i, l = s * i;
            return [
                a,
                l,
                a + r * i,
                l + n * i
            ];
        }
        function wo(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e.o.devicePixelRatio,
                    i * e.o.devicePixelRatio
                ]);
        }
        class To {
            constructor(e, t1, i){
                this.id = e, this.scope = t1, this.sourceCache = i, this.pendingRequests = new Set, this.missingRequests = new Set;
            }
            addPendingRequest(e) {
                this.missingRequests.has(e.name) || this.pendingRequests.has(e.name) || this.pendingRequests.add(e.name);
            }
            hasPendingRequests() {
                return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
                const t1 = new Map;
                if (!this.sourceCache.loaded()) return t1;
                const i = this.sourceCache.getVisibleCoordinates();
                if (0 === i.length) return t1;
                const o = this.sourceCache.getSource();
                if (!(o instanceof pt)) return t1;
                const s = i.map((e)=>this.sourceCache.getTile(e)), r = o.getImages(s, Array.from(this.pendingRequests));
                for (const [i, o] of r)t1.set(e.I.from({
                    name: i,
                    iconsetId: this.id
                }), o), this.pendingRequests.delete(i);
                for (const e of this.pendingRequests)this.missingRequests.add(e);
                return this.pendingRequests.clear(), t1;
            }
        }
        class Eo {
            constructor(){
                this._previousClosestBuildingId = null, this._hysteresisRatio = .8, this._indoorMinimumZoom = 16;
            }
            findClosestBuilding(e, t1, i, o, s) {
                if (i < this._indoorMinimumZoom) return this._previousClosestBuildingId = null, null;
                let r = null, n = Number.MAX_VALUE, a = Number.MAX_VALUE, l = !1;
                const c = this._previousClosestBuildingId ? e[this._previousClosestBuildingId] : null;
                this._previousClosestBuildingId && c && this._isBuildingVisible(c, o, s) && (l = !0, a = this._calculateDistance(t1, c));
                for (const [i, a] of Object.entries(e)){
                    if (!this._isBuildingVisible(a, o, s)) continue;
                    const e = this._calculateDistance(t1, a);
                    e < n && (n = e, r = i);
                }
                return l && r && this._previousClosestBuildingId && r !== this._previousClosestBuildingId ? n > a * this._hysteresisRatio && (r = this._previousClosestBuildingId) : l && !r && (r = this._previousClosestBuildingId), this._previousClosestBuildingId = r, r;
            }
            _calculateDistance(e, t1) {
                if (!t1.center) return Number.MAX_VALUE;
                const i = e.lat - t1.center[1], o = e.lng - t1.center[0];
                return i * i + o * o;
            }
            _isBuildingVisible(t1, i, o) {
                if (!o) return !1;
                for (const i of t1.floorIds){
                    const s = t1.floors[i];
                    if (!s.geometry) continue;
                    const r = s.geometry;
                    if ("Polygon" === r.type) {
                        const t1 = this._convertRingToPoints(r.coordinates[0]);
                        if (e.bY(t1, o)) return !0;
                    } else if ("MultiPolygon" === r.type) {
                        const t1 = this._convertMultiPolygonToPoints(r.coordinates);
                        if (e.di(o, t1)) return !0;
                    }
                }
                return !1;
            }
            _convertRingToPoints(t1) {
                return t1.map((t1)=>new e.P(t1[0], t1[1]));
            }
            _convertMultiPolygonToPoints(t1) {
                return t1.map((t1)=>0 === t1.length ? [] : t1[0].map((t1)=>new e.P(t1[0], t1[1])));
            }
        }
        class So extends e.E {
            constructor(t1){
                super(), this._style = t1, this._buildings = {}, this._activeFloors = new Set, this._indoorState = {
                    selectedFloorId: null,
                    activeFloorsVisible: !1,
                    activeFloors: this._activeFloors
                }, this._buildingDetectionStrategy = new Eo, e.aZ([
                    "_updateUI"
                ], this), this._style.on("style.load", ()=>{
                    this._style.isIndoorEnabled() && (this._style.map.on("load", this._updateUI), this._style.map.on("move", this._updateUI), this._style.map.on("idle", this._updateUI), this._updateUI());
                });
            }
            destroy() {
                this._buildings = {}, this._activeFloors = new Set, this._indoorState = null;
            }
            selectFloor(e) {
                e === this._selectedFloorId && this._indoorState && this._indoorState.activeFloorsVisible || (this._selectedFloorId = e, this._recalculateActiveFloors());
            }
            setActiveFloorsVisibility(e) {
                this._updateActiveFloors(e), this._updateIndoorSelector();
            }
            setIndoorData(e) {
                let t1 = !1;
                for (const [i, o] of Object.entries(e.buildings))if (this._buildings[i]) for (const e of o.floorIds)this._buildings[i].floorIds.add(e), this._buildings[i].floors[e] ? this._mergeFloors(this._buildings[i].floors[e], o.floors[e]) : (this._buildings[i].floors[e] = o.floors[e], this._buildings[i].floorIds.add(e), t1 = !0);
                else this._buildings[i] = o, t1 = !0;
                t1 && this._recalculateActiveFloors(), this._updateIndoorSelector();
            }
            _mergeFloors(e, t1) {
                t1.geometry && (e.geometry ? ("Polygon" === e.geometry.type && (e.geometry = {
                    type: "MultiPolygon",
                    coordinates: [
                        e.geometry.coordinates
                    ]
                }), "Polygon" === t1.geometry.type ? e.geometry.coordinates.push(t1.geometry.coordinates) : "MultiPolygon" === t1.geometry.type && e.geometry.coordinates.push(...t1.geometry.coordinates)) : e.geometry = t1.geometry);
            }
            getIndoorTileOptions(e, t1) {
                return this._indoorState ? {
                    sourceLayers: this._style.getIndoorSourceLayers(e, t1),
                    indoorState: this._indoorState
                } : null;
            }
            _updateUI() {
                const e = this._style.map.transform, t1 = this._buildingDetectionStrategy.findClosestBuilding(this._buildings, e.center, e.zoom, e.getBounds(), this._makeViewportPolygon());
                if (t1 !== this._closestBuildingId) {
                    const e = this._closestBuildingId;
                    this._closestBuildingId = t1, this._updateIndoorSelector();
                    const i = !e && this._indoorState;
                    (!t1 && this._indoorState || i) && (this._indoorState.activeFloors = i ? this._activeFloors : new Set, this._indoorState.activeFloorsVisible = !!i, this._style.updateIndoorDependentLayers());
                }
            }
            getControlState() {
                const e = this._buildings, t1 = this._closestBuildingId, i = t1 && e ? e[t1] : void 0;
                if (!i) return {
                    selectedFloorId: null,
                    activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                    floors: []
                };
                let o = null;
                for (const e of i.floorIds)if (this._activeFloors && this._activeFloors.has(e)) {
                    o = e;
                    break;
                }
                const s = Array.from(i.floorIds).map((e)=>({
                        id: e,
                        name: i.floors[e].name,
                        zIndex: i.floors[e].zIndex
                    })).sort((e, t1)=>t1.zIndex - e.zIndex).filter((e, t1, i)=>0 === t1 || e.zIndex !== i[t1 - 1].zIndex);
                return {
                    selectedFloorId: o,
                    activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                    floors: s
                };
            }
            _updateIndoorSelector() {
                this.fire(new e.A("selector-update", this.getControlState()));
            }
            _updateActiveFloors(e) {
                this._indoorState = {
                    selectedFloorId: this._selectedFloorId,
                    activeFloorsVisible: e,
                    activeFloors: this._activeFloors
                }, this._style.updateIndoorDependentLayers();
            }
            _makeViewportPolygon() {
                const t1 = this._style.map.transform, i = t1.width, o = t1.height;
                return [
                    t1.pointLocation(new e.P(0, 0)),
                    t1.pointLocation(new e.P(i, 0)),
                    t1.pointLocation(new e.P(i, o)),
                    t1.pointLocation(new e.P(0, o))
                ].map((t1)=>new e.P(t1.lng, t1.lat));
            }
            _recalculateActiveFloors() {
                if (!this._buildings) return;
                const t1 = e.dj.calculate(this._buildings, this._selectedFloorId, this._activeFloors);
                this._activeFloors = t1, this._updateActiveFloors(!!this._indoorState && this._indoorState.activeFloorsVisible), this._updateIndoorSelector();
            }
        }
        const Io = (e, t1)=>Fe(e, t1 && t1.filter((e)=>"source.canvas" !== e.identifier)), Co = e.aI(Vt, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setLayerProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport",
            "addIconset",
            "removeIconset"
        ]), Ro = e.aI(Vt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), Ao = new Set([
            "background",
            "sky",
            "slot",
            "custom"
        ]), Do = {
            version: 8,
            layers: [],
            sources: {}
        }, Lo = {
            duration: 300,
            delay: 0
        };
        class Po extends e.E {
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = Object.assign({}, Lo), this._buildingIndex = new Nt(this), this.crossTileSymbolIndex = new Hi, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedIndoor = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = !1, this._hasAppearances = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._importedAsBasemap = !1, this._changes = i.styleChanges || new W, this._hasDataDrivenEmissive = !1, this.indoorManager = new So(this), this.dispatcher = i.dispatcher ? i.dispatcher : new e.D(e.dk(), this), i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new X(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e.dl(t1._requestManager, i.localFontFamily ? e.dm.all : i.localIdeographFontFamily ? e.dm.ideographs : e.dm.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new vo(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set, this._indoorDependentLayers = i.indoorDependentLayers ? i.indoorDependentLayers : new Set, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig, this.dispatcher.broadcast("setReferrer", e.dn());
                const o = this;
                this._rtlTextPluginCallback = Po.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e.dp(t1), i && i.every((e)=>e)) for(const e in o._sourceCaches){
                            const t1 = o._sourceCaches[e], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e)=>{
                    if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
                    const t1 = this.getOwnSource(e.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e in this._layers){
                        const i = this._layers[e];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e) {
                return e ? ("string" == typeof e ? this.loadURL(e) : this.loadJSON(e), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e.h(t1)) return t1;
                    const i = e.dq(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e) {
                        return i;
                    }
                    return i;
                }
                return `json://${e.dr(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, o) {
                this.globalId = this._getGlobalId(t1);
                const s = (e, t1)=>{
                    try {
                        t1(null, this.setState(e, o));
                    } catch (e) {
                        t1(e, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const o = this.map._requestManager.normalizeStyleURL(t1), r = this.map._requestManager.transformRequest(o, e.R.Style);
                    e.m(r, (t1, o)=>{
                        t1 ? this.fire(new e.z(t1)) : o && s(o, i);
                    });
                } else "object" == typeof t1 && s(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e.h(t1);
                this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const s = this.importsCache.get(t1);
                if (s) return this._load(s, o);
                const r = this.map._requestManager.transformRequest(t1, e.R.Style);
                this._request = e.m(r, (i, s)=>{
                    if (this._request = null, i) this.fire(new e.z(i));
                    else if (s) return this.importsCache.set(t1, s), this._load(s, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                })), this.globalId = this._getGlobalId(t1), this._request = e.o.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e.A("dataloading", {
                    dataType: "style"
                })), this._load(Do, !1);
            }
            _loadImports(t1, i, o) {
                if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const s = [];
                for (const e of t1){
                    const t1 = this._createFragmentStyle(e), r = new Promise((e)=>{
                        t1.once("style.import.load", e), t1.once("error", e);
                    }).then(()=>this.mergeAll());
                    if (s.push(r), this.resolvedImports.has(e.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const n = e.data || this.importsCache.get(e.url);
                    n ? (t1.loadJSON(n, {
                        validate: i
                    }), this._isInternalStyle(n) && (t1.globalId = null)) : e.url ? t1.loadURL(e.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const a = {
                        style: t1,
                        id: e.id,
                        config: e.config
                    };
                    if (o) {
                        const e = this.fragments.findIndex(({ id: e })=>e === o);
                        this.fragments = this.fragments.slice(0, e).concat(a).concat(this.fragments.slice(e));
                    } else this.fragments.push(a);
                }
                return Promise.allSettled(s);
            }
            getImportGlobalIds(e = this, t1 = new Set) {
                for (const i of e.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e.C(t1.id, this.scope) : t1.id;
                let o;
                const s = this._initialConfig && this._initialConfig[i];
                (t1.config || s) && (o = Object.assign({}, t1.config, s));
                const r = new Po(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: o,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    configDependentLayers: this._configDependentLayers,
                    indoorDependentLayers: this._indoorDependentLayers
                });
                return r.setEventedParent(this.map, {
                    style: r
                }), r;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this._updateLayers(this._indoorDependentLayers), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e) {
                return this.isRootStyle() && (e.fragment || !!e.schema && !1 !== e.fragment);
            }
            _load(t1, i) {
                if (this._isInternalStyle(t1)) {
                    const e = Object.assign({}, Do, {
                        imports: [
                            {
                                id: "basemap",
                                data: t1,
                                url: ""
                            }
                        ]
                    }, t1.center ? {
                        center: t1.center
                    } : {}, t1.bearing ? {
                        bearing: t1.bearing
                    } : {}, t1.pitch ? {
                        pitch: t1.pitch
                    } : {}, t1.zoom ? {
                        zoom: t1.zoom
                    } : {}, t1.light ? {
                        light: t1.light
                    } : {});
                    return this._importedAsBasemap = !0, void this._load(e, i);
                }
                if (this.updateConfig(this._config, t1.schema), i && Io(this, we(t1))) return;
                this._loaded = !0, this.stylesheet = e.ds(t1);
                const o = ()=>{
                    for(const e in t1.sources)this.addSource(e, t1.sources[e], {
                        validate: !1,
                        isInitialLoad: !0
                    });
                    if (t1.iconsets) for(const e in t1.iconsets)this.addIconset(e, t1.iconsets[e]);
                    t1.sprite ? this._loadIconset(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    })), !this.glyphManager.url && t1.glyphs && this.glyphManager.setURL(t1.glyphs);
                    const o = jt(this.stylesheet.layers);
                    if (this._order = o.map((e)=>e.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e = this.stylesheet.lights[0];
                            this.light = new Ne(e.properties, e.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new Ne(this.stylesheet.light)), this._layers = {};
                    for (const t1 of o){
                        const i = e.dx(t1, this.scope, this._styleColorTheme.lut, this.options);
                        0 !== i.expressionDependencies.configDependencies.size && this._configDependentLayers.add(i.fqid), i.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(i.fqid), this._hasAppearances = this._hasAppearances || 0 !== i.getAppearances().length, i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i;
                        const o = this.getOwnLayerSourceCache(i), s = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        o && i.canCastShadows() && s && (o.castsShadows = !0);
                    }
                    this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                    const s = this.stylesheet.terrain;
                    s && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(s, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                    const r = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(), this.fire(new e.A(r ? "style.load" : "style.import.load"));
                    }).catch((t1)=>{
                        this.fire(new e.z(new Error("Failed to load imports", t1))), this.fire(new e.A(r ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(), this.fire(new e.A(r ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const s = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (s) {
                    const t1 = this._evaluateColorThemeData(s);
                    this._loadColorTheme(t1).then(()=>{
                        o();
                    }).catch((t1)=>{
                        e.w(`Couldn't load color theme from the stylesheet: ${t1}`), o();
                    });
                } else this._styleColorTheme.lut = null, o();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            hasAppearances() {
                return this._hasAppearances || this.fragments.some((e)=>e.style.hasAppearances());
            }
            mergeAll() {
                let e, t1, i, o, s, r, n, a, l, c;
                const h = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((d)=>{
                    if (d.stylesheet) {
                        if (null != d.light && (e = d.light), d.stylesheet.lights) for (const e of d.stylesheet.lights)"ambient" === e.type && null != d.ambientLight && (t1 = d.ambientLight), "directional" === e.type && null != d.directionalLight && (i = d.directionalLight);
                        o = this._prioritizeTerrain(o, d.terrain, d.stylesheet.terrain), d.stylesheet.fog && null != d.fog && (s = d.fog), d.stylesheet.snow && null != d.snow && (r = d.snow), d.stylesheet.rain && null != d.rain && (n = d.rain), null != d.stylesheet.camera && (c = d.stylesheet.camera), null != d.stylesheet.projection && (a = d.stylesheet.projection), null != d.stylesheet.transition && (l = d.stylesheet.transition), h[d.scope] = d._styleColorTheme;
                    }
                }), this.light = e, this.ambientLight = t1, this.directionalLight = i, this.fog = s, this.snow = r, this.rain = n, this._styleColorThemeForScope = h, null === o ? delete this.terrain : this.terrain = o, this.camera = c || {
                    "camera-projection": "perspective"
                }, this.projection = a || {
                    name: "mercator"
                }, this.transition = Object.assign({}, Lo, l), this.mergeSources(), this.mergeLayers(), this.mergeIndoor();
            }
            forEachFragmentStyle(e) {
                const t1 = (i)=>{
                    for (const e of i.fragments)t1(e.style);
                    e(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e, t1, i) {
                const o = e && 0 === e.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : o ? e : null : null != t1 && (!e || o || t1 && 1 === t1.drapeRenderMode) ? t1 : e;
            }
            mergeTerrain() {
                let e;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e = this._prioritizeTerrain(e, t1.terrain, t1.stylesheet.terrain);
                }), null === e ? delete this.terrain : this.terrain = e;
            }
            mergeProjection() {
                let e;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e = t1.stylesheet.projection);
                }), this.projection = e || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const t1 = {}, i = {}, o = {};
                this.forEachFragmentStyle((s)=>{
                    for(const i in s._sourceCaches){
                        const o = e.C(i, s.scope);
                        t1[o] = s._sourceCaches[i];
                    }
                    for(const t1 in s._otherSourceCaches){
                        const o = e.C(t1, s.scope);
                        i[o] = s._otherSourceCaches[t1];
                    }
                    for(const t1 in s._symbolSourceCaches){
                        const i = e.C(t1, s.scope);
                        o[i] = s._symbolSourceCaches[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o;
            }
            mergeIndoor() {
                this.forEachFragmentStyle((t1)=>{
                    if (t1.stylesheet && t1.stylesheet.indoor) for (const i of Object.values(t1.stylesheet.indoor)){
                        const o = i, s = e.C(o.sourceId, t1.scope);
                        this._mergedIndoor[s] = new Set(o.sourceLayers || []);
                    }
                });
            }
            mergeLayers() {
                const t1 = {}, i = [], o = {};
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((o)=>{
                    for (const s of o._order){
                        const r = o._layers[s];
                        if ("slot" === r.type) {
                            const i = e.dt(s);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        r.slot && t1[r.slot] ? t1[r.slot].push(r) : i.push(r);
                    }
                }), this._mergedOrder = [];
                let s = -1;
                const r = (i = [])=>{
                    for (const n of i)if ("slot" === n.type) {
                        const i = e.dt(n.id);
                        t1[i] && r(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e.C(n.id, n.scope);
                        this._mergedOrder.push(t1), o[t1] = n, n.is3D(!!this.terrain) && (this._has3DLayers = !0, s = this._mergedOrder.length - 1), "circle" === n.type && (this._hasCircleLayers = !0), "symbol" === n.type && (this._hasSymbolLayers = !0), "clip" === n.type && (this._clipLayerPresent = !0);
                    }
                };
                if (r(i), this._has3DLayers) {
                    const e = {};
                    for(let t1 = 0; t1 < this._mergedOrder.length; ++t1){
                        const i = this._mergedOrder[t1];
                        e[i] = t1 === s ? 1 : t1 < s ? o[i].hasOcclusionOpacityProperties ? 2 : 0 : 4;
                    }
                    this._mergedOrder.sort((t1, i)=>e[t1] - e[i]);
                }
                this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged(), this._updateDataDrivenEmissiveStrength();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e) {
                return this.stylesheet.camera = Object.assign({}, this.stylesheet.camera, e), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, o) {
                    const s = Object.assign({}, i);
                    for (const e of Object.keys(yo))void 0 === s[e] && (s[e] = yo[e].default);
                    const r = new e.a9(xo, t1, new Map(o));
                    return r.setTransitionOrValue(s, o), r.untransitioned().possiblyEvaluate(new e.ad(0, {
                        worldview: void 0
                    }));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((o, s)=>{
                    const r = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void o();
                    let n = t1;
                    n.startsWith(r) || (n = r + n);
                    const a = e.I.from("mapbox-reserved-lut"), l = new Image;
                    l.src = n, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, s(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: r, height: n, data: c } = e.o.getImageData(l);
                        if (n > 32) return void s(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (r !== n * n) return void s(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(a) && this.removeImage(a), this.addImage(a, {
                            data: new e.q({
                                width: r,
                                height: n
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(a, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, o()) : s(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e) {
                const t1 = this._styleColorThemeForScope[e];
                return t1 ? t1.lut : null;
            }
            setProjection(e) {
                e ? this.stylesheet.projection = e : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let s, r, n;
                    const a = e.o.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e.m(i.transformRequest(i.normalizeSpriteURL(t1, a, ".json"), e.R.SpriteJSON), (e, t1)=>{
                        l = null, n || (n = e, s = t1, h());
                    }), c = e.n(i.transformRequest(i.normalizeSpriteURL(t1, a, ".png"), e.R.SpriteImage), (e, t1)=>{
                        c = null, n || (n = e, r = t1, h());
                    });
                    function h() {
                        if (n) o(n);
                        else if (s && r) {
                            const t1 = e.o.getImageData(r), i = {};
                            for(const o in s){
                                const { width: r, height: n, x: a, y: l, sdf: c, pixelRatio: h, stretchX: d, stretchY: u, content: _ } = s[o], p = new e.q({
                                    width: r,
                                    height: n
                                });
                                e.q.copy(t1, p, {
                                    x: a,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: r,
                                    height: n
                                }, null), i[o] = {
                                    data: p,
                                    pixelRatio: void 0 !== h ? h : 1,
                                    sdf: void 0 !== c && c,
                                    stretchX: d,
                                    stretchY: u,
                                    content: _,
                                    usvg: !1,
                                    version: 0
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e.z(t1));
                    else if (i) {
                        const t1 = new Map;
                        for(const o in i)t1.set(e.I.from(o), i[o]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                });
            }
            addIconset(t1, i) {
                if ("sprite" === i.type) return void this._loadSprite(i.url);
                const o = this.getOwnSourceCache(i.source);
                if (!o) return void this.fire(new e.z(new Error(`Source "${i.source}" as specified by iconset "${t1}" does not exist and cannot be used as an iconset source`)));
                const s = o.getSource();
                if ("raster-array" !== s.type) return void this.fire(new e.z(new Error(`Source "${i.source}" as specified by iconset "${t1}" is not a "raster-array" source and cannot be used as an iconset source`)));
                s.partial = !1;
                const r = new To(t1, this.scope, o);
                this.imageManager.addImageProvider(r, this.scope);
            }
            removeIconset(e) {
                this.imageManager.removeImageProvider(e, this.scope);
            }
            _loadIconset(t1) {
                if (!e.h(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat;
                var o, s;
                this._spriteRequest = (s = (o, s)=>{
                    if (this._spriteRequest = null, o) i ? this._loadSprite(t1) : this.fire(new e.z(o));
                    else if (s) {
                        const t1 = new Map;
                        for(const i in s)t1.set(e.I.from(i), s[i]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                }, e.bv((o = this.map._requestManager).transformRequest(o.normalizeIconsetURL(t1), e.R.Iconset), (t1, i)=>{
                    if (t1) return void s(t1);
                    const o = {}, r = e.dh(new e.bu(i));
                    for (const t1 of r.icons){
                        const i = {
                            version: 1,
                            pixelRatio: e.o.devicePixelRatio,
                            content: bo(t1),
                            stretchX: t1.metadata ? wo(t1.metadata.stretch_x_areas) : void 0,
                            stretchY: t1.metadata ? wo(t1.metadata.stretch_y_areas) : void 0,
                            sdf: !1,
                            usvg: !0,
                            icon: t1
                        };
                        o[t1.name] = i;
                    }
                    s(null, o);
                }));
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e.z(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e in this._sourceCaches)if (!this._sourceCaches[e].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (this.imageManager.hasPatternsInFlight()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e } of this.fragments)if (!e.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e.data = i.style.serialize()), e;
                });
            }
            _serializeSources() {
                const e = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e[i.id] || (e[i.id] = i.serialize());
                }
                return e;
            }
            _serializeLayers(e) {
                const t1 = [];
                for (const i of e){
                    const e = this._layers[i];
                    e && "custom" !== e.type && t1.push(e.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e in this._sourceCaches)if (this._sourceCaches[e].hasTransition()) return !0;
                for(const e in this._layers)if (this._layers[e].hasTransition()) return !0;
                return !1;
            }
            _updateDataDrivenEmissiveStrength() {
                for(const e in this._mergedLayers){
                    const t1 = this._mergedLayers[e];
                    if (t1._transitionablePaint && t1._transitionablePaint._values) {
                        const e = t1._transitionablePaint._values["line-emissive-strength"];
                        if (e && e.value && e.value.isDataDriven()) return void (this._hasDataDrivenEmissive = !0);
                    }
                }
                this._hasDataDrivenEmissive = !1;
            }
            hasDataDrivenEmissiveStrength() {
                return this._hasDataDrivenEmissive;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e) {
                return e ? this.order : this._mergedOrder;
            }
            isLayerDraped(e) {
                return !!this.terrain && e.isDraped(this.getLayerSourceCache(e));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e.z(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e.z(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            precompilePrograms(e, t1) {
                const i = this.map.painter;
                if (i) for(let o = e.minzoom || 0; o < (e.maxzoom || 25.5); o++){
                    const o = e.getProgramIds();
                    if (o) for (const s of o){
                        const o = e.getDefaultProgramParams(s, t1.zoom, this._styleColorTheme.lut);
                        o && (i.style = this, this.fog && (i._fogVisible = !0, o.overrideFog = !0, i.getOrCreateProgram(s, o)), i._fogVisible = !1, o.overrideFog = !1, i.getOrCreateProgram(s, o), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o.overrideRtt = !0, i.getOrCreateProgram(s, o)));
                    }
                }
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i)), t1.worldview !== this._worldview && (this._worldview = t1.worldview, this.dispatcher.broadcast("setWorldview", this._worldview));
                const o = this._changes.isDirty();
                let s = !1;
                if (this._changes.isDirty()) {
                    const e = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e){
                        const { updatedIds: i, removedIds: o } = e[t1];
                        (i || o) && (this._updateWorkerLayers(t1, i, o), s = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const r = {};
                for(const e in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e];
                    r[e] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                for (const e of this._mergedOrder){
                    const i = this._mergedLayers[e];
                    if (("none" !== i.visibility || i.hasTransition()) && i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e = this.getLayerSourceCache(i);
                        e && (e.used = !0, e.tileCoverLift = Math.max(e.tileCoverLift, i.tileCoverLift()));
                    }
                    !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(()=>{
                        this.precompilePrograms(i, t1);
                    }) : this.precompilePrograms(i, t1));
                }
                this._shouldPrecompile && (this._precompileDone = !0), this.terrain && s && this.mergeLayers();
                const n = this.imageManager.getPendingImageProviders();
                for (const e of n)e.sourceCache.used = !0;
                for(const t1 in r){
                    const i = this._mergedSourceCaches[t1];
                    r[t1] !== i.used && i.getSource().fire(new e.A("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), this.imageManager.clearUpdatedImages(this.scope), o && this.fire(new e.A("data", {
                    dataType: "style"
                }));
            }
            updateImageProviders() {
                const e = this.imageManager.getPendingImageProviders();
                for (const t1 of e){
                    const e = t1.resolvePendingRequests(), i = this.getFragmentStyle(t1.scope);
                    i && i.addImages(e);
                }
            }
            _updateTilesForChangedImages() {
                const e = {};
                for(const t1 in this._mergedSourceCaches){
                    const i = this._mergedSourceCaches[t1].getSource().scope;
                    e[i] = e[i] || this._changes.getUpdatedImages(i), 0 !== e[i].length && this._mergedSourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e[i]);
                }
                for(const t1 in e)this._changes.resetUpdatedImages(t1);
            }
            _updateWorkerLayers(e, t1, i) {
                const o = this.getFragmentStyle(e);
                o && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? o._serializeLayers(t1) : [],
                    scope: e,
                    removedIds: i || [],
                    options: o.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), Io(this, we(t1))) return !1;
                (t1 = e.ds(t1)).layers = jt(t1.layers);
                const o = (function(t1, i) {
                    if (!t1) return [
                        {
                            command: Vt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!e.bz(t1.version, i.version)) return [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        if (e.bz(t1.center, i.center) || o.push({
                            command: Vt.setCenter,
                            args: [
                                i.center
                            ]
                        }), e.bz(t1.zoom, i.zoom) || o.push({
                            command: Vt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), e.bz(t1.bearing, i.bearing) || o.push({
                            command: Vt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), e.bz(t1.pitch, i.pitch) || o.push({
                            command: Vt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), e.bz(t1.sprite, i.sprite) || o.push({
                            command: Vt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), e.bz(t1.glyphs, i.glyphs) || o.push({
                            command: Vt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), e.bz(t1.imports, i.imports) || function(t1 = [], i = [], o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map($t), r = i.map($t), n = t1.reduce(Xt, {}), a = i.reduce(Xt, {}), l = s.slice();
                            let c, h, d, u;
                            for(c = 0, h = 0; c < s.length; c++)d = s[c], a.hasOwnProperty(d) ? h++ : (o.push({
                                command: Vt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, h), 1));
                            for(c = 0, h = 0; c < r.length; c++)d = r[r.length - 1 - c], l[l.length - 1 - c] !== d && (n.hasOwnProperty(d) ? (o.push({
                                command: Vt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - h), 1)) : h++, u = l[l.length - c], o.push({
                                command: Vt.addImport,
                                args: [
                                    a[d],
                                    u
                                ]
                            }), l.splice(l.length - c, 0, d));
                            for (const t1 of i){
                                const i = n[t1.id];
                                i && (delete i.data, e.bz(i, t1) || o.push({
                                    command: Vt.updateImport,
                                    args: [
                                        t1.id,
                                        t1
                                    ]
                                }));
                            }
                        }(t1.imports, i.imports, o), e.bz(t1.transition, i.transition) || o.push({
                            command: Vt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), e.bz(t1.light, i.light) || o.push({
                            command: Vt.setLight,
                            args: [
                                i.light
                            ]
                        }), e.bz(t1.fog, i.fog) || o.push({
                            command: Vt.setFog,
                            args: [
                                i.fog
                            ]
                        }), e.bz(t1.snow, i.snow) || o.push({
                            command: Vt.setSnow,
                            args: [
                                i.snow
                            ]
                        }), e.bz(t1.rain, i.rain) || o.push({
                            command: Vt.setRain,
                            args: [
                                i.rain
                            ]
                        }), e.bz(t1.projection, i.projection) || o.push({
                            command: Vt.setProjection,
                            args: [
                                i.projection
                            ]
                        }), e.bz(t1.lights, i.lights) || o.push({
                            command: Vt.setLights,
                            args: [
                                i.lights
                            ]
                        }), e.bz(t1.camera, i.camera) || o.push({
                            command: Vt.setCamera,
                            args: [
                                i.camera
                            ]
                        }), e.bz(t1.iconsets, i.iconsets) || function(t1, i, o) {
                            let s;
                            for(s in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(s) && (i.hasOwnProperty(s) || o.push({
                                command: Vt.removeIconset,
                                args: [
                                    s
                                ]
                            }));
                            for(s in i){
                                if (!i.hasOwnProperty(s)) continue;
                                const r = i[s];
                                t1.hasOwnProperty(s) ? e.bz(t1[s], r) || (o.push({
                                    command: Vt.removeIconset,
                                    args: [
                                        s
                                    ]
                                }), o.push({
                                    command: Vt.addIconset,
                                    args: [
                                        s,
                                        r
                                    ]
                                })) : o.push({
                                    command: Vt.addIconset,
                                    args: [
                                        s,
                                        r
                                    ]
                                });
                            }
                        }(t1.iconsets, i.iconsets, o), !e.bz(t1["color-theme"], i["color-theme"])) return [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        const s = {}, r = [];
                        !function(t1, i, o, s) {
                            let r;
                            for(r in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(r) && (i.hasOwnProperty(r) || Ht(r, o, s));
                            for(r in i){
                                if (!i.hasOwnProperty(r)) continue;
                                const n = i[r];
                                t1.hasOwnProperty(r) ? e.bz(t1[r], n) || ("geojson" === t1[r].type && "geojson" === n.type && Zt(t1, i, r) ? o.push({
                                    command: Vt.setGeoJSONSourceData,
                                    args: [
                                        r,
                                        n.data
                                    ]
                                }) : qt(r, i, o, s)) : Gt(r, i, o);
                            }
                        }(t1.sources, i.sources, r, s);
                        const n = [];
                        t1.layers && t1.layers.forEach((e)=>{
                            e.source && s[e.source] ? o.push({
                                command: Vt.removeLayer,
                                args: [
                                    e.id
                                ]
                            }) : n.push(e);
                        });
                        let a = t1.terrain;
                        a && s[a.source] && (o.push({
                            command: Vt.setTerrain,
                            args: [
                                void 0
                            ]
                        }), a = void 0), o = o.concat(r), e.bz(a, i.terrain) || o.push({
                            command: Vt.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(t1, i, o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map($t), r = i.map($t), n = t1.reduce(Xt, {}), a = i.reduce(Xt, {}), l = s.slice(), c = Object.create(null);
                            let h, d, u, _, p, f, m;
                            for(h = 0, d = 0; h < s.length; h++)u = s[h], a.hasOwnProperty(u) ? d++ : (o.push({
                                command: Vt.removeLayer,
                                args: [
                                    u
                                ]
                            }), l.splice(l.indexOf(u, d), 1));
                            for(h = 0, d = 0; h < r.length; h++)u = r[r.length - 1 - h], l[l.length - 1 - h] !== u && (n.hasOwnProperty(u) ? (o.push({
                                command: Vt.removeLayer,
                                args: [
                                    u
                                ]
                            }), l.splice(l.lastIndexOf(u, l.length - d), 1)) : d++, f = l[l.length - h], o.push({
                                command: Vt.addLayer,
                                args: [
                                    a[u],
                                    f
                                ]
                            }), l.splice(l.length - h, 0, u), c[u] = !0);
                            for(h = 0; h < r.length; h++)if (u = r[h], _ = n[u], p = a[u], !c[u] && !e.bz(_, p)) {
                                if (e.bz(_.source, p.source) && e.bz(_["source-layer"], p["source-layer"]) && e.bz(_.type, p.type)) {
                                    for(m in Wt(_.layout, p.layout, o, u, null, Vt.setLayoutProperty), Wt(_.paint, p.paint, o, u, null, Vt.setPaintProperty), e.bz(_.slot, p.slot) || o.push({
                                        command: Vt.setSlot,
                                        args: [
                                            u,
                                            p.slot
                                        ]
                                    }), e.bz(_.filter, p.filter) || o.push({
                                        command: Vt.setFilter,
                                        args: [
                                            u,
                                            p.filter
                                        ]
                                    }), e.bz(_.minzoom, p.minzoom) && e.bz(_.maxzoom, p.maxzoom) || o.push({
                                        command: Vt.setLayerZoomRange,
                                        args: [
                                            u,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), _)_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? Wt(_[m], p[m], o, u, m.slice(6), Vt.setPaintProperty) : e.bz(_[m], p[m]) || o.push({
                                        command: Vt.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? Wt(_[m], p[m], o, u, m.slice(6), Vt.setPaintProperty) : e.bz(_[m], p[m]) || o.push({
                                        command: Vt.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else o.push({
                                    command: Vt.removeLayer,
                                    args: [
                                        u
                                    ]
                                }), f = l[l.lastIndexOf(u) + 1], o.push({
                                    command: Vt.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(n, i.layers, o);
                    } catch (e) {
                        console.warn("Unable to compute style diff:", e), o = [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), t1).filter((e)=>!(e.command in Ro));
                if (0 === o.length) return !1;
                const s = o.filter((e)=>!(e.command in Co));
                if (s.length > 0) throw new Error(`Unimplemented: ${s.map((e)=>e.command).join(", ")}.`);
                const r = [];
                return o.forEach((e)=>{
                    r.push(this[e.command](...e.args));
                }), i && Promise.all(r).then(i).catch(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            _updateWorkerImages() {
                this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                });
            }
            _updateWorkerModels() {
                this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", {
                    scope: this.scope,
                    models: this._availableModels
                });
            }
            addImages(t1) {
                if (0 === t1.size) return this;
                for (const [i, o] of t1.entries()){
                    if (this.getImage(i)) return this.fire(new e.z(new Error(`An image with the name "${i.name}" already exists.`)));
                    this.imageManager.addImage(i, this.scope, o), this._changes.updateImage(i, this.scope);
                }
                return this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e.z(new Error(`An image with the name "${t1.name}" already exists.`))) : (this.imageManager.addImage(t1, this.scope, i), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this);
            }
            updateImage(t1, i, o = !1) {
                this.imageManager.updateImage(t1, this.scope, i), o && (this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })));
            }
            getImage(e) {
                return this.imageManager.getImage(e, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this) : this.fire(new e.z(new Error("No image with this name exists.")));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            getActualScope() {
                return this._importedAsBasemap ? "basemap" : this.scope;
            }
            addModelURLs(t1) {
                return this.modelManager.addModelURLs(t1, this.getActualScope()), this._updateWorkerModels(), this.fire(new e.A("data", {
                    dataType: "style"
                })), this;
            }
            addModel(t1, i, o = {}) {
                return this._checkLoaded(), this._validate(ze, `models.${t1}`, i, null, o) || (this.modelManager.addModel(t1, i, this.getActualScope()), this.fire(new e.A("data", {
                    dataType: "style"
                }))), this;
            }
            hasModel(e) {
                return this.modelManager.hasModel(e, this.getActualScope());
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.getActualScope(), !1, !0), this.fire(new e.A("data", {
                    dataType: "style"
                })), this) : this.fire(new e.z(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.getActualScope());
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(Te, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const s = mt(t1, i, this.dispatcher, this);
                s.scope = this.scope, s.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(s.id),
                        source: s.serialize(),
                        sourceId: s.id
                    }));
                const r = (t1)=>{
                    const i = (t1 ? "symbol:" : "other:") + s.id, o = e.C(i, this.scope), r = this._sourceCaches[i] = new Ft(o, s, t1);
                    (t1 ? this._symbolSourceCaches : this._otherSourceCaches)[s.id] = r, r.onAdd(this.map);
                };
                r(!1), "vector" !== i.type && "geojson" !== i.type || r(!0), s.onAdd && s.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                if (this.stylesheet.iconsets) {
                    const i = Object.entries(this.stylesheet.iconsets).find(([e, i])=>"source" === i.type && i.source === t1);
                    if (i) return this.fire(new e.z(new Error(`Source "${t1}" cannot be removed while iconset "${i[0]}" is using it.`)));
                }
                const o = this.getOwnSourceCaches(t1);
                for (const t1 of o){
                    const i = e.dt(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e.A("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e, t1) {
                this._checkLoaded(), this.getOwnSource(e).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e) {
                const t1 = this.getOwnSourceCache(e);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e.push(i.getSource());
                }
                return e;
            }
            areTilesLoaded() {
                const e = this._mergedSourceCaches;
                for(const t1 in e){
                    const i = e[t1]._tiles;
                    for(const e in i){
                        const t1 = i[e];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const e of t1){
                    if (this._validate(Se, "lights", e)) return;
                    switch(e.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const t1 = this.ambientLight;
                                t1.set(e), t1.updateTransitions(i);
                            } else this.ambientLight = new et(e, tt(), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const t1 = this.directionalLight;
                                t1.set(e), t1.updateTransitions(i);
                            } else this.directionalLight = new et(e, ot(), this.scope, this.options);
                    }
                }
                const o = Object.assign(i, {
                    worldview: this.map.getWorldview()
                }), s = new e.ad(this.z || 0, o);
                this.ambientLight && this.ambientLight.recalculate(s), this.directionalLight && this.directionalLight.recalculate(s), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const o = (e)=>.2126 * (e[0] <= .03928 ? e[0] / 12.92 : Math.pow((e[0] + .055) / 1.055, 2.4)) + .7152 * (e[1] <= .03928 ? e[1] / 12.92 : Math.pow((e[1] + .055) / 1.055, 2.4)) + .0722 * (e[2] <= .03928 ? e[2] / 12.92 : Math.pow((e[2] + .055) / 1.055, 2.4)), s = t1.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), r = t1.properties.get("intensity"), n = t1.properties.get("direction"), a = 1 - e.d5(n.x, n.y, n.z)[2] / 90, l = o(s) * r * a, c = i.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h = i.properties.get("intensity"), d = o(c) * h;
                return Number(((l + d) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e = [];
                return this.directionalLight && e.push(this.directionalLight.get()), this.ambientLight && e.push(this.ambientLight.get()), e;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (null == t1 || "" === t1 && this.isRootStyle()) return this;
                if (e.du(t1)) {
                    const i = e.dv(t1), o = this.fragments.find(({ id: e })=>e === i);
                    if (!o) return;
                    const s = e.dt(t1);
                    return o.style.getFragmentStyle(s);
                }
                {
                    const e = this.fragments.find(({ id: e })=>e === t1);
                    return e ? e.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = (e, t1 = "")=>`${e}::${t1}`;
                this._featuresetSelectors = {};
                for(const o in t1){
                    const s = {}, r = this._featuresetSelectors[o] = [];
                    for (const n of t1[o].selectors){
                        if (n.featureNamespace) {
                            const t1 = this.getOwnLayer(n.layer);
                            if (!t1) {
                                e.w(`Layer is undefined for selector: ${n.layer}`);
                                continue;
                            }
                            const r = i(t1.source, t1.sourceLayer);
                            if (r in s && s[r] !== n.featureNamespace) {
                                e.w(`"featureNamespace ${n.featureNamespace} of featureset ${o}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            s[r] = n.featureNamespace;
                        }
                        let t1;
                        if (n.properties) for(const i in n.properties){
                            const o = e.W(n.properties[i]);
                            "success" === o.result && (t1 = t1 || {}, t1[i] = o.value);
                        }
                        r.push({
                            layerId: n.layer,
                            namespace: n.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: n._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e) {
                const t1 = this.getFragmentStyle(e);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e in t1.stylesheet.featuresets)i.push({
                    featuresetId: e,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const o = this.getFragmentStyle(i), s = o.stylesheet.featuresets;
                if (!s || !s[t1]) return this.fire(new e.z(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const r = [];
                for (const e of s[t1].selectors){
                    const t1 = o.getOwnLayer(e.layer);
                    t1 && r.push(t1);
                }
                return r;
            }
            getConfigProperty(t1, i) {
                const o = this.getFragmentStyle(t1);
                if (!o) return null;
                const s = e.C(i, o.scope), r = o.options.get(s), n = r ? r.value || r.default : null;
                return n ? n.serialize() : null;
            }
            isIndoorEnabled() {
                return Object.keys(this._mergedIndoor).length > 0;
            }
            getIndoorSourceLayers(t1, i) {
                const o = e.C(t1, i);
                return this._mergedIndoor[o];
            }
            setIndoorData(e, t1) {
                this.indoorManager.setIndoorData(t1);
            }
            updateIndoorDependentLayers() {
                this._updateLayers(this._indoorDependentLayers), this.map._styleDirty = !0, this.map.triggerRepaint();
            }
            setConfigProperty(t1, i, o) {
                const s = this.getFragmentStyle(t1);
                if (!s) return;
                const r = s.stylesheet.schema;
                if (!r || !r[i]) return;
                const n = e.W(o);
                if ("success" !== n.result) return void Io(this, n.value);
                const a = n.value.expression, l = e.C(i, s.scope), c = s.options.get(l);
                if (!c) return;
                let h;
                const { minValue: d, maxValue: u, stepValue: _, type: p, values: f } = r[i], m = e.W(r[i].default);
                "success" === m.result && (h = m.value.expression), h ? (this.options.set(l, Object.assign({}, c, {
                    value: a,
                    default: h,
                    minValue: d,
                    maxValue: u,
                    stepValue: _,
                    type: p,
                    values: f
                })), this.updateConfigDependencies(i)) : this.fire(new e.z(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const o = i.stylesheet.schema;
                if (!o) return null;
                const s = {};
                for(const t1 in o){
                    const o = e.C(t1, i.scope), r = i.options.get(o), n = r ? r.value || r.default : null;
                    s[t1] = n ? n.serialize() : null;
                }
                return s;
            }
            setConfig(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e) {
                const t1 = this.getFragmentStyle(e);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const o in i){
                        let s, r;
                        const n = e.W(i[o].default);
                        if ("success" === n.result && (s = n.value.expression), t1 && void 0 !== t1[o]) {
                            const i = e.W(t1[o]);
                            "success" === i.result && (r = i.value.expression);
                        }
                        const { minValue: a, maxValue: l, stepValue: c, type: h, values: d } = i[o];
                        if (s) {
                            const t1 = e.C(o, this.scope);
                            this.options.set(t1, {
                                default: s,
                                value: r,
                                minValue: a,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: d
                            });
                        } else this.fire(new e.z(new Error(`No schema defined for config option "${o}".`)));
                    }
                    else this.fire(new e.z(new Error("Attempting to set config for a style without schema.")));
                }
            }
            _updateLayers(e, t1 = ()=>!0) {
                for (const i of e){
                    const e = this.getLayer(i);
                    e && t1(e) && (e.possiblyEvaluateVisibility(), this._updateLayer(e), this._changes.setDirty());
                }
            }
            updateConfigDependencies(e) {
                this._updateLayers(this._configDependentLayers, (t1)=>!e || t1.expressionDependencies.configDependencies.has(e)), this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e)=>{
                    const t1 = e._styleColorTheme.colorThemeOverride ? e._styleColorTheme.colorThemeOverride : e._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e._evaluateColorThemeData(t1);
                        (!e._styleColorTheme.lut && "" !== i || e._styleColorTheme.lut && i !== e._styleColorTheme.lut.data) && e.setColorTheme(t1);
                    }
                }), this._changes.setDirty();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const s = t1.id;
                if (this._layers[s]) return void this.fire(new e.z(new Error(`Layer with id "${s}" already exists on this map`)));
                let r;
                if ("custom" === t1.type) {
                    if (Io(this, e.dw(t1))) return;
                    r = e.dx(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(s, t1.source), t1 = e.ds(t1), t1 = Object.assign(t1, {
                        source: s
                    })), this._validate(De, `layers.${s}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    r = e.dx(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(r), r.setEventedParent(this, {
                        layer: {
                            id: s
                        }
                    });
                }
                const n = e.C(r.source, r.scope);
                0 !== r.expressionDependencies.configDependencies.size && this._configDependentLayers.add(n), r.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(n);
                let a = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.z(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    r.slot && r.slot !== this._layers[i].slot ? e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : a = t1;
                }
                this._order.splice(a, 0, s), this._handleLayerOrderChange(), this._layers[s] = r;
                const l = this.getOwnLayerSourceCache(r), c = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                l && r.canCastShadows() && c && (l.castsShadows = !0);
                const h = this._changes.getRemovedLayer(r);
                if (h && r.source && l && "custom" !== r.type) {
                    this._changes.discardLayerRemoval(r);
                    const t1 = e.C(r.source, r.scope);
                    h.type !== r.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), l.pause());
                }
                this._updateLayer(r), r.onAdd && r.onAdd(this.map), r.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (!o) return;
                if (t1 === i) return;
                const s = this._order.indexOf(t1);
                this._order.splice(s, 1);
                let r = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.z(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot && o.slot !== this._layers[i].slot ? e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : r = t1;
                }
                this._order.splice(r, 0, t1), this._changes.setDirty(), this._handleLayerOrderChange(), this.mergeLayers();
            }
            removeLayer(e) {
                this._checkLoaded();
                const t1 = this._checkLayer(e);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e);
                this._order.splice(i, 1), delete this._layers[e], this._changes.setDirty(), this._handleLayerOrderChange(), this._configDependentLayers.delete(t1.fqid), this._indoorDependentLayers.delete(t1.fqid), this._changes.removeLayer(t1);
                const o = this.getOwnLayerSourceCache(t1);
                if (o && o.castsShadows) {
                    let e = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e = !0;
                        break;
                    }
                    o.castsShadows = e;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e) {
                return this._layers[e];
            }
            hasLayer(e) {
                return e in this._mergedLayers;
            }
            hasLayerType(e) {
                for(const t1 in this._layers)if (this._layers[t1].type === e) return !0;
                return !1;
            }
            setLayerZoomRange(e, t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(e);
                o && (o.minzoom === t1 && o.maxzoom === i || (null != t1 && (o.minzoom = t1), null != i && (o.maxzoom = i), this._updateLayer(o)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, o = {}) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (s && !e.bz(s.filter, i)) return null == i ? (s.filter = void 0, void this._updateLayer(s)) : void (this._validate(Le, `layers.${s.id}.filter`, i, {
                    layerType: s.type
                }, o) || (s.filter = e.ds(i), this._updateLayer(s)));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e.ds(i.filter);
            }
            setLayoutProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (r && !e.bz(r.getLayoutProperty(i), o)) {
                    if (null != o && (!s || !1 !== s.validate) && Io(r, Oe.call(we, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: r.type,
                        objectKey: i,
                        value: o,
                        styleSpec: e.a7,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    r.setLayoutProperty(i, o), 0 !== r.expressionDependencies.configDependencies.size && this._configDependentLayers.add(r.fqid), r.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(r.fqid), this._updateLayer(r);
                }
            }
            setLayerProperty(e, t1, i, o = {}) {
                this._checkLoaded();
                const s = this._checkLayer(e);
                s && ("appearances" === t1 ? (s.setAppearances(i), this._updateLayer(s)) : s.isPaintProperty(t1) ? this.setPaintProperty(e, t1, i, o) : this.setLayoutProperty(e, t1, i, o));
            }
            getLayoutProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (!r) return;
                if (e.bz(r.getPaintProperty(i), o)) return;
                if (null != o && (!s || !1 !== s.validate) && Io(r, Pe.call(we, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: r.type,
                    objectKey: i,
                    value: o,
                    styleSpec: e.a7
                }))) return;
                const n = r.setPaintProperty(i, o);
                0 !== r.expressionDependencies.configDependencies.size && this._configDependentLayers.add(r.fqid), r.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(r.fqid), n && this._updateLayer(r), this._changes.updatePaintProperties(r);
            }
            getPaintProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.setFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.setFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = t1.sourceLayer, r = this._checkSource(o);
                if (!r) return;
                const n = r.type;
                if ("geojson" === n && s) return void this.fire(new e.z(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === n && !s) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e.z(new Error("The feature id parameter must be provided.")));
                const a = this.getOwnSourceCaches(o);
                for (const e of a)e.setFeatureState(s, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.removeFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.removeFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = this._checkSource(o);
                if (!s) return;
                const r = s.type, n = "vector" === r ? t1.sourceLayer : void 0;
                if ("vector" === r && !n) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e.z(new Error("A feature id is required to remove its specific state property.")));
                const a = this.getOwnSourceCaches(o);
                for (const e of a)e.removeFeatureState(n, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: o, importId: s } = t1.target, r = this.getFragmentStyle(s), n = r.getFeaturesetLayers(o);
                        for (const { source: o, sourceLayer: s } of n){
                            const n = r.getFeatureState({
                                id: t1.id,
                                source: o,
                                sourceLayer: s
                            });
                            if (n && !i) i = n;
                            else if (!e.bz(i, n)) return void this.fire(new e.z(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        i = this.getFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, o = t1.sourceLayer, s = this._checkSource(i);
                if (s) {
                    if ("vector" !== s.type || o) return void 0 === t1.id && this.fire(new e.z(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(e) {
                return this.stylesheet.transition = Object.assign({}, this.stylesheet.transition, e), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return Object.assign({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e.dy({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    iconsets: this.stylesheet.iconsets,
                    featuresets: this.stylesheet.featuresets,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    indoor: this.stylesheet.indoor,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e)=>void 0 !== e);
            }
            _updateFilteredLayers(e) {
                for (const t1 of Object.values(this._mergedLayers))e(t1) && this._updateLayer(t1);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), o = e.C(t1.source, t1.scope), s = this._changes.getUpdatedSourceCaches();
                t1.source && !s[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e) {
                const t1 = (e)=>this._mergedLayers[e].is3D(!!this.terrain), i = this.order, o = {}, s = [];
                for(let r = i.length - 1; r >= 0; r--){
                    const n = i[r];
                    if (t1(n)) {
                        o[n] = r;
                        for (const t1 of e){
                            const e = t1[n];
                            if (e) for (const t1 of e)s.push(t1);
                        }
                    }
                }
                s.sort((e, t1)=>t1.intersectionZ - e.intersectionZ);
                const r = [];
                for(let n = i.length - 1; n >= 0; n--){
                    const a = i[n];
                    if (t1(a)) for(let e = s.length - 1; e >= 0; e--){
                        const t1 = s[e].feature;
                        if (t1.layer && o[t1.layer.id] < n) break;
                        r.push(t1), s.pop();
                    }
                    else for (const t1 of e){
                        const e = t1[a];
                        if (e) for (const t1 of e)r.push(t1.feature);
                    }
                }
                return r;
            }
            queryRasterValue(t1, i, o) {
                const s = this.getOwnSource(t1);
                return s ? "raster-array" !== s.type ? (this.fire(new e.z(new Error('queryRasterValue support only "raster-array" sources.'))), Promise.resolve(null)) : s.queryRasterArrayValue(i, o) : (this.fire(new e.z(new Error(`Source with id "${t1}" does not exist in the style.`))), Promise.resolve(null));
            }
            queryRenderedFeatures(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Le, "queryRenderedFeatures.filter", i.filter, null, i), s = e.b7(i.filter));
                const r = {}, n = (e)=>{
                    if (Ao.has(e.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e), i = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e.is3D(!!this.terrain) && (i.has3DLayers = !0), i.layers[e.fqid] = i.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, i.layers[e.fqid].targets.push({
                        filter: s
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e.z(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e.z(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        n(i);
                    }
                } else for(const e in this._layers)n(this._layers[e]);
                const a = this._queryRenderedFeatures(t1, r, o), l = this._flattenAndSortRenderedFeatures(a), c = [];
                for (const t1 of l)e.dz(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Le, "queryRenderedFeatures.filter", i.filter, null, i), s = e.b7(i.filter));
                const r = "mock", n = [];
                if (i && i.target) n.push(Object.assign({}, i, {
                    targetId: r,
                    filter: s
                }));
                else {
                    const e = this.getFeaturesetDescriptors();
                    for (const t1 of e)n.push({
                        targetId: r,
                        filter: s,
                        target: t1
                    });
                    for (const { style: e } of this.fragments){
                        const t1 = e.getFeaturesetDescriptors();
                        for (const e of t1)n.push({
                            targetId: r,
                            filter: s,
                            target: e
                        });
                    }
                }
                const a = this.queryRenderedTargets(t1, n, o), l = [], c = new Set;
                for (const t1 of a)for (const i of t1.variants[r])vt(i, t1, c) || l.push(new e.dA(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, o) {
                const s = {}, r = (e, t1, i, o)=>{
                    const r = s[t1.id] = s[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (r.layers[e.fqid] = r.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, e.is3D(!!this.terrain) && (r.has3DLayers = !0), !o) return i.uniqueFeatureID = !1, void r.layers[e.fqid].targets.push(i);
                    r.layers[e.fqid].targets.push(Object.assign({}, i, {
                        namespace: o.namespace,
                        properties: o.properties,
                        uniqueFeatureID: o.uniqueFeatureID
                    }));
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: o } = t1.target, s = this.getFragmentStyle(o);
                    if (!s || !s._featuresetSelectors) continue;
                    const n = s._featuresetSelectors[i];
                    if (!n) {
                        this.fire(new e.z(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e of n){
                        const i = s.getOwnLayer(e.layerId);
                        i && !Ao.has(i.type) && r(i, s.getOwnLayerSourceCache(i), t1, e);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e } = t1.target, i = this.getLayer(e);
                    if (!i || Ao.has(i.type)) continue;
                    r(i, this.getLayerSourceCache(i), t1);
                }
                const n = this._queryRenderedFeatures(t1, s, o);
                return this._flattenAndSortRenderedFeatures(n);
            }
            _queryRenderedFeatures(e, t1, i) {
                const o = [], s = !!this.map._showQueryGeometry, r = st.createFromScreenPoints(e, i);
                for(const e in t1){
                    const n = yt(r, t1[e], this._availableImages, i, s, this.getActualScope());
                    Object.keys(n).length && o.push(n);
                }
                if (this.placement) for(const e in t1){
                    if (!t1[e].sourceCache._onlySymbols) continue;
                    const i = xt(r.screenGeometry, t1[e], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                    Object.keys(i).length && o.push(i);
                }
                return o;
            }
            querySourceFeatures(e, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Le, "querySourceFeatures.filter", i, null, t1);
                let o = [];
                const s = this.getOwnSourceCaches(e);
                for (const e of s)o = o.concat(bt(e, t1));
                return o;
            }
            addSourceType(e, t1, i) {
                return Po.getSourceType(e) ? i(new Error(`A source type called "${e}" already exists.`)) : (Po.setSourceType(e, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, o = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let r = !1;
                for(const i in t1)if (!e.bz(t1[i], s[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const n = this._getTransitionParameters();
                this.light.setLight(t1, i, o), this.light.updateTransitions(n);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.o.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let o = t1;
                const s = !("source" in t1) || null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("source" in o && "object" == typeof o.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, o.source), o = e.ds(o), o = Object.assign(o, {
                            source: t1
                        });
                    }
                    const t1 = Object.assign({}, o), i = {};
                    if (this.terrain && s) {
                        t1.source = this.terrain.get().source;
                        const e = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e && (i.style = e.serialize());
                    }
                    if (this._validate(Ie, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !s || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!o) return;
                    this._createTerrain(o, i), this.fire(new e.A("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, s = i.get();
                    for (const t1 of Object.keys(e.a7.terrain))!o.hasOwnProperty(t1) && e.a7.terrain[t1].default && (o[t1] = e.a7.terrain[t1].default);
                    for(const o in t1)if (!e.bz(t1[o], s[o])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const o = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(o), this.fire(new e.A("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e) {
                const t1 = this.fog = new $e(e, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e) {
                const t1 = this.snow = new Je(e, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e) {
                const t1 = this.rain = new Qe(e, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e of this.map._markers)e._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), !t1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog;
                    if (!e.bz(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.fog = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createFog(t1);
                this._markersNeedUpdate = !0;
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e.bz(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e.bz(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e in this._layers)this._layers[e].lut = this._styleColorTheme.lut;
                    for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const o = this._evaluateColorThemeData(i);
                this._loadColorTheme(o).then(()=>{
                    this.fire(new e.A("colorthemeset")), t1();
                }).catch((t1)=>{
                    e.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e.o.now(),
                    transition: Object.assign(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e, t1) {
                const i = this.terrain = new je(e, t1, this.scope, this.options, this.map.getWorldview());
                1 === t1 && (this.stylesheet.terrain = e), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const o = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, s, r = {}) {
                if (r && !1 === r.validate) return !1;
                const n = Object.assign({}, this.serialize());
                return Io(this, t1.call(we, Object.assign({
                    key: i,
                    style: n,
                    value: o,
                    styleSpec: e.a7
                }, s)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.dB.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e in this._mergedLayers)this._mergedLayers[e].setEventedParent(null);
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles(), this._mergedSourceCaches[e].setEventedParent(null);
                this.imageManager.removeScope(this.scope), this.imageManager.imageAtlasCache.clear(), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.indoorManager.destroy(), this.isRootStyle() && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.clearTiles();
            }
            clearSources() {
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles();
            }
            clearLayers() {
                for(const e in this._mergedLayers){
                    const t1 = this._mergedLayers[e];
                    t1._clear && t1._clear();
                }
            }
            reloadSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.resume(), e.reload();
            }
            reloadSources() {
                for (const e of this.getSources())e.reload && e.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e)=>{
                    e.modelManager.reloadModels(e.scope);
                });
            }
            updateSources(e) {
                let t1;
                this.directionalLight && (t1 = fo(this.directionalLight));
                const i = new Set, o = new Set, s = new Set;
                for(const e in this._mergedLayers){
                    const t1 = this._mergedLayers[e];
                    "building" === t1.type ? i.add(t1.source) : "raster" === t1.type && t1.paint && "ground" === t1.paint.get("raster-elevation-reference") && s.add(t1.source), t1.hasElevation() && !o.has(t1.source) && o.add(t1.source);
                }
                for(const r in this._mergedSourceCaches){
                    const n = this._mergedSourceCaches[r], a = o.has(n._source.id);
                    n._isRasterElevatedOverTerrain = s.has(n._source.id), i.has(n._source.id) && (n._source.reparseOverscaled = !1), n.update(e, void 0, void 0, t1, a);
                }
            }
            _generateCollisionBoxes() {
                for(const e in this._sourceCaches){
                    const t1 = this._sourceCaches[e];
                    t1.resume(), t1.reload();
                }
            }
            _handleLayerOrderChange() {
                this._requestFullLabelPlacement(), this.fire(new e.A("neworder"));
            }
            _requestFullLabelPlacement() {
                this.pauseablePlacement || (this.pauseablePlacement = new Ni), this.pauseablePlacement.requestFullPlacement();
            }
            _setLabelPlacementStale() {
                this.placement && this.placement.setStale();
            }
            _updatePlacement(t1, i, o, s, r) {
                this.pauseablePlacement || (this.pauseablePlacement = new Ni);
                let n = !1, a = !1;
                const l = {}, c = {};
                for (const i of this._mergedOrder){
                    const o = this._mergedLayers[i];
                    if ("symbol" !== o.type) continue;
                    const s = e.C(o.source, o.scope);
                    let r = l[s];
                    if (!r) {
                        const e = this.getLayerSourceCache(o);
                        if (!e) continue;
                        const t1 = e.getRenderableIds(!0).map((t1)=>e.getTileByID(t1));
                        c[s] = t1.slice(), r = l[s] = t1.sort((e, t1)=>t1.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(o, r, t1.center.lng, t1.projection);
                    n = n || a;
                }
                this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder);
                const h = Boolean(this.placement && !t1.equals(this.placement.transform)), d = Boolean(this.placement && (0 !== this.placement.lastReplacementSourceUpdateTime && !r || this.placement.lastReplacementSourceUpdateTime !== r.updateTime)), u = h || d || n, _ = (u || this.pauseablePlacement.isStale()) && 0 === o, p = this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.o.now(), t1.zoom) && 0 !== o;
                if ((this.pauseablePlacement.isFullPlacementRequested() || !this.pauseablePlacement.placement || _ || p) && (this.pauseablePlacement = this.pauseablePlacement.startNewPlacement(t1, this._mergedOrder, i, o, s, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null, this._buildingIndex)), this.pauseablePlacement.isDone() ? u && 0 !== o && this.pauseablePlacement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, l, c, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.o.now()), a = !0), n && this.pauseablePlacement.setStale()), a || n) {
                    this._buildingIndex.onNewFrame(t1.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const i = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== i.type) continue;
                        if ("none" === i.visibility) continue;
                        const o = this.isLayerClipped(i);
                        this.placement.updateLayerOpacities(i, l[e.C(i.source, i.scope)], t1, o ? r : null);
                    }
                }
                return !this.pauseablePlacement.isDone() || this.placement.isStale() || this.placement.hasTransitions(e.o.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== o.findIndex(({ id: e })=>e === t1.id)) return void this.fire(new e.z(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return o.push(t1), this._loadImports([
                    t1
                ], !0);
                const s = o.findIndex(({ id: e })=>e === i);
                return -1 === s && this.fire(new e.z(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = o.slice(0, s).concat(t1).concat(o.slice(s)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports || [], s = this.getImportIndex(t1);
                return -1 === s ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== o[s].url && this.setImportUrl(t1, i.url), e.bz(i.config, o[s].config) || this.setImportConfig(t1, i.config, i.data.schema), e.bz(i.data, o[s].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const o = this.getImportIndex(e);
                if (-1 === o) return this;
                const s = this.getImportIndex(t1);
                if (-1 === s) return this;
                const r = i[o], n = this.fragments[o];
                return i = i.filter(({ id: t1 })=>t1 !== e), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e), this.stylesheet.imports = i.slice(0, s).concat(r).concat(i.slice(s)), this.fragments = this.fragments.slice(0, s).concat(n).concat(this.fragments.slice(s)), this.mergeLayers(), this;
            }
            setImportUrl(e, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], o = this.getImportIndex(e);
                if (-1 === o) return this;
                i[o].url = t1;
                const s = this.fragments[o];
                return s.style = this._createFragmentStyle(i[o]), s.style.on("style.import.load", ()=>this.mergeAll()), s.style.loadURL(t1), this;
            }
            setImportData(e, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e), o = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e, o[i].url));
            }
            setImportConfig(e, t1, i) {
                this._checkLoaded();
                const o = this.getImportIndex(e), s = this.stylesheet.imports || [];
                if (-1 === o) return this;
                t1 ? s[o].config = t1 : delete s[o].config;
                const r = this.fragments[o];
                i && r.style.stylesheet && (r.style.stylesheet.schema = i);
                const n = r.style.stylesheet && r.style.stylesheet.schema;
                return r.config = t1, r.style.updateConfig(t1, n), this.updateConfigDependencies(), this;
            }
            removeImport(e) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e)=>e.id === t1);
                return -1 === i && this.fire(new e.z(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e) {
                return this._mergedLayers[e];
            }
            getSources() {
                const e = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e.push(i.getSource());
                }
                return e;
            }
            getSource(e, t1) {
                const i = this.getSourceCache(e, t1);
                return i && i.getSource();
            }
            getLayerSource(e) {
                const t1 = this.getLayerSourceCache(e);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const o = e.C(t1, i);
                return this._mergedOtherSourceCaches[o];
            }
            getLayerSourceCache(t1) {
                const i = e.C(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e) {
                if (null == e) return Object.values(this._mergedSourceCaches);
                const t1 = [];
                return this._mergedOtherSourceCaches[e] && t1.push(this._mergedOtherSourceCaches[e]), this._mergedSymbolSourceCaches[e] && t1.push(this._mergedSymbolSourceCaches[e]), t1;
            }
            updateSourceCaches() {
                const e = this._changes.getUpdatedSourceCaches();
                for(const t1 in e){
                    const i = e[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e);
                }
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e) {
                this.stylesheet.glyphs = e, this.glyphManager.setURL(e);
            }
            getImages(t1, i, o) {
                this.imageManager.getImages(i.images, i.scope, o), this._updateTilesForChangedImages();
                const s = (t1)=>{
                    if (t1) {
                        const o = i.images.map((t1)=>e.I.toString(t1));
                        t1.setDependencies(i.tileID.key, i.type, o);
                    }
                }, r = e.C(i.source, i.scope);
                s(this._mergedOtherSourceCaches[r]), s(this._mergedSymbolSourceCaches[r]), i.images.some((e)=>e.iconsetId) && this.fire(new e.A("data", {
                    dataType: "style"
                }));
            }
            rasterizeImages(e, t1, i) {
                this.imageManager.rasterizeImages(t1, i);
            }
            checkAtlasCache(e, t1, i) {
                const o = this.imageManager.imageAtlasCache.findCachedAtlas(t1.descriptor);
                i(null, o && o.contentDescriptor ? {
                    iconPositions: o.iconPositions,
                    patternPositions: o.patternPositions,
                    sourceHash: o.contentDescriptor.hash
                } : null);
            }
            getGlyphs(e, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, i);
            }
            getOwnSourceCache(e) {
                return this._otherSourceCaches[e];
            }
            getOwnLayerSourceCache(e) {
                return "symbol" === e.type ? this._symbolSourceCaches[e.source] : this._otherSourceCaches[e.source];
            }
            getOwnSourceCaches(e) {
                const t1 = [];
                return this._otherSourceCaches[e] && t1.push(this._otherSourceCaches[e]), this._symbolSourceCaches[e] && t1.push(this._symbolSourceCaches[e]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e.z(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e)=>e.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e.type && "building" !== e.type) return !1;
                const i = "fill-extrusion" === e.type && ("building" === e.sourceLayer || "procedural_buildings" === e.sourceLayer), o = "building" === e.type;
                if (e.is3D(!!this.terrain)) {
                    if (i || o || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e.type) return !0;
                } else if ("symbol" === e.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            getBOMObject() {}
            destroy() {
                this._clearWorkerCaches(), this.imageManager.imageAtlasCache.clear(), this.fragments.forEach((e)=>{
                    e.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        Po.getSourceType = function(e) {
            return ft[e];
        }, Po.setSourceType = function(e, t1) {
            ft[e] = t1;
        }, Po.registerForPluginStateChange = e.dC;
        var Oo = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", zo = "\n#ifdef DUAL_SOURCE_BLENDING\nlayout(location=0,index=0) out vec4 glFragColor;layout(location=0,index=1) out vec4 glFragColorSrc1;\n#else\nlayout(location=0) out vec4 glFragColor;\n#endif\n#ifdef USE_MRT1\nlayout(location=1) out vec4 out_Target1;\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb*col.a,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", Mo = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#ifndef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_id) attrib\n#define DECLARE_MATERIAL_TABLE_INFO\n#endif", Fo = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", ko = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nint NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nhighp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif", Bo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", No = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nhighp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", Uo = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", jo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", Vo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif", Go = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {\n#ifdef CLIP_ZERO_TO_ONE\nhighp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z-bias);\n#else\nhighp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z*0.5+0.5-bias);\n#endif\nreturn texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const Ho = /#include\s+"([^"]+)"/g, qo = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g, Zo = /\b[A-Za-z_][A-Za-z0-9_]*\b/g, Wo = new Set([
            "ifdef",
            "ifndef",
            "elif",
            "if",
            "defined"
        ]), $o = new Set;
        is(Oo, $o), is(Mo, $o), is(zo, $o);
        const Xo = {
            "_prelude_fog.vertex.glsl": Bo,
            "_prelude_terrain.vertex.glsl": ko,
            "_prelude_shadow.vertex.glsl": Vo,
            "_prelude_material_table.vertex.glsl": "#ifdef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define MATERIAL_TABLE_DEBUG 0\nuniform int u_material_offset;uniform int u_vertex_offset;layout(std140,binding=0)readonly buffer material_buffer{uvec4 material_data[];};struct MaterialInfo{uint dataOffset;\n#if MATERIAL_TABLE_DEBUG\nvec4 colorDebug;\n#endif\n};uint read_buf_no_offset(uint iDword) {return material_data[iDword/4u][iDword % 4u];}uint read_buf(uint iDword) {iDword+=uint(u_material_offset/4);return read_buf_no_offset(iDword);}float read_buf_float(uint iDword){return uintBitsToFloat(read_buf(iDword));}uint read_buf_uint8(uint iDword,uint iUint8){uint dwordOffset=iDword+(iUint8/4u);uint byteOffset=iUint8 & 3u;uint bitOffset=8u*byteOffset;uint mask=0xffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint read_buf_uint16(uint iDword,uint iUint16){uint dwordOffset=iDword+(iUint16 >> 1u);uint bitOffset=(iUint16 & 1u)*16u;uint mask=0xffffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint nrDwordsForVertexIdEntries(uint nrMaterialLookupEntries) {return nrMaterialLookupEntries;}uint nrDwordsForMaterialIdEntries(uint nrMaterialLookupEntries) {return (nrMaterialLookupEntries*2u+3u)/4u;}uint findRangeBinarySearch(uint vertexId,uint numRanges,uint dwordOffset) {uint left=0u;uint right=numRanges-1u;for (uint i=0u; i < 16u; i++) { \nif (left > right) {break;}uint mid=(left+right)/2u;uint start=read_buf(dwordOffset+mid);uint nextStart=(mid+1u < numRanges) ? read_buf(dwordOffset+mid+1u) : 0xffffffffu;if (vertexId >=start && vertexId < nextStart) {return mid;} else if (vertexId < start) {if (mid==0u) {break;}right=mid-1u;} else {left=mid+1u;}}return 0u; \n}uint readVertexId(uint dwordOffset,uint iMaterialLookupEntry) {return read_buf(dwordOffset+iMaterialLookupEntry);}uint findRange(uint vertexId,uint numRanges,uint dwordOffset) {uint iRange;if(numRanges <=64u){uint vertexBegin;for(iRange=0u; iRange < numRanges;++iRange) {vertexBegin=readVertexId(dwordOffset,iRange);if(vertexBegin > vertexId) {break;}}iRange=iRange==0u? 0u : iRange-1u;} else { \niRange=findRangeBinarySearch(vertexId,numRanges,dwordOffset);}return iRange;}MaterialInfo read_material_info(uint vertex_id) {MaterialInfo info;\n#if MATERIAL_TABLE_DEBUG\nconst vec4 red=vec4(1.0,0.0,0.0,1.0);const vec4 orange=vec4(1.0,0.5,0.0,1.0);const vec4 yellow=vec4(1.0,1.0,0.0,1.0);const vec4 green=vec4(0.0,1.0,0.0,1.0);const vec4 indigo=vec4(0.294,0.0,0.510,1.0);const vec4 blue=vec4(0.0,0.0,1.0,1.0);const vec4 purple=vec4(0.5,0.0,0.5,1.0);const vec4 pink=vec4(1.0,0.0,1.0,1.0);info.colorDebug=green;\n#endif\nuint offset=0u;\n#if MATERIAL_TABLE_DEBUG\nbool keepFinding=true;uint magic=read_buf(offset);if(magic !=0xCAFEBABEu) {info.colorDebug=red;keepFinding=false;return info;}\n#endif\noffset++;\n#if MATERIAL_TABLE_DEBUG\nuint nrMaterials=read_buf(offset);uint nrVertices=read_buf(offset+1u);if(keepFinding && vertex_id >=nrVertices) {info.colorDebug=red;keepFinding=false;}\n#endif\noffset+=2u;uint nrMaterialLookupEntries=read_buf(offset++);uint perMaterialEntrySizeDwords=read_buf(offset++);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding && perMaterialEntrySizeDwords !=1u) {info.colorDebug=red;keepFinding=false;}\n#endif\nuint iMaterialLookup=findRange(vertex_id,nrMaterialLookupEntries,offset);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding)\n{uint vertexBeginCheck=readVertexId(offset,iMaterialLookup);if(vertexBeginCheck > vertex_id) {info.colorDebug=red;keepFinding=false;}if(iMaterialLookup < nrMaterialLookupEntries-1u) {uint vertexEndCheck=readVertexId(offset,iMaterialLookup+1u);if(vertexEndCheck <=vertex_id) {info.colorDebug=red;keepFinding=false;}}}\n#endif\noffset+=nrDwordsForVertexIdEntries(nrMaterialLookupEntries);uint materialId=iMaterialLookup;\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding) {if(materialId >=nrMaterialLookupEntries) {info.colorDebug=red;}}\n#endif\ninfo.dataOffset=offset+materialId*perMaterialEntrySizeDwords;return info;}uint get_data_location(const MaterialInfo matInfo,uint attribOffsetBytes)\n{uint attribFieldOffsetDwords=attribOffsetBytes/4u;return matInfo.dataOffset+attribFieldOffsetDwords;}vec4 read_material_vec4(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec4(read_buf_float(loc),read_buf_float(loc+1u),read_buf_float(loc+2u),read_buf_float(loc+3u));}vec2 read_material_vec2(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec2(read_buf_float(loc),read_buf_float(loc+1u));}float read_material_float(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return read_buf_float(loc);}\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_offset) read_material_float(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_offset) read_material_vec4(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_offset) read_material_vec2(matInfo,attrib_offset)\n#define DECLARE_MATERIAL_TABLE_INFO MaterialInfo materialInfo=read_material_info(uint(gl_VertexID));\n#define DECLARE_MATERIAL_TABLE_INFO_DEBUG(dbgColor) MaterialInfo materialInfo=read_material_info(uint(gl_VertexID)); dbgColor=materialInfo.colorDebug;\n#endif",
            "_prelude_fog.fragment.glsl": No,
            "_prelude_shadow.fragment.glsl": Go,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif",
            "_prelude_raster_array.glsl": Uo,
            "_prelude_raster_particle.glsl": jo
        }, Ko = {};
        os("", ko), os(No, Bo), os(Go, Vo), os(Uo, ""), os(jo, "");
        const Yo = os(zo, Mo), Jo = Oo, Qo = [
            "\n#if defined(GL_EXT_blend_func_extended) && defined(DUAL_SOURCE_BLENDING)\n#extension GL_EXT_blend_func_extended : require\n#endif",
            "precision mediump float;",
            Jo,
            Yo.fragmentSource
        ].join("\n"), es = [
            "precision highp float;",
            Jo,
            Yo.vertexSource
        ].join("\n");
        var ts = {
            background: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            building: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nconst float window_depth=0.5;const float ao_radius=0.2;in vec4 v_color;in highp vec3 v_normal;in highp vec3 v_pos;\n#ifdef BUILDING_FAUX_FACADE\nin lowp float v_faux_facade;in highp float v_faux_facade_ed;in highp vec2 v_faux_facade_window;in highp vec2 v_faux_facade_floor;in highp vec2 v_faux_facade_range;in highp float v_aspect;in highp vec3 v_tbn_0;in highp vec3 v_tbn_1;in highp vec3 v_tbn_2;in highp vec4 v_faux_color_emissive;uniform float u_faux_facade_ao_intensity;\n#endif\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nin highp float v_flood_radius;in float v_has_flood_light;\n#endif\nuniform lowp float u_opacity;uniform vec3 u_camera_pos;uniform highp float u_tile_to_meter;uniform float u_facade_emissive_chance;uniform vec3 u_flood_light_color;uniform float u_flood_light_intensity;vec3 linearTosRGB(in vec3 color) {return pow(color,vec3(1./2.2));}\n#ifdef BUILDING_FAUX_FACADE\nfloat hash12(in vec2 p) {vec3 p3 =fract(vec3(p.xyx)*0.1031);p3+=dot(p3,p3.yzx+33.33);return fract((p3.x+p3.y)*p3.z);}float min3(in vec3 v) {return min(min(v.x,v.y),v.z);}vec2 get_uv_mask_id(in vec2 q,out float mask,out vec2 id) {vec2 p=q;mask=step(v_faux_facade_range.x,p.y)*step(p.y,v_faux_facade_range.y);p.y=p.y-v_faux_facade_range.x;vec2 uv=modf(p/v_faux_facade_floor,id);vec4 d=(v_faux_facade_floor.xyxy+vec4(-v_faux_facade_window,v_faux_facade_window))*0.5;vec4 edge=d/v_faux_facade_floor.xyxy;vec2 m=step(edge.xy,uv)*step(uv,edge.zw);mask*=m.x*m.y;uv-=vec2(0.5);uv*=vec2(0.5)/(vec2(0.5)-edge.xy);uv+=vec2(0.5);return uv;}float ray_unit_box(in vec3 ray_o,in vec3 ray_d,in vec3 bmin,in vec3 bmax) {vec3 planes=mix(bmin,bmax,step(0.0,ray_d));vec3 t=(planes-ray_o)/ray_d;return min3(t);}float get_emissive(in vec2 id) {if (u_facade_emissive_chance > 0.0) {return (step(hash12(id),u_facade_emissive_chance)+0.05)*v_faux_color_emissive.a;}return 0.0;}vec3 get_shade_info(in vec3 v,in vec3 v_normalized,in vec3 color,in vec2 id,in mat3 tbn,inout vec3 out_normal,inout float out_emissive) {vec3 out_color=color;vec3 abs_v=abs(v_normalized);bool x_major=abs_v.x >=abs_v.y && abs_v.x >=abs_v.z;bool y_major=abs_v.y >=abs_v.x && abs_v.y >=abs_v.z;bool z_major=abs_v.z >=abs_v.x && abs_v.z >=abs_v.y;\n#if 0\nif (x_major) {out_color=v.x > 0.0 ? vec3(1.0,0.0,0.0) : vec3(0.0,1.0,1.0);} else if (y_major) {out_color=v.y > 0.0 ? vec3(0.0,1.0,0.0) : vec3(1.0,0.0,1.0);} else if (z_major) {out_color=v.z > 0.0 ? vec3(0.0,0.0,1.0) : vec3(1.0,1.0,0.0);}out_emissive=1.0;\n#else\nif (x_major) {out_normal=-sign(v.x)*tbn[0];} else if (y_major) {out_normal=vec3(0.0,0.0,-sign(v.y));} else if (z_major) {out_color=v_faux_color_emissive.rgb;out_emissive=v.z <=0.0 ? get_emissive(id) : out_emissive;}float ao=1.0;if (u_faux_facade_ao_intensity > 0.0) {vec4 ao_range=v_faux_facade_window.xxyy*0.5-vec4(0,ao_radius,0,ao_radius);vec2 ao_range_z=vec2(window_depth*0.5)-vec2(0.0,ao_radius);if (x_major || y_major) {ao*=smoothstep(-ao_range_z.x,-ao_range_z.y,v.z);} else if (z_major) {ao*=smoothstep(-ao_range.x,-ao_range.y,v.x)*(1.0-smoothstep(ao_range.y,ao_range.x,v.x));ao*=smoothstep(-ao_range.z,-ao_range.w,v.y)*(1.0-smoothstep(ao_range.w,ao_range.z,v.y));}ao=mix(1.0,min(1.0,ao+0.25),u_faux_facade_ao_intensity);}out_color*=ao;\n#endif\nreturn out_color;}\n#endif\nvec3 apply_lighting_linear(in vec3 color,in vec3 normal,in float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec3 normal=normalize(v_normal);vec3 base_color=v_color.rgb;float emissive=v_color.a;\n#ifdef BUILDING_FAUX_FACADE\nif (v_faux_facade > 0.0) {mat3 tbn=mat3(v_tbn_0,v_tbn_1,v_tbn_2);vec3 v=vec3(v_pos.xy,v_pos.z/u_tile_to_meter)-u_camera_pos;vec3 view_tangent=transpose(tbn)*v;vec2 q=vec2(v_faux_facade_ed,v_pos.z);float mask=0.0;vec2 id=vec2(0.0);vec2 uv=get_uv_mask_id(q,mask,id);uv*=v_faux_facade_window;vec3 bmin=vec3(0.0,0.0,-window_depth);vec3 bmax=bmin+vec3(v_faux_facade_window,window_depth);vec3 ray_o=vec3(uv,0.0);vec3 ray_d=normalize(view_tangent);float t_min=ray_unit_box(ray_o,ray_d,bmin,bmax);vec3 hit=ray_o+t_min*ray_d;vec3 r=vec3(v_faux_facade_window,-window_depth);hit-=r*0.5;vec3 normalized=hit/r;vec3 out_normal=normal;float out_emissive=emissive;vec3 room_color=get_shade_info(hit,normalized,base_color,id,tbn,out_normal,out_emissive);base_color=mix(base_color,room_color,mask);normal=mix(normal,out_normal,mask);emissive=mix(emissive,out_emissive,mask);}\n#endif\nvec4 color=vec4(base_color,1.0);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\n#else\nshadowed_lighting_factor=max(0.0,dot(xy_flipped_normal,u_lighting_directional_dir));\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=linearTosRGB(color.rgb);\n#ifdef FLOOD_LIGHT\nfloat flood_radiance=(1.0-min(v_pos.z/v_flood_radius,1.0))*u_flood_light_intensity*v_has_flood_light;color.rgb=mix(color.rgb,u_flood_light_color,flood_radiance);\n#endif\ncolor.rgb=mix(color.rgb,linearTosRGB(base_color.rgb),emissive);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_pos.z));\n#endif\ncolor*=u_opacity;\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_pos.z);\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord);\n#endif\nglFragColor=color; \n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;in vec3 a_normal_3;in vec3 a_centroid_3;in float a_flood_light_wall_radius_1i16;in vec4 a_faux_facade_data;in vec2 a_faux_facade_vertical_range;uniform mat4 u_matrix;uniform mat4 u_normal_matrix;uniform highp float u_tile_to_meter;out vec4 v_color;out vec3 v_normal;out highp vec3 v_pos;\n#ifdef BUILDING_FAUX_FACADE\nout lowp float v_faux_facade;out highp float v_faux_facade_ed;out highp vec2 v_faux_facade_window;out highp vec2 v_faux_facade_floor;out highp vec2 v_faux_facade_range;out highp float v_aspect;out highp vec3 v_tbn_0;out highp vec3 v_tbn_1;out highp vec3 v_tbn_2;out highp vec4 v_faux_color_emissive;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nout highp float v_flood_radius;out float v_has_flood_light;\n#endif\nconst float MAX_UINT_16=65535.0;const float MAX_INT_16=32767.0;const float MAX_UINT_8=255.0;const float TWO_POW_8=256.0;const float FLOOD_LIGHT_MAX_RADIUS_METER=2048.0;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#ifdef BUILDING_FAUX_FACADE\nmat3 get_tbn(in vec3 normal) {const vec3 bitangent=vec3(0.0,0.0,1.0);vec3 tangent=normalize(vec3(normal.y,-normal.x,0.0));return mat3(tangent,bitangent,normal);}\n#endif\n#pragma mapbox: define-attribute-vertex-shader-only highp vec2 part_color_emissive\n#pragma mapbox: define-attribute-vertex-shader-only highp vec2 faux_facade_color_emissive\nvoid main() {\n#pragma mapbox: initialize-attribute-custom highp vec2 part_color_emissive\n#pragma mapbox: initialize-attribute-custom highp vec2 faux_facade_color_emissive\n#ifdef FLOOD_LIGHT\nv_flood_radius=(a_flood_light_wall_radius_1i16/MAX_INT_16*FLOOD_LIGHT_MAX_RADIUS_METER);v_has_flood_light=step(0.0,v_flood_radius);\n#endif\nvec4 color_emissive=decode_color(part_color_emissive);v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);vec3 a_normal_3f=a_normal_3/MAX_INT_16;v_normal=vec3(u_normal_matrix*vec4(a_normal_3f,0.0));float hidden=0.0;float depth_offset=0.0;\n#ifdef BUILDING_FAUX_FACADE\nv_faux_facade=a_faux_facade_data.x;if (v_faux_facade > 0.0) {v_faux_facade_ed=a_faux_facade_data.x *u_tile_to_meter;float window_x_perc=floor(a_faux_facade_data.y/TWO_POW_8);float window_y_perc=a_faux_facade_data.y-TWO_POW_8*window_x_perc;vec2 window_perc=vec2(window_x_perc,window_y_perc)/MAX_UINT_8;v_faux_facade_floor=(a_faux_facade_data.zw/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_faux_facade_window=window_perc*v_faux_facade_floor;v_faux_facade_range=(a_faux_facade_vertical_range/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_aspect=v_faux_facade_window.x/v_faux_facade_window.y;mat3 tbn=get_tbn(normalize(v_normal));v_tbn_0=tbn[0];v_tbn_1=tbn[1];v_tbn_2=tbn[2];v_faux_color_emissive=decode_color(faux_facade_color_emissive);v_faux_color_emissive.rgb=sRGBToLinear(v_faux_color_emissive.rgb);float height=a_centroid_3.z;depth_offset=min(1000.0,height)*0.0000002;}\n#endif\nv_pos=a_pos_3f;\n#ifdef RENDER_CUTOFF\nvec4 ground=u_matrix*vec4(a_centroid_3,1.0);v_cutoff_opacity=cutoff_opacity(u_cutoff_params,ground.z);hidden=float(v_cutoff_opacity==0.0);v_pos.z*=v_cutoff_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=v_pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(v_pos);\n#endif\ngl_Position=mix(u_matrix*vec4(v_pos,1),AWAY,hidden);gl_Position.z-=depth_offset*gl_Position.w;}'),
            buildingBloom: os("in vec4 v_color_emissive;\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\nfloat saturate(float val) {return clamp(val,0.0,1.0);}void main() {float emission=v_color_emissive.a;float opacity=1.0;\n#ifdef HAS_ATTRIBUTE_a_bloom_attenuation\nfloat distance=length(vec2(1.3*max(0.0,abs(bloom_attenuation.x)-bloom_attenuation.z),bloom_attenuation.y));distance+= mix(0.5,0.0,clamp(emission-1.0,0.0,1.0));opacity*=saturate(1.0-distance*distance);\n#endif\n#ifdef RENDER_CUTOFF\nopacity*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(v_color_emissive.rgb,1.0)*opacity;}", "in vec3 a_pos_3f;\n#pragma mapbox: define-attribute-vertex-shader-only highp vec2 part_color_emissive\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nout vec4 v_color_emissive;uniform mat4 u_matrix;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute-custom highp vec2 part_color_emissive\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\n#ifdef HAS_ATTRIBUTE_a_part_color_emissive\nvec4 color_emissive=decode_color(part_color_emissive);float part_emissive=color_emissive.a*5.0;v_color_emissive=vec4(sRGBToLinear(color_emissive.rgb),part_emissive);\n#else\nv_color_emissive=vec4(1.0);\n#endif\ngl_Position=u_matrix*vec4(a_pos_3f,1.0);\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}"),
            buildingDepth: os("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;void main() {gl_Position=u_matrix*vec4(a_pos_3f,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
            circle: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: os("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: os('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: os("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: os("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform float u_zoom_transition;\n#endif\nout float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec3 proj_pos=a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation);\n#ifdef PROJECTION_GLOBE_VIEW\n#ifndef PROJECTED_POS_ON_VIEWPORT\nvec3 globe_pos=proj_pos;vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,a_anchor_pos,u_tile_id,u_merc_center);proj_pos=mix_globe_mercator(globe_pos,mercator_pos,u_zoom_transition);\n#endif\n#endif\nvec4 projectedPoint=u_matrix*vec4(proj_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: os("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: os("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            elevatedStructuresDepth: os("void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=vec4(0.);\n#endif\n}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"),
            elevatedStructuresDepthReconstruct: os("#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#else\n#ifdef FEATURE_CUTOUT\napply_feature_cutout(vec4(0.0,0.0,0.0,1.0),gl_FragCoord);\n#endif\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}"),
            elevatedStructures: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat shadowed_lighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb=apply_lighting(color.rgb,transformed_normal,shadowed_lighting_factor);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_height);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\nglFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;in float a_height;in vec3 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=a_pos_normal_3/16384.0;v_height=a_height;vec3 pos=vec3(a_pos,a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fill: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=opacity;\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\nglFragColor=out_color;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'),
            fillOutline: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef FLIP_Y\nv_pos=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FLIP_Y\nv_pos_world=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,h);\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);\n#ifdef CLIP_ZERO_TO_ONE\ncutoff=cutoff_opacity(u_cutoff_params,ground.z*2.0-ground.w);\n#else\ncutoff=cutoff_opacity(u_cutoff_params,ground.z);\n#endif\nif (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillExtrusionDepth: os("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: os('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: os("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(1.0-texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size)).a,0.0,0.0,0.0);\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: os("precision highp float;uniform highp sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform highp vec2 u_trim_gradient_mix_range;uniform lowp vec4 u_trim_color;uniform bool u_emissive_in_shadows;in vec4 v_width2_dilute;in vec2 v_normal;in float v_gamma_scale;in highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nin float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\nfloat dist=length(v_normal)*v_width2_dilute.x;\n#ifdef VARIABLE_LINE_WIDTH\nblur=mix(blur,0.0,stub_side);\n#endif\nfloat diluted_opacity=opacity*v_width2_dilute.z;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2_dilute.y-blur2),v_width2_dilute.x-dist)/blur2,0.0,1.0);\n#ifdef VARIABLE_LINE_WIDTH\nalpha=mix(alpha,1.0,stub_side);\n#endif\nalpha=side_z_offset > 0.0 ? 1.0-alpha : alpha;\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);highp float gradient_trim_color_mix_factor=0.0;\n#ifdef RENDER_LINE_GRADIENT\ngradient_trim_color_mix_factor=smoothstep(u_trim_gradient_mix_range.x,u_trim_gradient_mix_range.y,line_progress);\n#endif\nhighp vec4 trim_color=mix(u_trim_color,out_color,gradient_trim_color_mix_factor);out_color=mix(u_trim_gradient_mix_range.x < 1.0 ? color : out_color,trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\nfloat edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2_dilute.y-edgeBlur),v_width2_dilute.x-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}out_color*=v_width2_dilute.w;}\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=u_emissive_in_shadows ? mix(light,1.0,emissive_strength) : light;\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*diluted_opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\nglFragColor=out_color;\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)\nin vec3 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;\n#ifdef RENDER_LINE_CURVE\nuniform mat3 u_curve_points_x;uniform mat3 u_curve_points_y;uniform mat3 u_curve_points_z;uniform float u_curve_point_count;\n#endif\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec4 v_width2_dilute;out float v_gamma_scale;out highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nout float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\n#ifdef RENDER_LINE_CURVE\nvec3 getCurvePoint(int index) {int row=index/3;int col=index-row*3;float x=u_curve_points_x[row][col];float y=u_curve_points_y[row][col];float z=u_curve_points_z[row][col];return vec3(x,y,z);}vec3 catmullRom(vec3 p0,vec3 p1,vec3 p2,vec3 p3,float t) {float t2=t*t;float t3=t2*t;return 0.5*(\n2.0*p1+(-p0+p2)*t+(2.0*p0-5.0*p1+4.0*p2-p3)*t2+(-p0+3.0*p1-3.0*p2+p3)*t3\n);}vec2 catmullRomTangent(vec2 p0,vec2 p1,vec2 p2,vec2 p3,float t) {float t2=t*t;return 0.5*(\n(-p0+p2)+(2.0*p0-5.0*p1+4.0*p2-p3)*2.0*t+(-p0+3.0*p1-3.0*p2+p3)*3.0*t2\n);}struct CurveResult {vec3 point;vec2 tangent;};CurveResult calculateCurve(float line_progress) {float curve_progress=line_progress*(u_curve_point_count-1.0);float curve_progress_local=fract(curve_progress);float curve_segment=floor(curve_progress);int seg=int(curve_segment);vec3 p1=getCurvePoint(seg);vec3 p2=getCurvePoint(seg+1);float is_first_seg=step(curve_segment,0.5);vec3 p0_extrapolated=p1-(p2-p1);vec3 p0_fetched=getCurvePoint(max(seg-1,0));vec3 p0=mix(p0_fetched,p0_extrapolated,is_first_seg);int last_seg=int(u_curve_point_count)-2;float is_last_seg=step(float(last_seg)-0.5,curve_segment);vec3 p3_extrapolated=p2+(p2-p1);vec3 p3_fetched=getCurvePoint(min(seg+2,int(u_curve_point_count)-1));vec3 p3=mix(p3_fetched,p3_extrapolated,is_last_seg);vec3 point=catmullRom(p0,p1,p2,p3,curve_progress_local);vec2 tangent=catmullRomTangent(p0.xy,p1.xy,p2.xy,p3.xy,curve_progress_local)*(u_curve_point_count-1.0);CurveResult result;result.point=point;result.tangent=tangent;return result;}\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nhighp float line_progress=0.0;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nline_progress=a_packed[2];\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;offset=-1.0*offset*u_width_scale;bool left=normal.y==1.0;\n#ifdef RENDER_LINE_CURVE\nCurveResult curve=calculateCurve(line_progress);pos=curve.point.xy*8192.0;a_extrude=length(a_extrude)*normalize(curve.tangent);a_extrude=left ? vec2(-a_extrude.y,a_extrude.x) : vec2(a_extrude.y,-a_extrude.x);a_z_offset+=curve.point.z;\n#endif\ngapwidth=gapwidth/2.0;float halfwidth;float dilute_scale=1.0;float dilute_border_scale=1.0;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left_width=a_z_offset_width.y;float right_width=a_z_offset_width.z;halfwidth=(u_width_scale*(left ? left_width : right_width))/2.0;if (side_z_offset !=0.0) {float left_f=step(1.0,normal.y);float is_negative=step(side_z_offset,0.0);float apply=mix(1.0-left_f,left_f,is_negative);a_extrude*=apply;a_z_offset+=abs(side_z_offset)*apply;v_normal*=left_f;}offset=border_width > 0.0 ? (left_width+right_width)*u_width_scale*0.5 : offset;halfwidth=border_width > 0.0 ? border_width*u_width_scale*0.5 : halfwidth;bool zero_right_width=border_width==0.0 && right_width==0.0;stub_side=zero_right_width ?-normal.y : 0.0;v_normal=!left && zero_right_width ? vec2(0.0) : v_normal;ANTIALIASING=!left && zero_right_width ? 0.0 : ANTIALIASING;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\nfloat inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0);\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0);\n#endif\n#endif\n#ifndef ELEVATED\n#ifndef VARIABLE_LINE_WIDTH\n#ifndef RENDER_TO_TEXTURE\nfloat base_w=gl_Position.w;vec2 screen_width=abs(projected_extrude.xy/base_w*u_units_to_pixels);float max_extrude_component=max(screen_width.x,screen_width.y);if (base_w > 0.0 && max_extrude_component > 0.0001) {float min_pixel=1.05;if (max_extrude_component < min_pixel) {vec2 abs_pos=abs(gl_Position.xy);float is_out=max(abs_pos.x,abs_pos.y)/base_w;dilute_scale=mix(max_extrude_component/min_pixel,1.0,smoothstep(2.5,4.5,is_out));projected_extrude/=dilute_scale;}else\n{\n#ifdef RENDER_LINE_BORDER\nfloat border_ratio=(border_width*u_width_scale+ANTIALIASING)/outset;screen_width*=border_ratio;float max_border_component=max(screen_width.x,screen_width.y);dilute_border_scale=min(1.0,max_border_component/min_pixel);\n#endif\n}}\n#endif\n#endif\n#ifdef ELEVATED_ROADS\ngl_Position=gl_Position+projected_extrude;\n#else\ngl_Position=mix(gl_Position+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2_dilute=vec4(outset,inset,dilute_scale,dilute_border_scale);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            linePattern: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec3 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            raster: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;\n#endif\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;uv=a_uv;float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT);\n#endif\nglobe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nvec4 world_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nuv=a_texture_pos/8192.0;vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);  \nfloat tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT)-decomposed_pos_and_skirt.z;\n#endif\nvec4 merc_world_pos=vec4(0.0);   \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,ele,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);world_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat ele=0.0;vec2 decodedPos=a_pos;\n#ifdef ELEVATION_REFERENCE_GROUND\nvec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;decodedPos=decomposedPosAndSkirt.xy;uv=decodedPos/8192.0;ele=elevation(decodedPos)-skirt;\n#else\nuv=a_texture_pos/8192.0;\n#endif\nworld_pos=vec4(decodedPos,(u_raster_elevation+ele),1.0);\n#ifdef FOG\nv_fog_pos=fog_position(decodedPos);\n#endif\n#endif\nfloat w=1.0+dot(uv*EXTENT,u_perspective_transform);gl_Position=u_matrix*world_pos*w;\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef ELEVATED\nfloat z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor);gl_Position.z-=(gl_Position.w*zbias);\n#endif\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            rasterParticle: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),1.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: os("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: os("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: os('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"),
            symbol: os('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef TERRAIN\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#else\nout_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#define USING_APPEARANCE 1.0\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float a_size_max= floor(a_size[1]*0.5);float a_apperance=a_size[1]-2.0*a_size_max;vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (a_apperance==USING_APPEARANCE) {size=a_size_max/128.0;} else if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size_max,u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);    \n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\n#ifdef Z_TEST_OCCLUSION\nout_fade_opacity*=occlusion_opacity;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#else\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n#endif\n}'),
            terrainRaster: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nin vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;vec3 unlit_base=image_color.rgb*(1.0-emissive_strength);vec3 emissive_base=image_color.rgb*emissive_strength;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;color.rgb=mix(color.rgb,image_color.rgb,emissive_strength);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: os("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: os('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Fo),
            skyboxGradient: os('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Fo),
            skyboxCapture: os("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nuniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nhighp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : raster.a;raster=apply_lighting_with_emission_ground(raster,emissive_strength);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : color.a;color=apply_lighting_with_emission_ground(color,emissive_strength);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: os('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_atmosphere_fog_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_atmosphere_fog_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_atmosphere_fog_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: os('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;\n#ifdef DITHERED_DISCARD\nuniform float u_dithered_discard_threshold;\n#endif\nuniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef FLIP_Y\ncoord.y=1.0-coord.y;\n#endif\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;\n#ifdef FLIP_Y\nT=-T;B=-B;\n#endif\nhighp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));\n#ifdef FLIP_Y\nn=normalize(cross(fdx,fdy));\n#else\nn=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef DITHERED_DISCARD\nif (abs(u_dithered_discard_threshold) < 1.0) {float ditherValue=fract(52.9829189*fract(0.06711056*gl_FragCoord.x+0.00583715*gl_FragCoord.y));float compareValue=mix(1.0-ditherValue,ditherValue,step(0.0,u_dithered_discard_threshold));if (abs(u_dithered_discard_threshold) < compareValue) {discard;}}\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\n#ifdef FEATURE_CUTOUT\nfinalColor=apply_feature_cutout(finalColor,gl_FragCoord);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#ifdef CLIP_ZERO_TO_ONE\nv_depth=-1.0+2.0*v_depth; \n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: os("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: os("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            snowParticle: os("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: os("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: os("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            occlusion: os("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function is(e, t1) {
            const i = e.split("\n");
            for (let e of i){
                if (e = e.trimStart(), "#" !== e[0]) continue;
                if (!e.includes("if")) continue;
                if (e.startsWith("#endif")) continue;
                const i = e.match(Zo);
                if (i) for (const e of i)Wo.has(e) || t1.add(e);
            }
        }
        function os(e, t1) {
            const i = new Set, o = [], s = [];
            e = e.replace(Ho, (e, t1)=>(s.push(t1), "")), t1 = t1.replace(Ho, (e, t1)=>(o.push(t1), ""));
            let r = new Set($o);
            is(e, r), is(t1, r);
            for (const e of [
                ...o,
                ...s
            ])Ko[e] || (Ko[e] = new Set, is(Xo[e], Ko[e])), r = new Set([
                ...r,
                ...Ko[e]
            ]);
            return {
                fragmentSource: e = e.replace(qo, (e, t1, o, s, r)=>(i.add(r), "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nin ${o} ${s} ${r};\n#else\nuniform ${o} ${s} u_${r};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${r}\n    ${o} ${s} ${r} = u_${r};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    in ${o} ${s} ${r};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(qo, (e, t1, o, s, r)=>{
                    const n = `MATERIAL_ATTRIBUTE_OFFSET_${r}`, a = "float" === s ? "vec2" : s, l = `GET_ATTRIBUTE_${a}(a_${r}, materialInfo, ${n})`, c = r.match(/color/) ? "color" : a;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\nin ${o} ${s} a_${r};\n#endif\n` : i.has(r) ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\n    #if !defined(${n})\n        in ${o} ${a} a_${r};\n    #endif\nout ${o} ${s} ${r};\n#else\nuniform ${o} ${s} u_${r};\n#endif\n` : "initialize" === t1 ? "vec4" === c ? `\n#ifndef HAS_UNIFORM_u_${r}\n    ${r} = a_${r};\n#else\n    ${o} ${s} ${r} = u_${r};\n#endif\n` : `\n#if !defined(HAS_UNIFORM_u_${r})\n    #ifdef ${n}\n        ${r} = unpack_mix_${c}(${l}, u_${r}_t);\n    #else\n        ${r} = unpack_mix_${c}(a_${r}, u_${r}_t);\n    #endif\n#else\n    ${o} ${s} ${r} = u_${r};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    in ${o} ${s} a_${r};\n    out ${o} ${s} ${r};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    ${r} = a_${r};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${r}\nuniform lowp float u_${r}_t;\n    #if !defined(${n})\n        in ${o} ${a} a_${r};\n    #endif\n#else\nuniform ${o} ${s} u_${r};\n#endif\n` : "define-instanced" === t1 ? "mat4" === c ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${r}0;\nin vec4 a_${r}1;\nin vec4 a_${r}2;\nin vec4 a_${r}3;\n#else\nuniform ${o} ${s} u_${r};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${o} ${a} a_${r};\n#else\nuniform ${o} ${s} u_${r};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${r}\n    ${o} ${s} ${r} = a_${r};\n#endif\n` : "vec4" === c ? `\n#ifndef HAS_UNIFORM_u_${r}\n    #ifdef ${n}\n        ${o} ${s} ${r} = ${l};\n    #else\n        ${o} ${s} ${r} = a_${r};\n    #endif\n#else\n    ${o} ${s} ${r} = u_${r};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${r}\n    #ifdef ${n}\n        ${o} ${s} ${r} = unpack_mix_${c}(${l}, u_${r}_t);\n    #else\n        ${o} ${s} ${r} = unpack_mix_${c}(a_${r}, u_${r}_t);\n    #endif\n#else\n    ${o} ${s} ${r} = u_${r};\n#endif\n`;
                }),
                usedDefines: r,
                vertexIncludes: o,
                fragmentIncludes: s
            };
        }
        class ss {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e, t1, i, o, s, r, n, a) {
                this.context = e;
                let l = this.boundPaintVertexBuffers.length !== o.length;
                for(let e = 0; !l && e < o.length; e++)this.boundPaintVertexBuffers[e] !== o[e] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== n.length;
                for(let e = 0; !c && e < n.length; e++)this.boundDynamicVertexBuffers[e] !== n[e] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== s || this.boundVertexOffset !== r) this.freshBind(t1, i, o, s, r, n, a);
                else {
                    e.bindVertexArrayOES.set(this.vao);
                    for (const i of n)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e.gl, t1, a));
                    s && s.dynamicDraw && s.bind();
                }
            }
            freshBind(e, t1, i, o, s, r, n) {
                const a = this.context, l = a.gl;
                this.vao && this.destroy(), this.vao = a.gl.createVertexArray(), a.bindVertexArrayOES.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = s, this.boundDynamicVertexBuffers = r, t1.enableAttributes(l, e), t1.bind(), t1.setVertexAttribPointers(l, e, s);
                for (const t1 of i)t1.enableAttributes(l, e), t1.bind(), t1.setVertexAttribPointers(l, e, s);
                for (const t1 of r)t1 && (t1.enableAttributes(l, e), t1.bind(), t1.setVertexAttribPointers(l, e, s), n && t1.instanceCount && t1.setVertexAttribDivisor(l, e, n));
                o && o.bind();
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function rs(t1, i) {
            const o = Math.pow(2, i.canonical.z), s = i.canonical.y;
            return [
                new e.af(0, s / o).toLngLat().lat,
                new e.af(0, (s + 1) / o).toLngLat().lat
            ];
        }
        function ns(t1, i, o, s, r, n, a) {
            const l = t1.context, c = l.gl, h = o.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const d = t1.isTileAffectedByFog(i), u = [];
            t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && u.push("USE_MRT1");
            const _ = t1.getOrCreateProgram("hillshade", {
                overrideFog: d,
                defines: u
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment0.get());
            const p = ((t1, i, o, s)=>{
                const r = o.paint.get("hillshade-shadow-color"), n = "none" === o.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a = o.paint.get("hillshade-highlight-color"), l = "none" === o.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = o.paint.get("hillshade-accent-color"), h = "none" === o.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d = o.paint.get("hillshade-emissive-strength");
                let u = e.ao(o.paint.get("hillshade-illumination-direction"));
                if ("viewport" === o.paint.get("hillshade-illumination-anchor")) u -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), o = e.d5(i.x, i.y, i.z);
                    u = e.ao(o[1]);
                }
                const _ = !t1.options.moving;
                return {
                    u_matrix: s || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), _),
                    u_image: 0,
                    u_latrange: rs(0, i.tileID),
                    u_light: [
                        o.paint.get("hillshade-exaggeration"),
                        u
                    ],
                    u_shadow: r.toPremultipliedRenderColor(n ? null : o.lut),
                    u_highlight: a.toPremultipliedRenderColor(l ? null : o.lut),
                    u_emissive_strength: d,
                    u_accent: c.toPremultipliedRenderColor(h ? null : o.lut)
                };
            })(t1, o, s, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, _, i.toUnwrapped());
            const { tileBoundsBuffer: f, tileBoundsIndexBuffer: m, tileBoundsSegments: g } = t1.getTileBoundsBuffers(o);
            _.draw(t1, c.TRIANGLES, r, n, a, Ji.disabled, p, s.id, f, m, g);
        }
        function as(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const s = t1.context, r = s.gl;
            s.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const n = o.getPixels();
            i.demTexture ? i.demTexture.update(n, {
                premultiply: !1
            }) : i.demTexture = new e.T(s, n, r.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function ls(t1, i, o) {
            const s = t1.context, r = s.gl;
            if (!i.dem) return;
            const n = i.dem;
            if (s.activeTexture.set(r.TEXTURE1), as(t1, i, n), !i.demTexture) return;
            i.demTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE);
            const a = n.dim;
            s.activeTexture.set(r.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e.T(s, {
                    width: a,
                    height: a,
                    data: null
                }, r.RGBA8);
                t1.bind(r.LINEAR, r.CLAMP_TO_EDGE), l = i.hillshadeFBO = s.createFramebuffer(a, a, 1, "renderbuffer"), l.colorAttachment0.set(t1.texture);
            }
            s.bindFramebuffer.set(l.framebuffer), s.viewport.set([
                0,
                0,
                a,
                a
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: d } = t1.getMercatorTileBoundsBuffers(), u = [];
            t1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && u.push("USE_MRT1"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(t1, r.TRIANGLES, Wi.disabled, Xi.disabled, Zi.unblended, Ji.disabled, ((t1, i)=>{
                const o = i.stride, s = e.bD();
                return e.cf(s, 0, e.am, -e.am, 0, 0, 1), e.bs(s, s, [
                    0,
                    -e.am,
                    0
                ]), {
                    u_matrix: s,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, n), o.id, c, h, d), i.needsHillshadePrepare = !1;
        }
        class cs {
            constructor(e){
                this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class hs extends cs {
            getDefault() {
                return e.ap.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class ds extends cs {
            getDefault() {
                return 1;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
            }
        }
        class us extends cs {
            getDefault() {
                return 0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
            }
        }
        class _s extends cs {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class ps extends cs {
            getDefault() {
                return !0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
            }
        }
        class fs extends cs {
            getDefault() {
                return 255;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
            }
        }
        class ms extends cs {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e) {
                const t1 = this.current;
                (e.func !== t1.func || e.ref !== t1.ref || e.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
            }
        }
        class gs extends cs {
            getDefault() {
                const e = this.gl;
                return [
                    e.KEEP,
                    e.KEEP,
                    e.KEEP
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
            }
        }
        class vs extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e, this.dirty = !1;
            }
        }
        class ys extends cs {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class xs extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e, this.dirty = !1;
            }
        }
        class bs extends cs {
            getDefault() {
                return this.gl.LESS;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
            }
        }
        class ws extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e, this.dirty = !1;
            }
        }
        class Ts extends cs {
            getDefault() {
                const e = this.gl;
                return [
                    e.ONE,
                    e.ZERO,
                    e.ONE,
                    e.ZERO
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Es extends cs {
            getDefault() {
                return e.ap.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class Ss extends cs {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e, e), this.current = e, this.dirty = !1);
            }
        }
        class Is extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e, this.dirty = !1;
            }
        }
        class Cs extends cs {
            getDefault() {
                return this.gl.BACK;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
            }
        }
        class Rs extends cs {
            getDefault() {
                return this.gl.CCW;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
            }
        }
        let As = class extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
            }
        };
        class Ds extends cs {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
            }
        }
        class Ls extends cs {
            getDefault() {
                const e = this.gl;
                return [
                    0,
                    0,
                    e.drawingBufferWidth,
                    e.drawingBufferHeight
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Ps extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Os extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class zs extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e), this.current = e, this.dirty = !1;
            }
        }
        class Ms extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Fs extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ks extends cs {
            getDefault() {
                return null;
            }
            set(e) {
                this.gl && (e !== this.current || this.dirty) && (this.gl.bindVertexArray(e), this.current = e, this.dirty = !1);
            }
        }
        class Bs extends cs {
            getDefault() {
                return 4;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
            }
        }
        class Ns extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Us extends cs {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class js extends cs {
            constructor(e, t1){
                super(e), this.context = e, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class Vs extends js {
            constructor(e, t1, i = 0){
                super(e, t1), this.attachmentPoint = e.gl.COLOR_ATTACHMENT0 + i;
            }
            setDirty() {
                this.dirty = !0;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachmentPoint, t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Gs extends js {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Hs extends js {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class qs extends Gs {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const Zs = (e, t1, i, o)=>({
                u_matrix: e,
                u_image0: 0,
                u_image1: 1,
                u_skirt_height: t1,
                u_ground_shadow_factor: i,
                u_emissive_texture_available: o
            }), Ws = (e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m)=>({
                u_proj_matrix: Float32Array.from(e),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: s,
                u_merc_center: r,
                u_image0: 0,
                u_image1: 1,
                u_frustum_tl: n,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: d,
                u_viewport: u,
                u_grid_matrix: m ? Float32Array.from(m) : new Float32Array(9),
                u_skirt_height: _,
                u_far_z_cutoff: p,
                u_emissive_texture_available: f
            });
        function $s(e, t1) {
            return null != e && null != t1 && !(!e.hasData() || !t1.hasData()) && null != e.demTexture && null != t1.demTexture && e.tileID.key !== t1.tileID.key;
        }
        const Xs = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e, t1, i, o, s) {
                if (e in this.operations) {
                    const t1 = this.operations[e];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e] = {
                    startTime: o,
                    phase: 0,
                    duration: s,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e) {
                if (!(e in this.operations)) return null;
                const t1 = this.operations[e];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e, t1) {
                return !!e.queued && (e.from = e.to, e.to = e.queued, e.queued = null, e.phase = 0, e.startTime = t1, !0);
            }
            _validOp(e) {
                return e.from.hasData() && e.to.hasData();
            }
        }, Ks = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function Ys(e, t1, i) {
            if (0 === t1) return 0;
            const o = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e) * Math.max(t1, 1) * o;
        }
        function Js(e, t1) {
            const i = 1 << e.z;
            return !t1 && (0 === e.x || e.x === i - 1) || 0 === e.y || e.y === i - 1;
        }
        function Qs(e, t1) {
            if (!e.style || !e.style.enable3dLights()) return;
            const i = e.context, o = i.gl;
            i.activeTexture.set(o.TEXTURE1), t1 ? t1.bind(o.LINEAR, o.CLAMP_TO_EDGE) : e.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
        }
        const er = (e)=>({
                u_matrix: e
            });
        function tr(t1, i, o, s, r) {
            if (r > 0) {
                const n = e.o.now(), a = (n - t1.timeAdded) / r, l = i ? (n - i.timeAdded) / r : -1, c = o.getSource(), h = s.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), u = d && t1.refreshedUponExpiration ? 1 : e.aB(d ? a : 1 - l, 0, 1);
                return i ? {
                    opacity: 1,
                    mix: 1 - u,
                    isFading: a < 1
                } : {
                    opacity: u,
                    mix: 0,
                    isFading: a < 1
                };
            }
            return {
                opacity: 1,
                mix: 0,
                isFading: !1
            };
        }
        class ir extends Ft {
            constructor(e){
                const t1 = {
                    type: "raster-dem",
                    maxzoom: Math.ceil(e.transform.maxZoom)
                }, i = mt("mock-dem", t1, e.style.dispatcher, e.style);
                super("mock-dem", i, !1), i.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e, t1) {
                e.state = "loaded", t1(null);
            }
        }
        class or extends Ft {
            constructor(e){
                const t1 = mt("proxy", {
                    type: "geojson",
                    maxzoom: Math.ceil(e.transform.maxZoom)
                }, e.style.dispatcher, e.style);
                super("proxy", t1, !1), t1.setEventedParent(this), this.map = this.getSource().map = e, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e, t1, i) {
                if (e.freezeTileCoverage) return;
                this.transform = e;
                const o = e.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t1, i)=>{
                    if (t1[i.key] = "", !this._tiles[i.key]) {
                        const t1 = new Pt(i, this._source.tileSize * i.overscaleFactor(), e.tileZoom, void 0, void 0, this._source.worldview);
                        t1.state = "loaded", this._tiles[i.key] = t1;
                    }
                    return t1;
                }, {});
                for(const e in this._tiles)e in o || (this.freeFBO(e), this._tiles[e].unloadVectorData(), delete this._tiles[e]);
            }
            freeFBO(e) {
                const t1 = this.proxyCachedFBO[e];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e)=>e.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class sr extends e.aR {
            constructor(e, t1, i){
                super(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class rr extends e.bW {
            constructor(t1, i){
                super(), this._debugParams = {
                    sortTilesHiZFirst: !0,
                    disableRenderCache: !1
                }, this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, s, r] = function() {
                    const t1 = new e.be, i = new e.b1, o = 131;
                    t1.reserve(17161), i.reserve(33800);
                    const s = e.am / 128, r = e.am + s / 2, n = r + s;
                    for(let i = -s; i < n; i += s)for(let o = -s; o < n; o += s){
                        const s = o < 0 || o > r || i < 0 || i > r ? 24575 : 0, n = e.aB(Math.round(o), 0, e.am), a = e.aB(Math.round(i), 0, e.am);
                        t1.emplaceBack(n + s, a);
                    }
                    const a = (e, t1)=>{
                        const s = t1 * o + e;
                        i.emplaceBack(s + 1, s, s + o), i.emplaceBack(s + o, s + o + 1, s + 1);
                    };
                    for(let e = 1; e < 129; e++)for(let t1 = 1; t1 < 129; t1++)a(t1, e);
                    return [
                        0,
                        129
                    ].forEach((e)=>{
                        for(let t1 = 0; t1 < 130; t1++)a(t1, e), a(e, t1);
                    }), [
                        t1,
                        i,
                        32768
                    ];
                }(), n = t1.context;
                this.gridBuffer = n.createVertexBuffer(o, e.bg.members), this.gridIndexBuffer = n.createIndexBuffer(s), this.gridSegments = e.bh.simpleSegment(0, 0, o.length, s.length), this.gridNoSkirtSegments = e.bh.simpleSegment(0, 0, o.length, r), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new or(i.map), this.orthoMatrix = e.bD(), e.cf(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e.am, 0, e.am, 0, 1);
                const a = n.gl;
                this._overlapStencilMode = new Xi({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new ir(i.map), this._pendingGroundEffectLayers = [], this._emissiveTexture = !1;
            }
            set style(e) {
                e.on("data", this._onStyleDataEvent.bind(this)), this._style = e, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const s = t1.terrain.properties, r = 0 === t1.terrain.drapeRenderMode, n = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.o.now();
                    const a = t1.terrain && t1.terrain.scope, l = s.get("source"), c = r ? this._mockSourceCache : t1.getSourceCache(l, a);
                    if (!c) return void e.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = n ? this.calculateExaggeration(i) : s.get("exaggeration"), !i.projection.requiresDraping && n && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, o = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = o;
                const s = null != i ? o - i : Number.MAX_VALUE;
                if (Math.abs(s) < 2) return this._exaggeration;
                const r = t1.zoom, n = this._style.terrain;
                if (!this._previousUpdateTimestamp) return n.getExaggeration(r);
                let a = r - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = r;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(r - c) > .5 && (a = .5 * (r - c + a)), a * s < 0 && (c += a)), this._evaluationZoom = c;
                const h = n.getExaggeration(c), d = h === n.getExaggeration(Math.max(0, c - .1));
                if (d && Math.abs(h - this._exaggeration) < .01) return h;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (d || h < .1 || Math.abs(a) < 1e-4) && (u = Math.min(.2, 4 * u)), e.al(this._exaggeration, h, u);
            }
            resetTileLookupCache(e) {
                this._findCoveringTileCache[e] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e) {
                "source" === e.dataType && e.coord ? this._clearRenderCacheForTile(e.sourceCacheId, e.coord) : "style" === e.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e)=>e.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e,
                    e
                ];
            }
            set useVertexMorphing(e) {
                this._useVertexMorphing = e;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e.af.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const s = this.proxyCoords = i.getIds().map((e)=>{
                    const t1 = i.getTileByID(e).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), s = new e.P(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), r = new e.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), n = s.mult(1 << t1.canonical.z);
                        return n.x -= .5, n.y -= .5, n.distSqr(o) - n.distSqr(r);
                    });
                }(s, this.painter);
                const r = this.proxyToSource || {};
                this.proxyToSource = {}, s.forEach((e)=>{
                    this.proxyToSource[e.key] = {};
                }), this.terrainTileForTile = {};
                const n = this._style._mergedSourceCaches;
                for(const e in n){
                    const i = n[e];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e], r), i.usedForTerrain) continue;
                    const o = t1[e];
                    (i.getSource().reparseOverscaled || i._isRasterElevatedOverTerrain) && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = s.map((e)=>new sr(e, e.key, this.orthoMatrix)), this._assignTerrainTiles(s), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(r), this.renderingToTexture = !1;
                const a = {};
                this._visibleDemTiles = [];
                for (const e of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e) {
                this._initializing || e.forEach((e)=>{
                    if (this.terrainTileForTile[e.key]) return;
                    const t1 = this._findTileCoveringTileID(e, this.sourceCache);
                    t1 && (this.terrainTileForTile[e.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e = this.painter.context, t1 = e.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], s = o.dem;
                    !s || o.demTexture && !o.needsDEMTextureUpload || (e.activeTexture.set(t1.TEXTURE1), as(this.painter, o, s));
                }
            }
            _prepareDemTileUniforms(e, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const s = e.tileID.canonical, r = Math.pow(2, t1.tileID.canonical.z - s.z), n = o || "";
                return i[`u_dem_tl${n}`] = [
                    s.x * r % 1,
                    s.y * r % 1
                ], i[`u_dem_scale${n}`] = r, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e++, t1 + o;
                }, 0);
                return e ? t1 / e : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), s = new e.dN({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    o
                ]));
                this._emptyDEMTextureDirty = !1;
                let r = this._emptyDEMTexture;
                return r ? r.update(s, {
                    premultiply: !1
                }) : r = this._emptyDEMTexture = new e.T(t1, s, i.R32F, {
                    premultiply: !1
                }), r;
            }
            setupElevationDraw(t1, i, o) {
                const s = this.painter.context, r = s.gl, n = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                n.u_exaggeration = this.exaggeration();
                let a = null, l = null, c = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    c = o.morphing.phase, e && i && (this._prepareDemTileUniforms(t1, e, n, "_prev") && (l = e), this._prepareDemTileUniforms(t1, i, n) && (a = i));
                }
                const h = (e)=>e && e.demTexture && this.painter.linearFloatFilteringSupported() ? r.LINEAR : r.NEAREST;
                let d = null;
                var u;
                if (this.enabled ? l && a ? (d = a.demTexture, s.activeTexture.set(r.TEXTURE4), l.demTexture.bind(h(l), r.CLAMP_TO_EDGE), n.u_dem_lerp = c) : (a = this.terrainTileForTile[t1.tileID.key], d = this._prepareDemTileUniforms(t1, a, n) ? a.demTexture : this.emptyDEMTexture) : d = this.emptyDEMTexture, s.activeTexture.set(r.TEXTURE2), d && (n.u_dem_size = 1 === (u = d).size[0] ? 1 : u.size[0] - 2, d.bind(h(a), r.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, n), o && o.useMeterToDem && a) {
                    const t1 = (1 << a.tileID.canonical.z) * e.cg(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    n.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (n.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(s, n), "globe" === this.painter.transform.projection.name) {
                    const e = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(s, e);
                }
            }
            globeUniformValues(t1, i, o) {
                const s = t1.projection;
                return {
                    u_tile_tl_up: s.upVector(i, 0, 0),
                    u_tile_tr_up: s.upVector(i, e.am, 0),
                    u_tile_br_up: s.upVector(i, e.am, e.am),
                    u_tile_bl_up: s.upVector(i, 0, e.am),
                    u_tile_up_scale: o ? e.dO(1) : s.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, s, r) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, s, r) {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.transform, d = e.dG(t1, n, h), u = (e, i)=>{
                            if (c === i) return;
                            const o = [
                                Ks[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && o.push("CUSTOM_ANTIALIASING");
                            const s = t1.isTileAffectedByFog(e);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: o,
                                overrideFog: s
                            }), c = i;
                        }, _ = t1.colorModeForRenderPass(), p = new Wi(a.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D);
                        Xs.update(r);
                        const f = e.dH(h), m = [
                            e.aG(h.center.lng),
                            e.aK(h.center.lat)
                        ], g = t1.globeSharedBuffers, v = [
                            h.width * e.o.devicePixelRatio,
                            h.height * e.o.devicePixelRatio
                        ], y = Float32Array.from(h.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, d = Ys(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const b = a.TRIANGLES;
                            for (const c of s){
                                const s = o.getTile(c), w = Xi.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                $s(T, E) && Xs.newMorphing(c.key, T, E, r, 250), Qs(t1, s.emissiveTexture), n.activeTexture.set(a.TEXTURE0), s.texture && s.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const S = Xs.getMorphValuesForProxy(c.key), I = S ? 1 : 0;
                                S && Object.assign(x, {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e.dF(S.phase)
                                    }
                                });
                                const C = e.dI(c.canonical), R = e.dJ(C.getCenter().lat), A = e.dK(c.canonical, C, R, h.worldSize / h._pixelsPerMercatorPixel), D = e.bl(e.dL(c.canonical)), L = "mrt-fallback" === t1.emissiveMode ? 1 : 0, P = Ws(h.expandedFarZProjMatrix, y, f, D, e.ak(h.zoom), m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, d, h._farZ, L, A);
                                if (u(c, I), l && (i.setupElevationDraw(s, l, x), t1.uploadCommonUniforms(n, l, c.toUnwrapped()), g)) {
                                    const [e, i, o] = g.getGridBuffers(R, 0 !== d);
                                    l.draw(t1, b, p, w, _, Ji.backCCW, P, "globe_raster", e, i, o);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const r = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && r.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: r
                            });
                            for (const r of s){
                                const { x: s, y: c, z: d } = r.canonical, u = 0 === c, f = c === (1 << d) - 1, [y, b, w, T] = g.getPoleBuffers(d, !1);
                                if (T && (u || f)) {
                                    const c = o.getTile(r);
                                    Qs(t1, c.emissiveTexture), n.activeTexture.set(a.TEXTURE0), c.texture && c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let g = e.dM(d, s, h);
                                    const E = e.bl(e.dL(r.canonical)), S = "mrt-fallback" === t1.emissiveMode ? 1 : 0, I = (e, i)=>e.draw(t1, a.TRIANGLES, p, Xi.disabled, _, Ji.disabled, Ws(h.expandedFarZProjMatrix, g, g, E, 0, m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ, S), "globe_pole_raster", i, w, T);
                                    i.setupElevationDraw(c, l, x), t1.uploadCommonUniforms(n, l, r.toUnwrapped()), u && t1.renderDefaultNorthPole && I(l, y), f && t1.renderDefaultSouthPole && (g = e.cT(e.bD(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), I(l, b));
                                }
                            }
                        }
                    }(t1, i, o, s, r);
                    else {
                        const n = t1.context, a = n.gl;
                        let l, c;
                        const h = t1.shadowRenderer, d = lo(t1, t1.longestCutoffRange), u = (e)=>{
                            if (c === e) return;
                            const i = [];
                            i.push(Ks[e]), d.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e;
                        }, _ = t1.colorModeForRenderPass(), p = new Wi(a.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D);
                        Xs.update(r);
                        const f = t1.transform, m = Ys(f.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (g = mo(t1.style, e, i));
                        }
                        {
                            c = -1;
                            const v = a.TRIANGLES, [y, x] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of s){
                                const s = o.getTile(c), b = Xi.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                $s(w, T) && Xs.newMorphing(c.key, w, T, r, 250), Qs(t1, s.emissiveTexture), n.activeTexture.set(a.TEXTURE0), s.texture && s.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const E = Xs.getMorphValuesForProxy(c.key), S = E ? 1 : 0;
                                let I;
                                E && (I = {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: e.dF(E.phase)
                                    }
                                });
                                const C = "mrt-fallback" === t1.emissiveMode ? 1 : 0, R = Zs(c.projMatrix, Js(c.canonical, f.renderWorldCopies) ? m / 10 : m, g, C);
                                if (u(S), !l) continue;
                                i.setupElevationDraw(s, l, I);
                                const A = c.toUnwrapped();
                                h && h.setupShadows(A, l), t1.uploadCommonUniforms(n, l, A, null, d), l.draw(t1, v, p, b, _, Ji.backCCW, R, "terrain_raster", i.gridBuffer, y, x);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, s = this.proxySourceCache, r = this.proxiedCoords[s.id], n = this._drapedRenderBatches.shift(), a = i.style.order, l = [];
                this._updateFBOs("mrt-fallback" === i.emissiveMode);
                let c = 0;
                for (const h of r){
                    const r = s.getTileByID(h.proxyTileKey), d = s.proxyCachedFBO[h.key] ? s.proxyCachedFBO[h.key][t1] : void 0, u = void 0 !== d ? s.renderCache[d] : this.pool[c++], _ = void 0 !== d;
                    if (r.texture = u.tex, r.emissiveTexture = u.emissiveTex, _ && !u.dirty) {
                        l.push(r.tileID);
                        continue;
                    }
                    o.bindFramebuffer.set(u.fb.framebuffer);
                    const p = o.gl;
                    let f;
                    p.drawBuffers("mrt-fallback" === i.emissiveMode ? [
                        p.COLOR_ATTACHMENT0,
                        p.COLOR_ATTACHMENT1
                    ] : [
                        p.COLOR_ATTACHMENT0
                    ]), this.renderedToTile = !1, u.dirty && (o.clear({
                        color: e.ap.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e = n.start; e <= n.end; ++e){
                        const t1 = i.style._mergedLayers[a[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const n = r;
                        o.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), f !== (s ? s.id : null) && (this._setupStencil(u, r, t1, s), f = s ? s.id : null), i.renderLayer(i, s, t1, n);
                    }
                    if (p.drawBuffers([
                        p.COLOR_ATTACHMENT0
                    ]), 0 === this._drapedRenderBatches.length) for (const e of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[a[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const n = r;
                        o.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), f !== (s ? s.id : null) && (this._setupStencil(u, r, t1, s), f = s ? s.id : null), i.renderLayer(i, s, t1, n);
                    }
                    this.renderedToTile ? (u.dirty = !0, l.push(r.tileID)) : _ || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), n.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e) {
                const t1 = e.order.length;
                let i = -1, o = t1;
                for(let s = 0; s < t1; ++s)this._style.isLayerDraped(e._mergedLayers[e.order[s]]) ? i = Math.max(i, s) : o = Math.min(o, s);
                return o > i;
            }
            getMinElevationBelowMSL() {
                let e = 0;
                return this._visibleDemTiles.filter((e)=>e.dem).forEach((t1)=>{
                    e = Math.min(e, t1.dem.tree.minimums[0]);
                }), 0 === e ? e : (e - 30) * this._exaggeration;
            }
            raycast(e, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e)=>e.dem).map((o)=>{
                    const s = o.tileID, r = 1 << s.overscaledZ, { x: n, y: a } = s.canonical, l = n / r, c = (n + 1) / r, h = a / r, d = (a + 1) / r;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: d,
                        t: o.dem.tree.raycastRoot(l, h, c, d, e, t1, i),
                        tile: o
                    };
                });
                o.sort((e, t1)=>(null !== e.t ? e.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const s of o){
                    if (null == s.t) return null;
                    const o = s.tile.dem.tree.raycast(s.minx, s.miny, s.maxx, s.maxy, e, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const s = new e.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA8);
                s.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const r = t1.createFramebuffer(o[0], o[1], 1, null);
                let n;
                return r.colorAttachment0.set(s.texture), this._emissiveTexture && (n = new e.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.R8), n.bind(i.LINEAR, i.CLAMP_TO_EDGE), r.createColorAttachment(t1, 1), r.colorAttachment1.set(n.texture)), r.depthAttachment = new qs(t1, r.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, r.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : r.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: r,
                    tex: s,
                    emissiveTex: n,
                    dirty: !1
                };
            }
            _updateFBOs(e) {
                if (this._emissiveTexture !== e) {
                    for (const t1 of this.pool)this._updateFBO(t1, e);
                    for (const t1 of this.proxySourceCache.renderCache)this._updateFBO(t1, e);
                    this._emissiveTexture = e;
                }
            }
            _updateFBO(t1, i) {
                const o = t1.fb, s = this.painter.context, r = s.gl, n = this.drapeBufferSize;
                if (i) {
                    const i = new e.T(s, {
                        width: n[0],
                        height: n[1],
                        data: null
                    }, r.R8);
                    i.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.emissiveTex = i, o.createColorAttachment(s, 1), o.colorAttachment1.set(i.texture);
                } else t1.emissiveTex = void 0, o.removeColorAttachment(s, 1);
                t1.dirty = !0;
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._debugParams.disableRenderCache) return !0;
                if (this._style.hasLightTransitions()) return !0;
                for(const e in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e].hasTransition()) return !0;
                return this._style.order.some((e)=>{
                    const t1 = this._style._mergedLayers[e], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e of this._style.getSources())if (e instanceof dt) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._mergedLayers[this._style.order[t1]], s = this._style.getLayerSourceCache(o);
                    if (!s || i[s.id]) continue;
                    if (o.isHidden(this.painter.transform.zoom) || "line" !== o.type) continue;
                    const r = o.widthExpression(), n = o.emissiveStrengthExpression();
                    if (r instanceof e.ae || n instanceof e.ae) {
                        i[s.id] = !0;
                        for (const e of this.proxyCoords){
                            const t1 = this.proxyToSource[e.key][s.id];
                            if (t1) for (const e of t1)this._clearRenderCacheForTile(s.id, e);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof ut) {
                    e = !0;
                    break;
                }
                if (!e) return;
                const t1 = {};
                for(let e = 0; e < this._style.order.length; ++e){
                    const i = this._style._mergedLayers[this._style.order[e]], o = this._style.getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const s = i.paint.get("raster-fade-duration");
                    for (const e of this.proxyCoords){
                        const t1 = this.proxyToSource[e.key][o.id];
                        if (t1) for (const e of t1){
                            const t1 = tr(o.getTile(e), o.findLoadedParent(e, 0), o, this.painter.transform, s);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const o = [];
                this._pendingGroundEffectLayers = [];
                let s, r = 0, n = this._style._mergedLayers[t1[r]];
                for(; !this._style.isLayerDraped(n) && n.isHidden(this.painter.transform.zoom) && ++r < i;)n = this._style._mergedLayers[t1[r]];
                for(; r < i; ++r){
                    const e = this._style._mergedLayers[t1[r]];
                    e.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e) ? void 0 === s && (s = r) : ("fill-extrusion" === e.type && this._pendingGroundEffectLayers.push(r), void 0 !== s && (o.push({
                        start: s,
                        end: r - 1
                    }), s = void 0)));
                }
                if (void 0 !== s && o.push({
                    start: s,
                    end: r - 1
                }), 0 !== o.length) {
                    const t1 = o[o.length - 1];
                    this._pendingGroundEffectLayers.every((e)=>e > t1.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = o;
            }
            _setupRenderCache(e) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e.length; ++i){
                            const o = Object.values(e[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let s = i.length - 1; s >= 0; s--){
                    const r = i[s];
                    if (t1.getTileByID(r.key), void 0 !== t1.proxyCachedFBO[r.key]) {
                        const i = e[r.key], s = this.proxyToSource[r.key];
                        let n = 0;
                        for(const e in s){
                            const t1 = s[e], r = i[e];
                            if (!r || r.length !== t1.length || t1.some((t1, i)=>t1 !== r[i] || o[e] && o[e].hasOwnProperty(t1.key))) {
                                n = -1;
                                break;
                            }
                            ++n;
                        }
                        for(const e in t1.proxyCachedFBO[r.key])t1.renderCache[t1.proxyCachedFBO[r.key][e]].dirty = n < 0 || n !== Object.values(i).length;
                    }
                }
                const s = [
                    ...this._drapedRenderBatches
                ];
                s.sort((e, t1)=>t1.end - t1.start - (e.end - e.start));
                for (const e of s)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const s = this.painter.context, r = s.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let n;
                if (i.isTileClipped()) n = t1.length, this._overlapStencilMode.test = {
                    func: r.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    n = 1, this._overlapStencilMode.test = {
                        func: r.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + n > 255 && (s.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += n, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e.key]), this._overlapStencilMode) : Xi.disabled;
            }
            _renderTileClippingMasks(e, t1) {
                const i = this.painter, o = this.painter.context, s = o.gl;
                i._tileClippingMaskIDs = {}, o.setColorMode(Zi.disabled), o.setDepthMode(Wi.disabled);
                const r = i.getOrCreateProgram("clippingMask");
                for (const o of e){
                    const e = i._tileClippingMaskIDs[o.key] = --t1;
                    r.draw(i, s.TRIANGLES, Wi.disabled, new Xi({
                        func: s.ALWAYS,
                        mask: 0
                    }, e, 255, s.KEEP, s.KEEP, s.REPLACE), Zi.disabled, Ji.disabled, er(o.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.aD(o, o, i.pixelMatrixInverse), e.cL(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const s = i._camera.position, r = e.cg(1, i.center.lat), n = [
                    s[0],
                    s[1],
                    s[2] / r,
                    0
                ], a = e.db([], o.slice(0, 3), n);
                e.ax(a, a);
                const l = this.raycast(n, a, this._exaggeration);
                return null !== l && l ? (e.bI(n, n, a, l), n[3] = n[2], n[2] *= r, n) : null;
            }
            _setupProxiedCoordsForOrtho(t1, i, o) {
                if (t1.getSource() instanceof e.aV) return this._setupProxiedCoordsForImageSource(t1, i, o);
                this._findCoveringTileCache[t1.id] = this._findCoveringTileCache[t1.id] || {};
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords;
                for(let e = 0; e < r.length; e++){
                    const i = r[e], n = this._findTileCoveringTileID(i, t1);
                    if (n) {
                        const e = this._createProxiedId(i, n, o[i.key] && o[i.key][t1.id]);
                        s.push(e), this.proxyToSource[i.key][t1.id] = [
                            e
                        ];
                    }
                }
                let n = !1;
                const a = new Set;
                for(let e = 0; e < i.length; e++){
                    const r = t1.getTile(i[e]);
                    if (!r || !r.hasData()) continue;
                    const l = this._findTileCoveringTileID(r.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== r.tileID.canonical.z) {
                        const e = this.proxyToSource[l.tileID.key][t1.id], i = this._createProxiedId(l.tileID, r, o[l.tileID.key] && o[l.tileID.key][t1.id]);
                        e ? e.splice(e.length - 1, 0, i) : this.proxyToSource[l.tileID.key][t1.id] = [
                            i
                        ];
                        const c = this.proxyToSource[l.tileID.key][t1.id];
                        a.has(c) || a.add(c), s.push(i), n = !0;
                    }
                }
                if (this._sourceTilesOverlap[t1.id] = n, n && this._debugParams.sortTilesHiZFirst) for (const e of a)e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords, n = t1.getSource(), a = n.tileID;
                if (!a) return;
                const l = new e.P(a.x, a.y)._div(1 << a.z), c = n.coordinates.map(e.af.fromLngLat).reduce((e, t1)=>(e.min.x = Math.min(e.min.x, t1.x - l.x), e.min.y = Math.min(e.min.y, t1.y - l.y), e.max.x = Math.max(e.max.x, t1.x - l.x), e.max.y = Math.max(e.max.y, t1.y - l.y), e), {
                    min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), s = t1.canonical.y / (1 << t1.canonical.z), r = e.am / (1 << t1.canonical.z), n = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return o + r < n + c.min.x || o > n + c.max.x || s + r < a + c.min.y || s > a + c.max.y;
                };
                for(let e = 0; e < r.length; e++){
                    const n = r[e];
                    for(let e = 0; e < i.length; e++){
                        const r = t1.getTile(i[e]);
                        if (!r || !r.hasData()) continue;
                        if (h(n, r.tileID)) continue;
                        const a = this._createProxiedId(n, r, o[n.key] && o[n.key][t1.id]), l = this.proxyToSource[n.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[n.key][t1.id] = [
                            a
                        ], s.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let s = this.orthoMatrix;
                if (o) {
                    const e = o.find((e)=>e.key === i.tileID.key);
                    if (e) return e;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let r, n, a;
                    s = e.bD();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (r = e.am >> o, n = r * ((i.tileID.canonical.x << o) - t1.canonical.x + l), a = r * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (r = e.am << -o, n = e.am * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), a = e.am * (i.tileID.canonical.y - (t1.canonical.y << -o))), e.cf(s, 0, r, 0, r, 0, 1), e.bs(s, s, [
                        n,
                        a,
                        0
                    ]);
                }
                return new sr(i.tileID, t1.key, s);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const s = this._findCoveringTileCache[i.id], r = s[t1.key];
                if (o = r ? i.getTileByID(r) : null, o && o.hasData() || null === r) return o;
                let n = o ? o.tileID : t1, a = n.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!r) {
                    const s = i.getSource().maxzoom;
                    if (t1.canonical.z >= s) {
                        const o = t1.canonical.z - s;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), n = new e.aR(a, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (a = s, n = new e.aR(a, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    n.key !== t1.key && (c.push(n.key), o = i.getTile(n));
                }
                const h = (e)=>{
                    c.forEach((t1)=>{
                        s[t1] = e;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!o || !o.hasData()); a--){
                    o && h(o.tileID.key);
                    const e = n.calculateScaledKey(a);
                    if (o = i.getTileByID(e), o && o.hasData()) break;
                    const t1 = s[e];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e) {
                return this.enabled ? this._findTileCoveringTileID(e, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e, t1) {
                let i = this._tilesDirty[e];
                i || (i = this._tilesDirty[e] = {}), i[t1.key] = !0;
            }
        }
        function nr(t1, i, o) {
            const s = function(t1, i, o) {
                const s = e.bK(i, t1), r = e.bK(o, [
                    .2126,
                    .7152,
                    .0722
                ]), n = (e, t1, i)=>(1 - i) * e + i * t1, a = n(1 - .3 * Math.min(r, 1), 1, Math.min(s + 1, 1));
                return n(.92, 1, Math.asin(e.aB(i[2], -1, 1)) / Math.PI + .5) * a;
            }(t1, [
                0,
                0,
                1
            ], i), r = [
                0,
                0,
                0
            ];
            e.c6(r, o.slice(0, 3), s);
            const n = [
                0,
                0,
                0
            ];
            e.c6(n, i.slice(0, 3), t1[2]);
            const a = [
                0,
                0,
                0
            ];
            return e.d9(a, r, n), e.dc(a);
        }
        const ar = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], lr = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "building",
            "buildingBloom",
            "elevatedStructures",
            "model",
            "symbol"
        ];
        class cr {
            static cacheKey(e, t1, i, o) {
                const s = [
                    t1
                ];
                o && s.push(o.cacheKey);
                for (const t1 of i)e.usedDefines.has(t1) && s.push(t1);
                return s.join("/");
            }
            constructor(t1, i, o, s, r, n){
                const a = t1.gl;
                this.program = a.createProgram(), this.configuration = s, this.name = i, this.fixedDefines = [
                    ...n
                ];
                const l = `#version 300 es\n${(s ? s.defines() : []).concat(n.map((e)=>`#define ${e}`)).join("\n")}`, c = [
                    l,
                    Qo
                ];
                for (const e of o.fragmentIncludes)c.push(Xo[e]);
                c.push(o.fragmentSource);
                const h = c.join("\n"), d = [
                    l,
                    es
                ];
                for (const e of o.vertexIncludes)d.push(Xo[e]);
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && o.vertexSource.includes("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && d.push("uniform int u_instanceID;"), d.push(o.vertexSource);
                let u = d.join("\n");
                this.forceManualRenderingForInstanceIDShaders && (u = u.replaceAll("gl_InstanceID", "u_instanceID"));
                const _ = a.createShader(a.FRAGMENT_SHADER);
                if (a.isContextLost()) return void (this.failedToCreate = !0);
                a.shaderSource(_, h), a.compileShader(_), a.attachShader(this.program, _);
                const p = a.createShader(a.VERTEX_SHADER);
                a.isContextLost() ? this.failedToCreate = !0 : (a.shaderSource(p, u), a.compileShader(p), a.attachShader(this.program, p), this.attributes = {}, a.linkProgram(this.program), a.deleteShader(p), a.deleteShader(_), this.fixedUniforms = r(t1), this.fixedUniformsEntries = Object.entries(this.fixedUniforms), this.binderUniforms = s ? s.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                        u_instanceID: new e.ci(t1)
                    }))(t1)), (n.includes("TERRAIN") || n.includes("ELEVATED") || i.includes("symbol") || i.includes("circle")) && (this.terrainUniforms = ((t1)=>({
                        u_dem: new e.ci(t1),
                        u_dem_prev: new e.ci(t1),
                        u_dem_tl: new e.cl(t1),
                        u_dem_scale: new e.ck(t1),
                        u_dem_tl_prev: new e.cl(t1),
                        u_dem_scale_prev: new e.ck(t1),
                        u_dem_size: new e.ck(t1),
                        u_dem_lerp: new e.ck(t1),
                        u_exaggeration: new e.ck(t1),
                        u_depth: new e.ci(t1),
                        u_depth_size_inv: new e.cl(t1),
                        u_depth_range_unpack: new e.cl(t1),
                        u_occluder_half_size: new e.ck(t1),
                        u_occlusion_depth_offset: new e.ck(t1),
                        u_meter_to_dem: new e.ck(t1),
                        u_label_plane_matrix_inv: new e.cm(t1)
                    }))(t1)), n.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                        u_tile_tl_up: new e.cj(t1),
                        u_tile_tr_up: new e.cj(t1),
                        u_tile_br_up: new e.cj(t1),
                        u_tile_bl_up: new e.cj(t1),
                        u_tile_up_scale: new e.ck(t1)
                    }))(t1)), n.includes("FOG") && (this.fogUniforms = ((t1)=>({
                        u_fog_matrix: new e.cm(t1),
                        u_fog_range: new e.cl(t1),
                        u_fog_color: new e.d4(t1),
                        u_fog_horizon_blend: new e.ck(t1),
                        u_fog_vertical_limit: new e.cl(t1),
                        u_fog_temporal_offset: new e.ck(t1),
                        u_frustum_tl: new e.cj(t1),
                        u_frustum_tr: new e.cj(t1),
                        u_frustum_br: new e.cj(t1),
                        u_frustum_bl: new e.cj(t1),
                        u_globe_pos: new e.cj(t1),
                        u_globe_radius: new e.ck(t1),
                        u_globe_transition: new e.ck(t1),
                        u_is_globe: new e.ci(t1),
                        u_viewport: new e.cl(t1)
                    }))(t1)), n.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t1)=>({
                        u_cutoff_params: new e.d4(t1)
                    }))(t1)), n.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                        u_lighting_ambient_color: new e.cj(t1),
                        u_lighting_directional_dir: new e.cj(t1),
                        u_lighting_directional_color: new e.cj(t1),
                        u_ground_radiance: new e.cj(t1)
                    }))(t1)), n.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t1)=>({
                        u_light_matrix_0: new e.cm(t1),
                        u_light_matrix_1: new e.cm(t1),
                        u_fade_range: new e.cl(t1),
                        u_shadow_normal_offset: new e.cj(t1),
                        u_shadow_intensity: new e.ck(t1),
                        u_shadow_texel_size: new e.ck(t1),
                        u_shadow_map_resolution: new e.ck(t1),
                        u_shadow_direction: new e.cj(t1),
                        u_shadow_bias: new e.cj(t1),
                        u_shadowmap_0: new e.ci(t1),
                        u_shadowmap_1: new e.ci(t1)
                    }))(t1)));
            }
            getAttributeLocation(e, t1) {
                let i = this.attributes[t1];
                return void 0 === i && (i = this.attributes[t1] = e.getAttribLocation(this.program, t1)), i;
            }
            setTerrainUniformValues(e, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setGlobeUniformValues(e, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setFogUniformValues(e, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setCutoffUniformValues(e, t1) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setLightsUniformValues(e, t1) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setShadowUniformValues(e, t1) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e.program.set(this.program);
                for(const e in t1)i[e].set(this.program, e, t1[e]);
            }
            _drawDebugWireframe(t1, i, o, s, r, n, a, l, c, h) {
                const d = t1.options.wireframe;
                if (!1 === d.terrain && !1 === d.layers2D && !1 === d.layers3D) return;
                const u = t1.context;
                if (!(()=>!(!d.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!d.layers2D || t1._terrain && t1._terrain.renderingToTexture || !ar.includes(this.name)) || !(!d.layers3D || !lr.includes(this.name)))()) return;
                const _ = u.gl, p = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, r, u);
                if (!p) return;
                const f = [
                    ...this.fixedDefines,
                    "DEBUG_WIREFRAME"
                ], m = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                u.program.set(m.program);
                const g = (e, t1, i)=>{
                    if (t1[e] && i[e]) for(const o in t1[e])i[e][o] && i[e][o].set(i.program, o, t1[e][o].current);
                };
                c && c.setUniforms(m.program, u, m.binderUniforms, a, {
                    zoom: l
                }), g("fixedUniforms", this, m), g("terrainUniforms", this, m), g("globeUniforms", this, m), g("fogUniforms", this, m), g("lightsUniforms", this, m), g("shadowUniforms", this, m), p.bind(), u.setColorMode(new Zi([
                    _.ONE,
                    _.ONE_MINUS_SRC_ALPHA,
                    _.ZERO,
                    _.ONE
                ], e.ap.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), u.setDepthMode(new Wi(i.func === _.LESS ? _.LEQUAL : i.func, Wi.ReadOnly, i.range)), u.setStencilMode(Xi.disabled);
                const v = 3 * n.primitiveLength * 2, y = 3 * n.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e = h || 1;
                    for(let t1 = 0; t1 < e; ++t1)m.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                } else h && h > 1 ? _.drawElementsInstanced(_.LINES, v, _.UNSIGNED_SHORT, y, h) : _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                r.bind(), u.program.set(this.program), u.setDepthMode(i), u.setStencilMode(o), u.setColorMode(s);
            }
            checkUniforms(e, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const o of Object.keys(i))if (!i[o].initialized) throw new Error(`Program '${this.name}', from draw '${e}': uniform ${o} not set but required by ${t1} being defined`);
                }
            }
            draw(e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f) {
                const m = e.context, g = m.gl;
                if (this.failedToCreate) return;
                m.program.set(this.program), m.setDepthMode(i), m.setStencilMode(o), m.setColorMode(s), m.setCullFace(r);
                for (const [e, t1] of this.fixedUniformsEntries)t1.set(this.program, e, n[e]);
                _ && _.setUniforms(this.program, m, this.binderUniforms, d, {
                    zoom: u
                });
                const v = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(a, "RENDER_SHADOWS", this.shadowUniforms);
                const y = p || [], x = _ ? _.getPaintVertexBuffers() : [], b = t1 === g.TRIANGLES && c, w = f && f > 0 ? 1 : void 0;
                for (const r of h.get()){
                    const n = r.vaos || (r.vaos = {});
                    if ((n[a] || (n[a] = new ss)).bind(m, this, l, x, c, r.vertexOffset, y, w), this.forceManualRenderingForInstanceIDShaders) {
                        const e = f || 1;
                        for(let i = 0; i < e; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    } else f && f > 1 ? g.drawElementsInstanced(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2, f) : c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    b && this._drawDebugWireframe(e, i, o, s, c, r, d, u, _, f);
                }
            }
        }
        function hr(t1, i, o = 0) {
            const s = Math.pow(2, i.tileID.overscaledZ), r = i.tileSize * Math.pow(2, t1.transform.tileZoom) / s, n = r * (i.tileID.canonical.x + i.tileID.wrap * s), a = r * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / e.az(i, 1, t1.transform.tileZoom),
                u_pixel_coord_upper: [
                    n >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & a
                ],
                u_pattern_transition: o
            };
        }
        const dr = {
            terrain: 0,
            flat: 1
        }, ur = e.bD(), _r = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v)=>{
            const y = i.style.light, x = y.properties.get("position"), b = [
                x.x,
                x.y,
                x.z
            ], w = e.dQ();
            "viewport" === y.properties.get("anchor") && (e.dR(w, -i.transform.angle), e.dS(b, b, w));
            const T = y.properties.get("color").toPremultipliedRenderColor(null), E = i.transform, S = {
                u_matrix: t1,
                u_lightpos: b,
                u_lightintensity: y.properties.get("intensity"),
                u_lightcolor: [
                    T.r,
                    T.g,
                    T.b
                ],
                u_vertical_gradient: +o,
                u_opacity: s,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: ur,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: dr[h],
                u_base_type: dr[d],
                u_ao: r,
                u_edge_radius: n,
                u_width_scale: a,
                u_flood_light_color: f,
                u_vertical_scale: m,
                u_flood_light_intensity: g,
                u_ground_shadow_factor: v
            };
            return "globe" === E.projection.name && (S.u_tile_id = [
                l.canonical.x,
                l.canonical.y,
                1 << l.canonical.z
            ], S.u_zoom_transition = u, S.u_inv_rot_matrix = p, S.u_merc_center = _, S.u_up_dir = E.projection.upVector(new e.cE(0, 0, 0), _[0] * e.am, _[1] * e.am), S.u_height_lift = c), S;
        }, pr = (e, t1, i, o, s, r)=>({
                u_matrix: e,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: o,
                u_height_type: dr[s],
                u_base_type: dr[r]
            }), fr = (e, t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g)=>{
            const v = _r(e, t1, i, o, s, r, n, a, c, h, d, u, _, p, f, m, 1, [
                0,
                0,
                0
            ]), y = {
                u_height_factor: -Math.pow(2, a.overscaledZ) / l.tileSize / 8
            };
            return Object.assign(v, hr(t1, l, g), y);
        }, mr = (e, t1, i)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_ground_shadow_factor: i
            }), gr = (e, t1, i, o, s, r = 0)=>Object.assign(mr(e, t1, s), hr(i, o, r)), vr = (e, t1, i, o)=>({
                u_matrix: e,
                u_world: i,
                u_emissive_strength: t1,
                u_ground_shadow_factor: o
            }), yr = (e, t1, i, o, s, r, n = 0)=>Object.assign(gr(e, t1, i, o, r, n), {
                u_world: s
            }), xr = (e, t1)=>({
                u_matrix: e,
                u_depth_bias: t1
            }), br = (e, t1)=>({
                u_matrix: e,
                u_ground_shadow_factor: t1
            }), wr = (e, t1, i, o, s)=>({
                u_matrix: e,
                u_camera_pos: [
                    t1[0],
                    t1[1],
                    t1[2]
                ],
                u_depth_bias: i,
                u_height_scale: o,
                u_reset_depth: s
            }), Tr = (e, t1, i, o, s, r, n, a, l)=>({
                u_matrix: e,
                u_normal_matrix: t1,
                u_opacity: i,
                u_faux_facade_ao_intensity: o,
                u_camera_pos: s,
                u_tile_to_meter: r,
                u_facade_emissive_chance: n,
                u_flood_light_color: a,
                u_flood_light_intensity: l
            }), Er = (e)=>({
                u_matrix: e
            }), Sr = (e)=>({
                u_matrix: e
            }), Ir = (t1, i, o, s, r, n, a, l)=>{
            const c = e.am / n.tileSize;
            return {
                u_matrix: t1,
                u_inv_rot_matrix: i,
                u_camera_to_center_distance: o.getCameraToCenterDistance(l),
                u_extrude_scale: [
                    o.pixelsToGLUnits[0] / c,
                    o.pixelsToGLUnits[1] / c
                ],
                u_zoom_transition: s,
                u_tile_id: a,
                u_merc_center: r
            };
        }, Cr = (e, t1, i, o)=>({
                u_matrix: e,
                u_inv_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(o),
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            }), Rr = (e, t1, i = 1)=>({
                u_matrix: e,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), Ar = e.bD(), Dr = (t1, i, o, s, r, n, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e.dT(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e.az(o, 1, n), d = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: Ar,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                d.u_inv_rot_matrix = s, d.u_merc_center = r, d.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], d.u_zoom_transition = e.ak(l.zoom);
                const t1 = r[0] * e.am, o = r[1] * e.am;
                d.u_up_dir = l.projection.upVector(new e.cE(0, 0, 0), t1, o);
            }
            return d;
        };
        function Lr(e, [t1, i, o, s], [r, n]) {
            if (r === n) return [
                0,
                0,
                0,
                0
            ];
            const a = 255 * (e - 1) / (e * (n - r));
            return [
                t1 * a,
                i * a,
                o * a,
                s * a
            ];
        }
        function Pr(e, t1, [i, o]) {
            return i === o ? 0 : .5 / e + (t1 - i) * (e - 1) / (e * (o - i));
        }
        function Or(t1) {
            const i = t1.terrain ? t1.terrain.exaggeration() : 1;
            var o;
            return (t1.transform.pitch < 15 ? .07 * (1 - (o = e.aB((14 - t1.transform.zoom) / 5, 0, 1))) + .7 * o : .07) * i;
        }
        const zr = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x, b, w)=>({
                u_matrix: i,
                u_normalize_matrix: o,
                u_globe_matrix: s,
                u_merc_matrix: r,
                u_grid_matrix: n,
                u_tl_parent: a,
                u_scale_parent: d,
                u_fade_t: u.mix,
                u_opacity: u.opacity * _.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: _.paint.get("raster-brightness-min"),
                u_brightness_high: _.paint.get("raster-brightness-max"),
                u_saturation_factor: e.dV(_.paint.get("raster-saturation")),
                u_contrast_factor: e.dU(_.paint.get("raster-contrast")),
                u_spin_weights: Mr(_.paint.get("raster-hue-rotate")),
                u_perspective_transform: p,
                u_raster_elevation: f,
                u_zoom_transition: l,
                u_merc_center: c,
                u_cutoff_params: h,
                u_colorization_mix: Lr(e.dW, g, y),
                u_colorization_offset: Pr(e.dW, v, y),
                u_color_ramp: m,
                u_texture_offset: [
                    b / (x + 2 * b),
                    x / (x + 2 * b)
                ],
                u_texture_res: [
                    x + 2 * b,
                    x + 2 * b
                ],
                u_emissive_strength: w,
                u_zbias_factor: Or(t1)
            });
        function Mr(e) {
            e *= Math.PI / 180;
            const t1 = Math.sin(e), i = Math.cos(e);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const Fr = .05, kr = (e, t1, i, o, s, r, n, a, l, c, h, d)=>({
                u_matrix: e,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: o,
                u_grid_matrix: s,
                u_tl_parent: r,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: d,
                u_zoom_transition: n,
                u_merc_center: a,
                u_cutoff_params: l
            }), Br = (e, t1, i, o, s, r, n, a, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: o,
                u_color_ramp: r,
                u_velocity_res: s,
                u_max_speed: n,
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Fr,
                    Fr
                ]
            }), Nr = (e, t1, i, o, s, r, n, a, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: o,
                u_max_speed: s,
                u_speed_factor: r,
                u_reset_rate: n,
                u_rand_seed: Math.random(),
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    Fr,
                    Fr
                ]
            }), Ur = e.bD(), jr = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x, b, w, T, E)=>{
            const S = r.transform, I = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: S.getCameraToCenterDistance(y),
                u_rotate_symbol: +o,
                u_aspect_ratio: S.width / S.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: n,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +h,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +s,
                u_texsize: d,
                u_texsize_icon: u,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Ur,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: Ur,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: w,
                u_icon_transition: T || 0,
                u_gamma_scale: s ? r.transform.getCameraToCenterDistance(y) * Math.cos(r.terrain ? 0 : r.transform._pitch) : 1,
                u_device_pixel_ratio: e.o.devicePixelRatio,
                u_is_halo: 1,
                u_scale_factor: E || 1,
                u_ground_shadow_factor: x,
                u_inv_matrix: e.bm(e.bD(), a),
                u_normal_scale: b,
                u_lutTexture: 10
            };
            return "globe" === y.name && (I.u_tile_id = [
                p.canonical.x,
                p.canonical.y,
                1 << p.canonical.z
            ], I.u_zoom_transition = f, I.u_inv_rot_matrix = g, I.u_merc_center = m, I.u_camera_forward = S._camera.forward(), I.u_ecef_origin = e.dX(S.globeMatrix, p.toUnwrapped()), I.u_tile_matrix = Float32Array.from(S.globeMatrix), I.u_up_vector = v), I;
        }, Vr = (e, t1, i, o)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: o
            }), Gr = (t1, i, o, s, r, n, a, l, c)=>Object.assign(function(t1, i, o, s, r, n) {
                const { width: a, height: l } = s.imageManager.getPixelSize(i), c = Math.pow(2, n.tileID.overscaledZ), h = n.tileSize * Math.pow(2, s.transform.tileZoom) / c, d = h * (n.tileID.canonical.x + n.tileID.wrap * c), u = h * n.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        a,
                        l
                    ],
                    u_pattern_size: o.displaySize,
                    u_pattern_units_to_pixels: r ? [
                        s.transform.width,
                        -1 * s.transform.height
                    ] : [
                        1 / e.az(n, 1, s.transform.tileZoom),
                        1 / e.az(n, 1, s.transform.tileZoom)
                    ],
                    u_pixel_coord_upper: [
                        d >> 16,
                        u >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & d,
                        65535 & u
                    ]
                };
            }(0, n, a, s, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: o
            }), Hr = new Float32Array(e.bB([])), qr = (t1, i, o, s, r, n, a, l, c, h, d, u, _, p = [
            0,
            0,
            0
        ], f, m, g)=>{
            const v = r.style.light, y = v.properties.get("position"), x = [
                -y.x,
                -y.y,
                y.z
            ], b = e.dQ();
            "viewport" === v.properties.get("anchor") && (e.dR(b, -r.transform.angle), e.dS(x, x, b));
            const w = "MASK" === d.alphaMode, T = v.properties.get("color").toNonPremultipliedRenderColor(null), E = _.paint.get("model-ambient-occlusion-intensity"), S = _.paint.get("model-color").constantOr(e.ap.white).toNonPremultipliedRenderColor(null);
            return S.a = _.paint.get("model-color-mix-intensity").constantOr(0), g && (S.r = g[0], S.g = g[1], S.b = g[2], S.a = g[3]), m && (S.r = m.color.r, S.g = m.color.g, S.b = m.color.b, S.a = m.colorMix, u = m.emissionStrength, n *= m.opacity), {
                u_matrix: t1,
                u_lighting_matrix: i,
                u_normal_matrix: o,
                u_node_matrix: s || Hr,
                u_lightpos: x,
                u_lightintensity: v.properties.get("intensity"),
                u_lightcolor: [
                    T.r,
                    T.g,
                    T.b
                ],
                u_camera_pos: p,
                u_opacity: n,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +w,
                u_alphaCutoff: d.alphaCutoff,
                u_baseColorFactor: a.toNonPremultipliedRenderColor(null).toArray01(),
                u_emissiveFactor: l.toNonPremultipliedRenderColor(null).toArray01(),
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: 5,
                u_metallicRoughnessTexture: 6,
                u_normalTexture: 7,
                u_occlusionTexture: 8,
                u_emissionTexture: 9,
                u_lutTexture: 10,
                u_color_mix: S.toArray01(),
                u_aoIntensity: E,
                u_emissive_strength: u,
                u_occlusionTextureTransform: f || [
                    0,
                    0,
                    0,
                    0
                ]
            };
        }, Zr = (e, t1 = Hr, i = Hr)=>({
                u_matrix: e,
                u_instance: t1,
                u_node_matrix: i
            }), Wr = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_lightpos: new e.cj(t1),
                    u_lightintensity: new e.ck(t1),
                    u_lightcolor: new e.cj(t1),
                    u_vertical_gradient: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_edge_radius: new e.ck(t1),
                    u_width_scale: new e.ck(t1),
                    u_ao: new e.cl(t1),
                    u_height_type: new e.ci(t1),
                    u_base_type: new e.ci(t1),
                    u_tile_id: new e.cj(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_inv_rot_matrix: new e.cm(t1),
                    u_merc_center: new e.cl(t1),
                    u_up_dir: new e.cj(t1),
                    u_height_lift: new e.ck(t1),
                    u_flood_light_color: new e.cj(t1),
                    u_vertical_scale: new e.ck(t1),
                    u_flood_light_intensity: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1)
                }),
            fillExtrusionDepth: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_edge_radius: new e.ck(t1),
                    u_width_scale: new e.ck(t1),
                    u_vertical_scale: new e.ck(t1),
                    u_height_type: new e.ci(t1),
                    u_base_type: new e.ci(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_lightpos: new e.cj(t1),
                    u_lightintensity: new e.ck(t1),
                    u_lightcolor: new e.cj(t1),
                    u_vertical_gradient: new e.ck(t1),
                    u_height_factor: new e.ck(t1),
                    u_edge_radius: new e.ck(t1),
                    u_width_scale: new e.ck(t1),
                    u_ao: new e.cl(t1),
                    u_height_type: new e.ci(t1),
                    u_base_type: new e.ci(t1),
                    u_tile_id: new e.cj(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_inv_rot_matrix: new e.cm(t1),
                    u_merc_center: new e.cl(t1),
                    u_up_dir: new e.cj(t1),
                    u_height_lift: new e.ck(t1),
                    u_image: new e.ci(t1),
                    u_texsize: new e.cl(t1),
                    u_pixel_coord_upper: new e.cl(t1),
                    u_pixel_coord_lower: new e.cl(t1),
                    u_tile_units_to_pixels: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_pattern_transition: new e.ck(t1)
                }),
            fillExtrusionGroundEffect: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_opacity: new e.ck(t1),
                    u_ao_pass: new e.ck(t1),
                    u_meter_to_tile: new e.ck(t1),
                    u_ao: new e.cl(t1),
                    u_flood_light_intensity: new e.ck(t1),
                    u_flood_light_color: new e.cj(t1),
                    u_attenuation: new e.ck(t1),
                    u_edge_radius: new e.ck(t1),
                    u_fb: new e.ci(t1),
                    u_fb_size: new e.ck(t1),
                    u_dynamic_offset: new e.ck(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_image: new e.ci(t1),
                    u_texsize: new e.cl(t1),
                    u_pixel_coord_upper: new e.cl(t1),
                    u_pixel_coord_lower: new e.cl(t1),
                    u_tile_units_to_pixels: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1),
                    u_pattern_transition: new e.ck(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_world: new e.cl(t1),
                    u_ground_shadow_factor: new e.cj(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_world: new e.cl(t1),
                    u_image: new e.ci(t1),
                    u_texsize: new e.cl(t1),
                    u_pixel_coord_upper: new e.cl(t1),
                    u_pixel_coord_lower: new e.cl(t1),
                    u_tile_units_to_pixels: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1),
                    u_pattern_transition: new e.ck(t1)
                }),
            building: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_normal_matrix: new e.cm(t1),
                    u_opacity: new e.ck(t1),
                    u_faux_facade_ao_intensity: new e.ck(t1),
                    u_camera_pos: new e.cj(t1),
                    u_tile_to_meter: new e.ck(t1),
                    u_facade_emissive_chance: new e.ck(t1),
                    u_flood_light_color: new e.cj(t1),
                    u_flood_light_intensity: new e.ck(t1)
                }),
            buildingBloom: (t1)=>({
                    u_matrix: new e.cm(t1)
                }),
            buildingDepth: (t1)=>({
                    u_matrix: new e.cm(t1)
                }),
            elevatedStructuresDepth: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_depth_bias: new e.ck(t1)
                }),
            elevatedStructures: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_ground_shadow_factor: new e.cj(t1)
                }),
            elevatedStructuresDepthReconstruct: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_camera_pos: new e.cj(t1),
                    u_depth_bias: new e.ck(t1),
                    u_height_scale: new e.ck(t1),
                    u_reset_depth: new e.ck(t1)
                }),
            circle: e.d_,
            collisionBox: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_inv_rot_matrix: new e.cm(t1),
                    u_camera_to_center_distance: new e.ck(t1),
                    u_extrude_scale: new e.cl(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_merc_center: new e.cl(t1),
                    u_tile_id: new e.cj(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_inv_matrix: new e.cm(t1),
                    u_camera_to_center_distance: new e.ck(t1),
                    u_viewport_size: new e.cl(t1)
                }),
            debug: (t1)=>({
                    u_color: new e.dD(t1),
                    u_matrix: new e.cm(t1),
                    u_overlay: new e.ci(t1),
                    u_overlay_scale: new e.ck(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e.cm(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e.ck(t1),
                    u_intensity: new e.ck(t1),
                    u_matrix: new e.cm(t1),
                    u_inv_rot_matrix: new e.cm(t1),
                    u_merc_center: new e.cl(t1),
                    u_tile_id: new e.cj(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_up_dir: new e.cj(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e.ci(t1),
                    u_color_ramp: new e.ci(t1),
                    u_opacity: new e.ck(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_image: new e.ci(t1),
                    u_latrange: new e.cl(t1),
                    u_light: new e.cl(t1),
                    u_shadow: new e.dD(t1),
                    u_highlight: new e.dD(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_accent: new e.dD(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_image: new e.ci(t1),
                    u_dimension: new e.cl(t1),
                    u_zoom: new e.ck(t1)
                }),
            line: e.dZ,
            linePattern: e.dY,
            raster: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_normalize_matrix: new e.cm(t1),
                    u_globe_matrix: new e.cm(t1),
                    u_merc_matrix: new e.cm(t1),
                    u_grid_matrix: new e.dE(t1),
                    u_tl_parent: new e.cl(t1),
                    u_scale_parent: new e.ck(t1),
                    u_fade_t: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_image0: new e.ci(t1),
                    u_image1: new e.ci(t1),
                    u_brightness_low: new e.ck(t1),
                    u_brightness_high: new e.ck(t1),
                    u_saturation_factor: new e.ck(t1),
                    u_contrast_factor: new e.ck(t1),
                    u_spin_weights: new e.cj(t1),
                    u_perspective_transform: new e.cl(t1),
                    u_raster_elevation: new e.ck(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_merc_center: new e.cl(t1),
                    u_cutoff_params: new e.d4(t1),
                    u_colorization_mix: new e.d4(t1),
                    u_colorization_offset: new e.ck(t1),
                    u_color_ramp: new e.ci(t1),
                    u_texture_offset: new e.cl(t1),
                    u_texture_res: new e.cl(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_zbias_factor: new e.ck(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_normalize_matrix: new e.cm(t1),
                    u_globe_matrix: new e.cm(t1),
                    u_merc_matrix: new e.cm(t1),
                    u_grid_matrix: new e.dE(t1),
                    u_tl_parent: new e.cl(t1),
                    u_scale_parent: new e.ck(t1),
                    u_fade_t: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_image0: new e.ci(t1),
                    u_image1: new e.ci(t1),
                    u_raster_elevation: new e.ck(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_merc_center: new e.cl(t1),
                    u_cutoff_params: new e.d4(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e.ci(t1),
                    u_opacity: new e.ck(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e.ci(t1),
                    u_particle_texture_side_len: new e.ck(t1),
                    u_tile_offset: new e.cl(t1),
                    u_velocity: new e.ci(t1),
                    u_color_ramp: new e.ci(t1),
                    u_velocity_res: new e.cl(t1),
                    u_max_speed: new e.ck(t1),
                    u_uv_offset: new e.cl(t1),
                    u_data_scale: new e.cl(t1),
                    u_data_offset: new e.ck(t1),
                    u_particle_pos_scale: new e.ck(t1),
                    u_particle_pos_offset: new e.cl(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e.ci(t1),
                    u_particle_texture_side_len: new e.ck(t1),
                    u_velocity: new e.ci(t1),
                    u_velocity_res: new e.cl(t1),
                    u_max_speed: new e.ck(t1),
                    u_speed_factor: new e.ck(t1),
                    u_reset_rate: new e.ck(t1),
                    u_rand_seed: new e.ck(t1),
                    u_uv_offset: new e.cl(t1),
                    u_data_scale: new e.cl(t1),
                    u_data_offset: new e.ck(t1),
                    u_particle_pos_scale: new e.ck(t1),
                    u_particle_pos_offset: new e.cl(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e.ci(t1),
                    u_is_size_feature_constant: new e.ci(t1),
                    u_size_t: new e.ck(t1),
                    u_size: new e.ck(t1),
                    u_camera_to_center_distance: new e.ck(t1),
                    u_rotate_symbol: new e.ci(t1),
                    u_aspect_ratio: new e.ck(t1),
                    u_fade_change: new e.ck(t1),
                    u_matrix: new e.cm(t1),
                    u_label_plane_matrix: new e.cm(t1),
                    u_coord_matrix: new e.cm(t1),
                    u_is_text: new e.ci(t1),
                    u_elevation_from_sea: new e.ci(t1),
                    u_pitch_with_map: new e.ci(t1),
                    u_texsize: new e.cl(t1),
                    u_texsize_icon: new e.cl(t1),
                    u_texture: new e.ci(t1),
                    u_texture_icon: new e.ci(t1),
                    u_gamma_scale: new e.ck(t1),
                    u_device_pixel_ratio: new e.ck(t1),
                    u_tile_id: new e.cj(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_inv_rot_matrix: new e.cm(t1),
                    u_merc_center: new e.cl(t1),
                    u_camera_forward: new e.cj(t1),
                    u_tile_matrix: new e.cm(t1),
                    u_up_vector: new e.cj(t1),
                    u_ecef_origin: new e.cj(t1),
                    u_is_halo: new e.ci(t1),
                    u_icon_transition: new e.ck(t1),
                    u_color_adj_mat: new e.cm(t1),
                    u_scale_factor: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1),
                    u_inv_matrix: new e.cm(t1),
                    u_normal_scale: new e.ck(t1),
                    u_lutTexture: new e.ci(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_color: new e.dD(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_image: new e.ci(t1),
                    u_pattern_tl: new e.cl(t1),
                    u_pattern_br: new e.cl(t1),
                    u_texsize: new e.cl(t1),
                    u_pattern_size: new e.cl(t1),
                    u_pixel_coord_upper: new e.cl(t1),
                    u_pixel_coord_lower: new e.cl(t1),
                    u_pattern_units_to_pixels: new e.cl(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_image0: new e.ci(t1),
                    u_image1: new e.ci(t1),
                    u_skirt_height: new e.ck(t1),
                    u_ground_shadow_factor: new e.cj(t1),
                    u_emissive_texture_available: new e.ck(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_sun_direction: new e.cj(t1),
                    u_cubemap: new e.ci(t1),
                    u_opacity: new e.ck(t1),
                    u_temporal_offset: new e.ck(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_color_ramp: new e.ci(t1),
                    u_center_direction: new e.cj(t1),
                    u_radius: new e.ck(t1),
                    u_opacity: new e.ck(t1),
                    u_temporal_offset: new e.ck(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e.dE(t1),
                    u_sun_direction: new e.cj(t1),
                    u_sun_intensity: new e.ck(t1),
                    u_color_tint_r: new e.d4(t1),
                    u_color_tint_m: new e.d4(t1),
                    u_luminance: new e.ck(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e.cm(t1),
                    u_globe_matrix: new e.cm(t1),
                    u_normalize_matrix: new e.cm(t1),
                    u_merc_matrix: new e.cm(t1),
                    u_zoom_transition: new e.ck(t1),
                    u_merc_center: new e.cl(t1),
                    u_image0: new e.ci(t1),
                    u_image1: new e.ci(t1),
                    u_grid_matrix: new e.dE(t1),
                    u_skirt_height: new e.ck(t1),
                    u_far_z_cutoff: new e.ck(t1),
                    u_frustum_tl: new e.cj(t1),
                    u_frustum_tr: new e.cj(t1),
                    u_frustum_br: new e.cj(t1),
                    u_frustum_bl: new e.cj(t1),
                    u_globe_pos: new e.cj(t1),
                    u_globe_radius: new e.ck(t1),
                    u_viewport: new e.cl(t1),
                    u_emissive_texture_available: new e.ck(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e.cj(t1),
                    u_frustum_tr: new e.cj(t1),
                    u_frustum_br: new e.cj(t1),
                    u_frustum_bl: new e.cj(t1),
                    u_horizon: new e.ck(t1),
                    u_transition: new e.ck(t1),
                    u_fadeout_range: new e.ck(t1),
                    u_atmosphere_fog_color: new e.d4(t1),
                    u_high_color: new e.d4(t1),
                    u_space_color: new e.d4(t1),
                    u_temporal_offset: new e.ck(t1),
                    u_horizon_angle: new e.ck(t1)
                }),
            model: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_lighting_matrix: new e.cm(t1),
                    u_normal_matrix: new e.cm(t1),
                    u_node_matrix: new e.cm(t1),
                    u_lightpos: new e.cj(t1),
                    u_lightintensity: new e.ck(t1),
                    u_lightcolor: new e.cj(t1),
                    u_camera_pos: new e.cj(t1),
                    u_opacity: new e.ck(t1),
                    u_baseColorFactor: new e.d4(t1),
                    u_emissiveFactor: new e.d4(t1),
                    u_metallicFactor: new e.ck(t1),
                    u_roughnessFactor: new e.ck(t1),
                    u_baseTextureIsAlpha: new e.ci(t1),
                    u_alphaMask: new e.ci(t1),
                    u_alphaCutoff: new e.ck(t1),
                    u_baseColorTexture: new e.ci(t1),
                    u_metallicRoughnessTexture: new e.ci(t1),
                    u_normalTexture: new e.ci(t1),
                    u_occlusionTexture: new e.ci(t1),
                    u_emissionTexture: new e.ci(t1),
                    u_lutTexture: new e.ci(t1),
                    u_color_mix: new e.d4(t1),
                    u_aoIntensity: new e.ck(t1),
                    u_emissive_strength: new e.ck(t1),
                    u_occlusionTextureTransform: new e.d4(t1)
                }),
            modelDepth: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_instance: new e.cm(t1),
                    u_node_matrix: new e.cm(t1)
                }),
            groundShadow: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_ground_shadow_factor: new e.cj(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_up: new e.cj(t1),
                    u_right: new e.cj(t1),
                    u_intensity_multiplier: new e.ck(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e.cm(t1),
                    u_projection: new e.cm(t1),
                    u_time: new e.ck(t1),
                    u_cam_pos: new e.cj(t1),
                    u_velocityConeAperture: new e.ck(t1),
                    u_velocity: new e.ck(t1),
                    u_horizontalOscillationRadius: new e.ck(t1),
                    u_horizontalOscillationRate: new e.ck(t1),
                    u_boxSize: new e.ck(t1),
                    u_billboardSize: new e.ck(t1),
                    u_simpleShapeParameters: new e.cl(t1),
                    u_screenSize: new e.cl(t1),
                    u_thinningCenterPos: new e.cl(t1),
                    u_thinningShape: new e.cj(t1),
                    u_thinningAffectedRatio: new e.ck(t1),
                    u_thinningParticleOffset: new e.ck(t1),
                    u_particleColor: new e.d4(t1),
                    u_direction: new e.cj(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e.cm(t1),
                    u_projection: new e.cm(t1),
                    u_time: new e.ck(t1),
                    u_cam_pos: new e.cj(t1),
                    u_texScreen: new e.ci(t1),
                    u_velocityConeAperture: new e.ck(t1),
                    u_velocity: new e.ck(t1),
                    u_boxSize: new e.ck(t1),
                    u_rainDropletSize: new e.cl(t1),
                    u_distortionStrength: new e.ck(t1),
                    u_rainDirection: new e.cj(t1),
                    u_color: new e.d4(t1),
                    u_screenSize: new e.cl(t1),
                    u_thinningCenterPos: new e.cl(t1),
                    u_thinningShape: new e.cj(t1),
                    u_thinningAffectedRatio: new e.ck(t1),
                    u_thinningParticleOffset: new e.ck(t1),
                    u_shapeDirectionalPower: new e.ck(t1),
                    u_shapeNormalPower: new e.ck(t1),
                    u_mode: new e.ck(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e.cj(t1),
                    u_vignetteColor: new e.d4(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e.cm(t1),
                    u_anchorPos: new e.cj(t1),
                    u_screenSizePx: new e.cl(t1),
                    u_occluderSizePx: new e.cl(t1),
                    u_color: new e.d4(t1)
                })
        };
        class $r {
            constructor(e, t1, i, o){
                this.id = $r.uniqueIdxCounter, $r.uniqueIdxCounter++, this.context = e;
                const s = e.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || o || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e) {
                this.id = $r.uniqueIdxCounter, $r.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        $r.uniqueIdxCounter = 0;
        const Xr = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Kr {
            constructor(e, t1, i, o, s, r){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.instanceCount = r, this.context = e;
                const n = e.gl;
                this.buffer = n.createBuffer(), e.bindVertexBuffer.set(this.buffer), n.bufferData(n.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || s || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            enableAttributes(e, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.getAttributeLocation(e, this.attributes[i].name);
                    -1 !== o && e.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = this.attributes[o], r = t1.getAttributeLocation(e, s.name);
                    -1 !== r && e.vertexAttribPointer(r, s.components, e[Xr[s.type]], !1, this.itemSize, s.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = t1.getAttributeLocation(e, this.attributes[o].name);
                    -1 !== s && this.instanceCount && this.instanceCount > 0 && e.vertexAttribDivisor(s, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Yr {
            constructor(e, t1, i, o, s){
                this.context = e, this.width = t1, this.height = i;
                const r = this.framebuffer = e.gl.createFramebuffer();
                o > 0 && (this.colorAttachment0 = new Vs(e, r, 0)), o > 1 && (this.colorAttachment1 = new Vs(e, r, 1)), s && (this.depthAttachmentType = s, this.depthAttachment = "renderbuffer" === s ? new Gs(e, r) : new Hs(e, r));
            }
            createColorAttachment(e, t1) {
                0 === t1 ? this.colorAttachment0 = new Vs(e, this.framebuffer, 0) : 1 === t1 && (this.colorAttachment1 = new Vs(e, this.framebuffer, 1));
            }
            removeColorAttachment(e, t1) {
                const i = this.context.gl;
                let o;
                0 === t1 ? (o = this.colorAttachment0.get(), this.colorAttachment0 = void 0) : 1 === t1 && (o = this.colorAttachment1.get(), this.colorAttachment1 = void 0), o && i.deleteTexture(o);
            }
            destroy() {
                const e = this.context.gl;
                if (this.colorAttachment0) {
                    const t1 = this.colorAttachment0.get();
                    t1 && e.deleteTexture(t1);
                }
                if (this.colorAttachment1) {
                    const t1 = this.colorAttachment1.get();
                    t1 && e.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteTexture(t1);
                    }
                }
                e.deleteFramebuffer(this.framebuffer);
            }
        }
        class Jr {
            constructor(e, t1){
                this.gl = e, this.clearColor = new hs(this), this.clearDepth = new ds(this), this.clearStencil = new us(this), this.colorMask = new _s(this), this.depthMask = new ps(this), this.stencilMask = new fs(this), this.stencilFunc = new ms(this), this.stencilOp = new gs(this), this.stencilTest = new vs(this), this.depthRange = new ys(this), this.depthTest = new xs(this), this.depthFunc = new bs(this), this.blend = new ws(this), this.blendFunc = new Ts(this), this.blendColor = new Es(this), this.blendEquation = new Ss(this), this.cullFace = new Is(this), this.cullFaceSide = new Cs(this), this.frontFace = new Rs(this), this.program = new As(this), this.activeTexture = new Ds(this), this.viewport = new Ls(this), this.bindFramebuffer = new Ps(this), this.bindRenderbuffer = new Os(this), this.bindTexture = new zs(this), this.bindVertexBuffer = new Ms(this), this.bindElementBuffer = new Fs(this), this.bindVertexArrayOES = new ks(this), this.pixelStoreUnpack = new Bs(this), this.pixelStoreUnpackPremultiplyAlpha = new Ns(this), this.pixelStoreUnpackFlipY = new Us(this), this.options = t1 ? Object.assign({}, t1) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.extBlendFuncExtended = e.getExtension("WEBGL_blend_func_extended");
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e, t1, i) {
                return new $r(this, e, t1, i);
            }
            createVertexBuffer(e, t1, i, o, s) {
                return new Kr(this, e, t1, i, o, s);
            }
            createRenderbuffer(e, t1, i) {
                const o = this.gl, s = o.createRenderbuffer();
                return this.bindRenderbuffer.set(s), o.renderbufferStorage(o.RENDERBUFFER, e, t1, i), this.bindRenderbuffer.set(null), s;
            }
            createFramebuffer(e, t1, i, o) {
                return new Yr(this, e, t1, i, o);
            }
            clear({ color: e, depth: t1, stencil: i, colorMask: o }) {
                const s = this.gl;
                let r = 0;
                e && (r |= s.COLOR_BUFFER_BIT, this.clearColor.set(e.toNonPremultipliedRenderColor(null)), this.colorMask.set(o || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (r |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (r |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(r);
            }
            setCullFace(e) {
                !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
            }
            setDepthMode(e) {
                e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e) {
                e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([
                    e.fail,
                    e.depthFail,
                    e.pass
                ]), this.stencilFunc.set({
                    func: e.test.func,
                    ref: e.ref,
                    mask: e.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e.bz(t1.blendFunction, Zi.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        let Qr;
        function en(t1, i, o, s, r, n, a) {
            const l = t1.context, c = l.gl, h = t1.transform, d = [
                e.aG(h.center.lng),
                e.aK(h.center.lat)
            ], u = o.layout.get("symbol-placement"), _ = o.layout.get("text-variable-anchor"), p = "map" === o.layout.get("icon-rotation-alignment"), f = "map" === o.layout.get("text-rotation-alignment"), m = "point" !== u, g = [];
            let v = 0, y = 0;
            for(let l = 0; l < s.length; l++){
                const u = s[l], x = i.getTile(u), b = x.getBucket(o);
                if (!b) continue;
                const w = b.getProjection().createInversionMatrix(h, u.canonical), T = [], E = Yt(u, b, h), S = !a && p && m, I = a && f && m, C = _ && b.hasTextData(), R = b.hasIconTextFit() && C && b.hasIconData(), A = S || I || a && C || R, D = "globe" === b.projection.name, L = D ? e.ak(h.zoom) : 0;
                D && (T.push("PROJECTION_GLOBE_VIEW"), A && T.push("PROJECTED_POS_ON_VIEWPORT"));
                const P = t1.getOrCreateProgram("collisionBox", {
                    defines: T
                });
                let O = E;
                0 === r[0] && 0 === r[1] || (O = t1.translatePosMatrix(E, x, r, n));
                const z = a ? b.textCollisionBox : b.iconCollisionBox, M = b.collisionCircleArray;
                if (M.length > 0) {
                    const t1 = e.bD(), i = O;
                    e.cQ(t1, b.placementInvProjMatrix, h.glCoordMatrix), e.cQ(t1, t1, b.placementViewportMatrix), g.push({
                        circleArray: M,
                        circleOffset: y,
                        transform: i,
                        invTransform: t1,
                        projection: b.getProjection()
                    }), v += M.length / 4, y = v;
                }
                if (!z) continue;
                t1.terrain && t1.terrain.setupElevationDraw(x, P);
                const F = D ? [
                    u.canonical.x,
                    u.canonical.y,
                    1 << u.canonical.z
                ] : [
                    0,
                    0,
                    0
                ];
                P.draw(t1, c.LINES, Wi.disabled, Xi.disabled, t1.colorModeForRenderPass(), Ji.disabled, Ir(O, w, h, L, d, x, F, b.getProjection()), o.id, z.layoutVertexBuffer, z.indexBuffer, z.segments, null, h.zoom, null, [
                    z.collisionVertexBuffer,
                    z.collisionVertexBufferExt
                ]);
            }
            if (!a || !g.length) return;
            const x = t1.getOrCreateProgram("collisionCircle"), b = new e.d$;
            b.resize(4 * v), b._trim();
            let w = 0;
            for (const e of g)for(let t1 = 0; t1 < e.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e.circleArray[i + 0], s = e.circleArray[i + 1], r = e.circleArray[i + 2], n = e.circleArray[i + 3];
                b.emplace(w++, o, s, r, n, 0), b.emplace(w++, o, s, r, n, 1), b.emplace(w++, o, s, r, n, 2), b.emplace(w++, o, s, r, n, 3);
            }
            (!Qr || Qr.length < 2 * v) && (Qr = function(t1) {
                const i = 2 * t1, o = new e.b1;
                o.resize(i), o._trim();
                for(let e = 0; e < i; e++){
                    const t1 = 6 * e;
                    o.uint16[t1 + 0] = 4 * e + 0, o.uint16[t1 + 1] = 4 * e + 1, o.uint16[t1 + 2] = 4 * e + 2, o.uint16[t1 + 3] = 4 * e + 2, o.uint16[t1 + 4] = 4 * e + 3, o.uint16[t1 + 5] = 4 * e + 0;
                }
                return o;
            }(v));
            const T = l.createIndexBuffer(Qr, !0), E = l.createVertexBuffer(b, e.e0.members, !0);
            for (const i of g){
                const s = Cr(i.transform, i.invTransform, h, i.projection);
                x.draw(t1, c.TRIANGLES, Wi.disabled, Xi.disabled, t1.colorModeForRenderPass(), Ji.disabled, s, o.id, E, T, e.bh.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            E.destroy(), T.destroy();
        }
        const tn = e.bD();
        function on(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e.aC([], i, t1.globeMatrix);
            e.bm(o, o);
            const s = [
                0,
                0,
                0
            ], r = [
                0,
                1,
                0,
                0
            ];
            return e.aD(r, r, o), s[0] = r[0], s[1] = r[1], s[2] = r[2], e.ax(s, s), s;
        }
        function sn({ width: t1, height: i, anchor: o, textOffset: s, textScale: r }, n) {
            const { horizontalAlign: a, verticalAlign: l } = e.c2(o), c = -(a - .5) * t1, h = -(l - .5) * i, d = e.c3(o, s);
            return new e.P((c / r + d[0]) * n, (h / r + d[1]) * n);
        }
        function rn(t1, i, o, s, r, n, a, l, c, h) {
            const d = t1.text.placedSymbolArray, u = t1.text.dynamicLayoutVertexArray, _ = t1.icon.dynamicLayoutVertexArray, p = {}, f = t1.getProjection(), m = Jt(a, f, r), g = r.elevation, v = f.upVectorScale(a.canonical, r.center.lat, r.worldSize).metersToTile;
            u.clear();
            for(let _ = 0; _ < d.length; _++){
                const y = d.get(_), { tileAnchorX: x, tileAnchorY: b, numGlyphs: w } = y, T = y.hidden || !y.crossTileID || t1.allowVerticalPlacement && !y.placedOrientation ? null : s[y.crossTileID];
                if (T) {
                    let s = 0, d = 0, E = 0;
                    const S = "road" === t1.elevationType;
                    if (g || S) {
                        const i = S ? t1.getElevationFeatureForText(_) : null, o = e.bW.getAtTileOffset(a, new e.P(x, b), g, i), [r, n, l] = f.upVector(a.canonical, x, b);
                        s = o * r * v, d = o * n * v, E = o * l * v;
                    }
                    let [I, C, R, A] = ri(y.projectedAnchorX + s, y.projectedAnchorY + d, y.projectedAnchorZ + E, o ? m : n);
                    const D = ni(r.getCameraToCenterDistance(f), A);
                    let L = e.bN(t1.textSizeData, c, y) * D / e.bZ;
                    o && (L *= t1.tilePixelRatio / l);
                    const P = sn(T, L);
                    o ? ({ x: I, y: C, z: R } = f.projectTilePoint(x + P.x, b + P.y, a.canonical), [I, C, R] = ri(I + s, C + d, R + E, n)) : (i && P._rotate(-r.angle), I += P.x, C += P.y, R = 0);
                    const O = t1.allowVerticalPlacement && y.placedOrientation === e.bM.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < w; t1++)e.bP(u, I, C, R, O);
                    h && y.associatedIconIndex >= 0 && (p[y.associatedIconIndex] = {
                        x: I,
                        y: C,
                        z: R,
                        angle: O
                    });
                } else fi(w, u);
            }
            if (h) {
                _.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: s } = o, r = p[t1];
                    if (o.hidden || !r) fi(s, _);
                    else {
                        const { x: t1, y: i, z: o, angle: n } = r;
                        for(let r = 0; r < s; r++)e.bP(_, t1, i, o, n);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(_);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(u);
        }
        function nn(t1, i, o, s, r, n, a = {}) {
            const l = o.paint.get("icon-translate"), c = o.paint.get("text-translate"), h = o.paint.get("icon-translate-anchor"), d = o.paint.get("text-translate-anchor"), u = o.layout.get("icon-rotation-alignment"), _ = o.layout.get("text-rotation-alignment"), p = o.layout.get("icon-pitch-alignment"), f = o.layout.get("text-pitch-alignment"), m = o.layout.get("icon-keep-upright"), g = o.layout.get("text-keep-upright"), v = o.paint.get("icon-color-saturation"), y = o.paint.get("icon-color-contrast"), x = o.paint.get("icon-color-brightness-min"), b = o.paint.get("icon-color-brightness-max"), w = "sea" === o.layout.get("symbol-elevation-reference"), T = "none" === o.layout.get("icon-image-use-theme"), E = t1.context, S = E.gl, I = t1.transform, C = "map" === u, R = "map" === _, A = "map" === p, D = "map" === f, L = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let P = !1;
            const O = t1.depthModeForSublayer(0, Wi.ReadOnly), z = new Wi(t1.context.gl.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D), M = [
                e.aG(I.center.lng),
                e.aK(I.center.lat)
            ], F = o.layout.get("text-variable-anchor"), k = "globe" === I.projection.name, B = [], N = [
                0,
                -1,
                0
            ];
            for (const r of s){
                const s = i.getTile(r), n = s.getBucket(o);
                if (!n) continue;
                if ("mercator" === n.projection.name && k) continue;
                if (n.fullyClipped) continue;
                const u = "globe" === n.projection.name, _ = u ? e.ak(I.zoom) : 0, p = Jt(r, n.getProjection(), I), f = I.calculatePixelsToTileUnitsMatrix(s), U = F && n.hasTextData(), j = n.hasIconTextFit() && U && n.hasIconData(), V = n.getProjection().createInversionMatrix(I, r.canonical), G = (1 << s.tileID.canonical.z) * e.am / t1.transform.worldSize, H = (e)=>{
                    let i = [
                        0,
                        0,
                        0
                    ];
                    if (e) {
                        const e = t1.style.directionalLight, o = t1.style.ambientLight;
                        e && o && (i = mo(t1.style, e, o));
                    }
                    return i;
                }, q = (e)=>{
                    I.depthOcclusionForSymbolsAndCircles && (o.hasOcclusionOpacityProperties || t1.terrain) && (e.push("DEPTH_D24"), e.push("DEPTH_OCCLUSION"));
                }, Z = (i)=>{
                    o.lut && !T && (o.lut.texture || (o.lut.texture = new e.e1(t1.context, o.lut.image, [
                        o.lut.image.height,
                        o.lut.image.height,
                        o.lut.image.height
                    ], E.gl.RGBA8)), E.activeTexture.set(E.gl.TEXTURE0 + 10), o.lut.texture && o.lut.texture.bind(E.gl.LINEAR, E.gl.CLAMP_TO_EDGE), i.push("APPLY_LUT_ON_GPU"));
                }, W = ()=>{
                    const i = C && "point" !== o.layout.get("symbol-placement"), a = [];
                    q(a), Z(a);
                    const c = i || j, d = "road" === n.elevationType, g = t1.shadowRenderer, T = d && A && !!g && g.enabled, E = H(T), R = d && A && !t1.terrain ? z : O, D = o.paint.get("icon-image-cross-fade");
                    t1.terrainRenderModeElevated() && A && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), c && a.push("PROJECTED_POS_ON_VIEWPORT")), D > 0 && n.hasAnySecondaryIcon && a.push("ICON_TRANSITION"), !n.icon.zOffsetVertexBuffer || d && t1.terrain || a.push("Z_OFFSET"), 0 === v && 0 === y && 0 === x && 1 === b || a.push("COLOR_ADJUSTMENT"), n.sdfIcons && a.push("RENDER_SDF"), T && a.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), d && A && !t1.terrain && n.icon.orientationVertexBuffer && a.push("ELEVATED_ROADS");
                    const L = n.icon.programConfigurations.get(o.id), P = t1.getOrCreateProgram("symbol", {
                        config: L,
                        defines: a
                    }), F = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], B = n.iconSizeData, U = e.bL(B, I.zoom), W = A || !I.isOrthographic, $ = ii(p, s.tileID.canonical, A, C, I, n.getProjection(), f), X = si(p, s.tileID.canonical, A, C, I, n.getProjection(), f), K = t1.translatePosMatrix(X, s, l, h, !0), Y = t1.translatePosMatrix(p, s, l, h), J = c ? tn : $, Q = C && !A && !i;
                    let ee = N;
                    !k && !I.mercatorFromTransition || C || (ee = on(I));
                    const te = u ? ee : N, ie = o.getColorAdjustmentMatrix(v, y, x, b), oe = jr(B.kind, U, Q, A, t1, Y, J, K, w, !1, F, [
                        0,
                        0
                    ], 0, r, _, M, V, te, n.getProjection(), E, G, ie, D, null), se = s.imageAtlasTexture ? s.imageAtlasTexture : null, re = 1 !== o.layout.get("icon-size").constantOr(0) || n.iconsNeedLinear, ne = n.sdfIcons || t1.options.rotating || t1.options.zooming || re || W ? S.LINEAR : S.NEAREST, ae = n.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1), le = t1.terrain && A && i ? e.bm(e.bD(), $) : tn;
                    if (i && n.icon) {
                        const i = e.bW.getAtTileOffsetFunc(r, I.center.lat, I.worldSize, n.getProjection()), a = oi(p, s.tileID.canonical, A, C, I, n.getProjection(), f), l = o.layout.get("icon-size-scale-range"), c = e.aB(t1.scaleFactor, l[0], l[1]);
                        li(n, p, t1, !1, a, X, A, m, i, r, c);
                    }
                    return {
                        program: P,
                        buffers: n.icon,
                        uniformValues: oe,
                        atlasTexture: se,
                        atlasTextureIcon: null,
                        atlasInterpolation: ne,
                        atlasInterpolationIcon: null,
                        isSDF: n.sdfIcons,
                        hasHalo: ae,
                        depthMode: R,
                        tile: s,
                        renderWithShadows: T,
                        labelPlaneMatrixInv: le
                    };
                }, $ = ()=>{
                    const i = R && "point" !== o.layout.get("symbol-placement"), a = [], l = i || F || j, h = "road" === n.elevationType, m = t1.shadowRenderer, v = h && D && !!m && m.enabled, y = H(v), x = h && D && !t1.terrain ? z : O;
                    t1.terrainRenderModeElevated() && D && a.push("PITCH_WITH_MAP_TERRAIN"), u && (a.push("PROJECTION_GLOBE_VIEW"), l && a.push("PROJECTED_POS_ON_VIEWPORT")), !n.text.zOffsetVertexBuffer || h && t1.terrain || a.push("Z_OFFSET"), n.iconsInText && a.push("RENDER_TEXT_AND_SYMBOL"), a.push("RENDER_SDF"), v && a.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), h && D && !t1.terrain && n.text.orientationVertexBuffer && a.push("ELEVATED_ROADS"), q(a);
                    const b = n.text.programConfigurations.get(o.id), T = t1.getOrCreateProgram("symbol", {
                        config: b,
                        defines: a
                    });
                    let E, C = [
                        0,
                        0
                    ], A = null;
                    const L = n.textSizeData;
                    n.iconsInText && (C = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], A = s.imageAtlasTexture ? s.imageAtlasTexture : null, E = D || !I.isOrthographic || t1.options.rotating || t1.options.zooming || "composite" === L.kind || "camera" === L.kind ? S.LINEAR : S.NEAREST);
                    const P = s.glyphAtlasTexture ? s.glyphAtlasTexture.size : [
                        0,
                        0
                    ], B = o.layout.get("text-size-scale-range"), U = e.aB(t1.scaleFactor, B[0], B[1]), Z = e.bL(L, I.zoom, U), W = ii(p, s.tileID.canonical, D, R, I, n.getProjection(), f), $ = si(p, s.tileID.canonical, D, R, I, n.getProjection(), f), X = t1.translatePosMatrix($, s, c, d, !0), K = t1.translatePosMatrix(p, s, c, d), Y = l ? tn : W, J = R && !D && !i;
                    let Q = N;
                    !k && !I.mercatorFromTransition || R || (Q = on(I));
                    const ee = jr(L.kind, Z, J, D, t1, K, Y, X, w, !0, P, C, 0, r, _, M, V, u ? Q : N, n.getProjection(), y, G, null, null, U), te = s.glyphAtlasTexture ? s.glyphAtlasTexture : null, ie = S.LINEAR, oe = 0 !== o.paint.get("text-halo-width").constantOr(1), se = t1.terrain && D && i ? e.bm(e.bD(), W) : tn;
                    if (i && n.text) {
                        const i = e.bW.getAtTileOffsetFunc(r, I.center.lat, I.worldSize, n.getProjection()), o = oi(p, s.tileID.canonical, D, R, I, n.getProjection(), f);
                        li(n, p, t1, !0, o, $, D, g, i, r, U);
                    }
                    return {
                        program: T,
                        buffers: n.text,
                        uniformValues: ee,
                        atlasTexture: te,
                        atlasTextureIcon: A,
                        atlasInterpolation: ie,
                        atlasInterpolationIcon: E,
                        isSDF: !0,
                        hasHalo: oe,
                        depthMode: x,
                        tile: s,
                        renderWithShadows: v,
                        labelPlaneMatrixInv: se
                    };
                }, X = n.icon.segments.get().length, K = n.text.segments.get().length, Y = X && !a.onlyText ? W() : null, J = K && !a.onlyIcons ? $() : null, Q = o.paint.get("icon-opacity").constantOr(1), ee = o.paint.get("text-opacity").constantOr(1);
                if (L && n.canOverlap) {
                    P = !0;
                    const t1 = Q && !a.onlyText ? n.icon.segments.get() : [], i = ee && !a.onlyIcons ? n.text.segments.get() : [];
                    for (const i of t1)B.push({
                        segments: new e.bh([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Y
                    });
                    for (const t1 of i)B.push({
                        segments: new e.bh([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: J
                    });
                } else a.onlyText || B.push({
                    segments: Q ? n.icon.segments : new e.bh([]),
                    sortKey: 0,
                    state: Y
                }), a.onlyIcons || B.push({
                    segments: ee ? n.text.segments : new e.bh([]),
                    sortKey: 0,
                    state: J
                });
            }
            P && B.sort((e, t1)=>e.sortKey - t1.sortKey);
            for (const e of B){
                const i = e.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: I.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(I.depthOcclusionForSymbolsAndCircles, i.program), E.activeTexture.set(S.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, S.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (E.activeTexture.set(S.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, S.CLAMP_TO_EDGE, !0)), i.renderWithShadows && t1.shadowRenderer.setupShadows(i.tile.tileID.toUnwrapped(), i.program, "vector-tile"), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const s = i.uniformValues;
                        s.u_is_halo = 1, an(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, s, 2), s.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const s = i.uniformValues;
                            i.hasHalo && (s.u_is_halo = 1, an(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, s, 1)), s.u_is_halo = 0;
                        }
                        an(i.buffers, e.segments, o, t1, i.program, i.depthMode, r, n, i.uniformValues, 1);
                    }
                }
            }
        }
        function an(e, t1, i, o, s, r, n, a, l, c) {
            const h = [
                e.dynamicLayoutVertexBuffer,
                e.opacityVertexBuffer,
                e.iconTransitioningVertexBuffer,
                e.globeExtVertexBuffer,
                e.zOffsetVertexBuffer,
                e.orientationVertexBuffer
            ];
            s.draw(o, o.context.gl.TRIANGLES, r, n, a, Ji.disabled, l, i.id, e.layoutVertexBuffer, e.indexBuffer, t1, i.paint, o.transform.zoom, e.programConfigurations.get(i.id), h, c);
        }
        function ln(t1, i) {
            const o = 1 << t1.canonical.z, s = (i.x * o - t1.canonical.x - t1.wrap * o) * e.am, r = (i.y * o - t1.canonical.y) * e.am, n = e.ea(i.z, i.y);
            return e.d6(s, r, n);
        }
        function cn(t1, i, o, s, r) {
            if (!o.layout || "none" === o.layout.get("fill-elevation-reference") || 0 === o.paint.get("fill-opacity").constantOr(1)) return;
            const n = t1.context.gl, a = new Wi(t1.context.gl.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D), l = new Wi(t1.context.gl.GREATER, Wi.ReadWrite, t1.depthRangeFor3D), c = function(t1) {
                let i = .01;
                return t1.isOrthographic && (i = e.al(1e-4, i, e.d1(t1.pitch >= no ? 1 : t1.pitch / no))), 2 * i;
            }(t1.transform), h = t1.transform.getFreeCameraOptions().position, d = "elevatedStructuresDepthReconstruct", u = t1.getOrCreateProgram(d, {
                defines: [
                    "DEPTH_RECONSTRUCTION"
                ]
            }), _ = t1.getOrCreateProgram(d);
            for (const e of s){
                const s = i.getTile(e), d = s.getBucket(o);
                if (!d) continue;
                const p = d.elevatedStructures;
                if (!p) continue;
                const f = d.elevationBufferData.heightRange, m = ln(e.toUnwrapped(), h), g = t1.translatePosMatrix(e.projMatrix, s, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                let v, y, x, b;
                if ("initialize" === r) {
                    if (!f || f.min >= 1 || 0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = wr(g, m, c, 1, 0), y = a, x = p.depthSegments, b = u;
                } else if ("reset" === r) {
                    if (!f || f.min >= 0 || 0 === p.maskSegments.segments[0].primitiveLength) continue;
                    v = wr(g, m, 0, 0, 1), y = l, x = p.maskSegments, b = u;
                } else if ("geometry" === r) {
                    if (0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = wr(g, m, c, 1, 0), y = a, x = p.depthSegments, b = _;
                }
                b.draw(t1, n.TRIANGLES, y, Xi.disabled, Zi.disabled, Ji.disabled, v, o.id, p.vertexBuffer, p.indexBuffer, x, o.paint, t1.transform.zoom);
            }
        }
        function hn(t1, i, o, s) {
            const { painter: r, sourceCache: n, layer: a, coords: l, colorMode: c, elevationType: h, terrainEnabled: d, pass: u } = t1, _ = r.context.gl, p = a.paint.get("fill-pattern"), f = a.paint.get("fill-pattern-cross-fade"), m = p.constantOr(null);
            let g = h;
            "road" !== h || i && !d || (g = "none");
            const v = "road" === g, y = t1.painter.shadowRenderer, x = v && !!y && y.enabled, b = new Wi(r.context.gl.LEQUAL, Wi.ReadOnly, r.depthRangeFor3D);
            let w = [
                0,
                0,
                0
            ];
            if (x) {
                const e = r.style.directionalLight, t1 = r.style.ambientLight;
                e && t1 && (w = mo(r.style, e, t1));
            }
            const T = p && p.constantOr(1), E = r.terrain && r.terrain.renderingToTexture, S = (t1, u)=>{
                let p, g, S, I, C;
                u ? (p = T && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", S = _.LINES) : (p = T ? "fillPattern" : "fill", S = _.TRIANGLES);
                for (const R of l){
                    const l = n.getTile(R);
                    if (T && !l.patternsLoaded()) continue;
                    const A = l.getBucket(a);
                    if (!A) continue;
                    const D = i ? A.elevationBufferData : A.bufferData;
                    if (D.isEmpty()) continue;
                    r.prepareDrawTile();
                    const L = D.programConfigurations.get(a.id), P = r.isTileAffectedByFog(R), O = [], z = [];
                    v && (O.push("ELEVATED_ROADS"), z.push(D.elevatedLayoutVertexBuffer)), x && O.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), E && o && O.push("USE_MRT1"), T && (r.context.activeTexture.set(_.TEXTURE0), l.imageAtlasTexture && l.imageAtlasTexture.bind(_.LINEAR, _.CLAMP_TO_EDGE), L.updatePaintBuffers());
                    let M = !1;
                    if (m && l.imageAtlas) {
                        const t1 = l.imageAtlas, i = e.e5.from(m), o = i.getPrimary().scaleSelf(e.o.devicePixelRatio).toString(), s = i.getSecondary(), r = t1.patternPositions.get(o), n = s ? t1.patternPositions.get(s.scaleSelf(e.o.devicePixelRatio).toString()) : null;
                        M = !!r && !!n, r && L.setConstantPatternPositions(r, n);
                    }
                    f > 0 && (M || L.getPatternTransitionVertexBuffer("fill-pattern")) && O.push("FILL_PATTERN_TRANSITION");
                    const F = r.getOrCreateProgram(p, {
                        config: L,
                        overrideFog: P,
                        defines: O
                    }), k = r.translatePosMatrix(R.projMatrix, l, a.paint.get("fill-translate"), a.paint.get("fill-translate-anchor"));
                    x && y.setupShadows(l.tileID.toUnwrapped(), F, "vector-tile");
                    const B = a.paint.get("fill-emissive-strength");
                    if (u) {
                        I = D.lineIndexBuffer, C = D.lineSegments;
                        const e = r.terrain && r.terrain.renderingToTexture ? r.terrain.drapeBufferSize : [
                            _.drawingBufferWidth,
                            _.drawingBufferHeight
                        ];
                        g = "fillOutlinePattern" === p && T ? yr(k, B, r, l, e, w, f) : vr(k, B, e, w);
                    } else I = D.indexBuffer, C = D.triangleSegments, g = T ? gr(k, B, r, l, w, f) : mr(k, B, w);
                    r.uploadCommonUniforms(r.context, F, R.toUnwrapped());
                    let N = t1;
                    ("road" === h && !d || "offset" === h) && (N = b), F.draw(r, S, N, s || r.stencilModeForClipping(R), c, Ji.disabled, g, a.id, D.layoutVertexBuffer, I, C, a.paint, r.transform.zoom, L, z);
                }
            };
            r.renderPass === u && S(r.depthModeForSublayer(1, "opaque" === r.renderPass ? Wi.ReadWrite : Wi.ReadOnly), !1), "none" === g && "translucent" === r.renderPass && a.paint.get("fill-antialias") && S(r.depthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, Wi.ReadOnly), !0);
        }
        function dn(t1, i, o, s, r, n, a, l) {
            o.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, d = t1.transform, u = o.paint.get("fill-extrusion-pattern"), _ = o.paint.get("fill-extrusion-pattern-cross-fade"), p = u.constantOr(null), f = u.constantOr(1), m = o.paint.get("fill-extrusion-opacity"), g = t1.style.enable3dLights(), v = o.paint.get(g && !f ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), y = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                v
            ], x = o.layout.get("fill-extrusion-edge-radius"), b = x > 0 && !o.paint.get("fill-extrusion-rounded-roof"), w = b ? 0 : x, T = "globe" === d.projection.name ? e.ed() : 0, E = "globe" === d.projection.name, S = E ? e.ak(d.zoom) : 0, I = [
                e.aG(d.center.lng),
                e.aK(d.center.lat)
            ], C = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), R = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(C ? null : o.lut).toArray01().slice(0, 3), A = o.paint.get("fill-extrusion-flood-light-intensity"), D = o.paint.get("fill-extrusion-vertical-scale"), L = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1), P = o.paint.get("fill-extrusion-height-alignment"), O = o.paint.get("fill-extrusion-base-alignment"), z = lo(t1, o.paint.get("fill-extrusion-cutoff-fade-range")), M = [];
            let F;
            E && M.push("PROJECTION_GLOBE_VIEW"), y[0] > 0 && M.push("FAUX_AO"), b && M.push("ZERO_ROOF_RADIUS"), l && M.push("HAS_CENTROID"), A > 0 && M.push("FLOOD_LIGHT"), z.shouldRenderCutoff && M.push("RENDER_CUTOFF"), L && M.push("RENDER_WALL_MODE");
            const k = "shadow" === t1.renderPass, B = t1.shadowRenderer, N = k && !!B, U = k ? Ji.disabled : Ji.backCCW;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let j = [
                0,
                0,
                0
            ];
            if (B) {
                const e = t1.style.directionalLight, i = t1.style.ambientLight;
                e && i && (j = mo(t1.style, e, i)), k || (M.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), B.useNormalOffset && M.push("NORMAL_OFFSET")), F = M.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const V = N ? "fillExtrusionDepth" : f ? "fillExtrusionPattern" : "fillExtrusion", G = o.getLayerRenderingStats();
            for (const u of s){
                const s = i.getTile(u), g = s.getBucket(o);
                if (!g || g.projection.name !== d.projection.name) continue;
                let v = !1;
                B && (v = 0 === B.getMaxCascadeForTile(u.toUnwrapped()));
                const x = t1.isTileAffectedByFog(u), b = g.programConfigurations.get(o.id);
                let C = !1;
                if (p && s.imageAtlas) {
                    const t1 = s.imageAtlas, i = e.e5.from(p), o = i.getPrimary().scaleSelf(e.o.devicePixelRatio).toString(), r = i.getSecondary(), n = t1.patternPositions.get(o), a = r ? t1.patternPositions.get(r.scaleSelf(e.o.devicePixelRatio).toString()) : null;
                    C = !!n && !!a, n && b.setConstantPatternPositions(n, a);
                }
                _ > 0 && (C || b.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && M.push("FILL_EXTRUSION_PATTERN_TRANSITION");
                const N = t1.getOrCreateProgram(V, {
                    config: b,
                    defines: v ? F : M,
                    overrideFog: x
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(s, N, {
                    useMeterToDem: !0
                }), !g.centroidVertexBuffer) {
                    const e = N.getAttributeLocation(h, "a_centroid_pos");
                    -1 !== e && h.vertexAttrib2f(e, 0, 0);
                }
                !k && B && B.setupShadows(s.tileID.toUnwrapped(), N, "vector-tile"), f && (t1.context.activeTexture.set(h.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers());
                const H = o.paint.get("fill-extrusion-vertical-gradient"), q = 1 / g.tileToMeter;
                let Z;
                if (k && B) {
                    if (vn(s.tileID, g.maxHeight, t1)) continue;
                    const e = B.calculateShadowPassMatrixFromTile(s.tileID.toUnwrapped());
                    Z = pr(e, w, q, D, P, O);
                } else {
                    const e = t1.translatePosMatrix(u.expandedProjMatrix, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = d.projection.createInversionMatrix(d, u.canonical);
                    Z = f ? fr(e, t1, H, m, y, w, q, u, s, T, P, O, S, I, i, R, D, _) : _r(e, t1, H, m, y, w, q, u, T, P, O, S, I, i, R, D, A, j);
                }
                t1.uploadCommonUniforms(c, N, u.toUnwrapped(), null, z);
                let W = g.segments;
                if ("mercator" === d.projection.name && !k && (W = g.getVisibleSegments(s.tileID, t1.terrain, t1.transform.getFrustum(0)), !W.get().length)) continue;
                if (G) {
                    if (k) for (const e of W.get())G.numRenderedVerticesInShadowPass += e.primitiveLength;
                    else for (const e of W.get())G.numRenderedVerticesInTransparentPass += e.primitiveLength;
                }
                const $ = [];
                (t1.terrain || l) && $.push(g.centroidVertexBuffer), E && $.push(g.layoutVertexExtBuffer), L && $.push(g.wallVertexBuffer), N.draw(t1, c.gl.TRIANGLES, r, n, a, U, Z, o.id, g.layoutVertexBuffer, g.indexBuffer, W, o.paint, t1.transform.zoom, b, $);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        class un {
            constructor(){
                this.translate = [
                    0,
                    0
                ], this.translateAnchor = "map", this.edgeRadius = 0, this.cutoffFadeRange = 0;
            }
        }
        function _n(t1, i, o, s, r, n, a, l, c, h, d, u, _, p, f, m, g, v, y, x) {
            const b = i.context, w = b.gl, T = i.transform, E = i.transform.zoom, S = [], I = t1.translate, C = t1.translateAnchor, R = t1.edgeRadius, A = lo(i, t1.cutoffFadeRange);
            "clear" === d ? (S.push("CLEAR_SUBPASS"), x && (S.push("CLEAR_FROM_TEXTURE"), b.activeTexture.set(w.TEXTURE0), x.bind(w.LINEAR, w.CLAMP_TO_EDGE))) : "sdf" === d ? S.push("SDF_SUBPASS") : "emissive" === d && (S.push("USE_MRT1"), b.activeTexture.set(w.TEXTURE0), x.bind(w.LINEAR, w.CLAMP_TO_EDGE)), v && S.push("HAS_CENTROID"), A.shouldRenderCutoff && S.push("RENDER_CUTOFF");
            const D = (e, t1, o, r, d)=>{
                let y = S;
                null != t1.groundRadiusBuffer && (y = S.concat("HAS_ATTRIBUTE_a_flood_light_ground_radius"));
                const w = t1.programConfigurations.get(s.id), T = i.isTileAffectedByFog(e), I = i.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: w,
                    defines: y,
                    overrideFog: T
                }), C = ((e, t1, i, o, s, r, n, a, l, c, h)=>({
                        u_matrix: t1,
                        u_opacity: i,
                        u_ao_pass: o ? 1 : 0,
                        u_meter_to_tile: s,
                        u_ao: r,
                        u_flood_light_intensity: n,
                        u_flood_light_color: a,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h,
                        u_dynamic_offset: 1
                    }))(0, r, u, h, d, [
                    _,
                    p * d
                ], f, m, g, E >= 17 ? 0 : R * d, x ? x.size[0] : 0), D = [];
                v && D.push(t1.hiddenByLandmarkVertexBuffer), null != t1.groundRadiusBuffer && D.push(t1.groundRadiusBuffer), i.uploadCommonUniforms(b, I, e.toUnwrapped(), null, A), I.draw(i, b.gl.TRIANGLES, n, a, l, c, C, s.id, t1.vertexBuffer, t1.indexBuffer, o, s.paint, E, w, D);
            };
            for (const t1 of r){
                const r = o.getTile(t1), n = r.getBucket(s);
                if (!n || n.projection.name !== T.projection.name || !n.groundEffect || n.groundEffect && !n.groundEffect.hasData()) continue;
                const a = n.groundEffect, l = 1 / n.tileToMeter;
                {
                    const e = i.translatePosMatrix(t1.projMatrix, r, I, C), o = a.getDefaultSegment();
                    D(t1, a, o, e, l);
                }
                if (y) for(let n = 0; n < 4; n++){
                    const a = e.eb[n](t1), c = o.getTile(a);
                    if (!c) continue;
                    const h = c.getBucket(s);
                    if (!h || h.projection.name !== T.projection.name || !h.groundEffect || h.groundEffect && !h.groundEffect.hasData()) continue;
                    const d = h.groundEffect;
                    let u, _;
                    0 === n ? (u = [
                        -e.am,
                        0,
                        0
                    ], _ = 1) : 1 === n ? (u = [
                        e.am,
                        0,
                        0
                    ], _ = 0) : 2 === n ? (u = [
                        0,
                        -e.am,
                        0
                    ], _ = 3) : (u = [
                        0,
                        e.am,
                        0
                    ], _ = 2);
                    const p = d.regionSegments[_];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    e.bs(f, t1.projMatrix, u), D(t1, d, p, i.translatePosMatrix(f, r, I, C), l);
                }
            }
        }
        function pn(t1, i, o, s, r, n, a) {
            0 === s.centroidVertexArray.length && s.createCentroidsBuffer();
            const l = n ? n.findDEMTileFor(o) : null;
            if (!(l && l.dem || a)) return;
            n && l && l.dem && s.selfDEMTileTimestamp !== l.dem._timestamp && (s.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], s.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1, i)=>{
                (t1.flags | i.flags) & e.ee ? (t1.flags |= e.ee, i.flags |= e.ee) : (t1.flags &= ~e.ee, i.flags &= ~e.ee);
            }, h = (t1)=>new e.P(Math.ceil((t1 + e.ef) * e.eg), 0), d = (e)=>{
                const t1 = i.getSource().minzoom, o = (e)=>{
                    const t1 = i.getTileByID(e);
                    if (t1 && t1.hasData()) return t1.getBucket(r);
                }, s = [
                    0,
                    -1,
                    1
                ];
                for (const i of s){
                    if (e.overscaledZ + i < t1) continue;
                    const s = o(e.calculateScaledKey(e.overscaledZ + i));
                    if (s) return s;
                }
            }, u = [
                0,
                0,
                0
            ], _ = (t1, i)=>(u[0] = Math.min(t1.min.y, i.min.y), u[1] = Math.max(t1.max.y, i.max.y), u[2] = e.am - i.min.x > t1.max.x ? i.min.x - e.am : t1.max.x, u), p = (t1, i)=>(u[0] = Math.min(t1.min.x, i.min.x), u[1] = Math.max(t1.max.x, i.max.x), u[2] = e.am - i.min.y > t1.max.y ? i.min.y - e.am : t1.max.y, u), f = [
                (e, t1)=>_(e, t1),
                (e, t1)=>_(t1, e),
                (e, t1)=>p(e, t1),
                (e, t1)=>p(t1, e)
            ], m = (t1, i, s, r, a, c, h)=>{
                if (!n) return 0;
                const d = [
                    [
                        c ? s : t1,
                        c ? t1 : s,
                        0
                    ],
                    [
                        c ? s : i,
                        c ? i : s,
                        0
                    ]
                ], u = h < 0 ? e.am + h : h, _ = [
                    c ? u : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : u,
                    0
                ];
                return 0 === s && h < 0 || 0 !== s && h > 0 ? n.getForTilePoints(a, [
                    _
                ], !0, r) : d.push(_), n.getForTilePoints(o, d, !0, l), Math.max(d[0][2], d[1][2], _[2]) / n.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = s.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const r = e.eb[t1](o), l = d(r);
                if (!(l && l instanceof e.ec)) continue;
                const u = n ? n.findDEMTileFor(r) : null;
                if (!(u && u.dem || a)) continue;
                if (n && u && u.dem && s.borderDEMTileTimestamp[t1] !== u.dem._timestamp && (s.borderDoneWithNeighborZ[t1] = -1, s.borderDEMTileTimestamp[t1] = u.dem._timestamp), s.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const _ = (t1 < 2 ? 1 : 5) - t1, p = l.borderDoneWithNeighborZ[_] !== s.canonical.z, g = l.borderFeatureIndices[_];
                let v = 0;
                if (s.canonical.z !== l.canonical.z) {
                    for (const e of i)s.showCentroid(s.featuresOnBorder[e]);
                    if (p) for (const e of g)l.showCentroid(l.featuresOnBorder[e]);
                    s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[_] = s.canonical.z;
                }
                for (const o of i){
                    const i = s.featuresOnBorder[o], n = s.centroidData[i.centroidDataIndex], d = i.borders[t1];
                    let p;
                    for(; v < g.length;){
                        p = l.featuresOnBorder[g[v]];
                        const e = p.borders[_];
                        if (e[1] > d[0] + 3 || e[0] > d[0] - 3) break;
                        l.showCentroid(p), v++;
                    }
                    if (p && v < g.length) {
                        const o = v;
                        let y = 0;
                        for(; !(p.borders[_][0] > d[1] - 3) && (y++, ++v !== g.length);)p = l.featuresOnBorder[g[v]];
                        p = l.featuresOnBorder[g[o]];
                        let x = !1;
                        if (y >= 1) {
                            const e = p.borders[_];
                            Math.abs(d[0] - e[0]) < 3 && Math.abs(d[1] - e[1]) < 3 && (y = 1, x = !0, v = o + 1);
                        } else if (0 === y) {
                            s.showCentroid(i);
                            continue;
                        }
                        const b = l.centroidData[p.centroidDataIndex];
                        a && x && c(n, b);
                        const w = i.intersectsCount() > 1 || p.intersectsCount() > 1;
                        if (y > 1) v = o, n.centroidXY = b.centroidXY = new e.P(0, 0);
                        else if (u && u.dem && !w) {
                            const i = f[t1](n, b), o = t1 % 2 ? e.am - 1 : 0, s = m(i[0], Math.min(e.am - 1, i[1]), o, u, r, t1 < 2, i[2]);
                            n.centroidXY = b.centroidXY = h(s);
                        } else w ? n.centroidXY = b.centroidXY = new e.P(0, 0) : (n.centroidXY = s.encodeBorderCentroid(i), b.centroidXY = l.encodeBorderCentroid(p));
                        s.writeCentroidToBuffer(n), l.writeCentroidToBuffer(b);
                    } else s.showCentroid(i);
                }
                s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[_] = s.canonical.z;
            }
            (s.needsCentroidUpdate || !s.centroidVertexBuffer && 0 !== s.centroidVertexArray.length) && s.uploadCentroid(t1);
        }
        const fn = [
            1,
            0,
            0
        ], mn = [
            0,
            1,
            0
        ], gn = [
            0,
            0,
            1
        ];
        function vn(t1, i, o) {
            const s = o.transform, r = o.shadowRenderer;
            if (!r) return !0;
            const n = t1.toUnwrapped(), a = s.tileSize * r._cascades[o.currentShadowCascade].scale;
            let l = i;
            if (s.elevation) {
                const e = s.elevation.getMinMaxForTile(t1);
                e && (l += e.max);
            }
            const c = [
                ...r.shadowDirection
            ];
            c[2] = -c[2];
            const h = r.computeSimplifiedTileShadowVolume(n, l, a, c);
            if (!h) return !1;
            const d = [
                fn,
                mn,
                gn,
                c,
                [
                    c[0],
                    0,
                    c[2]
                ],
                [
                    0,
                    c[1],
                    c[2]
                ]
            ], u = "globe" === s.projection.name, _ = s.scaleZoom(a), p = e.cC.fromInvProjectionMatrix(s.invProjMatrix, s.worldSize, _, !u), f = r.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(h.vertices, h.planes, d) || 0 === f.intersectsPrecise(h.vertices, h.planes, d);
        }
        function yn(t1) {
            const { painter: i, source: o, layer: s, coords: r } = t1;
            let n = t1.defines;
            const a = i.context, l = "shadow" === i.renderPass, c = "light-beam" === i.renderPass, h = i.shadowRenderer, d = e.eh(i.transform.center.lat, i.transform.zoom), u = lo(i, s.paint.get("building-cutoff-fade-range"));
            u.shouldRenderCutoff && (n = n.concat("RENDER_CUTOFF")), t1.floodLightIntensity > 0 && (n = n.concat("FLOOD_LIGHT"));
            for (const _ of r){
                const r = o.getTile(_), p = r.getBucket(s);
                if (!p) continue;
                h && 0 === h.getMaxCascadeForTile(_.toUnwrapped()) && (n = n.concat("SHADOWS_SINGLE_CASCADE"));
                const f = p.programConfigurations.get(s.id);
                let m, g, v, y = i.translatePosMatrix(_.expandedProjMatrix, r, [
                    0,
                    0
                ], "map");
                if (y = e.cT(e.bD(), y, [
                    1,
                    1,
                    t1.verticalScale
                ]), l && h) {
                    if (vn(r.tileID, p.maxHeight * d, i)) continue;
                    let o = h.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    o = e.cT(e.bD(), o, [
                        1,
                        1,
                        t1.verticalScale
                    ]), v = Sr(o), m = g = i.getOrCreateProgram("buildingDepth", {
                        config: f,
                        defines: n,
                        overrideFog: !1
                    });
                } else if (c) m = g = i.getOrCreateProgram("buildingBloom", {
                    config: f,
                    defines: n,
                    overrideFog: !1
                }), v = Er(y);
                else {
                    const o = i.transform.calculatePosMatrix(_.toUnwrapped(), i.transform.worldSize);
                    e.cT(o, o, [
                        1,
                        1,
                        t1.verticalScale
                    ]);
                    const s = e.bD();
                    e.cT(s, o, [
                        1,
                        -1,
                        1 / d
                    ]), e.bm(s, s), e.ei(s, s);
                    const r = i.transform.getFreeCameraOptions().position, a = 1 << _.canonical.z;
                    if (v = Tr(y, s, t1.opacity, t1.facadeAOIntensity, [
                        ((r.x - _.wrap) * a - _.canonical.x) * e.am,
                        (r.y * a - _.canonical.y) * e.am,
                        r.z * a * e.am
                    ], p.tileToMeter, t1.facadeEmissiveChance, t1.floodLightColor, t1.floodLightIntensity), g = i.getOrCreateProgram("building", {
                        config: f,
                        defines: n,
                        overrideFog: !1
                    }), !0 === t1.depthOnly) m = g;
                    else {
                        const e = n.concat([
                            "BUILDING_FAUX_FACADE",
                            "HAS_ATTRIBUTE_a_faux_facade_color_emissive"
                        ]);
                        m = i.getOrCreateProgram("building", {
                            config: f,
                            defines: e,
                            overrideFog: !1
                        });
                    }
                    h && (h.setupShadowsFromMatrix(o, g, !0), m !== g && h.setupShadowsFromMatrix(o, m, !0));
                }
                const x = (e, o)=>{
                    if (c) {
                        const r = e.entranceBloom;
                        o.draw(i, a.gl.TRIANGLES, t1.depthMode, Xi.disabled, t1.blendMode, Ji.disabled, v, s.id, r.layoutVertexBuffer, r.indexBuffer, r.segmentsBucket, s.paint, i.transform.zoom, f, [
                            r.layoutAttenuationBuffer,
                            r.layoutColorBuffer
                        ]);
                    } else {
                        const r = e.segmentsBucket;
                        let n = [
                            e.layoutNormalBuffer,
                            e.layoutCentroidBuffer,
                            e.layoutColorBuffer,
                            e.layoutFloodLightDataBuffer
                        ];
                        e.layoutFacadePaintBuffer && (n = n.concat([
                            e.layoutFacadeDataBuffer,
                            e.layoutFacadeVerticalRangeBuffer,
                            e.layoutFacadePaintBuffer
                        ])), o.draw(i, a.gl.TRIANGLES, t1.depthMode, Xi.disabled, t1.blendMode, l ? Ji.disabled : Ji.backCW, v, s.id, e.layoutVertexBuffer, e.indexBuffer, r, s.paint, i.transform.zoom, f, n);
                    }
                };
                i.uploadCommonUniforms(a, g, _.toUnwrapped(), null, u), p.buildingWithoutFacade && x(p.buildingWithoutFacade, g), p.buildingWithFacade && (m !== g && i.uploadCommonUniforms(a, m, _.toUnwrapped(), null, u), x(p.buildingWithFacade, m));
            }
        }
        function xn(t1, i, o, s, r, n, a, l, c, h, d, u, _) {
            const p = t1.context.gl, f = t1.depthModeForSublayer(1, Wi.ReadOnly, p.LEQUAL, !0), m = .1 * (1 - (g = d)) + 3 * g;
            var g;
            const v = t1._showOverdrawInspector, y = u, x = new un;
            v || _n(x, t1, i, o, s, f, new Xi({
                func: p.ALWAYS,
                mask: 255
            }, 255, 255, p.KEEP, p.KEEP, p.REPLACE), new Zi([
                p.ONE,
                p.ONE,
                p.ONE,
                p.ONE
            ], e.ap.transparent, [
                !1,
                !1,
                !1,
                !0
            ], p.MIN), Ji.disabled, r, "sdf", n, a, l, c, h, m, y, !1);
            {
                const d = v ? Xi.disabled : new Xi({
                    func: p.EQUAL,
                    mask: 255
                }, 255, 255, p.KEEP, p.DECR, p.DECR), u = v ? t1.colorModeForRenderPass() : new Zi([
                    p.ONE_MINUS_DST_ALPHA,
                    p.DST_ALPHA,
                    p.ONE,
                    p.ONE
                ], e.ap.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]);
                _n(x, t1, i, o, s, f, d, u, Ji.disabled, r, "color", n, a, l, c, h, m, y, !1);
            }
        }
        function bn(t1) {
            return [
                t1[0] * e.ej,
                t1[1] * e.ej,
                t1[2] * e.ej,
                0
            ];
        }
        function wn(t1, i, o, s, r, n, a, l, c) {
            const h = s.getSource(), d = o.globeSharedBuffers;
            if (!d) return;
            let u, _, p;
            if (i && (u = s.getTile(i)), h instanceof e.aV ? (_ = h.texture, p = e.dM(0, 0, o.transform)) : u && i && (_ = u.texture, p = e.dM(i.canonical.z, i.canonical.x, o.transform)), !_ || !p) return;
            t1 || (p = e.cT(e.bD(), p, [
                1,
                -1,
                1
            ]));
            const f = o.context, m = f.gl, g = "nearest" === r.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR, v = o.colorModeForDrapableLayerRenderPass(n), y = a.defines;
            y.push("GLOBE_POLES");
            const x = new Wi(m.LEQUAL, Wi.ReadWrite, o.depthRangeFor3D), b = Float32Array.from(o.transform.expandedFarZProjMatrix), w = Float32Array.from(e.bl(e.dL(new e.cE(0, 0, 0))));
            o.terrain && o.terrain.prepareDrawTile(), f.activeTexture.set(m.TEXTURE0), _.bind(g, m.CLAMP_TO_EDGE), f.activeTexture.set(m.TEXTURE1), _.bind(g, m.CLAMP_TO_EDGE), "useMipmap" in _ && f.extTextureFilterAnisotropic && o.transform.pitch > 20 && m.texParameterf(m.TEXTURE_2D, f.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f.extTextureFilterAnisotropicMax);
            const [T, E, S, I] = i ? d.getPoleBuffers(i.canonical.z, !1) : d.getPoleBuffers(0, !0), C = r.paint.get("raster-elevation");
            let R;
            t1 ? (R = T, o.renderDefaultNorthPole = 0 !== C) : (R = E, o.renderDefaultSouthPole = 0 !== C);
            const A = bn(a.mix), D = ((e, t1, i, o, s, r, n, a, l, c, h, d, u, _)=>zr(e, t1, i, o, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], s, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, n, [
                    0,
                    0
                ], l, 2, h, d, u, 1, 0, _))(o, b, w, p, e.ak(o.transform.zoom), 0, r, 0, C, 0, A, a.offset, a.range, n), L = o.getOrCreateProgram("raster", {
                defines: y
            });
            o.uploadCommonUniforms(f, L, null), L.draw(o, m.TRIANGLES, x, c, v, l, D, r.id, R, S, I);
        }
        function Tn(e) {
            if (e.isOrthographic) return [
                0,
                0,
                0,
                0
            ];
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        function En(e, t1, i, o) {
            if (e) return t1 instanceof pt && e instanceof Ot ? t1.getTextureDescriptor(e, i, !0) : {
                texture: e.texture,
                mix: bn(o.mix),
                offset: o.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        var Sn = e.ek([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class In {
            constructor(t1, i, o, s){
                const r = {
                    width: o[0],
                    height: o[1],
                    data: null
                }, n = t1.gl;
                this.targetColorTexture = new e.T(t1, r, n.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e.T(t1, r, n.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, s), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const o = this.context.gl, s = i.width * i.height;
                this.particleTexture0 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const r = new e.el;
                r.reserve(s);
                for(let e = 0; e < s; e++)r.emplaceBack(e);
                this.particleIndexBuffer = this.context.createVertexBuffer(r, Sn.members, !0), this.particleSegment = e.bh.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e.o.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function Cn(t1, i, o) {
            if (!t1) return null;
            const s = i.getTextureDescriptor(t1, o, !0);
            if (!s) return null;
            let { texture: r, mix: n, offset: a, tileSize: l, buffer: c, format: h } = s;
            if (!r || !h) return null;
            let d = !1;
            return "uint32" === h && (d = !0, n[3] = 0, n = Lr(e.em, n, [
                0,
                o.paint.get("raster-particle-max-speed")
            ]), a = Pr(e.em, a, [
                0,
                o.paint.get("raster-particle-max-speed")
            ])), {
                texture: r,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: d,
                scale: n,
                offset: a,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function Rn(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        const An = new e.ap(1, 0, 0, 1), Dn = new e.ap(0, 1, 0, 1), Ln = new e.ap(0, 0, 1, 1), Pn = new e.ap(1, 0, 1, 1), On = new e.ap(0, 1, 1, 1);
        function zn(t1, i, o, s, r, n) {
            for(let a = 0; a < o.length; a++)if (r) {
                const r = 1, l = .8, c = new e.ap(s.r * l, s.g * l, s.b * l, 1);
                Mn(t1, i, o[a], s, -r, -r, n), Mn(t1, i, o[a], s, -r, r, n), Mn(t1, i, o[a], s, r, r, n), Mn(t1, i, o[a], s, r, -r, n), Mn(t1, i, o[a], c, 0, 0, n);
            } else Mn(t1, i, o[a], s, 0, 0, n);
        }
        function Mn(t1, i, o, s, r, n, a) {
            const l = t1.context, c = t1.transform, h = l.gl, d = "globe" === c.projection.name, u = d ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let _ = e.bA(o.projMatrix);
            if (d && e.ak(c.zoom) > 0) {
                const t1 = e.bk(o.canonical, c), i = e.eo(t1);
                _ = e.aC(new Float32Array(16), c.globeMatrix, i), e.aC(_, c.projMatrix, _);
            }
            const p = e.bD();
            p[12] += 2 * r / (e.o.devicePixelRatio * c.width), p[13] += 2 * n / (e.o.devicePixelRatio * c.height), e.aC(_, p, _);
            const f = t1.getOrCreateProgram("debug", {
                defines: u
            }), m = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(m, f);
            const g = Wi.disabled, v = Xi.disabled, y = t1.colorModeForRenderPass(), x = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), d ? m._makeGlobeTileDebugBuffers(t1.context, c) : m._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const b = m._tileDebugBuffer || t1.debugBuffer, w = m._tileDebugIndexBuffer || t1.debugIndexBuffer, T = m._tileDebugSegments || t1.debugSegments;
            if (f.draw(t1, h.LINE_STRIP, g, v, y, Ji.disabled, Rr(_, s.toPremultipliedRenderColor(null)), x, b, w, T, null, null, null, [
                m._globeTileDebugBorderBuffer
            ]), a) {
                const e = m.latestRawTileData, i = Math.floor((e && e.byteLength || 0) / 1024);
                let s = o.canonical.toString();
                o.overscaledZ !== o.canonical.z && (s += ` => ${o.overscaledZ}`), s += ` ${m.state}`, s += ` ${i}kb`, function(e, t1) {
                    e.initDebugOverlayCanvas();
                    const i = e.debugOverlayCanvas, o = e.context.gl, s = e.debugOverlayCanvas.getContext("2d");
                    s.clearRect(0, 0, i.width, i.height), s.shadowColor = "white", s.shadowBlur = 2, s.lineWidth = 1.5, s.strokeStyle = "white", s.textBaseline = "top", s.font = "bold 36px Open Sans, sans-serif", s.fillText(t1, 5, 5), s.strokeText(t1, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
                }(t1, s);
            }
            const E = i.getTile(o).tileSize, S = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5, I = m._tileDebugTextBuffer || t1.debugBuffer, C = m._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, R = m._tileDebugTextSegments || t1.debugSegments;
            f.draw(t1, h.TRIANGLES, g, v, Zi.alphaBlended, Ji.disabled, Rr(_, e.ap.transparent.toPremultipliedRenderColor(null), S), x, I, C, R, null, null, null, [
                m._globeTileDebugTextBuffer
            ]);
        }
        function Fn(e, t1, i, o) {
            Bn(e, 0, t1 + i / 2, e.transform.width, i, o);
        }
        function kn(e, t1, i, o) {
            Bn(e, t1 - i / 2, 0, i, e.transform.height, o);
        }
        function Bn(t1, i, o, s, r, n) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e.o.devicePixelRatio, o * e.o.devicePixelRatio, s * e.o.devicePixelRatio, r * e.o.devicePixelRatio), a.clear({
                color: n
            }), l.disable(l.SCISSOR_TEST);
        }
        const Nn = e.ek([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: Un } = Nn;
        function jn(e, t1, i, o) {
            e.emplaceBack(t1, i, o);
        }
        class Vn {
            constructor(t1){
                this.vertexArray = new e.ep, this.indices = new e.b1, jn(this.vertexArray, -1, -1, 1), jn(this.vertexArray, 1, -1, 1), jn(this.vertexArray, -1, 1, 1), jn(this.vertexArray, 1, 1, 1), jn(this.vertexArray, -1, -1, -1), jn(this.vertexArray, 1, -1, -1), jn(this.vertexArray, -1, 1, -1), jn(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Un), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e.bh.simpleSegment(0, 0, 36, 12);
            }
        }
        function Gn(t1, i, o, s, r, n) {
            const a = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), d = ((e, t1, i, o, s)=>({
                    u_matrix_3f: e,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ],
                    u_luminance: 5e-5
                }))(e.er(e.dQ(), s), r, h, l.toPremultipliedRenderColor(null), c.toPremultipliedRenderColor(null));
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + n, i.skyboxTexture, 0), o.draw(t1, a.TRIANGLES, Wi.disabled, Xi.disabled, Zi.unblended, Ji.frontCW, d, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const Hn = e.ek([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class qn {
            constructor(t1){
                const i = new e.es;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e.b1;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, Hn.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e.bh.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const Zn = e.ek([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class Wn {
            constructor(){
                this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
            }
        }
        class $n {
            constructor(t1){
                this.colorModeAlphaBlendedWriteRGB = new Zi([
                    1,
                    qi,
                    1,
                    qi
                ], e.ap.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new Zi([
                    1,
                    0,
                    1,
                    0
                ], e.ap.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = new Wn, this.updateNeeded = !0;
            }
            update(t1) {
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new qn(i);
                    const t1 = this.params.sizeRange, o = this.params.intensityRange, s = function(t1) {
                        const i = e.ex(30), o = [];
                        for(let s = 0; s < t1; ++s){
                            const t1 = 2 * Math.PI * i(), s = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            o.push(e.d6(Math.cos(s) * Math.cos(t1), Math.cos(s) * Math.sin(t1), Math.sin(s)));
                        }
                        return o;
                    }(this.params.starsCount), r = e.ex(300), n = new e.et, a = new e.b1;
                    let l = 0;
                    for(let i = 0; i < s.length; ++i){
                        const c = e.c6([], s[i], 200), h = Math.max(0, 1 + .01 * t1 * (1 * r() - .5)), d = Math.max(0, 1 + .01 * o * (1 * r() - .5));
                        n.emplaceBack(c[0], c[1], c[2], -1, -1, h, d), n.emplaceBack(c[0], c[1], c[2], 1, -1, h, d), n.emplaceBack(c[0], c[1], c[2], 1, 1, h, d), n.emplaceBack(c[0], c[1], c[2], -1, 1, h, d), a.emplaceBack(l + 0, l + 1, l + 2), a.emplaceBack(l + 0, l + 2, l + 3), l += 4;
                    }
                    this.starsVx = i.createVertexBuffer(n, Zn.members), this.starsIdx = i.createIndexBuffer(a), this.starsSegments = e.bh.simpleSegment(0, 0, n.length, a.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t1, i) {
                const o = t1.context, s = o.gl, r = t1.transform, n = new Wi(s.LEQUAL, Wi.ReadOnly, [
                    0,
                    1
                ]), a = e.ak(r.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : l), d = "none" === i.properties.get("high-color-use-theme"), u = i.properties.get("high-color").toNonPremultipliedRenderColor(d ? null : l), _ = "none" === i.properties.get("space-color-use-theme"), p = i.properties.get("space-color").toNonPremultipliedRenderColor(_ ? null : l), f = 5e-4, m = e.eu(i.properties.get("horizon-blend"), 0, 1, f, .25), g = e.dG(t1, o, r) && m === f ? r.worldSize / (2 * Math.PI * 1.025) - 1 : r.globeRadius, v = t1.frameCounter / 1e3 % 1, y = e.ah(r.globeCenterInViewSpace), x = Math.sqrt(Math.pow(y, 2) - Math.pow(g, 2)), b = Math.acos(x / y), w = (e)=>{
                    const i = "globe" === r.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    e && i.push("ALPHA_PASS");
                    const l = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: i
                    }), c = ((e, t1, i, o, s, r, n, a, l, c, h, d)=>({
                            u_frustum_tl: e,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: o,
                            u_horizon: s,
                            u_transition: r,
                            u_fadeout_range: n,
                            u_atmosphere_fog_color: a.toArray01(),
                            u_high_color: l.toArray01(),
                            u_space_color: c.toArray01(),
                            u_temporal_offset: h,
                            u_horizon_angle: d
                        }))(r.frustumCorners.TL, r.frustumCorners.TR, r.frustumCorners.BR, r.frustumCorners.BL, r.frustumCorners.horizon, a, m, h, u, p, v, b);
                    t1.uploadCommonUniforms(o, l);
                    const d = this.atmosphereBuffer;
                    d && l.draw(t1, s.TRIANGLES, n, Xi.disabled, e ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Ji.backCW, c, e ? "atmosphere_glow_alpha" : "atmosphere_glow", d.vertexBuffer, d.indexBuffer, d.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const o = e.aB(i.properties.get("star-intensity"), 0, 1);
                if (0 === o) return;
                const s = t1.context, r = s.gl, n = t1.transform, a = t1.getOrCreateProgram("stars"), l = e.c8([]);
                e.ca(l, l, -n._pitch), e.c9(l, l, -n.angle), e.ca(l, l, e.ao(n._center.lat)), e.ev(l, l, -e.ao(n._center.lng));
                const c = e.cd(new Float32Array(16), l), h = e.aC([], n.starsProjMatrix, c), d = e.er([], c), u = e.ew([], d), _ = [
                    0,
                    1,
                    0
                ];
                e.dS(_, _, u), e.c6(_, _, this.params.sizeMultiplier);
                const p = [
                    1,
                    0,
                    0
                ];
                e.dS(p, p, u), e.c6(p, p, this.params.sizeMultiplier);
                const f = (m = _, g = p, v = o, {
                    u_matrix: Float32Array.from(h),
                    u_up: m,
                    u_right: g,
                    u_intensity_multiplier: v
                });
                var m, g, v;
                t1.uploadCommonUniforms(s, a), this.starsVx && this.starsIdx && a.draw(t1, r.TRIANGLES, Wi.disabled, Xi.disabled, this.colorModeAlphaBlendedWriteRGB, Ji.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        class Xn {
            constructor(){
                this.visibleTiles = [];
            }
            updateBorders(t1, i) {
                const o = [], s = [], r = t1._getRenderableCoordinates(!1, !0);
                for (const e of r){
                    const r = t1.getTile(e);
                    if (!r.hasData()) continue;
                    const n = r.getBucket(i);
                    n && (n.isEmpty() || (o.push(e.key), s.push({
                        bucket: n,
                        tileID: e.canonical
                    })));
                }
                let n = o.length !== this.visibleTiles.length;
                if (!n) {
                    o.sort();
                    for(let e = 0; e < o.length; e++)if (o[e] !== this.visibleTiles[e]) {
                        n = !0;
                        break;
                    }
                }
                if (!n) return;
                const a = new Set;
                this.visibleTiles = o, s.sort((e, t1)=>e.tileID.z - t1.tileID.z || e.tileID.x - t1.tileID.x || e.tileID.y - t1.tileID.y);
                for (const t1 of s){
                    const i = new Array, o = new Array, s = t1.bucket;
                    for (const e of s.featuresOnBorder)a.has(e.featureId) ? o.push(e.footprintIndex) : (a.add(e.featureId), i.push(e.footprintIndex));
                    s.updateFootprintHiddenFlags(i, e.ey, !1), s.updateFootprintHiddenFlags(o, e.ey, !0);
                }
            }
        }
        function Kn(t1, i) {
            const o = [
                ...t1
            ], s = i.cameraWorldSizeForFog / i.worldSize, r = e.bB([]);
            return e.cT(r, r, [
                s,
                s,
                1
            ]), e.aC(o, r, o), e.aC(o, i.worldToFogMatrix, o), o;
        }
        function Yn(t1, i, o, s, r) {
            const n = o.material, a = s.context, { baseColorTexture: l, metallicRoughnessTexture: c } = n.pbrMetallicRoughness, { normalTexture: h, occlusionTexture: d, emissionTexture: u } = n;
            function _(e, i, o) {
                if (e && (t1.push(i), a.activeTexture.set(a.gl.TEXTURE0 + o), e.gfxTexture)) {
                    const { minFilter: t1, magFilter: i, wrapS: o, wrapT: s } = e.sampler;
                    e.gfxTexture.bindExtraParam(t1, i, o, s);
                }
            }
            _(l, "HAS_TEXTURE_u_baseColorTexture", 5), _(c, "HAS_TEXTURE_u_metallicRoughnessTexture", 6), _(h, "HAS_TEXTURE_u_normalTexture", 7), _(d, "HAS_TEXTURE_u_occlusionTexture", 8), _(u, "HAS_TEXTURE_u_emissionTexture", 9), r && (r.texture || (r.texture = new e.e1(s.context, r.image, [
                r.image.height,
                r.image.height,
                r.image.height
            ], a.gl.RGBA8)), a.activeTexture.set(a.gl.TEXTURE0 + 10), r.texture && r.texture.bind(a.gl.LINEAR, a.gl.CLAMP_TO_EDGE), t1.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t1.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t1.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t1.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t1.push("HAS_ATTRIBUTE_a_pbr"), t1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== n.alphaMode && "MASK" !== n.alphaMode || t1.push("UNPREMULT_TEXTURE_IN_SHADER"), n.defined || t1.push("DIFFUSE_SHADED");
            const p = s.shadowRenderer;
            p && (t1.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), p.useNormalOffset && t1.push("NORMAL_OFFSET"));
        }
        function Jn(t1, i, o, s, r, n) {
            const a = t1.modelOpacity, l = i.context, c = new Wi(i.context.gl.LEQUAL, t1.isLightMesh ? Wi.ReadOnly : Wi.ReadWrite, i.depthRangeFor3D), h = i.transform, d = t1.mesh, u = d.material, _ = u.pbrMetallicRoughness, p = i.style.fog;
            let f;
            f = "pixels" === i.transform.projection.zAxisUnit ? [
                ...t1.nodeModelMatrix
            ] : e.aC([], s.zScaleMatrix, t1.nodeModelMatrix), e.aC(f, s.negCameraPosMatrix, f);
            const m = e.bm([], f);
            e.ei(m, m);
            const g = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = o.paint.get("model-emissive-strength").constantOr(0), y = qr(new Float32Array(t1.worldViewProjection), new Float32Array(f), new Float32Array(m), null, i, a, _.baseColorFactor, u.emissiveFactor, _.metallicFactor, _.roughnessFactor, u, v, o, void 0, void 0, t1.materialOverride, t1.modelColor), x = {
                defines: []
            }, b = [], w = i.shadowRenderer;
            w && (w.useNormalOffset = !1), Yn(x.defines, b, d, i, g ? null : o.lut);
            let T = null;
            if (p) {
                const e = Kn(t1.nodeModelMatrix, i.transform);
                if (T = new Float32Array(e), "globe" !== h.projection.name) {
                    const t1 = d.aabb.min, i = d.aabb.max, [o, s] = p.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                    x.overrideFog = o >= Ve || s >= Ve;
                }
            }
            const E = lo(i, o.paint.get("model-cutoff-fade-range"));
            E.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const S = i.getOrCreateProgram("model", x);
            i.uploadCommonUniforms(l, S, null, T, E), "shadow" !== i.renderPass && w && w.setupShadowsFromMatrix(t1.nodeModelMatrix, S), S.draw(i, l.gl.TRIANGLES, c, r, n, d.material.doubleSided ? Ji.disabled : Ji.backCCW, y, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, i.transform.zoom, void 0, b);
        }
        function Qn(e, t1) {
            return e.style._importedAsBasemap ? "basemap" : t1.scope;
        }
        function ea(t1, i, o, s, r, n, a, l, c, h) {
            const d = t1.transform, u = !!i.isGeometryBloom && i.isGeometryBloom;
            if (u && "shadow" === t1.renderPass) return;
            const _ = "globe" === d.projection.name ? e.eG(o, d) : [
                ...o
            ];
            e.aC(_, _, i.globalMatrix);
            const p = e.aC([], s, _);
            if (i.meshes) for (const t1 of i.meshes){
                const s = l.get(t1.material.name);
                if (s && s.opacity <= 0) continue;
                if ("BLEND" !== t1.material.alphaMode) {
                    a.push({
                        mesh: t1,
                        depth: 0,
                        modelIndex: r,
                        worldViewProjection: p,
                        nodeModelMatrix: _,
                        isLightMesh: u,
                        materialOverride: s,
                        modelOpacity: c,
                        modelColor: h,
                        node: i,
                        modelMatrix: o
                    });
                    continue;
                }
                const f = e.ag([], t1.centroid, p);
                !d.isOrthographic && f[2] <= 0 || n.push({
                    mesh: t1,
                    depth: f[2],
                    modelIndex: r,
                    worldViewProjection: p,
                    nodeModelMatrix: _,
                    isLightMesh: u,
                    materialOverride: s,
                    modelOpacity: c,
                    modelColor: h,
                    node: i,
                    modelMatrix: o
                });
            }
            if (i.children) for (const e of i.children)ea(t1, e, o, s, r, n, a, l, c, h);
        }
        function ta(e, t1, i, o) {
            const s = i.shadowRenderer;
            if (!s) return;
            const r = s.getShadowPassDepthMode(), n = s.getShadowPassColorMode(), a = s.calculateShadowPassMatrixFromMatrix(t1), l = Zr(a);
            i.getOrCreateProgram("modelDepth", {
                defines: i._shadowMapDebug ? [] : [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, r, Xi.disabled, n, Ji.disabled, l, o.id, e.vertexBuffer, e.indexBuffer, e.segments, o.paint, i.transform.zoom, void 0, void 0);
        }
        function ia(t1, i, o, s) {
            const r = function(t1, i) {
                if (i.footprintDebugMesh) return i.footprintDebugMesh;
                if (!i.footprint) return null;
                const o = t1.context, s = i.footprint.vertices, r = i.footprint.indices, n = new e.be;
                n.reserve(s.length);
                for (const e of s)n.emplaceBack(e.x, e.y);
                const a = new e.b1;
                a.reserve(r.length);
                for(let e = 0; e < r.length; e += 3)a.emplaceBack(r[e], r[e + 1], r[e + 2]);
                const l = o.createVertexBuffer(n, e.bg.members), c = o.createIndexBuffer(a), h = e.bh.simpleSegment(0, 0, s.length, r.length), d = i.id || i.name || "footprint";
                let u;
                const _ = parseInt(d, 10);
                u = isNaN(_) ? function(e) {
                    let t1 = 0;
                    for(let i = 0; i < e.length; i++)t1 = (t1 << 5) - t1 + e.charCodeAt(i) | 0;
                    return t1;
                }(d) : _;
                const p = e.en(u), f = e.en(u + 1), m = e.en(u + 2);
                return i.footprintDebugMesh = {
                    vertexBuffer: l,
                    indexBuffer: c,
                    segments: h,
                    color: new e.ap(p, f, m, .5)
                }, i.footprintDebugMesh;
            }(t1, o);
            if (!r) return;
            const n = t1.context, a = n.gl, l = t1.getOrCreateProgram("debug"), c = r.color, h = Wi.disabled;
            n.activeTexture.set(a.TEXTURE0), t1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), l.draw(t1, a.TRIANGLES, h, Xi.disabled, Zi.alphaBlended, Ji.disabled, Rr(s, c.toPremultipliedRenderColor(null)), "$debug", r.vertexBuffer, r.indexBuffer, r.segments);
        }
        function oa(e, t1, i, o, s, r) {
            for (const n of s){
                const s = Object.assign({}, o);
                s.part = n;
                const a = {
                    type: "Unknown",
                    id: t1,
                    properties: s
                }, l = {
                    orientation: e.paint.get("model-rotation").evaluate(a, i)
                };
                r.set(n, l);
            }
        }
        function sa(e, t1, i, o, s, r) {
            for (const n of s){
                const s = Object.assign({}, o);
                s.part = n;
                const a = {
                    type: "Unknown",
                    id: t1,
                    properties: s
                }, l = {
                    color: e.paint.get("model-color").evaluate(a, i),
                    colorMix: e.paint.get("model-color-mix-intensity").evaluate(a, i),
                    opacity: e.paint.get("model-opacity").evaluate(a, i),
                    emissionStrength: e.paint.get("model-emissive-strength").evaluate(a, i)
                };
                r.set(n, l);
            }
        }
        function ra(e, t1, i, o, s) {
            let r = !1;
            for (const i of o)1 !== i.modelOpacity && (Jn(i, e, t1, s[i.modelIndex], Xi.disabled, Zi.disabled), r = !0);
            for (const i of o)Jn(i, e, t1, s[i.modelIndex], 1 !== i.modelOpacity ? e.stencilModeFor3D() : Xi.disabled, e.colorModeForRenderPass());
            r && e.resetStencilClippingMasks();
            const n = Zi.additive;
            for (const o of i)Jn(o, e, t1, s[o.modelIndex], Xi.disabled, o.isLightMesh ? n : e.colorModeForRenderPass());
        }
        function na(t1, i, o) {
            const s = i.updateZoomBasedPaintProperties(), r = function(t1, i, o) {
                let s, r, n, a = t1.terrain ? t1.terrain.exaggeration() : 0;
                if (t1.terrain && a > 0) {
                    const i = t1.terrain, r = i.findDEMTileFor(o);
                    r && r.dem ? s = e.eI.create(i, o, r) : a = 0;
                }
                if (0 === a && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), a === i.validForExaggeration && (0 === a || s && s._demTile && s._demTile.tileID === i.validForDEMTile.id && s._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
                for(const e in i.instancesPerModel){
                    const t1 = i.instancesPerModel[e];
                    for(let e = 0; e < t1.instancedDataArray.length; ++e){
                        const o = (s ? a * s.getElevationAt(0 | t1.instancedDataArray.float32[16 * e], 0 | t1.instancedDataArray.float32[16 * e + 1], !0, !0) : 0) + t1.instancesEvaluatedElevation[e];
                        t1.instancedDataArray.float32[16 * e + 6] = o, r = r ? Math.min(i.terrainElevationMin, o) : o, n = n ? Math.max(i.terrainElevationMax, o) : o;
                    }
                }
                return i.terrainElevationMin = r || 0, i.terrainElevationMax = n || 0, i.validForExaggeration = a, i.validForDEMTile = s && s._demTile ? {
                    id: s._demTile.tileID,
                    timestamp: s._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(t1, i, o);
            (s || r) && (i.uploaded = !1, i.upload(t1.context));
        }
        const aa = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new e.da([
                0,
                0,
                0
            ], [
                e.am,
                e.am,
                0
            ])
        };
        function la(t1, i) {
            const o = 1 << t1.canonical.z, s = i.getFreeCameraOptions().position, r = i.elevation, n = t1.canonical.x / o, a = (t1.canonical.x + 1) / o, l = t1.canonical.y / o, c = (t1.canonical.y + 1) / o;
            let h = i._centerAltitude;
            if (r) {
                const e = r.getMinMaxForTile(t1);
                e && e.max > h && (h = e.max);
            }
            const d = e.aB(s.x, n, a) - s.x, u = e.aB(s.y, l, c) - s.y, _ = e.cg(h, i.center.lat) - s.z;
            return i._zoomFromMercatorZ(Math.sqrt(d * d + u * u + _ * _));
        }
        function ca(e, t1, i, o, s, r, n) {
            const a = e.context, l = "shadow" === e.renderPass, c = e.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Wi(a.gl.LEQUAL, Wi.ReadWrite, e.depthRangeFor3D), d = e.isTileAffectedByFog(r), u = "globe" === e.transform.projection.name;
            if (i.meshes) for (const _ of i.meshes){
                const p = u ? [] : [
                    "MODEL_POSITION_ON_GPU"
                ], f = [];
                let m, g, v;
                const y = !u && o.instancedDataArray.length > 20;
                y && p.push("INSTANCED_ARRAYS");
                const x = lo(e, t1.paint.get("model-cutoff-fade-range"));
                if (x.shouldRenderCutoff && p.push("RENDER_CUTOFF"), l && c) m = e.getOrCreateProgram("modelDepth", {
                    defines: p
                }), g = Zr(n.shadowTileMatrix, n.shadowTileMatrix, Float32Array.from(i.globalMatrix)), v = c.getShadowPassColorMode();
                else {
                    Yn(p, f, _, e, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), m = e.getOrCreateProgram("model", {
                        defines: p,
                        overrideFog: d
                    });
                    const o = _.material, l = o.pbrMetallicRoughness, h = t1.paint.get("model-opacity").constantOr(1), u = t1.paint.get("model-emissive-strength").constantOr(0);
                    g = qr(r.expandedProjMatrix, Float32Array.from(i.globalMatrix), new Float32Array(16), null, e, h, l.baseColorFactor, o.emissiveFactor, l.metallicFactor, l.roughnessFactor, o, u, t1, s), c && (n.shadowUniformsInitialized ? m.setShadowUniformValues(a, c.getShadowUniformValues()) : (c.setupShadows(r.toUnwrapped(), m, "model-tile"), n.shadowUniformsInitialized = !0)), v = x.shouldRenderCutoff || h < 1 || "OPAQUE" !== o.alphaMode ? Zi.alphaBlended : Zi.unblended;
                }
                e.uploadCommonUniforms(a, m, r.toUnwrapped(), null, x);
                const b = _.material.doubleSided ? Ji.disabled : Ji.backCCW;
                if (y) f.push(o.instancedDataBuffer), m.draw(e, a.gl.TRIANGLES, h, Xi.disabled, v, b, g, t1.id, _.vertexBuffer, _.indexBuffer, _.segments, t1.paint, e.transform.zoom, void 0, f, o.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let s = 0; s < o.instancedDataArray.length; ++s)g[i] = new Float32Array(o.instancedDataArray.arrayBuffer, 64 * s, 16), m.draw(e, a.gl.TRIANGLES, h, Xi.disabled, v, b, g, t1.id, _.vertexBuffer, _.indexBuffer, _.segments, t1.paint, e.transform.zoom, void 0, f);
                }
            }
            if (i.children) for (const a of i.children)ca(e, t1, a, o, s, r, n);
        }
        const ha = [
            1,
            -1,
            1
        ];
        function da(t1, i, o, s) {
            if (!o.modelManager) return !0;
            const r = o.modelManager;
            if (!o.shadowRenderer) return !0;
            const n = o.shadowRenderer, a = i.aabb;
            let l = !0, c = t1.maxHeight;
            if (0 === c) {
                let e = 0;
                for(const i in t1.instancesPerModel){
                    const t1 = r.getModel(i, s);
                    t1 ? e = Math.max(e, Math.max(Math.max(t1.aabb.max[0], t1.aabb.max[1]), t1.aabb.max[2])) : l = !1;
                }
                c = t1.maxScale * e * 1.41 + t1.maxVerticalOffset, l && (t1.maxHeight = c);
            }
            a.max[2] = c, a.min[2] += t1.terrainElevationMin, a.max[2] += t1.terrainElevationMax, e.ag(a.min, a.min, i.tileMatrix), e.ag(a.max, a.max, i.tileMatrix);
            const h = a.intersects(n.getCurrentCascadeFrustum());
            return 0 === o.currentShadowCascade && (t1.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
        }
        function ua(t1, i) {
            const o = t1.uniformValues.u_cutoff_params[0], s = t1.uniformValues.u_cutoff_params[1], r = t1.uniformValues.u_cutoff_params[2], n = t1.uniformValues.u_cutoff_params[3];
            return s === o || n === r ? 1 : e.aB(((i - o) / (s - o) - r) / (n - r), 0, 1);
        }
        function _a(t1, i, o, s) {
            if (i.pitch < 20) return 1;
            const r = i.getWorldToCameraMatrix();
            e.aC(r, r, t1);
            const n = e.bV(o.min[0], o.min[1], o.min[2], 1);
            let a = e.aD(e.eJ(), n, r), l = a, c = a;
            n[1] = o.max[1], a = e.aD(e.eJ(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, n[0] = o.max[0], a = e.aD(e.eJ(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, n[1] = o.min[1], a = e.aD(e.eJ(), n, r), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c;
            const h = e.aB(s[0], 0, 1), d = 100 * i.pixelsPerMeter * e.aB(s[1], 0, 1), u = e.aB(s[2], 0, 1), _ = e.eK(e.eJ(), l, c, h), p = Math.tan(.5 * i.fovX), f = -_[2] * p;
            if (0 === d) return _[1] < -Math.abs(f) ? u : 1;
            const m = (-Math.abs(f) - _[1]) / d, g = (e, t1, i)=>(1 - i) * e + i * t1, v = e.aB(g(1, u, m), u, 1);
            return g(1, v, e.aB((i.pitch - 20) / 20, 0, 1));
        }
        class pa {
        }
        class fa {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, o) {
                {
                    const e = this._storage.get(i.id);
                    if (e) return e.lastUsedFrameIdx = t1, e.buf;
                }
                const s = o.gl, r = s.getBufferParameter(s.ELEMENT_ARRAY_BUFFER, s.BUFFER_SIZE), n = new ArrayBuffer(r), a = new Int16Array(n);
                s.getBufferSubData(s.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n));
                const l = new e.eM;
                for(let e = 0; e < r / 2; e += 3){
                    const t1 = a[e], i = a[e + 1], o = a[e + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, o), l.emplaceBack(o, t1);
                }
                const c = o.bindVertexArrayOES.current, h = new pa;
                return h.buf = new $r(o, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
            }
            update(e) {
                for (const [t1, i] of this._storage)e - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e);
            }
        }
        class ma {
            constructor(){
                this.occluderSize = 30, this.depthOffset = -0.0001;
            }
        }
        const ga = e.ek([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]);
        class va {
            constructor(e){
                this.revealStart = 11, this.revealRange = 2;
            }
        }
        const ya = e.ek([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class xa {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const o = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e.eN, o = new e.b1;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), o.emplaceBack(0, 1, 2), o.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, ya.members), this.vignetteIdx = t1.context.createIndexBuffer(o);
                }
                const s = e.bh.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, o);
                    const e = {
                        u_vignetteShape: (r = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: r.vignetteColor
                    };
                    o.draw(t1, t1.context.gl.TRIANGLES, Wi.disabled, Xi.disabled, Zi.alphaBlended, Ji.disabled, e, "vignette", this.vignetteVx, this.vignetteIdx, s);
                }
                var r;
            }
        }
        class ba {
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t1, i) {
                const o = t1.getFreeCameraOptions().position, s = o.toAltitude(), r = o.toLngLat(), n = e.ao(r.lng), a = e.ao(r.lat), l = t1.pixelsPerMeter / i, c = n * e.eP, h = e.eP * Math.log(Math.tan(Math.PI / 4 + a / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e = -this._offsetYPrev + h, t1 = -this._elevationPrev + s;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = s;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
        }
        function wa(e, t1) {
            return [
                -(e[0] - Math.floor(e[0] / t1) * t1),
                -(e[1] - Math.floor(e[1] / t1) * t1),
                -(e[2] - Math.floor(e[2] / t1) * t1)
            ];
        }
        function Ta(t1) {
            const i = e.ex(1323123451230), o = [];
            for(let s = 0; s < t1; ++s){
                const t1 = 2 * i() - 1, s = 2 * i() - 1, r = 2 * i() - 1;
                o.push(e.d6(t1, s, r));
            }
            return o;
        }
        function Ea(t1, i, o, s, r) {
            const n = e.aB((r - o) / (s - o), 0, 1);
            return (1 - n) * t1 + n * i;
        }
        class Sa {
            constructor(e){
                this._movement = new ba, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new xa, this._ppmScaleFactor = e;
            }
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const o = t1.transform;
                this._movement.update(o, this._ppmScaleFactor);
                const s = o.starsProjMatrix, r = e.c8([]);
                e.ca(r, r, e.ao(90) - o._pitch), e.c9(r, r, -o.angle);
                const n = e.cd(new Float32Array(16), r), a = e.eO(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), l = e.ei([], a), c = e.aC([], l, n), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: s,
                    modelviewMatrix: c
                };
            }
        }
        class Ia extends Sa {
            constructor(e){
                super(4.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .5,
                    timeFactor: 1,
                    velocityConeAperture: 0,
                    velocity: 300,
                    boxSize: 2500,
                    dropletSizeX: 1,
                    dropletSizeYScale: 10,
                    distortionStrength: 70,
                    screenThinning: {
                        intensity: .57,
                        start: .46,
                        range: 1.17,
                        fadePower: .17,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: .66,
                        g: .68,
                        b: .74,
                        a: .7
                    },
                    direction: {
                        x: -50,
                        y: -35
                    },
                    shapeDirPower: 2,
                    shapeNormalPower: 1
                }, this._revealParams = new va("Precipitation > Rain"), this._vignetteParams = {
                    strength: 1,
                    start: .7,
                    range: 1,
                    fadePower: .4,
                    color: {
                        r: .27,
                        g: .27,
                        b: .27,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = Ta(this.particlesCount), o = new e.eQ, s = new e.b1;
                    let r = 0;
                    const n = e.ex(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], a = [
                            2 * n() - 1,
                            n(),
                            n(),
                            n()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...a), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...a), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, ga.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.rain) return;
                const i = this._params.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, o = t1.transform.zoom;
                if (i.revealStart > o) return;
                const s = Ea(0, 1, i.revealStart, i.revealStart + i.revealRange, o);
                if (!this.particlesVx || !this.particlesIdx) return;
                const r = structuredClone(this._params);
                let n = [
                    -r.direction.x,
                    r.direction.y,
                    -100
                ];
                e.ax(n, n);
                const a = structuredClone(this._vignetteParams);
                a.strength *= s, r.overrideStyleParameters || (r.intensity = t1.style.rain.state.density, r.timeFactor = t1.style.rain.state.intensity, r.color = structuredClone(t1.style.rain.state.color), n = structuredClone(t1.style.rain.state.direction), r.screenThinning.intensity = t1.style.rain.state.centerThinning, r.dropletSizeX = t1.style.rain.state.dropletSize[0], r.dropletSizeYScale = t1.style.rain.state.dropletSize[1] / t1.style.rain.state.dropletSize[0], r.distortionStrength = 100 * t1.style.rain.state.distortionStrength, a.strength = 1, a.color = structuredClone(t1.style.rain.state.vignetteColor));
                const l = this.updateOnRender(t1, r.timeFactor), c = t1.context, h = c.gl, d = t1.transform;
                this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e.T(c, {
                    width: t1.width,
                    height: t1.height,
                    data: null
                }, h.RGBA8)), r.distortionStrength > 0 && (c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), h.copyTexSubImage2D(h.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                const u = t1.getOrCreateProgram("rainParticle");
                t1.uploadCommonUniforms(c, u), c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE);
                const _ = [
                    r.color.r,
                    r.color.g,
                    r.color.b,
                    r.color.a
                ], p = (i, o)=>{
                    const s = wa(this._movement.getPosition(), i), a = r.dropletSizeX, c = r.dropletSizeX * r.dropletSizeYScale, p = t1.width / 2, f = t1.height / 2, m = Ea(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), g = Ea(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), v = Ea(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), y = (x = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: s,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        boxSize: i,
                        rainDropletSize: [
                            a,
                            c
                        ],
                        distortionStrength: r.distortionStrength,
                        rainDirection: n,
                        color: _,
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            p,
                            f
                        ],
                        thinningShape: [
                            m,
                            g,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: v,
                        shapeDirectionalPower: r.shapeDirPower,
                        shapeNormalPower: r.shapeNormalPower,
                        mode: o ? 0 : 1
                    }, {
                        u_modelview: Float32Array.from(x.modelview),
                        u_projection: Float32Array.from(x.projection),
                        u_time: x.time,
                        u_cam_pos: x.camPos,
                        u_texScreen: 0,
                        u_velocityConeAperture: x.velocityConeAperture,
                        u_velocity: x.velocity,
                        u_boxSize: x.boxSize,
                        u_rainDropletSize: x.rainDropletSize,
                        u_distortionStrength: x.distortionStrength,
                        u_rainDirection: x.rainDirection,
                        u_color: x.color,
                        u_screenSize: x.screenSize,
                        u_thinningCenterPos: x.thinningCenterPos,
                        u_thinningShape: x.thinningShape,
                        u_thinningAffectedRatio: x.thinningAffectedRatio,
                        u_thinningParticleOffset: x.thinningParticleOffset,
                        u_shapeDirectionalPower: x.shapeDirectionalPower,
                        u_shapeNormalPower: x.shapeNormalPower,
                        u_mode: x.mode
                    });
                    var x;
                    const b = Math.round(r.intensity * this.particlesCount), w = e.bh.simpleSegment(0, 0, 4 * b, 2 * b);
                    u.draw(t1, h.TRIANGLES, Wi.disabled, Xi.disabled, Zi.alphaBlended, Ji.disabled, y, "rain_particles", this.particlesVx, this.particlesIdx, w);
                };
                r.distortionStrength > 0 && p(r.boxSize, !0), p(r.boxSize, !1), this._vignette.draw(t1, a);
            }
        }
        const Ca = e.ek([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]);
        class Ra extends Sa {
            constructor(e){
                super(2.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .85,
                    timeFactor: .75,
                    velocityConeAperture: 70,
                    velocity: 40,
                    horizontalOscillationRadius: 4,
                    horizontalOscillationRate: 1.5,
                    boxSize: 2e3,
                    billboardSize: 2,
                    shapeFadeStart: .27,
                    shapeFadePower: .21,
                    screenThinning: {
                        intensity: .4,
                        start: .15,
                        range: 1.4,
                        fadePower: .24,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    },
                    direction: {
                        x: -50,
                        y: -35
                    }
                }, this._revealParams = new va("Precipitation > Snow"), this._vignetteParams = {
                    strength: .3,
                    start: .78,
                    range: .46,
                    fadePower: .2,
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = Ta(this.particlesCount), o = new e.eR, s = new e.b1;
                    let r = 0;
                    const n = e.ex(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], a = n(), l = n(), c = n(), h = [
                            e / t1.length,
                            a,
                            l,
                            c
                        ], d = [
                            n(),
                            n()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...d), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, Ca.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.snow) return;
                const i = structuredClone(this._params);
                let o = [
                    -i.direction.x,
                    i.direction.y,
                    -100
                ];
                e.ax(o, o);
                const s = structuredClone(this._vignetteParams), r = i.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, n = t1.transform.zoom;
                if (r.revealStart > n) return;
                const a = Ea(0, 1, r.revealStart, r.revealStart + r.revealRange, n);
                s.strength *= a, i.overrideStyleParameters || (i.intensity = t1.style.snow.state.density, i.timeFactor = t1.style.snow.state.intensity, i.color = structuredClone(t1.style.snow.state.color), o = structuredClone(t1.style.snow.state.direction), i.screenThinning.intensity = t1.style.snow.state.centerThinning, i.billboardSize = 2.79 * t1.style.snow.state.flakeSize, s.strength = 1, s.color = structuredClone(t1.style.snow.state.vignetteColor));
                const l = this.updateOnRender(t1, i.timeFactor);
                if (!this.particlesVx || !this.particlesIdx) return;
                const c = t1.context, h = c.gl, d = t1.transform, u = t1.getOrCreateProgram("snowParticle");
                t1.uploadCommonUniforms(c, u), ((i, s, r)=>{
                    const n = wa(this._movement.getPosition(), i), a = d.width / 2, c = d.height / 2, _ = Ea(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), p = Ea(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), f = Ea(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), m = (g = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: n,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        horizontalOscillationRadius: r.horizontalOscillationRadius,
                        horizontalOscillationRate: r.horizontalOscillationRate,
                        boxSize: i,
                        billboardSize: 1 * r.billboardSize,
                        simpleShapeParameters: [
                            r.shapeFadeStart,
                            r.shapeFadePower
                        ],
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            a,
                            c
                        ],
                        thinningShape: [
                            _,
                            p,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: f,
                        color: [
                            r.color.r,
                            r.color.g,
                            r.color.b,
                            r.color.a
                        ],
                        direction: o
                    }, {
                        u_modelview: Float32Array.from(g.modelview),
                        u_projection: Float32Array.from(g.projection),
                        u_time: g.time,
                        u_cam_pos: g.camPos,
                        u_velocityConeAperture: g.velocityConeAperture,
                        u_velocity: g.velocity,
                        u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                        u_horizontalOscillationRate: g.horizontalOscillationRate,
                        u_boxSize: g.boxSize,
                        u_billboardSize: g.billboardSize,
                        u_simpleShapeParameters: g.simpleShapeParameters,
                        u_screenSize: g.screenSize,
                        u_thinningCenterPos: g.thinningCenterPos,
                        u_thinningShape: g.thinningShape,
                        u_thinningAffectedRatio: g.thinningAffectedRatio,
                        u_thinningParticleOffset: g.thinningParticleOffset,
                        u_particleColor: g.color,
                        u_direction: g.direction
                    });
                    var g;
                    const v = Math.round(r.intensity * this.particlesCount), y = e.bh.simpleSegment(0, 0, 4 * v, 2 * v);
                    this.particlesVx && this.particlesIdx && u.draw(t1, h.TRIANGLES, Wi.disabled, Xi.disabled, Zi.alphaBlended, Ji.disabled, m, "snow_particles", this.particlesVx, this.particlesIdx, y);
                })(i.boxSize, 0, i), this._vignette.draw(t1, s);
            }
        }
        const Aa = {
            symbol: function(t1, i, o, s, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = Xi.disabled, a = t1.colorModeForRenderPass(), l = o.layout.get("text-variable-anchor"), c = o.layout.get("text-size-scale-range"), h = e.aB(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, o, s, r, n, a, l) {
                    const c = i.transform, h = "map" === r, d = "map" === n;
                    for (const i of t1){
                        const t1 = s.getTile(i), r = t1.getBucket(o);
                        if (!r || !r.text || !r.text.segments.get().length) continue;
                        const n = e.bL(r.textSizeData, c.zoom, l), u = Jt(i, r.getProjection(), c), _ = c.calculatePixelsToTileUnitsMatrix(t1), p = ii(u, t1.tileID.canonical, d, h, c, r.getProjection(), _), f = r.hasIconTextFit() && r.hasIconData();
                        n && rn(r, h, d, a, c, p, i, Math.pow(2, c.zoom - t1.tileID.overscaledZ), n, f);
                    }
                }(s, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), r, h);
                const d = 0 !== o.paint.get("icon-opacity").constantOr(1), u = 0 !== o.paint.get("text-opacity").constantOr(1);
                void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (d || u) ? nn(t1, i, o, s, n, a) : (d && nn(t1, i, o, s, n, a, {
                    onlyIcons: !0
                }), u && nn(t1, i, o, s, n, a, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && (en(t1, i, o, s, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), en(t1, i, o, s, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("circle-opacity"), n = o.paint.get("circle-stroke-width"), a = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1), c = o.paint.get("circle-emissive-strength");
                if (0 === r.constantOr(1) && (0 === n.constantOr(1) || 0 === a.constantOr(1))) return;
                const h = t1.context, d = h.gl, u = t1.transform, _ = !(!t1.terrain || !t1.terrain.enabled), p = o.layout.get("circle-elevation-reference"), f = t1.depthModeForSublayer(0, Wi.ReadOnly), m = new Wi(t1.context.gl.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D), g = "none" === p || _ ? f : m, v = Xi.disabled, y = t1.colorModeForDrapableLayerRenderPass(c), x = "globe" === u.projection.name, b = [
                    e.aG(u.center.lng),
                    e.aK(u.center.lat)
                ], w = [];
                for(let r = 0; r < s.length; r++){
                    const n = s[r], a = i.getTile(n), c = a.getBucket(o);
                    if (!c || c.projection.name !== u.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), d = c.layoutVertexBuffer, _ = c.globeExtVertexBuffer, p = c.indexBuffer, f = e.e2(o), m = [
                        _
                    ], g = t1.isTileAffectedByFog(n);
                    x && f.push("PROJECTION_GLOBE_VIEW"), f.push("DEPTH_D24"), t1.terrain && u.depthOcclusionForSymbolsAndCircles && f.push("DEPTH_OCCLUSION"), c.hasElevation && !t1.terrain && (f.push("ELEVATED_ROADS"), m.push(c.elevatedLayoutVertexBuffer));
                    const v = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: f,
                        overrideFog: g
                    }), y = u.projection.createInversionMatrix(u, n.canonical), T = {
                        programConfiguration: h,
                        program: v,
                        layoutVertexBuffer: d,
                        dynamicBuffers: m,
                        indexBuffer: p,
                        uniformValues: e.e3(t1, n, a, y, b, o),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)w.push({
                            segments: new e.bh([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: T
                        });
                    } else w.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: T
                    });
                }
                l && w.sort((e, t1)=>e.sortKey - t1.sortKey);
                const T = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const e of w){
                    const { programConfiguration: i, program: s, layoutVertexBuffer: r, dynamicBuffers: n, indexBuffer: a, uniformValues: l, tile: c } = e.state, _ = e.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(c, s, T), t1.uploadCommonUniforms(h, s, c.tileID.toUnwrapped()), s.draw(t1, d.TRIANGLES, g, v, y, Ji.disabled, l, o.id, r, a, _, o.paint, u.zoom, i, n);
                }
            },
            heatmap: function(t1, i, o, s) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const r = t1.context, n = r.gl, a = Xi.disabled, l = new Zi([
                            n.ONE,
                            n.ONE,
                            n.ONE,
                            n.ONE
                        ], e.ap.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e, t1, i, o) {
                            const s = e.gl, r = t1.width * o, n = t1.height * o;
                            e.activeTexture.set(s.TEXTURE1), e.viewport.set([
                                0,
                                0,
                                r,
                                n
                            ]);
                            let a = i.heatmapFbo;
                            if (!a || a && (a.width !== r || a.height !== n)) {
                                a && a.destroy();
                                const t1 = s.createTexture();
                                s.bindTexture(s.TEXTURE_2D, t1), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), a = i.heatmapFbo = e.createFramebuffer(r, n, 1, null), function(e, t1, i, o, s, r) {
                                    const n = e.gl;
                                    n.texImage2D(n.TEXTURE_2D, 0, e.extRenderToTextureHalfFloat ? n.RGBA16F : n.RGBA, s, r, 0, n.RGBA, e.extRenderToTextureHalfFloat ? n.HALF_FLOAT : n.UNSIGNED_BYTE, null), o.colorAttachment0.set(i);
                                }(e, 0, t1, a, r, n);
                            } else s.bindTexture(s.TEXTURE_2D, a.colorAttachment0.get()), e.bindFramebuffer.set(a.framebuffer);
                        }(r, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), r.clear({
                            color: e.ap.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, d = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], u = h ? Ji.frontCCW : Ji.disabled, _ = [
                            e.aG(c.center.lng),
                            e.aK(c.center.lat)
                        ];
                        for(let e = 0; e < s.length; e++){
                            const p = s[e];
                            if (i.hasRenderableParent(p)) continue;
                            const f = i.getTile(p), m = f.getBucket(o);
                            if (!m || m.projection.name !== c.projection.name) continue;
                            const g = t1.isTileAffectedByFog(p), v = m.programConfigurations.get(o.id), y = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: d,
                                overrideFog: g
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, y), t1.uploadCommonUniforms(r, y, p.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, p.canonical);
                            y.draw(t1, n.TRIANGLES, Wi.disabled, a, l, u, Dr(t1, p, f, b, _, x, o.paint.get("heatmap-intensity")), o.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, o.paint, t1.transform.zoom, v, h ? [
                                m.globeExtVertexBuffer
                            ] : null);
                        }
                        r.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, s = o.gl, r = i.heatmapFbo;
                        if (!r) return;
                        o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, r.colorAttachment0.get()), o.activeTexture.set(s.TEXTURE1);
                        let n = i.colorRampTexture;
                        n || (n = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), n.bind(s.LINEAR, s.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, s.TRIANGLES, Wi.disabled, Xi.disabled, t1.colorModeForRenderPass(), Ji.disabled, ((e, t1)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("line-opacity"), n = o.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === n.constantOr(1)) return;
                const a = o.paint.get("line-emissive-strength").isConstant(), l = o.paint.get("line-emissive-strength").constantOr(0), c = o.paint.get("line-occlusion-opacity"), h = o.layout.get("line-elevation-reference"), d = "meters" === o.layout.get("line-width-unit"), u = "sea" === h, _ = !(!t1.terrain || !t1.terrain.enabled), p = t1.context, f = p.gl;
                if (o.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
                const m = o.layout.get("line-cross-slope"), g = void 0 !== m, v = m < 1, y = t1.colorModeForDrapableLayerRenderPass(a ? l : null), x = t1.terrain && t1.terrain.renderingToTexture, b = x ? 1 : e.o.devicePixelRatio, w = o.paint.get("line-dasharray"), T = w.constantOr(1), E = o.layout.get("line-cap"), S = w.constantOr(null), I = E.constantOr(null), C = o.paint.get("line-pattern"), R = C.constantOr(1), A = o.paint.get("line-pattern-cross-fade"), D = C.constantOr(null), L = o.paint.get("line-opacity").constantOr(1);
                let P = !R && 1 !== L || t1.depthOcclusion && c > 0 && c < 1;
                const O = o.paint.get("line-gradient"), z = R ? "linePattern" : "line", M = e.e4(o);
                let F;
                if (x && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (P = !1), 0 !== c && t1.depthOcclusion) {
                    const t1 = o.paint._values["line-opacity"];
                    t1 && t1.value && "constant" === t1.value.kind ? F = t1.value : e.w(`Occlusion opacity for layer ${o.id} is supported only when line-opacity isn't data-driven.`);
                }
                "constant" !== n.value.kind && !1 === n.value.isLineProgressConstant && M.push("VARIABLE_LINE_WIDTH"), x && ("dual-source-blending" !== t1.emissiveMode || a ? "mrt-fallback" === t1.emissiveMode && M.push("USE_MRT1") : M.push("DUAL_SOURCE_BLENDING"));
                const k = {}, B = (s, r, n, a, l, h)=>{
                    for (const u of s){
                        const s = i.getTile(u);
                        if (R && !s.patternsLoaded()) continue;
                        const _ = s.getBucket(o);
                        if (!_) continue;
                        if ("none" !== _.elevationType && !l || "none" === _.elevationType && l) continue;
                        t1.prepareDrawTile();
                        const m = [
                            ...r
                        ], g = t1.shadowRenderer, v = "road" === _.elevationType && !!g && g.enabled;
                        let w = [
                            0,
                            0,
                            0
                        ];
                        if (v) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (w = mo(t1.style, e, i)), m.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                        }
                        const E = _.programConfigurations.get(o.id);
                        let C = !1;
                        if (D && s.imageAtlas) {
                            const t1 = e.e5.from(D), i = t1.getPrimary().scaleSelf(b).toString(), o = s.imageAtlas.patternPositions.get(i), r = t1.getSecondary(), n = r ? s.imageAtlas.patternPositions.get(r.scaleSelf(b).toString()) : null;
                            C = !!o && !!n, o && E.setConstantPatternPositions(o, n);
                        }
                        A > 0 && (C || E.getPatternTransitionVertexBuffer("line-pattern")) && m.push("LINE_PATTERN_TRANSITION"), _.elevationGroundScaleVertexBuffer && m.push("ELEVATION_GROUND_SCALE");
                        const M = t1.isTileAffectedByFog(u), B = t1.getOrCreateProgram(z, {
                            config: E,
                            defines: m,
                            overrideFog: M
                        });
                        if (!R && S && I && s.lineAtlas) {
                            const e = s.lineAtlas.getDash(S, I);
                            e && E.setConstantPatternPositions(e);
                        }
                        v && g.setupShadows(s.tileID.toUnwrapped(), B, "vector-tile");
                        let [N, U] = o.paint.get("line-trim-offset");
                        if ("round" === I || "square" === I) {
                            const e = 1;
                            N !== U && (0 === N && (N -= e), 1 === U && (U += e));
                        }
                        const j = x ? u.projMatrix : null, V = d ? 1 / _.tileToMeter / e.az(s, 1, t1.transform.zoom) : 1, G = d ? 1 / _.tileToMeter / e.az(s, 1, Math.floor(t1.transform.zoom)) : 1, H = T ? o.paint._values["line-floorwidth"] : null;
                        let q;
                        if (H && "constant" === H.value.kind) {
                            const e = _.zoom;
                            e in k || (k[e] = Math.max(.01, o.widthExpression().evaluate({
                                zoom: e
                            }))), q = H.value.value;
                            const i = Math.floor(t1.transform.zoom);
                            H.value.value = k[e] * Math.pow(2, i - s.tileID.overscaledZ);
                        }
                        const Z = R ? e.e6(t1, s, o, j, b, V, G, [
                            N,
                            U
                        ], w, A) : e.e7(t1, s, o, j, _.lineClipsArray.length, b, V, G, [
                            N,
                            U
                        ], w);
                        if (O) {
                            const s = _.gradients[o.id];
                            let r = s.texture;
                            if (o.gradientVersion !== s.version) {
                                let n = 256;
                                if (o.stepInterpolant) {
                                    const o = i.getSource().maxzoom, s = u.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - u.canonical.z) : 1;
                                    n = e.aB(e.e8(_.maxLineLength / e.am * 1024 * s), 256, p.maxTextureSize);
                                }
                                s.gradient = e.e9({
                                    expression: o.gradientExpression(),
                                    evaluationKey: "lineProgress",
                                    resolution: n,
                                    image: s.gradient || void 0,
                                    clips: _.lineClipsArray
                                }), s.texture ? s.texture.update(s.gradient) : s.texture = new e.T(p, s.gradient, f.RGBA8), s.version = o.gradientVersion, r = s.texture;
                            }
                            p.activeTexture.set(f.TEXTURE1), r.bind(o.stepInterpolant ? f.NEAREST : f.LINEAR, f.CLAMP_TO_EDGE);
                        }
                        T && (p.activeTexture.set(f.TEXTURE0), s.lineAtlasTexture && s.lineAtlasTexture.bind(f.LINEAR, f.REPEAT), E.updatePaintBuffers()), R && (p.activeTexture.set(f.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(f.LINEAR, f.CLAMP_TO_EDGE), E.updatePaintBuffers()), l && t1.terrain.setupElevationDraw(s, B), t1.uploadCommonUniforms(p, B, u.toUnwrapped());
                        const W = (e)=>{
                            null != F && (F.value = L * c), B.draw(t1, f.TRIANGLES, n, e, y, Ji.disabled, Z, o.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, o.paint, t1.transform.zoom, E, [
                                _.layoutVertexBuffer2,
                                _.patternVertexBuffer,
                                _.zOffsetVertexBuffer,
                                _.elevationGroundScaleVertexBuffer
                            ]), null != F && (F.value = L);
                        };
                        if (P && !l) {
                            const e = t1.stencilModeForClipping(u).ref;
                            0 === e && x && p.clear({
                                stencil: 0
                            });
                            const i = {
                                func: f.EQUAL,
                                mask: 255
                            };
                            Z.u_alpha_discard_threshold = .8, W(new Xi(i, e, 255, f.KEEP, f.KEEP, f.INVERT)), Z.u_alpha_discard_threshold = 0, W(new Xi(i, e, 255, f.KEEP, f.KEEP, f.KEEP));
                        } else Z.u_alpha_discard_threshold = P && l && h ? .8 : 0, W(l ? a : t1.stencilModeForClipping(u));
                        void 0 !== q && (H.value.value = q);
                    }
                };
                let N = t1.depthModeForSublayer(0, Wi.ReadOnly);
                const U = new Wi(t1.depthOcclusion ? f.GREATER : f.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D);
                if (o.hasNonElevatedBuckets) {
                    const i = !x && t1.terrain;
                    0 !== c && i ? e.w(`Occlusion opacity for layer ${o.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${o.id}.`) : B(s, M, N, Xi.disabled, !1, !0);
                }
                if (o.hasElevatedBuckets) {
                    "hd-road-markup" === h ? _ || (N = U, M.push("ELEVATED_ROADS")) : (M.push("ELEVATED"), N = U, g && M.push(v ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), u && M.push("ELEVATION_REFERENCE_SEA"));
                    const e = P ? t1.stencilModeFor3D() : Xi.disabled;
                    t1.forceTerrainMode = !0, B(s, M, N, e, !0, !0), P && B(s, M, N, e, !0, !1), t1.forceTerrainMode = !1;
                }
                P && (t1.resetStencilClippingMasks(), x && p.clear({
                    stencil: 0
                })), 0 === c || t1.depthOcclusion || x || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
            },
            fill: function(t1, i, o, s) {
                const r = o.paint.get("fill-color"), n = o.paint.get("fill-opacity");
                if (0 === n.constantOr(1)) return;
                const a = o.paint.get("fill-emissive-strength"), l = t1.colorModeForDrapableLayerRenderPass(a), c = o.paint.get("fill-pattern"), h = t1.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === r.constantOr(e.ap.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                let d = "none";
                "none" !== o.layout.get("fill-elevation-reference") ? d = "road" : 0 !== o.paint.get("fill-z-offset").constantOr(1) && (d = "offset");
                const u = !(!t1.terrain || !t1.terrain.enabled), _ = {
                    painter: t1,
                    sourceCache: i,
                    layer: o,
                    coords: s,
                    colorMode: l,
                    elevationType: d,
                    terrainEnabled: u,
                    pass: h
                };
                if ("shadow" === t1.renderPass) return void (t1.shadowRenderer && "road" === d && !u && function(e) {
                    const { painter: t1, sourceCache: i, layer: o, coords: s } = e, r = t1.context.gl, n = e.painter.shadowRenderer;
                    for (const e of s){
                        const s = i.getTile(e), a = s.getBucket(o);
                        if (!a) continue;
                        const l = a.elevatedStructures;
                        if (!l) continue;
                        if (!l.shadowCasterSegments || 0 === l.shadowCasterSegments.segments[0].primitiveLength) continue;
                        t1.prepareDrawTile();
                        const c = a.bufferData.programConfigurations.get(o.id), h = t1.isTileAffectedByFog(e), d = t1.getOrCreateProgram("elevatedStructuresDepth", {
                            config: c,
                            overrideFog: h
                        }), u = n.calculateShadowPassMatrixFromTile(s.tileID.toUnwrapped());
                        t1.uploadCommonUniforms(t1.context, d, e.toUnwrapped());
                        const _ = xr(u, 0);
                        d.draw(t1, r.TRIANGLES, n.getShadowPassDepthMode(), Xi.disabled, n.getShadowPassColorMode(), Ji.disabled, _, o.id, l.vertexBuffer, l.indexBuffer, l.shadowCasterSegments, o.paint, t1.transform.zoom, c);
                    }
                }(_));
                const p = "mrt-fallback" === t1.emissiveMode;
                if ("offset" !== d) {
                    if (hn(_, !1, p), "road" === d) {
                        const e = !u && "translucent" === t1.renderPass;
                        e && cn(t1, i, o, s, "geometry"), hn(_, !0, p, Xi.disabled), e && function(e) {
                            const { painter: t1, sourceCache: i, layer: o, coords: s, colorMode: r } = e, n = t1.context.gl, a = e.painter.shadowRenderer, l = !!a && a.enabled, c = new Wi(t1.context.gl.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D);
                            let h = [
                                0,
                                0,
                                0
                            ];
                            if (l) {
                                const e = t1.style.directionalLight, i = t1.style.ambientLight;
                                e && i && (h = mo(t1.style, e, i));
                            }
                            const d = (e)=>{
                                for (const d of s){
                                    const s = i.getTile(d), u = s.getBucket(o);
                                    if (!u) continue;
                                    const _ = u.elevatedStructures;
                                    if (!_) continue;
                                    let p, f;
                                    if (e ? (p = _.renderableBridgeSegments, f = _.bridgeProgramConfigurations.get(o.id)) : (p = _.renderableTunnelSegments, f = _.tunnelProgramConfigurations.get(o.id)), !p || 0 === p.segments[0].primitiveLength) continue;
                                    f.updatePaintBuffers(), t1.prepareDrawTile();
                                    const m = t1.isTileAffectedByFog(d), g = [];
                                    l && g.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                                    const v = t1.getOrCreateProgram("elevatedStructures", {
                                        config: f,
                                        overrideFog: m,
                                        defines: g
                                    }), y = t1.translatePosMatrix(d.projMatrix, s, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                                    l && a.setupShadows(s.tileID.toUnwrapped(), v, "vector-tile");
                                    const x = br(y, h);
                                    t1.uploadCommonUniforms(t1.context, v, d.toUnwrapped()), v.draw(t1, n.TRIANGLES, c, Xi.disabled, r, Ji.backCCW, x, o.id, _.vertexBuffer, _.indexBuffer, p, o.paint, t1.transform.zoom, f, [
                                        _.vertexBufferNormal
                                    ]);
                                }
                            };
                            d(!0), d(!1);
                        }(_);
                    }
                } else hn(_, !1, p, t1.stencilModeFor3D());
            },
            "fill-extrusion": function(t1, i, o, s) {
                const r = o.paint.get("fill-extrusion-opacity"), n = t1.context, a = n.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === r) return;
                const h = "mrt-fallback" === t1.emissiveMode, d = t1.conflationActive && t1.style.isLayerClipped(o, i.getSource()), u = t1.style.order.indexOf(o.fqid);
                if (d && function(e, t1, i, o, s) {
                    for (const r of o){
                        const o = t1.getTile(r).getBucket(i);
                        o && (o.updateReplacement(r, e.replacementSource, s), o.uploadCentroid(e.context));
                    }
                }(t1, i, o, s, u), l || d) for (const e of s){
                    const s = i.getTile(e).getBucket(o);
                    s && pn(t1.context, i, e, s, o, l, d);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    const n = t1.shadowRenderer;
                    if (l && r < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.ae) return;
                    const a = n.getShadowPassDepthMode(), c = n.getShadowPassColorMode();
                    dn(t1, i, o, s, a, Xi.disabled, c, d);
                } else if ("translucent" === t1.renderPass) {
                    const u = !o.paint.get("fill-extrusion-pattern").constantOr(1), _ = o.paint.get("fill-extrusion-color").constantOr(e.ap.white);
                    if (!c && 0 !== _.a) {
                        const e = new Wi(t1.context.gl.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D);
                        1 === r && u ? dn(t1, i, o, s, e, Xi.disabled, Zi.unblended, d) : (dn(t1, i, o, s, e, Xi.disabled, Zi.disabled, d), dn(t1, i, o, s, e, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), d), t1.resetStencilClippingMasks());
                    }
                    if (t1.style.enable3dLights() && u && (!l && "globe" !== t1.transform.projection.name || c)) {
                        const r = o.paint.get("fill-extrusion-opacity"), u = o.paint.get("fill-extrusion-ambient-occlusion-intensity"), _ = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), p = o.paint.get("fill-extrusion-flood-light-intensity"), f = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), m = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(f ? null : o.lut).toArray01().slice(0, 3), g = u > 0 && _ > 0, v = p > 0, y = (e, t1, i)=>(1 - i) * e + i * t1, x = new un;
                        x.translate = o.paint.get("fill-extrusion-translate"), x.translateAnchor = o.paint.get("fill-extrusion-translate-anchor"), x.edgeRadius = o.layout.get("fill-extrusion-edge-radius"), x.cutoffFadeRange = o.paint.get("fill-extrusion-cutoff-fade-range");
                        const b = (n)=>{
                            const l = t1.depthModeForSublayer(1, Wi.ReadOnly, a.LEQUAL, !0), c = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), h = y(.1, 3, c), f = t1._showOverdrawInspector;
                            if (!f) {
                                const c = new Xi({
                                    func: a.ALWAYS,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), f = new Zi([
                                    a.ONE,
                                    a.ONE,
                                    a.ONE,
                                    a.ONE
                                ], e.ap.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], a.MIN);
                                _n(x, t1, i, o, s, l, c, f, Ji.disabled, n, "sdf", r, u, _, p, m, h, d, !1);
                            }
                            {
                                const c = f ? Xi.disabled : new Xi({
                                    func: a.EQUAL,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.DECR, a.DECR), g = f ? t1.colorModeForRenderPass() : new Zi([
                                    a.ONE_MINUS_DST_ALPHA,
                                    a.DST_ALPHA,
                                    a.ONE,
                                    a.ONE
                                ], e.ap.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                _n(x, t1, i, o, s, l, c, g, Ji.disabled, n, "color", r, u, _, p, m, h, d, !1);
                            }
                        };
                        if (c) {
                            const c = ()=>{
                                const t1 = l.drapeBufferSize[0], i = l.drapeBufferSize[1];
                                let o = l.framebufferCopyTexture;
                                return o && (!o || o.size[0] === t1 && o.size[1] === i) || (o && o.destroy(), o = l.framebufferCopyTexture = new e.T(n, new e.q({
                                    width: t1,
                                    height: i
                                }), a.RGBA8)), o.bind(a.LINEAR, a.CLAMP_TO_EDGE), a.copyTexSubImage2D(a.TEXTURE_2D, 0, 0, 0, 0, 0, t1, i), o;
                            }, f = (n, l, f)=>{
                                const g = t1.depthModeForSublayer(1, Wi.ReadOnly, a.LEQUAL, !1), v = o.paint.get(n ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), b = y(.1, 3, v);
                                {
                                    const c = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e.ap.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    _n(x, t1, i, o, s, g, Xi.disabled, c, Ji.disabled, n, "clear", r, u, _, p, m, b, d, l);
                                }
                                {
                                    const c = new Xi({
                                        func: a.ALWAYS,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), h = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e.ap.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a.MIN);
                                    _n(x, t1, i, o, s, g, c, h, Ji.disabled, n, "sdf", r, u, _, p, m, b, d, l);
                                }
                                h && !n && (f = c());
                                {
                                    const c = n ? a.ZERO : a.ONE_MINUS_DST_ALPHA, h = new Xi({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.DECR, a.DECR), f = new Zi([
                                        c,
                                        a.DST_ALPHA,
                                        a.ONE_MINUS_DST_ALPHA,
                                        a.ZERO
                                    ], e.ap.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    _n(x, t1, i, o, s, g, h, f, Ji.disabled, n, "color", r, u, _, p, m, b, d, l);
                                }
                                if (!h || n) {
                                    const c = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        n ? a.ZERO : a.ONE
                                    ], e.ap.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n ? a.FUNC_ADD : a.MAX);
                                    _n(x, t1, i, o, s, g, Xi.disabled, c, Ji.disabled, n, "clear", r, u, _, p, m, b, d, l, f);
                                } else {
                                    a.drawBuffers([
                                        a.NONE,
                                        a.COLOR_ATTACHMENT1
                                    ]);
                                    const c = new Xi({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 254, 255, a.KEEP, a.DECR, a.DECR), h = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e.ap.transparent, [
                                        !0,
                                        !1,
                                        !1,
                                        !1
                                    ], a.MAX);
                                    _n(x, t1, i, o, s, g, c, h, Ji.disabled, n, "emissive", r, u, _, p, m, b, d, l, f), a.drawBuffers([
                                        a.COLOR_ATTACHMENT0
                                    ]);
                                }
                            };
                            if (g || v) {
                                let e;
                                t1.prepareDrawTile(), h && !g || (e = c()), g && f(!0, !1, e), v && f(!1, !0, e);
                            }
                        } else g && b(!0), v && b(!1), (g || v) && t1.resetStencilClippingMasks();
                    }
                }
            },
            building: function(e, t1, i, o) {
                e.currentLayer < e.firstLightBeamLayer && (e.firstLightBeamLayer = e.currentLayer);
                const s = i.paint.get("building-ambient-occlusion-ground-intensity"), r = i.paint.get("building-ambient-occlusion-ground-radius"), n = i.paint.get("building-ambient-occlusion-ground-attenuation"), a = i.paint.get("building-opacity");
                if (a <= 0) return;
                let l = s > 0 && r > 0, c = !0;
                const h = i.paint.get("building-vertical-scale");
                if (h <= 0) return;
                e.shadowRenderer || (c = !1);
                const d = e.conflationActive && e.style.isLayerClipped(i, t1.getSource()), u = e.style.order.indexOf(i.fqid);
                if (function(e, t1, i, o, s, r) {
                    for (const n of r){
                        const r = t1.getTile(n).getBucket(i);
                        r && (s && r.updateReplacement(n, e.replacementSource, o), r.uploadUpdatedIndexBuffer(e.context));
                    }
                }(e, t1, i, u, d, o), function(e, t1, i, o) {
                    for (const s of o){
                        const o = t1.getTile(s).getBucket(i);
                        o && o.needsEvaluation() && o.uploadUpdatedColorBuffer(e.context);
                    }
                }(e, t1, i, o), i.resetLayerRenderingStats(e), e.shadowRenderer && (e.shadowRenderer.useNormalOffset = !0), "shadow" === e.renderPass && e.shadowRenderer) {
                    const s = e.shadowRenderer, r = [], n = s.getShadowPassDepthMode();
                    yn({
                        painter: e,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: r,
                        blendMode: s.getShadowPassColorMode(),
                        depthMode: n,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                } else if ("translucent" === e.renderPass) {
                    let u = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "LIGHTING_3D_MODE"
                    ];
                    c && (u = u.concat("RENDER_SHADOWS", "DEPTH_TEXTURE")), e.shadowRenderer && e.shadowRenderer.useNormalOffset && (u = u.concat("NORMAL_OFFSET"));
                    const _ = i.paint.get("building-facade-emissive-chance"), p = i.paint.get("building-ambient-occlusion-intensity"), f = i.paint.get("building-flood-light-intensity"), m = "none" === i.paint.get("building-flood-light-color-use-theme").constantOr("default"), g = i.paint.get("building-flood-light-color").toNonPremultipliedRenderColor(m ? null : i.lut).toArray01().slice(0, 3), v = i.paint.get("building-flood-light-ground-attenuation"), y = f > 0, x = new Wi(e.context.gl.LEQUAL, Wi.ReadWrite, e.depthRangeFor3D);
                    a < 1 && yn({
                        painter: e,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: u,
                        blendMode: Zi.disabled,
                        depthMode: x,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: _,
                        facadeAOIntensity: p,
                        floodLightIntensity: f,
                        floodLightColor: g,
                        depthOnly: !0
                    });
                    const b = e.colorModeForRenderPass();
                    yn({
                        painter: e,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: u,
                        blendMode: b,
                        depthMode: x,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: _,
                        facadeAOIntensity: p,
                        floodLightIntensity: f,
                        floodLightColor: g
                    }), l && xn(e, t1, i, o, !0, a, s, r, f, g, n, d), y && xn(e, t1, i, o, !1, a, s, r, f, g, v, d);
                } else if ("light-beam" === e.renderPass) {
                    const s = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "HAS_ATTRIBUTE_a_bloom_attenuation"
                    ], r = new Wi(e.context.gl.LEQUAL, Wi.ReadOnly, e.depthRangeFor3D);
                    yn({
                        painter: e,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: s,
                        blendMode: Zi.alphaBlended,
                        depthMode: r,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                }
                e.shadowRenderer && (e.shadowRenderer.useNormalOffset = !1), e.resetStencilClippingMasks();
            },
            hillshade: function(e, t1, i, o) {
                if ("offscreen" !== e.renderPass && "translucent" !== e.renderPass) return;
                if (e.style.disableElevatedTerrain) return;
                const s = e.context, r = e.terrain && e.terrain.renderingToTexture, [n, a] = "translucent" !== e.renderPass || r ? [
                    {},
                    o
                ] : e.stencilConfigForOverlap(o);
                for (const o of a){
                    const s = t1.getTile(o);
                    if (s.needsHillshadePrepare && "offscreen" === e.renderPass) ls(e, s, i);
                    else if ("translucent" === e.renderPass) {
                        const t1 = e.depthModeForSublayer(0, Wi.ReadOnly), a = i.paint.get("hillshade-emissive-strength"), l = e.colorModeForDrapableLayerRenderPass(a), c = r && e.terrain ? e.terrain.stencilModeForRTTOverlap(o) : n[o.overscaledZ];
                        ns(e, o, s, i, t1, c, l);
                    }
                }
                s.viewport.set([
                    0,
                    0,
                    e.width,
                    e.height
                ]), e.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, s, r, n) {
                if ("translucent" !== t1.renderPass) return;
                const a = o.paint.get("raster-opacity");
                if (0 === a) return;
                const l = "globe" === t1.transform.projection.name, c = 0 !== o.paint.get("raster-elevation"), h = c && l, d = t1.terrain && t1.terrain.exaggeration() > 0 && c && "ground" === o.paint.get("raster-elevation-reference"), u = !l && d;
                if (t1.renderElevatedRasterBackface && !h) return;
                const _ = t1.context, p = _.gl, f = i.getSource(), m = function(t1, i, o, s, r) {
                    const n = i.paint.get("raster-color"), a = "raster-array" === t1.type, l = [], c = i.paint.get("raster-resampling"), h = i.paint.get("raster-color-mix");
                    let d = i.paint.get("raster-color-range");
                    const u = [
                        h[0],
                        h[1],
                        h[2],
                        0
                    ], _ = h[3];
                    let p = "nearest" === c ? s.NEAREST : s.LINEAR;
                    if (a && (l.push("RASTER_ARRAY"), n || l.push("RASTER_COLOR"), "linear" === c && l.push("RASTER_ARRAY_LINEAR"), p = s.NEAREST, !d && t1.rasterLayers)) {
                        const e = t1.rasterLayers.find(({ id: e })=>e === i.sourceLayer);
                        e && e.fields && e.fields.range && (d = e.fields.range);
                    }
                    if (d = d || [
                        0,
                        1
                    ], n) {
                        l.push("RASTER_COLOR"), o.activeTexture.set(s.TEXTURE2), i.updateColorRamp(d);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), t1.bind(p, s.CLAMP_TO_EDGE);
                    }
                    return r && l.push("USE_MRT1"), {
                        mix: u,
                        range: d,
                        offset: _,
                        defines: l,
                        resampling: p
                    };
                }(f, o, _, p, t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode);
                if (f instanceof e.aV && !s.length && !l) return;
                const g = o.paint.get("raster-emissive-strength"), v = t1.colorModeForDrapableLayerRenderPass(g), y = t1.terrain && t1.terrain.renderingToTexture, x = !t1.options.moving, b = "nearest" === o.paint.get("raster-resampling") ? p.NEAREST : p.LINEAR;
                if (f instanceof e.aV && !s.length && (f.onNorthPole || f.onSouthPole)) {
                    const e = c ? t1.stencilModeFor3D() : Xi.disabled;
                    return void wn(!!f.onNorthPole, null, t1, i, o, g, m, Ji.disabled, e);
                }
                if (!s.length) return;
                const [w, T] = f instanceof e.aV || y ? [
                    {},
                    s
                ] : t1.stencilConfigForOverlap(s), E = T[T.length - 1].overscaledZ;
                h && m.defines.push("PROJECTION_GLOBE_VIEW"), c && m.defines.push("RENDER_CUTOFF", "ELEVATED"), d && m.defines.push("ELEVATION_REFERENCE_GROUND");
                const S = (s, r, T)=>{
                    for (const S of s){
                        const s = S.toUnwrapped(), I = i.getTile(S);
                        if (y && (!I || !I.hasData())) continue;
                        _.activeTexture.set(p.TEXTURE0);
                        const C = En(I, f, o, m);
                        if (!C || !C.texture) continue;
                        const { texture: R, mix: A, offset: D, tileSize: L, buffer: P } = C;
                        let O, z;
                        y ? (O = Wi.disabled, z = S.projMatrix) : c ? (O = new Wi(p.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D), z = l ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(s, x)) : (O = t1.depthModeForSublayer(S.overscaledZ - E, 1 === a ? Wi.ReadWrite : Wi.ReadOnly, p.LESS), z = t1.transform.calculateProjMatrix(s, x));
                        const M = t1.terrain && y ? t1.terrain.stencilModeForRTTOverlap(S) : w[S.overscaledZ], F = n ? 0 : o.paint.get("raster-fade-duration");
                        I.registerFadeDuration(F);
                        const k = i.findLoadedParent(S, 0), B = tr(I, k, i, t1.transform, F);
                        let N, U;
                        !B.isFading && I.refreshedUponExpiration && (I.refreshedUponExpiration = !1), t1.terrain && t1.terrain.prepareDrawTile(), _.activeTexture.set(p.TEXTURE0), R.bind(b, p.CLAMP_TO_EDGE), _.activeTexture.set(p.TEXTURE1), k ? (k.texture && k.texture.bind(b, p.CLAMP_TO_EDGE), N = Math.pow(2, k.tileID.overscaledZ - I.tileID.overscaledZ), U = [
                            I.tileID.canonical.x * N % 1,
                            I.tileID.canonical.y * N % 1
                        ]) : R.bind(b, p.CLAMP_TO_EDGE), "useMipmap" in R && _.extTextureFilterAnisotropic && t1.transform.pitch > 20 && p.texParameterf(p.TEXTURE_2D, _.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, _.extTextureFilterAnisotropicMax);
                        const j = t1.transform;
                        let V;
                        const G = c ? Tn(j) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let H, q, Z, W, $, X = 0;
                        if (h && f instanceof e.aV && f.coordinates.length > 3) H = Float32Array.from(e.bl(e.dL(new e.cE(0, 0, 0)))), q = Float32Array.from(j.globeMatrix), Z = Float32Array.from(e.dH(j)), W = [
                            e.aG(j.center.lng),
                            e.aK(j.center.lat)
                        ], V = f.elevatedGlobePerspectiveTransform, $ = f.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (h) {
                            const t1 = e.dI(S.canonical);
                            X = e.dJ(t1.getCenter().lat), H = Float32Array.from(e.bl(e.dL(S.canonical))), q = Float32Array.from(j.globeMatrix), Z = Float32Array.from(e.dH(j)), W = [
                                e.aG(j.center.lng),
                                e.aK(j.center.lat)
                            ], V = [
                                0,
                                0
                            ], $ = Float32Array.from(e.dK(S.canonical, t1, X, j.worldSize / j._pixelsPerMercatorPixel));
                        } else V = f instanceof e.aV ? f.perspectiveTransform : [
                            0,
                            0
                        ], H = new Float32Array(16), q = new Float32Array(9), Z = new Float32Array(16), W = [
                            0,
                            0
                        ], $ = new Float32Array(9);
                        const K = zr(t1, z, H, q, Z, $, U || [
                            0,
                            0
                        ], e.ak(t1.transform.zoom), W, G, N || 1, B, o, V, c ? o.paint.get("raster-elevation") : 0, 2, A, D, m.range, L, P, g), Y = t1.isTileAffectedByFog(S), J = t1.getOrCreateProgram("raster", {
                            defines: m.defines,
                            overrideFog: Y
                        });
                        if (t1.uploadCommonUniforms(_, J, s), f instanceof e.aV) {
                            const i = f.elevatedGlobeVertexBuffer, s = f.elevatedGlobeIndexBuffer;
                            if (y || !l) f.boundsBuffer && f.boundsSegments && J.draw(t1, p.TRIANGLES, O, Xi.disabled, v, Ji.disabled, K, o.id, f.boundsBuffer, t1.quadTriangleIndexBuffer, f.boundsSegments);
                            else if (i && s) {
                                const n = j.zoom <= e.c$ ? f.elevatedGlobeSegments : f.getSegmentsForLongitude(j.center.lng);
                                n && J.draw(t1, p.TRIANGLES, O, Xi.disabled, v, r, K, o.id, i, s, n);
                            }
                        } else if (h) {
                            O = new Wi(p.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D);
                            const e = t1.globeSharedBuffers;
                            if (e) {
                                d && (t1.terrain.setupElevationDraw(I, J), t1.uploadCommonUniforms(_, J, I.tileID.toUnwrapped()));
                                const [i, s, n] = e.getGridBuffers(X, !1);
                                J.draw(t1, p.TRIANGLES, O, T || M, t1.colorModeForRenderPass(), r, K, o.id, i, s, n);
                            }
                        } else if (u) O = new Wi(p.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D), t1.terrain.setupElevationDraw(I, J), t1.uploadCommonUniforms(_, J, I.tileID.toUnwrapped()), j.pitch > 20 && J.draw(t1, p.TRIANGLES, O, Xi.disabled, Zi.disabled, Ji.frontCCW, K, o.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments), J.draw(t1, p.TRIANGLES, O, M, v, Ji.backCCW, K, o.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments);
                        else {
                            const { tileBoundsBuffer: e, tileBoundsIndexBuffer: i, tileBoundsSegments: s } = t1.getTileBoundsBuffers(I);
                            J.draw(t1, p.TRIANGLES, O, M, v, Ji.disabled, K, o.id, e, i, s);
                        }
                    }
                    if (!(f instanceof e.aV) && h) for (const e of s){
                        const s = e.canonical.y === (1 << e.canonical.z) - 1;
                        0 === e.canonical.y && wn(!0, e, t1, i, o, g, m, r, T || Xi.disabled), s && wn(!1, e, t1, i, o, g, m, r === Ji.frontCW ? Ji.backCW : Ji.frontCW, T || Xi.disabled);
                    }
                };
                h ? S(T, t1.renderElevatedRasterBackface ? Ji.backCW : Ji.frontCW, t1.stencilModeFor3D()) : S(T, Ji.disabled, void 0), t1.resetStencilClippingMasks();
            },
            "raster-particle": function(t1, i, o, s, r, n) {
                "offscreen" === t1.renderPass && function(t1, i, o, s) {
                    if (!s.length) return;
                    const r = t1.context, n = r.gl, a = i.getSource();
                    if (!(a instanceof pt)) return;
                    const l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
                    let c = o.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(t1) {
                            const i = t1 * t1, o = new Uint8Array(4 * i), s = .9090909090909091;
                            for(let t1 = 0; t1 < i; t1++){
                                const i = s * (e.en(2 * t1 + 0) + Fr), r = s * (e.en(2 * t1 + 1) + Fr), n = 255 * i % 1, a = 255 * r % 1, l = n, c = r - a / 255, h = a;
                                o[4 * t1 + 0] = 255 * (i - n / 255), o[4 * t1 + 1] = 255 * l, o[4 * t1 + 2] = 255 * c, o[4 * t1 + 3] = 255 * h;
                            }
                            return o;
                        }(l);
                        c = o.particlePositionRGBAImage = new e.q({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = o.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = r.createFramebuffer(l, l, 1, null)) : h = o.particleFramebuffer = r.createFramebuffer(l, l, 1, null);
                    const d = [];
                    for (const e of s){
                        const t1 = i.getTile(e);
                        if (!(t1 instanceof Ot)) continue;
                        const s = Cn(t1, a, o);
                        if (!s) continue;
                        const n = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = o.tileFramebuffer;
                        h || (h = o.tileFramebuffer = r.createFramebuffer(n[0], n[1], 1, null));
                        let u = t1.rasterParticleState;
                        u || (u = t1.rasterParticleState = new In(r, e, n, c));
                        const _ = u.update(o.lastInvalidatedAt);
                        u.particleTextureDimension !== l && u.updateParticleTexture(e, c);
                        const p = u.targetColorTexture;
                        u.targetColorTexture = u.backgroundColorTexture, u.backgroundColorTexture = p;
                        const f = u.particleTexture0;
                        u.particleTexture0 = u.particleTexture1, u.particleTexture1 = f, d.push([
                            e,
                            s,
                            u,
                            _
                        ]);
                    }
                    if (0 === d.length) return;
                    const u = e.o.now(), _ = o.previousDrawTimestamp ? .001 * (u - o.previousDrawTimestamp) : .0167;
                    if (o.previousDrawTimestamp = u, o.hasColorMap()) {
                        r.activeTexture.set(n.TEXTURE0 + 2);
                        let t1 = o.colorRampTexture;
                        t1 || (t1 = o.colorRampTexture = new e.T(r, o.colorRamp, n.RGBA8)), t1.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    }
                    r.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function(t1, i, o) {
                        const s = t1.context, r = s.gl, n = i.tileFramebuffer;
                        s.activeTexture.set(r.TEXTURE0);
                        const a = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of o){
                            const [, , o, h] = c;
                            n.colorAttachment0.set(o.targetColorTexture.texture), s.viewport.set([
                                0,
                                0,
                                n.width,
                                n.height
                            ]), s.clear({
                                color: e.ap.transparent
                            }), h && (o.backgroundColorTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), l.draw(t1, r.TRIANGLES, Wi.disabled, Xi.disabled, Zi.alphaBlended, Ji.disabled, a, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, o, d), function(t1, i, o, s) {
                        const r = t1.context, n = r.gl, a = o.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = o.paint.get("raster-particle-max-speed");
                        for (const h of s){
                            const [s, d, u] = h;
                            r.activeTexture.set(n.TEXTURE0 + 0), d.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.colorAttachment0.set(u.targetColorTexture.texture);
                            const _ = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: d.defines,
                                overrideFog: !1
                            });
                            r.activeTexture.set(n.TEXTURE0 + 1);
                            const p = d.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e.eb[t1](s));
                            p.push(s);
                            const f = s.canonical.x, m = s.canonical.y;
                            for (const e of p){
                                const r = i.getTile(l ? e.wrapped() : e);
                                if (!r) continue;
                                const a = r.rasterParticleState;
                                if (!a) continue;
                                const h = e.canonical.x + (1 << e.canonical.z) * (e.wrap - s.wrap), u = e.canonical.y;
                                a.particleTexture0.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                                const p = Br(1, a.particleTexture0.size[0], [
                                    h - f,
                                    u - m
                                ], 0, d.texture.size, 2, c, d.textureOffset, d.scale, d.offset);
                                _.draw(t1, n.POINTS, Wi.disabled, Xi.disabled, Zi.alphaBlended, Ji.disabled, p, o.id, a.particleIndexBuffer, void 0, a.particleSegment);
                            }
                        }
                    }(t1, i, o, d), r.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function(t1, i, o, s) {
                        const r = t1.context, n = r.gl, a = i.paint.get("raster-particle-max-speed"), l = s * i.paint.get("raster-particle-speed-factor") * .15, c = function(e) {
                            return Math.pow(e, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        r.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const s of o){
                            const [, o, d] = s;
                            r.activeTexture.set(n.TEXTURE0 + 0), o.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE), r.activeTexture.set(n.TEXTURE0 + 1);
                            const u = d.particleTexture0;
                            u.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                            const _ = Nr(1, u.size[0], 0, o.texture.size, a, l, c, o.textureOffset, o.scale, o.offset);
                            h.colorAttachment0.set(d.particleTexture1.texture), r.clear({
                                color: e.ap.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: o.defines
                            }).draw(t1, n.TRIANGLES, Wi.disabled, Xi.disabled, Zi.unblended, Ji.disabled, _, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, o, d, _);
                }(t1, i, o, s), "translucent" === t1.renderPass && (function(t1, i, o, s) {
                    const r = t1.context, n = r.gl, a = i.getSource().tileSize, l = 5 * (1 - e.ai(e.cM, e.cM + 1, t1.transform.zoom)) * a + o.paint.get("raster-particle-elevation"), c = !t1.options.moving, h = "globe" === t1.transform.projection.name;
                    if (!s.length) return;
                    const [d, u] = t1.stencilConfigForOverlap(s), _ = [];
                    h && _.push("PROJECTION_GLOBE_VIEW");
                    const p = t1.stencilModeFor3D();
                    for (const s of u){
                        const a = s.toUnwrapped(), u = i.getTile(s);
                        if (!u.rasterParticleState) continue;
                        const f = u.rasterParticleState, m = 100;
                        u.registerFadeDuration(m);
                        const g = i.findLoadedParent(s, 0), v = tr(u, g, i, t1.transform, m);
                        let y, x;
                        t1.terrain && t1.terrain.prepareDrawTile(), r.activeTexture.set(n.TEXTURE0), f.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), r.activeTexture.set(n.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), y = Math.pow(2, g.tileID.overscaledZ - u.tileID.overscaledZ), x = [
                            u.tileID.canonical.x * y % 1,
                            u.tileID.canonical.y * y % 1
                        ]) : f.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                        const b = h ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(a, c), w = t1.transform, T = Rn(w), E = e.dI(s.canonical), S = e.dJ(E.getCenter().lat);
                        let I, C, R, A, D;
                        h ? (I = Float32Array.from(e.bl(e.dL(s.canonical))), C = Float32Array.from(w.globeMatrix), R = Float32Array.from(e.dH(w)), A = [
                            e.aG(w.center.lng),
                            e.aK(w.center.lat)
                        ], D = Float32Array.from(e.dK(s.canonical, E, S, w.worldSize / w._pixelsPerMercatorPixel))) : (I = new Float32Array(16), C = new Float32Array(9), R = new Float32Array(16), A = [
                            0,
                            0
                        ], D = new Float32Array(9));
                        const L = kr(b, I, C, R, D, x || [
                            0,
                            0
                        ], e.ak(t1.transform.zoom), A, T, y || 1, v, l), P = t1.isTileAffectedByFog(s), O = t1.getOrCreateProgram("rasterParticle", {
                            defines: _,
                            overrideFog: P
                        });
                        if (t1.uploadCommonUniforms(r, O, a), h) {
                            const e = new Wi(n.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D), i = 0, s = t1.globeSharedBuffers;
                            if (s) {
                                const [r, a, l] = s.getGridBuffers(S, 0 !== i);
                                O.draw(t1, n.TRIANGLES, e, p, Zi.alphaBlended, t1.renderElevatedRasterBackface ? Ji.frontCCW : Ji.backCCW, L, o.id, r, a, l);
                            }
                        } else {
                            const e = t1.depthModeForSublayer(0, Wi.ReadOnly), i = d[s.overscaledZ], { tileBoundsBuffer: r, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = t1.getTileBoundsBuffers(u);
                            O.draw(t1, n.TRIANGLES, e, i, Zi.alphaBlended, Ji.disabled, L, o.id, r, a, l);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, o, s), t1.style.map.triggerRepaint());
            },
            background: function(t1, i, o, s) {
                const r = o.paint.get("background-color"), n = "none" === o.paint.get("background-color-use-theme").constantOr("default"), a = o.paint.get("background-opacity"), l = o.paint.get("background-emissive-strength"), c = "viewport" === o.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const h = t1.context, d = h.gl, u = t1.transform, _ = u.tileSize, p = o.paint.get("background-pattern");
                let f;
                if (void 0 !== p) {
                    if (null === p) return;
                    if (f = t1.imageManager.getPattern(e.I.from(p.toString()), o.scope, t1.style.getLut(o.scope)), !f) return;
                }
                const m = !p && 1 === r.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== m) return;
                const g = Xi.disabled, v = t1.depthModeForSublayer(0, "opaque" === m ? Wi.ReadWrite : Wi.ReadOnly), y = t1.colorModeForDrapableLayerRenderPass(l), x = p ? "backgroundPattern" : "background";
                let b, w = s;
                w || (b = t1.getBackgroundTiles(), w = Object.values(b).map((e)=>e.tileID)), p && (h.activeTexture.set(d.TEXTURE0), t1.imageManager.bind(t1.context, o.scope));
                const T = [];
                if (t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && T.push("USE_MRT1"), c) {
                    const i = t1.getOrCreateProgram(x, {
                        overrideFog: !1,
                        overrideRtt: !0,
                        defines: T
                    }), s = new Float32Array(e.bB([])), h = new e.aR(0, 0, 0, 0, 0), u = p ? Gr(s, l, a, t1, 0, o.scope, f, c, {
                        tileID: h,
                        tileSize: _
                    }) : Vr(s, l, a, r.toPremultipliedRenderColor(n ? null : o.lut));
                    return void i.draw(t1, d.TRIANGLES, v, g, y, Ji.disabled, u, o.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                }
                for (const e of w){
                    const m = t1.isTileAffectedByFog(e), w = t1.getOrCreateProgram(x, {
                        overrideFog: m,
                        defines: T
                    }), E = e.toUnwrapped(), S = s ? e.projMatrix : t1.transform.calculateProjMatrix(E);
                    t1.prepareDrawTile();
                    const I = i ? i.getTile(e) : b ? b[e.key] : new Pt(e, _, u.zoom, t1), C = p ? Gr(S, l, a, t1, 0, o.scope, f, c, {
                        tileID: e,
                        tileSize: _
                    }) : Vr(S, l, a, r.toPremultipliedRenderColor(n ? null : o.lut));
                    t1.uploadCommonUniforms(h, w, E);
                    const { tileBoundsBuffer: R, tileBoundsIndexBuffer: A, tileBoundsSegments: D } = t1.getTileBoundsBuffers(I);
                    w.draw(t1, d.TRIANGLES, v, g, y, Ji.disabled, C, o.id, R, A, D);
                }
            },
            sky: function(t1, i, o) {
                const s = t1._atmosphere ? e.ak(t1.transform.zoom) : 1, r = o.paint.get("sky-opacity") * s;
                if (0 === r) return;
                const n = t1.context, a = o.paint.get("sky-type"), l = new Wi(n.gl.LEQUAL, Wi.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === a ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i) {
                    const o = t1.context, s = o.gl;
                    let r = i.skyboxFbo;
                    if (!r) {
                        r = i.skyboxFbo = o.createFramebuffer(32, 32, 1, null), i.skyboxGeometry = new Vn(o), i.skyboxTexture = o.gl.createTexture(), s.bindTexture(s.TEXTURE_CUBE_MAP, i.skyboxTexture), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_CUBE_MAP, s.TEXTURE_MAG_FILTER, s.LINEAR);
                        for(let e = 0; e < 6; ++e)s.texImage2D(s.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, s.RGBA, 32, 32, 0, s.RGBA, s.UNSIGNED_BYTE, null);
                    }
                    o.bindFramebuffer.set(r.framebuffer), o.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const n = i.getCenter(t1, !0), a = t1.getOrCreateProgram("skyboxCapture"), l = new Float64Array(16);
                    e.bB(l), e.eq(l, l, .5 * -Math.PI), Gn(t1, i, a, l, n, 0), e.bB(l), e.eq(l, l, .5 * Math.PI), Gn(t1, i, a, l, n, 1), e.bB(l), e.cV(l, l, .5 * -Math.PI), Gn(t1, i, a, l, n, 2), e.bB(l), e.cV(l, l, .5 * Math.PI), Gn(t1, i, a, l, n, 3), e.bB(l), Gn(t1, i, a, l, n, 4), e.bB(l), e.eq(l, l, Math.PI), Gn(t1, i, a, l, n, 5), o.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(e, t1, i, o, s) {
                    const r = e.context, n = r.gl, a = e.transform, l = e.getOrCreateProgram("skybox");
                    r.activeTexture.set(n.TEXTURE0), n.bindTexture(n.TEXTURE_CUBE_MAP, t1.skyboxTexture);
                    const c = ((e, t1, i, o, s)=>({
                            u_matrix: e,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: s
                        }))(a.skyboxMatrix, t1.getCenter(e, !1), 0, o, s);
                    e.uploadCommonUniforms(r, l), l.draw(e, n.TRIANGLES, i, Xi.disabled, e.colorModeForRenderPass(), Ji.backCW, c, "skybox", t1.skyboxGeometry.vertexBuffer, t1.skyboxGeometry.indexBuffer, t1.skyboxGeometry.segment);
                }(t1, o, l, r, c) : "gradient" === a && "sky" === t1.renderPass && function(t1, i, o, s, r) {
                    const n = t1.context, a = n.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new Vn(n)), n.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e.T(n, i.colorRamp, a.RGBA8)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const d = ((t1, i, o, s, r)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e.ao(o),
                            u_opacity: s,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), s, r);
                    t1.uploadCommonUniforms(n, c), c.draw(t1, a.TRIANGLES, o, Xi.disabled, t1.colorModeForRenderPass(), Ji.backCW, d, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, l, r, c);
            },
            custom: function(t1, i, o, s) {
                const r = t1.context, n = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = n.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(n, r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ak(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(n, r.gl, t1.transform.customLayerMatrix());
                            r.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const e = n.renderToTile;
                            if (e) {
                                const i = s[0].canonical, o = {
                                    x: i.x + s[0].wrap * (n.wrapTileId ? 0 : 1 << i.z),
                                    y: i.y,
                                    z: i.z
                                };
                                r.setDepthMode(Wi.disabled), r.setStencilMode(Xi.disabled), r.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), e.call(n, r.gl, o), r.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), r.setStencilMode(Xi.disabled);
                        const i = "3d" === n.renderingMode ? new Wi(t1.context.gl.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Wi.ReadOnly);
                        if (r.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            n.render(r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ak(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else n.render(r.gl, t1.transform.customLayerMatrix());
                        r.setDirty(), t1.setBaseState(), r.bindFramebuffer.set(null);
                    }
                } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(t1, i, o, s) {
                if ("opaque" === t1.renderPass) return;
                const r = o.paint.get("model-opacity").constantOr(1), n = o.paint.get("model-elevation-reference"), a = "ground" === n, l = "ground" === n;
                if (0 === r) return;
                const c = o.paint.get("model-cast-shadows");
                if ("shadow" === t1.renderPass) {
                    if (!c) return;
                    if (t1.terrain && r < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e.ae) return;
                }
                const h = t1.shadowRenderer, d = o.paint.get("model-receive-shadows");
                h && (h.useNormalOffset = !0, d || (h.enabled = !1));
                const u = ()=>{
                    h && (h.useNormalOffset = !0, d || (h.enabled = !0));
                }, _ = i.getSource();
                if ("light-beam" === t1.renderPass && "batched-model" !== _.type) return;
                if ("vector" === _.type || "geojson" === _.type) return function(t1, i, o, s, r) {
                    const n = t1.transform, a = "globe" === n.projection.name, l = n.getFreeCameraOptions().position;
                    if (!t1.modelManager) return;
                    const c = t1.modelManager;
                    o.modelManager = c;
                    const h = t1.shadowRenderer;
                    if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const d = o._unevaluatedLayout._values["model-id"], u = Object.assign({}, o.layout.get("model-id").parameters), _ = t1.style.order.indexOf(o.fqid), p = o.paint.get("model-opacity").constantOr(1);
                    for (const f of s){
                        const s = i.getTile(f).getBucket(o);
                        if (!s || s.projection.name !== n.projection.name) continue;
                        const m = s.getModelUris();
                        if (m && !s.modelsRequested && (c.addModelsFromBucket(m, r), s.modelsRequested = !0), a) u.zoom = f.overscaledZ;
                        else {
                            const e = la(f, n);
                            u.zoom = e;
                        }
                        const g = d.possiblyEvaluate(u);
                        if (na(t1, s, f), aa.shadowUniformsInitialized = !1, aa.useSingleShadowCascade = !!h && 0 === h.getMaxCascadeForTile(f.toUnwrapped()), "shadow" === t1.renderPass && h) {
                            if (1 === t1.currentShadowCascade && s.isInsideFirstShadowMapFrustum) continue;
                            const i = n.calculatePosMatrix(f.toUnwrapped(), n.worldSize);
                            if (aa.tileMatrix.set(i), aa.shadowTileMatrix = Float32Array.from(h.calculateShadowPassMatrixFromMatrix(i)), aa.aabb.min = [
                                0,
                                0,
                                0
                            ], aa.aabb.max[0] = aa.aabb.max[1] = e.am, aa.aabb.max[2] = 0, da(s, aa, t1, o.scope)) continue;
                        }
                        const v = 1 << f.canonical.z, y = [
                            ((l.x - f.wrap) * v - f.canonical.x) * e.am,
                            (l.y * v - f.canonical.y) * e.am,
                            l.z * v * e.am
                        ];
                        t1.conflationActive && Object.keys(s.instancesPerModel).length > 0 && t1.style.isLayerClipped(o, i.getSource()) && s.updateReplacement(f, t1.replacementSource, _, o.scope) && (s.uploaded = !1, s.upload(t1.context));
                        let x = 0;
                        const b = new Array, w = new Array, T = new Array;
                        for(let i in s.instancesPerModel){
                            const n = s.instancesPerModel[i];
                            n.features.length > 0 && !a && (i = g.evaluate(n.features[0].feature, {}));
                            const h = c.getModel(i, r);
                            if (h || c.hasURLBeenRequested(i) || s.modelUris.includes(i) || (s.modelUris.push(i), s.modelsRequested = !1), h && h.uploaded) {
                                if (a) {
                                    const i = e.c6([], [
                                        l.x,
                                        l.y,
                                        l.z
                                    ], t1.transform.worldSize);
                                    e.ez(i, i);
                                    for(let o = 0; o < n.instancedDataArray.length; ++o){
                                        const r = [
                                            0,
                                            0,
                                            0
                                        ], a = [
                                            1,
                                            1,
                                            1
                                        ], l = e.eA(), c = n.tileCoordinatesForInstance(o), d = n.transformForInstance(o);
                                        e.eB(a, d), e.eC(l, d), e.eD(r, l);
                                        const u = n.translationForInstance(o), _ = new e.aU(0, 0);
                                        e.eE(s.canonical, _, c.x, c.y);
                                        const f = e.bD();
                                        e.eF(f, h, t1.transform, _, r, a, u, !0, !1, !1);
                                        const m = n.colorForInstance(o), g = e.bB([]), v = e.eh(_.lat, t1.transform.zoom), y = e.br([], [
                                            1,
                                            1,
                                            1 / v
                                        ]);
                                        e.bs(g, g, i), T.push({
                                            zScaleMatrix: y,
                                            negCameraPosMatrix: g
                                        });
                                        for (const e of h.nodes)ea(t1, e, f, t1.transform.expandedFarZProjMatrix, x, b, w, h.materialOverrides, p, m);
                                        ++x;
                                    }
                                } else for (const e of h.nodes)ca(t1, o, e, n, y, f, aa);
                            }
                        }
                        if (a) {
                            if ("shadow" === t1.renderPass) {
                                for (const e of w)ta(e.mesh, e.nodeModelMatrix, t1, o);
                                for (const e of b)ta(e.mesh, e.nodeModelMatrix, t1, o);
                            } else ra(t1, o, b, w, T);
                        }
                    }
                }(t1, i, o, s, Qn(t1, o)), void u();
                if (!_.loaded()) return;
                if ("batched-model" === _.type) return function(t1, i, o, s) {
                    o.resetLayerRenderingStats(t1);
                    const r = t1.context, n = t1.transform, a = t1.style.fog, l = t1.shadowRenderer;
                    if ("mercator" !== n.projection.name) return void e.w(`Drawing 3D landmark models for ${n.projection.name} projection is not yet implemented`);
                    const c = t1.transform.getFreeCameraOptions().position, h = e.c6([], [
                        c.x,
                        c.y,
                        c.z
                    ], t1.transform.worldSize), d = e.ez([], h), u = e.bB([]), _ = e.eh(n.center.lat, n.zoom), p = e.br([], [
                        1,
                        1,
                        1 / _
                    ]);
                    e.bs(u, u, d);
                    const f = o.paint.get("model-opacity").constantOr(1), m = new Wi(r.gl.LEQUAL, Wi.ReadWrite, t1.depthRangeFor3D), g = new Wi(r.gl.LEQUAL, Wi.ReadOnly, t1.depthRangeFor3D), v = new e.da([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), y = "shadow" === t1.renderPass, x = y && l ? l.getCurrentCascadeFrustum() : n.getFrustum(n.scaleZoom(n.worldSize)), b = o.paint.get("model-front-cutoff"), w = b[2] < 1, T = lo(t1, o.paint.get("model-cutoff-fade-range")), E = o.getLayerRenderingStats();
                    (function(e, t1, i, o) {
                        const s = e.terrain ? e.terrain.exaggeration() : 0, r = e.transform.zoom;
                        for (const n of o){
                            const o = t1.getTile(n).getBucket(i);
                            o && (o.setFilter(i.filter), e.conflationActive && o.updateReplacement(n, e.replacementSource), o.evaluateTransform(e, i), e.terrain && s > 0 && o.elevationUpdate(e.terrain, s, n, i.source), o.needsReEvaluation(e, r, i) && o.evaluate(i));
                        }
                    })(t1, i, o, s), function() {
                        const c = new Map;
                        let d, S, I;
                        w ? (d = s.length - 1, S = -1, I = -1) : (d = 0, S = s.length, I = 1);
                        const C = new Float64Array(16), R = e.cB(), A = new e.P(0, 0);
                        for(let D = d; D !== S; D += I){
                            const d = s[D], S = i.getTile(d).getBucket(o);
                            if (!S || !S.uploaded) continue;
                            let I = !1;
                            l && (I = 0 === l.getMaxCascadeForTile(d.toUnwrapped()));
                            const L = n.calculatePosMatrix(d.toUnwrapped(), n.worldSize), P = S.modelTraits;
                            !y && w && (e.bm(C, L), e.ag(R, h, C), A.x = R[0], A.y = R[1]);
                            const O = [];
                            S.setFilter(o.filter);
                            for (const i of S.getNodesInfo()){
                                if (i.hiddenByReplacement) continue;
                                if (!i.node.meshes) continue;
                                const o = i.node;
                                let s = 0;
                                t1.terrain && o.elevation && (s = o.elevation * t1.terrain.exaggeration());
                                const r = (()=>{
                                    const t1 = i.aabb;
                                    return v.min = [
                                        ...t1.min
                                    ], v.max = [
                                        ...t1.max
                                    ], v.min[2] += s, v.max[2] += s, e.ag(v.min, v.min, L), e.ag(v.max, v.max, L), v;
                                })(), a = i.evaluatedScale;
                                if (a[0] <= 1 && a[1] <= 1 && a[2] <= 1 && 0 === r.intersects(x)) continue;
                                if (!y && w) {
                                    const t1 = 1 / 6;
                                    i.cameraCollisionOpacity = h[0] > r.min[0] && h[0] < r.max[0] && h[1] > r.min[1] && h[1] < r.max[1] && h[2] * _ < r.max[2] && o.footprint && e.c1(A, o.footprint) ? Math.max(i.cameraCollisionOpacity - t1, 0) : Math.min(1, i.cameraCollisionOpacity + t1);
                                }
                                const l = [
                                    ...L
                                ], c = 1 / e.d8(d.canonical), u = o.anchor ? o.anchor[0] : 0, p = o.anchor ? o.anchor[1] : 0;
                                e.bs(l, l, [
                                    u * (a[0] - 1) + i.evaluatedTranslation[0] * c,
                                    p * (a[1] - 1) + i.evaluatedTranslation[1] * c,
                                    s + i.evaluatedTranslation[2]
                                ]), e.cr(a, e.eH) || e.cT(l, l, a);
                                const m = e.aC([], l, o.globalMatrix), g = e.aC([], n.expandedFarZProjMatrix, m), E = e.aC([], n.expandedFarZProjMatrix, l), S = e.aD([], [
                                    u,
                                    p,
                                    s,
                                    1
                                ], g)[2];
                                o.hidden = !1;
                                let I = f;
                                y || (w && (I *= i.cameraCollisionOpacity, I *= _a(l, n, i.aabb, b)), I *= ua(T, S)), 0 !== I ? O.push({
                                    nodeInfo: i,
                                    depth: S,
                                    opacity: I,
                                    wvpForNode: g,
                                    wvpForTile: E,
                                    nodeModelMatrix: m,
                                    tileModelMatrix: l
                                }) : o.hidden = !0;
                            }
                            y || O.sort((e, t1)=>!w || 1 === e.opacity && 1 === t1.opacity ? e.depth < t1.depth ? -1 : 1 : 1 === e.opacity ? -1 : 1 === t1.opacity ? 1 : e.depth > t1.depth ? -1 : 1);
                            for (const i of O){
                                const s = i.nodeInfo, h = s.node;
                                if (t1._debugParams.show3DModelFootprints && h.footprint) {
                                    const e = h.id || h.name || "footprint";
                                    c.has(e) || c.set(e, {
                                        node: h,
                                        mvp: i.wvpForTile
                                    });
                                }
                                let d = e.aC([], p, i.tileModelMatrix);
                                e.aC(d, u, d);
                                const _ = e.bm([], d);
                                e.ei(_, _), e.cT(_, _, ha), d = e.aC(d, d, h.globalMatrix);
                                const f = "light-beam" === t1.renderPass, v = "none" === o.paint.get("model-color-use-theme").constantOr("default"), x = P & e.eL.HasMapboxMeshFeatures, b = x ? 0 : s.evaluatedRMEA[0][2];
                                for(let e = 0; e < h.meshes.length; ++e){
                                    const c = h.meshes[e], u = e === h.lightMeshIndex;
                                    let p = i.wvpForNode;
                                    if (u) {
                                        if (!f && !t1.terrain && t1.shadowRenderer) {
                                            t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                                            continue;
                                        }
                                        p = i.wvpForTile;
                                    } else if (f) continue;
                                    const w = {
                                        defines: []
                                    }, T = [];
                                    if (!y && l && (l.useNormalOffset = !!c.normalBuffer), Yn(w.defines, T, c, t1, v ? null : o.lut), x || w.defines.push("DIFFUSE_SHADED"), I && w.defines.push("SHADOWS_SINGLE_CASCADE"), E && (y ? E.numRenderedVerticesInShadowPass += c.vertexArray.length : E.numRenderedVerticesInTransparentPass += c.vertexArray.length), y) {
                                        ta(c, i.nodeModelMatrix, t1, o);
                                        continue;
                                    }
                                    let S = null;
                                    if (a) {
                                        const e = Kn(i.nodeModelMatrix, t1.transform);
                                        if (S = new Float32Array(e), "globe" !== n.projection.name) {
                                            const t1 = c.aabb.min, i = c.aabb.max, [o, s] = a.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                                            w.overrideFog = o >= Ve || s >= Ve;
                                        }
                                    }
                                    const C = c.material;
                                    let R;
                                    C.occlusionTexture && C.occlusionTexture.offsetScale && (R = C.occlusionTexture.offsetScale, w.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                                    const A = t1.getOrCreateProgram("model", w);
                                    !y && l && l.setupShadowsFromMatrix(i.tileModelMatrix, A, l.useNormalOffset), t1.uploadCommonUniforms(r, A, null, S);
                                    const D = C.pbrMetallicRoughness;
                                    D.metallicFactor = .9, D.roughnessFactor = .5;
                                    const L = qr(new Float32Array(p), new Float32Array(d), new Float32Array(_), new Float32Array(h.globalMatrix), t1, i.opacity, D.baseColorFactor, C.emissiveFactor, D.metallicFactor, D.roughnessFactor, C, b, o, [
                                        0,
                                        0,
                                        0
                                    ], R);
                                    !u && (s.hasTranslucentParts || i.opacity < 1) && A.draw(t1, r.gl.TRIANGLES, m, Xi.disabled, Zi.disabled, Ji.backCCW, L, o.id, c.vertexBuffer, c.indexBuffer, c.segments, o.paint, t1.transform.zoom, void 0, T), A.draw(t1, r.gl.TRIANGLES, u ? g : m, Xi.disabled, u || i.opacity < 1 || s.hasTranslucentParts ? Zi.alphaBlended : Zi.unblended, Ji.backCCW, L, o.id, c.vertexBuffer, c.indexBuffer, c.segments, o.paint, t1.transform.zoom, void 0, T);
                                }
                            }
                        }
                        if (t1._debugParams.show3DModelFootprints && c.size > 0) {
                            const e = Array.from(c.keys()).sort();
                            for (const i of e){
                                const { node: e, mvp: o } = c.get(i);
                                ia(t1, 0, e, o);
                            }
                        }
                    }();
                }(t1, i, o, s), void u();
                if ("model" !== _.type) return;
                const p = _.getModels(), f = [], m = t1.transform.getFreeCameraOptions().position, g = e.c6([], [
                    m.x,
                    m.y,
                    m.z
                ], t1.transform.worldSize);
                e.ez(g, g);
                const v = [], y = [];
                let x = 0;
                for (const s of p){
                    const r = i.getFeatureState("", s.id), n = {
                        type: "Unknown",
                        id: s.id,
                        properties: s.featureProperties
                    }, c = o.paint.get("model-rotation").evaluate(n, r), h = o.paint.get("model-scale").evaluate(n, r), d = o.paint.get("model-translation").evaluate(n, r), u = o.paint.get("model-opacity").evaluate(n, r);
                    oa(o, s.id, r, s.featureProperties, s.nodeOverrideNames, s.nodeOverrides), sa(o, s.id, r, s.featureProperties, s.materialOverrideNames, s.materialOverrides), s.nodeOverrides.size > 0 && s.computeBoundsAndApplyParent(), s.computeModelMatrix(t1, c, h, d, l, a, !1);
                    const _ = e.bB([]), p = e.eh(s.position.lat, t1.transform.zoom), m = e.br([], [
                        1,
                        1,
                        1 / p
                    ]);
                    e.bs(_, _, g), f.push({
                        zScaleMatrix: m,
                        negCameraPosMatrix: _
                    });
                    for (const e of s.nodes)ea(t1, e, s.matrix, t1.transform.expandedFarZProjMatrix, x, v, y, s.materialOverrides, u);
                    x++;
                }
                if (v.sort((e, t1)=>t1.depth - e.depth), "shadow" !== t1.renderPass) {
                    if (t1._debugParams.show3DModelFootprints) {
                        const i = t1.transform.projMatrix, o = new Map, s = (t1, s)=>{
                            if (t1.footprint) {
                                const r = t1.id || t1.name || "footprint";
                                if (!o.has(r)) {
                                    const n = e.aC([], i, s);
                                    o.set(r, {
                                        node: t1,
                                        mvp: n
                                    });
                                }
                            }
                        };
                        for (const e of y)s(e.node, e.modelMatrix);
                        for (const e of v)s(e.node, e.modelMatrix);
                        const r = Array.from(o.keys()).sort();
                        for (const e of r){
                            const { node: i, mvp: s } = o.get(e);
                            ia(t1, 0, i, s);
                        }
                    }
                    ra(t1, o, v, y, f), u();
                } else {
                    for (const e of y)ta(e.mesh, e.nodeModelMatrix, t1, o);
                    for (const e of v)ta(e.mesh, e.nodeModelMatrix, t1, o);
                    u();
                }
            }
        }, Da = {
            line: function(e, t1, i) {
                if (e.hasElevatedBuckets = !1, e.hasNonElevatedBuckets = !1, void 0 !== e._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e._unevaluatedLayout.getValue("line-z-offset")) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const o of i){
                            const i = t1.getTile(o).getBucket(e);
                            if (i && ("none" !== i.elevationType ? e.hasElevatedBuckets = !0 : e.hasNonElevatedBuckets = !0, e.hasElevatedBuckets && e.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e.hasNonElevatedBuckets = !0;
            },
            model: function(e, t1, i) {
                const o = t1.getSource();
                if (!o.loaded()) return;
                if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, Qn(i, e)));
                if ("batched-model" === o.type) return;
                if ("model" !== o.type) return;
                const s = o.getModels();
                for (const e of s)e.upload(i.context);
            },
            raster: function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof pt && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const n = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const t1 of n)t1.updateNeeded(e.id, r) && o.prepareTile(t1, s, e.id, r);
            },
            "raster-particle": function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof pt && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-particle-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const n = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const t1 of n)t1.updateNeeded(e.id, r) && o.prepareTile(t1, s, e.id, r);
            }
        }, La = {
            fill: cn
        }, Pa = {
            fill: function(e, t1, i, o) {
                if (!i.layout || "none" === i.layout.get("fill-elevation-reference") || 0 === i.paint.get("fill-opacity").constantOr(1)) return;
                const s = e.context.gl, r = new Wi(s.LEQUAL, Wi.ReadOnly, e.depthRangeFor3D), n = new Xi({
                    func: s.ALWAYS,
                    mask: 255
                }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), a = e.transform.getFreeCameraOptions().position, l = e.getOrCreateProgram("elevatedStructuresDepthReconstruct");
                for (const c of o){
                    const o = t1.getTile(c), h = o.getBucket(i);
                    if (!h) continue;
                    const d = h.elevatedStructures;
                    if (!d || 0 === d.depthSegments.segments[0].primitiveLength) continue;
                    const u = ln(c.toUnwrapped(), a), _ = e.translatePosMatrix(c.projMatrix, o, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), p = wr(_, u, 0, 1, 0);
                    l.draw(e, s.TRIANGLES, r, n, Zi.disabled, Ji.disabled, p, i.id, d.vertexBuffer, d.indexBuffer, d.depthSegments, i.paint, e.transform.zoom);
                }
            }
        };
        class Oa {
            constructor(t1, i, o, s, r){
                this.context = new Jr(t1, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this._timeStamp = e.o.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
                    forceEnablePrecipitation: !1,
                    showTerrainProxyTiles: !1,
                    fpsWindow: 30,
                    continousRedraw: !1,
                    show3DModelFootprints: !1,
                    enabledLayers: {}
                };
                const n = [
                    "fill",
                    "line",
                    "symbol",
                    "circle",
                    "heatmap",
                    "fill-extrusion",
                    "building",
                    "raster",
                    "raster-particle",
                    "hillshade",
                    "model",
                    "background",
                    "sky"
                ];
                for (const e of n)this._debugParams.enabledLayers[e] = !0;
                for (const e of n);
                this.occlusionParams = new ma, this.setup(), this.numSublayers = Ft.maxUnderzooming + Ft.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e.eS, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new _o(this), this._wireframeDebugCache = new fa, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const a = new e.q({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e.T(this.context, a, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = s, this.worldview = r, this._forceEmissiveMode = !1, this.emissiveMode = "constant";
            }
            updateTerrain(e, t1) {
                const i = !!e && !!e.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new rr(this, e));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e, this.transform, t1), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
            }
            _updateFog(e) {
                const t1 = e.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const s = i + .78 * (o - i);
                this.transform.fogCullDistSq = s * s;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e) {
                e && !this._terrain && (this._terrain = new rr(this, this.style)), this._forceTerrainMode = e;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e.o.devicePixelRatio, this.height = i * e.o.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e of this.style.order)this.style._mergedLayers[e].resize();
            }
            setup() {
                const t1 = this.context, i = new e.be;
                i.emplaceBack(0, 0), i.emplaceBack(e.am, 0), i.emplaceBack(0, e.am), i.emplaceBack(e.am, e.am), this.tileExtentBuffer = t1.createVertexBuffer(i, e.bg.members), this.tileExtentSegments = e.bh.simpleSegment(0, 0, 4, 2);
                const o = new e.be;
                o.emplaceBack(0, 0), o.emplaceBack(e.am, 0), o.emplaceBack(0, e.am), o.emplaceBack(e.am, e.am), this.debugBuffer = t1.createVertexBuffer(o, e.bg.members), this.debugSegments = e.bh.simpleSegment(0, 0, 4, 5);
                const s = new e.be;
                s.emplaceBack(-1, -1), s.emplaceBack(1, -1), s.emplaceBack(-1, 1), s.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(s, e.bg.members), this.viewportSegments = e.bh.simpleSegment(0, 0, 4, 2);
                const r = new e.b2;
                r.emplaceBack(0, 0, 0, 0), r.emplaceBack(e.am, 0, e.am, 0), r.emplaceBack(0, e.am, 0, e.am), r.emplaceBack(e.am, e.am, e.am, e.am), this.mercatorBoundsBuffer = t1.createVertexBuffer(r, e.bj.members), this.mercatorBoundsSegments = e.bh.simpleSegment(0, 0, 4, 2);
                const n = new e.b1;
                n.emplaceBack(0, 1, 2), n.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(n);
                const a = new e.bf;
                for (const e of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e.T(t1, new e.q({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e.bD();
                const l = this.context.gl;
                this.stencilClearMode = new Xi({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e) {
                return e._makeTileBoundsBuffers(this.context, this.transform.projection), e._tileBoundsBuffer ? {
                    tileBoundsBuffer: e._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e._tileBoundsIndexBuffer,
                    tileBoundsSegments: e._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e.TRIANGLES, Wi.disabled, this.stencilClearMode, Zi.disabled, Ji.disabled, er(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e, t1, i) {
                if (!t1 || this.currentStencilSource === t1.id || !e.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e = !1;
                    for (const t1 of i)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e = !0;
                        break;
                    }
                    if (!e) return;
                }
                this.currentStencilSource = t1.id;
                const o = this.context, s = o.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), o.setColorMode(Zi.disabled), o.setDepthMode(Wi.disabled);
                const r = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e of i){
                    const i = t1.getTile(e), o = this._tileClippingMaskIDs[e.key] = this.nextStencilID++, { tileBoundsBuffer: n, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    r.draw(this, s.TRIANGLES, Wi.disabled, new Xi({
                        func: s.ALWAYS,
                        mask: 0
                    }, o, 255, s.KEEP, s.KEEP, s.REPLACE), Zi.disabled, Ji.disabled, er(e.projMatrix), "$clipping", n, a, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e = this.nextStencilID++, t1 = this.context.gl;
                return new Xi({
                    func: t1.NOTEQUAL,
                    mask: 255
                }, e, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilModeForClipping(e) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e);
                const t1 = this.context.gl;
                return new Xi({
                    func: t1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e.key], 0, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilConfigForOverlap(e) {
                const t1 = this.context.gl, i = e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ), o = i[i.length - 1].overscaledZ, s = i[0].overscaledZ - o + 1;
                if (s > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + s > 256 && this.clearStencil();
                    const e = {};
                    for(let i = 0; i < s; i++)e[i + o] = new Xi({
                        func: t1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
                    return this.nextStencilID += s, [
                        e,
                        i
                    ];
                }
                return [
                    {
                        [o]: Xi.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Zi([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e.ap(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Zi.unblended : Zi.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? null != t1 && "mrt-fallback" !== this.emissiveMode || "constant" === this.emissiveMode ? new Zi([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e.ap(0, 0, 0, null != t1 ? t1 : 0), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : "dual-source-blending" === this.emissiveMode ? new Zi([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    this.context.extBlendFuncExtended.SRC1_ALPHA_WEBGL,
                    i.ONE_MINUS_SRC_ALPHA
                ], e.ap.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass() : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e, t1, i, o = !1) {
                if (this.depthOcclusion) return new Wi(this.context.gl.GREATER, Wi.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !o) return Wi.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
                return new Wi(i || this.context.gl.LEQUAL, t1, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), o = Math.ceil(this.height), s = this.context.bindFramebuffer.get(), r = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new Yr(this.context, i, o, 0, "texture"), this.depthTexture = new e.T(this.context, {
                    width: i,
                    height: o,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(s), t1.bindTexture(t1.TEXTURE_2D, r), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
                this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e, t1)=>e + t1 / this._fpsHistory.length, 0));
            }
            render(t1, i) {
                const o = e.o.now();
                this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t1.map.repaint, this.style = t1, this.options = i;
                const s = this.style._mergedLayers, r = !(!this.terrain || !this.terrain.enabled), n = ()=>this.style._getOrder(r).filter((e)=>{
                        const t1 = s[e];
                        return !(t1.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t1.type];
                    });
                let a = n(), l = !1, c = !1, h = null, d = 0, u = !1;
                for (const e of a){
                    const t1 = s[e];
                    "none" !== t1.visibility && ("circle" === t1.type ? l = !0 : "building" === t1.type ? (h = t1, ++d) : "symbol" === t1.type && (t1.hasOcclusionOpacityProperties ? c = !0 : l = !0));
                }
                this.updateEmissiveMode();
                let _ = a.map((e)=>s[e]);
                const p = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e.o.now()), this.imageManager.beginFrame();
                for(const e in p){
                    const t1 = p[e];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++d);
                }
                let f = !1;
                for (const e of _)e.isHidden(this.transform.zoom) || ("clip" === e.type && (f = !0), this.prepareLayer(e));
                const m = {}, g = {}, v = {}, y = {}, x = {};
                for(const e in p){
                    const t1 = p[e];
                    m[e] = t1.getVisibleCoordinates(), g[e] = m[e].slice().reverse(), v[e] = t1.getVisibleCoordinates(!0).reverse(), y[e] = t1.getShadowCasterCoordinates(), x[e] = t1.sortCoordinatesByDistance(m[e]);
                }
                const b = (e)=>{
                    const t1 = this.style.getLayerSourceCache(e);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (d || f || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let o = 0;
                    for (const e of _)this.isSourceForClippingOrConflation(e, b(e)) && (t1.push(e), i.push(o)), o++;
                    if (t1 && (f || t1.length > 1) || this._clippingActiveLastFrame) {
                        f = !1;
                        const o = [];
                        for(let s = 0; s < t1.length; s++){
                            const r = t1[s], n = i[s], a = this.style.getLayerSourceCache(r);
                            if (!a || !a.used || !a.getSource().usedInConflation && "clip" !== r.type && "building" !== r.type) continue;
                            let l = e.eT, c = e.b$.None;
                            const h = [];
                            let d = !0;
                            if ("building" === r.type) l = e.eV;
                            else if ("clip" === r.type) {
                                if (l = n, r.isHidden(this.transform.zoom)) d = !1;
                                else {
                                    if (!r.layout) {
                                        d = !1;
                                        continue;
                                    }
                                    for (const t1 of r.layout.get("clip-layer-types"))c |= "model" === t1 ? e.b$.Model : "symbol" === t1 ? e.b$.Symbol : e.b$.FillExtrusion;
                                    for (const e of r.layout.get("clip-layer-scope"))h.push(e);
                                    f = !0;
                                }
                            }
                            d && o.push({
                                layer: r.fqid,
                                cache: a,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(o), u = !0;
                    }
                }
                this._clippingActiveLastFrame = f, u || this.replacementSource.clear(), this.conflationActive = u, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e = 0; e < _.length; e++){
                    const t1 = _[e];
                    if ("none" === t1.visibility) continue;
                    const i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e = b(t1);
                        e && (this.minCutoffZoom = Math.max(e.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D(r) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e), this._lastOcclusionLayer = e);
                }
                const w = this.style && this.style.fog;
                w ? (this._fogVisible = 0 !== w.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = w.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(v), this.opaquePassCutoff = 0, a = n(), _ = a.map((e)=>s[e]));
                const T = this._shadowRenderer;
                if (T) {
                    T.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e in p)for (const t1 of m[e]){
                        let e = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e = this.terrain.getMinMaxForTile(t1) || e), T.addShadowReceiver(t1.toUnwrapped(), e.min, e.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.eU(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new $n(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                const E = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), S = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
                if (E && !this._snow && (this._snow = new Ra(this)), !E && this._snow && (this._snow.destroy(), delete this._snow), S && !this._rain && (this._rain = new Ia(this)), !S && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), h) {
                    this.buildingTileBorderManager || (this.buildingTileBorderManager = new Xn);
                    const e = this.style.getLayerSourceCache(h);
                    this.buildingTileBorderManager.updateBorders(e, h);
                }
                if (!q.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e of _){
                    const i = t1.getLayerSourceCache(e);
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const o = i ? g[i.id] : void 0;
                    ("custom" === e.type || "raster" === e.type || "raster-particle" === e.type || e.isSky() || o && o.length) && this.renderLayer(this, i, e, o);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (_.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, y)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const I = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), C = (()=>{
                    if (i.showOverdrawInspector) return e.ap.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!I) {
                            const o = "none" === t1.properties.get("color-use-theme"), s = t1.properties.get("color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e.ap(...s);
                        }
                        if (I) {
                            const o = "none" === t1.properties.get("space-color-use-theme"), s = t1.properties.get("space-color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e.ap(...s);
                        }
                    }
                    return e.ap.transparent;
                })();
                if (this.context.clear({
                    color: C,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && I && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e = _[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) continue;
                    const o = i ? (e.is3D(r) ? x : g)[i.id] : void 0;
                    this._renderTileClippingMasks(e, i, o), this.renderLayer(this, i, e, o);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && I && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.ak(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++){
                    const e = _[this.currentLayer], i = t1.getLayerSourceCache(e);
                    e.isSky() && this.renderLayer(this, i, e, i ? g[i.id] : void 0);
                }
                function R(e, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e.type ? v : e.is3D(r) ? x : g)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < a.length;){
                        const e = _[this.currentLayer];
                        if ("raster" === e.type || "raster-particle" === e.type) {
                            const i = t1.getLayerSourceCache(e);
                            this.renderLayer(this, i, e, R(e, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                const A = T ? T.getGroundShadowLayerIndex() : -1;
                let D = !1, L = -1;
                for(let e = 0; e < a.length; ++e){
                    const t1 = _[e];
                    t1.isHidden(this.transform.zoom) || t1.is3D(r) && (L = e);
                }
                c && -1 === L && (l = !0);
                let P = !1;
                for(; this.currentLayer < a.length;){
                    const e = _[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e)) {
                        if (e.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (!P && e.is3D(r) && !r) {
                            const e = this.currentLayer, t1 = (e)=>{
                                for(this.currentLayer = 0; this.currentLayer < _.length; this.currentLayer++){
                                    const t1 = _[this.currentLayer];
                                    if (La[t1.type]) {
                                        const i = this.style.getLayerSourceCache(t1);
                                        La[t1.type](this, i, t1, R(t1, i), e);
                                    }
                                }
                            };
                            t1("initialize"), t1("reset"), this.currentLayer = e, P = !0;
                        }
                        if (l && !D && this.terrain && !this.transform.isOrthographic && (D = !0, this.blitDepth()), c && -1 !== L && this.currentLayer === L + 1 && !this.transform.isOrthographic && this.blitDepth(), this.terrain || this._renderTileClippingMasks(e, i, i ? m[i.id] : void 0), this.renderLayer(this, i, e, R(e, i)), !this.terrain && T && this.currentLayer === A) {
                            {
                                this.clearStencil(), this.resetStencilClippingMasks();
                                const e = this.currentLayer;
                                for(this.currentLayer = 0; this.currentLayer < _.length; this.currentLayer++){
                                    const e = _[this.currentLayer];
                                    if (Pa[e.type]) {
                                        const t1 = this.style.getLayerSourceCache(e);
                                        Pa[e.type](this, t1, e, R(e, t1));
                                    }
                                }
                                this.currentLayer = e;
                            }
                            if (T.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                                const e = this.currentLayer;
                                for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e; this.currentLayer++){
                                    const e = _[this.currentLayer];
                                    if (!e.hasLightBeamPass()) continue;
                                    const i = t1.getLayerSourceCache(e);
                                    this.renderLayer(this, i, e, i ? g[i.id] : void 0);
                                }
                                this.currentLayer = e, this.renderPass = "translucent";
                            }
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e of this.layersWithOcclusionOpacity){
                                this.currentLayer = e;
                                const i = _[this.currentLayer], o = t1.getLayerSourceCache(i), s = o ? g[o.id] : void 0;
                                this.terrain || this._renderTileClippingMasks(i, o, o ? m[o.id] : void 0), this.renderLayer(this, o, i, s);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    _.forEach((e)=>{
                        const o = t1.getLayerSourceCache(e);
                        o && !e.isHidden(this.transform.zoom) && o.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                    }), i && this.options.showTileBoundaries && zn(this, i, i.getVisibleCoordinates(), e.ap.red, !1, this.options.showParseStatus);
                }
                this.terrain && this._debugParams.showTerrainProxyTiles && zn(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.ap(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(e) {
                    const t1 = e.transform.padding;
                    Fn(e, e.transform.height - (t1.top || 0), 3, An), Fn(e, t1.bottom || 0, 3, Dn), kn(e, t1.left || 0, 3, Ln), kn(e, e.transform.width - (t1.right || 0), 3, Pn);
                    const i = e.transform.centerPoint;
                    !function(e, t1, i, o) {
                        Bn(e, t1 - 1, i - 10, 2, 20, o), Bn(e, t1 - 10, i - 1, 20, 2, o);
                    }(e, i.x, e.transform.height - i.y, On);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), u || (this.conflationActive = !1);
            }
            prepareLayer(e) {
                this.gpuTimingStart(e);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e.type);
                if (Da[e.type] && (i || this.terrain && "custom" === e.type)) {
                    const t1 = this.style.getLayerSourceCache(e);
                    Da[e.type](e, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e.transform.projection.unsupportedLayers && e.transform.projection.unsupportedLayers.includes(i.type) && (!e.terrain || "custom" !== i.type) || "clip" === i.type || Aa[i.type](e, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = this.gpuTimers[e.id];
                o || (o = this.gpuTimers[e.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), o.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, o.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e = this.gpuTimers;
                return this.gpuTimers = {}, e;
            }
            collectDeferredRenderGpuQueries() {
                const e = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e;
            }
            queryGpuTimers(e) {
                const t1 = {};
                for(const i in e){
                    const o = e[i], s = this.context.extTimerQuery, r = s.getQueryParameter(o.query, this.context.gl.QUERY_RESULT) / 1e6;
                    s.deleteQueryEXT(o.query), t1[i] = r;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const o of e)i += t1.getQueryParameter(o, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(o);
                return i;
            }
            translatePosMatrix(t1, i, o, s, r) {
                if (!o[0] && !o[1]) return t1;
                const n = r ? "map" === s ? this.transform.angle : 0 : "viewport" === s ? -this.transform.angle : 0;
                if (n) {
                    const e = Math.sin(n), t1 = Math.cos(n);
                    o = [
                        o[0] * t1 - o[1] * e,
                        o[0] * e + o[1] * t1
                    ];
                }
                const a = [
                    r ? o[0] : e.az(i, o[0], this.transform.zoom),
                    r ? o[1] : e.az(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e.bs(l, t1, a), l;
            }
            saveTileTexture(e) {
                if (e.context !== this.context) return;
                const t1 = e.size[0], i = this._tileTextures[t1];
                i ? i.push(e) : this._tileTextures[t1] = [
                    e
                ];
            }
            getTileTexture(e) {
                const t1 = this._tileTextures[e];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e, t1, i) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, s = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e || "terrainRaster" === e ? (s.push("LIGHTING_3D_MODE"), s.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || s.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass && (this._shadowMapDebug || s.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (s.push("TERRAIN"), this.linearFloatFilteringSupported() && s.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && s.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || s.push("FOG"), o && s.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && s.push("OVERDRAW_INSPECTOR"), s;
            }
            getOrCreateProgram(e, t1) {
                this.cache = this.cache || {};
                const i = t1 && t1.defines || [], o = t1 && t1.config, s = this.currentGlobalDefines(e, t1 && t1.overrideFog, t1 && t1.overrideRtt).concat(i), r = cr.cacheKey(ts[e], e, s, o);
                return this.cache[r] || (this.cache[r] = new cr(this.context, e, ts[e], o, Wr[e], s)), this.cache[r];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i) {
                if (this.style.enable3dLights()) {
                    const o = this.style.directionalLight, s = this.style.ambientLight;
                    if (o && s) {
                        const r = ((t1, i, o)=>{
                            const s = t1.properties.get("direction"), r = "none" === t1.properties.get("color-use-theme"), n = t1.properties.get("color").toNonPremultipliedRenderColor(r ? null : o.getLut(t1.scope)).toArray01(), a = t1.properties.get("intensity"), l = "none" === i.properties.get("color-use-theme"), c = i.properties.get("color").toNonPremultipliedRenderColor(l ? null : o.getLut(i.scope)).toArray01(), h = i.properties.get("intensity"), d = [
                                s.x,
                                s.y,
                                s.z
                            ], u = e.dP(c, h), _ = e.dP(n, a);
                            return {
                                u_lighting_ambient_color: u,
                                u_lighting_directional_dir: d,
                                u_lighting_directional_color: _,
                                u_ground_radiance: nr(d, _, u)
                            };
                        })(o, s, this.style);
                        i.setLightsUniformValues(t1, r);
                    }
                }
            }
            uploadCommonUniforms(t1, i, o, s, r) {
                if (this.uploadCommonLightUniforms(t1, i), this.terrain && this.terrain.renderingToTexture) return;
                const n = this.style.fog;
                if (n) {
                    const r = n.getOpacity(this.transform.pitch), a = ((t1, i, o, s, r, n, a, l, c, h, d, u)=>{
                        const _ = t1.transform, p = "none" === i.properties.get("color-use-theme"), f = i.properties.get("color").toNonPremultipliedRenderColor(p ? null : t1.style.getLut(i.scope)).toArray01();
                        f[3] = s;
                        const m = t1.frameCounter / 1e3 % 1, [g, v] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : u || t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: f,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(g, v),
                                v
                            ],
                            u_fog_temporal_offset: m,
                            u_frustum_tl: r,
                            u_frustum_tr: n,
                            u_frustum_br: a,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: d,
                            u_globe_transition: e.ak(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, n, o, r, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e.o.devicePixelRatio,
                        this.transform.height * e.o.devicePixelRatio
                    ], s);
                    i.setFogUniformValues(t1, a);
                }
                r && i.setCutoffUniformValues(t1, r.uniformValues);
            }
            setTileLoadedFlag(e) {
                this.tileLoaded = e;
            }
            saveCanvasCopy() {
                const e = this.canvasCopy();
                e && (this.frameCopies.push(e), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e = this.context.gl, t1 = e.createTexture();
                return e.bindTexture(e.TEXTURE_2D, t1), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, e.drawingBufferWidth, e.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e = this.style && this.style.fog;
                return !!e && 0 !== e.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const o of i)t1[o.key] = e[o.key] || new Pt(o, 512, this.transform.tileZoom, this, void 0, this.worldview);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e, t1) {
                return !(!e.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e.type && "building" !== e.type && (e.minzoom && e.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e.sourceLayer && "procedural_buildings" !== e.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(e) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t1 = this._cachedTileFogOpacities[e.key];
                return t1 || (this._cachedTileFogOpacities[e.key] = t1 = this.style.fog.getOpacityForTile(e)), t1[0] >= Ve || t1[1] >= Ve;
            }
            setupDepthForOcclusion(e, t1, i) {
                const o = this.context, s = o.gl, r = !!i;
                var n;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), o.activeTexture.set(s.TEXTURE3), e && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((n = this.depthRangeFor3D)[1] - n[0]),
                    -1 - 2 * n[0] / (n[1] - n[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), o.activeTexture.set(s.TEXTURE0), r || t1.setTerrainUniformValues(o, i);
            }
            updateEmissiveMode() {
                if (this._forceEmissiveMode) return;
                const e = this.style.hasDataDrivenEmissiveStrength();
                this.emissiveMode = e ? this.context.extBlendFuncExtended ? "dual-source-blending" : "mrt-fallback" : "constant";
            }
        }
        function za(e, t1) {
            let i = !1, o = null;
            const s = ()=>{
                o = null, i && (e(), o = setTimeout(s, t1), i = !1);
            };
            return ()=>(i = !0, o || s(), o);
        }
        class Ma {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e.aZ([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = za(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e) {
                return this._map = e, window.addEventListener("hashchange", this._onHashChange, !1), e.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e = this._map;
                if (!e) return "";
                const t1 = Fa(e);
                if (this._hashName) {
                    const e = this._hashName;
                    let i = !1;
                    const o = location.hash.slice(1).split("&").map((o)=>{
                        const s = o.split("=")[0];
                        return s === e ? (i = !0, `${s}=${t1}`) : o;
                    }).filter((e)=>e);
                    return i || o.push(`${e}=${t1}`), `#${o.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e.split("&").map((e)=>e.split("=")).forEach((e)=>{
                        e[0] === this._hashName && (t1 = e);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e.split("/");
            }
            _onHashChange() {
                const e = this._map;
                if (!e) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e)=>isNaN(Number(e)))) {
                    const i = e.dragRotate.isEnabled() && e.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e.getBearing();
                    return e.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
        }
        function Fa(e, t1) {
            const i = e.getCenter(), o = Math.round(100 * e.getZoom()) / 100, s = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), r = Math.pow(10, s), n = Math.round(i.lng * r) / r, a = Math.round(i.lat * r) / r, l = e.getBearing(), c = e.getPitch();
            let h = t1 ? `/${n}/${a}/${o}` : `${o}/${a}/${n}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const ka = {
            linearity: .3,
            easing: e.eW(0, 0, .3, 1)
        }, Ba = Object.assign({
            deceleration: 2500,
            maxSpeed: 1400
        }, ka), Na = Object.assign({
            deceleration: 20,
            maxSpeed: 1400
        }, ka), Ua = Object.assign({
            deceleration: 1e3,
            maxSpeed: 360
        }, ka), ja = Object.assign({
            deceleration: 1e3,
            maxSpeed: 90
        }, ka);
        class Va {
            constructor(e){
                this._map = e, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e.o.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e.o.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e } of this._inertiaBuffer)i.zoom += e.zoomDelta || 0, i.bearing += e.bearingDelta || 0, i.pitch += e.pitchDelta || 0, e.panDelta && i.pan._add(e.panDelta), e.around && (i.around = e.around), e.pinchAround && (i.pinchAround = e.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    const e = Ha(i.pan.mag(), o, Object.assign({}, Ba, t1 || {}));
                    s.offset = i.pan.mult(e.amount / i.pan.mag()), s.center = this._map.transform.center, Ga(s, e);
                }
                if (i.zoom) {
                    const e = Ha(i.zoom, o, Na);
                    s.zoom = this._map.transform.zoom + e.amount, Ga(s, e);
                }
                if (i.bearing) {
                    const t1 = Ha(i.bearing, o, Ua);
                    s.bearing = this._map.transform.bearing + e.aB(t1.amount, -179, 179), Ga(s, t1);
                }
                if (i.pitch) {
                    const e = Ha(i.pitch, o, ja);
                    s.pitch = this._map.transform.pitch + e.amount, Ga(s, e);
                }
                if (s.zoom || s.bearing) {
                    const e = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = e ? this._map.unproject(e) : this._map.getCenter();
                }
                return this.clear(), s.noMoveStart = !0, s;
            }
        }
        function Ga(e, t1) {
            (!e.duration || e.duration < t1.duration) && (e.duration = t1.duration, e.easing = t1.easing);
        }
        function Ha(t1, i, o) {
            const { maxSpeed: s, linearity: r, deceleration: n } = o, a = e.aB(t1 * r / (i / 1e3), -s, s), l = Math.abs(a) / (n * r);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class qa extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t1, i, o = {}){
                const s = g(t1.getCanvasContainer(), i), r = t1.unproject(s);
                super(e, Object.assign({
                    point: s,
                    lngLat: r,
                    originalEvent: i
                }, o)), this._defaultPrevented = !1, this.target = t1;
            }
        }
        class Za extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const s = "touchend" === t1 ? o.changedTouches : o.touches, r = v(i.getCanvasContainer(), s), n = r.map((e)=>i.unproject(e)), a = r.reduce((e, t1, i, o)=>e.add(t1.div(o.length)), new e.P(0, 0));
                super(t1, {
                    points: r,
                    point: a,
                    lngLats: n,
                    lngLat: i.unproject(a),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class Wa extends e.A {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class $a {
            constructor(e, t1){
                this._map = e, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e) {
                return this._firePreventable(new Wa(this._map, e));
            }
            mousedown(e, t1) {
                return this._mousedownPos = t1, this._firePreventable(new qa(e.type, this._map, e));
            }
            mouseup(e) {
                this._map.fire(new qa(e.type, this._map, e));
            }
            preclick(e) {
                const t1 = new MouseEvent("preclick", e);
                this._map.fire(new qa(t1.type, this._map, t1));
            }
            click(e, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e), this._map.fire(new qa(e.type, this._map, e)));
            }
            dblclick(e) {
                return this._firePreventable(new qa(e.type, this._map, e));
            }
            mouseover(e) {
                this._map.fire(new qa(e.type, this._map, e));
            }
            mouseout(e) {
                this._map.fire(new qa(e.type, this._map, e));
            }
            touchstart(e) {
                return this._firePreventable(new Za(e.type, this._map, e));
            }
            touchmove(e) {
                this._map.fire(new Za(e.type, this._map, e));
            }
            touchend(e) {
                this._map.fire(new Za(e.type, this._map, e));
            }
            touchcancel(e) {
                this._map.fire(new Za(e.type, this._map, e));
            }
            _firePreventable(e) {
                if (this._map.fire(e), e.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Xa {
            constructor(e){
                this._map = e;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e) {
                this._map.fire(new qa(e.type, this._map, e));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new qa("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e) {
                this._delayContextMenu ? this._contextMenuEvent = e : this._map.fire(new qa(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ka {
            constructor(e, t1){
                this._map = e, this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e, t1) {
                this.isEnabled() && e.shiftKey && 0 === e.button && (_(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, s = this._lastPos;
                if (!o || !s || s.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e));
                const r = Math.min(o.x, i.x), n = Math.max(o.x, i.x), a = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${r}px,${a}px)`, this._box.style.width = n - r + "px", this._box.style.height = c - a + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, s = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), m(), o.x !== s.x || o.y !== s.y) return this._map.fire(new e.A("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e)=>e.fitScreenCoordinates(o, s, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e) {
                this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e.A(t1, {
                    originalEvent: i
                }));
            }
        }
        function Ya(e, t1) {
            const i = {};
            for(let o = 0; o < e.length; o++)i[e[o].identifier] = t1[o];
            return i;
        }
        class Ja {
            constructor(e){
                this.reset(), this.numTouches = e.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e.P(0, 0);
                    for (const e of t1)i._add(e);
                    return i.div(t1.length);
                }(i), this.touches = Ya(o, i)));
            }
            touchmove(e, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = Ya(i, t1);
                for(const e in this.touches){
                    const t1 = o[e];
                    (!t1 || t1.dist(this.touches[e]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e, t1, i) {
                if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e = !this.aborted && this.centroid;
                    if (this.reset(), e) return e;
                }
            }
        }
        class Qa {
            constructor(e){
                this.singleTap = new Ja(e), this.numTaps = e.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e, t1, i) {
                this.singleTap.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this.singleTap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this.singleTap.touchend(e, t1, i);
                if (o) {
                    const t1 = e.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class el {
            constructor(){
                this._zoomIn = new Qa({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new Qa({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e, t1, i) {
                this._zoomIn.touchstart(e, t1, i), this._zoomOut.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this._zoomIn.touchmove(e, t1, i), this._zoomOut.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this._zoomIn.touchend(e, t1, i), s = this._zoomOut.touchend(e, t1, i);
                return o ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e
                        })
                }) : s ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(s)
                        }, {
                            originalEvent: e
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const tl = 0, il = 2, ol = {
            [tl]: 1,
            [il]: 2
        }, sl = {
            Control: "ctrlKey",
            Alt: "altKey",
            Shift: "shiftKey",
            Meta: "metaKey"
        };
        class rl {
            constructor(e){
                this.reset(), this._clickTolerance = e.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e, t1) {
                return !1;
            }
            _move(e, t1) {
                return {};
            }
            mousedown(e, t1) {
                if (this._lastPoint) return;
                const i = y(e);
                this._correctButton(e, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e.preventDefault(), null != this._eventButton && function(e, t1) {
                        const i = ol[t1];
                        return void 0 === e.buttons || (e.buttons & i) !== i;
                    }(e, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e) {
                this._lastPoint && y(e) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class nl extends rl {
            mousedown(e, t1) {
                super.mousedown(e, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e, t1) {
                return 0 === t1 && !e.ctrlKey;
            }
            _move(e, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e)
                };
            }
        }
        class al extends rl {
            constructor(e){
                super(e), this._pitchRotateKey = e.pitchRotateKey ? sl[e.pitchRotateKey] : void 0;
            }
            _correctButton(e, t1) {
                return this._pitchRotateKey ? 0 === t1 && e[this._pitchRotateKey] : 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = .8 * (t1.x - e.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e) {
                this._pitchRotateKey || e.preventDefault();
            }
        }
        class ll extends rl {
            constructor(e){
                super(e), this._pitchRotateKey = e.pitchRotateKey ? sl[e.pitchRotateKey] : void 0;
            }
            _correctButton(e, t1) {
                return this._pitchRotateKey ? 0 === t1 && e[this._pitchRotateKey] : 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = -0.5 * (t1.y - e.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e) {
                this._pitchRotateKey || e.preventDefault();
            }
        }
        class cl {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e.aZ([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
            }
            touchstart(e, t1, i) {
                return this._calculateTransform(e, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e.eX()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e, t1, i) {
                this._calculateTransform(e, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const s = Ya(o, i), r = new e.P(0, 0), n = new e.P(0, 0);
                let a = 0;
                for(const e in s){
                    const t1 = s[e], i = this._touches[e];
                    i && (r._add(t1), n._add(t1.sub(i)), a++, s[e] = t1);
                }
                if (this._touches = s, a < this._minTouches || !n.mag()) return;
                const l = n.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: r.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class hl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e) {}
            _move(e, t1, i) {
                return {};
            }
            touchstart(e, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e.preventDefault();
                const [s, r] = o, n = dl(i, t1, s), a = dl(i, t1, r);
                if (!n || !a) return;
                const l = this._aroundCenter ? null : n.add(a).div(2);
                return this._move([
                    n,
                    a
                ], l, e);
            }
            touchend(e, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, s] = this._firstTwoTouches, r = dl(i, t1, o), n = dl(i, t1, s);
                r && n || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e) {
                this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function dl(e, t1, i) {
            for(let o = 0; o < e.length; o++)if (e[o].identifier === i) return t1[o];
        }
        function ul(e, t1) {
            return Math.log2(e / t1);
        }
        class _l extends hl {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e) {
                this._startDistance = this._distance = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._distance;
                if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(ul(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: ul(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function pl(e, t1) {
            return 180 * e.angleWith(t1) / Math.PI;
        }
        class fl extends hl {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e) {
                this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._vector;
                if (this._vector = e[0].sub(e[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: pl(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e) {
                this._minDiameter = Math.min(this._minDiameter, e.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = pl(e, i);
                return Math.abs(o) < t1;
            }
        }
        function ml(e) {
            return Math.abs(e.y) > Math.abs(e.x);
        }
        class gl extends hl {
            constructor(e){
                super(), this._map = e;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e) {
                this._lastPoints = e, ml(e[0].sub(e[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const s = this._lastPoints;
                if (!s) return;
                const r = t1[0].sub(s[0]), n = t1[1].sub(s[1]);
                return this._map._cooperativeGestures && !e.eX() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r, n, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (r.y + n.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e.mag() >= 2, s = t1.mag() >= 2;
                if (!o && !s) return;
                if (!o || !s) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const r = e.y > 0 == t1.y > 0;
                return ml(e) && ml(t1) && r;
            }
        }
        const vl = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class yl {
            constructor(){
                const e = vl;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e) {
                if (e.altKey || e.ctrlKey || e.metaKey) return;
                let t1 = 0, i = 0, o = 0, s = 0, r = 0;
                switch(e.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e.shiftKey ? i = -1 : (e.preventDefault(), s = -1);
                        break;
                    case 39:
                        e.shiftKey ? i = 1 : (e.preventDefault(), s = 1);
                        break;
                    case 38:
                        e.shiftKey ? o = 1 : (e.preventDefault(), r = -1);
                        break;
                    case 40:
                        e.shiftKey ? o = -1 : (e.preventDefault(), r = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (n)=>{
                        const a = n.getZoom();
                        n.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: xl,
                            zoom: t1 ? Math.round(a) + t1 * (e.shiftKey ? 2 : 1) : a,
                            bearing: n.getBearing() + i * this._bearingStep,
                            pitch: n.getPitch() + o * this._pitchStep,
                            offset: [
                                -s * this._panStep,
                                -r * this._panStep
                            ],
                            center: n.getCenter()
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function xl(e) {
            return e * (2 - e);
        }
        const bl = 4.000244140625, wl = 1 / 450;
        class Tl {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = wl, e.aZ([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e) {
                this._defaultZoomRate = e;
            }
            setWheelZoomRate(e) {
                this._wheelZoomRate = e;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e.eX())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e.o.now(), s = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % bl === 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : s > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(s * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = g(this._el, e);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e = "wheel" === this._type && Math.abs(this._delta) > bl ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const s = i(), r = Math.pow(2, s), n = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : r;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(n * o))), "wheel" === this._type && (this._startZoom = s, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), s = this._startZoom, r = this._easing;
                let n, a = !1;
                if ("wheel" === this._type && s && r) {
                    const t1 = Math.min((e.o.now() - this._lastWheelEventTime) / 200, 1), i = r(t1);
                    n = e.al(s, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else n = o, a = !0;
                this._active = !0, a && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = n - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e.eY;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e.o.now() - t1.start) / t1.duration, s = t1.easing(o + .01) - t1.easing(o), r = .27 / Math.sqrt(s * s + 1e-4) * .01, n = Math.sqrt(.0729 - r * r);
                    i = e.eW(r, n, .25, 1);
                }
                return this._prevEase = {
                    start: e.o.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class El {
            constructor(e, t1){
                this._clickZoom = e, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Sl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e, t1) {
                return e.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Il {
            constructor(){
                this._tap = new Qa({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e, t1, i) {
                this._swipePoint || (this._tapTime && e.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e, t1, i));
            }
            touchmove(e, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], s = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e.preventDefault(), this._active = !0, {
                            zoomDelta: s / 128
                        };
                    }
                } else this._tap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e, t1, i) && (this._tapTime = e.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Cl {
            constructor(e, t1, i){
                this._el = e, this._mousePan = t1, this._touchPan = i;
            }
            enable(e) {
                this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Rl {
            constructor(e, t1, i){
                this._pitchWithRotate = e.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class Al {
            constructor(e, t1, i, o){
                this._el = e, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e) {
                this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const Dl = (e)=>e.zoom || e.drag || e.pitch || e.rotate;
        class Ll extends e.A {
        }
        class Pl {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const o = e.aw([], i, t1);
                this.radius = e.ah(o[2] < 0 ? e.e_([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e.e_(t1, t1, this.constants), e.ax(t1, t1), e.e$(t1, t1, this.constants);
                const i = e.c6([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e.c6([], [
                        0,
                        0,
                        1
                    ], e.bK(i, [
                        0,
                        0,
                        1
                    ])), o = e.c6([], e.ax([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), s = e.d9([], i, e.c6([], e.aw([], e.d9([], o, t1), i), 2));
                    i[0] = s[0], i[1] = s[1];
                }
                return i;
            }
        }
        function Ol(e) {
            return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta;
        }
        class zl {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Va(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Pl, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e.aZ([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.addEventListener(t1, o, i);
                }
            }
            destroy() {
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.removeEventListener(t1, o, i);
                }
            }
            _addDefaultHandlers(e) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new $a(t1, e));
                const o = t1.boxZoom = new Ka(t1, e);
                this._add("boxZoom", o);
                const s = new el, r = new Sl;
                t1.doubleClickZoom = new El(r, s), this._add("tapZoom", s), this._add("clickZoom", r);
                const n = new Il;
                this._add("tapDragZoom", n);
                const a = t1.touchPitch = new gl(t1);
                this._add("touchPitch", a);
                const l = new al(e), c = new ll(e);
                t1.dragRotate = new Rl(e, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new nl(e), d = new cl(t1, e);
                t1.dragPan = new Cl(i, h, d), this._add("mousePan", h), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const u = new fl, _ = new _l;
                t1.touchZoomRotate = new Al(i, _, u, n), this._add("touchRotate", u, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", _, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new Xa(t1));
                const p = t1.scrollZoom = new Tl(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const f = t1.keyboard = new yl;
                this._add("keyboard", f);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e.interactive && e[i] && t1[i].enable(e[i]);
            }
            _add(e, t1, i) {
                this._handlers.push({
                    handlerName: e,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e] = t1;
            }
            stop(e) {
                if (!this._updatingCamera) {
                    for (const { handler: e } of this._handlers)e.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e } of this._handlers)if (e.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Dl(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e, t1, i) {
                for(const o in e)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e) {
                this.handleEvent(e, `${e.type}Window`);
            }
            _getMapTouches(e) {
                const t1 = [];
                for (const i of e)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e.type, o = i ? void 0 : e, s = {
                    needsRenderFrame: !1
                }, r = {}, n = {}, a = e.touches ? this._getMapTouches(e.touches) : void 0, l = a ? v(this._el, a) : i ? void 0 : g(this._el, e);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let d;
                    this._blockedByActive(n, h, i) ? c.reset() : c[t1 || e.type] && (d = c[t1 || e.type](e, l, a), this.mergeHandlerResult(s, r, d, i, o), d && d.needsRenderFrame && this._triggerRenderFrame()), (d || c.isActive()) && (n[i] = c);
                }
                const c = {};
                for(const e in this._previousActiveHandlers)n[e] || (c[e] = o);
                this._previousActiveHandlers = n, (Object.keys(c).length || Ol(s)) && (this._changes.push([
                    s,
                    r,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(n).length || Ol(s)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = s;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e, t1, i, o, s) {
                if (!i) return;
                Object.assign(e, i);
                const r = {
                    handlerName: o,
                    originalEvent: i.originalEvent || s
                };
                void 0 !== i.zoomDelta && (t1.zoom = r), void 0 !== i.panDelta && (t1.drag = r), void 0 !== i.pitchDelta && (t1.pitch = r), void 0 !== i.bearingDelta && (t1.rotate = r);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [s, r, n] of this._changes)s.panDelta && (t1.panDelta = (t1.panDelta || new e.P(0, 0))._add(s.panDelta)), s.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (t1.around = s.around), void 0 !== s.aroundCoord && (t1.aroundCoord = s.aroundCoord), void 0 !== s.pinchAround && (t1.pinchAround = s.pinchAround), s.noInertia && (t1.noInertia = s.noInertia), Object.assign(i, r), Object.assign(o, n);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const s = this._map, r = s.transform, n = (e)=>[
                        e.x,
                        e.y,
                        e.z
                    ];
                if ((()=>{
                    const e = this._eventsInProgress.drag;
                    return e && !this._handlersById[e.handlerName].isActive();
                })() && !Ol(t1)) {
                    const e = r.zoom;
                    r.cameraElevationReference = "sea", null != this._originalZoom && r._orthographicProjectionAtLowPitch && "globe" !== r.projection.name && 0 === r.pitch ? (r.cameraElevationReference = "ground", r.zoom = this._originalZoom) : (r.recenterOnTerrain(), r.cameraElevationReference = "ground"), e !== r.zoom && this._map._update(!0);
                }
                if (r._isCameraConstrained && s._stop(!0), !Ol(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: d, aroundCoord: u, pinchAround: _ } = t1;
                r._isCameraConstrained && (l > 0 && (l = 0), r._isCameraConstrained = !1), void 0 !== _ && (d = _), (l || ((e)=>i[e] && !this._eventsInProgress[e])("drag")) && d && (this._dragOrigin = n(r.pointCoordinate3D(d)), this._originalZoom = r.zoom, this._trackingEllipsoid.setup(r._camera.position, this._dragOrigin)), r.cameraElevationReference = "sea", s._stop(!0), d = d || s.transform.centerPoint, c && (r.bearing += c), h && (r.pitch += h), r._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === r.projection.name) {
                        const e = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(d).dir), t1 = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(d.sub(a)).dir);
                        p[0] = t1[0] - e[0], p[1] = t1[1] - e[1];
                    } else {
                        const t1 = r.pointCoordinate(d);
                        if ("globe" === r.projection.name) {
                            a = a.rotate(-r.angle);
                            const i = r._pixelsPerMercatorPixel / r.worldSize;
                            p[0] = -a.x * e.eZ(e.b0(t1.y)) * i, p[1] = -a.y * e.eZ(r.center.lat) * i;
                        } else {
                            const e = r.pointCoordinate(d.sub(a));
                            t1 && e && (p[0] = e.x - t1.x, p[1] = e.y - t1.y);
                        }
                    }
                }
                const f = r.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = n(u || r.pointCoordinate3D(d)), i = {
                        dir: e.ax([], e.aw([], t1, r._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = r.zoomDeltaToMovement(t1, l);
                        e.c6(m, i.dir, o);
                    }
                }
                const g = e.d9(p, p, m);
                r._translateCameraConstrained(g), l && Math.abs(r.zoom - f) > 1e-4 && r.recenterOnTerrain(), r.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const s = Dl(this._eventsInProgress), r = Dl(t1), n = {};
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._eventsInProgress[e] || (n[`${e}start`] = i), this._eventsInProgress[e] = t1[e];
                }
                !s && r && this._fireEvent("movestart", r.originalEvent);
                for(const e in n)this._fireEvent(e, n[e]);
                r && this._fireEvent("move", r.originalEvent);
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._fireEvent(e, i);
                }
                const a = {};
                let l;
                for(const e in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e], l = i[t1] || o, a[`${e}end`] = l);
                }
                for(const e in a)this._fireEvent(e, a[e]);
                const c = Dl(this._eventsInProgress);
                if (o && (s || r) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e)=>0 !== e && -this._bearingSnap < e && e < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e.A("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e.A(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e)=>{
                    this._frameId = void 0, this.handleEvent(new Ll("renderFrame", {
                        timeStamp: e
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const Ml = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Fl extends e.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e.aZ([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e.aU(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e, t1) {
                return this.jumpTo({
                    center: e
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e.P.convert(t1).mult(-1), this.panTo(this.transform.center, Object.assign({
                    offset: t1
                }, i), o);
            }
            panTo(e, t1, i) {
                return this.easeTo(Object.assign({
                    center: e
                }, t1), i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e, t1) {
                return this.jumpTo({
                    zoom: e
                }, t1), this;
            }
            zoomTo(e, t1, i) {
                return this.easeTo(Object.assign({
                    zoom: e
                }, t1), i);
            }
            zoomIn(e, t1) {
                return this.zoomTo(this.getZoom() + 1, e, t1), this;
            }
            zoomOut(e, t1) {
                return this.zoomTo(this.getZoom() - 1, e, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e, t1) {
                return this.jumpTo({
                    bearing: e
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e, t1) {
                return this.jumpTo({
                    padding: e
                }, t1), this;
            }
            rotateTo(e, t1, i) {
                return this.easeTo(Object.assign({
                    bearing: e
                }, t1), i);
            }
            resetNorth(e, t1) {
                return this.rotateTo(0, Object.assign({
                    duration: 1e3
                }, e), t1), this;
            }
            resetNorthPitch(e, t1) {
                return this.easeTo(Object.assign({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e), t1), this;
            }
            snapToNorth(e, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e, t1) {
                return this.jumpTo({
                    pitch: e
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e.aJ.convert(t1);
                const o = i && i.bearing || 0, s = i && i.pitch || 0, r = t1.getNorthWest(), n = t1.getSouthEast();
                return this._cameraForBounds(this.transform, r, n, o, s, i);
            }
            _extendPadding(e) {
                const t1 = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == e ? Object.assign({}, t1, this.transform.padding) : "number" == typeof e ? {
                    top: e,
                    bottom: e,
                    right: e,
                    left: e
                } : Object.assign({}, t1, e);
            }
            _extendCameraOptions(e) {
                return (e = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, e)).padding = this._extendPadding(e.padding), e;
            }
            _minimumAABBFrustumDistance(e, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e.aspect ? i / (2 * Math.tan(.5 * e.fovX) * e.aspect) : o / (2 * Math.tan(.5 * e.fovY) * e.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, s, r, n) {
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = s, a.pitch = r;
                const c = e.aU.convert(i), h = e.aU.convert(o), d = .5 * (c.lat + h.lat), u = .5 * (c.lng + h.lng), _ = e.f0(d, u), p = e.ax([], _), f = e.ax([], e.bJ([], p, [
                    0,
                    1,
                    0
                ])), m = e.bJ([], f, p), g = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    _,
                    e.f0(c.lat, c.lng),
                    e.f0(h.lat, c.lng),
                    e.f0(h.lat, h.lng),
                    e.f0(c.lat, h.lng),
                    e.f0(d, c.lng),
                    e.f0(d, h.lng),
                    e.f0(c.lat, u),
                    e.f0(h.lat, u)
                ];
                let y = e.da.fromPoints(v.map((t1)=>[
                        e.bK(f, t1),
                        e.bK(m, t1),
                        e.bK(p, t1)
                    ]));
                const x = e.ag([], y.center, g);
                0 === e.f1(x) && e.f2(x, 0, 0, 1), e.ax(x, x), e.c6(x, x, e.aE), a.center = e.f3(x);
                const b = a.getWorldToCameraMatrix(), w = e.bm(new Float64Array(16), b);
                y = e.da.applyTransform(y, e.aC([], b, g));
                const T = this._extendAABB(y, a, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                y = T, e.ag(x, x, b);
                const E = .5 * (y.max[2] - y.min[2]), S = this._minimumAABBFrustumDistance(a, y), I = e.c6([], [
                    0,
                    0,
                    1
                ], E), C = e.d9(I, x, I), R = S + (0 === a.pitch ? 0 : e.bH(x, C)), A = a.globeCenterInViewSpace, D = e.aw([], x, [
                    A[0],
                    A[1],
                    A[2]
                ]);
                e.ax(D, D), e.c6(D, D, R);
                const L = e.d9([], x, D);
                e.ag(L, L, w);
                const P = e.eP / e.aE, O = e.ah(L), z = e.cg(Math.max(O * P - e.eP, Number.EPSILON), 0), M = Math.min(a.zoomFromMercatorZAdjusted(z), l.maxZoom);
                return M > .5 * (e.c$ + e.cM) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = M, this._cameraForBounds(a, i, o, s, r, n)) : {
                    center: a.center,
                    zoom: M,
                    bearing: s,
                    pitch: r
                };
            }
            _extendAABB(t1, i, o, s) {
                const r = .5 * ((o.padding.left || 0) + (o.padding.right || 0)), n = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)), a = n, l = r, c = r, h = n, d = i.width - (l + c), u = i.height - (a + h), _ = e.aw([], t1.max, t1.min), p = Math.min(d / _[0], u / _[1]), f = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
                if (isNaN(f)) return null;
                const m = i.scale / i.zoomScale(f), g = new e.da([
                    t1.min[0] - l * m,
                    t1.min[1] - h * m,
                    t1.min[2]
                ], [
                    t1.max[0] + c * m,
                    t1.max[1] + a * m,
                    t1.max[2]
                ]), v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e.P(o.offset.x, o.offset.y) : e.P.convert(o.offset)).rotate(-e.ao(s));
                return g.center[0] -= v.x * m, g.center[1] += v.y * m, g;
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = Object.assign({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e.af.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, s, r, n) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, s, r, n);
                const a = t1.clone(), l = this._extendCameraOptions(n);
                a.bearing = s, a.pitch = r;
                const c = e.aU.convert(i), h = e.aU.convert(o), d = new e.aU(c.lng, h.lat), u = new e.aU(h.lng, c.lat), _ = a.project(c), p = a.project(h), f = this.queryTerrainElevation(c), m = this.queryTerrainElevation(h), g = this.queryTerrainElevation(d), v = this.queryTerrainElevation(u), y = [
                    [
                        _.x,
                        _.y,
                        Math.min(f || 0, m || 0, g || 0, v || 0)
                    ],
                    [
                        p.x,
                        p.y,
                        Math.max(f || 0, m || 0, g || 0, v || 0)
                    ]
                ];
                let x = e.da.fromPoints(y);
                const b = a.getWorldToCameraMatrix(), w = e.bm(new Float64Array(16), b);
                x = e.da.applyTransform(x, b);
                const T = this._extendAABB(x, a, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                x = T;
                const E = .5 * e.aw([], x.max, x.min)[2], S = this._minimumAABBFrustumDistance(a, x), I = [
                    0,
                    0,
                    1,
                    0
                ];
                e.aD(I, I, b), e.f4(I, I);
                const C = e.c6([], I, S + E), R = e.d9([], x.center, C);
                e.ag(x.center, x.center, w), e.ag(R, R, w);
                const A = a.unproject(new e.P(x.center[0], x.center[1])), D = e.f5(a.projection, A), L = Math.pow(2, D), P = Math.min(a._zoomFromMercatorZ(R[2] * a.pixelsPerMeter * L / a.worldSize), l.maxZoom);
                return a.mercatorFromTransition && P < .5 * (e.c$ + e.cM) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = P, this._cameraForBounds(a, i, o, s, r, n)) : {
                    center: A,
                    zoom: P,
                    bearing: s,
                    pitch: r
                };
            }
            fitBounds(e, t1, i) {
                const o = this.cameraForBounds(e, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, s, r) {
                const n = e.P.convert(t1), a = e.P.convert(i), l = new e.P(Math.min(n.x, a.x), Math.min(n.y, a.y)), c = new e.P(Math.max(n.x, a.x), Math.max(n.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n, a)) return this;
                const h = this.transform.pointLocation3D(l), d = this.transform.pointLocation3D(c), u = this.transform.pointLocation3D(new e.P(l.x, c.y)), _ = this.transform.pointLocation3D(new e.P(c.x, l.y)), p = [
                    Math.min(h.lng, d.lng, u.lng, _.lng),
                    Math.min(h.lat, d.lat, u.lat, _.lat)
                ], f = [
                    Math.max(h.lng, d.lng, u.lng, _.lng),
                    Math.max(h.lat, d.lat, u.lat, _.lat)
                ], m = s && s.pitch ? s.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, f, o, m, s);
                return this._fitInternal(g, s, r);
            }
            _fitInternal(e, t1, i) {
                return e ? (t1 = Object.assign(e, t1)).linear ? this.easeTo(t1, i) : this.flyTo(t1, i) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let s = !1, r = !1, n = !1;
                "zoom" in t1 && o.zoom !== +t1.zoom && (s = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e.aU.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (r = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (n = !0, o.pitch = +t1.pitch);
                const a = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !o.isPaddingEqual(a)) {
                    if (!1 === t1.retainPadding) {
                        const e = o.clone();
                        e.padding = a, o.setLocationAtPoint(o.center, e.centerPoint);
                    } else o.padding = a;
                }
                return t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e.A("movestart", i)).fire(new e.A("move", i)), s && this.fire(new e.A("zoomstart", i)).fire(new e.A("zoom", i)).fire(new e.A("zoomend", i)), r && this.fire(new e.A("rotatestart", i)).fire(new e.A("rotate", i)).fire(new e.A("rotateend", i)), n && this.fire(new e.A("pitchstart", i)).fire(new e.A("pitch", i)).fire(new e.A("pitchend", i)), this.fire(new e.A("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e.w(Ml), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e.w(Ml), this;
                this.stop();
                const s = o.zoom, r = o.pitch, n = o.bearing;
                o.setFreeCameraOptions(t1);
                const a = s !== o.zoom, l = r !== o.pitch, c = n !== o.bearing;
                return this.fire(new e.A("movestart", i)).fire(new e.A("move", i)), a && this.fire(new e.A("zoomstart", i)).fire(new e.A("zoom", i)).fire(new e.A("zoomend", i)), c && this.fire(new e.A("rotatestart", i)).fire(new e.A("rotate", i)).fire(new e.A("rotateend", i)), l && this.fire(new e.A("pitchstart", i)).fire(new e.A("pitch", i)).fire(new e.A("pitchend", i)), this.fire(new e.A("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e.eY
                }, t1)).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : n, d = this._extendPadding(t1.padding), u = e.P.convert(t1.offset);
                let _, p, f;
                if ("globe" === o.projection.name) {
                    const i = e.af.fromLngLat(o.center), s = u.rotate(-o.angle);
                    i.x += s.x / o.worldSize, i.y += s.y / o.worldSize;
                    const r = i.toLngLat(), n = e.aU.convert(t1.center || r);
                    this._normalizeCenter(n), _ = o.centerPoint.add(s), p = new e.P(i.x, i.y).mult(o.worldSize), f = new e.P(e.aG(n.lng), e.aK(n.lat)).mult(o.worldSize).sub(p);
                } else {
                    _ = o.centerPoint.add(u);
                    const i = o.pointLocation(_), s = e.aU.convert(t1.center || i);
                    this._normalizeCenter(s), p = o.project(i), f = o.project(s).sub(p);
                }
                const m = o.zoomScale(l - s);
                let g, v;
                t1.around && (g = e.aU.convert(t1.around), v = o.locationPoint(g));
                const y = this._zooming || l !== s, x = this._rotating || r !== c, b = this._pitching || h !== n, w = !o.isPaddingEqual(d), T = !1 === t1.retainPadding ? o.clone() : o, E = (o)=>(E)=>{
                        if (y && (o.zoom = e.al(s, l, E)), x && (o.bearing = e.al(r, c, E)), b && (o.pitch = e.al(n, h, E)), w && (T.interpolatePadding(a, d, E), _ = T.centerPoint.add(u)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e = o.zoomScale(o.zoom - s), t1 = l > s ? Math.min(2, m) : Math.max(.5, m), i = Math.pow(t1, 1 - E), r = o.unproject(p.add(f.mult(E * i)).mult(e));
                            o.setLocationAtPoint(o.renderWorldCopies ? r.wrap() : r, _);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(E, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                const S = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = y, this._rotating = x, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, S), this._ease(E(o), (e)=>{
                    "sea" === o.cameraElevationReference && o.recenterOnTerrain(), this._afterEase(i, e);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e.A("movestart", t1)), this._zooming && !o.zooming && this.fire(new e.A("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e.A("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e.A("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e.A("move", t1)), this._zooming && this.fire(new e.A("zoom", t1)), this._rotating && this.fire(new e.A("rotate", t1)), this._pitching && this.fire(new e.A("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, s = this._rotating, r = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e.A("zoomend", t1)), s && this.fire(new e.A("rotateend", t1)), r && this.fire(new e.A("pitchend", t1)), this.fire(new e.A("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const o = e.aI(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e.eY
                }, t1);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), n = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? e.aB(+t1.zoom, o.minZoom, o.maxZoom) : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : n, d = this._extendPadding(t1.padding), u = o.zoomScale(l - s), _ = e.P.convert(t1.offset);
                let p = o.centerPoint.add(_);
                const f = o.pointLocation(p), m = e.aU.convert(t1.center || f);
                this._normalizeCenter(m);
                const g = o.project(f), v = o.project(m).sub(g);
                let y = t1.curve;
                const x = Math.max(o.width, o.height), b = x / u, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e.aB(Math.min(t1.minZoom, s, l), o.minZoom, o.maxZoom), r = x / o.zoomScale(i - s);
                    y = Math.sqrt(r / w * 2);
                }
                const T = y * y;
                function E(e) {
                    const t1 = (b * b - x * x + (e ? -1 : 1) * T * T * w * w) / (2 * (e ? b : x) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function S(e) {
                    return (Math.exp(e) - Math.exp(-e)) / 2;
                }
                function I(e) {
                    return (Math.exp(e) + Math.exp(-e)) / 2;
                }
                const C = E(0);
                let R = function(e) {
                    return I(C) / I(C + y * e);
                }, A = function(e) {
                    var t1;
                    return x * ((I(C) * (S(t1 = C + y * e) / I(t1)) - S(C)) / T) / w;
                }, D = (E(1) - C) / y;
                if (Math.abs(w) < 1e-6 || !isFinite(D)) {
                    if (Math.abs(x - b) < 1e-6) return this.easeTo(t1, i);
                    const e = b < x ? -1 : 1;
                    D = Math.abs(Math.log(b / x)) / y, A = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e * y * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * D / ("screenSpeed" in t1 ? +t1.screenSpeed / y : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const L = r !== c, P = h !== n, O = !o.isPaddingEqual(d), z = !1 === t1.retainPadding ? o.clone() : o, M = (o)=>(u)=>{
                        const f = u * D, y = 1 / R(f);
                        o.zoom = 1 === u ? l : s + o.scaleZoom(y), L && (o.bearing = e.al(r, c, u)), P && (o.pitch = e.al(n, h, u)), O && (z.interpolatePadding(a, d, u), p = z.centerPoint.add(_));
                        const x = 1 === u ? m : o.unproject(g.add(v.mult(A(f))).mult(y));
                        return o.setLocationAtPoint(o.renderWorldCopies ? x.wrap() : x, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(M, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                return this._zooming = !0, this._rotating = L, this._pitching = P, this._padding = O, this._prepareEase(i, !1), this._ease(M(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e) {}
            _cancelRenderFrame(e) {}
            _stop(e, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e = this._onEaseEnd;
                    this._onEaseEnd = void 0, e.call(this, t1);
                }
                if (!e) {
                    const e = this.handlers;
                    e && e.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e.o.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e.o.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e.bU(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e.lng - t1.center.lng;
                e.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e.o.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), s = [], r = e(i.clone());
                for(let e = 0; e <= o; e++){
                    const t1 = r(e / o);
                    s.push(t1.clone());
                }
                return s;
            }
            _preloadTiles(e, t1) {}
        }
        class kl {
            constructor(t1 = {}){
                this.options = t1, e.aZ([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e) {
                const t1 = this.options && this.options.compact, i = e._getUIString("AttributionControl.ToggleAttribution");
                this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const o = l("span", "mapboxgl-ctrl-icon", this._compactButton);
                return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e.e.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e, t1, o)=>(t1.value && (e += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e), "?");
                    t1.href = `${e.e.FEEDBACK_URL}/${o}#${Fa(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e) {
                !e || ("source" !== e.dataType || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType) && "style" !== e.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e = [];
                if (this._map.style.stylesheet) {
                    const e = this._map.style.stylesheet;
                    this.styleOwner = e.owner, this.styleId = e.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e.indexOf(t1.attribution) < 0 && e.push(t1.attribution);
                    }
                }
                e.sort((e, t1)=>e.length - t1.length), e = e.filter((t1, i)=>{
                    for(let o = i + 1; o < e.length; o++)if (e[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = [
                    ...this.options.customAttribution,
                    ...e
                ] : e.unshift(this.options.customAttribution));
                const i = e.map((e)=>(function(e) {
                        const t1 = (new DOMParser).parseFromString(e, "text/html");
                        return Array.from(t1.body.querySelectorAll("*")).reverse().forEach((e)=>{
                            const i = e.textContent || "";
                            if ("A" !== e.tagName) return void e.replaceWith(...e.childNodes);
                            const o = e.getAttribute("href");
                            if (!o || !/^(https?:|mailto:)/i.test(o)) return void e.replaceWith(t1.createTextNode(i));
                            const s = t1.createElement("a");
                            s.href = o, s.textContent = i, s.rel = "noopener nofollow";
                            const r = e.getAttribute("class");
                            r && (s.className = r), e.replaceWith(s);
                        }), t1.body.innerHTML;
                    })(e)).join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class Bl {
            constructor(){
                e.aZ([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e) {
                this._map = e, this._container = l("div", "mapboxgl-ctrl");
                const t1 = l("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e) {
                e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e = this._map.style._sourceCaches;
                if (0 === Object.entries(e).length) return !0;
                for(const t1 in e){
                    const i = e[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e = this._container.children;
                if (e.length) {
                    const t1 = e[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class Nl {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e) return void (t1.cancelled = !0);
            }
            run(e = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class Ul {
            constructor(e){
                this.jumpTo(e);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e.dF((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e) {
                return e >= this._startTime && e <= this._endTime;
            }
            jumpTo(e) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e, this._end = e;
            }
            easeTo(e, t1, i) {
                this._start = this.getValue(t1), this._end = e, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const jl = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class Vl extends e.A {
            constructor(e, t1, i, o){
                const { point: s, lngLat: r, originalEvent: n, target: a } = e;
                super(e.type, {
                    point: s,
                    lngLat: r,
                    originalEvent: n,
                    target: a
                }), this.preventDefault = ()=>{
                    e.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = o;
            }
        }
        class Gl {
            constructor(e){
                this.map = e, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const o = i.filter;
                let s = i.type;
                o && this.filters.set(t1, e.b7(o)), "mouseover" === s && (s = "mouseenter"), "mouseout" === s && (s = "mouseleave");
                const r = this.interactionsByType.get(s) || new Map;
                "mouseenter" === s || "mouseleave" === s ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === r.size && this.map.on(s, this.handleType), 0 === r.size && this.interactionsByType.set(s, r), r.set(t1, i), this.typeById.set(t1, s);
            }
            get(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e) : void 0;
            }
            remove(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                this.typeById.delete(e), this.filters.delete(e);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e, t1) {
                const i = [];
                for (const [e, o] of t1)o.target && i.push({
                    targetId: e,
                    target: o.target,
                    filter: this.filters.get(e)
                });
                return this.map.style.queryRenderedTargets(e, i, this.map.transform);
            }
            handleMove(e) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e.type = "mouseenter", this.handleType(e, t1));
                const i = new Map;
                for (const [e, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e) || i.set(t1.id, t1);
                i.size && (e.type = "mouseleave", this.handleType(e, Array.from(i.values())));
            }
            handleOut(e) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e })=>e);
                t1.length && (e.type = "mouseleave", this.handleType(e, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const o = "mouseenter" === t1.type;
                if (o && !this.interactionsByType.has(t1.type)) return void e.w("mouseenter interaction required for mouseleave to work.");
                const s = Array.from(this.interactionsByType.get(t1.type)).reverse(), r = !!i;
                i = i || this.queryTargets(t1.point, s);
                let n = !1;
                const a = new Set;
                for (const l of i){
                    for (const [i, c] of s){
                        if (!c.target) continue;
                        const s = l.variants ? l.variants[i] : null;
                        if (s) {
                            for (const h of s){
                                if (vt(h, l, a, i)) continue;
                                const s = new e.dA(l, h), d = gt(h, l, i);
                                r && void 0 !== s.id && (s.state = this.map.getFeatureState(s));
                                const u = o ? this.prevHoveredFeatures.get(d) : null, _ = new Vl(t1, i, c, s), p = u ? u.stop : c.handler(_);
                                if (o && this.hoveredFeatures.set(d, {
                                    feature: l,
                                    stop: p
                                }), !1 !== p) {
                                    n = !0;
                                    break;
                                }
                            }
                            if (n) break;
                        }
                    }
                    if (n) break;
                }
                if (!n) for (const [e, i] of s){
                    const { handler: o, target: s } = i;
                    if (!s && !1 !== o(new Vl(t1, e, i, null))) break;
                }
            }
        }
        function Hl(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e = new Set(t1), o = new Set(i);
                return e.size === o.size && t1.every((e)=>o.has(e));
            }
            return e.bz(t1, i);
        }
        const ql = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1,
            spriteFormat: "auto"
        }, Zl = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class Wl {
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new al({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new ll({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e.aZ([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e, t1) {
                this.mouseRotate.mousedown(e, t1), this.mousePitch && this.mousePitch.mousedown(e, t1), _();
            }
            move(e, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e, t1), s = o && o.bearingDelta;
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e, t1), s = o && o.pitchDelta;
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const e = this.element;
                e.removeEventListener("mousedown", this.mousedown), e.removeEventListener("touchstart", this.touchstart), e.removeEventListener("touchmove", this.touchmove), e.removeEventListener("touchend", this.touchend), e.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e) {
                this.down(Object.assign({}, e, {
                    type: e.type,
                    ctrlKey: !0,
                    preventDefault: ()=>e.preventDefault()
                }), g(this.element, e)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e) {
                this.move(e, g(this.element, e));
            }
            mouseup(e) {
                this.mouseRotate.mouseupWindow(e), this.mousePitch && this.mousePitch.mouseupWindow(e), this.offTemp();
            }
            touchstart(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e.preventDefault()
                }, this._startPos));
            }
            touchmove(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e.targetTouches)[0], this.move({
                    buttons: 1,
                    preventDefault: ()=>e.preventDefault()
                }, this._lastPos));
            }
            touchend(e) {
                0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function $l(t1, i, o) {
            if (t1 = new e.aU(t1.lng, t1.lat), i) {
                const s = new e.aU(t1.lng - 360, t1.lat), r = new e.aU(t1.lng + 360, t1.lat), n = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), a = o.locationPoint3D(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint3D(s).distSqr(i) < a && (l || Math.abs(s.lng - o.center.lng) < n) ? t1 = s : o.locationPoint3D(r).distSqr(i) < a && (l || Math.abs(r.lng - o.center.lng) < n) && (t1 = r);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e = o.locationPoint3D(t1);
                if (e.x >= 0 && e.y >= 0 && e.x <= o.width && e.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const Xl = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        }, Kl = {
            rotation: 0,
            rotationAlignment: "auto",
            pitchAlignment: "auto",
            occludedOpacity: .2,
            altitude: 0
        };
        class Yl extends e.E {
            constructor(t1, i){
                super(), (t1 instanceof HTMLElement || i) && (t1 = Object.assign({
                    element: t1
                }, i)), e.aZ([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this);
                const { anchor: o = "center", color: s = "#3FB1CE", scale: r = 1, draggable: n = !1, clickTolerance: a = 0, rotation: l = Kl.rotation, rotationAlignment: c = Kl.rotationAlignment, pitchAlignment: h = Kl.pitchAlignment, occludedOpacity: d = Kl.occludedOpacity, altitude: u = Kl.altitude } = t1 || {};
                this._anchor = o, this._color = s, this._scale = r, this._draggable = n, this._clickTolerance = a, this._rotation = l, this._rotationAlignment = c, this._pitchAlignment = h, this._occludedOpacity = d, this._altitude = u, this._state = "inactive", this._isDragging = !1, this._updateMoving = ()=>this._update(!0), t1 && t1.element ? (this._element = t1.element, this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    0
                ])) : (this._defaultMarker = !0, this._element = this._createDefaultMarker(), this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    -14
                ])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e)=>{
                    e.preventDefault();
                }), this._element.addEventListener("mousedown", (e)=>{
                    e.preventDefault();
                });
                const _ = this._element.classList;
                for(const e in Xl)_.remove(`mapboxgl-marker-anchor-${e}`);
                _.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const p = t1 && t1.className ? t1.className.trim().split(/\s+/) : [];
                _.add(...p), this._popup = null;
            }
            _createDefaultMarker() {
                const e = l("div"), t1 = c("svg", {
                    display: "block",
                    height: 41 * this._scale + "px",
                    width: 27 * this._scale + "px",
                    viewBox: "0 0 27 41"
                }, e);
                if (0 === this._altitude) {
                    const e = c("radialGradient", {
                        id: "shadowGradient"
                    }, c("defs", {}, t1));
                    c("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, e), c("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, e), c("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, t1);
                }
                return c("path", {
                    fill: this._color,
                    d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                }, t1), c("path", {
                    opacity: .25,
                    d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                }, t1), c("circle", {
                    fill: "white",
                    cx: 13.5,
                    cy: 13.5,
                    r: 5.5
                }, t1), e;
            }
            addTo(e) {
                return e === this._map || (this.remove(), this._map = e, e.getCanvasContainer().appendChild(this._element), e.on("move", this._updateMoving), e.on("moveend", this._update), e.on("remove", this._clearFadeTimer), e._addMarker(this), this.setDraggable(this._draggable), this._update(), e.on("click", this._onMapClick)), this;
            }
            remove() {
                const e = this._map;
                return e && (e.off("click", this._onMapClick), e.off("move", this._updateMoving), e.off("moveend", this._update), e.off("mousedown", this._addDragHandler), e.off("touchstart", this._addDragHandler), e.off("mouseup", this._onUp), e.off("touchend", this._onUp), e.off("mousemove", this._onMove), e.off("touchmove", this._onMove), e.off("remove", this._clearFadeTimer), e._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e.aU.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            setAltitude(e) {
                return e === this._altitude || (this._defaultMarker && (0 === this._altitude && 0 !== e || 0 !== this._altitude && 0 === e) && (this._element = this._createDefaultMarker()), this._altitude = e || Kl.altitude, this._update()), this;
            }
            getAltitude() {
                return this._altitude;
            }
            getElement() {
                return this._element;
            }
            setPopup(e) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
                    if (!("offset" in e.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e, e._marker = this, e._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e) {
                const t1 = e.code, i = e.charCode || e.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e) {
                const t1 = e.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e = this._popup;
                return e ? (e.isOpen() ? (e.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e = this._map, t1 = this._pos;
                if (!e || !t1) return !1;
                const i = e.unproject(t1, this._altitude), o = e.getFreeCameraOptions();
                if (!o.position) return !1;
                const s = o.position.toLngLat();
                return s.distanceTo(i) < .9 * s.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i, this._altitude);
                let s;
                t1._showingGlobe() && e.f8(t1.transform, this._lngLat) ? s = 0 : (s = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (s *= this._occludedOpacity)), this._element.style.opacity = `${s}`, this._element.style.pointerEvents = s > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(s), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e = this._pos;
                if (!e || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e.x}px,${e.y}px)\n            ${Xl[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e = i.getPitch();
                    return e ? `rotateX(${e}deg)` : "";
                }
                const s = e.cY(e.f9(i.transform, this._lngLat)), r = t1.sub(e.fa(i.transform)), n = Math.abs(r.x) + Math.abs(r.y);
                if (0 === n) return "";
                const a = s / n;
                return `rotateX(${-r.y * a}deg) rotateY(${r.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const s = this.getRotationAlignment();
                if ("map" === s) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e.aU(this._lngLat.lng, this._lngLat.lat + .001), this._altitude), s = i.project(new e.aU(this._lngLat.lng, this._lngLat.lat - .001), this._altitude).sub(t1);
                        o = e.cY(Math.atan2(s.y, s.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === s) {
                    const s = e.ai(4, 6, i.getZoom()), r = e.fa(i.transform);
                    r.y += s * i.transform.height;
                    const n = t1.sub(r), a = e.cY(Math.atan2(n.y, n.x));
                    o = (a > 90 ? a - 270 : a + 90) * (1 - s);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(e) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = $l(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat, this._altitude), !0 === e ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.getTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e.P.convert(t1), this._update(), this;
            }
            addClassName(e) {
                return this._element.classList.add(e), this;
            }
            removeClassName(e) {
                return this._element.classList.remove(e), this;
            }
            toggleClassName(e) {
                return this._element.classList.toggle(e);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, s = this._positionDelta;
                if (o && s) {
                    if (!this._isDragging) {
                        const e = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(s), this._lngLat = i.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.A("dragstart"))), this.fire(new e.A("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.A("dragend")), this._state = "inactive";
            }
            _addDragHandler(e) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(i), this._pointerdownPos = e.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e) {
                this._draggable = !!e;
                const t1 = this._map;
                return t1 && (e ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e) {
                return this._rotation = e || Kl.rotation, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e) {
                return this._rotationAlignment = e || Kl.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e) {
                return this._pitchAlignment = e || Kl.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e) {
                return this._occludedOpacity = e || Kl.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const Jl = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1,
            showButton: !0,
            followUserLocation: !0
        }, Ql = {
            maxWidth: 100,
            unit: "metric"
        }, ec = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, tc = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            altitude: 0
        }, ic = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function oc(t1 = new e.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e.P(0, t1);
                    case "top-left":
                        return new e.P(o, o);
                    case "top-right":
                        return new e.P(-o, o);
                    case "bottom":
                        return new e.P(0, -t1);
                    case "bottom-left":
                        return new e.P(o, -o);
                    case "bottom-right":
                        return new e.P(-o, -o);
                    case "left":
                        return new e.P(t1, 0);
                    case "right":
                        return new e.P(-t1, 0);
                }
                return new e.P(0, 0);
            }
            return t1 instanceof e.P || Array.isArray(t1) ? e.P.convert(t1) : e.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const sc = {
            version: t1,
            supported: a.supported,
            setRTLTextPlugin: e.fe,
            getRTLTextPluginStatus: e.fd,
            Map: class extends Fl {
                constructor(t1){
                    o.mark(i.create);
                    const s = t1;
                    if (null != (t1 = Object.assign({}, ql, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e.f6(window) && (t1.antialias = !1, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new ao(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies, null, null), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Nl, this._domRenderTaskQueue = new Nl, this._controls = [], this._markers = [], this._popups = [], this._mapId = e.b3(), this._locale = Object.assign({}, jl, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new Ul(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = t1.scaleFactor, this._requestManager = new T(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? Object.assign({}, t1.contextCreateOptions) : {}, "string" == typeof t1.container) {
                        const e = document.getElementById(t1.container);
                        if (!e) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = t1.spriteFormat, e.aZ([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new zl(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, (t1.style || !t1.testMode) && this.setStyle(t1.style || e.e.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), t1.hash && (this._hash = new Ma("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == s.center && null == s.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const e = t1.bounds;
                        e && (this.resize(), this.fitBounds(e, Object.assign({}, t1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new kl({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new Bl, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent(), this._postStyleWithAppearanceEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e.A(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e.A(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new Gl(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e.z(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const s = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? s.insertBefore(o, s.firstChild) : s.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e.z(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e) {
                    return this._controls.indexOf(e) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e.A("movestart", t1)).fire(new e.A("move", t1)), this.fire(new e.A("resize", t1)), i && this.fire(new e.A("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e.aJ.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e) {
                    return this._scaleFactor = e, this.painter.scaleFactor = e, this.style && this.style._setLabelPlacementStale(), this.style._updateFilteredLayers((e)=>"symbol" === e.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e) {
                    return this.transform.renderWorldCopies = e, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e) {
                    return "auto" === e ? navigator.language : Array.isArray(e) ? 0 === e.length ? void 0 : e.map((e)=>"auto" === e ? navigator.language : e) : e;
                }
                setLanguage(e) {
                    const t1 = this._parseLanguage(e);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e of this._controls)e._setLanguage && e._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e) {
                    return this.style && e !== this._worldview ? (this._worldview = e, this._styleDirty = !0, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e) {
                    return this._lazyInitEmptyStyle(), e ? "string" == typeof e && (e = {
                        name: e
                    }) : e = null, this._useExplicitProjection = !!e, this._prioritizeAndUpdateProjection(e, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e.cM ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e.cM && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(!0));
                }
                _prioritizeAndUpdateProjection(e, t1) {
                    return this._updateProjection(e || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    const o = this.transform.mercatorFromTransition;
                    i = "globe" === t1.name && this.transform.zoom >= e.cM ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate();
                    const s = "mercator" === this.transform.getProjection().name && o !== this.transform.mercatorFromTransition;
                    return (i || s) && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1, i) {
                    return this.transform.locationPoint3D(e.aU.convert(t1), i);
                }
                unproject(t1, i) {
                    return this.transform.pointLocation3D(e.P.convert(t1), i);
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e, t1, i) {
                    const o = (e)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const o = t1.filter((e)=>this.getLayer(e));
                            i = o.length ? this.queryRenderedFeatures(e, {
                                layers: o
                            }) : [];
                        } else i = this.queryRenderedFeatures(e, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e || "mouseover" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            const r = o(t1.point);
                            r.length ? s || (s = !0, i.call(this, new qa(e, this, t1.originalEvent, {
                                features: r
                            }))) : s = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: ()=>{
                                    s = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e || "mouseout" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            o(t1.point).length ? s = !0 : s && (s = !1, i.call(this, new qa(e, this, t1.originalEvent)));
                        }, n = (t1)=>{
                            s && (s = !1, i.call(this, new qa(e, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: n
                            }
                        };
                    }
                    {
                        const s = (e)=>{
                            const t1 = o(e.point);
                            t1.length && (e.features = t1, i.call(this, e), delete e.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e]: s
                            }
                        };
                    }
                }
                on(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(o);
                    for(const e in o.delegates)this.on(e, o.delegates[e]);
                    return this;
                }
                once(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    for(const e in o.delegates)this.once(e, o.delegates[e]);
                    return this;
                }
                off(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._delegatedListeners ? this._delegatedListeners[e] : void 0;
                    return o && ((e)=>{
                        for(let o = 0; o < e.length; o++){
                            const s = e[o];
                            if (s.listener === i && Hl(s.targets, t1)) {
                                for(const e in s.delegates)this.off(e, s.delegates[e]);
                                return e.splice(o, 1), this;
                            }
                        }
                    })(o), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e.concat(i);
                    }
                    let o = !0;
                    if (i.target && (o = this._isTargetValid(i.target), o && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let s = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e of i.layers)if (!this._isValidId(e)) {
                            s = !1;
                            break;
                        }
                        if (s && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let r = [];
                    return s && (r = r.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), o && (r = r.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), r;
                }
                querySourceFeatures(e, t1) {
                    return !e || "string" == typeof e && !this._isValidId(e) ? [] : this.style.querySourceFeatures(e, t1);
                }
                queryRasterValue(e, t1, i) {
                    return this._isValidId(e) ? this.style.queryRasterValue(e, t1, i) : Promise.resolve(null);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t1));
                }
                addInteraction(e, t1) {
                    return this._interactions.add(e, t1), this;
                }
                removeInteraction(e) {
                    return this._interactions.remove(e), this;
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(e) {
                    return this._cooperativeGestures = e, this;
                }
                setStyle(t1, i) {
                    return i = Object.assign({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i), this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t1, (o, s)=>{
                        if (o) {
                            const s = "string" == typeof o ? o : o instanceof Error ? o.message : o.error;
                            e.w(`Unable to perform style diff: ${s}. Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                        } else s && this._update(!0);
                    }, ()=>this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e) {
                    const t1 = this._locale[e];
                    if (null == t1) throw new Error(`Missing UI string '${e}'`);
                    return t1;
                }
                _updateStyle(e, t1) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e) {
                        const i = Object.assign({}, t1);
                        t1 && t1.config && (i.initialConfig = t1.config, delete i.config), this.style = new Po(this, i).load(e), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new Po(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e.z(new Error("IDs can't be empty."))), !1) : !e.du(t1) || (this.fire(new e.z(new Error(`IDs can't contain special symbols: "${t1}".`))), !1);
                }
                _isTargetValid(e) {
                    return "featuresetId" in e ? this._isValidId("importId" in e ? e.importId : e.featuresetId) : "layerId" in e && this._isValidId(e.layerId);
                }
                _areTargetsValid(e) {
                    if (Array.isArray(e)) {
                        for (const t1 of e)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e);
                }
                addSource(e, t1) {
                    return this._isValidId(e) ? (this._lazyInitEmptyStyle(), this.style.addSource(e, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e) {
                    return !!this._isValidId(e) && !!this.style && this.style._isSourceCacheLoaded(e);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                addSourceType(e, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e, t1, i);
                }
                removeSource(e) {
                    return this._isValidId(e) ? (this.style.removeSource(e), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e) {
                    return this._isValidId(e) ? this.style.getOwnSource(e) : null;
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: s = !1, stretchX: r, stretchY: n, content: a } = {}) {
                    this._lazyInitEmptyStyle();
                    const l = e.I.from(t1);
                    if (i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: t1, height: c, data: h } = e.o.getImageData(i);
                        this.style.addImage(l, {
                            data: new e.q({
                                width: t1,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: n,
                            content: a,
                            sdf: s,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e.z(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: c, height: h } = i, d = i;
                        this.style.addImage(l, {
                            data: new e.q({
                                width: c,
                                height: h
                            }, new Uint8Array(d.data)),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: n,
                            content: a,
                            sdf: s,
                            usvg: !1,
                            version: 0,
                            userImage: d
                        }), d.onAdd && d.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const o = e.I.from(t1), s = this.style.getImage(o);
                    if (!s) return void this.fire(new e.z(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const r = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e.o.getImageData(i) : i, { width: n, height: a, data: l } = r;
                    if (void 0 === n || void 0 === a) return void this.fire(new e.z(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (n !== (s.usvg ? s.icon.usvg_tree.width : s.data.width) || a !== (s.usvg ? s.icon.usvg_tree.height : s.data.height)) return void this.fire(new e.z(new Error(`The width and height of the updated image (${n}, ${a})\n                must be that same as the previous version of the image\n                (${s.data.width}, ${s.data.height})`)));
                    const c = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let h = !1;
                    s.usvg ? (s.data = new e.q({
                        width: n,
                        height: a
                    }, new Uint8Array(l)), s.usvg = !1, s.icon = void 0, h = !0) : s.data.replace(l, c), this.style.updateImage(o, s, h);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(e.I.from(t1)) : (this.fire(new e.z(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(e.I.from(t1));
                }
                loadImage(t1, i) {
                    e.n(this._requestManager.transformRequest(t1, e.R.Image), (e, t1)=>{
                        i(e, t1);
                    });
                }
                listImages() {
                    return this.style.listImages().map((e)=>e.name);
                }
                addModel(e, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e.z(new Error("Missing required model id"))), !1);
                }
                removeModel(e) {
                    this.style.removeModel(e);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e, t1) {
                    return this._isValidId(e.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e, t1), this._update(!0)) : this;
                }
                getSlot(e) {
                    const t1 = this.getLayer(e);
                    return t1 && t1.slot || null;
                }
                setSlot(e, t1) {
                    return this.style.setSlot(e, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(t1, i) {
                    return this.style.addImport(t1, i).catch((t1)=>this.fire(new e.z(new Error("Failed to add import", t1)))), this;
                }
                updateImport(e, t1) {
                    return "string" != typeof t1 && t1.id !== e ? (this.removeImport(e), this.addImport(t1)) : (this.style.updateImport(e, t1), this._update(!0));
                }
                removeImport(e) {
                    return this.style.removeImport(e), this;
                }
                moveImport(e, t1) {
                    return this.style.moveImport(e, t1), this._update(!0);
                }
                moveLayer(e, t1) {
                    return this._isValidId(e) ? (this.style.moveLayer(e, t1), this._update(!0)) : this;
                }
                removeLayer(e) {
                    return this._isValidId(e) ? (this.style.removeLayer(e), this._update(!0)) : this;
                }
                getLayer(e) {
                    if (!this._isValidId(e)) return null;
                    const t1 = this.style.getOwnLayer(e);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e, t1, i) {
                    return this._isValidId(e) ? (this.style.setLayerZoomRange(e, t1, i), this._update(!0)) : this;
                }
                setFilter(e, t1, i = {}) {
                    return this._isValidId(e) ? (this.style.setFilter(e, t1, i), this._update(!0)) : this;
                }
                getFilter(e) {
                    return this._isValidId(e) ? this.style.getFilter(e) : null;
                }
                setPaintProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setPaintProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getPaintProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getPaintProperty(e, t1) : null;
                }
                setLayoutProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setLayoutProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getLayoutProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getLayoutProperty(e, t1) : null;
                }
                setLayerProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? ("appearances" === t1 && this._postAddingAppearancesToStyleEvent(), this.style.setLayerProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getGlyphsUrl() {
                    return this.style.getGlyphsUrl();
                }
                setGlyphsUrl(e) {
                    return this.style.setGlyphsUrl(e), this._update(!0);
                }
                getSchema(e) {
                    return this.style.getSchema(e);
                }
                setSchema(e, t1) {
                    return this.style.setSchema(e, t1), this._update(!0);
                }
                getConfig(e) {
                    return this.style.getConfig(e);
                }
                setConfig(e, t1) {
                    return this.style.setConfig(e, t1), this._update(!0);
                }
                getConfigProperty(e, t1) {
                    return this.style.getConfigProperty(e, t1);
                }
                setConfigProperty(e, t1, i) {
                    return this.style.setConfigProperty(e, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e) {
                    return this.style.getFeaturesetDescriptors(e);
                }
                setLights(e) {
                    if (this._lazyInitEmptyStyle(), e && 1 === e.length && "flat" === e[0].type) {
                        const t1 = e[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e = this.style.getLights() || [];
                    return 0 === e.length && e.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e;
                }
                setLight(e, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e) {
                    return this._lazyInitEmptyStyle(), !e && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e), this._update(!0);
                }
                setImportColorTheme(e, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e, t1), this._update(!0);
                }
                setCamera(e) {
                    return this.style.setCamera(e), this._triggerCameraUpdate(e);
                }
                getNearClipOffset() {
                    return this.transform.nearClipOffset;
                }
                setNearClipOffset(e) {
                    const t1 = this.transform.nearClipOffset !== e;
                    return this.transform.nearClipOffset = e, this._update(t1);
                }
                _triggerCameraUpdate(e) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.aU.convert(t1), this.transform) : 0;
                }
                setFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.setFeatureState(e, t1), this._update());
                }
                removeFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.removeFeatureState(e, t1), this._update());
                }
                getFeatureState(e) {
                    return e.source && !this._isValidId(e.source) ? null : this.style.getFeatureState(e);
                }
                _selectIndoorFloor(e) {
                    this.style.indoorManager.selectFloor(e);
                }
                _setIndoorActiveFloorsVisibility(e) {
                    this.style.indoorManager.setActiveFloorsVisibility(e);
                }
                getIndoorTileOptions(e, t1) {
                    return this.style.isIndoorEnabled() ? this.style.indoorManager.getIndoorTileOptions(e, t1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, o, s, r = this._container;
                    for(; r && (!o || !s);){
                        const e = window.getComputedStyle(r).transform;
                        e && "none" !== e && (i = e.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (s = i[3])), r = r.parentElement;
                    }
                    this._containerWidth = o ? Math.abs(e / o) : e, this._containerHeight = s ? Math.abs(t1 / s) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e = this._container;
                    e.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e);
                    this._canvas = l("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = l("div", "mapboxgl-control-container", e), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e)=>{
                        o[e] = l("div", `mapboxgl-ctrl-${e}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e.o.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e) {
                    this._markers.push(e);
                }
                _removeMarker(e) {
                    const t1 = this._markers.indexOf(e);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e) {
                    this._popups.push(e);
                }
                _removePopup(e) {
                    const t1 = this._popups.indexOf(e);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = Object.assign({}, a.supported.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), i = this._canvas.getContext("webgl2", t1);
                    i ? (Z(i, !0), this.painter = new Oa(i, this._contextCreateOptions, this.transform, this._scaleFactor, this._worldview), this.on("data", (e)=>{
                        if ("source" === e.dataType) {
                            const t1 = this.transform.elevation ? this.transform.elevation._source() : null;
                            t1 && e.sourceCacheId === t1.id && this.style && this.style._setLabelPlacementStale(), this.painter.setTileLoadedFlag(!0);
                        }
                    }), e.k.testSupport(i)) : this.fire(new e.z(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.A("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.clearLayers(), this.style.imageManager.destroyAtlasTextures(), this.style.imageManager.imageAtlasCache.destroyTextures(), this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e.A("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e) {
                    if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e) {
                    return this.style ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e) {
                    return this._update(), this._renderTaskQueue.add(e);
                }
                _cancelRenderFrame(e) {
                    this._renderTaskQueue.remove(e);
                }
                _requestDomTask(e) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e() : this._domRenderTaskQueue.add(e);
                }
                _render(t1) {
                    let s;
                    this.fire(new e.A("renderstart")), ++this._frameId;
                    const r = this.painter.context.extTimerQuery, n = e.o.now(), a = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (s = a.createQuery(), a.beginQuery(r.TIME_ELAPSED_EXT, s)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const l = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e.o.now(), s = new e.ad(t1, {
                            now: o,
                            fadeDuration: l,
                            pitch: i,
                            transition: this.style.transition,
                            worldview: this._worldview
                        });
                        this.style.update(s);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let c = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), c = this._updateAverageElevation(n), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : c = this._updateAverageElevation(n), this.style && (this._placementDirty = this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, this.painter.replacementSource)), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: l,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e.A("render")), this.loaded() && !this._loaded && (this._loaded = !0, o.mark(i.load), this.fire(new e.A("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = !0), this.style && !this.style.modelManager.isLoaded() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), s) {
                        const t1 = e.o.now() - n;
                        a.endQuery(r.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const i = a.getQueryParameter(s, a.QUERY_RESULT) / 1e6;
                            a.deleteQuery(s), this.fire(new e.A("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e.A("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e.A("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const h = this._sourcesDirty || this._styleDirty || this._placementDirty || c;
                    if (h || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (c = this._updateAverageElevation(n, !0)), c) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e.A("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e.A("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || h || (this._fullyLoaded = !0, o.mark(i.fullLoad), this._performanceMetricsCollection && V(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e) {
                    for (const t1 of this._markers)e && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e, t1 = !1) {
                    const i = (e)=>(this.transform.averageElevation = e, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (o || (t1 || e - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e)) {
                        const t1 = this.transform.averageElevation;
                        let s = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(s) ? s = 0 : this._averageElevationLastSampledAt = e;
                        const r = Math.abs(t1 - s);
                        if (r > 1) {
                            if (this._isInitialLoad || o) return this._averageElevation.jumpTo(s), i(s);
                            this._averageElevation.easeTo(s, e, 300);
                        } else if (r > 1e-4) return this._averageElevation.jumpTo(s), i(s);
                    }
                    return !!this._averageElevation.isEasing(e) && i(this._averageElevation.getValue(e));
                }
                _authenticate() {
                    H(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === w || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            Z(t1, !1), this._logoControl instanceof Bl && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.z(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), z(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && F(this._requestManager._customAccessToken, {
                        map: this,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _postStyleWithAppearanceEvent() {
                    this.style.globalId && this.style.hasAppearances() && B(this._requestManager._customAccessToken);
                }
                _postAddingAppearancesToStyleEvent() {
                    U(this._requestManager._customAccessToken);
                }
                _updateTerrain() {
                    const e = this._isDragging();
                    this.painter.updateTerrain(this.style, e);
                }
                _calculateSpeedIndex() {
                    const e = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function s(e) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(s(e), t1.canvasCopies.map(s), t1.timeStamps);
                }
                _canvasPixelComparison(e, t1, i) {
                    let o = i[1] - i[0];
                    const s = e.length / 4;
                    for(let r = 0; r < t1.length; r++){
                        const n = t1[r];
                        let a = 0;
                        for(let t1 = 0; t1 < n.length; t1 += 4)n[t1] === e[t1] && n[t1 + 1] === e[t1 + 1] && n[t1 + 2] === e[t1 + 2] && n[t1 + 3] === e[t1 + 3] && (a += 1);
                        o += (i[r + 2] - i[r + 1]) * (1 - a / s);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e of this._controls)e.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), q.delete(this.painter.context.gl), G.remove(), O.remove(), this._removed = !0, this.fire(new e.A("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e.o.frame((e)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e.bx(i, (e, i)=>e._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e) {
                    this._trackResize && this.resize({
                        originalEvent: e
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e) {
                    this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e) {
                    this._showParseStatus !== e && (this._showParseStatus = e, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e) {
                    this._showTerrainWireframe !== e && (this._showTerrainWireframe = e, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e) {
                    this._showLayers2DWireframe !== e && (this._showLayers2DWireframe = e, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e) {
                    this._showLayers3DWireframe !== e && (this._showLayers3DWireframe = e, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e) {
                    this._speedIndexTiming !== e && (this._speedIndexTiming = e, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e) {
                    this._showPadding !== e && (this._showPadding = e, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e) {
                    this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, this.style && e ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e) {
                    this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e) {
                    this._repaint !== e && (this._repaint = e, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e) {
                    this._vertices = e, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e) {
                    this._showTileAABBs !== e && (this._showTileAABBs = e, e && this._update());
                }
                _setCacheLimits(t1, i) {
                    e.f7(t1, i);
                }
                get version() {
                    return t1;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = Object.assign({}, Zl, t1), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.options.showZoom && (e.aZ([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.aZ([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e
                        }) : t1.resetNorth({}, {
                            originalEvent: e
                        }));
                    }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = e.getZoom(), i = t1 === e.getMaxZoom(), o = t1 === e.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e.transform.angle * (180 / Math.PI)}deg)`;
                    e._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e) {
                    return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e.on("pitch", this._rotateCompassArrow), e.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Wl(e, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e = this._map;
                    e && (this._container.remove(), this.options.showZoom && e.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e.off("pitch", this._rotateCompassArrow), e.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e, t1) {
                    const i = l("button", e, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e.setAttribute("aria-label", i), e.firstElementChild && e.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = Object.assign({
                        geolocation: i
                    }, Jl, t1), e.aZ([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = za(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e) {
                    return this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    this._clearRequestTimeout(), void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>t1("denied" !== e.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e) {
                    const t1 = this._map.getMaxBounds(), i = e.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e.A("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this.options.followUserLocation ? (this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active")) : (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"));
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.followUserLocation && (!this.options.trackUserLocation || "ACTIVE_LOCK" === this._watchState) && this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("geolocate", Object.assign({
                            coords: t1.coords,
                            timestamp: t1.timestamp
                        }, t1.toJSON ? {
                            toJSON: t1.toJSON.bind(t1)
                        } : {}))), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e.aU(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, s = this._map.getBearing(), r = Object.assign({
                        bearing: s
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e.aU(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e.cg(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("error", {
                            code: t1.code,
                            message: t1.message,
                            PERMISSION_DENIED: t1.PERMISSION_DENIED,
                            POSITION_UNAVAILABLE: t1.POSITION_UNAVAILABLE,
                            TIMEOUT: t1.TIMEOUT
                        })), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _startRequestTimeout() {
                    this._clearRequestTimeout();
                    const e = this.options.positionOptions.timeout;
                    e && (this._requestTimeoutId = window.setTimeout(()=>{
                        this._onError({
                            code: 3,
                            message: "Geolocation request timed out"
                        });
                    }, e));
                }
                _clearRequestTimeout() {
                    void 0 !== this._requestTimeoutId && (clearTimeout(this._requestTimeoutId), this._requestTimeoutId = void 0);
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Yl({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Yl({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.showButton || (this._container.style.display = "none"), this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.A("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e) {
                    this._userLocationDotMarker && (e.webkitCompassHeading ? this._heading = e.webkitCompassHeading : !0 === e.absolute && (this._heading = -1 * e.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e.A("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.A("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.A("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e), this._startRequestTimeout(), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._startRequestTimeout(), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                setFollowUserLocation(t1) {
                    return this.options.followUserLocation = null != t1 ? t1 : Jl.followUserLocation, this.options.trackUserLocation && "OFF" !== this._watchState && (this.options.followUserLocation ? "BACKGROUND" !== this._watchState && "BACKGROUND_ERROR" !== this._watchState || (this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.A("trackuserlocationstart"))) : "ACTIVE_LOCK" !== this._watchState && "ACTIVE_ERROR" !== this._watchState || (this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this.fire(new e.A("trackuserlocationend")))), this;
                }
                _addDeviceOrientationListener() {
                    const e = ()=>{
                        const e = "ondeviceorientationabsolute" in window ? "deviceorientationabsolute" : "deviceorientation";
                        window.addEventListener(e, this._onDeviceOrientation);
                    };
                    "function" == typeof DeviceOrientationEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e();
                    }).catch(console.error) : e();
                }
                _clearWatch() {
                    this._clearRequestTimeout(), this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: kl,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = Object.assign({}, Ql, t1), e.aZ([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e / 2, s = t1.unproject([
                        o,
                        i
                    ]), r = t1.unproject([
                        o + e,
                        i
                    ]), n = s.distanceTo(r);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * n;
                        t1 > 5280 ? this._setScale(e, t1 / 5280, "mile") : this._setScale(e, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e, n / 1852, "nautical-mile") : n >= 1e3 ? this._setScale(e, n / 1e3, "kilometer") : this._setScale(e, n, "meter");
                }
                _setScale(e, t1, i) {
                    this._map._requestDomTask(()=>{
                        const o = function(e) {
                            const t1 = Math.pow(10, `${Math.floor(e)}`.length - 1);
                            let i = e / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                                return Math.round(e * t1) / t1;
                            }(i), t1 * i;
                        }(t1), s = o / t1;
                        this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(o) : `${o}&nbsp;${ec[i]}`, this._container.style.width = e * s + "px";
                    });
                }
                onAdd(e) {
                    return this._map = e, this._language = e.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e) {
                    this._language = e, this._update();
                }
                setUnit(e) {
                    this.options.unit = e, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e.w("Full screen control 'container' must be a DOM element.")), e.aZ([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            IndoorControl: class {
                constructor(){
                    e.aZ([
                        "_onIndoorUpdate",
                        "_onStyleData",
                        "_scrollUp",
                        "_scrollDown",
                        "_toggleIndoor"
                    ], this), this._visibleFloorStart = 0, this._lastSelectedFloorId = null;
                }
                onAdd(e) {
                    return this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.style.display = "none", this._map.on("styledata", this._onStyleData), this._updateConnection(), this._container;
                }
                _onStyleData() {
                    this._updateConnection();
                }
                _updateConnection() {
                    if (this._map && this._map.style && this._map.style.indoorManager) {
                        const e = this._map.style.indoorManager;
                        e.off("selector-update", this._onIndoorUpdate), e.on("selector-update", this._onIndoorUpdate), this._onIndoorUpdate(e.getControlState());
                    }
                }
                _createButton(e, t1) {
                    const i = l("button", e, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e, t1) {
                    e.setAttribute("aria-label", t1), e.textContent = t1;
                }
                onRemove() {
                    this._container && this._container.remove(), this._map && (this._map.off("styledata", this._onStyleData), this._map.style && this._map.style.indoorManager.off("selector-update", this._onIndoorUpdate), this._map = null);
                }
                getDefaultPosition() {
                    return "top-right";
                }
                _onIndoorUpdate(e) {
                    if (!e || !e.floors || 0 === e.floors.length) return this._model = e, void (this._container.style.display = "none");
                    const t1 = this._model;
                    this._model = e, this._container.style.display = "inline-block";
                    const i = !t1 || t1.floors.length !== e.floors.length || t1.floors.some((t1, i)=>t1.id !== e.floors[i].id);
                    if (i && (this._visibleFloorStart = 0, this._lastSelectedFloorId = null), e.selectedFloorId) {
                        if (e.selectedFloorId !== this._lastSelectedFloorId || i) {
                            const t1 = e.floors.findIndex((t1)=>t1.id === e.selectedFloorId);
                            if (-1 !== t1) {
                                const i = e.floors.length;
                                let o, s;
                                i <= 5 ? (o = 0, s = i - 1) : 0 === this._visibleFloorStart ? (o = 0, s = 3) : this._visibleFloorStart >= i - 3 ? (o = i - 3 - 1, s = i - 1) : (o = this._visibleFloorStart, s = this._visibleFloorStart + 3 - 1), t1 < o ? this._visibleFloorStart = t1 : t1 > s && (this._visibleFloorStart = t1 - 2);
                            }
                        }
                        this._lastSelectedFloorId = e.selectedFloorId;
                    }
                    this._render();
                }
                _render() {
                    if (!this._container || !this._model || !this._model.floors) return;
                    this._container.innerHTML = "";
                    const e = this._createButton("mapboxgl-ctrl-indoor-toggle", this._toggleIndoor);
                    l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), this._model.activeFloorsVisible || e.classList.add("mapboxgl-ctrl-level-button-selected"), this._container.appendChild(e);
                    const t1 = this._model.floors, i = t1.length;
                    if (i <= 5) return void t1.forEach((e)=>this._createFloorButton(e));
                    const o = 0 === this._visibleFloorStart, s = this._visibleFloorStart >= i - 3;
                    if (o) this._createFloorButton(t1[0]);
                    else {
                        const e = this._createButton("mapboxgl-ctrl-arrow-up", this._scrollUp);
                        l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), this._container.appendChild(e);
                    }
                    let r = [];
                    if (r = o ? t1.slice(1, 4) : s ? t1.slice(this._visibleFloorStart - 1, this._visibleFloorStart + 3 - 1) : t1.slice(this._visibleFloorStart, this._visibleFloorStart + 3), r.forEach((e)=>this._createFloorButton(e)), s) this._createFloorButton(t1[i - 1]);
                    else {
                        const e = this._createButton("mapboxgl-ctrl-arrow-down", this._scrollDown);
                        l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), this._container.appendChild(e);
                    }
                }
                _createFloorButton(e) {
                    const t1 = this._createButton("mapboxgl-ctrl-level-button", ()=>{
                        const t1 = e.id;
                        this._model && this._model.selectedFloorId === t1 && this._model.activeFloorsVisible || this._map && (this._model && !this._model.activeFloorsVisible && this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.setActiveFloorsVisibility(!0), this._map._selectIndoorFloor(t1));
                    }), i = (e.name || "").trim(), o = e.zIndex.toString(), s = i ? Array.from(i).slice(0, 3).join("") : o;
                    this._setButtonTitle(t1, s), this._model && this._model.activeFloorsVisible && e.id === this._model.selectedFloorId && t1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container && this._container.appendChild(t1);
                }
                _toggleIndoor() {
                    this._map && this._map.style && this._map.style.indoorManager && this._model && this._model.activeFloorsVisible && this._map.style.indoorManager.setActiveFloorsVisibility(!1);
                }
                _scrollUp() {
                    if (this._visibleFloorStart > 0) {
                        this._visibleFloorStart--, 1 === this._visibleFloorStart && (this._visibleFloorStart = 0);
                        const e = this._model && this._model.floors || [];
                        if (e.length > 3) {
                            const t1 = e.length - 3;
                            this._visibleFloorStart === t1 - 1 && (this._visibleFloorStart = t1 - 2);
                        }
                        this._render();
                    }
                }
                _scrollDown() {
                    if (this._model && this._model.floors) {
                        const e = this._model.floors.length - 3;
                        this._visibleFloorStart < e && (this._visibleFloorStart++, 1 === this._visibleFloorStart && (this._visibleFloorStart = 2), this._visibleFloorStart === e - 1 && (this._visibleFloorStart = e), this._visibleFloorStart > e && (this._visibleFloorStart = e), this._render());
                    }
                }
            },
            Popup: class extends e.E {
                constructor(t1){
                    super(), this.options = Object.assign(Object.create(tc), t1), this._altitude = this.options.altitude, e.aZ([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e.A("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e.A("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e.aU.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                getAltitude() {
                    return this._altitude;
                }
                setAltitude(e) {
                    return this._altitude = e, this._update(), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e = this._map;
                    return e && (e.off("move", this._update), e.on("mousemove", this._onMouseEvent), e.on("drag", this._onMouseEvent), e._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e) {
                    return this.setDOMContent(document.createTextNode(e));
                }
                setHTML(e) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = e; o = i.firstChild, o;)t1.appendChild(o);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e) {
                    return this.options.maxWidth = e, this._update(), this;
                }
                setDOMContent(e) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e), this.options.closeButton) {
                        const e = this._closeButton = l("button", "mapboxgl-popup-close-button", t1);
                        e.type = "button", e.setAttribute("aria-label", "Close popup"), e.innerHTML = '<span aria-hidden="true">&#215;</span>', e.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e) {
                    return this._classList.add(e), this._updateClassList(), this;
                }
                removeClassName(e) {
                    return this._classList.delete(e), this._updateClassList(), this;
                }
                setOffset(e) {
                    return this.options.offset = e, this._update(), this;
                }
                toggleClassName(e) {
                    let t1;
                    return this._classList.delete(e) ? t1 = !1 : (this._classList.add(e), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e) {
                    this._update(e.point);
                }
                _getAnchor(e) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const s = i.offsetWidth, r = i.offsetHeight, n = o.x < s / 2, a = o.x > t1.transform.width - s / 2;
                    if (o.y + e < r) return n ? "top-left" : a ? "top-right" : "top";
                    if (o.y > t1.transform.height - r) {
                        if (n) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return n ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e = this._container;
                    if (!e) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let s = this._container;
                    if (s || (s = this._container = l("div", "mapboxgl-popup", i.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", s), s.appendChild(o)), this.options.maxWidth && s.style.maxWidth !== this.options.maxWidth && (s.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = $l(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const o = this._pos = this._trackPointer && t1 instanceof e.P ? t1 : i.project(this._lngLat, this._altitude), s = oc(this.options.offset), r = this._anchor = this._getAnchor(s.y), n = oc(this.options.offset, r), a = o.add(n).round();
                        i._requestDomTask(()=>{
                            this._container && r && (this._container.style.transform = `${Xl[r]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e.f8(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e = this._container.querySelector(ic);
                    e && e.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e) {
                    this._container && (this._container.style.opacity = `${e}`), this._content && (this._content.style.pointerEvents = e ? "auto" : "none");
                }
            },
            Marker: Yl,
            Style: Po,
            LngLat: e.aU,
            LngLatBounds: e.aJ,
            Point: e.P,
            MercatorCoordinate: e.af,
            FreeCameraOptions: io,
            Evented: e.E,
            config: e.e,
            prewarm: e.fc,
            clearPrewarmedResources: e.fb,
            get accessToken () {
                return e.e.ACCESS_TOKEN;
            },
            set accessToken (t){
                e.e.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e.e.API_URL;
            },
            set baseApiUrl (t){
                e.e.API_URL = t;
            },
            get workerCount () {
                return e.fl.workerCount;
            },
            set workerCount (t){
                e.fl.workerCount = t;
            },
            get maxParallelImageRequests () {
                return e.e.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e.e.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e.fk(t1);
            },
            get workerUrl () {
                return e.fj.workerUrl;
            },
            set workerUrl (t){
                e.fj.workerUrl = t;
            },
            get workerClass () {
                return e.fj.workerClass;
            },
            set workerClass (t){
                e.fj.workerClass = t;
            },
            get workerParams () {
                return e.fj.workerParams;
            },
            set workerParams (t){
                e.fj.workerParams = t;
            },
            get dracoUrl () {
                return e.fi();
            },
            set dracoUrl (t){
                e.fh(t);
            },
            get meshoptUrl () {
                return e.fg();
            },
            set meshoptUrl (t){
                e.ff(t);
            },
            setNow: e.o.setNow,
            restoreNow: e.o.restoreNow
        };
        return sc;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});



var $2bvox = parcelRequire("2bvox");
/*!
 * ScrollToPlugin 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $4bab6a91d9236b66$var$gsap, $4bab6a91d9236b66$var$_coreInitted, $4bab6a91d9236b66$var$_window, $4bab6a91d9236b66$var$_docEl, $4bab6a91d9236b66$var$_body, $4bab6a91d9236b66$var$_toArray, $4bab6a91d9236b66$var$_config, $4bab6a91d9236b66$var$ScrollTrigger, $4bab6a91d9236b66$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4bab6a91d9236b66$var$_getGSAP = function _getGSAP() {
    return $4bab6a91d9236b66$var$gsap || $4bab6a91d9236b66$var$_windowExists() && ($4bab6a91d9236b66$var$gsap = window.gsap) && $4bab6a91d9236b66$var$gsap.registerPlugin && $4bab6a91d9236b66$var$gsap;
}, $4bab6a91d9236b66$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $4bab6a91d9236b66$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $4bab6a91d9236b66$var$_max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === $4bab6a91d9236b66$var$_window || element === $4bab6a91d9236b66$var$_docEl || element === $4bab6a91d9236b66$var$_body ? Math.max($4bab6a91d9236b66$var$_docEl[scroll], $4bab6a91d9236b66$var$_body[scroll]) - ($4bab6a91d9236b66$var$_window["inner" + dim] || $4bab6a91d9236b66$var$_docEl[client] || $4bab6a91d9236b66$var$_body[client]) : element[scroll] - element["offset" + dim];
}, $4bab6a91d9236b66$var$_buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === $4bab6a91d9236b66$var$_window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = $4bab6a91d9236b66$var$_docEl[p] != null ? $4bab6a91d9236b66$var$_docEl : $4bab6a91d9236b66$var$_body;
    }
    return function() {
        return e[p];
    };
}, $4bab6a91d9236b66$var$_clean = function _clean(value, index, target, targets) {
    $4bab6a91d9236b66$var$_isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return $4bab6a91d9236b66$var$_isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)result[p] = p !== "onAutoKill" && $4bab6a91d9236b66$var$_isFunction(value[p]) ? value[p](index, target, targets) : value[p];
        return result;
    }
}, $4bab6a91d9236b66$var$_getOffset = function _getOffset(element, container) {
    element = $4bab6a91d9236b66$var$_toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === $4bab6a91d9236b66$var$_window || container === $4bab6a91d9236b66$var$_body, cRect = isRoot ? {
        top: $4bab6a91d9236b66$var$_docEl.clientTop - ($4bab6a91d9236b66$var$_window.pageYOffset || $4bab6a91d9236b66$var$_docEl.scrollTop || $4bab6a91d9236b66$var$_body.scrollTop || 0),
        left: $4bab6a91d9236b66$var$_docEl.clientLeft - ($4bab6a91d9236b66$var$_window.pageXOffset || $4bab6a91d9236b66$var$_docEl.scrollLeft || $4bab6a91d9236b66$var$_body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += $4bab6a91d9236b66$var$_buildGetter(container, "x")();
        offsets.y += $4bab6a91d9236b66$var$_buildGetter(container, "y")();
    }
    return offsets;
}, $4bab6a91d9236b66$var$_parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : $4bab6a91d9236b66$var$_isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? $4bab6a91d9236b66$var$_max(target, axis) - offset : Math.min($4bab6a91d9236b66$var$_max(target, axis), $4bab6a91d9236b66$var$_getOffset(value, target)[axis] - offset);
}, $4bab6a91d9236b66$var$_initCore = function _initCore() {
    $4bab6a91d9236b66$var$gsap = $4bab6a91d9236b66$var$_getGSAP();
    if ($4bab6a91d9236b66$var$_windowExists() && $4bab6a91d9236b66$var$gsap && typeof document !== "undefined" && document.body) {
        $4bab6a91d9236b66$var$_window = window;
        $4bab6a91d9236b66$var$_body = document.body;
        $4bab6a91d9236b66$var$_docEl = document.documentElement;
        $4bab6a91d9236b66$var$_toArray = $4bab6a91d9236b66$var$gsap.utils.toArray;
        $4bab6a91d9236b66$var$gsap.config({
            autoKillThreshold: 7
        });
        $4bab6a91d9236b66$var$_config = $4bab6a91d9236b66$var$gsap.config();
        $4bab6a91d9236b66$var$_coreInitted = 1;
    }
};
var $4bab6a91d9236b66$export$6953cc323644330b = {
    version: "3.14.2",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        $4bab6a91d9236b66$var$gsap = core;
        $4bab6a91d9236b66$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $4bab6a91d9236b66$var$_coreInitted || $4bab6a91d9236b66$var$_initCore();
        var data = this, snapType = $4bab6a91d9236b66$var$gsap.getProperty(target, "scrollSnapType");
        data.isWin = target === $4bab6a91d9236b66$var$_window;
        data.target = target;
        data.tween = tween;
        value = $4bab6a91d9236b66$var$_clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!("autoKill" in value ? value : $4bab6a91d9236b66$var$_config).autoKill;
        data.getX = $4bab6a91d9236b66$var$_buildGetter(target, "x");
        data.getY = $4bab6a91d9236b66$var$_buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        $4bab6a91d9236b66$var$ScrollTrigger || ($4bab6a91d9236b66$var$ScrollTrigger = $4bab6a91d9236b66$var$gsap.core.globals().ScrollTrigger);
        $4bab6a91d9236b66$var$gsap.getProperty(target, "scrollBehavior") === "smooth" && $4bab6a91d9236b66$var$gsap.set(target, {
            scrollBehavior: "auto"
        });
        if (snapType && snapType !== "none") {
            // disable scroll snapping to avoid strange behavior
            data.snap = 1;
            data.snapInline = target.style.scrollSnapType;
            target.style.scrollSnapType = "none";
        }
        if (value.x != null) {
            data.add(data, "x", data.x, $4bab6a91d9236b66$var$_parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, $4bab6a91d9236b66$var$_parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = $4bab6a91d9236b66$var$_config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < $4bab6a91d9236b66$var$_max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < $4bab6a91d9236b66$var$_max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) $4bab6a91d9236b66$var$_window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        if (snap && (ratio === 1 || ratio === 0)) {
            y = target.scrollTop;
            x = target.scrollLeft;
            snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
            target.scrollTop = y + 1; // bug in Safari causes the element to totally reset its scroll position when scroll-snap-type changes, so we need to set it to a slightly different value and then back again to work around this bug.
            target.scrollLeft = x + 1;
            target.scrollTop = y;
            target.scrollLeft = x;
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
        $4bab6a91d9236b66$var$ScrollTrigger && $4bab6a91d9236b66$var$ScrollTrigger.update();
    },
    kill: function kill(property) {
        var both = property === "scrollTo", i = this._props.indexOf(property);
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
        i > -1 && this._props.splice(i, 1);
        return !this._props.length;
    }
};
$4bab6a91d9236b66$export$6953cc323644330b.max = $4bab6a91d9236b66$var$_max;
$4bab6a91d9236b66$export$6953cc323644330b.getOffset = $4bab6a91d9236b66$var$_getOffset;
$4bab6a91d9236b66$export$6953cc323644330b.buildGetter = $4bab6a91d9236b66$var$_buildGetter;
$4bab6a91d9236b66$export$6953cc323644330b.config = function(vars) {
    $4bab6a91d9236b66$var$_config || $4bab6a91d9236b66$var$_initCore() || ($4bab6a91d9236b66$var$_config = $4bab6a91d9236b66$var$gsap.config()); // in case the window hasn't been defined yet.
    for(var p in vars)$4bab6a91d9236b66$var$_config[p] = vars[p];
};
$4bab6a91d9236b66$var$_getGSAP() && $4bab6a91d9236b66$var$gsap.registerPlugin($4bab6a91d9236b66$export$6953cc323644330b);



var $f5sus = parcelRequire("f5sus");

var $gKp6f = parcelRequire("gKp6f");

var $kMGLj = parcelRequire("kMGLj");
// GSAP setup
(0, $2bvox.gsap).registerPlugin((0, $4bab6a91d9236b66$export$6953cc323644330b));
// Elements
const $7830a2490cf539f0$var$container = document.querySelector('.map');
const $7830a2490cf539f0$var$isBlock = $7830a2490cf539f0$var$container.classList.contains('is-block');
const $7830a2490cf539f0$var$canvas = document.querySelector('.map-canvas');
const $7830a2490cf539f0$var$loader = document.querySelector('.map-loader');
const $7830a2490cf539f0$var$locationContainer = document.querySelector('.map-locations');
const $7830a2490cf539f0$var$filter = document.querySelector('.map-filter');
const $7830a2490cf539f0$var$filterBox = $7830a2490cf539f0$var$filter?.querySelector('.map-filter-box');
const $7830a2490cf539f0$var$filterToggle = document.querySelector('.map-filter-toggle');
const $7830a2490cf539f0$var$filterToggleLabel = $7830a2490cf539f0$var$filterToggle?.querySelector('.map-filter-toggle-label');
const $7830a2490cf539f0$var$filterToggleLabelWhenOpen = $7830a2490cf539f0$var$filterToggleLabel?.dataset.labelWhenOpen;
const $7830a2490cf539f0$var$filterToggleLabelWhenClosed = $7830a2490cf539f0$var$filterToggleLabel?.textContent;
const $7830a2490cf539f0$var$filterGroups = $7830a2490cf539f0$var$filter?.querySelectorAll('.map-filter-group') ?? [];
// Data container variables
let $7830a2490cf539f0$var$markers = [];
let $7830a2490cf539f0$var$currentMarker = null;
let $7830a2490cf539f0$var$currentCard = null;
let $7830a2490cf539f0$var$bounds = null;
let $7830a2490cf539f0$var$filterIsOpen = false;
let $7830a2490cf539f0$var$filterHasChanged = false;
let $7830a2490cf539f0$var$currentCategories = [];
// Map setup
const $7830a2490cf539f0$var$map = (0, $gKp6f.createMap)({
    container: $7830a2490cf539f0$var$canvas,
    center: [
        5.618274168348004,
        52.350066993329314
    ],
    zoom: 14
});
// If the map is a block, we disable the scroll zoom and add zoom and rotation controls
// so users can scroll past the map without zooming in or out
if ($7830a2490cf539f0$var$isBlock) {
    // Disable map zoom on scroll, so users can scroll past the map
    $7830a2490cf539f0$var$map.scrollZoom.disable();
    // Add zoom and rotation controls to the map
    $7830a2490cf539f0$var$map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).NavigationControl());
}
function $7830a2490cf539f0$var$getBoundsOptions(extraPaddingBottom = false) {
    if (window.matchMedia('(max-width: 767px)').matches) return {
        padding: {
            top: 100,
            right: 30,
            bottom: extraPaddingBottom ? 300 : 120,
            left: 30
        }
    };
    else return {
        padding: {
            top: 100,
            right: 100,
            bottom: 100,
            left: 424
        }
    };
}
function $7830a2490cf539f0$var$createMarkers(addCategoryIdsToMarkers) {
    const locations = $7830a2490cf539f0$var$locationContainer.querySelectorAll('.map-location');
    if (!locations.length) return;
    $7830a2490cf539f0$var$bounds = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).LngLatBounds();
    locations.forEach((location)=>{
        const lng = parseFloat(location.dataset.lng);
        const lat = parseFloat(location.dataset.lat);
        const marker = document.createElement('div');
        marker.className = 'map-marker';
        marker.dataset.id = location.dataset.id;
        marker.addEventListener('click', $7830a2490cf539f0$var$handleMarkerClick);
        if (addCategoryIdsToMarkers) marker.dataset.categoryIds = location.dataset.categoryIds;
        else marker.classList.add('highlight');
        $7830a2490cf539f0$var$markers.push(new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Marker(marker).setLngLat([
            lng,
            lat
        ]).addTo($7830a2490cf539f0$var$map));
        $7830a2490cf539f0$var$bounds.extend([
            lng,
            lat
        ]);
    });
    if (locations.length > 1) $7830a2490cf539f0$var$map.fitBounds($7830a2490cf539f0$var$bounds, $7830a2490cf539f0$var$getBoundsOptions());
    else $7830a2490cf539f0$var$map.flyTo({
        center: $7830a2490cf539f0$var$bounds.getCenter(),
        zoom: 14
    });
}
function $7830a2490cf539f0$var$removeMarkers() {
    $7830a2490cf539f0$var$markers.forEach((marker)=>marker.remove());
    $7830a2490cf539f0$var$markers = [];
}
function $7830a2490cf539f0$var$activateLocation(locationId) {
    const targetMarker = $7830a2490cf539f0$var$markers.find((marker)=>marker.getElement().dataset.id == locationId);
    const targetCard = $7830a2490cf539f0$var$locationContainer.querySelector('.map-location[data-id="' + locationId + '"]');
    if (!targetMarker || !targetCard) return;
    $7830a2490cf539f0$var$currentMarker?.getElement().classList.remove('active');
    $7830a2490cf539f0$var$currentCard?.classList.remove('active');
    targetMarker.getElement().classList.add('active');
    targetCard.classList.add('active');
    $7830a2490cf539f0$var$currentMarker = targetMarker;
    $7830a2490cf539f0$var$currentCard = targetCard;
    // Side effect 1: highlight the target marker
    $7830a2490cf539f0$var$map.fitBounds($7830a2490cf539f0$var$bounds, $7830a2490cf539f0$var$getBoundsOptions(true));
    // Side effect 2: scroll the location container to the target card
    const cardContainerHeight = $7830a2490cf539f0$var$locationContainer.getBoundingClientRect().height;
    const cardHeight = targetCard.getBoundingClientRect().height;
    const maxScroll = $7830a2490cf539f0$var$locationContainer.scrollHeight - cardContainerHeight;
    let targetPosition = targetCard.offsetTop - cardContainerHeight / 2 + cardHeight / 2;
    if (targetPosition < 0) targetPosition = 0;
    else if (targetPosition > maxScroll) targetPosition = maxScroll;
    (0, $2bvox.gsap).to($7830a2490cf539f0$var$locationContainer, {
        duration: 0.8,
        scrollTo: targetPosition,
        ease: 'power3.inOut'
    });
    // Side effect 3: close the filter
    $7830a2490cf539f0$var$closeFilter();
}
function $7830a2490cf539f0$var$deactivateLocation() {
    $7830a2490cf539f0$var$currentMarker?.getElement().classList.remove('active');
    $7830a2490cf539f0$var$currentCard?.classList.remove('active');
    $7830a2490cf539f0$var$currentMarker = $7830a2490cf539f0$var$currentCard = null;
    if ($7830a2490cf539f0$var$markers.length > 1) $7830a2490cf539f0$var$map.fitBounds($7830a2490cf539f0$var$bounds, $7830a2490cf539f0$var$getBoundsOptions());
}
function $7830a2490cf539f0$var$handleMarkerClick(e) {
    const marker = e.target;
    if ($7830a2490cf539f0$var$currentMarker?.getElement() === marker) $7830a2490cf539f0$var$deactivateLocation();
    else $7830a2490cf539f0$var$activateLocation(marker.dataset.id);
}
function $7830a2490cf539f0$var$handleLocationContainerClick(e) {
    const isCloseButton = e.target.classList.contains('.card-close') || e.target.closest('.card-close');
    const isShowButton = e.target.classList.contains('.card-show-on-map') || e.target.closest('.card-show-on-map');
    const card = e.target.closest('.map-location');
    if (!isCloseButton && !isShowButton) return;
    e.stopPropagation();
    e.preventDefault();
    if (isShowButton && card !== $7830a2490cf539f0$var$currentCard) $7830a2490cf539f0$var$activateLocation(card.dataset.id);
    else if (isCloseButton || isShowButton && card === $7830a2490cf539f0$var$currentCard) $7830a2490cf539f0$var$deactivateLocation();
}
function $7830a2490cf539f0$var$handleFilterChange(e) {
    const checkbox = e.target;
    const group = checkbox.closest('.map-filter-group');
    const parentCheckbox = group.querySelector('.map-filter-group-input');
    const childCheckboxes = group.querySelectorAll('.map-filter-item-input');
    const isParentCheckbox = checkbox === parentCheckbox;
    const allChildrenAreChecked = Array.from(childCheckboxes).every((childCheckbox)=>childCheckbox.checked);
    const anyChildIsChecked = Array.from(childCheckboxes).some((childCheckbox)=>childCheckbox.checked);
    if (isParentCheckbox) childCheckboxes.forEach((childCheckbox)=>{
        childCheckbox.checked = checkbox.checked;
    });
    else {
        if (allChildrenAreChecked) {
            parentCheckbox.indeterminate = false;
            parentCheckbox.checked = true;
        } else if (anyChildIsChecked) {
            parentCheckbox.indeterminate = true;
            parentCheckbox.checked = false;
        } else {
            parentCheckbox.indeterminate = false;
            parentCheckbox.checked = false;
        }
    }
    $7830a2490cf539f0$var$currentCategories = [];
    $7830a2490cf539f0$var$filter.querySelectorAll('.map-filter-item-input:checked').forEach((checkbox)=>{
        $7830a2490cf539f0$var$currentCategories.push(checkbox.value);
    });
    $7830a2490cf539f0$var$filterHasChanged = true;
}
function $7830a2490cf539f0$var$executeFilter() {
    if (!$7830a2490cf539f0$var$filterHasChanged) return;
    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'action=filter_locations&categories=' + $7830a2490cf539f0$var$currentCategories.join('|')
    }).then((response)=>response.text()).then((result)=>{
        $7830a2490cf539f0$var$locationContainer.innerHTML = result;
        $7830a2490cf539f0$var$removeMarkers();
        $7830a2490cf539f0$var$createMarkers(!!$7830a2490cf539f0$var$currentCategories.length);
        $7830a2490cf539f0$var$filterHasChanged = false;
    });
}
function $7830a2490cf539f0$var$closeFilter() {
    if ($7830a2490cf539f0$var$filterIsOpen) {
        $7830a2490cf539f0$var$filterToggleLabel.textContent = $7830a2490cf539f0$var$filterToggleLabelWhenClosed;
        // It would be better to create a timeline outside of this function and reuse it, 
        // but that causes problems with the height animation because the inner panels animate too.
        (0, $2bvox.gsap).timeline().to($7830a2490cf539f0$var$filterBox, {
            duration: 0.5,
            height: 0,
            y: -8,
            opacity: 0,
            ease: 'power3.inOut'
        }).set($7830a2490cf539f0$var$filterBox, {
            display: 'none'
        });
        (0, $f5sus.toggleAriaExpanded)($7830a2490cf539f0$var$filterToggle);
    }
    $7830a2490cf539f0$var$filterIsOpen = false;
}
function $7830a2490cf539f0$var$openFilter() {
    if (!$7830a2490cf539f0$var$filterIsOpen) {
        $7830a2490cf539f0$var$filterToggleLabel.textContent = $7830a2490cf539f0$var$filterToggleLabelWhenOpen;
        (0, $2bvox.gsap).timeline().set($7830a2490cf539f0$var$filterBox, {
            display: 'block',
            y: -8,
            opacity: 0
        }).to($7830a2490cf539f0$var$filterBox, {
            duration: 0.5,
            height: 'auto',
            y: 0,
            opacity: 1,
            ease: 'power3.inOut'
        });
        (0, $f5sus.toggleAriaExpanded)($7830a2490cf539f0$var$filterToggle);
    }
    $7830a2490cf539f0$var$filterIsOpen = true;
}
function $7830a2490cf539f0$var$handleFilterToggleClick() {
    if ($7830a2490cf539f0$var$filterIsOpen) {
        $7830a2490cf539f0$var$executeFilter();
        $7830a2490cf539f0$var$closeFilter();
    } else $7830a2490cf539f0$var$openFilter();
}
$7830a2490cf539f0$var$createMarkers(false);
$7830a2490cf539f0$var$map.on('load', ()=>$7830a2490cf539f0$var$loader.classList.add('hidden'));
$7830a2490cf539f0$var$locationContainer.addEventListener('click', $7830a2490cf539f0$var$handleLocationContainerClick);
$7830a2490cf539f0$var$filter?.addEventListener('change', $7830a2490cf539f0$var$handleFilterChange);
$7830a2490cf539f0$var$filterToggle?.addEventListener('click', $7830a2490cf539f0$var$handleFilterToggleClick);
// Handle filter group toggles
$7830a2490cf539f0$var$filterGroups.forEach((group)=>{
    const toggle = group.querySelector('.map-filter-group-toggle');
    const items = group.querySelector('.map-filter-items');
    const animation = (0, $2bvox.gsap).timeline({
        paused: true
    }).to(items, {
        duration: 0.5,
        height: 'auto',
        ease: 'power3.inOut'
    });
    toggle.addEventListener('click', ()=>{
        const isOpen = group.classList.contains('open');
        group.classList.toggle('open');
        if (isOpen) animation.reverse();
        else animation.play();
    });
});

})();
//# sourceMappingURL=map-large.js.map
